
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("iuVKP", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $a1L5E = parcelRequire("a1L5E");


var $d5gEx = parcelRequire("d5gEx");





var $6cFsl = parcelRequire("6cFsl");


var $kiAM2 = parcelRequire("kiAM2");


var $7akNQ = parcelRequire("7akNQ");


var $5HApy = parcelRequire("5HApy");





var $dUAp3 = parcelRequire("dUAp3");


var $91ZZN = parcelRequire("91ZZN");


var $hdBxM = parcelRequire("hdBxM");


var $37RgG = parcelRequire("37RgG");


var $8lt5O = parcelRequire("8lt5O");


var $irnO2 = parcelRequire("irnO2");


var $89QZA = parcelRequire("89QZA");


var $bjY3F = parcelRequire("bjY3F");


var $lJ6db = parcelRequire("lJ6db");


var $isp1U = parcelRequire("isp1U");


var $bGNkz = parcelRequire("bGNkz");











var $9EOlJ = parcelRequire("9EOlJ");

const $741693f1d6085f6e$var$enableDebugging = ()=>{
    if (window.top) window.top.__aifcDebuggerEnabled__ = true;
};
const $741693f1d6085f6e$var$disableDebugging = ()=>{
    if (window.top) window.top.__aifcDebuggerEnabled__ = false;
};
function $741693f1d6085f6e$var$addAifcDebugListeners() {
    if (window.top) {
        window.top.__aifcDebuggerStart__ = $741693f1d6085f6e$var$enableDebugging;
        window.top.__aifcDebuggerStop__ = $741693f1d6085f6e$var$disableDebugging;
    }
}
function $741693f1d6085f6e$var$removeAifcDebugListeners() {
    if (window.top) {
        window.top.__aifcDebuggerStart__ = undefined;
        window.top.__aifcDebuggerStop__ = undefined;
    }
}
const $741693f1d6085f6e$var$AifcDebuggerListeners = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    (0, $cozmU.useEffect)($741693f1d6085f6e$var$_temp2, t0);
    return null;
} : ()=>{
    (0, $cozmU.useEffect)(()=>{
        $741693f1d6085f6e$var$addAifcDebugListeners();
        return ()=>{
            $741693f1d6085f6e$var$removeAifcDebugListeners();
        };
    }, []);
    return null;
};
const $741693f1d6085f6e$var$onAifcDebuggerError = (error, errorInfo)=>{
    // eslint-disable-next-line no-console
    console.error('AifcDebugger failed:', error, errorInfo);
};
const $741693f1d6085f6e$export$1f35aa17211e523d = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            fallbackRender: $741693f1d6085f6e$var$_temp3,
            onError: $741693f1d6085f6e$var$onAifcDebuggerError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($741693f1d6085f6e$var$AifcDebuggerListeners, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallbackRender: ()=>null,
        onError: $741693f1d6085f6e$var$onAifcDebuggerError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($741693f1d6085f6e$var$AifcDebuggerListeners, null));
};
function $741693f1d6085f6e$var$_temp() {
    $741693f1d6085f6e$var$removeAifcDebugListeners();
}
function $741693f1d6085f6e$var$_temp2() {
    $741693f1d6085f6e$var$addAifcDebugListeners();
    return $741693f1d6085f6e$var$_temp;
}
function $741693f1d6085f6e$var$_temp3() {
    return null;
}



var $oV0CU = parcelRequire("oV0CU");


var $gyWKg = parcelRequire("gyWKg");







const $66b2cc9d5a9f46b4$export$d41865d5350d9e0a = (product)=>{
    switch(product){
        case 'confluence':
            return 'confluence';
        case 'jira-software':
        case 'jira-core':
        case 'jsm':
        case 'jpd':
        case 'jira':
            return 'jira';
        case 'atlassian-studio':
        case 'rovo':
        case 'atlas':
            return 'atlas';
        case 'bitbucket':
            return 'bitbucket';
        case 'trello':
            return 'trello';
        case 'admin':
            return 'admin';
        case 'store':
            return 'store';
        case 'loom':
            return 'loom';
        default:
            return 'unknown';
    }
};


const $58f16686a4f70667$export$b9c35db6980960f2 = ({ profileData: profileData, displaySubmitFlag: displaySubmitFlag, siteId: siteId, activationId: activationId, product: product, experienceId: experienceId = (0, $oV0CU.AI_MATE_EXPERIENCE_ID), workspaceId: workspaceId, orgId: orgId, assistanceServiceConfig: assistanceServiceConfig, closeChat: closeChat, emojiProvider: emojiProvider, preventAbortRequestsOnStagingModalClose: preventAbortRequestsOnStagingModalClose, preventAbortRequestsOnStandaloneChatClose: preventAbortRequestsOnStandaloneChatClose, renderingTouchpoint: renderingTouchpoint, inProductExperience: inProductExperience, smartCreationContext: smartCreationContext, jiraIssueCommentEditor: jiraIssueCommentEditor, autocompletePageContentSource: autocompletePageContentSource, editorContentIdResolver: editorContentIdResolver, contextualPromptAnalyticsMetadata: contextualPromptAnalyticsMetadata, analyticsProductHeader: analyticsProductHeader })=>({
        profileData: profileData,
        feedbackCollector: {
            entryPointId: (0, $oV0CU.FEEDBACK_COLLECTOR_ENTRYPOINT_ID),
            displaySubmitFlag: displaySubmitFlag
        },
        siteId: siteId,
        activationId: activationId,
        experienceId: experienceId,
        workspaceId: workspaceId,
        productKey: (0, $66b2cc9d5a9f46b4$export$d41865d5350d9e0a)(product),
        productHeader: analyticsProductHeader ?? product,
        orgId: orgId,
        assistanceServiceConfig: assistanceServiceConfig,
        closeChat: closeChat,
        emojiProvider: emojiProvider,
        preventAbortRequestsOnStagingModalClose: preventAbortRequestsOnStagingModalClose,
        preventAbortRequestsOnStandaloneChatClose: preventAbortRequestsOnStandaloneChatClose,
        ...(0, $iDrrr.fg)('fe_enable_sa_externally') && {
            renderingTouchpoint: renderingTouchpoint
        },
        inProductExperience: inProductExperience,
        smartCreationContext: smartCreationContext,
        jiraIssueCommentEditor: jiraIssueCommentEditor,
        autocompletePageContentSource: autocompletePageContentSource,
        editorContentIdResolver: editorContentIdResolver,
        contextualPromptAnalyticsMetadata: contextualPromptAnalyticsMetadata,
        analyticsProductHeader: analyticsProductHeader
    });



var $6H2Ay = parcelRequire("6H2Ay");

const $b6e4c82a4164acfc$export$920227929045c1b5 = (0, $6H2Ay.globalConfig).Provider;


// NOTE: Global `Window` augmentations merge across the entire program. The sibling
// package `@atlassian/conversation-assistant-service` declares this same
// `__ROVO_CHAT_CONFIG_PRODUCT__` global; keep the modifier (`?: string`) identical to
// that declaration, otherwise TS2687 ("All declarations of X must have identical
// modifiers") will fail at the program level.
const $de717ae3a7549f1b$export$caa27b16709bc2df = (product)=>{
    if (window) window.__ROVO_CHAT_CONFIG_PRODUCT__ = product;
};












var $cXtTj = parcelRequire("cXtTj");


var $atEX8 = parcelRequire("atEX8");

const $557d858394512263$var$StabilizedSideNavContextProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, isSideNavOpen: isSideNavOpen, setSideNavOpen: setSideNavOpen } = t0;
    let t1;
    if ($[0] !== isSideNavOpen || $[1] !== setSideNavOpen) {
        t1 = {
            isSideNavOpen: isSideNavOpen,
            setSideNavOpen: setSideNavOpen
        };
        $[0] = isSideNavOpen;
        $[1] = setSideNavOpen;
        $[2] = t1;
    } else t1 = $[2];
    const value = t1;
    let t2;
    if ($[3] !== children || $[4] !== value) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $atEX8.SideNavContext).Provider, {
            value: value
        }, children);
        $[3] = children;
        $[4] = value;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ children: children, isSideNavOpen: isSideNavOpen, setSideNavOpen: setSideNavOpen })=>{
    const value = (0, $cozmU.useMemo)(()=>({
            isSideNavOpen: isSideNavOpen,
            setSideNavOpen: setSideNavOpen
        }), [
        isSideNavOpen,
        setSideNavOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $atEX8.SideNavContext).Provider, {
        value: value
    }, children);
};
const $557d858394512263$var$InlineSideNavContextProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, isSideNavOpen: isSideNavOpen, setSideNavOpen: setSideNavOpen } = t0;
    let t1;
    if ($[0] !== isSideNavOpen || $[1] !== setSideNavOpen) {
        t1 = {
            isSideNavOpen: isSideNavOpen,
            setSideNavOpen: setSideNavOpen
        };
        $[0] = isSideNavOpen;
        $[1] = setSideNavOpen;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== children || $[4] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $atEX8.SideNavContext).Provider, {
            value: t1
        }, children);
        $[3] = children;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ children: children, isSideNavOpen: isSideNavOpen, setSideNavOpen: setSideNavOpen })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $atEX8.SideNavContext).Provider, {
        value: {
            isSideNavOpen: isSideNavOpen,
            setSideNavOpen: setSideNavOpen
        }
    }, children);
const $557d858394512263$export$b0b2d9624bbf3936 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    const [isSideNavOpen, setSideNavOpen] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] !== children || $[1] !== isSideNavOpen) {
        t1 = (0, $cXtTj.default).getExperimentValue("rovo_ttai_segment_render_stabilization", "isEnabled", false) === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($557d858394512263$var$StabilizedSideNavContextProvider, {
            isSideNavOpen: isSideNavOpen,
            setSideNavOpen: setSideNavOpen
        }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($557d858394512263$var$InlineSideNavContextProvider, {
            isSideNavOpen: isSideNavOpen,
            setSideNavOpen: setSideNavOpen
        }, children);
        $[0] = children;
        $[1] = isSideNavOpen;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ children: children })=>{
    const [isSideNavOpen, setSideNavOpen] = (0, $cozmU.useState)(false);
    return (0, $cXtTj.default).getExperimentValue('rovo_ttai_segment_render_stabilization', 'isEnabled', false) === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($557d858394512263$var$StabilizedSideNavContextProvider, {
        isSideNavOpen: isSideNavOpen,
        setSideNavOpen: setSideNavOpen
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($557d858394512263$var$InlineSideNavContextProvider, {
        isSideNavOpen: isSideNavOpen,
        setSideNavOpen: setSideNavOpen
    }, children);
};



var $blKf8 = parcelRequire("blKf8");

const $735ca6a936ab5049$export$3063519296e335bf = (0, $blKf8.uiConfig).Provider;



var $c69qG = parcelRequire("c69qG");

const $31f0ba1c2c4d97e2$export$51f901728a02d39c = (0, $c69qG.agentVersioningConfigContext).Provider;



var $j180q = parcelRequire("j180q");











var $ieeJu = parcelRequire("ieeJu");


var $lUXDc = parcelRequire("lUXDc");


var $6rwn6 = parcelRequire("6rwn6");





var $Ou0Zz = parcelRequire("Ou0Zz");




const $d91d74abbb95cf45$var$SEND_MESSAGE_EXPERIENCE_NAMES = new Set([
    (0, $irnO2.ExperienceName).SEND_MESSAGE
]);
const $d91d74abbb95cf45$var$toError = (error)=>error ?? new Error('aiMateSendMessage failed');
const $d91d74abbb95cf45$var$matchesSendMessageFailure = (event, context)=>{
    if (!$d91d74abbb95cf45$var$SEND_MESSAGE_EXPERIENCE_NAMES.has(event.name) || event.action !== 'taskFail') return false;
    const attributes = event.attributes;
    const isRemixRegenerate = attributes?.isRemixRegenerate === true;
    if (!isRemixRegenerate) return false;
    const requestSource = attributes?.remixRegenerateSource;
    if (context.regenerateSource && requestSource !== context.regenerateSource) return false;
    const requestConversationId = attributes?.conversationId;
    if (context.conversationChannelId && requestConversationId === context.conversationChannelId) return true;
    // For now, if allowCollectFallback is true, we will assume there's only one conversation stream at a time
    // and that this failure event is related to the inflight Remix request
    return Boolean(context.allowCollectFallback && context.regenerateSource === 'inline-existing-node');
};
const $d91d74abbb95cf45$export$a9538f4db585a467 = (context)=>{
    return (events, experience)=>{
        for (const event of events){
            if (!$d91d74abbb95cf45$var$matchesSendMessageFailure(event, context)) continue;
            const attributes = event.attributes;
            experience.fail({
                error: $d91d74abbb95cf45$var$toError(event.error),
                attributes: {
                    ...attributes ?? {},
                    ...context.featureArea ? {
                        featureArea: context.featureArea
                    } : {},
                    failureSource: 'send_message_collect',
                    failureStage: 'request',
                    upstreamExperience: event.name,
                    ...context.regenerateSource ? {
                        regenerateSource: context.regenerateSource
                    } : {},
                    ...context.targetIds ?? {}
                }
            });
            return;
        }
    };
};






var $4m5jb = parcelRequire("4m5jb");


var $gzMZq = parcelRequire("gzMZq");


var $iW40i = parcelRequire("iW40i");


var $8akfd = parcelRequire("8akfd");


var $lTU4O = parcelRequire("lTU4O");


var $5Tn11 = parcelRequire("5Tn11");


var $j1J3n = parcelRequire("j1J3n");


var $8gcBG = parcelRequire("8gcBG");


var $2BLI8 = parcelRequire("2BLI8");


var $6yHkF = parcelRequire("6yHkF");


var $3MoJD = parcelRequire("3MoJD");


var $2YoG8 = parcelRequire("2YoG8");


var $95cHD = parcelRequire("95cHD");


var $85mU8 = parcelRequire("85mU8");


var $n71o5 = parcelRequire("n71o5");


var $3TxKn = parcelRequire("3TxKn");


var $hlvTd = parcelRequire("hlvTd");


var $7lXV4 = parcelRequire("7lXV4");


var $3wccB = parcelRequire("3wccB");


var $5OXoi = parcelRequire("5OXoi");


var $6isLN = parcelRequire("6isLN");





var $4nKqn = parcelRequire("4nKqn");





var $jb3zd = parcelRequire("jb3zd");

const $e4efc8cb7e22be34$export$ff6a2981a5436d75 = (status, streamId, content)=>{
    if (!content) return;
    const api = (0, $85mU8.getBrowserBridgeAPI)();
    const id = String(content.id);
    const receiverId = (()=>{
        switch(content.type){
            case 'page':
                return (0, $5OXoi.getConfluenceEditorClientId)(id);
            case 'database':
                return (0, $7lXV4.getConfluenceDatabaseClientId)(id);
            case 'whiteboard':
                return (0, $6isLN.getConfluenceWhiteboardClientId)(id);
            case 'slide':
                return (0, $3wccB.getConfluenceSlidesClientId)(id);
            default:
                return undefined;
        }
    })();
    try {
        if (!receiverId) return;
        switch(status){
            case (0, $jb3zd.StreamLifecycleState).SEND_CONTEXT_READY:
                api.send((0, $4nKqn.RovoSendContextReadyCommand), {
                    streamId: streamId,
                    contentId: content.id,
                    senderId: (0, $5Tn11.ROVO_CHAT_CLIENT_ID),
                    receiverId: receiverId
                });
                break;
            case (0, $jb3zd.StreamLifecycleState).COMPLETED:
                api.send((0, $4nKqn.RovoStreamCompletedCommand), {
                    streamId: streamId,
                    contentId: content.id,
                    senderId: (0, $5Tn11.ROVO_CHAT_CLIENT_ID),
                    receiverId: receiverId
                });
                break;
            case (0, $jb3zd.StreamLifecycleState).ERRORED:
                api.send((0, $4nKqn.RovoStreamErroredCommand), {
                    streamId: streamId,
                    contentId: content.id,
                    senderId: (0, $5Tn11.ROVO_CHAT_CLIENT_ID),
                    receiverId: receiverId
                });
                break;
            case (0, $jb3zd.StreamLifecycleState).ABORTED:
                api.send((0, $4nKqn.RovoStreamAbortedCommand), {
                    streamId: streamId,
                    contentId: content.id,
                    senderId: (0, $5Tn11.ROVO_CHAT_CLIENT_ID),
                    receiverId: receiverId
                });
                break;
            default:
                (0, $hlvTd.logException)({
                    exception: new Error(`Unknown stream lifecycle state: ${status}`),
                    name: 'UnknownStreamLifecycleState'
                });
        }
    } catch (error) {
        (0, $hlvTd.logException)({
            exception: error,
            name: 'SendStreamLifecycleCommandError'
        });
    }
};















var $4o0zT = parcelRequire("4o0zT");








var $i7OAD = parcelRequire("i7OAD");


var $aYC8J = parcelRequire("aYC8J");








var $2zvMw = parcelRequire("2zvMw");


var $9jFb0 = parcelRequire("9jFb0");


var $2lEwc = parcelRequire("2lEwc");


var $i35QN = parcelRequire("i35QN");


var $dSCNl = parcelRequire("dSCNl");


var $3Ak5G = parcelRequire("3Ak5G");











var $dE5YE = parcelRequire("dE5YE");

/**
 * Extracts the numeric page ID from a Confluence page URL.
 *
 * Takes the URL as an argument instead of reading `window.location`, so hosts that are not on the
 * page they are asking about can use it: the Rovo browser extension's chat lives in a Chrome side
 * panel, where `window.location` is the panel. `getCurrentPageId` is the `window.location` wrapper.
 */ const $6e5da6dcd273dca5$export$34ef9695f77fe7fe = (pageUrl)=>{
    return pageUrl?.match(/\/pages\/(?:edit-v2\/)?(\d+)/)?.[1];
};


const $93ce060b6123b497$export$365076dec8e1120e = ()=>{
    // Extracts the numeric page ID from the current Confluence page URL.
    // Handles both view and edit URL formats:
    //   View: https://<site>.atlassian.net/wiki/spaces/<spaceKey>/pages/<pageId>/<page-title>
    //   Edit: https://<site>.atlassian.net/wiki/spaces/<spaceKey>/pages/edit-v2/<pageId>
    return (0, $6e5da6dcd273dca5$export$34ef9695f77fe7fe)(window?.location.href);
};


const $4a71479a1e1aaf2c$var$UNKNOWN_AGENT_TYPE = 'unknown';
function $4a71479a1e1aaf2c$export$cb00071f594190c2(sendCommand, { contentId: contentId, groupId: groupId }) {
    const resolvedContentId = contentId || (0, $93ce060b6123b497$export$365076dec8e1120e)();
    if (!resolvedContentId) return;
    sendCommand((0, $dE5YE.ConfluenceUpdatePageCommand), {
        ...(0, $iDrrr.fg)('platform_editor_agentic_step_attribution') ? {
            agentType: $4a71479a1e1aaf2c$var$UNKNOWN_AGENT_TYPE
        } : {},
        key: (0, $aYC8J.IMAGE_CREATE_KEY),
        data: {
            __isError: true
        },
        isStreamComplete: false,
        receiverId: (0, $5OXoi.getConfluenceEditorClientId)(resolvedContentId),
        groupId: groupId,
        buffer: false
    });
}


const $c1435cb431a8c757$export$ef93491bca821fa2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(31);
    const { sendCommand: sendCommand } = (0, $3Ak5G.useBridgeSendCommand)();
    const [t0] = (0, $gzMZq.useChatContextEditorContext)();
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { isViewMode: editorIsViewMode } = t1;
    const publish = (0, $hdBxM.usePublish)("ai-mate");
    const { mounted: mounted } = (0, $bGNkz.useUIStore)();
    const { elements: elements } = (0, $dSCNl.useUIConfig)();
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = new Set();
        $[2] = t2;
    } else t2 = $[2];
    const publishedMessagesRef = (0, $cozmU.useRef)(t2);
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = new Set();
        $[3] = t3;
    } else t3 = $[3];
    const messagesWithUpdateActionsRef = (0, $cozmU.useRef)(t3);
    elements?.stagingAreaEnabled;
    const stagingAreaEnabled = elements?.stagingAreaEnabled;
    let t4;
    if ($[4] !== mounted || $[5] !== publish || $[6] !== stagingAreaEnabled) {
        t4 = (conversationId, messageId, openChat)=>{
            if (!publishedMessagesRef.current.has(messageId) && !mounted && !stagingAreaEnabled) {
                publishedMessagesRef.current.add(messageId);
                publish({
                    type: "chat-open",
                    source: "input-prompt-box",
                    openChat: openChat,
                    data: {
                        channelId: conversationId
                    }
                });
            }
        };
        $[4] = mounted;
        $[5] = publish;
        $[6] = stagingAreaEnabled;
        $[7] = t4;
    } else t4 = $[7];
    const publishChatOpen = t4;
    let t5;
    if ($[8] !== mounted || $[9] !== publish || $[10] !== stagingAreaEnabled) {
        t5 = (conversationId_0, messageId_0)=>{
            if (!publishedMessagesRef.current.has(messageId_0) && !mounted && !stagingAreaEnabled) {
                publishedMessagesRef.current.add(messageId_0);
                publish({
                    type: "open-smart-creation-modal",
                    source: "input-prompt-box",
                    openChat: false,
                    data: {
                        channelId: conversationId_0,
                        entryPoint: "dynamicUiFromInlineEditorToolbarAskRovo",
                        stagingAreaActive: true,
                        isFloating: true,
                        shouldShowBackButton: false
                    }
                });
            }
        };
        $[8] = mounted;
        $[9] = publish;
        $[10] = stagingAreaEnabled;
        $[11] = t5;
    } else t5 = $[11];
    const publishEphemeralPreviewOpen = t5;
    let t6;
    if ($[12] !== sendCommand) {
        t6 = (t7, invocationId)=>{
            const { message: message } = t7;
            const command = sendCommand((0, $i35QN.InlineInputBoxTraceMessageCommand), {
                message: message,
                receiverId: (0, $2zvMw.ROVO_INLINE_INPUT_BOX_CLIENT_ID),
                groupId: invocationId,
                buffer: false
            });
            return command.result();
        };
        $[12] = sendCommand;
        $[13] = t6;
    } else t6 = $[13];
    const onTraceMessage = t6;
    let t7;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (action, messageId_1)=>new Promise((resolve)=>{
                if (!(0, $i7OAD.isEphemeralCreateAction)(action.message) && (0, $i7OAD.isUpdatableAction)(action.message) && (0, $iDrrr.fg)("platform_editor_ai_fix_update_backend_no_chat_open")) messagesWithUpdateActionsRef.current.add(messageId_1);
                resolve();
            });
        $[14] = t7;
    } else t7 = $[14];
    const onActionComplete = t7;
    let t8;
    if ($[15] !== editorIsViewMode || $[16] !== publishChatOpen || $[17] !== publishEphemeralPreviewOpen) {
        t8 = (actionPart, messageId_2, conversationId_1, openChat_0)=>new Promise((resolve_0)=>{
                if ((0, $i7OAD.isEphemeralCreateAction)(actionPart.message)) {
                    if (!editorIsViewMode && (0, $iDrrr.fg)("cc-maui-phase-2")) messagesWithUpdateActionsRef.current.add(messageId_2);
                    else publishEphemeralPreviewOpen(conversationId_1, messageId_2);
                } else if ((0, $i7OAD.isUpdatableAction)(actionPart.message)) messagesWithUpdateActionsRef.current.add(messageId_2);
                else publishChatOpen(conversationId_1, messageId_2, openChat_0);
                resolve_0();
            });
        $[15] = editorIsViewMode;
        $[16] = publishChatOpen;
        $[17] = publishEphemeralPreviewOpen;
        $[18] = t8;
    } else t8 = $[18];
    const onActionPart = t8;
    let t9;
    if ($[19] !== publishChatOpen) {
        t9 = (_, messageId_3, conversationId_2, openChat_1)=>new Promise((resolve_1)=>{
                if (!messagesWithUpdateActionsRef.current.has(messageId_3)) publishChatOpen(conversationId_2, messageId_3, (0, $4o0zT.isExperimentEnabled)("platform_editor_agent_mentions_nudge_indication") ? openChat_1 : undefined);
                resolve_1();
            });
        $[19] = publishChatOpen;
        $[20] = t9;
    } else t9 = $[20];
    const onAnswerPart = t9;
    let t10;
    if ($[21] !== sendCommand) {
        t10 = (response, invocationId_0)=>{
            const command_0 = sendCommand((0, $2lEwc.InlineInputBoxFinalResponseMessageCommand), {
                receiverId: (0, $2zvMw.ROVO_INLINE_INPUT_BOX_CLIENT_ID),
                groupId: invocationId_0,
                buffer: false
            });
            messagesWithUpdateActionsRef.current.delete(invocationId_0);
            return command_0.result();
        };
        $[21] = sendCommand;
        $[22] = t10;
    } else t10 = $[22];
    const onFinalResponse = t10;
    let t11;
    if ($[23] !== sendCommand) {
        t11 = (error, invocationId_1, options)=>{
            if ("message" in error && error.message && typeof error.message === "object" && "key" in error.message && error.message.key === (0, $aYC8J.IMAGE_CREATE_KEY)) {
                const errorData = "data" in error.message ? error.message.data : undefined;
                (0, $4a71479a1e1aaf2c$export$cb00071f594190c2)(sendCommand, {
                    contentId: errorData?.contentId,
                    groupId: invocationId_1
                });
            }
            const command_1 = sendCommand((0, $9jFb0.InlineInputBoxErrorMessageCommand), {
                error: {
                    message: error.message,
                    metadata: error.metadata
                },
                receiverId: (0, $2zvMw.ROVO_INLINE_INPUT_BOX_CLIENT_ID),
                groupId: invocationId_1,
                buffer: false,
                openChatOnError: options?.openChatOnError,
                conversationId: options?.conversationId
            });
            messagesWithUpdateActionsRef.current.delete(invocationId_1);
            return command_1.result();
        };
        $[23] = sendCommand;
        $[24] = t11;
    } else t11 = $[24];
    const onError = t11;
    let t12;
    if ($[25] !== onActionPart || $[26] !== onAnswerPart || $[27] !== onError || $[28] !== onFinalResponse || $[29] !== onTraceMessage) {
        t12 = {
            onTraceMessage: onTraceMessage,
            onActionPart: onActionPart,
            onActionComplete: onActionComplete,
            onAnswerPart: onAnswerPart,
            onFinalResponse: onFinalResponse,
            onError: onError
        };
        $[25] = onActionPart;
        $[26] = onAnswerPart;
        $[27] = onError;
        $[28] = onFinalResponse;
        $[29] = onTraceMessage;
        $[30] = t12;
    } else t12 = $[30];
    return t12;
} : ()=>{
    const { sendCommand: sendCommand } = (0, $3Ak5G.useBridgeSendCommand)();
    const [{ isViewMode: editorIsViewMode } = {}] = (0, $gzMZq.useChatContextEditorContext)();
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const { mounted: mounted } = (0, $bGNkz.useUIStore)();
    const { elements: elements } = (0, $dSCNl.useUIConfig)();
    // Track which messages have already called publish to avoid duplicate calls
    const publishedMessagesRef = (0, $cozmU.useRef)(new Set());
    // Track which messages have update actions to prevent processing publishChatOpen
    const messagesWithUpdateActionsRef = (0, $cozmU.useRef)(new Set());
    const stagingAreaEnabled = (0, $cozmU.useMemo)(()=>elements?.stagingAreaEnabled, [
        elements?.stagingAreaEnabled
    ]);
    const publishChatOpen = (0, $cozmU.useCallback)((conversationId, messageId, openChat)=>{
        if (!publishedMessagesRef.current.has(messageId) && !mounted && !stagingAreaEnabled) {
            publishedMessagesRef.current.add(messageId);
            publish({
                type: 'chat-open',
                source: 'input-prompt-box',
                openChat: openChat,
                data: {
                    channelId: conversationId
                }
            });
        }
    }, [
        publish,
        stagingAreaEnabled,
        mounted
    ]);
    const publishEphemeralPreviewOpen = (0, $cozmU.useCallback)((conversationId_0, messageId_0)=>{
        if (!publishedMessagesRef.current.has(messageId_0) && !mounted && !stagingAreaEnabled) {
            publishedMessagesRef.current.add(messageId_0);
            publish({
                type: 'open-smart-creation-modal',
                source: 'input-prompt-box',
                openChat: false,
                data: {
                    channelId: conversationId_0,
                    entryPoint: 'dynamicUiFromInlineEditorToolbarAskRovo',
                    stagingAreaActive: true,
                    isFloating: true,
                    shouldShowBackButton: false
                }
            });
        }
    }, [
        publish,
        stagingAreaEnabled,
        mounted
    ]);
    const onTraceMessage = (0, $cozmU.useCallback)(({ message: message }, invocationId)=>{
        const command = sendCommand((0, $i35QN.InlineInputBoxTraceMessageCommand), {
            message: message,
            receiverId: (0, $2zvMw.ROVO_INLINE_INPUT_BOX_CLIENT_ID),
            groupId: invocationId,
            buffer: false
        });
        return command.result();
    }, [
        sendCommand
    ]);
    const onActionComplete = (0, $cozmU.useCallback)((action, messageId_1)=>{
        return new Promise((resolve)=>{
            // Backend-persisted edits stream no incremental action parts, so completion is the
            // only signal that the document was updated before the answer arrives.
            // Ephemeral create actions are left to the action part flow, which opens a preview.
            if (!(0, $i7OAD.isEphemeralCreateAction)(action.message) && (0, $i7OAD.isUpdatableAction)(action.message) && (0, $iDrrr.fg)('platform_editor_ai_fix_update_backend_no_chat_open')) messagesWithUpdateActionsRef.current.add(messageId_1);
            resolve();
        });
    }, []);
    const onActionPart = (0, $cozmU.useCallback)((actionPart, messageId_2, conversationId_1, openChat_0)=>{
        return new Promise((resolve_0)=>{
            // Ephemeral create actions must be checked before update actions, since they are update actions too.
            if ((0, $i7OAD.isEphemeralCreateAction)(actionPart.message)) {
                if (!editorIsViewMode && (0, $iDrrr.fg)('cc-maui-phase-2')) // When phase-2 is enabled and in edit mode, suppress ephemeral preview —
                // the inline editor handles it. In view mode, always open the preview.
                messagesWithUpdateActionsRef.current.add(messageId_2);
                else // When phase-2 is disabled, open the AIFC modal in ephemeral preview mode
                publishEphemeralPreviewOpen(conversationId_1, messageId_2);
            } else if ((0, $i7OAD.isUpdatableAction)(actionPart.message)) // Temporary Patch to not open Rovo Chat on update actions
            messagesWithUpdateActionsRef.current.add(messageId_2);
            else publishChatOpen(conversationId_1, messageId_2, openChat_0);
            resolve_0();
        });
    }, [
        publishChatOpen,
        publishEphemeralPreviewOpen,
        editorIsViewMode
    ]);
    const onAnswerPart = (0, $cozmU.useCallback)((_, messageId_3, conversationId_2, openChat_1)=>{
        return new Promise((resolve_1)=>{
            if (!messagesWithUpdateActionsRef.current.has(messageId_3)) publishChatOpen(conversationId_2, messageId_3, (0, $4o0zT.isExperimentEnabled)('platform_editor_agent_mentions_nudge_indication') ? openChat_1 : undefined);
            resolve_1();
        });
    }, [
        publishChatOpen
    ]);
    const onFinalResponse = (0, $cozmU.useCallback)((response, invocationId_0)=>{
        const command_0 = sendCommand((0, $2lEwc.InlineInputBoxFinalResponseMessageCommand), {
            receiverId: (0, $2zvMw.ROVO_INLINE_INPUT_BOX_CLIENT_ID),
            groupId: invocationId_0,
            buffer: false
        });
        // Clean up message tracking for this invocation
        messagesWithUpdateActionsRef.current.delete(invocationId_0);
        return command_0.result();
    }, [
        sendCommand
    ]);
    const onError = (0, $cozmU.useCallback)((error, invocationId_1, options)=>{
        // If the error is for an image-create action, signal the editor bridge to
        // clear the AI generating state from the existing image node
        if ('message' in error && error.message && typeof error.message === 'object' && 'key' in error.message && error.message.key === (0, $aYC8J.IMAGE_CREATE_KEY)) {
            const errorData = 'data' in error.message ? error.message.data : undefined;
            (0, $4a71479a1e1aaf2c$export$cb00071f594190c2)(sendCommand, {
                contentId: errorData?.contentId,
                groupId: invocationId_1
            });
        }
        const command_1 = sendCommand((0, $9jFb0.InlineInputBoxErrorMessageCommand), {
            error: {
                message: error.message,
                metadata: error.metadata
            },
            receiverId: (0, $2zvMw.ROVO_INLINE_INPUT_BOX_CLIENT_ID),
            groupId: invocationId_1,
            buffer: false,
            openChatOnError: options?.openChatOnError,
            conversationId: options?.conversationId
        });
        // Clean up message tracking for this invocation
        messagesWithUpdateActionsRef.current.delete(invocationId_1);
        return command_1.result();
    }, [
        sendCommand
    ]);
    return (0, $cozmU.useMemo)(()=>({
            onTraceMessage: onTraceMessage,
            onActionPart: onActionPart,
            onActionComplete: onActionComplete,
            onAnswerPart: onAnswerPart,
            onFinalResponse: onFinalResponse,
            onError: onError
        }), [
        onTraceMessage,
        onActionPart,
        onActionComplete,
        onAnswerPart,
        onFinalResponse,
        onError
    ]);
};


const $cd23f59678a0acda$export$4ae751989dace185 = ()=>{
    const [{ currentConversationId: currentConversationId }] = (0, $n71o5.useChatStore)();
    const currentConversationIdRef = (0, $cozmU.useRef)(currentConversationId);
    currentConversationIdRef.current = currentConversationId;
    const { sendMessage: sendMessage, abortRequests: abortRequests } = (0, $3TxKn.useChatStoreActions)();
    const { getTarget: getTarget, getContentContext: getContentContext, getCurrentTargetId: getCurrentTargetId, setTarget: setTarget, clearTarget: clearTarget, getActiveContext: getActiveContext, setCurrentTargetId: setCurrentTargetId } = (0, $gzMZq.useChatContextStoreActions)();
    const promptStreamHook = (0, $c1435cb431a8c757$export$ef93491bca821fa2)();
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const { trackAIMAUEvent: trackAIMAUEvent } = (0, $Ou0Zz.useAnalytics)();
    const [messageIdSelectedForPreview] = (0, $8akfd.useMessageIdSelectedForPreview)();
    const { stagingAreaEntryPoint: stagingAreaEntryPoint } = (0, $8akfd.useStagingAreaState)();
    const { getMessages: getMessages } = (0, $iW40i.useChatMessagesActions)();
    const { preferences: preferences } = (0, $lTU4O.useUserPreferences)();
    const { storeUserMessages: storeUserMessages } = preferences;
    const messageIdSelectedForPreviewRef = (0, $cozmU.useRef)(messageIdSelectedForPreview);
    messageIdSelectedForPreviewRef.current = messageIdSelectedForPreview;
    const stagingAreaEntryPointRef = (0, $cozmU.useRef)(stagingAreaEntryPoint);
    stagingAreaEntryPointRef.current = stagingAreaEntryPoint;
    const trackAIMAUEventRef = (0, $cozmU.useRef)(trackAIMAUEvent);
    trackAIMAUEventRef.current = trackAIMAUEvent;
    const bridgeAPI = (0, $85mU8.getBrowserBridgeAPI)();
    const isFirstInlineMessageOnGlobalContent = (0, $cozmU.useRef)(false);
    const storeUserMessagesRef = (0, $cozmU.useRef)(storeUserMessages);
    storeUserMessagesRef.current = storeUserMessages;
    (0, $cozmU.useEffect)(()=>{
        // we don't want to clash between the rovo chat client which is offered and implemented in desktop
        // and web; in a future iteration, we will re-use the below code in desktop itself.
        if ((0, $95cHD.isWebviewContext)()) return;
        bridgeAPI.on((0, $5Tn11.ROVO_CHAT_CLIENT_ID), (0, $2BLI8.ContentReadyCommand), (command)=>{
            const ctx = command.contentContext;
            setTarget(ctx, {
                id: command.contentId,
                type: command.contentType,
                canProvideContext: command.canProvideContext
            });
            const currentContext = getActiveContext();
            isFirstInlineMessageOnGlobalContent.current = currentContext === 'global';
            // Mark this content as the active target for staging-area context.
            // This ensures broadcasts and follow-up messages use the correct content
            // even if the modal re-sets the page target.
            if ((ctx === 'staging-area' || currentContext === 'staging-area') && (0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true)) setCurrentTargetId(command.contentId);
        });
        bridgeAPI.on((0, $5Tn11.ROVO_CHAT_CLIENT_ID), (0, $2BLI8.ContentDestroyCommand), (command_0)=>{
            const ctx_0 = command_0.contentContext;
            // Targets are stored as arrays; clear by specific ID for the target content.
            clearTarget(ctx_0, command_0.contentId);
            const currentContext_0 = getActiveContext();
            isFirstInlineMessageOnGlobalContent.current = currentContext_0 === 'global';
        });
        bridgeAPI.on((0, $5Tn11.ROVO_CHAT_CLIENT_ID), (0, $3MoJD.InlineInputBoxSendMessageCommand), (command_1)=>{
            if (!command_1.prompt || !command_1.contentId) return;
            setCurrentTargetId(command_1.contentId);
            const encodedPrompt = command_1.skillMetadata ? (0, $6rwn6.encodePromptToAdf)(command_1.prompt, command_1.skillMetadata).adf : (0, $6rwn6.encodeAdf)(command_1.prompt);
            sendMessage({
                ...command_1,
                prompt: encodedPrompt,
                // TODO(ai_mate_store_messages_be_driven): remove this local storeUserMessages payload
                // value when BE user settings are fully rolled out; BE overrides it via the capability header.
                storeUserMessages: storeUserMessagesRef.current,
                promptStreamHook: promptStreamHook,
                messageSources: {
                    interactionSource: command_1.source === 'CONFLUENCE_MAUI_INLINE_EDITOR' ? 'inlineRovoFromRemix' : 'inlineRovo',
                    followUpSource: command_1.source === 'CONFLUENCE_MAUI_INLINE_EDITOR' ? 'inlineRovoFromRemix' : 'inlineRovo',
                    // Mark the Create with Rovo blank-object route on AIMAU events.
                    entryPoint: command_1.source === 'CONFLUENCE_CWR_BLANK_OBJECT' ? 'cwrBlankObject' : undefined
                },
                // Using agents with inline prompt should always start a new chat
                // The first inline prompt message on a new content ID should always start a new chat
                conversationId: command_1.agentId || command_1.shouldStartNewConversation || isFirstInlineMessageOnGlobalContent.current ? (0, $4m5jb.EMPTY_CONVERSATION_ID) : undefined
            });
            isFirstInlineMessageOnGlobalContent.current = false;
        });
        bridgeAPI.on((0, $5Tn11.ROVO_CHAT_CLIENT_ID), (0, $6yHkF.InlineInputBoxAbortMessageCommand), ()=>{
            abortRequests({
                conversationId: currentConversationIdRef.current
            });
            if ((0, $ieeJu.expValEquals)('platform_editor_remove_pause_streaming', 'isEnabled', true)) {
                const currentTargetId = getCurrentTargetId();
                const currentTargetContext = currentTargetId ? getContentContext(currentTargetId) ?? getActiveContext() : getActiveContext();
                const activeTarget = getTarget(currentTargetContext, currentTargetId);
                const activeTargetType = activeTarget?.type;
                if (activeTarget?.id && activeTargetType === 'page') (0, $e4efc8cb7e22be34$export$ff6a2981a5436d75)((0, $jb3zd.StreamLifecycleState).ABORTED, `inline-abort-${Date.now()}`, {
                    id: activeTarget.id,
                    type: activeTargetType
                });
            }
            experienceTracker.abort({
                name: (0, $irnO2.ExperienceName).REMIX_REGENERATE,
                reason: 'User cancelled remix thinking'
            });
        });
        bridgeAPI.on((0, $5Tn11.ROVO_CHAT_CLIENT_ID), (0, $8gcBG.AifcExperienceTrackingCommand), (command_2)=>{
            if (!command_2?.status || !command_2.experienceName) return;
            const featureArea = command_2.attributes?.featureArea;
            if (command_2.status === 'start') {
                const isEditExperienceTrackerFixEnabled = !(0, $iDrrr.fg)('cc-maui-disable-edit-experience-tracker-fixes');
                const attributes = {
                    ...command_2.attributes || {},
                    ...featureArea !== undefined && {
                        featureArea: featureArea
                    },
                    ...command_2.actionType && {
                        actionType: command_2.actionType
                    },
                    ...command_2.actionId && {
                        actionId: command_2.actionId
                    },
                    ...command_2.contentContext && {
                        contentContext: command_2.contentContext
                    },
                    ...command_2.dynamicUiSubtype && {
                        dynamicUiSubtype: command_2.dynamicUiSubtype
                    },
                    ...command_2.remixType && {
                        remixType: command_2.remixType
                    },
                    ...command_2.remixSubtype && {
                        remixSubtype: command_2.remixSubtype
                    },
                    ...currentConversationIdRef.current && {
                        conversationChannelId: currentConversationIdRef.current
                    }
                };
                let collect;
                if (isEditExperienceTrackerFixEnabled) // Collect callbacks have to be constructed parent-side because functions are
                // not serializable and cannot be sent over the bridge as command payload data.
                switch(command_2.experienceName){
                    case (0, $irnO2.ExperienceName).REMIX_REGENERATE:
                        collect = (0, $d91d74abbb95cf45$export$a9538f4db585a467)({
                            conversationChannelId: currentConversationIdRef.current,
                            regenerateSource: command_2.attributes?.regenerateSource,
                            featureArea: featureArea,
                            allowCollectFallback: true,
                            targetIds: {
                                actionId: command_2.actionId ?? undefined,
                                selectionLocalId: command_2.actionId ?? undefined
                            }
                        });
                        break;
                    default:
                        break;
                }
                experienceTracker.start({
                    name: command_2.experienceName,
                    id: command_2.messageId ?? command_2.actionId ?? command_2.experienceName,
                    attributes: attributes,
                    ...collect ? {
                        collect: collect
                    } : {}
                });
            } else if (command_2.status === 'success') experienceTracker.succeed({
                name: command_2.experienceName,
                ...command_2.messageId && {
                    id: command_2.messageId
                },
                attributes: {
                    ...command_2.attributes || {},
                    ...featureArea !== undefined && {
                        featureArea: featureArea
                    },
                    ...command_2.actionType && {
                        actionType: command_2.actionType
                    },
                    ...command_2.actionId && {
                        actionId: command_2.actionId
                    },
                    ...command_2.contentContext && {
                        contentContext: command_2.contentContext
                    },
                    ...command_2.dynamicUiSubtype && {
                        dynamicUiSubtype: command_2.dynamicUiSubtype
                    },
                    ...command_2.remixType && {
                        remixType: command_2.remixType
                    },
                    ...command_2.remixSubtype && {
                        remixSubtype: command_2.remixSubtype
                    },
                    ...command_2.isSafetyViolation && {
                        isSafetyViolation: command_2.isSafetyViolation
                    }
                }
            });
            else if (command_2.status === 'fail') experienceTracker.fail({
                name: command_2.experienceName,
                ...command_2.messageId && {
                    id: command_2.messageId
                },
                error: new Error(command_2.error ?? 'Unknown error'),
                attributes: {
                    ...command_2.attributes || {},
                    ...featureArea !== undefined && {
                        featureArea: featureArea
                    },
                    ...command_2.actionType && {
                        actionType: command_2.actionType
                    },
                    ...command_2.actionId && {
                        actionId: command_2.actionId
                    },
                    ...command_2.contentContext && {
                        contentContext: command_2.contentContext
                    },
                    ...command_2.dynamicUiSubtype && {
                        dynamicUiSubtype: command_2.dynamicUiSubtype
                    },
                    ...command_2.remixType && {
                        remixType: command_2.remixType
                    },
                    ...command_2.remixSubtype && {
                        remixSubtype: command_2.remixSubtype
                    }
                }
            });
            else if (command_2.status === 'abort') {
                const isKillswitchEnabled = (0, $cXtTj.default).getExperimentValue('platform_aifc_bridge_experience_tracker_fix_aborts', 'value', false);
                const attributes_0 = {
                    ...command_2.attributes || {},
                    ...featureArea !== undefined && {
                        featureArea: featureArea
                    },
                    ...command_2.actionType && {
                        actionType: command_2.actionType
                    },
                    ...command_2.actionId && {
                        actionId: command_2.actionId
                    },
                    ...command_2.contentContext && {
                        contentContext: command_2.contentContext
                    },
                    ...command_2.dynamicUiSubtype && {
                        dynamicUiSubtype: command_2.dynamicUiSubtype
                    }
                };
                if (isKillswitchEnabled) experienceTracker.fail({
                    name: command_2.experienceName,
                    ...command_2.messageId && {
                        id: command_2.messageId
                    },
                    error: new Error(command_2.reason ?? 'Aborted'),
                    attributes: attributes_0
                });
                else experienceTracker.abort({
                    name: command_2.experienceName,
                    ...command_2.messageId && {
                        id: command_2.messageId
                    },
                    reason: command_2.reason ?? 'Aborted',
                    attributes: attributes_0
                });
            }
        });
        bridgeAPI.on((0, $5Tn11.ROVO_CHAT_CLIENT_ID), (0, $2YoG8.SmartCreationModalActivatedCommand), (command_3)=>{
            setTarget('staging-area', {
                id: command_3.type,
                // Currently, there is only Jira is using this Command and Jira doesn't have a content id for the smart creation modal
                type: command_3.type,
                canProvideContext: true
            });
        });
        bridgeAPI.on((0, $5Tn11.ROVO_CHAT_CLIENT_ID), (0, $2YoG8.SmartCreationModalDeactivatedCommand), (command_4)=>{
            if (getTarget('staging-area')?.id === command_4.type) {
                clearTarget('staging-area', command_4.type);
                if ((0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true)) setCurrentTargetId(undefined);
            }
        });
        bridgeAPI.on((0, $5Tn11.ROVO_CHAT_CLIENT_ID), (0, $j1J3n.AifcContentCopiedCommand), (command_5)=>{
            const askQuestionAttributes = (0, $ieeJu.expValEquals)('cc-disambiguation-in-cwr', 'isEnabled', true) ? (0, $lUXDc.getConfluenceResultAcceptanceAttributesForAskQuestion)({
                messages: getMessages(currentConversationIdRef.current ?? ''),
                contentId: command_5.contentId
            }) : undefined;
            trackAIMAUEventRef.current({
                type: 'actioned',
                actionResult: 'copy',
                source: 'AIMate',
                invokedFrom: 'AIFC',
                proactive: false,
                userGenerated: true,
                singleInstrumentationID: messageIdSelectedForPreviewRef.current ?? undefined,
                attributes: {
                    isInSmartCreateFlow: true,
                    createdContentProduct: 'confluence',
                    createdContentType: command_5.contentType,
                    copiedCharCount: command_5.copiedCharCount,
                    copiedWordCount: command_5.copiedWordCount,
                    totalDocCharCount: command_5.totalDocCharCount,
                    copiedPercentage: command_5.copiedPercentage,
                    entryPoint: stagingAreaEntryPointRef.current || undefined,
                    ...askQuestionAttributes ?? {}
                }
            });
        });
        // handlers have been setup - now we can mark ourselves as 'ready' to handle incoming messages
        bridgeAPI.ready((0, $5Tn11.ROVO_CHAT_CLIENT_ID));
    }, [
        bridgeAPI,
        sendMessage,
        abortRequests,
        promptStreamHook,
        setTarget,
        clearTarget,
        getTarget,
        getContentContext,
        getCurrentTargetId,
        getActiveContext,
        setCurrentTargetId,
        experienceTracker,
        currentConversationId,
        getMessages
    ]);
    return null;
};



var $j8on0 = parcelRequire("j8on0");








var $4tJut = parcelRequire("4tJut");


var $lx3cN = parcelRequire("lx3cN");


var $7eGGZ = parcelRequire("7eGGZ");


var $dHz2q = parcelRequire("dHz2q");


var $3z1p5 = parcelRequire("3z1p5");





var $5SS4O = parcelRequire("5SS4O");





var $8OiFS = parcelRequire("8OiFS");

const $af50a3081521b9ff$export$ca0820b729763025 = ({ siteId: siteId })=>async ({ setState: setState, dispatch: dispatch }, { setConversationError: setConversationError })=>{
        (0, $hlvTd.addSentryBreadcrumb)('resetChatStoresForSite: clearing chat state for the new site');
        await dispatch((0, $8OiFS.abortRequests)());
        setState({
            ...(0, $4m5jb.createInitialChatState)(),
            liveChatMetadata: null,
            hydratedSiteId: siteId
        });
        setConversationError(undefined);
        (0, $3z1p5.resetAgentStores)();
        (0, $5SS4O.clearQueryCache)();
    };


/**
 * ************************************************************
 * Container
 * ************************************************************
 */ const $07964e27dfae7b36$var$storeInit = ()=>async ({ dispatch: dispatch, getState: getState, setState: setState }, { setChatStatus: setChatStatus, skipAutoConversationSelection: skipAutoConversationSelection, siteId: siteId, forceRestoreConversationId: forceRestoreConversationId })=>{
        (0, $hlvTd.addSentryBreadcrumb)('ChatStoreContainer: storeInit');
        setChatStatus('launching');
        const isSiteSwitchResetEnabled = (0, $iDrrr.fg)('rovo_chat_site_switch_reset');
        const previousSiteId = getState().hydratedSiteId;
        const isSiteChange = isSiteSwitchResetEnabled && Boolean(siteId) && previousSiteId !== undefined && previousSiteId !== siteId;
        if (isSiteSwitchResetEnabled) Promise.resolve().then(()=>{
            setState({
                hydratedSiteId: siteId
            });
        });
        // Init conversation hydrates the chat store with conversation from URL or Storage
        // and fetches conversations list (however, fetching conversations list is performed "in the background")
        // conversations list is fetched to be later on displayed in the sidebar/conversation list to remove/minimize
        // visual delay when user opens the side-navigation; or in full-screen mode to fetch conversations as early as possible;
        const initConversation = async ()=>{
            if (isSiteChange) await dispatch((0, $af50a3081521b9ff$export$ca0820b729763025)({
                siteId: siteId
            }));
            dispatch((0, $dHz2q.hydrateConversationWithExternalParams)({
                autoSelectConversation: !skipAutoConversationSelection,
                forceRestoreConversationId: forceRestoreConversationId
            }));
            (0, $4tJut.interactionMetrics).initializeChannels.start();
            await dispatch((0, $7eGGZ.fetchConversationChannelsData)({
                isInitialLoad: true
            }));
            (0, $4tJut.interactionMetrics).initializeChannels.stop();
        };
        initConversation();
        (0, $hlvTd.addSentryBreadcrumb)('ChatStoreContainer: storeInit completed');
    };
const $07964e27dfae7b36$var$storeInitOnUpdate = ()=>async ({ getState: getState, setState: setState, dispatch: dispatch }, { siteId: siteId })=>{
        if (!(0, $iDrrr.fg)('rovo_chat_site_switch_reset')) return;
        const { hydratedSiteId: hydratedSiteId } = getState();
        if (!siteId || siteId === hydratedSiteId) return;
        await Promise.resolve();
        if (getState().hydratedSiteId === siteId) return;
        setState({
            hydratedSiteId: siteId
        });
        if (hydratedSiteId === undefined) return;
        (0, $hlvTd.addSentryBreadcrumb)('ChatStoreContainer: site changed, re-initialising chat');
        await dispatch((0, $af50a3081521b9ff$export$ca0820b729763025)({
            siteId: siteId
        }));
        await dispatch($07964e27dfae7b36$var$storeInit());
    };
const $07964e27dfae7b36$var$chatStoreContainerOptions = {
    onInit: $07964e27dfae7b36$var$storeInit,
    onUpdate: $07964e27dfae7b36$var$storeInitOnUpdate
};
const $07964e27dfae7b36$export$9b7b433b0520b82b = (0, $j8on0.createContainer)((0, $lx3cN.chatStore), $07964e27dfae7b36$var$chatStoreContainerOptions);






var $1FOPM = parcelRequire("1FOPM");

const $ccc7a37bcb1eb3eb$export$a04da3780397ecbb = (0, $cozmU.lazy)(()=>(0, $1FOPM.importConversationAssistantUI)().then((module)=>({
            default: module.ConversationAssistantUI
        })));












var $iA8l9 = parcelRequire("iA8l9");


var $aQWBL = parcelRequire("aQWBL");


var $aJU2k = parcelRequire("aJU2k");


var $hOUgz = parcelRequire("hOUgz");




















var $k4g8h = parcelRequire("k4g8h");





var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $d59150c4763cb391$var$initialReconnectionState = {
    isReconnecting: false,
    messageId: null
};
const $d59150c4763cb391$var$initialState = {
    reconnections: {}
};
const $d59150c4763cb391$var$store = (0, $8s9DV.createStore)({
    name: 'rovoReconnect',
    initialState: $d59150c4763cb391$var$initialState,
    actions: {
        startReconnection: (conversationId, messageId)=>({ getState: getState, setState: setState })=>{
                const state = getState();
                // Guard: already reconnecting
                if (state.reconnections[conversationId]?.isReconnecting) return false;
                setState({
                    reconnections: {
                        ...state.reconnections,
                        [conversationId]: {
                            isReconnecting: true,
                            messageId: messageId
                        }
                    }
                });
                return true;
            },
        endReconnection: (conversationId)=>({ getState: getState, setState: setState })=>{
                const state = getState();
                setState({
                    reconnections: {
                        ...state.reconnections,
                        [conversationId]: $d59150c4763cb391$var$initialReconnectionState
                    }
                });
            },
        isReconnecting: (conversationId)=>({ getState: getState })=>{
                return getState().reconnections[conversationId]?.isReconnecting ?? false;
            }
    }
});
const $d59150c4763cb391$export$2d5e21bcae15bf2 = (0, $kBr4q.createHook)($d59150c4763cb391$var$store);
const $d59150c4763cb391$export$bec843ddf321b89b = (0, $kBr4q.createActionsHook)($d59150c4763cb391$var$store);
const $d59150c4763cb391$export$489be5bbb9bfa3f2 = (0, $kBr4q.createHook)($d59150c4763cb391$var$store, {
    selector: (state, conversationId)=>state.reconnections[conversationId] ?? $d59150c4763cb391$var$initialReconnectionState
});









var $9qJ1N = parcelRequire("9qJ1N");





var $8VrqA = parcelRequire("8VrqA");


var $12shJ = parcelRequire("12shJ");







const $bd4e57972be9e4ca$export$e0427dd13bcccf1b = ()=>{
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const capabilities = (0, $cozmU.useMemo)(()=>[
            'ask-question-enabled',
            ...(0, $iDrrr.fg)('rovo_chat_csat_interaction_conclusion_signal') ? [
                'interaction-conclusion-v1'
            ] : [],
            ...(0, $iDrrr.fg)('rovo_chat_enable_inline_lumina') ? [
                'inline_lumina_enabled'
            ] : [],
            ...(0, $iDrrr.fg)('rovo_chat_enable_tool_resumption') ? [
                'tool_resumption_enabled'
            ] : [],
            // TODO - once experiment is decided use actionable-follow-ups or actionable-follow-ups-stacked
            // The actual value does not matter outside of SSE. Do this to prevent an additional experiment check.
            ...(0, $iDrrr.fg)('rovo_chat_actionable_followups_enabled') ? [
                'actionable-follow-ups'
            ] : []
        ], // fg() values are static at runtime — gates don't change between renders
    []);
    return capabilities;
};












var $20Kr8 = parcelRequire("20Kr8");

const $e2d7843b3ff1bcdd$export$47f0b7e1efb22e0f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BackBehaviorOverrideProvider(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { children: children } = t0;
    const [override, setOverride] = (0, $cozmU.useState)(null);
    let t1;
    if ($[0] !== override) {
        t1 = {
            override: override,
            setOverride: setOverride
        };
        $[0] = override;
        $[1] = t1;
    } else t1 = $[1];
    const value = t1;
    let t2;
    if ($[2] !== children || $[3] !== value) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $20Kr8.BackBehaviorOverrideContext).Provider, {
            value: value
        }, children);
        $[2] = children;
        $[3] = value;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : function BackBehaviorOverrideProvider({ children: children }) {
    const [override, setOverride] = (0, $cozmU.useState)(null);
    const value = (0, $cozmU.useMemo)(()=>({
            override: override,
            setOverride: setOverride
        }), [
        override
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $20Kr8.BackBehaviorOverrideContext).Provider, {
        value: value
    }, children);
};












var $hJC44 = parcelRequire("hJC44");

const $83df2c4d369ade6b$export$1ea8b76066893345 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { showFlag: showFlag, children: children } = t0;
    let t1;
    if ($[0] !== children || $[1] !== showFlag) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hJC44.default).Provider, {
            value: showFlag
        }, children);
        $[0] = children;
        $[1] = showFlag;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ showFlag: showFlag, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hJC44.default).Provider, {
        value: showFlag
    }, children);












var $kSwu1 = parcelRequire("kSwu1");


var $4MnFz = parcelRequire("4MnFz");


var $24dy7 = parcelRequire("24dy7");


var $8KiU9 = parcelRequire("8KiU9");


var $idzM5 = parcelRequire("idzM5");

const $55592f6773d96032$export$4610738c067a7645 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const { showFlag: showFlagFromFlags } = (0, $4MnFz.useFlags)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage || $[1] !== showFlagFromFlags) {
        t0 = (flagId)=>{
            bb2: switch(flagId){
                case (0, $idzM5.StoreErrorFlagId).CONVERSATION_FORBIDDEN:
                    showFlagFromFlags({
                        id: "conversation-assistant.conversation-forbidden",
                        title: formatMessage((0, $8KiU9.default).conversationForbiddenTitle),
                        description: formatMessage((0, $8KiU9.default).conversationForbiddenDescription),
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                            color: "var(--ds-icon-danger, #C9372C)",
                            label: ""
                        }),
                        isAutoDismiss: true
                    });
                    break bb2;
                case (0, $idzM5.StoreErrorFlagId).CONVERSATION_HISTORY_LOAD_FAILED:
                    showFlagFromFlags({
                        id: "conversation-assistant.conversation-history-load-failed",
                        title: formatMessage((0, $8KiU9.default).conversationHistoryLoadFailedTitle),
                        description: formatMessage((0, $8KiU9.default).conversationHistoryLoadFailedDescription),
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                            color: "var(--ds-icon-danger, #C9372C)",
                            label: ""
                        }),
                        isAutoDismiss: true
                    });
                    break bb2;
                case (0, $idzM5.StoreErrorFlagId).FOLLOW_UP_AGENT_UNAVAILABLE:
                    showFlagFromFlags({
                        id: "ai-mate.follow-up-agent-unavailable",
                        title: formatMessage((0, $8KiU9.default).followUpAgentUnavailableTitle),
                        description: formatMessage((0, $8KiU9.default).followUpAgentUnavailableDescription),
                        appearance: "error",
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                            color: "var(--ds-icon-danger, #C9372C)",
                            label: ""
                        }),
                        isAutoDismiss: true
                    });
            }
        };
        $[0] = formatMessage;
        $[1] = showFlagFromFlags;
        $[2] = t0;
    } else t0 = $[2];
    const showFlag = t0;
    return showFlag;
} : ()=>{
    const { showFlag: showFlagFromFlags } = (0, $4MnFz.useFlags)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const showFlag = (0, $cozmU.useCallback)((flagId)=>{
        switch(flagId){
            case (0, $idzM5.StoreErrorFlagId).CONVERSATION_FORBIDDEN:
                showFlagFromFlags({
                    id: 'conversation-assistant.conversation-forbidden',
                    title: formatMessage((0, $8KiU9.default).conversationForbiddenTitle),
                    description: formatMessage((0, $8KiU9.default).conversationForbiddenDescription),
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                        color: "var(--ds-icon-danger, #C9372C)",
                        label: ""
                    }),
                    isAutoDismiss: true
                });
                break;
            case (0, $idzM5.StoreErrorFlagId).CONVERSATION_HISTORY_LOAD_FAILED:
                showFlagFromFlags({
                    id: 'conversation-assistant.conversation-history-load-failed',
                    title: formatMessage((0, $8KiU9.default).conversationHistoryLoadFailedTitle),
                    description: formatMessage((0, $8KiU9.default).conversationHistoryLoadFailedDescription),
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                        color: "var(--ds-icon-danger, #C9372C)",
                        label: ""
                    }),
                    isAutoDismiss: true
                });
                break;
            case (0, $idzM5.StoreErrorFlagId).FOLLOW_UP_AGENT_UNAVAILABLE:
                showFlagFromFlags({
                    id: 'ai-mate.follow-up-agent-unavailable',
                    title: formatMessage((0, $8KiU9.default).followUpAgentUnavailableTitle),
                    description: formatMessage((0, $8KiU9.default).followUpAgentUnavailableDescription),
                    appearance: 'error',
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                        color: "var(--ds-icon-danger, #C9372C)",
                        label: ""
                    }),
                    isAutoDismiss: true
                });
                break;
        }
    }, [
        showFlagFromFlags,
        formatMessage
    ]);
    return showFlag;
};



var $eKjv9 = parcelRequire("eKjv9");





var $5BOJB = parcelRequire("5BOJB");








var $4MASx = parcelRequire("4MASx");


var $8vae9 = parcelRequire("8vae9");




const $0e8cab1d0778bbd2$export$4fbf4621651f722d = ()=>{
    const { sendCommand: sendCommand } = (0, $3Ak5G.useBridgeSendCommand)();
    const requestJiraContext = (0, $cozmU.useCallback)(async ()=>{
        try {
            const invocation = await sendCommand((0, $8vae9.JiraContextCommand), {
                receiverId: (0, $4MASx.JIRA_SMART_CREATE_TABLE_CLIENT_ID),
                buffer: false
            });
            return await invocation.result() ?? undefined;
        } catch (error) {
            (0, $hlvTd.logException)({
                exception: error,
                name: 'SendJiraContextCommandError'
            });
            return undefined;
        }
    }, [
        sendCommand
    ]);
    return {
        requestJiraContext: requestJiraContext
    };
};















var $1qXpt = parcelRequire("1qXpt");


var $457kL = parcelRequire("457kL");




const $cb145149c0b90d17$export$46457d11c8328445 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { sendCommand: sendCommand } = (0, $3Ak5G.useBridgeSendCommand)();
    let t0;
    if ($[0] !== sendCommand) {
        t0 = async ()=>{
            try {
                const invocation = await sendCommand((0, $457kL.BrowserContextCommand), {
                    receiverId: (0, $1qXpt.ROVO_EXTENSION_CLIENT_ID),
                    buffer: false
                });
                const result = await invocation.result();
                return result;
            } catch (t1) {
                const error = t1;
                (0, $hlvTd.logException)({
                    exception: error,
                    name: "SendBridgeCommandError"
                });
                return;
            }
        };
        $[0] = sendCommand;
        $[1] = t0;
    } else t0 = $[1];
    const requestBrowserContent = t0;
    let t1;
    if ($[2] !== requestBrowserContent) {
        t1 = {
            requestBrowserContent: requestBrowserContent
        };
        $[2] = requestBrowserContent;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const { sendCommand: sendCommand } = (0, $3Ak5G.useBridgeSendCommand)();
    const requestBrowserContent = (0, $cozmU.useCallback)(async ()=>{
        try {
            const invocation = await sendCommand((0, $457kL.BrowserContextCommand), {
                receiverId: (0, $1qXpt.ROVO_EXTENSION_CLIENT_ID),
                buffer: false
            });
            const result = await invocation.result();
            return result;
        } catch (error) {
            (0, $hlvTd.logException)({
                exception: error,
                name: 'SendBridgeCommandError'
            });
            return undefined;
        }
    }, [
        sendCommand
    ]);
    return {
        requestBrowserContent: requestBrowserContent
    };
};


















var $eTCWv = parcelRequire("eTCWv");











var $2yWJZ = parcelRequire("2yWJZ");


var $bxkJA = parcelRequire("bxkJA");


var $1teNl = parcelRequire("1teNl");











var $4Y660 = parcelRequire("4Y660");





var $lzoay = parcelRequire("lzoay");


var $dSoGR = parcelRequire("dSoGR");

const $3198e830c76ae77b$export$afe0f8c15b322bae = (0, $dSoGR.createCommand)('avp-chart-create-command');





const $36224131a47080f4$export$8e7b6355e5c9f9b8 = (0, $dSoGR.createCommand)('avp-chart-delete-command');





const $5c20a362f938841b$export$bf9f3058c24acaf7 = (0, $dSoGR.createCommand)('avp-chart-update-command');





const $2d7555c6a20a6e0d$export$30119ee169641415 = (0, $dSoGR.createCommand)('avp_dashboard_remove_element');





const $33b1e48b44bef4bc$export$1043d497905355c5 = (0, $dSoGR.createCommand)('avp_dashboard_remove_row');





const $a7e4d48d0be08f3f$export$60aa7d56c60ccf3 = (0, $dSoGR.createCommand)('avp-filter-expression-create-command');





const $75314bd107214525$export$8bcde83747cc4995 = (0, $dSoGR.createCommand)('avp-filter-expression-delete-command');





const $913d8206dd988764$export$70ff4e7a2a918421 = (0, $dSoGR.createCommand)('avp-filter-expression-update-command');



var $1HNcu = parcelRequire("1HNcu");


var $hwIq7 = parcelRequire("hwIq7");




const $9304f1c94bc0e75e$export$41fae3f948f80e82 = (0, $dSoGR.createCommand)('confluence-slides-create-command');



var $eDZUH = parcelRequire("eDZUH");


var $iL3p7 = parcelRequire("iL3p7");


var $6HplX = parcelRequire("6HplX");


var $3elg8 = parcelRequire("3elg8");


var $kFVAr = parcelRequire("kFVAr");







const $c835c164f3a5f5c5$export$1e1d6631b3e74025 = (0, $dSoGR.createCommand)('confluence-slides-update-command');



var $jd9s8 = parcelRequire("jd9s8");


var $joJ6c = parcelRequire("joJ6c");


var $j0orF = parcelRequire("j0orF");


var $irHFv = parcelRequire("irHFv");


var $1r5s7 = parcelRequire("1r5s7");


var $l3qz4 = parcelRequire("l3qz4");


var $2xH7b = parcelRequire("2xH7b");














var $2xjCL = parcelRequire("2xjCL");







const $3d563edd0e5ff26e$export$1fbbb7c0119badfd = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $85mU8.getBrowserBridgeAPI)();
        $[0] = t0;
    } else t0 = $[0];
    const bridgeAPI = t0;
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (command, params)=>{
            const paramsWithRovoSenderId = {
                ...params,
                senderId: (0, $5Tn11.ROVO_CHAT_CLIENT_ID)
            };
            return bridgeAPI.broadcast(command, paramsWithRovoSenderId, {
                filter: (0, $2xjCL.isRovoBroadcastConfirmedActions)
            });
        };
        $[1] = t1;
    } else t1 = $[1];
    const broadcastConfirmedActionCommand = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            broadcastConfirmedActionCommand: broadcastConfirmedActionCommand
        };
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ()=>{
    const bridgeAPI = (0, $85mU8.getBrowserBridgeAPI)();
    const broadcastConfirmedActionCommand = (0, $cozmU.useCallback)((command, params)=>{
        const paramsWithRovoSenderId = {
            ...params,
            senderId: (0, $5Tn11.ROVO_CHAT_CLIENT_ID)
        };
        return bridgeAPI.broadcast(command, paramsWithRovoSenderId, {
            filter: (0, $2xjCL.isRovoBroadcastConfirmedActions)
        });
    }, [
        bridgeAPI
    ]);
    return {
        broadcastConfirmedActionCommand: broadcastConfirmedActionCommand
    };
};







var $jIWEY = parcelRequire("jIWEY");

// Shape-only diagnostics for blank AIFC database rows. AFM only sends the
// `document`; this records its shape at stream completion, never its raw content.
// At or below this length a finalized `document` is treated as effectively blank.
const $1f143c6f1fbb4300$var$BLANK_DOCUMENT_LENGTH_THRESHOLD = 2;
// The database `document` is XML-tagged CSV: a `<fields>` block (header
// `field_name,type,configuration` + one line per column) then data rows.
const $1f143c6f1fbb4300$var$FIELDS_OPEN_TAG = '<fields>';
const $1f143c6f1fbb4300$var$FIELDS_CLOSE_TAG = '</fields>';
const $1f143c6f1fbb4300$var$FIELDS_HEADER = 'field_name,type,configuration';
const $1f143c6f1fbb4300$var$firstNonWhitespaceChar = (value)=>{
    const match = value.match(/\S/);
    return match ? match[0] : null;
};
const $1f143c6f1fbb4300$var$isBlankDocument = (rawDocument)=>rawDocument.trim().length <= $1f143c6f1fbb4300$var$BLANK_DOCUMENT_LENGTH_THRESHOLD;
const $1f143c6f1fbb4300$var$extractBlock = (rawDocument, openTag, closeTag)=>{
    const start = rawDocument.indexOf(openTag);
    if (start === -1) return null;
    const end = rawDocument.indexOf(closeTag, start + openTag.length);
    if (end === -1) return null;
    return rawDocument.slice(start + openTag.length, end);
};
const $1f143c6f1fbb4300$var$nonEmptyLines = (block)=>block.split('\n').map((line)=>line.trim()).filter((line)=>line.length > 0);
/** Splits a CSV line into cells, respecting simple double-quoted fields. */ const $1f143c6f1fbb4300$var$splitCsvLine = (line)=>{
    const cells = [];
    let current = '';
    let inQuotes = false;
    for (const char of line){
        if (char === '"') inQuotes = !inQuotes;
        else if (char === ',' && !inQuotes) {
            cells.push(current);
            current = '';
        } else current += char;
    }
    cells.push(current);
    return cells;
};
/** True when every cell in the row is blank. */ const $1f143c6f1fbb4300$var$rowHasNoValues = (line)=>$1f143c6f1fbb4300$var$splitCsvLine(line).every((cell)=>cell.trim().length === 0);
const $1f143c6f1fbb4300$export$dd8651a13acea708 = (rawDocument, contentId)=>{
    const firstChar = $1f143c6f1fbb4300$var$firstNonWhitespaceChar(rawDocument);
    const base = {
        source: 'aifcDatabaseDocumentCategory',
        documentLength: String(rawDocument.length),
        contentId: contentId
    };
    const build = (category, fieldCount = 0, dataRowCount = 0, emptyDataRowCount = 0)=>({
            ...base,
            category: category,
            fieldCount: String(fieldCount),
            dataRowCount: String(dataRowCount),
            emptyDataRowCount: String(emptyDataRowCount)
        });
    if ($1f143c6f1fbb4300$var$isBlankDocument(rawDocument)) return build('emptyDocument');
    if (firstChar === ',') return build('commaPrefixed');
    const fieldsBlock = $1f143c6f1fbb4300$var$extractBlock(rawDocument, $1f143c6f1fbb4300$var$FIELDS_OPEN_TAG, $1f143c6f1fbb4300$var$FIELDS_CLOSE_TAG);
    if (fieldsBlock === null) return build('missingFieldsBlock');
    const fieldsLines = $1f143c6f1fbb4300$var$nonEmptyLines(fieldsBlock);
    if (fieldsLines.length === 0 || fieldsLines[0] !== $1f143c6f1fbb4300$var$FIELDS_HEADER) return build('malformedFieldsHeader');
    const fieldCount = fieldsLines.length - 1; // exclude the header line
    if (fieldCount === 0) return build('malformedFieldsHeader', fieldCount);
    // Data rows: non-empty, non-XML-tag lines after the </fields> tag.
    const afterFields = rawDocument.slice(rawDocument.indexOf($1f143c6f1fbb4300$var$FIELDS_CLOSE_TAG) + $1f143c6f1fbb4300$var$FIELDS_CLOSE_TAG.length);
    const dataLines = $1f143c6f1fbb4300$var$nonEmptyLines(afterFields).filter((line)=>!line.startsWith('<') && !line.startsWith('</'));
    if (dataLines.length === 0) return build('noDataRows', fieldCount);
    const emptyDataRowCount = dataLines.filter($1f143c6f1fbb4300$var$rowHasNoValues).length;
    if (emptyDataRowCount === dataLines.length) return build('emptyDataCells', fieldCount, dataLines.length, emptyDataRowCount);
    const mismatchedRow = dataLines.some((line)=>$1f143c6f1fbb4300$var$splitCsvLine(line).length !== fieldCount);
    if (mismatchedRow) return build('columnCountMismatch', fieldCount, dataLines.length, emptyDataRowCount);
    return build('ok', fieldCount, dataLines.length, emptyDataRowCount);
};



const $571372d50c430197$var$ADDITIONAL_CONTEXT_TIMEOUT_MS = 2000;
const $571372d50c430197$var$getAgentTypeCommandProperties = (agentId)=>(0, $iDrrr.fg)('platform_editor_agentic_step_attribution') ? {
        agentType: agentId && !(0, $2yWJZ.isDefaultRovoChat)({
            agentId: agentId
        }) ? 'convo-ai' : 'rovo_chat'
    } : {};
const $571372d50c430197$var$cloneSerializableValue = (value)=>{
    if (value === undefined || value === null || typeof value !== 'object') return value;
    return typeof window !== 'undefined' && typeof window.structuredClone === 'function' ? window.structuredClone(value) : JSON.parse(JSON.stringify(value));
};
const $571372d50c430197$export$392dcf789ba32ca6 = ()=>{
    const { sendCommand: sendCommand } = (0, $3Ak5G.useBridgeSendCommand)();
    const { broadcastConfirmedActionCommand: broadcastConfirmedActionCommand } = (0, $3d563edd0e5ff26e$export$1fbbb7c0119badfd)();
    const { productKey: productKey, smartCreationContext: smartCreationContext, editorContentIdResolver: editorContentIdResolver } = (0, $eKjv9.useGlobalConfig)();
    const sendBridgeCommand = (0, $cozmU.useCallback)(({ invocationId: invocationId, key: key, data: data, status: status, prompt: prompt, traceId: traceId, requestId: requestId, singleInstrumentationId: singleInstrumentationId, isFinalResponse: isFinalResponse = false, agent: agent, experience: experience })=>{
        const resolveEditorContentId = (contentId)=>// `||` not `??`: an empty id builds the unroutable `confluence-editor-`, so it must fall through.
            (contentId || undefined) ?? // Falls through unchanged if the resolver has no opinion.
            (editorContentIdResolver?.() || undefined) ?? (productKey !== 'confluence' && (0, $iDrrr.fg)('platform_editor_maui_jira_updates_1') ? smartCreationContext?.editor?.editorId : undefined) ?? (0, $93ce060b6123b497$export$365076dec8e1120e)();
        try {
            switch(key){
                case 0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_TO_PAGE_KEY:
                case 0, $aYC8J.CONFLUENCE_AIFC_PAGE_CREATE_KEY:
                    if ((0, $aYC8J.isConfluenceAIFCPageCreateActionData)(data)) {
                        sendCommand((0, $hwIq7.ConfluencePageCreateCommand), {
                            key: key,
                            data: data,
                            isStreamComplete: isFinalResponse,
                            receiverId: (0, $5OXoi.getConfluenceEditorClientId)(data.contentId),
                            groupId: invocationId,
                            traceId: traceId,
                            singleInstrumentationId: singleInstrumentationId
                        });
                        if (status === 'PREPARING' && prompt) sendCommand((0, $3elg8.ConfluenceSubmitPromptOnPageCreateCommand), {
                            receiverId: (0, $5OXoi.getConfluenceEditorClientId)(data.contentId),
                            userPrompt: (0, $jIWEY.extractTextFromDocNode)(prompt)
                        });
                    }
                    break;
                case 0, $aYC8J.AIFC_ADF_UPDATE_KEY:
                    if ((0, $aYC8J.isAIFCADFUpdateActionData)(data)) {
                        const contentId_2 = resolveEditorContentId(data.contentId);
                        if (!contentId_2) break;
                        sendCommand((0, $dE5YE.ConfluenceUpdatePageCommand), {
                            key: key,
                            data: data,
                            isStreamComplete: isFinalResponse,
                            receiverId: (0, $5OXoi.getConfluenceEditorClientId)(contentId_2),
                            groupId: invocationId,
                            traceId: traceId,
                            requestId: requestId,
                            singleInstrumentationId: singleInstrumentationId,
                            ...$571372d50c430197$var$getAgentTypeCommandProperties(agent?.id),
                            agentId: agent?.id,
                            agentName: agent?.name,
                            agentIdentityAccountId: agent?.identityAccountId,
                            isThirdParty: agent?.isThirdParty,
                            // Mark inline edits so the editor receiver only
                            // auto-opens the Post Stream Review "Review moment" for them.
                            isInlineEdit: experience === 'inline_edit'
                        });
                    }
                    break;
                case 0, $aYC8J.DYNAMIC_UI_CREATE_KEY:
                case 0, $aYC8J.IMAGE_CREATE_KEY:
                    if ((0, $aYC8J.isDynamicUiUpdateActionData)(data) || (0, $aYC8J.isImageUpdateActionData)(data) || (0, $aYC8J.isImageCreateData)(data)) {
                        const contentId_0 = resolveEditorContentId(data.contentId);
                        if (!contentId_0) break;
                        sendCommand((0, $dE5YE.ConfluenceUpdatePageCommand), {
                            key: key,
                            data: data,
                            isStreamComplete: isFinalResponse,
                            receiverId: (0, $5OXoi.getConfluenceEditorClientId)(contentId_0),
                            groupId: invocationId,
                            traceId: traceId,
                            requestId: requestId,
                            singleInstrumentationId: singleInstrumentationId,
                            ...$571372d50c430197$var$getAgentTypeCommandProperties(agent?.id)
                        });
                    } else if (key === (0, $aYC8J.IMAGE_CREATE_KEY) && (0, $aYC8J.isImageUpdatePrepareData)(data) && !isFinalResponse) {
                        const contentId_1 = resolveEditorContentId(data.contentId);
                        if (!contentId_1) break;
                        // ACTION_PREPARE: send partial data to trigger loading state on the existing image
                        sendCommand((0, $dE5YE.ConfluenceUpdatePageCommand), {
                            key: key,
                            data: data,
                            isStreamComplete: false,
                            receiverId: (0, $5OXoi.getConfluenceEditorClientId)(contentId_1),
                            groupId: invocationId,
                            traceId: traceId,
                            requestId: requestId,
                            singleInstrumentationId: singleInstrumentationId,
                            ...$571372d50c430197$var$getAgentTypeCommandProperties(agent?.id)
                        });
                    }
                    break;
                case 0, $aYC8J.AIFC_ACTION_CLASSIFICATION_METADATA:
                    if ((0, $iDrrr.fg)('platform_editor_ai_promptversion_in_analytics')) {
                        if ((0, $aYC8J.isAIFCADFSetActionClassificationActionData)(data)) sendCommand((0, $lzoay.ActionClassificationCommand), {
                            data: data,
                            receiverId: (0, $5OXoi.getConfluenceEditorClientId)(data.contentId),
                            groupId: invocationId
                        });
                    }
                    break;
                case 0, $aYC8J.CONFLUENCE_AIFC_DEEP_RESEARCH_PAGE_CREATE_KEY:
                    if ((0, $aYC8J.isConfluenceAIFCDeepResearchPageCreateActionData)(data)) sendCommand((0, $6HplX.ConfluenceDeepResearchPageCreateCommand), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $5OXoi.getConfluenceEditorClientId)(data.contentId),
                        groupId: invocationId
                    });
                    // TODO: Remove isConfluenceAIFCDeepResearchPageCreateActionPrepare condition and type once BE fix is in
                    // https://hello.jira.atlassian.cloud/browse/CCI-12965
                    if ((0, $aYC8J.isConfluenceAIFCDeepResearchPageCreateActionPrepare)(data) || (0, $aYC8J.isConfluenceAIFCDeepResearchPageCreateActionData)(data)) {
                        if (status === 'PREPARING' && prompt) sendCommand((0, $3elg8.ConfluenceSubmitPromptOnPageCreateCommand), {
                            receiverId: (0, $5OXoi.getConfluenceEditorClientId)(data?.contentId),
                            userPrompt: (0, $jIWEY.extractTextFromDocNode)(prompt)
                        });
                    }
                    break;
                case 0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY:
                    if ((0, $aYC8J.isConfluenceAIFCWhiteboardCreateActionData)(data)) sendCommand((0, $iL3p7.ConfluenceWhiteboardCreateCommand), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $6isLN.getConfluenceWhiteboardClientId)(data.contentId),
                        groupId: invocationId,
                        singleInstrumentationID: singleInstrumentationId
                    });
                    break;
                case 0, $aYC8J.CONFLUENCE_AIFC_SLIDES_CREATE_KEY:
                    if ((0, $aYC8J.isConfluenceAIFCSlidesCreateActionData)(data)) sendCommand((0, $9304f1c94bc0e75e$export$41fae3f948f80e82), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $3wccB.getConfluenceSlidesClientId)(data.contentId),
                        groupId: invocationId,
                        singleInstrumentationID: singleInstrumentationId
                    });
                    break;
                case 0, $aYC8J.CONFLUENCE_AIFC_SLIDES_UPDATE_KEY:
                    if ((0, $aYC8J.isConfluenceAIFCSlidesUpdateActionData)(data)) sendCommand((0, $c835c164f3a5f5c5$export$1e1d6631b3e74025), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $3wccB.getConfluenceSlidesClientId)(data.contentId),
                        groupId: invocationId,
                        singleInstrumentationID: singleInstrumentationId
                    });
                    break;
                case 0, $aYC8J.CONFLUENCE_AIFC_DATABASE_CREATE_KEY:
                    if ((0, $aYC8J.isConfluenceAIFCDatabaseCreateActionData)(data)) {
                        // Shape-only blank-row diagnostic; does not change flow.
                        if (isFinalResponse && (0, $iDrrr.fg)('platform_editor_aifc_create_stream_debug')) {
                            const diagnostics = (0, $1f143c6f1fbb4300$export$dd8651a13acea708)(data.document, data.contentId);
                            if (diagnostics.category !== 'ok') (0, $hlvTd.logException)({
                                exception: new Error(`AIFC database create finalized with problematic document: ${diagnostics.category}`),
                                name: 'AifcDatabaseCreateDocumentIssue',
                                tags: diagnostics
                            });
                        }
                        sendCommand((0, $1HNcu.ConfluenceDatabaseCreateCommand), {
                            key: key,
                            data: data,
                            isStreamComplete: isFinalResponse,
                            receiverId: (0, $7lXV4.getConfluenceDatabaseClientId)(data.contentId),
                            groupId: invocationId,
                            singleInstrumentationID: singleInstrumentationId
                        });
                    }
                    break;
                case 0, $aYC8J.CONFLUENCE_AIFC_DATABASE_UPDATE_KEY:
                    if ((0, $aYC8J.isConfluenceAIFCDatabaseUpdateActionData)(data)) sendCommand((0, $kFVAr.ConfluenceDatabaseUpdateCommand), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $7lXV4.getConfluenceDatabaseClientId)(data.contentId),
                        groupId: invocationId,
                        singleInstrumentationID: singleInstrumentationId
                    });
                    break;
                case 0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_UPDATE_KEY:
                    if ((0, $aYC8J.isConfluenceAIFCWhiteboardUpdateActionData)(data)) sendCommand((0, $joJ6c.ConfluenceWhiteboardUpdateCommand), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $6isLN.getConfluenceWhiteboardClientId)(data.contentId),
                        groupId: invocationId,
                        singleInstrumentationID: singleInstrumentationId
                    });
                    break;
                case 0, $aYC8J.CONFLUENCE_WHITEBOARD_BRAINSTORMING_KEY:
                    if ((0, $aYC8J.isConfluenceWhiteboardBrainstormingActionData)(data)) sendCommand((0, $j0orF.ConfluenceWhiteboardBrainstormingCommand), {
                        key: key,
                        data: data,
                        status: status,
                        // Brainst. agent sends `status=SUCCESS` in the last message of the stream to mark end of data
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $6isLN.getConfluenceWhiteboardClientId)(data.contentId),
                        groupId: invocationId
                    });
                    break;
                case 0, $aYC8J.LEGACY_CONFLUENCE_WHITEBOARD_DIAGRAMMING_KEY:
                    if ((0, $aYC8J.isConfluenceWhiteboardDiagrammingActionData)(data)) sendCommand((0, $irHFv.ConfluenceWhiteboardDiagrammingCommand), {
                        key: key,
                        data: data,
                        status: status,
                        // Diag. agent sends `status=SUCCESS` in the last message of the stream to mark end of data
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $6isLN.getConfluenceWhiteboardClientId)(data.contentId),
                        groupId: invocationId
                    });
                    break;
                case 0, $aYC8J.AIFC_CONFLUENCE_WHITEBOARD_DIAGRAMMING_KEY:
                    // This new key goes through the new AIFC flow for diagramming
                    // Before we were going through the legacy flow, LEGACY_CONFLUENCE_WHITEBOARD_DIAGRAMMING_KEY
                    if ((0, $aYC8J.isConfluenceAIFCWhiteboardCreateActionData)(data)) sendCommand((0, $iL3p7.ConfluenceWhiteboardCreateCommand), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $6isLN.getConfluenceWhiteboardClientId)(data.contentId),
                        groupId: invocationId,
                        singleInstrumentationID: singleInstrumentationId
                    });
                    break;
                case 0, $aYC8J.CONFLUENCE_AIFC_SPACE_CREATE_KEY:
                    if ((0, $aYC8J.isConfluenceAIFCSpaceCreateActionData)(data)) sendCommand((0, $eDZUH.ConfluenceSpaceCreateCommand), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $4Y660.CONFLUENCE_SPACE_CLIENT_ID),
                        groupId: invocationId
                    });
                    break;
                case 0, $aYC8J.CONFLUENCE_AIFC_SPACE_UPDATE_KEY:
                    if ((0, $aYC8J.isConfluenceAIFCSpaceUpdateActionData)(data)) sendCommand((0, $jd9s8.ConfluenceSpaceUpdateCommand), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $4Y660.CONFLUENCE_SPACE_CLIENT_ID),
                        groupId: invocationId
                    });
                    break;
                case 0, $eTCWv.AVP_CHART_CREATE_KEY:
                    if ((0, $eTCWv.isAvpChartCreateActionData)(data)) sendCommand((0, $3198e830c76ae77b$export$afe0f8c15b322bae), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $1teNl.getAvpDashboardClientId)(data.dashboardAri),
                        groupId: invocationId
                    });
                    break;
                case 0, $eTCWv.AVP_CHART_DELETE_KEY:
                    if ((0, $eTCWv.isAvpChartDeleteActionData)(data)) sendCommand((0, $36224131a47080f4$export$8e7b6355e5c9f9b8), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $1teNl.getAvpDashboardClientId)(data.dashboardAri),
                        groupId: invocationId
                    });
                    break;
                case 0, $eTCWv.AVP_CHART_UPDATE_KEY:
                    if ((0, $eTCWv.isAvpChartUpdateActionData)(data)) sendCommand((0, $5c20a362f938841b$export$bf9f3058c24acaf7), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $1teNl.getAvpDashboardClientId)(data.dashboardAri),
                        groupId: invocationId
                    });
                    break;
                case 0, $eTCWv.AVP_DASHBOARD_REMOVE_ROW_KEY:
                    if ((0, $eTCWv.isAvpDashboardRemoveRowActionData)(data)) sendCommand((0, $33b1e48b44bef4bc$export$1043d497905355c5), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $1teNl.getAvpDashboardClientId)(data.dashboardAri),
                        groupId: invocationId
                    });
                    break;
                case 0, $eTCWv.AVP_DASHBOARD_REMOVE_ELEMENT_KEY:
                    if ((0, $eTCWv.isAvpDashboardRemoveElementActionData)(data)) sendCommand((0, $2d7555c6a20a6e0d$export$30119ee169641415), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $1teNl.getAvpDashboardClientId)(data.dashboardAri),
                        groupId: invocationId
                    });
                    break;
                case 0, $eTCWv.AVP_FILTER_EXPRESSION_CREATE_KEY:
                    if ((0, $eTCWv.isAvpFilterExpressionCreateActionData)(data)) sendCommand((0, $a7e4d48d0be08f3f$export$60aa7d56c60ccf3), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $1teNl.getAvpDashboardClientId)(data.dashboardAri),
                        groupId: invocationId
                    });
                    break;
                case 0, $eTCWv.AVP_FILTER_EXPRESSION_DELETE_KEY:
                    if ((0, $eTCWv.isAvpFilterExpressionDeleteActionData)(data)) sendCommand((0, $75314bd107214525$export$8bcde83747cc4995), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $1teNl.getAvpDashboardClientId)(data.dashboardAri),
                        groupId: invocationId
                    });
                    break;
                case 0, $eTCWv.AVP_FILTER_EXPRESSION_UPDATE_KEY:
                    if ((0, $eTCWv.isAvpFilterExpressionUpdateActionData)(data)) sendCommand((0, $913d8206dd988764$export$70ff4e7a2a918421), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $1teNl.getAvpDashboardClientId)(data.dashboardAri),
                        groupId: invocationId
                    });
                    break;
                default:
                    (0, $hlvTd.logException)({
                        exception: new Error(`Unsupported action key: ${key}`),
                        name: 'SendBridgeCommandUnsupportedActionKey'
                    });
                    break;
            }
        } catch (error) {
            (0, $hlvTd.logException)({
                exception: error,
                name: 'SendBridgeCommandError'
            });
        }
    }, [
        sendCommand,
        productKey,
        smartCreationContext,
        editorContentIdResolver
    ]);
    // receiver
    const processMessageStreamAction = (0, $cozmU.useCallback)((invocationId_0, streamAction, traceId_0, requestId_0, prompt_0, attributes, agent_0)=>{
        const { message: action } = streamAction;
        if (!(0, $i7OAD.isSupportedStreamAction)(action)) return;
        // serverSideExecution persists content server-side and the iframe loads it by contentId. no FE based streaming
        if ((0, $aYC8J.isServerSideExecutionAction)(action) && (0, $cXtTj.default).getExperimentValue('cwr-be-based-multi-creation-v0', 'isEnabled', false)) return;
        sendBridgeCommand({
            invocationId: invocationId_0,
            key: action.key,
            data: action.data,
            status: action.status,
            prompt: prompt_0,
            isFinalResponse: false,
            traceId: traceId_0,
            requestId: requestId_0,
            singleInstrumentationId: attributes?.singleInstrumentationId,
            agent: agent_0,
            experience: attributes?.experience
        });
    }, [
        sendBridgeCommand
    ]);
    const processMessageStreamComplete = (0, $cozmU.useCallback)((invocationId_1, streamAction_0, traceId_1, requestId_1, attributes_0)=>{
        const { message: action_0 } = streamAction_0;
        if (!(0, $i7OAD.isSupportedStreamAction)(action_0)) return;
        // serverSideExecution persists content server-side and the iframe loads it by contentId. no FE based streaming
        if ((0, $aYC8J.isServerSideExecutionAction)(action_0) && (0, $cXtTj.default).getExperimentValue('cwr-be-based-multi-creation-v0', 'isEnabled', false)) return;
        // metadata is only available on ACTION_COMPLETE for editing remix.
        if (action_0.key === 'dynamic-ui-create' || action_0.key === 'image-create') {
            (0, $irnO2.remixEditExistingExperience).mark((0, $irnO2.REMIX_EDIT_EXISTING_MARKS).ACTION_COMPLETE_RECEIVED);
            const actionData = action_0.data;
            // marking image create to infographic to be same as generating preview
            if (action_0.key === 'image-create') (0, $irnO2.remixEditExistingExperience).addMetadata({
                remixType: 'infographic'
            });
            else (0, $irnO2.remixEditExistingExperience).addMetadata({
                remixType: actionData?.contentType,
                remixSubtype: actionData?.dynamicUiSubtype
            });
        }
        sendBridgeCommand({
            invocationId: invocationId_1,
            key: action_0.key,
            data: action_0.data,
            isFinalResponse: true,
            traceId: traceId_1,
            requestId: requestId_1,
            singleInstrumentationId: attributes_0?.singleInstrumentationId,
            experience: attributes_0?.experience
        });
    }, [
        sendBridgeCommand
    ]);
    const processMessageStreamError = (0, $cozmU.useCallback)((errorInfo)=>{
        // Fail the remix-edit-existing UFO experience when the stream errors.
        // .failure() is a no-op on a non-started experience, so this is safe
        // for non-remix-edit-existing flows.
        if (errorInfo.actionKey === 'dynamic-ui-create' || errorInfo.actionKey === 'image-create') (0, $irnO2.remixEditExistingExperience).failure({
            metadata: {
                errorType: errorInfo.errorType,
                errorMessage: errorInfo.errorMessage,
                traceId: errorInfo.traceId
            }
        });
    }, []);
    const processMessageStreamActionClassification = (0, $cozmU.useCallback)((invocationId_2, streamActionClassification, traceId_2, requestId_2, attributes_1)=>{
        if (streamActionClassification.message.metadata && (0, $iDrrr.fg)('platform_editor_ai_promptversion_in_analytics')) sendBridgeCommand({
            invocationId: invocationId_2,
            key: (0, $aYC8J.AIFC_ACTION_CLASSIFICATION_METADATA),
            data: streamActionClassification.message.metadata,
            isFinalResponse: false,
            traceId: traceId_2,
            requestId: requestId_2,
            singleInstrumentationId: attributes_1?.singleInstrumentationId
        });
    }, [
        sendBridgeCommand
    ]);
    /**
   * Broadcasts confirmed message actions to subscribed clients.
   *
   * Iterates over the provided list of actions, and for each action that is confirmed
   * (as determined by `isConfirmAction`), it sends a broadcast command using
   * `broadcastConfirmedActionCommand`. The broadcast includes the action's key and
   * the provided invocation ID as the group identifier, plus a content ID when available.
   *
   * @param invocationId - The unique identifier for the current invocation or group.
   * @param actions - An array of message action payload contexts to be checked and broadcasted if confirmed.
   */ const broadcastConfirmedActions = (0, $cozmU.useCallback)((invocationId_3, actions)=>{
        for (const action_1 of actions)if ((0, $bxkJA.isConfirmAction)(action_1)) {
            const contentId_3 = (0, $aYC8J.isAIFCADFUpdateActionData)(action_1.data) ? action_1.data.contentId : undefined;
            broadcastConfirmedActionCommand((0, $2xH7b.RovoBroadcastConfirmedActionsCommand), {
                key: action_1.key,
                groupId: invocationId_3,
                ...contentId_3 ? {
                    contentId: contentId_3
                } : {}
            });
        }
    }, [
        broadcastConfirmedActionCommand
    ]);
    const getContentBody = (0, $cozmU.useCallback)(async ({ type: type, id: id, source: source, prompt: prompt_1 })=>{
        const identifier = String(id);
        let receiverId;
        switch(type){
            case 'page':
                receiverId = (0, $5OXoi.getConfluenceEditorClientId)(identifier);
                break;
            case 'whiteboard':
                receiverId = (0, $6isLN.getConfluenceWhiteboardClientId)(identifier);
                break;
            case 'slide':
                receiverId = (0, $3wccB.getConfluenceSlidesClientId)(identifier);
                break;
            case 'database':
                receiverId = (0, $7lXV4.getConfluenceDatabaseClientId)(identifier);
                break;
            case 'dashboard':
                receiverId = (0, $1teNl.getAvpDashboardClientId)(identifier);
                break;
            default:
                receiverId = (0, $5OXoi.getConfluenceEditorClientId)(identifier);
        }
        const shouldSendFastPathInputs = (0, $4o0zT.isExperimentEnabled)('platform_editor_ai_minion_skip_orchestrator');
        const shouldSendSource = source !== undefined && shouldSendFastPathInputs;
        const shouldSendPrompt = prompt_1 !== undefined && shouldSendFastPathInputs;
        const invocation = sendCommand((0, $1r5s7.ReadContentCommand), {
            receiverId: receiverId,
            buffer: false,
            ...shouldSendSource ? {
                source: source
            } : {},
            ...shouldSendPrompt ? {
                // eslint-disable-next-line @atlaskit/platform/no-double-type-assertions -- DocNode is serializable ADF, but its type does not satisfy the bridge SerializableValue index signature.
                prompt: $571372d50c430197$var$cloneSerializableValue(prompt_1)
            } : {}
        });
        return invocation.result();
    }, [
        sendCommand
    ]);
    const getStagingSpace = (0, $cozmU.useCallback)((id_0)=>sendCommand((0, $l3qz4.ReadSpaceCommand), {
            id: id_0,
            receiverId: (0, $4Y660.CONFLUENCE_SPACE_CLIENT_ID),
            buffer: false
        }).result(), [
        sendCommand
    ]);
    const getAdditionalContext = (0, $cozmU.useCallback)(async (receiverId_0)=>{
        let timeoutId;
        try {
            const result = await Promise.race([
                sendCommand((0, $1r5s7.ReadContentCommand), {
                    receiverId: receiverId_0,
                    buffer: false
                }).result(),
                new Promise((resolve)=>{
                    timeoutId = setTimeout(resolve, $571372d50c430197$var$ADDITIONAL_CONTEXT_TIMEOUT_MS);
                })
            ]);
            return result?.contentType === 'page' ? result.additionalContext : undefined;
        } catch  {
            return undefined;
        } finally{
            if (timeoutId !== undefined) clearTimeout(timeoutId);
        }
    }, [
        sendCommand
    ]);
    return {
        getContentBody: getContentBody,
        getAdditionalContext: getAdditionalContext,
        getStagingSpace: getStagingSpace,
        processMessageStreamAction: processMessageStreamAction,
        processMessageStreamComplete: processMessageStreamComplete,
        processMessageStreamError: processMessageStreamError,
        processMessageStreamActionClassification: processMessageStreamActionClassification,
        broadcastStreamStatus: $e4efc8cb7e22be34$export$ff6a2981a5436d75,
        broadcastConfirmedActions: broadcastConfirmedActions
    };
};








const $8447bc9ff2b3f038$export$6f57813fe9f31bf9 = (0, $8s9DV.createStore)({
    initialState: {
        initiator: 'unknown',
        initiatorApplied: false
    },
    actions: {
        initChatInitiator: (initiator)=>({ setState: setState, getState: getState })=>{
                if (!getState().initiatorApplied) setState({
                    initiator: initiator ?? 'unknown',
                    initiatorApplied: true
                });
            },
        getChatInitiator: ()=>({ getState: getState })=>{
                return getState().initiator;
            }
    }
});


const $70f03fc4cd84995c$export$8a56a4af5643d61b = (0, $kBr4q.createActionsHook)((0, $8447bc9ff2b3f038$export$6f57813fe9f31bf9));



var $guRLk = parcelRequire("guRLk");










const $37f0dfcbe79a956a$export$1e02c4fe277d3d74 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const { setChatMode: setChatMode } = (0, $aJU2k.useChatModeStoreActions)();
    let t0;
    if ($[0] !== setChatMode) {
        t0 = (newConversationId, mode)=>{
            setChatMode(newConversationId, {
                autoActionApprovalMode: mode.autoActionApprovalMode ?? "ALWAYS_HUMAN",
                reasoningMode: mode.deepResearchEnabled ? "deep-research" : mode.thinkDeeperEnabled ? mode.alphaExtendedThinkingMode === "LONG_HORIZON" ? "think-deeper-orchestrator" : mode.alphaExtendedThinkingMode === "MARATHON" ? "think-deeper-marathon" : "think-deeper" : mode.planModeEnabled ? "task" : mode.fastModeEnabled ? "fast" : "auto",
                webSearchEnabled: mode.webSearchEnabled ?? false,
                sourceMode: mode.sourceMode ?? "GENERAL",
                useCurrentPageContext: mode.useCurrentPageContext ?? false,
                spaceSourceCount: mode.spaceSourceCount,
                appFilters: mode.appFilters,
                selectedCloudIds: mode.selectedCloudIds ?? []
            });
        };
        $[0] = setChatMode;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const { setChatMode: setChatMode } = (0, $aJU2k.useChatModeStoreActions)();
    return (newConversationId, mode)=>{
        setChatMode(newConversationId, {
            autoActionApprovalMode: mode.autoActionApprovalMode ?? 'ALWAYS_HUMAN',
            // TODO: ROVOFE-1411 - refactor into passing the reasoningMode directly
            reasoningMode: mode.deepResearchEnabled ? 'deep-research' : mode.thinkDeeperEnabled ? mode.alphaExtendedThinkingMode === 'LONG_HORIZON' ? 'think-deeper-orchestrator' : mode.alphaExtendedThinkingMode === 'MARATHON' ? 'think-deeper-marathon' : 'think-deeper' : mode.planModeEnabled ? 'task' : mode.fastModeEnabled ? 'fast' : 'auto',
            webSearchEnabled: mode.webSearchEnabled ?? false,
            sourceMode: mode.sourceMode ?? 'GENERAL',
            useCurrentPageContext: mode.useCurrentPageContext ?? false,
            spaceSourceCount: mode.spaceSourceCount,
            appFilters: mode.appFilters,
            selectedCloudIds: mode.selectedCloudIds ?? []
        });
    };
};




var $iDdTC = parcelRequire("iDdTC");

const $67bde2f896c04cc0$export$d077ccae10682bac = {
    createViewDeadAirMetrics: ()=>{
        return (0, $iDdTC.metrics).interaction({
            key: 'ai-mate.view-dead-air'
        });
    }
};


/**
 * Calculates the total excess dead air time above a given threshold.
 * For each interval exceeding the threshold, only the portion above the threshold is summed.
 * Example: threshold=3000, intervals=[2000, 4000, 5000] => (4000-3000) + (5000-3000) = 3000
 */ function $ed4bda8939492652$export$f21d08fe326f3fd8(intervals, thresholdMs) {
    return intervals.filter((interval)=>interval > thresholdMs).reduce((sum, interval)=>sum + (interval - thresholdMs), 0);
}


const $af849802a7ce9421$export$d679f89c82173941 = (conditions)=>{
    return(// AIFC: Not tracking the full extent of AIFC flow. Visual changes in the staging area
    // (where content is created/modified) are not instrumented, resulting in incomplete metrics.
    conditions.isAIFC || // Deep Research: Has a separate research steps view/handler not tracked by ViewDeadAirTracker.
    // Requires additional instrumentation work to capture accurately.
    conditions.isDeepResearch);
};



var $cWJWG = parcelRequire("cWJWG");

const $3a2dcf28cd216b6e$var$createInitialState = ()=>({
        isActive: false,
        sessionConfig: null,
        startTimestamp: 0,
        previousMark: null,
        intervals: [],
        maxDeadAirMs: 0,
        finishedOnce: false,
        identity: null
    });
const $3a2dcf28cd216b6e$var$LOG_PREFIX = '[ViewDeadAir]';
const $3a2dcf28cd216b6e$var$DEBUG_LOGGING = false; // Set to true for debugging
// Threshold constants in milliseconds
const $3a2dcf28cd216b6e$var$THRESHOLD_3_SECONDS = 3000;
const $3a2dcf28cd216b6e$var$THRESHOLD_5_SECONDS = 5000;
const $3a2dcf28cd216b6e$var$THRESHOLD_7_SECONDS = 7000;
function $3a2dcf28cd216b6e$export$e75a25d5c6776a72(brokerConfig) {
    let state = $3a2dcf28cd216b6e$var$createInitialState();
    function start(config) {
        // If a session was active and never finished, finish it first to avoid losing data
        if (state.isActive && !state.finishedOnce) {
            if ($3a2dcf28cd216b6e$var$DEBUG_LOGGING) // eslint-disable-next-line no-console
            console.log(`${$3a2dcf28cd216b6e$var$LOG_PREFIX} interrupting active session to start new one`);
            finish('interrupted');
        }
        // Preserve identity across session resets
        const currentIdentity = state.identity;
        state = $3a2dcf28cd216b6e$var$createInitialState();
        state.identity = currentIdentity;
        state.isActive = true;
        state.sessionConfig = config;
        state.startTimestamp = performance.now();
        if ($3a2dcf28cd216b6e$var$DEBUG_LOGGING) // eslint-disable-next-line no-console
        console.log(`${$3a2dcf28cd216b6e$var$LOG_PREFIX} Session started:`, config);
    }
    function mark({ id: id, contentType: contentType }) {
        if (!state.isActive) return;
        const now = performance.now();
        const currentMark = {
            id: id,
            contentType: contentType,
            timestamp: now
        };
        if (!state.previousMark) {
            // First mark — interval from session start
            const interval = now - state.startTimestamp;
            if ((0, $cWJWG.shouldExcludeInterval)(interval)) {
                state.previousMark = currentMark;
                return;
            }
            state.intervals.push(interval);
            state.maxDeadAirMs = interval;
            state.previousMark = currentMark;
            if ($3a2dcf28cd216b6e$var$DEBUG_LOGGING) // eslint-disable-next-line no-console
            console.log(`${$3a2dcf28cd216b6e$var$LOG_PREFIX} interval: ${interval.toFixed(1)}ms Mark: id=${id}, contentType=${contentType}`);
            return;
        }
        // Aggregate consecutive stream marks with same id and same contentType
        if (contentType === 'stream' && state.previousMark.id === id && state.previousMark.contentType === 'stream') {
            state.previousMark.timestamp = now;
            return;
        }
        const interval = now - state.previousMark.timestamp;
        if ((0, $cWJWG.shouldExcludeInterval)(interval)) {
            state.previousMark = currentMark;
            return;
        }
        state.intervals.push(interval);
        if (interval > state.maxDeadAirMs) state.maxDeadAirMs = interval;
        state.previousMark = currentMark;
        if ($3a2dcf28cd216b6e$var$DEBUG_LOGGING) // eslint-disable-next-line no-console
        console.log(`${$3a2dcf28cd216b6e$var$LOG_PREFIX} interval: ${interval.toFixed(1)}ms Mark: id=${id}, contentType=${contentType}`);
    }
    function finish(reason) {
        if (state.finishedOnce || !state.isActive) return;
        state.finishedOnce = true;
        state.isActive = false;
        const { intervals: intervals, maxDeadAirMs: maxDeadAirMs, sessionConfig: sessionConfig } = state;
        // Calculate excess dead air time above thresholds
        const excessDeadAirAbove3s = (0, $ed4bda8939492652$export$f21d08fe326f3fd8)(intervals, $3a2dcf28cd216b6e$var$THRESHOLD_3_SECONDS);
        const excessDeadAirAbove5s = (0, $ed4bda8939492652$export$f21d08fe326f3fd8)(intervals, $3a2dcf28cd216b6e$var$THRESHOLD_5_SECONDS);
        const excessDeadAirAbove7s = (0, $ed4bda8939492652$export$f21d08fe326f3fd8)(intervals, $3a2dcf28cd216b6e$var$THRESHOLD_7_SECONDS);
        const result = {
            sessionConfig: sessionConfig,
            reason: reason,
            intervals: intervals,
            maxDeadAirMs: maxDeadAirMs
        };
        brokerConfig?.onEmit?.(result);
        const shouldSkip = (0, $af849802a7ce9421$export$d679f89c82173941)({
            isAIFC: sessionConfig?.isAIFCEnabled ?? false,
            isDeepResearch: sessionConfig?.reasoningMode === 'deep-research'
        });
        if (shouldSkip) {
            if ($3a2dcf28cd216b6e$var$DEBUG_LOGGING) // eslint-disable-next-line no-console
            console.log(`${$3a2dcf28cd216b6e$var$LOG_PREFIX} Skipping metrics (AIFC=${sessionConfig?.isAIFCEnabled}, reasoningMode=${sessionConfig?.reasoningMode})`);
            return;
        }
        // Send browser metric - truncate all numeric values to integers before egress
        const metric = (0, $67bde2f896c04cc0$export$d077ccae10682bac).createViewDeadAirMetrics();
        const now = performance.now();
        const intervalsInt = intervals.map((i)=>Math.trunc(i));
        metric.start({
            startTime: now - maxDeadAirMs
        });
        metric.stop({
            stopTime: now,
            customData: {
                // Session config
                messageId: sessionConfig?.messageId ?? '',
                conversationId: sessionConfig?.conversationId ?? '',
                traceId: sessionConfig?.traceId ?? '',
                productKey: sessionConfig?.productKey ?? '',
                reasoningMode: sessionConfig?.reasoningMode ?? '',
                isAIFCEnabled: sessionConfig?.isAIFCEnabled ?? false,
                isWebSearchEnabled: sessionConfig?.isWebSearchEnabled ?? false,
                reason: // Result data
                reason,
                maxDeadAirMs: Math.trunc(maxDeadAirMs),
                intervalCount: intervalsInt.length,
                intervals: JSON.stringify(intervalsInt),
                // Excess dead air time above thresholds
                excessDeadAirAbove3s: Math.trunc(excessDeadAirAbove3s),
                excessDeadAirAbove5s: Math.trunc(excessDeadAirAbove5s),
                excessDeadAirAbove7s: Math.trunc(excessDeadAirAbove7s)
            }
        });
        if ($3a2dcf28cd216b6e$var$DEBUG_LOGGING) // eslint-disable-next-line no-console
        console.log(`${$3a2dcf28cd216b6e$var$LOG_PREFIX} Session finished (${reason}):`, {
            intervals: result.intervals,
            maxDeadAirMs: result.maxDeadAirMs,
            excessDeadAirAbove3s: excessDeadAirAbove3s,
            excessDeadAirAbove5s: excessDeadAirAbove5s,
            excessDeadAirAbove7s: excessDeadAirAbove7s
        });
    }
    function updateIdentity(newIdentity) {
        // If session is active and identity changed, finish the current session
        if (state.isActive && state.identity !== null && state.identity !== newIdentity) {
            if ($3a2dcf28cd216b6e$var$DEBUG_LOGGING) // eslint-disable-next-line no-console
            console.log(`${$3a2dcf28cd216b6e$var$LOG_PREFIX} identity changed from ${state.identity} to ${newIdentity}, finishing session`);
            finish('identity-changed');
        }
        state.identity = newIdentity;
    }
    return {
        start: start,
        mark: mark,
        finish: finish,
        updateIdentity: updateIdentity
    };
}















var $4KNZy = parcelRequire("4KNZy");

const $fb3a263627da0e72$export$8218c921a415cac1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const handlerRef = (0, $cozmU.useRef)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (handler)=>{
            handlerRef.current = handler;
            return ()=>{
                if (handlerRef.current === handler) handlerRef.current = undefined;
            };
        };
        $[0] = t0;
    } else t0 = $[0];
    const registerHumanMessageIdReplacementHandler = t0;
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (conversationId, oldId, newId)=>{
            (0, $4KNZy.userSubmissionLifecycle).replaceHumanMessageId({
                conversationId: conversationId,
                oldId: oldId,
                newId: newId
            });
            handlerRef.current?.({
                conversationId: conversationId,
                oldId: oldId,
                newId: newId
            });
        };
        $[1] = t1;
    } else t1 = $[1];
    const onHumanMessageIdReplaced = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            onHumanMessageIdReplaced: onHumanMessageIdReplaced,
            registerHumanMessageIdReplacementHandler: registerHumanMessageIdReplacementHandler
        };
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ()=>{
    const handlerRef = (0, $cozmU.useRef)();
    const registerHumanMessageIdReplacementHandler = (0, $cozmU.useCallback)((handler)=>{
        handlerRef.current = handler;
        return ()=>{
            if (handlerRef.current === handler) handlerRef.current = undefined;
        };
    }, []);
    const onHumanMessageIdReplaced = (0, $cozmU.useCallback)((conversationId, oldId, newId)=>{
        (0, $4KNZy.userSubmissionLifecycle).replaceHumanMessageId({
            conversationId: conversationId,
            oldId: oldId,
            newId: newId
        });
        handlerRef.current?.({
            conversationId: conversationId,
            oldId: oldId,
            newId: newId
        });
    }, []);
    return {
        onHumanMessageIdReplaced: onHumanMessageIdReplaced,
        registerHumanMessageIdReplacementHandler: registerHumanMessageIdReplacementHandler
    };
};












var $cRubi = parcelRequire("cRubi");


var $gB5in = parcelRequire("gB5in");


var $cC5sC = parcelRequire("cC5sC");

async function $9efff1c82a0288bb$export$6227c2682e216a37({ chatContextStoreActions: chatContextStoreActions, productKey: productKey = 'confluence', creationContextParams: creationContextParams, contentContext: contentContext, sendAnalyticsEvent: sendAnalyticsEvent = ()=>undefined }) {
    const contentContextValue = contentContext ?? chatContextStoreActions.getActiveContext() ?? 'global';
    const activeTargetId = chatContextStoreActions.getCurrentTargetId();
    const populated = await (0, $cC5sC.populateSendMessageContext)(chatContextStoreActions, // Treat as a non-first prompt so staging-area / CwR follow-up context rules apply.
    false, // Source that is eligible for AIFC context requirements across CwR surfaces.
    'CONFLUENCE_CWR_BLANK_OBJECT', undefined, // Always include current page / surface context for Voice pull.
    true, contentContextValue, creationContextParams, productKey, sendAnalyticsEvent, activeTargetId);
    const browserUrl = populated.browserContext?.context?.browserUrl ?? window.location.href;
    return (0, $gB5in.buildMessageStreamRequestContext)({
        browserUrl: browserUrl,
        // Voice CwR needs browsing context for placement and surface resolution.
        useCurrentBrowsingContext: true,
        editorContext: populated.editorContext,
        whiteboardContext: populated.whiteboardContext,
        slidesContext: populated.slidesContext,
        databaseContext: populated.databaseContext,
        dashboardEditorContext: populated.dashboardEditorContext,
        browserContext: populated.browserContext,
        additionalContext: populated.additionalContext,
        aiFeatureContext: populated.aiFeatureContext,
        jiraWorkflowContext: populated.jiraWorkflowContext,
        dashboardContext: populated.dashboardContext
    });
}


const $f88a73356e9d1aca$export$af9b701d05e4ed42 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useRegisterRovoChatContextProviderForEnterpriseHer(chatContextStoreActions, productKey) {
    const $ = (0, $bDgLe.c)(4);
    let t0;
    let t1;
    if ($[0] !== chatContextStoreActions || $[1] !== productKey) {
        t0 = ()=>{
            (0, $cRubi.setRovoChatContextProvider)(()=>(0, $9efff1c82a0288bb$export$6227c2682e216a37)({
                    chatContextStoreActions: chatContextStoreActions,
                    productKey: productKey
                }));
            return $f88a73356e9d1aca$var$_temp;
        };
        t1 = [
            chatContextStoreActions,
            productKey
        ];
        $[0] = chatContextStoreActions;
        $[1] = productKey;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
} : function useRegisterRovoChatContextProviderForEnterpriseHer(chatContextStoreActions, productKey) {
    (0, $cozmU.useEffect)(()=>{
        (0, $cRubi.setRovoChatContextProvider)(()=>(0, $9efff1c82a0288bb$export$6227c2682e216a37)({
                chatContextStoreActions: chatContextStoreActions,
                productKey: productKey
            }));
        return ()=>{
            (0, $cRubi.setRovoChatContextProvider)(null);
        };
    }, [
        chatContextStoreActions,
        productKey
    ]);
};
function $f88a73356e9d1aca$var$_temp() {
    (0, $cRubi.setRovoChatContextProvider)(null);
}


const $b1c23cecabb25d6f$export$fa770f2a78bdd2f7 = ({ enableBrowserContextBanner: enableBrowserContextBanner, shouldShowContextBanner: shouldShowContextBanner = true, pageType: pageType })=>{
    if (!shouldShowContextBanner) return false;
    // Using browser context (rovo extension sidebar) return true
    if (enableBrowserContextBanner) return true;
    // if user is viewing a 1p atlassian page in mini modal or in product side panel return true else return undefined
    return pageType === 'current_page' ? true : undefined;
};















var $O96nq = parcelRequire("O96nq");

const $c036c439c40c28d8$export$c1e7a155a036a9ec = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ViewDeadAirProvider(t0) {
    const $ = (0, $bDgLe.c)(10);
    const { value: value, identity: identity, children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $iDrrr.fg)("rovo_chat_track_view_dead_air");
        $[0] = t1;
    } else t1 = $[0];
    const isEnabled = t1;
    let t2;
    let t3;
    if ($[1] !== identity || $[2] !== value) {
        t2 = ()=>{
            if (!isEnabled) return;
            if (identity !== undefined && value) value.updateIdentity(identity);
        };
        t3 = [
            identity,
            value,
            isEnabled
        ];
        $[1] = identity;
        $[2] = value;
        $[3] = t2;
        $[4] = t3;
    } else {
        t2 = $[3];
        t3 = $[4];
    }
    (0, $cozmU.useEffect)(t2, t3);
    if (!isEnabled) {
        let t4;
        if ($[5] !== children) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
            $[5] = children;
            $[6] = t4;
        } else t4 = $[6];
        return t4;
    }
    let t4;
    if ($[7] !== children || $[8] !== value) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $O96nq.ViewDeadAirContext).Provider, {
            value: value
        }, children);
        $[7] = children;
        $[8] = value;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : function ViewDeadAirProvider({ value: value, identity: identity, children: children }) {
    const isEnabled = (0, $iDrrr.fg)('rovo_chat_track_view_dead_air');
    (0, $cozmU.useEffect)(()=>{
        if (!isEnabled) return;
        if (identity !== undefined && value) value.updateIdentity(identity);
    }, [
        identity,
        value,
        isEnabled
    ]);
    if (!isEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $O96nq.ViewDeadAirContext).Provider, {
        value: value
    }, children);
};


function $37f8d57d84bed17b$export$cd17d76da7967240() {
    // return packageInfo;
    return {
        name: '@atlassian/conversation-assistant',
        version: 'unavailable'
    };
}


const $8b089c26465af0fa$export$de9a15d22e1ad816 = ({ onPromptSent: onPromptSent, forceRestoreConversationId: forceRestoreConversationId, children: children })=>{
    (0, $6cFsl.di)((0, $bjY3F.useAIMateExperienceTracker), (0, $eKjv9.useGlobalConfig));
    const showFlag = (0, $55592f6773d96032$export$4610738c067a7645)();
    const { getContentBody: getContentBody, getAdditionalContext: getAdditionalContext, getStagingSpace: getStagingSpace, processMessageStreamAction: processMessageStreamAction, processMessageStreamComplete: processMessageStreamComplete, processMessageStreamError: processMessageStreamError, processMessageStreamActionClassification: processMessageStreamActionClassification, broadcastConfirmedActions: broadcastConfirmedActions, broadcastStreamStatus: broadcastStreamStatus } = (0, $571372d50c430197$export$392dcf789ba32ca6)();
    const { requestBrowserContent: requestBrowserContent } = (0, $cb145149c0b90d17$export$46457d11c8328445)();
    const { requestJiraContext: requestJiraContext } = (0, $0e8cab1d0778bbd2$export$4fbf4621651f722d)();
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const assistanceService = (0, $lJ6db.useAssistanceService)();
    const { getIsMounted: getIsChatMounted } = (0, $bGNkz.useUIStoreActions)();
    const { sendAnalyticsEvent: sendAnalyticsEvent, trackAIMAUEvent: trackAIMAUEvent } = (0, $Ou0Zz.useAnalytics)();
    const onSentrySetupFailure = (0, $cozmU.useCallback)((failure)=>{
        sendAnalyticsEvent({
            eventType: 'operational',
            action: 'failed',
            actionSubject: 'sentryClientSetup',
            attributes: failure
        });
    }, [
        sendAnalyticsEvent
    ]);
    const { browserContextSanitizer: browserContextSanitizer, enableBrowserContextBanner: enableBrowserContextBanner, elements: elements, preserveUrlConversationId: preserveUrlConversationId } = (0, $dSCNl.useUIConfig)();
    const { productHeader: productHeader, siteId: siteId } = (0, $eKjv9.useGlobalConfig)();
    const { currentContext: currentContext } = (0, $hOUgz.useCurrentPageAsContext)();
    const [{ currentConversationId: currentConversationId }] = (0, $n71o5.useChatStore)();
    // Read the active conversation's "use current page as context" toggle from the
    // chat mode store so the chat-context provider can derive useCurrentBrowsingContext.
    const { useCurrentPageContext: useCurrentPageContext } = (0, $aQWBL.useChatModeState)(currentConversationId);
    const chatContextStoreActions = (0, $gzMZq.useChatContextProvider)({
        requestBrowserContent: requestBrowserContent,
        requestJiraContext: requestJiraContext,
        getContentBody: getContentBody,
        getAdditionalContext: getAdditionalContext,
        getStagingSpace: getStagingSpace,
        useCurrentNonEditingPageAsContext: (0, $b1c23cecabb25d6f$export$fa770f2a78bdd2f7)({
            enableBrowserContextBanner: enableBrowserContextBanner,
            shouldShowContextBanner: elements?.shouldShowContextBanner,
            pageType: currentContext?.type
        }),
        useCurrentPageContext: useCurrentPageContext
    });
    (0, $f88a73356e9d1aca$export$af9b701d05e4ed42)(chatContextStoreActions, productHeader);
    const { setStatus: setStatus, setConversationError: setConversationError } = (0, $k4g8h.useChatSignalsActions)();
    const { getMessages: getMessages, setMessages: setMessages } = (0, $iW40i.useChatMessagesActions)();
    const { setIsRovoEnabled: setIsRovoEnabled } = (0, $8lt5O.useRovoEntitlementActions)();
    const { startReconnection: startReconnection, endReconnection: endReconnection, isReconnecting: isReconnecting } = (0, $d59150c4763cb391$export$bec843ddf321b89b)();
    (0, $cozmU.useEffect)(()=>{
        (0, $hlvTd.setupSentryClient)({
            packageVersion: (0, $37f8d57d84bed17b$export$cd17d76da7967240)().version,
            product: productHeader,
            onSetupFailure: onSentrySetupFailure
        });
    }, [
        productHeader,
        onSentrySetupFailure
    ]);
    const { processStreamResearch: processStreamResearch, updateResearchMessageId: updateResearchMessageId, markIncompleteResearchesErrored: markIncompleteResearchesErrored, completeAllSteps: completeAllSteps, clearMessageResearch: clearMessageResearch, addImplicitResearchPlan: addImplicitResearchPlan, resetHasReceivedAnswerPart: resetHasReceivedAnswerPart } = (0, $guRLk.useChatMessageResearchActions)();
    const { getChatInitiator: getChatInitiator, initChatInitiator: initChatInitiator } = (0, $70f03fc4cd84995c$export$8a56a4af5643d61b)();
    const { insertHighlightActionsEditorPlaceholder: insertHighlightActionsEditorPlaceholder } = (0, $8VrqA.useHighlightActionsEditorPlaceholder)();
    const { setMessageIdSelectedForPreview: setMessageIdSelectedForPreview, setStagingAreaMode: setStagingAreaMode, setInvocationIdSelectedForPreview: setInvocationIdSelectedForPreview, getMessageIdSelectedForPreview: getMessageIdSelectedForPreview, getInvocationIdSelectedForPreview: getInvocationIdSelectedForPreview } = (0, $8akfd.useStagingAreaActions)();
    const { forceSkipAutoConversationSelection: forceSkipAutoConversationSelection } = (0, $8akfd.useStagingAreaState)();
    const onNewConversationStartingWithSendMessage = (0, $37f0dfcbe79a956a$export$1e02c4fe277d3d74)();
    const { preferences: preferences } = (0, $lTU4O.useUserPreferences)();
    // TODO(ai_mate_store_messages_be_driven): remove this local storeUserMessages payload
    // value when BE user settings are fully rolled out; BE overrides it via the capability header.
    const getStoreUserMessagesPreference = (0, $cozmU.useCallback)(()=>preferences.storeUserMessages, [
        preferences.storeUserMessages
    ]);
    const { activeAction: activeAction } = (0, $5BOJB.useActiveAction)();
    // Skip auto conversation selection if we're already previewing a message or an action is pending.
    // When an action is set, the chat store must start with EMPTY_CONVERSATION_ID rather than
    // restoring the previous conversation from localStorage via autoSelectConversation.
    // Matters only on initialization.
    const skipAutoConversationSelection = !!getMessageIdSelectedForPreview?.() || !!getInvocationIdSelectedForPreview?.() || forceSkipAutoConversationSelection || !!activeAction;
    const onTempMessageIdReplaced = (0, $cozmU.useCallback)((oldId, newId)=>{
        // Update messageIdSelectedForPreview when the message ID changes during streaming
        if (oldId === getMessageIdSelectedForPreview?.()) setMessageIdSelectedForPreview(newId);
    }, [
        getMessageIdSelectedForPreview,
        setMessageIdSelectedForPreview
    ]);
    const { onHumanMessageIdReplaced: onHumanMessageIdReplaced, registerHumanMessageIdReplacementHandler: registerHumanMessageIdReplacementHandler } = (0, $fb3a263627da0e72$export$8218c921a415cac1)();
    const { trackAgentEvent: trackAgentEvent } = (0, $iA8l9.useRovoAgentActionAnalytics)({});
    const { setReasoningMode: setReasoningMode } = (0, $aJU2k.useChatModeStoreActions)();
    const { setSmartContextLinkRecommendations: setSmartContextLinkRecommendations, upsertConversationSpace: upsertConversationSpace } = (0, $12shJ.useSpaceStoreActions)();
    const onConversationSpacesHydrated = (0, $cozmU.useCallback)((_conversationId, spaces)=>{
        spaces.forEach((space)=>upsertConversationSpace(space));
    }, [
        upsertConversationSpace
    ]);
    // Build the unified tasks container dep consumed by chat-store actions.
    // Always assembled (cheap) so the container shape is stable across renders.
    // All read accessors are sweet-state actions so the dep object identity does not depend on store
    // state — chat-store consumers won't re-render on every task mutation.
    const unifiedTasksActions = (0, $9qJ1N.useTasksStoreActions)();
    const unifiedTasksContainerDep = (0, $cozmU.useMemo)(()=>({
            createTaskFromStream: unifiedTasksActions.createTaskFromStream,
            setTaskProgressState: unifiedTasksActions.setTaskProgressState,
            setTaskTodoSnapshot: unifiedTasksActions.setTaskTodoSnapshot,
            ackTaskCompleted: unifiedTasksActions.ackTaskCompleted,
            mergeConversationChannelTasks: unifiedTasksActions.mergeConversationChannelTasks,
            getTaskById: unifiedTasksActions.getTaskById,
            getActiveTaskForConversation: unifiedTasksActions.getActiveTaskForConversation
        }), [
        unifiedTasksActions
    ]);
    const isViewDeadAirEnabled = (0, $iDrrr.fg)('rovo_chat_track_view_dead_air');
    const viewDeadAirBroker = (0, $cozmU.useMemo)(()=>isViewDeadAirEnabled ? (0, $3a2dcf28cd216b6e$export$e75a25d5c6776a72)() : null, [
        isViewDeadAirEnabled
    ]);
    const capabilities = (0, $bd4e57972be9e4ca$export$e0427dd13bcccf1b)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $07964e27dfae7b36$export$9b7b433b0520b82b), {
        isGlobal: true,
        preserveUrlConversationId: (0, $iDrrr.fg)('rovo_chat_preserve_url_conversation_id') && preserveUrlConversationId,
        siteId: siteId,
        onPromptSent: onPromptSent,
        forceRestoreConversationId: forceRestoreConversationId,
        assistanceService: assistanceService,
        experienceTracker: experienceTracker,
        sendAnalyticsEvent: sendAnalyticsEvent,
        trackAIMAUEvent: trackAIMAUEvent,
        chatContextStoreActions: chatContextStoreActions,
        capabilities: capabilities,
        setChatStatus: setStatus,
        setConversationError: setConversationError,
        getMessages: getMessages,
        setMessages: setMessages,
        getIsChatMounted: getIsChatMounted,
        startReconnection: startReconnection,
        endReconnection: endReconnection,
        isReconnecting: isReconnecting,
        setRovoEnabled: setIsRovoEnabled,
        processStreamResearch: processStreamResearch,
        markIncompleteResearchesErrored: markIncompleteResearchesErrored,
        completeAllSteps: completeAllSteps,
        updateResearchMessageId: updateResearchMessageId,
        clearMessageResearch: clearMessageResearch,
        addImplicitResearchPlan: addImplicitResearchPlan,
        resetHasReceivedAnswerPart: resetHasReceivedAnswerPart,
        initChatInitiator: initChatInitiator,
        getChatInitiator: getChatInitiator,
        insertHighlightActionsEditorPlaceholder: insertHighlightActionsEditorPlaceholder,
        processMessageStreamAction: processMessageStreamAction,
        processMessageStreamComplete: processMessageStreamComplete,
        processMessageStreamError: processMessageStreamError,
        processMessageStreamActionClassification: processMessageStreamActionClassification,
        broadcastStreamStatus: broadcastStreamStatus,
        broadcastConfirmedActions: broadcastConfirmedActions,
        setStagingAreaMode: setStagingAreaMode,
        setMessageIdSelectedForPreview: setMessageIdSelectedForPreview,
        setInvocationIdSelectedForPreview: setInvocationIdSelectedForPreview,
        onTempMessageIdReplaced: onTempMessageIdReplaced,
        onHumanMessageIdReplaced: onHumanMessageIdReplaced,
        registerHumanMessageIdReplacementHandler: registerHumanMessageIdReplacementHandler,
        skipAutoConversationSelection: skipAutoConversationSelection,
        onNewConversationStartingWithSendMessage: onNewConversationStartingWithSendMessage,
        browserContextSanitizer: browserContextSanitizer,
        getStoreUserMessagesPreference: getStoreUserMessagesPreference,
        trackAgentEvent: trackAgentEvent,
        viewDeadAirBroker: viewDeadAirBroker,
        showFlag: showFlag,
        setReasoningMode: setReasoningMode,
        unifiedTasksActions: unifiedTasksContainerDep,
        onSpaceSourceRecommendations: setSmartContextLinkRecommendations,
        onConversationSpacesHydrated: onConversationSpacesHydrated
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $83df2c4d369ade6b$export$1ea8b76066893345), {
        showFlag: showFlag
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c036c439c40c28d8$export$c1e7a155a036a9ec), {
        value: viewDeadAirBroker,
        identity: currentConversationId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e2d7843b3ff1bcdd$export$47f0b7e1efb22e0f), null, children)))));
};



var $dPoYT = parcelRequire("dPoYT");

const $ad68d77a48a38e4c$export$d4f9eca8f56c7ee5 = (mode, isFullScreen)=>isFullScreen ? 'rovo-chat.fullscreen' : `rovo-chat.${mode ?? (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR}`;


const $0f2cd6a53c0a2177$export$6e73203ac85a4798 = ({ mode: mode, isFullScreen: isFullScreen, xpcBridge: xpcBridge, xpcProduct: xpcProduct, xpcSubProduct: xpcSubProduct, productKey: productKey })=>({
        bridgeProduct: xpcBridge || (0, $ad68d77a48a38e4c$export$d4f9eca8f56c7ee5)(mode, isFullScreen),
        xpcProduct: xpcProduct || productKey,
        xpcSubProduct: xpcSubProduct
    });












var $dqxOF = parcelRequire("dqxOF");








var $jqg1p = parcelRequire("jqg1p");





var $2zlSy = parcelRequire("2zlSy");

const $53ffa4edfba5c089$export$3e623b13d2da727a = (config)=>{
    // Allow fullscreen override for branch deploy testing purposes
    const processedConfig = // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem('DEBUG_rovo_chat_fullscreen') === 'true' && (0, $iDrrr.fg)('rovo_chat_show_local_frontend_components') ? {
        ...config,
        fullScreen: true
    } : config;
    return {
        ...{
            ...(0, $2zlSy.initialState),
            ...processedConfig,
            enableSkills: processedConfig?.enableSkills ?? (0, $2zlSy.initialState).enableSkills,
            enableAgentMentions: processedConfig?.enableAgentMentions,
            enableAutoSuggest: processedConfig?.enableAutoSuggest ?? (0, $2zlSy.initialState).enableAutoSuggest,
            enableBrowserContextBanner: processedConfig?.enableBrowserContextBanner ?? (0, $2zlSy.initialState).enableBrowserContextBanner,
            disableSettingsModal: processedConfig?.disableSettingsModal ?? (0, $2zlSy.initialState).disableSettingsModal,
            browserContextSanitizer: processedConfig?.browserContextSanitizer,
            elements: {
                ...(0, $2zlSy.initialState).elements,
                ...processedConfig?.elements
            },
            promptInputDroppableUrls: processedConfig?.promptInputDroppableUrls
        }
    };
};



var $jAZYc = parcelRequire("jAZYc");

const $2af21e7e5be03781$var$areAgentsConfigsEqual = (current, next)=>current?.defaultAgentId === next?.defaultAgentId && (0, $jqg1p.areStringArraysEqual)(current?.filter, next?.filter);
const $2af21e7e5be03781$var$getUIConfigForShallowCompare = (config)=>{
    const { customHandlers: _customHandlers, elements: _elements, ...shallowConfig } = config ?? {};
    return shallowConfig;
};
const $2af21e7e5be03781$var$hasCustomHandlersProperty = (config)=>Object.prototype.hasOwnProperty.call(config ?? {}, 'customHandlers');
const $2af21e7e5be03781$var$areUIConfigsEqual = (current, next)=>(0, $dqxOF.shallowEqualObjects)($2af21e7e5be03781$var$getUIConfigForShallowCompare(current), $2af21e7e5be03781$var$getUIConfigForShallowCompare(next)) && (0, $dqxOF.shallowEqualObjects)(current?.elements ?? {}, next?.elements ?? {}) && $2af21e7e5be03781$var$hasCustomHandlersProperty(current) === $2af21e7e5be03781$var$hasCustomHandlersProperty(next) && (0, $dqxOF.shallowEqualObjects)(current?.customHandlers, next?.customHandlers);
const $2af21e7e5be03781$export$1d5179b714ffcf31 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { agentsConfig: agentsConfig, uiConfig: uiConfig } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $cXtTj.default).getExperimentValue("rovo_ttai_segment_render_stabilization", "isEnabled", false);
        $[0] = t1;
    } else t1 = $[0];
    const isTreatmentEnabled = t1 === true;
    const stableAgentsConfig = (0, $jAZYc.useSemanticStableValue)(agentsConfig, isTreatmentEnabled, $2af21e7e5be03781$var$areAgentsConfigsEqual);
    const stableUIConfig = (0, $jAZYc.useSemanticStableValue)(uiConfig, isTreatmentEnabled, $2af21e7e5be03781$var$areUIConfigsEqual);
    let t2;
    if ($[1] !== stableAgentsConfig) {
        t2 = isTreatmentEnabled ? {
            value: (0, $37RgG.createAgentsConfig)(stableAgentsConfig)
        } : undefined;
        $[1] = stableAgentsConfig;
        $[2] = t2;
    } else t2 = $[2];
    const memoizedAgentOverriderValue = t2;
    let t3;
    if ($[3] !== stableUIConfig) {
        t3 = isTreatmentEnabled ? {
            value: (0, $53ffa4edfba5c089$export$3e623b13d2da727a)(stableUIConfig)
        } : undefined;
        $[3] = stableUIConfig;
        $[4] = t3;
    } else t3 = $[4];
    const memoizedUIConfigValue = t3;
    if (memoizedAgentOverriderValue && memoizedUIConfigValue) {
        let t4;
        if ($[5] !== memoizedAgentOverriderValue.value || $[6] !== memoizedUIConfigValue.value) {
            t4 = {
                agentOverriderValue: memoizedAgentOverriderValue.value,
                uiConfigValue: memoizedUIConfigValue.value
            };
            $[5] = memoizedAgentOverriderValue.value;
            $[6] = memoizedUIConfigValue.value;
            $[7] = t4;
        } else t4 = $[7];
        return t4;
    }
    let t4;
    if ($[8] !== agentsConfig) {
        t4 = (0, $37RgG.createAgentsConfig)(agentsConfig);
        $[8] = agentsConfig;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== uiConfig) {
        t5 = (0, $53ffa4edfba5c089$export$3e623b13d2da727a)(uiConfig);
        $[10] = uiConfig;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== t4 || $[13] !== t5) {
        t6 = {
            agentOverriderValue: t4,
            uiConfigValue: t5
        };
        $[12] = t4;
        $[13] = t5;
        $[14] = t6;
    } else t6 = $[14];
    return t6;
} : ({ agentsConfig: agentsConfig, uiConfig: uiConfig })=>{
    const isTreatmentEnabled = (0, $cXtTj.default).getExperimentValue('rovo_ttai_segment_render_stabilization', 'isEnabled', false) === true;
    const stableAgentsConfig = (0, $jAZYc.useSemanticStableValue)(agentsConfig, isTreatmentEnabled, $2af21e7e5be03781$var$areAgentsConfigsEqual);
    const stableUIConfig = (0, $jAZYc.useSemanticStableValue)(uiConfig, isTreatmentEnabled, $2af21e7e5be03781$var$areUIConfigsEqual);
    const memoizedAgentOverriderValue = (0, $cozmU.useMemo)(()=>isTreatmentEnabled ? {
            value: (0, $37RgG.createAgentsConfig)(stableAgentsConfig)
        } : undefined, [
        isTreatmentEnabled,
        stableAgentsConfig
    ]);
    const memoizedUIConfigValue = (0, $cozmU.useMemo)(()=>isTreatmentEnabled ? {
            value: (0, $53ffa4edfba5c089$export$3e623b13d2da727a)(stableUIConfig)
        } : undefined, [
        isTreatmentEnabled,
        stableUIConfig
    ]);
    if (memoizedAgentOverriderValue && memoizedUIConfigValue) return {
        agentOverriderValue: memoizedAgentOverriderValue.value,
        uiConfigValue: memoizedUIConfigValue.value
    };
    return {
        agentOverriderValue: (0, $37RgG.createAgentsConfig)(agentsConfig),
        uiConfigValue: (0, $53ffa4edfba5c089$export$3e623b13d2da727a)(uiConfig)
    };
};












var $cMyWi = parcelRequire("cMyWi");

const $6390d7b9d52b6817$export$94b280d16f0eef6b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { bridgeProduct: bridgeProduct, xpcProduct: xpcProduct, xpcSubProduct: xpcSubProduct, children: children } = t0;
    const smartLinkContext = (0, $cMyWi.useSmartLinkContext)();
    let t1;
    if ($[0] !== bridgeProduct || $[1] !== smartLinkContext || $[2] !== xpcProduct || $[3] !== xpcSubProduct) {
        t1 = {
            ...smartLinkContext,
            bridgeProduct: bridgeProduct,
            xpcProduct: xpcProduct,
            xpcSubProduct: xpcSubProduct
        };
        $[0] = bridgeProduct;
        $[1] = smartLinkContext;
        $[2] = xpcProduct;
        $[3] = xpcSubProduct;
        $[4] = t1;
    } else t1 = $[4];
    const smartCardContextValue = t1;
    let t2;
    if ($[5] !== children || $[6] !== smartCardContextValue) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cMyWi.SmartCardContext).Provider, {
            value: smartCardContextValue
        }, children);
        $[5] = children;
        $[6] = smartCardContextValue;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : ({ bridgeProduct: bridgeProduct, xpcProduct: xpcProduct, xpcSubProduct: xpcSubProduct, children: children })=>{
    const smartLinkContext = (0, $cMyWi.useSmartLinkContext)();
    const smartCardContextValue = (0, $cozmU.useMemo)(()=>({
            ...smartLinkContext,
            bridgeProduct: bridgeProduct,
            xpcProduct: xpcProduct,
            xpcSubProduct: xpcSubProduct
        }), [
        smartLinkContext,
        bridgeProduct,
        xpcProduct,
        xpcSubProduct
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cMyWi.SmartCardContext).Provider, {
        value: smartCardContextValue
    }, children);
};


















var $7SkLu = parcelRequire("7SkLu");


var $gXfti = parcelRequire("gXfti");

var $3PNw6 = parcelRequire("3PNw6");





var $hd4Ag = parcelRequire("hd4Ag");

const $d53b47274490f517$export$b0f54970cfd52c5b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { fullscreen: fullscreen, mode: mode, shouldPublishChatOpenOnTransitionData: t1 } = t0;
    const shouldPublishChatOpenOnTransitionData = t1 === undefined ? true : t1;
    const location = (0, $hd4Ag.useWindowLocation)();
    const previousLocationRef = (0, $cozmU.useRef)(location);
    const [isChatMountedAcrossTransition, setIsChatMountedAcrossTransition] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    let conversationAssistantMode = "unknown";
    const [t2] = (0, $8akfd.useStagingArea)();
    const { stagingAreaMode: stagingAreaMode } = t2;
    if (stagingAreaMode === "modal" || stagingAreaMode === "ephemeralModal") conversationAssistantMode = "aifc-modal";
    else if (fullscreen) conversationAssistantMode = "fullscreen";
    else {
        if (mode === "mini-modal") conversationAssistantMode = "mini-modal";
        else if (mode === "sidebar") conversationAssistantMode = "sidebar";
    }
    let t3;
    let t4;
    if ($[0] !== fullscreen || $[1] !== location) {
        t3 = ()=>{
            if (!fullscreen) (0, $iDrrr.fg)("platform_ufo_custom_cohort_data_migration") ? (0, $7SkLu.addUFOCustomCohortData)("isRovoSidebarVisible", true) : (0, $gXfti.addUFOCustomData)({
                isRovoSidebarVisible: true
            });
            if (previousLocationRef.current !== location) {
                previousLocationRef.current = location;
                setIsChatMountedAcrossTransition(true);
            }
            return $d53b47274490f517$var$_temp;
        };
        t4 = [
            fullscreen,
            location
        ];
        $[0] = fullscreen;
        $[1] = location;
        $[2] = t3;
        $[3] = t4;
    } else {
        t3 = $[2];
        t4 = $[3];
    }
    (0, $cozmU.useLayoutEffect)(t3, t4);
    let t5;
    if ($[4] !== isChatMountedAcrossTransition || $[5] !== shouldPublishChatOpenOnTransitionData) {
        t5 = shouldPublishChatOpenOnTransitionData ? {
            isChatMountedAcrossTransition: isChatMountedAcrossTransition
        } : undefined;
        $[4] = isChatMountedAcrossTransition;
        $[5] = shouldPublishChatOpenOnTransitionData;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== conversationAssistantMode || $[8] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3PNw6.default), {
            data: {
                conversationAssistantMode: conversationAssistantMode,
                ...t5
            }
        });
        $[7] = conversationAssistantMode;
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    return t6;
} : ({ fullscreen: fullscreen, mode: mode, shouldPublishChatOpenOnTransitionData: shouldPublishChatOpenOnTransitionData = true })=>{
    const location = (0, $hd4Ag.useWindowLocation)();
    const previousLocationRef = (0, $cozmU.useRef)(location);
    const [isChatMountedAcrossTransition, setIsChatMountedAcrossTransition] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    let conversationAssistantMode = 'unknown';
    const [{ stagingAreaMode: stagingAreaMode }] = (0, $8akfd.useStagingArea)();
    if (stagingAreaMode === 'modal' || stagingAreaMode === 'ephemeralModal') conversationAssistantMode = 'aifc-modal';
    else if (fullscreen) conversationAssistantMode = 'fullscreen';
    else if (mode === 'mini-modal') conversationAssistantMode = 'mini-modal';
    else if (mode === 'sidebar') conversationAssistantMode = 'sidebar';
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!fullscreen) (0, $iDrrr.fg)('platform_ufo_custom_cohort_data_migration') ? (0, $7SkLu.addUFOCustomCohortData)('isRovoSidebarVisible', true) : (0, $gXfti.addUFOCustomData)({
            isRovoSidebarVisible: true
        });
        if (previousLocationRef.current !== location) {
            previousLocationRef.current = location;
            setIsChatMountedAcrossTransition(true);
        }
        return ()=>{
            (0, $iDrrr.fg)('platform_ufo_custom_cohort_data_migration') ? (0, $7SkLu.addUFOCustomCohortData)('isRovoSidebarVisible', false) : (0, $gXfti.addUFOCustomData)({
                isRovoSidebarVisible: false
            });
        };
    }, [
        fullscreen,
        location
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3PNw6.default), {
        data: {
            conversationAssistantMode: conversationAssistantMode,
            ...shouldPublishChatOpenOnTransitionData ? {
                isChatMountedAcrossTransition: isChatMountedAcrossTransition
            } : undefined
        }
    });
};
function $d53b47274490f517$var$_temp() {
    (0, $iDrrr.fg)("platform_ufo_custom_cohort_data_migration") ? (0, $7SkLu.addUFOCustomCohortData)("isRovoSidebarVisible", false) : (0, $gXfti.addUFOCustomData)({
        isRovoSidebarVisible: false
    });
}


const $8065a799419bdbe8$export$e4ac8b50628685c4 = ({ testId: testId, onCloseChat: onCloseChat, config: config, uiConfig: uiConfig, agentsConfig: agentsConfig, agentVersioningConfig: agentVersioningConfig, isNav4Enabled: isNav4Enabled, sitePickerRender: sitePickerRender, overridingChildren: overridingChildren, modeConfig: modeConfig, getActions: getActions, prioritizeCustomActionResults: prioritizeCustomActionResults, numStartersToShow: numStartersToShow, stagingAreaRef: stagingAreaRef, topOffset: topOffset = 0, tags: tags, initialPrompt: initialPrompt, suppressInitialFocus: suppressInitialFocus, skipChatUI: skipChatUI, forceRestoreConversationId: forceRestoreConversationId })=>{
    (0, $6cFsl.di)((0, $lJ6db.AssistanceServiceProvider), (0, $07964e27dfae7b36$export$9b7b433b0520b82b), (0, $5HApy.SmartCardProvider), (0, $89QZA.AnalyticsContextWithSourceAndProperties));
    const shouldSkipChatUI = skipChatUI ?? Boolean(overridingChildren);
    (0, $cozmU.useMemo)(()=>{
        // Setting devtools in useMemo to make sure we catch the first render.
        // ReactSweetStateDefaults may be undefined when bundlers tree-shake or when the
        // module isn't available at runtime. Guard access to avoid runtime exceptions.
        try {
            if (// eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $iDrrr.fg)('ai_mate_react_sweet_state_devtools') && typeof (0, $kiAM2.default) !== 'undefined' && (0, $kiAM2.default) && 'devtools' in (0, $kiAM2.default)) (0, $kiAM2.default).devtools = true;
        } catch  {
        // swallow errors intentionally — best-effort only
        }
    }, []);
    const ufoContext = (0, $dUAp3.useInteractionContext)();
    const ufoLabelStack = (0, $cozmU.useMemo)(()=>ufoContext?.labelStack ?? [
            {
                name: 'rovo-conversation-assistant'
            }
        ], [
        ufoContext?.labelStack
    ]);
    const setUFOLabelStack = (0, $bjY3F.useUFOLabelStackSetter)();
    (0, $cozmU.useMemo)(()=>{
        setUFOLabelStack(ufoLabelStack);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ufoLabelStack
    ]);
    const profileData = (0, $isp1U.useProfileController)();
    const { isRovoEnabled: isRovoEnabled } = (0, $8lt5O.useRovoEntitlement)();
    (0, $bGNkz.useUIStoreSubscription)();
    const { setIsChatOnboardingMiniModalOpen: setIsChatOnboardingMiniModalOpen } = (0, $bGNkz.useUIStoreActions)();
    const { isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen } = (0, $bGNkz.useUIStore)();
    (0, $cozmU.useEffect)(()=>{
        (0, $de717ae3a7549f1b$export$caa27b16709bc2df)(config.product);
    }, [
        config.product
    ]);
    const [sharedFeaturesInstrumentationId, setSharedFeaturesInstrumentationId] = (0, $cozmU.useState)(undefined);
    const assistanceService = (0, $cozmU.useMemo)(()=>new (0, $lJ6db.AssistanceServiceImpl)({
            baseUrl: config.assistanceServiceConfig?.baseUrl,
            headers: config.assistanceServiceConfig?.headers,
            channelId: config.assistanceServiceConfig?.channelId,
            product: config.product,
            siteId: config.siteId,
            experienceId: config.experienceId ?? (0, $oV0CU.AI_MATE_EXPERIENCE_ID),
            minionAlias: config.assistanceServiceConfig?.minionAlias,
            labelStack: ufoLabelStack
        }), [
        config.assistanceServiceConfig?.baseUrl,
        config.assistanceServiceConfig?.headers,
        config.assistanceServiceConfig?.channelId,
        config.product,
        config.siteId,
        config.experienceId,
        config.assistanceServiceConfig?.minionAlias,
        ufoLabelStack
    ]);
    const globalConfig = (0, $cozmU.useMemo)(()=>(0, $58f16686a4f70667$export$b9c35db6980960f2)({
            ...config,
            profileData: profileData,
            closeChat: ()=>{
                onCloseChat?.();
                if (isChatOnboardingMiniModalOpen) setIsChatOnboardingMiniModalOpen(false);
            }
        }), [
        config,
        profileData,
        onCloseChat,
        setIsChatOnboardingMiniModalOpen,
        isChatOnboardingMiniModalOpen
    ]);
    const { agentOverriderValue: agentOverriderValue, uiConfigValue: uiConfigValue } = (0, $2af21e7e5be03781$export$1d5179b714ffcf31)({
        agentsConfig: agentsConfig,
        uiConfig: uiConfig
    });
    // When initialPrompt is provided, self-publish a chat-new PubSub event
    // to trigger the existing PubSubListener handler which creates a seeded
    // conversation and auto-sends the prompt.
    const initialPromptFiredRef = (0, $cozmU.useRef)(false);
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    (0, $cozmU.useEffect)(()=>{
        if (!initialPrompt || initialPromptFiredRef.current) return;
        initialPromptFiredRef.current = true;
        // Use requestAnimationFrame to ensure PubSubListener has subscribed
        requestAnimationFrame(()=>{
            publish({
                type: 'chat-new',
                source: 'linkedConfluenceDocRovoNudge',
                data: {
                    prompt: initialPrompt,
                    dialogues: [],
                    mode: {
                        useCurrentPageContext: true
                    }
                }
            });
        });
    }, [
        initialPrompt,
        publish
    ]);
    const rovoChatXpcContextValues = (0, $cozmU.useMemo)(()=>(0, $0f2cd6a53c0a2177$export$6e73203ac85a4798)({
            mode: modeConfig?.mode,
            isFullScreen: uiConfig?.fullScreen,
            xpcBridge: config.xpcBridge,
            xpcProduct: config.xpcProduct,
            xpcSubProduct: config.xpcSubProduct,
            productKey: globalConfig.productKey
        }), [
        config.xpcBridge,
        config.xpcProduct,
        config.xpcSubProduct,
        globalConfig.productKey,
        modeConfig?.mode,
        uiConfig?.fullScreen
    ]);
    return(// The order of analytics properties context and experienceTracker matters here
    // for experience tracker to send correct analytics properties, it needs to be under analyticsContext
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $89QZA.AnalyticsContextWithSourceAndProperties), {
        source: "AIMate",
        mode: modeConfig?.mode ?? (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR,
        sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId,
        isAlwaysInSmartCreateFlow: sharedFeaturesInstrumentationId !== undefined ? true : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lt5O.RovoEntitlementSetter), {
        isRovoEnabled: isRovoEnabled
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gyWKg.ErrorBoundary), {
        experienceName: (0, $irnO2.ExperienceName).LOAD_PANEL,
        rethrowErrors: config.rethrowErrors ?? false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6e4c82a4164acfc$export$920227929045c1b5), {
        value: globalConfig
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $37RgG.AgentOverriderProvider), {
        value: agentOverriderValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $31f0ba1c2c4d97e2$export$51f901728a02d39c), {
        value: agentVersioningConfig
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $735ca6a936ab5049$export$3063519296e335bf), {
        value: uiConfigValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HApy.SmartCardProvider), {
        bridgeProduct: rovoChatXpcContextValues.bridgeProduct,
        xpcProduct: rovoChatXpcContextValues.xpcProduct,
        xpcSubProduct: rovoChatXpcContextValues.xpcSubProduct
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6390d7b9d52b6817$export$94b280d16f0eef6b), rovoChatXpcContextValues, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7akNQ.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lJ6db.AssistanceServiceProvider), {
        value: assistanceService
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $557d858394512263$export$b0b2d9624bbf3936), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d53b47274490f517$export$b0f54970cfd52c5b), {
        fullscreen: uiConfig?.fullScreen,
        mode: modeConfig?.mode ?? (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR,
        shouldPublishChatOpenOnTransitionData: !shouldSkipChatUI
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8b089c26465af0fa$export$de9a15d22e1ad816), {
        onPromptSent: config.onPromptSent,
        forceRestoreConversationId: forceRestoreConversationId
    }, shouldSkipChatUI ? // NOTE: `overridingChildren` consumers (e.g. CwR staging-area-modal,
    // chat-only-creation-modal) are responsible for wrapping their own
    // subtree with `RovoSettingsModalProvider` so entrypoints to the
    // settings modal work via useSideNavModal(). The provider is
    // idempotent, so defensive wrapping is safe. See ASIMO-3977.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j180q.AnalyticsPropertiesUpdater), null), overridingChildren) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        fallback: null,
        interactionName: "LoadingConversationAssistantUIBundle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ccc7a37bcb1eb3eb$export$a04da3780397ecbb), {
        config: config,
        getActions: getActions,
        isNav4Enabled: isNav4Enabled,
        modeConfig: modeConfig,
        numStartersToShow: numStartersToShow,
        prioritizeCustomActionResults: prioritizeCustomActionResults,
        setSharedFeaturesInstrumentationId: setSharedFeaturesInstrumentationId,
        sitePickerRender: sitePickerRender,
        stagingAreaRef: stagingAreaRef,
        suppressInitialFocus: suppressInitialFocus,
        tags: tags,
        testId: testId,
        topOffset: topOffset,
        uiConfig: uiConfig
    })), ((0, $iDrrr.fg)('aifc_create_enabled') || (0, $iDrrr.fg)('jira_aifc_enabled') || (0, $iDrrr.fg)('rovo-ext_aifc_enabled')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cd23f59678a0acda$export$4ae751989dace185), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $741693f1d6085f6e$export$1f35aa17211e523d), null)))))))))))))));
};


const $4bc8868ee45f5b87$export$9777b121d71c4de1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    let props;
    let skipRelayProvider;
    if ($[0] !== t0) {
        ({ skipRelayProvider: skipRelayProvider, ...props } = t0);
        $[0] = t0;
        $[1] = props;
        $[2] = skipRelayProvider;
    } else {
        props = $[1];
        skipRelayProvider = $[2];
    }
    const shouldSkipChatUI = props.skipChatUI ?? Boolean(props.overridingChildren);
    const rootSegmentName = shouldSkipChatUI ? "rovo-conversation-assistant-wOverriddenChildren" : "rovo-conversation-assistant";
    let t1;
    if ($[3] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8065a799419bdbe8$export$e4ac8b50628685c4), props);
        $[3] = props;
        $[4] = t1;
    } else t1 = $[4];
    const content = t1;
    let t2;
    if ($[5] !== content || $[6] !== skipRelayProvider) {
        t2 = skipRelayProvider && (0, $iDrrr.fg)("ai_agent_sessions_warming_cache") ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, content);
        $[5] = content;
        $[6] = skipRelayProvider;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    if ($[8] !== rootSegmentName || $[9] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: rootSegmentName
        }, t2);
        $[8] = rootSegmentName;
        $[9] = t2;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : ({ skipRelayProvider: skipRelayProvider, ...props })=>{
    // Mounts that skip the chat UI still initialise the shared providers, the global chat store and the
    // bridge API handlers. `overridingChildren` is the legacy signal for the same intent, so it keeps
    // implying the chat UI is skipped.
    const shouldSkipChatUI = props.skipChatUI ?? Boolean(props.overridingChildren);
    const rootSegmentName = shouldSkipChatUI ? 'rovo-conversation-assistant-wOverriddenChildren' : 'rovo-conversation-assistant';
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8065a799419bdbe8$export$e4ac8b50628685c4), props);
    return(// The UFOSegment has to be absolute top, please do not introduce any side effects in this parent level component,
    // otherwise it may not get captured with performance metrics
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: rootSegmentName
    }, skipRelayProvider && (0, $iDrrr.fg)('ai_agent_sessions_warming_cache') ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, content)));
};
module.exports["ConversationAssistant"] = $4bc8868ee45f5b87$export$9777b121d71c4de1;

});

parcelRegister("7akNQ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $a2foB = parcelRequire("a2foB");


var $FKQbh = parcelRequire("FKQbh");


var $iXRmn = parcelRequire("iXRmn");


var $lqtHz = parcelRequire("lqtHz");

const $08beb25a8c4ef160$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
const $08beb25a8c4ef160$export$a4270ab432ac8a58 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function FlagsProvider(t0) {
    const $ = (0, $bDgLe.c)(13);
    const { children: children, shouldRenderToParent: shouldRenderToParent } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [flags, setFlags] = (0, $cozmU.useState)(t1);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (id)=>{
            setFlags((current)=>current.slice(0).filter((flag)=>flag.id !== id));
        };
        $[1] = t2;
    } else t2 = $[1];
    const removeFlag = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            showFlag: function show(value) {
                const flag_0 = {
                    ...value,
                    id: value.id || $08beb25a8c4ef160$var$getUniqueId()
                };
                setFlags((current_0)=>{
                    const index = current_0.findIndex((value_0)=>value_0.id === flag_0.id);
                    if (index === -1) return [
                        flag_0,
                        ...current_0
                    ];
                    const shallow = [
                        ...current_0
                    ];
                    shallow[index] = flag_0;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag_0.id);
                };
            },
            hideFlag: removeFlag
        };
        $[2] = t3;
    } else t3 = $[2];
    const api = t3;
    let t4;
    if ($[3] !== children) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iXRmn.FlagContext).Provider, {
            value: api,
            children: children
        });
        $[3] = children;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== flags) {
        t5 = flags.map($08beb25a8c4ef160$var$_temp);
        $[5] = flags;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== shouldRenderToParent || $[8] !== t5) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lqtHz.default), {
            onDismissed: removeFlag,
            shouldRenderToParent: shouldRenderToParent,
            children: t5
        });
        $[7] = shouldRenderToParent;
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== t4 || $[11] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
            children: [
                t4,
                t6
            ]
        });
        $[10] = t4;
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    return t7;
} : function FlagsProvider({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $cozmU.useState)([]);
    const removeFlag = (0, $cozmU.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $cozmU.useMemo)(()=>({
            showFlag: function show(value) {
                const flag_0 = {
                    ...value,
                    id: value.id || $08beb25a8c4ef160$var$getUniqueId()
                };
                setFlags((current_0)=>{
                    const index = current_0.findIndex((value_0)=>value_0.id === flag_0.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag_0,
                        ...current_0
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current_0
                    ];
                    shallow[index] = flag_0;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag_0.id);
                };
            },
            hideFlag: removeFlag
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iXRmn.FlagContext).Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lqtHz.default), {
                onDismissed: removeFlag,
                shouldRenderToParent: shouldRenderToParent,
                children: flags.map((flag_1)=>{
                    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag_1;
                    const FlagType = isAutoDismiss ? (0, $a2foB.default) : (0, $FKQbh.default);
                    return /*#__PURE__*/ (0, $cozmU.createElement)(FlagType, {
                        ...restProps,
                        key: flag_1.id
                    });
                })
            })
        ]
    });
};
function $08beb25a8c4ef160$var$_temp(flag_1) {
    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag_1;
    const FlagType = isAutoDismiss ? (0, $a2foB.default) : (0, $FKQbh.default);
    return /*#__PURE__*/ (0, $cozmU.createElement)(FlagType, {
        ...restProps,
        key: flag_1.id
    });
}
module.exports["FlagsProvider"] = $08beb25a8c4ef160$export$a4270ab432ac8a58;

});

parcelRegister("iXRmn", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $bbe556224ecd1c1b$export$2eb95677cf2465e1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(null);
module.exports["FlagContext"] = $bbe556224ecd1c1b$export$2eb95677cf2465e1;

});

parcelRegister("37RgG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");

const $cd2bff7865b1d155$export$ccc6603eb027f48b = /*#__PURE__*/ (0, $cozmU.createContext)({});
const $cd2bff7865b1d155$export$7b61e11d4e81ba17 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($cd2bff7865b1d155$export$ccc6603eb027f48b);
} : ()=>(0, $cozmU.useContext)($cd2bff7865b1d155$export$ccc6603eb027f48b);
const $cd2bff7865b1d155$export$aa582af5b4b72bb2 = $cd2bff7865b1d155$export$ccc6603eb027f48b.Provider;
const $cd2bff7865b1d155$export$6aab84dc399ad753 = (config)=>({
        agentDefaultIdOverride: config?.defaultAgentId,
        agentIdFiltersOverride: config?.filter
    });
module.exports["useAgentOverrider"] = $cd2bff7865b1d155$export$7b61e11d4e81ba17;
module.exports["AgentOverriderProvider"] = $cd2bff7865b1d155$export$aa582af5b4b72bb2;
module.exports["createAgentsConfig"] = $cd2bff7865b1d155$export$6aab84dc399ad753;

});

parcelRegister("8lt5O", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $464fa95e1d18f18e$var$rovoEntitlementStore = (0, $8s9DV.createStore)({
    initialState: {
        isRovoEnabled: false
    },
    name: 'RovoEntitlementStore',
    actions: {
        setIsRovoEnabled: (isRovoEnabled, reason)=>({ setState: setState })=>{
                setState({
                    isRovoEnabled: isRovoEnabled,
                    reason: reason
                });
            }
    }
});
const $464fa95e1d18f18e$var$useStateHook = (0, $kBr4q.createStateHook)($464fa95e1d18f18e$var$rovoEntitlementStore);
const $464fa95e1d18f18e$export$66d5dd4be64dea43 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const result = $464fa95e1d18f18e$var$useStateHook();
    let t0;
    if ($[0] !== result) {
        t0 = {
            ...result,
            isRovoEnabled: result.isRovoEnabled
        };
        $[0] = result;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const result = $464fa95e1d18f18e$var$useStateHook();
    return {
        ...result,
        isRovoEnabled: result.isRovoEnabled
    };
};
const $464fa95e1d18f18e$export$8004893135276275 = (0, $kBr4q.createActionsHook)($464fa95e1d18f18e$var$rovoEntitlementStore);
const $464fa95e1d18f18e$export$d03a05ad8547472c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const { isRovoEnabled: isRovoEnabled } = t0;
    const { setIsRovoEnabled: setIsRovoEnabled } = $464fa95e1d18f18e$export$8004893135276275();
    setIsRovoEnabled(isRovoEnabled);
    return null;
} : ({ isRovoEnabled: isRovoEnabled })=>{
    const { setIsRovoEnabled: setIsRovoEnabled } = $464fa95e1d18f18e$export$8004893135276275();
    (0, $cozmU.useMemo)(()=>{
        setIsRovoEnabled(isRovoEnabled);
    }, [
        isRovoEnabled,
        setIsRovoEnabled
    ]);
    return null;
};
module.exports["useRovoEntitlement"] = $464fa95e1d18f18e$export$66d5dd4be64dea43;
module.exports["useRovoEntitlementActions"] = $464fa95e1d18f18e$export$8004893135276275;
module.exports["RovoEntitlementSetter"] = $464fa95e1d18f18e$export$d03a05ad8547472c;

});

parcelRegister("irnO2", function(module, exports) {

var $cNAch = parcelRequire("cNAch");


var $4MiWC = parcelRequire("4MiWC");

const $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1 = {
    LOAD_PANEL: 'aiMateLoadPanel',
    LOAD_PANEL_COMPOSABLE_EDITOR: 'aiMateLoadPanelComposableEditor',
    LOAD_INLINE_EDITOR: 'aiMateLoadInlineComposableEditor',
    LOAD_BROWSE_AGENTS: 'aiMateLoadBrowseAgents',
    SEARCH_BROWSE_AGENTS: 'aiMateSearchBrowseAgents',
    LOAD_CREATE_AGENT: 'aiMateLoadCreateAgent',
    LOAD_AUTO_SUGGEST_SKILLS_LEGACY: 'aiMateAutoSuggestSkillsLegacy',
    LOAD_AUTO_SUGGEST_SKILLS_UNIFIED: 'aiMateAutoSuggestSkillsUnified',
    LOAD_CHAT_PROMPT_INPUT_SKILLS: 'aiMateChatPromptInputSkillsLoad',
    LOAD_INLINE_CHAT_PROMPT_INPUT_SKILLS: 'aiMateInlineChatPromptInputSkillsLoad',
    FETCH_CHAT: 'aiMateFetchChat',
    PREFETCH_CHAT: 'aiMatePrefetchChat',
    FETCH_AGENTS: 'aiMateFetchAgents',
    FETCH_AGENTS_PAGINATED: 'aiMateFetchAgentsPaginated',
    FETCH_AGENTS_OVERRIDES: 'aiMateFetchAgentsOverrides',
    FETCH_AGENT_BY_AGENT_ID: 'aiMateFetchAgentByAgentId',
    FETCH_SCENARIO_LIST: 'aiMateFetchScenarioList',
    FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID: 'aiMateFetchAgentByIdentityAccountId',
    FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE: 'aiMateFetchAgentByExternalConfigReference',
    FETCH_AGENT_DEBUG_MODAL_DATA: 'aiMateFetchAgentDebugModalData',
    FETCH_AGENT_DEBUG_MODAL_CONVERSATION_REVIEW: 'aiMateFetchAgentDebugModalDataConversationReview',
    CREATE_AGENT: 'aiMateCreateAgent',
    UPDATE_AGENT: 'aiMateUpdateAgent',
    DELETE_AGENT: 'aiMateDeleteAgent',
    DUPLICATE_AGENT: 'aiMateDuplicateAgent',
    HYDRATE_AGENT_DATA: 'aiMateHydrateAgentData',
    HYDRATE_SKILL_METADATA: 'aiMateHydrateSkillMetadata',
    FAVOURITE_AGENT: 'aiMateFavouriteAgent',
    UNFAVOURITE_AGENT: 'aiMateUnfavouriteAgent',
    CLEAR_CHAT: 'aiMateClearChat',
    SEND_MESSAGE: 'aiMateSendMessage',
    SEND_MESSAGE_ROVO_CUSTOM_AGENT: 'aiMateSendMessageRovoCustomAgent',
    SEND_DR_MESSAGE: 'aiMateSendDRMessage',
    SEND_TD_MESSAGE: 'aiMateSendThinkDeeperMessage',
    SEND_TASK_MODE_MESSAGE: 'aiMateSendTaskModeMessage',
    SEND_CONFIRMED_TOOLS_MESSAGE: 'aiMateSendConfirmedToolsMessage',
    SEND_CONFIRMED_TOOLS_TASK_MODE_MESSAGE: 'aiMateSendConfirmedToolsTaskModeMessage',
    SEND_A2UI_ACTION: 'aiMateSendA2UIAction',
    RECONNECT_TO_ACTIVE_STREAM: 'aiMateReconnectToActiveStream',
    ABORT_AGENT_STREAM: 'aiMateAbortAgentStream',
    ANSWER_NOW: 'aiMateAnswerNow',
    HYDRATE_CONVERSATION: 'aiMateHydrateConversation',
    GET_CONVERSATION_CHANNELS: 'aiMateGetConversationChannels',
    GET_CONVERSATION_CHANNELS_INITIAL_LOAD: 'aiMateGetConversationChannelsInitialLoad',
    LOAD_MORE_CONVERSATION_CHANNELS: 'aiMateLoadMoreConversationChannels',
    UPDATE_CONVERSATION_CHANNEL: 'aiMateUpdateConversationChannel',
    CREATE_SEEDED_CONVERSATION_CHANNEL: 'aiMateCreateSeededConversationChannel',
    PUBSUB_LISTENER: 'aiMatePubSubListener',
    FETCH_AGENT_TENANT_DATA: 'aiMateFetchAgentTenantData',
    RESOLVE_CONVERSATION_ACTION: 'aiMateResolveConversationAction',
    BULK_RESOLVE_CONVERSATION_ACTIONS: 'aiMateBulkResolveConversationActions',
    MESSAGE_RENDERER: 'aiMateMessageRenderer',
    FETCH_CONTEXTUAL_STARTERS: 'aiMateFetchContextualStarters',
    FETCH_DYNAMIC_CONVERSATION_STARTERS: 'aiMateFetchDynamicConversationStarters',
    GENERATE_CONVERSATION_STARTERS: 'aiMateGenerateConversationStarters',
    FETCH_AGENT_TEAM_DATA: 'aiMateFetchAgentTeamData',
    FETCH_CONNECTED_KNOWLEDGE_SOURCES: 'aiMateFetchConnectedKnowledgeSources',
    FETCH_CONNECTED_KNOWLEDGE_SOURCES_STORE: 'aiMateFetchKnowledgeSourcesStore',
    PREFETCH_CONNECTED_KNOWLEDGE_SOURCES_STORE: 'aiMatePrefetchKnowledgeSourcesStore',
    FETCH_AGENT_ACTIONS: 'aiMateFetchAgentActions',
    CHANGE_AGENT_OWNER: 'aiMateChangeAgentOwner',
    GET_AGENT_PERMISSIONS: 'aiMateGetAgentPermissions',
    AIFC_FINALIZE_CONTENT: 'aiMateAIFCFinalizeContent',
    PREVIEW_CONTENT: 'aiMatePreviewContent',
    PREVIEW_CARD_RENDER: 'aiMatePreviewCardRender',
    JIRA_PREVIEW_CARD_RENDER: 'aiMateJiraPreviewCardRender',
    JSM_PREVIEW_CARD_RENDER: 'aiMateJsmPreviewCardRender',
    FETCH_AGENT_SITE_PERMISSIONS: 'aiMateFetchAgentSitePermissions',
    PREFETCH_AGENT_SITE_PERMISSIONS: 'aiMatePrefetchAgentSitePermissions',
    SEND_MESSAGE_NL_AGENT: 'aiMateSendMessageNLAgent',
    FILTERED_CLIENT_ERROR: 'aiMateFilteredClientError',
    GET_RECOMMENDED_AGENTS: 'aiMateGetRecommendedAgents',
    PREFETCH_RECOMMENDED_AGENTS: 'aiMatePrefetchRecommendedAgents',
    PREFETCH_RECOMMENDED_SPACES: 'aiMatePrefetchRecommendedSpaces',
    OPEN_RECOMMENDED_SPACES: 'aiMateOpenRecommendedSpaces',
    UPLOAD_FILES_TO_CONVERSATION: 'aiMateUploadFilesToConversation',
    VALIDATE_FILES: 'aiMateValidateFiles',
    GET_CONVERSATION_FILES: 'aiMateGetConversationFiles',
    AIFC_MESSAGE: 'aiMateAifcMessage',
    AIFC_LOAD_STAGING_AREA_MODAL: 'aiMateLoadStagingAreaModal',
    AIFC_TWC_ONBOARDING_MODAL_LAUNCH: 'aiMateTwcAifcOnboardingModalLaunch',
    AIFC_LOAD_CHAT_ONLY_CREATION_MODAL: 'aiMateLoadChatOnlyCreationModal',
    AIFC_LOAD_DRAFTS_SECTION: 'aiMateLoadDraftsSection',
    AIFC_GENERATE_CONTENT: 'aiMateAifcGenerateContent',
    AIFC_GENERATE_CONTENT_IN_CHAT: 'aiMateAifcGenerateContentInChat',
    AIFC_INITIAL_DATA_RECEIVED: 'aiMateAifcInitialDataReceived',
    AIFC_ALL_DATA_HANDLED: 'aiMateAifcAllDataHandled',
    AIFC_UPDATE_CONTENT: 'aiMateAifcUpdateContent',
    UPDATE_CONTENT_IN_CHAT: 'aiMateUpdateContentInChat',
    AIFC_MODAL_SESSION: 'aiMateAifcModalSession',
    CSM_WIDGET_RENDER: 'csmWidgetRender',
    CSM_AGENT_IDENTITY_NAME: 'csmAgentIdentityName',
    CSM_AGENT_IDENTITY_COMPANY: 'csmAgentIdentityCompany',
    CSM_AGENT_IDENTITY_TONE: 'csmAgentIdentityTone',
    CSM_AGENT_IDENTITY_GREETING_MESSAGE: 'csmAgentIdentityGreetingMessage',
    CSM_AGENT_IDENTITY_CONVERSATION_STARTERS: 'csmAgentIdentityConversationStarters',
    CSM_AGENT_IDENTITY_GENERATE_CONVERSATION_STARTERS: 'csmAgentIdentityGenerateConversationStarters',
    GET_AUTO_APPLY_STATE: 'aiMateGetAutoApplyState',
    SET_AUTO_APPLY_STATE: 'aiMateSetAutoApplyState',
    AGENTS_MODAL_AND_SIDEBAR_LIST: 'aiMateAgentsModalAndSidebarList',
    AGENTS_MODAL_FAVOURITE_AGENTS: 'aiMateAgentsModalFavouriteAgents',
    AGENTS_FULLSCREEN_AGENT_LIST: 'aiMateAgentsFullscreenAgentList',
    STUDIO_TRIGGER_SOLUTION_PLAN: 'aiMateStudioTriggerSolutionPlan',
    MY_PROJECTS_LIST_QUERY: 'aiMateMyProjectsListQuery',
    STUDIO_UPDATE_AGENT: 'aiMateStudioUpdateAgent',
    STUDIO_AUTOMATION_CREATE_RULE: 'aiMateStudioAutomationCreateRule',
    THREADS_LIST_QUERY: 'aiMateThreadsListQuery',
    WARM_CONVERSATION_CACHE: 'aiMateWarmConversationCache',
    WARM_CONTEXT_BANNER_LINK: 'aiMateWarmContextBannerLink',
    AIFC_LOAD_PROMPT_SUGGESTIONS: 'aiMateAifcLoadPromptSuggestions',
    REMIX_START: 'aiMateRemixStart',
    REMIX_AIFC_HANDOFF: 'aiMateRemixAifcHandoff',
    FETCH_PROMPTS: 'aiMateFetchPrompts',
    FETCH_INSIGHTS_STATUS: 'aiMateFetchInsightsStatus',
    FETCH_INSIGHTS_FEED: 'aiMateFetchInsightsFeed',
    REMIX_RENDERS_IN_MODAL: 'aiMateRemixRendersInModal',
    REMIX_CREATE: 'aiMateRemixCreate',
    REMIX_OPEN_MENU: 'aiMateRemixOpenMenu',
    REMIX_SELECT_OPTION: 'aiMateRemixSelectOption',
    REMIX_SHOW_LOADING: 'aiMateRemixShowLoading',
    REMIX_VIEW: 'aiMateRemixView',
    REMIX_REGENERATE: 'aiMateRemixRegenerate',
    REMIX_INSERT: 'aiMateRemixInsert',
    REMIX_PASTE: 'aiMateRemixPaste',
    REMIX_COPY_FROM_PREVIEW: 'aiMateRemixCopyFromPreview',
    REMIX_DIAGRAM_PASTE_FINALIZE: 'aiMateRemixDiagramPasteFinalize',
    FETCH_TASKS: 'aiMateFetchTasks',
    LOAD_STICKY_SKILL_LISTENER: 'aiMateLoadStickySkillListener',
    /**
   * Tracks duplicating a Remix/MAUI app when its link is pasted into another
   * Confluence page. Started when the editor plugin detects a MAUI link in
   * the paste, succeeded once the duplicated app's URL has been swapped into
   * the editor doc, and failed if the duplicate API call (or any JS error in
   * the duplication flow) fails. When this experience fails, the
   * REMIX_INSERT experience is also failed so the overall paste-and-insert
   * flow is reflected in the SLO.
   */ REMIX_DUPLICATE_APP: 'aiMateRemixDuplicateApp',
    STUDIO_CREATE_AGENT: 'aiMateStudioCreateAgent',
    STUDIO_CREATE_AGENT_ASSIGN: 'aiMateStudioCreateAgentAssign',
    STUDIO_CREATE_AGENT_INVOKE: 'aiMateStudioCreateAgentInvoke',
    STUDIO_CREATE_AGENT_BUILD_AND_CHAT: 'aiMateStudioCreateAgentBuildAndChat',
    STUDIO_CREATE_AGENT_REFINE_IN_STUDIO: 'aiMateStudioCreateAgentRefineInStudio',
    STUDIO_CREATE_AGENT_RENDER: 'aiMateStudioCreateAgentRender',
    JIRA_SAVE_DRAFT_WORK_ITEM: 'aiMateJiraSaveDraftWorkItem',
    JIRA_RESOLVE_DRAFT_WORK_ITEM: 'aiMateJiraResolveDraftWorkItem',
    JIRA_CREATE_WORK_ITEMS_BULK: 'aiMateJiraCreateWorkItemsBulk',
    ROVO_SKILLS_PLAN_WORK_ITEM_CREATE: 'RovoSkillsPlanWorkItemCreate',
    ROVO_SKILLS_EXECUTION_WORK_ITEM_CREATE: 'RovoSkillsExecutionWorkItemCreate',
    ROVO_SKILLS_PLAN_WORK_ITEM_UPDATE: 'RovoSkillsPlanWorkItemUpdate',
    ROVO_SKILLS_EXECUTION_WORK_ITEM_UPDATE: 'RovoSkillsExecutionWorkItemUpdate',
    /**
   * Tracks the sender's end-to-end conversation-sharing funnel as a single
   * experience. Started when the share modal opens and succeeded only after
   * an existing or newly created share link is copied to the clipboard.
   * Unexpected hydration, persistence, share-creation, and clipboard errors
   * fail the experience. A `404` when loading existing share details is the
   * expected "not shared yet" state and does not fail the experience. Closing
   * the modal before any terminal state is recorded aborts the experience so
   * abandonment is excluded from the SLO.
   */ SHARE_CONVERSATION_SESSION: 'aiMateShareConversationSession',
    /**
   * Tracks the first action that reaches a terminal event while the Shared
   * chats tab in Rovo settings is active. Preview succeeds with `action` set
   * to `preview`; deleting a share or conversation succeeds or fails with
   * `action` set to `delete`. Later or overlapping terminal calls are ignored
   * by the underlying tracker. Closing the tab first aborts the experience.
   */ MANAGE_CONVERSATION_SHARES: 'aiMateManageConversationShares',
    /**
   * Tracks loading a shared conversation on the shared conversation preview
   * page, for both the sender previewing their own share and a recipient
   * opening a share link. Started when the route mounts and succeeded only
   * after the conversation has rendered. Errors retrieving or mapping the
   * share fail the experience. A link that never carried the parameters needed
   * to request a share aborts the experience, as does leaving the page before
   * the conversation renders, so malformed links and abandonment are still
   * recorded without counting against the SLO.
   */ VIEW_CONVERSATION_SHARE: 'aiMateViewConversationShare',
    /**
   * Tracks rendering the skill detail view of the skills directory, from either
   * Atlassian Studio or the Rovo Chat skills modal. Started when the detail
   * segment mounts and succeeded once the skill has rendered. Errors thrown
   * while loading or rendering the skill fail the experience.
   */ LOAD_SKILL_DETAIL_IN_SKILL_DIRECTORY: 'aiMateLoadSkillDetailInSkillDirectory',
    /**
   * Tracks rendering the products filter of the skills directory. Started when
   * the filter segment mounts and succeeded once the product list has
   * rendered. Errors loading the product dimension metadata fail the
   * experience.
   */ LOAD_SKILLS_DIRECTORY_PRODUCTS_FILTER: 'aiMateLoadSkillsDirectoryProductsFilter'
};
const $b6334bd5b5c71b1c$export$97bfa295b10f6f9e = ({ deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, taskModeEnabled: taskModeEnabled, fastModeEnabled: fastModeEnabled, isCustomRovoAgent: isCustomRovoAgent })=>{
    if (isCustomRovoAgent) return $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.SEND_MESSAGE_ROVO_CUSTOM_AGENT;
    if (deepResearchEnabled) return $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.SEND_DR_MESSAGE;
    if (thinkDeeperEnabled) return $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.SEND_TD_MESSAGE;
    if (taskModeEnabled) return $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.SEND_TASK_MODE_MESSAGE;
    if (fastModeEnabled) // Sending the same experience name for fast mode as it is the same as the default (auto) mode
    return $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.SEND_MESSAGE;
    return $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.SEND_MESSAGE;
};
const $b6334bd5b5c71b1c$export$233a4307e330ea30 = [
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.AIFC_GENERATE_CONTENT,
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.AIFC_GENERATE_CONTENT_IN_CHAT,
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.AIFC_UPDATE_CONTENT,
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.AIFC_FINALIZE_CONTENT,
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.AIFC_LOAD_STAGING_AREA_MODAL,
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.AIFC_MODAL_SESSION,
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.REMIX_REGENERATE
];
const $b6334bd5b5c71b1c$export$1b8ade75bafe2a6d = {
    /** Browser-level network failure — request never reached Atlassian servers (e.g. VPN, firewall, no connectivity) */ CLIENT_FETCH_ERROR: 'clientFetchError',
    /** Rovo is not enabled for the user's organisation (product-not-active stream error) */ PRODUCT_NOT_ACTIVE: 'productNotActive',
    /** User is not authenticated or lacks permission (HTTP 401/403) */ AUTH_OR_PERMISSION_ERROR: 'authOrPermissionError',
    /** Request was rejected by rate limiting or quota admission control (HTTP 429) */ RATE_LIMIT_ERROR: 'rateLimitError'
};
const $b6334bd5b5c71b1c$export$315c6d415b08d278 = {
    /** Experience started (intent detection decided on a creatable/Remix action) */ STARTED_AT: 'previewCardRenderStartedAtMs',
    /** Most recent ACTION_PART received */ ACTION_PART_AT: 'previewCardRenderActionPartAtMs',
    /** ACTION_COMPLETE received */ ACTION_COMPLETE_AT: 'previewCardRenderActionCompleteAtMs',
    /** SmartCreatePreviewCard mounted */ CARD_MOUNTED_AT: 'previewCardRenderCardMountedAtMs',
    /** SmartCreatePreviewCard mounted but used a non-instrumented branch. */ ROUTED_TO_NON_INSTRUMENTED_BRANCH_AT: 'previewCardRenderRoutedToNonInstrumentedBranchAtMs'
};
const $b6334bd5b5c71b1c$export$754812bba125b4c4 = {
    /** Why the experience succeeded or aborted. */ TERMINAL_REASON: 'previewCardRenderTerminalReason'
};
const $b6334bd5b5c71b1c$export$51e40ef74b0123bc = {
    /** Action status on the ACTION_PREPARE chunk */ ACTION_PREPARE_STATUS: 'previewCardRenderActionPrepareStatus',
    /** Action status on the most recent ACTION_PART chunk */ ACTION_PART_STATUS: 'previewCardRenderActionPartStatus',
    /** Action status on the ACTION_COMPLETE chunk */ ACTION_COMPLETE_STATUS: 'previewCardRenderActionCompleteStatus',
    /** Action key on the ACTION_COMPLETE chunk */ ACTION_COMPLETE_KEY: 'previewCardRenderActionCompleteKey'
};
const $b6334bd5b5c71b1c$export$b49585ccbc2980b5 = {
    STARTED_AT: 'previewContentStartedAtMs',
    EMBED_URL_RESOLVED_AT: 'previewContentEmbedUrlResolvedAtMs',
    IFRAME_MOUNTED_AT: 'previewContentIframeMountedAtMs',
    HANDSHAKE_RECEIVED_AT: 'previewContentHandshakeReceivedAtMs',
    IFRAME_LOADED_AT: 'previewContentIframeLoadedAtMs'
};
const $b6334bd5b5c71b1c$export$449b821dadec8760 = [
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.AIFC_INITIAL_DATA_RECEIVED,
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.AIFC_ALL_DATA_HANDLED,
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.PREVIEW_CONTENT,
    ...$b6334bd5b5c71b1c$export$233a4307e330ea30
];
const $b6334bd5b5c71b1c$export$ebde7a14f059b67f = {
    SUBMIT: 'submit',
    ACTION_COMPLETE_RECEIVED: 'action_complete_received',
    PREVIEW_VISIBLE: 'preview_visible'
};
const $b6334bd5b5c71b1c$export$35724980a513a99d = [
    {
        key: 'backend_latency',
        startMark: $b6334bd5b5c71b1c$export$ebde7a14f059b67f.SUBMIT,
        endMark: $b6334bd5b5c71b1c$export$ebde7a14f059b67f.ACTION_COMPLETE_RECEIVED
    },
    {
        key: 'render_latency',
        startMark: $b6334bd5b5c71b1c$export$ebde7a14f059b67f.ACTION_COMPLETE_RECEIVED,
        endMark: $b6334bd5b5c71b1c$export$ebde7a14f059b67f.PREVIEW_VISIBLE
    }
];
const $b6334bd5b5c71b1c$export$13437d7a030ee3e7 = new (0, $cNAch.UFOExperience)('remix-generate-preview', {
    type: (0, $4MiWC.ExperienceTypes).Experience,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).InlineResult,
    timings: [
        ...$b6334bd5b5c71b1c$export$35724980a513a99d
    ]
});
const $b6334bd5b5c71b1c$export$bef09d36689d0f74 = {
    SUBMIT: 'submit',
    // mark the start of the experience when the user submits the edit request
    ACTION_COMPLETE_RECEIVED: 'action_complete_received',
    // mark when we receive the ACTION_COMPLETE event from the backend
    NODE_INSERTED: 'node_inserted' // mark when the new app node is inserted into the editor
};
const $b6334bd5b5c71b1c$export$222a56424ec38dc0 = [
    {
        key: 'backend_latency',
        startMark: $b6334bd5b5c71b1c$export$bef09d36689d0f74.SUBMIT,
        endMark: $b6334bd5b5c71b1c$export$bef09d36689d0f74.ACTION_COMPLETE_RECEIVED
    },
    {
        key: 'insertion_latency',
        startMark: $b6334bd5b5c71b1c$export$bef09d36689d0f74.ACTION_COMPLETE_RECEIVED,
        endMark: $b6334bd5b5c71b1c$export$bef09d36689d0f74.NODE_INSERTED
    }
];
const $b6334bd5b5c71b1c$export$a143927e9fe401a2 = new (0, $cNAch.UFOExperience)('remix-edit-existing', {
    type: (0, $4MiWC.ExperienceTypes).Experience,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).InlineResult,
    timings: [
        ...$b6334bd5b5c71b1c$export$222a56424ec38dc0
    ]
});
const $b6334bd5b5c71b1c$export$5806cfefce9dc0ad = {
    PASTE_DETECTED: 'paste_detected',
    EMBED_LOADED: 'embed_loaded'
};
const $b6334bd5b5c71b1c$export$c39e7538132ae645 = [
    {
        key: 'render_latency',
        startMark: $b6334bd5b5c71b1c$export$5806cfefce9dc0ad.PASTE_DETECTED,
        endMark: $b6334bd5b5c71b1c$export$5806cfefce9dc0ad.EMBED_LOADED
    }
];
const $b6334bd5b5c71b1c$export$cf4d370f87e7f73d = new (0, $cNAch.UFOExperience)('remix-paste-render-embed', {
    type: (0, $4MiWC.ExperienceTypes).Experience,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).InlineResult,
    timings: [
        ...$b6334bd5b5c71b1c$export$c39e7538132ae645
    ]
});
let $b6334bd5b5c71b1c$var$isRemixPasteRenderEmbedExperienceActive = false;
const $b6334bd5b5c71b1c$export$c0c3ed9d934fa9fe = (metadata)=>{
    if ($b6334bd5b5c71b1c$var$isRemixPasteRenderEmbedExperienceActive) return;
    $b6334bd5b5c71b1c$var$isRemixPasteRenderEmbedExperienceActive = true;
    $b6334bd5b5c71b1c$export$cf4d370f87e7f73d.start();
    $b6334bd5b5c71b1c$export$cf4d370f87e7f73d.mark($b6334bd5b5c71b1c$export$5806cfefce9dc0ad.PASTE_DETECTED);
    if (metadata) $b6334bd5b5c71b1c$export$cf4d370f87e7f73d.addMetadata(metadata);
};
const $b6334bd5b5c71b1c$export$aa07d60d01b2c5e3 = (metadata)=>{
    if (!$b6334bd5b5c71b1c$var$isRemixPasteRenderEmbedExperienceActive) return;
    $b6334bd5b5c71b1c$export$cf4d370f87e7f73d.mark($b6334bd5b5c71b1c$export$5806cfefce9dc0ad.EMBED_LOADED);
    if (metadata) $b6334bd5b5c71b1c$export$cf4d370f87e7f73d.addMetadata(metadata);
    $b6334bd5b5c71b1c$export$cf4d370f87e7f73d.success();
    $b6334bd5b5c71b1c$var$isRemixPasteRenderEmbedExperienceActive = false;
};
const $b6334bd5b5c71b1c$export$2ed37a75e20c9dc7 = (error, metadata)=>{
    if (!$b6334bd5b5c71b1c$var$isRemixPasteRenderEmbedExperienceActive) return;
    if (metadata) $b6334bd5b5c71b1c$export$cf4d370f87e7f73d.addMetadata(metadata);
    $b6334bd5b5c71b1c$export$cf4d370f87e7f73d.failure({
        metadata: {
            reason: error.message
        }
    });
    $b6334bd5b5c71b1c$var$isRemixPasteRenderEmbedExperienceActive = false;
};
module.exports["ExperienceName"] = $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1;
module.exports["sendMessageExperienceName"] = $b6334bd5b5c71b1c$export$97bfa295b10f6f9e;
module.exports["AIFC_EXPERIENCES_TO_FAIL"] = $b6334bd5b5c71b1c$export$233a4307e330ea30;
module.exports["SLOExclusionReason"] = $b6334bd5b5c71b1c$export$1b8ade75bafe2a6d;
module.exports["PreviewCardRenderStage"] = $b6334bd5b5c71b1c$export$315c6d415b08d278;
module.exports["PreviewCardRenderDiagnosticAttribute"] = $b6334bd5b5c71b1c$export$754812bba125b4c4;
module.exports["PreviewCardRenderActionAttribute"] = $b6334bd5b5c71b1c$export$51e40ef74b0123bc;
module.exports["PreviewContentStage"] = $b6334bd5b5c71b1c$export$b49585ccbc2980b5;
module.exports["AIFC_EXPERIENCES_TO_ABORT"] = $b6334bd5b5c71b1c$export$449b821dadec8760;
module.exports["REMIX_GENERATE_PREVIEW_MARKS"] = $b6334bd5b5c71b1c$export$ebde7a14f059b67f;
module.exports["remixGeneratePreviewExperience"] = $b6334bd5b5c71b1c$export$13437d7a030ee3e7;
module.exports["REMIX_EDIT_EXISTING_MARKS"] = $b6334bd5b5c71b1c$export$bef09d36689d0f74;
module.exports["remixEditExistingExperience"] = $b6334bd5b5c71b1c$export$a143927e9fe401a2;
module.exports["startRemixPasteRenderEmbedExperience"] = $b6334bd5b5c71b1c$export$c0c3ed9d934fa9fe;
module.exports["succeedRemixPasteRenderEmbedExperience"] = $b6334bd5b5c71b1c$export$aa07d60d01b2c5e3;
module.exports["failRemixPasteRenderEmbedExperience"] = $b6334bd5b5c71b1c$export$2ed37a75e20c9dc7;

});

parcelRegister("89QZA", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gBjHb = parcelRequire("gBjHb");

const $87e579b14b793016$var$initialState = {
    conversationChannelId: '',
    chatEntryPoint: undefined,
    experienceId: '',
    product: '',
    productHeader: '',
    inProductExperience: '',
    agentId: null,
    agentExternalConfigReference: null,
    agentActions: [],
    agentIsDefault: null,
    agentIsVerified: null,
    fullScreen: false,
    agentCreatorType: '',
    agentVisibility: '',
    singleInstrumentationID: '',
    mode: undefined
};
const $87e579b14b793016$var$AnalyticsPropertiesContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    propertiesRef: {
        current: {
            ...$87e579b14b793016$var$initialState
        }
    },
    mode: undefined,
    setAnalyticsPropertiesWithoutRerender: ()=>{}
});
const $87e579b14b793016$export$5ae3634fdb64882c = /*#__PURE__*/ (0, $cozmU.createContext)({
    sharedFeaturesInstrumentationId: undefined,
    isInSmartCreateFlow: undefined
});
const $87e579b14b793016$export$1aefd27d2ed3c1c9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { children: children, mode: mode, launchSource: launchSource, rovoJourneyId: rovoJourneyId } = t0;
    let t1;
    if ($[0] !== launchSource || $[1] !== rovoJourneyId) {
        t1 = {
            ...$87e579b14b793016$var$initialState,
            launchSource: launchSource,
            rovoJourneyId: rovoJourneyId
        };
        $[0] = launchSource;
        $[1] = rovoJourneyId;
        $[2] = t1;
    } else t1 = $[2];
    const propertiesRef = (0, $cozmU.useRef)(t1);
    let t2;
    let t3;
    if ($[3] !== launchSource) {
        t2 = ()=>{
            propertiesRef.current.launchSource = launchSource;
        };
        t3 = [
            launchSource
        ];
        $[3] = launchSource;
        $[4] = t2;
        $[5] = t3;
    } else {
        t2 = $[4];
        t3 = $[5];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[6] !== rovoJourneyId) {
        t4 = ()=>{
            propertiesRef.current.rovoJourneyId = rovoJourneyId;
        };
        t5 = [
            rovoJourneyId
        ];
        $[6] = rovoJourneyId;
        $[7] = t4;
        $[8] = t5;
    } else {
        t4 = $[7];
        t5 = $[8];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (properties)=>{
            propertiesRef.current = {
                ...propertiesRef.current,
                ...properties
            };
        };
        $[9] = t6;
    } else t6 = $[9];
    const setAnalyticsPropertiesWithoutRerender = t6;
    let t7;
    if ($[10] !== mode) {
        t7 = {
            propertiesRef: propertiesRef,
            mode: mode,
            setAnalyticsPropertiesWithoutRerender: setAnalyticsPropertiesWithoutRerender
        };
        $[10] = mode;
        $[11] = t7;
    } else t7 = $[11];
    const value = t7;
    let t8;
    if ($[12] !== children || $[13] !== value) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87e579b14b793016$var$AnalyticsPropertiesContext.Provider, {
            value: value
        }, children);
        $[12] = children;
        $[13] = value;
        $[14] = t8;
    } else t8 = $[14];
    return t8;
} : ({ children: children, mode: mode, launchSource: launchSource, rovoJourneyId: rovoJourneyId })=>{
    const propertiesRef = (0, $cozmU.useRef)({
        ...$87e579b14b793016$var$initialState,
        launchSource: launchSource,
        rovoJourneyId: rovoJourneyId
    });
    // Sync the (possibly late/changing) prop into the ref after commit, so concurrent
    // renders that are paused or discarded never leak an uncommitted launch source.
    (0, $cozmU.useEffect)(()=>{
        propertiesRef.current.launchSource = launchSource;
    }, [
        launchSource
    ]);
    (0, $cozmU.useEffect)(()=>{
        propertiesRef.current.rovoJourneyId = rovoJourneyId;
    }, [
        rovoJourneyId
    ]);
    const setAnalyticsPropertiesWithoutRerender = (0, $cozmU.useCallback)((properties)=>{
        propertiesRef.current = {
            ...propertiesRef.current,
            ...properties
        };
    }, []);
    const value = (0, $cozmU.useMemo)(()=>({
            propertiesRef: propertiesRef,
            mode: mode,
            setAnalyticsPropertiesWithoutRerender: setAnalyticsPropertiesWithoutRerender
        }), [
        setAnalyticsPropertiesWithoutRerender,
        mode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87e579b14b793016$var$AnalyticsPropertiesContext.Provider, {
        value: value
    }, children);
};
const $87e579b14b793016$export$a00cd3c213413389 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { source: source, sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId, iframeHostProduct: iframeHostProduct, children: children, mode: mode, isAlwaysInSmartCreateFlow: isAlwaysInSmartCreateFlow, launchSource: launchSource, rovoJourneyId: rovoJourneyId } = t0;
    const { sharedFeaturesInstrumentationId: parentSharedFeaturesInstrumentationId, isInSmartCreateFlow: parentIsInSmartCreateFlow } = (0, $cozmU.useContext)($87e579b14b793016$export$5ae3634fdb64882c);
    const isInSmartCreateFlow = isAlwaysInSmartCreateFlow === undefined ? parentIsInSmartCreateFlow : isAlwaysInSmartCreateFlow;
    const t1 = sharedFeaturesInstrumentationId ?? parentSharedFeaturesInstrumentationId;
    let t2;
    if ($[0] !== iframeHostProduct || $[1] !== isInSmartCreateFlow || $[2] !== t1) {
        t2 = {
            sharedFeaturesInstrumentationId: t1,
            isInSmartCreateFlow: isInSmartCreateFlow,
            iframeHostProduct: iframeHostProduct
        };
        $[0] = iframeHostProduct;
        $[1] = isInSmartCreateFlow;
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== source || $[5] !== t2) {
        t3 = {
            source: source,
            attributes: t2
        };
        $[4] = source;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    const data = t3;
    const t4 = sharedFeaturesInstrumentationId ?? parentSharedFeaturesInstrumentationId;
    let t5;
    if ($[7] !== isInSmartCreateFlow || $[8] !== t4) {
        t5 = {
            sharedFeaturesInstrumentationId: t4,
            isInSmartCreateFlow: isInSmartCreateFlow
        };
        $[7] = isInSmartCreateFlow;
        $[8] = t4;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== children || $[11] !== launchSource || $[12] !== mode || $[13] !== rovoJourneyId) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87e579b14b793016$export$1aefd27d2ed3c1c9, {
            mode: mode,
            launchSource: launchSource,
            rovoJourneyId: rovoJourneyId
        }, children);
        $[10] = children;
        $[11] = launchSource;
        $[12] = mode;
        $[13] = rovoJourneyId;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== t5 || $[16] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87e579b14b793016$export$5ae3634fdb64882c.Provider, {
            value: t5
        }, t6);
        $[15] = t5;
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    let t8;
    if ($[18] !== data || $[19] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
            data: data
        }, t7);
        $[18] = data;
        $[19] = t7;
        $[20] = t8;
    } else t8 = $[20];
    return t8;
} : ({ source: source, sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId, iframeHostProduct: iframeHostProduct, children: children, mode: mode, isAlwaysInSmartCreateFlow: isAlwaysInSmartCreateFlow, launchSource: launchSource, rovoJourneyId: rovoJourneyId })=>{
    const { sharedFeaturesInstrumentationId: parentSharedFeaturesInstrumentationId, isInSmartCreateFlow: parentIsInSmartCreateFlow } = (0, $cozmU.useContext)($87e579b14b793016$export$5ae3634fdb64882c);
    const isInSmartCreateFlow = isAlwaysInSmartCreateFlow === undefined ? parentIsInSmartCreateFlow : isAlwaysInSmartCreateFlow;
    const data = (0, $cozmU.useMemo)(()=>({
            source: source,
            attributes: {
                sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId ?? parentSharedFeaturesInstrumentationId,
                isInSmartCreateFlow: isInSmartCreateFlow,
                iframeHostProduct: iframeHostProduct
            }
        }), [
        source,
        sharedFeaturesInstrumentationId,
        parentSharedFeaturesInstrumentationId,
        isInSmartCreateFlow,
        iframeHostProduct
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
        data: data
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87e579b14b793016$export$5ae3634fdb64882c.Provider, {
        value: {
            sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId ?? parentSharedFeaturesInstrumentationId,
            isInSmartCreateFlow: isInSmartCreateFlow
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87e579b14b793016$export$1aefd27d2ed3c1c9, {
        mode: mode,
        launchSource: launchSource,
        rovoJourneyId: rovoJourneyId
    }, children)));
};
const $87e579b14b793016$export$ab8aa3dfd687f012 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($87e579b14b793016$var$AnalyticsPropertiesContext);
} : ()=>{
    return (0, $cozmU.useContext)($87e579b14b793016$var$AnalyticsPropertiesContext);
};
module.exports["SharedFeaturesInstrumentationIdContext"] = $87e579b14b793016$export$5ae3634fdb64882c;
module.exports["AnalyticsContextWithSourceAndProperties"] = $87e579b14b793016$export$a00cd3c213413389;
module.exports["useAnalyticsPropertiesContext"] = $87e579b14b793016$export$ab8aa3dfd687f012;

});

parcelRegister("bjY3F", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $6cFsl = parcelRequire("6cFsl");


var $1hQ0e = parcelRequire("1hQ0e");


var $cXtTj = parcelRequire("cXtTj");


var $a33Aa = parcelRequire("a33Aa");


var $boaiH = parcelRequire("boaiH");


var $10XTN = parcelRequire("10XTN");


var $hlvTd = parcelRequire("hlvTd");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $irnO2 = parcelRequire("irnO2");


var $1XM8n = parcelRequire("1XM8n");


var $8YL3U = parcelRequire("8YL3U");

var $78cafaa44d513db0$var$_ExperienceTrackerHandler;
const $78cafaa44d513db0$var$isRovoInstrumentedError = (error)=>error !== null && error !== undefined && typeof error === 'object' && 'errorAttributes' in error && typeof error.errorAttributes === 'object';
const $78cafaa44d513db0$var$isTerminalEvent = (event)=>event.action === 'taskSuccess' || event.action === 'taskFail' || event.action === 'taskAbort';
const $78cafaa44d513db0$var$isAbortEvent = (event)=>event.action === 'taskAbort';
class $78cafaa44d513db0$export$5a92a056565f01cc {
    setSendAnalyticsEvent(sendAnalyticsEvent) {
        this.sendAnalyticsEvent = sendAnalyticsEvent;
    }
    static getInstance() {
        if (!$78cafaa44d513db0$export$5a92a056565f01cc.instance) {
            const dropEvents = (0, $cXtTj.default).getExperimentValue('platform_ai_drop_instrumentation_tracking', 'value', false);
            $78cafaa44d513db0$export$5a92a056565f01cc.instance = new $78cafaa44d513db0$export$5a92a056565f01cc(dropEvents);
        }
        // instance is guaranteed to be set after the guard above
        return $78cafaa44d513db0$export$5a92a056565f01cc.instance;
    }
    /**
   * @internal For tests only.
   */ static resetInstance() {
        $78cafaa44d513db0$export$5a92a056565f01cc.instance = undefined;
    }
    static setLabelStack(labelStack) {
        $78cafaa44d513db0$export$5a92a056565f01cc.labelStack = labelStack;
    }
    constructor(dropEvents){
        this.experienceTracker = new (0, $boaiH.ExperienceTracker)();
        this.sendAnalyticsEvent = null;
        this.tabVisibilityByExperience = new Map();
        const doc = (0, $1hQ0e.getDocument)();
        if (doc) (0, $cbY7C.bind)(doc, {
            type: 'visibilitychange',
            listener: ()=>{
                const isHidden = doc.visibilityState === 'hidden';
                this.tabVisibilityByExperience.forEach((tracker)=>{
                    tracker.onVisibilityChange(isHidden);
                });
            }
        });
        if (!dropEvents) this.experienceTracker.subscribe((event)=>{
            if (event.action === 'taskStart') this.tabVisibilityByExperience.set(event.name, new (0, $8YL3U.TabVisibilityTracker)(doc));
            let filteredErrorAttributes = {};
            let preventSendingLogException = false;
            // When non-null, converts taskFail → taskAbort so the error is excluded from SLO
            // failure counts but still recorded for anomaly detection purposes.
            let sloExclusion = null;
            const isErrorEvent = 'error' in event;
            // Skip SLO exclusion logic for the aiMateFilteredClientError experience itself
            // to avoid re-processing and potential infinite loops.
            const isFilteredClientErrorExperience = event.name === (0, $irnO2.ExperienceName).FILTERED_CLIENT_ERROR;
            if (isErrorEvent && !isFilteredClientErrorExperience) {
                // Classify common non-service errors so they can be tracked separately from
                // real backend failures:
                //   - client fetch errors (e.g. "Failed to fetch") — request never reached Atlassian
                //   - product-not-active — HTTP 200 but SSE payload contains an errorCode
                //   - auth/permission — HTTP 401/403 (session expired, HIPAA, IP allowlist, etc.)
                if ((0, $10XTN.isClientFetchError)(event.error)) {
                    preventSendingLogException = true;
                    sloExclusion = {
                        reason: (0, $irnO2.SLOExclusionReason).CLIENT_FETCH_ERROR
                    };
                } else if ((0, $10XTN.isProductNotActiveError)(event.error)) {
                    preventSendingLogException = true;
                    sloExclusion = {
                        reason: (0, $irnO2.SLOExclusionReason).PRODUCT_NOT_ACTIVE
                    };
                } else if ((0, $10XTN.isAuthOrPermissionError)(event.error)) {
                    preventSendingLogException = true;
                    sloExclusion = {
                        reason: (0, $irnO2.SLOExclusionReason).AUTH_OR_PERMISSION_ERROR
                    };
                } else if ((0, $10XTN.isRateLimitError)(event.error)) {
                    preventSendingLogException = true;
                    sloExclusion = {
                        reason: (0, $irnO2.SLOExclusionReason).RATE_LIMIT_ERROR
                    };
                }
                if (event.attributes) {
                    const { webSearchEnabled: webSearchEnabled, deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, fastModeEnabled: fastModeEnabled } = event.attributes;
                    if (webSearchEnabled !== undefined) filteredErrorAttributes = {
                        ...filteredErrorAttributes,
                        webSearchEnabled: webSearchEnabled
                    };
                    if (deepResearchEnabled !== undefined) filteredErrorAttributes = {
                        ...filteredErrorAttributes,
                        deepResearchEnabled: deepResearchEnabled
                    };
                    if (fastModeEnabled !== undefined) filteredErrorAttributes = {
                        ...filteredErrorAttributes,
                        fastModeEnabled: fastModeEnabled
                    };
                    if (thinkDeeperEnabled !== undefined) filteredErrorAttributes = {
                        ...filteredErrorAttributes,
                        thinkDeeperEnabled: thinkDeeperEnabled
                    };
                }
                if ($78cafaa44d513db0$var$isRovoInstrumentedError(event.error)) {
                    const errorAttributes = event.error.errorAttributes;
                    // Remove undefined properties
                    filteredErrorAttributes = Object.fromEntries(Object.entries(errorAttributes).filter(([, value])=>value !== undefined));
                }
                const teamName = (0, $1XM8n.getOwningTeam)(event.error.message ?? '', event.name);
                filteredErrorAttributes = {
                    teamName: teamName,
                    // We intentionally put this first so a `teamName` attribute can override this.
                    ...filteredErrorAttributes
                };
                if (!preventSendingLogException) {
                    const error = event.error instanceof Error ? event.error : new Error(JSON.stringify(event.error));
                    const attributes = event.attributes;
                    // this is added by `useExperienceTracker` below
                    const touchpointSource = typeof attributes?.touchpointSource === 'string' ? attributes.touchpointSource : undefined;
                    const teamName = typeof attributes?.teamName === 'string' ? attributes.teamName : undefined;
                    const { traceId: traceIdFromErrorObject, ...filteredErrorAttributesRest } = filteredErrorAttributes;
                    const altTraceId = attributes?.traceId || traceIdFromErrorObject;
                    (0, $hlvTd.logException)({
                        exception: error,
                        name: event.name,
                        // eslint-disable-next-line @atlaskit/platform/no-double-type-assertions -- Existing experience-tracker baseline: legacy UFO attributes are assembled from mixed attribute sources before being passed to a string map API.
                        tags: {
                            source: 'aiMateExperienceTracker',
                            ...filteredErrorAttributesRest,
                            ...touchpointSource && {
                                touchpointSource: touchpointSource
                            },
                            ...teamName && {
                                teamName: teamName
                            },
                            // Rename traceId to atlTraceId if present in attributes to distinguish from Sentry's Trace ID
                            ...altTraceId && {
                                altTraceId: altTraceId
                            }
                        }
                    });
                }
            }
            if ($78cafaa44d513db0$var$isTerminalEvent(event)) // the experience tracker already uses performance.now() to calculate the duration, so we can just piggyback on that,
            // we will loose some precision due to rounding of duration, but it's good enough for our purposes
            (0, $a33Aa.addSpanToAll)('custom', `exp-${event.name}`, $78cafaa44d513db0$export$5a92a056565f01cc.labelStack, event.startTime, event.startTime + event.duration);
            const tabVisibilityAttributes = $78cafaa44d513db0$var$isTerminalEvent(event) ? this.tabVisibilityByExperience.get(event.name)?.getAttributes(doc) ?? {} : {};
            // If the error should be excluded from SLO, report it as taskAbort instead of taskFail.
            // taskAbort events are not counted as failures in the SLO but are still recorded
            // so anomaly detectors can track spikes in these error types.
            const effectiveAction = sloExclusion && event.action === 'taskFail' ? 'taskAbort' : event.action;
            this.sendAnalyticsEvent?.({
                eventType: 'operational',
                action: effectiveAction,
                actionSubject: 'ui',
                attributes: {
                    task: event.name,
                    taskId: event.id,
                    startTime: event.startTime,
                    ...$78cafaa44d513db0$var$isTerminalEvent(event) && {
                        duration: event.duration
                    },
                    // Include error info on both taskFail and taskAbort (for excluded errors)
                    // so analytics/anomaly detectors can distinguish error types.
                    ...isErrorEvent && {
                        error: event.error.message,
                        ...filteredErrorAttributes
                    },
                    // Surface why the error was excluded from the SLO so the raw analytics
                    // event can be queried/grouped without joining to the synthetic experience.
                    ...sloExclusion && {
                        sloExclusionReason: sloExclusion.reason
                    },
                    // `abort()` takes its reason as a top-level field rather than inside
                    // `attributes`, so it is otherwise dropped here and aborts land in
                    // analytics with no indication of why they happened. Spread before
                    // `event.attributes` so callers that already nest their own `reason`
                    // keep precedence.
                    ...$78cafaa44d513db0$var$isAbortEvent(event) && {
                        reason: event.reason
                    },
                    ...event.attributes,
                    ...tabVisibilityAttributes
                }
            }, {
                removeDefaultTags: true
            });
            // When a client error is excluded from the main SLO (ie. converted to taskAbort),
            // track a separate experience so the volume of these errors can be monitored with its own SLO threshold.
            if (sloExclusion && isErrorEvent) {
                this.experienceTracker.start({
                    name: (0, $irnO2.ExperienceName).FILTERED_CLIENT_ERROR,
                    id: (0, $irnO2.ExperienceName).FILTERED_CLIENT_ERROR,
                    startTime: event.startTime
                });
                this.experienceTracker.fail({
                    name: (0, $irnO2.ExperienceName).FILTERED_CLIENT_ERROR,
                    error: event.error,
                    attributes: {
                        // Preserve the original experience name, error, and exclusion reason for queryability
                        originalTask: event.name,
                        error: event.error.message,
                        sloExclusionReason: sloExclusion.reason,
                        ...filteredErrorAttributes
                    }
                });
            }
            if ($78cafaa44d513db0$var$isTerminalEvent(event)) this.tabVisibilityByExperience.delete(event.name);
        });
    }
}
$78cafaa44d513db0$var$_ExperienceTrackerHandler = $78cafaa44d513db0$export$5a92a056565f01cc;
$78cafaa44d513db0$export$5a92a056565f01cc.instance = void 0;
$78cafaa44d513db0$export$5a92a056565f01cc.labelStack = [];
const $78cafaa44d513db0$export$63af6e7bbb4f375d = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return $78cafaa44d513db0$var$_temp;
} : ()=>{
    return (0, $cozmU.useCallback)((componentLabelStack)=>{
        $78cafaa44d513db0$export$5a92a056565f01cc.setLabelStack(componentLabelStack);
    }, []);
};
const $78cafaa44d513db0$export$412c53791574f6f0 = (params)=>{
    (0, $6cFsl.di)((0, $Ou0Zz.useAnalytics));
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    (0, $cozmU.useMemo)(()=>{
        const experienceTracker = $78cafaa44d513db0$export$5a92a056565f01cc.getInstance();
        // this is not ideal, okay just because `sendAnalyticsEvent` is never change
        // since every hook instance will override the singleton sendAnalyticsEvent
        experienceTracker.setSendAnalyticsEvent(sendAnalyticsEvent);
    }, [
        sendAnalyticsEvent
    ]);
    const experienceTrackerProxy = (0, $cozmU.useMemo)(()=>{
        const proxyHandler = {
            get: (target, prop)=>{
                // Overriding the experienceTracker target methods to add additional attributes
                if (prop === 'fail') return (failParams)=>{
                    target.fail({
                        ...failParams,
                        name: failParams.name,
                        attributes: {
                            ...failParams.attributes,
                            touchpointSource: params?.touchpointSource,
                            teamName: failParams.teamName
                        }
                    });
                };
                if (prop === 'succeed') return (succeedParams)=>{
                    target.succeed({
                        ...succeedParams,
                        name: succeedParams.name,
                        attributes: {
                            ...succeedParams.attributes,
                            touchpointSource: params?.touchpointSource
                        }
                    });
                };
                if (prop === 'start') return (startParams)=>{
                    target.start({
                        ...startParams,
                        name: startParams.name
                    });
                };
                if (prop === 'abort') return (abortParams)=>{
                    target.abort({
                        ...abortParams,
                        name: abortParams.name
                    });
                };
                if (prop === 'stopOnError') return (stopOnErrorParams)=>{
                    target.stopOnError({
                        ...stopOnErrorParams,
                        name: stopOnErrorParams.name
                    });
                };
                return typeof target[prop] === 'function' ? target[prop].bind(target) : target[prop];
            }
        };
        return new Proxy($78cafaa44d513db0$export$5a92a056565f01cc.getInstance().experienceTracker, proxyHandler);
    }, [
        params?.touchpointSource
    ]);
    return experienceTrackerProxy;
};
function $78cafaa44d513db0$var$_temp(componentLabelStack) {
    $78cafaa44d513db0$export$5a92a056565f01cc.setLabelStack(componentLabelStack);
}
module.exports["ExperienceTrackerHandler"] = $78cafaa44d513db0$export$5a92a056565f01cc;
module.exports["useUFOLabelStackSetter"] = $78cafaa44d513db0$export$63af6e7bbb4f375d;
module.exports["useAIMateExperienceTracker"] = $78cafaa44d513db0$export$412c53791574f6f0;

});

parcelRegister("boaiH", function(module, exports) {

var $2gr4B = parcelRequire("2gr4B");

class $ffade2ccf1ecf3ef$export$12b6b072930fd68f {
    start({ name: name, id: id, timeout: timeout, startTime: startTime, attributes: attributes, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort, collect: collect }) {
        const current = this.experiences[name];
        if (current && !current.hasStopped && current.id === id) return;
        // Before replacing a current experience, abort it to ensure
        // it is cleaned up.
        if (current) current.abort({
            reason: 'Aborted because the same experience was started with a new id'
        });
        const experience = new (0, $2gr4B.Experience)({
            name: name,
            id: id,
            timeout: timeout,
            startTime: startTime,
            attributes: attributes,
            onSuccess: onSuccess,
            onFailure: onFailure,
            onAbort: onAbort,
            onStart: (startEvent)=>{
                this.emit(startEvent);
                let disposeCollectSubscription = ()=>{};
                if (collect) {
                    const events = [];
                    disposeCollectSubscription = this.subscribe((event)=>{
                        // Ignore already running experiences that started before this
                        // experience started
                        if (event.action === 'taskStart' || events.some((previousEvent)=>previousEvent.name === event.name && previousEvent.action === 'taskStart')) {
                            events.push(event);
                            collect(events, experience);
                        }
                    });
                }
                return (stopEvent)=>{
                    disposeCollectSubscription();
                    this.emit(stopEvent);
                };
            }
        });
        this.experiences[name] = experience;
    }
    succeed({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.succeed(attributes);
    }
    fail({ name: name, error: error, attributes: attributes }) {
        Object.values(this.experiences).forEach((current)=>{
            if (name != null && current.name !== name) return;
            current.fail({
                error: error,
                attributes: attributes
            });
        });
    }
    abort({ name: name, reason: reason, attributes: attributes, checkForTimeout: checkForTimeout }) {
        function abort(experience) {
            if (name != null && experience.name !== name) return;
            experience.abort({
                reason: reason,
                checkForTimeout: checkForTimeout,
                attributes: attributes
            });
        }
        const experiencesWithTimeouts = Object.values(this.experiences).filter((experience)=>experience.timeout);
        const experiencesWithoutTimeouts = Object.values(this.experiences).filter((experience)=>!experience.timeout);
        // We need to abort all experiences with timeouts first in order to properly
        // capture compound experiences composed of sub-experiences which have timeouts
        experiencesWithTimeouts.forEach(abort);
        experiencesWithoutTimeouts.forEach(abort);
    }
    subscribe(subscriber) {
        if (typeof subscriber !== 'function') throw new Error('Subscriber must be a function');
        this.subscribers.push(subscriber);
        return ()=>{
            this.subscribers = this.subscribers.filter((x)=>x !== subscriber);
        };
    }
    stopOnError({ name: name, error: error, attributes: attributes }) {
        if (this.isNetworkOfflineError(error)) {
            this.abort({
                name: name,
                reason: `Aborted ${name} because of network error: ${error.toString()}`,
                checkForTimeout: false,
                attributes: attributes
            });
            return;
        }
        return this.fail({
            name: name,
            error: error,
            attributes: attributes
        });
    }
    updateAttributes({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.updateAttributes(attributes);
    }
    emit(event) {
        this.subscribers.forEach((subscriber)=>{
            try {
                subscriber(event);
            } catch (e) {}
        });
    }
    constructor(options){
        this.experiences = {};
        this.subscribers = [];
        this.isNetworkOfflineError = void 0;
        this.isNetworkOfflineError = options && options.isNetworkOfflineError || (()=>false);
    }
}
module.exports["ExperienceTracker"] = $ffade2ccf1ecf3ef$export$12b6b072930fd68f;

});

parcelRegister("2gr4B", function(module, exports) {

var $apqal = parcelRequire("apqal");

function $8617e1b2001e7e7c$var$mergeAttributes(first, last) {
    if (first === undefined) return last;
    if (last === undefined) return first;
    return {
        ...first,
        ...last
    };
}
class $8617e1b2001e7e7c$export$c90b54e658fc4d7c {
    get hasStopped() {
        return this._hasStopped;
    }
    succeed(attributes) {
        if (this._hasStopped) return;
        this.onSuccess && this.onSuccess();
        this.stop({
            action: 'taskSuccess',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            attributes: $8617e1b2001e7e7c$var$mergeAttributes(this.attributes, attributes)
        });
    }
    fail({ error: error, attributes: attributes }) {
        if (this._hasStopped) return;
        this.onFailure && this.onFailure();
        this.stop({
            action: 'taskFail',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            error: error,
            attributes: $8617e1b2001e7e7c$var$mergeAttributes(this.attributes, attributes)
        });
    }
    abort({ reason: reason, attributes: attributes, checkForTimeout: checkForTimeout = true }) {
        if (this._hasStopped) return;
        // Check if the experience should have failed due to timeout
        if (checkForTimeout && this.timeout != null && this.getDuration() >= this.timeout) {
            this.fail({
                attributes: attributes,
                error: new (0, $apqal.ExperienceTimeoutError)(`${this.name} failed to complete in ${this.timeout}ms`)
            });
            return;
        }
        this.onAbort && this.onAbort();
        this.stop({
            action: 'taskAbort',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            reason: reason,
            checkForTimeout: checkForTimeout,
            attributes: $8617e1b2001e7e7c$var$mergeAttributes(this.attributes, attributes)
        });
    }
    stopOn(event) {
        if (!event) return;
        if (event.action === 'taskSuccess') this.succeed();
        else if (event.action === 'taskAbort') this.abort({
            reason: event.reason,
            checkForTimeout: event.checkForTimeout
        });
        else if (event.action === 'taskFail') this.fail({
            error: event.error
        });
    }
    updateAttributes(attributes) {
        this.attributes = {
            ...this.attributes,
            ...attributes
        };
    }
    stop(event) {
        this._hasStopped = true;
        if (this.onStop) this.onStop(event);
    }
    getDuration() {
        return Math.round(window.performance.now() - this.startTime);
    }
    constructor({ name: name, id: id, timeout: timeout, startTime: startTime = window.performance.now(), attributes: attributes, onStart: onStart, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort }){
        this.name = void 0;
        this.id = void 0;
        this.timeout = void 0;
        this._hasStopped = false;
        this.startTime = void 0;
        this.attributes = void 0;
        this.onStop = void 0;
        this.onSuccess = void 0;
        this.onFailure = void 0;
        this.onAbort = void 0;
        this.name = name;
        this.id = id;
        this.timeout = timeout;
        this.startTime = startTime;
        this.attributes = attributes;
        this.onSuccess = onSuccess;
        this.onFailure = onFailure;
        this.onAbort = onAbort;
        const startEvent = {
            action: 'taskStart',
            name: name,
            id: id,
            startTime: startTime,
            timeout: timeout,
            attributes: attributes
        };
        if (onStart) this.onStop = onStart(startEvent);
    }
}
module.exports["Experience"] = $8617e1b2001e7e7c$export$c90b54e658fc4d7c;

});

parcelRegister("apqal", function(module, exports) {
class $f9800b995ac71735$export$d27a2b6293f7631c extends Error {
    constructor(message){
        super(message);
        this.name = 'ExperienceTimeoutError';
    }
}
module.exports["ExperienceTimeoutError"] = $f9800b995ac71735$export$d27a2b6293f7631c;

});

parcelRegister("10XTN", function(module, exports) {

var $3PJhM = parcelRequire("3PJhM");

// Referenced from jira/src/packages/platform/utils/fetch/src/utils/is-error.tsx
// Issues we are not gonna track in Sentry
const $ab109556016fa76e$var$KNOWN_NETWORK_ERRORS_LIMITED = [
    'server with the specified hostname could not be found',
    'connection failure',
    'Failed to fetch',
    'Load failed',
    // Safari equivalent of "Failed to fetch"
    'Network request failed',
    'NetworkError',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted'
];
const $ab109556016fa76e$var$isClientFetchErrorMessage = (message)=>{
    const errorTypes = $ab109556016fa76e$var$KNOWN_NETWORK_ERRORS_LIMITED;
    return Boolean(message) && !!errorTypes.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
};
const $ab109556016fa76e$var$KNOWN_NETWORK_ERRORS_TYPES = [
    'AbortError',
    'AuthError',
    'ChunkLoadError',
    'NetworkError'
];
const $ab109556016fa76e$var$MAX_ERROR_CAUSE_DEPTH = 3;
const $ab109556016fa76e$var$getErrorAndCauseRecords = (error)=>{
    const records = [];
    let currentError = error;
    for(let depth = 0; depth < $ab109556016fa76e$var$MAX_ERROR_CAUSE_DEPTH && (0, $3PJhM.isRecord)(currentError); depth++){
        records.push(currentError);
        currentError = currentError.cause;
    }
    return records;
};
const $ab109556016fa76e$var$getErrorStatusCode = (error)=>{
    const errorAttributes = (0, $3PJhM.isRecord)(error.errorAttributes) ? error.errorAttributes : undefined;
    const attributes = (0, $3PJhM.isRecord)(error.attributes) ? error.attributes : undefined;
    const status = errorAttributes?.statusCode ?? error.status ?? attributes?.status;
    return typeof status === 'number' ? status : undefined;
};
const $ab109556016fa76e$var$getErrorCode = (error)=>{
    const errorAttributes = (0, $3PJhM.isRecord)(error.errorAttributes) ? error.errorAttributes : undefined;
    return typeof errorAttributes?.errorCode === 'string' ? errorAttributes.errorCode.toLowerCase() : undefined;
};
const $ab109556016fa76e$export$2e7adc44463c3f4f = (error)=>{
    if (!(0, $3PJhM.isRecord)(error)) return false;
    // Check top-level error name and message
    const hasKnownName = typeof error.name === 'string' && $ab109556016fa76e$var$KNOWN_NETWORK_ERRORS_TYPES.includes(error.name);
    const hasKnownMessage = typeof error.message === 'string' && $ab109556016fa76e$var$isClientFetchErrorMessage(error.message);
    if (hasKnownName || hasKnownMessage) return true;
    // Also check the nested cause (e.g. wrapped fetch errors)
    if (!(0, $3PJhM.isRecord)(error.cause)) return false;
    return typeof error.cause.name === 'string' && $ab109556016fa76e$var$KNOWN_NETWORK_ERRORS_TYPES.includes(error.cause.name) || typeof error.cause.message === 'string' && $ab109556016fa76e$var$isClientFetchErrorMessage(error.cause.message);
};
const $ab109556016fa76e$export$de229d5c9394f905 = (error)=>{
    return $ab109556016fa76e$var$getErrorAndCauseRecords(error).some((errorRecord)=>{
        const status = $ab109556016fa76e$var$getErrorStatusCode(errorRecord);
        return status === 401 || status === 403;
    });
};
const $ab109556016fa76e$export$a8908c3867f6f20b = (error)=>{
    return $ab109556016fa76e$var$getErrorAndCauseRecords(error).some((errorRecord)=>$ab109556016fa76e$var$getErrorStatusCode(errorRecord) === 429);
};
const $ab109556016fa76e$export$9f0dca42eff14720 = (error)=>{
    return $ab109556016fa76e$var$getErrorAndCauseRecords(error).some((errorRecord)=>{
        const errorCode = $ab109556016fa76e$var$getErrorCode(errorRecord) ?? '';
        return errorCode.includes('product.not.active') || errorCode.includes('product_not_active');
    });
};
module.exports["isClientFetchError"] = $ab109556016fa76e$export$2e7adc44463c3f4f;
module.exports["isAuthOrPermissionError"] = $ab109556016fa76e$export$de229d5c9394f905;
module.exports["isRateLimitError"] = $ab109556016fa76e$export$a8908c3867f6f20b;
module.exports["isProductNotActiveError"] = $ab109556016fa76e$export$9f0dca42eff14720;

});

parcelRegister("3PJhM", function(module, exports) {
/**
 * Type guard that checks whether a value is a plain record object.
 */ const $99d6458d8ffffa8f$export$6ba840931da50680 = (value)=>typeof value === 'object' && value !== null && !Array.isArray(value);
module.exports["isRecord"] = $99d6458d8ffffa8f$export$6ba840931da50680;

});

parcelRegister("hlvTd", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $jTKfH = parcelRequire("jTKfH");


var $10XTN = parcelRequire("10XTN");


var $cj7GQ = parcelRequire("cj7GQ");


var $8DeC3 = parcelRequire("8DeC3");


var $2AFxF = parcelRequire("2AFxF");


var $fPSAz = parcelRequire("fPSAz");


// importing local file instead of from '@sentry/browser' otherwise there will be typescript errors
const $024249913f1d8b5b$var$importLegacySentryAsync = async ()=>(parcelRequire("55apF"));

const $024249913f1d8b5b$var$importPrivateSentryAsync = async ()=>{
    const sentry = await (parcelRequire("55apF"));
    return {
        BrowserClient: sentry.BrowserClient,
        eventFromException: sentry.eventFromException
    };
};
const $024249913f1d8b5b$var$DEFAULT_PACKAGE_NAME = '@atlassian/conversation-assistant';
const $024249913f1d8b5b$var$DEFAULT_SENTRY_DSN = 'https://0d679a1c0fe3816e2b2e34d4ca85d5da@o55978.ingest.sentry.io/4506794008903680';
const $024249913f1d8b5b$var$KNOWN_NON_PRODUCTION_LOCATION_PARTS = [
    'localhost',
    '.local',
    'jira-dev.com',
    'stg.atlassian.com',
    'stg.internal.atlassian.com',
    'stg-east.frontend.public.atl-paas.net'
];
let $024249913f1d8b5b$var$sentryClient;
let $024249913f1d8b5b$var$privateReporter;
let $024249913f1d8b5b$var$selectedReportingPipeline;
const $024249913f1d8b5b$var$reportingPipelineSelector = (0, $2AFxF.createPageSessionReportingPipelineSelector)(()=>(0, $iDrrr.fg)('rovo_chat_sentry_isolated_reporter'));
let $024249913f1d8b5b$var$sentrySetupFailed = false;
let $024249913f1d8b5b$var$sentrySetupFailure;
// Report the irrecoverable setup failure once per page session. The underlying mismatch cannot
// recover until the host reloads with compatible Sentry versions.
let $024249913f1d8b5b$var$sentrySetupFailureReported = false;
let $024249913f1d8b5b$var$accountIdPromise;
const $024249913f1d8b5b$var$defaultAccountIdProvider = ()=>new Promise((resolve, reject)=>{
        (0, $jTKfH.performHttpFetch)({
            path: '/gateway/api/me',
            options: {
                method: 'GET'
            }
        }).then((profileData)=>{
            if (profileData?.account_id) resolve(profileData.account_id);
            else reject(new Error('Profile data not loaded'));
        }).catch((error)=>{
            reject(error);
        });
    });
let $024249913f1d8b5b$var$accountIdProvider = $024249913f1d8b5b$var$defaultAccountIdProvider;
const $024249913f1d8b5b$export$59333a3d3d770a30 = (fn)=>{
    $024249913f1d8b5b$var$accountIdProvider = fn;
    $024249913f1d8b5b$var$accountIdPromise = undefined;
};
const $024249913f1d8b5b$export$e941c8ce80d1ac70 = ()=>{
    $024249913f1d8b5b$var$accountIdProvider = $024249913f1d8b5b$var$defaultAccountIdProvider;
    $024249913f1d8b5b$var$accountIdPromise = undefined;
};
const $024249913f1d8b5b$export$388db6ab9ccbe151 = ()=>{
    $024249913f1d8b5b$var$privateReporter?.resetForTests();
    $024249913f1d8b5b$var$sentryClient = undefined;
    $024249913f1d8b5b$var$privateReporter = undefined;
    $024249913f1d8b5b$var$selectedReportingPipeline = undefined;
    $024249913f1d8b5b$var$reportingPipelineSelector.resetForTests();
    $024249913f1d8b5b$var$sentrySetupFailed = false;
    $024249913f1d8b5b$var$sentrySetupFailure = undefined;
    $024249913f1d8b5b$var$sentrySetupFailureReported = false;
    $024249913f1d8b5b$var$accountIdPromise = undefined;
    $024249913f1d8b5b$var$accountIdProvider = $024249913f1d8b5b$var$defaultAccountIdProvider;
};
// copied from platform/packages/people-and-teams/teams-client/src/services/sentry/utils/initialise-sentry.ts
const $024249913f1d8b5b$var$DISABLED_INTEGRATIONS = [
    'onerror',
    'onunhandledrejection',
    // In Jira this integration is being initialised twice, resulting in no events being sent to Sentry
    'Dedupe'
];
const $024249913f1d8b5b$var$getEnvironment = ()=>{
    return 'production';
};
const $024249913f1d8b5b$var$getReportingPipeline = ()=>{
    if (!$024249913f1d8b5b$var$selectedReportingPipeline) $024249913f1d8b5b$var$selectedReportingPipeline = $024249913f1d8b5b$var$reportingPipelineSelector.get();
    return $024249913f1d8b5b$var$selectedReportingPipeline;
};
const $024249913f1d8b5b$export$2cf018785da78e5 = ()=>$024249913f1d8b5b$var$getReportingPipeline() === 'isolatedPrivateV1';
const $024249913f1d8b5b$var$getRelease = ()=>{
    if (typeof window === 'undefined') return;
    return window.SENTRY_RELEASE?.id;
};
const $024249913f1d8b5b$var$setupPrivateReporter = async ({ accountId: accountId, customSentryDsn: customSentryDsn, ignoreErrors: ignoreErrors, packageName: packageName, packageVersion: packageVersion, product: product })=>{
    const dsn = customSentryDsn || $024249913f1d8b5b$var$DEFAULT_SENTRY_DSN;
    if ($024249913f1d8b5b$var$privateReporter) {
        $024249913f1d8b5b$var$privateReporter.updateContext({
            accountId: accountId,
            packageVersion: packageVersion,
            product: product
        });
        return;
    }
    try {
        const importedSentry = await $024249913f1d8b5b$var$importPrivateSentryAsync();
        $024249913f1d8b5b$var$privateReporter = new (0, $8DeC3.ConversationAssistantPrivateReporter)({
            accountId: accountId,
            dsn: dsn,
            environment: $024249913f1d8b5b$var$getEnvironment(),
            ignoreErrors: ignoreErrors,
            packageName: packageName,
            packageVersion: packageVersion,
            product: product,
            release: $024249913f1d8b5b$var$getRelease(),
            sentry: importedSentry
        });
    } catch  {
    // Private reporting is best effort and must not affect Sentry callers.
    }
};
const $024249913f1d8b5b$export$d8bd0edf6c978788 = async ({ customSentryDsn: customSentryDsn, packageName: packageName, product: productOverride, ignoreErrors: ignoreErrors, packageVersion: packageVersion, onSetupFailure: onSetupFailure } = {})=>{
    let accountId = 'UNKNOWN_AAID';
    let product = productOverride ?? (0, $cj7GQ.getRovoChatProduct)();
    const resolvedPackageName = packageName || $024249913f1d8b5b$var$DEFAULT_PACKAGE_NAME;
    if ($024249913f1d8b5b$var$getReportingPipeline() === 'legacyGlobal' && $024249913f1d8b5b$var$sentrySetupFailed) {
        $024249913f1d8b5b$var$reportSentrySetupFailure(onSetupFailure);
        return;
    }
    try {
        if (!$024249913f1d8b5b$var$accountIdPromise) $024249913f1d8b5b$var$accountIdPromise = $024249913f1d8b5b$var$accountIdProvider();
        accountId = await $024249913f1d8b5b$var$accountIdPromise;
    } catch  {
    // do nothing
    }
    if ($024249913f1d8b5b$export$2cf018785da78e5()) {
        await $024249913f1d8b5b$var$setupPrivateReporter({
            accountId: accountId,
            customSentryDsn: customSentryDsn,
            ignoreErrors: ignoreErrors,
            packageName: resolvedPackageName,
            packageVersion: packageVersion,
            product: product
        });
        return;
    }
    if ($024249913f1d8b5b$var$sentryClient) {
        // if sentry is trying to be initialized again with new product or account id
        // update the user and tags
        $024249913f1d8b5b$var$sentryClient.setTag('product', product);
        $024249913f1d8b5b$var$sentryClient.setUser({
            id: accountId
        });
        // do not initialise sentry again, only update the existing one
        return;
    }
    let importedSentry;
    try {
        importedSentry = await $024249913f1d8b5b$var$importLegacySentryAsync();
    } catch (e) {
        console.warn('Failed to load conversation-assistant sentry', e); // eslint-disable-line no-console
        return;
    }
    const shouldSuppressSetupRetry = (0, $iDrrr.fg)('rovo_chat_sentry_setup_retry_killswitch');
    try {
        importedSentry.init({
            dsn: customSentryDsn || $024249913f1d8b5b$var$DEFAULT_SENTRY_DSN,
            environment: $024249913f1d8b5b$var$getEnvironment(),
            integrations: (integrations)=>{
                return integrations.filter((integration)=>{
                    return $024249913f1d8b5b$var$DISABLED_INTEGRATIONS.indexOf(integration.name) === -1;
                });
            },
            initialScope: {
                user: {
                    id: accountId
                },
                tags: {
                    packageName: resolvedPackageName,
                    product: product,
                    packageVersion: packageVersion
                }
            },
            // referencing jira/src/packages/platform/observability/errors-handling/src/utils/sentry/handling/normalise-sentry-event.tsx
            beforeSend: (event, hint)=>{
                const exception = hint?.originalException;
                // Ignore network-like errors
                if ((0, $10XTN.isClientFetchError)(exception)) return null;
                if (!event.tags?.name) // we only want to capture errors that has `name` tag from `logException` function below
                // since the `DISABLED_INTEGRATIONS` filter above is not enough to prevent unhandled errors
                return null;
                let updatedEvent = event;
                if (updatedEvent.request?.url) {
                    // Ignore events from localhost and staging
                    if ($024249913f1d8b5b$var$KNOWN_NON_PRODUCTION_LOCATION_PARTS.some((part)=>updatedEvent.request?.url?.includes(part))) return null;
                    updatedEvent.request.url = (0, $fPSAz.normaliseUrl)(updatedEvent.request.url);
                }
                if (updatedEvent.exception?.values) {
                    const allMatchedUUIDs = [];
                    updatedEvent.exception.values = updatedEvent.exception.values.map((exception)=>{
                        const { normalized: normalized, matchedUUIDs: matchedUUIDs } = (0, $fPSAz.normalizeUUID)(exception.value);
                        allMatchedUUIDs.push(...matchedUUIDs);
                        return {
                            ...exception,
                            value: normalized
                        };
                    });
                    if (allMatchedUUIDs.length > 0) {
                        if (!updatedEvent.tags) updatedEvent.tags = {};
                        updatedEvent.tags.matchedUUID = JSON.stringify(allMatchedUUIDs);
                    }
                }
                return updatedEvent;
            },
            attachStacktrace: true,
            ignoreErrors: ignoreErrors
        });
        $024249913f1d8b5b$var$sentryClient = importedSentry;
    } catch (error) {
        // this function throws e.update is not a function errors when we have a mismatch in sentry versions.
        // all targeted errors include 'update is not a function' even if minified differently
        if (error instanceof Error && error.message.includes('update is not a function')) {
            // Instead of throwing and logging the error to sentry, swallow it.
            if (shouldSuppressSetupRetry) {
                $024249913f1d8b5b$var$sentrySetupFailure = {
                    reason: 'sentry_version_mismatch',
                    product: product,
                    packageName: resolvedPackageName,
                    setupRetrySuppressed: true
                };
                $024249913f1d8b5b$var$reportSentrySetupFailure(onSetupFailure);
                $024249913f1d8b5b$var$sentrySetupFailed = true;
            } else $024249913f1d8b5b$var$sentryClient = importedSentry;
        } else throw error;
    }
};
const $024249913f1d8b5b$var$reportSentrySetupFailure = (onSetupFailure)=>{
    if (!onSetupFailure || !$024249913f1d8b5b$var$sentrySetupFailure || $024249913f1d8b5b$var$sentrySetupFailureReported) return;
    $024249913f1d8b5b$var$sentrySetupFailureReported = true;
    try {
        onSetupFailure($024249913f1d8b5b$var$sentrySetupFailure);
    } catch  {
    // Setup failure telemetry is best effort and must not break Sentry callers.
    }
};
const $024249913f1d8b5b$var$getSentryClient = async ()=>{
    if (!$024249913f1d8b5b$var$sentryClient && !$024249913f1d8b5b$var$sentrySetupFailed) // this only happens if something using sentry before the initialisation in root app
    await $024249913f1d8b5b$export$d8bd0edf6c978788();
    return $024249913f1d8b5b$var$sentryClient;
};
const $024249913f1d8b5b$export$f86b2a1a2ce291b3 = async ({ exception: exception, name: name, tags: tags })=>{
    if ($024249913f1d8b5b$export$2cf018785da78e5()) {
        if (!$024249913f1d8b5b$var$privateReporter) await $024249913f1d8b5b$export$d8bd0edf6c978788();
        try {
            await $024249913f1d8b5b$var$privateReporter?.captureException({
                exception: exception,
                name: name,
                tags: tags
            });
        } catch  {
        // Private reporting is best effort and must not affect Sentry callers.
        }
        return;
    }
    const sentryClient = await $024249913f1d8b5b$var$getSentryClient();
    if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
    sentryClient.withScope((scope)=>{
        scope.setTag('name', name);
        if (tags) scope.setTags(tags);
        if (tags?.source === 'aiMateExperienceTracker') scope.setTag('experience', name);
        try {
            sentryClient.captureException(exception, scope);
        } catch (error) {
        // this function throws e.update is not a function errors when we have a mismatch in sentry versions. Instead of throwing and logging the error to sentry, swallow it.
        // TODO: upgrade sentry across confluence, jira, etc. to the same version to avoid this error
        }
    });
};
async function $024249913f1d8b5b$export$de29810e0b4aa46e(crumb) {
    if ($024249913f1d8b5b$export$2cf018785da78e5()) {
        if (!$024249913f1d8b5b$var$privateReporter) await $024249913f1d8b5b$export$d8bd0edf6c978788();
        try {
            $024249913f1d8b5b$var$privateReporter?.addBreadcrumb(crumb);
        } catch  {
        // Breadcrumb collection is best effort and must never affect the caller.
        }
        return;
    }
    const sentryClient = await $024249913f1d8b5b$var$getSentryClient();
    if (!sentryClient || typeof sentryClient.addBreadcrumb !== 'function') return;
    sentryClient.addBreadcrumb(typeof crumb === 'string' ? {
        message: crumb
    } : crumb);
}
const $024249913f1d8b5b$export$2a10cc65cb1c6167 = (...args)=>{
    console.error(...args); // eslint-disable-line no-console
    if ($024249913f1d8b5b$export$2cf018785da78e5() && $024249913f1d8b5b$var$privateReporter) try {
        $024249913f1d8b5b$var$privateReporter.addBreadcrumb({
            category: 'console',
            level: 'error',
            message: args.map(String).join(' ')
        });
    } catch  {
    // Mirroring selected console output is best effort.
    }
};
const $024249913f1d8b5b$export$b9f335638bb5225f = (...args)=>{
    console.warn(...args); // eslint-disable-line no-console
    if ($024249913f1d8b5b$export$2cf018785da78e5() && $024249913f1d8b5b$var$privateReporter) try {
        $024249913f1d8b5b$var$privateReporter.addBreadcrumb({
            category: 'console',
            level: 'warning',
            message: args.map(String).join(' ')
        });
    } catch  {
    // Mirroring selected console output is best effort.
    }
};
module.exports["isIsolatedSentryReportingSelected"] = $024249913f1d8b5b$export$2cf018785da78e5;
module.exports["setupSentryClient"] = $024249913f1d8b5b$export$d8bd0edf6c978788;
module.exports["logException"] = $024249913f1d8b5b$export$f86b2a1a2ce291b3;
module.exports["addSentryBreadcrumb"] = $024249913f1d8b5b$export$de29810e0b4aa46e;
module.exports["logSentryConsoleError"] = $024249913f1d8b5b$export$2a10cc65cb1c6167;
module.exports["logSentryConsoleWarning"] = $024249913f1d8b5b$export$b9f335638bb5225f;

});

parcelRegister("jTKfH", function(module, exports) {

var $5rzIE = parcelRequire("5rzIE");

const $93101e1e1df3fd55$export$9f229e40eb65abfc = (response)=>response?.headers?.get('x-trace-id') ?? response?.headers?.get('atl-traceid') ?? response?.headers?.get('x-b3-traceid') ?? undefined;
class $93101e1e1df3fd55$export$26e841bcf1aeb894 extends Error {
    constructor(message, errorAttributes){
        super(message), this.errorAttributes = errorAttributes;
        this.name = 'FetchError';
    }
}
class $93101e1e1df3fd55$var$HttpApiError extends Error {
    constructor(message, errorAttributes){
        super(message), this.message = message, this.errorAttributes = errorAttributes;
    }
}
const $93101e1e1df3fd55$export$a38d93aa782475f6 = async ({ path: path, options: options })=>{
    const startedAt = (0, $5rzIE.hasRequestObservationSubscribers)() ? (0, $5rzIE.requestObservationNow)() : undefined;
    try {
        const response = await fetch(path, options);
        if (!response.ok || response.status >= 400) await $93101e1e1df3fd55$var$processHttpErrorResponse({
            response: response
        });
        const result = await response.json();
        if (startedAt !== undefined) (0, $5rzIE.publishRequestObservation)({
            kind: 'http',
            method: (options.method ?? 'GET').toUpperCase(),
            route: (0, $5rzIE.normalizeRequestRoute)(path),
            durationMs: (0, $5rzIE.requestObservationDuration)(startedAt),
            outcome: 'success',
            status: response.status
        });
        return result;
    } catch (err) {
        const outcome = err instanceof $93101e1e1df3fd55$var$HttpApiError ? 'httpError' : err instanceof Error && err.name === 'AbortError' ? 'abort' : 'networkError';
        const statusCode = err instanceof $93101e1e1df3fd55$var$HttpApiError ? err.errorAttributes.statusCode : undefined;
        if (startedAt !== undefined) (0, $5rzIE.publishRequestObservation)({
            kind: 'http',
            method: (options.method ?? 'GET').toUpperCase(),
            route: (0, $5rzIE.normalizeRequestRoute)(path),
            durationMs: (0, $5rzIE.requestObservationDuration)(startedAt),
            outcome: outcome,
            status: statusCode
        });
        const originalErrorMessage = err instanceof Error ? 'Original error: ' + err.message : 'Unknown error';
        throw new $93101e1e1df3fd55$export$26e841bcf1aeb894(`performHttpFetch error while fetching ${path}. ${originalErrorMessage}`, {
            errorCode: 'performHttpFetchError',
            statusCode: statusCode
        });
    }
};
const $93101e1e1df3fd55$var$processHttpErrorResponse = async ({ response: response })=>{
    throw new $93101e1e1df3fd55$var$HttpApiError(`[Code ${response.status}] ${await response.text()}`, {
        statusCode: response.status,
        traceId: $93101e1e1df3fd55$export$9f229e40eb65abfc(response)
    });
};
module.exports["getTraceIdFromResponse"] = $93101e1e1df3fd55$export$9f229e40eb65abfc;
module.exports["FetchError"] = $93101e1e1df3fd55$export$26e841bcf1aeb894;
module.exports["performHttpFetch"] = $93101e1e1df3fd55$export$a38d93aa782475f6;

});

parcelRegister("5rzIE", function(module, exports) {
const $40a8b1f594239208$var$listeners = new Set();
const $40a8b1f594239208$var$UUID_SEGMENT_PATTERN = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
const $40a8b1f594239208$var$NUMERIC_SEGMENT_PATTERN = /\/\d+(?=\/|$)/g;
const $40a8b1f594239208$export$eb91308c925b64ce = ()=>{
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') return performance.now();
    return Date.now();
};
const $40a8b1f594239208$export$327998895df08b85 = (startedAt)=>Math.max(0, Math.round($40a8b1f594239208$export$eb91308c925b64ce() - startedAt));
const $40a8b1f594239208$export$c805539eac489f93 = (path)=>{
    try {
        const parsed = new URL(path, 'https://conversation-assistant.invalid');
        return parsed.pathname.replace($40a8b1f594239208$var$UUID_SEGMENT_PATTERN, '{id}').replace($40a8b1f594239208$var$NUMERIC_SEGMENT_PATTERN, '/{id}');
    } catch  {
        return '/unparseable';
    }
};
const $40a8b1f594239208$export$d23c16bc33c579b9 = (listener)=>{
    $40a8b1f594239208$var$listeners.add(listener);
    return ()=>{
        $40a8b1f594239208$var$listeners.delete(listener);
    };
};
const $40a8b1f594239208$export$1914d1896389da95 = ()=>$40a8b1f594239208$var$listeners.size > 0;
const $40a8b1f594239208$export$58e155918d09bf5f = (observation)=>{
    for (const listener of Array.from($40a8b1f594239208$var$listeners))try {
        listener(observation);
    } catch  {
    // Observability must never change the request's result or error behavior.
    }
};
const $40a8b1f594239208$export$ef42b2d680ea8d8d = ()=>{
    $40a8b1f594239208$var$listeners.clear();
};
module.exports["requestObservationNow"] = $40a8b1f594239208$export$eb91308c925b64ce;
module.exports["requestObservationDuration"] = $40a8b1f594239208$export$327998895df08b85;
module.exports["normalizeRequestRoute"] = $40a8b1f594239208$export$c805539eac489f93;
module.exports["subscribeToRequestObservations"] = $40a8b1f594239208$export$d23c16bc33c579b9;
module.exports["hasRequestObservationSubscribers"] = $40a8b1f594239208$export$1914d1896389da95;
module.exports["publishRequestObservation"] = $40a8b1f594239208$export$58e155918d09bf5f;

});

parcelRegister("cj7GQ", function(module, exports) {
const $cfb262a7d2b032b8$export$d4fdfa93c283ffc = ()=>{
    let product = 'UNKNOWN';
    const win = window;
    if (win.__ROVO_CHAT_CONFIG_PRODUCT__) product = win.__ROVO_CHAT_CONFIG_PRODUCT__;
    return product;
};
module.exports["getRovoChatProduct"] = $cfb262a7d2b032b8$export$d4fdfa93c283ffc;

});

parcelRegister("8DeC3", function(module, exports) {

var $5rzIE = parcelRequire("5rzIE");


var $10XTN = parcelRequire("10XTN");


var $u3ka6 = parcelRequire("u3ka6");


var $fPSAz = parcelRequire("fPSAz");

const $0e0107334ae89504$var$MAX_LINKED_ERRORS = 5;
const $0e0107334ae89504$var$MAX_MATCHED_UUID_TAG_LENGTH = 200;
const $0e0107334ae89504$var$BLOCKED_LOCATION_PARTS = [
    'localhost',
    'jira-dev.com',
    'stg.atlassian.com',
    'stg.internal.atlassian.com',
    'stg-east.frontend.public.atl-paas.net'
];
const $0e0107334ae89504$var$eventId = ()=>crypto.randomUUID().replace(/-/g, '');
const $0e0107334ae89504$var$matchesIgnorePattern = (value, patterns)=>patterns?.some((pattern)=>typeof pattern === 'string' ? value.includes(pattern) : (()=>{
            pattern.lastIndex = 0;
            const matches = pattern.test(value);
            pattern.lastIndex = 0;
            return matches;
        })()) ?? false;
const $0e0107334ae89504$var$isBlockedLocation = ()=>{
    if (typeof window === 'undefined') return false;
    return $0e0107334ae89504$var$BLOCKED_LOCATION_PARTS.some((part)=>window.location.href.includes(part));
};
const $0e0107334ae89504$var$requestObservationToBreadcrumb = (observation)=>({
        category: observation.kind === 'graphql' ? 'conversation-assistant.request.graphql' : 'conversation-assistant.request.http',
        data: observation,
        level: observation.outcome === 'success' || observation.outcome === 'abort' ? 'info' : 'warning',
        message: observation.kind === 'graphql' ? `${observation.operation} ${observation.outcome}` : `${observation.method} ${observation.route} ${observation.outcome}`,
        type: 'http'
    });
const $0e0107334ae89504$var$toPrivateBreadcrumb = (breadcrumb)=>({
        ...breadcrumb,
        level: breadcrumb.level
    });
const $0e0107334ae89504$var$getCause = (error)=>{
    const cause = error.cause;
    return cause instanceof Error ? cause : undefined;
};
class $0e0107334ae89504$export$7c63502cdfeff038 {
    updateContext({ accountId: accountId, packageVersion: packageVersion, product: product }) {
        this.accountId = accountId;
        if (this.packageVersion === undefined && packageVersion !== undefined) this.packageVersion = packageVersion;
        this.product = product;
    }
    addBreadcrumb(crumb) {
        this.breadcrumbGateway.add(crumb);
    }
    async captureException({ exception: exception, name: name, tags: tags }) {
        if (!this.enabled || (0, $10XTN.isClientFetchError)(exception) || $0e0107334ae89504$var$isBlockedLocation()) return;
        const rootMessage = exception instanceof Error ? exception.message : String(exception);
        if ($0e0107334ae89504$var$matchesIgnorePattern(rootMessage, this.ignoreErrors)) return;
        const id = $0e0107334ae89504$var$eventId();
        const event = await this.sentry.eventFromException(exception, {
            event_id: id
        }, true);
        await this.addLinkedErrors(event, exception);
        const eventTags = {
            experience: tags?.source === 'aiMateExperienceTracker' ? name : undefined,
            name: name,
            packageName: this.packageName,
            packageVersion: this.packageVersion,
            product: this.product,
            reportingPipeline: 'isolatedPrivateV1',
            sentryOwner: 'conversation-assistant',
            ...tags
        };
        event.tags = {
            ...event.tags,
            ...eventTags
        };
        event.user = {
            id: this.accountId
        };
        event.breadcrumbs = this.breadcrumbGateway.snapshot().map($0e0107334ae89504$var$toPrivateBreadcrumb);
        if (typeof window !== 'undefined') event.request = {
            ...event.request,
            url: (0, $fPSAz.normaliseUrl)(window.location.href)
        };
        this.normalizeEventUUIDs(event);
        // Do not pass `originalException`: BaseClient otherwise consults the SDK-wide
        // already-caught registry shared through Sentry's global carrier.
        this.client.captureEvent(event, {
            event_id: id
        });
    }
    resetForTests() {
        this.unsubscribeFromRequestObservations();
        this.breadcrumbGateway.reset();
    }
    async addLinkedErrors(event, exception) {
        if (!(exception instanceof Error) || !event.exception?.values) return;
        const linkedValues = [];
        let current = $0e0107334ae89504$var$getCause(exception);
        const seen = new Set([
            exception
        ]);
        while(current && linkedValues.length < $0e0107334ae89504$var$MAX_LINKED_ERRORS - 1 && !seen.has(current)){
            seen.add(current);
            const linkedEvent = await this.sentry.eventFromException(current, undefined, true);
            if (linkedEvent.exception?.values?.[0]) linkedValues.unshift(linkedEvent.exception.values[0]);
            current = $0e0107334ae89504$var$getCause(current);
        }
        event.exception.values = [
            ...linkedValues,
            ...event.exception.values
        ];
    }
    normalizeEventUUIDs(event) {
        if (!event.exception?.values) return;
        const matchedUUIDs = new Set();
        event.exception.values = event.exception.values.map((exceptionValue)=>{
            const { normalized: normalized, matchedUUIDs: matches } = (0, $fPSAz.normalizeUUID)(exceptionValue.value);
            matches.forEach((match)=>matchedUUIDs.add(match));
            return {
                ...exceptionValue,
                stacktrace: exceptionValue.stacktrace ? {
                    ...exceptionValue.stacktrace,
                    frames: exceptionValue.stacktrace.frames?.map((frame)=>{
                        const normalizedFrame = {
                            ...frame
                        };
                        [
                            'abs_path',
                            'filename',
                            'function',
                            'module'
                        ].forEach((key)=>{
                            if (typeof normalizedFrame[key] !== 'string') return;
                            const normalizedStackValue = (0, $fPSAz.normalizeUUID)(normalizedFrame[key]);
                            normalizedStackValue.matchedUUIDs.forEach((match)=>matchedUUIDs.add(match));
                            normalizedFrame[key] = normalizedStackValue.normalized;
                        });
                        return normalizedFrame;
                    })
                } : undefined,
                value: normalized
            };
        });
        if (matchedUUIDs.size === 0) return;
        const boundedMatches = [];
        for (const match of matchedUUIDs){
            const candidate = [
                ...boundedMatches,
                match
            ];
            if (JSON.stringify(candidate).length > $0e0107334ae89504$var$MAX_MATCHED_UUID_TAG_LENGTH) break;
            boundedMatches.push(match);
        }
        event.tags = {
            ...event.tags,
            matchedUUID: JSON.stringify(boundedMatches)
        };
    }
    constructor({ accountId: accountId, dsn: dsn, environment: environment, ignoreErrors: ignoreErrors, packageName: packageName, packageVersion: packageVersion, product: product, release: release, sentry: sentry }){
        this.breadcrumbGateway = new (0, $u3ka6.ConversationAssistantBreadcrumbGateway)();
        this.client = void 0;
        this.enabled = void 0;
        this.ignoreErrors = void 0;
        this.sentry = void 0;
        this.accountId = void 0;
        this.packageName = void 0;
        this.packageVersion = void 0;
        this.product = void 0;
        this.unsubscribeFromRequestObservations = void 0;
        this.accountId = accountId;
        this.enabled = environment === 'production';
        this.ignoreErrors = ignoreErrors;
        this.packageName = packageName;
        this.packageVersion = packageVersion;
        this.product = product;
        this.sentry = sentry;
        this.client = new sentry.BrowserClient({
            attachStacktrace: true,
            autoSessionTracking: false,
            dsn: dsn,
            enabled: this.enabled,
            environment: environment,
            integrations: [],
            maxBreadcrumbs: 100,
            release: release,
            sendClientReports: true
        });
        this.unsubscribeFromRequestObservations = (0, $5rzIE.subscribeToRequestObservations)((observation)=>{
            this.breadcrumbGateway.add($0e0107334ae89504$var$requestObservationToBreadcrumb(observation));
        });
    }
}
module.exports["ConversationAssistantPrivateReporter"] = $0e0107334ae89504$export$7c63502cdfeff038;

});

parcelRegister("u3ka6", function(module, exports) {

var $fPSAz = parcelRequire("fPSAz");

const $e73c9a6ea29f4dd8$var$MAX_BREADCRUMBS = 100;
const $e73c9a6ea29f4dd8$var$MAX_MESSAGE_LENGTH = 500;
const $e73c9a6ea29f4dd8$var$MAX_DATA_VALUE_LENGTH = 200;
const $e73c9a6ea29f4dd8$var$COALESCE_WINDOW_MS = 5000;
const $e73c9a6ea29f4dd8$var$ALLOWED_DATA_KEYS = new Set([
    'action',
    'actionSubject',
    'actionSubjectId',
    'durationMs',
    'experience',
    'kind',
    'lifecycle',
    'method',
    'nextState',
    'operation',
    'outcome',
    'previousState',
    'repeatCount',
    'route',
    'screen',
    'state',
    'status',
    'surface',
    'touchpoint'
]);
const $e73c9a6ea29f4dd8$var$truncate = (value, maxLength)=>value.length > maxLength ? `${value.slice(0, maxLength - 1)}\u{2026}` : value;
const $e73c9a6ea29f4dd8$var$sanitizeString = (value, maxLength = $e73c9a6ea29f4dd8$var$MAX_DATA_VALUE_LENGTH)=>{
    const { normalized: normalized } = (0, $fPSAz.normalizeUUID)(value);
    const withoutQuery = normalized.replace(/([a-z][a-z0-9+.-]*:\/\/[^?\s]+)\?[^\s]*/gi, '$1');
    return $e73c9a6ea29f4dd8$var$truncate(withoutQuery, maxLength);
};
const $e73c9a6ea29f4dd8$var$sanitizeData = (data)=>{
    if (!data) return;
    const sanitized = Object.entries(data).reduce((result, [key, value])=>{
        if (!$e73c9a6ea29f4dd8$var$ALLOWED_DATA_KEYS.has(key) || value !== null && typeof value !== 'string' && typeof value !== 'number' && typeof value !== 'boolean') return result;
        if (typeof value === 'string') {
            const sanitizedValue = $e73c9a6ea29f4dd8$var$sanitizeString(value);
            result[key] = sanitizedValue;
        } else if (value !== null) result[key] = value;
        return result;
    }, {});
    return Object.keys(sanitized).length > 0 ? sanitized : undefined;
};
const $e73c9a6ea29f4dd8$var$sanitizeCategory = (category)=>{
    if (!category) return 'conversation-assistant.custom';
    const safeCategory = category.toLowerCase().replace(/[^a-z0-9._-]+/g, '-').slice(0, 80);
    return safeCategory.startsWith('conversation-assistant.') ? safeCategory : `conversation-assistant.${safeCategory}`;
};
const $e73c9a6ea29f4dd8$var$isCoalescable = (breadcrumb)=>breadcrumb.level === 'warning' || breadcrumb.level === 'error' || breadcrumb.category?.includes('store') === true;
class $e73c9a6ea29f4dd8$export$78d89786cb79630b {
    add(crumb) {
        const breadcrumb = this.sanitize(typeof crumb === 'string' ? {
            message: crumb
        } : crumb);
        if (!$e73c9a6ea29f4dd8$var$isCoalescable(breadcrumb)) {
            this.push(breadcrumb);
            return;
        }
        const key = JSON.stringify({
            category: breadcrumb.category,
            data: breadcrumb.data,
            level: breadcrumb.level,
            message: breadcrumb.message,
            type: breadcrumb.type
        });
        const pending = this.pendingCoalescedBreadcrumb;
        if (pending?.key === key) {
            pending.repeatCount += 1;
            return;
        }
        this.flushCoalescedSummary();
        this.push(breadcrumb);
        this.pendingCoalescedBreadcrumb = {
            key: key,
            breadcrumb: breadcrumb,
            repeatCount: 1,
            timer: setTimeout(()=>this.flushCoalescedSummary(), $e73c9a6ea29f4dd8$var$COALESCE_WINDOW_MS)
        };
    }
    snapshot() {
        this.flushCoalescedSummary();
        return this.breadcrumbs.map((breadcrumb)=>({
                ...breadcrumb,
                data: breadcrumb.data ? {
                    ...breadcrumb.data
                } : undefined
            }));
    }
    reset() {
        if (this.pendingCoalescedBreadcrumb) clearTimeout(this.pendingCoalescedBreadcrumb.timer);
        this.pendingCoalescedBreadcrumb = undefined;
        this.breadcrumbs = [];
    }
    sanitize(breadcrumb) {
        const category = $e73c9a6ea29f4dd8$var$sanitizeCategory(breadcrumb.category);
        const data = $e73c9a6ea29f4dd8$var$sanitizeData(breadcrumb.data);
        const message = typeof breadcrumb.message === 'string' ? $e73c9a6ea29f4dd8$var$sanitizeString(breadcrumb.message, $e73c9a6ea29f4dd8$var$MAX_MESSAGE_LENGTH) : undefined;
        return {
            category: category,
            data: data,
            level: breadcrumb.level,
            message: message,
            timestamp: breadcrumb.timestamp ?? Date.now() / 1000,
            type: breadcrumb.type
        };
    }
    flushCoalescedSummary() {
        const pending = this.pendingCoalescedBreadcrumb;
        if (!pending) return;
        clearTimeout(pending.timer);
        this.pendingCoalescedBreadcrumb = undefined;
        if (pending.repeatCount <= 1) return;
        this.push({
            ...pending.breadcrumb,
            data: {
                ...pending.breadcrumb.data,
                repeatCount: pending.repeatCount
            },
            message: pending.breadcrumb.message ? `${pending.breadcrumb.message} (repeated ${pending.repeatCount} times)` : `Breadcrumb repeated ${pending.repeatCount} times`,
            timestamp: Date.now() / 1000
        });
    }
    push(breadcrumb) {
        this.breadcrumbs.push(breadcrumb);
        if (this.breadcrumbs.length > $e73c9a6ea29f4dd8$var$MAX_BREADCRUMBS) this.breadcrumbs.splice(0, this.breadcrumbs.length - $e73c9a6ea29f4dd8$var$MAX_BREADCRUMBS);
    }
    constructor(){
        this.breadcrumbs = [];
        this.pendingCoalescedBreadcrumb = void 0;
    }
}
module.exports["ConversationAssistantBreadcrumbGateway"] = $e73c9a6ea29f4dd8$export$78d89786cb79630b;

});

parcelRegister("fPSAz", function(module, exports) {
const $155164db85c7fae0$var$pathnamePrefixes = [
    '/jira/',
    '/wiki/',
    '/browse/'
];
const $155164db85c7fae0$var$ATLAS_HOST = 'home.atlassian.com';
const $155164db85c7fae0$var$ATLAS_TEAM_HOST = 'team.atlassian.com';
const $155164db85c7fae0$var$UUID_REGEX = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
const $155164db85c7fae0$export$d57ae76c6dc57a5 = (url)=>{
    try {
        let parsedUrl = new URL(url);
        let normalizedPath = '/any/';
        if (parsedUrl.host === $155164db85c7fae0$var$ATLAS_HOST || parsedUrl.host === $155164db85c7fae0$var$ATLAS_TEAM_HOST) // Replace org ID with "orgId" in the path
        normalizedPath = parsedUrl.pathname.replace(/\/o\/[^/]+/, '/o/orgId');
        const prefixRegex = new RegExp(`^(${$155164db85c7fae0$var$pathnamePrefixes.join('|')})`);
        if (prefixRegex.test(parsedUrl.pathname)) normalizedPath = parsedUrl.pathname.match(prefixRegex)[0];
        const normalizedUrl = `${parsedUrl.protocol}//${parsedUrl.host}${normalizedPath}`;
        return normalizedUrl;
    } catch (error) {
        return 'https://could-not-parse.example.com';
    }
};
const $155164db85c7fae0$export$5efaf8444170fe75 = (str)=>{
    if (!str) return {
        normalized: '',
        matchedUUIDs: []
    };
    const matchedUUIDs = str.match($155164db85c7fae0$var$UUID_REGEX) || [];
    const normalized = str.replace($155164db85c7fae0$var$UUID_REGEX, '{uuid}');
    return {
        normalized: normalized,
        matchedUUIDs: matchedUUIDs
    };
};
module.exports["normaliseUrl"] = $155164db85c7fae0$export$d57ae76c6dc57a5;
module.exports["normalizeUUID"] = $155164db85c7fae0$export$5efaf8444170fe75;

});

parcelRegister("2AFxF", function(module, exports) {
const $a1cdab547537e98f$export$33f86b6cbc947514 = (isIsolatedReporterEnabled)=>{
    let selected;
    return {
        get: ()=>{
            selected ?? (selected = isIsolatedReporterEnabled() ? 'isolatedPrivateV1' : 'legacyGlobal');
            return selected;
        },
        resetForTests: ()=>{
            selected = undefined;
        }
    };
};
module.exports["createPageSessionReportingPipelineSelector"] = $a1cdab547537e98f$export$33f86b6cbc947514;

});

parcelRegister("55apF", function(module, exports) {

let $3b357f295bbe6b1c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3b357f295bbe6b1c$var$load("kT6dz"),
    $3b357f295bbe6b1c$var$load("aAWLw")
]).then(()=>parcelRequire('eieXD'));

});

parcelRegister("Ou0Zz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7TCQz = parcelRequire("7TCQz");


var $9DHhW = parcelRequire("9DHhW");


var $iDrrr = parcelRequire("iDrrr");


var $cFVPs = parcelRequire("cFVPs");


var $hlvTd = parcelRequire("hlvTd");


var $89QZA = parcelRequire("89QZA");


var $eMlr8 = parcelRequire("eMlr8");


var $1jIs1 = parcelRequire("1jIs1");


var $nl5f2 = parcelRequire("nl5f2");

const $0fbd029e2a18e798$var$isTownSquareEvent = ()=>[
        'home.atlassian.com',
        'team.atlassian.com'
    ].some((host)=>window.location?.host?.includes(host));
const $0fbd029e2a18e798$var$DEFAULT_TAGS = [
    'atlaskit',
    'aiMate'
];
const $0fbd029e2a18e798$export$f30c856a07c48ee5 = ({ action: action, actionSubject: actionSubject, type: type })=>// message sent (client) — sendAnalyticsEvent only, no trackAIMAUEvent equivalent.
    action === 'sent' && actionSubject === 'message' || // aiMateActions displayed (client) — sendAnalyticsEvent only, no trackAIMAUEvent equivalent.
    action === 'displayed' && actionSubject === 'aiMateActions' || // aiInteraction initiated — via sendAnalyticsEvent or trackAIMAUEvent({ type: 'initiated' }).
    action === 'initiated' && actionSubject === 'aiInteraction' || type === 'initiated' || // aiResult viewed — via sendAnalyticsEvent or trackAIMAUEvent({ type: 'viewed' }).
    action === 'viewed' && actionSubject === 'aiResult' || type === 'viewed' || // aiResult actioned (client) — via sendAnalyticsEvent or trackAIMAUEvent({ type: 'actioned' }).
    action === 'actioned' && actionSubject === 'aiResult' || type === 'actioned';
const $0fbd029e2a18e798$var$getRovoJourneyEventAttributes = ({ eventPayload: eventPayload, attributes: attributes, contextRovoJourneyId: contextRovoJourneyId })=>{
    const { [(0, $eMlr8.AI_MATE_ATTRIBUTES).rovoJourneyId]: suppliedRovoJourneyId, ...attributesWithoutRovoJourneyId } = attributes;
    const rovoJourneyId = suppliedRovoJourneyId ?? contextRovoJourneyId;
    return {
        ...attributesWithoutRovoJourneyId,
        ...$0fbd029e2a18e798$export$f30c856a07c48ee5(eventPayload) && rovoJourneyId ? {
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).rovoJourneyId]: rovoJourneyId
        } : {}
    };
};
const $0fbd029e2a18e798$var$SENTRY_ANALYTICS_ATTRIBUTE_KEYS = [
    'experience',
    'nextState',
    'outcome',
    'previousState',
    'screen',
    'state',
    'surface',
    'touchpoint'
];
const $0fbd029e2a18e798$var$getSentryAnalyticsBreadcrumb = (event)=>{
    const payload = event.payload;
    const attributes = payload?.attributes ?? {};
    const safeAttributes = $0fbd029e2a18e798$var$SENTRY_ANALYTICS_ATTRIBUTE_KEYS.reduce((result, key)=>{
        const value = attributes[key];
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') result[key] = value;
        return result;
    }, {});
    return {
        category: 'analytics',
        data: {
            action: payload?.action,
            actionSubject: payload?.actionSubject,
            actionSubjectId: payload?.actionSubjectId,
            ...safeAttributes
        },
        message: [
            payload?.action,
            payload?.actionSubject,
            payload?.actionSubjectId
        ].filter(Boolean).join(' ')
    };
};
const $0fbd029e2a18e798$export$e955abb82869dc84 = (options)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { propertiesRef: propertiesRef, mode: mode } = (0, $89QZA.useAnalyticsPropertiesContext)();
    // TODO: Improve this functionality, potentially with a higher order provider for tags or similar
    // This is a temporary solution to add the 'townsquare' tag to operational events so Experience Tracker works in Atlas
    const maybeAtlasOperationalTags = (0, $cozmU.useCallback)((inputPayload)=>{
        const payload = (0, $7TCQz.isUIAnalyticsEvent)(inputPayload) ? inputPayload.payload : inputPayload;
        if (payload.actionSubject === 'ui' && payload.eventType === 'operational' && $0fbd029e2a18e798$var$isTownSquareEvent()) return [
            'townsquare'
        ];
        return [];
    }, []);
    const tagsForAIAnalytics = [
        ...$0fbd029e2a18e798$var$DEFAULT_TAGS
    ];
    if ($0fbd029e2a18e798$var$isTownSquareEvent()) tagsForAIAnalytics.push('townsquare');
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultView: trackAIResultView, trackAIResultError: trackAIResultError, trackAIInteractionDismiss: trackAIInteractionDismiss, trackAIResultAction: trackAIResultAction, trackAIResultAdopted: trackAIResultAdopted, trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $cFVPs.useAIEventsInstrumentation)({
        // Required configruation
        product: propertiesRef.current.product,
        subproduct: propertiesRef.current.product,
        aiFeatureName: 'aiChat',
        proactiveGeneratedAI: 0,
        userGeneratedAI: 1,
        enablePlatformEvents: true,
        tags: tagsForAIAnalytics,
        skipAISessionValidation: options?.skipAISessionValidation,
        customAnalyticsFire: (rawEvent, _createdEvent)=>{
            // Build event and apply context attributes
            const event = createAnalyticsEvent(rawEvent);
            if (!event) // In SSR / no-listener environments, `createAnalyticsEvent` can return `undefined`.
            // Nothing to fire.
            return;
            const aiMateContextAttributes = (0, $nl5f2.getAttributesFromContexts)(event.context);
            // Fire. `event.update(...)` returns `undefined` for stub events (no `<AnalyticsListener>`
            // mounted, e.g. during SSR), so fall back to the original event and guard `.fire` with
            // optional chaining.
            const updatedEvent = event.update({
                attributes: $0fbd029e2a18e798$var$getRovoJourneyEventAttributes({
                    eventPayload: event.payload ?? rawEvent,
                    attributes: {
                        ...event.payload?.attributes ?? {},
                        ...aiMateContextAttributes
                    },
                    contextRovoJourneyId: propertiesRef.current.rovoJourneyId
                })
            }) ?? event;
            updatedEvent?.fire?.((0, $1jIs1.ANALYTICS_CHANNEL));
        }
    });
    const getDefaultAttributes = (0, $cozmU.useCallback)(()=>{
        const { agentCreatorType: agentCreatorType, agentId: agentId, agentVisibility: agentVisibility, agentExternalConfigReference: agentExternalConfigReference, agentActions: agentActions, agentIsDefault: agentIsDefault, agentIsVerified: agentIsVerified, conversationChannelId: conversationChannelId, chatEntryPoint: chatEntryPoint, experienceId: experienceId, fullScreen: fullScreen, product: product, productHeader: productHeader, inProductExperience: inProductExperience, mode: mode_0, assistanceServiceConfigMinionAlias: assistanceServiceConfigMinionAlias, spaceId: spaceId, isThirdPartyPromptConversation: isThirdPartyPromptConversation, thirdPartyPromptCohort: thirdPartyPromptCohort, thirdPartyConnectCount: thirdPartyConnectCount } = propertiesRef.current;
        return {
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).agentCreatorType]: agentCreatorType,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).agentId]: agentId,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).agentVisibility]: agentVisibility,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).conversationChannelId]: conversationChannelId,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).chatEntryPoint]: chatEntryPoint,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).experienceId]: experienceId,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).fullScreen]: fullScreen,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).product]: product,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).productHeader]: productHeader,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).inProductExperience]: inProductExperience,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).singleInstrumentationID]: conversationChannelId,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).agentExternalConfigReference]: agentExternalConfigReference,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).agentActions]: agentActions,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).agentIsDefault]: agentIsDefault,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).agentIsVerified]: agentIsVerified,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).mode]: mode_0,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).assistanceServiceConfigMinionAlias]: assistanceServiceConfigMinionAlias,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).spaceId]: spaceId,
            // Gated on TRUE, not merely defined: the modal stamps `false` on every submit to clear
            // a previous 3P conversation, so a defined-check would let every later conversation
            // carry these keys with two `undefined`s.
            ...isThirdPartyPromptConversation ? {
                [(0, $eMlr8.AI_MATE_ATTRIBUTES).isThirdPartyPromptConversation]: isThirdPartyPromptConversation,
                [(0, $eMlr8.AI_MATE_ATTRIBUTES).thirdPartyPromptCohort]: thirdPartyPromptCohort,
                [(0, $eMlr8.AI_MATE_ATTRIBUTES).thirdPartyConnectCount]: thirdPartyConnectCount
            } : {}
        };
    }, [
        propertiesRef
    ]);
    const trackAIMAUEvent = (0, $cozmU.useCallback)((payload_0)=>{
        // Handle tags
        const tags = [
            ...$0fbd029e2a18e798$var$DEFAULT_TAGS
        ];
        if ($0fbd029e2a18e798$var$isTownSquareEvent()) tags.push('townsquare');
        const { source: sourceUnknown, subjectId: subjectIdUnknown, proactive: proactive, userGenerated: userGenerated, doesNotMeetMAUCriteria: doesNotMeetMAUCriteria, messageId: messageId, messageActions: messageActions, singleInstrumentationID: singleInstrumentationID, deepResearchEnabled: deepResearchEnabled, webSearchEnabled: webSearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, fastModeEnabled: fastModeEnabled, timestamp: timestamp, citedProductList: citedProductList, citedProduct: citedProduct, connectorInfo: connectorInfo, sourceProducts: sourceProducts, sourceProduct: sourceProduct, pluginsInvoked: pluginsInvoked, tools: tools, skillsInvoked: skillsInvoked, executedStratusSkill: executedStratusSkill, responseSources: responseSources, usesJsm: usesJsm, invokedFrom: invokedFrom, conversationChannelId: conversationChannelId_0, assistanceServiceConfigMinionAlias: assistanceServiceConfigMinionAlias_0, scenarioId: scenarioId, pageContext: pageContext, viewContext: viewContext, attributes: customAttributes } = payload_0;
        // source and subjectId are optional in the payload type but trackAI* functions require string.
        // The runtime value (including undefined) is intentionally passed through as-is.
        // eslint-disable-next-line @atlaskit/platform/no-double-type-assertions -- Existing analytics baseline: preserves the runtime value while satisfying a string-only downstream API type.
        const source = sourceUnknown;
        // eslint-disable-next-line @atlaskit/platform/no-double-type-assertions -- Existing analytics baseline: preserves the runtime value while satisfying a string-only downstream API type.
        const subjectId = subjectIdUnknown;
        const customAttributesRecord = customAttributes ?? {};
        const { [(0, $eMlr8.AI_MATE_ATTRIBUTES).rovoJourneyId]: customRovoJourneyId, ...customAttributesWithoutRovoJourneyId } = customAttributesRecord;
        const contextRovoJourneyId = propertiesRef.current.rovoJourneyId;
        let attributes = {
            ...getDefaultAttributes(),
            isAIFeature: 1,
            proactiveAIGenerated: proactive ? 1 : 0,
            userGeneratedAI: userGenerated ? 1 : 0,
            citedProductList: citedProductList,
            citedProduct: citedProduct,
            sourceProducts: sourceProducts,
            sourceProduct: sourceProduct,
            ...customAttributesWithoutRovoJourneyId,
            ...$0fbd029e2a18e798$export$f30c856a07c48ee5(payload_0) && (customRovoJourneyId || contextRovoJourneyId) ? {
                [(0, $eMlr8.AI_MATE_ATTRIBUTES).rovoJourneyId]: customRovoJourneyId ?? contextRovoJourneyId
            } : {},
            aiFeatureName: customAttributesRecord.aiFeatureName || 'aiChat'
        };
        if (messageId) attributes.messageId = messageId;
        if (messageActions) attributes.messageActions = messageActions;
        if (invokedFrom) attributes.invokedFrom = invokedFrom;
        if (timestamp) attributes.timestamp = timestamp;
        if (singleInstrumentationID) attributes.singleInstrumentationID = singleInstrumentationID;
        if (pluginsInvoked) attributes.pluginsInvoked = pluginsInvoked;
        if (tools) attributes.tools = tools;
        if (skillsInvoked) attributes.skillsInvoked = skillsInvoked;
        if (executedStratusSkill !== undefined) attributes.executedStratusSkill = executedStratusSkill;
        if (responseSources) attributes.responseSources = responseSources;
        if (connectorInfo && (payload_0.type === 'actioned' ? (0, $iDrrr.fg)('rovo_chat_connector_info_analytics_on_click') : (0, $iDrrr.fg)('rovo_chat_connector_info_analytics'))) attributes.connectorInfo = connectorInfo;
        if (usesJsm !== undefined) attributes.usesJsm = usesJsm;
        if (deepResearchEnabled) attributes.deepResearchEnabled = deepResearchEnabled;
        if (fastModeEnabled) attributes.fastModeEnabled = fastModeEnabled;
        if (thinkDeeperEnabled) attributes.thinkDeeperEnabled = thinkDeeperEnabled;
        if (webSearchEnabled) attributes.webSearchEnabled = webSearchEnabled;
        if (conversationChannelId_0) attributes.conversationChannelId = conversationChannelId_0;
        if (assistanceServiceConfigMinionAlias_0) attributes.assistanceServiceConfigMinionAlias = assistanceServiceConfigMinionAlias_0;
        if (pageContext) attributes.pageContext = pageContext;
        if (scenarioId) attributes.scenarioId = scenarioId;
        if (viewContext) attributes.viewContext = viewContext;
        let libAttributes = {
            ...attributes,
            aiFeatureName: customAttributesRecord.aiFeatureName || 'aiChat',
            proactiveGeneratedAI: proactive ? 1 : 0
        };
        const launchSource = propertiesRef.current.launchSource;
        const launchSourceAttribute = launchSource ? {
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).launchSource]: launchSource
        } : {};
        switch(payload_0.type){
            case 'initiated':
                trackAIInteractionInit({
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'viewed':
                trackAIResultView({
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId,
                    doesNotMeetMAUCriteria: doesNotMeetMAUCriteria
                });
                break;
            case 'error':
                trackAIResultError({
                    aiErrorMessage: payload_0.errorMessage
                }, {
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'dismissed':
                trackAIInteractionDismiss({
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'actioned':
                {
                    const actionedPayload = payload_0;
                    trackAIResultAction(actionedPayload.actionResult, {
                        attributes: {
                            ...libAttributes,
                            ...launchSourceAttribute
                        },
                        tags: tags,
                        source: source,
                        actionSubjectId: subjectId
                    });
                    break;
                }
            case 'adopted':
                {
                    const adoptedPayload = payload_0;
                    trackAIResultAdopted(adoptedPayload.actionResult, {
                        attributes: {
                            ...libAttributes,
                            actionKey: adoptedPayload.actionKey,
                            rovoModifiedObjects: adoptedPayload.rovoModifiedObjects,
                            ...launchSourceAttribute
                        },
                        tags: tags,
                        source: source,
                        actionSubjectId: subjectId
                    });
                    break;
                }
            case 'feedback':
                {
                    const feedbackPayload = payload_0;
                    trackAIFeedbackSubmit(feedbackPayload.feedbackResult, {
                        attributes: libAttributes,
                        tags: tags,
                        source: source,
                        actionSubjectId: subjectId
                    });
                    break;
                }
        }
    // Handle specific AI MAU events
    }, [
        getDefaultAttributes,
        propertiesRef,
        trackAIInteractionInit,
        trackAIResultView,
        trackAIResultError,
        trackAIInteractionDismiss,
        trackAIResultAction,
        trackAIResultAdopted,
        trackAIFeedbackSubmit
    ]);
    const sendAnalyticsEvent = (0, $cozmU.useCallback)((payload_1, options_0)=>{
        const extraTags = options_0?.removeDefaultTags ? [] : $0fbd029e2a18e798$var$DEFAULT_TAGS;
        const allTags = Array.from(new Set([
            ...extraTags,
            ...'tags' in payload_1 && Array.isArray(payload_1.tags) ? payload_1.tags : [],
            ...maybeAtlasOperationalTags(payload_1)
        ]));
        const defaultAttributes = getDefaultAttributes();
        // `UIAnalyticsEvent | undefined` because in SSR (no `<AnalyticsListener>`),
        // `createAnalyticsEvent` and `event.update(...)` may return `undefined` stubs.
        let eventToBeLoggedWithSentry;
        if ((0, $7TCQz.isUIAnalyticsEvent)(payload_1)) {
            const aiMateContextAttributes_0 = (0, $nl5f2.getAttributesFromContexts)(payload_1.context);
            // `payload.update(...)` can return `undefined` for stub events in SSR / no-listener
            // contexts. Fall back to the original event and guard `.fire` with optional chaining.
            const updatedEvent_0 = payload_1.update({
                ...payload_1.payload,
                tags: allTags,
                attributes: $0fbd029e2a18e798$var$getRovoJourneyEventAttributes({
                    eventPayload: payload_1.payload ?? {},
                    attributes: {
                        ...defaultAttributes,
                        // `payload.payload` is typed as defined on a UIAnalyticsEvent, but during SSR
                        // (and other no-listener contexts) the underlying event can be a stub whose
                        // `payload` is `undefined`. Guard the spread so the subscriber does not throw
                        // `Cannot read properties of undefined (reading 'attributes')`.
                        ...payload_1.payload?.attributes ?? {},
                        ...aiMateContextAttributes_0
                    },
                    contextRovoJourneyId: propertiesRef.current.rovoJourneyId
                })
            }) ?? payload_1;
            updatedEvent_0?.fire?.((0, $1jIs1.ANALYTICS_CHANNEL));
            eventToBeLoggedWithSentry = updatedEvent_0;
        } else {
            const event_0 = createAnalyticsEvent({
                ...payload_1,
                tags: allTags,
                attributes: $0fbd029e2a18e798$var$getRovoJourneyEventAttributes({
                    eventPayload: payload_1,
                    attributes: {
                        ...defaultAttributes,
                        ...payload_1.attributes
                    },
                    contextRovoJourneyId: propertiesRef.current.rovoJourneyId
                })
            });
            if (!event_0) // In SSR / no-listener environments, `createAnalyticsEvent` can return `undefined`.
            // Nothing to fire or log.
            return;
            const aiMateContextAttributes_1 = (0, $nl5f2.getAttributesFromContexts)(event_0.context);
            // `event.update(...)` can return `undefined` for stub events in SSR / no-listener
            // contexts (previously crashed with `Cannot read properties of undefined (reading
            // 'fire')`). Fall back to the original event and guard `.fire` with optional chaining.
            const updatedEvent_1 = event_0.update({
                attributes: $0fbd029e2a18e798$var$getRovoJourneyEventAttributes({
                    eventPayload: event_0.payload ?? payload_1,
                    attributes: {
                        // `event.payload` is normally defined when `createAnalyticsEvent` is wired up
                        // via `<AnalyticsListener>`, but in SSR (where no listener is mounted) the
                        // returned event can be a stub whose `payload` is `undefined`. Spreading
                        // without a guard previously crashed the ExperienceTracker subscriber with
                        // `Cannot read properties of undefined (reading 'attributes')`.
                        ...event_0.payload?.attributes ?? {},
                        ...aiMateContextAttributes_1
                    },
                    contextRovoJourneyId: propertiesRef.current.rovoJourneyId
                })
            }) ?? event_0;
            updatedEvent_1?.fire?.((0, $1jIs1.ANALYTICS_CHANNEL));
            eventToBeLoggedWithSentry = updatedEvent_1;
        }
        if (eventToBeLoggedWithSentry && eventToBeLoggedWithSentry.payload?.eventType !== 'operational') // choosing to log the event with Sentry if it is not an operational event to prevent noise in Sentry and not eat up the Sentry quota
        (0, $hlvTd.addSentryBreadcrumb)((0, $hlvTd.isIsolatedSentryReportingSelected)() ? $0fbd029e2a18e798$var$getSentryAnalyticsBreadcrumb(eventToBeLoggedWithSentry) : `sendAnalyticsEvent event: ${JSON.stringify(eventToBeLoggedWithSentry)}`);
    }, [
        createAnalyticsEvent,
        maybeAtlasOperationalTags,
        getDefaultAttributes,
        propertiesRef
    ]);
    return {
        sendAnalyticsEvent: sendAnalyticsEvent,
        trackAIMAUEvent: trackAIMAUEvent,
        mode: mode
    };
};
module.exports["isRovoJourneyAllowlistedEvent"] = $0fbd029e2a18e798$export$f30c856a07c48ee5;
module.exports["useAnalytics"] = $0fbd029e2a18e798$export$e955abb82869dc84;

});

parcelRegister("7TCQz", function(module, exports) {
/// <reference types="node" />

var $dgpXm = parcelRequire("dgpXm");

const $6cd011fc484d182c$export$35f8383928ba8d7 = (obj)=>obj instanceof (0, $dgpXm.default) || !!obj?._isUIAnalyticsEvent || // Backwards compatibility with older analytics-next packages
    obj?.constructor?.name === 'UIAnalyticsEvent';
module.exports["isUIAnalyticsEvent"] = $6cd011fc484d182c$export$35f8383928ba8d7;

});

parcelRegister("cFVPs", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3U8XR = parcelRequire("3U8XR");


var $iTJtk = parcelRequire("iTJtk");


var $9DHhW = parcelRequire("9DHhW");


var $jU6s6 = parcelRequire("jU6s6");


var $4dW9D = parcelRequire("4dW9D");


var $96Ikf = parcelRequire("96Ikf");


var $iCEWf = parcelRequire("iCEWf");


var $jLdbZ = parcelRequire("jLdbZ");

const $a12da25560425c44$export$ddf49ad062368ad2 = (customConfig)=>{
    let context = (0, $cozmU.useContext)((0, $jU6s6.AIEventsInstrumentationContext));
    const aiEventAttributesOverride = (0, $cozmU.useRef)({});
    if (customConfig) context = {
        config: {
            ...(0, $4dW9D.defaultAIEventsInstrumentationConfigValues),
            ...customConfig
        },
        // eslint-disable-next-line react-hooks/rules-of-hooks
        ...(0, $jLdbZ.useAIInstrumentationSetup)(customConfig.singleInstrumentationID, customConfig.cookieSingleInstrumentationConfig)
    };
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    if (context === null) throw new Error('useAIEventsInstrumentation must be used within a AIEventsInstrumentationProvider');
    const { config: { source: source, aiExperienceName: aiExperienceName, aiFeatureName: aiFeatureName, aiFeatureId: aiFeatureId, proactiveGeneratedAI: proactiveGeneratedAI, userGeneratedAI: userGeneratedAI, isAIFeature: isAIFeature, channel: channel, subproduct: subproduct, actionSubjectId: actionSubjectId, tags: tags, product: product, eventDispatcherSource: eventDispatcherSource, skipAISessionValidation: skipAISessionValidation, customAnalyticsFire: customAnalyticsFire, additionalAttributes: additionalAttributes, useDefaultGASv3EventSchema: useDefaultGASv3EventSchema, enablePlatformEvents: enablePlatformEvents }, refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = context;
    const validateAndUpdateAISession = (0, $cozmU.useCallback)((nextState)=>{
        const currentAISessionState = getAISessionState();
        return (0, $3U8XR.match)({
            currentState: currentAISessionState,
            nextState: nextState,
            skipAISessionValidation: skipAISessionValidation
        }).with({
            skipAISessionValidation: true
        }, ()=>true).with({
            currentState: (0, $iCEWf.AISessionState).unset,
            nextState: (0, $3U8XR.P).union((0, $iCEWf.AISessionState).viewed, (0, $iCEWf.AISessionState).error, (0, $iCEWf.AISessionState).dismissed)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIInteractionInit()`);
            return false;
        }).with({
            currentState: (0, $iCEWf.AISessionState).initiated,
            nextState: (0, $3U8XR.P).union((0, $iCEWf.AISessionState).submitted, (0, $iCEWf.AISessionState).actioned, (0, $iCEWf.AISessionState).adopted, (0, $iCEWf.AISessionState).discarded)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIResultView()`);
            return false;
        }).otherwise(()=>{
            setAISessionState(nextState);
            return true;
        });
    }, [
        setAISessionState,
        getAISessionState,
        skipAISessionValidation
    ]);
    const fireEventWithOptionalChannel = (0, $cozmU.useCallback)((event)=>{
        if (typeof customAnalyticsFire === 'function') {
            customAnalyticsFire(event, createAnalyticsEvent({}));
            return;
        }
        if (enablePlatformEvents) {
            // it goes thru the aiMate analytics listener to avoid validation per prodcut listener
            // https://bitbucket.org/atlassian/atlassian-frontend-mirror/src/f904f690cf57ef84acad6c7bf1b5bd90ad9cada2/analytics/analytics-listeners/src/atlaskit/process-event.ts#lines-58
            createAnalyticsEvent(event).fire((0, $iTJtk.FabricChannel).aiMate);
            return;
        }
        if (channel) {
            createAnalyticsEvent(event).fire(channel);
            return;
        }
        createAnalyticsEvent(event).fire();
    }, [
        channel,
        customAnalyticsFire,
        createAnalyticsEvent,
        enablePlatformEvents
    ]);
    const createAndMergeEventPayload = (0, $cozmU.useCallback)((payload, partialPayload)=>{
        const singleInstrumentationID = getSingleInstrumentationID();
        const eventPayload = {
            action: payload.action,
            actionSubject: payload.actionSubject,
            actionSubjectId: partialPayload?.actionSubjectId ?? actionSubjectId,
            attributes: {
                aiExperienceName: aiExperienceName,
                aiFeatureName: aiFeatureName,
                aiFeatureId: aiFeatureId,
                proactiveGeneratedAI: proactiveGeneratedAI,
                userGeneratedAI: userGeneratedAI,
                isAIFeature: isAIFeature,
                eventDispatcherSource: eventDispatcherSource,
                singleInstrumentationID: singleInstrumentationID,
                ...payload.attributes,
                ...partialPayload?.attributes,
                ...additionalAttributes,
                ...aiEventAttributesOverride.current
            }
        };
        return (0, $3U8XR.match)({
            product: product,
            channel: channel,
            useDefaultGASv3EventSchema: useDefaultGASv3EventSchema,
            enablePlatformEvents: enablePlatformEvents
        }).with({
            enablePlatformEvents: true
        }, ()=>{
            return {
                eventType: 'track',
                ...eventPayload,
                tags: (0, $96Ikf.getTagsWithPlatformTag)(tags),
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        }).with({
            product: 'confluence',
            channel: (0, $3U8XR.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // confluence event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/confluence/next/packages/analytics/src/analyticsListener.tsx#lines-53
            return {
                type: 'sendTrackEvent',
                data: {
                    ...eventPayload,
                    tags: partialPayload?.tags ?? tags,
                    source: partialPayload?.source ?? source,
                    subproduct: subproduct
                }
            };
        }).with({
            product: 'jira',
            channel: (0, $3U8XR.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // jira event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/jira/src/packages/platform/observability/product-analytics-bridge/src/utils/extract-data-from-event.tsx#lines-164
            // it requires to use no more than 4 properties on the top level of event shape for custom event fire.
            return eventPayload;
        }).otherwise(()=>{
            // for any other product type we should use the default event shape
            // also if there is a custom event channel, we also should use the default event shape
            return {
                eventType: 'track',
                ...eventPayload,
                tags: partialPayload?.tags ?? tags,
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        });
    }, [
        subproduct,
        channel,
        product,
        getSingleInstrumentationID,
        useDefaultGASv3EventSchema,
        source,
        tags,
        eventDispatcherSource,
        actionSubjectId,
        additionalAttributes,
        enablePlatformEvents,
        aiExperienceName,
        aiFeatureName,
        aiFeatureId,
        proactiveGeneratedAI,
        userGeneratedAI,
        isAIFeature
    ]);
    const trackAIInteractionInit = (0, $cozmU.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).initiated)) return;
        refreshSingleInstrumentationID(payload?.attributes?.singleInstrumentationID);
        const event = createAndMergeEventPayload({
            action: 'initiated',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        refreshSingleInstrumentationID,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel,
        validateAndUpdateAISession
    ]);
    const trackAIResultView = (0, $cozmU.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).viewed)) return;
        const { doesNotMeetMAUCriteria: doesNotMeetMAUCriteria, attributes: attributes, ...payloadRest } = payload || {};
        const event = createAndMergeEventPayload({
            action: 'viewed',
            actionSubject: 'aiResult'
        }, {
            ...payloadRest,
            attributes: {
                ...attributes,
                doesNotMeetMAUCriteria: !!doesNotMeetMAUCriteria
            }
        });
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultError = (0, $cozmU.useCallback)((error, payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).error)) return;
        const event = createAndMergeEventPayload({
            action: 'error',
            actionSubject: 'aiResult',
            attributes: {
                ...error
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIInteractionDismiss = (0, $cozmU.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).dismissed)) return;
        const event = createAndMergeEventPayload({
            action: 'dismissed',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultAction = (0, $cozmU.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).actioned)) return;
        const event = createAndMergeEventPayload({
            action: 'actioned',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultDiscarded = (0, $cozmU.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).discarded)) return;
        const event = createAndMergeEventPayload({
            action: 'discarded',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultAdopted = (0, $cozmU.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).adopted)) return;
        const event = createAndMergeEventPayload({
            action: 'adopted',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIFeedbackSubmit = (0, $cozmU.useCallback)((aiFeedbackResult, payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).submitted)) return;
        const event = createAndMergeEventPayload({
            action: 'submitted',
            actionSubject: 'aiFeedback',
            attributes: {
                aiFeedbackResult: aiFeedbackResult
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const updateAIAttributes = (0, $cozmU.useCallback)((newAttributes)=>{
        aiEventAttributesOverride.current = {
            ...aiEventAttributesOverride.current,
            ...newAttributes
        };
    }, []);
    const baseReturn = {
        updateAIAttributes: updateAIAttributes,
        trackAIInteractionInit: trackAIInteractionInit,
        trackAIResultView: trackAIResultView,
        trackAIResultError: trackAIResultError,
        trackAIResultDiscarded: trackAIResultDiscarded,
        trackAIInteractionDismiss: trackAIInteractionDismiss,
        trackAIResultAction: trackAIResultAction,
        trackAIResultAdopted: trackAIResultAdopted,
        trackAIFeedbackSubmit: trackAIFeedbackSubmit,
        refreshSingleInstrumentationID: refreshSingleInstrumentationID
    };
    return $a12da25560425c44$var$useStableMethods(baseReturn);
};
/**
 * Returns an object with the same shape as `methods`, but with every method
 * replaced by a stable wrapper that delegates to the latest version. The
 * wrappers are created once on mount; they always read the freshest closure
 * via a ref, so calls observe the same behaviour as calling the unstable
 * methods directly.
 */ function $a12da25560425c44$var$useStableMethods(methods) {
    const ref = (0, $cozmU.useRef)(methods);
    ref.current = methods;
    return (0, $cozmU.useMemo)(()=>{
        const out = {};
        for (const key of Object.keys(ref.current))out[key] = (...args)=>ref.current[key](...args);
        return out;
    // Wrappers always read from `ref.current`; no deps needed.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
module.exports["useAIEventsInstrumentation"] = $a12da25560425c44$export$ddf49ad062368ad2;

});

parcelRegister("3U8XR", function(module, exports) {
const $2d7d8e3cc345803e$var$t = Symbol.for("@ts-pattern/matcher"), $2d7d8e3cc345803e$var$e = Symbol.for("@ts-pattern/isVariadic"), $2d7d8e3cc345803e$var$n = "@ts-pattern/anonymous-select-key", $2d7d8e3cc345803e$var$r = (t)=>Boolean(t && "object" == typeof t), $2d7d8e3cc345803e$var$i = (e)=>e && !!e[$2d7d8e3cc345803e$var$t], $2d7d8e3cc345803e$var$o = (n, s, c)=>{
    if ($2d7d8e3cc345803e$var$i(n)) {
        const e = n[$2d7d8e3cc345803e$var$t](), { matched: r, selections: i } = e.match(s);
        return r && i && Object.keys(i).forEach((t)=>c(t, i[t])), r;
    }
    if ($2d7d8e3cc345803e$var$r(n)) {
        if (!$2d7d8e3cc345803e$var$r(s)) return !1;
        if (Array.isArray(n)) {
            if (!Array.isArray(s)) return !1;
            let t = [], r = [], a = [];
            for (const o of n.keys()){
                const s = n[o];
                $2d7d8e3cc345803e$var$i(s) && s[$2d7d8e3cc345803e$var$e] ? a.push(s) : a.length ? r.push(s) : t.push(s);
            }
            if (a.length) {
                if (a.length > 1) throw new Error("Pattern error: Using `...P.array(...)` several times in a single pattern is not allowed.");
                if (s.length < t.length + r.length) return !1;
                const e = s.slice(0, t.length), n = 0 === r.length ? [] : s.slice(-r.length), i = s.slice(t.length, 0 === r.length ? Infinity : -r.length);
                return t.every((t, n)=>$2d7d8e3cc345803e$var$o(t, e[n], c)) && r.every((t, e)=>$2d7d8e3cc345803e$var$o(t, n[e], c)) && (0 === a.length || $2d7d8e3cc345803e$var$o(a[0], i, c));
            }
            return n.length === s.length && n.every((t, e)=>$2d7d8e3cc345803e$var$o(t, s[e], c));
        }
        return Reflect.ownKeys(n).every((e)=>{
            const r = n[e];
            var a;
            return (e in s || $2d7d8e3cc345803e$var$i(a = r) && "optional" === a[$2d7d8e3cc345803e$var$t]().matcherType) && $2d7d8e3cc345803e$var$o(r, s[e], c);
        });
    }
    return Object.is(s, n);
}, $2d7d8e3cc345803e$var$s = (e)=>{
    var n, o, a;
    return $2d7d8e3cc345803e$var$r(e) ? $2d7d8e3cc345803e$var$i(e) ? null != (n = null == (o = (a = e[$2d7d8e3cc345803e$var$t]()).getSelectionKeys) ? void 0 : o.call(a)) ? n : [] : Array.isArray(e) ? $2d7d8e3cc345803e$var$c(e, $2d7d8e3cc345803e$var$s) : $2d7d8e3cc345803e$var$c(Object.values(e), $2d7d8e3cc345803e$var$s) : [];
}, $2d7d8e3cc345803e$var$c = (t, e)=>t.reduce((t, n)=>t.concat(e(n)), []);
function $2d7d8e3cc345803e$export$ce1e7a33533a73d9(...t) {
    if (1 === t.length) {
        const [e] = t;
        return (t)=>$2d7d8e3cc345803e$var$o(e, t, ()=>{});
    }
    if (2 === t.length) {
        const [e, n] = t;
        return $2d7d8e3cc345803e$var$o(e, n, ()=>{});
    }
    throw new Error(`isMatching wasn't given the right number of arguments: expected 1 or 2, received ${t.length}.`);
}
function $2d7d8e3cc345803e$var$u(t) {
    return Object.assign(t, {
        optional: ()=>$2d7d8e3cc345803e$var$l(t),
        and: (e)=>$2d7d8e3cc345803e$var$m(t, e),
        or: (e)=>$2d7d8e3cc345803e$var$d(t, e),
        select: (e)=>void 0 === e ? $2d7d8e3cc345803e$var$y(t) : $2d7d8e3cc345803e$var$y(e, t)
    });
}
function $2d7d8e3cc345803e$var$h(t) {
    return Object.assign(((t)=>Object.assign(t, {
            [Symbol.iterator] () {
                let n = 0;
                const r = [
                    {
                        value: Object.assign(t, {
                            [$2d7d8e3cc345803e$var$e]: !0
                        }),
                        done: !1
                    },
                    {
                        done: !0,
                        value: void 0
                    }
                ];
                return {
                    next: ()=>{
                        var t;
                        return null != (t = r[n++]) ? t : r.at(-1);
                    }
                };
            }
        }))(t), {
        optional: ()=>$2d7d8e3cc345803e$var$h($2d7d8e3cc345803e$var$l(t)),
        select: (e)=>$2d7d8e3cc345803e$var$h(void 0 === e ? $2d7d8e3cc345803e$var$y(t) : $2d7d8e3cc345803e$var$y(e, t))
    });
}
function $2d7d8e3cc345803e$var$l(e) {
    return $2d7d8e3cc345803e$var$u({
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return void 0 === t ? ($2d7d8e3cc345803e$var$s(e).forEach((t)=>r(t, void 0)), {
                        matched: !0,
                        selections: n
                    }) : {
                        matched: $2d7d8e3cc345803e$var$o(e, t, r),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$2d7d8e3cc345803e$var$s(e),
                matcherType: "optional"
            })
    });
}
const $2d7d8e3cc345803e$var$f = (t, e)=>{
    for (const n of t)if (!e(n)) return !1;
    return !0;
}, $2d7d8e3cc345803e$var$g = (t, e)=>{
    for (const [n, r] of t.entries())if (!e(r, n)) return !1;
    return !0;
};
function $2d7d8e3cc345803e$var$m(...e) {
    return $2d7d8e3cc345803e$var$u({
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return {
                        matched: e.every((e)=>$2d7d8e3cc345803e$var$o(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$2d7d8e3cc345803e$var$c(e, $2d7d8e3cc345803e$var$s),
                matcherType: "and"
            })
    });
}
function $2d7d8e3cc345803e$var$d(...e) {
    return $2d7d8e3cc345803e$var$u({
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return $2d7d8e3cc345803e$var$c(e, $2d7d8e3cc345803e$var$s).forEach((t)=>r(t, void 0)), {
                        matched: e.some((e)=>$2d7d8e3cc345803e$var$o(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$2d7d8e3cc345803e$var$c(e, $2d7d8e3cc345803e$var$s),
                matcherType: "or"
            })
    });
}
function $2d7d8e3cc345803e$var$p(e) {
    return {
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>({
                        matched: Boolean(e(t))
                    })
            })
    };
}
function $2d7d8e3cc345803e$var$y(...e) {
    const r = "string" == typeof e[0] ? e[0] : void 0, i = 2 === e.length ? e[1] : "string" == typeof e[0] ? void 0 : e[0];
    return $2d7d8e3cc345803e$var$u({
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>{
                    let e = {
                        [null != r ? r : $2d7d8e3cc345803e$var$n]: t
                    };
                    return {
                        matched: void 0 === i || $2d7d8e3cc345803e$var$o(i, t, (t, n)=>{
                            e[t] = n;
                        }),
                        selections: e
                    };
                },
                getSelectionKeys: ()=>[
                        null != r ? r : $2d7d8e3cc345803e$var$n
                    ].concat(void 0 === i ? [] : $2d7d8e3cc345803e$var$s(i))
            })
    });
}
function $2d7d8e3cc345803e$var$v(t) {
    return "number" == typeof t;
}
function $2d7d8e3cc345803e$var$b(t) {
    return "string" == typeof t;
}
function $2d7d8e3cc345803e$var$w(t) {
    return "bigint" == typeof t;
}
const $2d7d8e3cc345803e$var$S = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return !0;
})), $2d7d8e3cc345803e$var$O = $2d7d8e3cc345803e$var$S, $2d7d8e3cc345803e$var$j = (t)=>Object.assign($2d7d8e3cc345803e$var$u(t), {
        startsWith: (e)=>{
            var n;
            return $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, (n = e, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$b(t) && t.startsWith(n)))));
        },
        endsWith: (e)=>{
            var n;
            return $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, (n = e, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$b(t) && t.endsWith(n)))));
        },
        minLength: (e)=>$2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$b(e) && e.length >= t))(e))),
        length: (e)=>$2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$b(e) && e.length === t))(e))),
        maxLength: (e)=>$2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$b(e) && e.length <= t))(e))),
        includes: (e)=>{
            var n;
            return $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, (n = e, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$b(t) && t.includes(n)))));
        },
        regex: (e)=>{
            var n;
            return $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, (n = e, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$b(t) && Boolean(t.match(n))))));
        }
    }), $2d7d8e3cc345803e$var$K = $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$p($2d7d8e3cc345803e$var$b)), $2d7d8e3cc345803e$var$x = (t)=>Object.assign($2d7d8e3cc345803e$var$u(t), {
        between: (e, n)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t, e)=>$2d7d8e3cc345803e$var$p((n)=>$2d7d8e3cc345803e$var$v(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$v(e) && e < t))(e))),
        gt: (e)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$v(e) && e > t))(e))),
        lte: (e)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$v(e) && e <= t))(e))),
        gte: (e)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$v(e) && e >= t))(e))),
        int: ()=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$v(t) && Number.isInteger(t)))),
        finite: ()=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$v(t) && Number.isFinite(t)))),
        positive: ()=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$v(t) && t > 0))),
        negative: ()=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$v(t) && t < 0)))
    }), $2d7d8e3cc345803e$var$E = $2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$p($2d7d8e3cc345803e$var$v)), $2d7d8e3cc345803e$var$A = (t)=>Object.assign($2d7d8e3cc345803e$var$u(t), {
        between: (e, n)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t, e)=>$2d7d8e3cc345803e$var$p((n)=>$2d7d8e3cc345803e$var$w(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$w(e) && e < t))(e))),
        gt: (e)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$w(e) && e > t))(e))),
        lte: (e)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$w(e) && e <= t))(e))),
        gte: (e)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$w(e) && e >= t))(e))),
        positive: ()=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$w(t) && t > 0))),
        negative: ()=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$w(t) && t < 0)))
    }), $2d7d8e3cc345803e$var$P = $2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$p($2d7d8e3cc345803e$var$w)), $2d7d8e3cc345803e$var$T = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return "boolean" == typeof t;
})), $2d7d8e3cc345803e$var$B = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return "symbol" == typeof t;
})), $2d7d8e3cc345803e$var$_ = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return null == t;
})), $2d7d8e3cc345803e$var$k = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return null != t;
}));
var $2d7d8e3cc345803e$export$56c0d5a1e737357d = {
    __proto__: null,
    matcher: $2d7d8e3cc345803e$var$t,
    optional: $2d7d8e3cc345803e$var$l,
    array: function(...e) {
        return $2d7d8e3cc345803e$var$h({
            [$2d7d8e3cc345803e$var$t]: ()=>({
                    match: (t)=>{
                        if (!Array.isArray(t)) return {
                            matched: !1
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const n = e[0];
                        let r = {};
                        if (0 === t.length) return $2d7d8e3cc345803e$var$s(n).forEach((t)=>{
                            r[t] = [];
                        }), {
                            matched: !0,
                            selections: r
                        };
                        const i = (t, e)=>{
                            r[t] = (r[t] || []).concat([
                                e
                            ]);
                        };
                        return {
                            matched: t.every((t)=>$2d7d8e3cc345803e$var$o(n, t, i)),
                            selections: r
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $2d7d8e3cc345803e$var$s(e[0])
                })
        });
    },
    set: function(...e) {
        return $2d7d8e3cc345803e$var$u({
            [$2d7d8e3cc345803e$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Set)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        }, i = e[0];
                        return {
                            matched: $2d7d8e3cc345803e$var$f(t, (t)=>$2d7d8e3cc345803e$var$o(i, t, r)),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $2d7d8e3cc345803e$var$s(e[0])
                })
        });
    },
    map: function(...e) {
        return $2d7d8e3cc345803e$var$u({
            [$2d7d8e3cc345803e$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Map)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        var i;
                        if (1 === e.length) throw new Error(`\`P.map\` wasn't given enough arguments. Expected (key, value), received ${null == (i = e[0]) ? void 0 : i.toString()}`);
                        const [s, c] = e;
                        return {
                            matched: $2d7d8e3cc345803e$var$g(t, (t, e)=>{
                                const n = $2d7d8e3cc345803e$var$o(s, e, r), i = $2d7d8e3cc345803e$var$o(c, t, r);
                                return n && i;
                            }),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : [
                            ...$2d7d8e3cc345803e$var$s(e[0]),
                            ...$2d7d8e3cc345803e$var$s(e[1])
                        ]
                })
        });
    },
    intersection: $2d7d8e3cc345803e$var$m,
    union: $2d7d8e3cc345803e$var$d,
    not: function(e) {
        return $2d7d8e3cc345803e$var$u({
            [$2d7d8e3cc345803e$var$t]: ()=>({
                    match: (t)=>({
                            matched: !$2d7d8e3cc345803e$var$o(e, t, ()=>{})
                        }),
                    getSelectionKeys: ()=>[],
                    matcherType: "not"
                })
        });
    },
    when: $2d7d8e3cc345803e$var$p,
    select: $2d7d8e3cc345803e$var$y,
    any: $2d7d8e3cc345803e$var$S,
    _: $2d7d8e3cc345803e$var$O,
    string: $2d7d8e3cc345803e$var$K,
    number: $2d7d8e3cc345803e$var$E,
    bigint: $2d7d8e3cc345803e$var$P,
    boolean: $2d7d8e3cc345803e$var$T,
    symbol: $2d7d8e3cc345803e$var$B,
    nullish: $2d7d8e3cc345803e$var$_,
    nonNullable: $2d7d8e3cc345803e$var$k,
    instanceOf: function(t) {
        return $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
            return (e)=>e instanceof t;
        }(t)));
    },
    shape: function(t) {
        return $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p($2d7d8e3cc345803e$export$ce1e7a33533a73d9(t)));
    }
};
class $2d7d8e3cc345803e$export$6c1467edb54d3773 extends Error {
    constructor(t){
        let e;
        try {
            e = JSON.stringify(t);
        } catch (n) {
            e = t;
        }
        super(`Pattern matching error: no pattern matches value ${e}`), this.input = void 0, this.input = t;
    }
}
const $2d7d8e3cc345803e$var$$ = {
    matched: !1,
    value: void 0
};
function $2d7d8e3cc345803e$export$4659b591c19bdf3d(t) {
    return new $2d7d8e3cc345803e$var$I(t, $2d7d8e3cc345803e$var$$);
}
class $2d7d8e3cc345803e$var$I {
    with(...t) {
        if (this.state.matched) return this;
        const e = t[t.length - 1], r = [
            t[0]
        ];
        let i;
        3 === t.length && "function" == typeof t[1] ? i = t[1] : t.length > 2 && r.push(...t.slice(1, t.length - 1));
        let s = !1, c = {};
        const a = (t, e)=>{
            s = !0, c[t] = e;
        }, u = !r.some((t)=>$2d7d8e3cc345803e$var$o(t, this.input, a)) || i && !Boolean(i(this.input)) ? $2d7d8e3cc345803e$var$$ : {
            matched: !0,
            value: e(s ? $2d7d8e3cc345803e$var$n in c ? c[$2d7d8e3cc345803e$var$n] : c : this.input, this.input)
        };
        return new $2d7d8e3cc345803e$var$I(this.input, u);
    }
    when(t, e) {
        if (this.state.matched) return this;
        const n = Boolean(t(this.input));
        return new $2d7d8e3cc345803e$var$I(this.input, n ? {
            matched: !0,
            value: e(this.input, this.input)
        } : $2d7d8e3cc345803e$var$$);
    }
    otherwise(t) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    exhaustive(t = $2d7d8e3cc345803e$var$L) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    run() {
        return this.exhaustive();
    }
    returnType() {
        return this;
    }
    narrow() {
        return this;
    }
    constructor(t, e){
        this.input = void 0, this.state = void 0, this.input = t, this.state = e;
    }
}
function $2d7d8e3cc345803e$var$L(t) {
    throw new $2d7d8e3cc345803e$export$6c1467edb54d3773(t);
}
module.exports["P"] = $2d7d8e3cc345803e$export$56c0d5a1e737357d;
module.exports["match"] = $2d7d8e3cc345803e$export$4659b591c19bdf3d;

});

parcelRegister("jU6s6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $1f90c1a79bae927c$export$4f059feb37b5835e = (0, $cozmU.createContext)(null);
module.exports["AIEventsInstrumentationContext"] = $1f90c1a79bae927c$export$4f059feb37b5835e;

});

parcelRegister("4dW9D", function(module, exports) {

var $iCEWf = parcelRequire("iCEWf");

const $7545c0c100898f47$export$5013b36eeed4ec19 = {
    isAIFeature: 1,
    actionSubjectId: 'client',
    eventDispatcherSource: (0, $iCEWf.EventDispatcherSources).JSLib,
    skipAISessionValidation: false,
    useDefaultGASv3EventSchema: false,
    enablePlatformEvents: false
};
module.exports["defaultAIEventsInstrumentationConfigValues"] = $7545c0c100898f47$export$5013b36eeed4ec19;

});

parcelRegister("iCEWf", function(module, exports) {
var $d6416e2c87d11da8$export$af92e0e920a45719 = /*#__PURE__*/ function(AISessionState) {
    AISessionState["unset"] = "[AIInteraction]:UNSET";
    AISessionState["initiated"] = "[AIInteraction]:INITIATED";
    AISessionState["viewed"] = "[AIInteraction]:VIEWED";
    AISessionState["error"] = "[AIInteraction]:ERROR";
    AISessionState["dismissed"] = "[AIInteraction]:DISMISSED";
    AISessionState["actioned"] = "[AIInteraction]:ACTIONED";
    AISessionState["adopted"] = "[AIInteraction]:ADOPTED";
    AISessionState["discarded"] = "[AIInteraction]:DISCARDED";
    AISessionState["submitted"] = "[AIInteraction]:SUBMITTED";
    return AISessionState;
}({});
var $d6416e2c87d11da8$export$7052d5b66e36f60f = /*#__PURE__*/ function(EventDispatcherSources) {
    EventDispatcherSources["JSLib"] = "name:@atlassian/ai-analytics|language:javascript";
    return EventDispatcherSources;
}({});
module.exports["AISessionState"] = $d6416e2c87d11da8$export$af92e0e920a45719;
module.exports["EventDispatcherSources"] = $d6416e2c87d11da8$export$7052d5b66e36f60f;

});

parcelRegister("96Ikf", function(module, exports) {
const $3836d38b50a38c42$export$e053e424fcbfebe9 = (tags)=>{
    const defaultTags = [
        'atlaskit'
    ];
    if (!tags) return defaultTags;
    return defaultTags.concat(tags);
};
module.exports["getTagsWithPlatformTag"] = $3836d38b50a38c42$export$e053e424fcbfebe9;

});

parcelRegister("jLdbZ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1r1cI = parcelRequire("1r1cI");


var $7mJer = parcelRequire("7mJer");


var $iCEWf = parcelRequire("iCEWf");

const $e5d5cfe1f6d4c858$export$259576f4e7ac6488 = (customSingleInstrumentationIDFromUserConfig, cookieSingleInstrumentationConfig)=>{
    const singleInstrumentationIDRef = (0, $cozmU.useRef)(undefined);
    const aiSessionStateRef = (0, $cozmU.useRef)((0, $iCEWf.AISessionState).unset);
    const setAISessionState = (0, $cozmU.useCallback)((nextState)=>{
        aiSessionStateRef.current = nextState;
    }, []);
    const getAISessionState = (0, $cozmU.useCallback)(()=>{
        return aiSessionStateRef.current;
    }, []);
    const refreshSingleInstrumentationID = (0, $cozmU.useCallback)((customSingleInstrumentationIDFromEvent)=>{
        const nextSingleInstrumentationID = (0, $1r1cI.getNewSingleInstrumentationID)(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig);
        singleInstrumentationIDRef.current = nextSingleInstrumentationID;
        if (cookieSingleInstrumentationConfig) (0, $7mJer.setSingleInstrumentationIDCookie)(cookieSingleInstrumentationConfig.uniqueCookieFeatureName, nextSingleInstrumentationID);
    }, [
        customSingleInstrumentationIDFromUserConfig,
        cookieSingleInstrumentationConfig
    ]);
    const getSingleInstrumentationID = (0, $cozmU.useCallback)(()=>{
        // this handles a race condition when we have a new singleInstrumentationID from the user config
        // but Provider knows only about the initial singleInstrumentationID. In this case we need to update
        // singleInstrumentationID at first step and then return a new one.
        if (customSingleInstrumentationIDFromUserConfig && customSingleInstrumentationIDFromUserConfig !== singleInstrumentationIDRef.current) {
            refreshSingleInstrumentationID();
            return singleInstrumentationIDRef.current;
        }
        if (cookieSingleInstrumentationConfig) return (0, $7mJer.readSingleInstrumentationIDCookie)(cookieSingleInstrumentationConfig.uniqueCookieFeatureName);
        return singleInstrumentationIDRef.current;
    }, [
        customSingleInstrumentationIDFromUserConfig,
        cookieSingleInstrumentationConfig,
        refreshSingleInstrumentationID
    ]);
    return {
        refreshSingleInstrumentationID: refreshSingleInstrumentationID,
        getSingleInstrumentationID: getSingleInstrumentationID,
        setAISessionState: setAISessionState,
        getAISessionState: getAISessionState
    };
};
module.exports["useAIInstrumentationSetup"] = $e5d5cfe1f6d4c858$export$259576f4e7ac6488;

});

parcelRegister("1r1cI", function(module, exports) {

var $3U8XR = parcelRequire("3U8XR");


var $03RpJ = parcelRequire("03RpJ");

function $d83e4e74e28b2b37$export$cee2a1482be61648(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig) {
    // priority for setting singleInstrumentationID override rule
    // 1. from consumer event attribute
    // 2. from consumer configuration
    // 3. from cookie lib
    // 4. default behaviour generates through the crypto API
    return (0, $3U8XR.match)({
        customSingleInstrumentationIDFromEvent: customSingleInstrumentationIDFromEvent,
        customSingleInstrumentationIDFromUserConfig: customSingleInstrumentationIDFromUserConfig
    }).with({
        customSingleInstrumentationIDFromEvent: (0, $3U8XR.P).string
    }, (result)=>result.customSingleInstrumentationIDFromEvent).with({
        customSingleInstrumentationIDFromUserConfig: (0, $3U8XR.P).string
    }, (result)=>result.customSingleInstrumentationIDFromUserConfig)// we can't use the crypto API in the browser due to SSR issues?
    // https://atlassian.slack.com/archives/C051ARA9QGH/p1749587419868869
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    .otherwise(()=>(0, $03RpJ.default)());
}
module.exports["getNewSingleInstrumentationID"] = $d83e4e74e28b2b37$export$cee2a1482be61648;

});

parcelRegister("7mJer", function(module, exports) {

var $1Qi0Q = parcelRequire("1Qi0Q");

var $lnexi = parcelRequire("lnexi");

const $0ca840bf5f9ee98d$export$72d8c154d3f75075 = 'SINGLE_INSTRUMENTATION_ID_IS_NOT_SET';
const $0ca840bf5f9ee98d$export$35ae1861d13fb6c8 = (uniqueCookieFeatureName)=>`AI_INSTRUMENTATION_FEATURE_ID_${uniqueCookieFeatureName}`;
const $0ca840bf5f9ee98d$export$9a4eaf99327c19fe = (uniqueCookieFeatureName, nextSingleInstrumentationID)=>(0, $lnexi.setCookie)($0ca840bf5f9ee98d$export$35ae1861d13fb6c8(uniqueCookieFeatureName), nextSingleInstrumentationID, {
        expires: 7,
        domain: location.hostname,
        sameSite: 'strict'
    });
const $0ca840bf5f9ee98d$export$d6fb1caea334c7c7 = (uniqueCookieFeatureName)=>(0, $1Qi0Q.getCookie)($0ca840bf5f9ee98d$export$35ae1861d13fb6c8(uniqueCookieFeatureName)) || $0ca840bf5f9ee98d$export$72d8c154d3f75075;
module.exports["setSingleInstrumentationIDCookie"] = $0ca840bf5f9ee98d$export$9a4eaf99327c19fe;
module.exports["readSingleInstrumentationIDCookie"] = $0ca840bf5f9ee98d$export$d6fb1caea334c7c7;

});

parcelRegister("eMlr8", function(module, exports) {
/**
 * NOTE: Some of these fields are used to track AI MAU
 * See this page for more details: https://hello.atlassian.net/wiki/spaces/AAI/pages/3770721410/Unified+event+Instrumentation+for+AI
 */ const $49f89fe5a40ece12$export$8cffc8b2c93affd4 = {
    agentCreatorType: 'agentCreatorType',
    agentId: 'agentId',
    agentVisibility: 'agentVisibility',
    agentExternalConfigReference: 'agentExternalConfigReference',
    agentActions: 'agentActions',
    agentIsDefault: 'agentIsDefault',
    agentIsVerified: 'agentIsVerified',
    conversationChannelId: 'conversationChannelId',
    chatEntryPoint: 'chatEntryPoint',
    experienceId: 'experienceId',
    fullScreen: 'fullScreen',
    mode: 'mode',
    product: 'product',
    productHeader: 'productHeader',
    inProductExperience: 'inProductExperience',
    singleInstrumentationID: 'singleInstrumentationID',
    sharedFeaturesInstrumentationId: 'sharedFeaturesInstrumentationId',
    assistanceServiceConfigMinionAlias: 'assistanceServiceConfigMinionAlias',
    skillSelectionSource: 'skillSelectionSource',
    // The Rovo Space a chat is scoped to (when any). Set on every event fired
    // while a space-scoped chat is active so "Space MAU" (unique users who
    // initiate a chat in a space) can be measured downstream.
    spaceId: 'spaceId',
    // Source surface that launched the conversation; emitted on result events only.
    // Runtime-validated against the launch-source allowlists at the pubsub boundary, so
    // only closed-vocabulary values ever reach analytics despite FollowUpSource's
    // `| string` fallback.
    launchSource: 'launchSource',
    // Quick Find-to-Chat journey correlation. Emitted only on the five funnel events
    // allowlisted by the analytics controller while the attributed conversation is active.
    rovoJourneyId: 'rovoJourneyId',
    // Set once a conversation is started from a third-party suggested prompt in the
    // Create-with-Rovo modal, so downstream events the 3P experiment does not own
    // (`message/sent`, `adopted/contentFinalized`) can be segmented by cohort.
    isThirdPartyPromptConversation: 'isThirdPartyPromptConversation',
    thirdPartyPromptCohort: 'thirdPartyPromptCohort',
    // Third-party apps connected from the in-thread connect prompt so far in this
    // conversation, so a later message can be read as post-connect without a join.
    thirdPartyConnectCount: 'thirdPartyConnectCount'
};
module.exports["AI_MATE_ATTRIBUTES"] = $49f89fe5a40ece12$export$8cffc8b2c93affd4;

});

parcelRegister("1jIs1", function(module, exports) {

var $iTJtk = parcelRequire("iTJtk");

const $70c81957c9ee94b4$export$85183a312807388d = (0, $iTJtk.FabricChannel).aiMate;
const $70c81957c9ee94b4$var$REMIX_SOURCES = [
    'remix',
    'inlineRovoFromRemix',
    'remixModalFromToolbar',
    'remixModalFromBlockControls',
    'remixModalFromBlockMenu',
    'remixModalFromFloatingToolbar',
    'remixModalFromViewPageFloatingToolbar',
    'remixModalFromViewPageNudge',
    'remixModalFromNudge',
    'remixModalFromObjectLevelSidebar',
    'remixModalFromPasteMenu',
    'remixStagingArea',
    'remixModalFromMediaInserts'
];
const $70c81957c9ee94b4$export$e86f3aae41de8a7 = 'smartLinkRovoButton';
const $70c81957c9ee94b4$export$5a1bc70923e441e9 = new Set($70c81957c9ee94b4$var$REMIX_SOURCES);
const $70c81957c9ee94b4$export$c576fc434c88316f = new Set([
    'automation-discovery-meeting-notes-nudge',
    'automation-discovery-archive-page-nudge',
    'automation-discovery-status-updates-nudge',
    'automation-discovery-keep-up-to-date-dropdown-action',
    'automation-discovery-custom-prompt-dropdown-action',
    'jiraListChildCreateRovo',
    'jiraTimelineChildCreateRovo',
    'jsmSurveyAggregatedInsights',
    'recommendation-card-nudge'
]);
const $70c81957c9ee94b4$export$c377c6e02c795ae4 = new Set([
    'jiraAddViewCreateWithRovo'
]);
const $70c81957c9ee94b4$export$f57fd972b3024068 = (value, includeGatedLaunchSources = false)=>value !== undefined && ($70c81957c9ee94b4$export$c576fc434c88316f.has(value) || includeGatedLaunchSources && $70c81957c9ee94b4$export$c377c6e02c795ae4.has(value));
var $70c81957c9ee94b4$export$406073150b1a408 = /*#__PURE__*/ function(AUTOSUGGEST_SOURCE) {
    AUTOSUGGEST_SOURCE["ROVO_CHAT"] = "rovo-chat";
    AUTOSUGGEST_SOURCE["CONFLUENCE_AIFC"] = "confluence-aifc";
    AUTOSUGGEST_SOURCE["CONFLUENCE_AIFC_SLIDES"] = "confluence-aifc-slides";
    AUTOSUGGEST_SOURCE["CONFLUENCE_AIFC_WHITEBOARD"] = "confluence-aifc-whiteboard";
    AUTOSUGGEST_SOURCE["CONFLUENCE_AIFC_DATABASE"] = "confluence-aifc-database";
    AUTOSUGGEST_SOURCE["CONFLUENCE_AIFC_LIVE_DOC"] = "confluence-aifc-live-doc";
    return AUTOSUGGEST_SOURCE;
}({});
const $70c81957c9ee94b4$export$f3c4b70a2cbe1eb3 = 'thirdPartyConnectPrompt';
module.exports["ANALYTICS_CHANNEL"] = $70c81957c9ee94b4$export$85183a312807388d;
module.exports["SMART_LINK_ROVO_BUTTON_INTERACTION_SOURCE"] = $70c81957c9ee94b4$export$e86f3aae41de8a7;
module.exports["REMIX_INTERACTION_SOURCES"] = $70c81957c9ee94b4$export$5a1bc70923e441e9;
module.exports["isAllowedLaunchSource"] = $70c81957c9ee94b4$export$f57fd972b3024068;
module.exports["AUTOSUGGEST_SOURCE"] = $70c81957c9ee94b4$export$406073150b1a408;
module.exports["THIRD_PARTY_CONNECT_PROMPT_SUBJECT"] = $70c81957c9ee94b4$export$f3c4b70a2cbe1eb3;

});

parcelRegister("nl5f2", function(module, exports) {

var $1Pvvv = parcelRequire("1Pvvv");


var $5oT0d = parcelRequire("5oT0d");

const $0e75beeba4a8395f$var$isSourceAndAttributes = (x)=>{
    if (typeof x !== 'object' || x === null) return false;
    if (!('source' in x) || !('attributes' in x) || typeof x.attributes !== 'object' || x.attributes === null) return false;
    return (0, $5oT0d.ALLOWED_AI_MATE_SOURCES).includes(x.source);
};
const $0e75beeba4a8395f$export$d97c97ed77ff09e8 = (context)=>{
    if (!context || !Array.isArray(context)) return {};
    let contextsThatHaveAttributes = context.filter((x)=>$0e75beeba4a8395f$var$isSourceAndAttributes(x) || x[0, $1Pvvv.AI_MATE_CONTEXT]);
    return contextsThatHaveAttributes.reduce((acc, x)=>{
        return {
            ...acc,
            ...x[0, $1Pvvv.AI_MATE_CONTEXT]?.attributes ?? {},
            ...x.attributes ?? {}
        };
    }, {});
};
module.exports["getAttributesFromContexts"] = $0e75beeba4a8395f$export$d97c97ed77ff09e8;

});

parcelRegister("5oT0d", function(module, exports) {
const $19fd3c58da81b4e5$export$e31e24b63b7085fd = [
    'AIMate',
    'smart-create',
    'CSMAI',
    'CSMAIEmbed',
    'rovoServiceAgent',
    'solutionComposer'
];
module.exports["ALLOWED_AI_MATE_SOURCES"] = $19fd3c58da81b4e5$export$e31e24b63b7085fd;

});

parcelRegister("1XM8n", function(module, exports) {
/**
 * Determines the owning team for a failure event based on the experience task name,
 * error message, and optional attributes (e.g. actionKey).
 *
 * The rules are derived from the AIFC Top Baseline Errors report and use regex matching
 * to handle error messages that contain dynamic values (UUIDs, IDs, hashes, etc).
 *
 * @see https://hello.atlassian.net/wiki/spaces/ac8/pages/6822974693/Apr+13-14+2026+-+AIFC+Top+Baseline+Errors
 */ 
var $irnO2 = parcelRequire("irnO2");

var $8fc2212d0df9a0a6$export$e196c5257e9c94dd = /*#__PURE__*/ function(OwningTeam) {
    OwningTeam["AifcFoundations"] = "AIFC Foundations";
    OwningTeam["EditorAi"] = "Editor AI";
    OwningTeam["RovoChat"] = "Rovo Chat";
    OwningTeam["Whiteboards"] = "Whiteboards";
    OwningTeam["Databases"] = "Databases";
    OwningTeam["JiraAifc"] = "Jira AIFC";
    OwningTeam["Pulsar"] = "Pulsar";
    return OwningTeam;
}({});
/**
 * Step 1 — Experience-specific error rules.
 * These are checked first and only when the experience name matches.
 */ const $8fc2212d0df9a0a6$var$RULES_FOR_SPECIFIC_EXPERIENCES = [
    {
        pattern: /Something went wrong on Rovo's end. Please try sending your message again./i,
        team: "AIFC Foundations",
        experiences: [
            (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT
        ]
    },
    {
        pattern: /The ConfluenceCreationTool was invoked, but valid content was not created for action key:.*whiteboard/i,
        team: "Whiteboards",
        experiences: [
            (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT
        ]
    },
    {
        pattern: /The ConfluenceCreationTool was invoked, but valid content was not created for action key:.*database/i,
        team: "Databases",
        experiences: [
            (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT
        ]
    },
    {
        pattern: /The ConfluenceCreationTool was invoked, but valid content was not created for action key:.*page/i,
        team: "AIFC Foundations",
        experiences: [
            (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT
        ]
    },
    {
        pattern: /The orchestrator reached its depth limit and the ConfluenceCreationTool was not invoked./i,
        team: "AIFC Foundations",
        experiences: [
            (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT
        ]
    },
    {
        pattern: /Could not create content of type \w+ in the Confluence staging area./i,
        team: "AIFC Foundations",
        experiences: [
            (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT,
            (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT_IN_CHAT
        ]
    },
    {
        pattern: /Message action error: [Code 400] convoai.rest.bad.request - Failed to update page: missing pageId and ADF content for actionKey:.*/i,
        team: "AIFC Foundations",
        experiences: [
            (0, $irnO2.ExperienceName).AIFC_UPDATE_CONTENT
        ]
    },
    {
        pattern: /Message action error: [Code 400] convoai.rest.bad.request - Failed to update page: missing pageId and ADF content for actionKey:.*/i,
        team: "Editor AI",
        experiences: [
            (0, $irnO2.ExperienceName).UPDATE_CONTENT_IN_CHAT
        ]
    },
    {
        pattern: /AIFC stream received edit tags but no elements were affected/i,
        team: "Whiteboards",
        experiences: [
            (0, $irnO2.ExperienceName).AIFC_UPDATE_CONTENT
        ]
    }
];
/**
 * Step 2 — Global error rules that apply across all experiences.
 */ const $8fc2212d0df9a0a6$var$GLOBAL_ERROR_MESSAGE_RULES = [
    {
        pattern: /network error/i,
        team: "Rovo Chat"
    },
    {
        pattern: /An error occurred. Please try again later./i,
        team: "Rovo Chat"
    },
    {
        pattern: /Failed to fetch/i,
        team: "Rovo Chat"
    },
    {
        pattern: /An unknown error occurred/i,
        team: "Rovo Chat"
    },
    {
        pattern: /\[Code 403\] {"code":403,"message":"You're unable to access content because your IP address is not listed in the IP allowlist. Contact your admin for help."}/i,
        team: "Rovo Chat"
    },
    {
        pattern: /AIFC stream received only preamble but no <todo_list>, SVG or whiteboards XML.*/i,
        team: "Whiteboards"
    },
    {
        pattern: /No sizing converter defined for element type 'mindmap'/i,
        team: "Whiteboards"
    },
    {
        pattern: /AIFC stream received edit tags but no elements were affected/i,
        team: "Whiteboards"
    },
    {
        pattern: /Could not find database:/i,
        team: "Databases"
    }
];
/**
 * Step 3 — Default team ownership per experience.
 * Used as a fallback when no error-pattern rule matches.
 */ const $8fc2212d0df9a0a6$var$DEFAULT_TEAM_FOR_EXPERIENCE = new Map([
    [
        (0, $irnO2.ExperienceName).AIFC_FINALIZE_CONTENT,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).AIFC_ALL_DATA_HANDLED,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT_IN_CHAT,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).AIFC_INITIAL_DATA_RECEIVED,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).AIFC_MODAL_SESSION,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).AIFC_UPDATE_CONTENT,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).UPDATE_CONTENT_IN_CHAT,
        "Editor AI"
    ],
    [
        (0, $irnO2.ExperienceName).PREVIEW_CARD_RENDER,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).PREVIEW_CONTENT,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).SEND_MESSAGE,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).SEND_TASK_MODE_MESSAGE,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).SEND_CONFIRMED_TOOLS_TASK_MODE_MESSAGE,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).LOAD_AUTO_SUGGEST_SKILLS_LEGACY,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).LOAD_AUTO_SUGGEST_SKILLS_UNIFIED,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).LOAD_CHAT_PROMPT_INPUT_SKILLS,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).LOAD_INLINE_CHAT_PROMPT_INPUT_SKILLS,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).JIRA_SAVE_DRAFT_WORK_ITEM,
        "Jira AIFC"
    ],
    [
        (0, $irnO2.ExperienceName).JIRA_CREATE_WORK_ITEMS_BULK,
        "Jira AIFC"
    ],
    [
        (0, $irnO2.ExperienceName).ROVO_SKILLS_PLAN_WORK_ITEM_CREATE,
        "Jira AIFC"
    ],
    [
        (0, $irnO2.ExperienceName).ROVO_SKILLS_EXECUTION_WORK_ITEM_CREATE,
        "Jira AIFC"
    ],
    [
        (0, $irnO2.ExperienceName).SHARE_CONVERSATION_SESSION,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).MANAGE_CONVERSATION_SHARES,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).VIEW_CONVERSATION_SHARE,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).ROVO_SKILLS_PLAN_WORK_ITEM_UPDATE,
        "Pulsar"
    ],
    [
        (0, $irnO2.ExperienceName).ROVO_SKILLS_EXECUTION_WORK_ITEM_UPDATE,
        "Pulsar"
    ]
]);
const $8fc2212d0df9a0a6$export$d6e429d0895093 = (errorMessage, experienceName)=>{
    if (!errorMessage) return $8fc2212d0df9a0a6$var$DEFAULT_TEAM_FOR_EXPERIENCE.get(experienceName);
    // Step 1: Experience-specific error-pattern rules
    if (experienceName) for (const rule of $8fc2212d0df9a0a6$var$RULES_FOR_SPECIFIC_EXPERIENCES){
        if (rule.experiences.includes(experienceName) && rule.pattern.test(errorMessage)) return rule.team;
    }
    // Step 2: Global error-pattern rules
    for (const rule of $8fc2212d0df9a0a6$var$GLOBAL_ERROR_MESSAGE_RULES){
        if (rule.pattern.test(errorMessage)) return rule.team;
    }
    // Step 3: Default team for this experience
    if (experienceName) return $8fc2212d0df9a0a6$var$DEFAULT_TEAM_FOR_EXPERIENCE.get(experienceName);
    return undefined;
};
module.exports["getOwningTeam"] = $8fc2212d0df9a0a6$export$d6e429d0895093;

});

parcelRegister("8YL3U", function(module, exports) {
class $f2446ffb8af04183$export$79c3dc6f15d36f18 {
    onVisibilityChange(isHidden) {
        const now = performance.now();
        if (isHidden) {
            if (this.lastHiddenAt === null) this.lastHiddenAt = now;
            if (this.firstHiddenOffsetMs === null) this.firstHiddenOffsetMs = now - this.startTime;
        } else if (this.lastHiddenAt !== null) {
            this.totalHiddenMs += now - this.lastHiddenAt;
            this.lastHiddenAt = null;
        }
    }
    getAttributes(doc) {
        const now = performance.now();
        const elapsed = now - this.startTime;
        let totalHiddenMs = this.totalHiddenMs;
        if (this.lastHiddenAt !== null) totalHiddenMs += now - this.lastHiddenAt;
        const tabHiddenProportion = elapsed > 0 ? totalHiddenMs / elapsed : 0;
        return {
            isActiveTab: doc ? doc.visibilityState === 'visible' : true,
            tabHiddenProportion: tabHiddenProportion,
            tabFirstHiddenOffsetMs: this.firstHiddenOffsetMs
        };
    }
    constructor(doc){
        this.startTime = void 0;
        this.totalHiddenMs = 0;
        this.lastHiddenAt = void 0;
        this.firstHiddenOffsetMs = void 0;
        this.startTime = performance.now();
        const isHidden = doc?.visibilityState === 'hidden';
        this.lastHiddenAt = isHidden ? this.startTime : null;
        this.firstHiddenOffsetMs = isHidden ? 0 : null;
    }
}
module.exports["TabVisibilityTracker"] = $f2446ffb8af04183$export$79c3dc6f15d36f18;

});

parcelRegister("lJ6db", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");



var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");


var $cha5E = parcelRequire("cha5E");


var $a33Aa = parcelRequire("a33Aa");


var $bjY3F = parcelRequire("bjY3F");


var $hlvTd = parcelRequire("hlvTd");


var $5XWbo = parcelRequire("5XWbo");


var $bxkJA = parcelRequire("bxkJA");


var $8A2GO = parcelRequire("8A2GO");


var $jTKfH = parcelRequire("jTKfH");


var $5rzIE = parcelRequire("5rzIE");


var $7zss8 = parcelRequire("7zss8");


var $gB5in = parcelRequire("gB5in");


var $bQQtO = parcelRequire("bQQtO");


var $fDfQA = parcelRequire("fDfQA");


var $emCLk = parcelRequire("emCLk");


var $5suST = parcelRequire("5suST");


var $irsyK = parcelRequire("irsyK");


var $7td41 = parcelRequire("7td41");


var $bkEBw = parcelRequire("bkEBw");

const $a1ccb2b7a1450c9c$var$addRequestBreadcrumb = ({ durationMs: durationMs, lifecycle: lifecycle, options: options, status: status })=>{
    (0, $hlvTd.addSentryBreadcrumb)({
        category: 'request',
        data: {
            durationMs: durationMs === undefined ? undefined : Math.round(durationMs),
            lifecycle: lifecycle,
            method: (options.options.method ?? 'GET').toUpperCase(),
            operation: options.holdName,
            route: (0, $5rzIE.normalizeRequestRoute)(options.path),
            status: status
        },
        message: `${options.options.method ?? 'GET'} ${options.holdName ?? (0, $5rzIE.normalizeRequestRoute)(options.path)} ${lifecycle}`,
        type: 'http'
    });
};
const $a1ccb2b7a1450c9c$var$observeStreamLifecycle = async function*(generator, options) {
    const startedAt = performance.now();
    let firstDataReceived = false;
    let lifecycleEnded = false;
    $a1ccb2b7a1450c9c$var$addRequestBreadcrumb({
        lifecycle: 'started',
        options: options
    });
    try {
        for await (const value of generator){
            if (!firstDataReceived) {
                firstDataReceived = true;
                $a1ccb2b7a1450c9c$var$addRequestBreadcrumb({
                    durationMs: performance.now() - startedAt,
                    lifecycle: 'firstData',
                    options: options
                });
            }
            yield value;
        }
        lifecycleEnded = true;
        $a1ccb2b7a1450c9c$var$addRequestBreadcrumb({
            durationMs: performance.now() - startedAt,
            lifecycle: options.options.signal?.aborted ? 'abort' : 'completed',
            options: options
        });
    } catch (error) {
        lifecycleEnded = true;
        $a1ccb2b7a1450c9c$var$addRequestBreadcrumb({
            durationMs: performance.now() - startedAt,
            lifecycle: error instanceof Error && error.name === 'AbortError' ? 'abort' : error instanceof Error && /timeout/i.test(error.name) ? 'timedOut' : 'error',
            options: options
        });
        throw error;
    } finally{
        if (!lifecycleEnded) $a1ccb2b7a1450c9c$var$addRequestBreadcrumb({
            durationMs: performance.now() - startedAt,
            lifecycle: options.options.signal?.aborted ? 'abort' : 'cancelled',
            options: options
        });
    }
};
const $a1ccb2b7a1450c9c$var$PRODUCT_HEADER = 'x-product';
/** Number of tasks to request per page when using cursor-based pagination. */ const $a1ccb2b7a1450c9c$var$TASKS_PAGE_SIZE = 25;
const $a1ccb2b7a1450c9c$var$LIBRARY_PAGE_SIZE = 25;
const $a1ccb2b7a1450c9c$var$EXPERIENCE_ID_HEADER = 'x-experience-id';
const $a1ccb2b7a1450c9c$var$CHANNEL_ID_HEADER = 'X-Channel-Id';
const $a1ccb2b7a1450c9c$var$CLOUD_ID_HEADER = 'x-cloudid';
const $a1ccb2b7a1450c9c$var$GATEWAY_BASE_URL = '/gateway/api';
const $a1ccb2b7a1450c9c$var$AGENT_SESSION_STATE_VALUES = new Set([
    'WORKING',
    'INPUT_REQUIRED',
    'ARTEFACT_READY',
    'AUTH_REQUIRED',
    'FAILED',
    'REJECTED',
    'COMPLETED',
    'CANCELLED',
    'UNKNOWN'
]);
const $a1ccb2b7a1450c9c$var$isAgentSessionState = (value)=>$a1ccb2b7a1450c9c$var$AGENT_SESSION_STATE_VALUES.has(value);
const $a1ccb2b7a1450c9c$var$hasCloudIdHeader = (headers)=>Object.keys(headers).some((name)=>name.toLowerCase() === $a1ccb2b7a1450c9c$var$CLOUD_ID_HEADER);
const $a1ccb2b7a1450c9c$var$DEFAULT_FILE_VALIDATE_PATH = '/rovo/v1/chat/message/file/validate';
const $a1ccb2b7a1450c9c$var$DEFAULT_FILE_UPLOAD_PATH = '/rovo/v1/chat/message/file';
class $a1ccb2b7a1450c9c$export$40a7802808e2fbe3 {
    createHeaders(init) {
        const configHeaders = this.config.headers || {};
        return new Headers({
            [$a1ccb2b7a1450c9c$var$PRODUCT_HEADER]: this.config.product,
            [$a1ccb2b7a1450c9c$var$EXPERIENCE_ID_HEADER]: this.config.experienceId,
            ...this.config.siteId && (0, $iDrrr.fg)('rovo_chat_site_switch_reset') && !$a1ccb2b7a1450c9c$var$hasCloudIdHeader(configHeaders) ? {
                [$a1ccb2b7a1450c9c$var$CLOUD_ID_HEADER]: this.config.siteId
            } : {},
            ...configHeaders,
            ...this.config.channelId ? {
                [$a1ccb2b7a1450c9c$var$CHANNEL_ID_HEADER]: this.config.channelId
            } : {},
            ...init
        });
    }
    getChannelId(defaultChannelId) {
        return this.config.channelId || defaultChannelId;
    }
    async fetch({ path: path, options: options, holdName: holdName, baseUrl: requestBaseUrl }) {
        const { baseUrl: configBaseUrl, credentials: configCredentials } = this.config;
        const baseUrl = requestBaseUrl ?? configBaseUrl;
        const requestUrl = (0, $irsyK.addPath)(baseUrl, path);
        const startTime = performance.now();
        if (!(0, $hlvTd.isIsolatedSentryReportingSelected)()) {
            const response = await window.fetch(requestUrl, {
                credentials: configCredentials,
                ...options
            });
            if (this.config.labelStack) {
                // Please note that the recorded duration of this hold may differ from the time spent actually fetching the data.
                // This is because the browser may schedule network calls and JavaScript execution at its own discrection based
                // on available resources, the main thread being blocked, etc... Still, it is a helpful approximation.
                const endTime = performance.now();
                (0, $a33Aa.addSpanToAll)('fetch', holdName ? `${options.method}-${holdName}` : 'unknown', this.config.labelStack, startTime, endTime);
            }
            return (0, $irsyK.processResponse)({
                response: response
            });
        }
        try {
            const response = await window.fetch(requestUrl, {
                credentials: configCredentials,
                ...options
            });
            if (this.config.labelStack) {
                // Please note that the recorded duration of this hold may differ from the time spent actually fetching the data.
                // This is because the browser may schedule network calls and JavaScript execution at its own discrection based
                // on available resources, the main thread being blocked, etc... Still, it is a helpful approximation.
                const endTime = performance.now();
                (0, $a33Aa.addSpanToAll)('fetch', holdName ? `${options.method}-${holdName}` : 'unknown', this.config.labelStack, startTime, endTime);
            }
            const processedResponse = await (0, $irsyK.processResponse)({
                response: response
            });
            $a1ccb2b7a1450c9c$var$addRequestBreadcrumb({
                durationMs: performance.now() - startTime,
                lifecycle: 'success',
                options: {
                    path: path,
                    options: options,
                    holdName: holdName
                },
                status: response.status
            });
            return processedResponse;
        } catch (error) {
            $a1ccb2b7a1450c9c$var$addRequestBreadcrumb({
                durationMs: performance.now() - startTime,
                lifecycle: error instanceof (0, $8A2GO.ApiError) ? 'httpError' : error instanceof Error && error.name === 'AbortError' ? 'abort' : 'networkError',
                options: {
                    path: path,
                    options: options,
                    holdName: holdName
                },
                status: error instanceof (0, $8A2GO.ApiError) ? error.errorAttributes.statusCode : undefined
            });
            throw error;
        }
    }
    async fetchJson(options) {
        const response = await this.fetch(options);
        const json = await response.json();
        return json;
    }
    async getConversationSharePreview(_payload) {
        throw new (0, $8A2GO.ApiError)('Share preview not found', {
            statusCode: 404
        });
    }
    async getConversationShareMetadata(_payload) {
        throw new (0, $8A2GO.ApiError)('Share metadata not found', {
            statusCode: 404
        });
    }
    async fetchStream(options, config) {
        const response = await this.fetch(options);
        const contentType = response.headers.get('content-type') ?? '';
        const headerSuggestsSSE = config?.useSSE && contentType.includes('text/event-stream');
        const shouldObserveStream = (0, $hlvTd.isIsolatedSentryReportingSelected)();
        return {
            responseData: {
                traceId: (0, $jTKfH.getTraceIdFromResponse)(response)
            },
            generator: headerSuggestsSSE ? shouldObserveStream ? $a1ccb2b7a1450c9c$var$observeStreamLifecycle((0, $emCLk.readSSEStream)(response), options) : (0, $emCLk.readSSEStream)(response) : shouldObserveStream ? $a1ccb2b7a1450c9c$var$observeStreamLifecycle((0, $fDfQA.readJsonStream)(response), options) : (0, $fDfQA.readJsonStream)(response)
        };
    }
    constructor(props){
        this.config = void 0;
        this.getConfig = ()=>{
            return {
                ...this.config
            };
        };
        const defaultBaseUrl = '/gateway/api/assist';
        const defaultConfig = {
            baseUrl: defaultBaseUrl,
            headers: {}
        };
        this.config = {
            ...props,
            baseUrl: props.baseUrl || defaultConfig.baseUrl,
            credentials: props.credentials,
            headers: {
                ...props.headers || defaultConfig.headers
            }
        };
    }
}
class $a1ccb2b7a1450c9c$export$a522c5f4ccda1c94 extends $a1ccb2b7a1450c9c$export$40a7802808e2fbe3 {
    async sendMessageStream({ agentNamedId: agentNamedId, agentId: agentId, message: message, autoActionApprovalMode: autoActionApprovalMode, mimeType: mimeType, conversationId: conversationId, controller: controller, storeMessage: storeMessage = false, citationsEnabled: citationsEnabled = true, aiFeatureContext: aiFeatureContext, jiraWorkflowContext: jiraWorkflowContext, editorContext: editorContext, whiteboardContext: whiteboardContext, slidesContext: slidesContext, databaseContext: databaseContext, browserContext: browserContext, additionalContext: additionalContext, writingStyleContext: writingStyleContext, dashboardContext: dashboardContext, dashboardEditorContext: dashboardEditorContext, fileIds: fileIds, webSearchEnabled: webSearchEnabled, sourceMode: sourceMode, deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, alphaExtendedThinkingMode: alphaExtendedThinkingMode, fastModeEnabled: fastModeEnabled, planModeEnabled: planModeEnabled, appFilters: appFilters, selectedCloudIds: selectedCloudIds, useCurrentBrowsingContext: useCurrentBrowsingContext, minionAliasConfig: minionAliasConfig, optInToDeepResearchV2: optInToDeepResearchV2 = false, optInThinkDeeperMessages: optInThinkDeeperMessages = false, optInAnsNow: optInAnsNow = false, optInNewToolTraces: optInNewToolTraces = false, optInNewTeamworkTraceIcons: optInNewTeamworkTraceIcons = false, browserContextSanitizer: browserContextSanitizer, optInSSEStream: optInSSEStream = false, agentVersion: agentVersion, spaceId: spaceId, capabilities: capabilities, shouldExtractConversationScopes: shouldExtractConversationScopes, searchArtifact: searchArtifact, parentMessageId: parentMessageId, requestedSkills: requestedSkills }) {
        const effectiveCapabilities = (0, $5suST.buildEffectiveCapabilities)(capabilities);
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8',
            [$a1ccb2b7a1450c9c$var$CHANNEL_ID_HEADER]: this.getChannelId('rovo-chat'),
            // This header is used to opt-in to Deep Research v2 on the BE.
            // This is to ensure that we don't use v2 deep research when we are using the old Rovo Chat UI prior to the refresh..
            ...optInToDeepResearchV2 && {
                'X-Deep-Research-V2-Opt-In': 'true'
            },
            // Opt in to using RESEARCH_STEP, RESEARCH_PLAN, and similar messages for "think deeper".
            // Ensures backward compatibility with legacy clients and allows application targeting within the experiment.
            ...optInThinkDeeperMessages && {
                'X-Think-Deeper-Messages-Opt-In': 'true'
            },
            ...optInAnsNow && {
                'X-Answer-Now-UI-Opt-In': 'true'
            },
            ...optInNewToolTraces && {
                'X-New-Tool-Traces-Opt-In': 'true'
            },
            ...optInNewTeamworkTraceIcons && {
                'X-New-Teamwork-Trace-Icons-Opt-In': 'true'
            },
            ...effectiveCapabilities && effectiveCapabilities.length > 0 && {
                'X-Rovo-Chat-Capabilities': JSON.stringify(effectiveCapabilities)
            }
        });
        let knowledgeOverride = {};
        // not setting knowledgeEnabled and filters means all org knowledge is applied by default.
        if (appFilters) {
            if (appFilters.length === 0) knowledgeOverride = {
                knowledgeEnabled: false
            };
            else knowledgeOverride = {
                knowledgeEnabled: true,
                filters: {
                    knowledgeSources: appFilters
                }
            };
        }
        const selectedCloudIdsOverride = (0, $iDrrr.fg)((0, $5XWbo.ROVO_CHAT_SITES_SOURCE_FILTER_GATE)) && selectedCloudIds && selectedCloudIds.length > 0 ? {
            selectedCloudIds: selectedCloudIds.map((cloudId)=>({
                    cloudId: cloudId
                }))
        } : {};
        const { browserUrl: url, isBrowserContextBlocklisted: isBrowserContextBlocklisted } = (0, $bQQtO.resolveMessageStreamBrowserUrl)({
            browserContext: browserContext,
            browserContextSanitizer: browserContextSanitizer,
            product: this.getConfig().product
        });
        const defaultMimeType = typeof message === 'string' ? 'text/markdown' : 'text/adf';
        const body = {
            content: message,
            context: (0, $gB5in.buildMessageStreamRequestContext)({
                browserUrl: url,
                autoActionApprovalMode: autoActionApprovalMode,
                useCurrentBrowsingContext: useCurrentBrowsingContext,
                webSearchEnabled: webSearchEnabled,
                sourceMode: sourceMode,
                deepResearchEnabled: deepResearchEnabled,
                thinkDeeperEnabled: thinkDeeperEnabled,
                alphaExtendedThinkingMode: alphaExtendedThinkingMode,
                fastModeEnabled: fastModeEnabled,
                planModeEnabled: planModeEnabled,
                editorContext: editorContext,
                whiteboardContext: whiteboardContext,
                slidesContext: slidesContext,
                databaseContext: databaseContext,
                dashboardEditorContext: dashboardEditorContext,
                browserContext: browserContext,
                isBrowserContextBlocklisted: isBrowserContextBlocklisted,
                jiraWorkflowContext: jiraWorkflowContext,
                additionalContext: additionalContext,
                writingStyleContext: writingStyleContext,
                dashboardContext: dashboardContext,
                aiFeatureContext: aiFeatureContext,
                fileIds: fileIds,
                knowledgeOverride: knowledgeOverride,
                selectedCloudIdsOverride: selectedCloudIdsOverride,
                searchArtifact: searchArtifact,
                shouldExtractConversationScopes: shouldExtractConversationScopes
            }),
            recipient_agent_named_id: agentNamedId,
            agent_id: agentId,
            mimeType: mimeType && (0, $iDrrr.fg)('jira_ai_rendering_a2ui') ? mimeType : defaultMimeType,
            ...agentVersion ? {
                agent_version: agentVersion
            } : {},
            // don't allow store message if feature flag is off
            store_message: (0, $iDrrr.fg)('ai_mate_show_store_messages') ? storeMessage : false,
            citations_enabled: citationsEnabled,
            ...minionAliasConfig ?? (this.getConfig().minionAlias ? {
                stratus_config: {
                    minion_alias: this.getConfig().minionAlias
                }
            } : {}),
            ...spaceId ? {
                space_id: spaceId
            } : {},
            ...parentMessageId ? {
                parent_message_id: parentMessageId
            } : {},
            ...requestedSkills?.length ? {
                skills: requestedSkills
            } : {}
        };
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body),
            signal: controller?.signal
        };
        return this.fetchStream({
            path: optInSSEStream ? `/rovo/v1/chat/conversation/${conversationId}/message/stream/sse` : `/rovo/v1/chat/conversation/${conversationId}/message/stream`,
            options: options
        }, {
            useSSE: optInSSEStream
        });
    }
    async reconnectToMessageStream({ conversationId: conversationId, messageId: messageId, lastEventId: lastEventId, controller: controller }) {
        const headers = this.createHeaders();
        // Add Last-Event-ID header if available
        if (lastEventId) headers.set('Last-Event-ID', lastEventId);
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchStream({
            path: `/rovo/v1/chat/conversation/${conversationId}/message/${messageId}/stream/sse`,
            options: options
        }, {
            useSSE: true
        });
    }
    // Only takes effect if the stream is a Deep Research stream
    async cancelMessageStream({ conversationId: conversationId, messageId: messageId }) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers
        };
        await this.fetch({
            path: `/rovo/v1/chat/conversation/${conversationId}/message/${messageId}/cancel`,
            options: options
        });
    }
    async sendMessageConfirmedTools({ conversationId: conversationId, agentId: agentId, controller: controller, confirmed_tools: confirmed_tools, optInSSEStream: optInSSEStream = false, storeMessage: storeMessage = false, webSearchEnabled: webSearchEnabled, deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, alphaExtendedThinkingMode: alphaExtendedThinkingMode, fastModeEnabled: fastModeEnabled, planModeEnabled: planModeEnabled, aiFeatureContext: aiFeatureContext, agentVersion: agentVersion, optInToDeepResearchV2: optInToDeepResearchV2 = false, optInThinkDeeperMessages: optInThinkDeeperMessages = false, optInAnsNow: optInAnsNow = false, optInNewToolTraces: optInNewToolTraces = false, optInNewTeamworkTraceIcons: optInNewTeamworkTraceIcons = false, capabilities: capabilities, searchArtifact: searchArtifact, jiraWorkflowContext: jiraWorkflowContext, editorContext: editorContext, whiteboardContext: whiteboardContext, slidesContext: slidesContext, databaseContext: databaseContext, browserContext: browserContext, additionalContext: additionalContext, dashboardContext: dashboardContext, dashboardEditorContext: dashboardEditorContext, useCurrentBrowsingContext: useCurrentBrowsingContext, browserContextSanitizer: browserContextSanitizer }) {
        const effectiveCapabilities = (0, $5suST.buildEffectiveCapabilities)(capabilities);
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8',
            [$a1ccb2b7a1450c9c$var$CHANNEL_ID_HEADER]: this.getChannelId('rovo-chat'),
            ...optInToDeepResearchV2 && {
                'X-Deep-Research-V2-Opt-In': 'true'
            },
            ...optInThinkDeeperMessages && {
                'X-Think-Deeper-Messages-Opt-In': 'true'
            },
            ...optInAnsNow && {
                'X-Answer-Now-UI-Opt-In': 'true'
            },
            ...optInNewToolTraces && {
                'X-New-Tool-Traces-Opt-In': 'true'
            },
            ...optInNewTeamworkTraceIcons && {
                'X-New-Teamwork-Trace-Icons-Opt-In': 'true'
            },
            ...effectiveCapabilities && effectiveCapabilities.length > 0 && {
                'X-Rovo-Chat-Capabilities': JSON.stringify(effectiveCapabilities)
            }
        });
        // browser_url is historically the current window location. The blocklist gates the page
        // browser context added under the `rovo-include-full-context-on-confirmed-tools`
        // experiment (when a browserContext is supplied). The NO-URL sentinel under the
        // `jira_free_gen_editor` experiment suppresses the URL (matching sendMessageStream) so that
        // cohort does not leak a URL.
        const browserUrl = browserContext?.context?.browserUrl;
        const isBrowserContextBlocklisted = !!(browserUrl && browserContextSanitizer?.isBlocklisted(browserUrl));
        const isBrowserUrlSuppressed = browserUrl === 'NO-URL' && (0, $cXtTj.default).getExperimentValue('jira_free_gen_editor', 'isEnabled', false);
        const url = isBrowserUrlSuppressed ? '' : window?.location?.href;
        const isBrowserSelectionContextGateEnabled = (0, $iDrrr.fg)('rovo_chat_browser_selection_context');
        const browserSelection = isBrowserSelectionContextGateEnabled ? browserContext?.context?.selection : undefined;
        const body = {
            conversation_id: conversationId,
            agent_id: agentId,
            confirmed_tools: confirmed_tools,
            ...agentVersion ? {
                agent_version: agentVersion
            } : {},
            context: {
                // Historical slim context — unchanged so the experiment-off request is byte-identical.
                browser_url: url,
                webSearchEnabled: webSearchEnabled,
                ...deepResearchEnabled ? {
                    deepResearchEnabled: deepResearchEnabled
                } : {},
                ...thinkDeeperEnabled ? {
                    extendedThinkingEnabled: thinkDeeperEnabled
                } : {},
                ...alphaExtendedThinkingMode ? {
                    alphaExtendedThinkingMode: alphaExtendedThinkingMode
                } : {},
                ...planModeEnabled ? {
                    planModeEnabled: planModeEnabled,
                    alphaExtendedThinkingMode: 'MARATHON',
                    extendedThinkingEnabled: true
                } : {},
                ...fastModeEnabled ? {
                    fastModeEnabled: fastModeEnabled
                } : {},
                ...aiFeatureContext ? {
                    aiFeatureContext: aiFeatureContext
                } : {},
                ...searchArtifact ? {
                    search_artifact: searchArtifact
                } : {},
                // Full request context — supplied by the store action only when the
                // `rovo-include-full-context-on-confirmed-tools` experiment is on, so the backend
                // receives the same page/whiteboard/creation context as a regular sendMessage.
                // Every field is omitted when undefined, so the slim request above is unaffected.
                ...useCurrentBrowsingContext === undefined ? {} : {
                    useCurrentBrowsingContext: useCurrentBrowsingContext
                },
                // Content-context objects. Inlined to mirror sendMessageStream's serialization
                // exactly; a unit test (the drift guard) asserts the two stay in sync. Each is
                // omitted when undefined, so the slim request above is unaffected.
                ...editorContext ? {
                    editor: editorContext
                } : {},
                ...whiteboardContext ? {
                    whiteboardContext: whiteboardContext
                } : {},
                ...slidesContext ? {
                    slidesContext: slidesContext
                } : {},
                ...databaseContext ? {
                    databaseContext: databaseContext
                } : {},
                ...dashboardEditorContext ? {
                    dashboardEditorContext: dashboardEditorContext
                } : {},
                ...browserContext && !isBrowserContextBlocklisted ? {
                    browser: {
                        htmlBody: browserContext.context?.htmlBody,
                        canvasText: browserContext.context?.canvasText,
                        ...browserSelection ? {
                            selection: browserSelection
                        } : {}
                    }
                } : {},
                jiraWorkflowContext: jiraWorkflowContext,
                ...additionalContext,
                dashboardContext: dashboardContext
            },
            // These values are hardcoded because they are not used in backend, but required in the contract
            content: '',
            mimeType: 'text/markdown',
            // don't allow store message if feature flag is off
            store_message: (0, $iDrrr.fg)('ai_mate_show_store_messages') ? storeMessage : false,
            citations_enabled: false
        };
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body),
            signal: controller?.signal
        };
        return this.fetchStream({
            path: optInSSEStream ? `/rovo/v1/chat/conversation/${conversationId}/message/stream/sse` : `/rovo/v1/chat/conversation/${conversationId}/message/stream`,
            options: options
        }, {
            useSSE: optInSSEStream
        });
    }
    async nlCreateAgentStream({ controller: controller, latest_user_message: latest_user_message, draft_agent: draft_agent, conversation_history: conversation_history }) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const body = {
            latest_user_message: latest_user_message,
            draft_agent: draft_agent,
            conversation_history: conversation_history
        };
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body),
            signal: controller?.signal
        };
        return this.fetchStream({
            path: `/rovo/v1/agents/nlcreate`,
            options: options
        });
    }
    async getChat(conversationId, capabilities) {
        // Forward the caller-provided chat capabilities (e.g. `inline_lumina_enabled`,
        // which is gated behind `rovo_chat_enable_inline_lumina`) so that fetching a
        // chat from history renders the same rich (Lumina) components as a live stream,
        // rather than downgrading to basic markdown.
        //
        // Note: this intentionally forwards `capabilities` as-is rather than routing
        // through `buildEffectiveCapabilities`. That helper fires the actionable
        // follow-ups experiment exposure, which must only happen when a message is
        // SENT — not when history is read — so reusing it here would pollute the
        // experiment and attach send-only capabilities to a read request.
        const headers = this.createHeaders({
            ...capabilities && capabilities.length > 0 && {
                'X-Rovo-Chat-Capabilities': JSON.stringify(capabilities)
            }
        });
        const options = {
            method: 'GET',
            headers: headers
        };
        const params = new URLSearchParams({
            shouldMergeA2UI: 'true'
        });
        const path = (0, $cha5E.expVal)('jira_ai_merging_a2ui_history', 'isEnabled', false) ? `/rovo/v1/chat/conversation/${conversationId}/messages?${params}` : `/rovo/v1/chat/conversation/${conversationId}/messages`;
        const rawChat = await this.fetchJson({
            path: path,
            options: options,
            holdName: 'rovo-v1-chat-conversation-[conversationId]-messages'
        });
        const chatArray = rawChat.items;
        return chatArray.map((message)=>(0, $bxkJA.isHumanMessage)(message) ? message : (0, $bkEBw.toStreamResponse)(message));
    }
    async deleteChat(conversationId, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers,
            signal: controller?.signal
        };
        await this.fetch({
            path: `/rovo/v1/chat/conversation/${conversationId}`,
            options: options,
            holdName: 'rovo-v1-chat-conversation-[conversationId]'
        });
    }
    async getAgents(controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        const response = await this.fetchJson({
            path: '/rovo/v1/agents',
            options: options,
            holdName: 'rovo-v1-agents'
        });
        return response.items;
    }
    async getAgentDetails(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: `/rovo/v1/agents/${id}`,
            options: options,
            holdName: 'rovo-v1-agents-[id]'
        });
    }
    async getAgentDetailsByIdentityAccountId(identityAccountId, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: `/rovo/v1/agents/accountid/${identityAccountId}`,
            options: options,
            holdName: 'rovo-v1-agents-accountid-[identityAccountId]'
        });
    }
    async createAgent(payload, controller) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload),
            signal: controller?.signal
        };
        return this.fetchJson({
            path: '/rovo/v1/agents',
            options: options,
            holdName: 'rovo-v1-agents'
        });
    }
    async updateAgent(id, payload, controller) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'PUT',
            headers: headers,
            body: JSON.stringify(payload),
            signal: controller?.signal
        };
        const response = await this.fetchJson({
            path: `/rovo/v1/agents/${id}`,
            options: options,
            holdName: 'rovo-v1-agents-[id]'
        });
        return response;
    }
    async deleteAgent(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: `/rovo/v1/agents/${id}`,
            options: options,
            holdName: 'rovo-v1-agents-[id]'
        });
    }
    async favouriteAgent(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'POST',
            headers: headers,
            signal: controller?.signal
        };
        this.fetch({
            path: `/rovo/v1/agents/${id}/favourite`,
            options: options,
            holdName: 'rovo-v1-agents-[id]-favourite'
        });
    }
    async unfavouriteAgent(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers,
            signal: controller?.signal
        };
        this.fetch({
            path: `/rovo/v1/agents/${id}/favourite`,
            options: options,
            holdName: 'rovo-v1-agents-[id]-favourite'
        });
    }
    async createConversationChannel(options) {
        const name = options && 'name' in options ? options.name : (0, $7td41.generateConversationName)();
        return this.fetchJson({
            path: `/rovo/v1/chat/conversation`,
            options: {
                method: 'POST',
                headers: this.createHeaders({
                    'content-type': 'application/json;charset=UTF-8',
                    [$a1ccb2b7a1450c9c$var$CHANNEL_ID_HEADER]: this.getChannelId('rovo-chat')
                }),
                body: JSON.stringify({
                    name: name,
                    dialogues: options?.dialogues ?? undefined,
                    tags: options?.tags,
                    agent_id: options?.agentId
                })
            },
            holdName: 'rovo-v1-chat-conversation'
        });
    }
    async getConversationChannels(options) {
        const searchParams = new URLSearchParams();
        if (options?.limit !== undefined) searchParams.set('limit', String(options.limit));
        if (options?.cursor !== undefined) searchParams.set('cursor', options.cursor);
        const queryString = searchParams.toString();
        const result = await this.fetchJson({
            path: `/rovo/v1/chat/conversations${queryString ? `?${queryString}` : ''}`,
            options: {
                method: 'GET',
                headers: this.createHeaders()
            },
            holdName: 'rovo-v1-chat-conversations'
        });
        // Transform snake_case fields to camelCase
        return {
            items: result.items.map((item)=>this.transformSnakeCaseToCamelCase(item)),
            hasNext: result.hasNext ?? false,
            cursor: result.cursor ?? null
        };
    }
    async getPinnedConversationSummary() {
        try {
            const result = await this.fetchJson({
                path: '/rovo/v1/chat/conversations/pinned-summary',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-chat-conversations-pinned-summary'
            });
            return {
                pinnedCount: result.pinned_count ?? 0,
                maxPinnedConversations: result.max_pinned_conversations ?? 0
            };
        } catch (error) {
            // The endpoint not being deployed yet surfaces as a 404 — ignore that (callers fall back to
            // the local pinned count). Any other failure is genuine, so rethrow rather than swallow it
            // silently, letting the caller report/handle it.
            const statusCode = error instanceof (0, $8A2GO.ApiError) ? error.errorAttributes?.statusCode : undefined;
            if (statusCode === 404) return undefined;
            throw error;
        }
    }
    updateConversationChannel(id, payload) {
        // Transform camelCase field names to snake_case for the REST API
        const apiPayload = this.transformCamelCaseToSnakeCase(payload);
        return this.fetchJson({
            path: `/rovo/v1/chat/conversation/${id}`,
            options: {
                method: 'PUT',
                headers: this.createHeaders({
                    'content-type': 'application/json;charset=UTF-8'
                }),
                body: JSON.stringify(apiPayload)
            },
            holdName: 'rovo-v1-chat-conversation-[id]'
        }).then((response)=>this.transformSnakeCaseToCamelCase(response));
    }
    transformCamelCaseToSnakeCase(payload) {
        const result = {};
        for (const [key, value] of Object.entries(payload)){
            if (key === 'readStatus') result['read_status'] = value;
            else if (key === 'isPinned') result['is_pinned'] = value;
            else if (key === 'pinnedAt') result['pinned_at'] = value;
            else if (key === 'sourceMode') result['source_mode'] = value;
            else result[key] = value;
        }
        return result;
    }
    transformSnakeCaseToCamelCase(item) {
        if (item == null || typeof item !== 'object') throw new Error(`Expected an object from conversation channel API, got: ${typeof item}`);
        const result = {
            ...item
        };
        if ('read_status' in result) {
            result['readStatus'] = result['read_status'];
            delete result['read_status'];
        }
        if ('is_pinned' in result) {
            result['isPinned'] = result['is_pinned'];
            delete result['is_pinned'];
        }
        if ('pinned_at' in result) {
            result['pinnedAt'] = result['pinned_at'];
            delete result['pinned_at'];
        }
        if ('source_mode' in result) {
            result['sourceMode'] = result['source_mode'];
            delete result['source_mode'];
        }
        const agentSessionState = result['agent_session_state'];
        delete result['agent_session_state'];
        delete result['agentSessionState'];
        if ($a1ccb2b7a1450c9c$var$isAgentSessionState(agentSessionState)) result['agentSessionState'] = agentSessionState;
        else if (agentSessionState != null) (0, $hlvTd.logSentryConsoleWarning)('Unknown agent session state returned by conversation channel API:', agentSessionState);
        return result;
    }
    async resolveConversationAction(id, payload) {
        return this.fetchJson({
            path: `/rovo/v1/chat/conversation/${id}/action`,
            options: {
                method: 'POST',
                headers: this.createHeaders({
                    'content-type': 'application/json;charset=UTF-8'
                }),
                body: JSON.stringify({
                    ...payload,
                    context: {
                        ...payload.context,
                        browser_url: window.location.href
                    }
                })
            },
            holdName: 'rovo-v1-chat-conversation-[id]-action'
        });
    }
    async bulkResolveConversationUIActions(conversationId, messageId, payload) {
        // The bulk API supports a maximum of 50 items per request.
        // Split into batches and process them sequentially.
        const BATCH_SIZE = 50;
        const allResponses = [];
        for(let batchStart = 0; batchStart < payload.items.length; batchStart += BATCH_SIZE){
            const batchItems = payload.items.slice(batchStart, batchStart + BATCH_SIZE);
            const batchResponses = await this.fetchJson({
                path: `/rovo/v1/chat/conversation/${conversationId}/message/${messageId}/tools/resolution`,
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'content-type': 'application/json;charset=UTF-8'
                    }),
                    body: JSON.stringify({
                        items: batchItems.map((item)=>({
                                ...item,
                                context: {
                                    ...item.context,
                                    browser_url: window.location.href
                                }
                            }))
                    })
                },
                holdName: 'rovo-v1-chat-conversation-[id]-message-[messageId]-tools-resolution'
            });
            allResponses.push(...batchResponses);
        }
        return allResponses;
    }
    // REST starters, newer API
    async generateAgentStarters(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/rovo/v1/conversation-starters/agent-starter-suggestion',
            options: options,
            holdName: 'rovo-v1-conversation-starters-agent-starter-suggestion'
        });
    }
    // REST conversation starters, newer API
    async generateContextualStarters(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/rovo/v1/conversation-starters/page-contextual',
            options: options,
            holdName: 'rovo-v1-conversation-starters-page-contextual'
        });
    }
    // REST dynamic conversation starters (new endpoint)
    async getDynamicConvoStartersNew(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8',
            'x-experience-id': 'convo-starter-for-rovo-button'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/api/ai/v2/ai-feature/convo-starters',
            options: options,
            holdName: 'api-ai-v2-ai-feature-convo-starters'
        });
    }
    async getWebSearchConfiguration() {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers
        };
        const result = await this.fetchJson({
            path: '/api/v2/configuration/web-search-ai',
            options: options,
            holdName: 'api-v2-configuration-web-search-ai'
        });
        return result;
    }
    async getPrompts() {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers
        };
        const result = await this.fetchJson({
            path: '/api/v2/prompts',
            options: options,
            holdName: 'api-v2-prompts'
        });
        return result;
    }
    async getPrompt(promptId) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers
        };
        return this.fetchJson({
            path: `/api/v2/prompts/${promptId}`,
            options: options,
            holdName: 'api-v2-prompts-[promptId]'
        });
    }
    async bulkGetPrompts(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/api/v2/prompts/bulk-get',
            options: options,
            holdName: 'api-v2-prompts-bulk-get'
        });
    }
    async createPrompt(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/api/v2/prompts',
            options: options,
            holdName: 'api-v2-prompts'
        });
    }
    async updatePrompt(promptId, payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'PATCH',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: `/api/v2/prompts/${promptId}`,
            options: options,
            holdName: 'api-v2-prompts-update'
        });
    }
    async addPromptsToLibrary(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        await this.fetch({
            path: '/api/v2/prompts/add-to-library',
            options: options,
            holdName: 'api-v2-prompts-add-to-library'
        });
    }
    /**
   * Deletes a prompt from the library. `shareId` is the same value as `GetPromptResponse.id`, not a
   * second kind of identifier: `getPrompt`/`updatePrompt` call the identical value `promptId`, and
   * the client never holds any other prompt id. See the `deletePrompt` note on `AssistanceService`.
   */ async deletePrompt(shareId) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers
        };
        await this.fetch({
            path: `/api/v2/prompts/${shareId}`,
            options: options,
            holdName: 'api-v2-prompts-delete'
        });
    }
    async favoritePrompts(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        await this.fetch({
            path: `/api/v2/prompts/favorite`,
            options: options,
            holdName: 'api-v2-prompts-favorite'
        });
    }
    async bulkUpdatePrivacy(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/api/v2/prompts/bulk-update-privacy',
            options: options,
            holdName: 'api-v2-prompts-bulk-update-privacy'
        });
    }
    async upsertConversationShare(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'PATCH',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/api/v2/share',
            options: options,
            holdName: 'api-v2-share-upsert'
        });
    }
    async ensureConversationShare(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'PATCH',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/api/v2/share',
            options: options,
            holdName: 'api-v2-share-ensure'
        });
    }
    async replaceConversationShare(payload) {
        const { conversationId: conversationId, messageId: messageId, shareType: shareType, allowedUserAris: allowedUserAris } = payload;
        const query = new URLSearchParams({
            conversationId: conversationId,
            messageId: messageId
        });
        const body = {
            conversationId: conversationId,
            messageId: messageId,
            shareType: shareType,
            ...shareType === 'SPECIFIC_USERS' ? {
                allowedUserAris: allowedUserAris ?? []
            } : {}
        };
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'PUT',
            headers: headers,
            body: JSON.stringify(body)
        };
        return this.fetchJson({
            path: `/api/v2/share?${query.toString()}`,
            options: options,
            holdName: 'api-v2-share-replace'
        });
    }
    async getConversationShare(shareToken) {
        return this.fetchJson({
            path: `/api/v2/share/${encodeURIComponent(shareToken)}`,
            options: {
                method: 'GET',
                headers: this.createHeaders()
            },
            holdName: 'api-v2-share-get'
        });
    }
    async getConversationShareMetadata({ conversationId: conversationId, messageId: messageId }) {
        const query = new URLSearchParams({
            conversationId: conversationId,
            messageId: messageId
        });
        return this.fetchJson({
            path: `/api/v2/share?${query.toString()}`,
            options: {
                method: 'GET',
                headers: this.createHeaders()
            },
            holdName: 'api-v2-share-metadata-get'
        });
    }
    async getConversationSharePreview({ conversationId: conversationId, messageId: messageId }) {
        const query = new URLSearchParams({
            conversationId: conversationId,
            messageId: messageId
        });
        return this.fetchJson({
            path: `/api/v2/share/preview?${query.toString()}`,
            options: {
                method: 'GET',
                headers: this.createHeaders()
            },
            holdName: 'api-v2-share-preview-get'
        });
    }
    async forkSharedConversation(shareToken) {
        return this.fetchJson({
            path: `/api/v2/share/${encodeURIComponent(shareToken)}/fork`,
            options: {
                method: 'POST',
                headers: this.createHeaders()
            },
            holdName: 'api-v2-share-fork'
        });
    }
    async deleteConversationShare(shareToken) {
        await this.fetch({
            path: `/api/v2/share/${encodeURIComponent(shareToken)}`,
            options: {
                method: 'DELETE',
                headers: this.createHeaders()
            },
            holdName: 'api-v2-share-delete'
        });
    }
    async deleteAllSharesForConversation(conversationId) {
        await this.fetch({
            path: `/api/v2/shares/conversation/${encodeURIComponent(conversationId)}`,
            options: {
                method: 'DELETE',
                headers: this.createHeaders()
            },
            holdName: 'api-v2-shares-conversation-delete'
        });
    }
    constructor(props){
        super(props);
        // Defined as an arrow property so `this` stays bound when the reference is
        // passed directly to data-fetching hooks (e.g. useQuery's queryFn).
        this.getGroupedConversationShares = async ()=>{
            return this.fetchJson({
                path: '/api/v2/shares/grouped',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'api-v2-shares-grouped-get'
            });
        };
        this.getAgentActions = async ()=>{
            const response = await this.fetchJson({
                path: '/rovo/v1/agents/configuration/actions',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agents-configuration-actions'
            });
            return response.actions;
        };
        this.getAgentKnowledgeConfiguration = (agentCreatorType)=>{
            const queryParams = agentCreatorType ? `?agentCreatorType=${agentCreatorType}` : '';
            return this.fetchJson({
                path: `/rovo/v1/agents/configuration/knowledge${queryParams}`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agents-configuration-knowledge'
            });
        };
        this.getAgentPermissions = (agentId, payload)=>{
            return this.fetchJson({
                path: `/rovo/v2/permissions/agents/${agentId}`,
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'content-type': 'application/json;charset=UTF-8'
                    }),
                    body: JSON.stringify(payload)
                },
                holdName: 'rovo-v2-permissions-agents-[agentId]'
            });
        };
        this.getRecommendedAgents = ({ limit: limit, pageUrl: pageUrl })=>{
            const urlParams = new URLSearchParams({
                limit: limit.toString()
            });
            if (pageUrl) urlParams.append('pageUrl', pageUrl);
            const fullPath = `/rovo/v1/agents/recommend/v2?${urlParams.toString()}`;
            return this.fetchJson({
                path: fullPath,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agents-recommend-v2'
            });
        };
        this.getConversationDebugLogs = async (conversationId)=>{
            const response = await this.fetchJson({
                path: `/rovo/v1/chat/conversation/${conversationId}/debug-logs`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-chat-conversation-[conversationId]-debug-logs'
            });
            return response.items;
        };
        this.validateFiles = async (payload)=>{
            const headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
            });
            return this.fetchJson({
                path: this.config.fileValidatePath ?? $a1ccb2b7a1450c9c$var$DEFAULT_FILE_VALIDATE_PATH,
                options: {
                    method: 'POST',
                    headers: headers,
                    body: JSON.stringify(payload)
                },
                holdName: 'rovo-v1-chat-message-file-validate'
            });
        };
        this.uploadFiles = async (payload)=>{
            const formData = new FormData();
            for (const file of payload.files)formData.append('files', file);
            const response = await this.fetchJson({
                path: this.config.fileUploadPath ?? $a1ccb2b7a1450c9c$var$DEFAULT_FILE_UPLOAD_PATH,
                options: {
                    method: 'POST',
                    headers: this.createHeaders(),
                    body: formData
                },
                holdName: 'rovo-v1-chat-message-file'
            });
            return response;
        };
        this.rovoLabsSendMessage = (payload)=>{
            return this.fetchStream({
                path: '/rovo/v1/agent-playground/chat/stream',
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'content-type': 'application/json;charset=UTF-8'
                    }),
                    body: JSON.stringify(payload)
                },
                holdName: 'rovo-v1-agent-playground-chat-stream'
            });
        };
        this.rovoLabsGetConversations = ()=>{
            return this.fetchJson({
                path: '/rovo/v1/agent-playground/chat/conversations',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agent-playground-chat-conversations'
            });
        };
        this.rovoLabsGetTools = ()=>{
            return this.fetchJson({
                path: '/rovo/v1/agent-playground/tools',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agent-playground-tools'
            });
        };
        this.rovoLabsGetLanguageModels = ()=>{
            return this.fetchJson({
                path: '/rovo/v1/agent-playground/language-models',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agent-playground-language-models'
            });
        };
        this.rovoLabsGetPrompts = ()=>{
            return this.fetchJson({
                path: '/rovo/v1/agent-playground/prompts',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agent-playground-prompts'
            });
        };
        this.getGeneratedContent = (payload)=>{
            const queryParams = [];
            if (payload?.actions && payload.actions.length > 0) queryParams.push(`actionKeys=${payload.actions.join(',')}`);
            if (payload?.statuses && payload.statuses.length > 0) queryParams.push(`statuses=${payload.statuses.join(',')}`);
            if (payload?.limit !== undefined) queryParams.push(`limit=${payload.limit}`);
            const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
            return this.fetchJson({
                path: `/rovo/v1/chat/generated-content${queryString}`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-chat-generated-content'
            });
        };
        this.getRovoUserSettings = async ()=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/user-settings',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'rovo-v1-chat-user-settings'
            });
        };
        this.updateRovoUserSettings = async (settings)=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/user-settings',
                options: {
                    method: 'PUT',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    }),
                    body: JSON.stringify(settings)
                },
                holdName: 'rovo-v1-chat-user-settings'
            });
        };
        this.getRovoMemories = async ()=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/memories',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'rovo-v1-chat-memories'
            });
        };
        this.getRovoMemoryBlurb = async ()=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/memories/blurb',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'rovo-v1-chat-memories-blurb'
            });
        };
        this.answerNow = async (conversationId, messageId)=>{
            const headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
            });
            const options = {
                method: 'POST',
                headers: headers
            };
            await this.fetch({
                path: `/rovo/v1/chat/conversation/${conversationId}/message/${messageId}/answer-now`,
                options: options,
                holdName: 'rovo-v1-chat-conversation-message-answer-now'
            });
        };
        this.deleteRovoMemory = async (memoryId)=>{
            const headers = this.createHeaders();
            const options = {
                method: 'DELETE',
                headers: headers
            };
            await this.fetch({
                path: `/rovo/v1/chat/memories/${memoryId}`,
                options: options,
                holdName: 'rovo-v1-chat-memories-[memoryId]'
            });
        };
        this.getRovoMemoryEdits = async ()=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/memories/memory-edits',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'rovo-v1-chat-memories-memory-edits'
            });
        };
        this.createMemoryEdit = async (payload)=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/memories/memory-edits',
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    }),
                    body: JSON.stringify(payload)
                },
                holdName: 'rovo-v1-chat-memories-memory-edits'
            });
        };
        this.createMemory = async (payload)=>{
            await this.fetch({
                path: '/rovo/v1/chat/memories/create',
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    }),
                    body: JSON.stringify(payload)
                },
                holdName: 'rovo-v1-chat-memories-create'
            });
        };
        this.getRovoMemoryEditsCount = async ()=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/memories/memory-edits/count',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'rovo-v1-chat-memories-memory-edits-count'
            });
        };
        this.deleteRovoMemoryEdit = async (editId)=>{
            const headers = this.createHeaders();
            const options = {
                method: 'DELETE',
                headers: headers
            };
            await this.fetch({
                path: `/rovo/v1/chat/memories/memory-edits/${editId}`,
                options: options,
                holdName: 'rovo-v1-chat-memories-memory-edits-[editId]'
            });
        };
        this.fetchConversationMetadata = async (conversationId)=>{
            const result = await this.fetchJson({
                path: `/rovo/v1/chat/conversation/${conversationId}`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-chat-conversation-[conversationId]'
            });
            return this.transformSnakeCaseToCamelCase(result);
        };
        this.fetchPersonalizedPromptSuggestions = async (config)=>{
            const { offset: offset = 0, limit: limit = 9, contentType: contentType, entryPoint: entryPoint } = config;
            const headers = this.createHeaders({
                'Content-Type': 'application/json'
            });
            const options = {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                    ai_feature_input: {
                        offset: offset,
                        limit: limit,
                        ...contentType ? {
                            contentType: contentType
                        } : {},
                        ...entryPoint ? {
                            entryPoint: entryPoint
                        } : {}
                    }
                })
            };
            const result = await this.fetchJson({
                path: '/api/ai/v2/ai-feature/confluence-prompt-tiles',
                options: options,
                holdName: 'api-ai-v2-ai-feature-confluence-prompt-tiles'
            });
            return result?.ai_feature_output?.prompt_tiles ?? [];
        };
        this.getTasks = async (params)=>{
            const searchParams = new URLSearchParams();
            searchParams.set('limit', String(params?.limit ?? $a1ccb2b7a1450c9c$var$TASKS_PAGE_SIZE));
            if (params?.cursor) searchParams.set('cursor', params.cursor);
            return this.fetchJson({
                path: `/rovo/v1/tasks?${searchParams.toString()}`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'rovo-v1-tasks'
            });
        };
        this.getLibraryEntries = async (params)=>{
            const searchParams = new URLSearchParams();
            searchParams.set('limit', String(params?.limit ?? $a1ccb2b7a1450c9c$var$LIBRARY_PAGE_SIZE));
            if (params?.cursor) searchParams.set('cursor', params.cursor);
            const options = {
                method: 'GET',
                headers: this.createHeaders(),
                signal: params?.controller?.signal
            };
            return this.fetchJson({
                baseUrl: $a1ccb2b7a1450c9c$var$GATEWAY_BASE_URL,
                path: `/rovo-chat/v1/library?${searchParams.toString()}`,
                options: options,
                holdName: 'rovo-chat-v1-library'
            });
        };
        this.getTasksStream = async (controller)=>{
            return this.fetchStream({
                path: '/rovo/v1/tasks/stream',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        Accept: 'text/event-stream'
                    }),
                    signal: controller?.signal
                },
                holdName: 'rovo-v1-tasks-stream'
            }, {
                useSSE: true
            });
        };
        this.cancelTask = async (taskId)=>{
            const headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
            });
            const options = {
                method: 'POST',
                headers: headers
            };
            await this.fetch({
                path: `/rovo/v1/tasks/${taskId}/cancel`,
                options: options,
                holdName: 'rovo-v1-tasks-[taskId]-cancel'
            });
        };
        this.deleteTask = async (taskId)=>{
            const headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
            });
            const options = {
                method: 'DELETE',
                headers: headers
            };
            await this.fetch({
                path: `/rovo/v1/tasks/${taskId}`,
                options: options,
                holdName: 'rovo-v1-tasks-[taskId]-delete'
            });
        };
        this.renameTask = async (taskId, title)=>{
            return this.fetchJson({
                path: `/rovo/v1/tasks/${taskId}`,
                options: {
                    method: 'PUT',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    }),
                    body: JSON.stringify({
                        title: title
                    })
                },
                holdName: 'rovo-v1-tasks-[taskId]'
            });
        };
        this.fetchPersonalizedPromptSuggestionsStream = async (config)=>{
            const { offset: offset = 0, limit: limit = 9, contentType: contentType, entryPoint: entryPoint, enable3pPrompt: enable3pPrompt } = config;
            const headers = this.createHeaders({
                'Content-Type': 'application/json'
            });
            const options = {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                    ai_feature_input: {
                        offset: offset,
                        limit: limit,
                        ...contentType ? {
                            contentType: contentType
                        } : {},
                        ...entryPoint ? {
                            entryPoint: entryPoint
                        } : {},
                        // Only sent for experiment variants A/B; omitted for everyone else so the
                        // request is byte-identical to the pre-3P-feature request.
                        ...enable3pPrompt ? {
                            enable_3p_prompt: true
                        } : {}
                    }
                })
            };
            return this.fetchStream({
                path: '/api/ai/v2/ai-feature/confluence-prompt-tiles/stream',
                options: options,
                holdName: 'api-ai-v2-ai-feature-confluence-prompt-tiles-stream'
            });
        };
    }
}
const $a1ccb2b7a1450c9c$var$AssistanceServiceContext = /*#__PURE__*/ (0, $cozmU.createContext)(new $a1ccb2b7a1450c9c$export$a522c5f4ccda1c94({
    baseUrl: '',
    product: '',
    experienceId: ''
}));
const $a1ccb2b7a1450c9c$export$8fe647eb935c33db = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { value: value, children: children } = t0;
    let t1;
    if ($[0] !== children || $[1] !== value) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a1ccb2b7a1450c9c$var$AssistanceServiceContext.Provider, {
            value: value
        }, children);
        $[0] = children;
        $[1] = value;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ value: value, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a1ccb2b7a1450c9c$var$AssistanceServiceContext.Provider, {
        value: value
    }, children);
const $a1ccb2b7a1450c9c$export$7e31a1844ebbaf85 = (props)=>{
    (0, $6cFsl.di)((0, $cozmU.useContext), $a1ccb2b7a1450c9c$export$a522c5f4ccda1c94);
    const service = (0, $cozmU.useContext)($a1ccb2b7a1450c9c$var$AssistanceServiceContext);
    (0, $7zss8.setRovoChatProduct)(props?.product ?? service.getConfig().product);
    if (!props || !props.experienceId && !props.product && !props.headers && !props.channelId) return service;
    const product = props.product ?? service.getConfig().product;
    const experienceId = props.experienceId ?? service.getConfig().experienceId;
    const headers = props.headers ?? service.getConfig().headers;
    const channelId = props.channelId ?? service.getConfig().channelId;
    return new $a1ccb2b7a1450c9c$export$a522c5f4ccda1c94({
        ...service.getConfig(),
        product: product,
        experienceId: experienceId,
        headers: headers,
        channelId: channelId
    });
};
const $a1ccb2b7a1450c9c$export$5a9ea20fc196ec62 = (originalHook)=>{
    return (props)=>{
        (0, $6cFsl.di)($a1ccb2b7a1450c9c$export$a522c5f4ccda1c94, (0, $bjY3F.useAIMateExperienceTracker));
        const { assistanceServiceParams: assistanceServiceParams, ...restProps } = props;
        const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)({
            touchpointSource: assistanceServiceParams.touchpointSource
        });
        const headers = (0, $cozmU.useMemo)(()=>{
            // even though AssistanceServiceInputParam enforces lowercase header keys,
            // it is possible to get a non lowercase key if a prebuilt object was assigned to headers at runtime,
            // so this is an additional safety net, without this duplicate headers keys with different case
            // can get appended during header normalization causing request to fail
            // Relevant thread: https://atlassian.slack.com/archives/C0677M19GU9/p1748531977923069?thread_ts=1747336061.856749&cid=C0677M19GU9
            const inputHeaders = props.assistanceServiceParams.headers ? Object.fromEntries(Object.entries(props.assistanceServiceParams.headers).map(([key, value])=>[
                    key.toLowerCase(),
                    value
                ])) : undefined;
            return {
                'x-cloudid': props.assistanceServiceParams.siteId,
                ...inputHeaders
            };
        }, [
            props.assistanceServiceParams.siteId,
            props.assistanceServiceParams.headers
        ]);
        const assistanceService = (0, $cozmU.useMemo)(()=>{
            return new $a1ccb2b7a1450c9c$export$a522c5f4ccda1c94({
                product: assistanceServiceParams.product,
                experienceId: assistanceServiceParams.experienceId,
                headers: headers,
                channelId: assistanceServiceParams.channelId,
                baseUrl: assistanceServiceParams.baseUrl,
                minionAlias: assistanceServiceParams.minionAlias,
                fileValidatePath: assistanceServiceParams.fileValidatePath,
                fileUploadPath: assistanceServiceParams.fileUploadPath
            });
        }, [
            assistanceServiceParams.baseUrl,
            assistanceServiceParams.experienceId,
            assistanceServiceParams.product,
            assistanceServiceParams.channelId,
            headers,
            assistanceServiceParams.minionAlias,
            assistanceServiceParams.fileValidatePath,
            assistanceServiceParams.fileUploadPath
        ]);
        // eslint-disable-next-line @atlaskit/platform/no-double-type-assertions -- Existing assistance-service baseline: injected hook params are adapted to the generic hook parameter type.
        const result = originalHook({
            ...restProps,
            assistanceServiceInjectedParams: {
                ...assistanceServiceParams,
                headers: headers,
                experienceTracker: experienceTracker,
                assistanceService: assistanceService
            }
        });
        return result;
    };
};
module.exports["AssistanceServiceBase"] = $a1ccb2b7a1450c9c$export$40a7802808e2fbe3;
module.exports["AssistanceServiceImpl"] = $a1ccb2b7a1450c9c$export$a522c5f4ccda1c94;
module.exports["AssistanceServiceProvider"] = $a1ccb2b7a1450c9c$export$8fe647eb935c33db;
module.exports["useAssistanceService"] = $a1ccb2b7a1450c9c$export$7e31a1844ebbaf85;
module.exports["createHookWithAssistanceService"] = $a1ccb2b7a1450c9c$export$5a9ea20fc196ec62;

});

parcelRegister("cha5E", function(module, exports) {

var $a4RZV = parcelRequire("a4RZV");

function $62f475419a76226b$export$9db1624a8af791a4(experimentName, param, defaultValue) {
    return (0, $a4RZV.expValInternal)(experimentName, param, defaultValue, true);
}
module.exports["expVal"] = $62f475419a76226b$export$9db1624a8af791a4;

});

parcelRegister("a4RZV", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $7OZjB = parcelRequire("7OZjB");


var $gvJlB = parcelRequire("gvJlB");

function $9b4163a3d03875dc$export$48708229abf6ab93(experimentName, param, defaultValue, fireExperimentExposure) {
    // Dev-mode override (platform website dev panel, Gemini VR test harness).
    if ((0, $gvJlB.devOverrides).has(experimentName)) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const overrideParams = (0, $gvJlB.devOverrides).get(experimentName);
        const overrideValue = overrideParams[param];
        if (overrideValue !== undefined) {
            (0, $7OZjB.addFeatureFlagAccessed)(`${experimentName}:${param}`, overrideValue);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return overrideValue;
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return defaultValue;
    }
    // If Statsig is not initialized, return the default.
    if (!(0, $cXtTj.default).initializeCompleted()) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return defaultValue;
    // Live Statsig value.
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const value = (0, $cXtTj.default).getExperimentValue(experimentName, param, defaultValue, {
        fireExperimentExposure: fireExperimentExposure
    });
    (0, $7OZjB.addFeatureFlagAccessed)(`${experimentName}:${param}`, value);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return value;
}
module.exports["expValInternal"] = $9b4163a3d03875dc$export$48708229abf6ab93;

});

parcelRegister("gvJlB", function(module, exports) {
const $bd07fe7ea4e784d1$export$89f9222be8849d61 = new Map();
let $bd07fe7ea4e784d1$export$1443858d5f82511f = false;
function $bd07fe7ea4e784d1$export$6bce865e33a255c3(value) {
    $bd07fe7ea4e784d1$export$1443858d5f82511f = value;
}
module.exports["devOverrides"] = $bd07fe7ea4e784d1$export$89f9222be8849d61;

});

parcelRegister("5XWbo", function(module, exports) {
const $8801d8511b175030$export$e0744546db5b6189 = 'rovo_chat_sites_source_filter';
module.exports["ROVO_CHAT_SITES_SOURCE_FILTER_GATE"] = $8801d8511b175030$export$e0744546db5b6189;

});

parcelRegister("bxkJA", function(module, exports) {

var $fCunh = parcelRequire("fCunh");


var $8A2GO = parcelRequire("8A2GO");

const $c3ad42ae8c5c5089$export$f78edfe5a93b58af = (message)=>{
    return message !== null && typeof message === 'object' && '__isSSEWrapper' in message && message.__isSSEWrapper === true;
};
const $c3ad42ae8c5c5089$export$5945515082cc2cbf = 'convoai.rest.not.found';
const $c3ad42ae8c5c5089$export$c424fe9570a5f2d9 = 'ACCEPTABLE_USE_VIOLATIONS';
const $c3ad42ae8c5c5089$export$c162f3e7456e473f = [
    'rovo_default',
    'professional',
    'creative',
    'empathetic'
];
const $c3ad42ae8c5c5089$export$a461d78149e66005 = [
    'shorter',
    'neutral',
    'longer'
];
const $c3ad42ae8c5c5089$export$42a434f431015fce = [
    'less_structured',
    'neutral',
    'more_structured'
];
const $c3ad42ae8c5c5089$export$312f4aeec9b65640 = [
    'none',
    'neutral',
    'more'
];
const $c3ad42ae8c5c5089$export$f3430750c3a3992d = [
    'enabled',
    'disabled'
];
var $c3ad42ae8c5c5089$export$2e28f9aa1dcf9823 = /*#__PURE__*/ function(PromptCategory) {
    PromptCategory["ANALYZE"] = "Analyze";
    PromptCategory["BRAINSTORM"] = "Brainstorm";
    PromptCategory["REVIEW"] = "Review";
    PromptCategory["SUMMARIZE"] = "Summarize";
    PromptCategory["CREATE"] = "Create";
    PromptCategory["EXECUTE"] = "Execute";
    PromptCategory["FIND"] = "Find";
    PromptCategory["LEARN"] = "Learn";
    return PromptCategory;
}({});
var $c3ad42ae8c5c5089$export$bd1535eb0caf2683 = /*#__PURE__*/ function(PromptRole) {
    PromptRole["GENERAL"] = "General";
    PromptRole["ENGINEERING"] = "Engineering";
    PromptRole["PRODUCT"] = "Product";
    PromptRole["PROGRAM_MANAGEMENT"] = "Program Management";
    PromptRole["DESIGN"] = "Design";
    PromptRole["MARKETING"] = "Marketing";
    PromptRole["IT_OPS"] = "IT Ops";
    PromptRole["SALES"] = "Sales";
    PromptRole["CUSTOMER_SUPPORT"] = "Customer Support";
    PromptRole["HELPDESK_SUPPORT"] = "Helpdesk Support";
    PromptRole["SECURITY"] = "Security";
    return PromptRole;
}({});
const $c3ad42ae8c5c5089$export$77c9504201bdfdea = 'PROMPT_TILE';
const $c3ad42ae8c5c5089$export$7fe06c6ae176663 = 'third-party';
const $c3ad42ae8c5c5089$var$entityTypeMap = {
    person: 'Person',
    Person: 'Person',
    inferred_project: 'InferredProject',
    InferredProject: 'InferredProject'
};
const $c3ad42ae8c5c5089$export$d6de2556d50e53b4 = (message)=>({
        sentence: message.sentence,
        entities: message.entities.map((entity)=>({
                type: $c3ad42ae8c5c5089$var$entityTypeMap[entity.type],
                mention: entity.mention,
                start: entity.start,
                end: entity.end,
                ari: entity.ari,
                canonicalName: entity.canonical_name,
                confidenceScore: entity.confidence_score
            }))
    });
const $c3ad42ae8c5c5089$export$fb661125ffb29bd6 = (message)=>{
    return $c3ad42ae8c5c5089$export$a69fab2afb88c2eb(message) || $c3ad42ae8c5c5089$export$6f965deda7f0960c(message) || $c3ad42ae8c5c5089$export$b4631726cbc1440a(message);
};
const $c3ad42ae8c5c5089$export$a69fab2afb88c2eb = (message)=>message instanceof Object && message.role === 'HUMAN';
const $c3ad42ae8c5c5089$export$6f965deda7f0960c = (message)=>message instanceof Object && message.role === 'ASSISTANT';
const $c3ad42ae8c5c5089$export$1af37a4715539580 = (message)=>Boolean(message.message_metadata?.sharedFromMessageId);
const $c3ad42ae8c5c5089$export$a6e5100ca2770191 = (message)=>message instanceof Object && $c3ad42ae8c5c5089$export$6f965deda7f0960c(message.message);
const $c3ad42ae8c5c5089$export$2403e128f2e81f8f = (message)=>message instanceof Object && message.message instanceof Object;
const $c3ad42ae8c5c5089$export$5c1c15675df13ae5 = (message)=>$c3ad42ae8c5c5089$export$b4631726cbc1440a(message) && message.message?.message?.async_status === 'IN_PROGRESS';
const $c3ad42ae8c5c5089$export$b4631726cbc1440a = (message)=>message instanceof Object && message.type === 'FINAL_RESPONSE';
const $c3ad42ae8c5c5089$var$isRecord = (value)=>typeof value === 'object' && value !== null;
const $c3ad42ae8c5c5089$var$isOptionalNullableString = (value)=>value === undefined || value === null || typeof value === 'string';
const $c3ad42ae8c5c5089$export$2d3cb9d520902824 = (message)=>{
    if (!$c3ad42ae8c5c5089$var$isRecord(message) || message.type !== 'INTERACTION_CONCLUSION' || !$c3ad42ae8c5c5089$var$isRecord(message.message) || message.message.outcome !== 'SUCCEEDED' && message.message.outcome !== 'FAILED') return false;
    if (message.millisOffset !== undefined && typeof message.millisOffset !== 'number') return false;
    if (message.metadata != null && (!$c3ad42ae8c5c5089$var$isRecord(message.metadata) || !$c3ad42ae8c5c5089$var$isOptionalNullableString(message.metadata.request_id) || !$c3ad42ae8c5c5089$var$isOptionalNullableString(message.metadata.message_id))) return false;
    return true;
};
const $c3ad42ae8c5c5089$export$d422a2733a3b5def = (message)=>message instanceof Object && message.type === 'ERROR';
const $c3ad42ae8c5c5089$export$1e1cf807ece63df4 = (message)=>$c3ad42ae8c5c5089$export$d422a2733a3b5def(message) && message.message?.message_template === $c3ad42ae8c5c5089$export$c424fe9570a5f2d9;
const $c3ad42ae8c5c5089$export$e45102edbc73b240 = (message)=>message instanceof Object && message.type === 'ANSWER_PART';
const $c3ad42ae8c5c5089$var$isRawEntityAnnotation = (value)=>$c3ad42ae8c5c5089$var$isRecord(value) && (value.type === 'person' || value.type === 'Person' || value.type === 'inferred_project' || value.type === 'InferredProject') && typeof value.mention === 'string' && typeof value.start === 'number' && Number.isFinite(value.start) && typeof value.end === 'number' && Number.isFinite(value.end) && typeof value.ari === 'string' && typeof value.canonical_name === 'string' && typeof value.confidence_score === 'number' && Number.isFinite(value.confidence_score);
const $c3ad42ae8c5c5089$export$6fb760a9d35f0551 = (message)=>$c3ad42ae8c5c5089$var$isRecord(message) && message.type === 'ENTITY_ANNOTATIONS' && $c3ad42ae8c5c5089$var$isRecord(message.message) && typeof message.message.sentence === 'string' && Array.isArray(message.message.entities) && message.message.entities.every($c3ad42ae8c5c5089$var$isRawEntityAnnotation);
const $c3ad42ae8c5c5089$export$51a109436d382715 = (message)=>message instanceof Object && message.type === 'REASONING_PART';
const $c3ad42ae8c5c5089$export$dbf4211c9117b9bc = (message)=>message instanceof Object && message.type === 'ACTION_PART';
const $c3ad42ae8c5c5089$export$3d7b0b359441d5a6 = (message)=>message instanceof Object && message.type === 'ACTION_CLASSIFICATION';
const $c3ad42ae8c5c5089$export$584e11c2903f4ed6 = (message)=>message instanceof Object && message.type === 'ACTION_PREPARE';
const $c3ad42ae8c5c5089$export$7d94ce53d589f586 = (message)=>message instanceof Object && message.type === 'ACTION_COMPLETE';
const $c3ad42ae8c5c5089$var$AUTO_ACTION_APPROVAL_STATUSES = new Set([
    'REVIEWING',
    'AUTO_APPROVED',
    'AUTO_APPROVED_REQUIRES_HUMAN',
    'REQUIRES_HUMAN'
]);
const $c3ad42ae8c5c5089$var$isNullableString = (value)=>value === null || typeof value === 'string';
const $c3ad42ae8c5c5089$export$9082a8e48d820016 = (message)=>{
    if (!$c3ad42ae8c5c5089$var$isRecord(message) || message.type !== 'AUTO_ACTION_APPROVAL' || !$c3ad42ae8c5c5089$var$isRecord(message.message)) return false;
    const payload = message.message;
    const metadataIsValid = message.metadata === undefined || message.metadata === null || $c3ad42ae8c5c5089$var$isRecord(message.metadata) && (message.metadata.request_id === undefined || $c3ad42ae8c5c5089$var$isNullableString(message.metadata.request_id));
    const sequenceIdIsValid = message.sequence_id === undefined || typeof message.sequence_id === 'string';
    return typeof message.millisOffset === 'number' && Number.isFinite(message.millisOffset) && typeof payload.content === 'string' && typeof payload.status === 'string' && $c3ad42ae8c5c5089$var$AUTO_ACTION_APPROVAL_STATUSES.has(payload.status) && typeof payload.action_display_name === 'string' && typeof payload.tool_name === 'string' && $c3ad42ae8c5c5089$var$isNullableString(payload.action_key) && $c3ad42ae8c5c5089$var$isNullableString(payload.reason) && typeof payload.source === 'string' && typeof payload.risk_category === 'string' && typeof payload.policy_version === 'string' && $c3ad42ae8c5c5089$var$isNullableString(payload.model_id) && metadataIsValid && sequenceIdIsValid;
};
const $c3ad42ae8c5c5089$export$abec64f24e2ec3e7 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_START';
const $c3ad42ae8c5c5089$export$9c1f93971e9e3fbe = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH';
const $c3ad42ae8c5c5089$export$79a0ed7d987faa8f = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP';
const $c3ad42ae8c5c5089$export$7b1c8227569f1a92 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_TITLE';
const $c3ad42ae8c5c5089$export$cde91b49af35d559 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_PLAN';
const $c3ad42ae8c5c5089$export$4a6a601f69cf3c74 = (message)=>message instanceof Object && message.type === 'TODO_SNAPSHOT';
const $c3ad42ae8c5c5089$export$6b0058543411cb3a = (message)=>message instanceof Object && message.type === 'TASK_STATUS';
const $c3ad42ae8c5c5089$export$ac74da022f74040a = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_TITLE_SHORT';
const $c3ad42ae8c5c5089$export$7898cc38956b9052 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'SKILL_START';
const $c3ad42ae8c5c5089$export$bb608d13a1268633 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'SKILL_END';
const $c3ad42ae8c5c5089$export$b65c73c7e2d8d96f = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'FAST_MODE_RESPONSE_AVAILABLE';
const $c3ad42ae8c5c5089$export$40cf419186312161 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'FAST_MODE_ENABLED';
const $c3ad42ae8c5c5089$export$a83708fc4401682d = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'REMOVE_ANSWER_NOW';
const $c3ad42ae8c5c5089$export$68192da24ac8c141 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_SOURCE';
const $c3ad42ae8c5c5089$export$cfccfd17b68ccb0 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_COMPLETE';
const $c3ad42ae8c5c5089$export$1fd230d6956c2575 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_ICONS';
const $c3ad42ae8c5c5089$export$3bc697eeff31bdf6 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_DOCUMENT';
const $c3ad42ae8c5c5089$export$c679ee34f7312895 = (message)=>message instanceof Object && message.type === 'RECONNECT_SUPPORTED';
const $c3ad42ae8c5c5089$export$46e0fb5e4b019a49 = (message)=>message instanceof Object && message.type === 'TRACE' && (message.message.message_template === 'RESEARCH' || message.message.message_template === 'RESEARCH_STEP' || message.message.message_template === 'RESEARCH_STEP_TITLE' || message.message.message_template === 'RESEARCH_STEP_TITLE_SHORT' || message.message.message_template === 'RESEARCH_STEP_SOURCE' || message.message.message_template === 'RESEARCH_STEP_COMPLETE' || message.message.message_template === 'RESEARCH_STEP_ICONS' || message.message.message_template === 'RESEARCH_STEP_DOCUMENT');
const $c3ad42ae8c5c5089$export$6f74311d40862a9f = (message)=>message instanceof Object && message.type === 'TRACE' && ($c3ad42ae8c5c5089$export$7898cc38956b9052(message) || $c3ad42ae8c5c5089$export$bb608d13a1268633(message));
const $c3ad42ae8c5c5089$export$d95e474df0d530df = (message)=>message instanceof Object && message.type === 'TRACE' && message.message?.message_template === 'MEMORY_UPDATE';
const $c3ad42ae8c5c5089$export$fd5a05be03f147a0 = (message)=>{
    // TRACE and research steps are sharing the same type, but we want to separate them
    if ($c3ad42ae8c5c5089$export$46e0fb5e4b019a49(message)) return false;
    if ($c3ad42ae8c5c5089$export$cde91b49af35d559(message)) return false;
    if ($c3ad42ae8c5c5089$export$6f74311d40862a9f(message)) return false;
    if ($c3ad42ae8c5c5089$export$b65c73c7e2d8d96f(message)) return false;
    if ($c3ad42ae8c5c5089$export$682514f3a8131b98(message)) return false;
    return message instanceof Object && message.type === 'TRACE';
};
const $c3ad42ae8c5c5089$export$682514f3a8131b98 = (message)=>{
    return message instanceof Object && message.type === 'TRACE' && message.message?.message_template === 'THINK_DEEPER_TRIGGERED';
};
const $c3ad42ae8c5c5089$export$aeae5b4fda357302 = (message)=>message !== undefined && message !== null && typeof message === 'object' && 'type' in message && message.type === 'FOLLOW_UP_QUERIES';
const $c3ad42ae8c5c5089$export$6275ff996073145e = (message)=>{
    if (!$c3ad42ae8c5c5089$export$f78edfe5a93b58af(message) || message.eventType !== 'AGENTIC_UI') return false;
    if (message.data === null || typeof message.data !== 'object') return false;
    const data = message.data;
    return Array.isArray(data.message?.content);
};
const $c3ad42ae8c5c5089$export$b46beea5c82aa1b9 = (message)=>message instanceof Object && message.type === 'HEART_BEAT';
const $c3ad42ae8c5c5089$export$b8391261162989d9 = (message)=>$c3ad42ae8c5c5089$export$6f965deda7f0960c(message) && (message?.message_metadata?.is_action_execution ?? false) && message?.message_metadata?.action_execution_result === 'SUCCESS';
const $c3ad42ae8c5c5089$export$1060c4fa97e34fa7 = (payloadContext)=>{
    return payloadContext?.resolution?.type === 'cancel';
};
const $c3ad42ae8c5c5089$export$6ce1ccc24e75456f = (error)=>(0, $8A2GO.isApiError)(error) && error.errorAttributes?.errorCode === $c3ad42ae8c5c5089$export$5945515082cc2cbf;
const $c3ad42ae8c5c5089$export$c3c933dad2745d3f = (msg)=>msg && msg.type === 'ACTION_ERROR' && msg.message && msg.message.status === 'ERRORED';
const $c3ad42ae8c5c5089$export$bc96a6a479480590 = (error)=>(0, $8A2GO.isApiError)(error) && error.errorAttributes.statusCode === 429;
const $c3ad42ae8c5c5089$export$f8b1b75846492611 = (error)=>(0, $8A2GO.isApiError)(error) && !!error.errorAttributes.errorCode && error.errorAttributes.errorCode === (0, $fCunh.ASSISTANCE_SERVICE_ERROR_CODES).HAS_HIPAA_ENABLED;
const $c3ad42ae8c5c5089$export$d263dc5d64f36d48 = (error)=>error instanceof Object && error?.detail?.type === 'ERROR' && !!error.errorAttributes.errorCode && error.errorAttributes.errorCode === $c3ad42ae8c5c5089$export$c424fe9570a5f2d9;
const $c3ad42ae8c5c5089$export$b454081350f4a578 = (message)=>message instanceof Object && message.type === 'CONVERSATION_CHANNEL_DATA';
const $c3ad42ae8c5c5089$export$145ab74998a54a20 = (message)=>message instanceof Object && message.type === 'SCOPE_DETERMINED';
const $c3ad42ae8c5c5089$export$75ceabc5bb9500e4 = (message)=>message instanceof Object && message.type === 'SPACE_SOURCE_RECOMMENDATIONS' && message.message instanceof Object;
const $c3ad42ae8c5c5089$export$f4111656f23d9b9b = (message)=>message instanceof Object && (message.type === 'PROMPT_REDACTION' || message.type === 'PROMPT_REDACTED');
const $c3ad42ae8c5c5089$export$c43cf9ba6a2176ef = (message)=>message instanceof Object && (message.type === 'PROMPT_BLOCKED' || message.type === 'PROMPT_BLOCK');
const $c3ad42ae8c5c5089$export$f16ff8eb19967a97 = (message)=>message instanceof Object && message.type === 'RESPONSE_REDACTION';
const $c3ad42ae8c5c5089$export$55f7bd80eacbc51b = (message)=>message instanceof Object && message.type === 'RESPONSE_BLOCKED';
const $c3ad42ae8c5c5089$export$a1be74470d3c1fe9 = (message)=>message instanceof Object && message.type === 'ATTACHMENT_BLOCKED';
function $c3ad42ae8c5c5089$export$4af48296a8d61cec(payloadContext) {
    return payloadContext?.resolution?.type === 'confirm';
}
module.exports["isSSEMessage"] = $c3ad42ae8c5c5089$export$f78edfe5a93b58af;
module.exports["ACCEPTABLE_USE_VIOLATIONS_ERROR"] = $c3ad42ae8c5c5089$export$c424fe9570a5f2d9;
module.exports["RESPONSE_TONES"] = $c3ad42ae8c5c5089$export$c162f3e7456e473f;
module.exports["RESPONSE_LENGTHS"] = $c3ad42ae8c5c5089$export$a461d78149e66005;
module.exports["RESPONSE_STRUCTURES"] = $c3ad42ae8c5c5089$export$42a434f431015fce;
module.exports["RESPONSE_EMOJIS"] = $c3ad42ae8c5c5089$export$312f4aeec9b65640;
module.exports["RESPONSE_TLDR_OPTIONS"] = $c3ad42ae8c5c5089$export$f3430750c3a3992d;
module.exports["SUGGESTED_PROMPT_TILE_STREAM_MESSAGE_TYPE"] = $c3ad42ae8c5c5089$export$77c9504201bdfdea;
module.exports["THIRD_PARTY_PROMPT_SOURCE_CONTENT_TYPE"] = $c3ad42ae8c5c5089$export$7fe06c6ae176663;
module.exports["normalizeEntityAnnotationsMessage"] = $c3ad42ae8c5c5089$export$d6de2556d50e53b4;
module.exports["isHumanMessage"] = $c3ad42ae8c5c5089$export$a69fab2afb88c2eb;
module.exports["isAssistantMessage"] = $c3ad42ae8c5c5089$export$6f965deda7f0960c;
module.exports["isStreamResponse"] = $c3ad42ae8c5c5089$export$b4631726cbc1440a;
module.exports["isSharedSnapshotMessage"] = $c3ad42ae8c5c5089$export$1af37a4715539580;
module.exports["isAgentResponse"] = $c3ad42ae8c5c5089$export$a6e5100ca2770191;
module.exports["isStreamMessageWithMessage"] = $c3ad42ae8c5c5089$export$2403e128f2e81f8f;
module.exports["isInProgressStreamResponse"] = $c3ad42ae8c5c5089$export$5c1c15675df13ae5;
module.exports["isStreamInteractionConclusion"] = $c3ad42ae8c5c5089$export$2d3cb9d520902824;
module.exports["isStreamError"] = $c3ad42ae8c5c5089$export$d422a2733a3b5def;
module.exports["isStreamAUPError"] = $c3ad42ae8c5c5089$export$1e1cf807ece63df4;
module.exports["isStreamAnswerPart"] = $c3ad42ae8c5c5089$export$e45102edbc73b240;
module.exports["isStreamEntityAnnotations"] = $c3ad42ae8c5c5089$export$6fb760a9d35f0551;
module.exports["isStreamReasoningPart"] = $c3ad42ae8c5c5089$export$51a109436d382715;
module.exports["isStreamActionPart"] = $c3ad42ae8c5c5089$export$dbf4211c9117b9bc;
module.exports["isStreamActionClassification"] = $c3ad42ae8c5c5089$export$3d7b0b359441d5a6;
module.exports["isStreamActionPrepare"] = $c3ad42ae8c5c5089$export$584e11c2903f4ed6;
module.exports["isStreamActionComplete"] = $c3ad42ae8c5c5089$export$7d94ce53d589f586;
module.exports["isStreamAutoActionApproval"] = $c3ad42ae8c5c5089$export$9082a8e48d820016;
module.exports["isStreamResearchStart"] = $c3ad42ae8c5c5089$export$abec64f24e2ec3e7;
module.exports["isStreamResearchBeginningTrace"] = $c3ad42ae8c5c5089$export$9c1f93971e9e3fbe;
module.exports["isStreamResearchStepContent"] = $c3ad42ae8c5c5089$export$79a0ed7d987faa8f;
module.exports["isStreamResearchStepTitle"] = $c3ad42ae8c5c5089$export$7b1c8227569f1a92;
module.exports["isStreamResearchPlan"] = $c3ad42ae8c5c5089$export$cde91b49af35d559;
module.exports["isStreamTodoSnapshot"] = $c3ad42ae8c5c5089$export$4a6a601f69cf3c74;
module.exports["isStreamTaskStatus"] = $c3ad42ae8c5c5089$export$6b0058543411cb3a;
module.exports["isStreamResearchStepTitleShort"] = $c3ad42ae8c5c5089$export$ac74da022f74040a;
module.exports["isStreamSkillStart"] = $c3ad42ae8c5c5089$export$7898cc38956b9052;
module.exports["isStreamSkillEnd"] = $c3ad42ae8c5c5089$export$bb608d13a1268633;
module.exports["isStreamFastModeResponseAvailable"] = $c3ad42ae8c5c5089$export$b65c73c7e2d8d96f;
module.exports["isStreamFastModeEnabled"] = $c3ad42ae8c5c5089$export$40cf419186312161;
module.exports["isStreamRemoveAnswerNow"] = $c3ad42ae8c5c5089$export$a83708fc4401682d;
module.exports["isStreamResearchStepSource"] = $c3ad42ae8c5c5089$export$68192da24ac8c141;
module.exports["isStreamResearchStepCompleted"] = $c3ad42ae8c5c5089$export$cfccfd17b68ccb0;
module.exports["isStreamResearchStepIcons"] = $c3ad42ae8c5c5089$export$1fd230d6956c2575;
module.exports["isStreamResearchStepDocument"] = $c3ad42ae8c5c5089$export$3bc697eeff31bdf6;
module.exports["isStreamReconnectSupportPart"] = $c3ad42ae8c5c5089$export$c679ee34f7312895;
module.exports["isStreamResearchPayload"] = $c3ad42ae8c5c5089$export$46e0fb5e4b019a49;
module.exports["isStreamSkill"] = $c3ad42ae8c5c5089$export$6f74311d40862a9f;
module.exports["isStreamMemoryUpdate"] = $c3ad42ae8c5c5089$export$d95e474df0d530df;
module.exports["isStreamTrace"] = $c3ad42ae8c5c5089$export$fd5a05be03f147a0;
module.exports["isStreamThinkDeeperTriggered"] = $c3ad42ae8c5c5089$export$682514f3a8131b98;
module.exports["isFollowUpMessage"] = $c3ad42ae8c5c5089$export$aeae5b4fda357302;
module.exports["isStreamAgenticUi"] = $c3ad42ae8c5c5089$export$6275ff996073145e;
module.exports["isStreamHeartbeat"] = $c3ad42ae8c5c5089$export$b46beea5c82aa1b9;
module.exports["isActionExecutedSuccessfully"] = $c3ad42ae8c5c5089$export$b8391261162989d9;
module.exports["isActionResolutionCancelled"] = $c3ad42ae8c5c5089$export$1060c4fa97e34fa7;
module.exports["isChannelNotFoundError"] = $c3ad42ae8c5c5089$export$6ce1ccc24e75456f;
module.exports["isStreamActionError"] = $c3ad42ae8c5c5089$export$c3c933dad2745d3f;
module.exports["isRateLimitedError"] = $c3ad42ae8c5c5089$export$bc96a6a479480590;
module.exports["isHipaaError"] = $c3ad42ae8c5c5089$export$f8b1b75846492611;
module.exports["isAUPViolationError"] = $c3ad42ae8c5c5089$export$d263dc5d64f36d48;
module.exports["isConversationChannelDataMessage"] = $c3ad42ae8c5c5089$export$b454081350f4a578;
module.exports["isScopeDeterminedMessage"] = $c3ad42ae8c5c5089$export$145ab74998a54a20;
module.exports["isSpaceSourceRecommendationsMessage"] = $c3ad42ae8c5c5089$export$75ceabc5bb9500e4;
module.exports["isStreamPromptRedaction"] = $c3ad42ae8c5c5089$export$f4111656f23d9b9b;
module.exports["isStreamPromptBlock"] = $c3ad42ae8c5c5089$export$c43cf9ba6a2176ef;
module.exports["isStreamResponseRedaction"] = $c3ad42ae8c5c5089$export$f16ff8eb19967a97;
module.exports["isStreamResponseBlock"] = $c3ad42ae8c5c5089$export$55f7bd80eacbc51b;
module.exports["isStreamAttachmentBlock"] = $c3ad42ae8c5c5089$export$a1be74470d3c1fe9;
module.exports["isConfirmAction"] = $c3ad42ae8c5c5089$export$4af48296a8d61cec;

});

parcelRegister("fCunh", function(module, exports) {
const $885d54b804b288bc$export$e8114853eca81277 = 'ai-mate';
const $885d54b804b288bc$export$1106bf31edf2a9b8 = {
    AGENT_DOES_NOT_EXIST: 'errorAgentNotFound',
    USER_NOT_CREATOR: 'errorIncorrectOwner',
    AGENT_HAS_CONVERSATIONS: 'errorAgentInUse',
    AGENT_DEACTIVATED: 'convoai.rest.bad.request.archived.agent',
    AGENT_FORBIDDEN: 'convoai.rest.agent-forbidden',
    ROVO_PRODUCT_NOT_ACTIVE: 'convoai.rest.rovo.product.not.active',
    HAS_HIPAA_ENABLED: 'convoai.rest.browsing.product.has.hipaa.enabled',
    FILE_SIZE_TOO_LARGE: 'convoai.rest.bad.request.file.size.too.large'
};
const $885d54b804b288bc$export$333e4f57333eadfa = {
    UNSUPPORTED_FILE_TYPE: 415,
    FILE_RAI_POLICY_VIOLATION: 406
};
module.exports["ASSISTANCE_SERVICE_ERROR_CODES"] = $885d54b804b288bc$export$1106bf31edf2a9b8;
module.exports["STATUS_CODES"] = $885d54b804b288bc$export$333e4f57333eadfa;

});

parcelRegister("8A2GO", function(module, exports) {
const $a4d06b5ca4d94b78$export$8de5b7b1f5c5cfb7 = 'convoai.rest.pinned.conversation.limit.exceeded';
class $a4d06b5ca4d94b78$export$f2e832acab1bdd79 extends Error {
    constructor(message, errorAttributes, data){
        super(message), this.message = message, this.errorAttributes = errorAttributes;
        /** Structured, non-user-facing details supplied by the API. */ this.data = void 0;
        this.data = data;
    }
}
const $a4d06b5ca4d94b78$export$89d83cc97c52a37 = (error)=>error instanceof $a4d06b5ca4d94b78$export$f2e832acab1bdd79;
const $a4d06b5ca4d94b78$var$getRecord = (value)=>typeof value === 'object' && value !== null && !Array.isArray(value) ? value : undefined;
const $a4d06b5ca4d94b78$var$getApiErrorAttributes = (error)=>{
    if ($a4d06b5ca4d94b78$export$89d83cc97c52a37(error)) return error.errorAttributes;
    return $a4d06b5ca4d94b78$var$getRecord($a4d06b5ca4d94b78$var$getRecord(error)?.errorAttributes);
};
const $a4d06b5ca4d94b78$var$getStructuredErrorData = (error)=>{
    const errorRecord = $a4d06b5ca4d94b78$var$getRecord(error);
    return $a4d06b5ca4d94b78$var$getRecord(errorRecord?.data) ?? $a4d06b5ca4d94b78$var$getRecord($a4d06b5ca4d94b78$var$getRecord(errorRecord?.errorAttributes)?.data);
};
const $a4d06b5ca4d94b78$var$getValidCount = (value, minimum)=>typeof value === 'number' && Number.isInteger(value) && value >= minimum ? value : undefined;
const $a4d06b5ca4d94b78$export$45f7ada0fbd007df = (error)=>{
    const errorAttributes = $a4d06b5ca4d94b78$var$getApiErrorAttributes(error);
    if (errorAttributes?.errorCode !== $a4d06b5ca4d94b78$export$8de5b7b1f5c5cfb7) return undefined;
    const data = $a4d06b5ca4d94b78$var$getStructuredErrorData(error);
    if (!data) return {};
    const maxPinnedConversations = $a4d06b5ca4d94b78$var$getValidCount(data.maxPinnedConversations, 1);
    const pinnedCount = $a4d06b5ca4d94b78$var$getValidCount(data.pinnedCount, 0);
    return {
        ...maxPinnedConversations !== undefined && {
            maxPinnedConversations: maxPinnedConversations
        },
        ...pinnedCount !== undefined && {
            pinnedCount: pinnedCount
        }
    };
};
const $a4d06b5ca4d94b78$export$3c02d1a328d4d808 = (error)=>{
    if ($a4d06b5ca4d94b78$export$89d83cc97c52a37(error)) return error;
    // Fallback since we expect the error to be an instance of ApiError
    return new $a4d06b5ca4d94b78$export$f2e832acab1bdd79(error.message, {
        statusCode: 0
    });
};
module.exports["ApiError"] = $a4d06b5ca4d94b78$export$f2e832acab1bdd79;
module.exports["isApiError"] = $a4d06b5ca4d94b78$export$89d83cc97c52a37;
module.exports["getPinnedConversationLimitErrorData"] = $a4d06b5ca4d94b78$export$45f7ada0fbd007df;
module.exports["mapErrorToApiError"] = $a4d06b5ca4d94b78$export$3c02d1a328d4d808;

});

parcelRegister("7zss8", function(module, exports) {

const $b3b3d72d5c15ae5d$export$caa27b16709bc2df = (product)=>{
    if (window) window.__ROVO_CHAT_CONFIG_PRODUCT__ = product;
};
module.exports["setRovoChatProduct"] = $b3b3d72d5c15ae5d$export$caa27b16709bc2df;

});

parcelRegister("gB5in", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

function $344aa3e9f3db9c3d$export$693ae5fbaa444eeb(params) {
    const { browserUrl: browserUrl, autoActionApprovalMode: autoActionApprovalMode, useCurrentBrowsingContext: useCurrentBrowsingContext, webSearchEnabled: webSearchEnabled, sourceMode: sourceMode, deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, alphaExtendedThinkingMode: alphaExtendedThinkingMode, fastModeEnabled: fastModeEnabled, planModeEnabled: planModeEnabled, editorContext: editorContext, whiteboardContext: whiteboardContext, slidesContext: slidesContext, databaseContext: databaseContext, dashboardEditorContext: dashboardEditorContext, browserContext: browserContext, isBrowserContextBlocklisted: isBrowserContextBlocklisted = false, jiraWorkflowContext: jiraWorkflowContext, additionalContext: additionalContext, writingStyleContext: writingStyleContext, dashboardContext: dashboardContext, aiFeatureContext: aiFeatureContext, fileIds: fileIds, knowledgeOverride: knowledgeOverride, selectedCloudIdsOverride: selectedCloudIdsOverride, searchArtifact: searchArtifact, shouldExtractConversationScopes: shouldExtractConversationScopes } = params;
    const isBrowserSelectionContextGateEnabled = (0, $iDrrr.fg)('rovo_chat_browser_selection_context');
    const browserSelection = isBrowserSelectionContextGateEnabled ? browserContext?.context?.selection : undefined;
    return {
        // without useCurrentBrowsingContext browser_url is not always used by the Rovo,
        // instead it depends on prompt intent to use it,
        // with useCurrentBrowsingContext we can ensure it is always used
        browser_url: browserUrl,
        ...autoActionApprovalMode ? {
            auto_action_approval_mode: autoActionApprovalMode
        } : {},
        ...useCurrentBrowsingContext === undefined ? {} : {
            useCurrentBrowsingContext: useCurrentBrowsingContext
        },
        webSearchEnabled: webSearchEnabled,
        ...sourceMode ? {
            sourceMode: sourceMode
        } : {},
        deepResearchEnabled: deepResearchEnabled,
        ...thinkDeeperEnabled ? {
            extendedThinkingEnabled: thinkDeeperEnabled
        } : {},
        ...alphaExtendedThinkingMode ? {
            alphaExtendedThinkingMode: alphaExtendedThinkingMode
        } : {},
        ...fastModeEnabled ? {
            fastModeEnabled: fastModeEnabled
        } : {},
        ...planModeEnabled ? {
            planModeEnabled: planModeEnabled,
            alphaExtendedThinkingMode: 'MARATHON',
            extendedThinkingEnabled: true
        } : {},
        ...editorContext ? {
            editor: editorContext
        } : {},
        ...whiteboardContext ? {
            whiteboardContext: whiteboardContext
        } : {},
        ...slidesContext ? {
            slidesContext: slidesContext
        } : {},
        ...databaseContext ? {
            databaseContext: databaseContext
        } : {},
        ...dashboardEditorContext ? {
            dashboardEditorContext: dashboardEditorContext
        } : {},
        // If browserUrl is inaccessible, fallback to htmlBody or canvasText if they exist
        // Do not send htmlBody or canvasText if the URL is blocklisted to ensure the site is truly not sent to the backend
        ...browserContext && !isBrowserContextBlocklisted ? {
            browser: {
                htmlBody: browserContext.context?.htmlBody,
                canvasText: browserContext.context?.canvasText,
                ...browserSelection ? {
                    selection: browserSelection
                } : {}
            }
        } : {},
        jiraWorkflowContext: jiraWorkflowContext,
        ...additionalContext,
        ...writingStyleContext ? {
            writingStyleContext: writingStyleContext
        } : {},
        dashboardContext: dashboardContext,
        aiFeatureContext: aiFeatureContext,
        fileIds: fileIds,
        ...knowledgeOverride,
        ...selectedCloudIdsOverride,
        ...searchArtifact ? {
            search_artifact: searchArtifact
        } : {},
        ...shouldExtractConversationScopes !== undefined ? {
            shouldExtractConversationScopes: shouldExtractConversationScopes
        } : {}
    };
}
module.exports["buildMessageStreamRequestContext"] = $344aa3e9f3db9c3d$export$693ae5fbaa444eeb;

});

parcelRegister("bQQtO", function(module, exports) {

var $4o0zT = parcelRequire("4o0zT");

const $c1455ae7f1250686$var$getMessageStreamHref = (product)=>{
    const backendOriginHost = window?.__backendOriginHost;
    if (product === 'confluence' && window.location.hostname === 'localhost' && typeof backendOriginHost === 'string') {
        const urlWithLocalhost = new URL(window.location.href);
        urlWithLocalhost.hostname = backendOriginHost;
        urlWithLocalhost.port = '';
        urlWithLocalhost.protocol = 'https:';
        return urlWithLocalhost.toString();
    }
    return window?.location?.href;
};
const $c1455ae7f1250686$export$d272e1989c4ab4bf = ({ browserContext: browserContext, browserContextSanitizer: browserContextSanitizer, product: product })=>{
    const browserContextUrl = browserContext?.context?.browserUrl;
    const isBrowserContextBlocklisted = Boolean(browserContextUrl && browserContextSanitizer?.isBlocklisted(browserContextUrl));
    const isBrowserUrlSuppressed = browserContextUrl === 'NO-URL' && (0, $4o0zT.isExperimentEnabled)('jira_free_gen_editor');
    if (isBrowserContextBlocklisted || isBrowserUrlSuppressed) return {
        browserUrl: '',
        isBrowserContextBlocklisted: isBrowserContextBlocklisted
    };
    return {
        browserUrl: browserContextUrl || $c1455ae7f1250686$var$getMessageStreamHref(product) || '',
        isBrowserContextBlocklisted: isBrowserContextBlocklisted
    };
};
module.exports["resolveMessageStreamBrowserUrl"] = $c1455ae7f1250686$export$d272e1989c4ab4bf;

});

parcelRegister("4o0zT", function(module, exports) {

var $cha5E = parcelRequire("cha5E");

function $36a5a3af492bc91f$export$336b018592dc9972(experimentName) {
    return (0, $cha5E.expVal)(experimentName, 'isEnabled', false) === true;
}
module.exports["isExperimentEnabled"] = $36a5a3af492bc91f$export$336b018592dc9972;

});

parcelRegister("fDfQA", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $k046L = parcelRequire("k046L");

async function* $6c7eb7a39a02f1c4$export$1f24b2b263bcfa75(response) {
    const reader = (0, $k046L.getBufferReader)(response);
    let doneStreaming = false;
    let remainder = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) try {
            const processedChunks = `${remainder}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            remainder = '';
            for (let chunk of processedChunks)try {
                const json = chunk.startsWith('data: ') && (0, $iDrrr.fg)('rovo-guard-ui-redaction-and-blocking') ? chunk.slice(6) : chunk;
                yield JSON.parse(json);
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                remainder = chunk;
            }
        } catch (e) {
            const error = new Error(`Error Processing Stream Data: ${value}`);
            throw error;
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else throw e;
    }
    while (!doneStreaming);
}
module.exports["readJsonStream"] = $6c7eb7a39a02f1c4$export$1f24b2b263bcfa75;

});

parcelRegister("k046L", function(module, exports) {
const $c70dfd75c754b14f$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};
module.exports["getBufferReader"] = $c70dfd75c754b14f$export$f6383c3ea1307da9;

});

parcelRegister("emCLk", function(module, exports) {

var $k046L = parcelRequire("k046L");

const $b3957af9ca78f17a$var$parseSSEMessage = (message)=>{
    const parsed = {};
    const dataLines = [];
    for (const line of message.split('\n')){
        const trimmedLine = line.trim();
        const colonIndex = trimmedLine.indexOf(':');
        if (trimmedLine && colonIndex !== -1) {
            const field = trimmedLine.substring(0, colonIndex);
            const value = trimmedLine.substring(colonIndex + 1).trimStart();
            switch(field){
                case 'event':
                    parsed.eventType = value;
                    break;
                case 'data':
                    dataLines.push(value);
                    break;
                case 'id':
                    parsed.id = value;
                    break;
                default:
                    break;
            }
        }
    }
    if (dataLines.length) parsed.data = dataLines.join('\n');
    return parsed;
};
async function* $b3957af9ca78f17a$export$6dab2f647580dc69(response) {
    const reader = (0, $k046L.getBufferReader)(response);
    let doneStreaming = false;
    let remainder = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) {
            const combined = `${remainder}${value}`;
            const parts = combined.split('\n\n'); // SSE messages are separated by double newlines
            // the last part may be incomplete — keep it for the next read
            remainder = parts.pop() ?? '';
            for (const chunk of parts)try {
                const parsed = $b3957af9ca78f17a$var$parseSSEMessage(chunk);
                if (parsed.data) {
                    const parsedData = JSON.parse(parsed.data);
                    yield {
                        __isSSEWrapper: true,
                        data: parsedData,
                        id: parsed.id,
                        eventType: parsed.eventType
                    };
                }
            } catch  {
            // ignore malformed JSON; keep streaming future valid messages
            }
        }
        // If the stream just ended and we still have a remainder, try to parse it once.
        if (doneStreaming && remainder) try {
            const parsed = $b3957af9ca78f17a$var$parseSSEMessage(remainder);
            if (parsed.data) {
                const parsedData = JSON.parse(parsed.data);
                yield {
                    __isSSEWrapper: true,
                    data: parsedData,
                    id: parsed.id,
                    eventType: parsed.eventType
                };
            }
        } catch  {
        // ignore malformed tail
        } finally{
            remainder = '';
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else throw e;
    }
    while (!doneStreaming);
}
module.exports["readSSEStream"] = $b3957af9ca78f17a$export$6dab2f647580dc69;

});

parcelRegister("5suST", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");

const $751ca72a9993528e$export$3b20549d55cda4db = 'store-message-from-user-settings';
const $751ca72a9993528e$export$bd10ff38e53e4101 = 'actionable-follow-ups';
const $751ca72a9993528e$export$f447b2e2b8f0d61e = 'actionable-follow-ups-stacked';
/**
 * Maps each gated capability to the gate/experiment that enables it. Add new
 * capability/gate pairs here rather than introducing nested ternaries at the
 * call sites.
 */ const $751ca72a9993528e$var$GATED_CAPABILITIES = [
    {
        capability: $751ca72a9993528e$export$3b20549d55cda4db,
        isEnabled: ()=>(0, $iDrrr.fg)('ai_mate_store_messages_be_driven')
    }
];
/** Maps an experiment cohort to the capability header it opts the request into. */ const $751ca72a9993528e$var$ACTIONABLE_FOLLOW_UPS_CAPABILITY_BY_COHORT = {
    control: undefined,
    inline: $751ca72a9993528e$export$bd10ff38e53e4101,
    stacked: $751ca72a9993528e$export$f447b2e2b8f0d61e
};
/**
 * Resolves the actionable follow-ups experiment cohort and FIRES an exposure.
 *
 * Exposure is fired here — at the point we decide which capability header to send —
 * so that all cohorts (including `control`, which never receives a `◈` marker from
 * the backend) are exposed equally. Firing on client-side marker detection instead
 * would never expose the control cohort and would imbalance the experiment.
 */ const $751ca72a9993528e$var$resolveActionableFollowUpsCohort = ()=>(0, $cXtTj.default).getExperimentValue('rovo_chat_actionable_follow_ups_exp', 'cohort', 'control');
const $751ca72a9993528e$export$6656e8be041b8747 = (capabilities)=>{
    const enabledCapabilities = $751ca72a9993528e$var$GATED_CAPABILITIES.filter(({ isEnabled: isEnabled })=>isEnabled()).map(({ capability: capability })=>capability);
    const followUpsCapability = $751ca72a9993528e$var$ACTIONABLE_FOLLOW_UPS_CAPABILITY_BY_COHORT[$751ca72a9993528e$var$resolveActionableFollowUpsCohort()];
    if (followUpsCapability) enabledCapabilities.push(followUpsCapability);
    // useRovoChatCapabilities adds `actionable-follow-ups` to the capabilities list for non-sendMessage requests
    // but we want the actual value of the experiment in this case and to avoid sending both
    // TODO: remove when the experiment is cleaned up and we can rely on useRovoChatCapabilities entirely
    const capabilitiesWithoutInlineFollowups = capabilities?.filter((capability)=>capability !== $751ca72a9993528e$export$bd10ff38e53e4101);
    if (enabledCapabilities.length === 0) return capabilitiesWithoutInlineFollowups;
    return Array.from(new Set([
        ...capabilitiesWithoutInlineFollowups ?? [],
        ...enabledCapabilities
    ]));
};
module.exports["buildEffectiveCapabilities"] = $751ca72a9993528e$export$6656e8be041b8747;

});

parcelRegister("irsyK", function(module, exports) {

var $8A2GO = parcelRequire("8A2GO");


var $jTKfH = parcelRequire("jTKfH");

const $c641c5a09bfdfc34$export$4c25481b843feb0b = (baseUrl, path)=>{
    if (path === '') // return base url without trailing slash
    return baseUrl;
    const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
    const url = [
        urlWithTrailingSlash,
        pathWithoutLeadingSlash
    ].join('');
    return url;
};
const $c641c5a09bfdfc34$var$removeTimestampFromErrorMessage = (errorBodyJson)=>{
    const { timestamp: _timestamp, ...rest } = errorBodyJson;
    return JSON.stringify(rest);
};
const $c641c5a09bfdfc34$var$processErrorResponse = async ({ response: response })=>{
    let errorCode;
    let outputErrorMessage;
    const responseText = await response.text();
    let rawErrorMessage;
    let data;
    try {
        const errorBodyJson = JSON.parse(responseText);
        const { data: responseData, error_code: error_code, error_message: error_message, message_template: message_template, errors: errors, errorMessage: errorMessage, timestamp: timestamp } = errorBodyJson;
        data = typeof responseData === 'object' && responseData !== null && !Array.isArray(responseData) ? responseData : undefined;
        rawErrorMessage = errorMessage ?? error_message;
        if (errors?.length) // Use a single error code for now
        errorCode = errors[0];
        else if (error_code) errorCode = error_code;
        else errorCode = message_template;
        if (!errorCode || !rawErrorMessage) outputErrorMessage = timestamp ? $c641c5a09bfdfc34$var$removeTimestampFromErrorMessage(errorBodyJson) : responseText;
        else outputErrorMessage = `${errorCode} - ${rawErrorMessage}`;
    } catch  {
        outputErrorMessage = responseText;
    }
    const errorMessage = `[Code ${response.status}] ${outputErrorMessage}`;
    const errorAttributes = {
        errorCode: errorCode,
        statusCode: response.status,
        rawErrorMessage: rawErrorMessage,
        traceId: (0, $jTKfH.getTraceIdFromResponse)(response)
    };
    throw new (0, $8A2GO.ApiError)(errorMessage, errorAttributes, data);
};
const $c641c5a09bfdfc34$export$21fcb6cfd5628534 = async ({ response: response })=>{
    if (!response.ok || response.status >= 400) await $c641c5a09bfdfc34$var$processErrorResponse({
        response: response
    });
    return response;
};
module.exports["addPath"] = $c641c5a09bfdfc34$export$4c25481b843feb0b;
module.exports["processResponse"] = $c641c5a09bfdfc34$export$21fcb6cfd5628534;

});

parcelRegister("7td41", function(module, exports) {
const $00fdf2622c1683af$export$11cc4786742ed7c2 = ()=>{
    const date = new Date();
    const formattedDate = date.toLocaleDateString(undefined, {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit'
    });
    const formattedTime = date.toLocaleTimeString(undefined, {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    });
    const name = `${formattedDate} ${formattedTime}`;
    return name;
};
module.exports["generateConversationName"] = $00fdf2622c1683af$export$11cc4786742ed7c2;

});

parcelRegister("bkEBw", function(module, exports) {

var $bxkJA = parcelRequire("bxkJA");


var $3PJhM = parcelRequire("3PJhM");

const $ac118120c3114919$export$218c8c3169c024d2 = (streamResponse)=>streamResponse.message.message.id;
const $ac118120c3114919$var$addAnswerPartAssistantMessage = (response, answerPart)=>{
    const content = `${response.content}${answerPart.message.content}`;
    // Remove source indexes, e.g [^1^] from the content
    const cleanedContent = content.replace(/\[\^\d+\^\]/g, '');
    return {
        ...response,
        content: cleanedContent
    };
};
const $ac118120c3114919$var$addAnswerPartAgentResponse = (response, answerPart)=>({
        ...response,
        message: $ac118120c3114919$var$addAnswerPartAssistantMessage(response.message, answerPart)
    });
// ****************************************************************************
// Action streaming accumulation configuration
// ****************************************************************************
const $ac118120c3114919$var$toPathArr = (path)=>Array.isArray(path) ? path : path.split('.').filter(Boolean);
const $ac118120c3114919$var$getAtPath = (obj, path)=>{
    let cur = obj;
    for (const key of path){
        if (!(0, $3PJhM.isRecord)(cur)) return undefined;
        cur = cur[key];
    }
    return cur;
};
const $ac118120c3114919$var$setAtPath = (obj, path, value)=>{
    if (path.length === 0) return value;
    const [head, ...rest] = path;
    const base = (0, $3PJhM.isRecord)(obj) ? obj : {};
    return {
        ...base,
        [head]: $ac118120c3114919$var$setAtPath(base[head], rest, value)
    };
};
// Defines which sub-field(s) of a message action's data should be accumulated by string appending.
// Keyed by action key. Values can be a dot path or an array path, or an array of multiple paths.
// E.g.:
// {
//   'create-document-action': 'content',
//   'update-document-action': ['content', 'meta.subtitle']
// }
let $ac118120c3114919$var$actionDataAccumulationConfig = {
    ['aifc-confluence-page-create']: 'adf'
};
const $ac118120c3114919$export$a1715e22f3105088 = (prev, next)=>{
    const key = next.key;
    const rulePaths = $ac118120c3114919$var$actionDataAccumulationConfig[key];
    const prevData = prev?.data;
    const newData = next?.data;
    if (rulePaths && typeof prevData === 'object' && prevData !== null && typeof newData === 'object' && newData !== null) {
        const paths = Array.isArray(rulePaths) ? rulePaths : [
            rulePaths
        ];
        let base = {
            ...newData
        };
        for (const p of paths){
            const pathArr = $ac118120c3114919$var$toPathArr(p);
            const prevVal = $ac118120c3114919$var$getAtPath(prevData, pathArr);
            const nextVal = $ac118120c3114919$var$getAtPath(newData, pathArr);
            const accumulated = String(prevVal ?? '') + String(nextVal ?? '');
            const updated = $ac118120c3114919$var$setAtPath(base, pathArr, accumulated);
            // `setAtPath` only returns the raw `value` when the path is empty; here
            // `pathArr` is always non-empty (derived from a configured rule path), so
            // the result is always the spread record branch.
            if ((0, $3PJhM.isRecord)(updated)) base = updated;
        }
        return {
            ...prev,
            data: base,
            status: next.status
        };
    }
    // Default: replace only data from next, keep other fields from prev
    return {
        ...prev,
        data: next.data,
        status: next.status
    };
};
const $ac118120c3114919$export$6554ad578994a75f = (actions, actionPart, actionUpdaterOverride)=>{
    const { key: key, invocationId: invocationId } = actionPart.message;
    // Accumulate by `invocationId` when the part has one, so multiple same-`key` actions (e.g. several
    // page creates in a single message) stream independently; fall back to `key` for parts without an
    // invocationId. For single-action messages both resolve to the same action, so no experiment gate
    // is needed here.
    const existingActionIndex = invocationId ? actions.findIndex((action)=>action.invocationId === invocationId) : actions.findIndex((action)=>action.key === key);
    if (existingActionIndex === -1) return [
        ...actions || [],
        actionPart.message
    ];
    const updatedActions = [
        ...actions
    ];
    const prevAction = updatedActions[existingActionIndex];
    const nextAction = actionPart.message;
    updatedActions[existingActionIndex] = actionUpdaterOverride ? actionUpdaterOverride(prevAction, nextAction) : $ac118120c3114919$export$a1715e22f3105088(prevAction, nextAction);
    return updatedActions;
};
const $ac118120c3114919$export$6e5609c05ab74cc7 = (response, answerPart)=>({
        ...response,
        message: $ac118120c3114919$var$addAnswerPartAgentResponse(response.message, answerPart)
    });
const $ac118120c3114919$export$13b6a4e4e3704011 = (response, actionPart, actionUpdaterOverride)=>{
    const { message: message } = response.message;
    const { actions: actions } = message;
    const isActionsArrayPresent = actions && actions.length > 0;
    return {
        ...response,
        message: {
            ...response.message,
            message: {
                ...message,
                actions: !isActionsArrayPresent ? [
                    actionPart.message
                ] : $ac118120c3114919$export$6554ad578994a75f(actions, actionPart, actionUpdaterOverride)
            }
        }
    };
};
const $ac118120c3114919$var$removeSensitiveDataAssistantMessage = (message)=>{
    const { plugin_invocations: plugin_invocations, ...rest } = message;
    return {
        ...rest,
        plugin_invocations: plugin_invocations.map((pluginInvocation)=>({
                ...pluginInvocation,
                plugin_output: '--PRIVATE--'
            }))
    };
};
const $ac118120c3114919$var$removeSensitiveDataAgentResponse = (message)=>({
        ...message,
        message: $ac118120c3114919$var$removeSensitiveDataAssistantMessage(message.message)
    });
const $ac118120c3114919$export$efd4f6b5d168b654 = (message)=>({
        ...message,
        message: $ac118120c3114919$var$removeSensitiveDataAgentResponse(message.message)
    });
const $ac118120c3114919$export$4c47ae95c311c518 = '00000000-0000-0000-0000-000000000000';
const $ac118120c3114919$export$4010f996e89e886a = (id, content, isFromSeededConversation, requestId, fileUploads, displayContext)=>{
    return {
        role: 'HUMAN',
        id: id,
        content: content,
        time_created: new Date().toISOString(),
        user_ari: 'unknown',
        plugin_invocations: [],
        isFromSeededConversation: isFromSeededConversation,
        requestId: requestId,
        file_uploads: fileUploads,
        ...displayContext ? {
            display_context: displayContext
        } : {}
    };
};
const $ac118120c3114919$export$3220a4ff7b3a96df = (message)=>{
    if ((0, $bxkJA.isAgentResponse)(message)) return {
        type: 'FINAL_RESPONSE',
        message: message
    };
    return {
        type: 'FINAL_RESPONSE',
        message: {
            message: message
        }
    };
};
module.exports["getId"] = $ac118120c3114919$export$218c8c3169c024d2;
module.exports["addAnswerPart"] = $ac118120c3114919$export$6e5609c05ab74cc7;
module.exports["addActionPart"] = $ac118120c3114919$export$13b6a4e4e3704011;
module.exports["removeSensitiveData"] = $ac118120c3114919$export$efd4f6b5d168b654;
module.exports["NO_PARENT_MESSAGE_ID"] = $ac118120c3114919$export$4c47ae95c311c518;
module.exports["createHumanMessage"] = $ac118120c3114919$export$4010f996e89e886a;
module.exports["toStreamResponse"] = $ac118120c3114919$export$3220a4ff7b3a96df;

});

parcelRegister("isp1U", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $dOBRD = parcelRequire("dOBRD");


var $2A9fJ = parcelRequire("2A9fJ");

const $2def26aed08f588d$var$fetchProfileData = (0, $dOBRD.default)(async ()=>{
    const data = await (0, $2A9fJ.me)();
    return {
        aaid: data.account_id,
        name: data.name || '',
        displayName: data.nickname,
        avatarUrl: data.picture,
        email: data.email,
        organization: data.extended_profile?.organization
    };
});
const $2def26aed08f588d$export$3c814b55c7cbb1fb = (0, $cozmU.createContext)(null);
const $2def26aed08f588d$var$emptyProfileData = {
    name: '',
    displayName: '',
    avatarUrl: ''
};
const $2def26aed08f588d$export$68afc71177137005 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (preFetchedProfileData)=>{
    const $ = (0, $bDgLe.c)(4);
    const [profileData, setProfileData] = (0, $cozmU.useState)($2def26aed08f588d$var$emptyProfileData);
    const profileContextData = (0, $cozmU.useContext)($2def26aed08f588d$export$3c814b55c7cbb1fb);
    let t0;
    let t1;
    if ($[0] !== preFetchedProfileData || $[1] !== profileContextData) {
        t0 = ()=>{
            if (preFetchedProfileData) setProfileData(preFetchedProfileData);
            else if (profileContextData) setProfileData(profileContextData);
            else $2def26aed08f588d$var$fetchProfileData().then((data)=>setProfileData(data)).catch(()=>setProfileData($2def26aed08f588d$var$emptyProfileData));
        };
        t1 = [
            setProfileData,
            profileContextData,
            preFetchedProfileData
        ];
        $[0] = preFetchedProfileData;
        $[1] = profileContextData;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return profileData;
} : (preFetchedProfileData)=>{
    const [profileData, setProfileData] = (0, $cozmU.useState)($2def26aed08f588d$var$emptyProfileData);
    const profileContextData = (0, $cozmU.useContext)($2def26aed08f588d$export$3c814b55c7cbb1fb);
    (0, $cozmU.useEffect)(()=>{
        if (preFetchedProfileData) setProfileData(preFetchedProfileData);
        else if (profileContextData) setProfileData(profileContextData);
        else $2def26aed08f588d$var$fetchProfileData().then((data)=>setProfileData(data)).catch(()=>setProfileData($2def26aed08f588d$var$emptyProfileData));
    }, [
        setProfileData,
        profileContextData,
        preFetchedProfileData
    ]);
    return profileData;
};
module.exports["useProfileController"] = $2def26aed08f588d$export$68afc71177137005;

});

parcelRegister("2A9fJ", function(module, exports) {

var $jTKfH = parcelRequire("jTKfH");

const $baf5ee02956fd5a8$export$3e32638432616b6 = async ()=>{
    const response = await (0, $jTKfH.performHttpFetch)({
        path: '/gateway/api/me',
        options: {
            method: 'GET'
        }
    });
    return response;
};
module.exports["me"] = $baf5ee02956fd5a8$export$3e32638432616b6;

});

parcelRegister("gyWKg", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $1VhsF = parcelRequire("1VhsF");


var $hlvTd = parcelRequire("hlvTd");


var $iuCeV = parcelRequire("iuCeV");

function $e5d42e7967be8c63$var$_defineProperty(e, r, t) {
    return (r = $e5d42e7967be8c63$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $e5d42e7967be8c63$var$_toPropertyKey(t) {
    var i = $e5d42e7967be8c63$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $e5d42e7967be8c63$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $e5d42e7967be8c63$var$styles = {
    wrapper: "_0jFU0VN91d _39xV02N91d _0KLXruhH7k"
};
const $e5d42e7967be8c63$var$ErrorView = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { error: error } = t0;
    let t1;
    if ($[0] !== error) {
        t1 = error?.message ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "p"
        }, "[", error.message, "]") : null;
        $[0] = error;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            alignInline: "center",
            xcss: $e5d42e7967be8c63$var$styles.wrapper,
            testId: "ai-mate-error-boundary"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
            title: "Oops. We've got an error.",
            appearance: "error"
        }, t1)));
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ error: error })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        alignInline: "center",
        xcss: $e5d42e7967be8c63$var$styles.wrapper,
        testId: "ai-mate-error-boundary"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
        title: "Oops. We've got an error.",
        appearance: "error"
    }, error?.message ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "p"
    }, "[", error.message, "]") : null)));
};
class $e5d42e7967be8c63$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidCatch(error) {
        (0, $hlvTd.addSentryBreadcrumb)(`ErrorBoundary: componentDidCatch: ${error.message}`);
        this.setState({
            error: error
        });
        if (this.props.rethrowErrors) throw error;
    }
    render() {
        const { error: error } = this.state;
        const { children: children, experienceName: experienceName, experienceNameList: experienceNameList } = this.props;
        if (!!error) {
            const combinedExperienceNameList = [
                ...new Set([
                    ...experienceNameList || [],
                    experienceName
                ])
            ].filter((experienceName)=>experienceName !== undefined);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, this.props.fallback ? this.props.fallback : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e5d42e7967be8c63$var$ErrorView, {
                error: error
            }), combinedExperienceNameList.map((experienceName)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceFailure), {
                    error: error,
                    name: experienceName
                })));
        }
        return children;
    }
    constructor(...args){
        super(...args);
        $e5d42e7967be8c63$var$_defineProperty(this, "state", {});
    }
}
$e5d42e7967be8c63$var$_defineProperty($e5d42e7967be8c63$export$e926676385687eaf, "displayName", 'ConversationAssistantErrorBoundary');
module.exports["ErrorBoundary"] = $e5d42e7967be8c63$export$e926676385687eaf;

});

parcelRegister("iuCeV", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $bjY3F = parcelRequire("bjY3F");

const $4726ba45c1bca0cb$export$4962f3898bd5c829 = ({ name: name, trigger: trigger = 'mount', attributes: attributes })=>{
    (0, $6cFsl.di)((0, $bjY3F.useAIMateExperienceTracker));
    const successTriggerRef = (0, $cozmU.useRef)(trigger);
    const attributesRef = (0, $cozmU.useRef)(attributes);
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    (0, $cozmU.useEffect)(()=>{
        const successAttributes = attributesRef.current;
        if (successTriggerRef.current === 'mount') experienceTracker.succeed({
            name: name,
            ...successAttributes && {
                attributes: successAttributes
            }
        });
        if (successTriggerRef.current === 'unmount') return ()=>{
            experienceTracker.succeed({
                name: name,
                ...successAttributes && {
                    attributes: successAttributes
                }
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
const $4726ba45c1bca0cb$export$eed1d73ebdd8c7ab = ({ error: error, name: name })=>{
    (0, $6cFsl.di)((0, $bjY3F.useAIMateExperienceTracker));
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    (0, $cozmU.useEffect)(()=>{
        experienceTracker.fail({
            name: name,
            error: error
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
const $4726ba45c1bca0cb$export$f20b867e738a222c = ({ name: name, attributes: attributes })=>{
    (0, $6cFsl.di)((0, $bjY3F.useAIMateExperienceTracker));
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    (0, $cozmU.useMemo)(()=>{
        experienceTracker.start({
            id: name,
            name: name,
            attributes: attributes
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
module.exports["ExperienceSuccess"] = $4726ba45c1bca0cb$export$4962f3898bd5c829;
module.exports["ExperienceFailure"] = $4726ba45c1bca0cb$export$eed1d73ebdd8c7ab;
module.exports["ExperienceStart"] = $4726ba45c1bca0cb$export$f20b867e738a222c;

});

parcelRegister("6H2Ay", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8wqiw = parcelRequire("8wqiw");

const $e3dfb33e54e47641$export$f9cd1e43211d8a4a = (0, $cozmU.createContext)((0, $8wqiw.initialState));
module.exports["globalConfig"] = $e3dfb33e54e47641$export$f9cd1e43211d8a4a;

});

parcelRegister("8wqiw", function(module, exports) {
const $fc6f73f3a32dac3c$export$d4c72bab9d6cc13a = {
    profileData: {
        name: 'John Doe'
    },
    feedbackCollector: {
        entryPointId: ''
    },
    siteId: '',
    experienceId: '',
    productKey: '',
    productHeader: '',
    orgId: '',
    assistanceServiceConfig: undefined,
    closeChat: ()=>{},
    emojiProvider: undefined,
    preventAbortRequestsOnStagingModalClose: false,
    preventAbortRequestsOnStandaloneChatClose: false,
    inProductExperience: '',
    smartCreationContext: undefined,
    autocompletePageContentSource: undefined,
    contextualPromptAnalyticsMetadata: undefined,
    analyticsProductHeader: undefined
};
module.exports["initialState"] = $fc6f73f3a32dac3c$export$d4c72bab9d6cc13a;

});

parcelRegister("atEX8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $a771a20ee041d8be$export$33f9eded602e3caf = (0, $cozmU.createContext)(undefined);
module.exports["SideNavContext"] = $a771a20ee041d8be$export$33f9eded602e3caf;

});

parcelRegister("blKf8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $2zlSy = parcelRequire("2zlSy");

const $25b69de57535dd1e$export$c85ba824665b708f = (0, $cozmU.createContext)((0, $2zlSy.initialState));
module.exports["uiConfig"] = $25b69de57535dd1e$export$c85ba824665b708f;

});

parcelRegister("2zlSy", function(module, exports) {
const $25fc89fcc6d2e62b$export$d4c72bab9d6cc13a = {
    fullScreen: false,
    externalEmbed: false,
    preserveUrlConversationId: false,
    isContextPanelEnabled: false,
    customHandlers: {
        handleDeepLinkClick: undefined,
        handleSubmitSmartCreate: ()=>{}
    },
    isBitbucketBetaEnabled: false,
    customFeedbackCategories: undefined,
    stagingAreaRef: undefined,
    promptInputDroppableUrls: undefined,
    enableBrowserContextBanner: false,
    disableSettingsModal: false,
    enableSkills: true,
    enableAutoSuggest: true,
    enableMiniModalResize: true,
    browserContextSanitizer: undefined,
    elements: {
        closeButton: true,
        backButton: true,
        newChatButton: true,
        fullscreenButton: true,
        createAgentButton: true,
        browseAgentsButton: true,
        agentsMenu: true,
        navbar: true,
        mainChatHeader: true,
        stagingAreaEnabled: false,
        voiceDictationButton: false,
        fileUploadButton: true,
        chatModeMenuButton: true,
        maxModeButton: true,
        shouldShowConversationActions: true,
        shouldShowContextBanner: true
    }
};
module.exports["initialState"] = $25fc89fcc6d2e62b$export$d4c72bab9d6cc13a;

});

parcelRegister("c69qG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $12fb09f9899d13ab$export$dfdd5bb3b7412d6d = (0, $cozmU.createContext)(undefined);
module.exports["agentVersioningConfigContext"] = $12fb09f9899d13ab$export$dfdd5bb3b7412d6d;

});

parcelRegister("j180q", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");


var $89QZA = parcelRequire("89QZA");


var $bGNkz = parcelRequire("bGNkz");


var $eKjv9 = parcelRequire("eKjv9");


var $dSCNl = parcelRequire("dSCNl");


var $n71o5 = parcelRequire("n71o5");


var $5wAPd = parcelRequire("5wAPd");

const $044e4eae4d9054a7$export$18774f6b5154d8f2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const { mode: mode } = t0;
    const [t1] = (0, $n71o5.useChatStore)();
    const { currentConversationId: currentConversationId } = t1;
    const { experienceId: experienceId, productKey: productKey, productHeader: productHeader, assistanceServiceConfig: assistanceServiceConfig, inProductExperience: inProductExperience } = (0, $eKjv9.useGlobalConfig)();
    const { selectedAgent: selectedAgent, conversation: conversation } = (0, $5wAPd.useConversation)();
    const { setAnalyticsPropertiesWithoutRerender: setAnalyticsPropertiesWithoutRerender } = (0, $89QZA.useAnalyticsPropertiesContext)();
    const { fullScreen: fullScreen } = (0, $dSCNl.useUIConfig)();
    const [t2] = (0, $bGNkz.useSelectedSpaceSelector)();
    const { selectedSpace: selectedSpace } = t2;
    const modeVal = fullScreen ? "fullscreen" : mode;
    const resolvedSpaceId = (0, $cXtTj.default).getExperimentValue("rovo_chat_spaces_experiment", "isEnabled", false) ? selectedSpace?.id ?? conversation?.rovoSpaceId : undefined;
    const agentAttributes = {
        agentCreatorType: selectedAgent?.creator_type ?? null,
        agentId: selectedAgent?.id ?? null,
        agentVisibility: selectedAgent?.visibility ?? null,
        agentExternalConfigReference: selectedAgent?.external_config_reference ?? null,
        agentActions: ((0, $iDrrr.fg)("rovo_autodev_analytics_track_actions") ? selectedAgent?.action_config?.map($044e4eae4d9054a7$var$_temp) : []) ?? [],
        agentIsDefault: selectedAgent?.is_default ?? null,
        agentIsVerified: selectedAgent?.is_verified ?? null
    };
    setAnalyticsPropertiesWithoutRerender({
        ...agentAttributes,
        conversationChannelId: currentConversationId,
        experienceId: experienceId,
        fullScreen: fullScreen,
        mode: modeVal,
        product: productKey,
        productHeader: productHeader,
        inProductExperience: inProductExperience,
        singleInstrumentationID: currentConversationId,
        assistanceServiceConfigMinionAlias: assistanceServiceConfig?.minionAlias ?? null,
        spaceId: resolvedSpaceId,
        ...(0, $iDrrr.fg)("rovo_chat_entry_point_foundation") ? {
            chatEntryPoint: conversation?.chatEntryPoint
        } : {},
        launchSource: conversation?.resultAttributionContext?.launchSource,
        rovoJourneyId: conversation?.rovoJourneyId,
        isThirdPartyPromptConversation: conversation?.thirdPartyPrompt ? true : undefined,
        thirdPartyPromptCohort: conversation?.thirdPartyPrompt?.cohort,
        thirdPartyConnectCount: conversation?.thirdPartyPrompt?.connectCount
    });
    return null;
} : ({ mode: mode })=>{
    const [{ currentConversationId: currentConversationId }] = (0, $n71o5.useChatStore)();
    const { experienceId: experienceId, productKey: productKey, productHeader: productHeader, assistanceServiceConfig: assistanceServiceConfig, inProductExperience: inProductExperience } = (0, $eKjv9.useGlobalConfig)();
    const { selectedAgent: selectedAgent, conversation: conversation } = (0, $5wAPd.useConversation)();
    const { setAnalyticsPropertiesWithoutRerender: setAnalyticsPropertiesWithoutRerender } = (0, $89QZA.useAnalyticsPropertiesContext)();
    const { fullScreen: fullScreen } = (0, $dSCNl.useUIConfig)();
    const [{ selectedSpace: selectedSpace }] = (0, $bGNkz.useSelectedSpaceSelector)();
    const modeVal = fullScreen ? 'fullscreen' : mode;
    // When the chat is scoped to a Rovo Space, tag every fired event with the
    // spaceId (mirrors the resolution used at message-send time in
    // chat-input-refresh) so "Space MAU" — unique users who initiate a chat in a
    // space — is measurable from the standard AI MAU `initiated`/`viewed` events.
    // Resolves to `undefined` (never `null`) when there is no active space so the
    // attribute is omitted from non-space events, and — because it is always
    // written below — a previously-set spaceId is cleared when the user moves from
    // a space-scoped chat back to a general one.
    const resolvedSpaceId = (0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false) ? selectedSpace?.id ?? conversation?.rovoSpaceId : undefined;
    const agentAttributes = {
        agentCreatorType: selectedAgent?.creator_type ?? null,
        agentId: selectedAgent?.id ?? null,
        agentVisibility: selectedAgent?.visibility ?? null,
        agentExternalConfigReference: selectedAgent?.external_config_reference ?? null,
        agentActions: ((0, $iDrrr.fg)('rovo_autodev_analytics_track_actions') ? selectedAgent?.action_config?.map((config)=>config.id) : []) ?? [],
        agentIsDefault: selectedAgent?.is_default ?? null,
        agentIsVerified: selectedAgent?.is_verified ?? null
    };
    setAnalyticsPropertiesWithoutRerender({
        ...agentAttributes,
        conversationChannelId: currentConversationId,
        experienceId: experienceId,
        fullScreen: fullScreen,
        mode: modeVal,
        product: productKey,
        productHeader: productHeader,
        inProductExperience: inProductExperience,
        singleInstrumentationID: currentConversationId,
        assistanceServiceConfigMinionAlias: assistanceServiceConfig?.minionAlias ?? null,
        // Always written (not conditionally spread) so switching away from a space
        // clears the previous spaceId; `undefined` is omitted from event payloads.
        spaceId: resolvedSpaceId,
        // Always write this while the gate is enabled so a conversation without an entry point
        // clears the value inherited from the previous conversation.
        ...(0, $iDrrr.fg)('rovo_chat_entry_point_foundation') ? {
            chatEntryPoint: conversation?.chatEntryPoint
        } : {},
        // Launch source from the conversation, surfaced on all fired events.
        launchSource: conversation?.resultAttributionContext?.launchSource,
        // Always write this so switching conversations also clears stale journey attribution.
        rovoJourneyId: conversation?.rovoJourneyId,
        // Mirrored from the conversation, always written for the same reason as `spaceId`: this is
        // what clears the attributes when the chat moves to a conversation that did not come from
        // a 3P prompt (CCINT-8714).
        isThirdPartyPromptConversation: conversation?.thirdPartyPrompt ? true : undefined,
        thirdPartyPromptCohort: conversation?.thirdPartyPrompt?.cohort,
        thirdPartyConnectCount: conversation?.thirdPartyPrompt?.connectCount
    });
    return null;
};
function $044e4eae4d9054a7$var$_temp(config) {
    return config.id;
}
module.exports["AnalyticsPropertiesUpdater"] = $044e4eae4d9054a7$export$18774f6b5154d8f2;

});

parcelRegister("eKjv9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $6H2Ay = parcelRequire("6H2Ay");

const $964b2b4aa2fb5756$export$29031ce8b4e54e85 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)((0, $6H2Ay.globalConfig));
} : ()=>(0, $cozmU.useContext)((0, $6H2Ay.globalConfig));
module.exports["useGlobalConfig"] = $964b2b4aa2fb5756$export$29031ce8b4e54e85;

});

parcelRegister("dSCNl", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $blKf8 = parcelRequire("blKf8");

const $78dfed354051ab06$export$e83755c3ab7a4493 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)((0, $blKf8.uiConfig));
} : ()=>(0, $cozmU.useContext)((0, $blKf8.uiConfig));
module.exports["useUIConfig"] = $78dfed354051ab06$export$e83755c3ab7a4493;

});

parcelRegister("n71o5", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");


var $lx3cN = parcelRequire("lx3cN");


var $3TrVh = parcelRequire("3TrVh");

/**
 * ************************************************************
 * Main Hook
 * ************************************************************
 */ const $cea7beaf4fdf86cd$var$publicStateSelector = (state)=>{
    return {
        ...state,
        checkActiveConversationMatchesSource: (id)=>{
            return (0, $3TrVh.checkActiveConversationMatchesSource)(state, id);
        }
    };
};
const $cea7beaf4fdf86cd$export$5ca9bbfceeb3b458 = (0, $kBr4q.createHook)((0, $lx3cN.chatStore), {
    selector: $cea7beaf4fdf86cd$var$publicStateSelector
});
module.exports["useChatStore"] = $cea7beaf4fdf86cd$export$5ca9bbfceeb3b458;

});

parcelRegister("3TrVh", function(module, exports) {
const $8991d15323cea08f$export$80b847bfebcaa3fd = (state, id)=>{
    return !!id && state.conversations[state.currentConversationId]?.sourceId === id;
};
module.exports["checkActiveConversationMatchesSource"] = $8991d15323cea08f$export$80b847bfebcaa3fd;

});

parcelRegister("5wAPd", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $n71o5 = parcelRequire("n71o5");


var $i4nJ0 = parcelRequire("i4nJ0");

const $2344621fd00df2c4$export$626f7ff9a7747889 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { conversationId: conversationIdParam, assistanceServiceParams: assistanceServiceParams } = t1;
    const [t2] = (0, $n71o5.useChatStore)();
    const { currentConversationId: currentConversationId, conversations: conversations } = t2;
    const conversationId = conversationIdParam ?? currentConversationId;
    const conversation = conversations[conversationId];
    let t3;
    if ($[2] !== assistanceServiceParams || $[3] !== conversation || $[4] !== conversationId) {
        t3 = {
            conversationId: conversationId,
            conversation: conversation,
            assistanceServiceParams: assistanceServiceParams
        };
        $[2] = assistanceServiceParams;
        $[3] = conversation;
        $[4] = conversationId;
        $[5] = t3;
    } else t3 = $[5];
    return (0, $i4nJ0.useConversationData)(t3);
} : ({ conversationId: conversationIdParam, assistanceServiceParams: assistanceServiceParams } = {})=>{
    const [{ currentConversationId: currentConversationId, conversations: conversations }] = (0, $n71o5.useChatStore)();
    const conversationId = conversationIdParam ?? currentConversationId;
    const conversation = conversations[conversationId];
    return (0, $i4nJ0.useConversationData)({
        conversationId: conversationId,
        conversation: conversation,
        assistanceServiceParams: assistanceServiceParams
    });
};
module.exports["useConversation"] = $2344621fd00df2c4$export$626f7ff9a7747889;

});

parcelRegister("i4nJ0", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $37RgG = parcelRequire("37RgG");


var $3z1p5 = parcelRequire("3z1p5");


var $igOtY = parcelRequire("igOtY");


var $iW40i = parcelRequire("iW40i");


var $6YdPR = parcelRequire("6YdPR");


var $gn6Jj = parcelRequire("gn6Jj");


var $222kR = parcelRequire("222kR");


var $1IZrU = parcelRequire("1IZrU");


var $dvUlt = parcelRequire("dvUlt");

const $daf188600e0350bc$var$createProvisionalSelectedAgent = (conversationAgent)=>{
    const conversationAgentId = conversationAgent?.agent_id;
    if (!conversationAgentId) return undefined;
    const conversationAgentCreatorType = conversationAgent?.creator_type;
    return {
        id: conversationAgentId,
        named_id: conversationAgent?.agent_named_id || conversationAgentId,
        name: conversationAgent?.agent_name || conversationAgentId,
        description: null,
        creator_type: conversationAgentCreatorType || 'CUSTOMER',
        available_plugins: {},
        is_default: conversationAgent?.is_default ?? false,
        actor_type: 'AGENT',
        user_defined_conversation_starters: null,
        favourite: false,
        deactivated: false,
        identity_account_id: conversationAgent?.identity_account_id,
        execution_config: conversationAgent?.execution_config
    };
};
const $daf188600e0350bc$export$23f34d314e5eff9c = ({ conversationId: conversationId, conversation: conversation, assistanceServiceParams: assistanceServiceParams })=>{
    const fallbackParams = (0, $6YdPR.useAssistanceServiceParams)({
        touchpointSource: 'useConversationHook'
    });
    const serviceParams = assistanceServiceParams || fallbackParams;
    const [messages] = (0, $iW40i.useChatMessages)({
        conversationId: conversationId
    });
    const { agentDefaultIdOverride: agentDefaultIdOverride } = (0, $37RgG.useAgentOverrider)();
    // Read only the specific conversation fields the derivation needs as locals,
    // so the memo below depends on these primitives rather than the whole
    // `conversation` object. A whole-object dependency would re-run the memo (and
    // the downstream `useAgentsPaginatedByAgentId` fetch) on unrelated per-turn
    // conversation writes during streaming, even though neither the gate-on nor
    // gate-off path reads those fields here.
    const conversationBackendAgentId = conversation?.agent?.agent_id;
    const conversationSourceAgentId = conversation?.sourceAgentId;
    const selectedAgentId = (0, $cozmU.useMemo)(()=>{
        if ((0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents')) // CONVERSATION identity shown in the agent selector header. Prefer the
        // canonical backend/store conversation agent when present. Before the first
        // turn is sent, use the surface-level default agent so that first turn is
        // routed to it and the backend persists it as the conversation agent.
        return conversationBackendAgentId || agentDefaultIdOverride || undefined;
        const firstAssistantAuthorId = (0, $222kR.getFirstMessageOfType)(messages ?? [], 'ASSISTANT')?.content.message.message.author_id;
        const agentIdFromConversation = conversationSourceAgentId ?? firstAssistantAuthorId;
        if ((0, $iDrrr.fg)('rovo_chat_fix_agent_selection_after_cancel')) // fixing the fallback to correctly select an agent if a user cancels a session
        return agentIdFromConversation ?? conversationBackendAgentId ?? agentDefaultIdOverride;
        return agentIdFromConversation ?? agentDefaultIdOverride;
    }, [
        agentDefaultIdOverride,
        conversationSourceAgentId,
        conversationBackendAgentId,
        messages
    ]);
    const { agent: agent, error: agentError } = (0, $3z1p5.useAgentsPaginatedByAgentId)({
        agentId: selectedAgentId,
        assistanceServiceParams: serviceParams
    });
    const agentErrorCode = agentError?.errorAttributes?.errorCode;
    /**
   * if agent fetch failed with status code AGENT_FORBIDDEN or AGENT_DEACTIVATED, extract agent name from messages because user has no access to the agent endpoint anymore
   * scenario: user has access to an agent, created a conversation with it, but then lost access to the agent, this will be triggered when user tries to reopen the conversation;
   * scenario: user has access to an agent, created a conversation with it, but then the agent was deactivated, this will be triggered when user tries to reopen the conversation;
   */ const fallbackAgent = (0, $cozmU.useMemo)(()=>{
        if (!(0, $iDrrr.fg)('convo-ai-enable-agents-use-permission')) return undefined;
        // Don't create fallback agent for empty conversations (new chats)
        if ((0, $1IZrU.isEmptyConversation)(conversationId) || !selectedAgentId) return undefined;
        // Only create fallback agent when agent fetch failed (to extract agent name from messages for display)
        // If agent was successfully fetched, no need for fallback
        if (!(0, $dvUlt.isAgentUnavailable)(agentErrorCode)) return undefined;
        // Try to extract agent metadata from the first assistant message
        const firstAssistantMessage = (0, $222kR.getFirstMessageOfType)(messages ?? [], 'ASSISTANT');
        const author = firstAssistantMessage?.content.message.message.author;
        if (!author?.name) return undefined;
        // Create a minimal Agent object with only required fields from message metadata
        // This allows the UI to display the agent name even when access is denied
        return {
            id: selectedAgentId,
            named_id: author.named_id ?? selectedAgentId,
            name: author.name,
            description: null,
            creator_type: 'CUSTOMER',
            available_plugins: {},
            is_default: false,
            actor_type: 'AGENT',
            user_defined_conversation_starters: null,
            favourite: false,
            deactivated: false
        };
    }, [
        selectedAgentId,
        messages,
        agentErrorCode,
        conversationId
    ]);
    const conversationAgentNamedId = conversation?.agent?.agent_named_id;
    const conversationAgentName = conversation?.agent?.agent_name;
    const conversationAgentCreatorType = conversation?.agent?.creator_type;
    const conversationAgentIdentityAccountId = conversation?.agent?.identity_account_id;
    const conversationAgentIsDefault = conversation?.agent?.is_default;
    const conversationAgentExecutionTier = conversation?.agent?.execution_config?.execution_tier;
    const provisionalSelectedAgent = (0, $cozmU.useMemo)(()=>{
        if (!(0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents') || !conversationBackendAgentId) return undefined;
        const conversationAgentForFallback = {
            agent_id: conversationBackendAgentId
        };
        if (conversationAgentNamedId) conversationAgentForFallback.agent_named_id = conversationAgentNamedId;
        if (conversationAgentName) conversationAgentForFallback.agent_name = conversationAgentName;
        if (conversationAgentCreatorType) conversationAgentForFallback.creator_type = conversationAgentCreatorType;
        if (conversationAgentIdentityAccountId) conversationAgentForFallback.identity_account_id = conversationAgentIdentityAccountId;
        if (typeof conversationAgentIsDefault === 'boolean') conversationAgentForFallback.is_default = conversationAgentIsDefault;
        if (conversationAgentExecutionTier) conversationAgentForFallback.execution_config = {
            execution_tier: conversationAgentExecutionTier
        };
        return $daf188600e0350bc$var$createProvisionalSelectedAgent(conversationAgentForFallback);
    }, [
        conversationBackendAgentId,
        conversationAgentNamedId,
        conversationAgentName,
        conversationAgentCreatorType,
        conversationAgentIdentityAccountId,
        conversationAgentIsDefault,
        conversationAgentExecutionTier
    ]);
    const selectedAgent = agent ?? fallbackAgent ?? provisionalSelectedAgent;
    const isFetching = (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents') && Boolean(selectedAgentId && !selectedAgent && !agentError);
    // Calculate agentIdForNewChat: only use valid agents (not fallback/error state) for new chats
    const agentIdForNewChat = (0, $cozmU.useMemo)(()=>{
        if (!(0, $iDrrr.fg)('convo-ai-enable-agents-use-permission')) return selectedAgent?.id;
        // No agent selected
        if (!selectedAgent?.id) return undefined;
        // If agent fetch failed with forbidden/deactivated error, don't use it for new chats
        if ((0, $dvUlt.isAgentUnavailable)(agentErrorCode)) return undefined;
        // If conversation has an error state, the agent is a fallback - don't use it for new chats
        if (conversation?.status === (0, $igOtY.CHAT_STORE_STATUS).deactivatedAgentError) return undefined;
        // Valid agent - safe to use for new chats
        return selectedAgent?.id;
    }, [
        agentErrorCode,
        selectedAgent?.id,
        conversation?.status
    ]);
    const agentVersioningConfig = (0, $gn6Jj.useAgentVersioningConfig)();
    const agentVersion = (0, $cozmU.useMemo)(()=>{
        if (!(0, $iDrrr.fg)('rovo_agent_versioning_enabled')) return undefined;
        // Prefer version stored on conversation (from chat-new event)
        if (conversation?.agentVersion) return conversation.agentVersion;
        // Fall back to version from first assistant message author (from BE response)
        const firstAssistantMessage_0 = (0, $222kR.getFirstMessageOfType)(messages ?? [], 'ASSISTANT');
        const author_0 = firstAssistantMessage_0?.content.message.message.author;
        if (author_0?.versionId || author_0?.versionType) return {
            versionId: author_0.versionId,
            versionType: author_0.versionType,
            versionNumber: author_0.versionNumber
        };
        return undefined;
    }, [
        conversation?.agentVersion,
        messages
    ]);
    const agentVersionForNewChat = (0, $cozmU.useMemo)(()=>{
        if (!agentVersioningConfig?.preserveVersionOnNewChat) return undefined;
        return agentVersion;
    }, [
        agentVersioningConfig?.preserveVersionOnNewChat,
        agentVersion
    ]);
    return {
        conversation: conversation,
        selectedAgent: selectedAgent,
        selectedAgentId: selectedAgentId,
        isFetching: isFetching,
        agentErrorCode: agentErrorCode,
        agentIdForNewChat: agentIdForNewChat,
        agentVersion: agentVersion,
        agentVersionForNewChat: agentVersionForNewChat
    };
};
module.exports["useConversationData"] = $daf188600e0350bc$export$23f34d314e5eff9c;

});

parcelRegister("3z1p5", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $6SsN4 = parcelRequire("6SsN4");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

var $c6StJ = parcelRequire("c6StJ");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $8lt5O = parcelRequire("8lt5O");


var $irnO2 = parcelRequire("irnO2");


var $bxkJA = parcelRequire("bxkJA");


var $8A2GO = parcelRequire("8A2GO");


var $5SS4O = parcelRequire("5SS4O");


var $lJ6db = parcelRequire("lJ6db");


var $bJzbV = parcelRequire("bJzbV");


var $33DP2 = parcelRequire("33DP2");


var $ig6TM = parcelRequire("ig6TM");


var $aihbI = parcelRequire("aihbI");


var $h6LPv = parcelRequire("h6LPv");


var $3ay5Z = parcelRequire("3ay5Z");


var $37RgG = parcelRequire("37RgG");


var $5Vuk7 = parcelRequire("5Vuk7");


var $8reXX = parcelRequire("8reXX");


var $fU4xN = parcelRequire("fU4xN");

const $808992f64c91fd00$var$categoriseAgents = (agents)=>agents.reduce((categorisedAgents, agent)=>{
        if (agent.creator_type === 'SYSTEM') categorisedAgents.system.push(agent);
        else if (agent.visibility === 'PUBLIC') categorisedAgents.public.push(agent);
        else if (agent.visibility === 'PRIVATE') categorisedAgents.private.push(agent);
        else if (!agent.visibility && agent.creator_type === 'CUSTOMER') categorisedAgents.private.push(agent);
        return categorisedAgents;
    }, {
        public: [],
        private: [],
        system: []
    });
const $808992f64c91fd00$var$connectionContainsNode = (connection, nodeId)=>(connection.getLinkedRecords('edges') ?? []).some((edge)=>edge?.getLinkedRecord('node')?.getDataID() === nodeId);
const $808992f64c91fd00$var$createInitialAgentsState = ()=>({
        availableAgents: [],
        categorisedAgents: {
            private: [],
            public: [],
            system: []
        },
        agentsInitialized: false,
        agentsError: undefined
    });
/**
 * @deprecated Please use `useAgentsPaginated...` hooks instead
 * @TODO move to different folder https://product-fabric.atlassian.net/browse/RAGE-1562
 */ const $808992f64c91fd00$var$agentsStore = (0, $8s9DV.createStore)({
    initialState: $808992f64c91fd00$var$createInitialAgentsState(),
    name: 'AgentsStore',
    actions: {
        setAgents: (availableAgents)=>({ setState: setState })=>{
                setState({
                    availableAgents: availableAgents,
                    categorisedAgents: $808992f64c91fd00$var$categoriseAgents(availableAgents)
                });
            },
        setAgentsInitialized: ()=>({ setState: setState })=>{
                setState({
                    agentsInitialized: true
                });
            },
        setAgentsError: (agentsError)=>({ setState: setState })=>{
                setState({
                    agentsError: agentsError
                });
            },
        resetAgentStore: ()=>({ setState: setState })=>{
                setState($808992f64c91fd00$var$createInitialAgentsState());
            }
    }
});
/**
 * @deprecated Please use `useAgentsPaginated...` instead
 * @TODO move to different folder https://product-fabric.atlassian.net/browse/RAGE-1562
 */ const $808992f64c91fd00$var$useAgentsStore = (0, $kBr4q.createHook)($808992f64c91fd00$var$agentsStore);
const $808992f64c91fd00$export$f5b1109ecd7858c1 = (0, $lJ6db.createHookWithAssistanceService)(({ onError: onError, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker, experienceId: experienceId, product: product, siteId: siteId, touchpointSource: touchpointSource } })=>{
    // TODO remove `isRovoEnabled`
    const { isRovoEnabled: isRovoEnabled } = (0, $8lt5O.useRovoEntitlement)();
    const { agentIdFiltersOverride: agentIdFiltersOverride, agentDefaultIdOverride: agentDefaultIdOverride } = (0, $37RgG.useAgentOverrider)();
    const [{ availableAgents: availableAgents, categorisedAgents: categorisedAgents, agentsInitialized: agentsInitialized, agentsError: agentsError }, { setAgents: setAgents, setAgentsInitialized: setAgentsInitialized, setAgentsError: setAgentsError }] = $808992f64c91fd00$var$useAgentsStore();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { favouriteAgent: favouriteAgent, unfavouriteAgent: unfavouriteAgent } = (0, $3ay5Z.useAgentFavourites)({
        assistanceServiceParams: {
            experienceId: experienceId,
            product: product,
            siteId: siteId,
            touchpointSource: touchpointSource
        }
    });
    const favouritedAgents = availableAgents.filter((agent)=>agent.favourite);
    const defaultAgent = (0, $cozmU.useMemo)(()=>availableAgents.find((agent)=>agent.is_default), [
        availableAgents
    ]);
    const nonDefaultAgents = (0, $cozmU.useMemo)(()=>availableAgents.filter((agent)=>!agent.is_default), [
        availableAgents
    ]);
    const nonDefaultFavouriteAgents = (0, $cozmU.useMemo)(()=>nonDefaultAgents.filter((agent)=>!agent.favourite), [
        nonDefaultAgents
    ]);
    const fetchAndStoreAvailableAgents = (0, $5SS4O.useQuery)({
        queryKey: (0, $iDrrr.fg)('rovo_chat_site_switch_reset') ? [
            'fetchAgents',
            siteId
        ] : [
            'fetchAgents'
        ],
        queryFn: async ()=>{
            const isSiteSwitchResetEnabled = (0, $iDrrr.fg)('rovo_chat_site_switch_reset');
            const generationAtRequestStart = $808992f64c91fd00$var$getAgentStoresGeneration();
            try {
                experienceTracker.start({
                    id: (0, $irnO2.ExperienceName).FETCH_AGENTS,
                    name: (0, $irnO2.ExperienceName).FETCH_AGENTS
                });
                const agents = await assistanceService.getAgents();
                if (isSiteSwitchResetEnabled && $808992f64c91fd00$var$isStaleAgentStoresGeneration(generationAtRequestStart)) {
                    experienceTracker.succeed({
                        name: (0, $irnO2.ExperienceName).FETCH_AGENTS
                    });
                    return;
                }
                const transformedAgents = agents.map((agent)=>{
                    // Rename default agent to Chat, which is displayed in the UI
                    if (agent.is_default) {
                        agent.name = formatMessage((0, $fU4xN.default).defaultAgentName);
                        agent.description = formatMessage((0, $fU4xN.default).defaultAgentDescription);
                    }
                    return agent;
                });
                const overriddenAgents = (0, $5Vuk7.getOverridenAgents)(transformedAgents, agentIdFiltersOverride, agentDefaultIdOverride);
                setAgents(overriddenAgents);
                experienceTracker.succeed({
                    name: (0, $irnO2.ExperienceName).FETCH_AGENTS
                });
                setAgentsInitialized();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                //Filter out HIPAA errors from experience tracker https://product-fabric.atlassian.net/browse/ROVOFE-543
                if ((0, $8reXX.isHipaaError)(error)) {
                    experienceTracker.succeed({
                        name: (0, $irnO2.ExperienceName).FETCH_AGENTS
                    });
                    return;
                }
                const isStaleSite = isSiteSwitchResetEnabled && $808992f64c91fd00$var$isStaleAgentStoresGeneration(generationAtRequestStart);
                if ((0, $bxkJA.isRateLimitedError)(error) && !isStaleSite) setAgentsError(error);
                experienceTracker.fail({
                    name: (0, $irnO2.ExperienceName).FETCH_AGENTS,
                    error: error
                });
                throw error;
            }
        },
        onError: onError,
        enabled: isRovoEnabled,
        refetchOnWindowFocus: false
    });
    const { deleteAgent: deleteAgent } = (0, $h6LPv.useDeleteAgent)({
        onSuccess: ()=>{
            fetchAndStoreAvailableAgents.refetch();
        },
        assistanceServiceParams: {
            experienceId: experienceId,
            product: product,
            siteId: siteId,
            touchpointSource: touchpointSource
        },
        onInit: (id)=>{
            setAgents(availableAgents.filter((agent)=>agent.id !== id));
        },
        onError: ()=>{
            setAgents(availableAgents);
        }
    });
    const setFavouriteAgent = (0, $cozmU.useCallback)(async (id, isFavourite)=>{
        const updatedAgent = availableAgents.find((a)=>a.id === id);
        const setUpdatedAgent = (shouldBeFavourite)=>{
            if (updatedAgent) {
                updatedAgent.favourite = shouldBeFavourite;
                setAgents(availableAgents.map((a)=>{
                    // If the current agent's id matches the new agent's id, return the new agent.
                    // Otherwise, return the current agent.
                    return a.id === updatedAgent.id ? updatedAgent : a;
                }));
            }
        };
        //Optimistically update favourite value before we mutate
        setUpdatedAgent(isFavourite);
        //Pass callback to roll back optimistic update if mutation fails
        const errorCallback = {
            onError: ()=>{
                setUpdatedAgent(!isFavourite);
            }
        };
        if (isFavourite) return await favouriteAgent.mutate(id, errorCallback);
        else return await unfavouriteAgent.mutate(id, errorCallback);
    }, [
        availableAgents,
        setAgents,
        favouriteAgent,
        unfavouriteAgent
    ]);
    /** This updates the agent on the client side only
   * Useful for updating the agent after a successful mutation
   */ const updateAgentLocally = (0, $cozmU.useCallback)((agentId, updatedAgent)=>{
        const updatedAgents = availableAgents.map((agent)=>{
            if (agent.id === agentId) return {
                ...agent,
                ...updatedAgent
            };
            return agent;
        });
        setAgents(updatedAgents);
    }, [
        availableAgents,
        setAgents
    ]);
    return {
        availableAgents: availableAgents,
        favouritedAgents: favouritedAgents,
        categorisedAgents: categorisedAgents,
        fetchAndStoreAvailableAgents: fetchAndStoreAvailableAgents,
        deleteAgent: deleteAgent,
        setFavouriteAgent: setFavouriteAgent,
        defaultAgent: defaultAgent,
        agentsInitialized: agentsInitialized,
        nonDefaultAgents: nonDefaultAgents,
        nonDefaultFavouriteAgents: nonDefaultFavouriteAgents,
        updateAgentLocally: updateAgentLocally,
        agentsError: agentsError
    };
});
const $808992f64c91fd00$var$createEmptyAgentCategory = ()=>({
        agentIds: [],
        pageInfo: {
            ...(0, $ig6TM.DEFAULT_PAGE_INFO)
        },
        abortController: new AbortController()
    });
const $808992f64c91fd00$var$agentsPaginatedStore = (0, $8s9DV.createStore)({
    initialState: {
        /*
    Hash map which is the source of truth for agent data
    agent categories simply hold the agent ids to perform a lookup
    */ agentsMap: {},
        loadingCategories: new Set(),
        agentCategories: {
            ['all-agents']: {
                agentIds: [],
                pageInfo: (0, $ig6TM.DEFAULT_PAGE_INFO),
                abortController: new AbortController()
            },
            ['starred-agents']: {
                agentIds: [],
                pageInfo: (0, $ig6TM.DEFAULT_PAGE_INFO),
                abortController: new AbortController()
            },
            ['my-agents']: {
                agentIds: [],
                pageInfo: (0, $ig6TM.DEFAULT_PAGE_INFO),
                abortController: new AbortController()
            },
            ['templates']: {
                agentIds: [],
                pageInfo: (0, $ig6TM.DEFAULT_PAGE_INFO),
                abortController: new AbortController()
            },
            ['verified-agents']: {
                agentIds: [],
                pageInfo: (0, $ig6TM.DEFAULT_PAGE_INFO),
                abortController: new AbortController()
            },
            ['available-for-jira']: {
                agentIds: [],
                pageInfo: (0, $ig6TM.DEFAULT_PAGE_INFO),
                abortController: new AbortController()
            }
        }
    },
    name: 'AgentsPaginatedStore',
    actions: {
        /**
     * This action populates a specific category with backend data
     * it will store the ids in `agentCategories` and the agents in `agentsMap`
     */ populateAgentCategories: ({ agentsList: agentsList, pageInfo: pageInfo, category: category = 'all-agents' })=>({ setState: setState, getState: getState })=>{
                const { agentsMap: agentsMap, agentCategories: agentCategories } = getState();
                const updatedAgentsMap = {
                    ...agentsMap
                };
                const updatedAgentCategories = {
                    ...agentCategories
                };
                updatedAgentCategories[category].pageInfo = pageInfo;
                if (!agentsList.length) updatedAgentCategories[category].agentIds = [];
                else agentsList.forEach((agent)=>{
                    // Ensure isPlaceholder is cleared when hydrating with real BE data
                    const { isPlaceholder: _isPlaceholder, ...existingData } = updatedAgentsMap[agent.id] ?? {};
                    updatedAgentsMap[agent.id] = {
                        ...existingData,
                        ...agent
                    };
                    updatedAgentCategories[category].agentIds.push(agent.id);
                });
                setState({
                    agentsMap: updatedAgentsMap,
                    agentCategories: updatedAgentCategories
                });
            },
        setAgentCategoriesByCategory: ({ categoryName: categoryName, agentCategoryData: agentCategoryData })=>({ getState: getState, setState: setState })=>{
                const { agentCategories: agentCategories } = getState();
                const updatedAgentCategories = {
                    ...agentCategories,
                    [categoryName]: agentCategoryData
                };
                setState({
                    agentCategories: updatedAgentCategories
                });
            },
        setCategoryError: (categoryName, agentsError)=>({ getState: getState, setState: setState })=>{
                const { agentCategories: agentCategories } = getState();
                const updatedAgentCategories = {
                    ...agentCategories,
                    [categoryName]: {
                        ...agentCategories[categoryName],
                        agentsError: agentsError
                    }
                };
                setState({
                    agentCategories: updatedAgentCategories
                });
            },
        getAgentCategoriesByCategory: (category)=>({ getState: getState })=>{
                const state = getState();
                const { agentCategories: agentCategories } = state;
                return agentCategories[category];
            },
        removeAgent: (id)=>({ setState: setState, getState: getState })=>{
                const { agentsMap: agentsMap, agentCategories: agentCategories } = getState();
                const catsImpacted = new Set();
                let agentToReturn;
                const updatedAgentsMap = {
                    ...agentsMap
                };
                const updatedAgentCategories = {
                    ...agentCategories
                };
                if (agentsMap[id]) {
                    agentToReturn = agentsMap[id];
                    delete updatedAgentsMap[id];
                }
                Object.keys(agentCategories).forEach((category)=>{
                    if (updatedAgentCategories[category]?.agentIds.includes(id)) {
                        updatedAgentCategories[category].agentIds = updatedAgentCategories[category].agentIds.filter((agentId)=>agentId !== id);
                        catsImpacted.add(category);
                    }
                });
                setState({
                    agentsMap: updatedAgentsMap,
                    agentCategories: updatedAgentCategories
                });
                return {
                    agent: agentToReturn,
                    categories: Array.from(catsImpacted)
                };
            },
        addAgent: (agent, categories = [
            'all-agents'
        ])=>({ setState: setState, getState: getState })=>{
                const { agentsMap: agentsMap, agentCategories: agentCategories } = getState();
                const updatedAgentsMap = {
                    ...agentsMap
                };
                const updatedAgentCategories = {
                    ...agentCategories
                };
                categories.forEach((category)=>{
                    updatedAgentCategories?.[category]?.agentIds.push(agent.id);
                });
                // Ensure isPlaceholder is cleared when adding full agent data
                const { isPlaceholder: _isPlaceholder, ...existingData } = updatedAgentsMap[agent.id] ?? {};
                updatedAgentsMap[agent.id] = {
                    ...existingData,
                    ...agent
                };
                setState({
                    agentsMap: updatedAgentsMap,
                    agentCategories: updatedAgentCategories
                });
            },
        updateAgent: (id, data)=>({ setState: setState, getState: getState })=>{
                const { agentsMap: agentsMap } = getState();
                const updatedAgentsMap = {
                    ...agentsMap
                };
                const prevData = agentsMap[id] ?? {};
                const updatedData = {
                    ...prevData,
                    ...data
                };
                // Clean up placeholder flag when real agent data arrives
                // Keep placeholderAvatarUrl to avoid avatar flicker (same image, stable source)
                if (prevData.isPlaceholder) delete updatedData.isPlaceholder;
                updatedAgentsMap[id] = updatedData;
                setState({
                    agentsMap: updatedAgentsMap
                });
                return updatedData;
            },
        setCategoryLoading: (category, loading)=>({ setState: setState, getState: getState })=>{
                const { loadingCategories: loadingCategories } = getState();
                const updatedLoadingCategories = new Set(loadingCategories);
                if (loading) updatedLoadingCategories.add(category);
                else updatedLoadingCategories.delete(category);
                setState({
                    loadingCategories: updatedLoadingCategories
                });
            },
        abortCategoryFetch: (category)=>({ getState: getState })=>{
                const { agentCategories: agentCategories } = getState();
                agentCategories[category].abortController.abort();
                agentCategories[category].abortController = new AbortController();
            },
        /**
     * Sets a placeholder agent in the agentsMap with partial data for immediate rendering.
     * The agent is marked with `isPlaceholder: true` so that `useAgentsPaginatedByAgentId`
     * still fetches full details from the network to replace it.
     * Used for optimistic rendering of agent name/avatar from pubsub payloads.
     */ setPlaceholderAgent: (agentId, data)=>({ setState: setState, getState: getState })=>{
                const { agentsMap: agentsMap } = getState();
                // Only set placeholder if agent doesn't already exist with full data
                if (!agentsMap[agentId]) {
                    const updatedAgentsMap = {
                        ...agentsMap
                    };
                    updatedAgentsMap[agentId] = {
                        ...data,
                        id: agentId,
                        isPlaceholder: true
                    };
                    setState({
                        agentsMap: updatedAgentsMap
                    });
                }
            },
        getCachedAgentByExternalConfigReference: (externalConfigReference)=>({ getState: getState })=>{
                const { agentsMap: agentsMap } = getState();
                return Object.values(agentsMap).find((agent)=>agent.external_config_reference === externalConfigReference);
            },
        resetPaginatedAgents: ()=>({ getState: getState, setState: setState })=>{
                const agentCategories = {
                    ...getState().agentCategories
                };
                Object.keys(agentCategories).forEach((category)=>{
                    agentCategories[category].abortController.abort();
                    agentCategories[category] = $808992f64c91fd00$var$createEmptyAgentCategory();
                });
                setState({
                    agentsMap: {},
                    loadingCategories: new Set(),
                    agentCategories: agentCategories
                });
            }
    }
});
/**
 * Both agent stores are page-level singletons, so switching site can only clear them, never replace
 * them. `agentStoresGeneration` is the version of the data they currently hold: async writers read
 * it before their request and compare afterwards, so a response belonging to the site we just left
 * is dropped instead of repopulating the cleared store.
 */ let $808992f64c91fd00$var$agentStoresGeneration = 0;
const $808992f64c91fd00$var$getAgentStoresGeneration = ()=>$808992f64c91fd00$var$agentStoresGeneration;
const $808992f64c91fd00$var$isStaleAgentStoresGeneration = (generation)=>generation !== $808992f64c91fd00$var$agentStoresGeneration;
const $808992f64c91fd00$export$242eb13d25184007 = ()=>{
    $808992f64c91fd00$var$agentStoresGeneration += 1;
    (0, $c6StJ.defaultRegistry).getStore($808992f64c91fd00$var$agentsStore).actions.resetAgentStore();
    (0, $c6StJ.defaultRegistry).getStore($808992f64c91fd00$var$agentsPaginatedStore).actions.resetPaginatedAgents();
};
const $808992f64c91fd00$export$1553678862324ff0 = (0, $kBr4q.createActionsHook)($808992f64c91fd00$var$agentsPaginatedStore);
const $808992f64c91fd00$export$cea603150faaa56f = (0, $kBr4q.createHook)($808992f64c91fd00$var$agentsPaginatedStore, {
    // TODO https://product-fabric.atlassian.net/browse/RAGE-618
    // change `{ agentId }` to `agentId`
    selector: (state, agentId)=>({
            agent: state.agentsMap[agentId],
            doesAgentExist: Boolean(state.agentsMap[agentId]),
            isPlaceholder: Boolean(state.agentsMap[agentId]?.isPlaceholder)
        })
});
const $808992f64c91fd00$export$44c2e95a7a8b47c9 = (0, $lJ6db.createHookWithAssistanceService)(({ agentId: agentId, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker, siteId: siteId } })=>{
    (0, $6cFsl.di)($808992f64c91fd00$export$44c2e95a7a8b47c9, $808992f64c91fd00$export$cea603150faaa56f, $808992f64c91fd00$export$1553678862324ff0);
    const [{ agent: agent, doesAgentExist: doesAgentExist, isPlaceholder: isPlaceholder }] = $808992f64c91fd00$export$cea603150faaa56f(agentId ?? '');
    const { updateAgent: updateAgent } = $808992f64c91fd00$export$1553678862324ff0();
    const { error: error } = (0, $5SS4O.useQuery)({
        queryKey: (0, $iDrrr.fg)('rovo_chat_site_switch_reset') ? [
            'agentHydration',
            agentId ?? '',
            siteId ?? ''
        ] : [
            'agentHydration',
            agentId ?? ''
        ],
        queryFn: async ()=>{
            if (!agentId) // this throw won't happen because the `enabled` field below
            throw new Error('Agent ID is required');
            const generation = $808992f64c91fd00$var$getAgentStoresGeneration();
            experienceTracker.start({
                name: (0, $irnO2.ExperienceName).HYDRATE_AGENT_DATA,
                id: (0, $irnO2.ExperienceName).HYDRATE_AGENT_DATA
            });
            return {
                agentDetails: await assistanceService.getAgentDetails(agentId),
                generation: generation
            };
        },
        enabled: Boolean(agentId) && (!doesAgentExist || isPlaceholder),
        onSuccess: ({ agentDetails: agentDetails, generation: generation })=>{
            if (!agentId) return;
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).HYDRATE_AGENT_DATA
            });
            if ((0, $iDrrr.fg)('rovo_chat_site_switch_reset') && $808992f64c91fd00$var$isStaleAgentStoresGeneration(generation)) return;
            updateAgent(agentId ?? '', agentDetails);
        },
        onError: (error)=>{
            if (!agentId) return;
            const is404Error = error.errorAttributes.statusCode === 404;
            const is403Error = error.errorAttributes.statusCode === 403 && (0, $iDrrr.fg)('convo-ai-enable-agents-use-permission');
            if (!(is404Error || is403Error)) experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).HYDRATE_AGENT_DATA,
                error: error,
                teamName: (0, $33DP2.ROVO_AGENTS_FE_TEAM_NAME)
            });
        }
    });
    if (!agentId) return {
        agent: undefined,
        error: undefined
    };
    return {
        agent: agent,
        error: error ?? undefined
    };
});
const $808992f64c91fd00$export$eae59c91509947e4 = (0, $lJ6db.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: assistanceServiceInjectedParams })=>{
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const removedAgentCache = (0, $cozmU.useRef)({
        categories: [],
        agent: undefined,
        generation: 0
    });
    const { removeAgent: removeAgent, addAgent: addAgent, updateAgent: updateAgent } = $808992f64c91fd00$export$1553678862324ff0();
    const { favouriteAgent: favouriteAgent, unfavouriteAgent: unfavouriteAgent } = (0, $3ay5Z.useAgentFavourites)({
        assistanceServiceParams: assistanceServiceInjectedParams
    });
    // Note: Experience Tracker events implemented in useDeleteAgent
    const { deleteAgent: deleteAgent } = (0, $h6LPv.useDeleteAgent)({
        assistanceServiceParams: assistanceServiceInjectedParams,
        onInit: (id)=>{
            const { categories: categories, agent: agent } = removeAgent(id);
            // The generation is cached alongside the agent so the rollback below is judged against the
            // state this particular removal was made from.
            removedAgentCache.current = {
                categories: categories,
                agent: agent,
                generation: $808992f64c91fd00$var$getAgentStoresGeneration()
            };
        },
        onError: ()=>{
            // Restoring after a reset would put a complete agent from the previous site back into the
            // new site's map and its category lists.
            if ((0, $iDrrr.fg)('rovo_chat_site_switch_reset') && $808992f64c91fd00$var$isStaleAgentStoresGeneration(removedAgentCache.current.generation)) return;
            if (removedAgentCache.current.agent) addAgent(removedAgentCache.current.agent, removedAgentCache.current.categories);
        }
    });
    // Note: Experience Tracker events implemented in useAgentFavourites
    const setFavouriteAgent = (0, $cozmU.useCallback)(async (id, favourite, agentAri)=>{
        const generationAtMutationStart = $808992f64c91fd00$var$getAgentStoresGeneration();
        // Optimistic update
        updateAgent(id, {
            favourite: favourite
        });
        const localRelayUpdate = async (isFavourite)=>{
            if (agentAri) (0, $6SsN4.commitLocalUpdate)(environment, (store)=>{
                const id = (0, $bJzbV.default)({
                    id: agentAri
                }, 'AgentStudioAssistant');
                if (!id) return;
                const agentRecord = store.get(id);
                if (agentRecord) agentRecord.setValue(isFavourite, 'isFavourite');
                const root = store.getRoot();
                const connection = (0, $6SsN4.ConnectionHandler).getConnection(root, 'paginatedAgentsList_agentStudio_getAgents', {
                    cloudId: assistanceServiceInjectedParams.siteId,
                    input: {
                        onlyFavouriteAgents: true
                    },
                    product: assistanceServiceInjectedParams.product
                });
                const agentDataID = agentRecord?.getDataID();
                if (!connection || !agentDataID || !agentRecord) return;
                if (isFavourite) {
                    if ((0, $4o0zT.isExperimentEnabled)('jira_agent_recommendations_m1') && $808992f64c91fd00$var$connectionContainsNode(connection, agentDataID)) return;
                    const edge = (0, $6SsN4.ConnectionHandler).createEdge(store, connection, agentRecord, 'AgentStudioAgentEdge');
                    (0, $6SsN4.ConnectionHandler).insertEdgeAfter(connection, edge);
                } else (0, $6SsN4.ConnectionHandler).deleteNode(connection, agentDataID);
            });
        };
        localRelayUpdate(favourite);
        const errorCallback = {
            onError: ()=>{
                // Reverse optimistic update, unless the stores were reset for another site while the
                // mutation was in flight — `updateAgent` creates the entry when the id is absent, so
                // rolling back would insert a partial agent from the previous site into the new one.
                if (!((0, $iDrrr.fg)('rovo_chat_site_switch_reset') && $808992f64c91fd00$var$isStaleAgentStoresGeneration(generationAtMutationStart))) updateAgent(id, {
                    favourite: !favourite
                });
                // The Relay rollback is safe either way: its connection is keyed by cloudId.
                localRelayUpdate(!favourite);
            }
        };
        if (favourite) return await favouriteAgent.mutate(id, errorCallback);
        else return await unfavouriteAgent.mutate(id, errorCallback);
    }, [
        assistanceServiceInjectedParams.product,
        assistanceServiceInjectedParams.siteId,
        environment,
        favouriteAgent,
        unfavouriteAgent,
        updateAgent
    ]);
    /**
   * Function that updates the verified status of an agent.
   * This can be removed once the dropdown has converted over to relay.
   */ const setVerifiedAgent = (0, $cozmU.useCallback)((id, isVerified)=>{
        updateAgent(id, {
            is_verified: isVerified
        });
    }, [
        updateAgent
    ]);
    // Local cache update function for optimistic delete
    // This only handles cache updates, not API calls or analytics
    const deleteAgentLocally = (0, $cozmU.useCallback)((id)=>{
        const generationAtRemoval = $808992f64c91fd00$var$getAgentStoresGeneration();
        // Optimistically remove from cache
        const { categories: categories, agent: agent } = removeAgent(id);
        // Return restore function for error handling
        return {
            restore: ()=>{
                if ((0, $iDrrr.fg)('rovo_chat_site_switch_reset') && $808992f64c91fd00$var$isStaleAgentStoresGeneration(generationAtRemoval)) return;
                if (agent) addAgent(agent, categories);
            }
        };
    }, [
        removeAgent,
        addAgent
    ]);
    return {
        deleteAgent: deleteAgent,
        setFavouriteAgent: setFavouriteAgent,
        setVerifiedAgent: setVerifiedAgent,
        deleteAgentLocally: deleteAgentLocally
    };
});
const $808992f64c91fd00$export$cc3deb815b1c179b = (0, $kBr4q.createHook)($808992f64c91fd00$var$agentsPaginatedStore, {
    selector: (state, category)=>({
            agentsByCategory: state.agentCategories[category].agentIds.map((agentId)=>state.agentsMap[agentId]),
            isCategoryInitialized: state.agentCategories[category].pageInfo.startCursor !== undefined && state.agentCategories[category].pageInfo.endCursor !== undefined,
            isCategoryLoading: state.loadingCategories.has(category),
            isCategoryEmpty: state.agentCategories[category].agentIds.length === 0,
            hasNextPage: state.agentCategories[category].pageInfo.hasNextPage,
            nextPageCursor: state.agentCategories[category].pageInfo.endCursor,
            agentsError: state.agentCategories[category].agentsError
        })
});
const $808992f64c91fd00$export$e6997ec35c535c54 = (0, $lJ6db.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker, siteId: siteId } })=>{
    (0, $6cFsl.di)((0, $37RgG.useAgentOverrider), $808992f64c91fd00$export$1553678862324ff0);
    const { agentDefaultIdOverride: agentDefaultIdOverride, agentIdFiltersOverride: agentIdFiltersOverride } = (0, $37RgG.useAgentOverrider)();
    const { addAgent: addAgent, populateAgentCategories: populateAgentCategories } = $808992f64c91fd00$export$1553678862324ff0();
    const fetchOverriddenAgentsAndPopulateStoreQuery = (0, $5SS4O.useQuery)({
        queryKey: (0, $iDrrr.fg)('rovo_chat_site_switch_reset') ? [
            'fetchOverriddenAgentsAndPopulateStore',
            agentDefaultIdOverride ?? '',
            agentIdFiltersOverride?.join(',') ?? '',
            siteId ?? ''
        ] : [
            'fetchOverriddenAgentsAndPopulateStore',
            agentDefaultIdOverride ?? '',
            agentIdFiltersOverride?.join(',') ?? ''
        ],
        queryFn: async ()=>{
            const isSiteSwitchResetEnabled = (0, $iDrrr.fg)('rovo_chat_site_switch_reset');
            const generationAtRequestStart = $808992f64c91fd00$var$getAgentStoresGeneration();
            const agentIdsToFetchSet = new Set();
            if (agentDefaultIdOverride) agentIdsToFetchSet.add(agentDefaultIdOverride);
            if (agentIdFiltersOverride?.length) agentIdFiltersOverride.forEach((agentId)=>{
                agentIdsToFetchSet.add(agentId);
            });
            if (agentIdsToFetchSet.size === 0) return;
            const agentIdsToFetch = Array.from(agentIdsToFetchSet);
            populateAgentCategories({
                category: 'all-agents',
                agentsList: [],
                pageInfo: (0, $ig6TM.DEFAULT_PAGE_INFO)
            });
            experienceTracker.start({
                name: (0, $irnO2.ExperienceName).FETCH_AGENTS_OVERRIDES,
                id: (0, $irnO2.ExperienceName).FETCH_AGENTS_OVERRIDES
            });
            const agents = await Promise.all(agentIdsToFetch.map(async (agentId)=>{
                return await assistanceService.getAgentDetails(agentId);
            }));
            if (isSiteSwitchResetEnabled && $808992f64c91fd00$var$isStaleAgentStoresGeneration(generationAtRequestStart)) return agentIdsToFetch;
            // then add the agents into "All agents" category
            agents.forEach((agent)=>{
                addAgent(agent, [
                    'all-agents'
                ]);
            });
            return agentIdsToFetch;
        },
        onSuccess: ()=>{
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).FETCH_AGENTS_OVERRIDES
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).FETCH_AGENTS_OVERRIDES,
                error: error,
                teamName: (0, $33DP2.ROVO_AGENTS_FE_TEAM_NAME)
            });
        },
        enabled: false
    });
    return {
        fetchOverriddenAgentsAndPopulateStore: fetchOverriddenAgentsAndPopulateStoreQuery.refetch
    };
});
const $808992f64c91fd00$export$94c2040c41639ede = (0, $lJ6db.createHookWithAssistanceService)(({ onError: onError, assistanceServiceInjectedParams: assistanceServiceInjectedParams })=>{
    (0, $6cFsl.di)($808992f64c91fd00$export$1553678862324ff0, (0, $37RgG.useAgentOverrider), $808992f64c91fd00$export$e6997ec35c535c54);
    const { experienceTracker: experienceTracker, siteId: siteId, product: product, headers: assistanceServiceHeaders } = assistanceServiceInjectedParams;
    const actions = $808992f64c91fd00$export$1553678862324ff0();
    const { setCategoryLoading: setCategoryLoading, setCategoryError: setCategoryError, populateAgentCategories: populateAgentCategories, getAgentCategoriesByCategory: getAgentCategoriesByCategory, setAgentCategoriesByCategory: setAgentCategoriesByCategory } = actions;
    const { agentDefaultIdOverride: agentDefaultIdOverride, agentIdFiltersOverride: agentIdFiltersOverride } = (0, $37RgG.useAgentOverrider)();
    const { fetchOverriddenAgentsAndPopulateStore: fetchOverriddenAgentsAndPopulateStore } = $808992f64c91fd00$export$e6997ec35c535c54({
        assistanceServiceParams: assistanceServiceInjectedParams
    });
    const fetchAgentsByCategory = (0, $cozmU.useCallback)(async ({ category: category = 'all-agents', after: after, query: query })=>{
        // if there are any overrides, cancel the normal fetchByCategory and instead fetch the overridden agents
        if (agentDefaultIdOverride || agentIdFiltersOverride?.length) return await fetchOverriddenAgentsAndPopulateStore() ?? [];
        const isSiteSwitchResetEnabled = (0, $iDrrr.fg)('rovo_chat_site_switch_reset');
        const generationAtRequestStart = $808992f64c91fd00$var$getAgentStoresGeneration();
        const dataBeforeFetch = getAgentCategoriesByCategory(category);
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).FETCH_AGENTS_PAGINATED,
            id: (0, $irnO2.ExperienceName).FETCH_AGENTS_PAGINATED
        });
        let queryInput = {};
        switch(category){
            case 'starred-agents':
                queryInput.onlyFavouriteAgents = true;
                break;
            case 'my-agents':
                queryInput.onlyMyAgents = true;
                break;
            case 'templates':
                queryInput.onlyTemplateAgents = true;
                break;
            case 'verified-agents':
                queryInput.onlyVerifiedAgents = true;
                break;
        }
        if (query) queryInput.name = query;
        // for rolling back data in case of abort/failure
        const resetData = ()=>{
            setAgentCategoriesByCategory({
                categoryName: category,
                agentCategoryData: dataBeforeFetch
            });
            return dataBeforeFetch.agentIds;
        };
        // No after means we're requesting the first page so the category data is reset
        if (!after) populateAgentCategories({
            category: category,
            agentsList: [],
            pageInfo: (0, $ig6TM.DEFAULT_PAGE_INFO)
        });
        setCategoryLoading(category, true);
        setCategoryError(category, undefined);
        const headers = new Headers(assistanceServiceHeaders);
        const maybeWorkspaceId = headers.get('x-workspace-id');
        try {
            const response = await (0, $ig6TM.fetchPaginatedAgents)({
                after: after ?? undefined,
                cloudId: siteId,
                count: 10,
                input: Object.keys(queryInput).length > 0 ? queryInput : undefined,
                product: product,
                abortController: getAgentCategoriesByCategory(category).abortController,
                workspaceId: maybeWorkspaceId
            });
            if (isSiteSwitchResetEnabled && $808992f64c91fd00$var$isStaleAgentStoresGeneration(generationAtRequestStart)) {
                experienceTracker.abort({
                    reason: 'Aborted',
                    name: (0, $irnO2.ExperienceName).FETCH_AGENTS_PAGINATED
                });
                return [];
            }
            setCategoryLoading(category, false);
            if (getAgentCategoriesByCategory(category).abortController.signal?.aborted) {
                experienceTracker.abort({
                    reason: 'Aborted',
                    name: (0, $irnO2.ExperienceName).FETCH_AGENTS_PAGINATED
                });
                return resetData();
            }
            if (response) {
                populateAgentCategories({
                    category: category,
                    agentsList: response.agents,
                    pageInfo: response.pageInfo
                });
                experienceTracker.succeed({
                    name: (0, $irnO2.ExperienceName).FETCH_AGENTS_PAGINATED
                });
            }
            return response?.agents.map((agent)=>agent.id);
        } catch (error) {
            if (isSiteSwitchResetEnabled && $808992f64c91fd00$var$isStaleAgentStoresGeneration(generationAtRequestStart)) {
                experienceTracker.abort({
                    reason: 'Aborted',
                    name: (0, $irnO2.ExperienceName).FETCH_AGENTS_PAGINATED
                });
                return [];
            }
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).FETCH_AGENTS_PAGINATED,
                error: error,
                teamName: (0, $33DP2.ROVO_AGENTS_FE_TEAM_NAME)
            });
            const prevAgentIds = resetData();
            setCategoryError(category, error);
            setCategoryLoading(category, false);
            if (error instanceof (0, $8A2GO.ApiError)) onError?.(error);
            return prevAgentIds;
        }
    }, [
        agentDefaultIdOverride,
        agentIdFiltersOverride?.length,
        getAgentCategoriesByCategory,
        experienceTracker,
        setCategoryLoading,
        setCategoryError,
        assistanceServiceHeaders,
        fetchOverriddenAgentsAndPopulateStore,
        setAgentCategoriesByCategory,
        populateAgentCategories,
        siteId,
        product,
        onError
    ]);
    return {
        ...actions,
        fetchAgentsByCategory: fetchAgentsByCategory
    };
});
const $808992f64c91fd00$export$65c6565d33cf8f4f = (0, $kBr4q.createHook)($808992f64c91fd00$var$agentsPaginatedStore, {
    selector: (state)=>state.agentsMap
});
const $808992f64c91fd00$var$DEFAULT_RECOMMENDED_AGENTS_LIMIT = 3;
const $808992f64c91fd00$var$getRecommendedAgentsQueryKey = ({ limit: limit, pageUrl: pageUrl, siteId: siteId })=>(0, $iDrrr.fg)('rovo_chat_site_switch_reset') ? [
        'recommendedAgents',
        limit,
        pageUrl ?? '',
        siteId ?? ''
    ] : [
        'recommendedAgents',
        limit,
        pageUrl ?? ''
    ];
const $808992f64c91fd00$var$fetchRecommendedAgents = async ({ assistanceService: assistanceService, limit: limit, pageUrl: pageUrl, updateAgent: updateAgent })=>{
    const isSiteSwitchResetEnabled = (0, $iDrrr.fg)('rovo_chat_site_switch_reset');
    const generationAtRequestStart = $808992f64c91fd00$var$getAgentStoresGeneration();
    const response = await assistanceService.getRecommendedAgents({
        limit: limit,
        pageUrl: pageUrl
    });
    if (isSiteSwitchResetEnabled && $808992f64c91fd00$var$isStaleAgentStoresGeneration(generationAtRequestStart)) return response;
    // Store the agents in the paginated store for optimistic updates etc.
    // Not adding them to a specific category in local cache on purpose.
    response.agents.forEach((agent)=>{
        updateAgent(agent.id, agent);
    });
    return response;
};
const $808992f64c91fd00$export$100f85e1b969f92e = ({ assistanceService: assistanceService, limit: limit = $808992f64c91fd00$var$DEFAULT_RECOMMENDED_AGENTS_LIMIT, pageUrl: pageUrl, updateAgent: updateAgent, onStart: onStart, onSuccess: onSuccess, onError: onError })=>{
    (0, $5SS4O.prefetchQuery)({
        queryKey: $808992f64c91fd00$var$getRecommendedAgentsQueryKey({
            limit: limit,
            pageUrl: pageUrl,
            siteId: assistanceService.getConfig().siteId
        }),
        queryFn: ()=>$808992f64c91fd00$var$fetchRecommendedAgents({
                assistanceService: assistanceService,
                limit: limit,
                pageUrl: pageUrl,
                updateAgent: updateAgent
            }),
        onStart: onStart,
        onSuccess: onSuccess,
        onError: onError
    });
};
const $808992f64c91fd00$export$631401679afcb10f = (0, $lJ6db.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: assistanceServiceInjectedParams, limit: limit = $808992f64c91fd00$var$DEFAULT_RECOMMENDED_AGENTS_LIMIT, pageUrl: pageUrl })=>{
    (0, $6cFsl.di)($808992f64c91fd00$export$65c6565d33cf8f4f);
    const { assistanceService: assistanceService, experienceTracker: experienceTracker, siteId: siteId } = assistanceServiceInjectedParams;
    const [agentsMap, { updateAgent: updateAgent }] = $808992f64c91fd00$export$65c6565d33cf8f4f();
    const { isFetching: isFetching, data: data } = (0, $5SS4O.useQuery)({
        queryKey: $808992f64c91fd00$var$getRecommendedAgentsQueryKey({
            limit: limit,
            pageUrl: pageUrl,
            siteId: siteId
        }),
        queryFn: async ()=>{
            experienceTracker.start({
                id: (0, $irnO2.ExperienceName).GET_RECOMMENDED_AGENTS,
                name: (0, $irnO2.ExperienceName).GET_RECOMMENDED_AGENTS
            });
            return $808992f64c91fd00$var$fetchRecommendedAgents({
                assistanceService: assistanceService,
                limit: limit,
                pageUrl: pageUrl,
                updateAgent: updateAgent
            });
        },
        enabled: Boolean(siteId),
        onSuccess: ()=>{
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).GET_RECOMMENDED_AGENTS
            });
        },
        onError: (error)=>{
            if ((0, $8reXX.isHipaaError)(error)) {
                experienceTracker.succeed({
                    name: (0, $irnO2.ExperienceName).GET_RECOMMENDED_AGENTS
                });
                return;
            }
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).GET_RECOMMENDED_AGENTS,
                error: error,
                teamName: (0, $33DP2.ROVO_AGENTS_FE_TEAM_NAME)
            });
        }
    });
    return {
        isFetching: isFetching,
        recommendedAgents: data?.agents.map((agent)=>agentsMap[agent.id]).filter(Boolean) ?? [],
        recommendationKey: data?.metadata?.recommendationKey
    };
});
const $808992f64c91fd00$export$71d3696dcc60eb2d = (0, $lJ6db.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { experienceTracker: experienceTracker, siteId: siteId } })=>{
    (0, $6cFsl.di)($808992f64c91fd00$export$1553678862324ff0, (0, $ig6TM.fetchAgentByExternalConfigReference));
    const { updateAgent: updateAgent, getCachedAgentByExternalConfigReference: getCachedAgentByExternalConfigReference } = $808992f64c91fd00$export$1553678862324ff0();
    const getAndStoreAgentByExternalConfigReference = (0, $cozmU.useCallback)(async ({ externalConfigReference: externalConfigReference })=>{
        const cachedAgent = getCachedAgentByExternalConfigReference(externalConfigReference);
        if (cachedAgent) return cachedAgent;
        const isSiteSwitchResetEnabled = (0, $iDrrr.fg)('rovo_chat_site_switch_reset');
        const generationAtRequestStart = $808992f64c91fd00$var$getAgentStoresGeneration();
        try {
            experienceTracker.start({
                name: (0, $irnO2.ExperienceName).FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE,
                id: (0, $irnO2.ExperienceName).FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE
            });
            const agentData = await (0, $ig6TM.fetchAgentByExternalConfigReference)({
                cloudId: siteId,
                externalConfigReference: externalConfigReference
            });
            if (!(isSiteSwitchResetEnabled && $808992f64c91fd00$var$isStaleAgentStoresGeneration(generationAtRequestStart))) // cache the data
            updateAgent(agentData.id, agentData);
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE
            });
            return agentData;
        } catch (error) {
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE,
                error: error,
                teamName: (0, $33DP2.ROVO_AGENTS_FE_TEAM_NAME)
            });
            return undefined;
        }
    }, [
        getCachedAgentByExternalConfigReference,
        experienceTracker,
        siteId,
        updateAgent
    ]);
    return {
        getAndStoreAgentByExternalConfigReference: getAndStoreAgentByExternalConfigReference
    };
});
const $808992f64c91fd00$export$eee66751ca85dbf7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (param)=>{
    return $808992f64c91fd00$export$f5b1109ecd7858c1(param);
} : (param)=>{
    return $808992f64c91fd00$export$f5b1109ecd7858c1(param);
};
const $808992f64c91fd00$export$6553fa633373a34 = (0, $lJ6db.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { product: product, experienceId: experienceId, headers: headers, touchpointSource: touchpointSource, siteId: siteId }, filter: filter })=>{
    const { availableAgents: availableAgents, favouritedAgents: favouritedAgents } = $808992f64c91fd00$export$eee66751ca85dbf7({
        assistanceServiceParams: {
            product: product,
            experienceId: experienceId,
            headers: headers,
            touchpointSource: touchpointSource,
            siteId: siteId
        }
    });
    const defaultAgents = (0, $aihbI.getSuggestedOotbAgents)({
        availableAgents: availableAgents,
        product: product
    });
    const defaultAgentsOutsideUserFavourites = defaultAgents.filter((defaultAgent)=>!favouritedAgents.find((favAgent)=>favAgent.id === defaultAgent.id));
    const favouritedAgentsWithDefault = [
        ...favouritedAgents,
        ...defaultAgentsOutsideUserFavourites.slice(0, Math.max(3 - favouritedAgents.length, 0))
    ];
    return filter === 'favourites' ? favouritedAgentsWithDefault : availableAgents;
});
module.exports["resetAgentStores"] = $808992f64c91fd00$export$242eb13d25184007;
module.exports["useAgentsPaginatedStoreActions"] = $808992f64c91fd00$export$1553678862324ff0;
module.exports["useAgentsPaginatedByAgentIdStoreHook"] = $808992f64c91fd00$export$cea603150faaa56f;
module.exports["useAgentsPaginatedByAgentId"] = $808992f64c91fd00$export$44c2e95a7a8b47c9;
module.exports["useAgentsPaginatedActionsWithOptimistic"] = $808992f64c91fd00$export$eae59c91509947e4;
module.exports["usePaginatedAgentsByCategory"] = $808992f64c91fd00$export$cc3deb815b1c179b;
module.exports["usePaginatedAgentsActions"] = $808992f64c91fd00$export$94c2040c41639ede;
module.exports["useRecommendedAgents"] = $808992f64c91fd00$export$631401679afcb10f;
module.exports["usePaginatedAgentByConfigReference"] = $808992f64c91fd00$export$71d3696dcc60eb2d;
module.exports["useAgentsList"] = $808992f64c91fd00$export$6553fa633373a34;

});

parcelRegister("5SS4O", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $kBr4q = parcelRequire("kBr4q");

var $fjHkB = parcelRequire("fjHkB");

var $8s9DV = parcelRequire("8s9DV");

var $c6StJ = parcelRequire("c6StJ");


var $8A2GO = parcelRequire("8A2GO");

const $65e219e9f9df9520$var$store = (0, $8s9DV.createStore)({
    initialState: {
        cache: {},
        epoch: 0
    },
    actions: {
        updateCacheEntry: (key, value)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const currentCacheEntry = state.cache[key] ?? {
                    data: null,
                    error: null,
                    isFetching: false
                };
                const newCacheEntry = {
                    ...currentCacheEntry,
                    ...value
                };
                setState({
                    cache: {
                        ...state.cache,
                        [key]: newCacheEntry
                    }
                });
            },
        getCacheEntry: (key)=>({ getState: getState })=>{
                const state = getState();
                return state.cache[key];
            },
        deleteCacheEntry: (key)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const cache = {
                    ...state.cache
                };
                delete cache[key];
                setState({
                    cache: cache
                });
            },
        clearCache: ()=>({ setState: setState, getState: getState })=>{
                setState({
                    cache: {},
                    epoch: getState().epoch + 1
                });
            }
    }
});
const $65e219e9f9df9520$var$getCacheEpoch = ()=>(0, $c6StJ.defaultRegistry).getStore($65e219e9f9df9520$var$store).storeState.getState().epoch;
const $65e219e9f9df9520$export$467f2e03eb04239a = ()=>{
    const storeApi = (0, $c6StJ.defaultRegistry).getStore($65e219e9f9df9520$var$store);
    storeApi.actions.clearCache();
};
const $65e219e9f9df9520$var$selector = (0, $fjHkB.createSelector)((state)=>state.cache, (state)=>state.epoch, (_, props)=>props.key, (_, props)=>props.initialQueryEnabled, /**
 * Based on testing, the result of this selector will be compared with previous result using `shallowEqual`
 * and it will determine whether to rerender the component
 * and also after looking at docs in https://github.com/atlassian/react-sweet-state/blob/master/src/utils/memoize.js#L38
 *
 * e.g. for `enabled` true condition:
 * -> 1st call -> cache[key] === undefined; so it will return { data: null, error: null, isFetching: true }
 * -> 2nd call -> cache[key] !== undefined; so it will return cache[key]; however shallowEqual(cache[key], previousResult) will return true -> so no rerender
 *
 * To test this, run the unit test, and then force this function to return new stuff on every call
 * e.g. `return { ...result, random: Math.random() };`
 * it will result in increase renderCount in the unit test
 */ (cache, epoch, key, initialQueryEnabled)=>({
        ...cache[key] ?? {
            data: null,
            error: null,
            isFetching: initialQueryEnabled
        },
        epoch: epoch
    }));
const $65e219e9f9df9520$var$useCacheEntry = (0, $kBr4q.createHook)($65e219e9f9df9520$var$store, {
    selector: $65e219e9f9df9520$var$selector
});
const $65e219e9f9df9520$export$96097db97bddd5cd = ({ queryKey: queryKeyParts, queryFn: queryFn, onStart: onStart, onSuccess: onSuccess, onError: onError })=>{
    const queryKey = queryKeyParts.map((x)=>x?.toString()).join('_');
    const storeApi = (0, $c6StJ.defaultRegistry).getStore($65e219e9f9df9520$var$store);
    const actions = storeApi.actions;
    if (actions.getCacheEntry(queryKey) !== undefined) return;
    onStart?.();
    const epochAtRequestStart = $65e219e9f9df9520$var$getCacheEpoch();
    actions.updateCacheEntry(queryKey, {
        isFetching: true,
        data: null,
        error: null
    });
    queryFn().then((response)=>{
        if ($65e219e9f9df9520$var$getCacheEpoch() !== epochAtRequestStart) return;
        actions.updateCacheEntry(queryKey, {
            data: response,
            error: null,
            isFetching: false
        });
        onSuccess?.(response);
    }).catch((error)=>{
        // Cache-side errors are intentionally swallowed: a downstream `useQuery`
        // observer (if any) must refetch and surface the error via its normal
        // path. Remove the warm entry so the failed prefetch does not poison the
        // shared cache for the cold path — unless the key has since been cleared
        // and refilled, in which case the entry is another request's to remove.
        if ($65e219e9f9df9520$var$getCacheEpoch() === epochAtRequestStart) actions.deleteCacheEntry(queryKey);
        onError?.(error);
    });
};
const $65e219e9f9df9520$export$dd0a697e1782aedd = ({ queryKey: queryKeyParts, queryFn: queryFn, onSuccess: onSuccess, onError: onError, enabled: enabled = true, refetchOnWindowFocus: refetchOnWindowFocus = false })=>{
    const queryKey = queryKeyParts.map((x)=>x?.toString()).join('_');
    const queryFnRef = (0, $cozmU.useRef)(queryFn);
    queryFnRef.current = queryFn;
    const onSuccessRef = (0, $cozmU.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $cozmU.useRef)(onError);
    onErrorRef.current = onError;
    const [cache, { updateCacheEntry: updateCacheEntry, getCacheEntry: getCacheEntry }] = $65e219e9f9df9520$var$useCacheEntry({
        key: queryKey,
        initialQueryEnabled: enabled
    });
    const fetchData = (0, $cozmU.useCallback)(async ()=>{
        const epochAtRequestStart = $65e219e9f9df9520$var$getCacheEpoch();
        updateCacheEntry(queryKey, {
            isFetching: true
        });
        try {
            const response = await queryFnRef.current();
            // The clear already dropped this request's entry, and whatever is under the key now
            // belongs to a later request — so write nothing at all, including `isFetching: false`.
            if ($65e219e9f9df9520$var$getCacheEpoch() !== epochAtRequestStart) return null;
            updateCacheEntry(queryKey, {
                data: response,
                error: null
            });
            onSuccessRef.current?.(response);
            return response;
        } catch (error) {
            const apiError = (0, $8A2GO.mapErrorToApiError)(error);
            if ($65e219e9f9df9520$var$getCacheEpoch() !== epochAtRequestStart) return null;
            updateCacheEntry(queryKey, {
                error: apiError
            });
            onErrorRef.current?.(apiError);
        } finally{
            if ($65e219e9f9df9520$var$getCacheEpoch() === epochAtRequestStart) updateCacheEntry(queryKey, {
                isFetching: false
            });
        }
        return null;
    }, [
        updateCacheEntry,
        queryKey
    ]);
    const updateCache = (0, $cozmU.useCallback)((data)=>{
        updateCacheEntry(queryKey, {
            data: data
        });
    }, [
        updateCacheEntry,
        queryKey
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (enabled && refetchOnWindowFocus) {
            const unbind = (0, $cbY7C.bind)(window, {
                // We use visibilitychange instead of focus to prevent triggering refetch when moving between iframes such as agent embed
                type: 'visibilitychange',
                listener: ()=>{
                    if (enabled && refetchOnWindowFocus && !getCacheEntry(queryKey)?.isFetching) {
                        if (document.visibilityState === 'visible') fetchData();
                    }
                }
            });
            return unbind;
        }
    }, [
        enabled,
        fetchData,
        getCacheEntry,
        queryKey,
        refetchOnWindowFocus
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!getCacheEntry(queryKey) && enabled) fetchData();
    }, [
        queryKey,
        fetchData,
        enabled,
        getCacheEntry,
        cache.epoch
    ]);
    return {
        data: cache.data,
        error: cache.error,
        isFetching: cache.isFetching,
        refetch: fetchData,
        updateCache: updateCache
    };
};
module.exports["clearQueryCache"] = $65e219e9f9df9520$export$467f2e03eb04239a;
module.exports["prefetchQuery"] = $65e219e9f9df9520$export$96097db97bddd5cd;
module.exports["useQuery"] = $65e219e9f9df9520$export$dd0a697e1782aedd;

});

parcelRegister("33DP2", function(module, exports) {
const $1034fab58a3f1117$export$73b400613798970e = 'rovo-agents-fe';
module.exports["ROVO_AGENTS_FE_TEAM_NAME"] = $1034fab58a3f1117$export$73b400613798970e;

});

parcelRegister("ig6TM", function(module, exports) {

var $6cFsl = parcelRequire("6cFsl");


var $iDrrr = parcelRequire("iDrrr");


var $haiCi = parcelRequire("haiCi");


var $hkokM = parcelRequire("hkokM");

const $23d23aea84aebb6d$export$cf57de7718965ae3 = {
    hasNextPage: false,
    hasPreviousPage: false,
    startCursor: undefined,
    endCursor: undefined
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $23d23aea84aebb6d$var$transformAgentListToGqlResponse = (response)=>{
    try {
        // data can be null if the `abortController` is aborted
        const { edges: edges, pageInfo: pageInfo } = response?.data?.agentStudio_getAgents ?? {
            pageInfo: $23d23aea84aebb6d$export$cf57de7718965ae3
        };
        const agents = edges?.map((edge)=>(0, $hkokM.transformAgentGqlResponse)(edge.node)).filter((agent)=>!!agent.id) ?? [];
        return {
            agents: agents,
            pageInfo: pageInfo
        };
    } catch  {
        return {
            agents: [],
            pageInfo: {
                hasNextPage: false,
                hasPreviousPage: false,
                startCursor: undefined,
                endCursor: undefined
            }
        };
    }
};
const $23d23aea84aebb6d$var$agentStudioAssistantFragment = `
fragment conversationAssistantAgent_agentStudioAssistant on AgentStudioAssistant {
  id
  name
  description
  conversationStarters
  isFavourite
  creatorType
  identityAccountId
  externalConfigReference
  creator {
    id
  }
  icon
  authoringTeam @skip(if: $skipAuthoringTeam) {
    id
    profileUrl
    displayName
		smallAvatarImageUrl
  }
  isVerified
  executionConfig @include(if: $includeExecutionConfig) {
    executionTier
    modelId
  }
}
`;
const $23d23aea84aebb6d$export$44f796a68d9bc9f1 = async ({ cloudId: cloudId, count: count = 10, after: after, product: product, input: input, abortController: abortController, workspaceId: workspaceId })=>{
    (0, $6cFsl.di)((0, $haiCi.performGqlFetch));
    const gqlQuery = `
	query agentStudioGetAgents($cloudId: String!, $first: Int, $input: AgentStudioAgentQueryInput, $after: String, $product: String, $workspaceId: String, $skipAuthoringTeam: Boolean = false, $includeExecutionConfig: Boolean = false) {
		agentStudio_getAgents(
			cloudId: $cloudId
			first: $first
			input: $input
			after: $after
			product: $product
			workspaceId: $workspaceId
		) @optIn(to: "AgentStudio") {
			edges {
				node {
					...conversationAssistantAgent_agentStudioAssistant
				}
			}
			pageInfo {
				startCursor
				endCursor
				hasNextPage
				hasPreviousPage
			}
		}
	}

	${$23d23aea84aebb6d$var$agentStudioAssistantFragment}
	`;
    const variables = {
        cloudId: cloudId,
        first: count,
        after: after,
        product: product,
        input: input,
        workspaceId: workspaceId,
        skipAuthoringTeam: (0, $iDrrr.fg)('rovo_agents_fetch_agents_without_authoring_team'),
        includeExecutionConfig: (0, $iDrrr.fg)('rovo_marathon_as_agent_enabled')
    };
    const response = await (0, $haiCi.performGqlFetch)({
        gqlQuery: gqlQuery,
        variables: variables,
        abortController: abortController
    });
    return $23d23aea84aebb6d$var$transformAgentListToGqlResponse(response);
};
const $23d23aea84aebb6d$export$fce04ce5e2fe57d3 = async ({ cloudId: cloudId, externalConfigReference: externalConfigReference })=>{
    (0, $6cFsl.di)((0, $haiCi.performGqlFetch));
    const gqlQuery = `
	query agentStudioGetAgentByExternalConfigReference($cloudId: String!, $externalConfigReference: String!, $skipAuthoringTeam: Boolean = false, $includeExecutionConfig: Boolean = false) {
		agentStudio_getByExternalReference(cloudId: $cloudId, externalReference: $externalConfigReference) @optIn(to: "AgentStudio") {
			...conversationAssistantAgent_agentStudioAssistant
			}
		}

		${$23d23aea84aebb6d$var$agentStudioAssistantFragment}
		`;
    const variables = {
        cloudId: cloudId,
        externalConfigReference: externalConfigReference,
        skipAuthoringTeam: (0, $iDrrr.fg)('rovo_agents_fetch_agents_without_authoring_team'),
        includeExecutionConfig: (0, $iDrrr.fg)('rovo_marathon_as_agent_enabled')
    };
    const response = await (0, $haiCi.performGqlFetch)({
        gqlQuery: gqlQuery,
        variables: variables
    });
    return (0, $hkokM.transformAgentGqlResponse)(response.data.agentStudio_getByExternalReference);
};
module.exports["DEFAULT_PAGE_INFO"] = $23d23aea84aebb6d$export$cf57de7718965ae3;
module.exports["fetchPaginatedAgents"] = $23d23aea84aebb6d$export$44f796a68d9bc9f1;
module.exports["fetchAgentByExternalConfigReference"] = $23d23aea84aebb6d$export$fce04ce5e2fe57d3;

});

parcelRegister("haiCi", function(module, exports) {

var $jTKfH = parcelRequire("jTKfH");


var $5rzIE = parcelRequire("5rzIE");

const $a406323faf455711$var$extractQueryName = (gqlQuery)=>{
    const operationMatch = gqlQuery.match(/(?:query|mutation)\s+(\w+)/);
    return operationMatch ? operationMatch[1] : undefined;
};
const $a406323faf455711$export$f602b5befecb0b84 = async ({ gqlQuery: gqlQuery, headerOptions: headerOptions, variables: variables, abortController: abortController })=>{
    const startedAt = (0, $5rzIE.hasRequestObservationSubscribers)() ? (0, $5rzIE.requestObservationNow)() : undefined;
    const operation = startedAt === undefined ? undefined : $a406323faf455711$var$extractQueryName(gqlQuery);
    try {
        const response = await fetch('/gateway/api/graphql', {
            headers: {
                'Content-Type': 'application/json',
                ...headerOptions
            },
            method: 'POST',
            body: JSON.stringify({
                query: gqlQuery,
                variables: variables
            }),
            signal: abortController?.signal
        });
        const json = await response.json();
        if (json?.errors?.length) await $a406323faf455711$var$processGqlErrorResponse({
            errors: json.errors,
            gqlQuery: gqlQuery
        });
        if (startedAt !== undefined) (0, $5rzIE.publishRequestObservation)({
            kind: 'graphql',
            method: 'POST',
            operation: operation,
            durationMs: (0, $5rzIE.requestObservationDuration)(startedAt),
            outcome: 'success',
            status: response.status
        });
        return json;
    } catch (err) {
        // GqlApiError is already processed
        if (err instanceof $a406323faf455711$export$ba203f24e0131ba7) {
            if (startedAt !== undefined) (0, $5rzIE.publishRequestObservation)({
                kind: 'graphql',
                method: 'POST',
                operation: operation,
                durationMs: (0, $5rzIE.requestObservationDuration)(startedAt),
                outcome: 'graphqlError'
            });
            throw err;
        }
        // Handle abort signal gracefully, it shouldn't be considered an error despite being caught
        if (err instanceof Error && err.name === 'AbortError') {
            if (startedAt !== undefined) (0, $5rzIE.publishRequestObservation)({
                kind: 'graphql',
                method: 'POST',
                operation: operation,
                durationMs: (0, $5rzIE.requestObservationDuration)(startedAt),
                outcome: 'abort'
            });
            return {
                // eslint-disable-next-line @atlaskit/platform/no-double-type-assertions -- Existing GraphQL abort baseline: abort returns an empty typed success shape for generic callers.
                data: null,
                errors: undefined
            };
        }
        const originalErrorMessage = err instanceof Error ? err.message : 'Unknown error';
        if (startedAt !== undefined) (0, $5rzIE.publishRequestObservation)({
            kind: 'graphql',
            method: 'POST',
            operation: operation,
            durationMs: (0, $5rzIE.requestObservationDuration)(startedAt),
            outcome: 'networkError'
        });
        throw new (0, $jTKfH.FetchError)(`GraphQL query failed (promise rejected): ${originalErrorMessage}`, {
            errorCode: 'performGqlFetchError'
        });
    }
};
class $a406323faf455711$export$ba203f24e0131ba7 extends Error {
    constructor({ errors: errors, queryName: queryName }){
        const errorsString = errors.map((error)=>error.message).join(', ');
        const errorMessage = `GraphQL API error: ${errorsString}`;
        super(errorMessage);
        this.message = void 0;
        this.errorAttributes = void 0;
        this.message = errorMessage;
        this.name = 'GraphQLError';
        this.errorAttributes = {
            errorCode: 'GqlApiError',
            queryName: queryName,
            rawErrorMessage: errorMessage,
            errors: errorsString
        };
    }
}
const $a406323faf455711$var$processGqlErrorResponse = async ({ errors: errors, gqlQuery: gqlQuery })=>{
    const errorsToThrow = [];
    errors.forEach((error)=>{
        errorsToThrow.push({
            message: error.message,
            status_code: error.extensions.statusCode,
            classification: error.extensions.classification
        });
    });
    throw new $a406323faf455711$export$ba203f24e0131ba7({
        errors: errorsToThrow,
        queryName: $a406323faf455711$var$extractQueryName(gqlQuery)
    });
};
module.exports["performGqlFetch"] = $a406323faf455711$export$f602b5befecb0b84;
module.exports["GqlApiError"] = $a406323faf455711$export$ba203f24e0131ba7;

});

parcelRegister("hkokM", function(module, exports) {
const $296d37b9c9e504ab$export$92f11cf4e802b166 = (ari)=>{
    // Pattern: ari:cloud:rovo::agent/activation/{uuid}/{uuid}
    const ariPattern = /^ari:cloud:rovo::agent\/activation\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/([^/]+)$/;
    const match = ari.match(ariPattern);
    if (!match) return null;
    // Return the second UUID (agent ID)
    return match[1];
};
const $296d37b9c9e504ab$export$91e35509133d1cc1 = (agentNode)=>({
        creator_type: agentNode.creatorType,
        creator: agentNode.creator?.id,
        description: agentNode.description,
        external_config_reference: agentNode.externalConfigReference,
        favourite: agentNode.isFavourite,
        id: $296d37b9c9e504ab$export$92f11cf4e802b166(agentNode.id) ?? '',
        agentAri: agentNode.id,
        identity_account_id: agentNode.identityAccountId,
        name: agentNode.name,
        user_defined_conversation_starters: agentNode.conversationStarters,
        icon: agentNode.icon,
        // We need named_id here as the FE requires it for certain features
        named_id: $296d37b9c9e504ab$export$92f11cf4e802b166(agentNode.id) ?? '',
        authoring_team: agentNode?.authoringTeam ? {
            id: agentNode.authoringTeam.id,
            profile_url: agentNode.authoringTeam.profileUrl,
            display_name: agentNode.authoringTeam.displayName,
            avatar_url: agentNode.authoringTeam.smallAvatarImageUrl
        } : null,
        is_verified: agentNode.isVerified,
        execution_config: agentNode.executionConfig ? {
            execution_tier: agentNode.executionConfig.executionTier
        } : null
    });
module.exports["transformAgentGqlResponse"] = $296d37b9c9e504ab$export$91e35509133d1cc1;

});

parcelRegister("aihbI", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $cXtTj = parcelRequire("cXtTj");


var $i1t43 = parcelRequire("i1t43");


var $NlHoa = parcelRequire("NlHoa");


var $12QCz = parcelRequire("12QCz");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");


var $hSs5g = parcelRequire("hSs5g");


var $hq9Cp = parcelRequire("hq9Cp");


var $a9aSv = parcelRequire("a9aSv");


var $hlvTd = parcelRequire("hlvTd");


var $5SS4O = parcelRequire("5SS4O");


var $ji12t = parcelRequire("ji12t");


var $yJycJ = parcelRequire("yJycJ");


var $8reXX = parcelRequire("8reXX");


var $aaPn1 = parcelRequire("aaPn1");


var $fjlCA = parcelRequire("fjlCA");


var $cKhij = parcelRequire("cKhij");

const $117d671412ecf119$export$3761e66a04602cbd = (ari)=>{
    const matched = ari.match(/\/([a-zA-Z0-9_\|\-\:]{1,128})$/);
    return matched ? matched[1] : undefined;
};
const $117d671412ecf119$export$acf3e1bcf222b00d = (aaid)=>{
    return `ari:cloud:identity::user/${aaid}`;
};
const $117d671412ecf119$export$1565ea9a9fb7ad67 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { agent: agent, siteId: siteId, simplified: simplified, onClick: onClick } = t0;
    if ((0, $ji12t.isSystemAgent)(agent) || (0, $ji12t.isOOTBAgent)(agent) || !agent.creator) {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                alignBlock: "center",
                testId: "atlassian-icon"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
                label: "",
                appearance: "brand",
                size: "small"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, "Atlassian"));
            $[0] = t1;
        } else t1 = $[0];
        return t1;
    }
    if ((0, $ji12t.isCustomerAgent)(agent)) {
        const authoringTeam = agent.authoring_team;
        if (authoringTeam?.id) {
            let t1;
            if ($[1] !== authoringTeam.display_name || $[2] !== authoringTeam.profile_url || $[3] !== onClick) {
                t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                    alignBlock: "center",
                    testId: "atlassian-icon"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    href: authoringTeam.profile_url,
                    target: "_blank",
                    onClick: onClick
                }, authoringTeam.display_name));
                $[1] = authoringTeam.display_name;
                $[2] = authoringTeam.profile_url;
                $[3] = onClick;
                $[4] = t1;
            } else t1 = $[4];
            return t1;
        }
        let t1;
        if ($[5] !== agent.creator) {
            t1 = agent.creator ? $117d671412ecf119$export$3761e66a04602cbd(agent.creator) : undefined;
            $[5] = agent.creator;
            $[6] = t1;
        } else t1 = $[6];
        const aaid = t1;
        if (!aaid) return null;
        let t2;
        if ($[7] !== aaid || $[8] !== onClick || $[9] !== simplified || $[10] !== siteId) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($117d671412ecf119$var$ResolvingMention, {
                userId: aaid,
                siteId: siteId,
                profileCard: true,
                simplified: simplified,
                onClick: onClick
            });
            $[7] = aaid;
            $[8] = onClick;
            $[9] = simplified;
            $[10] = siteId;
            $[11] = t2;
        } else t2 = $[11];
        return t2;
    }
    if ((0, $iDrrr.fg)("rovo_agent_support_a2a_avatar") ? (0, $hq9Cp.isForgeAgentByCreatorType)(agent.creator_type) : (0, $ji12t.isForgeAgent)(agent)) {
        if (agent.creator_type === "REMOTE_A2A" && (0, $cXtTj.default).getExperimentValue("rovo_hide_remote_a2a_agent_creator_exp", "isEnabled", false)) return null;
        let t1;
        if ($[12] !== agent.creator) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, agent.creator);
            $[12] = agent.creator;
            $[13] = t1;
        } else t1 = $[13];
        return t1;
    }
    return null;
} : ({ agent: agent, siteId: siteId, simplified: simplified, onClick: onClick })=>{
    if ((0, $ji12t.isSystemAgent)(agent) || (0, $ji12t.isOOTBAgent)(agent) || !agent.creator) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        testId: "atlassian-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
        label: "",
        appearance: "brand",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, "Atlassian"));
    if ((0, $ji12t.isCustomerAgent)(agent)) {
        const authoringTeam = agent.authoring_team;
        if (authoringTeam?.id) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            testId: "atlassian-icon"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: authoringTeam.profile_url,
            target: "_blank",
            onClick: onClick
        }, authoringTeam.display_name));
        const aaid = agent.creator ? $117d671412ecf119$export$3761e66a04602cbd(agent.creator) : undefined;
        if (!aaid) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($117d671412ecf119$var$ResolvingMention, {
            userId: aaid,
            siteId: siteId,
            profileCard: true,
            simplified: simplified,
            onClick: onClick
        });
    }
    if ((0, $iDrrr.fg)('rovo_agent_support_a2a_avatar') ? (0, $hq9Cp.isForgeAgentByCreatorType)(agent.creator_type) : (0, $ji12t.isForgeAgent)(agent)) {
        if (agent.creator_type === 'REMOTE_A2A' && (0, $cXtTj.default).getExperimentValue('rovo_hide_remote_a2a_agent_creator_exp', 'isEnabled', false)) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, agent.creator);
    }
    return null;
};
// TODO consolidate this with `AgentCreator` component `platform/packages/ai-mate/conversation-assistant-agent/src/common/ui/creator/index.tsx`
const $117d671412ecf119$var$ResolvingMention = ({ userId: userId, siteId: siteId, profileCard: profileCard = false, simplified: simplified = false, onClick: onClick })=>{
    (0, $6cFsl.di)($117d671412ecf119$export$5d980898591175e, (0, $yJycJ.useAgentCrossProductUrlWrapper));
    const { profile: profile, client: client } = $117d671412ecf119$export$5d980898591175e(userId, siteId);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { atlasURL: atlasURL } = (0, $aaPn1.useAtlasURL)(siteId);
    const wrapCrossProductUrl = (0, $yJycJ.useAgentCrossProductUrlWrapper)({
        xpcBridge: 'rovoAgents-browseAgentsModal'
    });
    const fullName = profile.data?.status === 'inactive' && profile.data.fullName ? formatMessage((0, $cKhij.default).deactivatedCreatorName, {
        name: profile.data.fullName
    }) : profile.data?.fullName;
    if (profile.isFetching || !profile.data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        isShimmering: true,
        height: 18,
        width: 100,
        borderRadius: "var(--ds-radius-small, 4px)"
    });
    if (simplified) {
        const profileUrl = wrapCrossProductUrl(atlasURL(`/people/${userId}`));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: profileUrl,
            target: "_blank",
            onClick: onClick
        }, fullName);
    }
    return profileCard ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSs5g.default), {
        userId: userId,
        resourceClient: client,
        ariaLabel: fullName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $12QCz.default), {
        id: userId,
        isHighlighted: profile.data.isCurrentUser,
        text: `@${fullName}`
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $12QCz.default), {
        id: userId,
        isHighlighted: profile.data.isCurrentUser,
        text: `@${fullName}`
    });
};
const $117d671412ecf119$export$5d980898591175e = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useProfileResolution(userId, siteId, t0) {
    const $ = (0, $bDgLe.c)(14);
    const shouldFetch = t0 === undefined ? true : t0;
    const profileClient = (0, $fjlCA.useProfileClient)();
    let t1;
    if ($[0] !== siteId || $[1] !== userId) {
        t1 = [
            "fetchProfile",
            siteId,
            userId
        ];
        $[0] = siteId;
        $[1] = userId;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== profileClient || $[4] !== siteId || $[5] !== userId) {
        t2 = async ()=>{
            try {
                const response = await profileClient.getProfile(siteId, userId);
                return response;
            } catch (t3) {
                const error = t3;
                (0, $hlvTd.logException)({
                    exception: error,
                    name: "ConversationAssistantAgentUseProfileResolutionError"
                });
                return {};
            }
        };
        $[3] = profileClient;
        $[4] = siteId;
        $[5] = userId;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== shouldFetch || $[8] !== t1 || $[9] !== t2) {
        t3 = {
            queryKey: t1,
            queryFn: t2,
            enabled: shouldFetch
        };
        $[7] = shouldFetch;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
    } else t3 = $[10];
    const profile = (0, $5SS4O.useQuery)(t3);
    let t4;
    if ($[11] !== profile || $[12] !== profileClient) {
        t4 = {
            profile: profile,
            client: profileClient
        };
        $[11] = profile;
        $[12] = profileClient;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
} : function useProfileResolution(userId, siteId, shouldFetch = true) {
    const profileClient = (0, $fjlCA.useProfileClient)();
    const profile = (0, $5SS4O.useQuery)({
        queryKey: [
            'fetchProfile',
            siteId,
            userId
        ],
        queryFn: async ()=>{
            try {
                const response = await profileClient.getProfile(siteId, userId);
                return response;
            } catch (error) {
                (0, $hlvTd.logException)({
                    exception: error,
                    name: 'ConversationAssistantAgentUseProfileResolutionError'
                });
                return {};
            }
        },
        enabled: shouldFetch
    });
    return {
        profile: profile,
        client: profileClient
    };
};
const $117d671412ecf119$export$13d60404a0dddebd = (agents, filters)=>{
    return agents.filter((agent)=>agent.name.toLocaleLowerCase().includes(filters.searchValue.toLocaleLowerCase()) || agent.description?.toLocaleLowerCase().includes(filters.searchValue.toLocaleLowerCase())).sort((a, b)=>a.name.localeCompare(b.name));
};
const $117d671412ecf119$export$a6e36c224ec3c0cb = (agent)=>{
    const enabledSources = agent.scenarios?.filter((scenario)=>scenario.isActive && scenario.isValid?.value)?.flatMap((scenario)=>scenario.knowledgeSources).filter((source)=>source?.enabled).flatMap((source)=>source?.sources).filter((source)=>source?.enabled);
    if (!enabledSources?.length) return [];
    const allAris = enabledSources.reduce((acc, cur)=>{
        const allFilters = [
            ...cur?.filters?.parentFilter ?? [],
            ...cur?.filters?.spaceFilter ?? [],
            ...cur?.filters?.projectFilter ?? []
        ];
        allFilters.forEach((item)=>acc.add(item));
        return acc;
    }, new Set());
    return Array.from(allAris);
};
const $117d671412ecf119$export$4aa0ac5d998cf08e = (agent)=>{
    const enabledSources = agent.scenarios?.filter((scenario)=>scenario.isActive && scenario.isValid?.value)?.flatMap((scenario)=>scenario.knowledgeSources).filter((source)=>source?.enabled).flatMap((source)=>source?.sources).filter((source)=>source?.enabled === true);
    const filtersByAri = new Map();
    enabledSources?.forEach((source)=>{
        const sourceAris = [
            ...source.filters?.parentFilter ?? [],
            ...source.filters?.spaceFilter ?? [],
            ...source.filters?.projectFilter ?? []
        ];
        sourceAris.forEach((ari)=>{
            if (!filtersByAri.has(ari)) filtersByAri.set(ari, {
                ari: ari,
                cloudId: source.cloudId ?? null
            });
        });
    });
    return [
        ...filtersByAri.values()
    ];
};
const $117d671412ecf119$export$6d876204c5d593ac = ({ availableAgents: availableAgents, product: product })=>{
    // If no product is provided / product is not supported, fallback to using default agents
    const defaultAgentsNamedIds = product ? (0, $8reXX.DEFAULT_OOTB_AGENTS_NAMED_IDS)[product] ?? (0, $8reXX.DEFAULT_AGENTS_NAMED_ID_LIST) : (0, $8reXX.DEFAULT_AGENTS_NAMED_ID_LIST);
    const defaultAgents = availableAgents.filter((agent)=>defaultAgentsNamedIds.has(agent.named_id) || agent.external_config_reference && defaultAgentsNamedIds.has(agent.external_config_reference));
    return defaultAgents;
};
module.exports["getAAIDFromARI"] = $117d671412ecf119$export$3761e66a04602cbd;
module.exports["AgentCreatedBy"] = $117d671412ecf119$export$1565ea9a9fb7ad67;
module.exports["useProfileResolution"] = $117d671412ecf119$export$5d980898591175e;
module.exports["getEnabledKnowlegeArisFromAgent"] = $117d671412ecf119$export$a6e36c224ec3c0cb;
module.exports["getEnabledKnowledgeFiltersFromAgent"] = $117d671412ecf119$export$4aa0ac5d998cf08e;
module.exports["getSuggestedOotbAgents"] = $117d671412ecf119$export$6d876204c5d593ac;

});

parcelRegister("i1t43", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $w6R6I = parcelRequire("w6R6I");


var $iDrrr = parcelRequire("iDrrr");


var $7vK9E = parcelRequire("7vK9E");

var $iMnC5 = parcelRequire("iMnC5");

const $7e44050607850249$var$styles = {
    base: "_0bjKvDcjp5 _0WKd3G4z3T",
    visitedLink: "_2nTuUYWfPD _3ADzdEWfPD _1warJ9WfPD _4scvAwWyeI",
    defaultAppearance: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _1UtDYzM7Tp _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5M7Tp _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _0clgaMM7Tp _3WzCGi98eZ _0NqVRtYbGa _3BKYwu6wH8 _0CMRbkAwSC",
    defaultAppearanceMotion: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYzM7Tp _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5M7Tp _0DCa9DjOvk _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMM7Tp _3WzCGijOvk _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbkAwSC",
    subtleAppearance: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _1UtDYzZpcK _32C2rk98eZ _0i9AWAYbGa _0mm6KQ6wH8 _10n1R5ZpcK _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMZpcK _3WzCGi98eZ _0NqVRt0Rl6 _3BKYwu6wH8 _0CMRbky7kJ",
    subtleAppearanceMotion: "_00uqCYjOvk _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYzZpcK _32C2rkjOvk _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5ZpcK _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMZpcK _3WzCGi98eZ _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbky7kJ",
    inverseAppearance: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _1UtDYze5R3 _2nTuUYe5R3 _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5e5R3 _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _0clgaMe5R3 _3WzCGi98eZ _0NqVRtYbGa _3BKYwu6wH8 _0CMRbke5R3",
    inverseAppearanceMotion: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYze5R3 _2nTuUYe5R3 _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5e5R3 _0DCa9DjOvk _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMe5R3 _3WzCGijOvk _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbke5R3",
    iconWrapper: "_3iDTPbS8kF _1ANEUSLRg7 _1RrJLiQame _1mT5xdRAKS _2I62gzVQEB"
};
const $7e44050607850249$var$iconStyles = null;
const $7e44050607850249$var$LinkWithoutRef = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(30);
    let children;
    let htmlAttributes;
    let newWindowLabel;
    let t1;
    let target;
    let testId;
    if ($[0] !== t0) {
        const { children: t2, testId: t3, appearance: t4, newWindowLabel: t5, target: t6, className: _preventedClassName, style: _preventedStyle, ...t7 } = t0;
        children = t2;
        testId = t3;
        t1 = t4;
        newWindowLabel = t5;
        target = t6;
        htmlAttributes = t7;
        $[0] = t0;
        $[1] = children;
        $[2] = htmlAttributes;
        $[3] = newWindowLabel;
        $[4] = t1;
        $[5] = target;
        $[6] = testId;
    } else {
        children = $[1];
        htmlAttributes = $[2];
        newWindowLabel = $[3];
        t1 = $[4];
        target = $[5];
        testId = $[6];
    }
    const appearance = t1 === undefined ? "default" : t1;
    let t2;
    if ($[7] !== appearance) {
        t2 = appearance === "default" && ((0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") ? $7e44050607850249$var$styles.defaultAppearanceMotion : $7e44050607850249$var$styles.defaultAppearance);
        $[7] = appearance;
        $[8] = t2;
    } else t2 = $[8];
    let t3;
    if ($[9] !== appearance) {
        t3 = appearance === "subtle" && ((0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") ? $7e44050607850249$var$styles.subtleAppearanceMotion : $7e44050607850249$var$styles.subtleAppearance);
        $[9] = appearance;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== appearance) {
        t4 = appearance === "inverse" && ((0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") ? $7e44050607850249$var$styles.inverseAppearanceMotion : $7e44050607850249$var$styles.inverseAppearance);
        $[11] = appearance;
        $[12] = t4;
    } else t4 = $[12];
    const t5 = appearance !== "inverse" && $7e44050607850249$var$styles.visitedLink;
    let t6;
    if ($[13] !== t2 || $[14] !== t3 || $[15] !== t4 || $[16] !== t5) {
        t6 = (0, $w6R6I.cx)($7e44050607850249$var$styles.base, t2, t3, t4, t5);
        $[13] = t2;
        $[14] = t3;
        $[15] = t4;
        $[16] = t5;
        $[17] = t6;
    } else t6 = $[17];
    let t7;
    if ($[18] !== target || $[19] !== testId) {
        t7 = target === "_blank" && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
            as: "span",
            xcss: $7e44050607850249$var$styles.iconWrapper,
            testId: testId && `${testId}__icon`,
            children: [
                "\uFEFF",
                /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
                    width: "12",
                    height: "12",
                    viewBox: "0 0 12 12",
                    fill: "none",
                    className: (0, $hekY6.default)([
                        "_39xV02YsW8 _0jFU0VYsW8 _0GTcwRu3qR"
                    ]),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                        fill: "currentColor"
                    })
                })
            ]
        });
        $[18] = target;
        $[19] = testId;
        $[20] = t7;
    } else t7 = $[20];
    let t8;
    if ($[21] !== children || $[22] !== htmlAttributes || $[23] !== newWindowLabel || $[24] !== ref || $[25] !== t6 || $[26] !== t7 || $[27] !== target || $[28] !== testId) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $7vK9E.Anchor), {
            ...htmlAttributes,
            target: target,
            ref: ref,
            xcss: t6,
            testId: testId,
            componentName: "Link",
            newWindowLabel: newWindowLabel,
            children: [
                children,
                t7
            ]
        });
        $[21] = children;
        $[22] = htmlAttributes;
        $[23] = newWindowLabel;
        $[24] = ref;
        $[25] = t6;
        $[26] = t7;
        $[27] = target;
        $[28] = testId;
        $[29] = t8;
    } else t8 = $[29];
    return t8;
} : ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>/*#__PURE__*/ (0, $8aG6j.jsxs)((0, $7vK9E.Anchor // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $w6R6I.cx)($7e44050607850249$var$styles.base, appearance === 'default' && ((0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') ? $7e44050607850249$var$styles.defaultAppearanceMotion : $7e44050607850249$var$styles.defaultAppearance), appearance === 'subtle' && ((0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') ? $7e44050607850249$var$styles.subtleAppearanceMotion : $7e44050607850249$var$styles.subtleAppearance), appearance === 'inverse' && ((0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') ? $7e44050607850249$var$styles.inverseAppearanceMotion : $7e44050607850249$var$styles.inverseAppearance), // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $7e44050607850249$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
                as: "span",
                xcss: $7e44050607850249$var$styles.iconWrapper,
                testId: testId && `${testId}__icon`,
                children: [
                    "\uFEFF",
                    /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, $hekY6.default)([
                            "_39xV02YsW8 _0jFU0VYsW8 _0GTcwRu3qR"
                        ]),
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    })
                ]
            })
        ]
    }); // Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $7e44050607850249$var$Link = /*#__PURE__*/ (0, $cozmU.forwardRef)($7e44050607850249$var$LinkWithoutRef);
var $7e44050607850249$export$2e2bcd8739ae039 = $7e44050607850249$var$Link;
module.exports["default"] = $7e44050607850249$export$2e2bcd8739ae039;

});

parcelRegister("12QCz", function(module, exports) {
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag React.Fragment
 */ /* eslint-disable @atlaskit/design-system/no-deprecated-imports, @typescript-eslint/no-restricted-types -- Preserve existing mention implementation while focus-ring usage is reviewed separately. */ parcelRequire("cozmU");


var $lzgC6 = parcelRequire("lzgC6");


var $kpMMm = parcelRequire("kpMMm");


var $9jOz9 = parcelRequire("9jOz9");


var $4cczm = parcelRequire("4cczm");

const $1b57c88557e5831b$export$7452d7062a4d0634 = 1000;
const $1b57c88557e5831b$var$MentionWithAnalytics = (0, $lzgC6.default)({
    onClick: (createEvent, props)=>{
        const { id: id, text: text, accessLevel: accessLevel } = props;
        const event = (0, $kpMMm.fireAnalyticsMentionEvent)(createEvent)('mention', 'selected', text, id, accessLevel);
        return event;
    },
    onHover: (createEvent, props)=>{
        const { id: id, text: text, accessLevel: accessLevel } = props;
        const event = (0, $kpMMm.fireAnalyticsMentionEvent)(createEvent)('mention', 'hovered', text, id, accessLevel);
        return event;
    }
})((0, $9jOz9.MentionInternal));
const $1b57c88557e5831b$var$Mention = $1b57c88557e5831b$var$MentionWithAnalytics;
var $1b57c88557e5831b$export$2e2bcd8739ae039 = $1b57c88557e5831b$var$Mention;
module.exports["ANALYTICS_HOVER_DELAY"] = $1b57c88557e5831b$export$7452d7062a4d0634;
module.exports["default"] = $1b57c88557e5831b$export$2e2bcd8739ae039;

});

parcelRegister("kpMMm", function(module, exports) {

var $852mP = parcelRequire("852mP");


var $4cczm = parcelRequire("4cczm");


var $vF2ex = parcelRequire("vF2ex");


var $caelp = parcelRequire("caelp");


var $4B8nE = parcelRequire("4B8nE");


var $iu9yU = parcelRequire("iu9yU");

const $e585dda4db4ca4b7$export$44902bc7b3f0b09f = (createEvent)=>(actionSubject, action, text, id, accessLevel)=>{
        const payload = {
            action: action,
            actionSubject: actionSubject,
            eventType: (0, $852mP.UI_EVENT_TYPE),
            attributes: {
                packageName: $4B8nE.packageName,
                packageVersion: $iu9yU.packageVersion,
                componentName: (0, $caelp.ComponentNames).MENTION,
                accessLevel: accessLevel,
                isSpecial: (0, $vF2ex.isSpecialMentionText)(text),
                userId: id
            }
        };
        const event = createEvent(payload);
        event.fire((0, $4cczm.ELEMENTS_CHANNEL));
        return event;
    };
module.exports["fireAnalyticsMentionEvent"] = $e585dda4db4ca4b7$export$44902bc7b3f0b09f;

});

parcelRegister("4cczm", function(module, exports) {
const $577b7b0c5e75a3c1$export$d821aa4c8afb384e = 'fabric-elements';
const $577b7b0c5e75a3c1$export$af8124aa496797f2 = '_|unknown|_';
module.exports["ELEMENTS_CHANNEL"] = $577b7b0c5e75a3c1$export$d821aa4c8afb384e;
module.exports["UNKNOWN_USER_ID"] = $577b7b0c5e75a3c1$export$af8124aa496797f2;

});

parcelRegister("vF2ex", function(module, exports) {
function $e97fcd08477c8114$export$d13d4f976b36a397(mentionText) {
    return mentionText && (mentionText === '@all' || mentionText === '@here');
}
module.exports["isSpecialMentionText"] = $e97fcd08477c8114$export$d13d4f976b36a397;

});

parcelRegister("caelp", function(module, exports) {
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $8auAj = parcelRequire("8auAj");





var $jymSm = parcelRequire("jymSm");



var $cLgZp = parcelRequire("cLgZp");

const $c573a2458006a7eb$export$43bc8ec87115a7b3 = '__agent-mentions-load-error__';
var $c573a2458006a7eb$export$2102863a3c660c6b = /*#__PURE__*/ function(MentionType) {
    MentionType[MentionType["SELF"] = 0] = "SELF";
    MentionType[MentionType["RESTRICTED"] = 1] = "RESTRICTED";
    MentionType[MentionType["DEFAULT"] = 2] = "DEFAULT";
    MentionType[MentionType["DISABLED"] = 3] = "DISABLED";
    return MentionType;
}({});
var $c573a2458006a7eb$export$81124e6148ca5db0 = /*#__PURE__*/ function(UserAccessLevel) {
    UserAccessLevel[UserAccessLevel["NONE"] = 0] = "NONE";
    UserAccessLevel[UserAccessLevel["SITE"] = 1] = "SITE";
    UserAccessLevel[UserAccessLevel["APPLICATION"] = 2] = "APPLICATION";
    UserAccessLevel[UserAccessLevel["CONTAINER"] = 3] = "CONTAINER";
    return UserAccessLevel;
}({});
var $c573a2458006a7eb$export$8436e53e45ffe15b = /*#__PURE__*/ function(UserType) {
    UserType[UserType["DEFAULT"] = 0] = "DEFAULT";
    UserType[UserType["SPECIAL"] = 1] = "SPECIAL";
    UserType[UserType["APP"] = 2] = "APP";
    UserType[UserType["TEAM"] = 3] = "TEAM";
    UserType[UserType["SYSTEM"] = 4] = "SYSTEM";
    return UserType;
}({});
var $c573a2458006a7eb$export$7afb0727c7d7e8af = /*#__PURE__*/ function(SliNames) {
    SliNames["SEARCH"] = "searchUser";
    SliNames["SEARCH_TEAM"] = "searchTeam";
    SliNames["INITIAL_STATE"] = "initialState";
    SliNames["SELECT"] = "select";
    SliNames["SELECT_TEAM"] = "selectTeam";
    return SliNames;
}({});
var $c573a2458006a7eb$export$5c42d9dea6d035c1 = /*#__PURE__*/ function(ComponentNames) {
    ComponentNames["TYPEAHEAD"] = "mentionTypeahead";
    ComponentNames["MENTION"] = "mention";
    return ComponentNames;
}({});
var $c573a2458006a7eb$export$b52183d5cfb26dc9 = /*#__PURE__*/ function(Actions) {
    Actions["VIEWED"] = "viewed";
    Actions["CLICKED"] = "clicked";
    Actions["CLOSED"] = "closed";
    Actions["SUCCEEDED"] = "succeeded";
    Actions["FAILED"] = "failed";
    return Actions;
}({});
var $c573a2458006a7eb$export$b8fa67dc54502853 = /*#__PURE__*/ function(MentionNameStatus) {
    MentionNameStatus[MentionNameStatus["UNKNOWN"] = 0] = "UNKNOWN";
    MentionNameStatus[MentionNameStatus["SERVICE_ERROR"] = 1] = "SERVICE_ERROR";
    MentionNameStatus[MentionNameStatus["OK"] = 2] = "OK";
    return MentionNameStatus;
}({});
module.exports["AGENT_MENTION_LOAD_ERROR_ID"] = $c573a2458006a7eb$export$43bc8ec87115a7b3;
module.exports["MentionType"] = $c573a2458006a7eb$export$2102863a3c660c6b;
module.exports["UserAccessLevel"] = $c573a2458006a7eb$export$81124e6148ca5db0;
module.exports["UserType"] = $c573a2458006a7eb$export$8436e53e45ffe15b;
module.exports["SliNames"] = $c573a2458006a7eb$export$7afb0727c7d7e8af;
module.exports["ComponentNames"] = $c573a2458006a7eb$export$5c42d9dea6d035c1;
module.exports["Actions"] = $c573a2458006a7eb$export$b52183d5cfb26dc9;
module.exports["MentionNameStatus"] = $c573a2458006a7eb$export$b8fa67dc54502853;

});

parcelRegister("8auAj", function(module, exports) {

var $caelp = parcelRequire("caelp");

function $34b824decffaa688$export$dbaa15dc1820b89a(accessLevel) {
    return !!accessLevel && accessLevel === (0, $caelp.UserAccessLevel)[(0, $caelp.UserAccessLevel).NONE];
}
module.exports["isRestricted"] = $34b824decffaa688$export$dbaa15dc1820b89a;

});

parcelRegister("dJKHF", function(module, exports) {

var $caelp = parcelRequire("caelp");

function $c171ae8007140e98$export$eb590c844d13454c(mention) {
    return mention.userType && mention.userType === (0, $caelp.UserType)[(0, $caelp.UserType).APP];
}
module.exports["isAppMention"] = $c171ae8007140e98$export$eb590c844d13454c;

});

parcelRegister("jymSm", function(module, exports) {

var $caelp = parcelRequire("caelp");

function $9c55ebf48e033037$export$803b1379348dbfd5(mention) {
    return mention.userType && mention.userType === (0, $caelp.UserType)[(0, $caelp.UserType).TEAM];
}
module.exports["isTeamMention"] = $9c55ebf48e033037$export$803b1379348dbfd5;

});

parcelRegister("cLgZp", function(module, exports) {
const $01246376cedc8400$export$4369c812aac99591 = (p)=>!!(p && p.then);
module.exports["isPromise"] = $01246376cedc8400$export$4369c812aac99591;

});

parcelRegister("4B8nE", function(module, exports) {
const $d00b5c54493e40b2$export$9345d7360ffe0722 = "platform-pkg";
module.exports["packageName"] = $d00b5c54493e40b2$export$9345d7360ffe0722;

});

parcelRegister("iu9yU", function(module, exports) {
const $d5e04dfa126c7e5e$export$91546b032799aa40 = "0.0.0-use.local";
module.exports["packageVersion"] = $d5e04dfa126c7e5e$export$91546b032799aa40;

});

parcelRegister("9jOz9", function(module, exports) {
/* MentionInternal.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $b1FLc = parcelRequire("b1FLc");


var $j7Sza = parcelRequire("j7Sza");


var $4cczm = parcelRequire("4cczm");


var $8auAj = parcelRequire("8auAj");


var $caelp = parcelRequire("caelp");


var $j1Rvl = parcelRequire("j1Rvl");


var $gcaru = parcelRequire("gcaru");


var $21cx5 = parcelRequire("21cx5");


var $iD1Wv = parcelRequire("iD1Wv");


var $cK6Td = parcelRequire("cK6Td");


var $12QCz = parcelRequire("12QCz");


var $27ALb = parcelRequire("27ALb");

function $23dc050c3f4ddea0$var$_defineProperty(e, r, t) {
    return (r = $23dc050c3f4ddea0$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $23dc050c3f4ddea0$var$_toPropertyKey(t) {
    var i = $23dc050c3f4ddea0$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $23dc050c3f4ddea0$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $23dc050c3f4ddea0$var$avatarStyles = null;
const $23dc050c3f4ddea0$var$avatarFallbackStyles = null;
const $23dc050c3f4ddea0$var$avatarImageStyles = null;
const $23dc050c3f4ddea0$var$agentAvatarStyles = null;
class $23dc050c3f4ddea0$export$92ab8442e7a15cef extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    componentDidMount() {
        (0, $27ALb.mentionRenderedUfoExperience).getInstance(this.props.id).success();
    }
    static getDerivedStateFromProps(props, state) {
        if (props.avatarUrl !== state.avatarUrl) return {
            avatarUrl: props.avatarUrl,
            hasAvatarError: false
        };
        return null;
    }
    componentWillUnmount() {
        if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        const ufoInstance = (0, $27ALb.mentionRenderedUfoExperience).getInstance(this.props.id);
        if ([
            (0, $j7Sza.UFOExperienceState)['STARTED'],
            (0, $j7Sza.UFOExperienceState)['IN_PROGRESS']
        ].includes(ufoInstance.state)) ufoInstance.abort();
    }
    renderUnknownUserError(id) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j1Rvl.UnknownUserError), {
            values: {
                userId: id.slice(-5)
            }
        }, (message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, `@${message}`));
    }
    render() {
        const { handleAvatarError: handleAvatarError, handleOnClick: handleOnClick, handleOnMouseEnter: handleOnMouseEnter, handleOnMouseLeave: handleOnMouseLeave, props: props } = this;
        const { appType: appType, avatarUrl: avatarUrl, text: text, id: id, accessLevel: accessLevel, localId: localId, disabledTooltip: disabledTooltip, isAvatarImagePreShaped: isAvatarImagePreShaped, renderAvatarSlot: renderAvatarSlot } = props;
        const mentionType = this.getMentionType();
        const failedMention = text === `@${0, $4cczm.UNKNOWN_USER_ID}`;
        const showAvatarSlot = Boolean(renderAvatarSlot) && !failedMention;
        const visibleText = showAvatarSlot && text.startsWith('@') ? text.slice(1) : text;
        const shouldApplyAgentShape = appType === 'agent' && !isAvatarImagePreShaped;
        const shouldRenderAvatar = avatarUrl && !this.state.hasAvatarError;
        const showRestrictedTooltip = mentionType === (0, $caelp.MentionType).RESTRICTED;
        const showDisabledTooltip = mentionType === (0, $caelp.MentionType).DISABLED && !!disabledTooltip; // A11y: when the chip is in the disabled visual state, expose
        // `aria-disabled` so assistive tech announces it as such. The
        // disabled-tooltip text is mirrored into `aria-label` so the
        // announcement carries the reason even without portal-id wiring for
        // `aria-describedby`.
        const isDisabledChip = mentionType === (0, $caelp.MentionType).DISABLED;
        const disabledA11yProps = isDisabledChip ? {
            'aria-disabled': true,
            tabIndex: 0,
            ...disabledTooltip ? {
                'aria-label': `${text || '@...'} \u{2014} ${disabledTooltip}`
            } : {}
        } : {};
        const mentionComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b1FLc.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cK6Td.default), {
            isAvatarVisible: showAvatarSlot,
            mentionType: mentionType,
            onClick: handleOnClick,
            onMouseEnter: handleOnMouseEnter,
            onMouseLeave: handleOnMouseLeave,
            spellCheck: false,
            "data-testid": `mention-${id}`,
            "data-mention-type": mentionType,
            "data-mention-tooltip": showRestrictedTooltip || showDisabledTooltip,
            ...disabledA11yProps
        }, failedMention ? this.renderUnknownUserError(id) : showAvatarSlot ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "aria-hidden": "true",
            "data-testid": "mention-avatar-slot",
            className: (0, $hekY6.default)([
                "_4bt5LAnQyn _2WAcuGnQyn _0bjKvDS5Zs _3iDTPbccYA _39xV02R4Xu _0jFU0VR4Xu _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _2xTnZx1Y8M _1RrJLiVdJo",
                shouldApplyAgentShape && "_0bjKvDdnbC _1uo2ZfnV0Y",
                this.state.hasAvatarError && "_1RrJLixiOt"
            ])
        }, shouldRenderAvatar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
            alt: "",
            decoding: "async",
            draggable: false,
            height: 16,
            loading: "lazy",
            onError: handleAvatarError,
            src: avatarUrl,
            "data-testid": "mention-avatar",
            width: 16,
            className: (0, $hekY6.default)([
                "_3iDTPbvLZJ _39xV02N91d _0jFU0VN91d _00EA0eiObl"
            ])
        }) : this.state.hasAvatarError ? '@' : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, visibleText || '...')) : text || '@...'));
        const ssrPlaceholderProp = props.ssrPlaceholderId ? {
            'data-ssr-placeholder': props.ssrPlaceholderId
        } : {};
        const wrappedMention = (()=>{
            if (showRestrictedTooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
                fallback: mentionComponent
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iD1Wv.default), {
                name: text
            }, mentionComponent));
            if (showDisabledTooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
                fallback: mentionComponent
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gcaru.default), {
                tooltip: disabledTooltip
            }, mentionComponent));
            return mentionComponent;
        })();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $27ALb.UfoErrorBoundary), {
            id: id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            id: localId,
            "data-mention-id": id,
            "data-local-id": localId,
            "data-access-level": accessLevel,
            spellCheck: false,
            ...ssrPlaceholderProp
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $21cx5.default), null, wrappedMention)));
    }
    constructor(props){
        super(props);
        $23dc050c3f4ddea0$var$_defineProperty(this, "hoverTimeout", void 0);
        $23dc050c3f4ddea0$var$_defineProperty(this, "state", {
            hasAvatarError: false
        });
        $23dc050c3f4ddea0$var$_defineProperty(this, "handleAvatarError", ()=>{
            this.setState({
                hasAvatarError: true
            });
        });
        $23dc050c3f4ddea0$var$_defineProperty(this, "handleOnClick", (e)=>{
            const { id: id, text: text, onClick: onClick, isDisabled: isDisabled } = this.props;
            if (isDisabled) // Disabled chips do not invoke their click handler.
            return;
            if (onClick) onClick(id, text, e);
        });
        $23dc050c3f4ddea0$var$_defineProperty(this, "handleOnMouseEnter", (e)=>{
            const { id: id, text: text, onMouseEnter: onMouseEnter, onHover: onHover } = this.props;
            if (onMouseEnter) onMouseEnter(id, text, e);
            this.hoverTimeout = window.setTimeout(()=>{
                if (onHover) onHover();
                this.hoverTimeout = undefined;
            }, (0, $12QCz.ANALYTICS_HOVER_DELAY));
        });
        $23dc050c3f4ddea0$var$_defineProperty(this, "handleOnMouseLeave", (e)=>{
            const { id: id, text: text, onMouseLeave: onMouseLeave } = this.props;
            if (onMouseLeave) onMouseLeave(id, text, e);
            if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        });
        $23dc050c3f4ddea0$var$_defineProperty(this, "getMentionType", ()=>{
            const { accessLevel: accessLevel, isHighlighted: isHighlighted, isDisabled: isDisabled } = this.props;
            if (isDisabled) return (0, $caelp.MentionType).DISABLED;
            if (isHighlighted) return (0, $caelp.MentionType).SELF;
            if ((0, $8auAj.isRestricted)(accessLevel)) return (0, $caelp.MentionType).RESTRICTED;
            return (0, $caelp.MentionType).DEFAULT;
        });
        (0, $27ALb.mentionRenderedUfoExperience).getInstance(props.id).start();
    }
}
module.exports["MentionInternal"] = $23dc050c3f4ddea0$export$92ab8442e7a15cef;

});

parcelRegister("j1Rvl", function(module, exports) {
parcelRequire("cozmU");


var $92AHJ = parcelRequire("92AHJ");


var $7n3BL = parcelRequire("7n3BL");

const $878ccfcc8552aaa6$export$98e06fe7a6174253 = (0, $7n3BL.propFormatter)((0, $92AHJ.messages).unknownUserError);
const $878ccfcc8552aaa6$export$58bd5a2057b6b855 = (0, $7n3BL.propFormatter)((0, $92AHJ.messages).noAccessWarning);
const $878ccfcc8552aaa6$export$da9f8ce14593162f = (0, $7n3BL.propFormatter)((0, $92AHJ.messages).noAccessLabel);
const $878ccfcc8552aaa6$export$4a258ffee7316766 = (0, $7n3BL.propFormatter)((0, $92AHJ.messages).defaultHeadline);
const $878ccfcc8552aaa6$export$702321a50d74536e = (0, $7n3BL.propFormatter)((0, $92AHJ.messages).defaultAdvisedAction);
const $878ccfcc8552aaa6$export$ed7f16088a93ae9d = (0, $7n3BL.propFormatter)((0, $92AHJ.messages).loginAgain);
const $878ccfcc8552aaa6$export$3ab158df56460d1c = (0, $7n3BL.propFormatter)((0, $92AHJ.messages).differentText);
module.exports["UnknownUserError"] = $878ccfcc8552aaa6$export$98e06fe7a6174253;
module.exports["NoAccessWarning"] = $878ccfcc8552aaa6$export$58bd5a2057b6b855;
module.exports["NoAccessLabel"] = $878ccfcc8552aaa6$export$da9f8ce14593162f;
module.exports["DefaultHeadline"] = $878ccfcc8552aaa6$export$4a258ffee7316766;
module.exports["DefaultAdvisedAction"] = $878ccfcc8552aaa6$export$702321a50d74536e;
module.exports["LoginAgain"] = $878ccfcc8552aaa6$export$ed7f16088a93ae9d;
module.exports["DifferentText"] = $878ccfcc8552aaa6$export$3ab158df56460d1c;

});

parcelRegister("92AHJ", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $fb7b952708721b37$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    unknownUserError: {
        id: "fabric.mention.unknow.user.error",
        defaultMessage: "Unknown user {userId}"
    },
    noAccessWarning: {
        id: "fabric.mention.noAccess.warning",
        defaultMessage: "{name} won't be notified as they have no access"
    },
    noAccessLabel: {
        id: "fabric.mention.noAccess.label",
        defaultMessage: "No access"
    },
    defaultHeadline: {
        id: "fabric.mention.error.defaultHeadline",
        defaultMessage: "Something went wrong"
    },
    defaultAdvisedAction: {
        id: "fabric.mention.error.defaultAction",
        defaultMessage: "Try again in a few seconds"
    },
    loginAgain: {
        id: "fabric.mention.error.loginAgain",
        defaultMessage: "Try logging out then in again"
    },
    differentText: {
        id: "fabric.mention.error.differentText",
        defaultMessage: "Try entering different text"
    },
    memberCountWithoutYou: {
        id: "fabric.elements.mentions.team.member.count",
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}"
    },
    memberCountWithYou: {
        id: "fabric.elements.mentions.team.member.count.including.you",
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}, including you"
    },
    plus50MembersWithoutYou: {
        id: "fabric.elements.mentions.team.member.50plus",
        defaultMessage: "Team \u2022 50+ members"
    },
    plus50MembersWithYou: {
        id: "fabric.elements.mentions.team.member.50plus.including.you",
        defaultMessage: "Team \u2022 50+ members, including you"
    },
    xProductMentionDescription: {
        id: "fabric.elements.mentions.xproduct.mention.description",
        defaultMessage: "Needs access to Confluence"
    },
    loadingPlaceholder: {
        id: "fabric.elements.mentions.loading.placeholder",
        defaultMessage: "Loading"
    }
});
module.exports["messages"] = $fb7b952708721b37$export$defe85febe8b728c;

});

parcelRegister("7n3BL", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

const $bb06cdc27dbcd8cb$export$392a0c6a82ab0e50 = (messageDescriptor)=>({ values: values, children: children })=>{
        const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
        const message = formatMessage(messageDescriptor, values);
        if (typeof children === 'function') return children(message);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            values: values,
            ...messageDescriptor
        });
    };
module.exports["propFormatter"] = $bb06cdc27dbcd8cb$export$392a0c6a82ab0e50;

});

parcelRegister("gcaru", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $139bcf7839d1a883$var$AsyncDisabledMentionTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("2GsKr")).then((module)=>{
        return {
            default: module.DisabledMentionTooltip
        };
    }));
var $139bcf7839d1a883$export$2e2bcd8739ae039 = $139bcf7839d1a883$var$AsyncDisabledMentionTooltip;
module.exports["default"] = $139bcf7839d1a883$export$2e2bcd8739ae039;

});

parcelRegister("2GsKr", function(module, exports) {

let $1f45cdcc4b463c3d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1f45cdcc4b463c3d$var$load("5bU1Y").then(()=>parcelRequire('eZafG'));

});

parcelRegister("21cx5", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $hI76F = parcelRequire("hI76F");

const $f497c875f65a609f$var$EMPTY = {};
const $f497c875f65a609f$var$useI18n = (0, $gtMdU.isReactCompilerActivePlatform)() ? (locale)=>{
    const $ = (0, $bDgLe.c)(3);
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState($f497c875f65a609f$var$EMPTY);
    let t0;
    let t1;
    if ($[0] !== locale) {
        t0 = ()=>{
            let aborted = false;
            setMessages($f497c875f65a609f$var$EMPTY);
            (0, $hI76F.getMessagesForLocale)(locale).then((messages_0)=>{
                if (!aborted) setMessages(messages_0);
            }).catch($f497c875f65a609f$var$_temp);
            return ()=>{
                aborted = true;
            };
        };
        t1 = [
            locale
        ];
        $[0] = locale;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t0, t1);
    return messages;
} : (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState($f497c875f65a609f$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        let aborted = false;
        setMessages($f497c875f65a609f$var$EMPTY);
        (0, $hI76F.getMessagesForLocale)(locale).then((messages_0)=>{
            if (!aborted) setMessages(messages_0);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $f497c875f65a609f$var$MessagesIntlProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children } = props;
    const intl = (0, $kSwu1.useIntl)();
    const messages = $f497c875f65a609f$var$useI18n(intl.locale);
    let t0;
    if ($[0] !== children || $[1] !== intl || $[2] !== messages) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            ...intl,
            messages: messages
        }, children);
        $[0] = children;
        $[1] = intl;
        $[2] = messages;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : (props)=>{
    const { children: children } = props;
    const intl = (0, $kSwu1.useIntl)();
    const messages = $f497c875f65a609f$var$useI18n(intl.locale);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        ...intl,
        messages: messages
    }, children);
};
var $f497c875f65a609f$export$2e2bcd8739ae039 = $f497c875f65a609f$var$MessagesIntlProvider;
function $f497c875f65a609f$var$_temp(error) {
    console.error(error);
}
module.exports["default"] = $f497c875f65a609f$export$2e2bcd8739ae039;

});

parcelRegister("hI76F", function(module, exports) {
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ 






























const $27fa02be5ce1169a$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("jX0rV")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("2tbWn")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("dOzBl")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("gpL0n")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("ePsdA")).then((mod)=>mod.default);
        case 'en_ZZ':
            return (parcelRequire("2GvIV")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("16HIv")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("WAFjY")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("474Ah")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("84VXz")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("fQ8BA")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("1lX2v")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("dDWYb")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("5XRxk")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("hMxVZ")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("58PuX")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("jglh9")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("iHOtt")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("d3k1V")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("6paIk")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("lXcxb")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("jK2My")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("cx1wp")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("ge9it")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("bMkyl")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("1O6Yy")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("486Xk")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("6bLNM")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("jNfyP")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("eL47t")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $27fa02be5ce1169a$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("gpL0n")).then((mod)=>mod.default);
            }
    }
};
module.exports["getMessagesForLocale"] = $27fa02be5ce1169a$export$d0a3169680473b6c;

});

parcelRegister("jX0rV", function(module, exports) {

let $e863e0441b14ec08$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e863e0441b14ec08$var$load("1JYrd"),
    $e863e0441b14ec08$var$load("cip6w"),
    $e863e0441b14ec08$var$load("gAG2n"),
    $e863e0441b14ec08$var$load("hFpP9"),
    $e863e0441b14ec08$var$load("3feYV"),
    $e863e0441b14ec08$var$load("cwjU2"),
    $e863e0441b14ec08$var$load("3Ff1R"),
    $e863e0441b14ec08$var$load("423Ga")
]).then(()=>parcelRequire('aIUTc'));

});

parcelRegister("2tbWn", function(module, exports) {

let $1cc78d5897d732a7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1cc78d5897d732a7$var$load("30242"),
    $1cc78d5897d732a7$var$load("3qBwQ"),
    $1cc78d5897d732a7$var$load("cYGDU"),
    $1cc78d5897d732a7$var$load("ddSTH"),
    $1cc78d5897d732a7$var$load("7Q1SM"),
    $1cc78d5897d732a7$var$load("33Iaa"),
    $1cc78d5897d732a7$var$load("blA7x"),
    $1cc78d5897d732a7$var$load("gJroP")
]).then(()=>parcelRequire('aK3gp'));

});

parcelRegister("dOzBl", function(module, exports) {

let $a0eb8f8a89644122$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a0eb8f8a89644122$var$load("15aAJ"),
    $a0eb8f8a89644122$var$load("8rREG"),
    $a0eb8f8a89644122$var$load("dgXJL"),
    $a0eb8f8a89644122$var$load("9d8JZ"),
    $a0eb8f8a89644122$var$load("7JdzX"),
    $a0eb8f8a89644122$var$load("6681T"),
    $a0eb8f8a89644122$var$load("3dn3H"),
    $a0eb8f8a89644122$var$load("cYXvt")
]).then(()=>parcelRequire('d43Vk'));

});

parcelRegister("gpL0n", function(module, exports) {

let $bf33715bc1c03891$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bf33715bc1c03891$var$load("hUbK8").then(()=>parcelRequire('6BJ6x'));

});

parcelRegister("ePsdA", function(module, exports) {

let $acbbb7a8f95cd6fc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $acbbb7a8f95cd6fc$var$load("l5BBd"),
    $acbbb7a8f95cd6fc$var$load("93ASN"),
    $acbbb7a8f95cd6fc$var$load("htu5t"),
    $acbbb7a8f95cd6fc$var$load("1A450"),
    $acbbb7a8f95cd6fc$var$load("24LNf"),
    $acbbb7a8f95cd6fc$var$load("iYQCc"),
    $acbbb7a8f95cd6fc$var$load("nBJth")
]).then(()=>parcelRequire('9BUhf'));

});

parcelRegister("2GvIV", function(module, exports) {

let $1f481cafca2c7f01$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1f481cafca2c7f01$var$load("bbv9t"),
    $1f481cafca2c7f01$var$load("9fQoJ"),
    $1f481cafca2c7f01$var$load("lTboH"),
    $1f481cafca2c7f01$var$load("gBDXQ"),
    $1f481cafca2c7f01$var$load("cnlNg"),
    $1f481cafca2c7f01$var$load("d3Phe"),
    $1f481cafca2c7f01$var$load("lASLx"),
    $1f481cafca2c7f01$var$load("bIXgz")
]).then(()=>parcelRequire('3u3mj'));

});

parcelRegister("16HIv", function(module, exports) {

let $0ce8433c656a7df9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0ce8433c656a7df9$var$load("7p4je"),
    $0ce8433c656a7df9$var$load("8SZbD"),
    $0ce8433c656a7df9$var$load("iE05k"),
    $0ce8433c656a7df9$var$load("lv5aU"),
    $0ce8433c656a7df9$var$load("9Uf61"),
    $0ce8433c656a7df9$var$load("3Yk1e"),
    $0ce8433c656a7df9$var$load("5lJyy"),
    $0ce8433c656a7df9$var$load("9w9df")
]).then(()=>parcelRequire('dWF5g'));

});

parcelRegister("WAFjY", function(module, exports) {

let $0b01dbe497441ac5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0b01dbe497441ac5$var$load("5ZQnr"),
    $0b01dbe497441ac5$var$load("lJyww"),
    $0b01dbe497441ac5$var$load("gVfjY"),
    $0b01dbe497441ac5$var$load("2hqQb"),
    $0b01dbe497441ac5$var$load("8RVFi")
]).then(()=>parcelRequire('33aAd'));

});

parcelRegister("474Ah", function(module, exports) {

let $2feb5f3312640ee1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2feb5f3312640ee1$var$load("1jQRQ"),
    $2feb5f3312640ee1$var$load("5pOQA"),
    $2feb5f3312640ee1$var$load("5GSny"),
    $2feb5f3312640ee1$var$load("cQump"),
    $2feb5f3312640ee1$var$load("fJSEb"),
    $2feb5f3312640ee1$var$load("ajzkj"),
    $2feb5f3312640ee1$var$load("eyysG"),
    $2feb5f3312640ee1$var$load("27gvR")
]).then(()=>parcelRequire('hDeI8'));

});

parcelRegister("84VXz", function(module, exports) {

let $5e1ba813b36eb977$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5e1ba813b36eb977$var$load("km37l"),
    $5e1ba813b36eb977$var$load("gbksI"),
    $5e1ba813b36eb977$var$load("j2X7f"),
    $5e1ba813b36eb977$var$load("fE8pi"),
    $5e1ba813b36eb977$var$load("9TeWr"),
    $5e1ba813b36eb977$var$load("kUZ7k"),
    $5e1ba813b36eb977$var$load("dJQL7"),
    $5e1ba813b36eb977$var$load("czj6d")
]).then(()=>parcelRequire('dvQoK'));

});

parcelRegister("fQ8BA", function(module, exports) {

let $b882632b90032289$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b882632b90032289$var$load("lTbXI"),
    $b882632b90032289$var$load("a98cw"),
    $b882632b90032289$var$load("e40mE"),
    $b882632b90032289$var$load("btBGI"),
    $b882632b90032289$var$load("fOGnR"),
    $b882632b90032289$var$load("cDQOq"),
    $b882632b90032289$var$load("8upye"),
    $b882632b90032289$var$load("GlmUM")
]).then(()=>parcelRequire('cvpu0'));

});

parcelRegister("1lX2v", function(module, exports) {

let $0fc58c977e435e13$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0fc58c977e435e13$var$load("8wMQe").then(()=>parcelRequire('LjIsh'));

});

parcelRegister("dDWYb", function(module, exports) {

let $9eeca90420daddea$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9eeca90420daddea$var$load("iUyZj"),
    $9eeca90420daddea$var$load("4PDaO"),
    $9eeca90420daddea$var$load("lMhbw"),
    $9eeca90420daddea$var$load("amTTV"),
    $9eeca90420daddea$var$load("8nEeY"),
    $9eeca90420daddea$var$load("kLZKK"),
    $9eeca90420daddea$var$load("c7GMc"),
    $9eeca90420daddea$var$load("bnhJ1")
]).then(()=>parcelRequire('e4VAB'));

});

parcelRegister("5XRxk", function(module, exports) {

let $457bfdb241591b32$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $457bfdb241591b32$var$load("kPlMQ"),
    $457bfdb241591b32$var$load("ervs7"),
    $457bfdb241591b32$var$load("8CX31"),
    $457bfdb241591b32$var$load("kYd4i"),
    $457bfdb241591b32$var$load("fzzMQ"),
    $457bfdb241591b32$var$load("33S6H"),
    $457bfdb241591b32$var$load("kFae4"),
    $457bfdb241591b32$var$load("iZWpE")
]).then(()=>parcelRequire('96CT4'));

});

parcelRegister("hMxVZ", function(module, exports) {

let $03573eef817c65ad$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $03573eef817c65ad$var$load("iT2sv"),
    $03573eef817c65ad$var$load("iMMtn"),
    $03573eef817c65ad$var$load("23VWs"),
    $03573eef817c65ad$var$load("e1KaU"),
    $03573eef817c65ad$var$load("3gNEO"),
    $03573eef817c65ad$var$load("93obY"),
    $03573eef817c65ad$var$load("6Y9jE"),
    $03573eef817c65ad$var$load("cUTaY")
]).then(()=>parcelRequire('2YvEH'));

});

parcelRegister("58PuX", function(module, exports) {

let $3be5a59a48a9e11b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3be5a59a48a9e11b$var$load("lyPpF"),
    $3be5a59a48a9e11b$var$load("eX5n7"),
    $3be5a59a48a9e11b$var$load("aiYuN"),
    $3be5a59a48a9e11b$var$load("gqMCT"),
    $3be5a59a48a9e11b$var$load("gvylW"),
    $3be5a59a48a9e11b$var$load("bxfRe"),
    $3be5a59a48a9e11b$var$load("ed6s8"),
    $3be5a59a48a9e11b$var$load("lAuJd")
]).then(()=>parcelRequire('6VUXz'));

});

parcelRegister("jglh9", function(module, exports) {

let $e06003d5e1220a42$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e06003d5e1220a42$var$load("iN3cj"),
    $e06003d5e1220a42$var$load("3nHdy"),
    $e06003d5e1220a42$var$load("gDEvm"),
    $e06003d5e1220a42$var$load("5MwHB"),
    $e06003d5e1220a42$var$load("80OLx"),
    $e06003d5e1220a42$var$load("1EVcg"),
    $e06003d5e1220a42$var$load("96q1k"),
    $e06003d5e1220a42$var$load("XQtfV")
]).then(()=>parcelRequire('4D1c2'));

});

parcelRegister("iHOtt", function(module, exports) {

let $d9e3654e24ebe721$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d9e3654e24ebe721$var$load("eC1OL"),
    $d9e3654e24ebe721$var$load("ilL9c"),
    $d9e3654e24ebe721$var$load("64nco"),
    $d9e3654e24ebe721$var$load("9cx6P"),
    $d9e3654e24ebe721$var$load("e4s0V"),
    $d9e3654e24ebe721$var$load("28EXy"),
    $d9e3654e24ebe721$var$load("7RZp5"),
    $d9e3654e24ebe721$var$load("leyTH")
]).then(()=>parcelRequire('htiZ2'));

});

parcelRegister("d3k1V", function(module, exports) {

let $980b17bc6670e7c7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $980b17bc6670e7c7$var$load("4NJ49"),
    $980b17bc6670e7c7$var$load("bfOZL"),
    $980b17bc6670e7c7$var$load("jLbRX"),
    $980b17bc6670e7c7$var$load("5g0HW"),
    $980b17bc6670e7c7$var$load("4dPO1"),
    $980b17bc6670e7c7$var$load("gg8tK"),
    $980b17bc6670e7c7$var$load("eF54W"),
    $980b17bc6670e7c7$var$load("3hnPt")
]).then(()=>parcelRequire('6FDlX'));

});

parcelRegister("6paIk", function(module, exports) {

let $4a9d6374e12b3eab$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4a9d6374e12b3eab$var$load("3zH5p").then(()=>parcelRequire('9VK7h'));

});

parcelRegister("lXcxb", function(module, exports) {

let $ffb8d4b57da0499e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ffb8d4b57da0499e$var$load("fsCDU"),
    $ffb8d4b57da0499e$var$load("kuolm"),
    $ffb8d4b57da0499e$var$load("fvE7S"),
    $ffb8d4b57da0499e$var$load("apVmx"),
    $ffb8d4b57da0499e$var$load("5xPg2")
]).then(()=>parcelRequire('0aYYd'));

});

parcelRegister("jK2My", function(module, exports) {

let $e5f478a9b13e5070$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e5f478a9b13e5070$var$load("g9gkE"),
    $e5f478a9b13e5070$var$load("jYdbS"),
    $e5f478a9b13e5070$var$load("6ncWv"),
    $e5f478a9b13e5070$var$load("gFneG"),
    $e5f478a9b13e5070$var$load("ltrgi"),
    $e5f478a9b13e5070$var$load("fu25G"),
    $e5f478a9b13e5070$var$load("iQGcz"),
    $e5f478a9b13e5070$var$load("ar4uw")
]).then(()=>parcelRequire('fHwYp'));

});

parcelRegister("cx1wp", function(module, exports) {

let $91f9bf4454da4b7f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $91f9bf4454da4b7f$var$load("dKdA9").then(()=>parcelRequire('6IGZA'));

});

parcelRegister("ge9it", function(module, exports) {

let $bd052a544036c7c1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $bd052a544036c7c1$var$load("jhikU"),
    $bd052a544036c7c1$var$load("f0i3H"),
    $bd052a544036c7c1$var$load("bvBAp"),
    $bd052a544036c7c1$var$load("9kqmW"),
    $bd052a544036c7c1$var$load("69YlM"),
    $bd052a544036c7c1$var$load("cyTsc"),
    $bd052a544036c7c1$var$load("kXCsp"),
    $bd052a544036c7c1$var$load("disCG")
]).then(()=>parcelRequire('cycD1'));

});

parcelRegister("bMkyl", function(module, exports) {

let $89341eca9b757efd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $89341eca9b757efd$var$load("52XP1").then(()=>parcelRequire('klwXC'));

});

parcelRegister("1O6Yy", function(module, exports) {

let $150fdf33bc578fed$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $150fdf33bc578fed$var$load("fSsz4"),
    $150fdf33bc578fed$var$load("kWOpS"),
    $150fdf33bc578fed$var$load("9tUAi"),
    $150fdf33bc578fed$var$load("bS9pO"),
    $150fdf33bc578fed$var$load("kgHzZ"),
    $150fdf33bc578fed$var$load("j4ur8"),
    $150fdf33bc578fed$var$load("fF7Id")
]).then(()=>parcelRequire('9kSto'));

});

parcelRegister("486Xk", function(module, exports) {

let $301d4e1521a68fed$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $301d4e1521a68fed$var$load("k3bMq").then(()=>parcelRequire('5pQz0'));

});

parcelRegister("6bLNM", function(module, exports) {

let $4818d99fabfc5b23$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4818d99fabfc5b23$var$load("lF2HI").then(()=>parcelRequire('dPXRL'));

});

parcelRegister("jNfyP", function(module, exports) {

let $e68ea9f4734869ef$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e68ea9f4734869ef$var$load("d91RK"),
    $e68ea9f4734869ef$var$load("f7hfJ"),
    $e68ea9f4734869ef$var$load("QI1kr"),
    $e68ea9f4734869ef$var$load("5LvhC"),
    $e68ea9f4734869ef$var$load("brdRT"),
    $e68ea9f4734869ef$var$load("lWBlc"),
    $e68ea9f4734869ef$var$load("s2EmI"),
    $e68ea9f4734869ef$var$load("jc0YL")
]).then(()=>parcelRequire('AOOMd'));

});

parcelRegister("eL47t", function(module, exports) {

let $abe8a684a19ae877$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $abe8a684a19ae877$var$load("708J7"),
    $abe8a684a19ae877$var$load("kVqUf"),
    $abe8a684a19ae877$var$load("2IMxh"),
    $abe8a684a19ae877$var$load("98tcg"),
    $abe8a684a19ae877$var$load("j03Pa"),
    $abe8a684a19ae877$var$load("kke1I"),
    $abe8a684a19ae877$var$load("gOwMq"),
    $abe8a684a19ae877$var$load("6GfaN")
]).then(()=>parcelRequire('gMQJr'));

});

parcelRegister("iD1Wv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $70ab48cd50028ae1$var$AsyncNoAccessTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("bfi3l")).then((module)=>{
        return {
            default: module.NoAccessTooltip
        };
    }));
var $70ab48cd50028ae1$export$2e2bcd8739ae039 = $70ab48cd50028ae1$var$AsyncNoAccessTooltip;
module.exports["default"] = $70ab48cd50028ae1$export$2e2bcd8739ae039;

});

parcelRegister("bfi3l", function(module, exports) {

let $021ce3818119c131$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $021ce3818119c131$var$load("akbkC").then(()=>parcelRequire('d7Uen'));

});

parcelRegister("cK6Td", function(module, exports) {
/* eslint-disable @atlaskit/design-system/no-html-button */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lOiVq = parcelRequire("lOiVq");


var $cozmU = parcelRequire("cozmU");


var $3U6po = parcelRequire("3U6po");

const $ef75f214d8da3bca$var$getStyle = ({ mentionType: mentionType }, property)=>(0, $3U6po.mentionStyle)[mentionType][property];
const $ef75f214d8da3bca$var$PrimitiveMention = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ isAvatarVisible: isAvatarVisible = false, mentionType: mentionType, ...other }, ref)=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        ref: ref,
        "data-avatar-visible": isAvatarVisible || undefined,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $lOiVq.css)("display:inline;border:var(--ds-border-width, 1px) solid ", $ef75f214d8da3bca$var$getStyle({
            mentionType: mentionType
        }, 'borderColor'), ";background:", $ef75f214d8da3bca$var$getStyle({
            mentionType: mentionType
        }, 'background'), ";color:", $ef75f214d8da3bca$var$getStyle({
            mentionType: mentionType
        }, 'text'), ";border-radius:20px;cursor:pointer;padding:0 0.3em 2px 0.23em;line-height:1.714;font-size:1em;font-weight:var(--ds-font-weight-regular, 400);word-break:break-word;&[data-avatar-visible='true']{padding:1px 0.3em 1px 0.23em;}&:hover{background:", $ef75f214d8da3bca$var$getStyle({
            mentionType: mentionType
        }, 'hoveredBackground'), ";}&:active{background:", $ef75f214d8da3bca$var$getStyle({
            mentionType: mentionType
        }, 'pressedBackground'), ";}"),
        ...other
    });
});
var $ef75f214d8da3bca$export$2e2bcd8739ae039 = $ef75f214d8da3bca$var$PrimitiveMention;
module.exports["default"] = $ef75f214d8da3bca$export$2e2bcd8739ae039;

});

parcelRegister("3U6po", function(module, exports) {

var $caelp = parcelRequire("caelp");

const $4789bd4e087c7edf$export$b0888661f7c77ab5 = {
    [(0, $caelp.MentionType).SELF]: {
        background: "var(--ds-background-brand-bold, #1868DB)",
        borderColor: 'transparent',
        text: "var(--ds-text-inverse, #FFFFFF)",
        hoveredBackground: "var(--ds-background-brand-bold-hovered, #1558BC)",
        pressedBackground: "var(--ds-background-brand-bold-pressed, #144794)"
    },
    [(0, $caelp.MentionType).RESTRICTED]: {
        background: 'transparent',
        borderColor: "var(--ds-border-bold, #7D818A)",
        text: "var(--ds-text, #292A2E)",
        hoveredBackground: 'transparent',
        pressedBackground: 'transparent'
    },
    [(0, $caelp.MentionType).DEFAULT]: {
        background: "var(--ds-background-neutral, #0515240F)",
        borderColor: 'transparent',
        text: "var(--ds-text-subtle, #505258)",
        hoveredBackground: "var(--ds-background-neutral-hovered, #0B120E24)",
        pressedBackground: "var(--ds-background-neutral-pressed, #080F214A)"
    },
    [(0, $caelp.MentionType).DISABLED]: {
        background: "var(--ds-background-disabled, #0515240F)",
        borderColor: 'transparent',
        text: "var(--ds-text-disabled, #080F214A)",
        // Disabled chips do not change on hover / press.
        hoveredBackground: "var(--ds-background-disabled, #0515240F)",
        pressedBackground: "var(--ds-background-disabled, #0515240F)"
    }
};
module.exports["mentionStyle"] = $4789bd4e087c7edf$export$b0888661f7c77ab5;

});

parcelRegister("27ALb", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4MiWC = parcelRequire("4MiWC");


var $fh15z = parcelRequire("fh15z");

const $0f53e930d80d4c74$export$1d011e4240507c78 = new (0, $fh15z.ConcurrentExperience)('mention-rendered', {
    platform: {
        component: 'mention'
    },
    type: (0, $4MiWC.ExperienceTypes).Load,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).PageSegmentLoad
});
class $0f53e930d80d4c74$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidCatch() {
        $0f53e930d80d4c74$export$1d011e4240507c78.getInstance(this.props.id).failure();
    }
    render() {
        return this.props.children;
    }
}
module.exports["mentionRenderedUfoExperience"] = $0f53e930d80d4c74$export$1d011e4240507c78;
module.exports["UfoErrorBoundary"] = $0f53e930d80d4c74$export$5ef1c2550074a375;

});

parcelRegister("hq9Cp", function(module, exports) {
const $84118747f7725463$export$3055eac4de8cbd2b = (creatorType)=>creatorType === 'THIRD_PARTY' || creatorType === 'FORGE' || creatorType === 'REMOTE_A2A';
module.exports["isForgeAgentByCreatorType"] = $84118747f7725463$export$3055eac4de8cbd2b;

});

parcelRegister("a9aSv", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $5EzLH = parcelRequire("5EzLH");


var $iDrrr = parcelRequire("iDrrr");

const $19ad0c297e7cfe22$var$shimmerKeyframes = null;
const $19ad0c297e7cfe22$var$skeletonStyles = null;
const $19ad0c297e7cfe22$var$activeShimmerStyles = null; /**
                                   * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
                                   * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
                                   * which makes things simpler than doing an `isServer` check or a `null` check.
                                   *
                                   * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
                                   */ 
const $19ad0c297e7cfe22$var$useLayoutEffect = typeof window === 'undefined' ? (0, $cozmU.useEffect) : (0, $cozmU.useLayoutEffect); /**
                                                                                          * __Skeleton__
                                                                                          *
                                                                                          * A skeleton acts as a placeholder for content, usually while the content loads.
                                                                                          *
                                                                                          * - [Examples](https://atlassian.design/components/skeleton/examples)
                                                                                          * - [Code](https://atlassian.design/components/skeleton/code)
                                                                                          */ 
const $19ad0c297e7cfe22$var$Skeleton = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { width: width, height: height, borderRadius: t1, color: color, ShimmeringEndColor: ShimmeringEndColor, isShimmering: t2, groupName: groupName, interactionName: interactionName, testId: testId } = t0;
    const borderRadius = t1 === undefined ? "var(--ds-radius-small, 4px)" : t1;
    const isShimmering = t2 === undefined ? false : t2;
    const groupDataAttribute = groupName && `data-${groupName}`;
    const context = (0, $cozmU.useContext)((0, $5EzLH.default));
    let t3;
    let t4;
    if ($[0] !== context || $[1] !== interactionName) {
        t3 = ()=>{
            if (context != null && (0, $iDrrr.fg)("platform-dst-skeleton-ufo-hold")) return context.hold(interactionName);
        };
        t4 = [
            context,
            interactionName
        ];
        $[0] = context;
        $[1] = interactionName;
        $[2] = t3;
        $[3] = t4;
    } else {
        t3 = $[2];
        t4 = $[3];
    }
    $19ad0c297e7cfe22$var$useLayoutEffect(t3, t4);
    const t5 = color && ShimmeringEndColor ? color : undefined;
    const t6 = color && ShimmeringEndColor ? ShimmeringEndColor : undefined;
    let t7;
    if ($[4] !== borderRadius || $[5] !== color || $[6] !== height || $[7] !== t5 || $[8] !== t6 || $[9] !== width) {
        t7 = {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color,
            "--ds-skeleton-from-color": t5,
            "--ds-skeleton-to-color": t6
        };
        $[4] = borderRadius;
        $[5] = color;
        $[6] = height;
        $[7] = t5;
        $[8] = t6;
        $[9] = width;
        $[10] = t7;
    } else t7 = $[10];
    const t8 = t7;
    let t9;
    if ($[11] !== groupDataAttribute) {
        t9 = groupDataAttribute && {
            [groupDataAttribute]: "true"
        };
        $[11] = groupDataAttribute;
        $[12] = t9;
    } else t9 = $[12];
    const t10 = isShimmering && "";
    const t11 = isShimmering && "_1gBibyKB6V";
    let t12;
    if ($[13] !== t10 || $[14] !== t11) {
        t12 = (0, $hekY6.default)([
            "_0uDzWjkSs3 _0nFVCGfONH _03m2nySHWH _43vdfTHVQb _0KLXruGsB2",
            t10,
            t11
        ]);
        $[13] = t10;
        $[14] = t11;
        $[15] = t12;
    } else t12 = $[15];
    let t13;
    if ($[16] !== t12 || $[17] !== t8 || $[18] !== t9 || $[19] !== testId) {
        t13 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": testId,
            style: t8,
            ...t9,
            className: t12
        });
        $[16] = t12;
        $[17] = t8;
        $[18] = t9;
        $[19] = testId;
        $[20] = t13;
    } else t13 = $[20];
    return t13;
} : ({ width: width, height: height, borderRadius: borderRadius = "var(--ds-radius-small, 4px)", color: color, ShimmeringEndColor: ShimmeringEndColor, isShimmering: isShimmering = false, groupName: groupName, interactionName: interactionName, testId: testId })=>{
    const groupDataAttribute = groupName && `data-${groupName}`;
    const context = (0, $cozmU.useContext)((0, $5EzLH.default));
    $19ad0c297e7cfe22$var$useLayoutEffect(()=>{
        if (context != null && (0, $iDrrr.fg)('platform-dst-skeleton-ufo-hold')) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-testid": testId,
        style: {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color,
            // Override the keyframes if both colors are provided, otherwise use the CSS variable fallbacks in our keyframes
            '--ds-skeleton-from-color': color && ShimmeringEndColor ? color : undefined,
            '--ds-skeleton-to-color': color && ShimmeringEndColor ? ShimmeringEndColor : undefined
        },
        ...groupDataAttribute && {
            [groupDataAttribute]: 'true'
        },
        className: (0, $hekY6.default)([
            "_0uDzWjkSs3 _0nFVCGfONH _03m2nySHWH _43vdfTHVQb _0KLXruGsB2",
            isShimmering && "",
            isShimmering && "_1gBibyKB6V"
        ])
    });
};
var $19ad0c297e7cfe22$export$2e2bcd8739ae039 = $19ad0c297e7cfe22$var$Skeleton;
module.exports["default"] = $19ad0c297e7cfe22$export$2e2bcd8739ae039;

});

parcelRegister("ji12t", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $ee0754b6a3322402$export$7c120b233d4844c6 = (agent)=>agent.creator_type === 'SYSTEM';
const $ee0754b6a3322402$export$f817e52cf2c5cc8c = (agent)=>agent.creator_type === 'CUSTOMER';
const $ee0754b6a3322402$export$2149adda3d8a5807 = (agent)=>agent.creator_type === 'THIRD_PARTY' || agent.creator_type === 'FORGE' || agent.creator_type === 'REMOTE_A2A' && (0, $iDrrr.fg)('rovo_agent_support_a2a_avatar');
const $ee0754b6a3322402$export$95433d0f8c6ad323 = (agent)=>agent.visibility === 'PRIVATE';
const $ee0754b6a3322402$export$7091e3bee2adaacb = (agent)=>agent.creator_type === 'OOTB';
const $ee0754b6a3322402$export$916e4870f74f205b = {
    ALL_AGENTS: 'all-agents',
    STARRED_AGENTS: 'starred-agents',
    MY_AGENTS: 'my-agents',
    TEMPLATES: 'templates',
    VERIFIED_AGENTS: 'verified-agents',
    /** Jira browse tab: agents available for Jira (UI label localized in product). */ AVAILABLE_FOR_JIRA: 'available-for-jira',
    /** Jira browse tab: 3P marketplace coding agents (UI label localized in product). */ CODING_AGENTS: 'coding-agents'
};
module.exports["isSystemAgent"] = $ee0754b6a3322402$export$7c120b233d4844c6;
module.exports["isCustomerAgent"] = $ee0754b6a3322402$export$f817e52cf2c5cc8c;
module.exports["isForgeAgent"] = $ee0754b6a3322402$export$2149adda3d8a5807;
module.exports["isOOTBAgent"] = $ee0754b6a3322402$export$7091e3bee2adaacb;
module.exports["BrowseCategories"] = $ee0754b6a3322402$export$916e4870f74f205b;

});

parcelRegister("yJycJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $aIlZA = parcelRequire("aIlZA");


var $6cFsl = parcelRequire("6cFsl");


var $cMyWi = parcelRequire("cMyWi");


var $iDrrr = parcelRequire("iDrrr");

const $77c2e4e3c0f10222$var$identity = (url)=>url;
const $77c2e4e3c0f10222$export$3c82e87d2696be5a = ({ xpcBridge: xpcBridge })=>{
    (0, $6cFsl.di)((0, $aIlZA.default));
    // Read defensively: `useSmartLinkContext()` throws without a provider, but
    // these components can render outside one.
    const cardContext = (0, $cozmU.useContext)((0, $cMyWi.SmartCardContext));
    const xpcProduct = cardContext?.xpcProduct;
    // Always call the hook (Rules of Hooks); result unused when we return identity.
    const wrapUrl = (0, $aIlZA.default)({
        bridge: xpcBridge,
        product: xpcProduct ?? ''
    });
    // No host product (unknown host / no provider) or kill-switch off: do not report.
    if (!xpcProduct || !(0, $iDrrr.fg)('ai-mate-xpc')) return $77c2e4e3c0f10222$var$identity;
    return wrapUrl;
};
module.exports["useAgentCrossProductUrlWrapper"] = $77c2e4e3c0f10222$export$3c82e87d2696be5a;

});

parcelRegister("8reXX", function(module, exports) {
const $631eae7ab6cb77ba$export$48783720d93c2d26 = {
    id: 'ai_mate_agent',
    named_id: 'ai_mate_agent',
    name: 'AI Mate',
    description: 'AI Mate',
    creator_type: 'SYSTEM',
    available_plugins: {},
    is_default: true,
    visibility: 'PUBLIC'
};
const $631eae7ab6cb77ba$export$2d0163867590928d = new Set([
    'decision_director_agent',
    'user_manual_writer_agent',
    'product_requirements_expert_agent'
]);
const $631eae7ab6cb77ba$export$804d9ee5f4cc40a8 = {
    ['confluence']: new Set([
        'decision_director_agent',
        'product_requirements_expert_agent',
        'rovo_expert_agent'
    ]),
    ['jira']: new Set([
        'rovo_expert_agent',
        'issue_organizer_agent',
        'jira_theme_analyzer_agent'
    ]),
    ['atlas']: new Set([
        'progress_tracker_agent',
        'product_requirements_expert_agent',
        'rovo_expert_agent'
    ])
};
const $631eae7ab6cb77ba$var$AGENT_AUP_ERROR_CODE = `convoai.agent.responsible-ai.failure`;
const $631eae7ab6cb77ba$var$HIPAA_ERROR_CODE = 'convoai.rest.browsing.product.has.hipaa.enabled';
const $631eae7ab6cb77ba$export$a08ace1426fa4a9e = (error)=>Boolean(error) && typeof error === 'object' && error.errorAttributes && error.errorAttributes.errorCode === $631eae7ab6cb77ba$var$AGENT_AUP_ERROR_CODE;
const $631eae7ab6cb77ba$export$f8b1b75846492611 = (error)=>Boolean(error) && typeof error === 'object' && error.errorAttributes && error.errorAttributes.errorCode === $631eae7ab6cb77ba$var$HIPAA_ERROR_CODE;
const $631eae7ab6cb77ba$export$429080cfef3412f2 = 'browse-agents-container';
module.exports["DEFAULT_AGENTS_NAMED_ID_LIST"] = $631eae7ab6cb77ba$export$2d0163867590928d;
module.exports["DEFAULT_OOTB_AGENTS_NAMED_IDS"] = $631eae7ab6cb77ba$export$804d9ee5f4cc40a8;
module.exports["isHipaaError"] = $631eae7ab6cb77ba$export$f8b1b75846492611;
module.exports["AGENTS_CONTAINER_ID"] = $631eae7ab6cb77ba$export$429080cfef3412f2;

});

parcelRegister("aaPn1", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7cQjw = parcelRequire("7cQjw");


var $iTxmV = parcelRequire("iTxmV");

const $bebfe5469a5e55d3$export$8a1abb7c176bd202 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (siteId)=>{
    const $ = (0, $bDgLe.c)(5);
    const { data: tenantData } = (0, $iTxmV.useTenantDataController)(siteId);
    let t0;
    if ($[0] !== siteId || $[1] !== tenantData?.orgId) {
        t0 = (path)=>(0, $7cQjw.getAtlasURL)(siteId, path, tenantData?.orgId);
        $[0] = siteId;
        $[1] = tenantData?.orgId;
        $[2] = t0;
    } else t0 = $[2];
    tenantData?.orgId;
    const atlasURL = t0;
    let t1;
    if ($[3] !== atlasURL) {
        t1 = {
            atlasURL: atlasURL
        };
        $[3] = atlasURL;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (siteId)=>{
    const { data: tenantData } = (0, $iTxmV.useTenantDataController)(siteId);
    const atlasURL = (0, $cozmU.useCallback)((path)=>(0, $7cQjw.getAtlasURL)(siteId, path, tenantData?.orgId), [
        siteId,
        tenantData?.orgId
    ]);
    return {
        atlasURL: atlasURL
    };
};
const $bebfe5469a5e55d3$export$b61b99f9ac0264be = (0, $gtMdU.isReactCompilerActivePlatform)() ? (siteId)=>{
    const $ = (0, $bDgLe.c)(2);
    const { atlasURL: atlasURL } = $bebfe5469a5e55d3$export$8a1abb7c176bd202(siteId);
    let t0;
    if ($[0] !== atlasURL) {
        t0 = atlasURL("/chat/agents/new");
        $[0] = atlasURL;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (siteId)=>{
    const { atlasURL: atlasURL } = $bebfe5469a5e55d3$export$8a1abb7c176bd202(siteId);
    return atlasURL('/chat/agents/new');
};
module.exports["useAtlasURL"] = $bebfe5469a5e55d3$export$8a1abb7c176bd202;

});

parcelRegister("7cQjw", function(module, exports) {

var $dTEBe = parcelRequire("dTEBe");


var $2J4Io = parcelRequire("2J4Io");

const $4c09219c949e06e3$var$ATLAS_PROD_URL = 'https://home.atlassian.com';
const $4c09219c949e06e3$var$ATLAS_STAGING_URL = 'https://home.stg.atlassian.com';
const $4c09219c949e06e3$export$5105758c0e772381 = ()=>{
    return (0, $2J4Io.isStaging)() ? $4c09219c949e06e3$var$ATLAS_STAGING_URL : $4c09219c949e06e3$var$ATLAS_PROD_URL;
};
const $4c09219c949e06e3$export$bfee0f88bf621ad3 = (siteId, path, orgId)=>{
    let argConcat = '?';
    let processedPath = path.startsWith('/') ? path : `/${path}`;
    if (processedPath.includes('?')) argConcat = '&';
    const basePath = orgId ? `${$4c09219c949e06e3$export$5105758c0e772381()}/o/${orgId}` : $4c09219c949e06e3$export$5105758c0e772381();
    return (0, $dTEBe.addRovoParamsToUrl)(`${basePath}${processedPath}${argConcat}cloudId=${siteId}`, {
        cloudId: siteId
    });
};
module.exports["getAtlasHost"] = $4c09219c949e06e3$export$5105758c0e772381;
module.exports["getAtlasURL"] = $4c09219c949e06e3$export$bfee0f88bf621ad3;

});

parcelRegister("2J4Io", function(module, exports) {
const $d610f1a90044572d$export$23da1d24a38b0bde = ()=>{
    const host = window.location.host;
    return host.includes('localhost') || host.includes('.stg.atlassian') || host.includes('.stg-east.frontend.public.atl-paas.net') || host.includes('jira-dev.com');
};
module.exports["isStaging"] = $d610f1a90044572d$export$23da1d24a38b0bde;

});

parcelRegister("iTxmV", function(module, exports) {

var $6cFsl = parcelRequire("6cFsl");


var $irnO2 = parcelRequire("irnO2");


var $bjY3F = parcelRequire("bjY3F");


var $5SS4O = parcelRequire("5SS4O");


var $fBeNh = parcelRequire("fBeNh");

const $a5b67b50b6da9994$export$b863fec6791eae25 = (siteId)=>{
    (0, $6cFsl.di)((0, $5SS4O.useQuery));
    const experience = (0, $bjY3F.useAIMateExperienceTracker)();
    const { data: data, isFetching: isFetching, error: error_0 } = (0, $5SS4O.useQuery)({
        queryKey: [
            'viewAgentTenantData',
            siteId
        ],
        queryFn: async ()=>{
            experience.start({
                id: (0, $irnO2.ExperienceName).FETCH_AGENT_TENANT_DATA,
                name: (0, $irnO2.ExperienceName).FETCH_AGENT_TENANT_DATA
            });
            const result = await (0, $fBeNh.getCloudUrlFromId)(siteId);
            return result;
        },
        onSuccess: ()=>{
            experience.succeed({
                name: (0, $irnO2.ExperienceName).FETCH_AGENT_TENANT_DATA
            });
        },
        onError: (error)=>{
            experience.fail({
                name: (0, $irnO2.ExperienceName).FETCH_AGENT_TENANT_DATA,
                error: error
            });
        }
    });
    return {
        data: data,
        isFetching: isFetching,
        error: error_0
    };
};
module.exports["useTenantDataController"] = $a5b67b50b6da9994$export$b863fec6791eae25;

});

parcelRegister("fBeNh", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $haiCi = parcelRequire("haiCi");


var $8JTh2 = parcelRequire("8JTh2");

const $c818cddb4b471711$var$CloudIdLookupQuery = `
query tenantQuery($cloudIds: [ID!]) {
  tenantContexts(cloudIds: $cloudIds) {
    cloudUrl
    orgId
    customDomains {
      product
      hostName
    }
  }
}
`;
// Cached per `cloudId` — the raw AGG payload is product-agnostic, so we fetch
// once per tenant and let the rewrite step branch on product. The cache stores
// the in-flight Promise so concurrent product lookups dedupe to one request.
const $c818cddb4b471711$var$rawTenantCache = new Map();
const $c818cddb4b471711$var$fetchTenantContext = async (cloudId)=>{
    const response = await (0, $haiCi.performGqlFetch)({
        gqlQuery: $c818cddb4b471711$var$CloudIdLookupQuery,
        variables: {
            cloudIds: [
                cloudId
            ]
        }
    });
    return response.data?.tenantContexts?.[0];
};
const $c818cddb4b471711$export$d4ace54df9bd6bb1 = async (cloudId, product)=>{
    const cachingEnabled = (0, $iDrrr.fg)('aifc_create_enabled');
    let inFlight = cachingEnabled ? $c818cddb4b471711$var$rawTenantCache.get(cloudId) : undefined;
    if (!inFlight) {
        inFlight = $c818cddb4b471711$var$fetchTenantContext(cloudId);
        if (cachingEnabled) {
            $c818cddb4b471711$var$rawTenantCache.set(cloudId, inFlight);
            inFlight.then((result)=>{
                if (result === undefined) $c818cddb4b471711$var$rawTenantCache.delete(cloudId);
            }, ()=>{
                $c818cddb4b471711$var$rawTenantCache.delete(cloudId);
            });
        }
    }
    const raw = await inFlight;
    if (!raw) return undefined;
    return {
        cloudUrl: product ? (0, $8JTh2.rewriteBaseToCustomDomain)(raw.cloudUrl, product, raw.customDomains) : raw.cloudUrl,
        orgId: raw.orgId
    };
};
module.exports["getCloudUrlFromId"] = $c818cddb4b471711$export$d4ace54df9bd6bb1;

});

parcelRegister("8JTh2", function(module, exports) {
const $43581a61b5d6dd12$export$432453592155ebf4 = (base, product, customDomains)=>{
    const match = customDomains?.find((domain)=>domain.product === product && Boolean(domain.hostName));
    if (!match) return base;
    try {
        const url = new URL(base);
        url.hostname = match.hostName;
        // url.toString() normalises bare-root URLs to include a trailing slash
        // (e.g. 'https://wiki.starbucks.com/'). All handlers concatenate a
        // leading-slash path, so we strip the trailing slash to avoid double-slashes
        // (e.g. 'https://wiki.starbucks.com//wiki/spaces/...' → correct).
        return url.toString().replace(/\/$/, '');
    } catch  {
        return base;
    }
};
module.exports["rewriteBaseToCustomDomain"] = $43581a61b5d6dd12$export$432453592155ebf4;

});

parcelRegister("fjlCA", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $5hJlu = parcelRequire("5hJlu");

const $b39593d68f627ba8$var$DIRECTORY_URL = '/gateway/api/directory/graphql';
let $b39593d68f627ba8$var$client;
const $b39593d68f627ba8$export$d43dc22a8337ee9f = ()=>{
    (0, $6cFsl.di)((0, $5hJlu.default));
    const profileClient = (0, $cozmU.useMemo)(()=>{
        if (!$b39593d68f627ba8$var$client) // To support di
        $b39593d68f627ba8$var$client = new (0, $5hJlu.default)({
            url: $b39593d68f627ba8$var$DIRECTORY_URL,
            cacheSize: 1000,
            // 1 day
            cacheMaxAge: 86400000
        });
        return $b39593d68f627ba8$var$client;
    }, []);
    return profileClient;
};
module.exports["useProfileClient"] = $b39593d68f627ba8$export$d43dc22a8337ee9f;

});

parcelRegister("cKhij", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $f61c2cb3f029b6ef$var$message = (0, $kSwu1.defineMessages)({
    deactivatedCreatorName: {
        id: "rovo-chat.agent-card.deactivated-name",
        defaultMessage: "{name} (deactivated)"
    }
});
var $f61c2cb3f029b6ef$export$2e2bcd8739ae039 = $f61c2cb3f029b6ef$var$message;
module.exports["default"] = $f61c2cb3f029b6ef$export$2e2bcd8739ae039;

});

parcelRegister("h6LPv", function(module, exports) {

var $irnO2 = parcelRequire("irnO2");


var $kuIhJ = parcelRequire("kuIhJ");


var $lJ6db = parcelRequire("lJ6db");


var $33DP2 = parcelRequire("33DP2");

const $ceec91f359597657$export$89877d4f8d8790ca = (0, $lJ6db.createHookWithAssistanceService)(({ onSuccess: onSuccess, onError: onError, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker }, onInit: onInit })=>{
    const deleteAgent = (0, $kuIhJ.useMutation)({
        mutationFn: async (id)=>{
            experienceTracker.start({
                id: (0, $irnO2.ExperienceName).DELETE_AGENT,
                name: (0, $irnO2.ExperienceName).DELETE_AGENT
            });
            onInit?.(id);
            return await assistanceService.deleteAgent(id);
        },
        onSuccess: async (data)=>{
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).DELETE_AGENT
            });
            onSuccess?.();
            return data;
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).DELETE_AGENT,
                error: error,
                teamName: (0, $33DP2.ROVO_AGENTS_FE_TEAM_NAME)
            });
            onError?.();
        }
    });
    return {
        deleteAgent: deleteAgent
    };
});
module.exports["useDeleteAgent"] = $ceec91f359597657$export$89877d4f8d8790ca;

});

parcelRegister("kuIhJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8A2GO = parcelRequire("8A2GO");

const $b4a77d21276ce51d$export$609860bf8b0084c = ({ mutationFn: mutationFn, onSuccess: onSuccess, onError: onError })=>{
    const mutationFnRef = (0, $cozmU.useRef)(mutationFn);
    mutationFnRef.current = mutationFn;
    const onSuccessRef = (0, $cozmU.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $cozmU.useRef)(onError);
    onErrorRef.current = onError;
    const [data, setData] = (0, $cozmU.useState)(null);
    const [error, setError] = (0, $cozmU.useState)(null);
    const [isSubmitting, setIsSubmitting] = (0, $cozmU.useState)(false);
    const mutate = (0, $cozmU.useCallback)(async (payload, mutateCallback)=>{
        setIsSubmitting(true);
        try {
            const response = await mutationFnRef.current(payload);
            setData(response);
            onSuccessRef.current?.(response);
            mutateCallback?.onSuccess?.(response);
            return response;
        } catch (error_0) {
            const apiError = (0, $8A2GO.mapErrorToApiError)(error_0);
            setError(apiError);
            onErrorRef.current?.(apiError, payload);
            mutateCallback?.onError?.(apiError);
        } finally{
            setIsSubmitting(false);
        }
    }, []);
    return {
        data: data,
        error: error,
        isSubmitting: isSubmitting,
        mutate: mutate
    };
};
module.exports["useMutation"] = $b4a77d21276ce51d$export$609860bf8b0084c;

});

parcelRegister("3ay5Z", function(module, exports) {

var $irnO2 = parcelRequire("irnO2");


var $kuIhJ = parcelRequire("kuIhJ");


var $lJ6db = parcelRequire("lJ6db");


var $33DP2 = parcelRequire("33DP2");

const $852df1b03fff5c54$export$5c4c46b1f93a6e69 = (0, $lJ6db.createHookWithAssistanceService)(({ onError: onError, onSuccess: onSuccess, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker } })=>{
    const favouriteAgent = (0, $kuIhJ.useMutation)({
        mutationFn: async (id)=>{
            experienceTracker.start({
                id: (0, $irnO2.ExperienceName).FAVOURITE_AGENT,
                name: (0, $irnO2.ExperienceName).FAVOURITE_AGENT
            });
            return await assistanceService.favouriteAgent(id);
        },
        onSuccess: async ()=>{
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).FAVOURITE_AGENT
            });
            onSuccess?.({
                favourite: true
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).FAVOURITE_AGENT,
                error: error,
                teamName: (0, $33DP2.ROVO_AGENTS_FE_TEAM_NAME)
            });
            onError?.({
                favourite: true
            });
        }
    });
    const unfavouriteAgent = (0, $kuIhJ.useMutation)({
        mutationFn: async (id)=>{
            experienceTracker.start({
                id: (0, $irnO2.ExperienceName).UNFAVOURITE_AGENT,
                name: (0, $irnO2.ExperienceName).UNFAVOURITE_AGENT
            });
            return await assistanceService.unfavouriteAgent(id);
        },
        onSuccess: async ()=>{
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).UNFAVOURITE_AGENT
            });
            onSuccess?.({
                favourite: false
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).UNFAVOURITE_AGENT,
                error: error,
                teamName: (0, $33DP2.ROVO_AGENTS_FE_TEAM_NAME)
            });
            onError?.({
                favourite: false
            });
        }
    });
    return {
        favouriteAgent: favouriteAgent,
        unfavouriteAgent: unfavouriteAgent
    };
});
module.exports["useAgentFavourites"] = $852df1b03fff5c54$export$5c4c46b1f93a6e69;

});

parcelRegister("5Vuk7", function(module, exports) {
const $17fc5339fe3ee56f$export$b873e2166b2a4c4f = (agents, agentIdFiltersOverride, agentDefaultIdOverride)=>{
    const defaultOverrideAgentsIndex = agents.findIndex((agent)=>agentDefaultIdOverride === agent.id);
    let overridenAgents = [];
    if (defaultOverrideAgentsIndex !== -1) overridenAgents = agents.map((agent, index)=>({
            ...agent,
            is_default: index === defaultOverrideAgentsIndex
        }));
    else overridenAgents = agents;
    if (Array.isArray(agentIdFiltersOverride)) return overridenAgents.filter((agent)=>agentIdFiltersOverride?.includes(agent.id) || agent.is_default);
    return overridenAgents;
};
module.exports["getOverridenAgents"] = $17fc5339fe3ee56f$export$b873e2166b2a4c4f;

});

parcelRegister("fU4xN", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $4657aea77ee8f7d7$var$message = (0, $kSwu1.defineMessages)({
    defaultAgentName: {
        id: "ai-mate.agent-selector.default-agent-name",
        defaultMessage: "Chat"
    },
    defaultAgentDescription: {
        id: "ai-mate.agent-selector.default-agent-description",
        defaultMessage: "Get answers, generate new ideas, and accelerate everyday work."
    }
});
var $4657aea77ee8f7d7$export$2e2bcd8739ae039 = $4657aea77ee8f7d7$var$message;
module.exports["default"] = $4657aea77ee8f7d7$export$2e2bcd8739ae039;

});

parcelRegister("6YdPR", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $eKjv9 = parcelRequire("eKjv9");

const $8640d528854286da$export$2a9125424215710e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { touchpointSource: touchpointSource } = t0;
    const { productHeader: productHeader, siteId: siteId, experienceId: experienceId, assistanceServiceConfig: assistanceServiceConfig } = (0, $eKjv9.useGlobalConfig)();
    assistanceServiceConfig?.headers;
    assistanceServiceConfig?.channelId;
    const t1 = assistanceServiceConfig?.headers;
    const t2 = assistanceServiceConfig?.channelId;
    let t3;
    if ($[0] !== experienceId || $[1] !== productHeader || $[2] !== siteId || $[3] !== t1 || $[4] !== t2 || $[5] !== touchpointSource) {
        t3 = {
            product: productHeader,
            experienceId: experienceId,
            touchpointSource: touchpointSource,
            siteId: siteId,
            headers: t1,
            channelId: t2
        };
        $[0] = experienceId;
        $[1] = productHeader;
        $[2] = siteId;
        $[3] = t1;
        $[4] = t2;
        $[5] = touchpointSource;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ touchpointSource: touchpointSource })=>{
    const { productHeader: productHeader, siteId: siteId, experienceId: experienceId, assistanceServiceConfig: assistanceServiceConfig } = (0, $eKjv9.useGlobalConfig)();
    return (0, $cozmU.useMemo)(()=>({
            product: productHeader,
            experienceId: experienceId,
            touchpointSource: touchpointSource,
            siteId: siteId,
            headers: assistanceServiceConfig?.headers,
            channelId: assistanceServiceConfig?.channelId
        }), [
        productHeader,
        experienceId,
        touchpointSource,
        siteId,
        assistanceServiceConfig?.headers,
        assistanceServiceConfig?.channelId
    ]);
};
module.exports["useAssistanceServiceParams"] = $8640d528854286da$export$2a9125424215710e;

});

parcelRegister("gn6Jj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $c69qG = parcelRequire("c69qG");

const $397d0442e822624b$export$e2f65d68917ec2b1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)((0, $c69qG.agentVersioningConfigContext));
} : ()=>(0, $cozmU.useContext)((0, $c69qG.agentVersioningConfigContext));
module.exports["useAgentVersioningConfig"] = $397d0442e822624b$export$e2f65d68917ec2b1;

});

parcelRegister("222kR", function(module, exports) {
const $925623d692bcf893$export$d669251a312339ff = (chat, type)=>{
    const lastIndex = chat.map((item)=>item.type).indexOf(type);
    if (lastIndex >= 0) return chat[lastIndex];
};
module.exports["getFirstMessageOfType"] = $925623d692bcf893$export$d669251a312339ff;

});

parcelRegister("dvUlt", function(module, exports) {

var $fCunh = parcelRequire("fCunh");

const $90bfb4e6c87059a4$export$8d253468a0039e81 = (errorCode)=>{
    return errorCode === (0, $fCunh.ASSISTANCE_SERVICE_ERROR_CODES).AGENT_FORBIDDEN || errorCode === (0, $fCunh.ASSISTANCE_SERVICE_ERROR_CODES).AGENT_DEACTIVATED;
};
module.exports["isAgentUnavailable"] = $90bfb4e6c87059a4$export$8d253468a0039e81;

});

parcelRegister("8akfd", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $d9cc5462c799c5c3$var$initialState = {
    messageIdSelectedForPreview: null,
    invocationIdSelectedForPreview: null,
    stagingAreaMode: undefined,
    stagingAreaEntryPoint: '',
    prompt: '',
    promptAppConnectorSources: [],
    isThirdPartyPromptStaged: false,
    dynamicUiType: undefined,
    dynamicUiSubtype: undefined,
    userSelectedDynamicUiSubtype: undefined,
    dynamicUiSource: undefined,
    interactionSource: undefined,
    isRemixUpdating: false,
    forceSkipAutoConversationSelection: false,
    currentDisplayMessageId: undefined,
    closeModalCallback: null
};
const $d9cc5462c799c5c3$var$actions = {
    setMessageIdSelectedForPreview: (messageId)=>({ setState: setState })=>{
            setState({
                messageIdSelectedForPreview: messageId
            });
        },
    getMessageIdSelectedForPreview: ()=>({ getState: getState })=>{
            return getState().messageIdSelectedForPreview;
        },
    setStagingAreaMode: (mode, entryPoint)=>({ setState: setState })=>{
            setState({
                stagingAreaMode: mode,
                stagingAreaEntryPoint: entryPoint ?? ''
            });
        },
    setStagingAreaEntryPoint: (entryPoint)=>({ setState: setState })=>{
            setState({
                stagingAreaEntryPoint: entryPoint ?? ''
            });
        },
    setPrompt: (prompt)=>({ setState: setState })=>{
            setState({
                prompt: prompt
            });
        },
    /**
   * Writes `isThirdPartyPromptStaged` in the same update, so the flag cannot drift from the
   * source list. Omitting `isThirdPartyPrompt` derives it from the list, which is what the
   * one-argument call has always meant: before this experiment a non-empty list was the only way
   * to stage a 3P prompt. Pass it for a 3P tile that carried no connectors — an empty list the
   * reader must still attribute to the experiment (CCINT-8714).
   */ setPromptAppConnectorSources: (promptAppConnectorSources, options)=>({ setState: setState })=>{
            setState({
                promptAppConnectorSources: promptAppConnectorSources,
                isThirdPartyPromptStaged: options?.isThirdPartyPrompt ?? promptAppConnectorSources.length > 0
            });
        },
    setInvocationIdSelectedForPreview: (invocationId)=>({ setState: setState })=>{
            setState({
                invocationIdSelectedForPreview: invocationId
            });
        },
    getInvocationIdSelectedForPreview: ()=>({ getState: getState })=>{
            return getState().invocationIdSelectedForPreview;
        },
    setIsRemixUpdating: (isUpdating)=>({ setState: setState })=>{
            setState({
                isRemixUpdating: isUpdating
            });
        },
    setDynamicUiContext: (dynamicUiType, dynamicUiSubtype, dynamicUiSource)=>({ setState: setState })=>{
            setState({
                dynamicUiType: dynamicUiType,
                dynamicUiSubtype: dynamicUiSubtype,
                dynamicUiSource: dynamicUiSource
            });
        },
    setUserSelectedDynamicUiSubtype: (userSelectedDynamicUiSubtype)=>({ setState: setState })=>{
            setState({
                userSelectedDynamicUiSubtype: userSelectedDynamicUiSubtype
            });
        },
    setInteractionSource: (interactionSource)=>({ setState: setState })=>{
            setState({
                interactionSource: interactionSource
            });
        },
    resetStagingArea: ()=>({ setState: setState })=>{
            setState({
                messageIdSelectedForPreview: null,
                invocationIdSelectedForPreview: null,
                isRemixUpdating: false,
                stagingAreaMode: undefined,
                stagingAreaEntryPoint: '',
                promptAppConnectorSources: [],
                isThirdPartyPromptStaged: false,
                dynamicUiType: undefined,
                dynamicUiSubtype: undefined,
                userSelectedDynamicUiSubtype: undefined,
                dynamicUiSource: undefined,
                interactionSource: undefined,
                forceSkipAutoConversationSelection: false,
                currentDisplayMessageId: undefined
            });
        },
    setForceSkipAutoConversationSelection: (forceSkip)=>({ setState: setState })=>{
            setState({
                forceSkipAutoConversationSelection: forceSkip
            });
        },
    setCurrentDisplayMessageId: (messageId)=>({ setState: setState })=>{
            setState({
                currentDisplayMessageId: messageId
            });
        },
    setCloseModalCallback: (closeModalCallback)=>({ setState: setState })=>{
            setState({
                closeModalCallback: closeModalCallback
            });
        },
    closeStagingAreaModal: ()=>({ getState: getState })=>{
            getState().closeModalCallback?.();
        }
};
const $d9cc5462c799c5c3$var$store = (0, $8s9DV.createStore)({
    initialState: $d9cc5462c799c5c3$var$initialState,
    actions: $d9cc5462c799c5c3$var$actions
});
const $d9cc5462c799c5c3$export$a2795b51ce92008f = (0, $kBr4q.createHook)($d9cc5462c799c5c3$var$store, {
    selector: (state)=>state.messageIdSelectedForPreview
});
const $d9cc5462c799c5c3$export$916334da9df8d04 = (0, $kBr4q.createHook)($d9cc5462c799c5c3$var$store);
const $d9cc5462c799c5c3$export$8f9a13b17bec42d5 = (0, $kBr4q.createActionsHook)($d9cc5462c799c5c3$var$store);
const $d9cc5462c799c5c3$export$5a57f796673aabea = (0, $kBr4q.createStateHook)($d9cc5462c799c5c3$var$store);
module.exports["useMessageIdSelectedForPreview"] = $d9cc5462c799c5c3$export$a2795b51ce92008f;
module.exports["useStagingArea"] = $d9cc5462c799c5c3$export$916334da9df8d04;
module.exports["useStagingAreaActions"] = $d9cc5462c799c5c3$export$8f9a13b17bec42d5;
module.exports["useStagingAreaState"] = $d9cc5462c799c5c3$export$5a57f796673aabea;

});

parcelRegister("lTU4O", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $cXtTj = parcelRequire("cXtTj");


var $2TZSo = parcelRequire("2TZSo");


var $isp1U = parcelRequire("isp1U");

const $1dccc6823e49008a$export$205c270e325a7524 = (aaid)=>{
    const preferences = JSON.parse(// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem((0, $2TZSo.LS_USER_PREFERENCES_KEY)) || '{}');
    return preferences[aaid];
};
const $1dccc6823e49008a$var$store = (0, $8s9DV.createStore)({
    initialState: {
        preferences: {
            // ideally we want to set the preference in the react component because
            // FF evaluated in module level may not resolve to correct value during SSR
            // however because there is localStorage setting and `firstLoad`, it requires a bit of refactoring to do it
            // this feature is only needed for dogfooding, so may not worth the refactor
            storeUserMessages: // eslint-disable-next-line @atlaskit/platform/no-module-level-eval
            (0, $cXtTj.default).initializeCalled() && (0, $cXtTj.default).checkGate('ai_mate_show_store_messages'),
            // default is undefined because we do not want migration to be started until we read from local storage value
            storeUserMessageMigratedToBE: undefined,
            useEditorContext: true
        },
        firstLoad: true
    },
    actions: {
        updatePreferences: (data)=>({ setState: setState, getState: getState })=>{
                setState({
                    preferences: {
                        ...getState().preferences,
                        ...data
                    },
                    firstLoad: false
                });
            }
    }
});
const $1dccc6823e49008a$var$useStore = (0, $kBr4q.createHook)($1dccc6823e49008a$var$store);
const $1dccc6823e49008a$export$b6472e0d8983f5f5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(27);
    const { aaid: aaid } = (0, $isp1U.useProfileController)();
    const [t0, t1] = $1dccc6823e49008a$var$useStore();
    const { preferences: preferences, firstLoad: firstLoad } = t0;
    const { updatePreferences: storeUpdatePreferences } = t1;
    let t2;
    if ($[0] !== aaid || $[1] !== preferences || $[2] !== storeUpdatePreferences) {
        t2 = (data)=>{
            if (!aaid) return;
            storeUpdatePreferences(data);
            localStorage.setItem((0, $2TZSo.LS_USER_PREFERENCES_KEY), JSON.stringify({
                [aaid]: {
                    ...preferences,
                    ...data
                }
            }));
        };
        $[0] = aaid;
        $[1] = preferences;
        $[2] = storeUpdatePreferences;
        $[3] = t2;
    } else t2 = $[3];
    const updatePreferences = t2;
    let t3;
    if ($[4] !== updatePreferences) {
        t3 = (storeUserMessages)=>{
            updatePreferences({
                storeUserMessages: storeUserMessages
            });
        };
        $[4] = updatePreferences;
        $[5] = t3;
    } else t3 = $[5];
    const setStoreUserMessages = t3;
    let t4;
    if ($[6] !== updatePreferences) {
        t4 = (useEditorContext)=>{
            updatePreferences({
                useEditorContext: useEditorContext
            });
        };
        $[6] = updatePreferences;
        $[7] = t4;
    } else t4 = $[7];
    const setUseEditorContext = t4;
    let t5;
    if ($[8] !== aaid || $[9] !== updatePreferences) {
        t5 = ()=>{
            if (!aaid) return;
            updatePreferences({
                storeUserMessageMigratedToBE: true
            });
        };
        $[8] = aaid;
        $[9] = updatePreferences;
        $[10] = t5;
    } else t5 = $[10];
    const markStoreUserMessageMigratedToBE = t5;
    let t6;
    if ($[11] !== updatePreferences) {
        t6 = (hasSeenFeedbackOptInPrompt)=>{
            updatePreferences({
                hasSeenFeedbackOptInPrompt: hasSeenFeedbackOptInPrompt
            });
        };
        $[11] = updatePreferences;
        $[12] = t6;
    } else t6 = $[12];
    const setHasSeenFeedbackOptInPrompt = t6;
    let t7;
    let t8;
    if ($[13] !== aaid || $[14] !== firstLoad || $[15] !== updatePreferences) {
        t7 = ()=>{
            if (aaid && firstLoad) {
                const preferences_0 = $1dccc6823e49008a$export$205c270e325a7524(aaid);
                if (preferences_0) updatePreferences({
                    ...preferences_0,
                    ...preferences_0.storeUserMessageMigratedToBE ? {} : {
                        storeUserMessageMigratedToBE: false
                    }
                });
            }
        };
        t8 = [
            aaid,
            firstLoad,
            updatePreferences
        ];
        $[13] = aaid;
        $[14] = firstLoad;
        $[15] = updatePreferences;
        $[16] = t7;
        $[17] = t8;
    } else {
        t7 = $[16];
        t8 = $[17];
    }
    (0, $cozmU.useEffect)(t7, t8);
    const t9 = aaid ? preferences.storeUserMessageMigratedToBE : undefined;
    let t10;
    if ($[18] !== preferences || $[19] !== t9) {
        t10 = {
            ...preferences,
            storeUserMessageMigratedToBE: t9
        };
        $[18] = preferences;
        $[19] = t9;
        $[20] = t10;
    } else t10 = $[20];
    let t11;
    if ($[21] !== markStoreUserMessageMigratedToBE || $[22] !== setHasSeenFeedbackOptInPrompt || $[23] !== setStoreUserMessages || $[24] !== setUseEditorContext || $[25] !== t10) {
        t11 = {
            preferences: t10,
            setStoreUserMessages: setStoreUserMessages,
            setUseEditorContext: setUseEditorContext,
            setHasSeenFeedbackOptInPrompt: setHasSeenFeedbackOptInPrompt,
            markStoreUserMessageMigratedToBE: markStoreUserMessageMigratedToBE
        };
        $[21] = markStoreUserMessageMigratedToBE;
        $[22] = setHasSeenFeedbackOptInPrompt;
        $[23] = setStoreUserMessages;
        $[24] = setUseEditorContext;
        $[25] = t10;
        $[26] = t11;
    } else t11 = $[26];
    return t11;
} : ()=>{
    const { aaid: aaid } = (0, $isp1U.useProfileController)();
    const [{ preferences: preferences, firstLoad: firstLoad }, { updatePreferences: storeUpdatePreferences }] = $1dccc6823e49008a$var$useStore();
    const updatePreferences = (0, $cozmU.useCallback)((data)=>{
        if (!aaid) return;
        storeUpdatePreferences(data);
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        localStorage.setItem((0, $2TZSo.LS_USER_PREFERENCES_KEY), JSON.stringify({
            [aaid]: {
                ...preferences,
                ...data
            }
        }));
    }, [
        aaid,
        preferences,
        storeUpdatePreferences
    ]);
    const setStoreUserMessages = (0, $cozmU.useCallback)((storeUserMessages)=>{
        updatePreferences({
            storeUserMessages: storeUserMessages
        });
    }, [
        updatePreferences
    ]);
    const setUseEditorContext = (0, $cozmU.useCallback)((useEditorContext)=>{
        updatePreferences({
            useEditorContext: useEditorContext
        });
    }, [
        updatePreferences
    ]);
    const markStoreUserMessageMigratedToBE = (0, $cozmU.useCallback)(()=>{
        if (!aaid) return;
        updatePreferences({
            storeUserMessageMigratedToBE: true
        });
    }, [
        updatePreferences,
        aaid
    ]);
    const setHasSeenFeedbackOptInPrompt = (0, $cozmU.useCallback)((hasSeenFeedbackOptInPrompt)=>{
        updatePreferences({
            hasSeenFeedbackOptInPrompt: hasSeenFeedbackOptInPrompt
        });
    }, [
        updatePreferences
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (aaid && firstLoad) {
            const preferences_0 = $1dccc6823e49008a$export$205c270e325a7524(aaid);
            if (preferences_0) updatePreferences({
                ...preferences_0,
                ...preferences_0.storeUserMessageMigratedToBE ? {} : {
                    storeUserMessageMigratedToBE: false
                }
            });
        }
    }, [
        aaid,
        firstLoad,
        updatePreferences
    ]);
    return {
        preferences: {
            ...preferences,
            storeUserMessageMigratedToBE: aaid ? preferences.storeUserMessageMigratedToBE : undefined
        },
        setStoreUserMessages: setStoreUserMessages,
        setUseEditorContext: setUseEditorContext,
        setHasSeenFeedbackOptInPrompt: setHasSeenFeedbackOptInPrompt,
        markStoreUserMessageMigratedToBE: markStoreUserMessageMigratedToBE
    };
};
module.exports["useUserPreferences"] = $1dccc6823e49008a$export$b6472e0d8983f5f5;

});

parcelRegister("2TZSo", function(module, exports) {
const $9ca4df0845d80c9e$export$97d0beb2ccc70a4d = 'aiMateUserPreferences';
module.exports["LS_USER_PREFERENCES_KEY"] = $9ca4df0845d80c9e$export$97d0beb2ccc70a4d;

});

parcelRegister("j1J3n", function(module, exports) {

var $dSoGR = parcelRequire("dSoGR");

const $76129364d697533a$export$5ea0e7c17cb45f8e = (0, $dSoGR.createCommand)('aifc-content-copied');
module.exports["AifcContentCopiedCommand"] = $76129364d697533a$export$5ea0e7c17cb45f8e;

});

parcelRegister("3Ak5G", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5Tn11 = parcelRequire("5Tn11");


var $85mU8 = parcelRequire("85mU8");

const $80d108dec70fe388$export$ff8fdce0b2574720 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $85mU8.getBrowserBridgeAPI)();
        $[0] = t0;
    } else t0 = $[0];
    const bridgeAPI = t0;
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (command, params)=>{
            const fullParams = {
                ...params,
                senderId: (0, $5Tn11.ROVO_CHAT_CLIENT_ID)
            };
            return bridgeAPI.send(command, fullParams);
        };
        $[1] = t1;
    } else t1 = $[1];
    const sendCommand = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            sendCommand: sendCommand
        };
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ()=>{
    const bridgeAPI = (0, $85mU8.getBrowserBridgeAPI)();
    const sendCommand = (0, $cozmU.useCallback)((command, params)=>{
        // Automatically inject senderId while preserving all other params
        const fullParams = {
            ...params,
            senderId: (0, $5Tn11.ROVO_CHAT_CLIENT_ID)
        };
        return bridgeAPI.send(command, fullParams);
    }, [
        bridgeAPI
    ]);
    return {
        sendCommand: sendCommand
    };
};
module.exports["useBridgeSendCommand"] = $80d108dec70fe388$export$ff8fdce0b2574720;

});

parcelRegister("1FOPM", function(module, exports) {
// Single-source dynamic import factory for the chat UI chunk.
// Mirrors `import-conversation-assistant.ts`: the `lazy()` boundary
// (`ConversationAssistantUILazy`) and the intent-time preload both go through here so they share
// one chunk identity.

const $9c885de35cb434ea$export$94646181d4dabf90 = ()=>(parcelRequire("lqMna"));
module.exports["importConversationAssistantUI"] = $9c885de35cb434ea$export$94646181d4dabf90;

});

parcelRegister("lqMna", function(module, exports) {

let $f9a18c7e04b1109a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f9a18c7e04b1109a$var$load("kwaPJ"),
    $f9a18c7e04b1109a$var$load("3ayyN"),
    $f9a18c7e04b1109a$var$load("52ggd"),
    $f9a18c7e04b1109a$var$load("hUbK8"),
    $f9a18c7e04b1109a$var$load("atmYP"),
    $f9a18c7e04b1109a$var$load("2putD"),
    $f9a18c7e04b1109a$var$load("d9LZs"),
    $f9a18c7e04b1109a$var$load("aROXU"),
    $f9a18c7e04b1109a$var$load("1rjMs"),
    $f9a18c7e04b1109a$var$load("2iMbN"),
    $f9a18c7e04b1109a$var$load("eLOQ2"),
    $f9a18c7e04b1109a$var$load("dx5gy"),
    $f9a18c7e04b1109a$var$load("gXTvE"),
    $f9a18c7e04b1109a$var$load("exl8k"),
    $f9a18c7e04b1109a$var$load("2mGc6"),
    $f9a18c7e04b1109a$var$load("kLS8s"),
    $f9a18c7e04b1109a$var$load("d19Pa"),
    $f9a18c7e04b1109a$var$load("l6kfs"),
    $f9a18c7e04b1109a$var$load("1R53K"),
    $f9a18c7e04b1109a$var$load("anA6E"),
    $f9a18c7e04b1109a$var$load("iPvQ1"),
    $f9a18c7e04b1109a$var$load("j2k0B"),
    $f9a18c7e04b1109a$var$load("14Wfp"),
    $f9a18c7e04b1109a$var$load("dxcsb"),
    $f9a18c7e04b1109a$var$load("3zwpG"),
    $f9a18c7e04b1109a$var$load("1VvO7"),
    $f9a18c7e04b1109a$var$load("g8Cky"),
    $f9a18c7e04b1109a$var$load("db7T5"),
    $f9a18c7e04b1109a$var$load("cIf37"),
    $f9a18c7e04b1109a$var$load("asveJ"),
    $f9a18c7e04b1109a$var$load("2TRyz"),
    $f9a18c7e04b1109a$var$load("lXUHS"),
    $f9a18c7e04b1109a$var$load("eoHHt"),
    $f9a18c7e04b1109a$var$load("51ESV"),
    $f9a18c7e04b1109a$var$load("ipIDQ"),
    $f9a18c7e04b1109a$var$load("gLJoQ"),
    $f9a18c7e04b1109a$var$load("8exG0"),
    $f9a18c7e04b1109a$var$load("gaT5l"),
    $f9a18c7e04b1109a$var$load("2Vm3g"),
    $f9a18c7e04b1109a$var$load("lkxmG"),
    $f9a18c7e04b1109a$var$load("c6SfL"),
    $f9a18c7e04b1109a$var$load("4Hcen"),
    $f9a18c7e04b1109a$var$load("9opi8"),
    $f9a18c7e04b1109a$var$load("ce05o"),
    $f9a18c7e04b1109a$var$load("kT6dz"),
    $f9a18c7e04b1109a$var$load("6vqGz"),
    $f9a18c7e04b1109a$var$load("aXAgf"),
    $f9a18c7e04b1109a$var$load("gw4CZ"),
    $f9a18c7e04b1109a$var$load("d1Ddn"),
    $f9a18c7e04b1109a$var$load("6wr18"),
    $f9a18c7e04b1109a$var$load("VXbA1"),
    $f9a18c7e04b1109a$var$load("7EorR"),
    $f9a18c7e04b1109a$var$load("fibpY"),
    $f9a18c7e04b1109a$var$load("4O6U4"),
    $f9a18c7e04b1109a$var$load("bQQNo"),
    $f9a18c7e04b1109a$var$load("ffEVr"),
    $f9a18c7e04b1109a$var$load("hhss7"),
    $f9a18c7e04b1109a$var$load("Wowvf"),
    $f9a18c7e04b1109a$var$load("f4Nog"),
    $f9a18c7e04b1109a$var$load("cKDij"),
    $f9a18c7e04b1109a$var$load("9SEo9")
]).then(()=>parcelRequire('8RDrG'));

});

parcelRegister("iA8l9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6CGVr = parcelRequire("6CGVr");


var $9DHhW = parcelRequire("9DHhW");


var $iGwRU = parcelRequire("iGwRU");


var $3Uocj = parcelRequire("3Uocj");


var $l9F99 = parcelRequire("l9F99");


var $i8NpI = parcelRequire("i8NpI");

const $65d9609224d5a714$var$globalEventConfig = (0, $i8NpI.getDefaultTrackEventConfig)();
const $65d9609224d5a714$export$885784b0858eefcc = (0, $gtMdU.isReactCompilerActivePlatform)() ? (commonAttributes)=>{
    const $ = (0, $bDgLe.c)(7);
    const analyticsContext = (0, $cozmU.useContext)((0, $6CGVr.default));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const commonAttributesRef = (0, $cozmU.useRef)(commonAttributes);
    let t0;
    if ($[0] !== analyticsContext || $[1] !== createAnalyticsEvent) {
        t0 = (event)=>{
            const attributes = {
                ...(0, $l9F99.getAttributesFromContexts)(analyticsContext.getAtlaskitAnalyticsContext()),
                ...commonAttributesRef.current,
                library: (0, $3Uocj.LIBRARY_ATTRIBUTE),
                ...event.attributes
            };
            createAnalyticsEvent({
                ...$65d9609224d5a714$var$globalEventConfig,
                ...event,
                attributes: attributes
            }).fire((0, $iGwRU.ANALYTICS_CHANNEL));
        };
        $[0] = analyticsContext;
        $[1] = createAnalyticsEvent;
        $[2] = t0;
    } else t0 = $[2];
    const fireAnalyticsEvent = t0;
    let t1;
    if ($[3] !== fireAnalyticsEvent) {
        t1 = (payload)=>{
            const { action: action, actionSubject: actionSubject, attributes: attributes_0, ...eventProps } = payload;
            fireAnalyticsEvent({
                actionSubject: actionSubject,
                action: action,
                ...eventProps,
                attributes: attributes_0
            });
        };
        $[3] = fireAnalyticsEvent;
        $[4] = t1;
    } else t1 = $[4];
    const trackAgentEvent = t1;
    let t2;
    if ($[5] !== trackAgentEvent) {
        t2 = {
            trackAgentEvent: trackAgentEvent
        };
        $[5] = trackAgentEvent;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : (commonAttributes)=>{
    const analyticsContext = (0, $cozmU.useContext)((0, $6CGVr.default));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const commonAttributesRef = (0, $cozmU.useRef)(commonAttributes);
    const fireAnalyticsEvent = (0, $cozmU.useCallback)((event)=>{
        const attributes = {
            ...(0, $l9F99.getAttributesFromContexts)(analyticsContext.getAtlaskitAnalyticsContext()),
            ...commonAttributesRef.current,
            library: (0, $3Uocj.LIBRARY_ATTRIBUTE),
            ...event.attributes
        };
        createAnalyticsEvent({
            ...$65d9609224d5a714$var$globalEventConfig,
            ...event,
            attributes: attributes
        }).fire((0, $iGwRU.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        analyticsContext
    ] // keep number of dependencies minimal to prevent re-rendering
    );
    /**
   * Fully-typed event tracking using discriminated union payload types.
   * The payload type enforces correct action, actionSubject, and attributes.
   */ const trackAgentEvent = (0, $cozmU.useCallback)((payload)=>{
        const { action: action, actionSubject: actionSubject, attributes: attributes_0, ...eventProps } = payload;
        fireAnalyticsEvent({
            actionSubject: actionSubject,
            action: action,
            ...eventProps,
            attributes: attributes_0
        });
    }, [
        fireAnalyticsEvent
    ]);
    return {
        trackAgentEvent: trackAgentEvent
    };
};
module.exports["useRovoAgentActionAnalytics"] = $65d9609224d5a714$export$885784b0858eefcc;

});

parcelRegister("6CGVr", function(module, exports) {
$parcel$export(module.exports, "default", () => $34a107ebb1ee65d2$export$2e2bcd8739ae039);

var $3ge84 = parcelRequire("3ge84");

var $34a107ebb1ee65d2$export$2e2bcd8739ae039 = (0, $3ge84.default);

});

parcelRegister("iGwRU", function(module, exports) {

var $iTJtk = parcelRequire("iTJtk");

const $3011e158d8129415$export$85183a312807388d = (0, $iTJtk.FabricChannel).aiMate;
module.exports["ANALYTICS_CHANNEL"] = $3011e158d8129415$export$85183a312807388d;

});

parcelRegister("3Uocj", function(module, exports) {
const $22c81417b0ee1e9b$export$88bd91d3e490ceb5 = 'agents-analytics';
module.exports["LIBRARY_ATTRIBUTE"] = $22c81417b0ee1e9b$export$88bd91d3e490ceb5;

});

parcelRegister("l9F99", function(module, exports) {
const $9a048168f718fa86$export$d97c97ed77ff09e8 = (context)=>{
    if (!context || !Array.isArray(context)) return {};
    return context.reduce((acc, x)=>{
        return {
            ...acc,
            ...x.attributes ?? {}
        };
    }, {});
};
module.exports["getAttributesFromContexts"] = $9a048168f718fa86$export$d97c97ed77ff09e8;

});

parcelRegister("i8NpI", function(module, exports) {
const $5912f9d7fe53faa6$export$f6abe2eda5c1912f = ()=>({
        eventType: 'track',
        tags: [
            'atlaskit'
        ]
    });
module.exports["getDefaultTrackEventConfig"] = $5912f9d7fe53faa6$export$f6abe2eda5c1912f;

});

parcelRegister("aQWBL", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $7685l = parcelRequire("7685l");

const $e2fc5133d9d39a50$export$e8c93422b36ab121 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (key)=>{
    const state = (0, $7685l.useChatModeStore)(key)[0];
    return state;
} : (key)=>{
    const state = (0, $7685l.useChatModeStore)(key)[0];
    return state;
};
module.exports["useChatModeState"] = $e2fc5133d9d39a50$export$e8c93422b36ab121;

});

parcelRegister("7685l", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");


var $gchVc = parcelRequire("gchVc");


var $5osBM = parcelRequire("5osBM");


var $eu92c = parcelRequire("eu92c");


var $fiVb2 = parcelRequire("fiVb2");

const $69cb0d12a6c3bd0b$var$selector = (state, key)=>{
    const chatMode = state[key] || (0, $5osBM.getDerivedDefaultChatMode)();
    return {
        ...chatMode,
        ...(0, $eu92c.getDerivedReasoningMode)(chatMode.reasoningMode),
        appFilters: (0, $gchVc.getAppFilters)(chatMode.orgKnowledge)
    };
};
const $69cb0d12a6c3bd0b$export$cdc6dc7c4e8829fa = (0, $kBr4q.createHook)((0, $fiVb2.store), {
    selector: $69cb0d12a6c3bd0b$var$selector
});
module.exports["useChatModeStore"] = $69cb0d12a6c3bd0b$export$cdc6dc7c4e8829fa;

});

parcelRegister("gchVc", function(module, exports) {
const $3b98ce1c6aca161d$export$6c9b22c84a96fd6c = (orgKnowledge)=>{
    if (orgKnowledge === 'disabled') // no org knowledge applied at all.
    return [];
    else if (orgKnowledge.filteredApps.length === 0) // all org knowledge applied and no apps filtered.
    return undefined;
    else // org knowledge applied and apps filtered.
    return orgKnowledge.filteredApps;
};
module.exports["getAppFilters"] = $3b98ce1c6aca161d$export$6c9b22c84a96fd6c;

});

parcelRegister("5osBM", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");

const $075476664b139afe$var$getWebSearchDefaultFromStorage = ()=>{
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    if (typeof globalThis === 'undefined' || !globalThis.document || !globalThis.localStorage) return null;
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    const value = globalThis.localStorage.getItem('rovo-chat-web-search-default-on');
    if (value === null) return null;
    return value !== 'false';
};
const $075476664b139afe$export$99faa9801df051b0 = ()=>{
    const storageValue = $075476664b139afe$var$getWebSearchDefaultFromStorage();
    // If localStorage explicitly says it's off, default should be off
    // Otherwise, use the experiment flag value
    const webSearchEnabled = storageValue === false ? false : (0, $cXtTj.default).getExperimentValue('rovo_web_search_default_on', 'isEnabled', false);
    return {
        reasoningMode: 'auto',
        autoActionApprovalMode: 'ALWAYS_HUMAN',
        webSearchEnabled: webSearchEnabled,
        sourceMode: 'GENERAL',
        orgKnowledge: {
            filteredApps: []
        },
        selectedCloudIds: [],
        autoApplyEnabled: true,
        appFiltersSetByPrompt: false,
        useCurrentPageContext: (0, $iDrrr.fg)('disable_default_on_current_page_as_context') ? false : true
    };
};
module.exports["getDerivedDefaultChatMode"] = $075476664b139afe$export$99faa9801df051b0;

});

parcelRegister("eu92c", function(module, exports) {

var $ePmEF = parcelRequire("ePmEF");

const $dcc4545520df4d8c$export$d6ea7bd50e1b3540 = (reasoningMode)=>{
    const isThinkDeeperMode = reasoningMode === 'think-deeper' || reasoningMode === 'think-deeper-marathon' || reasoningMode === 'think-deeper-orchestrator';
    return {
        deepResearchEnabled: reasoningMode === 'deep-research',
        thinkDeeperEnabled: isThinkDeeperMode,
        fastModeEnabled: reasoningMode === 'fast',
        autoReasoningEnabled: reasoningMode === 'auto',
        alphaExtendedThinkingMode: (0, $ePmEF.getAlphaExtendedThinkingMode)(reasoningMode),
        taskModeEnabled: reasoningMode === 'task'
    };
};
module.exports["getDerivedReasoningMode"] = $dcc4545520df4d8c$export$d6ea7bd50e1b3540;

});

parcelRegister("ePmEF", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $f28d0c39486e1a59$export$61a509aba0cee914 = (reasoningMode)=>{
    if (!(0, $iDrrr.fg)('rovo_chat_marathon_orchestrator_reasoning_modes')) return undefined;
    switch(reasoningMode){
        case 'think-deeper-marathon':
            return 'MARATHON';
        case 'think-deeper-orchestrator':
            return 'LONG_HORIZON';
        default:
            return undefined;
    }
};
module.exports["getAlphaExtendedThinkingMode"] = $f28d0c39486e1a59$export$61a509aba0cee914;

});

parcelRegister("fiVb2", function(module, exports) {

var $8s9DV = parcelRequire("8s9DV");


var $gchVc = parcelRequire("gchVc");


var $5osBM = parcelRequire("5osBM");


var $eu92c = parcelRequire("eu92c");


var $8XyiW = parcelRequire("8XyiW");

const $485b379839d8bc9f$var$getDefaultChatMode = (options)=>{
    const defaultChatMode = (0, $5osBM.getDerivedDefaultChatMode)();
    if (options?.webSearchDefaultEnabled === undefined) return defaultChatMode;
    return {
        ...defaultChatMode,
        webSearchEnabled: options.webSearchDefaultEnabled
    };
};
const $485b379839d8bc9f$var$actions = {
    setAutoActionApprovalMode: (key, autoActionApprovalMode)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, {
                autoActionApprovalMode: autoActionApprovalMode
            }));
        },
    setReasoningMode: (key, reasoningMode)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, {
                reasoningMode: reasoningMode
            }));
        },
    resetReasoningMode: (key)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, {
                reasoningMode: (0, $5osBM.getDerivedDefaultChatMode)().reasoningMode
            }));
        },
    setDeepResearchEnabled: (key, isEnabled)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, {
                reasoningMode: isEnabled ? 'deep-research' : 'auto'
            }));
        },
    setWebSearchEnabled: (key, isEnabled)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, {
                webSearchEnabled: isEnabled,
                webSearchEnabledOverridden: true
            }));
        },
    seedWebSearchDefault: (key, webSearchDefaultEnabled)=>({ dispatch: dispatch, getState: getState })=>{
            const state = getState()[key];
            if (state?.webSearchEnabledOverridden) return false;
            if (state?.rovoControlsSnapshot) {
                dispatch((0, $8XyiW.updateMode)(key, {
                    rovoControlsSnapshot: {
                        ...state.rovoControlsSnapshot,
                        webSearchEnabled: webSearchDefaultEnabled
                    }
                }));
                return false;
            }
            dispatch((0, $8XyiW.updateMode)(key, {
                webSearchEnabled: webSearchDefaultEnabled
            }));
            return true;
        },
    setSourceMode: (key, sourceMode)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, {
                sourceMode: sourceMode
            }));
        },
    setOrgKnowledge: (key, orgKnowledge)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, {
                orgKnowledge: orgKnowledge,
                appFiltersSetByPrompt: false
            }));
        },
    setAppFiltersFromPrompt: (key, filteredApps)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, {
                orgKnowledge: {
                    filteredApps: filteredApps
                },
                appFiltersSetByPrompt: true
            }));
        },
    addAppFilter: (key, app)=>({ getState: getState, dispatch: dispatch })=>{
            const { orgKnowledge: orgKnowledge } = getState()[key] || (0, $5osBM.getDerivedDefaultChatMode)();
            // An empty filter means "all connected apps apply" (see getAppFilters), so a
            // just-connected app is already included. Writing it in explicitly would turn
            // "all apps" into "only this app" and silently drop the rest — leave it be. Same
            // for 'disabled' (org knowledge off entirely). Only a narrowed filter needs the
            // app appended so it isn't excluded from the next message.
            if (orgKnowledge === 'disabled' || orgKnowledge.filteredApps.length === 0) return;
            if (orgKnowledge.filteredApps.some((a)=>a.source === app.source)) return;
            // Preserve appFiltersSetByPrompt (don't force it true): appending on connect must
            // not turn a manually-narrowed filter into a prompt-set one, which the input-clear
            // handler (RovoChatPromptInput) would then discard back to "all apps".
            dispatch((0, $8XyiW.updateMode)(key, {
                orgKnowledge: {
                    filteredApps: [
                        ...orgKnowledge.filteredApps,
                        app
                    ]
                }
            }));
        },
    setUseCurrentPageContext: (key, isEnabled)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, {
                useCurrentPageContext: isEnabled
            }));
        },
    setSpaceSourceCount: (key, count)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, {
                spaceSourceCount: count
            }));
        },
    setSelectedCloudIds: (key, selectedCloudIds)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, {
                selectedCloudIds: selectedCloudIds
            }));
        },
    setChatMode: (key, chatMode)=>({ dispatch: dispatch })=>{
            let updatedChatMode = chatMode;
            let orgKnowledge = (0, $5osBM.getDerivedDefaultChatMode)().orgKnowledge;
            if (chatMode.appFilters === undefined) orgKnowledge = (0, $5osBM.getDerivedDefaultChatMode)().orgKnowledge;
            else if (chatMode.appFilters.length > 0) orgKnowledge = {
                filteredApps: chatMode.appFilters
            };
            else orgKnowledge = 'disabled';
            updatedChatMode = {
                ...chatMode,
                orgKnowledge: orgKnowledge,
                ...chatMode.webSearchEnabled !== undefined ? {
                    webSearchEnabledOverridden: true
                } : {}
            };
            dispatch((0, $8XyiW.updateMode)(key, {
                ...updatedChatMode,
                appFiltersSetByPrompt: false
            }));
        },
    getChatMode: (key)=>({ getState: getState })=>{
            const state = getState()[key] || (0, $5osBM.getDerivedDefaultChatMode)();
            return {
                ...state,
                ...(0, $eu92c.getDerivedReasoningMode)(state.reasoningMode),
                appFilters: (0, $gchVc.getAppFilters)(state.orgKnowledge)
            };
        },
    clearMode: (key, options)=>({ dispatch: dispatch, getState: getState })=>{
            const currentMode = getState()[key];
            const shouldPreserveWebSearchEnabled = options?.preserveWebSearchEnabled === true && currentMode?.webSearchEnabledOverridden === true;
            const shouldPreserveUseCurrentPageContext = options?.preserveUseCurrentPageContext === true && currentMode?.useCurrentPageContext === false;
            const defaultChatMode = $485b379839d8bc9f$var$getDefaultChatMode(options);
            dispatch((0, $8XyiW.updateMode)(key, {
                ...defaultChatMode,
                webSearchEnabled: shouldPreserveWebSearchEnabled ? currentMode.webSearchEnabled : defaultChatMode.webSearchEnabled,
                webSearchEnabledOverridden: shouldPreserveWebSearchEnabled,
                useCurrentPageContext: shouldPreserveUseCurrentPageContext ? currentMode.useCurrentPageContext : defaultChatMode.useCurrentPageContext
            }));
        },
    /**
   * Keeps the Rovo-owned controls (reasoning mode, web search, app filters) in
   * sync with who owns the next turn, and is the single owner of the
   * snapshot/restore state.
   *
   * The stored `rovoControlsSnapshot` doubles as the edge-detector so callers
   * can invoke this idempotently every render without tracking previous state:
   *  - `suppressed` with no snapshot: a specialist just took the turn — stash the
   *    current controls and reset them to defaults so the specialist's own
   *    reasoning/sources apply.
   *  - not `suppressed` with a snapshot: the turn returned to Rovo — restore the
   *    stashed controls and clear the snapshot.
   *  - otherwise: no-op.
   *
   * Returns `RovoControlsSnapshot | null`: the effective control values it applied
   * (or `null` when nothing changed) so the caller can forward them to its
   * `on*Change` props. On the reset path `appFilters` is `[]`; on the restore path
   * it is the stashed value, which may be `undefined` (meaning "no filter / all
   * apps"). Callers coalesce with `?? []` before calling `onFilteredAppsChange`.
   */ setRovoControlsSuppressed: (key, { suppressed: suppressed })=>({ dispatch: dispatch, getState: getState })=>{
            const state = getState()[key] || (0, $5osBM.getDerivedDefaultChatMode)();
            const snapshot = state.rovoControlsSnapshot ?? null;
            if (suppressed && snapshot === null) {
                const derived = {
                    ...state,
                    ...(0, $eu92c.getDerivedReasoningMode)(state.reasoningMode),
                    appFilters: (0, $gchVc.getAppFilters)(state.orgKnowledge)
                };
                dispatch((0, $8XyiW.updateMode)(key, {
                    rovoControlsSnapshot: {
                        reasoningMode: state.reasoningMode,
                        autoActionApprovalMode: state.autoActionApprovalMode,
                        webSearchEnabled: derived.webSearchEnabled,
                        sourceMode: state.sourceMode,
                        appFilters: derived.appFilters,
                        selectedCloudIds: state.selectedCloudIds
                    },
                    reasoningMode: (0, $5osBM.getDerivedDefaultChatMode)().reasoningMode,
                    autoActionApprovalMode: 'ALWAYS_HUMAN',
                    webSearchEnabled: false,
                    sourceMode: (0, $5osBM.getDerivedDefaultChatMode)().sourceMode,
                    orgKnowledge: (0, $5osBM.getDerivedDefaultChatMode)().orgKnowledge,
                    selectedCloudIds: [],
                    appFiltersSetByPrompt: false
                }));
                return {
                    reasoningMode: (0, $5osBM.getDerivedDefaultChatMode)().reasoningMode,
                    autoActionApprovalMode: 'ALWAYS_HUMAN',
                    webSearchEnabled: false,
                    sourceMode: (0, $5osBM.getDerivedDefaultChatMode)().sourceMode,
                    appFilters: [],
                    selectedCloudIds: []
                };
            }
            if (!suppressed && snapshot !== null) {
                dispatch((0, $8XyiW.updateMode)(key, {
                    rovoControlsSnapshot: null,
                    reasoningMode: snapshot.reasoningMode,
                    autoActionApprovalMode: snapshot.autoActionApprovalMode,
                    webSearchEnabled: snapshot.webSearchEnabled,
                    sourceMode: snapshot.sourceMode,
                    orgKnowledge: snapshot.appFilters === undefined ? (0, $5osBM.getDerivedDefaultChatMode)().orgKnowledge : snapshot.appFilters.length > 0 ? {
                        filteredApps: snapshot.appFilters
                    } : 'disabled',
                    selectedCloudIds: snapshot.selectedCloudIds,
                    appFiltersSetByPrompt: false
                }));
                return snapshot;
            }
            return null;
        }
};
const $485b379839d8bc9f$export$6f57813fe9f31bf9 = (0, $8s9DV.createStore)({
    initialState: {},
    actions: $485b379839d8bc9f$var$actions
});
module.exports["store"] = $485b379839d8bc9f$export$6f57813fe9f31bf9;

});

parcelRegister("8XyiW", function(module, exports) {

var $5osBM = parcelRequire("5osBM");

const $3fc1c590f304ee0c$export$f80026ff7d109add = (key, mode)=>{
    return ({ setState: setState, getState: getState })=>{
        const state = getState()[key] || (0, $5osBM.getDerivedDefaultChatMode)();
        setState({
            [key]: {
                ...state,
                ...mode
            }
        });
    };
};
module.exports["updateMode"] = $3fc1c590f304ee0c$export$f80026ff7d109add;

});

parcelRegister("aJU2k", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");


var $fiVb2 = parcelRequire("fiVb2");

const $5436fb6e01d0eb8e$export$aaf871ddd4ec7885 = (0, $kBr4q.createActionsHook)((0, $fiVb2.store));
module.exports["useChatModeStoreActions"] = $5436fb6e01d0eb8e$export$aaf871ddd4ec7885;

});

parcelRegister("hOUgz", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");


var $gzMZq = parcelRequire("gzMZq");


var $aJU2k = parcelRequire("aJU2k");


var $4TNMQ = parcelRequire("4TNMQ");


var $d9k9Z = parcelRequire("d9k9Z");

const $0893a5bb718d1a9a$var$JIRA_VIEW_CONTEXT_KEY = 'jira_view_context';
const $0893a5bb718d1a9a$var$TRELLO_VIEW_CONTEXT_KEY = 'trello_view_context';
function $0893a5bb718d1a9a$var$hasValidJiraViewContextData(value) {
    if (value == null || typeof value !== 'object') return false;
    const selected = Object.getOwnPropertyDescriptor(value, 'selectedIssueIdentifiers')?.value;
    return Array.isArray(selected);
}
function $0893a5bb718d1a9a$var$hasValidTrelloViewContextData(value) {
    if (value == null || typeof value !== 'object') return false;
    const url = Object.getOwnPropertyDescriptor(value, 'url')?.value;
    return typeof url === 'string';
}
const $0893a5bb718d1a9a$export$a96e0fbf256603d8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(24);
    const pageContextType = (0, $d9k9Z.usePageContextType)();
    const { getChatMode: getChatMode, setUseCurrentPageContext: setUseCurrentPageContext } = (0, $aJU2k.useChatModeStoreActions)();
    const [editorContext] = (0, $gzMZq.useChatContextEditorContext)();
    const [databaseContext] = (0, $gzMZq.useChatContextDatabaseContext)();
    const [aiFeatureContext] = (0, $gzMZq.useChatContextAIFeatureContext)();
    const rawJiraViewContext = aiFeatureContext?.[$0893a5bb718d1a9a$var$JIRA_VIEW_CONTEXT_KEY];
    let t0;
    if ($[0] !== rawJiraViewContext) {
        t0 = $0893a5bb718d1a9a$var$hasValidJiraViewContextData(rawJiraViewContext) ? rawJiraViewContext : undefined;
        $[0] = rawJiraViewContext;
        $[1] = t0;
    } else t0 = $[1];
    const jiraViewContextData = t0;
    const rawTrelloViewContext = aiFeatureContext?.[$0893a5bb718d1a9a$var$TRELLO_VIEW_CONTEXT_KEY];
    let t1;
    if ($[2] !== rawTrelloViewContext) {
        t1 = $0893a5bb718d1a9a$var$hasValidTrelloViewContextData(rawTrelloViewContext) ? rawTrelloViewContext : undefined;
        $[2] = rawTrelloViewContext;
        $[3] = t1;
    } else t1 = $[3];
    const trelloViewContextData = t1;
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            type: "none"
        };
        $[4] = t2;
    } else t2 = $[4];
    let currentContext = t2;
    if (trelloViewContextData && (0, $iDrrr.fg)("trello_enterprise_rovo_trello_context")) {
        let t3;
        if ($[5] !== trelloViewContextData) {
            t3 = {
                type: "trello_view_context",
                payload: trelloViewContextData
            };
            $[5] = trelloViewContextData;
            $[6] = t3;
        } else t3 = $[6];
        currentContext = t3;
    } else {
        if (editorContext) {
            let t3;
            if ($[7] !== editorContext) {
                t3 = {
                    type: "editor_context",
                    payload: editorContext
                };
                $[7] = editorContext;
                $[8] = t3;
            } else t3 = $[8];
            currentContext = t3;
        } else if (databaseContext) {
            let t3;
            if ($[9] !== databaseContext.selectedElementIds) {
                t3 = databaseContext.selectedElementIds ?? [];
                $[9] = databaseContext.selectedElementIds;
                $[10] = t3;
            } else t3 = $[10];
            let t4;
            if ($[11] !== t3) {
                t4 = {
                    type: "database_context",
                    selectedElementIds: t3
                };
                $[11] = t3;
                $[12] = t4;
            } else t4 = $[12];
            currentContext = t4;
        } else {
            if (jiraViewContextData && (0, $cXtTj.default).getExperimentValue("jira-ai-jira-view-context-in-rovo-chat-experiment", "isEnabled", false)) {
                let t3;
                if ($[13] !== jiraViewContextData) {
                    t3 = {
                        type: "jira_view_context",
                        payload: jiraViewContextData
                    };
                    $[13] = jiraViewContextData;
                    $[14] = t3;
                } else t3 = $[14];
                currentContext = t3;
            } else if (pageContextType !== (0, $4TNMQ.PageContextType).UNKNOWN) {
                let t3;
                if ($[15] !== pageContextType) {
                    t3 = {
                        type: "current_page",
                        pageContextType: pageContextType
                    };
                    $[15] = pageContextType;
                    $[16] = t3;
                } else t3 = $[16];
                currentContext = t3;
            }
        }
    }
    let t3;
    if ($[17] !== getChatMode) {
        t3 = (key)=>getChatMode(key).useCurrentPageContext;
        $[17] = getChatMode;
        $[18] = t3;
    } else t3 = $[18];
    let t4;
    if ($[19] !== currentContext || $[20] !== jiraViewContextData || $[21] !== setUseCurrentPageContext || $[22] !== t3) {
        t4 = {
            canUseCurrentPageContextUserPreference: t3,
            setUseCurrentPageContextUserPreference: setUseCurrentPageContext,
            currentContext: currentContext,
            jiraViewContextData: jiraViewContextData
        };
        $[19] = currentContext;
        $[20] = jiraViewContextData;
        $[21] = setUseCurrentPageContext;
        $[22] = t3;
        $[23] = t4;
    } else t4 = $[23];
    return t4;
} : ()=>{
    const pageContextType = (0, $d9k9Z.usePageContextType)();
    const { getChatMode: getChatMode, setUseCurrentPageContext: setUseCurrentPageContext } = (0, $aJU2k.useChatModeStoreActions)();
    const [editorContext] = (0, $gzMZq.useChatContextEditorContext)();
    const [databaseContext] = (0, $gzMZq.useChatContextDatabaseContext)();
    const [aiFeatureContext] = (0, $gzMZq.useChatContextAIFeatureContext)();
    const rawJiraViewContext = aiFeatureContext?.[$0893a5bb718d1a9a$var$JIRA_VIEW_CONTEXT_KEY];
    const jiraViewContextData = $0893a5bb718d1a9a$var$hasValidJiraViewContextData(rawJiraViewContext) ? rawJiraViewContext : undefined;
    const rawTrelloViewContext = aiFeatureContext?.[$0893a5bb718d1a9a$var$TRELLO_VIEW_CONTEXT_KEY];
    const trelloViewContextData = $0893a5bb718d1a9a$var$hasValidTrelloViewContextData(rawTrelloViewContext) ? rawTrelloViewContext : undefined;
    let currentContext = {
        type: 'none'
    };
    if (trelloViewContextData && (0, $iDrrr.fg)('trello_enterprise_rovo_trello_context')) // prefer trello context over page context if available
    currentContext = {
        type: 'trello_view_context',
        payload: trelloViewContextData
    };
    else if (editorContext) // prefer editor context over page context if available
    currentContext = {
        type: 'editor_context',
        payload: editorContext
    };
    else if (databaseContext) currentContext = {
        type: 'database_context',
        selectedElementIds: databaseContext.selectedElementIds ?? []
    };
    else if (jiraViewContextData && // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $cXtTj.default).getExperimentValue('jira-ai-jira-view-context-in-rovo-chat-experiment', 'isEnabled', false)) currentContext = {
        type: 'jira_view_context',
        payload: jiraViewContextData
    };
    else if (pageContextType !== (0, $4TNMQ.PageContextType).UNKNOWN) // if no editor context, use page context if available
    currentContext = {
        type: 'current_page',
        pageContextType: pageContextType
    };
    return {
        canUseCurrentPageContextUserPreference: (key)=>{
            return getChatMode(key).useCurrentPageContext;
        },
        setUseCurrentPageContextUserPreference: setUseCurrentPageContext,
        currentContext: currentContext,
        jiraViewContextData: jiraViewContextData
    };
};
module.exports["useCurrentPageAsContext"] = $0893a5bb718d1a9a$export$a96e0fbf256603d8;

});

parcelRegister("4TNMQ", function(module, exports) {
var $4d02c50d752d2f92$export$7f7a6f1c2ab5127 = /*#__PURE__*/ function(PageContextType) {
    PageContextType["BITBUCKET"] = "bitbucket";
    PageContextType["CONFLUENCE_HOME"] = "confluence-home";
    PageContextType["CONFLUENCE_PAGE_VIEW"] = "confluence-page-view";
    PageContextType["CONFLUENCE_PAGE_EDIT"] = "confluence-page-edit";
    PageContextType["CONFLUENCE_WHITEBOARD"] = "confluence-whiteboard";
    PageContextType["CONFLUENCE_DATABASE"] = "confluence-database";
    PageContextType["CONFLUENCE_FOLDER"] = "confluence-folder";
    PageContextType["JIRA_HOME"] = "jira-home";
    PageContextType["JIRA_ISSUE_VIEW"] = "jira-issue-view";
    PageContextType["JIRA_BACKLOG"] = "jira-backlog";
    PageContextType["JIRA_BOARD"] = "jira-board-view";
    PageContextType["JIRA_PROJECT"] = "jira-project";
    PageContextType["JIRA_SERVICE_DESK"] = "jira-service-desk";
    PageContextType["JIRA_PLAN"] = "jira-plan";
    PageContextType["JIRA_CMP_SPACE_SETTINGS_PEOPLE_LEGACY"] = "jira-cmp-space-settings-people-legacy";
    PageContextType["JIRA_CMP_SPACE_SETTINGS_PERMISSIONS_LEGACY"] = "jira-cmp-space-settings-permissions-legacy";
    PageContextType["JIRA_ISSUES_LIST"] = "jira-issues-list";
    PageContextType["JIRA_ITAM_HAM"] = "jira-itam-ham";
    PageContextType["ATLAS_HOME"] = "atlas-home";
    PageContextType["ATLAS_PROJECT"] = "atlas-project";
    PageContextType["ATLAS_GOAL"] = "atlas-goal";
    PageContextType["FEEDBACK_APP"] = "feedback-app";
    PageContextType["STORE_HOME"] = "store-home";
    PageContextType["TRELLO_BOARD"] = "trello-board";
    PageContextType["TRELLO_CARD"] = "trello-card";
    PageContextType["LOOM_VIDEO"] = "loom-video";
    PageContextType["TEAM_PROFILE"] = "team-profile";
    PageContextType["USER_PROFILE"] = "user-profile";
    PageContextType["UNKNOWN"] = "unknown";
    return PageContextType;
}({});
module.exports["PageContextType"] = $4d02c50d752d2f92$export$7f7a6f1c2ab5127;

});

parcelRegister("d9k9Z", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $izud5 = parcelRequire("izud5");


var $lN13T = parcelRequire("lN13T");


var $hywIT = parcelRequire("hywIT");

const $050ca14b256e7a37$export$bc4bf2ff8e40b690 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const useCase = t0 === undefined ? (0, $lN13T.UseCase).THINKING_VIEW : t0;
    const location = (0, $hywIT.useWindowLocation)();
    let t1;
    if ($[0] !== location || $[1] !== useCase) {
        t1 = (0, $izud5.determinePageType)(location, useCase);
        $[0] = location;
        $[1] = useCase;
        $[2] = t1;
    } else t1 = $[2];
    const [pageContextType, setPageContextType] = (0, $cozmU.useState)(t1);
    let t2;
    let t3;
    if ($[3] !== location || $[4] !== useCase) {
        t2 = ()=>{
            setPageContextType((0, $izud5.determinePageType)(location, useCase));
        };
        t3 = [
            location,
            useCase
        ];
        $[3] = location;
        $[4] = useCase;
        $[5] = t2;
        $[6] = t3;
    } else {
        t2 = $[5];
        t3 = $[6];
    }
    (0, $cozmU.useEffect)(t2, t3);
    return pageContextType;
} : (useCase = (0, $lN13T.UseCase).THINKING_VIEW)=>{
    const location = (0, $hywIT.useWindowLocation)();
    const [pageContextType, setPageContextType] = (0, $cozmU.useState)((0, $izud5.determinePageType)(location, useCase));
    (0, $cozmU.useEffect)(()=>{
        setPageContextType((0, $izud5.determinePageType)(location, useCase));
    }, [
        location,
        useCase
    ]);
    return pageContextType;
};
module.exports["usePageContextType"] = $050ca14b256e7a37$export$bc4bf2ff8e40b690;

});

parcelRegister("izud5", function(module, exports) {

var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $4TNMQ = parcelRequire("4TNMQ");


var $lN13T = parcelRequire("lN13T");

const $9f65aecae4ace5e7$var$ALLOWED_PAGE_CONTEXT_TYPES = {
    [(0, $lN13T.UseCase).THINKING_VIEW]: [
        (0, $4TNMQ.PageContextType).CONFLUENCE_PAGE_EDIT,
        (0, $4TNMQ.PageContextType).CONFLUENCE_PAGE_VIEW,
        (0, $4TNMQ.PageContextType).CONFLUENCE_WHITEBOARD,
        (0, $4TNMQ.PageContextType).CONFLUENCE_DATABASE,
        (0, $4TNMQ.PageContextType).CONFLUENCE_FOLDER,
        (0, $4TNMQ.PageContextType).JIRA_ISSUE_VIEW,
        (0, $4TNMQ.PageContextType).JIRA_SERVICE_DESK,
        (0, $4TNMQ.PageContextType).JIRA_PROJECT,
        (0, $4TNMQ.PageContextType).JIRA_PLAN,
        (0, $4TNMQ.PageContextType).JIRA_CMP_SPACE_SETTINGS_PEOPLE_LEGACY,
        (0, $4TNMQ.PageContextType).JIRA_CMP_SPACE_SETTINGS_PERMISSIONS_LEGACY,
        (0, $4TNMQ.PageContextType).JIRA_ISSUES_LIST,
        (0, $4TNMQ.PageContextType).JIRA_ITAM_HAM,
        (0, $4TNMQ.PageContextType).ATLAS_PROJECT,
        (0, $4TNMQ.PageContextType).ATLAS_GOAL,
        (0, $4TNMQ.PageContextType).FEEDBACK_APP,
        (0, $4TNMQ.PageContextType).STORE_HOME,
        (0, $4TNMQ.PageContextType).TRELLO_BOARD,
        (0, $4TNMQ.PageContextType).TRELLO_CARD,
        (0, $4TNMQ.PageContextType).LOOM_VIDEO,
        (0, $4TNMQ.PageContextType).TEAM_PROFILE,
        (0, $4TNMQ.PageContextType).USER_PROFILE
    ],
    [(0, $lN13T.UseCase).AUTOCOMPLETE]: [
        (0, $4TNMQ.PageContextType).BITBUCKET,
        (0, $4TNMQ.PageContextType).CONFLUENCE_HOME,
        (0, $4TNMQ.PageContextType).CONFLUENCE_PAGE_EDIT,
        (0, $4TNMQ.PageContextType).CONFLUENCE_PAGE_VIEW,
        (0, $4TNMQ.PageContextType).CONFLUENCE_WHITEBOARD,
        (0, $4TNMQ.PageContextType).CONFLUENCE_DATABASE,
        (0, $4TNMQ.PageContextType).JIRA_BACKLOG,
        (0, $4TNMQ.PageContextType).JIRA_HOME,
        (0, $4TNMQ.PageContextType).JIRA_ISSUE_VIEW,
        (0, $4TNMQ.PageContextType).ATLAS_HOME,
        (0, $4TNMQ.PageContextType).STORE_HOME,
        (0, $4TNMQ.PageContextType).TRELLO_BOARD,
        (0, $4TNMQ.PageContextType).TRELLO_CARD
    ]
};
const $9f65aecae4ace5e7$var$FALLBACK_PAGE_CONTEXT_TYPE = {
    [(0, $lN13T.UseCase).THINKING_VIEW]: (0, $4TNMQ.PageContextType).UNKNOWN,
    [(0, $lN13T.UseCase).AUTOCOMPLETE]: (0, $4TNMQ.PageContextType).ATLAS_HOME
};
const $9f65aecae4ace5e7$export$a905239756c1fbae = (location, useCase = (0, $lN13T.UseCase).THINKING_VIEW)=>{
    const allowedTypes = new Set($9f65aecae4ace5e7$var$ALLOWED_PAGE_CONTEXT_TYPES[useCase]);
    const allUrlPatterns = [
        [
            (0, $4TNMQ.PageContextType).BITBUCKET,
            /bitbucket\.org\/.*/
        ],
        [
            (0, $4TNMQ.PageContextType).CONFLUENCE_PAGE_EDIT,
            /\/wiki\/spaces\/[^\/]+\/(?:pages|blog)\/edit-v2\//
        ],
        [
            (0, $4TNMQ.PageContextType).CONFLUENCE_PAGE_VIEW,
            /\/wiki\/spaces\/[^\/]+\/(?:pages|blog)\//
        ],
        // Support whiteboard url
        [
            (0, $4TNMQ.PageContextType).CONFLUENCE_WHITEBOARD,
            /\/wiki\/spaces\/[^\/]+\/whiteboard\//
        ],
        // Support whiteboard iframe url
        [
            (0, $4TNMQ.PageContextType).CONFLUENCE_WHITEBOARD,
            /\/whiteboards\/whiteboard\/[^\/\?]+/
        ],
        // Support whiteboard internal url after spa transition
        [
            (0, $4TNMQ.PageContextType).CONFLUENCE_WHITEBOARD,
            /\/whiteboard\/[a-f0-9-]+/
        ],
        // Support database url
        [
            (0, $4TNMQ.PageContextType).CONFLUENCE_DATABASE,
            /\/wiki\/spaces\/[^\/]+\/database\//
        ],
        // Support database internal url after spa transition
        [
            (0, $4TNMQ.PageContextType).CONFLUENCE_DATABASE,
            /\/database\/[a-f0-9-]+/
        ],
        // Support folder url
        ...(0, $4o0zT.isExperimentEnabled)('folder_content_wrapper') ? [
            [
                (0, $4TNMQ.PageContextType).CONFLUENCE_FOLDER,
                /\/wiki\/spaces\/[^\/]+\/folder\//
            ]
        ] : [],
        [
            (0, $4TNMQ.PageContextType).JIRA_BACKLOG,
            /\/jira\/.*\/backlog$/
        ],
        [
            (0, $4TNMQ.PageContextType).JIRA_BOARD,
            /\/jira\/.*\/boards\//
        ],
        [
            (0, $4TNMQ.PageContextType).JIRA_ISSUE_VIEW,
            /\/browse\/[^\/]+$/
        ],
        [
            (0, $4TNMQ.PageContextType).JIRA_ISSUE_VIEW,
            /\/jira\/.+\/projects\/.+\?selectedIssue/
        ],
        [
            (0, $4TNMQ.PageContextType).JIRA_HOME,
            /\/jira\/dashboards\/last-visited$/
        ],
        [
            (0, $4TNMQ.PageContextType).JIRA_SERVICE_DESK,
            /\/jira(?:\/.+)?\/servicedesk\/projects\/.+\/queues\/issue\//
        ],
        [
            (0, $4TNMQ.PageContextType).JIRA_PROJECT,
            /\/jira\/.+\/projects\//
        ],
        [
            (0, $4TNMQ.PageContextType).JIRA_ISSUES_LIST,
            /\/issues\/\?jql=/
        ],
        ...(0, $iDrrr.fg)('itam_ftw') ? [
            [
                (0, $4TNMQ.PageContextType).JIRA_ITAM_HAM,
                /\/jira\/itam\/ham(\/|$)/
            ]
        ] : [],
        ...(0, $iDrrr.fg)('rovo_chat_jira_plans_minion') ? [
            [
                (0, $4TNMQ.PageContextType).JIRA_PLAN,
                /\/jira\/plans\/\d+\//
            ]
        ] : [],
        [
            (0, $4TNMQ.PageContextType).JIRA_HOME,
            /\/jira\/dashboards\/last-visited$/
        ],
        [
            (0, $4TNMQ.PageContextType).JIRA_CMP_SPACE_SETTINGS_PEOPLE_LEGACY,
            /\/plugins\/servlet\/project-config\/[^\/]+\/people/
        ],
        [
            (0, $4TNMQ.PageContextType).JIRA_CMP_SPACE_SETTINGS_PERMISSIONS_LEGACY,
            /\/plugins\/servlet\/project-config\/[^\/]+\/permissions/
        ],
        // atlas home is either home.atlassian.com, home.stg.atlassian.com, team.atlassian.com, or team.stg.atlassian.com
        [
            (0, $4TNMQ.PageContextType).ATLAS_HOME,
            /\/(home|team)\./
        ],
        [
            (0, $4TNMQ.PageContextType).ATLAS_PROJECT,
            /\/(home|team).+\/project\/ATLAS-/
        ],
        [
            (0, $4TNMQ.PageContextType).ATLAS_GOAL,
            /\/(home|team).+\/goal\/ATLAS-/
        ],
        // Store and Marketplace surfaces can appear on both internal and production domains.
        [
            (0, $4TNMQ.PageContextType).STORE_HOME,
            /(?:store\.stg\.atlassian\.com|marketplace-store\.atlassian\.com).*\/(?:(?:objects|categories)\/|search(?:\/|\?|$))/
        ],
        [
            (0, $4TNMQ.PageContextType).TEAM_PROFILE,
            /\/(home|team)\..+\/people\/team/
        ],
        [
            (0, $4TNMQ.PageContextType).USER_PROFILE,
            /\/(home|team)\..+\/people\/(?!team)/
        ],
        [
            (0, $4TNMQ.PageContextType).FEEDBACK_APP,
            /\/feedback-app/
        ],
        // Trello: trello.com and trellis.coffee (enterprise)
        [
            (0, $4TNMQ.PageContextType).TRELLO_CARD,
            /(?:trello\.com|trellis\.coffee)\/c\/[^/]+/
        ],
        [
            (0, $4TNMQ.PageContextType).TRELLO_BOARD,
            /(?:trello\.com|trellis\.coffee)\/b\/[^/]+/
        ],
        // Loom share URLs: www.loom.com, stage.loom.com, loomlocal.com:<port>
        [
            (0, $4TNMQ.PageContextType).LOOM_VIDEO,
            /(?:(?:www|stage)\.loom\.com|loomlocal\.com(?::\d+)?)\/share\/[^\/?#]+/
        ]
    ];
    const urlPatterns = allUrlPatterns.filter(([type])=>allowedTypes.has(type));
    for (const [type, pattern] of urlPatterns){
        const matched = pattern.test(location);
        if (!matched) continue;
        return type;
    }
    return $9f65aecae4ace5e7$var$FALLBACK_PAGE_CONTEXT_TYPE[useCase];
};
module.exports["determinePageType"] = $9f65aecae4ace5e7$export$a905239756c1fbae;

});

parcelRegister("lN13T", function(module, exports) {
var $60986b1218619e0e$export$59961d6586ccfd15 = /*#__PURE__*/ function(UseCase) {
    UseCase["THINKING_VIEW"] = "thinking-view";
    UseCase["AUTOCOMPLETE"] = "autocomplete";
    return UseCase;
}({});
module.exports["UseCase"] = $60986b1218619e0e$export$59961d6586ccfd15;

});

parcelRegister("hywIT", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $9Yqfz = parcelRequire("9Yqfz");


var $jR5eS = parcelRequire("jR5eS");

const $e75d45e703058f92$export$6fa751d66e55d2e1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const contextValue = (0, $cozmU.useContext)((0, $jR5eS.WindowLocationContext));
    const location = (0, $cozmU.useSyncExternalStore)((0, $9Yqfz.subscribeToLocation), (0, $9Yqfz.getLocationSnapshot), (0, $9Yqfz.getLocationServerSnapshot));
    return contextValue ?? location;
} : ()=>{
    const contextValue = (0, $cozmU.useContext)((0, $jR5eS.WindowLocationContext));
    const location = (0, $cozmU.useSyncExternalStore)((0, $9Yqfz.subscribeToLocation), (0, $9Yqfz.getLocationSnapshot), (0, $9Yqfz.getLocationServerSnapshot));
    return contextValue ?? location;
};
module.exports["useWindowLocation"] = $e75d45e703058f92$export$6fa751d66e55d2e1;

});

parcelRegister("9Yqfz", function(module, exports) {

var $cbY7C = parcelRequire("cbY7C");

const $35332082f96c50ad$var$locationListeners = new Set();
const $35332082f96c50ad$var$titleListeners = new Set();
let $35332082f96c50ad$var$patched = false;
let $35332082f96c50ad$var$currentHref = '';
let $35332082f96c50ad$var$currentTitle = '';
let $35332082f96c50ad$var$titleMutationObserver;
const $35332082f96c50ad$var$isBrowser = ()=>typeof window !== 'undefined';
const $35332082f96c50ad$var$hasDocument = ()=>typeof document !== 'undefined';
const $35332082f96c50ad$var$readHref = ()=>$35332082f96c50ad$var$isBrowser() ? window.location.href : '';
const $35332082f96c50ad$var$readTitle = ()=>$35332082f96c50ad$var$hasDocument() ? document.title : '';
// Snapshot the set so a listener that (un)subscribes during notification does
// not mutate the collection we are iterating.
const $35332082f96c50ad$var$emit = (set)=>{
    for (const listener of Array.from(set))listener();
};
const $35332082f96c50ad$var$notifyLocation = ()=>{
    const nextHref = $35332082f96c50ad$var$readHref();
    if (nextHref === $35332082f96c50ad$var$currentHref) return;
    $35332082f96c50ad$var$currentHref = nextHref;
    $35332082f96c50ad$var$emit($35332082f96c50ad$var$locationListeners);
};
const $35332082f96c50ad$var$notifyTitle = ()=>{
    const nextTitle = $35332082f96c50ad$var$readTitle();
    if (nextTitle === $35332082f96c50ad$var$currentTitle) return;
    $35332082f96c50ad$var$currentTitle = nextTitle;
    $35332082f96c50ad$var$emit($35332082f96c50ad$var$titleListeners);
};
const $35332082f96c50ad$var$installOnce = ()=>{
    if ($35332082f96c50ad$var$patched || !$35332082f96c50ad$var$isBrowser()) return;
    $35332082f96c50ad$var$patched = true;
    $35332082f96c50ad$var$currentHref = $35332082f96c50ad$var$readHref();
    $35332082f96c50ad$var$currentTitle = $35332082f96c50ad$var$readTitle();
    const nativePushState = window.history.pushState.bind(window.history);
    const nativeReplaceState = window.history.replaceState.bind(window.history);
    // Intentionally permanent: we never restore these. See module docblock.
    window.history.pushState = function(...args) {
        nativePushState(...args);
        $35332082f96c50ad$var$notifyLocation();
    };
    window.history.replaceState = function(...args) {
        nativeReplaceState(...args);
        $35332082f96c50ad$var$notifyLocation();
    };
    (0, $cbY7C.bindAll)(window, [
        {
            type: 'popstate',
            listener: $35332082f96c50ad$var$notifyLocation
        },
        {
            type: 'hashchange',
            listener: $35332082f96c50ad$var$notifyLocation
        }
    ]);
    // Watch the <title> element for changes. The shell updates `document.title`
    // after the location change, so this is what keeps title-derived UI fresh.
    if ($35332082f96c50ad$var$hasDocument() && typeof MutationObserver !== 'undefined') {
        const titleEl = document.querySelector('title');
        if (titleEl) {
            $35332082f96c50ad$var$titleMutationObserver = new MutationObserver($35332082f96c50ad$var$notifyTitle);
            $35332082f96c50ad$var$titleMutationObserver.observe(titleEl, {
                childList: true,
                characterData: true,
                subtree: true
            });
        }
    }
};
const $35332082f96c50ad$export$9dcd3b3f4f8a572f = (listener)=>{
    $35332082f96c50ad$var$installOnce();
    $35332082f96c50ad$var$locationListeners.add(listener);
    return ()=>{
        $35332082f96c50ad$var$locationListeners.delete(listener);
    };
};
const $35332082f96c50ad$export$c6a96cf4e0abf9ac = (listener)=>{
    $35332082f96c50ad$var$installOnce();
    $35332082f96c50ad$var$titleListeners.add(listener);
    return ()=>{
        $35332082f96c50ad$var$titleListeners.delete(listener);
    };
};
const $35332082f96c50ad$export$ef3949f6f6b35a98 = ()=>$35332082f96c50ad$var$readHref();
const $35332082f96c50ad$export$1296b6401b011699 = ()=>'';
const $35332082f96c50ad$export$b8645558bd27590a = ()=>$35332082f96c50ad$var$readTitle();
const $35332082f96c50ad$export$60c631f42ecb55a7 = ()=>'';
const $35332082f96c50ad$export$9f0e18eb4b88e00d = ()=>{
    $35332082f96c50ad$var$patched = false;
    $35332082f96c50ad$var$currentHref = '';
    $35332082f96c50ad$var$currentTitle = '';
    $35332082f96c50ad$var$locationListeners.clear();
    $35332082f96c50ad$var$titleListeners.clear();
    $35332082f96c50ad$var$titleMutationObserver?.disconnect();
    $35332082f96c50ad$var$titleMutationObserver = undefined;
};
module.exports["subscribeToLocation"] = $35332082f96c50ad$export$9dcd3b3f4f8a572f;
module.exports["subscribeToTitle"] = $35332082f96c50ad$export$c6a96cf4e0abf9ac;
module.exports["getLocationSnapshot"] = $35332082f96c50ad$export$ef3949f6f6b35a98;
module.exports["getLocationServerSnapshot"] = $35332082f96c50ad$export$1296b6401b011699;
module.exports["getTitleSnapshot"] = $35332082f96c50ad$export$b8645558bd27590a;
module.exports["getTitleServerSnapshot"] = $35332082f96c50ad$export$60c631f42ecb55a7;

});

parcelRegister("jR5eS", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $9519c4d899a3b020$export$46133998910543ac = (0, $cozmU.createContext)(null);
module.exports["WindowLocationContext"] = $9519c4d899a3b020$export$46133998910543ac;

});

parcelRegister("k4g8h", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

function $c96a99d0f4ee3b3b$export$6c91fec22056810a(error) {
    return error?.type === 'rateLimited';
}
function $c96a99d0f4ee3b3b$export$f2905d128e30c457(error) {
    return error ? [
        'conversationNotFound',
        'conversationEmptyOrNotPresentInStore',
        'hipaa',
        'generic'
    ].includes(error.type) : false;
}
function $c96a99d0f4ee3b3b$export$a44d3d1877743c92(error) {
    return $c96a99d0f4ee3b3b$export$6c91fec22056810a(error) ? error.rateLimitedActionType : undefined;
}
const $c96a99d0f4ee3b3b$var$store = (0, $8s9DV.createStore)({
    name: 'rovoChatSignals',
    initialState: {
        conversationError: undefined,
        status: 'launching'
    },
    actions: {
        setConversationError: (conversationError)=>({ setState: setState })=>{
                setState({
                    conversationError: conversationError
                });
            },
        setStatus: (status)=>({ setState: setState })=>{
                setState({
                    status: status
                });
            }
    }
});
const $c96a99d0f4ee3b3b$export$63ceb69e3e2574ee = (0, $kBr4q.createActionsHook)($c96a99d0f4ee3b3b$var$store);
const $c96a99d0f4ee3b3b$export$4eeff361c6b400be = (0, $kBr4q.createHook)($c96a99d0f4ee3b3b$var$store, {
    selector: (state)=>({
            conversationError: state.conversationError,
            status: state.status
        })
});
module.exports["isRateLimited"] = $c96a99d0f4ee3b3b$export$6c91fec22056810a;
module.exports["isFullScreenError"] = $c96a99d0f4ee3b3b$export$f2905d128e30c457;
module.exports["getRateLimitedActionType"] = $c96a99d0f4ee3b3b$export$a44d3d1877743c92;
module.exports["useChatSignalsActions"] = $c96a99d0f4ee3b3b$export$63ceb69e3e2574ee;
module.exports["useChatSignals"] = $c96a99d0f4ee3b3b$export$4eeff361c6b400be;

});

parcelRegister("8VrqA", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $kMkDS = parcelRequire("kMkDS");


var $cGJsZ = parcelRequire("cGJsZ");

const $e14a5679e33f0f1b$var$state = (0, $8s9DV.createStore)({
    initialState: {
        highlightActionsEditorPlaceholder: null,
        highlightActionsEditorPlaceholderSource: null,
        highlightActionsEditorPlaceholderConversationId: null
    },
    actions: {
        setHighlightActionsEditorPlaceholder: (highlightActionsEditorPlaceholder, highlightActionsEditorPlaceholderSource = null, highlightActionsEditorPlaceholderConversationId = null)=>({ setState: setState })=>{
                setState({
                    highlightActionsEditorPlaceholder: highlightActionsEditorPlaceholder,
                    highlightActionsEditorPlaceholderSource: highlightActionsEditorPlaceholderSource,
                    highlightActionsEditorPlaceholderConversationId: highlightActionsEditorPlaceholderConversationId
                });
            }
    }
});
const $e14a5679e33f0f1b$export$e638cf26ae51308d = (0, $kBr4q.createHook)($e14a5679e33f0f1b$var$state);
const $e14a5679e33f0f1b$var$getHighlightActionPlaceholderData = (prompt, placeholderText)=>{
    const promptContent = (0, $kMkDS.appendADFContent)(prompt, placeholderText);
    return promptContent;
};
const $e14a5679e33f0f1b$export$21b2d5ca0689f678 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(11);
    const [t0, t1] = $e14a5679e33f0f1b$export$e638cf26ae51308d();
    const { highlightActionsEditorPlaceholder: highlightActionsEditorPlaceholder, highlightActionsEditorPlaceholderSource: highlightActionsEditorPlaceholderSource, highlightActionsEditorPlaceholderConversationId: highlightActionsEditorPlaceholderConversationId } = t0;
    const { setHighlightActionsEditorPlaceholder: setHighlightActionsEditorPlaceholder } = t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== formatMessage || $[1] !== setHighlightActionsEditorPlaceholder) {
        t2 = (prompt, options)=>{
            const adfDocument = options?.skipPlaceholderPrompt ? prompt : $e14a5679e33f0f1b$var$getHighlightActionPlaceholderData(prompt, formatMessage((0, $cGJsZ.default).highlightActionsPlaceholderPrompt));
            setHighlightActionsEditorPlaceholder(adfDocument, options?.source ?? null, options?.conversationId ?? null);
        };
        $[0] = formatMessage;
        $[1] = setHighlightActionsEditorPlaceholder;
        $[2] = t2;
    } else t2 = $[2];
    const insertHighlightActionsEditorPlaceholder = t2;
    let t3;
    if ($[3] !== setHighlightActionsEditorPlaceholder) {
        t3 = ()=>{
            setHighlightActionsEditorPlaceholder(null);
        };
        $[3] = setHighlightActionsEditorPlaceholder;
        $[4] = t3;
    } else t3 = $[4];
    const clearHighlightActionsEditorPlaceholder = t3;
    let t4;
    if ($[5] !== clearHighlightActionsEditorPlaceholder || $[6] !== highlightActionsEditorPlaceholder || $[7] !== highlightActionsEditorPlaceholderConversationId || $[8] !== highlightActionsEditorPlaceholderSource || $[9] !== insertHighlightActionsEditorPlaceholder) {
        t4 = {
            highlightActionsEditorPlaceholder: highlightActionsEditorPlaceholder,
            highlightActionsEditorPlaceholderSource: highlightActionsEditorPlaceholderSource,
            highlightActionsEditorPlaceholderConversationId: highlightActionsEditorPlaceholderConversationId,
            insertHighlightActionsEditorPlaceholder: insertHighlightActionsEditorPlaceholder,
            clearHighlightActionsEditorPlaceholder: clearHighlightActionsEditorPlaceholder
        };
        $[5] = clearHighlightActionsEditorPlaceholder;
        $[6] = highlightActionsEditorPlaceholder;
        $[7] = highlightActionsEditorPlaceholderConversationId;
        $[8] = highlightActionsEditorPlaceholderSource;
        $[9] = insertHighlightActionsEditorPlaceholder;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
} : ()=>{
    const [{ highlightActionsEditorPlaceholder: highlightActionsEditorPlaceholder, highlightActionsEditorPlaceholderSource: highlightActionsEditorPlaceholderSource, highlightActionsEditorPlaceholderConversationId: highlightActionsEditorPlaceholderConversationId }, { setHighlightActionsEditorPlaceholder: setHighlightActionsEditorPlaceholder }] = $e14a5679e33f0f1b$export$e638cf26ae51308d();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const insertHighlightActionsEditorPlaceholder = (0, $cozmU.useCallback)((prompt, options)=>{
        // When `skipPlaceholderPrompt` is set, seed the editor with the prompt
        // exactly as provided instead of appending the highlight-action
        // "Ask a question about this." trailer. This lets non-highlight callers
        // (e.g. a prompt supplied via URL param) pre-fill the input as an
        // editable draft without injecting extra text.
        const adfDocument = options?.skipPlaceholderPrompt ? prompt : $e14a5679e33f0f1b$var$getHighlightActionPlaceholderData(prompt, formatMessage((0, $cGJsZ.default).highlightActionsPlaceholderPrompt));
        setHighlightActionsEditorPlaceholder(adfDocument, options?.source ?? null, options?.conversationId ?? null);
    }, [
        setHighlightActionsEditorPlaceholder,
        formatMessage
    ]);
    const clearHighlightActionsEditorPlaceholder = (0, $cozmU.useCallback)(()=>{
        setHighlightActionsEditorPlaceholder(null);
    }, [
        setHighlightActionsEditorPlaceholder
    ]);
    return {
        highlightActionsEditorPlaceholder: highlightActionsEditorPlaceholder,
        highlightActionsEditorPlaceholderSource: highlightActionsEditorPlaceholderSource,
        highlightActionsEditorPlaceholderConversationId: highlightActionsEditorPlaceholderConversationId,
        insertHighlightActionsEditorPlaceholder: insertHighlightActionsEditorPlaceholder,
        clearHighlightActionsEditorPlaceholder: clearHighlightActionsEditorPlaceholder
    };
};
module.exports["useHighlightActionsEditorPlaceholder"] = $e14a5679e33f0f1b$export$21b2d5ca0689f678;

});

parcelRegister("kMkDS", function(module, exports) {
const $00de4dd959d7802e$export$f00236a854eaa848 = (content, suggestionContent)=>{
    const updatedContent = Array.isArray(content.content) ? content.content : [
        content.content
    ];
    // Append the new paragraph node
    updatedContent.push({
        type: 'paragraph',
        content: [
            {
                type: 'text',
                text: suggestionContent
            }
        ]
    });
    // Return the updated DocNode
    return {
        ...content,
        content: updatedContent
    };
};
module.exports["appendADFContent"] = $00de4dd959d7802e$export$f00236a854eaa848;

});

parcelRegister("cGJsZ", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $12b4cc67f5ec0d6d$var$message = (0, $kSwu1.defineMessages)({
    highlightActionsPlaceholderPrompt: {
        id: "highlight-actions.rovo-chat.placeholder-prompt",
        defaultMessage: "Ask a question about this."
    }
});
var $12b4cc67f5ec0d6d$export$2e2bcd8739ae039 = $12b4cc67f5ec0d6d$var$message;
module.exports["default"] = $12b4cc67f5ec0d6d$export$2e2bcd8739ae039;

});

parcelRegister("12shJ", function(module, exports) {
/** Sweet-state hooks for the spaces store. */ 
var $kBr4q = parcelRequire("kBr4q");


var $9k1Oq = parcelRequire("9k1Oq");

const $05a1a54631ae3038$export$d71442297730a984 = (0, $kBr4q.createHook)((0, $9k1Oq.spaceStore));
const $05a1a54631ae3038$export$c0aa94e8be00c505 = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore));
const $05a1a54631ae3038$export$995700e1beba27e2 = (0, $kBr4q.createActionsHook)((0, $9k1Oq.spaceStore));
const $05a1a54631ae3038$export$4a0158bb8391bcb = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state)=>state.spaces
});
const $05a1a54631ae3038$export$40840f9e6173b9a6 = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state)=>state.isListLoading
});
const $05a1a54631ae3038$export$98766e9d1f093889 = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state)=>state.listError
});
const $05a1a54631ae3038$export$3939f7e557578ce8 = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state)=>state.hasFetchedList
});
const $05a1a54631ae3038$export$be7cd4af1e0d2a9f = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state)=>state.conversationIds
});
const $05a1a54631ae3038$export$d021bec3570c33bf = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state, spaceId)=>state.spaceDetails.get(spaceId)
});
const $05a1a54631ae3038$export$a3814fef5b67c2b2 = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state, spaceId)=>state.detailLoading.get(spaceId) ?? false
});
const $05a1a54631ae3038$export$70f1b26c4cbf89d = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state, spaceId)=>state.detailErrors.get(spaceId) ?? null
});
const $05a1a54631ae3038$export$2cd2cb4a55b2965d = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state, spaceId)=>state.spaceConversations.get(spaceId) ?? null
});
const $05a1a54631ae3038$export$ed4ca1f1560fcd15 = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state, spaceId)=>state.conversationsLoading.get(spaceId) ?? false
});
const $05a1a54631ae3038$export$24e28f766ba9071e = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state, spaceId)=>state.conversationsErrors.get(spaceId) ?? null
});
const $05a1a54631ae3038$export$c2f6acacddd0717f = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state, spaceId)=>state.spaceMemories.get(spaceId) ?? []
});
const $05a1a54631ae3038$export$fa3b9f71961b2b87 = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state, spaceId)=>state.memoriesLoading.get(spaceId) ?? false
});
const $05a1a54631ae3038$export$70ff4bf3a8bd3e16 = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state, spaceId)=>state.memoriesErrors.get(spaceId) ?? null
});
const $05a1a54631ae3038$export$9a7c6df39e4e5fd4 = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state, spaceId)=>state.smartContextLinkRecommendations.get(spaceId) ?? []
});
module.exports["useSpaceStoreActions"] = $05a1a54631ae3038$export$995700e1beba27e2;
module.exports["useSpaces"] = $05a1a54631ae3038$export$4a0158bb8391bcb;
module.exports["useSpacesLoading"] = $05a1a54631ae3038$export$40840f9e6173b9a6;
module.exports["useSpacesError"] = $05a1a54631ae3038$export$98766e9d1f093889;
module.exports["useHasFetchedSpaces"] = $05a1a54631ae3038$export$3939f7e557578ce8;
module.exports["useSpaceConversationIds"] = $05a1a54631ae3038$export$be7cd4af1e0d2a9f;
module.exports["useSpaceById"] = $05a1a54631ae3038$export$d021bec3570c33bf;
module.exports["useSpaceDetailLoading"] = $05a1a54631ae3038$export$a3814fef5b67c2b2;
module.exports["useSpaceDetailError"] = $05a1a54631ae3038$export$70f1b26c4cbf89d;
module.exports["useSpaceConversationsPage"] = $05a1a54631ae3038$export$2cd2cb4a55b2965d;
module.exports["useSpaceConversationsLoading"] = $05a1a54631ae3038$export$ed4ca1f1560fcd15;
module.exports["useSpaceConversationsError"] = $05a1a54631ae3038$export$24e28f766ba9071e;
module.exports["useSpaceMemories"] = $05a1a54631ae3038$export$c2f6acacddd0717f;
module.exports["useSpaceMemoriesLoading"] = $05a1a54631ae3038$export$fa3b9f71961b2b87;
module.exports["useSpaceMemoriesError"] = $05a1a54631ae3038$export$70ff4bf3a8bd3e16;
module.exports["useSmartContextLinkRecommendations"] = $05a1a54631ae3038$export$9a7c6df39e4e5fd4;

});

parcelRegister("9k1Oq", function(module, exports) {
/**
 * react-sweet-state singleton store for Rovo Spaces. Mutating actions keep the
 * list and detail slices in sync so all consumers see a consistent view.
 */ 
var $8s9DV = parcelRequire("8s9DV");


var $73iDe = parcelRequire("73iDe");


var $1RoaH = parcelRequire("1RoaH");


var $6OvwE = parcelRequire("6OvwE");


var $2Z9WR = parcelRequire("2Z9WR");


var $10p5Q = parcelRequire("10p5Q");


var $9RoLt = parcelRequire("9RoLt");


var $2IYpC = parcelRequire("2IYpC");

// --- Initial state ---
/** Derives a stable flat deduplicated conversationIds array from a spaces list. */ const $c7f6d0062ae88238$var$computeConversationIds = (spaces)=>{
    const ids = new Set();
    for (const space of spaces){
        if (!space.sources) continue;
        for (const source of space.sources){
            if (!source.conversationIds) continue;
            for (const id of source.conversationIds)ids.add(id);
        }
    }
    return Array.from(ids);
};
/** Fresh initial state on every call so `reset()` doesn't share Set/Map refs. */ const $c7f6d0062ae88238$var$makeInitialState = ()=>({
        spaces: [],
        conversationIds: [],
        isListLoading: false,
        listError: null,
        hasFetchedList: false,
        deletedIds: new Set(),
        pendingAdds: new Map(),
        lastFetchedListParams: null,
        spaceDetails: new Map(),
        detailLoading: new Map(),
        detailErrors: new Map(),
        spaceConversations: new Map(),
        conversationsLoading: new Map(),
        conversationsErrors: new Map(),
        spaceMemories: new Map(),
        memoriesLoading: new Map(),
        memoriesErrors: new Map(),
        smartContextLinkRecommendations: new Map()
    });
/** Project a {@link SpaceResponse} down to the lighter {@link Space} list shape. */ const $c7f6d0062ae88238$var$detailToListShape = (response)=>({
        name: response.name,
        emoji: response.emoji ?? null,
        description: response.description ?? null,
        owner: response.owner,
        createdAt: response.createdAt,
        updatedAt: response.updatedAt
    });
/** Build a `Space` from a `CreateSpaceResponse`, defaulting fields not yet present. */ const $c7f6d0062ae88238$var$createResponseToSpace = (response, emojiId)=>({
        id: response.id,
        name: response.name,
        owner: response.owner,
        description: response.description ?? null,
        emoji: emojiId ?? null,
        threadId: null,
        createdAt: response.createdAt,
        updatedAt: response.updatedAt,
        conversationPage: null
    });
/** Immutable Map setter — returns a new Map so sweet-state equality checks fire. */ const $c7f6d0062ae88238$var$mapSet = (map, key, value)=>{
    const next = new Map(map);
    next.set(key, value);
    return next;
};
const $c7f6d0062ae88238$var$mapDelete = (map, key)=>{
    if (!map.has(key)) return map;
    const next = new Map(map);
    next.delete(key);
    return next;
};
const $c7f6d0062ae88238$var$replaceOrAppend = (arr, item, getKey)=>{
    const key = getKey(item);
    const idx = arr.findIndex((it)=>getKey(it) === key);
    if (idx < 0) return [
        ...arr,
        item
    ];
    const next = arr.slice();
    next[idx] = item;
    return next;
};
// --- Actions ---
const $c7f6d0062ae88238$var$actions = {
    /** Test-only — restores the store to its initial empty state. */ reset: ()=>({ setState: setState })=>{
            setState($c7f6d0062ae88238$var$makeInitialState());
        },
    /**
   * Merge spaces into the store (applies tombstones, re-injects pending adds).
   * `{ isLoading: true }` = loading snapshot; `{ error }` = record fetch failure.
   */ setSpaces: (nextSpaces, { isLoading: nextIsLoading = false, error: nextError = null } = {})=>({ getState: getState, setState: setState })=>{
            const { deletedIds: deletedIds, pendingAdds: pendingAdds, hasFetchedList: hasFetchedList } = getState();
            // 1. Drop any rows that have been optimistically deleted client-side.
            const withoutDeleted = deletedIds.size === 0 ? nextSpaces : nextSpaces.filter((s)=>!deletedIds.has(s.id));
            // 2. Reconcile pending adds. On a real server response, drop pending
            //    entries that the server now knows about; on a loading snapshot,
            //    leave them untouched.
            let merged = withoutDeleted;
            let nextPendingAdds = pendingAdds;
            if (pendingAdds.size > 0) {
                const serverIds = new Set(withoutDeleted.map((s)=>s.id));
                const stillPending = [];
                const isServerResponse = !nextIsLoading && nextError === null;
                if (isServerResponse) nextPendingAdds = new Map(pendingAdds);
                pendingAdds.forEach((space, id)=>{
                    if (serverIds.has(id)) {
                        if (isServerResponse) nextPendingAdds.delete(id);
                    } else stillPending.push(space);
                });
                if (stillPending.length > 0) merged = [
                    ...withoutDeleted,
                    ...stillPending
                ];
            }
            setState({
                spaces: merged,
                conversationIds: $c7f6d0062ae88238$var$computeConversationIds(merged),
                isListLoading: nextIsLoading,
                listError: nextError,
                hasFetchedList: !nextIsLoading && nextError === null ? true : hasFetchedList,
                pendingAdds: nextPendingAdds
            });
        },
    addSpace: (response, emojiId)=>({ getState: getState, setState: setState })=>{
            const space = $c7f6d0062ae88238$var$createResponseToSpace(response, emojiId);
            const { spaces: spaces, deletedIds: deletedIds, pendingAdds: pendingAdds } = getState();
            // If a space with this id was previously tombstoned, clear it so the
            // new space (potentially reusing an id) is allowed to surface again.
            const nextDeletedIds = deletedIds.has(response.id) ? new Set(Array.from(deletedIds).filter((id)=>id !== response.id)) : deletedIds;
            // Idempotent guard: if a space with this id is already in the list
            // (e.g. because another `addSpace` call has already run for the same
            // `CreateSpaceModal.onCreated` event, or a server list-fetch landed
            // before us), DO NOT append a duplicate row. We still want to
            // (a) clear any tombstone (handled above) and
            // (b) keep the entry in `pendingAdds` so a subsequent `setSpaces`
            //     loading-snapshot can't drop it before the server confirms it.
            if (spaces.some((s)=>s.id === response.id)) {
                if (deletedIds.has(response.id) || !pendingAdds.has(response.id)) setState({
                    deletedIds: nextDeletedIds,
                    pendingAdds: $c7f6d0062ae88238$var$mapSet(pendingAdds, response.id, space)
                });
                return;
            }
            const nextPendingAdds = $c7f6d0062ae88238$var$mapSet(pendingAdds, response.id, space);
            const nextSpacesAdd = [
                ...spaces,
                space
            ];
            setState({
                spaces: nextSpacesAdd,
                conversationIds: $c7f6d0062ae88238$var$computeConversationIds(nextSpacesAdd),
                deletedIds: nextDeletedIds,
                pendingAdds: nextPendingAdds
            });
        },
    removeSpace: (spaceId)=>({ getState: getState, setState: setState })=>{
            const { spaces: spaces, deletedIds: deletedIds, pendingAdds: pendingAdds } = getState();
            const nextDeletedIds = new Set(deletedIds);
            nextDeletedIds.add(spaceId);
            const nextPendingAdds = $c7f6d0062ae88238$var$mapDelete(pendingAdds, spaceId);
            const nextSpacesRemove = spaces.filter((s)=>s.id !== spaceId);
            setState({
                spaces: nextSpacesRemove,
                conversationIds: $c7f6d0062ae88238$var$computeConversationIds(nextSpacesRemove),
                deletedIds: nextDeletedIds,
                pendingAdds: nextPendingAdds
            });
        },
    restoreSpace: (space)=>({ getState: getState, setState: setState })=>{
            const { spaces: spaces, deletedIds: deletedIds } = getState();
            const nextDeletedIds = new Set(deletedIds);
            nextDeletedIds.delete(space.id);
            const nextSpacesRestore = spaces.some((s)=>s.id === space.id) ? spaces : [
                ...spaces,
                space
            ];
            setState({
                spaces: nextSpacesRestore,
                conversationIds: $c7f6d0062ae88238$var$computeConversationIds(nextSpacesRestore),
                deletedIds: nextDeletedIds
            });
        },
    patchSpace: (spaceId, patch)=>({ getState: getState, setState: setState })=>{
            const { spaces: spaces, spaceDetails: spaceDetails } = getState();
            // Mirror the patch into the detail slice if a detail entry exists, so
            // any open ManageSpaceModal stays consistent with the side-nav list.
            let nextDetails = spaceDetails;
            const existing = spaceDetails.get(spaceId);
            if (existing) {
                // Only mirror fields that exist on the detail shape. The list-only
                // `sources` field intentionally has a different element type
                // (`SpaceSource` vs `SpaceSourceResponse`) and is owned by the
                // dedicated `upsertSpaceSource` / `removeSpaceSource` actions.
                const { sources: _ignoredSources, conversationPage: _ignoredCP, threadId: _ignoredTid, ...detailPatch } = patch;
                nextDetails = $c7f6d0062ae88238$var$mapSet(spaceDetails, spaceId, {
                    ...existing,
                    ...detailPatch
                });
            }
            const nextSpacesPatch = spaces.map((s)=>s.id === spaceId ? {
                    ...s,
                    ...patch
                } : s);
            setState({
                spaces: nextSpacesPatch,
                conversationIds: $c7f6d0062ae88238$var$computeConversationIds(nextSpacesPatch),
                spaceDetails: nextDetails
            });
        },
    /**
   * Fetches the list of spaces from the BE and merges into the store. Marks
   * `isListLoading=true` *without* clearing the existing list so any
   * optimistic state is preserved while the request is in flight.
   *
   * Idempotent: if the store has already fetched for the same params, this
   * is a no-op unless `force=true`.
   */ fetchSpaces: (params)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const { cloudId: cloudId, product: product, experienceId: experienceId, force: force = false } = params;
            const key = `${cloudId}|${product}|${experienceId}`;
            const { hasFetchedList: hasFetchedList, lastFetchedListParams: lastFetchedListParams, spaces: spaces } = getState();
            if (!force && hasFetchedList && lastFetchedListParams === key) return;
            dispatch($c7f6d0062ae88238$var$actions.setSpaces(spaces, {
                isLoading: true
            }));
            try {
                const response = await (0, $9RoLt.listSpacesFetchAction)({
                    cloudId: cloudId,
                    product: product,
                    experienceId: experienceId
                });
                dispatch($c7f6d0062ae88238$var$actions.setSpaces(response.data));
                setState({
                    lastFetchedListParams: key
                });
            } catch (err) {
                const error = err instanceof Error ? err : new Error(String(err));
                dispatch($c7f6d0062ae88238$var$actions.setSpaces(getState().spaces, {
                    error: error
                }));
            }
        },
    setSpaceDetail: (spaceId, response)=>({ getState: getState, setState: setState })=>{
            const { spaces: spaces, spaceDetails: spaceDetails, detailLoading: detailLoading, detailErrors: detailErrors } = getState();
            setState({
                spaceDetails: $c7f6d0062ae88238$var$mapSet(spaceDetails, spaceId, response),
                detailLoading: $c7f6d0062ae88238$var$mapSet(detailLoading, spaceId, false),
                detailErrors: $c7f6d0062ae88238$var$mapSet(detailErrors, spaceId, null),
                spaces: spaces.some((s)=>s.id === spaceId) ? spaces.map((s)=>s.id === spaceId ? {
                        ...s,
                        ...$c7f6d0062ae88238$var$detailToListShape(response)
                    } : s) : spaces
            });
        },
    /**
   * Hydrate the list and detail slices from the full space metadata embedded in
   * GET /chat/conversation/{id}. This is server-confirmed data, so unlike
   * `addSpace` it must not be tracked as an optimistic pending creation.
   */ upsertConversationSpace: (response)=>({ getState: getState, setState: setState })=>{
            const { spaces: spaces, spaceDetails: spaceDetails, detailLoading: detailLoading, detailErrors: detailErrors, deletedIds: deletedIds } = getState();
            if (deletedIds.has(response.id)) return;
            const createdAt = new Date(response.createdAt).toISOString();
            const updatedAt = new Date(response.updatedAt).toISOString();
            const sources = response.sources.map((source)=>({
                    ...source,
                    name: source.name ?? undefined
                }));
            const detail = {
                id: response.id,
                name: response.name,
                owner: response.owner,
                description: response.description ?? null,
                emoji: response.emoji ?? null,
                threadId: response.threadId ?? null,
                createdAt: createdAt,
                updatedAt: updatedAt,
                sources: sources
            };
            const listSpace = {
                ...detail,
                conversationPage: null
            };
            const nextSpaces = spaces.some((space)=>space.id === response.id) ? spaces.map((space)=>space.id === response.id ? {
                    ...space,
                    ...listSpace
                } : space) : [
                ...spaces,
                listSpace
            ];
            setState({
                spaces: nextSpaces,
                conversationIds: $c7f6d0062ae88238$var$computeConversationIds(nextSpaces),
                spaceDetails: $c7f6d0062ae88238$var$mapSet(spaceDetails, response.id, detail),
                detailLoading: $c7f6d0062ae88238$var$mapSet(detailLoading, response.id, false),
                detailErrors: $c7f6d0062ae88238$var$mapSet(detailErrors, response.id, null)
            });
        },
    setSpaceDetailLoading: (spaceId, isLoading)=>({ getState: getState, setState: setState })=>{
            setState({
                detailLoading: $c7f6d0062ae88238$var$mapSet(getState().detailLoading, spaceId, isLoading)
            });
        },
    setSpaceDetailError: (spaceId, error)=>({ getState: getState, setState: setState })=>{
            setState({
                detailErrors: $c7f6d0062ae88238$var$mapSet(getState().detailErrors, spaceId, error),
                detailLoading: $c7f6d0062ae88238$var$mapSet(getState().detailLoading, spaceId, false)
            });
        },
    /**
   * Fetches a single space by id and populates the detail slice. Always
   * fetches when called (consumers wanting cache-only reads should use
   * `useSpaceById`).
   */ fetchSpace: (params)=>async ({ dispatch: dispatch })=>{
            const { spaceId: spaceId } = params;
            dispatch($c7f6d0062ae88238$var$actions.setSpaceDetailLoading(spaceId, true));
            dispatch($c7f6d0062ae88238$var$actions.setSpaceDetailError(spaceId, null));
            try {
                const response = await (0, $6OvwE.getSpaceFetchAction)(params);
                dispatch($c7f6d0062ae88238$var$actions.setSpaceDetail(spaceId, response));
            } catch (err) {
                const error = err instanceof Error ? err : new Error(String(err));
                dispatch($c7f6d0062ae88238$var$actions.setSpaceDetailError(spaceId, error));
            }
        },
    /**
   * Performs a PUT against the spaces API and, on success, patches both the
   * list and detail slices so all consumers see the change immediately.
   */ updateSpace: (params)=>async ({ dispatch: dispatch })=>{
            const response = await (0, $2IYpC.updateSpaceFetchAction)(params);
            dispatch($c7f6d0062ae88238$var$actions.patchSpace(params.spaceId, {
                name: response.name,
                emoji: response.emoji ?? null,
                description: response.description ?? null,
                updatedAt: response.updatedAt
            }));
            return response;
        },
    /**
   * Patches a source into the detail slice's `sources` array (and the list
   * slice's `sources` array if present). Used by `addSpaceSource` after a
   * successful POST to keep the open ManageSpaceModal in sync.
   */ upsertSpaceSource: (spaceId, source)=>({ getState: getState, setState: setState })=>{
            const { spaces: spaces, spaceDetails: spaceDetails } = getState();
            const detail = spaceDetails.get(spaceId);
            const nextDetails = detail !== undefined ? $c7f6d0062ae88238$var$mapSet(spaceDetails, spaceId, {
                ...detail,
                sources: $c7f6d0062ae88238$var$replaceOrAppend(detail.sources ?? [], source, (s)=>s.id)
            }) : spaceDetails;
            const nextSpaces = spaces.map((s)=>s.id === spaceId ? {
                    ...s,
                    sources: $c7f6d0062ae88238$var$replaceOrAppend(s.sources ?? [], {
                        id: source.id,
                        ari: source.ari,
                        url: source.url,
                        sourceType: source.sourceType,
                        name: source.name ?? null
                    }, (it)=>it.id)
                } : s);
            setState({
                spaces: nextSpaces,
                conversationIds: $c7f6d0062ae88238$var$computeConversationIds(nextSpaces),
                spaceDetails: nextDetails
            });
        },
    removeSpaceSource: (spaceId, sourceId)=>({ getState: getState, setState: setState })=>{
            const { spaces: spaces, spaceDetails: spaceDetails } = getState();
            const detail = spaceDetails.get(spaceId);
            const nextDetails = detail !== undefined ? $c7f6d0062ae88238$var$mapSet(spaceDetails, spaceId, {
                ...detail,
                sources: (detail.sources ?? []).filter((s)=>s.id !== sourceId)
            }) : spaceDetails;
            const nextSpaces = spaces.map((s)=>s.id === spaceId ? {
                    ...s,
                    sources: (s.sources ?? []).filter((it)=>it.id !== sourceId)
                } : s);
            setState({
                spaces: nextSpaces,
                conversationIds: $c7f6d0062ae88238$var$computeConversationIds(nextSpaces),
                spaceDetails: nextDetails
            });
        },
    setSpaceConversations: (spaceId, page, isLoading, error)=>({ getState: getState, setState: setState })=>{
            const { spaceConversations: spaceConversations, conversationsLoading: conversationsLoading, conversationsErrors: conversationsErrors } = getState();
            setState({
                spaceConversations: page !== null ? $c7f6d0062ae88238$var$mapSet(spaceConversations, spaceId, page) : spaceConversations,
                conversationsLoading: $c7f6d0062ae88238$var$mapSet(conversationsLoading, spaceId, isLoading),
                conversationsErrors: $c7f6d0062ae88238$var$mapSet(conversationsErrors, spaceId, error)
            });
        },
    removeConversationFromSpaceConversations: (conversationIds)=>({ getState: getState, setState: setState })=>{
            if (conversationIds.length === 0) return;
            const idsToRemove = new Set(conversationIds);
            const { spaceConversations: spaceConversations } = getState();
            let nextSpaceConversations = spaceConversations;
            spaceConversations.forEach((page, spaceId)=>{
                const nextConversations = page.conversations.filter((conversation)=>!idsToRemove.has(conversation.id) && !(conversation.backendConversationId && idsToRemove.has(conversation.backendConversationId)));
                if (nextConversations.length !== page.conversations.length) nextSpaceConversations = $c7f6d0062ae88238$var$mapSet(nextSpaceConversations, spaceId, {
                    ...page,
                    conversations: nextConversations,
                    totalCount: Math.max(0, page.totalCount - (page.conversations.length - nextConversations.length))
                });
            });
            if (nextSpaceConversations !== spaceConversations) setState({
                spaceConversations: nextSpaceConversations
            });
        },
    fetchSpaceConversations: (params)=>async ({ dispatch: dispatch })=>{
            const { spaceId: spaceId } = params;
            dispatch($c7f6d0062ae88238$var$actions.setSpaceConversations(spaceId, null, true, null));
            try {
                const response = await (0, $2Z9WR.getSpaceConversationsFetchAction)(params);
                dispatch($c7f6d0062ae88238$var$actions.setSpaceConversations(spaceId, response, false, null));
            } catch (err) {
                const error = err instanceof Error ? err : new Error(String(err));
                dispatch($c7f6d0062ae88238$var$actions.setSpaceConversations(spaceId, null, false, error));
            }
        },
    /** Internal setter — drives loading/error state and populates the memory list. */ setSpaceMemories: (spaceId, items, isLoading, error)=>({ getState: getState, setState: setState })=>{
            const { spaceMemories: spaceMemories, memoriesLoading: memoriesLoading, memoriesErrors: memoriesErrors } = getState();
            setState({
                spaceMemories: items !== null ? $c7f6d0062ae88238$var$mapSet(spaceMemories, spaceId, items) : spaceMemories,
                memoriesLoading: $c7f6d0062ae88238$var$mapSet(memoriesLoading, spaceId, isLoading),
                memoriesErrors: $c7f6d0062ae88238$var$mapSet(memoriesErrors, spaceId, error)
            });
        },
    /**
   * Lazily fetches the memory list for a space from GET /spaces/{spaceId}/memory.
   * Only fires a network request the first time it's called for a given spaceId
   * (or if a previous fetch errored).
   */ fetchSpaceMemories: (params)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { spaceId: spaceId } = params;
            const { memoriesLoading: memoriesLoading, spaceMemories: spaceMemories } = getState();
            if (memoriesLoading.get(spaceId) || spaceMemories.has(spaceId)) return;
            dispatch($c7f6d0062ae88238$var$actions.setSpaceMemories(spaceId, null, true, null));
            try {
                const response = await (0, $10p5Q.getSpaceMemoryFetchAction)(params);
                const items = response.items.map((item)=>({
                        id: item.id,
                        text: item.content
                    }));
                dispatch($c7f6d0062ae88238$var$actions.setSpaceMemories(spaceId, items, false, null));
            } catch (err) {
                const error = err instanceof Error ? err : new Error(String(err));
                dispatch($c7f6d0062ae88238$var$actions.setSpaceMemories(spaceId, null, false, error));
            }
        },
    /**
   * POSTs a new memory item and optimistically inserts it at the end of the
   * list so the UI updates immediately without a refetch.
   */ createSpaceMemory: (params)=>async ({ getState: getState, setState: setState })=>{
            const response = await (0, $73iDe.createSpaceMemoryFetchAction)(params);
            const { spaceMemories: spaceMemories } = getState();
            const { spaceId: spaceId } = params;
            const existing = spaceMemories.get(spaceId) ?? [];
            setState({
                spaceMemories: $c7f6d0062ae88238$var$mapSet(spaceMemories, spaceId, [
                    ...existing,
                    {
                        id: response.id,
                        text: response.content
                    }
                ])
            });
        },
    /**
   * Optimistically removes a memory item from the store, then fires the
   * DELETE request. Rolls back on failure.
   */ removeSpaceMemory: (spaceId, memoryId, cloudId, product, experienceId)=>async ({ getState: getState, setState: setState })=>{
            const { spaceMemories: spaceMemories } = getState();
            const existing = spaceMemories.get(spaceId) ?? [];
            const optimistic = existing.filter((m)=>m.id !== memoryId);
            setState({
                spaceMemories: $c7f6d0062ae88238$var$mapSet(spaceMemories, spaceId, optimistic)
            });
            try {
                await (0, $1RoaH.deleteSpaceMemoryFetchAction)({
                    spaceId: spaceId,
                    memoryId: memoryId,
                    cloudId: cloudId,
                    product: product,
                    experienceId: experienceId
                });
            } catch (err) {
                setState({
                    spaceMemories: $c7f6d0062ae88238$var$mapSet(getState().spaceMemories, spaceId, existing)
                });
                throw err;
            }
        },
    setSmartContextLinkRecommendations: (spaceId, recommendations)=>({ getState: getState, setState: setState })=>{
            setState({
                smartContextLinkRecommendations: $c7f6d0062ae88238$var$mapSet(getState().smartContextLinkRecommendations, spaceId, recommendations)
            });
        },
    clearSmartContextLinkRecommendations: (spaceId)=>({ getState: getState, setState: setState })=>{
            setState({
                smartContextLinkRecommendations: $c7f6d0062ae88238$var$mapDelete(getState().smartContextLinkRecommendations, spaceId)
            });
        },
    removeSmartContextLinkRecommendation: (spaceId, recommendationId)=>({ getState: getState, setState: setState })=>{
            const { smartContextLinkRecommendations: smartContextLinkRecommendations } = getState();
            const existing = smartContextLinkRecommendations.get(spaceId);
            if (!existing) return;
            setState({
                smartContextLinkRecommendations: $c7f6d0062ae88238$var$mapSet(smartContextLinkRecommendations, spaceId, existing.filter((recommendation)=>recommendation.recommendationId !== recommendationId))
            });
        }
};
const $c7f6d0062ae88238$export$34ecf36458142176 = (0, $8s9DV.createStore)({
    name: 'spaceStore',
    initialState: $c7f6d0062ae88238$var$makeInitialState(),
    actions: $c7f6d0062ae88238$var$actions
});
module.exports["spaceStore"] = $c7f6d0062ae88238$export$34ecf36458142176;

});

parcelRegister("73iDe", function(module, exports) {

var $jTKfH = parcelRequire("jTKfH");


var $98i9C = parcelRequire("98i9C");

const $f1fa406f69b22b7e$export$1b63f5338cb50250 = ({ spaceId: spaceId, content: content, cloudId: cloudId, product: product, experienceId: experienceId })=>{
    return (0, $jTKfH.performHttpFetch)({
        path: `${(0, $98i9C.SPACES_API_PATH)}/${spaceId}/memory`,
        options: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-cloudid': cloudId,
                'x-product': product,
                'x-experience-id': experienceId
            },
            credentials: 'include',
            body: JSON.stringify({
                content: content
            })
        }
    });
};
module.exports["createSpaceMemoryFetchAction"] = $f1fa406f69b22b7e$export$1b63f5338cb50250;

});

parcelRegister("98i9C", function(module, exports) {
/** Base path for the ConvoAI Spaces REST API. */ const $8ef18f344ac2d2f3$export$472fb0d2ff1c7d85 = '/gateway/api/assist/rovo/v1/spaces';
const $8ef18f344ac2d2f3$export$1dd3d5c121ebda25 = 100;
const $8ef18f344ac2d2f3$export$33d45ef69b8a7178 = 500;
module.exports["SPACES_API_PATH"] = $8ef18f344ac2d2f3$export$472fb0d2ff1c7d85;
module.exports["SPACE_NAME_MAX_LENGTH"] = $8ef18f344ac2d2f3$export$1dd3d5c121ebda25;
module.exports["SPACE_ABOUT_MAX_LENGTH"] = $8ef18f344ac2d2f3$export$33d45ef69b8a7178;

});

parcelRegister("1RoaH", function(module, exports) {
/**
 * The DELETE endpoint returns 204 No Content; `performHttpFetch` would
 * attempt `response.json()` and throw on an empty body, so we use the
 * manual `fetch` here instead.
 */ 
var $jTKfH = parcelRequire("jTKfH");


var $98i9C = parcelRequire("98i9C");

const $11c6d2f4dd10a9f1$export$53573fd484f1b3c3 = async ({ spaceId: spaceId, memoryId: memoryId, cloudId: cloudId, product: product, experienceId: experienceId })=>{
    const path = `${(0, $98i9C.SPACES_API_PATH)}/${spaceId}/memory/${memoryId}`;
    let response;
    try {
        response = await fetch(path, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'x-cloudid': cloudId,
                'x-product': product,
                'x-experience-id': experienceId
            },
            credentials: 'include'
        });
    } catch (err) {
        const originalErrorMessage = err instanceof Error ? err.message : 'Unknown error';
        throw new (0, $jTKfH.FetchError)(`deleteSpaceMemoryFetch error while fetching ${path}. Original error: ${originalErrorMessage}`, {
            errorCode: 'deleteSpaceMemoryFetchError'
        });
    }
    if (!response.ok || response.status >= 400) {
        const body = await response.text().catch(()=>'');
        throw new (0, $jTKfH.FetchError)(`deleteSpaceMemoryFetch error while fetching ${path}. Original error: [Code ${response.status}] ${body}`, {
            errorCode: 'deleteSpaceMemoryFetchError',
            statusCode: response.status
        });
    }
// 204 No Content — no body to parse.
};
module.exports["deleteSpaceMemoryFetchAction"] = $11c6d2f4dd10a9f1$export$53573fd484f1b3c3;

});

parcelRegister("6OvwE", function(module, exports) {
/**
 * Pure fetch helper extracted from `useGetSpace` so the spaces sweet-state
 * store can call it from inside an action without depending on React or on
 * the hook itself.
 */ 
var $jTKfH = parcelRequire("jTKfH");

const $51d5e1a1500b2e17$var$SPACES_API_PATH = '/gateway/api/assist/rovo/v1/spaces';
const $51d5e1a1500b2e17$export$fbca0b4b208eec07 = async ({ spaceId: spaceId, cloudId: cloudId, product: product, experienceId: experienceId })=>(0, $jTKfH.performHttpFetch)({
        path: `${$51d5e1a1500b2e17$var$SPACES_API_PATH}/${spaceId}`,
        options: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'x-cloudid': cloudId,
                'x-product': product,
                'x-experience-id': experienceId
            },
            credentials: 'include'
        }
    });
module.exports["getSpaceFetchAction"] = $51d5e1a1500b2e17$export$fbca0b4b208eec07;

});

parcelRegister("2Z9WR", function(module, exports) {
/**
 * Pure fetch helper extracted from `useGetSpaceConversations` so the spaces
 * sweet-state store can call it from inside an action without depending on
 * React or on the hook itself.
 */ 
var $igOtY = parcelRequire("igOtY");


var $jTKfH = parcelRequire("jTKfH");

const $3cc16f24d97017b7$var$SPACES_API_PATH = '/gateway/api/assist/rovo/v1/spaces';
const $3cc16f24d97017b7$var$mapSpaceConversationFromApi = (channel, spaceId)=>{
    const lastMessage = channel.last_message ?? undefined;
    return {
        id: channel.id,
        name: channel.name ?? '',
        messages: [],
        status: (0, $igOtY.CHAT_STORE_STATUS).idle,
        traces: [],
        timeCreated: channel.time_created,
        lastMessage: lastMessage,
        lastMessageType: channel.last_message_type ?? [],
        lastMessageTimestamp: channel.last_message_timestamp,
        lastAgentMessageStatus: channel.last_agent_message_status,
        readStatus: channel.readStatus ?? channel.read_status ?? null,
        agent: channel.agent,
        scopes: channel.scopes,
        tags: channel.tags,
        rovoSpaceId: spaceId,
        isEmpty: !lastMessage?.trim(),
        isPinned: channel.isPinned ?? channel.is_pinned ?? undefined,
        pinnedAt: channel.pinnedAt ?? channel.pinned_at ?? null
    };
};
const $3cc16f24d97017b7$export$539f16f68a4805bb = async ({ spaceId: spaceId, cloudId: cloudId, product: product, experienceId: experienceId, offset: offset, count: count })=>{
    const params = new URLSearchParams();
    if (offset !== undefined) params.set('offset', String(offset));
    if (count !== undefined) params.set('count', String(count));
    const query = params.toString();
    const raw = await (0, $jTKfH.performHttpFetch)({
        path: `${$3cc16f24d97017b7$var$SPACES_API_PATH}/${spaceId}/conversations${query ? `?${query}` : ''}`,
        options: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'x-cloudid': cloudId,
                'x-product': product,
                'x-experience-id': experienceId
            },
            credentials: 'include'
        }
    });
    return {
        ...raw,
        conversations: raw.conversations.map((row)=>$3cc16f24d97017b7$var$mapSpaceConversationFromApi(row, spaceId))
    };
};
module.exports["getSpaceConversationsFetchAction"] = $3cc16f24d97017b7$export$539f16f68a4805bb;

});

parcelRegister("10p5Q", function(module, exports) {
/**
 * Pure fetch helper for GET /spaces/{spaceId}/memory.
 * Extracted from `useGetSpaceMemory` so callers (e.g. the sweet-state store)
 * can invoke it without depending on React or the hook lifecycle.
 */ 
var $jTKfH = parcelRequire("jTKfH");


var $98i9C = parcelRequire("98i9C");

const $4aa5bad3aecdc97a$export$8149ce67f430cbb = ({ spaceId: spaceId, cloudId: cloudId, product: product, experienceId: experienceId })=>(0, $jTKfH.performHttpFetch)({
        path: `${(0, $98i9C.SPACES_API_PATH)}/${spaceId}/memory`,
        options: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'x-cloudid': cloudId,
                'x-product': product,
                'x-experience-id': experienceId
            },
            credentials: 'include'
        }
    });
module.exports["getSpaceMemoryFetchAction"] = $4aa5bad3aecdc97a$export$8149ce67f430cbb;

});

parcelRegister("9RoLt", function(module, exports) {

var $jTKfH = parcelRequire("jTKfH");


var $98i9C = parcelRequire("98i9C");

const $296439ad4ec4b4aa$export$6c7ca5b71363fc06 = async ({ cloudId: cloudId, product: product, experienceId: experienceId })=>(0, $jTKfH.performHttpFetch)({
        path: (0, $98i9C.SPACES_API_PATH),
        options: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'x-cloudid': cloudId,
                'x-product': product,
                'x-experience-id': experienceId
            },
            credentials: 'include'
        }
    });
module.exports["listSpacesFetchAction"] = $296439ad4ec4b4aa$export$6c7ca5b71363fc06;

});

parcelRegister("2IYpC", function(module, exports) {
/**
 * Pure fetch helper extracted from `useUpdateSpace` so the spaces sweet-state
 * store can call it from inside an action without depending on React or on
 * the hook itself.
 */ 
var $jTKfH = parcelRequire("jTKfH");

const $078217057a30f7df$var$SPACES_API_PATH = '/gateway/api/assist/rovo/v1/spaces';
const $078217057a30f7df$export$9c961ef5c3a31b95 = async ({ spaceId: spaceId, request: request, cloudId: cloudId, product: product, experienceId: experienceId })=>(0, $jTKfH.performHttpFetch)({
        path: `${$078217057a30f7df$var$SPACES_API_PATH}/${spaceId}`,
        options: {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'x-cloudid': cloudId,
                'x-product': product,
                'x-experience-id': experienceId
            },
            credentials: 'include',
            body: JSON.stringify(request)
        }
    });
module.exports["updateSpaceFetchAction"] = $078217057a30f7df$export$9c961ef5c3a31b95;

});

parcelRegister("20Kr8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $dab591e1852df37c$export$4c9ccf8a18d8ec6e = {
    override: null,
    setOverride: ()=>{}
};


const $ced7807ecaf30a36$export$a01f89f33dbfe1bd = (0, $cozmU.createContext)((0, $dab591e1852df37c$export$4c9ccf8a18d8ec6e));
module.exports["BackBehaviorOverrideContext"] = $ced7807ecaf30a36$export$a01f89f33dbfe1bd;

});

parcelRegister("hJC44", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $00c33fe8f91cd74f$var$StoreErrorFlagContext = (0, $cozmU.createContext)(undefined);
var $00c33fe8f91cd74f$export$2e2bcd8739ae039 = $00c33fe8f91cd74f$var$StoreErrorFlagContext;
module.exports["default"] = $00c33fe8f91cd74f$export$2e2bcd8739ae039;

});

parcelRegister("4MnFz", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $iXRmn = parcelRequire("iXRmn");

const $878d7a55fd1744f7$export$2879604e6aec4ab = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useFlags() {
    const api = (0, $cozmU.useContext)((0, $iXRmn.FlagContext));
    if (api == null) throw new Error("Unable to find FlagProviderContext");
    return api;
} : function useFlags() {
    const api = (0, $cozmU.useContext)((0, $iXRmn.FlagContext));
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
};
module.exports["useFlags"] = $878d7a55fd1744f7$export$2879604e6aec4ab;

});

parcelRegister("8KiU9", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $4b7a70d334529286$var$message = (0, $kSwu1.defineMessages)({
    conversationForbiddenTitle: {
        id: "ai-mate.conversation-assistant.flag.conversation-forbidden.title",
        defaultMessage: "This conversation is not available"
    },
    conversationForbiddenDescription: {
        id: "ai-mate.conversation-assistant.flag.conversation-forbidden.description",
        defaultMessage: "The conversation you tried to open may belong to another user or you may not have permission to view it."
    },
    conversationHistoryLoadFailedTitle: {
        id: "ai-mate.conversation-assistant.flag.conversation-history-load-failed.title",
        defaultMessage: "We couldn't load your conversations"
    },
    conversationHistoryLoadFailedDescription: {
        id: "ai-mate.conversation-assistant.flag.conversation-history-load-failed.description",
        defaultMessage: "You can keep chatting with Rovo, but your conversation history may be out of date."
    },
    followUpAgentUnavailableTitle: {
        id: "conversation-assistant.followUpAgentUnavailableTitle",
        defaultMessage: "This follow-up can't be sent"
    },
    followUpAgentUnavailableDescription: {
        id: "conversation-assistant.followUpAgentUnavailableDescription",
        defaultMessage: "The responding agent is unavailable. Choose an agent and try again."
    },
    autoConversationPrompt: {
        id: "ai-mate.conversation-assistant.auto-conversation.prompt",
        defaultMessage: "Hey Rovo, list three things you can do with my work that will make me more effective this week."
    }
});
var $4b7a70d334529286$export$2e2bcd8739ae039 = $4b7a70d334529286$var$message;
module.exports["default"] = $4b7a70d334529286$export$2e2bcd8739ae039;

});

parcelRegister("5BOJB", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $4m5jb = parcelRequire("4m5jb");


var $bGNkz = parcelRequire("bGNkz");


var $9aRNV = parcelRequire("9aRNV");


var $6iQ4q = parcelRequire("6iQ4q");


var $3TxKn = parcelRequire("3TxKn");


var $iLyZq = parcelRequire("iLyZq");

const $ebee8f54e12cc0bd$var$dismissActiveAction = (action, clearAction)=>{
    try {
        (0, $iLyZq.getActionOnDismiss)(action)?.();
    } finally{
        clearAction();
    }
};
const $ebee8f54e12cc0bd$export$e60c4e7dea337eb3 = ()=>{
    (0, $6cFsl.di)((0, $3TxKn.useChatStoreActions), (0, $9aRNV.useConversationActionsStoreActions), (0, $9aRNV.useConversationActionsStore), (0, $bGNkz.useUIStoreActions));
    const { setActiveAction_UNSAFE: setActiveAction_UNSAFE } = (0, $9aRNV.useConversationActionsStoreActions)();
    const { setSelectedConversation: setSelectedConversation } = (0, $3TxKn.useChatStoreActions)();
    (0, $bGNkz.useUIStoreSubscription)();
    const { setActiveMenu: setActiveMenu } = (0, $bGNkz.useUIStoreActions)();
    const [{ activeAction: activeAction }] = (0, $9aRNV.useConversationActionsStore)();
    const activeActionRef = (0, $cozmU.useRef)(activeAction);
    // Keep clearActiveAction safe for hook instances that did not set the action.
    (0, $cozmU.useEffect)(()=>{
        activeActionRef.current = activeAction;
    }, [
        activeAction
    ]);
    const setActiveAction = (0, $cozmU.useCallback)((action, options)=>{
        activeActionRef.current = action;
        setActiveAction_UNSAFE(action);
        if (action) {
            if (!options?.preserveSelectedConversation) setSelectedConversation({
                conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID),
                sourceAgentId: (0, $6iQ4q.DEFAULT_AGENT).id
            });
            setActiveMenu('none');
        }
    }, [
        setActiveAction_UNSAFE,
        setSelectedConversation,
        setActiveMenu
    ]);
    const clearActiveAction = (0, $cozmU.useCallback)(()=>{
        $ebee8f54e12cc0bd$var$dismissActiveAction(activeActionRef.current, ()=>{
            activeActionRef.current = undefined;
            setActiveAction_UNSAFE(undefined);
        });
    }, [
        setActiveAction_UNSAFE
    ]);
    return {
        activeAction: activeAction,
        setActiveAction: setActiveAction,
        clearActiveAction: clearActiveAction
    };
};
module.exports["useActiveAction"] = $ebee8f54e12cc0bd$export$e60c4e7dea337eb3;

});

parcelRegister("9aRNV", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $09ecffa85d56d9ae$var$store = (0, $8s9DV.createStore)({
    initialState: {
        actionFilter: undefined,
        actions: [],
        jiraIssueViewActions: undefined,
        input: '',
        activeAction: undefined,
        buttonClickedTimestamp: undefined
    },
    actions: {
        setConversationActions: (actions)=>({ setState: setState })=>{
                setState({
                    actions: actions
                });
            },
        /*
     * Jira Issue View does not use the provider pattern yet, so we need to skip the provider action fetching.
     * When Jira Issue View is migrated to set actions using provider pattern, we can remove this setter.
     */ setJiraIssueViewActions: (actions)=>({ setState: setState })=>{
                setState({
                    jiraIssueViewActions: actions
                });
            },
        setInput: (input)=>({ setState: setState })=>{
                setState({
                    input: input
                });
            },
        setActionFilter: (actionFilter)=>({ setState: setState })=>{
                setState({
                    actionFilter: actionFilter
                });
            },
        /*
     * Do not use this setter directly. Use setActiveAction from useActiveAction hook in conversation-assistant instead.
     */ setActiveAction_UNSAFE: (activeAction)=>({ setState: setState })=>{
                setState({
                    activeAction: activeAction
                });
            },
        setActiveActionFollowUpContext: (customFollowUpContext)=>({ getState: getState, setState: setState })=>{
                const activeAction = getState().activeAction;
                if (!activeAction || !('customFollowUpContext' in activeAction)) return;
                setState({
                    activeAction: {
                        ...activeAction,
                        customFollowUpContext: customFollowUpContext
                    }
                });
            },
        setButtonClickedTimestamp: (buttonClickedTimestamp)=>({ setState: setState })=>{
                setState({
                    buttonClickedTimestamp: buttonClickedTimestamp
                });
            },
        getConversationActions: ()=>({ getState: getState })=>{
                return getState().actions;
            },
        getActionFilter: ()=>({ getState: getState })=>{
                return getState().actionFilter;
            },
        getInput: ()=>({ getState: getState })=>{
                return getState().input;
            },
        getActiveAction: ()=>({ getState: getState })=>{
                return getState().activeAction;
            },
        getButtonClickedTimestamp: ()=>({ getState: getState })=>{
                return getState().buttonClickedTimestamp;
            },
        setConvoStarterActionPrompt: (convoStarterActionPrompt)=>({ setState: setState })=>{
                setState({
                    convoStarterActionPrompt: convoStarterActionPrompt
                });
            }
    }
});
const $09ecffa85d56d9ae$export$83a8985e8d377ba1 = (0, $kBr4q.createHook)($09ecffa85d56d9ae$var$store);
const $09ecffa85d56d9ae$export$74d7aed167e24a67 = (0, $kBr4q.createActionsHook)($09ecffa85d56d9ae$var$store);
const $09ecffa85d56d9ae$export$d6ed3fb83640b335 = (0, $kBr4q.createStateHook)($09ecffa85d56d9ae$var$store);
const $09ecffa85d56d9ae$export$4be353558b8b8a37 = (0, $kBr4q.createStateHook)($09ecffa85d56d9ae$var$store, {
    selector: (state)=>state.convoStarterActionPrompt
});
module.exports["useConversationActionsStore"] = $09ecffa85d56d9ae$export$83a8985e8d377ba1;
module.exports["useConversationActionsStoreActions"] = $09ecffa85d56d9ae$export$74d7aed167e24a67;
module.exports["useConversationActionsStoreState"] = $09ecffa85d56d9ae$export$d6ed3fb83640b335;

});

parcelRegister("iLyZq", function(module, exports) {

var $gR7ri = parcelRequire("gR7ri");

const $3bc7276fe39ce470$export$42c34726e4093ea = (action)=>(0, $gR7ri.getConversationActionWithAssistantMetadata)(action)?.onDismiss;
module.exports["getActionOnDismiss"] = $3bc7276fe39ce470$export$42c34726e4093ea;

});

parcelRegister("gR7ri", function(module, exports) {
const $e7fea99b17cf91ca$export$89c94a468e7458db = (action)=>action;
module.exports["getConversationActionWithAssistantMetadata"] = $e7fea99b17cf91ca$export$89c94a468e7458db;

});

parcelRegister("lzoay", function(module, exports) {

var $dSoGR = parcelRequire("dSoGR");

const $6b458841b18d92d3$export$2d48a0bb3ca90998 = (0, $dSoGR.createCommand)('action-classification-command');
module.exports["ActionClassificationCommand"] = $6b458841b18d92d3$export$2d48a0bb3ca90998;

});

parcelRegister("jIWEY", function(module, exports) {

var $4EPzQ = parcelRequire("4EPzQ");

const $6a4afb8ff5c7a0df$export$91924c1e64eedc26 = (docNode)=>{
    if (!docNode) return '';
    const text = (0, $4EPzQ.reduce)(docNode, (acc, node)=>node.type === 'text' ? acc + (node.text || '') : acc, '');
    return text.trim();
};
module.exports["extractTextFromDocNode"] = $6a4afb8ff5c7a0df$export$91924c1e64eedc26;

});

parcelRegister("guRLk", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");


var $bWJgt = parcelRequire("bWJgt");

const $94ac7e79844e2709$export$b2f14d06b1eb724e = (0, $kBr4q.createActionsHook)((0, $bWJgt.store));
module.exports["useChatMessageResearchActions"] = $94ac7e79844e2709$export$b2f14d06b1eb724e;

});

parcelRegister("bWJgt", function(module, exports) {

var $8s9DV = parcelRequire("8s9DV");


var $bxkJA = parcelRequire("bxkJA");

const $0ae2e85c06c407f6$export$d4032e5b8e7b1dac = 0.01;


const $80497cf038e22e03$export$62617f3d98f45616 = ({ messageId: messageId, content: content, title: title = 'Research Plan', roundId: roundId })=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const message = currentState[messageId];
        // Set the research plan on the message
        setState({
            ...currentState,
            [messageId]: {
                ...message ?? {
                    currentProgress: (0, $0ae2e85c06c407f6$export$d4032e5b8e7b1dac),
                    steps: {},
                    researchPlans: {}
                },
                researchPlans: {
                    ...message?.researchPlans,
                    [roundId]: {
                        title: title,
                        content: content,
                        roundId: roundId
                    }
                }
            }
        });
    };


const $d33209bbb5b85d5e$export$590dff6126d55b43 = 0.05;


const $bc7bf914d1a438d1$export$4c442435645f2043 = (currentProgress, weight = (0, $d33209bbb5b85d5e$export$590dff6126d55b43))=>Math.min(0.95, currentProgress + 0.95 * weight);


const $7e39e718c4e877b6$export$62ce0cc0b5f9371c = (steps)=>{
    return steps.length ? Math.max(...steps.map((step)=>step.order)) : 0;
};



const $37a7a07adcd579ae$export$b9dd42b4e24f01b4 = ({ messageId: messageId, stepId: stepId, updater: updater })=>({ getState: getState, setState: setState })=>{
        const message = getState()[messageId];
        const step = message?.steps[stepId];
        const isNewStep = !step;
        // reuse existing order if the step exists, otherwise create a new one with the next order
        const order = step?.order ?? (0, $7e39e718c4e877b6$export$62ce0cc0b5f9371c)(Object.values(message?.steps ?? {})) + 1;
        const separatedContent = step?.separatedContent ?? [];
        const updatedStep = updater({
            ...message?.steps[stepId],
            separatedContent: separatedContent,
            stepId: stepId,
            order: order
        }, isNewStep);
        setState({
            [messageId]: {
                ...message ?? {
                    currentProgress: (0, $0ae2e85c06c407f6$export$d4032e5b8e7b1dac)
                },
                steps: {
                    ...message?.steps,
                    [stepId]: updatedStep
                },
                // Consider total researchCompleted:false if any step is updated to completed:false
                // This covers any new rounds that may stream in after the others have been completed
                ...!updatedStep.completed ? {
                    researchCompleted: false
                } : {},
                ...updatedStep.completed ? {
                    currentProgress: (0, $bc7bf914d1a438d1$export$4c442435645f2043)(message?.currentProgress ?? (0, $0ae2e85c06c407f6$export$d4032e5b8e7b1dac))
                } : {}
            }
        });
    };


const $52c6649b0e0b7a84$export$a55635553828f889 = ({ messageId: messageId, stepId: stepId, content: content, isStreamed: isStreamed, immediate: immediate, roundId: roundId })=>({ dispatch: dispatch })=>{
        dispatch((0, $37a7a07adcd579ae$export$b9dd42b4e24f01b4)({
            messageId: messageId,
            stepId: stepId,
            updater: (step, isNewStep)=>{
                // Concat once and reuse to halve per-event allocation.
                const concatenatedContent = (step.content ?? '') + content;
                // streamed: single concatenated child; non-streamed: each chunk as a separate array item
                const separatedContent = isStreamed ? [
                    concatenatedContent
                ] : [
                    ...step.separatedContent,
                    content
                ];
                return {
                    ...step,
                    roundId: roundId,
                    content: concatenatedContent,
                    separatedContent: separatedContent,
                    immediate: immediate,
                    // If a step content arrives for a step that was never introduced with a title,
                    // consider it completed immediately — it's an orphan content step that won't
                    // receive a RESEARCH_STEP_COMPLETE message.
                    // Otherwise, it cannot be complete if we're still appending content.
                    completed: isNewStep && !step.title ? true : false,
                    isStreamed: // Track whether this step's content is streamed or discrete
                    isStreamed
                };
            }
        }));
    };



const $c0ef94996608e7a5$export$7d99c23b07ac0974 = ({ messageId: messageId, stepId: stepId, document: document })=>({ dispatch: dispatch })=>{
        dispatch((0, $37a7a07adcd579ae$export$b9dd42b4e24f01b4)({
            messageId: messageId,
            stepId: stepId,
            updater: (step)=>({
                    ...step,
                    documents: [
                        ...step.documents ?? [],
                        document
                    ]
                })
        }));
    };


const $627ddeb671c41e26$export$872f148557cf8bf5 = 0.001;



const $6a418f740b9b0640$export$2e0130e7f5800320 = ({ messageId: messageId })=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const message = currentState[messageId];
        if (message && !message.researchCompleted) {
            const updatedSteps = Object.entries(message.steps).reduce((acc, [stepId, step])=>({
                    ...acc,
                    [stepId]: {
                        ...step,
                        completed: true
                    }
                }), {});
            setState({
                ...currentState,
                [messageId]: {
                    ...message,
                    steps: updatedSteps,
                    currentProgress: undefined,
                    researchCompleted: true
                }
            });
        }
    };



const $a874628146faf38d$export$fd530ec9d7995e3e = ({ messageId: messageId })=>({ getState: getState, setState: setState })=>{
        const message = getState()[messageId];
        if (!message) setState({
            [messageId]: {
                currentProgress: (0, $0ae2e85c06c407f6$export$d4032e5b8e7b1dac),
                steps: {},
                researchPlans: {}
            }
        });
    };


const $af1e39fe228c220f$export$6514c23d684eadd8 = ({ messageId: messageId })=>({ getState: getState, setState: setState })=>{
        const message = getState()[messageId];
        if (message && !message.hasReceivedAnswerPart) setState({
            [messageId]: {
                ...message,
                hasReceivedAnswerPart: true
            }
        });
    };


const $0fd66ab30ab57c5a$export$8f77fbc4cfe15534 = ({ messageId: messageId })=>({ getState: getState, setState: setState })=>{
        const message = getState()[messageId];
        if (message && message.hasReceivedAnswerPart) setState({
            [messageId]: {
                ...message,
                hasReceivedAnswerPart: false
            }
        });
    };


const $06f681cd30867526$export$5cf35e65df857124 = ({ messageId: messageId, triggered: triggered })=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const message = currentState[messageId];
        setState({
            [messageId]: {
                ...message ?? {
                    steps: {},
                    researchPlans: {}
                },
                hasThinkDeeperTriggered: triggered
            }
        });
    };


const $5ff0c09ec43395a4$export$d035a949bdd52aff = ({ messageId: messageId })=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const message = currentState[messageId];
        setState({
            [messageId]: {
                ...message ?? {
                    steps: {},
                    researchPlans: {}
                },
                isDeepResearch: true
            }
        });
    };



const $8d246a514926505b$export$b9aadbf5032a78e5 = ({ messageId: messageId, stepId: stepId, sourceIcons: sourceIcons })=>({ dispatch: dispatch })=>{
        dispatch((0, $37a7a07adcd579ae$export$b9dd42b4e24f01b4)({
            messageId: messageId,
            stepId: stepId,
            updater: (step)=>({
                    ...step,
                    sourceIcons: sourceIcons
                })
        }));
    };



const $445c0b1f98ced811$export$32f8a965bfa76f84 = ({ messageId: messageId, stepId: stepId, sources: sources })=>({ dispatch: dispatch })=>{
        dispatch((0, $37a7a07adcd579ae$export$b9dd42b4e24f01b4)({
            messageId: messageId,
            stepId: stepId,
            updater: (step)=>({
                    ...step,
                    sources: sources
                })
        }));
    };



const $37e6411255737e57$export$f6ef21396b0d3d6d = ({ messageId: messageId, stepId: stepId, title: title, roundId: roundId, immediate: immediate, isSkill: isSkill = false, toolIcon: toolIcon, toolName: toolName })=>({ dispatch: dispatch })=>{
        dispatch((0, $37a7a07adcd579ae$export$b9dd42b4e24f01b4)({
            messageId: messageId,
            stepId: stepId,
            updater: (step)=>({
                    ...step,
                    title: title,
                    roundId: roundId,
                    isSkill: isSkill,
                    immediate: immediate,
                    completed: false,
                    toolIcon: toolIcon,
                    toolName: toolName
                })
        }));
    };




const $a88caf8a3c6dcb78$export$6f57813fe9f31bf9 = (0, $8s9DV.createStore)({
    initialState: {},
    actions: {
        resetHasReceivedAnswerPart: ({ messageId: messageId })=>({ dispatch: dispatch })=>{
                dispatch((0, $0fd66ab30ab57c5a$export$8f77fbc4cfe15534)({
                    messageId: messageId
                }));
            },
        addImplicitResearchPlan: ({ messageId: messageId, content: content, roundId: roundId })=>({ dispatch: dispatch })=>{
                dispatch((0, $a874628146faf38d$export$fd530ec9d7995e3e)({
                    messageId: messageId
                }));
                dispatch((0, $80497cf038e22e03$export$62617f3d98f45616)({
                    messageId: messageId,
                    content: content,
                    title: 'Research Plan',
                    roundId: roundId
                }));
            },
        processStreamResearch: ({ messageId: messageId, streamMessage: streamMessage, isDeepResearch: isDeepResearch = false })=>({ dispatch: dispatch, getState: getState })=>{
                // Check if this is a THINK_DEEPER_TRIGGERED trace
                if ((0, $bxkJA.isStreamThinkDeeperTriggered)(streamMessage)) dispatch((0, $06f681cd30867526$export$5cf35e65df857124)({
                    messageId: messageId,
                    triggered: true
                }));
                if ((0, $bxkJA.isStreamResearchPlan)(streamMessage)) {
                    dispatch((0, $a874628146faf38d$export$fd530ec9d7995e3e)({
                        messageId: messageId
                    }));
                    dispatch((0, $80497cf038e22e03$export$62617f3d98f45616)({
                        messageId: messageId,
                        content: streamMessage.message.content,
                        title: 'Research Plan',
                        roundId: streamMessage.message.roundId
                    }));
                }
                if ((0, $bxkJA.isStreamAnswerPart)(streamMessage)) dispatch((0, $af1e39fe228c220f$export$6514c23d684eadd8)({
                    messageId: messageId
                }));
                if ((0, $bxkJA.isStreamResearchBeginningTrace)(streamMessage)) dispatch((0, $a874628146faf38d$export$fd530ec9d7995e3e)({
                    messageId: messageId
                }));
                if ((0, $bxkJA.isStreamResearchStepContent)(streamMessage) || (0, $bxkJA.isStreamReasoningPart)(streamMessage)) {
                    const { stepId: stepId, content: content } = streamMessage.message;
                    const roundId = (0, $bxkJA.isStreamResearchStepContent)(streamMessage) ? streamMessage.message.roundId : getState()[messageId]?.steps[stepId]?.roundId ?? 0;
                    // append the stream chunk content to the correct step data
                    dispatch((0, $52c6649b0e0b7a84$export$a55635553828f889)({
                        messageId: messageId,
                        stepId: stepId,
                        roundId: Number(roundId),
                        isStreamed: (0, $bxkJA.isStreamReasoningPart)(streamMessage),
                        // Show reasoning parts steps (e.g. "Creating a plan") immediately
                        // to avoid artificial delays in UI from queued step logic
                        immediate: (0, $bxkJA.isStreamReasoningPart)(streamMessage),
                        content: content
                    }));
                }
                if ((0, $bxkJA.isStreamResearchStepTitle)(streamMessage) || (0, $bxkJA.isStreamResearchStepTitleShort)(streamMessage)) {
                    const { roundId: roundId, stepId: stepId, title: title, toolIcon: toolIcon, toolName: toolName } = streamMessage.message;
                    dispatch((0, $37e6411255737e57$export$f6ef21396b0d3d6d)({
                        messageId: messageId,
                        stepId: stepId,
                        title: title,
                        roundId: Number(roundId),
                        immediate: false,
                        toolIcon: toolIcon,
                        toolName: toolName
                    }));
                }
                if ((0, $bxkJA.isStreamSkillStart)(streamMessage)) {
                    const { skill_status_metadata: skill_status_metadata } = streamMessage.message;
                    dispatch((0, $37e6411255737e57$export$f6ef21396b0d3d6d)({
                        messageId: messageId,
                        // random UUID since skills do not send stepIds, this should not matter for the step title
                        stepId: '68df4a4e-a42b-4d77-851f-6ac5d91bf38a',
                        title: skill_status_metadata?.aliases?.[0],
                        roundId: 0,
                        immediate: true,
                        isSkill: true
                    }));
                }
                if ((0, $bxkJA.isStreamSkillEnd)(streamMessage)) dispatch((0, $37a7a07adcd579ae$export$b9dd42b4e24f01b4)({
                    messageId: messageId,
                    stepId: '12345',
                    updater: (step)=>({
                            ...step,
                            completed: true
                        })
                }));
                if ((0, $bxkJA.isStreamResearchStepSource)(streamMessage)) {
                    const { message: { sources: sources, stepId: stepId } } = streamMessage;
                    dispatch((0, $445c0b1f98ced811$export$32f8a965bfa76f84)({
                        messageId: messageId,
                        stepId: stepId,
                        sources: sources
                    }));
                }
                if ((0, $bxkJA.isStreamResearchStepIcons)(streamMessage)) {
                    const { products: products, stepId: stepId } = streamMessage.message;
                    const ICON_BASE_URL = '/gateway/api/assist/rovo/v1/resources/icon/';
                    dispatch((0, $8d246a514926505b$export$b9aadbf5032a78e5)({
                        messageId: messageId,
                        stepId: stepId,
                        // Backend returns short names like "jira" — prepend the full gateway path.
                        // If the path already starts with "/" or is a data URI, use it as-is.
                        sourceIcons: products.map((product)=>product.startsWith('/') || product.startsWith('data:') ? product : `${ICON_BASE_URL}${product}`)
                    }));
                }
                if ((0, $bxkJA.isStreamResearchStepDocument)(streamMessage)) {
                    const { title: title, url: url, product: product, toolName: toolName, stepId: stepId } = streamMessage.message;
                    dispatch((0, $c0ef94996608e7a5$export$7d99c23b07ac0974)({
                        messageId: messageId,
                        stepId: stepId,
                        document: {
                            stepId: stepId,
                            title: title,
                            url: url,
                            product: product,
                            toolName: toolName
                        }
                    }));
                }
                if ((0, $bxkJA.isStreamResearchStepCompleted)(streamMessage)) {
                    const { stepId: stepId } = streamMessage.message;
                    dispatch((0, $37a7a07adcd579ae$export$b9dd42b4e24f01b4)({
                        messageId: messageId,
                        stepId: stepId,
                        updater: (step)=>({
                                ...step,
                                completed: true
                            })
                    }));
                }
                // Fail safe to complete all steps so the UI doesn't appear incomplete if there are missing chunks in the payload
                if ((0, $bxkJA.isStreamResponse)(streamMessage)) dispatch((0, $6a418f740b9b0640$export$2e0130e7f5800320)({
                    messageId: messageId
                }));
                if (isDeepResearch) dispatch((0, $5ff0c09ec43395a4$export$d035a949bdd52aff)({
                    messageId: messageId
                }));
            },
        updateResearchMessageId: ({ messageId: messageId, newMessageId: newMessageId })=>({ getState: getState, setState: setState })=>{
                setState({
                    ...getState(),
                    [newMessageId]: getState()[messageId],
                    [messageId]: undefined
                });
            },
        incrementProgressArtificially: ({ messageId: messageId })=>({ getState: getState, setState: setState })=>{
                const currentState = getState();
                const currentMessage = currentState[messageId];
                setState({
                    ...currentState,
                    [messageId]: {
                        ...currentMessage,
                        currentProgress: (0, $bc7bf914d1a438d1$export$4c442435645f2043)(currentMessage?.currentProgress ?? (0, $0ae2e85c06c407f6$export$d4032e5b8e7b1dac), (0, $627ddeb671c41e26$export$872f148557cf8bf5))
                    }
                });
            },
        markIncompleteResearchesErrored: ({ messageId: messageId })=>({ getState: getState, setState: setState })=>{
                const currentState = getState();
                const message = currentState[messageId];
                if (message && (message.currentProgress ?? 0) > 0 && !message.researchCompleted && !message.errored) setState({
                    ...currentState,
                    [messageId]: {
                        ...message,
                        errored: true
                    }
                });
            },
        completeAllSteps: ({ messageId: messageId })=>({ dispatch: dispatch })=>{
                dispatch((0, $6a418f740b9b0640$export$2e0130e7f5800320)({
                    messageId: messageId
                }));
            },
        getMessageResearchById: ({ messageId: messageId })=>({ getState: getState })=>{
                return getState()[messageId];
            },
        /**
     * Clears all research data for a specific message.
     * Used when Answer Now is triggered to reset the research state.
     */ clearMessageResearch: ({ messageId: messageId })=>({ getState: getState, setState: setState })=>{
                const currentState = getState();
                const { [messageId]: _, ...rest } = currentState;
                setState({
                    [messageId]: undefined,
                    ...rest
                });
            }
    }
});
module.exports["store"] = $a88caf8a3c6dcb78$export$6f57813fe9f31bf9;

});

parcelRegister("iDdTC", function(module, exports) {

var $9aI7t = parcelRequire("9aI7t");


var $b5593 = parcelRequire("b5593");


var $b90aI = parcelRequire("b90aI");


var $1Ht4b = parcelRequire("1Ht4b");


var $aaEQD = parcelRequire("aaEQD");

const $ffb05ca8baf9d9e1$export$b0c5c2fac8144e54 = {
    pageLoad: $1Ht4b.pageLoad,
    pageSegmentLoad: $aaEQD.pageSegmentLoad,
    interaction: $b90aI.interaction,
    custom: $b5593.custom,
    concurrent: $9aI7t.concurrent
};
module.exports["metrics"] = $ffb05ca8baf9d9e1$export$b0c5c2fac8144e54;

});

parcelRegister("9aI7t", function(module, exports) {

var $lCTbz = parcelRequire("lCTbz");


var $b5593 = parcelRequire("b5593");


var $b90aI = parcelRequire("b90aI");

const $95763ae236d73d99$var$concurrentMetrics = {};
const $95763ae236d73d99$var$getKey = (config, type)=>`${type}--${config.key}`;
const $95763ae236d73d99$var$validateConfig = (config)=>{
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
const $95763ae236d73d99$var$ensurePath = (config, type)=>{
    const key = $95763ae236d73d99$var$getKey(config, type);
    if (!(key in $95763ae236d73d99$var$concurrentMetrics)) $95763ae236d73d99$var$concurrentMetrics[key] = {};
};
const $95763ae236d73d99$var$getMetricFromCache = (concurrentId, config, type)=>{
    const concurrentKey = $95763ae236d73d99$var$getKey(config, type);
    if (concurrentKey in $95763ae236d73d99$var$concurrentMetrics && $95763ae236d73d99$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $95763ae236d73d99$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $95763ae236d73d99$var$concurrentMetrics)) $95763ae236d73d99$var$concurrentMetrics[concurrentKey] = {};
    return;
};
const $95763ae236d73d99$var$makeConcurrentMetric = (concurrentId, config, type)=>{
    $95763ae236d73d99$var$validateConfig(config);
    $95763ae236d73d99$var$ensurePath(config, type);
    const metricFromCache = $95763ae236d73d99$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    const metricFactory = type === (0, $lCTbz.BMEventsType).INLINE_RESULT ? (0, $b90aI.interaction) : (0, $b5593.custom);
    const metric = metricFactory(config);
    $95763ae236d73d99$var$concurrentMetrics[$95763ae236d73d99$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
const $95763ae236d73d99$export$370df09ecc3de059 = {
    pageSegmentLoad: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).PAGE_SEGMENT_LOAD),
    interaction: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).INLINE_RESULT),
    custom: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).CUSTOM)
};
module.exports["concurrent"] = $95763ae236d73d99$export$370df09ecc3de059;

});

parcelRegister("b5593", function(module, exports) {

var $ipFlS = parcelRequire("ipFlS");


var $lCTbz = parcelRequire("lCTbz");

const $39f57926a8ef795b$export$4c00f665f0d4b443 = (config)=>{
    return new (0, $ipFlS.Metric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).CUSTOM
    });
};
module.exports["custom"] = $39f57926a8ef795b$export$4c00f665f0d4b443;

});

parcelRegister("ipFlS", function(module, exports) {

var $hvVQt = parcelRequire("hvVQt");


var $581yf = parcelRequire("581yf");


var $7IphZ = parcelRequire("7IphZ");

class $4db3d4178d03c3ea$export$efdd3e096bc27746 extends (0, $7IphZ.BaseMetric) {
    start({ startTime: startTime } = {}) {
        super.start({
            startTime: startTime
        });
        this.route = (0, $hvVQt.Route).getRoute();
    }
    stop(params = {}) {
        const stoppedSuccessfully = super.stop(params);
        if (stoppedSuccessfully && !this.config.virtual) (0, $581yf.submitter).queue(this.getData());
        return stoppedSuccessfully;
    }
}
module.exports["Metric"] = $4db3d4178d03c3ea$export$efdd3e096bc27746;

});

parcelRegister("b90aI", function(module, exports) {

var $ipFlS = parcelRequire("ipFlS");


var $lCTbz = parcelRequire("lCTbz");

const $060787d14b6a30d6$export$92473e6020ad89b4 = (config)=>{
    return new (0, $ipFlS.Metric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).INLINE_RESULT
    });
};
module.exports["interaction"] = $060787d14b6a30d6$export$92473e6020ad89b4;

});

parcelRegister("1Ht4b", function(module, exports) {

var $3L5Pu = parcelRequire("3L5Pu");


var $lCTbz = parcelRequire("lCTbz");

const $a55ff36d094d83ef$export$791d520f7e8058a5 = (config)=>{
    return new (0, $3L5Pu.PageLoadMetric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).PAGE_LOAD
    });
};
module.exports["pageLoad"] = $a55ff36d094d83ef$export$791d520f7e8058a5;

});

parcelRegister("3L5Pu", function(module, exports) {

var $97AWA = parcelRequire("97AWA");


var $jk8rA = parcelRequire("jk8rA");


var $hvVQt = parcelRequire("hvVQt");


var $581yf = parcelRequire("581yf");


var $lCTbz = parcelRequire("lCTbz");


var $2QFOI = parcelRequire("2QFOI");


var $wgCbG = parcelRequire("wgCbG");


var $eNslE = parcelRequire("eNslE");

class $bbca0ae0eaeecc15$export$3c51073271a9eac3 extends (0, $2QFOI.BasePageLoadMetric) {
    startPageLoad(params = {
        isInitial: false
    }) {
        (0, $wgCbG.pageLoadMetaMetric).startPageLoad({
            ...params,
            cancelStarted: 'startTime' in params
        });
        this.watchUntil();
    }
    stop(params = {}) {
        const stopTime = params.stopTime || window.performance.now();
        const pageLoadData = (0, $wgCbG.pageLoadMetaMetric).getDataToMerge();
        const metaMetricStopped = (0, $wgCbG.pageLoadMetaMetric).stop(params);
        if (!metaMetricStopped) return false;
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[(0, $2QFOI.BasePageLoadMetric).FMP]) {
                const mark = (0, $97AWA.SSRGetDoneMark).getDoneMark();
                if (mark) (0, $wgCbG.pageLoadMetaMetric).markFMP(mark);
            } else (0, $wgCbG.pageLoadMetaMetric).markFMP(this.marks[(0, $2QFOI.BasePageLoadMetric).FMP]);
        }
        this.route = (0, $hvVQt.Route).getRoute();
        const metricStopped = this.stopPageLoad(pageLoadData, {
            ...params,
            stopTime: stopTime
        });
        if (!metricStopped) return false;
        const data = this.getData();
        if (!this.config.virtual) (0, $581yf.submitter).queue(data);
        (0, $jk8rA.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
        this.enqueueWebVitals();
        return true;
    }
    mark(mark, timestamp = window.performance.now()) {
        (0, $wgCbG.pageLoadMetaMetric).mark(mark, timestamp);
    }
    markFMP(timestamp) {
        (0, $wgCbG.pageLoadMetaMetric).markFMP(timestamp);
    }
    getData() {
        const pageLoadMetaData = (0, $wgCbG.pageLoadMetaMetric).getData();
        return {
            ...super.getData(),
            // marks and explicitTimings are available only in pageLoadMeta
            marks: pageLoadMetaData.marks,
            explicitTimings: pageLoadMetaData.explicitTimings
        };
    }
    async enqueueWebVitals() {
        if (this.config.virtual || !this.isInitial) return false;
        const configChunk = await (0, $581yf.submitter).config.configChunk;
        if (!configChunk?.[(0, $lCTbz.BMEventsType).WEB_VITALS].webVitals?.enabled) return false;
        const webVitalMetric = new (0, $eNslE.WebVitalsMetric)({
            key: this.config.key,
            route: this.route,
            startTime: this.startTime,
            stopTime: this.stopTime,
            pageVisibleState: this.pageVisibleState
        });
        (0, $581yf.submitter).queue(webVitalMetric.getData());
        (0, $jk8rA.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
        return true;
    }
}
module.exports["PageLoadMetric"] = $bbca0ae0eaeecc15$export$3c51073271a9eac3;

});

parcelRegister("eNslE", function(module, exports) {

var $lCTbz = parcelRequire("lCTbz");


var $7IphZ = parcelRequire("7IphZ");

class $23d0f6650a8bd5e3$export$dc0d85d4d6503cd7 extends (0, $7IphZ.BaseMetric) {
    constructor({ key: key, route: route, startTime: startTime, stopTime: stopTime, pageVisibleState: pageVisibleState }){
        super({
            type: (0, $lCTbz.BMEventsType).WEB_VITALS,
            key: key
        });
        this.route = route;
        this.startTime = startTime;
        this.stopTime = stopTime;
        this.state = (0, $7IphZ.MetricState).FINISHED;
        this.pageVisibleState = pageVisibleState;
    }
}
module.exports["WebVitalsMetric"] = $23d0f6650a8bd5e3$export$dc0d85d4d6503cd7;

});

parcelRegister("aaEQD", function(module, exports) {

var $h51B5 = parcelRequire("h51B5");


var $lCTbz = parcelRequire("lCTbz");

const $2eb5124fdb2b6158$export$94114666844d5f66 = (config)=>{
    return new (0, $h51B5.PageSegmentLoadMetric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).PAGE_SEGMENT_LOAD
    });
};
module.exports["pageSegmentLoad"] = $2eb5124fdb2b6158$export$94114666844d5f66;

});

parcelRegister("h51B5", function(module, exports) {

var $97AWA = parcelRequire("97AWA");


var $lCTbz = parcelRequire("lCTbz");


var $7IphZ = parcelRequire("7IphZ");


var $ipFlS = parcelRequire("ipFlS");


var $wgCbG = parcelRequire("wgCbG");

class $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1 extends (0, $ipFlS.Metric) {
    startFromPageLoad() {
        const pageLoadMetaData = (0, $wgCbG.pageLoadMetaMetric).getData();
        this.start({
            startTime: pageLoadMetaData.start ?? undefined
        });
        this.isInitial = pageLoadMetaData.isInitial;
        this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP) return;
        super.mark(mark, timestamp);
    }
    markFMP(timestamp) {
        super.mark($0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP, timestamp);
    }
    getPageSegmentLoadData() {
        return {
            isInitial: this.isInitial
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageSegmentLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageSegmentLoadData()
        };
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
    }
    stop(params = {}) {
        const pageLoadData = (0, $wgCbG.pageLoadMetaMetric).getData();
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[$0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP]) {
                const mark = (0, $97AWA.SSRGetDoneMark).getDoneMark();
                if (mark) this.markFMP(mark);
            }
        }
        if (this.config.includePageLoadTimings !== (0, $lCTbz.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $7IphZ.MetricState).FINISHED) return super.stop(params);
        const now = performance.now();
        if (pageLoadData.state === (0, $7IphZ.MetricState).STARTED) (0, $wgCbG.pageLoadMetaMetric).onStop(()=>{
            super.stop({
                ...params,
                stopTime: params.stopTime || now
            });
        }, ()=>{
            this.cancel();
        });
        return true;
    }
    constructor(config){
        super(config);
        this.isInitial = true;
        this.config = void 0;
        this.config = config;
    }
}
$0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP = 'fmp';
module.exports["PageSegmentLoadMetric"] = $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1;

});

parcelRegister("cRubi", function(module, exports) {
/**
 * Module registry so Conversation Assistant (which owns chat-context bridge wiring)
 * can publish a canonical context provider for Enterprise HER without React tree coupling.
 */ let $8478e96dfac09728$var$registeredProvider = null;
function $8478e96dfac09728$export$4f41b66184515f3(provider) {
    $8478e96dfac09728$var$registeredProvider = provider;
}
function $8478e96dfac09728$export$53df788b6a579ad7() {
    return $8478e96dfac09728$var$registeredProvider;
}
module.exports["setRovoChatContextProvider"] = $8478e96dfac09728$export$4f41b66184515f3;
module.exports["getRovoChatContextProvider"] = $8478e96dfac09728$export$53df788b6a579ad7;

});

parcelRegister("O96nq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $5c06eb0f3ede4a6c$export$ba3e2fddf5af0178 = (0, $cozmU.createContext)(null);
module.exports["ViewDeadAirContext"] = $5c06eb0f3ede4a6c$export$ba3e2fddf5af0178;

});

parcelRegister("dqxOF", function(module, exports) {
function $9c67ef4150ae4cb3$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $9c67ef4150ae4cb3$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $9c67ef4150ae4cb3$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $9c67ef4150ae4cb3$export$967a6b9924a689f7(a, b);
    return $9c67ef4150ae4cb3$export$3e67810a3f0e9f1c(a, b);
}
module.exports["shallowEqualObjects"] = $9c67ef4150ae4cb3$export$3e67810a3f0e9f1c;

});

parcelRegister("jqg1p", function(module, exports) {
const $cd16886f2e0e6e79$export$a89b9c1bf34c03e5 = (current, next)=>{
    if (current === next) return true;
    if (!current || !next || current.length !== next.length) return false;
    return current.every((value, index)=>value === next[index]);
};
module.exports["areStringArraysEqual"] = $cd16886f2e0e6e79$export$a89b9c1bf34c03e5;

});

parcelRegister("jAZYc", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $0165172f0f6448b6$export$8cc6a5423ea2e47d = (value, isEnabled, areEqual)=>{
    const stableValueRef = (0, $cozmU.useRef)(value);
    if (!isEnabled) {
        stableValueRef.current = value;
        return value;
    }
    if (!areEqual(stableValueRef.current, value)) stableValueRef.current = value;
    return stableValueRef.current;
};
module.exports["useSemanticStableValue"] = $0165172f0f6448b6$export$8cc6a5423ea2e47d;

});

parcelRegister("7SkLu", function(module, exports) {

var $E1QOf = parcelRequire("E1QOf");


var $a33Aa = parcelRequire("a33Aa");

function $c60ab42870e33b24$export$f9c6890b323d326b(key, value) {
    const interactionId = (0, $E1QOf.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    (0, $a33Aa.addCohortingCustomData)(currentInteractionId, key, value);
}
module.exports["addUFOCustomCohortData"] = $c60ab42870e33b24$export$f9c6890b323d326b;

});

parcelRegister("hd4Ag", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $9Yqfz = parcelRequire("9Yqfz");


var $eriCt = parcelRequire("eriCt");

const $1f69189ce877419f$export$6fa751d66e55d2e1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const contextValue = (0, $cozmU.useContext)((0, $eriCt.WindowLocationContext));
    const location = (0, $cozmU.useSyncExternalStore)((0, $9Yqfz.subscribeToLocation), (0, $9Yqfz.getLocationSnapshot), (0, $9Yqfz.getLocationServerSnapshot));
    return contextValue ?? location;
} : ()=>{
    const contextValue = (0, $cozmU.useContext)((0, $eriCt.WindowLocationContext));
    const location = (0, $cozmU.useSyncExternalStore)((0, $9Yqfz.subscribeToLocation), (0, $9Yqfz.getLocationSnapshot), (0, $9Yqfz.getLocationServerSnapshot));
    return contextValue ?? location;
};
module.exports["useWindowLocation"] = $1f69189ce877419f$export$6fa751d66e55d2e1;

});

parcelRegister("eriCt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $34391591fc09bf27$export$46133998910543ac = (0, $cozmU.createContext)(null);
module.exports["WindowLocationContext"] = $34391591fc09bf27$export$46133998910543ac;

});

parcelRegister("7Myh3", function(module, exports) {
// Single-source dynamic import factory for the conversation-assistant chunk.
// Mirrors the chunk-name used by the live lazy()/loadable() boundaries so preload
// and the live boundaries share the same chunk identity.

const $9d88e303fe02f351$export$24a887167476720c = ()=>(parcelRequire("83rWL"));
module.exports["importConversationAssistant"] = $9d88e303fe02f351$export$24a887167476720c;

});

parcelRegister("83rWL", function(module, exports) {

let $5dd44833aa22fc62$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5dd44833aa22fc62$var$load("c6SfL"),
    $5dd44833aa22fc62$var$load("4Hcen"),
    $5dd44833aa22fc62$var$load("f4Nog"),
    $5dd44833aa22fc62$var$load("6wr18"),
    $5dd44833aa22fc62$var$load("aXAgf"),
    $5dd44833aa22fc62$var$load("9opi8"),
    $5dd44833aa22fc62$var$load("ffEVr"),
    $5dd44833aa22fc62$var$load("Wowvf"),
    $5dd44833aa22fc62$var$load("6vqGz"),
    $5dd44833aa22fc62$var$load("gw4CZ"),
    $5dd44833aa22fc62$var$load("d1Ddn"),
    $5dd44833aa22fc62$var$load("hhss7"),
    $5dd44833aa22fc62$var$load("7EorR"),
    $5dd44833aa22fc62$var$load("ce05o")
]).then(()=>parcelRequire('iuVKP'));

});

parcelRegister("ir4h8", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $ac2J9 = parcelRequire("ac2J9");

const $abc73c6f5c74c436$export$6d558eab13290f59 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
} : ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
module.exports["useRouterLink"] = $abc73c6f5c74c436$export$6d558eab13290f59;

});

parcelRegister("ac2J9", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $b797161b98bd0492$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $cozmU.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $b797161b98bd0492$var$RouterLinkProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { routerLinkComponent: routerLinkComponent, children: children } = t0;
    let t1;
    if ($[0] !== routerLinkComponent) {
        t1 = {
            routerLinkComponent: routerLinkComponent
        };
        $[0] = routerLinkComponent;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
            value: t1,
            children: children
        });
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b797161b98bd0492$export$2e2bcd8739ae039 = $b797161b98bd0492$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $b797161b98bd0492$export$2931e0ee690eee88;

});

parcelRegister("jPzTX", function(module, exports) {

var $lyW2B = parcelRequire("lyW2B");


var $e7pPJ = parcelRequire("e7pPJ");


var $d246i = parcelRequire("d246i");

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $e6fea10dbb684687$var$flatRest(func) {
    return $d246i($e7pPJ(func, undefined, $lyW2B), func + '');
}
module.exports = $e6fea10dbb684687$var$flatRest;

});

parcelRegister("lyW2B", function(module, exports) {

var $avFJ9 = parcelRequire("avFJ9");

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $fb29cba7dcd09042$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $avFJ9(array, 1) : [];
}
module.exports = $fb29cba7dcd09042$var$flatten;

});

parcelRegister("avFJ9", function(module, exports) {

var $8kPaX = parcelRequire("8kPaX");


var $eED1E = parcelRequire("eED1E");

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $7a6d2ac83094702e$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $eED1E);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $7a6d2ac83094702e$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $8kPaX(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $7a6d2ac83094702e$var$baseFlatten;

});

parcelRegister("eED1E", function(module, exports) {

var $2v1OR = parcelRequire("2v1OR");


var $bZ5J1 = parcelRequire("bZ5J1");


var $1ScXu = parcelRequire("1ScXu");

/** Built-in value references. */ var $aab312c604d1130a$var$spreadableSymbol = $2v1OR ? $2v1OR.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $aab312c604d1130a$var$isFlattenable(value) {
    return $1ScXu(value) || $bZ5J1(value) || !!($aab312c604d1130a$var$spreadableSymbol && value && value[$aab312c604d1130a$var$spreadableSymbol]);
}
module.exports = $aab312c604d1130a$var$isFlattenable;

});

parcelRegister("as9lu", function(module, exports) {

var $aQ0yV = parcelRequire("aQ0yV");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/identity/user/manifest.ts
var $79c3c4c484846d28$var$identityUserAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $aQ0yV.IdentityUserAriResourceOwner),
    resourceType: (0, $aQ0yV.IdentityUserAriResourceType),
    resourceIdSlug: "{userId}",
    resourceIdSegmentFormats: {
        userId: /[a-zA-Z0-9_\-\:]{1,128}/
    }
};
// src/identity/user/index.ts
var $79c3c4c484846d28$export$1e9d09c2be53e55e = class _IdentityUserAri extends (0, $1gKSA.RegisteredAri) {
    get userId() {
        return this._userId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $79c3c4c484846d28$var$identityUserAriStaticOpts.qualifier,
            platformQualifier: $79c3c4c484846d28$var$identityUserAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $79c3c4c484846d28$var$identityUserAriStaticOpts.resourceOwner,
            resourceType: $79c3c4c484846d28$var$identityUserAriStaticOpts.resourceType,
            resourceId: `${opts.userId}`,
            resourceIdSegmentValues: {
                userId: opts.userId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $79c3c4c484846d28$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $79c3c4c484846d28$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(opts);
    }
    getVariables() {
        return {
            userId: this.userId
        };
    }
    constructor(opts){
        super(opts), this._userId = opts.resourceIdSegmentValues.userId;
    }
};
module.exports["IdentityUserAri"] = $79c3c4c484846d28$export$1e9d09c2be53e55e;

});

parcelRegister("aQ0yV", function(module, exports) {
// src/identity/user/types.ts
var $7e3f325f95b56bab$export$b4c14c54282a779d = "identity", $7e3f325f95b56bab$export$e9b50e20f4fbfb71 = "user";
module.exports["IdentityUserAriResourceOwner"] = $7e3f325f95b56bab$export$b4c14c54282a779d;
module.exports["IdentityUserAriResourceType"] = $7e3f325f95b56bab$export$e9b50e20f4fbfb71;

});

parcelRegister("89CKS", function(module, exports) {
/**
 * @generated SignedSource<<29d02a00238e986613f78bcab9812352>>
 * @relayHash 1c39b72e16854d19d11c51ceef0122b1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 57a186e10000ef184bec3a0e71a8dec9c1b57a66702d145178c98368d5d78434
const $76fac522acc3b282$var$node = function() {
    var v0 = [
        {
            "concreteType": "Entitlements",
            "kind": "LinkedField",
            "name": "entitlements",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ExternalCollaboratorFeature",
                    "kind": "LinkedField",
                    "name": "externalCollaborator",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEntitled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "fetchMentionsProviderDataQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "fetchMentionsProviderDataQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "1c39b72e16854d19d11c51ceef0122b1",
            "id": "57a186e10000ef184bec3a0e71a8dec9c1b57a66702d145178c98368d5d78434",
            "metadata": {},
            "name": "fetchMentionsProviderDataQuery",
            "operationKind": "query",
            "text": "query fetchMentionsProviderDataQuery{entitlements{externalCollaborator{isEntitled}}}"
        }
    };
}();
$76fac522acc3b282$var$node.hash = "97f5ab279ca8162d7d39b760a9aa8808";
var $76fac522acc3b282$export$2e2bcd8739ae039 = $76fac522acc3b282$var$node;
module.exports["default"] = $76fac522acc3b282$export$2e2bcd8739ae039;

});

parcelRegister("iKWdo", function(module, exports) {

var $j6gAQ = parcelRequire("j6gAQ");


var $1Rned = parcelRequire("1Rned");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $da79ae2b1521df52$var$uniqBy(array, iteratee) {
    return array && array.length ? $1Rned(array, $j6gAQ(iteratee, 2)) : [];
}
module.exports = $da79ae2b1521df52$var$uniqBy;

});

parcelRegister("1Rned", function(module, exports) {

var $dLza3 = parcelRequire("dLza3");


var $gqaVn = parcelRequire("gqaVn");


var $3wyDU = parcelRequire("3wyDU");


var $jG16D = parcelRequire("jG16D");


var $4sYWJ = parcelRequire("4sYWJ");


var $j8WYy = parcelRequire("j8WYy");

/** Used as the size to enable large array optimizations. */ var $15acc2503c30cdc7$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $15acc2503c30cdc7$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $gqaVn, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $3wyDU;
    } else if (length >= $15acc2503c30cdc7$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $4sYWJ(array);
        if (set) return $j8WYy(set);
        isCommon = false;
        includes = $jG16D;
        seen = new $dLza3;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $15acc2503c30cdc7$var$baseUniq;

});

parcelRegister("gqaVn", function(module, exports) {

var $62lK8 = parcelRequire("62lK8");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $bf478c6b28a93eba$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $62lK8(array, value, 0) > -1;
}
module.exports = $bf478c6b28a93eba$var$arrayIncludes;

});

parcelRegister("62lK8", function(module, exports) {

var $7jN2X = parcelRequire("7jN2X");


var $4Jcz7 = parcelRequire("4Jcz7");


var $jMyMb = parcelRequire("jMyMb");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $4653cbb84a510850$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $jMyMb(array, value, fromIndex) : $7jN2X(array, $4Jcz7, fromIndex);
}
module.exports = $4653cbb84a510850$var$baseIndexOf;

});

parcelRegister("7jN2X", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $55405a69ad8b093d$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $55405a69ad8b093d$var$baseFindIndex;

});

parcelRegister("4Jcz7", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $37151c9a2b945fe4$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $37151c9a2b945fe4$var$baseIsNaN;

});

parcelRegister("jMyMb", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $e66d79db7455d8ea$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $e66d79db7455d8ea$var$strictIndexOf;

});

parcelRegister("3wyDU", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $290f3b94ccd981c7$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $290f3b94ccd981c7$var$arrayIncludesWith;

});

parcelRegister("4sYWJ", function(module, exports) {

var $lE8ES = parcelRequire("lE8ES");


var $jEK83 = parcelRequire("jEK83");


var $j8WYy = parcelRequire("j8WYy");

/** Used as references for various `Number` constants. */ var $34090d9ff4ab3dd6$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $34090d9ff4ab3dd6$var$createSet = !($lE8ES && 1 / $j8WYy(new $lE8ES([
    ,
    -0
]))[1] == $34090d9ff4ab3dd6$var$INFINITY) ? $jEK83 : function(values) {
    return new $lE8ES(values);
};
module.exports = $34090d9ff4ab3dd6$var$createSet;

});

parcelRegister("jEK83", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $e4f588fe3a77f67d$var$noop() {
// No operation performed.
}
module.exports = $e4f588fe3a77f67d$var$noop;

});

parcelRegister("gtQgC", function(module, exports) {

var $62APY = parcelRequire("62APY");

const $1665c8ad23657fd1$var$getStudioHost = (env)=>env === 'staging' ? (0, $62APY.STUDIO_STAGING_URL) : (0, $62APY.STUDIO_PROD_URL);
const $1665c8ad23657fd1$export$b4a3ce4b99911063 = (env, path, email)=>{
    const studioHost = $1665c8ad23657fd1$var$getStudioHost(env);
    const normalizedPath = path ? path.startsWith('/') ? path : `/${path}` : '';
    const destination = `${studioHost}${normalizedPath}`;
    if (!email) return destination;
    // Merge login_hint into any existing query string.
    const url = new URL(destination);
    url.searchParams.set('login_hint', email);
    return url.toString();
};
module.exports["getStudioSessionSyncUrl"] = $1665c8ad23657fd1$export$b4a3ce4b99911063;

});

parcelRegister("62APY", function(module, exports) {
const $e6043006edffc91a$export$83a42cd6c4b5f72d = 'https://studio.atlassian.com';
const $e6043006edffc91a$export$1b2ea4d616a1810d = 'https://studio.stg.atlassian.com';
module.exports["STUDIO_PROD_URL"] = $e6043006edffc91a$export$83a42cd6c4b5f72d;
module.exports["STUDIO_STAGING_URL"] = $e6043006edffc91a$export$1b2ea4d616a1810d;

});

parcelRegister("go7uG", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $8f99a430e8355353$export$74e304339778e94d = (0, $kSwu1.defineMessages)({
    copyCodeToClipboard: {
        id: "fabric.editor.codeBlockCopyButton.copyToClipboard",
        defaultMessage: "Copy as text"
    },
    copiedCodeToClipboard: {
        id: "fabric.editor.codeBlockCopyButton.copiedToClipboard",
        defaultMessage: "Copied!"
    },
    // Remove wrapCode/unwrapCode and use wrapCodeLabel/unwrapCodeLabel
    // when cleaning up platform_editor_code_block_q4_lovability.
    wrapCode: {
        id: "fabric.editor.codeBlockWrapButton.wrapCodeBlock",
        defaultMessage: "Turn on wrap"
    },
    unwrapCode: {
        id: "fabric.editor.codeBlockWrapButton.unwrapCodeBlock",
        defaultMessage: "Turn off wrap"
    },
    wrapCodeLabel: {
        id: "fabric.editor.codeBlockWrapButton.wrapCode",
        defaultMessage: "Wrap code"
    },
    unwrapCodeLabel: {
        id: "fabric.editor.codeBlockWrapButton.unwrapCode",
        defaultMessage: "Unwrap code"
    },
    showLineNumbersLabel: {
        id: "fabric.editor.codeBlockLineNumbersButton.showLineNumbers",
        defaultMessage: "Show line numbers"
    },
    hideLineNumbersLabel: {
        id: "fabric.editor.codeBlockLineNumbersButton.hideLineNumbers",
        defaultMessage: "Hide line numbers"
    },
    formatCode: {
        id: "fabric.editor.codeBlockFormatButton.formatCode",
        defaultMessage: "Format code"
    },
    formatCodeUnavailable: {
        id: "fabric.editor.codeBlockFormatButton.formatCodeUnavailable",
        defaultMessage: "Formatting not available for this language"
    },
    formatCodeFailed: {
        id: "fabric.editor.codeBlockFormatButton.formatCodeFailed",
        defaultMessage: "Code formatting failed"
    },
    formatCodeFailedDescription: {
        id: "fabric.editor.codeBlockFormatButton.formatCodeFailedDescription",
        defaultMessage: "Review the content or change the selected language."
    },
    formatCodeFailedAutoDetectedDescription: {
        id: "fabric.editor.codeBlockFormatButton.formatCodeFailedAutoDetectedDescription",
        defaultMessage: "Review the content or select a specific language."
    },
    selectLanguage: {
        id: "fabric.editor.selectLanguage",
        defaultMessage: "Select language"
    },
    detectLanguage: {
        id: "fabric.editor.codeBlock.detectLanguage",
        defaultMessage: "Detect language"
    },
    detectedLanguage: {
        id: "fabric.editor.codeBlock.detectedLanguage",
        defaultMessage: "{language} (detected)"
    },
    noneDetected: {
        id: "fabric.editor.codeBlock.noneDetected",
        defaultMessage: "(None detected)"
    },
    recentlyUsed: {
        id: "fabric.editor.codeBlock.recentlyUsed",
        defaultMessage: "Recently used"
    },
    all: {
        id: "fabric.editor.codeBlock.all",
        defaultMessage: "All"
    },
    downloadCodeBlock: {
        id: "fabric.editor.codeBlockDownloadButton.downloadCodeBlock",
        defaultMessage: "Download"
    }
});
module.exports["codeBlockButtonMessages"] = $8f99a430e8355353$export$74e304339778e94d;

});

parcelRegister("1G3WB", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $2zVsi = parcelRequire("2zVsi");

const $dc93231c4629fa01$export$53903226fff06fbb = (featureFlagName, functionTrue, functionFalse)=>(0, $2zVsi.functionWithCondition)(()=>(0, $iDrrr.fg)(featureFlagName), functionTrue, functionFalse);
module.exports["functionWithFG"] = $dc93231c4629fa01$export$53903226fff06fbb;

});

parcelRegister("dDboE", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $6JrSr = parcelRequire("6JrSr");

const $92e077c22efcc597$export$6be90bcb437e928f = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children, postfix: postfix = '', prefix: prefix = '' }, ref)=>{
    const id = `${prefix}${(0, $6JrSr.useId)()}${postfix}`;
    (0, $cozmU.useEffect)(()=>{
        if (!ref) return;
        switch(typeof ref){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error(`Unreachable case for unsupported type of ref "${typeof ref}"`);
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: typeof children === 'function' ? children({
            id: id
        }) : children
    });
});
module.exports["IdProvider"] = $92e077c22efcc597$export$6be90bcb437e928f;

});

parcelRegister("1TlML", function(module, exports) {
function $cc70dd2ba0f00d0d$export$e618dc39ac9ad607(source, target = {}) {
    // initialize with source styles
    const styles = {
        ...source
    };
    // massage in target styles
    Object.keys(target).forEach((keyAsString)=>{
        const key = keyAsString;
        if (source[key]) styles[key] = (rsCss, props)=>{
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
module.exports["mergeStyles"] = $cc70dd2ba0f00d0d$export$e618dc39ac9ad607;

});

parcelRegister("nStJY", function(module, exports) {

var $gO7n9 = parcelRequire("gO7n9");


var $jPzTX = parcelRequire("jPzTX");

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $047c686ddfb588a6$var$pick = $jPzTX(function(object, paths) {
    return object == null ? {} : $gO7n9(object, paths);
});
module.exports = $047c686ddfb588a6$var$pick;

});

parcelRegister("gO7n9", function(module, exports) {

var $3Bix5 = parcelRequire("3Bix5");


var $h7loT = parcelRequire("h7loT");

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $c3c708e20cb40f59$var$basePick(object, paths) {
    return $3Bix5(object, paths, function(value, path) {
        return $h7loT(object, path);
    });
}
module.exports = $c3c708e20cb40f59$var$basePick;

});

parcelRegister("2c3Eq", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $arQY7 = parcelRequire("arQY7");


var $7zsi1 = parcelRequire("7zsi1");


var $iDrrr = parcelRequire("iDrrr");


var $3VIRc = parcelRequire("3VIRc");

const $402d6e8638203e24$export$ebe0b8fe8b6acbfd = "var(--ds-icon-inverse, #FFFFFF)";
const $402d6e8638203e24$export$72502e51aebdd94e = "var(--ds-icon-subtle, #505258)";
const $402d6e8638203e24$var$TeamAvatar = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TeamAvatar(t0) {
    const $ = (0, $bDgLe.c)(31);
    let props;
    let src;
    let t1;
    let t2;
    let t3;
    let testId;
    if ($[0] !== t0) {
        ({ testId: testId, src: src, size: t1, teamId: t2, compact: t3, ...props } = t0);
        $[0] = t0;
        $[1] = props;
        $[2] = src;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = testId;
    } else {
        props = $[1];
        src = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        testId = $[6];
    }
    const size = t1 === undefined ? "medium" : t1;
    let teamId = t2 === undefined ? "" : t2;
    const compact = t3 === undefined ? false : t3;
    let t4;
    if ($[7] !== teamId) {
        t4 = teamId.replace("ari:cloud:identity::team/", "");
        $[7] = teamId;
        $[8] = t4;
    } else t4 = $[8];
    teamId = t4;
    if ((0, $iDrrr.fg)("enable_teams_t26_design_drop_core_experiences")) {
        const t5 = `${testId}-team-avatar`;
        let t6;
        if ($[9] !== size || $[10] !== src || $[11] !== teamId || $[12] !== testId) {
            t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7zsi1.AvatarContent), {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3VIRc.TeamAvatarImage), {
                    src: src,
                    size: size,
                    testId: testId,
                    teamId: teamId
                }, teamId)
            });
            $[9] = size;
            $[10] = src;
            $[11] = teamId;
            $[12] = testId;
            $[13] = t6;
        } else t6 = $[13];
        let t7;
        if ($[14] !== props || $[15] !== size || $[16] !== t5 || $[17] !== t6) {
            t7 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {
                ...props,
                appearance: "square",
                size: size,
                testId: t5,
                children: t6
            });
            $[14] = props;
            $[15] = size;
            $[16] = t5;
            $[17] = t6;
            $[18] = t7;
        } else t7 = $[18];
        return t7;
    }
    const t5 = `${testId}-team-avatar`;
    let t6;
    if ($[19] !== compact || $[20] !== size || $[21] !== src || $[22] !== teamId || $[23] !== testId) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3VIRc.TeamAvatarImage), {
            src: src,
            size: size,
            testId: testId,
            teamId: teamId,
            compact: compact
        });
        $[19] = compact;
        $[20] = size;
        $[21] = src;
        $[22] = teamId;
        $[23] = testId;
        $[24] = t6;
    } else t6 = $[24];
    let t7;
    if ($[25] !== props || $[26] !== size || $[27] !== src || $[28] !== t5 || $[29] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {
            appearance: "square",
            ...props,
            size: size,
            src: src,
            testId: t5,
            children: t6
        });
        $[25] = props;
        $[26] = size;
        $[27] = src;
        $[28] = t5;
        $[29] = t6;
        $[30] = t7;
    } else t7 = $[30];
    return t7;
} : function TeamAvatar({ testId: testId, src: src, size: size = 'medium', teamId: teamId = '', compact: compact = false, ...props }) {
    // Strip ARI in case the teamId was given in that format
    teamId = teamId.replace('ari:cloud:identity::team/', '');
    if ((0, $iDrrr.fg)('enable_teams_t26_design_drop_core_experiences')) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {
        ...props,
        appearance: "square",
        size: size,
        testId: `${testId}-team-avatar`,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7zsi1.AvatarContent), {
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3VIRc.TeamAvatarImage), {
                src: src,
                size: size,
                testId: testId,
                teamId: teamId
            }, teamId)
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {
        appearance: "square",
        ...props,
        size: size,
        src: src,
        testId: `${testId}-team-avatar`,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3VIRc.TeamAvatarImage), {
            src: src,
            size: size,
            testId: testId,
            teamId: teamId,
            compact: compact
        })
    });
};
var $402d6e8638203e24$export$2e2bcd8739ae039 = $402d6e8638203e24$var$TeamAvatar;
module.exports["default"] = $402d6e8638203e24$export$2e2bcd8739ae039;

});

parcelRegister("3VIRc", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $giWSb = parcelRequire("giWSb");


var $l5WTV = parcelRequire("l5WTV");


var $5jzbe = parcelRequire("5jzbe");

const $e9b0094c91a8ccec$var$boxShadowCssVar = '--avatar-box-shadow';
const $e9b0094c91a8ccec$var$bgColorCssVar = '--avatar-bg-color'; /**
                                            * We need to maintan the container styles manually until Avatar provides the correct border radius.
                                            * After that we can return to wrapping in <AvatarContent> rather than span
                                            */ 
const $e9b0094c91a8ccec$var$containerStyles = {
    root: "_30huDKYbGa _2xIroY98eZ _497WNwYbGa _2zndICT6kp _4bt5LAnQyn _2WAcuGnQyn _23rrnHiNRm _3iDTPbQ4SZ _1mT5xd5HSx _0hPCNLFlnN _37wbyuDIqT _0aFT5vbt8w _0wOv4QOLYo _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg _1VJPcaeKTE _0EnhYgPgdg _1JM8vv4Jcb _2jfUf9N91d _2WYcYGWVPG _3wEj0XjOvk _0GBAIrJ5bs _43i6GSdnbC _2tbAUcYbGa",
    nonCompactSpacing: "_0rIjykFQfX _43nrzTFQfX _2xTnZxFQfX _0GTcwRFQfX",
    compactSpacing: "_0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg",
    circle: "_0bjKvDaaQb _2Gfj6iaaQb",
    positionRelative: "_1mT5xdRAKS",
    disabled: "_0wOv4Qsyl5 _3wEj0XlfZc _43i6GSVx3j"
};
const $e9b0094c91a8ccec$var$unboundStyles = {
    root: "_24h04iPvdi _0KLXruVZWJ _2OUyjtrcoi",
    interactive: "_0wOv4Q7zJH _0jKh9gMC01 _0ZgYXI7dHp _14Uf36qui9 _0WVYA37dHp _1if2KaHZdu"
};
const $e9b0094c91a8ccec$var$avatarImageStyles = {
    image: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEN91d _3iDTPbQ4SZ _39xV02N91d _0jFU0VN91d"
};
const $e9b0094c91a8ccec$var$SIZES = {
    xxsmall: 16,
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 96,
    xxlarge: 128
};
const $e9b0094c91a8ccec$var$borderRadiusMap = {
    xxsmall: "_0bjKvD0O7w",
    xsmall: "_0bjKvD0O7w",
    small: "_0bjKvD0O7w",
    medium: "_0bjKvD0O7w",
    large: "_0bjKvD0O7w",
    xlarge: "_0bjKvD0O7w",
    xxlarge: "_0bjKvD0O7w"
};
const $e9b0094c91a8ccec$var$widthHeightMap = {
    xxsmall: "_39xV02ey7F _0jFU0Vey7F",
    xsmall: "_39xV02ey7F _0jFU0Vey7F",
    small: "_39xV02oWWg _0jFU0VoWWg",
    medium: "_39xV02Uofl _0jFU0VUofl",
    large: "_39xV02UF4f _0jFU0VUF4f",
    xlarge: "_39xV02JgOI _0jFU0VJgOI",
    xxlarge: "_39xV02NNui _0jFU0VNNui"
}; /**
    * __Avatar image__
    *
    * An avatar image is an internal component used to control the rendering phases of an image.
    */ 
const $e9b0094c91a8ccec$export$ac3673635a5387be = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(32);
    const { alt: t1, src: src, size: size, testId: testId, teamId: teamId, compact: t2 } = t0;
    const alt = t1 === undefined ? "" : t1;
    const compact = t2 === undefined ? false : t2;
    const [hasImageErrored, setHasImageErrored] = (0, $cozmU.useState)(false);
    let t3;
    if ($[0] !== src || $[1] !== teamId) {
        t3 = (0, $5jzbe.getTeamAvatarSrc)(src, teamId);
        $[0] = src;
        $[1] = teamId;
        $[2] = t3;
    } else t3 = $[2];
    const avatarSrc = t3;
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            if ((0, $iDrrr.fg)("enable_teams_t26_design_drop_core_experiences")) return;
            setHasImageErrored(false);
        };
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== avatarSrc) {
        t5 = [
            avatarSrc
        ];
        $[4] = avatarSrc;
        $[5] = t5;
    } else t5 = $[5];
    (0, $cozmU.useEffect)(t4, t5);
    if ((!avatarSrc || hasImageErrored) && !(0, $iDrrr.fg)("enable_teams_t26_design_drop_core_experiences")) {
        const t6 = $e9b0094c91a8ccec$var$SIZES[size];
        const t7 = $e9b0094c91a8ccec$var$SIZES[size];
        let t8;
        if ($[6] !== alt || $[7] !== compact || $[8] !== t6 || $[9] !== t7 || $[10] !== testId) {
            t8 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $giWSb.FallbackAvatar), {
                "aria-label": alt,
                width: t6,
                height: t7,
                "data-testid": testId,
                compact: compact
            });
            $[6] = alt;
            $[7] = compact;
            $[8] = t6;
            $[9] = t7;
            $[10] = testId;
            $[11] = t8;
        } else t8 = $[11];
        return t8;
    }
    if ((0, $iDrrr.fg)("enable_teams_t26_design_drop_core_experiences")) {
        const resolvedSrc = hasImageErrored ? (0, $l5WTV.TEAM_FALLBACK_AVATAR_DATA_URI) : avatarSrc;
        const t6 = testId && `${testId}--image`;
        let t7;
        if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = ()=>setHasImageErrored(true);
            $[12] = t7;
        } else t7 = $[12];
        let t8;
        if ($[13] !== alt || $[14] !== resolvedSrc || $[15] !== t6) {
            t8 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                as: "img",
                src: resolvedSrc,
                alt: alt,
                testId: t6,
                xcss: $e9b0094c91a8ccec$var$avatarImageStyles.image,
                onError: t7
            });
            $[13] = alt;
            $[14] = resolvedSrc;
            $[15] = t6;
            $[16] = t8;
        } else t8 = $[16];
        return t8;
    }
    const t6 = $e9b0094c91a8ccec$var$borderRadiusMap[size];
    const t7 = $e9b0094c91a8ccec$var$widthHeightMap[size];
    const t8 = compact ? $e9b0094c91a8ccec$var$containerStyles.compactSpacing : $e9b0094c91a8ccec$var$containerStyles.nonCompactSpacing;
    let t9;
    if ($[17] !== t6 || $[18] !== t7 || $[19] !== t8) {
        t9 = (0, $hekY6.default)([
            $e9b0094c91a8ccec$var$unboundStyles.root,
            $e9b0094c91a8ccec$var$containerStyles.root,
            t6,
            t7,
            t8
        ]);
        $[17] = t6;
        $[18] = t7;
        $[19] = t8;
        $[20] = t9;
    } else t9 = $[20];
    const t10 = testId && `${testId}--image`;
    let t11;
    let t12;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = ()=>setHasImageErrored(true);
        t12 = (0, $hekY6.default)([
            $e9b0094c91a8ccec$var$avatarImageStyles.image
        ]);
        $[21] = t11;
        $[22] = t12;
    } else {
        t11 = $[21];
        t12 = $[22];
    }
    let t13;
    if ($[23] !== alt || $[24] !== avatarSrc || $[25] !== t10) {
        t13 = /*#__PURE__*/ (0, $8aG6j.jsx)("img", {
            src: avatarSrc,
            alt: alt,
            "data-testid": t10,
            onError: t11,
            className: t12
        });
        $[23] = alt;
        $[24] = avatarSrc;
        $[25] = t10;
        $[26] = t13;
    } else t13 = $[26];
    let t14;
    if ($[27] !== alt || $[28] !== t13 || $[29] !== t9 || $[30] !== testId) {
        t14 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            "data-testid": testId,
            "aria-label": alt,
            className: t9,
            children: t13
        });
        $[27] = alt;
        $[28] = t13;
        $[29] = t9;
        $[30] = testId;
        $[31] = t14;
    } else t14 = $[31];
    return t14;
} : ({ alt: alt = '', src: src, size: size, testId: testId, teamId: teamId, compact: compact = false })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $cozmU.useState)(false);
    const avatarSrc = (0, $5jzbe.getTeamAvatarSrc)(src, teamId);
    (0, $cozmU.useEffect)(()=>{
        if ((0, $iDrrr.fg)('enable_teams_t26_design_drop_core_experiences')) return;
        setHasImageErrored(false);
    }, [
        avatarSrc
    ]);
    if ((!avatarSrc || hasImageErrored) && !(0, $iDrrr.fg)('enable_teams_t26_design_drop_core_experiences')) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $giWSb.FallbackAvatar), {
        "aria-label": alt,
        width: $e9b0094c91a8ccec$var$SIZES[size],
        height: $e9b0094c91a8ccec$var$SIZES[size],
        "data-testid": testId,
        compact: compact
    });
    if ((0, $iDrrr.fg)('enable_teams_t26_design_drop_core_experiences')) {
        const resolvedSrc = hasImageErrored ? (0, $l5WTV.TEAM_FALLBACK_AVATAR_DATA_URI) : avatarSrc;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            as: "img",
            src: resolvedSrc,
            alt: alt,
            testId: testId && `${testId}--image`,
            xcss: $e9b0094c91a8ccec$var$avatarImageStyles.image,
            onError: ()=>setHasImageErrored(true)
        });
    }
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "data-testid": testId,
        "aria-label": alt,
        className: (0, $hekY6.default)([
            $e9b0094c91a8ccec$var$unboundStyles.root,
            $e9b0094c91a8ccec$var$containerStyles.root,
            $e9b0094c91a8ccec$var$borderRadiusMap[size],
            $e9b0094c91a8ccec$var$widthHeightMap[size],
            compact ? $e9b0094c91a8ccec$var$containerStyles.compactSpacing : $e9b0094c91a8ccec$var$containerStyles.nonCompactSpacing
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("img", {
            src: avatarSrc,
            alt: alt,
            "data-testid": testId && `${testId}--image`,
            onError: ()=>setHasImageErrored(true),
            className: (0, $hekY6.default)([
                $e9b0094c91a8ccec$var$avatarImageStyles.image
            ])
        })
    });
};
module.exports["TeamAvatarImage"] = $e9b0094c91a8ccec$export$ac3673635a5387be;

});

parcelRegister("giWSb", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");

const $fd19101f9abb11e9$var$styles = {
    wrapper: "_4bt5LAnQyn _2WAcuGnQyn _0bjKvD0O7w _3iDTPbQ4SZ",
    wrapperSpacing: "_313842FQfX _0adFHsFQfX _1DCdHiFQfX _2XsHFMFQfX",
    compactWrapperSpacing: "_313842Pgdg _0adFHsPgdg _1DCdHiPgdg _2XsHFMPgdg"
};
const $fd19101f9abb11e9$export$eb63dcc490f6bbcd = (0, $gtMdU.isReactCompilerActivePlatform)() ? function FallbackAvatar(t0) {
    const $ = (0, $bDgLe.c)(12);
    let compact;
    let props;
    if ($[0] !== t0) {
        ({ compact: compact, ...props } = t0);
        $[0] = t0;
        $[1] = compact;
        $[2] = props;
    } else {
        compact = $[1];
        props = $[2];
    }
    const t1 = compact ? $fd19101f9abb11e9$var$styles.compactWrapperSpacing : $fd19101f9abb11e9$var$styles.wrapperSpacing;
    let t2;
    if ($[3] !== t1) {
        t2 = (0, $w6R6I.cx)($fd19101f9abb11e9$var$styles.wrapper, t1);
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
            clipPath: "url(#clip0_2032_552)",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                    width: "32",
                    height: "32",
                    rx: "4",
                    fill: "#DCDFE4"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M10.6666 12.6666C11.7712 12.6666 12.6666 11.7712 12.6666 10.6666C12.6666 9.56206 11.7712 8.66663 10.6666 8.66663C9.56202 8.66663 8.66658 9.56206 8.66658 10.6666C8.66658 11.7712 9.56202 12.6666 10.6666 12.6666ZM10.6666 14.6666C12.8757 14.6666 14.6666 12.8758 14.6666 10.6666C14.6666 8.45749 12.8757 6.66663 10.6666 6.66663C8.45745 6.66663 6.66658 8.45749 6.66658 10.6666C6.66658 12.8758 8.45745 14.6666 10.6666 14.6666Z",
                    fill: "#44546F"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M21.3333 12.6666C22.4378 12.6666 23.3333 11.7712 23.3333 10.6666C23.3333 9.56206 22.4378 8.66663 21.3333 8.66663C20.2287 8.66663 19.3333 9.56206 19.3333 10.6666C19.3333 11.7712 20.2287 12.6666 21.3333 12.6666ZM21.3333 14.6666C23.5424 14.6666 25.3333 12.8758 25.3333 10.6666C25.3333 8.45749 23.5424 6.66663 21.3333 6.66663C19.1241 6.66663 17.3333 8.45749 17.3333 10.6666C17.3333 12.8758 19.1241 14.6666 21.3333 14.6666Z",
                    fill: "#44546F"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    d: "M21.6666 16C24.4273 16.0004 26.6666 18.2385 26.6666 21V22.6666C26.6666 24.1394 25.4727 25.3333 23.9999 25.3333H20.135C18.0324 25.3333 16.1545 24.018 15.436 22.042L14.6843 19.9747C14.2531 18.7892 13.1264 18 11.8649 18H10.3333C8.6764 18 7.33325 19.3431 7.33325 21V22.6666C7.33325 23.0348 7.63173 23.3333 7.99992 23.3333H13.3333V25.3333H7.99992C6.52716 25.3333 5.33325 24.1394 5.33325 22.6666V21C5.33325 18.2385 7.57183 16 10.3333 16H11.8649C13.9674 16 15.8453 17.3153 16.5638 19.2913L17.3156 21.3585C17.7467 22.5441 18.8734 23.3333 20.135 23.3333H23.9999C24.3681 23.3333 24.6666 23.0348 24.6666 22.6666V21C24.6666 19.3437 23.3233 18.0004 21.6666 18H20.135V16H21.6666Z",
                    fill: "#44546F"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    d: "M20.135 16C19.5972 16 18.7183 16.1407 18.0518 16.4564L18.908 18.2639C19.064 18.19 19.288 18.1205 19.537 18.0703C19.785 18.0203 20.0045 18 20.135 18V16Z",
                    fill: "#44546F"
                })
            ]
        });
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)("defs", {
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("clipPath", {
                id: "clip0_2032_552",
                children: /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                    width: "32",
                    height: "32",
                    rx: "4",
                    fill: "white"
                })
            })
        });
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== props) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsxs)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props,
            children: [
                t3,
                t4
            ]
        });
        $[7] = props;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== t2 || $[10] !== t5) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: t2,
            children: t5
        });
        $[9] = t2;
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    return t6;
} : function FallbackAvatar({ compact: compact, ...props }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($fd19101f9abb11e9$var$styles.wrapper, compact ? $fd19101f9abb11e9$var$styles.compactWrapperSpacing : $fd19101f9abb11e9$var$styles.wrapperSpacing),
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props,
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
                    clipPath: "url(#clip0_2032_552)",
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "#DCDFE4"
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M10.6666 12.6666C11.7712 12.6666 12.6666 11.7712 12.6666 10.6666C12.6666 9.56206 11.7712 8.66663 10.6666 8.66663C9.56202 8.66663 8.66658 9.56206 8.66658 10.6666C8.66658 11.7712 9.56202 12.6666 10.6666 12.6666ZM10.6666 14.6666C12.8757 14.6666 14.6666 12.8758 14.6666 10.6666C14.6666 8.45749 12.8757 6.66663 10.6666 6.66663C8.45745 6.66663 6.66658 8.45749 6.66658 10.6666C6.66658 12.8758 8.45745 14.6666 10.6666 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M21.3333 12.6666C22.4378 12.6666 23.3333 11.7712 23.3333 10.6666C23.3333 9.56206 22.4378 8.66663 21.3333 8.66663C20.2287 8.66663 19.3333 9.56206 19.3333 10.6666C19.3333 11.7712 20.2287 12.6666 21.3333 12.6666ZM21.3333 14.6666C23.5424 14.6666 25.3333 12.8758 25.3333 10.6666C25.3333 8.45749 23.5424 6.66663 21.3333 6.66663C19.1241 6.66663 17.3333 8.45749 17.3333 10.6666C17.3333 12.8758 19.1241 14.6666 21.3333 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                            d: "M21.6666 16C24.4273 16.0004 26.6666 18.2385 26.6666 21V22.6666C26.6666 24.1394 25.4727 25.3333 23.9999 25.3333H20.135C18.0324 25.3333 16.1545 24.018 15.436 22.042L14.6843 19.9747C14.2531 18.7892 13.1264 18 11.8649 18H10.3333C8.6764 18 7.33325 19.3431 7.33325 21V22.6666C7.33325 23.0348 7.63173 23.3333 7.99992 23.3333H13.3333V25.3333H7.99992C6.52716 25.3333 5.33325 24.1394 5.33325 22.6666V21C5.33325 18.2385 7.57183 16 10.3333 16H11.8649C13.9674 16 15.8453 17.3153 16.5638 19.2913L17.3156 21.3585C17.7467 22.5441 18.8734 23.3333 20.135 23.3333H23.9999C24.3681 23.3333 24.6666 23.0348 24.6666 22.6666V21C24.6666 19.3437 23.3233 18.0004 21.6666 18H20.135V16H21.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                            d: "M20.135 16C19.5972 16 18.7183 16.1407 18.0518 16.4564L18.908 18.2639C19.064 18.19 19.288 18.1205 19.537 18.0703C19.785 18.0203 20.0045 18 20.135 18V16Z",
                            fill: "#44546F"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)("clipPath", {
                        id: "clip0_2032_552",
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "white"
                        })
                    })
                })
            ]
        })
    });
};
module.exports["FallbackAvatar"] = $fd19101f9abb11e9$export$eb63dcc490f6bbcd;

});

parcelRegister("l5WTV", function(module, exports) {
const $ef1de21fbce43fe8$export$215bd25cfab1a96 = `data:image/svg+xml;utf8,${encodeURIComponent(`<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2032_552)">
<rect width="32" height="32" rx="4" fill="#DCDFE4"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M10.6666 12.6666C11.7712 12.6666 12.6666 11.7712 12.6666 10.6666C12.6666 9.56206 11.7712 8.66663 10.6666 8.66663C9.56202 8.66663 8.66658 9.56206 8.66658 10.6666C8.66658 11.7712 9.56202 12.6666 10.6666 12.6666ZM10.6666 14.6666C12.8757 14.6666 14.6666 12.8758 14.6666 10.6666C14.6666 8.45749 12.8757 6.66663 10.6666 6.66663C8.45745 6.66663 6.66658 8.45749 6.66658 10.6666C6.66658 12.8758 8.45745 14.6666 10.6666 14.6666Z" fill="#44546F"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M21.3333 12.6666C22.4378 12.6666 23.3333 11.7712 23.3333 10.6666C23.3333 9.56206 22.4378 8.66663 21.3333 8.66663C20.2287 8.66663 19.3333 9.56206 19.3333 10.6666C19.3333 11.7712 20.2287 12.6666 21.3333 12.6666ZM21.3333 14.6666C23.5424 14.6666 25.3333 12.8758 25.3333 10.6666C25.3333 8.45749 23.5424 6.66663 21.3333 6.66663C19.1241 6.66663 17.3333 8.45749 17.3333 10.6666C17.3333 12.8758 19.1241 14.6666 21.3333 14.6666Z" fill="#44546F"/>
<path d="M21.6666 16C24.4273 16.0004 26.6666 18.2385 26.6666 21V22.6666C26.6666 24.1394 25.4727 25.3333 23.9999 25.3333H20.135C18.0324 25.3333 16.1545 24.018 15.436 22.042L14.6843 19.9747C14.2531 18.7892 13.1264 18 11.8649 18H10.3333C8.6764 18 7.33325 19.3431 7.33325 21V22.6666C7.33325 23.0348 7.63173 23.3333 7.99992 23.3333H13.3333V25.3333H7.99992C6.52716 25.3333 5.33325 24.1394 5.33325 22.6666V21C5.33325 18.2385 7.57183 16 10.3333 16H11.8649C13.9674 16 15.8453 17.3153 16.5638 19.2913L17.3156 21.3585C17.7467 22.5441 18.8734 23.3333 20.135 23.3333H23.9999C24.3681 23.3333 24.6666 23.0348 24.6666 22.6666V21C24.6666 19.3437 23.3233 18.0004 21.6666 18H20.135V16H21.6666Z" fill="#44546F"/>
<path d="M20.135 16C19.5972 16 18.7183 16.1407 18.0518 16.4564L18.908 18.2639C19.064 18.19 19.288 18.1205 19.537 18.0703C19.785 18.0203 20.0045 18 20.135 18V16Z" fill="#44546F"/>
</g>
<defs>
<clipPath id="clip0_2032_552">
<rect width="32" height="32" rx="4" fill="white"/>
</clipPath>
</defs>
</svg>`)}`;
module.exports["TEAM_FALLBACK_AVATAR_DATA_URI"] = $ef1de21fbce43fe8$export$215bd25cfab1a96;

});

parcelRegister("5jzbe", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $l5WTV = parcelRequire("l5WTV");

function $b576d3f3fb082ae0$export$59ff7d19feb890b6(src, teamId) {
    if (src) return src;
    else if (teamId) return `/gateway/api/v4/teams/${teamId}/avatar`;
    return (0, $iDrrr.fg)('enable_teams_t26_design_drop_core_experiences') ? (0, $l5WTV.TEAM_FALLBACK_AVATAR_DATA_URI) : undefined;
}
module.exports["getTeamAvatarSrc"] = $b576d3f3fb082ae0$export$59ff7d19feb890b6;

});

parcelRegister("b9heI", function(module, exports) {

var $cMfSg = parcelRequire("cMfSg");


var $gh5tj = parcelRequire("gh5tj");

const $a24728959ef3490f$var$getUserRecommendations = (request, intl)=>{
    const url = (0, $gh5tj.config).getRecommendationServiceUrl(request.baseUrl || '');
    return fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify({
            context: request.context,
            includeUsers: request.includeUsers,
            includeGroups: request.includeGroups,
            includeTeams: request.includeTeams,
            includeNonLicensedUsers: request.includeNonLicensedUsers,
            maxNumberOfResults: request.maxNumberOfResults,
            performSearchQueryOnly: false,
            searchQuery: {
                ...request.verifiedTeams === true && {
                    isVerifiedTeamFilter: true
                },
                ...request.isTeamSyncedToGroupDirectoryFilter === true && {
                    isTeamSyncedToGroupDirectoryFilter: true
                },
                cpusQueryHighlights: {
                    query: '',
                    field: ''
                },
                ...request.context?.productAttributes?.isEntitledConfluenceExternalCollaborator && {
                    productAccessPermissionIds: [
                        'write',
                        'external-collaborator-write'
                    ]
                },
                customQuery: '',
                customerDirectoryId: '',
                filter: request.searchQueryFilter || '',
                minimumAccessLevel: 'APPLICATION',
                queryString: request.query,
                restrictTo: request.restrictTo || {
                    userIds: [],
                    groupIds: []
                },
                searchUserbase: false,
                searchEmail: request.searchEmail
            }
        })
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling smart service, statusCode=${response.status}, statusText=${response.statusText}`,
            statusCode: response.status
        });
    }).then((response)=>(0, $cMfSg.transformUsers)(response, intl));
};
var $a24728959ef3490f$export$2e2bcd8739ae039 = $a24728959ef3490f$var$getUserRecommendations;
module.exports["default"] = $a24728959ef3490f$export$2e2bcd8739ae039;

});

parcelRegister("cMfSg", function(module, exports) {

var $9kYT2 = parcelRequire("9kYT2");


var $4oxIw = parcelRequire("4oxIw");


var $jItb7 = parcelRequire("jItb7");


var $iDrrr = parcelRequire("iDrrr");

const $9b431fcf90cc0132$var$getLozenzeProperties = (entity, intl)=>{
    if (entity.attributes?.workspaceMember) return intl.formatMessage((0, $4oxIw.messages).memberLozengeText);
    if (entity.attributes?.isConfluenceExternalCollaborator) {
        const lozengeTooltipMessage = entity.entityType === (0, $jItb7.EntityType).GROUP ? (0, $4oxIw.messages).guestGroupLozengeTooltip : (0, $4oxIw.messages).guestUserLozengeTooltip;
        return {
            text: intl.formatMessage((0, $4oxIw.messages).guestLozengeText),
            tooltip: intl.formatMessage(lozengeTooltipMessage),
            appearance: 'default'
        };
    }
    const isJiraGuestUser = (0, $iDrrr.fg)('user_picker_guest_lozenges') && entity.attributes?.isJiraGuest;
    if (isJiraGuestUser) return intl.formatMessage((0, $4oxIw.messages).guestLozengeText);
    return undefined;
};
const $9b431fcf90cc0132$var$transformUser = (item, intl)=>{
    const type = item.entityType;
    if (type === (0, $jItb7.EntityType).USER) {
        const user = item;
        const lozenge = $9b431fcf90cc0132$var$getLozenzeProperties(user, intl);
        return {
            id: user.id,
            type: user.nonLicensedUser ? (0, $9kYT2.ExternalUserType) : (0, $9kYT2.UserType),
            userType: user.userType,
            avatarUrl: user.avatarUrl,
            name: user.name,
            email: user.email,
            title: user.title,
            lozenge: lozenge,
            tooltip: user.name,
            isExternal: Boolean(user.nonLicensedUser),
            sources: user.nonLicensedUser ? [
                'other-atlassian'
            ] : undefined,
            appType: user.appType !== undefined ? user.appType : user.attributes?.appType
        };
    }
    if (type === (0, $jItb7.EntityType).TEAM) {
        const team = item;
        return {
            id: team.id,
            type: (0, $9kYT2.TeamType),
            description: team.description || '',
            name: team.displayName || '',
            memberCount: team.memberCount,
            members: team.members,
            includesYou: team.includesYou,
            avatarUrl: team.largeAvatarImageUrl || team.smallAvatarImageUrl,
            tooltip: team.displayName,
            verified: team.verified,
            teamTypeName: team.type?.name,
            state: team.state
        };
    }
    if (type === (0, $jItb7.EntityType).GROUP) {
        const group = item;
        const lozenge = $9b431fcf90cc0132$var$getLozenzeProperties(group, intl);
        return {
            id: group.id,
            type: (0, $9kYT2.GroupType),
            name: group.name || '',
            lozenge: lozenge
        };
    }
    return;
};
const $9b431fcf90cc0132$export$fb8c90bfc4beaa59 = (serverResponse, intl)=>(serverResponse.recommendedUsers || []).map((item)=>$9b431fcf90cc0132$var$transformUser(item, intl)).filter((user)=>!!user).map((user)=>user);
module.exports["transformUsers"] = $9b431fcf90cc0132$export$fb8c90bfc4beaa59;

});

parcelRegister("9kYT2", function(module, exports) {
const $7b15e63389e1c86f$export$8436e53e45ffe15b = 'user';
const $7b15e63389e1c86f$export$50042ec1d2e00e63 = 'external_user';
const $7b15e63389e1c86f$export$26bc40b960693765 = 'team';
const $7b15e63389e1c86f$export$d460f747b73abb10 = 'group';
const $7b15e63389e1c86f$export$6662b3461398ef8c = 'email';
const $7b15e63389e1c86f$export$eafd0979afa5b224 = 'custom';
module.exports["UserType"] = $7b15e63389e1c86f$export$8436e53e45ffe15b;
module.exports["ExternalUserType"] = $7b15e63389e1c86f$export$50042ec1d2e00e63;
module.exports["TeamType"] = $7b15e63389e1c86f$export$26bc40b960693765;
module.exports["GroupType"] = $7b15e63389e1c86f$export$d460f747b73abb10;
module.exports["EmailType"] = $7b15e63389e1c86f$export$6662b3461398ef8c;
module.exports["CustomType"] = $7b15e63389e1c86f$export$eafd0979afa5b224;

});

parcelRegister("4oxIw", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $9369811f0ae39467$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    externalUserSourcesHeading: {
        id: "fabric.elements.user-picker.external.sourced.from",
        defaultMessage: "Found in:"
    },
    slackProvider: {
        id: "fabric.elements.user-picker.slack.provider",
        defaultMessage: "Slack"
    },
    googleProvider: {
        id: "fabric.elements.user-picker.google.provider",
        defaultMessage: "Google"
    },
    microsoftProvider: {
        id: "fabric.elements.user-picker.microsoft.provider",
        defaultMessage: "Microsoft"
    },
    gitHubProvider: {
        id: "fabric.elements.user-picker.github.provider",
        defaultMessage: "GitHub"
    },
    memberLozengeText: {
        id: "fabric.elements.user-picker.member.lozenge.text",
        defaultMessage: "MEMBER"
    },
    guestLozengeText: {
        id: "fabric.elements.user-picker.guest.lozenge.text",
        defaultMessage: "GUEST"
    },
    guestUserLozengeTooltip: {
        id: "fabric.elements.user-picker.guest.lozenge.tooltip.user",
        defaultMessage: "Guests can only access certain spaces and have limited access to user info."
    },
    guestGroupLozengeTooltip: {
        id: "fabric.elements.user-picker.guest.lozenge.tooltip.group",
        defaultMessage: "Guest groups can only access certain spaces and have limited access to user info."
    }
});
module.exports["messages"] = $9369811f0ae39467$export$defe85febe8b728c;

});

parcelRegister("jItb7", function(module, exports) {
var $96c0d04f40ba3ed5$export$8eda7e02f8f033b2 = /*#__PURE__*/ function(EntityType) {
    EntityType["USER"] = "USER";
    EntityType["TEAM"] = "TEAM";
    EntityType["GROUP"] = "GROUP";
    return EntityType;
}({});
var $96c0d04f40ba3ed5$export$ef0ef29634e52a6b = /*#__PURE__*/ function(UserEntityType) {
    UserEntityType["DEFAULT"] = "DEFAULT";
    UserEntityType["APP"] = "APP";
    UserEntityType["CUSTOMER"] = "CUSTOMER";
    UserEntityType["SYSTEM"] = "SYSTEM";
    return UserEntityType;
}({});
module.exports["EntityType"] = $96c0d04f40ba3ed5$export$8eda7e02f8f033b2;
module.exports["UserEntityType"] = $96c0d04f40ba3ed5$export$ef0ef29634e52a6b;

});

parcelRegister("gh5tj", function(module, exports) {
const $35b9c4aa02694e21$export$e506a1d27d1eaa20 = {
    getRecommendationServiceUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/v1/recommendations` : '/gateway/api/v1/recommendations';
    },
    getUsersServiceUrl (productKey, baseUrl = '') {
        return productKey === 'jira' ? `${baseUrl}/rest/api/3/user/bulk` : `${baseUrl}/wiki/rest/api/user/bulk`;
    },
    getGraphQLUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/graphql` : `/gateway/api/graphql`;
    },
    getTeamsUrl (id, baseUrl, siteId) {
        return baseUrl ? `${baseUrl}/gateway/api/v4/teams/${id}?siteId=${siteId ?? 'None'}` : `/gateway/api/v4/teams/${id}?siteId=${siteId ?? 'None'}`;
    }
};
module.exports["config"] = $35b9c4aa02694e21$export$e506a1d27d1eaa20;

});

parcelRegister("2SUNK", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b516e3b9bd2f12c$export$2e2bcd8739ae039);
let $1b516e3b9bd2f12c$var$debugEnabled = false;
let $1b516e3b9bd2f12c$var$stacktracesEnabled = false;
function $1b516e3b9bd2f12c$export$748ada60eaf985cc(enable) {
    $1b516e3b9bd2f12c$var$debugEnabled = enable;
}
function $1b516e3b9bd2f12c$export$4f7017086af31c25(enable) {
    $1b516e3b9bd2f12c$var$stacktracesEnabled = enable;
}
function $1b516e3b9bd2f12c$export$2a858f450a2f66d() {
    if ($1b516e3b9bd2f12c$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $1b516e3b9bd2f12c$export$2e2bcd8739ae039(msg, ...args) {
    if ($1b516e3b9bd2f12c$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});

parcelRegister("lUcpS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $k78uC = parcelRequire("k78uC");


var $8IfK6 = parcelRequire("8IfK6");

const $91b0a64470223be6$export$5bf35293e545f20c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent) {
        t0 = (...t1)=>{
            const params = t1;
            const event = createAnalyticsEvent((0, $8IfK6.default)(...params));
            event.fire((0, $k78uC.EVENT_CHANNEL));
        };
        $[0] = createAnalyticsEvent;
        $[1] = t0;
    } else t0 = $[1];
    const fireEvent = t0;
    let t1;
    if ($[2] !== fireEvent) {
        t1 = {
            fireEvent: fireEvent
        };
        $[2] = fireEvent;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireEvent = (0, $cozmU.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $8IfK6.default)(...params));
        event.fire((0, $k78uC.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};
module.exports["useAnalyticsEvents"] = $91b0a64470223be6$export$5bf35293e545f20c;

});

parcelRegister("k78uC", function(module, exports) {
const $0de3cce3bcdfa361$export$3f072f06b90c3985 = 'peopleTeams';
module.exports["EVENT_CHANNEL"] = $0de3cce3bcdfa361$export$3f072f06b90c3985;

});

parcelRegister("8IfK6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::d33f3d33520a5e35881ec61f3c089abb>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen teams-app-internal-analytics
 */ const $fcb00cbaaafbad36$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $fcb00cbaaafbad36$export$2e2bcd8739ae039 = $fcb00cbaaafbad36$var$createEventPayload;
module.exports["default"] = $fcb00cbaaafbad36$export$2e2bcd8739ae039;

});

parcelRegister("cSSWJ", function(module, exports) {
const $e8b102093dcaac45$export$849551cf61929d4f = {
    packageName: "platform-pkg" ?? '',
    packageVersion: "0.0.0-use.local" ?? ''
};
const $e8b102093dcaac45$export$efd16d9cf43b6e97 = 'teamProfileCard';
const $e8b102093dcaac45$export$7611b3e6899481f9 = 'profilecard';
const $e8b102093dcaac45$export$4c23d6e68fa71371 = 'rovoAgentProfilecard';
module.exports["PACKAGE_META_DATA"] = $e8b102093dcaac45$export$849551cf61929d4f;
module.exports["TEAM_SUBJECT"] = $e8b102093dcaac45$export$efd16d9cf43b6e97;
module.exports["USER_SUBJECT"] = $e8b102093dcaac45$export$7611b3e6899481f9;
module.exports["AGENT_SUBJECT"] = $e8b102093dcaac45$export$4c23d6e68fa71371;

});

parcelRegister("4PAHv", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");


var $7G50J = parcelRequire("7G50J");


var $hMCZS = parcelRequire("hMCZS");


var $lUcpS = parcelRequire("lUcpS");


var $dSW04 = parcelRequire("dSW04");


var $dRAjC = parcelRequire("dRAjC");


var $4k5Wq = parcelRequire("4k5Wq");


var $kb2tZ = parcelRequire("kb2tZ");


var $hIwXM = parcelRequire("hIwXM");

const $fe1c8bc12e81e628$export$4b013ffffcb40af8 = (props)=>{
    const [agentData, setAgentData] = (0, $cozmU.useState)();
    // Initialize as true when fix is enabled since we fetch immediately on mount,
    // avoiding a brief error screen flash before the useEffect fires.
    const [isLoading, setIsLoading] = (0, $cozmU.useState)((0, $iDrrr.fg)('confluence_fix_agent_profile_card_flash'));
    const [error, setError] = (0, $cozmU.useState)();
    const [isPermitted, setIsPermitted] = (0, $cozmU.useState)(true);
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const creatorUserId = (0, $cozmU.useMemo)(()=>agentData?.creator_type === 'CUSTOMER' && agentData.creator ? (0, $dRAjC.getAAIDFromARI)(agentData.creator) : '', [
        agentData?.creator_type,
        agentData?.creator
    ]);
    const navResult = (0, $hMCZS.navigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: creatorUserId || ''
        },
        cloudId: props.cloudId
    });
    let profileHref = navResult.href;
    const getCreator = (0, $cozmU.useCallback)(async ({ creator_type: creator_type, creator: creator, authoringTeam: authoringTeam })=>{
        try {
            let userCreatorInfo;
            const currentCreatorUserId = (0, $iDrrr.fg)('confluence_fix_agent_profile_card_flash') ? creator_type === 'CUSTOMER' && creator ? (0, $dRAjC.getAAIDFromARI)(creator) : undefined : creatorUserId;
            if (currentCreatorUserId && props.cloudId) {
                userCreatorInfo = await props.resourceClient.getProfile(props.cloudId, currentCreatorUserId, fireEvent);
                if ((0, $iDrrr.fg)('confluence_fix_agent_profile_card_flash')) profileHref = (0, $hMCZS.navigateToTeamsApp)({
                    type: 'USER',
                    payload: {
                        userId: currentCreatorUserId
                    },
                    cloudId: props.cloudId
                }).href;
            }
            const creatorInfo = (0, $7G50J.getAgentCreator)({
                creatorType: creator_type,
                authoringTeam: authoringTeam ? {
                    displayName: authoringTeam.displayName ?? '',
                    profileLink: authoringTeam.profileUrl ?? undefined
                } : undefined,
                userCreator: userCreatorInfo ? {
                    name: userCreatorInfo.fullName ?? '',
                    profileLink: (0, $iDrrr.fg)('platform-adopt-teams-nav-config') ? profileHref : `/people/${currentCreatorUserId}`
                } : undefined,
                forgeCreator: creator ?? undefined
            });
            return creatorInfo;
        } catch  {
            return undefined;
        }
    }, [
        creatorUserId,
        fireEvent,
        props.cloudId,
        props.resourceClient,
        profileHref
    ]);
    const fetchData = (0, $cozmU.useCallback)(async ()=>{
        setIsLoading(true);
        try {
            const profileResult = await props.resourceClient.getRovoAgentProfile({
                type: 'identity',
                value: props.accountId
            }, fireEvent);
            const profileData = profileResult.restData;
            const creatorInfoProps = {
                creator_type: profileData?.creator_type,
                creator: profileData?.creator || undefined,
                authoringTeam: profileResult.aggData?.authoringTeam ?? undefined
            };
            const agentCreatorInfo = await getCreator(creatorInfoProps);
            setAgentData({
                ...profileData,
                creatorInfo: agentCreatorInfo
            });
        } catch (err) {
            if (err instanceof (0, $dSW04.AgentForbiddenError) && (0, $cXtTj.default).getExperimentValue('platform_editor_reduced_agent_profile_cards', 'isEnabled', false)) setIsPermitted(false);
            else setError(err);
        } finally{
            setIsLoading(false);
        }
    }, [
        fireEvent,
        getCreator,
        props.accountId,
        props.resourceClient
    ]);
    // Depend on accountId rather than fetchData to avoid a re-fetch loop:
    // agentData changes → creatorUserId → getCreator → fetchData ref changes → useEffect re-fires.
    // Reset state on accountId change so stale data from the previous agent isn't briefly shown.
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $iDrrr.fg)('confluence_fix_agent_profile_card_flash')) return;
        setAgentData(undefined);
        setError(undefined);
        setIsLoading(true);
        fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.accountId
    ]);
    (0, $cozmU.useEffect)(()=>{
        if ((0, $iDrrr.fg)('confluence_fix_agent_profile_card_flash')) return;
        fetchData();
    }, [
        fetchData
    ]);
    const forbiddenAgent = (0, $cozmU.useMemo)(()=>(0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes') ? {
            id: '',
            named_id: '',
            name: props.agentName ?? '',
            description: '\u00A0',
            creator_type: 'CUSTOMER',
            is_default: false,
            actor_type: 'AGENT',
            user_defined_conversation_starters: null,
            favourite: false,
            favourite_count: 0,
            identity_account_id: props.accountId,
            creatorInfo: undefined
        } : undefined, [
        props.agentName,
        props.accountId
    ]);
    if (!isPermitted && (0, $cXtTj.default).getExperimentValue('platform_editor_reduced_agent_profile_cards', 'isEnabled', false)) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kb2tZ.AgentProfileCardWrapper), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
            fallback: null,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hIwXM.AgentProfileCardLazy), {
                agent: (0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes') ? forbiddenAgent : {
                    id: '',
                    named_id: '',
                    name: props.agentName ?? '',
                    description: '\u00A0',
                    creator_type: 'CUSTOMER',
                    is_default: false,
                    actor_type: 'AGENT',
                    user_defined_conversation_starters: null,
                    favourite: false,
                    favourite_count: 0,
                    identity_account_id: props.accountId,
                    creatorInfo: undefined
                },
                isLoading: false,
                resourceClient: props.resourceClient,
                cloudId: props.cloudId,
                hideAgentActions: true,
                hideConversationStarters: true,
                hideAiDisclaimer: true,
                hideStarButton: props.hideStarButton,
                showCreatorNameWithoutLink: props.showCreatorNameWithoutLink,
                footerComponent: props.footerComponent
            })
        })
    });
    if (error || !isLoading && !agentData) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kb2tZ.AgentProfileCardWrapper), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4k5Wq.default), {
            reload: ()=>{
                fetchData();
            },
            errorType: error || null,
            fireAnalytics: fireEvent
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hIwXM.AgentProfileCardLazy), {
            agent: agentData,
            isLoading: isLoading,
            hasError: !!error,
            onConversationStartersClick: props.onConversationStartersClick,
            onChatClick: props.onChatClick,
            addFlag: props.addFlag,
            resourceClient: props.resourceClient,
            cloudId: props.cloudId,
            onDeleteAgent: props.onDeleteAgent,
            hideMoreActions: props.hideMoreActions,
            hideAiDisclaimer: props.hideAiDisclaimer,
            hideConversationStarters: props.hideConversationStarters,
            hideAgentActions: props.hideAgentActions,
            hideStarButton: props.hideStarButton,
            showCreatorNameWithoutLink: props.showCreatorNameWithoutLink,
            footerComponent: props.footerComponent
        })
    });
};
module.exports["AgentProfileCardResourced"] = $fe1c8bc12e81e628$export$4b013ffffcb40af8;

});

parcelRegister("7G50J", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $cXtTj = parcelRequire("cXtTj");


var $I7hWB = parcelRequire("I7hWB");


var $i1t43 = parcelRequire("i1t43");


var $NlHoa = parcelRequire("NlHoa");


var $bltJZ = parcelRequire("bltJZ");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");


var $a9aSv = parcelRequire("a9aSv");


var $ieeJu = parcelRequire("ieeJu");


var $lpNn5 = parcelRequire("lpNn5");


var $6h4xM = parcelRequire("6h4xM");


var $i4kCF = parcelRequire("i4kCF");


var $hq9Cp = parcelRequire("hq9Cp");


var $fNIRw = parcelRequire("fNIRw");

const $f5fec235121c7193$var$styles = {
    clickableItem: "_2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLDIqT",
    rovoIconWrapper: "_3iDTPbQ4SZ",
    name: "_37wbyuI7V3 _0hPCNLchRC",
    description: "_3SamIHPgdg _3zvHkHdC7N _3W2Oc8wPeg",
    headingWrapper: "_1mT5xdRAKS",
    hiddenIconWrapper: "_313842FQfX"
};
const $f5fec235121c7193$export$7cbebf266a9bcc3c = ({ creatorType: creatorType, authoringTeam: authoringTeam, userCreator: userCreator, forgeCreator: forgeCreator })=>{
    if (creatorType === 'SYSTEM') return {
        type: 'SYSTEM'
    };
    if ((0, $iDrrr.fg)('rovo_agent_support_a2a_avatar') ? (0, $hq9Cp.isForgeAgentByCreatorType)(creatorType) : creatorType === 'FORGE' || creatorType === 'THIRD_PARTY' // THIRD_PARTY is deprecated in convo-ai, use FORGE instead
    ) return {
        // @todo: remove cast in rovo_agent_support_a2a_avatar cleanup
        type: (0, $iDrrr.fg)('jira_improve_agent_profile_for_a2a') ? creatorType : 'FORGE',
        name: forgeCreator ?? ''
    };
    if (creatorType === 'OOTB') return {
        type: 'OOTB'
    };
    if (creatorType === 'CUSTOMER') {
        if (authoringTeam) return {
            type: 'CUSTOMER',
            name: authoringTeam.displayName,
            profileLink: authoringTeam.profileLink ?? ''
        };
        if (!userCreator?.profileLink) return undefined;
        return {
            type: 'CUSTOMER',
            name: userCreator.name,
            profileLink: userCreator.profileLink,
            status: userCreator.status
        };
    }
    return;
};
const $f5fec235121c7193$export$f35b2eeaa7e3db15 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { creator: creator, onCreatorLinkClick: onCreatorLinkClick, isLoading: isLoading, showCreatorNameWithoutLink: t1 } = t0;
    const showCreatorNameWithoutLink = t1 === undefined ? false : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== creator || $[1] !== formatMessage || $[2] !== isLoading || $[3] !== onCreatorLinkClick || $[4] !== showCreatorNameWithoutLink) {
        const getCreatorRender = ()=>{
            if (isLoading) return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
                    testId: "agent-profile-creator-skeleton",
                    isShimmering: true,
                    height: 18,
                    width: 100
                })
            });
            if (!creator) return null;
            if (creator.type === "SYSTEM" || creator.type === "OOTB") return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                    alignBlock: "center",
                    testId: "atlassian-icon"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
                    label: "",
                    size: "small",
                    appearance: "brand"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, "Atlassian"))
            });
            if (creator.type === "CUSTOMER") {
                const creatorName = `${creator.name} ${creator.status === "inactive" ? formatMessage((0, $fNIRw.messages).agentDeactivated) : ""}`;
                return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                    creatorNameWithLink: showCreatorNameWithoutLink ? creatorName : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                        href: creator.profileLink,
                        onClick: ()=>onCreatorLinkClick(),
                        target: "_blank"
                    }, creatorName)
                });
            }
            if (creator.type === "REMOTE_A2A") {
                if ((0, $cXtTj.default).getExperimentValue("rovo_hide_remote_a2a_agent_creator_exp", "isEnabled", false)) return null;
                return formatMessage((0, $fNIRw.messages).remoteAgentCreatedBy, {
                    creatorNameWithLink: creator.name
                });
            }
            if (creator.type === "THIRD_PARTY" || creator.type === "FORGE") return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                creatorNameWithLink: creator.name
            });
            return null;
        };
        t2 = getCreatorRender();
        $[0] = creator;
        $[1] = formatMessage;
        $[2] = isLoading;
        $[3] = onCreatorLinkClick;
        $[4] = showCreatorNameWithoutLink;
        $[5] = t2;
    } else t2 = $[5];
    const creatorRender = t2;
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $ieeJu.expValEquals)("platform_editor_agent_mentions", "isEnabled", true) && (0, $iDrrr.fg)("platform_editor_agent_mentions_drop_one_fixes");
        $[6] = t3;
    } else t3 = $[6];
    const hideCreatorIcon = t3;
    if ((0, $iDrrr.fg)("jira_improve_agent_profile_for_a2a")) {
        const showRovoIcon = !hideCreatorIcon && creator?.type !== "REMOTE_A2A";
        let t4;
        if ($[7] !== creatorRender || $[8] !== showRovoIcon) {
            t4 = creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $f5fec235121c7193$var$styles.clickableItem
            }, showRovoIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $f5fec235121c7193$var$styles.rovoIconWrapper,
                testId: "rovo-icon-wrapper",
                "aria-hidden": "true"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.RovoIcon), {
                appearance: "brand",
                size: "small"
            })) : null, creatorRender) : null;
            $[7] = creatorRender;
            $[8] = showRovoIcon;
            $[9] = t4;
        } else t4 = $[9];
        return t4;
    }
    let t4;
    if ($[10] !== creatorRender) {
        t4 = creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.clickableItem
        }, !hideCreatorIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.rovoIconWrapper,
            testId: "rovo-icon-wrapper",
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.RovoIcon), {
            appearance: "brand",
            size: "small"
        })), creatorRender) : null;
        $[10] = creatorRender;
        $[11] = t4;
    } else t4 = $[11];
    return t4;
} : ({ creator: creator, onCreatorLinkClick: onCreatorLinkClick, isLoading: isLoading, showCreatorNameWithoutLink: showCreatorNameWithoutLink = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const getCreatorRender = ()=>{
        if (isLoading) return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
                testId: "agent-profile-creator-skeleton",
                isShimmering: true,
                height: 18,
                width: 100
            })
        });
        if (!creator) return null;
        if (creator.type === 'SYSTEM' || creator.type === 'OOTB') return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                alignBlock: "center",
                testId: "atlassian-icon"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
                label: "",
                size: "small",
                appearance: "brand"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, "Atlassian"))
        });
        if (creator.type === 'CUSTOMER') {
            const creatorName = `${creator.name} ${creator.status === 'inactive' ? formatMessage((0, $fNIRw.messages).agentDeactivated) : ''}`;
            return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                creatorNameWithLink: showCreatorNameWithoutLink ? creatorName : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    href: creator.profileLink,
                    onClick: ()=>onCreatorLinkClick(),
                    target: "_blank"
                }, creatorName)
            });
        }
        if (creator.type === 'REMOTE_A2A') {
            if ((0, $cXtTj.default).getExperimentValue('rovo_hide_remote_a2a_agent_creator_exp', 'isEnabled', false)) return null;
            return formatMessage((0, $fNIRw.messages).remoteAgentCreatedBy, {
                creatorNameWithLink: creator.name
            });
        } // THIRD_PARTY is deprecated in convo-ai, use FORGE instead
        if (creator.type === 'THIRD_PARTY' || creator.type === 'FORGE') return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
            creatorNameWithLink: creator.name
        });
        return null;
    };
    const creatorRender = getCreatorRender();
    const hideCreatorIcon = (0, $ieeJu.expValEquals)('platform_editor_agent_mentions', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes');
    if ((0, $iDrrr.fg)('jira_improve_agent_profile_for_a2a')) {
        const showRovoIcon = !hideCreatorIcon && creator?.type !== 'REMOTE_A2A';
        return creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.clickableItem
        }, showRovoIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.rovoIconWrapper,
            testId: "rovo-icon-wrapper",
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.RovoIcon), {
            appearance: "brand",
            size: "small"
        })) : null, creatorRender) : null;
    }
    return creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f5fec235121c7193$var$styles.clickableItem
    }, !hideCreatorIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f5fec235121c7193$var$styles.rovoIconWrapper,
        testId: "rovo-icon-wrapper",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.RovoIcon), {
        appearance: "brand",
        size: "small"
    })), creatorRender) : null;
};
const $f5fec235121c7193$export$e02348ba0b01a210 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { agentName: agentName, agentDescription: agentDescription, creatorRender: creatorRender, starCountRender: starCountRender, headingRender: headingRender, isStarred: isStarred, isHidden: isHidden, onStarToggle: onStarToggle, showStarButton: t1, renderAdditionalContent: renderAdditionalContent } = t0;
    const showStarButton = t1 === undefined ? true : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== agentName) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            as: "h2",
            size: "medium"
        }, agentName);
        $[0] = agentName;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== formatMessage || $[3] !== isHidden) {
        t3 = isHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.hiddenIconWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: formatMessage((0, $fNIRw.messages).hiddenTooltip),
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6h4xM.HiddenIcon), {
            label: formatMessage((0, $fNIRw.messages).hiddenIcon)
        })));
        $[2] = formatMessage;
        $[3] = isHidden;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== headingRender || $[6] !== t2 || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.075",
            xcss: $f5fec235121c7193$var$styles.headingWrapper
        }, t2, headingRender, t3);
        $[5] = headingRender;
        $[6] = t2;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== agentName || $[10] !== isStarred || $[11] !== onStarToggle || $[12] !== showStarButton) {
        t5 = showStarButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i4kCF.StarIconButton), {
            isStarred: isStarred,
            handleToggle: onStarToggle,
            agentName: agentName
        });
        $[9] = agentName;
        $[10] = isStarred;
        $[11] = onStarToggle;
        $[12] = showStarButton;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== t4 || $[15] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $f5fec235121c7193$var$styles.name,
            space: "space.100",
            alignBlock: "center"
        }, t4, t5);
        $[14] = t4;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    let t7;
    if ($[17] !== agentDescription) {
        t7 = !!agentDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.description,
            as: "p"
        }, agentDescription);
        $[17] = agentDescription;
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== renderAdditionalContent) {
        t8 = !!renderAdditionalContent && renderAdditionalContent();
        $[19] = renderAdditionalContent;
        $[20] = t8;
    } else t8 = $[20];
    let t9;
    if ($[21] !== creatorRender || $[22] !== starCountRender || $[23] !== t6 || $[24] !== t7 || $[25] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, t6, creatorRender, t7, starCountRender, t8);
        $[21] = creatorRender;
        $[22] = starCountRender;
        $[23] = t6;
        $[24] = t7;
        $[25] = t8;
        $[26] = t9;
    } else t9 = $[26];
    return t9;
} : ({ agentName: agentName, agentDescription: agentDescription, creatorRender: creatorRender, starCountRender: starCountRender, headingRender: headingRender, isStarred: isStarred, isHidden: isHidden, onStarToggle: onStarToggle, showStarButton: showStarButton = true, renderAdditionalContent: renderAdditionalContent })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $f5fec235121c7193$var$styles.name,
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.075",
        xcss: $f5fec235121c7193$var$styles.headingWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "h2",
        size: "medium"
    }, agentName), headingRender, isHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f5fec235121c7193$var$styles.hiddenIconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: formatMessage((0, $fNIRw.messages).hiddenTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6h4xM.HiddenIcon), {
        label: formatMessage((0, $fNIRw.messages).hiddenIcon)
    })))), showStarButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i4kCF.StarIconButton), {
        isStarred: isStarred,
        handleToggle: onStarToggle,
        agentName: agentName
    })), creatorRender, !!agentDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f5fec235121c7193$var$styles.description,
        as: "p"
    }, agentDescription), starCountRender, !!renderAdditionalContent && renderAdditionalContent());
};
module.exports["getAgentCreator"] = $f5fec235121c7193$export$7cbebf266a9bcc3c;
module.exports["AgentProfileCreator"] = $f5fec235121c7193$export$f35b2eeaa7e3db15;
module.exports["AgentProfileInfo"] = $f5fec235121c7193$export$e02348ba0b01a210;

});

parcelRegister("6h4xM", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bsSbN = parcelRequire("bsSbN");

const $fc7d462f5dd0deaa$export$bce21421c351deb1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bsSbN))), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bsSbN))), props);
module.exports["HiddenIcon"] = $fc7d462f5dd0deaa$export$bce21421c351deb1;

});

parcelRegister("i4kCF", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $6Cex3 = parcelRequire("6Cex3");


var $lbT4j = parcelRequire("lbT4j");


var $iMnC5 = parcelRequire("iMnC5");


var $4ssVW = parcelRequire("4ssVW");

const $fbe2d7b3097e2d22$var$styles = {
    hidden: "_1YKVNsdnbC"
};
const $fbe2d7b3097e2d22$export$703abb8bd2abdfa5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { isStarred: isStarred, handleToggle: handleToggle, visible: t1, agentName: agentName } = t0;
    const visible = t1 === undefined ? true : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const t2 = !visible && $fbe2d7b3097e2d22$var$styles.hidden;
    let t3;
    if ($[0] !== t2) {
        t3 = (0, $w6R6I.cx)(t2);
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== isHovered || $[3] !== isStarred) {
        t4 = (iconProps)=>isStarred || isHovered ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Cex3))), {
                ...iconProps,
                color: "var(--ds-icon-accent-orange, #E06C00)"
            }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbT4j))), {
                ...iconProps,
                color: "var(--ds-icon, #292A2E)"
            });
        $[2] = isHovered;
        $[3] = isStarred;
        $[4] = t4;
    } else t4 = $[4];
    const t5 = isStarred ? (0, $4ssVW.default).removeFromFavouritesLabel : (0, $4ssVW.default).clickToFavouriteLabel;
    let t6;
    if ($[5] !== agentName || $[6] !== formatMessage || $[7] !== t5) {
        t6 = formatMessage(t5, {
            agentName: agentName
        });
        $[5] = agentName;
        $[6] = formatMessage;
        $[7] = t5;
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    let t8;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = ()=>setIsHovered(true);
        t8 = ()=>setIsHovered(false);
        $[9] = t7;
        $[10] = t8;
    } else {
        t7 = $[9];
        t8 = $[10];
    }
    let t9;
    if ($[11] !== handleToggle || $[12] !== t4 || $[13] !== t6) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            appearance: "subtle",
            spacing: "compact",
            icon: t4,
            label: t6,
            onClick: handleToggle,
            onMouseEnter: t7,
            onMouseLeave: t8
        });
        $[11] = handleToggle;
        $[12] = t4;
        $[13] = t6;
        $[14] = t9;
    } else t9 = $[14];
    let t10;
    if ($[15] !== t3 || $[16] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: t3
        }, t9);
        $[15] = t3;
        $[16] = t9;
        $[17] = t10;
    } else t10 = $[17];
    return t10;
} : ({ isStarred: isStarred, handleToggle: handleToggle, visible: visible = true, agentName: agentName })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)(!visible && $fbe2d7b3097e2d22$var$styles.hidden)
    }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "subtle",
        spacing: "compact",
        icon: (iconProps)=>isStarred || isHovered ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Cex3))), {
                ...iconProps,
                color: "var(--ds-icon-accent-orange, #E06C00)"
            }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbT4j))), {
                ...iconProps,
                color: "var(--ds-icon, #292A2E)"
            }),
        label: formatMessage(isStarred ? (0, $4ssVW.default).removeFromFavouritesLabel : (0, $4ssVW.default).clickToFavouriteLabel, {
            agentName: agentName
        }),
        onClick: handleToggle,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false)
    }));
};
module.exports["StarIconButton"] = $fbe2d7b3097e2d22$export$703abb8bd2abdfa5;

});

parcelRegister("4ssVW", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $a47d9a7d981bdb91$var$message = (0, $kSwu1.defineMessages)({
    removeFromFavouritesLabel: {
        id: "rovo-chat.browse-agents.remove-from-favourites-label",
        defaultMessage: "Remove {agentName} from favourites"
    },
    clickToFavouriteLabel: {
        id: "rovo-chat.browse-agents.click-to-favourite-label",
        defaultMessage: "Add {agentName} to favourites"
    }
});
var $a47d9a7d981bdb91$export$2e2bcd8739ae039 = $a47d9a7d981bdb91$var$message;
module.exports["default"] = $a47d9a7d981bdb91$export$2e2bcd8739ae039;

});

parcelRegister("fNIRw", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $246a354bdf98d3ad$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    agentCreatedBy: {
        id: "ai-mate.agent-profile-info.created-by",
        defaultMessage: "Rovo Agent by {creatorNameWithLink}"
    },
    remoteAgentCreatedBy: {
        id: "ai-mate.agent-profile-info.agent-by",
        defaultMessage: "Agent by {creatorNameWithLink}"
    },
    agentDeactivated: {
        id: "ai-mate.agent-profile-info.deactivated",
        defaultMessage: "(deactivated)"
    },
    starredCount: {
        id: "ai-mate.agent-profile-info.starred-count",
        defaultMessage: "{count} starred"
    },
    hiddenIcon: {
        id: "ai-mate.agent-profile-info.hidden-icon",
        defaultMessage: "Hidden"
    },
    hiddenTooltip: {
        id: "ai-mate.agent-profile-info.hidden-tooltip",
        defaultMessage: "Agent won't show in search results"
    },
    starAgentTooltip: {
        id: "ai-mate.agent-profile-info.star-agent-tooltip",
        defaultMessage: "Star Agent"
    },
    creatorLabel: {
        id: "ai-mate.agent-profile-info.creator",
        defaultMessage: "Creator"
    }
});
module.exports["messages"] = $246a354bdf98d3ad$export$defe85febe8b728c;

});

parcelRegister("dSW04", function(module, exports) {
class $99c5d70c0df67415$export$a6d78d75d03919f1 extends Error {
    constructor(){
        super('Agent access forbidden');
        this.status = 403;
        this.name = 'AgentForbiddenError';
    }
}
module.exports["AgentForbiddenError"] = $99c5d70c0df67415$export$a6d78d75d03919f1;

});

parcelRegister("dRAjC", function(module, exports) {
const $d2643a1af3062f27$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $d2643a1af3062f27$export$3761e66a04602cbd = (ari)=>{
    return ari.replace($d2643a1af3062f27$export$470b0d72e4fdc43a, '');
};
module.exports["USER_ARI_PREFIX"] = $d2643a1af3062f27$export$470b0d72e4fdc43a;
module.exports["getAAIDFromARI"] = $d2643a1af3062f27$export$3761e66a04602cbd;

});

parcelRegister("4k5Wq", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $5avUB = parcelRequire("5avUB");


var $4aRua = parcelRequire("4aRua");


var $eU2tf = parcelRequire("eU2tf");


var $hHYlx = parcelRequire("hHYlx");


var $cSSWJ = parcelRequire("cSSWJ");

const $0f12e30f7425acf6$var$ErrorMessage = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(18);
    let t0;
    if ($[0] !== props.errorType) {
        t0 = props.errorType || {
            reason: "default"
        };
        $[0] = props.errorType;
        $[1] = t0;
    } else t0 = $[1];
    const errorType = t0;
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    let t1;
    let t2;
    if ($[2] !== errorReason || $[3] !== fireAnalytics || $[4] !== hasRetry) {
        t1 = ()=>{
            fireAnalytics("ui.profilecard.rendered.error", {
                hasRetry: hasRetry,
                errorType: errorReason,
                firedAt: Math.round(performance.now()),
                ...(0, $cSSWJ.PACKAGE_META_DATA)
            });
        };
        t2 = [
            errorReason,
            fireAnalytics,
            hasRetry
        ];
        $[2] = errorReason;
        $[3] = fireAnalytics;
        $[4] = hasRetry;
        $[5] = t1;
        $[6] = t2;
    } else {
        t1 = $[5];
        t2 = $[6];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[7] !== errorReason || $[8] !== reload) {
        t3 = ()=>{
            if (errorReason === "NotFound") return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hHYlx.ErrorTitle), {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                    ...(0, $eU2tf.default).errorUserNotFound
                })
            });
            return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hHYlx.ErrorTitle), {
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                        ...(0, $eU2tf.default).errorGeneric
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("br", {}),
                    reload && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        color: "color.text.subtlest",
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                            ...(0, $eU2tf.default).errorRetrySuggestion
                        })
                    })
                ]
            });
        };
        $[7] = errorReason;
        $[8] = reload;
        $[9] = t3;
    } else t3 = $[9];
    const errorContent = t3;
    let t4;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
            label: "icon error"
        });
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== errorContent) {
        t5 = errorContent();
        $[11] = errorContent;
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] !== reload) {
        t6 = reload && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
            onClick: reload,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                ...(0, $eU2tf.default).errorTryAgain
            })
        });
        $[13] = reload;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== t5 || $[16] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hHYlx.ErrorWrapper), {
            testId: "profilecard-error",
            children: [
                t4,
                t5,
                t6
            ]
        });
        $[15] = t5;
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    return t7;
} : (props)=>{
    const errorType = props.errorType || {
        reason: 'default'
    };
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    (0, $cozmU.useEffect)(()=>{
        fireAnalytics('ui.profilecard.rendered.error', {
            hasRetry: hasRetry,
            errorType: errorReason,
            firedAt: Math.round(performance.now()),
            ...(0, $cSSWJ.PACKAGE_META_DATA)
        });
    }, [
        errorReason,
        fireAnalytics,
        hasRetry
    ]);
    const errorContent = ()=>{
        if (errorReason === 'NotFound') return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hHYlx.ErrorTitle), {
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                ...(0, $eU2tf.default).errorUserNotFound
            })
        });
        return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hHYlx.ErrorTitle), {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                    ...(0, $eU2tf.default).errorGeneric
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("br", {}),
                reload && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                    color: "color.text.subtlest",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                        ...(0, $eU2tf.default).errorRetrySuggestion
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hHYlx.ErrorWrapper), {
        testId: "profilecard-error",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
                label: "icon error"
            }),
            errorContent(),
            reload && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                onClick: reload,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                    ...(0, $eU2tf.default).errorTryAgain
                })
            })
        ]
    });
};
var $0f12e30f7425acf6$export$2e2bcd8739ae039 = $0f12e30f7425acf6$var$ErrorMessage;
module.exports["default"] = $0f12e30f7425acf6$export$2e2bcd8739ae039;

});

parcelRegister("eU2tf", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $fe57f9d19e98fdc0$var$messages = (0, $kSwu1.defineMessages)({
    inactiveAccountMsg: {
        id: "pt.profile-card.inactive.account",
        defaultMessage: "Account deactivated"
    },
    generalDescMsgForDisabledUser: {
        id: "pt.profile-card.general.msg.disabled.user",
        defaultMessage: "You can no longer collaborate with this person."
    },
    inactiveAccountDescMsgNoDate: {
        id: "pt.profile-card.inactive.account.no.date",
        defaultMessage: "Their account has been deactivated."
    },
    inactiveAccountDescMsgHasDateThisWeek: {
        id: "pt.profile-card.inactive.account.has.date.this.week",
        defaultMessage: "Their account was deactivated this week."
    },
    inactiveAccountDescMsgHasDateThisMonth: {
        id: "pt.profile-card.inactive.account.has.date.this.month",
        defaultMessage: "Their account was deactivated this month."
    },
    inactiveAccountDescMsgHasDateLastMonth: {
        id: "pt.profile-card.inactive.account.has.date.last.month",
        defaultMessage: "Their account was deactivated last month."
    },
    inactiveAccountDescMsgHasDateAFewMonths: {
        id: "pt.profile-card.inactive.account.has.date.a.few.months",
        defaultMessage: "Their account has been deactivated for a few months."
    },
    inactiveAccountDescMsgHasDateSeveralMonths: {
        id: "pt.profile-card.inactive.account.has.date.several.months",
        defaultMessage: "Their account has been deactivated for several months."
    },
    inactiveAccountDescMsgHasDateMoreThanAYear: {
        id: "pt.profile-card.inactive.account.has.date.more.than.a.year",
        defaultMessage: "Their account has been deactivated for more than a year."
    },
    closedAccountMsg: {
        id: "pt.profile-card.closed.account",
        defaultMessage: "Account deleted"
    },
    closedAccountDescMsgNoDate: {
        id: "pt.profile-card.closed.account.no.date",
        defaultMessage: "Their account has been deleted."
    },
    closedAccountDescMsgHasDateThisWeek: {
        id: "pt.profile-card.closed.account.has.date.this.week",
        defaultMessage: "Their account was deleted this week."
    },
    closedAccountDescMsgHasDateThisMonth: {
        id: "pt.profile-card.closed.account.has.date.this.month",
        defaultMessage: "Their account was deleted this month."
    },
    closedAccountDescMsgHasDateLastMonth: {
        id: "pt.profile-card.closed.account.has.date.last.month",
        defaultMessage: "Their account was deleted last month."
    },
    closedAccountDescMsgHasDateAFewMonths: {
        id: "pt.profile-card.closed.account.has.date.a.few.months",
        defaultMessage: "Their account has been deleted for a few months."
    },
    closedAccountDescMsgHasDateSeveralMonths: {
        id: "pt.profile-card.closed.account.has.date.several.months",
        defaultMessage: "Their account has been deleted for several months."
    },
    closedAccountDescMsgHasDateMoreThanAYear: {
        id: "pt.profile-card.closed.account.has.date.more.than.a.year",
        defaultMessage: "Their account has been deleted for more than a year."
    },
    disabledAccountDefaultName: {
        id: "pt.profile-card.disabled.account.default.name",
        defaultMessage: "Former user"
    },
    teamViewProfile: {
        id: "pt.team-profile-card.team.action.view-profile",
        defaultMessage: "View profile"
    },
    memberCount: {
        id: "pt.team-profile-card.team.member.count",
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}"
    },
    memberCountIncludingYou: {
        id: "pt.team-profile-card.team.member.count-including-you",
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you"
    },
    membersMoreThan50: {
        id: "pt.team-profile-card.team.member.many",
        defaultMessage: "Team \u2022 50+ members"
    },
    membersMoreThan50IncludingYou: {
        id: "pt.team-profile-card.team.member.many-including-you",
        defaultMessage: "Team \u2022 50+ members, including you"
    },
    teamErrorTitle: {
        id: "pt.team-profile-card.error.title",
        defaultMessage: "We\u2019re having trouble retrieving this teams information"
    },
    teamErrorText: {
        id: "pt.team-profile-card.error.suggestion",
        defaultMessage: "Wait a few moments, then try again."
    },
    teamErrorButton: {
        id: "pt.team-profile-card.error.refresh-button",
        defaultMessage: "Try again"
    },
    teamForbiddenErrorStateTitle: {
        id: "pt.team-profile-card.forbidden-error-state.title",
        defaultMessage: "We can\u2019t show you this team"
    },
    teamForbiddenErrorStateDescription: {
        id: "pt.team-profile-card.forbidden-error-state.description",
        defaultMessage: "You don\u2019t have access to view this team."
    },
    managerSectionHeading: {
        id: "pt.team-profile-card.manager.heading",
        defaultMessage: "Manager"
    },
    directReportsSectionHeading: {
        id: "pt.team-profile-card.directReports.heading",
        defaultMessage: "Direct reports"
    },
    teamProfileCardAriaLabel: {
        id: "pt.team-profile-card.aria-label",
        defaultMessage: "More information about this team"
    },
    giveKudosButton: {
        id: "pt.profile-card.give-kudos",
        defaultMessage: "Give kudos"
    },
    // Remove this as part of the FG Cleanup for jfp_a11y_team_profile_card_actions_label
    profileCardMoreIconLabel: {
        id: "pt.profile-card.more-icon-label",
        defaultMessage: "More"
    },
    profileCardMoreIconLabelWithName: {
        id: "pt.profile-card.more-icon-label-with-name",
        defaultMessage: "More actions for {fullName}"
    },
    profileCardMoreReportingLinesLabel: {
        id: "pt.user-profile-card.reporting-lines.more-icon-label",
        defaultMessage: "+{count} more {count, plural, one {profile} other {profiles}}"
    },
    profileCardMoreMembersLabel: {
        id: "pt.team.profile-card.members.more-icon-label",
        defaultMessage: "+{count} more {count, plural, one {members} other {members}}"
    },
    archivedLozenge: {
        id: "pt.team-profile-card.archived-lozenge",
        defaultMessage: "Archived"
    },
    errorUserNotFound: {
        id: "pt.profile-card.error.user-not-found",
        defaultMessage: "The user is no longer available for the site"
    },
    errorGeneric: {
        id: "pt.profile-card.error.generic",
        defaultMessage: "Oops, looks like we\u2019re having issues"
    },
    errorRetrySuggestion: {
        id: "pt.profile-card.error.retry-suggestion",
        defaultMessage: "Try again and we\u2019ll give it another shot"
    },
    errorTryAgain: {
        id: "pt.profile-card.error.try-again-button",
        defaultMessage: "Try again"
    },
    errorDialogLabel: {
        id: "pt.profile-card.error.dialog-label",
        defaultMessage: "Profile card error"
    },
    loadingDialogLabel: {
        id: "pt.profile-card.loading.dialog-label",
        defaultMessage: "Loading profile card"
    },
    serviceAccountLabel: {
        id: "pt.profile-card.service-account.label",
        defaultMessage: "SERVICE ACCOUNT"
    },
    botAccountLabel: {
        id: "pt.profile-card.bot-account.label",
        defaultMessage: "APP"
    },
    viewManagerProfile: {
        id: "pt.profile-card.view-manager-profile",
        defaultMessage: "View {name} profile"
    }
});
var $fe57f9d19e98fdc0$export$2e2bcd8739ae039 = $fe57f9d19e98fdc0$var$messages;
module.exports["default"] = $fe57f9d19e98fdc0$export$2e2bcd8739ae039;

});

parcelRegister("hHYlx", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");

const $3b2daa1fed2d9894$var$styles = {
    errorWrapper: "_2fwxA5DIqT _0Of8r2NHnM _1ZnuxbNHnM _1wydGWNHnM _2Zuz6QNHnM",
    errorTitle: "_3138422ADO",
    teamErrorText: "_1UtDYzKGUX _3138422ADO"
};
const $3b2daa1fed2d9894$export$bb27b7e39840238f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $w6R6I.cx)($3b2daa1fed2d9894$var$styles.errorWrapper);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: t0,
            ...props
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($3b2daa1fed2d9894$var$styles.errorWrapper),
        ...props
    });
const $3b2daa1fed2d9894$export$b065fd053267ec81 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props.children) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $3b2daa1fed2d9894$var$styles.errorTitle,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                color: "color.text",
                children: props.children
            })
        });
        $[0] = props.children;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $3b2daa1fed2d9894$var$styles.errorTitle,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            color: "color.text",
            children: props.children
        })
    });
const $3b2daa1fed2d9894$export$90d92ccfb27352c6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $w6R6I.cx)($3b2daa1fed2d9894$var$styles.teamErrorText);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props.children) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: t0,
            children: props.children
        });
        $[1] = props.children;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($3b2daa1fed2d9894$var$styles.teamErrorText),
        children: props.children
    });
module.exports["ErrorWrapper"] = $3b2daa1fed2d9894$export$bb27b7e39840238f;
module.exports["ErrorTitle"] = $3b2daa1fed2d9894$export$b065fd053267ec81;

});

parcelRegister("kb2tZ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $ieeJu = parcelRequire("ieeJu");

const $d107d3e886647d93$var$styles = {
    wrapper: "_0bjKvD8fU6 _39xV02wBC3 _0KLXruoI2d _2OUyjtGk8v",
    wrapperLegacy: "_0bjKvD8fU6 _39xV02wBC3 _0KLXruoI2d"
};
const $d107d3e886647d93$export$2c6604b50c274e6f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children } = t0;
    if ((0, $ieeJu.expValEquals)("platform_editor_agent_mentions", "isEnabled", true) && (0, $iDrrr.fg)("platform_editor_agent_mentions_drop_one_fixes")) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $d107d3e886647d93$var$styles.wrapper,
                children: children
            });
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== children) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $d107d3e886647d93$var$styles.wrapperLegacy,
            children: children
        });
        $[2] = children;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ children: children })=>{
    if ((0, $ieeJu.expValEquals)('platform_editor_agent_mentions', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes')) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $d107d3e886647d93$var$styles.wrapper,
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $d107d3e886647d93$var$styles.wrapperLegacy,
        children: children
    });
};
module.exports["AgentProfileCardWrapper"] = $d107d3e886647d93$export$2c6604b50c274e6f;

});

parcelRegister("hIwXM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $795534535f4e0b8b$export$ed0ca9c1d49ea0bf = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("8pnTc")));
module.exports["AgentProfileCardLazy"] = $795534535f4e0b8b$export$ed0ca9c1d49ea0bf;

});

parcelRegister("8pnTc", function(module, exports) {

let $61f33076240dfb08$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $61f33076240dfb08$var$load("gw4CZ"),
    $61f33076240dfb08$var$load("d1Ddn"),
    $61f33076240dfb08$var$load("6wr18"),
    $61f33076240dfb08$var$load("fe1dp"),
    $61f33076240dfb08$var$load("h4UiS"),
    $61f33076240dfb08$var$load("jqoep"),
    $61f33076240dfb08$var$load("7EorR"),
    $61f33076240dfb08$var$load("ea3NB"),
    $61f33076240dfb08$var$load("ffEVr"),
    $61f33076240dfb08$var$load("hhss7"),
    $61f33076240dfb08$var$load("68aog")
]).then(()=>parcelRequire('ark00'));

});

parcelRegister("kfLla", function(module, exports) {
/* UserPicker.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $lzgC6 = parcelRequire("lzgC6");


var $Vh9GY = parcelRequire("Vh9GY");


var $6wGOF = parcelRequire("6wGOF");


var $j7Sza = parcelRequire("j7Sza");


var $dtWeq = parcelRequire("dtWeq");


var $aZ910 = parcelRequire("aZ910");


var $bmH9E = parcelRequire("bmH9E");


var $i7OwT = parcelRequire("i7OwT");


var $al9c2 = parcelRequire("al9c2");


var $1aEbM = parcelRequire("1aEbM");


var $7HZsv = parcelRequire("7HZsv");


var $aeELu = parcelRequire("aeELu");


var $03RpJ = parcelRequire("03RpJ");


var $iDrrr = parcelRequire("iDrrr");

function $039672e380479ab5$var$_defineProperty(e, r, t) {
    return (r = $039672e380479ab5$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $039672e380479ab5$var$_toPropertyKey(t) {
    var i = $039672e380479ab5$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $039672e380479ab5$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
class $039672e380479ab5$export$164f4d95e5d7e2f5 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidMount() {
        const experienceForId = (0, $aZ910.userPickerRenderedUfoExperience).getInstance(this.ufoId); // Send UFO success if the experience is still in progress i.e. hasn't failed
        if ([
            (0, $j7Sza.UFOExperienceState).IN_PROGRESS.id,
            (0, $j7Sza.UFOExperienceState).STARTED.id
        ].includes(experienceForId.state.id)) experienceForId.success();
    }
    render() {
        const { emailLabel: emailLabel, allowEmail: allowEmail, suggestEmailsForDomain: suggestEmailsForDomain, isMulti: isMulti, isValidEmail: isValidEmail, anchor: anchor, menuPortalTarget: menuPortalTarget, menuPosition: menuPosition, menuShouldBlockScroll: menuShouldBlockScroll, captureMenuScroll: captureMenuScroll, closeMenuOnScroll: closeMenuOnScroll, loadUserSource: loadUserSource, menuIsOpen: menuIsOpen, required: required = false, showClearIndicator: showClearIndicator = false, includeTeamsUpdates: includeTeamsUpdates = false } = this.props;
        const width = this.props.width;
        const SelectComponent = allowEmail ? (0, $Vh9GY.default) : (0, $6wGOF.default);
        const creatableProps = suggestEmailsForDomain ? (0, $7HZsv.getCreatableSuggestedEmailProps)(suggestEmailsForDomain, isValidEmail) : (0, $1aEbM.getCreatableProps)(isValidEmail);
        const defaultPickerProps = {
            closeMenuOnScroll: closeMenuOnScroll,
            menuPortalTarget: menuPortalTarget,
            menuPosition: menuPosition,
            menuShouldBlockScroll: menuShouldBlockScroll,
            captureMenuScroll: captureMenuScroll,
            required: required,
            includeTeamsUpdates: includeTeamsUpdates,
            menuIsOpen: menuIsOpen
        };
        const pickerProps = allowEmail ? {
            ...defaultPickerProps,
            ...creatableProps,
            emailLabel: emailLabel
        } : {
            ...defaultPickerProps
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aZ910.UfoErrorBoundary), {
            id: this.ufoId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i7OwT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dtWeq.ExusUserSourceProvider), {
            fetchUserSource: loadUserSource
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bmH9E.BaseUserPickerWithoutAnalytics), {
            ...this.props,
            forwardedRef: this.props.forwardedRef,
            width: width,
            SelectComponent: SelectComponent,
            styles: (0, $aeELu.getStyles)(width, isMulti, this.props.appearance === 'compact', this.props.styles, (0, $iDrrr.fg)('platform-component-visual-refresh'), false, this.props.height, this.props.minHeight),
            components: (0, $al9c2.getComponents)(isMulti, anchor, showClearIndicator, this.props?.components ? this.props.components : {}),
            pickerProps: pickerProps
        }))));
    }
    constructor(props){
        super(props); // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        $039672e380479ab5$var$_defineProperty(this, "ufoId", void 0);
        this.ufoId = (0, $03RpJ.default)();
        const experienceForId = (0, $aZ910.userPickerRenderedUfoExperience).getInstance(this.ufoId);
        if (![
            (0, $j7Sza.UFOExperienceState).IN_PROGRESS.id,
            (0, $j7Sza.UFOExperienceState).STARTED.id
        ].includes(experienceForId.state.id)) experienceForId.start();
    }
}
$039672e380479ab5$var$_defineProperty($039672e380479ab5$export$164f4d95e5d7e2f5, "defaultProps", {
    width: 350,
    isMulti: false
});
const $039672e380479ab5$export$83e0c73b09b3a9cd = (0, $lzgC6.default)()($039672e380479ab5$export$164f4d95e5d7e2f5);
module.exports["UserPicker"] = $039672e380479ab5$export$83e0c73b09b3a9cd;

});

parcelRegister("dtWeq", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $50iN8 = parcelRequire("50iN8");

const $fff7213ad440f373$export$bcd5c65b586ee3c3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { fetchUserSource: fetchUserSource, children: children } = t0;
    let t1;
    if ($[0] !== fetchUserSource) {
        t1 = {
            fetchUserSource: fetchUserSource
        };
        $[0] = fetchUserSource;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $50iN8.ExusUserSourceContext).Provider, {
            value: t1
        }, children);
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ fetchUserSource: fetchUserSource, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $50iN8.ExusUserSourceContext).Provider, {
        value: {
            fetchUserSource: fetchUserSource
        }
    }, children);
module.exports["ExusUserSourceProvider"] = $fff7213ad440f373$export$bcd5c65b586ee3c3;

});

parcelRegister("50iN8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $bfa0c313f69ddec7$export$1d6a09af71ef4ab1 = /*#__PURE__*/ (0, $cozmU.createContext)({});
module.exports["ExusUserSourceContext"] = $bfa0c313f69ddec7$export$1d6a09af71ef4ab1;

});

parcelRegister("aZ910", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4MiWC = parcelRequire("4MiWC");


var $fh15z = parcelRequire("fh15z");


var $j7Sza = parcelRequire("j7Sza");

const $e55e5f2e4b7d5736$export$b49757166e1acfc2 = new (0, $fh15z.ConcurrentExperience)('user-picker-rendered', {
    platform: {
        component: 'user-picker'
    },
    type: (0, $4MiWC.ExperienceTypes).Load,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).PageSegmentLoad
});
const $e55e5f2e4b7d5736$export$135a264e0da507ae = new (0, $fh15z.ConcurrentExperience)('user-picker-options-shown', {
    platform: {
        component: 'user-picker'
    },
    type: (0, $4MiWC.ExperienceTypes).Operation,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).InlineResult
});
class $e55e5f2e4b7d5736$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidCatch() {
        const instance = $e55e5f2e4b7d5736$export$b49757166e1acfc2.getInstance(this.props.id);
        if (instance.state.id !== (0, $j7Sza.UFOExperienceState).FAILED.id) instance.failure();
    }
    render() {
        return this.props.children;
    }
}
module.exports["userPickerRenderedUfoExperience"] = $e55e5f2e4b7d5736$export$b49757166e1acfc2;
module.exports["userPickerOptionsShownUfoExperience"] = $e55e5f2e4b7d5736$export$135a264e0da507ae;
module.exports["UfoErrorBoundary"] = $e55e5f2e4b7d5736$export$5ef1c2550074a375;

});

parcelRegister("bmH9E", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $55fM8 = parcelRequire("55fM8");


var $kSwu1 = parcelRequire("kSwu1");


var $lzgC6 = parcelRequire("lzgC6");


var $j7Sza = parcelRequire("j7Sza");


var $03RpJ = parcelRequire("03RpJ");


var $4hbXV = parcelRequire("4hbXV");


var $jc3SO = parcelRequire("jc3SO");


var $99MwU = parcelRequire("99MwU");


var $ltaNM = parcelRequire("ltaNM");


var $7YQXO = parcelRequire("7YQXO");


var $6p4Td = parcelRequire("6p4Td");


var $9f4Hk = parcelRequire("9f4Hk");


var $hyMtt = parcelRequire("hyMtt");


var $abzFz = parcelRequire("abzFz");


var $1Xd8s = parcelRequire("1Xd8s");


var $aZ910 = parcelRequire("aZ910");


var $a4iVb = parcelRequire("a4iVb");


var $6YyLn = parcelRequire("6YyLn");


var $frJkr = parcelRequire("frJkr");


var $7xLai = parcelRequire("7xLai");


var $A8EPJ = parcelRequire("A8EPJ");


var $elhMC = parcelRequire("elhMC");


var $2Ivef = parcelRequire("2Ivef");


var $a9YvT = parcelRequire("a9YvT");


var $f1uNX = parcelRequire("f1uNX");

const $a288f8d93fd9b6f7$var$loadingMessage = ()=>null;
const $a288f8d93fd9b6f7$var$classNamePrefix = 'fabric-user-picker';
class $a288f8d93fd9b6f7$export$b4ff48c8d43b18c3 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    static getDerivedStateFromProps(nextProps, prevState) {
        const derivedState = {};
        if (nextProps.isDisabled || nextProps.disableInput) derivedState.menuIsOpen = false;
        if (nextProps.open !== undefined) derivedState.menuIsOpen = nextProps.open;
        if (nextProps.value !== undefined) derivedState.value = (0, $f1uNX.optionToSelectableOptions)(nextProps.value);
        else if ((0, $A8EPJ.isDefaultValuePopulated)(nextProps.defaultValue) && !prevState.isDefaultSet) {
            derivedState.value = (0, $f1uNX.optionToSelectableOptions)(nextProps.defaultValue);
            derivedState.isDefaultSet = true;
        }
        if (nextProps.search !== undefined && nextProps.search !== prevState.inputValue) derivedState.inputValue = nextProps.search;
        if (nextProps.options !== undefined) derivedState.options = nextProps.options;
        return derivedState;
    }
    get isMenuOpenOnClickForSingleSelect() {
        return this.props.openMenuOnClick && !this.props.isMulti;
    }
    componentDidMount() {
        const { open: open, search: search } = this.props;
        // load options when the picker open
        if (open) {
            if (!this.session) this.startSession();
            this.executeLoadOptions(search);
        }
    }
    componentDidUpdate(prevProps, prevState) {
        const { menuIsOpen: menuIsOpen, options: options, resolving: resolving, count: count, inputValue: inputValue } = this.state;
        // Close menu when isFooterFocused or isHeaderFocused changes from true to false
        if (menuIsOpen && (prevProps.isFooterFocused === true && this.props.isFooterFocused === false || prevProps.isHeaderFocused === true && this.props.isHeaderFocused === false) && !this.shouldKeepMenuOpen()) {
            this.resetInputState();
            (0, $6YyLn.callCallback)(this.props.onClose, this.getSessionId());
            this.setState({
                menuIsOpen: false,
                options: []
            });
        }
        // Create a new session when the menu is opened and there is no session
        if (menuIsOpen && !prevState.menuIsOpen && !this.session) this.startSession();
        // Load options when user picker opens or when input value changes
        if (menuIsOpen && !prevState.menuIsOpen || inputValue !== prevState.inputValue) this.executeLoadOptions(inputValue);
        if (!menuIsOpen && prevState.menuIsOpen && this.session) {
            this.fireEvent((0, $jc3SO.cancelEvent), prevState);
            this.session = undefined;
        }
        if (menuIsOpen && (!prevState.menuIsOpen && options.length > 0 || options.length !== prevState.options.length)) this.fireEvent((0, $9f4Hk.searchedEvent));
        if (this.state.inputValue !== prevState.inputValue) {
            if (this.session) this.session.inputChangeTime = Date.now();
        }
        if (menuIsOpen && (!prevProps.loadOptions || prevState.menuIsOpen) && count === 0 && !resolving && [
            (0, $j7Sza.UFOExperienceState).STARTED.id,
            (0, $j7Sza.UFOExperienceState).IN_PROGRESS.id
        ].includes(this.optionsShownUfoExperienceInstance.state.id)) this.optionsShownUfoExperienceInstance.success();
    }
    get ariaProps() {
        const ariaLabels = Object.keys(this.props).filter((key)=>key.startsWith('aria-'));
        const props = {
            ...this.props
        };
        return ariaLabels.reduce((obj, key)=>({
                ...obj,
                [key]: props[key]
            }), {});
    }
    render() {
        const { isMulti: isMulti, isLoading: isLoading, subtle: subtle, noBorder: noBorder, placeholder: placeholder, isClearable: isClearable, isDisabled: isDisabled, isInvalid: isInvalid, clearValueLabel: clearValueLabel, menuMinWidth: menuMinWidth, menuPortalTarget: menuPortalTarget, loadOptionsErrorMessage: loadOptionsErrorMessage, addMoreMessage: addMoreMessage, noOptionsMessage: noOptionsMessage, footer: footer, disableInput: disableInput, components: components, pickerProps: pickerProps, SelectComponent: SelectComponent, styles: styles, autoFocus: autoFocus, fieldId: fieldId, inputId: inputId, maxPickerHeight: maxPickerHeight, textFieldBackgroundColor: textFieldBackgroundColor, ariaLabelledBy: ariaLabelledBy, ariaDescribedBy: ariaDescribedBy, ariaLive: ariaLive, ariaLabel: ariaLabel, name: name, header: header, required: required, UNSAFE_hasDraggableParentComponent: UNSAFE_hasDraggableParentComponent, placeholderAvatar: placeholderAvatar } = this.props;
        const { count: count, hoveringClearIndicator: hoveringClearIndicator, menuIsOpen: menuIsOpen, value: value, inputValue: inputValue, resolving: resolving, showError: showError } = this.state;
        const appearance = this.getAppearance();
        // these props override the default select menu open and close
        const menuOpenDeciderProps = {
            ...!this.isMenuOpenOnClickForSingleSelect && {
                menuIsOpen: menuIsOpen,
                blurInputOnSelect: !isMulti,
                openMenuOnFocus: this.props.openMenuOnFocus ?? true
            }
        };
        const { 'aria-labelledby': ariaLabelledByStandard, 'aria-describedby': ariaDescribedByStandard, ...restAriaProps } = this.ariaProps;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SelectComponent, {
            name: name,
            value: value,
            autoFocus: autoFocus !== undefined ? autoFocus : menuIsOpen,
            labelId: ariaLabelledBy ?? ariaLabelledByStandard,
            descriptionId: ariaDescribedBy ?? ariaDescribedByStandard,
            "aria-live": ariaLive,
            "aria-required": required,
            required: required,
            ref: this.handleSelectRef,
            isMulti: isMulti,
            options: this.getOptions(),
            styles: styles,
            enableAnimation: isMulti,
            components: components,
            inputValue: inputValue,
            isLoading: count > 0 || resolving || isLoading,
            loadingMessage: $a288f8d93fd9b6f7$var$loadingMessage,
            menuPlacement: "auto",
            placeholder: placeholder ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $7xLai.messages).placeholder),
            label: ariaLabel,
            addMoreMessage: addMoreMessage,
            classNamePrefix: $a288f8d93fd9b6f7$var$classNamePrefix,
            hoveringClearIndicator: hoveringClearIndicator,
            appearance: appearance,
            isClearable: isClearable,
            noBorder: noBorder,
            subtle: subtle,
            closeMenuOnSelect: !isMulti,
            noOptionsMessage: showError ? loadOptionsErrorMessage : typeof noOptionsMessage === 'function' ? noOptionsMessage : ()=>noOptionsMessage,
            footer: footer,
            isDisabled: isDisabled,
            isInvalid: isInvalid,
            isFocused: menuIsOpen,
            backspaceRemovesValue: isMulti,
            filterOption: null,
            clearValueLabel: clearValueLabel,
            menuMinWidth: menuMinWidth,
            menuPortalTarget: menuPortalTarget,
            disableInput: disableInput || isDisabled,
            instanceId: fieldId,
            inputId: inputId,
            onChange: this.handleChange,
            onMenuOpen: this.handleOpen,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            onMenuClose: this.handleClose,
            onInputChange: this.handleInputChange,
            onClearIndicatorHover: this.handleClearIndicatorHover,
            onKeyDown: this.handleKeyDown,
            maxPickerHeight: maxPickerHeight,
            textFieldBackgroundColor: textFieldBackgroundColor,
            header: header,
            placeholderAvatar: placeholderAvatar,
            ...restAriaProps,
            ...pickerProps,
            ...UNSAFE_hasDraggableParentComponent && {
                onValueContainerClick: this.handleClickDraggableParentComponent
            },
            ...menuOpenDeciderProps
        });
    }
    constructor(props){
        super(props);
        this.selectRef = void 0;
        this.session = void 0;
        // session id for focus to blur
        this.journeyId = void 0;
        this.optionsShownUfoExperienceInstance = void 0;
        this.getSessionId = ()=>this.session && this.session.id ? this.session.id : undefined;
        this.withSelectRef = (callback)=>()=>{
                if (this.selectRef) callback(this.selectRef);
            };
        this.nextOption = this.withSelectRef((select)=>select.focusOption('down'));
        this.previousOption = this.withSelectRef((select)=>select.focusOption('up'));
        this.focus = ()=>{
            if (this.selectRef && this.selectRef.focus) this.selectRef.focus();
        };
        this.blur = ()=>{
            if (this.selectRef && this.selectRef.blur) this.selectRef.blur();
        };
        this.selectOption = this.withSelectRef((select)=>{
            const focusedOption = select.state.focusedOption;
            select.selectOption(focusedOption);
        });
        // value = null if user deletes the last item in the user picker
        this.handleChange = (value, { action: action, removedValue: removedValue, option: option })=>{
            if (removedValue && removedValue.data.fixed) return;
            this.resetInputState();
            const { onChange: onChange, onSelection: onSelection, onClear: onClear, isMulti: isMulti } = this.props;
            (0, $6YyLn.callCallback)(onChange, (0, $frJkr.extractOptionValue)(value), action);
            switch(action){
                case 'select-option':
                    if (value) (0, $6YyLn.callCallback)(onSelection, (0, $frJkr.extractOptionValue)(value), this.getSessionId(), this);
                    this.fireEvent((0, $hyMtt.selectEvent), isMulti ? option : value);
                    this.session = isMulti ? (0, $abzFz.startSession)() : undefined;
                    break;
                case 'clear':
                    (0, $6YyLn.callCallback)(onClear);
                    this.fireEvent((0, $99MwU.clearEvent));
                    break;
                case 'remove-value':
                case 'pop-value':
                    if (removedValue) this.fireEvent((0, $ltaNM.deleteEvent), removedValue.data);
                    break;
            }
            this.fireEvent((0, $9f4Hk.searchedEvent));
            if (removedValue && this.state.value && Array.isArray(this.state.value)) {
                const remainingValues = this.state.value.filter((val)=>val.data.id !== removedValue.data.id);
                this.setState({
                    value: remainingValues ? remainingValues : [],
                    menuIsOpen: true
                });
            }
            if (!this.props.value) this.setState({
                value: value ? value : []
            });
        };
        this.handleSelectRef = (ref)=>{
            this.selectRef = ref;
        };
        this.addOptions = (0, $a4iVb.batchByKey)((request, newOptions)=>{
            const { resolving: resolving } = this.state;
            this.setState(({ inflightRequest: inflightRequest, options: options, count: count })=>{
                if (inflightRequest.toString() === request) return {
                    options: (resolving ? options : []).concat(newOptions.reduce((nextOptions, item)=>Array.isArray(item) ? nextOptions.concat(item[0]) : nextOptions.concat(item), [])),
                    count: count - newOptions.length,
                    resolving: count - newOptions.length !== 0
                };
                return null;
            });
        });
        this.handleLoadOptionsError = ()=>{
            const { count: count } = this.state;
            const newCount = count - 1;
            const resolving = newCount !== 0;
            let showError = false;
            if (!resolving) showError = true;
            this.setState({
                count: newCount,
                resolving: resolving,
                showError: showError
            });
            this.fireEvent((0, $7YQXO.failedEvent));
        };
        this.debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))((search)=>{
            const { loadOptions: loadOptions } = this.props;
            if (loadOptions) {
                const inflightRequest = this.state.inflightRequest + 1;
                const result = this.session && this.session.id ? loadOptions(search, this.session.id) : loadOptions(search);
                const addOptions = this.addOptions.bind(this, inflightRequest.toString());
                let count = 0;
                if ((0, $elhMC.isIterable)(result)) for (const value of result){
                    Promise.resolve(value).then(addOptions).catch(this.handleLoadOptionsError);
                    count++;
                }
                else {
                    Promise.resolve(result).then(addOptions).catch(this.handleLoadOptionsError);
                    count++;
                }
                this.setState({
                    inflightRequest: inflightRequest,
                    count: count,
                    resolving: count !== 0,
                    options: []
                });
            }
        }, 200);
        this.abortOptionsShownUfoExperience = ()=>{
            if (this.optionsShownUfoExperienceInstance.state.id === (0, $j7Sza.UFOExperienceState).STARTED.id) // There may be an existing UFO timing running from previous key entry or focus,
            // so abort it and restart it just in case.
            this.optionsShownUfoExperienceInstance.abort();
        };
        this.startOptionsShownUfoExperience = ()=>{
            this.abortOptionsShownUfoExperience();
            this.optionsShownUfoExperienceInstance.start();
        };
        this.executeLoadOptions = (search)=>{
            const { loadOptions: loadOptions } = this.props;
            if (loadOptions) this.setState({
                resolving: true,
                showError: false
            }, ()=>this.debouncedLoadOptions(search));
        };
        this.handleFocus = (event)=>{
            const { value: value, menuIsOpen: menuIsOpen } = this.state;
            if (!menuIsOpen || !this.session) this.startSession();
            this.startOptionsShownUfoExperience();
            (0, $6YyLn.callCallback)(this.props.onFocus, this.getSessionId());
            const openMenuOnFocus = this.props.openMenuOnFocus ?? true;
            if (!this.isMenuOpenOnClickForSingleSelect && openMenuOnFocus) {
                this.setState({
                    menuIsOpen: true
                });
                if (!this.props.isMulti && (0, $a9YvT.isSingleValue)(value)) {
                    const input = event.target;
                    this.setState({
                        inputValue: value.label
                    }, ()=>{
                        if (input instanceof HTMLInputElement) input.setSelectionRange(0, value.label.length);
                    });
                }
            }
        };
        this.resetInputState = ()=>{
            // Prevent filter if query typed, then blurred with no selection
            this.setState({
                inputValue: ''
            });
            (0, $6YyLn.callCallback)(this.props.onInputChange, '', this.getSessionId());
        };
        this.handleOpen = ()=>{
            (0, $6YyLn.callCallback)(this.props.onOpen, this.getSessionId());
            this.setState({
                menuIsOpen: true
            });
        };
        this.handleBlur = ()=>{
            if (this.props.isFooterFocused || this.props.isHeaderFocused) return;
            (0, $6YyLn.callCallback)(this.props.onBlur, this.getSessionId());
            if ((0, $2Ivef.isPopupUserPickerByComponent)(this.props.SelectComponent)) return;
            this.resetInputState();
            this.abortOptionsShownUfoExperience();
            this.setState({
                menuIsOpen: false,
                initialFocusHandled: false,
                options: []
            });
        };
        this.handleClose = ()=>{
            if (this.props.isFooterFocused || this.props.isHeaderFocused) return;
            this.resetInputState();
            (0, $6YyLn.callCallback)(this.props.onClose, this.getSessionId());
            this.setState({
                menuIsOpen: false,
                options: []
            });
        };
        this.handleInputChange = (search, { action: action })=>{
            if (action === 'input-change' || action === 'set-value') {
                (0, $6YyLn.callCallback)(this.props.onInputChange, search, this.getSessionId());
                this.setState({
                    inputValue: search
                });
                this.startOptionsShownUfoExperience();
            }
        };
        this.fireEvent = (eventCreator, ...args)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) (0, $4hbXV.createAndFireEventInElementsChannel)(eventCreator(this.props, this.state, this.session, this.journeyId, ...args))(createAnalyticsEvent);
        };
        this.startSession = ()=>{
            this.session = (0, $abzFz.startSession)();
            this.journeyId = this.getSessionId();
            this.fireEvent((0, $6p4Td.focusEvent));
        };
        this.handleKeyDown = (event)=>{
            if (!this.isMenuOpenOnClickForSingleSelect) {
                // Escape
                if (event.keyCode === 27) this.blur();
                // Space
                if (event.keyCode === 32 && !this.state.inputValue) {
                    event.preventDefault();
                    !this.props.disableInput && this.setState({
                        inputValue: ' '
                    });
                }
            }
            if (this.session) {
                this.session.lastKey = event.keyCode;
                switch(event.keyCode){
                    // KeyUp 38
                    case 38:
                        this.session.upCount++;
                        break;
                    // KeyDown 40
                    case 40:
                        this.session.downCount++;
                        break;
                }
            }
            this.props.onKeyDown && this.props.onKeyDown(event);
            if (event.key === 'Escape') {
                this.setState({
                    menuIsOpen: false,
                    options: []
                });
                this.props.setIsFooterFocused && this.props.setIsFooterFocused(false);
                this.props.setIsHeaderFocused && this.props.setIsHeaderFocused(false);
            }
            if (event.key === 'Tab' && this.props.setIsFooterFocused && this.props.footer) this.props.setIsFooterFocused(true);
            if (event.key === 'Tab' && this.props.setIsHeaderFocused && this.props.header) this.props.setIsHeaderFocused(true);
        };
        this.handleClearIndicatorHover = (hoveringClearIndicator)=>{
            this.setState({
                hoveringClearIndicator: hoveringClearIndicator
            });
        };
        this.getOptions = ()=>{
            const options = (0, $f1uNX.getOptions)(this.state.options) || [];
            const { maxOptions: maxOptions, isMulti: isMulti, groupByTypeOrder: groupByTypeOrder, customGroupLabels: customGroupLabels } = this.props;
            if (maxOptions === 0) return [];
            if (maxOptions && maxOptions > 0 && maxOptions < options.length) {
                const { value: value } = this.state;
                let filteredOptions = options;
                // Filter out previously selected options
                if (isMulti && Array.isArray(value)) {
                    const valueIds = value.map((item)=>item.data.id);
                    filteredOptions = options.filter((option)=>valueIds.indexOf(option.data.id) === -1);
                }
                return groupByTypeOrder ? (0, $1Xd8s.groupOptionsByType)(filteredOptions.slice(0, maxOptions), groupByTypeOrder, customGroupLabels) : filteredOptions.slice(0, maxOptions);
            }
            return groupByTypeOrder ? (0, $1Xd8s.groupOptionsByType)(options, groupByTypeOrder, customGroupLabels) : options;
        };
        this.getAppearance = ()=>this.props.appearance ? this.props.appearance : 'normal';
        this.handleClickDraggableParentComponent = ()=>{
            if (this.state.initialFocusHandled) {
                // As <Select /> is already focused, calling this.selectRef.current.focus() again no longer triggers its own handlers (i.e. onMenuOpen, onMenuClose)
                // We have to manually handle the open and close states of the dropdown menu based on a user's click from this point onwards to prevent the bug
                if (this.state.menuIsOpen) this.handleClose();
                else this.handleOpen();
            } else if (!this.state.menuIsOpen && !this.isMenuOpenOnClickForSingleSelect) {
                // Trigger focus state when ValueContainer is clicked for the first time
                // The focused state will then invoke <Select /> instance's own handlers (e.g. onMenuOpen, onMenuClose)
                // to manage the state of the dropdown menu
                this.focus();
                this.setState(()=>({
                        initialFocusHandled: true
                    }));
            }
        };
        this.shouldKeepMenuOpen = ()=>Boolean(!!this.props.footer) && Boolean(this.props.isFooterFocused) || Boolean(!!this.props.header) && Boolean(this.props.isHeaderFocused);
        this.state = {
            options: [],
            isDefaultSet: false,
            inflightRequest: 0,
            count: 0,
            hoveringClearIndicator: false,
            menuIsOpen: !!this.props.open,
            inputValue: props.search || '',
            resolving: false,
            showError: false,
            initialFocusHandled: false
        };
        this.optionsShownUfoExperienceInstance = // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        (0, $aZ910.userPickerOptionsShownUfoExperience).getInstance((0, $03RpJ.default)());
        if (this.props.forwardedRef) {
            const refValue = {
                focus: this.focus,
                blur: this.blur
            };
            if (typeof this.props.forwardedRef === 'function') this.props.forwardedRef(refValue);
            else this.props.forwardedRef.current = refValue;
        }
    }
}
$a288f8d93fd9b6f7$export$b4ff48c8d43b18c3.defaultProps = {
    isMulti: false,
    subtle: false,
    noBorder: false,
    textFieldBackgroundColor: false,
    isClearable: true,
    loadOptionsErrorMessage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $7xLai.messages).errorMessage),
    openMenuOnClick: false
};
const $a288f8d93fd9b6f7$export$d099ade7b4f4d2a4 = (0, $lzgC6.default)()($a288f8d93fd9b6f7$export$b4ff48c8d43b18c3);
module.exports["BaseUserPickerWithoutAnalytics"] = $a288f8d93fd9b6f7$export$b4ff48c8d43b18c3;

});

parcelRegister("4hbXV", function(module, exports) {
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $2iGHk = parcelRequire("2iGHk");






















const $dd632030d02bf872$export$9345d7360ffe0722 = "platform-pkg";
const $dd632030d02bf872$export$91546b032799aa40 = "0.0.0-use.local";
const $dd632030d02bf872$export$9037daac950b75c5 = /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
const $dd632030d02bf872$export$e4f4c397244d61fe = /^[a-fA-F0-9]{1,8}:[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
const $dd632030d02bf872$export$54dedce6f65502d1 = /^[a-fA-F0-9]{24,24}$/;
const $dd632030d02bf872$export$53eef0dcd9611650 = (0, $2iGHk.default)('fabric-elements');
function $dd632030d02bf872$export$438776d78e3f215(props) {
    return props.isMulti ? 'multi' : 'single';
}
module.exports["createAndFireEventInElementsChannel"] = $dd632030d02bf872$export$53eef0dcd9611650;
module.exports["pickerType"] = $dd632030d02bf872$export$438776d78e3f215;

});

parcelRegister("abzFz", function(module, exports) {

var $03RpJ = parcelRequire("03RpJ");

const $3fca1458edd8e1bd$export$c0d84948cecf78d8 = ()=>({
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        id: (0, $03RpJ.default)(),
        start: Date.now(),
        inputChangeTime: Date.now(),
        upCount: 0,
        downCount: 0,
        lastKey: undefined
    });
module.exports["startSession"] = $3fca1458edd8e1bd$export$c0d84948cecf78d8;

});

parcelRegister("6p4Td", function(module, exports) {

var $40IfH = parcelRequire("40IfH");


var $11jke = parcelRequire("11jke");


var $3NJhy = parcelRequire("3NJhy");

const $d07ac79c9dccaa2e$var$buildValueForAnalytics = (value)=>{
    if (value) {
        const valueToConvert = Array.isArray(value) ? value : [
            value
        ];
        return valueToConvert.map(({ data: data })=>(0, $3NJhy.optionData2Analytics)(data));
    }
    return [];
};
const $d07ac79c9dccaa2e$export$e7818c470f37c4bd = (props, state, session, journeyId)=>(0, $11jke.createEvent)('ui', 'focused', 'userPicker', {
        ...(0, $40IfH.createDefaultPickerAttributes)(props, session, journeyId),
        values: $d07ac79c9dccaa2e$var$buildValueForAnalytics(state.value)
    });
module.exports["focusEvent"] = $d07ac79c9dccaa2e$export$e7818c470f37c4bd;

});

parcelRegister("40IfH", function(module, exports) {

var $4hbXV = parcelRequire("4hbXV");


var $1eEuA = parcelRequire("1eEuA");

const $7008c37683a628c7$export$c9cf21ad5831731 = (props, session, journeyId)=>({
        context: props.fieldId,
        sessionId: (0, $1eEuA.sessionId)(session),
        pickerType: (0, $4hbXV.pickerType)(props),
        journeyId: journeyId
    });
module.exports["createDefaultPickerAttributes"] = $7008c37683a628c7$export$c9cf21ad5831731;

});

parcelRegister("1eEuA", function(module, exports) {
function $383f9eafbb1dc1ab$export$f1faf18bafef2950(session) {
    return session && session.id;
}
module.exports["sessionId"] = $383f9eafbb1dc1ab$export$f1faf18bafef2950;

});

parcelRegister("11jke", function(module, exports) {
const $2a7ae91e0c6a7b45$var$packageName = "platform-pkg";
const $2a7ae91e0c6a7b45$var$packageVersion = "0.0.0-use.local";
const $2a7ae91e0c6a7b45$export$c30017717ce2168e = (eventType, action, actionSubject, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        attributes: {
            packageName: $2a7ae91e0c6a7b45$var$packageName,
            packageVersion: $2a7ae91e0c6a7b45$var$packageVersion,
            ...attributes
        }
    });
module.exports["createEvent"] = $2a7ae91e0c6a7b45$export$c30017717ce2168e;

});

parcelRegister("3NJhy", function(module, exports) {

var $dzbsk = parcelRequire("dzbsk");


var $i8WyF = parcelRequire("i8WyF");


var $1e7zb = parcelRequire("1e7zb");

const $f295993f1926c3c2$export$71c12142dd2c7f7e = (option)=>{
    const { id: id, type: type } = option;
    // id's of email types are emails which is PII
    const validatedData = {
        id: (0, $dzbsk.checkValidId)(id) ? id : null,
        type: type || null
    };
    if ((0, $1e7zb.isExternalUser)(option)) return {
        ...validatedData,
        type: 'external_user',
        sources: option.sources,
        externalUserType: option.externalUserType
    };
    if ((0, $i8WyF.isCustom)(option) && option.analyticsType) return {
        ...validatedData,
        type: option.analyticsType
    };
    return validatedData;
};
module.exports["optionData2Analytics"] = $f295993f1926c3c2$export$71c12142dd2c7f7e;

});

parcelRegister("dzbsk", function(module, exports) {
const $67b5423be47f7009$var$UUID_REGEXP_TEAMS_GROUPS = /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
const $67b5423be47f7009$var$UUID_REGEXP_OLD_AAID = /^[a-fA-F0-9]{1,8}:[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
const $67b5423be47f7009$var$UUID_REGEXP_NEW_AAID = /^[a-fA-F0-9]{24,24}$/;
const $67b5423be47f7009$export$ca9116f4c9c69701 = (id)=>{
    return $67b5423be47f7009$var$UUID_REGEXP_NEW_AAID.test(id) || $67b5423be47f7009$var$UUID_REGEXP_OLD_AAID.test(id) || $67b5423be47f7009$var$UUID_REGEXP_TEAMS_GROUPS.test(id);
};
module.exports["checkValidId"] = $67b5423be47f7009$export$ca9116f4c9c69701;

});

parcelRegister("i8WyF", function(module, exports) {

var $9kYT2 = parcelRequire("9kYT2");

const $b78949e957cc3a43$export$d3a8f0b77e9737fc = (option)=>option.type === (0, $9kYT2.CustomType);
module.exports["isCustom"] = $b78949e957cc3a43$export$d3a8f0b77e9737fc;

});

parcelRegister("1e7zb", function(module, exports) {

var $9kYT2 = parcelRequire("9kYT2");

const $b10ef070a9d47e36$export$f6058dbcb5980cb = (option)=>option.type === (0, $9kYT2.ExternalUserType) || Boolean(option.isExternal);
module.exports["isExternalUser"] = $b10ef070a9d47e36$export$f6058dbcb5980cb;

});

parcelRegister("99MwU", function(module, exports) {

var $40IfH = parcelRequire("40IfH");


var $11jke = parcelRequire("11jke");


var $2L3iL = parcelRequire("2L3iL");

const $129dbc26e51d9a21$export$7b5800e732182efb = (props, state, session, journeyId)=>(0, $11jke.createEvent)('ui', 'cleared', 'userPicker', {
        ...(0, $40IfH.createDefaultPickerAttributes)(props, session, journeyId),
        pickerOpen: state.menuIsOpen,
        values: (0, $2L3iL.values)(state)
    });
module.exports["clearEvent"] = $129dbc26e51d9a21$export$7b5800e732182efb;

});

parcelRegister("2L3iL", function(module, exports) {

var $3NJhy = parcelRequire("3NJhy");

function $50cb6c5472284a36$export$68c286be0e7e55b7(state) {
    return state.value ? Array.isArray(state.value) ? state.value.map((option)=>(0, $3NJhy.optionData2Analytics)(option.data)) : [
        (0, $3NJhy.optionData2Analytics)(state.value.data)
    ] : [];
}
module.exports["values"] = $50cb6c5472284a36$export$68c286be0e7e55b7;

});

parcelRegister("ltaNM", function(module, exports) {

var $4o0zT = parcelRequire("4o0zT");


var $11jke = parcelRequire("11jke");


var $3NJhy = parcelRequire("3NJhy");


var $1eEuA = parcelRequire("1eEuA");

const $6b0d2831b884c390$export$95711ec6c6227e9a = (props, state, session, journeyId, ...args)=>(0, $11jke.createEvent)('ui', 'deleted', 'userPickerItem', {
        context: props.fieldId,
        sessionId: (0, $1eEuA.sessionId)(session),
        journeyId: journeyId,
        value: (0, $3NJhy.optionData2Analytics)(args[0]),
        pickerOpen: state.menuIsOpen,
        ...(0, $4o0zT.isExperimentEnabled)('team_member_suggestions_while_creating_team') && args[0]?.isSuggestedMember !== undefined ? {
            isSuggestedMember: args[0].isSuggestedMember
        } : {}
    });
module.exports["deleteEvent"] = $6b0d2831b884c390$export$95711ec6c6227e9a;

});

parcelRegister("jc3SO", function(module, exports) {

var $40IfH = parcelRequire("40IfH");


var $11jke = parcelRequire("11jke");


var $lPgdM = parcelRequire("lPgdM");


var $gYQe4 = parcelRequire("gYQe4");


var $1FghD = parcelRequire("1FghD");


var $8Kk67 = parcelRequire("8Kk67");


var $fwHAS = parcelRequire("fwHAS");

const $fff1be6b06c4a75b$export$e9caaaecfee38128 = (props, _, session, journeyId, ...args)=>(0, $11jke.createEvent)('ui', 'cancelled', 'userPicker', {
        ...(0, $40IfH.createDefaultPickerAttributes)(props, session, journeyId),
        sessionDuration: (0, $1FghD.sessionDuration)(session),
        queryLength: (0, $gYQe4.queryLength)(args[0]),
        spaceInQuery: (0, $8Kk67.spaceInQuery)(args[0]),
        upKeyCount: (0, $fwHAS.upKeyCount)(session),
        downKeyCount: (0, $lPgdM.downKeyCount)(session)
    });
module.exports["cancelEvent"] = $fff1be6b06c4a75b$export$e9caaaecfee38128;

});

parcelRegister("lPgdM", function(module, exports) {
function $839913c5cb2dc092$export$8e275983879a92da(session) {
    return session ? session.downCount : null;
}
module.exports["downKeyCount"] = $839913c5cb2dc092$export$8e275983879a92da;

});

parcelRegister("gYQe4", function(module, exports) {
function $b7c27a4205b62720$export$12328ed60cbf370d(state) {
    return state.inputValue.length;
}
module.exports["queryLength"] = $b7c27a4205b62720$export$12328ed60cbf370d;

});

parcelRegister("1FghD", function(module, exports) {
function $592240ee21b1249c$export$ec35a3d3e818fad2(session) {
    return session ? Date.now() - session.start : null;
}
module.exports["sessionDuration"] = $592240ee21b1249c$export$ec35a3d3e818fad2;

});

parcelRegister("8Kk67", function(module, exports) {
function $ba776fbde2ed2d31$export$56f1fb0c07ef3ef8(state) {
    return state.inputValue.indexOf(' ') !== -1;
}
module.exports["spaceInQuery"] = $ba776fbde2ed2d31$export$56f1fb0c07ef3ef8;

});

parcelRegister("fwHAS", function(module, exports) {
function $a9e2a69537afdc29$export$a2bbbf75f8d8a63a(session) {
    return session ? session.upCount : null;
}
module.exports["upKeyCount"] = $a9e2a69537afdc29$export$a2bbbf75f8d8a63a;

});

parcelRegister("hyMtt", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $40IfH = parcelRequire("40IfH");


var $11jke = parcelRequire("11jke");


var $lPgdM = parcelRequire("lPgdM");


var $bzu5u = parcelRequire("bzu5u");


var $3NJhy = parcelRequire("3NJhy");


var $gYQe4 = parcelRequire("gYQe4");


var $1FghD = parcelRequire("1FghD");


var $8Kk67 = parcelRequire("8Kk67");


var $fwHAS = parcelRequire("fwHAS");

const $e9309a7dded644e3$var$selectedCustomGroupAnalyticsAttributes = (props, option)=>{
    if (!props.customGroupLabels) return {};
    const selectedType = option?.data.type;
    const analyticsLabel = selectedType ? props.customGroupAnalyticsLabels?.[selectedType] : undefined;
    return {
        hasCustomGroupLabels: true,
        ...analyticsLabel ? {
            selectedLabel: analyticsLabel
        } : {}
    };
};
function $e9309a7dded644e3$var$selectEventType(session) {
    return session && session.lastKey === 13 ? 'pressed' : 'clicked';
}
function $e9309a7dded644e3$var$position(state, value) {
    return value ? state.options.findIndex((option)=>option === value.data) : -1;
}
function $e9309a7dded644e3$var$result(option) {
    return option ? (0, $3NJhy.optionData2Analytics)(option.data) : null;
}
const $e9309a7dded644e3$export$48143d759475d90f = (props, state, session, journeyId, ...args)=>{
    return (0, $11jke.createEvent)('ui', $e9309a7dded644e3$var$selectEventType(session), 'userPicker', {
        ...(0, $40IfH.createDefaultPickerAttributes)(props, session, journeyId),
        sessionDuration: (0, $1FghD.sessionDuration)(session),
        position: $e9309a7dded644e3$var$position(state, args[0]),
        queryLength: (0, $gYQe4.queryLength)(state),
        spaceInQuery: (0, $8Kk67.spaceInQuery)(state),
        upKeyCount: (0, $fwHAS.upKeyCount)(session),
        downKeyCount: (0, $lPgdM.downKeyCount)(session),
        result: $e9309a7dded644e3$var$result(args[0]),
        numberOfResults: (0, $bzu5u.numberOfResults)(state),
        ...(0, $iDrrr.fg)('jsm_routing_recommended_agent_minor_fix') ? $e9309a7dded644e3$var$selectedCustomGroupAnalyticsAttributes(props, args[0]) : {}
    });
};
module.exports["selectEvent"] = $e9309a7dded644e3$export$48143d759475d90f;

});

parcelRegister("bzu5u", function(module, exports) {
function $280ce558a57b802c$export$192bd5e0f9d827d0(state) {
    return (state.options || []).length;
}
module.exports["numberOfResults"] = $280ce558a57b802c$export$192bd5e0f9d827d0;

});

parcelRegister("9f4Hk", function(module, exports) {

var $40IfH = parcelRequire("40IfH");


var $11jke = parcelRequire("11jke");


var $3NJhy = parcelRequire("3NJhy");


var $gYQe4 = parcelRequire("gYQe4");


var $1FghD = parcelRequire("1FghD");

function $d8ec03e31fff13ef$var$durationSinceInputChange(session) {
    return session ? Date.now() - session.inputChangeTime : null;
}
function $d8ec03e31fff13ef$var$results(state) {
    return (state.options || []).map((0, $3NJhy.optionData2Analytics));
}
function $d8ec03e31fff13ef$var$isLoading(props, state) {
    return state.count > 0 || props.isLoading;
}
const $d8ec03e31fff13ef$export$911fb7184b6037eb = (props, state, session, journeyId)=>{
    const searchResults = $d8ec03e31fff13ef$var$results(state);
    return (0, $11jke.createEvent)('operational', 'searched', 'userPicker', {
        ...(0, $40IfH.createDefaultPickerAttributes)(props, session, journeyId),
        sessionDuration: (0, $1FghD.sessionDuration)(session),
        durationSinceInputChange: $d8ec03e31fff13ef$var$durationSinceInputChange(session),
        queryLength: (0, $gYQe4.queryLength)(state),
        isLoading: $d8ec03e31fff13ef$var$isLoading(props, state),
        results: searchResults,
        numberOfResults: searchResults.length
    });
};
module.exports["searchedEvent"] = $d8ec03e31fff13ef$export$911fb7184b6037eb;

});

parcelRegister("7YQXO", function(module, exports) {

var $40IfH = parcelRequire("40IfH");


var $11jke = parcelRequire("11jke");

const $8329569f4f093436$export$c2aec355fef65c9c = (props, _, session, journeyId)=>(0, $11jke.createEvent)('operational', 'failed', 'userPicker', {
        ...(0, $40IfH.createDefaultPickerAttributes)(props, session, journeyId)
    });
module.exports["failedEvent"] = $8329569f4f093436$export$c2aec355fef65c9c;

});

parcelRegister("1Xd8s", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $dOBRD = parcelRequire("dOBRD");


var $7xLai = parcelRequire("7xLai");

const $21c303164bc44ab5$var$getLabelForType = (type, customLabels)=>{
    if (customLabels && type in customLabels) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, customLabels[type]);
    switch(type){
        case 'user':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $7xLai.messages).userTypeLabel);
        case 'team':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $7xLai.messages).teamTypeLabel);
        case 'group':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $7xLai.messages).groupTypeLabel);
        case 'custom':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $7xLai.messages).customTypeLabel);
        case 'external_user':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $7xLai.messages).externalUserTypeLabel);
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $7xLai.messages).otherTypeLabel);
    }
};
const $21c303164bc44ab5$export$393a985f7dd07cfe = (0, $dOBRD.default)((options, groupByTypeOrder, customGroupLabels)=>{
    // If groupByTypeOrder is empty, just return the original options
    if (groupByTypeOrder.length === 0) return options;
    const groupedMap = new Map();
    options.forEach((option)=>{
        const type = option.data.type || 'other';
        if (!groupedMap.has(type)) groupedMap.set(type, []);
        groupedMap.get(type).push(option);
    });
    const result = [];
    // add groups in the specified order
    // type is not in groupByTypeOrder, don't add it to the result
    groupByTypeOrder.forEach((type)=>{
        if (groupedMap.has(type)) {
            result.push({
                label: $21c303164bc44ab5$var$getLabelForType(type, customGroupLabels),
                options: groupedMap.get(type)
            });
            groupedMap.delete(type);
        }
    });
    return result;
});
module.exports["groupOptionsByType"] = $21c303164bc44ab5$export$393a985f7dd07cfe;

});

parcelRegister("7xLai", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $b9ef7149d9297ba5$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    placeholder: {
        id: "fabric.elements.user-picker.placeholder",
        defaultMessage: "Enter people or teams..."
    },
    addMore: {
        id: "fabric.elements.user-picker.placeholder.add-more",
        defaultMessage: "add more people..."
    },
    remove: {
        id: "fabric.elements.user-picker.multi.remove-item",
        defaultMessage: "Remove"
    },
    clear: {
        id: "fabric.elements.user-picker.single.clear",
        defaultMessage: "Clear"
    },
    errorMessage: {
        id: "fabric.elements.user-picker.error.message",
        defaultMessage: "Something went wrong"
    },
    teamByline: {
        id: "fabric.elements.user-picker.team.byline",
        defaultMessage: "Team"
    },
    officialTeamByline: {
        id: "fabric.elements.user-picker.team.byline.official",
        defaultMessage: "{teamTypeName} {verifiedIcon}"
    },
    officialMemberCountWithoutYou: {
        id: "fabric.elements.user-picker.team.member.count.official",
        defaultMessage: "{teamTypeName} {verifiedIcon} \u2022 {count} {count, plural, one {member} other {members}}"
    },
    officialMemberCountWithYou: {
        id: "fabric.elements.user-picker.team.member.count.official.including.you",
        defaultMessage: "{teamTypeName} {verifiedIcon} \u2022 {count} {count, plural, one {member} other {members}}, including you"
    },
    memberCountWithoutYou: {
        id: "fabric.elements.user-picker.team.member.count",
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}"
    },
    memberCountWithYou: {
        id: "fabric.elements.user-picker.team.member.count.including.you",
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you"
    },
    officialPlus50MembersWithoutYou: {
        id: "fabric.elements.user-picker.team.member.50plus.official",
        defaultMessage: "{teamTypeName} {verifiedIcon} \u2022 50+ members"
    },
    officialPlus50MembersWithYou: {
        id: "fabric.elements.user-picker.team.member.50plus.official.including.you",
        defaultMessage: "{teamTypeName} {verifiedIcon} \u2022 50+ members, including you"
    },
    plus50MembersWithoutYou: {
        id: "fabric.elements.user-picker.team.member.50plus",
        defaultMessage: "Team \u2022 50+ members"
    },
    plus50MembersWithYou: {
        id: "fabric.elements.user-picker.team.member.50plus.including.you",
        defaultMessage: "Team \u2022 50+ members, including you"
    },
    addEmail: {
        id: "fabric.elements.user-picker.email.add",
        defaultMessage: "Add user"
    },
    selectToAddEmail: {
        id: "fabric.elements.user-picker.email.select.to.add",
        defaultMessage: "Select an email address"
    },
    continueToAddEmail: {
        id: "fabric.elements.user-picker.email.add.potential",
        defaultMessage: "Enter an email address"
    },
    adminManagedGroupByline: {
        id: "fabric.elements.user-picker.group.byline.admin-managed",
        defaultMessage: "Admin group {verifiedIcon}"
    },
    groupByline: {
        id: "fabric.elements.user-picker.group.byline",
        defaultMessage: "Admin-managed group"
    },
    externalUserSourcesHeading: {
        id: "fabric.elements.user-picker.external.sourced.from",
        defaultMessage: "Found in:"
    },
    externalUserSourcesError: {
        id: "fabric.elements.user-picker.external.sourced.error",
        defaultMessage: "We can't connect you right now."
    },
    slackProvider: {
        id: "fabric.elements.user-picker.slack.provider",
        defaultMessage: "Slack"
    },
    googleProvider: {
        id: "fabric.elements.user-picker.google.provider",
        defaultMessage: "Google"
    },
    microsoftProvider: {
        id: "fabric.elements.user-picker.microsoft.provider",
        defaultMessage: "Microsoft"
    },
    gitHubProvider: {
        id: "fabric.elements.user-picker.github.provider",
        defaultMessage: "GitHub"
    },
    jiraSource: {
        id: "fabric.elements.user-picker.source.jira",
        defaultMessage: "Jira"
    },
    confluenceSource: {
        id: "fabric.elements.user-picker.source.confluence",
        defaultMessage: "Confluence"
    },
    otherAtlassianSource: {
        id: "fabric.elements.user-picker.source.other-atlassian-appify",
        defaultMessage: "Other Atlassian apps"
    },
    memberLozengeText: {
        id: "fabric.elements.user-picker.member.lozenge.text",
        defaultMessage: "MEMBER"
    },
    guestLozengeText: {
        id: "fabric.elements.user-picker.guest.lozenge.text",
        defaultMessage: "GUEST"
    },
    guestUserLozengeTooltip: {
        id: "fabric.elements.user-picker.guest.lozenge.tooltip.user",
        defaultMessage: "Guests can only access certain spaces and have limited access to user info."
    },
    guestGroupLozengeTooltip: {
        id: "fabric.elements.user-picker.guest.lozenge.tooltip.group",
        defaultMessage: "Guest groups can only access certain spaces and have limited access to user info."
    },
    archivedLozenge: {
        id: "fabric.elements.user-picker.archived.lozenge.text",
        defaultMessage: "Archived"
    },
    userTypeLabel: {
        id: "fabric.elements.user-picker.user.type.label",
        defaultMessage: "People"
    },
    teamTypeLabel: {
        id: "fabric.elements.user-picker.team.type.label",
        defaultMessage: "Teams"
    },
    emailTypeLabel: {
        id: "fabric.elements.user-picker.email.type.label",
        defaultMessage: "Emails"
    },
    groupTypeLabel: {
        id: "fabric.elements.user-picker.group.type.label",
        defaultMessage: "Groups"
    },
    externalUserTypeLabel: {
        id: "fabric.elements.user-picker.external.user.type.label",
        defaultMessage: "External Users"
    },
    customTypeLabel: {
        id: "fabric.elements.user-picker.custom.type.label",
        defaultMessage: "Customs"
    },
    otherTypeLabel: {
        id: "fabric.elements.user-picker.other.type.label",
        defaultMessage: "Others"
    }
});
module.exports["messages"] = $b9ef7149d9297ba5$export$defe85febe8b728c;

});

parcelRegister("a4iVb", function(module, exports) {
function $77fb950dcbf791ab$export$da86c38211c1c0a8(callback) {
    const calls = {};
    return (key, ...args)=>{
        if (!calls[key]) {
            window.setTimeout(()=>{
                callback(key, calls[key]);
                delete calls[key];
            });
            calls[key] = [];
        }
        calls[key].push(args);
    };
}
module.exports["batchByKey"] = $77fb950dcbf791ab$export$da86c38211c1c0a8;

});

parcelRegister("6YyLn", function(module, exports) {
const $f2ea0887b70fc0a4$export$df325aa844b03c31 = (callback, ...args)=>{
    if (typeof callback === 'function') try {
        //  there is mystery error in IE 11, so we need this try-catch
        return callback(...args);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('@atlassian/user-select: an error happening in `callCallback`: ', error);
    }
    return undefined;
};
module.exports["callCallback"] = $f2ea0887b70fc0a4$export$df325aa844b03c31;

});

parcelRegister("frJkr", function(module, exports) {
const $f25e4d7015ddf0b1$export$7ae97131df521bff = (value)=>{
    if (!value) return undefined;
    if (Array.isArray(value)) return value.map(({ data: option })=>option);
    return value.data;
};
module.exports["extractOptionValue"] = $f25e4d7015ddf0b1$export$7ae97131df521bff;

});

parcelRegister("A8EPJ", function(module, exports) {
const $6748c52c84d7f7b3$export$d6978985a41b0c8 = (value)=>value && !Array.isArray(value) || Array.isArray(value) && value.length > 0;
module.exports["isDefaultValuePopulated"] = $6748c52c84d7f7b3$export$d6978985a41b0c8;

});

parcelRegister("elhMC", function(module, exports) {
const $2451e0e0500e874a$export$9652023d9040757 = (a)=>typeof a?.[Symbol.iterator] === 'function';
module.exports["isIterable"] = $2451e0e0500e874a$export$9652023d9040757;

});

parcelRegister("2Ivef", function(module, exports) {

var $3GNtk = parcelRequire("3GNtk");

const $0dbda37d84dfe153$export$4f60a74234178416 = (SelectComponent)=>SelectComponent === (0, $3GNtk.PopupSelect);
module.exports["isPopupUserPickerByComponent"] = $0dbda37d84dfe153$export$4f60a74234178416;

});

parcelRegister("a9YvT", function(module, exports) {
const $98a354b01123ffd4$export$203c2bd2662d1ca2 = (value)=>!!value && !Array.isArray(value);
module.exports["isSingleValue"] = $98a354b01123ffd4$export$203c2bd2662d1ca2;

});

parcelRegister("f1uNX", function(module, exports) {
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $dOBRD = parcelRequire("dOBRD");


var $MYMmv = parcelRequire("MYMmv");



















const $f703df8a196cd65a$export$d2312e68e1f5ad00 = (0, $dOBRD.default)((options)=>options.map((0, $MYMmv.optionToSelectableOption)));
const $f703df8a196cd65a$export$e6fda14a194bcbcc = (0, $dOBRD.default)((defaultValue)=>{
    if (!defaultValue) return null;
    if (Array.isArray(defaultValue)) return defaultValue.map((0, $MYMmv.optionToSelectableOption));
    return (0, $MYMmv.optionToSelectableOption)(defaultValue);
});
module.exports["getOptions"] = $f703df8a196cd65a$export$d2312e68e1f5ad00;
module.exports["optionToSelectableOptions"] = $f703df8a196cd65a$export$e6fda14a194bcbcc;

});

parcelRegister("MYMmv", function(module, exports) {
const $d5da93bc578cfdae$var$isOptionData = (option)=>option.name !== undefined;
const $d5da93bc578cfdae$export$3f993c492bd6c728 = (option)=>{
    if ($d5da93bc578cfdae$var$isOptionData(option)) return {
        data: option,
        isDisabled: option.isDisabled,
        label: option.name,
        value: option.id
    };
    else return {
        data: {
            ...option,
            name: option.id
        },
        isDisabled: option.isDisabled,
        label: option.id,
        value: option.id
    };
};
module.exports["optionToSelectableOption"] = $d5da93bc578cfdae$export$3f993c492bd6c728;

});

parcelRegister("kea9V", function(module, exports) {

var $9kYT2 = parcelRequire("9kYT2");

const $6c5617d3bef42589$export$2e44165f1da65304 = (option)=>option.type === undefined || option.type === (0, $9kYT2.UserType);
module.exports["isUser"] = $6c5617d3bef42589$export$2e44165f1da65304;

});

parcelRegister("9rnjH", function(module, exports) {

var $9kYT2 = parcelRequire("9kYT2");

const $7f7ede2064f4cb4d$export$f8c4277cb588611f = (option)=>option?.type === (0, $9kYT2.TeamType);
module.exports["isTeam"] = $7f7ede2064f4cb4d$export$f8c4277cb588611f;

});

parcelRegister("2wJhI", function(module, exports) {

var $9kYT2 = parcelRequire("9kYT2");

const $8e1ec1ad68a5e7aa$export$d7976824e9f55785 = (option)=>option.type === (0, $9kYT2.GroupType);
module.exports["isGroup"] = $8e1ec1ad68a5e7aa$export$d7976824e9f55785;

});

parcelRegister("7jjhc", function(module, exports) {

var $9kYT2 = parcelRequire("9kYT2");

const $a2c484d80d93675e$export$7fbbfbca30081d0 = (option)=>option.type === (0, $9kYT2.EmailType);
module.exports["isEmail"] = $a2c484d80d93675e$export$7fbbfbca30081d0;

});

parcelRegister("8lrCG", function(module, exports) {
const $17e8f9d55f5dd663$export$695fb564e621339a = (appearance)=>appearance === 'big' ? 'medium' : appearance === 'multi' ? 'xxsmall' : 'small';
module.exports["getAvatarSize"] = $17e8f9d55f5dd663$export$695fb564e621339a;

});

parcelRegister("daDHi", function(module, exports) {
const $e22683f4e6f3d48a$export$3c62cf9a01367f27 = (child)=>child && typeof child === 'object' && child.props && child.props.type === 'text';
module.exports["isChildInput"] = $e22683f4e6f3d48a$export$3c62cf9a01367f27;

});

parcelRegister("jQGil", function(module, exports) {
const $8e31d6514c6231d1$export$96bdbc84526f3739 = (value)=>!!value && value.trim().length > 0;
module.exports["hasValue"] = $8e31d6514c6231d1$export$96bdbc84526f3739;

});

parcelRegister("hNx4m", function(module, exports) {

var $i8WyF = parcelRequire("i8WyF");


var $1e7zb = parcelRequire("1e7zb");


var $9rnjH = parcelRequire("9rnjH");


var $kea9V = parcelRequire("kea9V");

const $4c621435c168f027$export$b4f8f1f54acec99b = (optionData)=>{
    if ((0, $kea9V.isUser)(optionData) || (0, $9rnjH.isTeam)(optionData) || (0, $i8WyF.isCustom)(optionData) || (0, $1e7zb.isExternalUser)(optionData)) return optionData.avatarUrl;
    return undefined;
};
module.exports["getAvatarUrl"] = $4c621435c168f027$export$b4f8f1f54acec99b;

});

parcelRegister("fudfM", function(module, exports) {
const $77cf387377b565cf$export$5419897287f5f1c7 = (lozengeProp)=>{
    return lozengeProp?.hasOwnProperty('text') || false;
};
module.exports["isLozengeText"] = $77cf387377b565cf$export$5419897287f5f1c7;

});

parcelRegister("i7OwT", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $8B59y = parcelRequire("8B59y");

const $affe1f0b873bb0fd$var$EMPTY = {};
const $affe1f0b873bb0fd$var$useI18n = (0, $gtMdU.isReactCompilerActivePlatform)() ? (locale)=>{
    const $ = (0, $bDgLe.c)(3);
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState($affe1f0b873bb0fd$var$EMPTY);
    let t0;
    let t1;
    if ($[0] !== locale) {
        t0 = ()=>{
            let aborted = false;
            setMessages($affe1f0b873bb0fd$var$EMPTY);
            (0, $8B59y.getMessagesForLocale)(locale).then((messages_0)=>{
                if (!aborted) setMessages(messages_0);
            }).catch($affe1f0b873bb0fd$var$_temp);
            return ()=>{
                aborted = true;
            };
        };
        t1 = [
            locale
        ];
        $[0] = locale;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t0, t1);
    return messages;
} : (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState($affe1f0b873bb0fd$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        let aborted = false;
        setMessages($affe1f0b873bb0fd$var$EMPTY);
        (0, $8B59y.getMessagesForLocale)(locale).then((messages_0)=>{
            if (!aborted) setMessages(messages_0);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $affe1f0b873bb0fd$var$MessagesIntlProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(7);
    const intl = (0, $kSwu1.useIntl)();
    const { children: children } = props;
    const messages = $affe1f0b873bb0fd$var$useI18n(intl.locale);
    const t0 = intl.messages;
    let t1;
    if ($[0] !== messages || $[1] !== t0) {
        t1 = {
            ...t0,
            ...messages
        };
        $[0] = messages;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    const mergedMessages = t1;
    let t2;
    if ($[3] !== children || $[4] !== intl.locale || $[5] !== mergedMessages) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            locale: intl.locale,
            messages: mergedMessages
        }, children);
        $[3] = children;
        $[4] = intl.locale;
        $[5] = mergedMessages;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : (props)=>{
    const intl = (0, $kSwu1.useIntl)();
    const { children: children } = props;
    const messages = $affe1f0b873bb0fd$var$useI18n(intl.locale);
    const mergedMessages = (0, $cozmU.useMemo)(()=>{
        return {
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        locale: intl.locale,
        messages: mergedMessages
    }, children);
};
var $affe1f0b873bb0fd$export$2e2bcd8739ae039 = $affe1f0b873bb0fd$var$MessagesIntlProvider;
function $affe1f0b873bb0fd$var$_temp(error) {
    console.error(error);
}
module.exports["default"] = $affe1f0b873bb0fd$export$2e2bcd8739ae039;

});

parcelRegister("8B59y", function(module, exports) {
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ 






























const $fabf0ee840193b6d$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("czT7f")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("is2CR")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("f9PXz")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("hTBlD")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("knhp1")).then((mod)=>mod.default);
        case 'en_ZZ':
            return (parcelRequire("6Jf3c")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("4stbQ")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("e5Zyb")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("hTGoS")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("4NzHm")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("7WMbM")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("kRet2")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("k0Ylw")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("ed6HY")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("gYHEQ")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("4y6hg")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("ipkwl")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("6Auf5")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("2Y1OG")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("7U9Cn")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("bpqHS")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("1UMpa")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("5rDRi")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("fTac2")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("kJkHm")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("aMBTr")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("4Y1bg")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("4KYVB")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("4DhwK")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("4H0kN")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $fabf0ee840193b6d$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("hTBlD")).then((mod)=>mod.default);
            }
    }
};
module.exports["getMessagesForLocale"] = $fabf0ee840193b6d$export$d0a3169680473b6c;

});

parcelRegister("czT7f", function(module, exports) {

let $928381cfcdc88412$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $928381cfcdc88412$var$load("aQPG0").then(()=>parcelRequire('2MNNk'));

});

parcelRegister("is2CR", function(module, exports) {

let $d6ece0f77e900d01$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d6ece0f77e900d01$var$load("bkZFg").then(()=>parcelRequire('6wHKZ'));

});

parcelRegister("f9PXz", function(module, exports) {

let $b090006a45f0dcb0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b090006a45f0dcb0$var$load("55jRH").then(()=>parcelRequire('9lr8J'));

});

parcelRegister("hTBlD", function(module, exports) {

let $d0748b3f49a16dcb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d0748b3f49a16dcb$var$load("7gZXw").then(()=>parcelRequire('kLDJj'));

});

parcelRegister("knhp1", function(module, exports) {

let $ed5374660f7d9b16$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ed5374660f7d9b16$var$load("b3SDM").then(()=>parcelRequire('bpfBt'));

});

parcelRegister("6Jf3c", function(module, exports) {

let $4e629ec849dd4d3f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4e629ec849dd4d3f$var$load("1JMhO").then(()=>parcelRequire('PSbJN'));

});

parcelRegister("4stbQ", function(module, exports) {

let $33f06b7bd600d6cb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $33f06b7bd600d6cb$var$load("9yhAT").then(()=>parcelRequire('bgepv'));

});

parcelRegister("e5Zyb", function(module, exports) {

let $a43146ee98ca6159$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a43146ee98ca6159$var$load("cdSjM").then(()=>parcelRequire('iklsj'));

});

parcelRegister("hTGoS", function(module, exports) {

let $d0787686b6b885e3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d0787686b6b885e3$var$load("d5cjH").then(()=>parcelRequire('iNF4u'));

});

parcelRegister("4NzHm", function(module, exports) {

let $37e76e00ca9b33bf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $37e76e00ca9b33bf$var$load("cM3qB").then(()=>parcelRequire('acET6'));

});

parcelRegister("7WMbM", function(module, exports) {

let $5c93548215716d82$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5c93548215716d82$var$load("ju3RT").then(()=>parcelRequire('aCa90'));

});

parcelRegister("kRet2", function(module, exports) {

let $f2f3facd803b8f3c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f2f3facd803b8f3c$var$load("eKgTI").then(()=>parcelRequire('5HGir'));

});

parcelRegister("k0Ylw", function(module, exports) {

let $e9229e398f49c2fd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e9229e398f49c2fd$var$load("4SiFB").then(()=>parcelRequire('50gw0'));

});

parcelRegister("ed6HY", function(module, exports) {

let $a5877bb71bc0f7fc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a5877bb71bc0f7fc$var$load("3sB8d").then(()=>parcelRequire('43D7o'));

});

parcelRegister("gYHEQ", function(module, exports) {

let $c5c41d72d00b66dd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c5c41d72d00b66dd$var$load("cufjc").then(()=>parcelRequire('8ROxp'));

});

parcelRegister("4y6hg", function(module, exports) {

let $34ff34fe5bb47354$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $34ff34fe5bb47354$var$load("hPzC3").then(()=>parcelRequire('8awf7'));

});

parcelRegister("ipkwl", function(module, exports) {

let $d66a7ac30169d5cd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d66a7ac30169d5cd$var$load("cjMnf").then(()=>parcelRequire('44rnN'));

});

parcelRegister("6Auf5", function(module, exports) {

let $4cbd90648eaac27c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4cbd90648eaac27c$var$load("bdFVZ").then(()=>parcelRequire('dfiIH'));

});

parcelRegister("2Y1OG", function(module, exports) {

let $229298178354000a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $229298178354000a$var$load("73TPf").then(()=>parcelRequire('g36ET'));

});

parcelRegister("7U9Cn", function(module, exports) {

let $5c15394e51389f53$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5c15394e51389f53$var$load("84JCz").then(()=>parcelRequire('biRQ5'));

});

parcelRegister("bpqHS", function(module, exports) {

let $84e6bee535d6157a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $84e6bee535d6157a$var$load("e9I4V").then(()=>parcelRequire('iVMCW'));

});

parcelRegister("1UMpa", function(module, exports) {

let $1650919caaa8e2ca$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1650919caaa8e2ca$var$load("11Tbc").then(()=>parcelRequire('1KBJA'));

});

parcelRegister("5rDRi", function(module, exports) {

let $3f6e6475cd44f19c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3f6e6475cd44f19c$var$load("9tJmD").then(()=>parcelRequire('aZaJA'));

});

parcelRegister("fTac2", function(module, exports) {

let $b913e639f322e6fc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b913e639f322e6fc$var$load("15Pfi").then(()=>parcelRequire('fXcYB'));

});

parcelRegister("kJkHm", function(module, exports) {

let $f17810e6417eeb22$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f17810e6417eeb22$var$load("5JkSw").then(()=>parcelRequire('cMTKF'));

});

parcelRegister("aMBTr", function(module, exports) {

let $7d9bc7e1a9c9a29a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7d9bc7e1a9c9a29a$var$load("8yuuY").then(()=>parcelRequire('i0dXc'));

});

parcelRegister("4Y1bg", function(module, exports) {

let $39ddae750cc71672$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $39ddae750cc71672$var$load("gYFls").then(()=>parcelRequire('47Oa4'));

});

parcelRegister("4KYVB", function(module, exports) {

let $376ab8566e57c3f9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $376ab8566e57c3f9$var$load("4tohK").then(()=>parcelRequire('20QzR'));

});

parcelRegister("4DhwK", function(module, exports) {

let $35f8667a2cfca562$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $35f8667a2cfca562$var$load("iXqHo").then(()=>parcelRequire('4cqqy'));

});

parcelRegister("4H0kN", function(module, exports) {

let $36ab7002b9784b9c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $36ab7002b9784b9c$var$load("lcic8").then(()=>parcelRequire('kb5xT'));

});

parcelRegister("al9c2", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $73k2m = parcelRequire("73k2m");


var $1UZNj = parcelRequire("1UZNj");


var $88TF2 = parcelRequire("88TF2");


var $cs8ca = parcelRequire("cs8ca");


var $c48SA = parcelRequire("c48SA");


var $cnIP4 = parcelRequire("cnIP4");


var $bPMiS = parcelRequire("bPMiS");


var $97jiw = parcelRequire("97jiw");


var $8otJJ = parcelRequire("8otJJ");


var $bV3S4 = parcelRequire("bV3S4");


var $dnFcR = parcelRequire("dnFcR");

const $c4825579da0c037a$export$4e811121b221213b = (0, $dOBRD.default)((multi, anchor, showClearIndicator, customComponents)=>{
    if (anchor) return {
        Control: anchor,
        Option: $cs8ca.Option
    };
    else return {
        MultiValue: $1UZNj.MultiValue,
        DropdownIndicator: null,
        SingleValue: $c48SA.SingleValue,
        ClearIndicator: showClearIndicator || !multi ? (0, $73k2m.ClearIndicator) : null,
        Option: $cs8ca.Option,
        ValueContainer: multi ? (0, $88TF2.MultiValueContainer) : (0, $bPMiS.SingleValueContainer),
        Input: $cnIP4.Input,
        Menu: $bV3S4.Menu,
        Control: $dnFcR.default,
        ...customComponents ? customComponents : {}
    };
});
const $c4825579da0c037a$export$19205fd341a6bb08 = (0, $dOBRD.default)((hasPopupTitle)=>{
    const baseProps = {
        DropdownIndicator: null,
        SingleValue: $c48SA.SingleValue,
        ClearIndicator: $73k2m.ClearIndicator,
        Option: $cs8ca.Option,
        ValueContainer: (0, $bPMiS.SingleValueContainer),
        Input: (0, $97jiw.PopupInput)
    };
    if (hasPopupTitle) return {
        ...baseProps,
        Control: (0, $8otJJ.PopupControl)
    };
    return baseProps;
});
module.exports["getComponents"] = $c4825579da0c037a$export$4e811121b221213b;

});

parcelRegister("73k2m", function(module, exports) {
/* ClearIndicator.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $l9ukq = parcelRequire("l9ukq");

function $f2345ab9bbe409ae$var$_defineProperty(e, r, t) {
    return (r = $f2345ab9bbe409ae$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $f2345ab9bbe409ae$var$_toPropertyKey(t) {
    var i = $f2345ab9bbe409ae$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $f2345ab9bbe409ae$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

const $f2345ab9bbe409ae$var$AsyncTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("8GbgH")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $f2345ab9bbe409ae$var$clearIndicatorStyles = {
    root: "_23rrnHyl2N _1YKVNs7dHp _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _0clgaM7j8z _06EbysAASz"
};
class $f2345ab9bbe409ae$export$ecf9cf59142dd54a extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    render() {
        const { selectProps: { clearValueLabel: clearValueLabel } } = this.props;
        const Indicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).ClearIndicator, {
            ...this.props,
            innerProps: {
                ...this.props.innerProps,
                onMouseDown: this.handleMouseDown
            },
            xcss: $f2345ab9bbe409ae$var$clearIndicatorStyles.root
        });
        return clearValueLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
            fallback: Indicator
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f2345ab9bbe409ae$var$AsyncTooltip, {
            content: clearValueLabel
        }, Indicator)) : Indicator;
    }
    constructor(...args){
        super(...args);
        $f2345ab9bbe409ae$var$_defineProperty(this, "handleMouseDown", (event)=>{
            if (event && event.type === 'mousedown' && event.button !== 0) return;
             // Prevent focus when clear on blurred state
            const { clearValue: clearValue, selectProps: selectProps } = this.props;
            clearValue();
            if (selectProps && !selectProps.isFocused) event.stopPropagation();
        });
    }
}
module.exports["ClearIndicator"] = $f2345ab9bbe409ae$export$ecf9cf59142dd54a;

});

parcelRegister("8GbgH", function(module, exports) {

let $651afca19fe3ed7a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $651afca19fe3ed7a$var$load("9XXCk").then(()=>parcelRequire('2TLXz'));

});

parcelRegister("1UZNj", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $arQY7 = parcelRequire("arQY7");


var $fBqzD = parcelRequire("fBqzD");


var $9KSWX = parcelRequire("9KSWX");


var $aRrFB = parcelRequire("aRrFB");


var $iDrrr = parcelRequire("iDrrr");


var $3izAL = parcelRequire("3izAL");

var $kz1Yj = parcelRequire("kz1Yj");

var $buxP3 = parcelRequire("buxP3");


var $l9ukq = parcelRequire("l9ukq");


var $3Una5 = parcelRequire("3Una5");


var $IOtUu = parcelRequire("IOtUu");


var $2c3Eq = parcelRequire("2c3Eq");


var $kBIAo = parcelRequire("kBIAo");


var $lvlsM = parcelRequire("lvlsM");


var $cGbTM = parcelRequire("cGbTM");


var $hNx4m = parcelRequire("hNx4m");


var $7xLai = parcelRequire("7xLai");


var $7jjhc = parcelRequire("7jjhc");


var $2wJhI = parcelRequire("2wJhI");


var $9rnjH = parcelRequire("9rnjH");


var $lafkh = parcelRequire("lafkh");

function $bffbf0089c3afad8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $bffbf0089c3afad8$var$groupTagContainerOld = (0, $buxP3.xcss)({
    paddingLeft: 'space.025',
    marginTop: 'space.025'
});
const $bffbf0089c3afad8$var$groupTagContainer = (0, $buxP3.xcss)({
    paddingLeft: 'space.050'
});
const $bffbf0089c3afad8$var$archivedLozengeWrapper = (0, $buxP3.xcss)({
    display: 'flex',
    paddingLeft: 'space.050'
});
const $bffbf0089c3afad8$var$iconStyle = {
    name: "1sq8lny",
    styles: "display:flex;align-items:center;justify-content:center;flex-shrink:0;width:20px;height:20px"
};
const $bffbf0089c3afad8$var$nameWrapper = {
    name: "1b3uxdh",
    styles: "font:var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);padding-left:var(--ds-space-050, 4px)"
};
const $bffbf0089c3afad8$var$avatarTagWrapperStyle = {
    name: "14413o7",
    styles: "display:flex;font:var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
class $bffbf0089c3afad8$export$419cdf50db8b579 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidUpdate() {
        const { isFocused: isFocused } = this.props;
        if (isFocused && this.containerRef.current && this.containerRef.current.parentElement && this.containerRef.current.parentElement.parentElement) (0, $lafkh.scrollToValue)(this.containerRef.current, this.containerRef.current.parentElement.parentElement);
    }
    shouldComponentUpdate(nextProps) {
        const { data: option, innerProps: innerProps, isFocused: isFocused } = this.props;
        const { data: nextOption, innerProps: nextInnerProps, isFocused: nextIsFocused } = nextProps;
        if (option == null || nextOption == null) return option !== nextOption || innerProps !== nextInnerProps || isFocused !== nextIsFocused;
        const { label: label, data: data } = option;
        const { label: nextLabel, data: nextData } = nextOption;
        // We can ignore onRemove here because it is an anonymous function
        // that will be recreated every time but with the same implementation.
        return data !== nextData || label !== nextLabel || innerProps !== nextInnerProps || isFocused !== nextIsFocused;
    }
    render() {
        const { children: children, innerProps: _innerProps, removeProps: removeProps, data: option, ...rest } = this.props;
        if ((0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
            const { data: data, label: label } = option;
            const isTeamOption = (0, $9rnjH.isTeam)(data);
            const isGroupOption = (0, $2wJhI.isGroup)(data);
            const isEmailOption = (0, $7jjhc.isEmail)(data);
            const avatarUrl = (0, $hNx4m.getAvatarUrl)(data);
            const isDisabled = Boolean(this.props.selectProps?.isDisabled);
            const canShowArchivedLozenge = (0, $9rnjH.isTeam)(data) && data?.state === 'DISBANDED';
            const avatarProps = avatarUrl ? {
                name: data.name,
                src: avatarUrl
            } : {
                name: data.name
            };
            const onAfterRemoveAction = ()=>{
                removeProps.onClick({});
            };
            if (isEmailOption) return /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
                ref: this.containerRef,
                css: $bffbf0089c3afad8$var$avatarTagWrapperStyle,
                "data-user-picker-multi-value": true
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $IOtUu.default), {
                text: label,
                elemBefore: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kBIAo.AddOptionAvatar), {
                    isLozenge: true,
                    isPendingAction: data.isPendingAction
                }),
                isRemovable: !isDisabled,
                onAfterRemoveAction: onAfterRemoveAction,
                hasMargin: false
            }));
            if (isGroupOption) return /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
                ref: this.containerRef,
                css: $bffbf0089c3afad8$var$avatarTagWrapperStyle,
                "data-user-picker-multi-value": true
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $IOtUu.default), {
                text: label,
                elemBefore: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.Box), {
                    xcss: $bffbf0089c3afad8$var$groupTagContainer
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fBqzD))), {
                    color: "currentColor",
                    label: "",
                    size: "small"
                })),
                isRemovable: !isDisabled,
                onAfterRemoveAction: onAfterRemoveAction,
                hasMargin: false
            }));
            if (data.icon) return /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
                ref: this.containerRef,
                css: $bffbf0089c3afad8$var$avatarTagWrapperStyle,
                "data-user-picker-multi-value": true
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $IOtUu.default), {
                text: label,
                elemBefore: /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                    css: $bffbf0089c3afad8$var$iconStyle,
                    style: {
                        color: data.iconColor
                    }
                }, data.icon),
                isRemovable: !isDisabled,
                hasMargin: false,
                onAfterRemoveAction: onAfterRemoveAction
            }));
            return /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
                ref: this.containerRef,
                css: $bffbf0089c3afad8$var$avatarTagWrapperStyle,
                "data-user-picker-multi-value": true
            }, isTeamOption ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3Una5.default), {
                type: "other",
                text: label,
                isVerified: isTeamOption ? data.verified : undefined,
                isRemovable: !isDisabled,
                onAfterRemoveAction: onAfterRemoveAction,
                avatar: (props)=>// AvatarTag always supplies size="xxsmall", which is a valid
                    // TeamAvatarSize; TeamAvatar does not support UNSAFE_xsmall.
                    /*#__PURE__*/ (0, $lOiVq.jsx)((0, $2c3Eq.default), {
                        ...props,
                        ...avatarProps
                    }),
                hasMargin: false
            }), canShowArchivedLozenge ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.Box), {
                xcss: $bffbf0089c3afad8$var$archivedLozengeWrapper
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9KSWX.default), {
                appearance: "neutral"
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kSwu1.FormattedMessage), (0, $7xLai.messages).archivedLozenge))) : null) : /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3Una5.default), {
                type: "user",
                text: label,
                isRemovable: !isDisabled,
                onAfterRemoveAction: onAfterRemoveAction,
                avatar: (props)=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, $arQY7.default), {
                        ...props,
                        ...avatarProps
                    }),
                hasMargin: false
            }));
        }
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $l9ukq.components).MultiValue, {
            ...rest,
            data: option,
            removeProps: removeProps,
            innerProps: {
                ref: this.containerRef
            },
            cropWithEllipsis: false
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kz1Yj.Inline), {
            alignBlock: "center"
        }, this.getElemBefore(), " ", /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: $bffbf0089c3afad8$var$nameWrapper
        }, children), this.getElemAfter()));
    }
    constructor(props){
        super(props);
        this.containerRef = void 0;
        this.getElemBefore = ()=>{
            const { data: { data: data } } = this.props;
            if ((0, $7jjhc.isEmail)(data)) // This element is a decorative icon and does not require a label
            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kBIAo.AddOptionAvatar), {
                isLozenge: true,
                isPendingAction: data.isPendingAction
            });
            if ((0, $2wJhI.isGroup)(data)) return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.Box), {
                xcss: $bffbf0089c3afad8$var$groupTagContainerOld
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fBqzD))), {
                color: "currentColor",
                label: ""
            }));
            if (data.icon) return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lvlsM.AvatarOrIcon), {
                appearance: "multi",
                icon: data.icon,
                iconColor: data.iconColor,
                src: (0, $hNx4m.getAvatarUrl)(data),
                type: (0, $9rnjH.isTeam)(data) ? 'team' : 'person'
            });
            // Fallback to original behavior
            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cGbTM.SizeableAvatar), {
                appearance: "multi",
                src: (0, $hNx4m.getAvatarUrl)(data),
                type: (0, $9rnjH.isTeam)(data) ? 'team' : 'person'
            });
        };
        this.getElemAfter = ()=>{
            const { data: { data: data } } = this.props;
            const canShowArchivedLozenge = (0, $9rnjH.isTeam)(data) && data?.state === 'DISBANDED';
            if ((0, $2wJhI.isGroup)(data) && data.includeTeamsUpdates || (0, $9rnjH.isTeam)(data) && data.verified) return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $aRrFB.VerifiedTeamIcon), {
                size: data.includeTeamsUpdates ? 'small' : 'medium'
            });
            if (canShowArchivedLozenge) return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.Box), {
                xcss: $bffbf0089c3afad8$var$archivedLozengeWrapper
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9KSWX.default), {
                appearance: "neutral"
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kSwu1.FormattedMessage), (0, $7xLai.messages).archivedLozenge)));
            return null;
        };
        this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
    }
}
module.exports["MultiValue"] = $bffbf0089c3afad8$export$419cdf50db8b579;

});

parcelRegister("aRrFB", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $d2UzA = parcelRequire("d2UzA");


var $lpNn5 = parcelRequire("lpNn5");


var $2rxeJ = parcelRequire("2rxeJ");

const $c118d249a8b39a96$export$d7949f68d31e5edd = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { label: t1, showTooltip: showTooltip, customTooltipContent: customTooltipContent, size: t2, spacing: t3 } = t0;
    const label = t1 === undefined ? "Verified Team" : t1;
    const size = t2 === undefined ? "medium" : t2;
    const spacing = t3 === undefined ? "spacious" : t3;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t4;
    if ($[0] !== customTooltipContent || $[1] !== formatMessage || $[2] !== showTooltip) {
        t4 = showTooltip ? customTooltipContent || formatMessage((0, $2rxeJ.messages).verifiedIconDefaultTooltip) : undefined;
        $[0] = customTooltipContent;
        $[1] = formatMessage;
        $[2] = showTooltip;
        $[3] = t4;
    } else t4 = $[3];
    const tooltipContent = t4;
    let t5;
    if ($[4] !== label || $[5] !== size || $[6] !== spacing || $[7] !== tooltipContent) {
        t5 = tooltipContent ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
            content: tooltipContent,
            children: /*#__PURE__*/ (0, $8aG6j.jsxs)("span", {
                tabIndex: 0,
                role: "button",
                "data-testid": "verified-team-icon",
                children: [
                    " ",
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d2UzA))), {
                        color: "var(--ds-icon-accent-blue, #357DE8)",
                        size: size,
                        label: tooltipContent,
                        spacing: spacing
                    })
                ]
            })
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d2UzA))), {
            color: "var(--ds-icon-accent-blue, #357DE8)",
            size: size,
            spacing: spacing,
            label: label
        });
        $[4] = label;
        $[5] = size;
        $[6] = spacing;
        $[7] = tooltipContent;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : ({ label: label = 'Verified Team', showTooltip: showTooltip, customTooltipContent: customTooltipContent, size: size = 'medium', spacing: spacing = 'spacious' })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const tooltipContent = showTooltip ? customTooltipContent || formatMessage((0, $2rxeJ.messages).verifiedIconDefaultTooltip) : undefined;
    return tooltipContent ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
        content: tooltipContent,
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)("span", {
            tabIndex: 0,
            role: "button",
            "data-testid": "verified-team-icon",
            children: [
                ' ',
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d2UzA))), {
                    color: "var(--ds-icon-accent-blue, #357DE8)",
                    size: size,
                    label: tooltipContent,
                    spacing: spacing
                })
            ]
        })
    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d2UzA))), {
        color: "var(--ds-icon-accent-blue, #357DE8)",
        size: size,
        spacing: spacing,
        label: label
    });
};
module.exports["VerifiedTeamIcon"] = $c118d249a8b39a96$export$d7949f68d31e5edd;

});

parcelRegister("2rxeJ", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $a8f8527678b71e0e$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    verifiedIconDefaultTooltip: {
        id: "ptc-directory.team-profile-page.team-name.verified-team.icon.tooltip",
        defaultMessage: "This team is verified because it can only be changed by admin."
    }
});
module.exports["messages"] = $a8f8527678b71e0e$export$defe85febe8b728c;

});

parcelRegister("kBIAo", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $ldb9Z = parcelRequire("ldb9Z");


var $lOiVq = parcelRequire("lOiVq");

parcelRequire("cozmU");

const $d4e90a9cb054ea8d$var$getEmailAvatarWrapperStyle = (isLozenge, isPendingAction)=>{
    const padding = isLozenge ? `${"var(--ds-space-0, 0px)"}` : `${"var(--ds-space-050, 4px)"}`;
    const backgroundColor = isPendingAction ? "var(--ds-background-warning, #FFF5DB)" : "var(--ds-background-neutral, #0515240F)";
    return /*#__PURE__*/ (0, $lOiVq.css)({
        padding: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding,
        backgroundColor: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor,
        borderRadius: "var(--ds-radius-full, 9999px)",
        display: 'flex',
        alignItems: 'center',
        marginLeft: "var(--ds-space-025, 2px)"
    });
};
const $d4e90a9cb054ea8d$export$df396db45e491922 = ({ isLozenge: isLozenge, label: label, isPendingAction: isPendingAction })=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $d4e90a9cb054ea8d$var$getEmailAvatarWrapperStyle(isLozenge, isPendingAction)
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ldb9Z))), {
        testId: "add-option-avatar-email-icon",
        label: label || '',
        color: isPendingAction ? "var(--ds-text-warning, #9E4C00)" : "var(--ds-text-subtle, #505258)"
    })));
};
module.exports["AddOptionAvatar"] = $d4e90a9cb054ea8d$export$df396db45e491922;

});

parcelRegister("lvlsM", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cGbTM = parcelRequire("cGbTM");


var $8lrCG = parcelRequire("8lrCG");


var $lOiVq = parcelRequire("lOiVq");

function $25f984a67853b2bf$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $25f984a67853b2bf$var$iconStyle = {
    name: "sjfyf",
    styles: "display:flex;align-items:center;justify-content:center;flex-shrink:0"
};
const $25f984a67853b2bf$var$iconSizes = {
    xxsmall: {
        name: "1aynuae",
        styles: "width:20px;height:20px"
    },
    xsmall: {
        name: "1aynuae",
        styles: "width:20px;height:20px"
    },
    small: {
        name: "1c76jn8",
        styles: "width:28px;height:28px"
    },
    medium: {
        name: "bgbjt4",
        styles: "width:36px;height:36px"
    }
};
const $25f984a67853b2bf$export$60751fd23180a0ed = ({ appearance: appearance = 'big', avatarAppearanceShape: avatarAppearanceShape, icon: icon, iconColor: iconColor, presence: presence, src: src, type: type = 'person' })=>{
    // If icon is provided, render it instead of avatar
    if (icon) {
        const avatarSize = (0, $8lrCG.getAvatarSize)(appearance);
        return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: [
                $25f984a67853b2bf$var$iconStyle,
                $25f984a67853b2bf$var$iconSizes[avatarSize]
            ],
            style: {
                color: iconColor
            }
        }, icon);
    }
    // Otherwise, render the avatar as before
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cGbTM.SizeableAvatar), {
        appearance: appearance,
        src: src,
        presence: presence,
        type: type,
        avatarAppearanceShape: avatarAppearanceShape
    });
};
module.exports["AvatarOrIcon"] = $25f984a67853b2bf$export$60751fd23180a0ed;

});

parcelRegister("cGbTM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $arQY7 = parcelRequire("arQY7");


var $2c3Eq = parcelRequire("2c3Eq");


var $8lrCG = parcelRequire("8lrCG");

class $e2222437848781c0$export$44d81a88129649da extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    render() {
        const { src: src, presence: presence, appearance: appearance, type: type = 'person', avatarAppearanceShape: avatarAppearanceShape } = this.props;
        const size = (0, $8lrCG.getAvatarSize)(appearance);
        const props = {
            size: size,
            src: src,
            borderColor: 'transparent',
            presence: presence,
            ...avatarAppearanceShape && {
                appearance: avatarAppearanceShape
            }
        };
        return type === 'team' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2c3Eq.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), props);
    }
}
module.exports["SizeableAvatar"] = $e2222437848781c0$export$44d81a88129649da;

});

parcelRegister("lafkh", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $0d8b9ffccc033d94$export$118122ebc1e626fa = (valueContainer, control)=>{
    const { top: top, height: height } = valueContainer.getBoundingClientRect();
    const { height: controlHeight } = control.getBoundingClientRect();
    if (top - height < 0) valueContainer.scrollIntoView();
    if (top + height > controlHeight) valueContainer.scrollIntoView(false);
};
module.exports["scrollToValue"] = $0d8b9ffccc033d94$export$118122ebc1e626fa;

});

parcelRegister("88TF2", function(module, exports) {
/* MultiValueContainer.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $k12R1 = parcelRequire("k12R1");


var $kSwu1 = parcelRequire("kSwu1");


var $iDrrr = parcelRequire("iDrrr");


var $l9ukq = parcelRequire("l9ukq");


var $9gNGh = parcelRequire("9gNGh");


var $7xLai = parcelRequire("7xLai");


var $daDHi = parcelRequire("daDHi");

function $f3ca9dc7e39dcc1b$var$_defineProperty(e, r, t) {
    return (r = $f3ca9dc7e39dcc1b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $f3ca9dc7e39dcc1b$var$_toPropertyKey(t) {
    var i = $f3ca9dc7e39dcc1b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $f3ca9dc7e39dcc1b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $f3ca9dc7e39dcc1b$var$valueContainerStyles = {
    root: "_2iEGP2N2y8 _4bt5LAnQyn _2WAcuGIZbP _3oUqlsYbGa _0NUa3rN91d _4ho0wCjOvk _3ILZpPdnbC",
    paddingLegacy: "_0Of8r22ADO _1wydGW2ADO _2Zuz6Q2ADO",
    tagUpliftVerticalDefault: "_0Of8r22ADO _1wydGW2ADO",
    tagUpliftVerticalCompact: "_0Of8r2FQfX _1wydGWFQfX",
    paddingLeftTight: "_2Zuz6QgVvo",
    paddingLeftWide: "_2Zuz6Q2ADO",
    withFlexAndGap: "_2mHwu81Y8M _2iEGP2ZqHV _3TGfC9HnLE"
};
class $f3ca9dc7e39dcc1b$export$cf9cf2a30a59265c extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    static getDerivedStateFromProps(nextProps, prevState) {
        return {
            valueSize: nextProps.getValue ? nextProps.getValue().length : 0,
            previousValueSize: prevState.valueSize
        };
    }
    componentDidUpdate() {
        const { previousValueSize: previousValueSize, valueSize: valueSize } = this.state;
        const { isFocused: isFocused } = this.props.selectProps;
        if (valueSize > previousValueSize && isFocused) {
            if (this.timeoutId) {
                window.clearTimeout(this.timeoutId);
                this.timeoutId = null;
            }
            this.scrollToBottom();
        }
    }
    componentWillUnmount() {
        if (this.timeoutId) window.clearTimeout(this.timeoutId);
    }
    render() {
        const { children: _children, innerProps: _innerProps, hasValue: hasValue, isCompact: isCompact, ...valueContainerProps } = this.props;
        const props = {
            ...valueContainerProps,
            hasValue: hasValue,
            isCompact: isCompact,
            innerProps: this.valueContainerInnerProps
        };
        const ffTagUplifts = (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts');
        const controlRendersValueInControl = this.props.selectProps.controlShouldRenderValue !== false;
        const tagUpliftChipRow = ffTagUplifts && hasValue && controlRendersValueInControl;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9gNGh.default), {
            isEnabled: this.onValueContainerClick,
            onMouseDown: this.onValueContainerClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).ValueContainer, {
            ...props,
            xcss: (0, $k12R1.cx)($f3ca9dc7e39dcc1b$var$valueContainerStyles.root, !ffTagUplifts && $f3ca9dc7e39dcc1b$var$valueContainerStyles.paddingLegacy, ffTagUplifts && (isCompact ? $f3ca9dc7e39dcc1b$var$valueContainerStyles.tagUpliftVerticalCompact : $f3ca9dc7e39dcc1b$var$valueContainerStyles.tagUpliftVerticalDefault), ffTagUplifts && (tagUpliftChipRow ? $f3ca9dc7e39dcc1b$var$valueContainerStyles.paddingLeftWide : $f3ca9dc7e39dcc1b$var$valueContainerStyles.paddingLeftTight), tagUpliftChipRow && $f3ca9dc7e39dcc1b$var$valueContainerStyles.withFlexAndGap)
        }, this.renderChildren()));
    }
    constructor(props){
        super(props);
        $f3ca9dc7e39dcc1b$var$_defineProperty(this, "valueContainerInnerProps", void 0);
        $f3ca9dc7e39dcc1b$var$_defineProperty(this, "timeoutId", null);
        $f3ca9dc7e39dcc1b$var$_defineProperty(this, "scrollToBottom", ()=>{
            this.timeoutId = window.setTimeout(()=>{
                const { ref: { current: current } } = this.valueContainerInnerProps;
                if (current !== null) current.scrollTop = current.scrollHeight;
                this.timeoutId = null;
            });
        });
        $f3ca9dc7e39dcc1b$var$_defineProperty(this, "showPlaceholder", ()=>{
            const { selectProps: { value: value } } = this.props;
            return value && value.length > 0;
        });
        $f3ca9dc7e39dcc1b$var$_defineProperty(this, "addPlaceholder", (placeholder)=>{
            const children = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(this.props.children, (child)=>(0, $daDHi.isChildInput)(child) && this.showPlaceholder() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(child, {
                    placeholder: placeholder
                }) : child);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
        });
        $f3ca9dc7e39dcc1b$var$_defineProperty(this, "renderChildren", ()=>{
            const { selectProps: { addMoreMessage: addMoreMessage, isDisabled: isDisabled } } = this.props; // Do not render "Add more..." message if picker is disabled
            if (isDisabled) return this.props.children;
            if (addMoreMessage === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $7xLai.messages).addMore, (addMore)=>{
                let addMoreMessages = addMore;
                if (addMore && typeof addMore === 'string') addMoreMessages = [
                    addMore
                ];
                const placeholder = addMoreMessages?.join('') ?? '';
                return this.addPlaceholder(placeholder);
            });
            return this.addPlaceholder(addMoreMessage);
        });
        $f3ca9dc7e39dcc1b$var$_defineProperty(this, "onValueContainerClick", this.props.selectProps.onValueContainerClick);
        this.state = {
            valueSize: 0,
            previousValueSize: 0
        };
        this.valueContainerInnerProps = {
            ref: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef()
        };
    }
}
module.exports["MultiValueContainer"] = $f3ca9dc7e39dcc1b$export$cf9cf2a30a59265c;

});

parcelRegister("9gNGh", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");

function $93cc2b2f9d20e1e3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Conditional wrapper for the ValueContainer in Select. Provides a workaround
 * for issues using react-select on react-beautiful-dnd Draggable elements.
 * @returns
 */ var $93cc2b2f9d20e1e3$var$_ref = {
    name: "1ff36h2",
    styles: "flex-grow:1"
};
const $93cc2b2f9d20e1e3$var$ValueContainerWrapper = ({ children: children, isEnabled: isEnabled, onMouseDown: onMouseDown })=>{
    return isEnabled ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlassian/a11y/no-static-element-interactions -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $93cc2b2f9d20e1e3$var$_ref,
        onMouseDown: onMouseDown
    }, children) : children;
};
var $93cc2b2f9d20e1e3$export$2e2bcd8739ae039 = $93cc2b2f9d20e1e3$var$ValueContainerWrapper;
module.exports["default"] = $93cc2b2f9d20e1e3$export$2e2bcd8739ae039;

});

parcelRegister("cs8ca", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $l9ukq = parcelRequire("l9ukq");


var $lpNn5 = parcelRequire("lpNn5");


var $2RstY = parcelRequire("2RstY");


var $cTtI6 = parcelRequire("cTtI6");


var $bYoB2 = parcelRequire("bYoB2");


var $hohk8 = parcelRequire("hohk8");


var $k0mXu = parcelRequire("k0mXu");


var $2c63x = parcelRequire("2c63x");


var $bsEy7 = parcelRequire("bsEy7");


var $i8WyF = parcelRequire("i8WyF");


var $7jjhc = parcelRequire("7jjhc");


var $1e7zb = parcelRequire("1e7zb");


var $2wJhI = parcelRequire("2wJhI");


var $9rnjH = parcelRequire("9rnjH");


var $kea9V = parcelRequire("kea9V");

const $e10fd610d1140d68$var$defaultOption = ({ data: { data: data }, isSelected: isSelected, status: status })=>// @ts-expect-error - <UserOption> expects `data` to be of User interface, but data is OptionData interface by default. Check if the `user` props in UserOption should also accept OptionData or refactor this file to accept generics
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2c63x.UserOption), {
        user: data,
        status: status,
        isSelected: isSelected
    });
const $e10fd610d1140d68$var$dataOption = ({ data: { data: data }, isSelected: isSelected, status: status, selectProps: selectProps })=>{
    if ((0, $1e7zb.isExternalUser)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bYoB2.default), {
        user: data,
        status: status,
        isSelected: isSelected
    });
    if ((0, $kea9V.isUser)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2c63x.UserOption), {
        user: data,
        status: status,
        isSelected: isSelected
    });
    if ((0, $7jjhc.isEmail)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cTtI6.default), {
        email: data,
        emailValidity: (0, $bsEy7.isValidEmail)(data.id),
        isSelected: isSelected,
        label: selectProps.emailLabel
    });
    if ((0, $9rnjH.isTeam)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k0mXu.default), {
        team: data,
        isSelected: isSelected,
        includeTeamsUpdates: data.includeTeamsUpdates
    });
    if ((0, $2wJhI.isGroup)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hohk8.default), {
        group: data,
        isSelected: isSelected,
        includeTeamsUpdates: data.includeTeamsUpdates
    });
    if ((0, $i8WyF.isCustom)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2RstY.default), {
        data: data,
        isSelected: isSelected
    });
    return null;
};
const $e10fd610d1140d68$var$dataOptionWithTooltip = (props)=>{
    if (props.data?.data?.tooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: props.data?.data?.tooltip
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), tooltipProps, $e10fd610d1140d68$var$dataOption(props)));
    return $e10fd610d1140d68$var$dataOption(props);
};
const $e10fd610d1140d68$export$36d18380658d5d20 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    let T0;
    let props;
    let renderOptionContent;
    let t1;
    let t2;
    if ($[0] !== t0) {
        ({ renderOptionContent: renderOptionContent, ...props } = t0);
        T0 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense;
        t1 = $e10fd610d1140d68$var$defaultOption(props);
        t2 = $e10fd610d1140d68$var$dataOptionWithTooltip(props);
        $[0] = t0;
        $[1] = T0;
        $[2] = props;
        $[3] = renderOptionContent;
        $[4] = t1;
        $[5] = t2;
    } else {
        T0 = $[1];
        props = $[2];
        renderOptionContent = $[3];
        t1 = $[4];
        t2 = $[5];
    }
    let t3;
    if ($[6] !== T0 || $[7] !== t1 || $[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            fallback: t1
        }, t2);
        $[6] = T0;
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    const defaultContent = t3;
    const t4 = props;
    let t5;
    if ($[10] !== defaultContent || $[11] !== renderOptionContent) {
        t5 = renderOptionContent ? renderOptionContent(defaultContent) : defaultContent;
        $[10] = defaultContent;
        $[11] = renderOptionContent;
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] !== t4 || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).Option, t4, t5);
        $[13] = t4;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
} : ({ renderOptionContent: renderOptionContent, ...props })=>{
    const defaultContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
        fallback: $e10fd610d1140d68$var$defaultOption(props)
    }, $e10fd610d1140d68$var$dataOptionWithTooltip(props));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).Option, props, renderOptionContent ? renderOptionContent(defaultContent) : defaultContent);
};
module.exports["Option"] = $e10fd610d1140d68$export$36d18380658d5d20;

});

parcelRegister("2RstY", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $846221ee191ca6c1$var$AsyncCustomOption = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("5aSGg")).then((module)=>{
        return {
            default: module.CustomOption
        };
    }));
var $846221ee191ca6c1$export$2e2bcd8739ae039 = $846221ee191ca6c1$var$AsyncCustomOption;
module.exports["default"] = $846221ee191ca6c1$export$2e2bcd8739ae039;

});

parcelRegister("5aSGg", function(module, exports) {

let $3c484d605f8245e8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3c484d605f8245e8$var$load("k9RdS").then(()=>parcelRequire('f8Kzz'));

});

parcelRegister("cTtI6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $a5138e07c3616ec7$var$AsyncEmailOption = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("hJOc8")).then((module)=>{
        return {
            default: module.EmailOption
        };
    }));
var $a5138e07c3616ec7$export$2e2bcd8739ae039 = $a5138e07c3616ec7$var$AsyncEmailOption;
module.exports["default"] = $a5138e07c3616ec7$export$2e2bcd8739ae039;

});

parcelRegister("hJOc8", function(module, exports) {

let $ce9d9343e981ef24$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ce9d9343e981ef24$var$load("g8N2Z").then(()=>parcelRequire('3wXNe'));

});

parcelRegister("bYoB2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $a3b2e53394cea8af$var$AsyncExternalUserOption = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("d2fOk")).then((module)=>{
        return {
            default: module.ExternalUserOption
        };
    }));
var $a3b2e53394cea8af$export$2e2bcd8739ae039 = $a3b2e53394cea8af$var$AsyncExternalUserOption;
module.exports["default"] = $a3b2e53394cea8af$export$2e2bcd8739ae039;

});

parcelRegister("d2fOk", function(module, exports) {

let $97d7b9f16d17573e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $97d7b9f16d17573e$var$load("6vqGz"),
    $97d7b9f16d17573e$var$load("l9aze")
]).then(()=>parcelRequire('hjSks'));

});

parcelRegister("hohk8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $85cffe183f5a17a9$var$AsyncGroupOption = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("0YD1J")).then((module)=>{
        return {
            default: module.GroupOption
        };
    }));
var $85cffe183f5a17a9$export$2e2bcd8739ae039 = $85cffe183f5a17a9$var$AsyncGroupOption;
module.exports["default"] = $85cffe183f5a17a9$export$2e2bcd8739ae039;

});

parcelRegister("0YD1J", function(module, exports) {

let $002f07c0999fbf19$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $002f07c0999fbf19$var$load("fFsaR").then(()=>parcelRequire('hrN4e'));

});

parcelRegister("k0mXu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $334e5641372502ac$var$AsyncTeamOption = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("Blpcv")).then((module)=>{
        return {
            default: module.TeamOption
        };
    }));
var $334e5641372502ac$export$2e2bcd8739ae039 = $334e5641372502ac$var$AsyncTeamOption;
module.exports["default"] = $334e5641372502ac$export$2e2bcd8739ae039;

});

parcelRegister("Blpcv", function(module, exports) {

let $07040f7ebd894018$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $07040f7ebd894018$var$load("dBsbZ").then(()=>parcelRequire('k0sQA'));

});

parcelRegister("2c63x", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $dWZMi = parcelRequire("dWZMi");


var $lOiVq = parcelRequire("lOiVq");


var $cozmU = parcelRequire("cozmU");


var $pr26r = parcelRequire("pr26r");


var $lvlsM = parcelRequire("lvlsM");


var $apA01 = parcelRequire("apA01");


var $cGbTM = parcelRequire("cGbTM");


var $jQGil = parcelRequire("jQGil");


var $dpq1f = parcelRequire("dpq1f");


var $iDrrr = parcelRequire("iDrrr");

class $afa55f5fa163021c$export$8e59f78010871662 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $pr26r.AvatarItemOption), {
            avatar: this.renderAvatar(),
            lozenge: this.getLozengeProps(),
            isDisabled: this.props.user.isDisabled,
            primaryText: this.getPrimaryText(),
            secondaryText: this.renderSecondaryText()
        });
    }
    constructor(...args){
        super(...args);
        this.getPrimaryText = ()=>{
            const { user: { name: name, publicName: publicName, highlight: highlight } } = this.props;
            const result = [
                /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
                    key: "name",
                    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    css: (0, $dpq1f.textWrapper)(this.props.isSelected ? "var(--ds-text-selected, #1868DB)" : "var(--ds-text, #292A2E)")
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $apA01.HighlightText), {
                    highlights: highlight && highlight.name
                }, name))
            ];
            if ((0, $jQGil.hasValue)(publicName) && name.trim() !== publicName.trim()) {
                const color = this.props.isSelected ? "var(--ds-text-selected, #1868DB)" : "var(--ds-text-subtlest, #6B6E76)";
                result.push(/*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
                    key: "publicName"
                }, ' ', /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
                    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    css: (0, $dpq1f.textWrapper)(color)
                }, "(", /*#__PURE__*/ (0, $lOiVq.jsx)((0, $apA01.HighlightText), {
                    highlights: highlight && highlight.publicName
                }, publicName), ")")));
            }
            return result;
        };
        this.renderSecondaryText = ()=>this.props.user.byline ? /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                css: (0, $dpq1f.textWrapper)(this.props.isSelected ? "var(--ds-text-selected, #1868DB)" : "var(--ds-text-subtlest, #6B6E76)")
            }, this.props.user.byline) : undefined;
        this.renderAvatar = ()=>{
            const { user: { avatarUrl: avatarUrl, appType: appType, icon: icon, iconColor: iconColor }, status: status } = this.props;
            const appearance = (0, $iDrrr.fg)('platform-component-visual-refresh') ? 'medium' : 'big';
            if (icon) return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lvlsM.AvatarOrIcon), {
                appearance: appearance,
                icon: icon,
                iconColor: iconColor,
                src: avatarUrl,
                presence: status,
                avatarAppearanceShape: (0, $dWZMi.default)(appType)
            });
            // Fallback to original behavior
            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cGbTM.SizeableAvatar), {
                appearance: appearance,
                src: avatarUrl,
                presence: status,
                avatarAppearanceShape: (0, $dWZMi.default)(appType)
            });
        };
        this.getLozengeProps = ()=>typeof this.props.user.lozenge === 'string' ? {
                text: this.props.user.lozenge
            } : this.props.user.lozenge;
    }
}
module.exports["UserOption"] = $afa55f5fa163021c$export$8e59f78010871662;

});

parcelRegister("pr26r", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $9KSWX = parcelRequire("9KSWX");


var $iDrrr = parcelRequire("iDrrr");


var $IOtUu = parcelRequire("IOtUu");


var $fudfM = parcelRequire("fudfM");

function $09486341bedb25c7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

const $09486341bedb25c7$var$AsyncTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("8GbgH")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $09486341bedb25c7$var$wrapper = (isDisabled)=>/*#__PURE__*/ (0, $lOiVq.css)({
        alignItems: 'center',
        boxSizing: 'border-box',
        display: 'flex',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1,
        outline: 'none',
        margin: 0,
        width: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: isDisabled ? "var(--ds-opacity-disabled, 0.4)" : undefined
    });
const $09486341bedb25c7$var$optionWrapper = {
    name: "13552d7",
    styles: "max-width:100%;min-width:0;line-height:1.4;padding-left:var(--ds-space-100, 8px)"
};
const $09486341bedb25c7$var$getTextStyle = (isSecondary)=>{
    const secondaryCssArgs = isSecondary ? {
        font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
    } : {};
    return /*#__PURE__*/ (0, $lOiVq.css)({
        margin: 0,
        overflowX: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...secondaryCssArgs
    });
};
const $09486341bedb25c7$var$additionalInfo = {
    name: "1hvgowa",
    styles: "float:right;margin-left:var(--ds-space-100, 8px)"
};
const $09486341bedb25c7$var$lozengeAppearanceToTagColor = {
    default: 'standard',
    success: 'lime',
    removed: 'red',
    inprogress: 'blue',
    new: 'purple',
    moved: 'orange'
};
const $09486341bedb25c7$export$164a9d9b3b86dd0c = ({ avatar: avatar, isDisabled: isDisabled, lozenge: lozenge, primaryText: primaryText, secondaryText: secondaryText })=>{
    const renderTag = ()=>{
        if ((0, $fudfM.isLozengeText)(lozenge) && !lozenge.isBold) {
            const color = lozenge.appearance ? $09486341bedb25c7$var$lozengeAppearanceToTagColor[lozenge.appearance] : 'standard';
            const tag = /*#__PURE__*/ (0, $lOiVq.jsx)((0, $IOtUu.default), {
                text: lozenge.text,
                color: color,
                isRemovable: false,
                migration_fallback: "lozenge"
            });
            if (lozenge.tooltip) return /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
                fallback: tag
            }, /*#__PURE__*/ (0, $lOiVq.jsx)($09486341bedb25c7$var$AsyncTooltip, {
                content: lozenge.tooltip
            }, tag));
            return tag;
        }
        return renderLozenge();
    };
    const renderLozenge = ()=>{
        if ((0, $fudfM.isLozengeText)(lozenge)) {
            if (lozenge?.tooltip) // Note that entire Lozenge must be wrapped in the Tooltip (rather than just the
            // Lozenge text) or tooltip won't work
            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
                fallback: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9KSWX.default), lozenge, lozenge.text)
            }, /*#__PURE__*/ (0, $lOiVq.jsx)($09486341bedb25c7$var$AsyncTooltip, {
                content: lozenge.tooltip
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9KSWX.default), lozenge, lozenge.text)));
            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9KSWX.default), lozenge, lozenge.text);
        }
        return lozenge;
    };
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: $09486341bedb25c7$var$wrapper(isDisabled)
    }, avatar, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $09486341bedb25c7$var$optionWrapper
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", null, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $09486341bedb25c7$var$getTextStyle()
    }, primaryText), secondaryText && /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $09486341bedb25c7$var$getTextStyle(true)
    }, secondaryText))), lozenge && /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $09486341bedb25c7$var$additionalInfo
    }, (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? renderTag() : renderLozenge())));
};
module.exports["AvatarItemOption"] = $09486341bedb25c7$export$164a9d9b3b86dd0c;

});

parcelRegister("apA01", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

class $f375a32a5b8051ad$export$bb02e7bc6e1a7119 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    render() {
        const { children: children, highlights: highlights } = this.props;
        const parts = [];
        let lastIndex = 0;
        if (highlights) highlights.sort((a, b)=>a.start - b.start).reduce((highlights, highlight)=>{
            const lastHighlight = highlights[highlights.length - 1];
            if (!lastHighlight || highlight.start > lastHighlight.end + 1) return highlights.concat(highlight);
            if (highlight.end > lastHighlight.end) lastHighlight.end = highlight.end;
            return highlights;
        }, []).forEach((highlight)=>{
            const { start: start, end: end } = highlight;
            if (start >= end) return;
            if (start > lastIndex) parts.push({
                value: children.substring(lastIndex, start),
                matches: false
            });
            parts.push({
                value: children.substring(start, end + 1),
                matches: true
            });
            lastIndex = end + 1;
        });
        if (lastIndex < children.length) parts.push({
            value: children.substring(lastIndex, children.length),
            matches: false
        });
        return parts.map((part, index)=>{
            if (part.matches) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", {
                key: index
            }, part.value);
            return part.value;
        });
    }
}
module.exports["HighlightText"] = $f375a32a5b8051ad$export$bb02e7bc6e1a7119;

});

parcelRegister("dpq1f", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $lOiVq = parcelRequire("lOiVq");

const $0aa62d26260f639b$export$aa6223da92b253dd = (color)=>/*#__PURE__*/ (0, $lOiVq.css)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: 'inline',
        color: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color
    });
module.exports["textWrapper"] = $0aa62d26260f639b$export$aa6223da92b253dd;

});

parcelRegister("bsEy7", function(module, exports) {
const $c776d91474b4faaf$var$validRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
const $c776d91474b4faaf$var$potentialRegex = /^[^\s@]+@[^\s@]*$/i;
const $c776d91474b4faaf$export$371e338370561054 = (inputText)=>{
    if (inputText.match($c776d91474b4faaf$var$validRegex)) return 'VALID';
    if (inputText.match($c776d91474b4faaf$var$potentialRegex)) return 'POTENTIAL';
    return 'INVALID';
};
module.exports["isValidEmail"] = $c776d91474b4faaf$export$371e338370561054;

});

parcelRegister("c48SA", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $dWZMi = parcelRequire("dWZMi");


var $9KSWX = parcelRequire("9KSWX");


var $aRrFB = parcelRequire("aRrFB");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $1l0kj = parcelRequire("1l0kj");


var $l9ukq = parcelRequire("l9ukq");


var $lvlsM = parcelRequire("lvlsM");


var $cGbTM = parcelRequire("cGbTM");


var $hNx4m = parcelRequire("hNx4m");


var $7xLai = parcelRequire("7xLai");


var $2wJhI = parcelRequire("2wJhI");


var $9rnjH = parcelRequire("9rnjH");

const $afcedb8febd5dd73$var$styles = {
    avatarItem: "_4bt5LAnQyn _2WAcuGnQyn _0hPCNLDIqT _4ouGXIQEt6",
    avatarItemTextWrapper: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEN91d _4ouGXIdnbC _1EqgXlN91d _0LQT5E2ADO _26BoRwflal",
    avatarItemText: "_1UtDYzy7kJ _4bt5LAnQyn _39HuIbz8Lp _1ANEUSLRg7",
    archivedLozengeWrapper: "_3iDTPbQ4SZ _2Zuz6Q1Y8M"
};
const $afcedb8febd5dd73$var$ElementAfter = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    const { data: t0, shouldShowVerifiedIcon: shouldShowVerifiedIcon } = props;
    const { data: data } = t0;
    const showIcon = shouldShowVerifiedIcon ? shouldShowVerifiedIcon(data) : (0, $9rnjH.isTeam)(data) && data.verified || (0, $2wJhI.isGroup)(data) && data.includeTeamsUpdates;
    if (showIcon) {
        const t1 = data.includeTeamsUpdates ? "small" : "medium";
        let t2;
        if ($[0] !== t1) {
            t2 = /*#__PURE__*/ $cozmU.createElement((0, $aRrFB.VerifiedTeamIcon), {
                size: t1
            });
            $[0] = t1;
            $[1] = t2;
        } else t2 = $[1];
        return t2;
    }
    return null;
} : (props)=>{
    const { data: { data: data }, shouldShowVerifiedIcon: shouldShowVerifiedIcon } = props;
    const showIcon = shouldShowVerifiedIcon ? shouldShowVerifiedIcon(data) : (0, $9rnjH.isTeam)(data) && data.verified || (0, $2wJhI.isGroup)(data) && data.includeTeamsUpdates;
    if (showIcon) return /*#__PURE__*/ $cozmU.createElement((0, $aRrFB.VerifiedTeamIcon), {
        size: data.includeTeamsUpdates ? 'small' : 'medium'
    });
    return null;
};
const $afcedb8febd5dd73$export$1949dac661ba6e3a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(9);
    const { data: t0, selectProps: t1 } = props;
    const { label: label, data: data } = t0;
    const { appearance: appearance, isFocused: isFocused } = t1;
    let t2;
    if ($[0] !== data) {
        t2 = (0, $9rnjH.isTeam)(data) && data?.state === "DISBANDED";
        $[0] = data;
        $[1] = t2;
    } else t2 = $[1];
    const canShowArchivedLozenge = t2;
    let t3;
    if ($[2] !== appearance || $[3] !== canShowArchivedLozenge || $[4] !== data || $[5] !== isFocused || $[6] !== label || $[7] !== props) {
        t3 = !isFocused ? /*#__PURE__*/ $cozmU.createElement((0, $l9ukq.components).SingleValue, props, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            xcss: $afcedb8febd5dd73$var$styles.avatarItem
        }, data.icon ? /*#__PURE__*/ $cozmU.createElement((0, $lvlsM.AvatarOrIcon), {
            icon: data.icon,
            iconColor: data.iconColor,
            src: (0, $hNx4m.getAvatarUrl)(data),
            appearance: appearance,
            type: (0, $9rnjH.isTeam)(data) ? "team" : "person",
            avatarAppearanceShape: (0, $dWZMi.default)(data.appType)
        }) : /*#__PURE__*/ $cozmU.createElement((0, $cGbTM.SizeableAvatar), {
            src: (0, $hNx4m.getAvatarUrl)(data),
            appearance: appearance,
            type: (0, $9rnjH.isTeam)(data) ? "team" : "person",
            avatarAppearanceShape: (0, $dWZMi.default)(data.appType)
        }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $afcedb8febd5dd73$var$styles.avatarItem
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $afcedb8febd5dd73$var$styles.avatarItemTextWrapper
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $afcedb8febd5dd73$var$styles.avatarItemText
        }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center"
        }, label, /*#__PURE__*/ $cozmU.createElement($afcedb8febd5dd73$var$ElementAfter, props), canShowArchivedLozenge ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $afcedb8febd5dd73$var$styles.archivedLozengeWrapper
        }, /*#__PURE__*/ $cozmU.createElement((0, $9KSWX.default), {
            appearance: "neutral"
        }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $7xLai.messages).archivedLozenge))) : null)))))) : null;
        $[2] = appearance;
        $[3] = canShowArchivedLozenge;
        $[4] = data;
        $[5] = isFocused;
        $[6] = label;
        $[7] = props;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : (props)=>{
    const { data: { label: label, data: data }, selectProps: { appearance: appearance, isFocused: isFocused } } = props;
    const canShowArchivedLozenge = (0, $9rnjH.isTeam)(data) && data?.state === 'DISBANDED';
    return !isFocused ? /*#__PURE__*/ $cozmU.createElement((0, $l9ukq.components).SingleValue, props, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        xcss: $afcedb8febd5dd73$var$styles.avatarItem
    }, data.icon ? /*#__PURE__*/ $cozmU.createElement((0, $lvlsM.AvatarOrIcon), {
        icon: data.icon,
        iconColor: data.iconColor,
        src: (0, $hNx4m.getAvatarUrl)(data),
        appearance: appearance,
        type: (0, $9rnjH.isTeam)(data) ? 'team' : 'person',
        avatarAppearanceShape: (0, $dWZMi.default)(data.appType)
    }) : /*#__PURE__*/ $cozmU.createElement((0, $cGbTM.SizeableAvatar), {
        src: (0, $hNx4m.getAvatarUrl)(data),
        appearance: appearance,
        type: (0, $9rnjH.isTeam)(data) ? 'team' : 'person',
        avatarAppearanceShape: (0, $dWZMi.default)(data.appType)
    }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $afcedb8febd5dd73$var$styles.avatarItem
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $afcedb8febd5dd73$var$styles.avatarItemTextWrapper
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $afcedb8febd5dd73$var$styles.avatarItemText
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center"
    }, label, /*#__PURE__*/ $cozmU.createElement($afcedb8febd5dd73$var$ElementAfter, props), canShowArchivedLozenge ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $afcedb8febd5dd73$var$styles.archivedLozengeWrapper
    }, /*#__PURE__*/ $cozmU.createElement((0, $9KSWX.default), {
        appearance: "neutral"
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $7xLai.messages).archivedLozenge))) : null)))))) : null;
};
module.exports["SingleValue"] = $afcedb8febd5dd73$export$1949dac661ba6e3a;

});

parcelRegister("cnIP4", function(module, exports) {
/* Input.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $l9ukq = parcelRequire("l9ukq");

function $0a548c9faa3635cd$var$_defineProperty(e, r, t) {
    return (r = $0a548c9faa3635cd$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $0a548c9faa3635cd$var$_toPropertyKey(t) {
    var i = $0a548c9faa3635cd$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $0a548c9faa3635cd$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $0a548c9faa3635cd$var$inputStyles = {
    root: "_0lRTubKGUX _3C3m0V7dHp _18bzZTKGUX"
};
class $0a548c9faa3635cd$export$f5b8910cec6cf069 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    get ariaLabelledBy() {
        // A11Y-37267: An explicit aria-labelledby is a deliberate association with a visible label
        // element and is the field's true accessible name (WCAG 2.5.3 Label in Name), so it always
        // wins. Otherwise we promote aria-describedby -> aria-labelledby to work around
        // react-select's placeholder linkage bug, but skip that promotion when the input already
        // has an accessible name via aria-label so the description is announced via
        // aria-describedby instead.
        if (this.props['aria-labelledby']) return this.props['aria-labelledby'];
        if (this.props['aria-label']) return undefined;
        return this.props['aria-describedby'];
    }
    get ariaDescribedBy() {
        return this.props.selectProps?.['aria-describedby'] ?? this.props['aria-describedby'];
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).Input, {
            ...this.props,
            "aria-labelledby": this.ariaLabelledBy,
            "aria-describedby": this.ariaDescribedBy,
            innerRef: this.props.innerRef,
            onKeyPress: this.handleKeyPress,
            xcss: $0a548c9faa3635cd$var$inputStyles.root
        });
    }
    constructor(...args){
        super(...args); // onKeyPress is used instead as
        // react-select is using onKeyDown for capturing keyboard input
        $0a548c9faa3635cd$var$_defineProperty(this, "handleKeyPress", (e)=>{
            if (e.key === 'Enter') e.preventDefault();
            if (this.props.selectProps?.disableInput) e.preventDefault();
        });
    }
}
module.exports["Input"] = $0a548c9faa3635cd$export$f5b8910cec6cf069;

});

parcelRegister("bPMiS", function(module, exports) {
/* SingleValueContainer.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $l9ukq = parcelRequire("l9ukq");


var $lvlsM = parcelRequire("lvlsM");


var $cGbTM = parcelRequire("cGbTM");


var $9gNGh = parcelRequire("9gNGh");


var $dWZMi = parcelRequire("dWZMi");

function $66428c86f185db93$var$_defineProperty(e, r, t) {
    return (r = $66428c86f185db93$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $66428c86f185db93$var$_toPropertyKey(t) {
    var i = $66428c86f185db93$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $66428c86f185db93$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $66428c86f185db93$var$valueContainerStyles = {
    root: "_2iEGP2N2y8 _0Of8r2gVvo _1wydGWgVvo _2Zuz6QPgdg _4bt5LAnQyn _2WAcuGIZbP _3oUqlsYbGa _0NUa3rN91d _4ho0wCjOvk _3ILZpPdnbC"
};
const $66428c86f185db93$var$placeholderIconContainer = null;
const $66428c86f185db93$var$wrapperStyle = null;
const $66428c86f185db93$var$showUserAvatar = (inputValue, value)=>value && value.data && inputValue === value.label;
class $66428c86f185db93$export$afa5f855316c6a48 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        const { children: children, ...valueContainerProps } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9gNGh.default), {
            isEnabled: this.onValueContainerClick,
            onMouseDown: this.onValueContainerClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).ValueContainer, {
            ...valueContainerProps,
            xcss: $66428c86f185db93$var$valueContainerStyles.root
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_1xC2CJarlp _2Zuz6QgVvo _26BoRwdnbC"
            ])
        }, this.renderAvatar()), children));
    }
    constructor(...args){
        super(...args);
        $66428c86f185db93$var$_defineProperty(this, "renderAvatar", ()=>{
            const { hasValue: hasValue, selectProps: { appearance: appearance, isFocused: isFocused, inputValue: inputValue, value: value, placeholderAvatar: placeholderAvatar } } = this.props;
            if (isFocused || !hasValue) {
                const userData = $66428c86f185db93$var$showUserAvatar(inputValue, value) ? value.data : undefined;
                if (userData?.icon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lvlsM.AvatarOrIcon), {
                    appearance: appearance,
                    icon: userData.icon,
                    iconColor: userData.iconColor,
                    type: placeholderAvatar,
                    src: userData.avatarUrl,
                    avatarAppearanceShape: userData ? (0, $dWZMi.default)(userData.appType) : undefined
                });
                 // Fallback to original behavior
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cGbTM.SizeableAvatar), {
                    appearance: appearance,
                    type: placeholderAvatar,
                    src: userData?.avatarUrl,
                    avatarAppearanceShape: userData ? (0, $dWZMi.default)(userData.appType) : undefined
                });
            }
            return null;
        });
        $66428c86f185db93$var$_defineProperty(this, "onValueContainerClick", this.props.selectProps.onValueContainerClick);
        $66428c86f185db93$var$_defineProperty(this, "Wrapper", ({ children: children })=>{
            return this.onValueContainerClick ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                onMouseDown: this.onValueContainerClick,
                className: (0, $hekY6.default)([
                    "_2O5Vij7dHp"
                ])
            }, children) : children;
        });
    }
}
module.exports["SingleValueContainer"] = $66428c86f185db93$export$afa5f855316c6a48;

});

parcelRegister("97jiw", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cnIP4 = parcelRequire("cnIP4");

class $ae16fbc8746297f4$export$d8edbfd510a7db82 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidMount() {
        if (this.ref) // @ts-ignore
        this.ref.select();
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cnIP4.Input), {
            ...this.props,
            innerRef: this.handleInnerRef
        });
    }
    constructor(...args){
        super(...args);
        this.ref = null;
        this.handleInnerRef = (ref)=>{
            this.ref = ref;
            if (this.props.innerRef) this.props.innerRef(ref);
        };
    }
}
module.exports["PopupInput"] = $ae16fbc8746297f4$export$d8edbfd510a7db82;

});

parcelRegister("8otJJ", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $dnFcR = parcelRequire("dnFcR");

function $aa22d968e17202e4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $aa22d968e17202e4$var$controlWrapper = /*#__PURE__*/ (0, $lOiVq.css)({
    display: 'flex',
    flexDirection: 'column',
    padding: `0px ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
});
const $aa22d968e17202e4$var$labelStyle = {
    name: "14uum76",
    styles: "color:var(--ds-text-subtlest, #6B6E76);font:var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-semibold, 600);padding-bottom:var(--ds-space-050, 4px);padding-left:var(--ds-space-0, 0px);padding-right:var(--ds-space-0, 0px);padding-top:var(--ds-space-250, 20px)"
};
class $aa22d968e17202e4$export$a0cb1b4352357fcc extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    render() {
        const { selectProps: { popupTitle: popupTitle } } = this.props;
        return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: $aa22d968e17202e4$var$controlWrapper
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: $aa22d968e17202e4$var$labelStyle
        }, popupTitle), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $dnFcR.default), this.props));
    }
}
module.exports["PopupControl"] = $aa22d968e17202e4$export$a0cb1b4352357fcc;

});

parcelRegister("dnFcR", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $l9ukq = parcelRequire("l9ukq");


var $k12R1 = parcelRequire("k12R1");

const $b9f98721f1489aa7$var$controlStyles = {
    invalid: "_3vBAKHnod9 _0hPERGnod9",
    focused: "_3vBAKHnXvL _0KLXru7Cj1 _0hPERGnXvL _1eOmH67Cj1",
    disabled: "_1eOmH6VrZW",
    subtle: "_3vBAKHjOvk _0KLXrujOvk _0hPERGjOvk _1eOmH6hH7k",
    root: "_0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _3vBAKHHKt7 _0KLXru7Cj1 _1EqgXlN91d _2GNrf4AASz _0hPERGHKt7 _1eOmH6qWX3 _33hNqm3mKv",
    compact: "_4kiQYAIZbP"
};
const $b9f98721f1489aa7$var$Control = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(9);
    const isCompact = props.appearance === "compact";
    const t0 = isCompact && $b9f98721f1489aa7$var$controlStyles.compact;
    const t1 = (props.selectProps.subtle || props.selectProps.noBorder) && $b9f98721f1489aa7$var$controlStyles.subtle;
    const t2 = props.isFocused && $b9f98721f1489aa7$var$controlStyles.focused;
    const t3 = props.isInvalid && $b9f98721f1489aa7$var$controlStyles.invalid;
    const t4 = props.isDisabled && $b9f98721f1489aa7$var$controlStyles.disabled;
    let t5;
    if ($[0] !== t0 || $[1] !== t1 || $[2] !== t2 || $[3] !== t3 || $[4] !== t4) {
        t5 = (0, $k12R1.cx)($b9f98721f1489aa7$var$controlStyles.root, t0, t1, t2, t3, t4);
        $[0] = t0;
        $[1] = t1;
        $[2] = t2;
        $[3] = t3;
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== props || $[7] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $l9ukq.components).Control, {
            ...props,
            xcss: t5
        });
        $[6] = props;
        $[7] = t5;
        $[8] = t6;
    } else t6 = $[8];
    return t6;
} : (props)=>{
    const isCompact = props.appearance === 'compact';
    return /*#__PURE__*/ $cozmU.createElement((0, $l9ukq.components).Control, {
        ...props,
        xcss: (0, $k12R1.cx)($b9f98721f1489aa7$var$controlStyles.root, isCompact && $b9f98721f1489aa7$var$controlStyles.compact, (props.selectProps.subtle || props.selectProps.noBorder) && $b9f98721f1489aa7$var$controlStyles.subtle, props.isFocused && $b9f98721f1489aa7$var$controlStyles.focused, props.isInvalid && $b9f98721f1489aa7$var$controlStyles.invalid, props.isDisabled && $b9f98721f1489aa7$var$controlStyles.disabled)
    });
};
var $b9f98721f1489aa7$export$2e2bcd8739ae039 = $b9f98721f1489aa7$var$Control;
module.exports["default"] = $b9f98721f1489aa7$export$2e2bcd8739ae039;

});

parcelRegister("bV3S4", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $l9ukq = parcelRequire("l9ukq");


var $lOiVq = parcelRequire("lOiVq");

const $797d49a3eba443b9$var$getFooterStyle = ()=>{
    return /*#__PURE__*/ (0, $lOiVq.css)({
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"}`
    });
};
class $797d49a3eba443b9$export$d9b273488cd8ce6f extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $l9ukq.components).Menu, this.props, this.props.selectProps.header, this.props.children, this.props.selectProps.footer && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: $797d49a3eba443b9$var$getFooterStyle()
        }, this.props.selectProps.footer));
    }
}
module.exports["Menu"] = $797d49a3eba443b9$export$d9b273488cd8ce6f;

});

parcelRegister("1aEbM", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $9kYT2 = parcelRequire("9kYT2");


var $bsEy7 = parcelRequire("bsEy7");


var $7jjhc = parcelRequire("7jjhc");

const $ff7ae3636e19fcd6$var$validOption = [
    'VALID',
    'POTENTIAL'
];
const $ff7ae3636e19fcd6$var$isValidNewOption = (isValidEmail = (0, $bsEy7.isValidEmail))=>(inputValue)=>inputValue && $ff7ae3636e19fcd6$var$validOption.includes(isValidEmail(inputValue));
const $ff7ae3636e19fcd6$var$getNewOptionData = (inputValue)=>({
        label: inputValue,
        value: inputValue,
        data: {
            id: inputValue,
            name: inputValue,
            type: (0, $9kYT2.EmailType)
        }
    });
const $ff7ae3636e19fcd6$var$formatCreateLabel = (inputText)=>{
    if (inputText) return inputText.trim();
    return '';
};
const $ff7ae3636e19fcd6$var$isOptionDisabled = (isValidEmail = (0, $bsEy7.isValidEmail))=>(option)=>{
        if ((0, $7jjhc.isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
        return !!option.isDisabled;
    };
function $ff7ae3636e19fcd6$var$creatableProps(isValidEmail) {
    return {
        allowCreateWhileLoading: true,
        createOptionPosition: 'first',
        isValidNewOption: $ff7ae3636e19fcd6$var$isValidNewOption(isValidEmail),
        getNewOptionData: $ff7ae3636e19fcd6$var$getNewOptionData,
        formatCreateLabel: $ff7ae3636e19fcd6$var$formatCreateLabel,
        isOptionDisabled: $ff7ae3636e19fcd6$var$isOptionDisabled(isValidEmail)
    };
}
const $ff7ae3636e19fcd6$export$36f97d8afa97203d = (0, $dOBRD.default)($ff7ae3636e19fcd6$var$creatableProps);
module.exports["getCreatableProps"] = $ff7ae3636e19fcd6$export$36f97d8afa97203d;

});

parcelRegister("7HZsv", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $9kYT2 = parcelRequire("9kYT2");


var $bsEy7 = parcelRequire("bsEy7");


var $7jjhc = parcelRequire("7jjhc");

const $c6733fa977d328f9$var$validOption = [
    'VALID',
    'POTENTIAL'
];
const $c6733fa977d328f9$var$isValidNewOption = (inputValue)=>inputValue && inputValue.length > 0;
// Generates suggested option data based on user input and validity of the input (if it is an email or not);
const $c6733fa977d328f9$var$getNewOptionData = (isValidEmail = (0, $bsEy7.isValidEmail), emailDomain)=>(inputValue)=>{
        if (!inputValue) return null;
        const isEmail = inputValue && $c6733fa977d328f9$var$validOption.includes(isValidEmail(inputValue));
        const value = isEmail ? inputValue : `${inputValue.replace(/\s+/g, '.').toLocaleLowerCase()}@${emailDomain}`;
        return {
            label: value,
            value: value,
            data: {
                id: value,
                name: value,
                type: (0, $9kYT2.EmailType),
                suggestion: true
            }
        };
    };
const $c6733fa977d328f9$var$formatCreateLabel = (inputText)=>{
    if (inputText) return inputText.trim();
    return '';
};
// Option will not be selectable until the email value is valid and can actually be invited
const $c6733fa977d328f9$var$isOptionDisabled = (isValidEmail = (0, $bsEy7.isValidEmail))=>(option)=>{
        if ((0, $7jjhc.isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
        return !!option.isDisabled;
    };
const $c6733fa977d328f9$export$34b9dd2dd6a225e5 = (0, $dOBRD.default)((emailDomain, isValidEmail)=>({
        allowCreateWhileLoading: true,
        createOptionPosition: 'last',
        isValidNewOption: $c6733fa977d328f9$var$isValidNewOption,
        getNewOptionData: $c6733fa977d328f9$var$getNewOptionData(isValidEmail, emailDomain),
        formatCreateLabel: $c6733fa977d328f9$var$formatCreateLabel,
        isOptionDisabled: $c6733fa977d328f9$var$isOptionDisabled(isValidEmail)
    }));
module.exports["getCreatableSuggestedEmailProps"] = $c6733fa977d328f9$export$34b9dd2dd6a225e5;

});

parcelRegister("aeELu", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $1TlML = parcelRequire("1TlML");


var $dOBRD = parcelRequire("dOBRD");

const $4ae7cbc7591eb216$export$59c188914e58c94b = "var(--ds-space-075, 6px)";
const $4ae7cbc7591eb216$export$53937c04f7dfc2ae = 6;
const $4ae7cbc7591eb216$export$2c62ba763e976c54 = 39;
const $4ae7cbc7591eb216$export$ffd58b7f6f099a57 = (0, $dOBRD.default)((width, isMulti, isCompact, overrideStyles, isVisualRefresh, isPopupStyles, height, minHeight)=>{
    let styles = {
        menu: (css, state)=>({
                ...css,
                width: width,
                minWidth: state.selectProps.menuMinWidth,
                zIndex: '400'
            }),
        menuList: (css)=>({
                ...css,
                zIndex: '400'
            }),
        control: (css, state)=>{
            const isMulti = state.selectProps.isMulti;
            return {
                ...css,
                width: width,
                borderColor: state.isFocused ? "var(--ds-border-focused, #4688EC)" : state.isInvalid ? "var(--ds-border-danger, #E2483D)" : state.selectProps.subtle || state.selectProps.noBorder ? 'transparent' : "var(--ds-border-input, #8C8F97)",
                backgroundColor: state.isFocused ? "var(--ds-background-input, #FFFFFF)" : state.selectProps.subtle ? 'transparent' : state.isDisabled && (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? "var(--ds-background-disabled, #0515240F)" : state.selectProps.textFieldBackgroundColor ? "var(--ds-background-input, #FFFFFF)" : "var(--ds-background-input, #FFFFFF)",
                '&:hover .fabric-user-picker__clear-indicator': {
                    opacity: 1
                },
                ':hover': {
                    ...css[':hover'],
                    borderColor: state.isFocused ? css[':hover'] ? "var(--ds-border-focused, #4688EC)" : "var(--ds-border-focused, #4688EC)" : state.isInvalid ? "var(--ds-border-danger, #E2483D)" : state.selectProps.subtle ? 'transparent' : "var(--ds-border-input, #8C8F97)",
                    backgroundColor: state.selectProps.subtle && state.selectProps.hoveringClearIndicator ? "var(--ds-background-danger, #FFECEB)" : state.isFocused ? css[':hover'] ? "var(--ds-background-input, #FFFFFF)" : "var(--ds-background-input, #FFFFFF)" : state.isDisabled ? "var(--ds-background-disabled, #0515240F)" : "var(--ds-background-input-hovered, #F8F8F8)"
                },
                padding: 0,
                minHeight: minHeight ? minHeight : height || isCompact ? isMulti && (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? 30 : 'none' : isMulti && (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? 42 : 44,
                /* IE 11 needs to set height explicitly to be vertical align when being in not compact mode */ height: height ? height : isCompact || isMulti ? '100%' : 44,
                maxWidth: '100%'
            };
        },
        clearIndicator: ({ _paddingTop: _paddingTop, _paddingBottom: _paddingBottom, _paddingLeft: _paddingLeft, _paddingRight: _paddingRight, ...css })=>({
                ...css,
                // By default show clear indicator, except for on devices where "hover" is supported.
                // This means mobile devices (which do not support hover) will be able to see the clear indicator.
                opacity: 1,
                '@media (hover: hover) and (pointer: fine)': {
                    opacity: 0
                },
                transition: css.transition + ', opacity 150ms',
                paddingTop: 0,
                padding: 0,
                ':hover': {
                    color: "var(--ds-icon-danger, #C9372C)"
                }
            }),
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        valueContainer: ({ _paddingTop: _paddingTop, _paddingBottom: _paddingBottom, _position: _position, ...css }, state)=>{
            const isMulti = state.selectProps.isMulti;
            return {
                ...css,
                gridTemplateColumns: 'auto 1fr',
                paddingTop: isCompact ? isMulti && (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? "var(--ds-space-025, 2px)" : 0 : isMulti && (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? "var(--ds-space-100, 8px)" : $4ae7cbc7591eb216$export$59c188914e58c94b,
                paddingBottom: isCompact ? isMulti && (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? "var(--ds-space-025, 2px)" : 0 : isMulti && (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? "var(--ds-space-100, 8px)" : $4ae7cbc7591eb216$export$59c188914e58c94b,
                // Match pre–tag-uplift leading inset when only the placeholder shows (share dialog VR, etc.).
                paddingLeft: isMulti ? state.hasValue && state.selectProps.controlShouldRenderValue !== false && (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? "var(--ds-space-100, 8px)" : $4ae7cbc7591eb216$export$59c188914e58c94b : 0,
                gap: isMulti && (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? "var(--ds-space-050, 4px)" : undefined,
                overflowX: 'hidden',
                overflowY: 'auto',
                scrollbarWidth: 'none',
                maxHeight: state.selectProps.maxPickerHeight || '100%',
                '::-webkit-scrollbar': {
                    width: 0,
                    background: 'transparent'
                }
            };
        },
        multiValue: (css)=>({
                ...css,
                borderRadius: 24,
                cursor: 'default'
            }),
        multiValueLabel: (css)=>({
                ...css,
                display: 'flex'
            }),
        multiValueRemove: (css)=>({
                ...css,
                borderRadius: 24,
                cursor: 'pointer'
            }),
        placeholder: (css, state)=>{
            // fix styling in IE 11: when the position is absolute and `left` prop is not defined,
            // IE and other browsers auto calculate value of "left" prop differently,
            // so we want to explicitly set value for the `left` property
            if (css.position === 'absolute' && !css.left) css.left = `${$4ae7cbc7591eb216$export$59c188914e58c94b}px`;
            return {
                ...css,
                gridArea: '1/2/2/3',
                paddingLeft: state.selectProps.isMulti ? 0 : $4ae7cbc7591eb216$export$59c188914e58c94b,
                /* Margin left right of 2px set by default */ // margin: `0 ${BORDER_PADDING}px`,
                margin: 0,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            };
        },
        option: (css)=>{
            if (isVisualRefresh) return {
                ...css,
                overflow: 'hidden',
                paddingLeft: isPopupStyles ? "var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px)",
                paddingRight: isPopupStyles ? "var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px)"
            };
            return {
                ...css,
                overflow: 'hidden'
            };
        },
        input: (css, state)=>({
                ...css,
                gridArea: '1/2/2/3',
                gridTemplateColumns: isMulti && state.placeholder ? '0 123px' : css.gridTemplateColumns,
                /* Necessary to make input height and tag height the same. */ margin: isMulti && (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? 0 : `${"var(--ds-space-050, 4px)"} 0`,
                /* Padding top and bottom of 2 is set by default. */ paddingTop: 0,
                paddingBottom: 0,
                ...isMulti && (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') && {
                    height: "var(--ds-space-250, 20px)",
                    alignItems: 'center'
                },
                paddingLeft: state.selectProps.isMulti ? 0 : $4ae7cbc7591eb216$export$59c188914e58c94b,
                '& input::placeholder': {
                    /* Chrome, Firefox, Opera, Safari 10.1+ */ color: "var(--ds-text-subtlest, #6B6E76)",
                    opacity: 1 /* Firefox */ 
                },
                '& input:-ms-input-placeholder': {
                    /* Internet Explorer 10-11 */ color: "var(--ds-text-subtlest, #6B6E76)"
                }
            }),
        singleValue: (css)=>({
                ...css,
                margin: 0,
                gridArea: '1/2/2/3'
            })
    };
    return overrideStyles ? (0, $1TlML.mergeStyles)(styles, overrideStyles) : styles;
});
const $4ae7cbc7591eb216$export$4e983f376ad8a3af = (0, $dOBRD.default)((width, isMulti, overrideStyles, isVisualRefresh)=>({
        ...$4ae7cbc7591eb216$export$ffd58b7f6f099a57(width, isMulti, false, overrideStyles, isVisualRefresh, true)
    }));
module.exports["getStyles"] = $4ae7cbc7591eb216$export$ffd58b7f6f099a57;

});

parcelRegister("e6Ach", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $3X3EV = parcelRequire("3X3EV");


var $iWhnp = parcelRequire("iWhnp");


var $2qYWP = parcelRequire("2qYWP");

const $bfdefd8cab144f9e$var$CreatableSelect = /*#__PURE__*/ (0, $cozmU.forwardRef)((props, ref)=>{
    const creatableProps = (0, $2qYWP.default)(props);
    const selectProps = (0, $iWhnp.default)(creatableProps);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3X3EV.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$bfdefd8cab144f9e$export$2e2bcd8739ae039 = $bfdefd8cab144f9e$var$CreatableSelect;
module.exports["default"] = $bfdefd8cab144f9e$export$2e2bcd8739ae039;

});

parcelRegister("iWhnp", function(module, exports) {
$parcel$export(module.exports, "default", () => $8107ecf375dbb21a$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");


var $bJjSn = parcelRequire("bJjSn");


var $kskvm = parcelRequire("kskvm");


var $hNobR = parcelRequire("hNobR");


var $aeRIw = parcelRequire("aeRIw");

const $8107ecf375dbb21a$var$compareOption = (inputValue = '', option, accessors)=>{
    const candidate = String(inputValue).toLowerCase();
    const optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    const optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
const $8107ecf375dbb21a$var$builtins = {
    formatCreateLabel: (inputValue)=>`Create "${inputValue}"`,
    isValidNewOption: (inputValue, selectValue, selectOptions, accessors)=>!(!inputValue || selectValue.some((option)=>$8107ecf375dbb21a$var$compareOption(inputValue, option, accessors)) || selectOptions.some((option)=>$8107ecf375dbb21a$var$compareOption(inputValue, option, accessors))),
    getNewOptionData: (inputValue, optionLabel)=>({
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        })
};
function $8107ecf375dbb21a$export$2e2bcd8739ae039({ allowCreateWhileLoading: allowCreateWhileLoading = false, createOptionPosition: createOptionPosition = 'last', formatCreateLabel: formatCreateLabel = $8107ecf375dbb21a$var$builtins.formatCreateLabel, isValidNewOption: isValidNewOption = $8107ecf375dbb21a$var$builtins.isValidNewOption, getNewOptionData: //@ts-ignore
getNewOptionData = $8107ecf375dbb21a$var$builtins.getNewOptionData, onCreateOption: onCreateOption, options: propsOptions = [], onChange: propsOnChange, ...restSelectProps }) {
    const { getOptionValue: getOptionValue = (0, $kskvm.getOptionValue), getOptionLabel: getOptionLabel = (0, $bJjSn.getOptionLabel), inputValue: inputValue, isLoading: isLoading, isMulti: isMulti, value: value, name: name } = restSelectProps;
    const newOption = (0, $cozmU.useMemo)(()=>isValidNewOption(inputValue, (0, $hNobR.cleanValue)(value), propsOptions, {
            getOptionValue: getOptionValue,
            getOptionLabel: getOptionLabel
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel,
        getOptionValue,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    const options = (0, $cozmU.useMemo)(()=>(allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
            newOption,
            ...propsOptions
        ] : [
            ...propsOptions,
            newOption
        ] : propsOptions, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    const onChange = (0, $cozmU.useCallback)((newValue, actionMeta)=>{
        if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
        const valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                const newOptionData = getNewOptionData(inputValue, inputValue);
                const newActionMeta = {
                    action: 'create-option',
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, $aeRIw.valueTernary)(isMulti, [
                    ...(0, $hNobR.cleanValue)(value),
                    newOptionData
                ], newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return {
        ...restSelectProps,
        options: options,
        onChange: onChange
    };
}

});

parcelRegister("8lhhf", function(module, exports) {
const $57d7e56ed333ab64$export$d0e832101df0ac96 = 'com.atlassian.rovo.skill';
const $57d7e56ed333ab64$export$d4f002c79ea2ad20 = 'skill';
const $57d7e56ed333ab64$export$e4d0b30afd49f7df = 'skillTag';
const $57d7e56ed333ab64$export$18f911e214c46d8 = /\/([a-zA-Z0-9-]+)/g;
const $57d7e56ed333ab64$export$aae1b80712c1b67b = `${$57d7e56ed333ab64$export$d4f002c79ea2ad20}:${$57d7e56ed333ab64$export$e4d0b30afd49f7df}`;
const $57d7e56ed333ab64$export$b22d8560058c60e1 = (extensionType, extensionKey)=>{
    return extensionType === $57d7e56ed333ab64$export$d0e832101df0ac96 && extensionKey === $57d7e56ed333ab64$export$aae1b80712c1b67b;
};
const $57d7e56ed333ab64$export$f88fd0c0ee7d509a = (skill)=>{
    return [
        {
            type: 'inlineExtension',
            attrs: {
                extensionKey: $57d7e56ed333ab64$export$aae1b80712c1b67b,
                extensionType: $57d7e56ed333ab64$export$d0e832101df0ac96,
                parameters: skill
            }
        },
        // render an empty space after the skill tag
        {
            type: 'text',
            text: ' '
        }
    ];
};
const $57d7e56ed333ab64$export$a425ebfe740d9932 = (skill)=>({
        type: 'doc',
        version: 1,
        content: [
            {
                type: 'paragraph',
                content: $57d7e56ed333ab64$export$f88fd0c0ee7d509a(skill)
            }
        ]
    });
module.exports["ROVO_SKILL_EXTENSION_TYPE"] = $57d7e56ed333ab64$export$d0e832101df0ac96;
module.exports["ROVO_SKILL_EXTENSION_KEY"] = $57d7e56ed333ab64$export$d4f002c79ea2ad20;
module.exports["ROVO_SKILL_TAG_PATTERN"] = $57d7e56ed333ab64$export$18f911e214c46d8;
module.exports["ROVO_SKILL_COMBINED_EXTENSION_KEY"] = $57d7e56ed333ab64$export$aae1b80712c1b67b;
module.exports["isSkillTagExtension"] = $57d7e56ed333ab64$export$b22d8560058c60e1;
module.exports["createSkillNode"] = $57d7e56ed333ab64$export$f88fd0c0ee7d509a;
module.exports["createSkillAdf"] = $57d7e56ed333ab64$export$a425ebfe740d9932;

});

parcelRegister("9cGsb", function(module, exports) {
"use strict";
var $6b362a72760d8152$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
function $6b362a72760d8152$var$__export(m) {
    for(var p in m)if (!module.exports.hasOwnProperty(p)) module.exports[p] = m[p];
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bAWmc = parcelRequire("bAWmc");


$6b362a72760d8152$var$__export((parcelRequire("5ixmT")));
/**
 * InvalidAriError - an error thrown if an invalid Ari is constructed
 */ var $6b362a72760d8152$var$InvalidAriError = /** @class */ function(_super) {
    $6b362a72760d8152$var$__extends(InvalidAriError, _super);
    /**
   * Construct an InvalidAriError given an error message
   *
   * @param {string} ariString - the ARI that failed to parse
   * @param {string|undefined} description - The error message
   */ function InvalidAriError(ariString, description) {
        var _this = _super.call(this, "Invalid ari string: " + ariString + (description ? '. ' + description : '')) || this;
        _this.ariString = ariString;
        // Support correct inheritance in ES5
        Object.setPrototypeOf(_this, InvalidAriError.prototype);
        return _this;
    }
    /**
   * Construct an InvalidAriError given some constraint violations
   *
   * @param {string} ariString - the ARI that failed to parse
   * @param {ConstraintViolation<Object>[]} violations - The array of constraint errors
   */ InvalidAriError.withConstraintViolations = function(ariString, violations) {
        return new InvalidAriError(ariString, violations.map(function(v) {
            return v.toString();
        }).join('\n'));
    };
    return InvalidAriError;
}(Error);
module.exports.InvalidAriError = $6b362a72760d8152$var$InvalidAriError;
function $6b362a72760d8152$var$matchesSegment(value1, value2) {
    if (value1 === value2) return true;
    else if (value1 === undefined) return true;
    return false;
}
// constraints are based on draft of v2 spec https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0#AtlassianResourceIdentifierSpec(draft-2.0)-Syntax
var $6b362a72760d8152$var$basicCharConstraint = $bAWmc.pattern(/^[a-z][a-z.-]*$/);
var $6b362a72760d8152$var$resourceOwnerConstraints = [
    $bAWmc.lengthBetween(3, 255),
    $6b362a72760d8152$var$basicCharConstraint
];
var $6b362a72760d8152$var$resourceTypeConstraints = [
    $bAWmc.lengthBetween(3, 255),
    $6b362a72760d8152$var$basicCharConstraint
];
var $6b362a72760d8152$var$cloudIdConstraints = [
    $bAWmc.lengthBetween(36, 255)
];
var $6b362a72760d8152$var$siteResourceType = 'site';
var $6b362a72760d8152$var$resourceIdChars = /[\w-._~:@#]/.source;
var $6b362a72760d8152$var$resourceIdConstraints = [
    $bAWmc.pattern(new RegExp("^" + $6b362a72760d8152$var$resourceIdChars + "+(/" + $6b362a72760d8152$var$resourceIdChars + "*)*(;v=" + $6b362a72760d8152$var$resourceIdChars + "*)*$"))
]; /**
                                                                                                                                                          * Returns an Ari that is of the latest version of the Ari spec that we support. Any legacy formats
                                                                                                                                                          * (like those for site wide ARIs) are upgraded to their latest form.
                                                                                                                                                          */ 
function $6b362a72760d8152$var$upgrade(values) {
    var resourceId = values.resourceId, resourceOwner = values.resourceOwner, cloudId = values.cloudId; // note: The new ARI spec has not defined a format for system wide contexts so we exclude them from upgrade
    if (!resourceId && cloudId) return {
        resourceOwner: resourceOwner,
        resourceType: $6b362a72760d8152$var$siteResourceType,
        resourceId: cloudId
    };
    else return values;
}
var $6b362a72760d8152$var$ResourceIdentifier = /** @class */ function() {
    /**
   * Create a new Ari
   *
   * Only the resourceOwner is a required field, any other field can be omitted.
   * Older format types are converted on creation
   *
   * @param {string} values.resourceOwner - the owner of this resource (e.g. hipchat, confluence or jira)
   * @param {string|undefined} values.cloudId - the cloud id for this identifier, defined in AID
   * @param {string|undefined} values.resourceType - the resource type this Ari is associated with (e.g. conversation in hipchat)
   * @param {string|undefined} values.resourceId - a resource identifier, if this is specified the associated resourceType *must* be provided.
   *
   * @throws {InvalidAriError} if the provided segments fail to pass validation
   */ function ResourceIdentifier(values) {
        var _a = $6b362a72760d8152$var$upgrade(values), resourceId = _a.resourceId, resourceOwner = _a.resourceOwner, resourceType = _a.resourceType, cloudId = _a.cloudId;
        this.resourceOwner = resourceOwner;
        this.internalCloudId = cloudId;
        this.resourceType = resourceType;
        this.resourceId = resourceId;
        this.validate();
    }
    Object.defineProperty(ResourceIdentifier.prototype, "cloudId", {
        get: function() {
            if (this.resourceType === $6b362a72760d8152$var$siteResourceType) return this.internalCloudId ? this.internalCloudId : this.resourceId;
            return this.internalCloudId;
        },
        enumerable: true,
        configurable: true
    });
    /**
  * Parse a string as an Ari
  *
  * @param {string} ariString - the string to parse
  * @returns {Ari} the parsed ari
  * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
  */ ResourceIdentifier.parse = function(ariString) {
        if (!ariString) throw new $6b362a72760d8152$var$InvalidAriError(ariString);
        var match = ariString.match(/^ari:cloud:([^:/]+):([^:/]*):([^:/]*)\/(.*)$/);
        if (!match || match.length !== 5) throw new $6b362a72760d8152$var$InvalidAriError(ariString);
        var terms = match.map(function(a) {
            return a && a.length > 0 ? a : undefined;
        });
        var resourceOwner = terms[1];
        if (!resourceOwner) throw new $6b362a72760d8152$var$InvalidAriError(ariString);
        return new ResourceIdentifier({
            resourceOwner: resourceOwner,
            cloudId: terms[2],
            resourceType: terms[3],
            resourceId: terms[4]
        });
    };
    ResourceIdentifier.parseEncoded = function(encodedAriString) {
        return $6b362a72760d8152$var$parse(decodeURIComponent(encodedAriString));
    }; /**
      * Converts this Ari to a string.
      */ 
    ResourceIdentifier.prototype.toString = function() {
        if (!this.ariString) {
            var resourceId = this.resourceType === $6b362a72760d8152$var$siteResourceType && this.internalCloudId ? this.internalCloudId : this.resourceId || '';
            var resourceType = this.resourceType || '';
            var sanitizedCloudId = this.resourceType === $6b362a72760d8152$var$siteResourceType ? '' : this.internalCloudId || '';
            this.ariString = "ari:cloud:" + this.resourceOwner + ":" + sanitizedCloudId + ":" + resourceType + "/" + resourceId;
        }
        return this.ariString;
    }; /**
      * Converts this object to its json representation
      */ 
    ResourceIdentifier.prototype.toJSON = function() {
        return this.toString();
    }; /**
      * Checks if this context is the same as another context
      *
      * @param {Ari} other - the other parameter to match with
      * @returns {boolean} - true if all segments of both Aris are equal, false otherwise
      */ 
    ResourceIdentifier.prototype.equals = function(other) {
        return other instanceof ResourceIdentifier && this.resourceOwner === other.resourceOwner && this.cloudId === other.cloudId && this.resourceType === other.resourceType && this.resourceId === other.resourceId;
    }; /**
      * This method checks if the current context contains the other context.
      *
      * Note: it does that by transforming a site context  (e.g. `ari:cloud:<resource owner>:site/<cloud id>`)
      * if required to an "any" resource type context (e.g. `ari:cloud:<resource owner>:<cloud id>:/`)
      *
      * @param {Ari} other
      * @returns {boolean}
      */ 
    ResourceIdentifier.prototype.contains = function(other) {
        return this.matches(new ResourceIdentifier(other));
    }; /**
      * Checks if this context is the same as or contains the provided context.
      *
      * Undefined segments in this ARI are treated as wildcards for matching purposes, but must exactly
      *  match if they are provided in the `other` Ari - i.e. this method is not commutative.
      *
      * e.g.
      * ```
      * parse('ari:cloud:hipchat::/').contains(parse('ari:cloud:hipchat:cloudid:conversation/blah')) === true
      * parse('ari:cloud:hipchat:cloudid:conversation/blah').contains(parse('ari:cloud:hipchat::/')) === false
      *
      * @param {Ari} other - the other parameter to match with
      * @returns {boolean} true if this Ari is the same as the other Ari, or matches the other Ari. False otherwise.
      */ 
    ResourceIdentifier.prototype.matches = function(other) {
        return $6b362a72760d8152$var$matchesSegment(this.resourceOwner, other.resourceOwner) && $6b362a72760d8152$var$matchesSegment(this.cloudId, other.cloudId) && (this.resourceType === $6b362a72760d8152$var$siteResourceType && !!other.resourceType || $6b362a72760d8152$var$matchesSegment(this.resourceType, other.resourceType)) && (this.resourceType === $6b362a72760d8152$var$siteResourceType && !!other.resourceType || $6b362a72760d8152$var$matchesSegment(this.resourceId, other.resourceId));
    };
    ResourceIdentifier.prototype.validateSiteWide = function() {
        var _a = this, resourceType = _a.resourceType, cloudId = _a.cloudId;
        if (resourceType === $6b362a72760d8152$var$siteResourceType && !cloudId) return new $bAWmc.GeneralValidationError('site wide ARIs must have a cloudId');
    };
    ResourceIdentifier.prototype.validate = function() {
        var constraintViolations = [
            $bAWmc.validateField(this, 'resourceOwner', $6b362a72760d8152$var$resourceOwnerConstraints),
            $bAWmc.validateField(this, 'resourceType', $6b362a72760d8152$var$resourceTypeConstraints),
            $bAWmc.validateField(this, 'resourceId', $6b362a72760d8152$var$resourceIdConstraints),
            $bAWmc.validateField(this, 'cloudId', $6b362a72760d8152$var$cloudIdConstraints),
            this.validateSiteWide()
        ].filter(function(v) {
            return v;
        });
        if (constraintViolations.length > 0) throw $6b362a72760d8152$var$InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
        if (this.resourceId !== undefined && this.resourceType === undefined) throw new $6b362a72760d8152$var$InvalidAriError(this.toString(), 'The resource type must be specified if the resource id is defined.');
    };
    ResourceIdentifier.prototype.urlEncode = function() {
        return encodeURIComponent(this.toString());
    };
    ResourceIdentifier.prototype.urlDecode = function() {
        return decodeURIComponent(this.toString());
    };
    return ResourceIdentifier;
}();
module.exports.ResourceIdentifier = $6b362a72760d8152$var$ResourceIdentifier;
/**
 * Parse a string as an Ari
 *
 * @param {string} ariString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $6b362a72760d8152$var$parse(ariString) {
    return $6b362a72760d8152$var$ResourceIdentifier.parse(ariString);
}
module.exports.parse = $6b362a72760d8152$var$parse; /**
                        * Parse a URL encoded string as an Ari
                        *
                        * @param {string} encodedAriString - the string to parse
                        * @returns {Ari} the parsed ari
                        * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
                        */ 
function $6b362a72760d8152$var$parseEncoded(encodedAriString) {
    return $6b362a72760d8152$var$ResourceIdentifier.parseEncoded(encodedAriString);
}
module.exports.parseEncoded = $6b362a72760d8152$var$parseEncoded;

});

parcelRegister("bAWmc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $871053056dfd3da9$var$LengthConstraint = /** @class */ function() {
    function LengthConstraint(min, max) {
        this.min = min;
        this.max = max;
    }
    Object.defineProperty(LengthConstraint.prototype, "description", {
        get: function() {
            return "length must be between " + this.min + " and " + this.max;
        },
        enumerable: true,
        configurable: true
    });
    LengthConstraint.prototype.isValid = function(value) {
        return !value || value.length >= this.min && value.length <= this.max;
    };
    return LengthConstraint;
}();
module.exports.LengthConstraint = $871053056dfd3da9$var$LengthConstraint;
var $871053056dfd3da9$var$RegexConstraint = /** @class */ function() {
    function RegexConstraint(regex) {
        this.regex = regex;
    }
    Object.defineProperty(RegexConstraint.prototype, "description", {
        get: function() {
            return "value must match regex " + this.regex.source;
        },
        enumerable: true,
        configurable: true
    });
    RegexConstraint.prototype.isValid = function(value) {
        return !value || this.regex.test(value);
    };
    return RegexConstraint;
}();
module.exports.RegexConstraint = $871053056dfd3da9$var$RegexConstraint;
var $871053056dfd3da9$var$GeneralValidationError = /** @class */ function() {
    function GeneralValidationError(error) {
        this.error = error;
    }
    GeneralValidationError.prototype.toString = function() {
        return this.error;
    };
    return GeneralValidationError;
}();
module.exports.GeneralValidationError = $871053056dfd3da9$var$GeneralValidationError;
var $871053056dfd3da9$var$ConstraintViolation = /** @class */ function() {
    function ConstraintViolation(fieldName, value, constraints) {
        this.fieldName = fieldName;
        this.value = value;
        this.constraints = constraints;
    }
    ConstraintViolation.prototype.toString = function() {
        var constraintSummary = this.constraints.map(function(c) {
            return "  - " + c.description;
        }).join('\n');
        return "'" + this.value + "' is not a valid value for " + this.fieldName + " as it violates the following constraints:\n" + constraintSummary;
    };
    return ConstraintViolation;
}();
module.exports.ConstraintViolation = $871053056dfd3da9$var$ConstraintViolation;
function $871053056dfd3da9$var$lengthBetween(min, max) {
    return new $871053056dfd3da9$var$LengthConstraint(min, max);
}
module.exports.lengthBetween = $871053056dfd3da9$var$lengthBetween;
function $871053056dfd3da9$var$pattern(regex) {
    return new $871053056dfd3da9$var$RegexConstraint(regex);
}
module.exports.pattern = $871053056dfd3da9$var$pattern;
function $871053056dfd3da9$var$validateField(object, fieldName, constraints) {
    var value = object[fieldName];
    var violatedConstraints = constraints.map(function(c) {
        return c.isValid(value) ? undefined : c;
    }).filter(function(c) {
        return c;
    });
    return violatedConstraints.length > 0 ? new $871053056dfd3da9$var$ConstraintViolation(fieldName, value, violatedConstraints) : undefined;
}
module.exports.validateField = $871053056dfd3da9$var$validateField;

});

parcelRegister("5ixmT", function(module, exports) {
"use strict";
var $3db8846e4ba8de9f$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $199iK = parcelRequire("199iK");

var $3db8846e4ba8de9f$var$AppFamilyAri;
(function(AppFamilyAri) {
    AppFamilyAri.resourceOwner = 'ecosystem';
    AppFamilyAri.appResourceType = 'app';
    AppFamilyAri.environmentResourceType = 'environment';
    AppFamilyAri.extensionGroupResourceType = 'extension-group';
    AppFamilyAri.extensionResourceType = 'extension';
    AppFamilyAri.appFamilyResourceTypes = [
        AppFamilyAri.appResourceType,
        AppFamilyAri.environmentResourceType,
        AppFamilyAri.extensionGroupResourceType,
        AppFamilyAri.extensionResourceType
    ];
})($3db8846e4ba8de9f$var$AppFamilyAri = module.exports.AppFamilyAri || (module.exports.AppFamilyAri = {}));
var $3db8846e4ba8de9f$var$AppFamilyAriError = /** @class */ function(_super) {
    $3db8846e4ba8de9f$var$__extends(AppFamilyAriError, _super);
    function AppFamilyAriError(message, cause) {
        var _this = _super.call(this, message) || this;
        _this.cause = cause;
        return _this;
    }
    return AppFamilyAriError;
}(Error);
module.exports.AppFamilyAriError = $3db8846e4ba8de9f$var$AppFamilyAriError;
var $3db8846e4ba8de9f$var$NotAppFamilyAriError = /** @class */ function(_super) {
    $3db8846e4ba8de9f$var$__extends(NotAppFamilyAriError, _super);
    function NotAppFamilyAriError(ari, reason) {
        var _this = _super.call(this, "ari is not a valid App family ari: " + ari.toString() + " as " + reason) || this;
        _this.reason = reason;
        return _this;
    }
    return NotAppFamilyAriError;
}($3db8846e4ba8de9f$var$AppFamilyAriError);
module.exports.NotAppFamilyAriError = $3db8846e4ba8de9f$var$NotAppFamilyAriError;
var $3db8846e4ba8de9f$var$NotExpectedAppFamilyAriTypeError = /** @class */ function(_super) {
    $3db8846e4ba8de9f$var$__extends(NotExpectedAppFamilyAriTypeError, _super);
    function NotExpectedAppFamilyAriTypeError(type, ari, cause) {
        var _this = _super.call(this, "App family ari (" + ari.toString() + ") is not of expected type: " + type, cause) || this;
        _this.cause = cause;
        return _this;
    }
    return NotExpectedAppFamilyAriTypeError;
}($3db8846e4ba8de9f$var$AppFamilyAriError);
module.exports.NotExpectedAppFamilyAriTypeError = $3db8846e4ba8de9f$var$NotExpectedAppFamilyAriTypeError; /**
                                                                              * throws NotAppFamilyAriError if not a valid app family ari
                                                                              */ 
function $3db8846e4ba8de9f$var$parseAppAri(ari) {
    return $199iK.AppFamilyAriImpl.parse(ari);
}
module.exports.parseAppAri = $3db8846e4ba8de9f$var$parseAppAri;
function $3db8846e4ba8de9f$var$createAppAri(json) {
    return new $199iK.AppFamilyAriImpl(json);
}
module.exports.createAppAri = $3db8846e4ba8de9f$var$createAppAri;

});

parcelRegister("199iK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5ixmT = parcelRequire("5ixmT");


var $9cGsb = parcelRequire("9cGsb");

var $0d5dd8c916c95343$var$versionPrefix = ';v=';
var $0d5dd8c916c95343$var$AppFamilyAriImpl = /** @class */ function() {
    function AppFamilyAriImpl(json) {
        this.json = json;
    }
    Object.defineProperty(AppFamilyAriImpl.prototype, "appId", {
        get: function() {
            return this.json.appId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "environmentId", {
        get: function() {
            return this.json.environmentId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "version", {
        get: function() {
            return this.json.version;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "extensionGroupId", {
        get: function() {
            return this.json.extensionGroupId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "extensionKey", {
        get: function() {
            return this.json.extensionKey;
        },
        enumerable: true,
        configurable: true
    });
    AppFamilyAriImpl.prototype.toJSON = function() {
        return this.json;
    };
    AppFamilyAriImpl.parse = function(ari) {
        var resourceOwner = ari.resourceOwner, resourceType = ari.resourceType, resourceId = ari.resourceId;
        if (resourceOwner !== $5ixmT.AppFamilyAri.resourceOwner) throw new $5ixmT.NotAppFamilyAriError(ari, "resourceOwner (" + resourceOwner + ") must be " + $5ixmT.AppFamilyAri.resourceOwner);
        if (!resourceType || $5ixmT.AppFamilyAri.appFamilyResourceTypes.indexOf(resourceType) < 0) throw new $5ixmT.NotAppFamilyAriError(ari, "resourceType must be one of " + $5ixmT.AppFamilyAri.appFamilyResourceTypes);
        if (!resourceId) throw new $5ixmT.NotAppFamilyAriError(ari, 'resourceId is must be provided');
        var versionIndex = resourceId.indexOf($0d5dd8c916c95343$var$versionPrefix);
        if (versionIndex > 0 && resourceId.lastIndexOf($0d5dd8c916c95343$var$versionPrefix) > versionIndex) throw new $5ixmT.NotAppFamilyAriError(ari, 'can only include one version suffix');
        var _a = resourceId.split($0d5dd8c916c95343$var$versionPrefix), mainResourceId = _a[0], version = _a[1];
        var segments = mainResourceId.split('/').map($0d5dd8c916c95343$var$stripToUndefined);
        if (segments.length > 4) throw new $5ixmT.NotAppFamilyAriError(ari, "no path segments can be added after extensionKey " + segments.slice(4));
        var _b = segments[0], appId = _b === void 0 ? undefined : _b, _c = segments[1], environmentId = _c === void 0 ? undefined : _c, _d = segments[2], providedExtensionGroupId = _d === void 0 ? undefined : _d, _e = segments[3], extensionKey = _e === void 0 ? undefined : _e;
        if (!appId) throw new $5ixmT.NotAppFamilyAriError(ari, 'appId must be included');
        var extensionGroupId = providedExtensionGroupId || (resourceType === $5ixmT.AppFamilyAri.extensionGroupResourceType || resourceType === $5ixmT.AppFamilyAri.extensionResourceType ? 'static' : undefined);
        if (resourceType === $5ixmT.AppFamilyAri.extensionResourceType && !(environmentId && providedExtensionGroupId && extensionKey)) throw new $5ixmT.NotAppFamilyAriError(ari, "environmentId, extensionGroupId, extensionKey must all be provided for resourceType " + $5ixmT.AppFamilyAri.extensionResourceType);
        else if (resourceType === $5ixmT.AppFamilyAri.extensionGroupResourceType && (!(environmentId && extensionGroupId) || extensionKey)) throw new $5ixmT.NotAppFamilyAriError(ari, "environmentId, extensionGroupId must all be provided for resourceType " + $5ixmT.AppFamilyAri.extensionGroupResourceType);
        else if (resourceType === $5ixmT.AppFamilyAri.environmentResourceType && (!environmentId || providedExtensionGroupId || extensionKey)) throw new $5ixmT.NotAppFamilyAriError(ari, "environmentId must be provided for resourceType " + $5ixmT.AppFamilyAri.environmentResourceType);
        else if (resourceType === $5ixmT.AppFamilyAri.appResourceType && (environmentId || providedExtensionGroupId || extensionKey)) throw new $5ixmT.NotAppFamilyAriError(ari, "environmentId must be provided for resourceType " + $5ixmT.AppFamilyAri.environmentResourceType);
        return new AppFamilyAriImpl({
            appId: appId,
            environmentId: environmentId,
            extensionGroupId: extensionGroupId,
            extensionKey: extensionKey,
            version: version
        });
    };
    AppFamilyAriImpl.prototype.asAppAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isAppAri();
        }, 'app');
    };
    AppFamilyAriImpl.prototype.asAppEnvironmentAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isAppEnvironmentAri();
        }, 'environment');
    };
    AppFamilyAriImpl.prototype.asExtensionGroupAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isExtensionGroupAri();
        }, 'extension-group');
    };
    AppFamilyAriImpl.prototype.asExtensionAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isExtensionAri();
        }, 'extension');
    };
    AppFamilyAriImpl.prototype.isAppAri = function() {
        return !this.isAtLeastAppEnvironmentAri;
    };
    AppFamilyAriImpl.prototype.isAppEnvironmentAri = function() {
        return this.isAtLeastAppEnvironmentAri && !this.isAtLeastExtensionGroupAri;
    };
    AppFamilyAriImpl.prototype.isExtensionGroupAri = function() {
        return this.isAtLeastExtensionGroupAri && !this.isExtensionAri();
    };
    AppFamilyAriImpl.prototype.isExtensionAri = function() {
        return this.isAtLeastExtensionGroupAri && this.extensionKey !== undefined;
    };
    AppFamilyAriImpl.prototype.returnIf = function(check, type) {
        if (!check()) throw new $5ixmT.NotExpectedAppFamilyAriTypeError(type, this);
        return this; // :sadpanda:
    };
    Object.defineProperty(AppFamilyAriImpl.prototype, "isAtLeastAppEnvironmentAri", {
        get: function() {
            return this.environmentId !== undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "isAtLeastExtensionGroupAri", {
        get: function() {
            return this.isAtLeastAppEnvironmentAri && this.extensionGroupId !== undefined;
        },
        enumerable: true,
        configurable: true
    });
    AppFamilyAriImpl.prototype.toAri = function() {
        var resourceOwner = $5ixmT.AppFamilyAri.resourceOwner;
        var _a = this.toJSON(), appId = _a.appId, environmentId = _a.environmentId, extensionGroupId = _a.extensionGroupId, extensionKey = _a.extensionKey, version = _a.version;
        function withVersion(segments) {
            var path = segments.join('/');
            if (!version) return path;
            else return "" + path + $0d5dd8c916c95343$var$versionPrefix + version;
        }
        if (this.isExtensionAri()) return new $9cGsb.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $5ixmT.AppFamilyAri.extensionResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId,
                extensionKey
            ])
        });
        else if (this.isExtensionGroupAri()) return new $9cGsb.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $5ixmT.AppFamilyAri.extensionGroupResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId
            ])
        });
        else if (this.isAppEnvironmentAri()) return new $9cGsb.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $5ixmT.AppFamilyAri.environmentResourceType,
            resourceId: withVersion([
                appId,
                environmentId
            ])
        });
        else return new $9cGsb.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $5ixmT.AppFamilyAri.appResourceType,
            resourceId: appId
        });
    };
    AppFamilyAriImpl.prototype.toString = function() {
        return this.toAri().toString();
    };
    return AppFamilyAriImpl;
}();
module.exports.AppFamilyAriImpl = $0d5dd8c916c95343$var$AppFamilyAriImpl;
function $0d5dd8c916c95343$var$stripToUndefined(str) {
    if (!str) return undefined;
    var trimmed = str.trim();
    if (trimmed.length === 0) return undefined;
    return trimmed;
}

});

parcelRegister("k9rxT", function(module, exports) {
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $eaCYh = parcelRequire("eaCYh");


var $3ETCd = parcelRequire("3ETCd");


var $anJMe = parcelRequire("anJMe");


var $fcFES = parcelRequire("fcFES");

class $f4cb6c0703060f5e$export$60449a906da67814 extends (0, $3ETCd.AbstractPresenceResource) {
    refreshPresence(userIds) {
        const cacheHits = this.presenceCache.getBulk(userIds);
        this.notifyListeners(cacheHits);
        const cacheMisses = this.presenceCache.getMissingUserIds(userIds);
        if (cacheMisses.length) this.retrievePresence(cacheMisses);
    }
    retrievePresence(userIds) {
        this.queryDirectoryForPresences(userIds).then((res)=>this.presenceParser.parse(res)).then((presences)=>{
            this.notifyListeners(presences);
            this.presenceCache.update(presences);
        });
    }
    queryDirectoryForPresences(userIds) {
        const query = {
            query: `query getPresenceForMentions($organizationId: String!, $userIds: [String!], $productId: String) {
                PresenceBulk(organizationId: $organizationId, product: $productId, userIds: $userIds) {
                  userId
                  state
                  stateMetadata
                }
              }`,
            variables: {
                organizationId: this.config.cloudId,
                userIds: userIds
            }
        };
        if (this.config.productId) query.variables['productId'] = this.config.productId;
        const atlAttributionHeader = (0, $eaCYh.buildAtlAttributionHeaderValue)({
            cloudId: this.config.cloudId,
            productId: this.config.productId,
            activationId: this.config.activationId
        });
        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...atlAttributionHeader,
                ...this.config.headers
            },
            credentials: 'include',
            body: JSON.stringify(query)
        };
        return fetch(this.config.url, options).then((response)=>response.json());
    }
    static cleanUrl(url) {
        if (url.substr(-1) !== '/') url += '/';
        return url;
    }
    constructor(config){
        super();
        this.config = void 0;
        this.presenceCache = void 0;
        this.presenceParser = void 0;
        if (!config.url) throw new Error('config.url is a required parameter');
        if (!config.cloudId) throw new Error('config.cloudId is a required parameter');
        this.config = config;
        this.config.url = $f4cb6c0703060f5e$export$60449a906da67814.cleanUrl(config.url);
        this.presenceCache = config.cache || new (0, $anJMe.DefaultPresenceCache)(config.cacheExpiry);
        this.presenceParser = config.parser || new (0, $fcFES.DefaultPresenceParser)();
    }
}
var $f4cb6c0703060f5e$export$2e2bcd8739ae039 = $f4cb6c0703060f5e$export$60449a906da67814;
module.exports["default"] = $f4cb6c0703060f5e$export$2e2bcd8739ae039;

});

parcelRegister("eaCYh", function(module, exports) {
function $669159666a118337$export$9df8b8301f41e4b7(config) {
    const { cloudId: cloudId, activationId: activationId, productId: productId = 'platform' } = config;
    const value = {
        tenantId: cloudId,
        product: productId
    };
    if (activationId) value.atlWorkspaceId = `ari:cloud:${productId}:${cloudId}:workspace/${activationId}`;
    return {
        'atl-attribution': JSON.stringify(value)
    };
}
module.exports["buildAtlAttributionHeaderValue"] = $669159666a118337$export$9df8b8301f41e4b7;

});

parcelRegister("3ETCd", function(module, exports) {

var $2SUNK = parcelRequire("2SUNK");


var $dvMxu = parcelRequire("dvMxu");

class $4bf5f554e4571238$export$7b4524ed61cc8203 extends (0, $dvMxu.AbstractResource) {
    refreshPresence(userIds) {
        throw new Error(`not yet implemented.\nParams: userIds=${userIds}`);
    }
    notifyListeners(presences) {
        this.changeListeners.forEach((listener, key)=>{
            try {
                listener(presences);
            } catch (e) {
                // ignore error from listener
                (0, $2SUNK.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
}
module.exports["AbstractPresenceResource"] = $4bf5f554e4571238$export$7b4524ed61cc8203;

});

parcelRegister("dvMxu", function(module, exports) {
class $5c4239d07c0ef4c8$export$4529f10aed0950d4 {
    subscribe(key, callback, errCallback, infoCallback, allResultsCallback, analyticsListeners) {
        if (callback) this.changeListeners.set(key, callback);
        if (errCallback) this.errListeners.set(key, errCallback);
        if (infoCallback) this.infoListeners.set(key, infoCallback);
        if (allResultsCallback) this.allResultsListeners.set(key, allResultsCallback);
        if (analyticsListeners) this.analyticsListeners.set(key, analyticsListeners);
    }
    unsubscribe(key) {
        this.changeListeners.delete(key);
        this.errListeners.delete(key);
        this.infoListeners.delete(key);
        this.allResultsListeners.delete(key);
        this.analyticsListeners.delete(key);
    }
    constructor(){
        this.changeListeners = void 0;
        this.errListeners = void 0;
        this.infoListeners = void 0;
        this.allResultsListeners = void 0;
        this.analyticsListeners = void 0;
        this.changeListeners = new Map();
        this.allResultsListeners = new Map();
        this.errListeners = new Map();
        this.infoListeners = new Map();
        this.analyticsListeners = new Map();
    }
}
module.exports["AbstractResource"] = $5c4239d07c0ef4c8$export$4529f10aed0950d4;

});

parcelRegister("anJMe", function(module, exports) {
class $cb82e10138ad9a17$var$CacheEntry {
    expired() {
        return Date.now() > this.expiry;
    }
    constructor(pres, timeout){
        this.presence = void 0;
        this.expiry = void 0;
        this.presence = pres;
        this.expiry = Date.now() + timeout;
    }
}
class $cb82e10138ad9a17$export$f962b6f1aaaafaf5 {
    /**
   * Precondition: _delete is only called internally if userId exists in cache
   * Removes cache entry
   * @param userId
   */ _delete(userId) {
        delete this.cache[userId];
        this.size--;
    }
    /**
   * Checks a cache entry and calls delete if the info has expired
   * @param userId
   */ _deleteIfExpired(userId) {
        if (this.contains(userId) && this.cache[userId].expired()) this._delete(userId);
    }
    /**
   * Cleans expired entries from cache
   */ _removeExpired() {
        Object.keys(this.cache).forEach((id)=>{
            this._deleteIfExpired(id);
        });
    }
    /**
   * Checks if a user exists in the cache
   * @param userId
   */ contains(userId) {
        return this.cache.hasOwnProperty(userId);
    }
    /**
   * Retrieves a presence from the cache after checking for expired entries
   * @param userId - to index the cache
   * @returns Presence - the presence that matches the userId
   */ get(userId) {
        this._deleteIfExpired(userId);
        if (!this.contains(userId)) return {};
        return this.cache[userId].presence;
    }
    /**
   * Retrieve multiple presences at once from the cache
   * @param userIds - to index the cache
   * @returns PresenceMap - A map of userIds to cached Presences
   */ getBulk(userIds) {
        const presences = {};
        for (const userId of userIds)if (this.contains(userId)) presences[userId] = this.get(userId);
        return presences;
    }
    /**
   * For a given list of ids, returns a subset
   * of all the ids with missing cache entries.
   * @param userIds - to index the cache
   * @returns string[] - ids missing from the cache
   */ getMissingUserIds(userIds) {
        return userIds.filter((id)=>!this.contains(id));
    }
    /**
   * Precondition: presMap only contains ids of users not in cache
   *               expired users must first be removed then reinserted with updated presence
   * Updates the cache by adding the new Presence entries and setting the expiry time
   * @param presMap
   */ update(presMap) {
        if (this.size >= this.flushTrigger) this._removeExpired();
        Object.keys(presMap).forEach((userId)=>{
            this.cache[userId] = new $cb82e10138ad9a17$var$CacheEntry(presMap[userId], this.expiryInMillis);
            this.size++;
        });
    }
    constructor(cacheTimeout, cacheTrigger){
        this.cache = void 0;
        this.size = void 0;
        this.expiryInMillis = void 0;
        this.flushTrigger = void 0;
        this.expiryInMillis = cacheTimeout ? cacheTimeout : $cb82e10138ad9a17$export$f962b6f1aaaafaf5.defaultTimeout;
        this.flushTrigger = cacheTrigger ? cacheTrigger : $cb82e10138ad9a17$export$f962b6f1aaaafaf5.defaultFlushTrigger;
        this.cache = {};
        this.size = 0;
    }
}
$cb82e10138ad9a17$export$f962b6f1aaaafaf5.defaultTimeout = 20000;
$cb82e10138ad9a17$export$f962b6f1aaaafaf5.defaultFlushTrigger = 50;
module.exports["DefaultPresenceCache"] = $cb82e10138ad9a17$export$f962b6f1aaaafaf5;

});

parcelRegister("fcFES", function(module, exports) {
class $5a1745191e76205a$export$80bae4549cafd20d {
    mapState(state) {
        if (state === 'unavailable') return 'offline';
        else if (state === 'available') return 'online';
        else return state;
    }
    parse(response) {
        const presences = {};
        if (response.hasOwnProperty('data') && response['data'].hasOwnProperty('PresenceBulk')) {
            const results = response['data'].PresenceBulk;
            // Store map of state and time indexed by userId.  Ignore null results.
            for (const user of results){
                if (user.userId && user.state) {
                    const state = $5a1745191e76205a$export$80bae4549cafd20d.extractState(user) || user.state;
                    presences[user.userId] = {
                        status: this.mapState(state)
                    };
                } else if (!user.hasOwnProperty('userId') || !user.hasOwnProperty('state')) // eslint-disable-next-line no-console
                console.error('Unexpected response from presence service contains keys: ' + Object.keys(user));
            }
        }
        return presences;
    }
    static extractState(presence) {
        if ($5a1745191e76205a$export$80bae4549cafd20d.isFocusState(presence)) return $5a1745191e76205a$export$80bae4549cafd20d.FOCUS_STATE;
        return presence.state;
    }
    /*
     This is a bit of an odd exception. In the case where a user is in "Focus Mode", their presence state
     is returned as 'busy' along with a `stateMetadata` object containing a `focus` field.
     In this case we ignore the value of the `state` field and treat the presence as a 'focus' state.
    */ static isFocusState(presence) {
        if (presence.stateMetadata) try {
            const metadata = JSON.parse(presence.stateMetadata);
            return metadata && !!metadata.focus;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`Failed to parse presence's stateMetadata for user with id ${presence.userId}: ${presence.stateMetadata}`);
            // eslint-disable-next-line no-console
            console.error(e);
        }
        return false;
    }
}
$5a1745191e76205a$export$80bae4549cafd20d.FOCUS_STATE = 'focus';
module.exports["DefaultPresenceParser"] = $5a1745191e76205a$export$80bae4549cafd20d;

});

parcelRegister("bje9P", function(module, exports) {

var $caelp = parcelRequire("caelp");


var $d7tjP = parcelRequire("d7tjP");


var $fnGw7 = parcelRequire("fnGw7");

class $64c10b9731bd9a19$export$2ae0434dccdcb77e {
    lookupName(id) {
        const name = this.nameCache.get(id);
        if (name) {
            this.fireAnalytics(true, name);
            if (this.nameQueue.size === 0) this.scheduleOnAllResolved();
            return name;
        }
        return new Promise((resolve)=>{
            const processingItems = this.processingQueue.get(id);
            if (processingItems) this.processingQueue.set(id, [
                ...processingItems,
                resolve
            ]);
            const queuedItems = this.nameQueue.get(id) || [];
            this.nameQueue.set(id, [
                ...queuedItems,
                resolve
            ]);
            if (queuedItems.length === 0 && !processingItems) this.nameStartTime.set(id, Date.now());
            this.scheduleProcessQueue();
            if (this.isQueueAtLimit()) this.processQueue();
        });
    }
    cacheName(id, name) {
        this.nameCache.set(id, {
            id: id,
            name: name,
            status: (0, $caelp.MentionNameStatus).OK
        });
    }
    scheduleProcessQueue() {
        if (!this.debounce) this.debounce = window.setTimeout(this.processQueue, $64c10b9731bd9a19$export$2ae0434dccdcb77e.waitForBatch);
    }
    scheduleOnAllResolved() {
        if (this.debounceOnResolve) clearTimeout(this.debounceOnResolve);
        this.debounceOnResolve = window.setTimeout(()=>{
            if (this.isOnResolvedAllCalled) return;
            this.onResolvedAll();
            this.isOnResolvedAllCalled = true;
        }, $64c10b9731bd9a19$export$2ae0434dccdcb77e.waitForResolveAll);
    }
    isQueueAtLimit() {
        return this.nameQueue.size >= this.client.getLookupLimit();
    }
    splitQueueAtLimit() {
        const values = Array.from(this.nameQueue.entries());
        const splitPoint = this.client.getLookupLimit();
        return {
            queue: new Map(values.slice(0, splitPoint)),
            extraQueue: new Map(values.slice(splitPoint))
        };
    }
    resolveQueueItem(mentionDetail) {
        const { id: id } = mentionDetail;
        const resolvers = this.processingQueue.get(id);
        if (resolvers) {
            this.processingQueue.delete(id);
            this.nameCache.set(id, mentionDetail);
            resolvers.forEach((resolve)=>{
                try {
                    resolve(mentionDetail);
                } catch  {
                // ignore - exception in consumer
                }
            });
            this.fireAnalytics(false, mentionDetail);
        }
    }
    fireAnalytics(fromCache, mentionDetail) {
        const { id: id } = mentionDetail;
        const action = mentionDetail.status === (0, $caelp.MentionNameStatus).OK ? 'completed' : 'failed';
        const start = this.nameStartTime.get(id);
        const duration = start ? Date.now() - start : 0;
        this.nameStartTime.delete(id);
        this.fireHydrationEvent(action, id, fromCache, duration);
    }
    constructor(client, analyticsProps = {}, onResolvedAll = ()=>{}){
        // ms
        this.client = void 0;
        this.nameCache = new Map();
        this.nameQueue = new Map();
        this.nameStartTime = new Map();
        this.processingQueue = new Map();
        this.debounce = 0;
        this.debounceOnResolve = null;
        this.onResolvedAll = void 0;
        this.isOnResolvedAllCalled = false;
        this.fireHydrationEvent = void 0;
        this.processQueue = ()=>{
            clearTimeout(this.debounce);
            this.debounce = 0;
            const { queue: queue, extraQueue: extraQueue } = this.splitQueueAtLimit();
            this.nameQueue = extraQueue;
            this.processingQueue = (0, $fnGw7.mergeNameResolverQueues)(this.processingQueue, queue);
            this.client.lookupMentionNames(Array.from(queue.keys())).then((response)=>{
                response.forEach((mentionDetail)=>{
                    const { id: id } = mentionDetail;
                    queue.delete(id);
                    this.resolveQueueItem(mentionDetail);
                });
                queue.forEach((_callback, id)=>{
                    // No response from client for these ids treat as unknown
                    this.resolveQueueItem({
                        id: id,
                        status: (0, $caelp.MentionNameStatus).UNKNOWN
                    });
                });
            }).catch(()=>{
                // Service completely failed, reject all items in the queue
                queue.forEach((_callback, id)=>{
                    this.resolveQueueItem({
                        id: id,
                        status: (0, $caelp.MentionNameStatus).SERVICE_ERROR
                    });
                });
            });
            // Make sure anything left in the queue gets processed.
            if (this.nameQueue.size > 0) this.scheduleProcessQueue();
            else this.scheduleOnAllResolved();
        };
        this.client = client;
        this.fireHydrationEvent = (0, $d7tjP.fireAnalyticsMentionHydrationEvent)(analyticsProps);
        // If provided, this will be called once all pending mentions in the queue are resolved.
        // A sample usage is scrolling to a mention on page load, after the mentions have loadad.
        this.onResolvedAll = onResolvedAll;
    }
}
$64c10b9731bd9a19$export$2ae0434dccdcb77e.waitForBatch = 100;
// ms
$64c10b9731bd9a19$export$2ae0434dccdcb77e.waitForResolveAll = 800;
module.exports["DefaultMentionNameResolver"] = $64c10b9731bd9a19$export$2ae0434dccdcb77e;

});

parcelRegister("d7tjP", function(module, exports) {

var $852mP = parcelRequire("852mP");


var $4cczm = parcelRequire("4cczm");


var $caelp = parcelRequire("caelp");


var $4B8nE = parcelRequire("4B8nE");


var $iu9yU = parcelRequire("iu9yU");

const $7638fcfba6821dc7$export$91b2fa6a0fe06408 = (props)=>(action, userId, fromCache, duration)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $caelp.ComponentNames).MENTION,
                actionSubjectId: 'hydration',
                attributes: {
                    packageName: $4B8nE.packageName,
                    packageVersion: $iu9yU.packageVersion,
                    componentName: (0, $caelp.ComponentNames).MENTION,
                    userId: userId,
                    fromCache: fromCache,
                    duration: Math.round(duration)
                },
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $4cczm.ELEMENTS_CHANNEL));
        }
    };
module.exports["fireAnalyticsMentionHydrationEvent"] = $7638fcfba6821dc7$export$91b2fa6a0fe06408;

});

parcelRegister("fnGw7", function(module, exports) {
function $89691861f49f9b0f$export$71ea0798a8cad7d8(queueA, queueB) {
    const queueBeingMerged = new Map([
        ...queueA
    ]);
    // now add the items from the second queue that are not already in the
    //  merged queue being built
    [
        ...queueB
    ].forEach((item)=>{
        const [key, queueBCallbacks] = item;
        const itemAlreadyInMergedQueue = queueBeingMerged.has(key);
        if (!itemAlreadyInMergedQueue) queueBeingMerged.set(key, queueBCallbacks);
        else {
            // item already in merged queue, merge the callback arrays
            const queueACallbacks = queueBeingMerged.get(key) ?? [];
            const mergedCallbacks = new Set([
                ...queueBCallbacks,
                ...queueACallbacks
            ]);
            const deduplicatedCallbacks = Array.from(mergedCallbacks.values()); // prevents calling them twice
            queueBeingMerged.set(key, deduplicatedCallbacks);
        }
    });
    return queueBeingMerged;
}
module.exports["mergeNameResolverQueues"] = $89691861f49f9b0f$export$71ea0798a8cad7d8;

});

parcelRegister("80Dol", function(module, exports) {

var $55fM8 = parcelRequire("55fM8");


var $bijHC = parcelRequire("bijHC");


var $b3nqj = parcelRequire("b3nqj");


var $caelp = parcelRequire("caelp");


var $f7B1p = parcelRequire("f7B1p");


var $ge2sX = parcelRequire("ge2sX");


var $9fywD = parcelRequire("9fywD");


var $04e9M = parcelRequire("04e9M");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $5CrKL = parcelRequire("5CrKL");


var $j5rtD = parcelRequire("j5rtD");


var $gYPwD = parcelRequire("gYPwD");

const $76cb501321125a14$var$INITIAL_STATE = 'initialState';
const $76cb501321125a14$var$SEARCH = 'searchUser';
const $76cb501321125a14$var$SUCCEEDED = 'succeeded';
const $76cb501321125a14$var$FAILED = 'failed';
const $76cb501321125a14$var$CONTEXT_TYPE = 'Mentions';
/**
 * MAX_NOTIFIED_ITEMS in platform/packages/elements/mention/src/api/MentionResource.ts limits how many mentions returned by UserTeamMentionProvider will be used really! 20 is its value at the time of this writing.
 */ const $76cb501321125a14$var$MAX_RESULTS = 20;
/**
 * platform/packages/editor/editor-plugin-mentions/src/ui/type-ahead/index.tsx sections the mentions returned by UserTeamMentionProvider in agents and non-agents (such as people and teams).
 * But it also defines its own limit per section! 5 is its limit for agents at the time of this writing.
 * So to see both agents and people/non-agents in the sectioned UI, UserTeamMentionProvider needs to arrange enough of each section into the first MAX_RESULTS mentions it returns.
 */ const $76cb501321125a14$var$MIN_AGENT_RESULTS = 5;
const $76cb501321125a14$var$AGENT_LOADING_PLACEHOLDER_COUNT = 2;
const $76cb501321125a14$var$AGENT_LOADING_PLACEHOLDER_ID_PREFIX = '__confluence-agents-loading-';
const $76cb501321125a14$var$AGENT_MENTIONS_QUERY_TIMEOUT_MS = 5000;
const $76cb501321125a14$var$ASYNC_AGENT_MENTIONS_REQUEST = Symbol('asyncAgentMentionsRequest');
const $76cb501321125a14$var$agentMentionsLoadErrorResult = (query)=>({
        mentions: [
            {
                appType: 'agent',
                id: (0, $caelp.AGENT_MENTION_LOAD_ERROR_ID),
                isPlaceholder: true,
                placeholderType: 'error',
                userType: 'APP'
            }
        ],
        query: query
    });
const $76cb501321125a14$var$emptyAgentMentionsResult = (query)=>({
        mentions: [],
        query: query
    });
const $76cb501321125a14$var$createAgentLoadingPlaceholders = ()=>Array.from({
        length: $76cb501321125a14$var$AGENT_LOADING_PLACEHOLDER_COUNT
    }, (_, index)=>({
            id: `${$76cb501321125a14$var$AGENT_LOADING_PLACEHOLDER_ID_PREFIX}${index}__`,
            isPlaceholder: true,
            placeholderType: 'loading',
            userType: 'APP',
            appType: 'agent'
        }));
const $76cb501321125a14$var$hasPlaceholders = (result)=>result.mentions.some((mention)=>mention.isPlaceholder);
const $76cb501321125a14$var$queryAgentMentionsWithoutTimeout = (query, maxResults, showLoadErrorOnFailure = false)=>(0, $gYPwD.queryAgentMentions)(query, maxResults).then((result)=>({
            result: result,
            successful: true,
            timedOut: false,
            timeoutApplied: false
        })).catch(()=>/* Do not let queryAgentMentions break the production-available people and teams search. */ ({
            result: showLoadErrorOnFailure ? $76cb501321125a14$var$agentMentionsLoadErrorResult(query) : $76cb501321125a14$var$emptyAgentMentionsResult(query),
            successful: false,
            timedOut: false,
            timeoutApplied: false
        }));
const $76cb501321125a14$var$queryAgentMentionsWithTimeout = async (query, maxResults, showLoadErrorOnFailure = true)=>{
    let timeoutId;
    const queryStartedAt = Date.now();
    const timeoutPromise = new Promise((resolve)=>{
        timeoutId = setTimeout(()=>{
            resolve({
                result: showLoadErrorOnFailure ? $76cb501321125a14$var$agentMentionsLoadErrorResult(query) : $76cb501321125a14$var$emptyAgentMentionsResult(query),
                successful: false,
                timedOut: true,
                timeoutApplied: true
            });
        }, $76cb501321125a14$var$AGENT_MENTIONS_QUERY_TIMEOUT_MS);
    });
    const queryPromise = $76cb501321125a14$var$queryAgentMentionsWithoutTimeout(query, maxResults, showLoadErrorOnFailure).then((result)=>({
            ...result,
            queryDurationMs: Date.now() - queryStartedAt,
            timeoutApplied: true
        }));
    const result = await Promise.race([
        queryPromise,
        timeoutPromise
    ]);
    if (timeoutId) clearTimeout(timeoutId);
    return result;
};
// Use in memory cache only
const $76cb501321125a14$var$defaultCache = {
    getStoredValues: ()=>Promise.resolve(new Map()),
    setStoredValues: ()=>Promise.resolve()
};
class $76cb501321125a14$export$f500b4849378edff extends (0, $bijHC.MentionResource) {
    // Treatment helpers for platform_editor_mention_search_order are intentionally grouped here.
    async filter(query, contextIdentifier) {
        if (this.includeAgents && (0, $6mKj3.isExperimentEnabled)('platform_editor_mention_search_order')) return this.filterWithAsyncAgentMentions(query, contextIdentifier);
        // Control: preserve MentionResource's existing single-emission behavior.
        return super.filter(query, contextIdentifier);
    }
    async filterWithAsyncAgentMentions(query, contextIdentifier) {
        const sequence = ++this.agentMentionsFilterSequence;
        const startedAt = Date.now();
        let markInitialResultEmitted = ()=>{};
        const initialResultEmitted = new Promise((resolve)=>{
            markInitialResultEmitted = resolve;
        });
        const asyncContextIdentifier = {
            ...contextIdentifier,
            [$76cb501321125a14$var$ASYNC_AGENT_MENTIONS_REQUEST]: {
                initialResultEmitted: initialResultEmitted,
                sequence: sequence,
                startedAt: startedAt
            }
        };
        try {
            await super.filter(query, asyncContextIdentifier);
        } finally{
            // `super.filter` notifies the first URS result before resolving. Agent
            // enrichment waits on this barrier so it can never become the first emission.
            markInitialResultEmitted();
        }
    }
    async notifyAgentMentionsWhenReady(query, ursMentions, agentMentionsQueryResultPromise, request) {
        const [agentMentionsQueryResult] = await Promise.all([
            agentMentionsQueryResultPromise,
            request.initialResultEmitted
        ]);
        if (request.sequence !== this.agentMentionsFilterSequence) return;
        const result = {
            query: query,
            mentions: this.mergeAsyncAgentMentions(agentMentionsQueryResult.result.mentions, ursMentions)
        };
        this._notifyListeners(result, {
            duration: Date.now() - request.startedAt
        });
        this._notifyAllResultsListeners(result);
        if (agentMentionsQueryResult.successful && query === '' && (0, $6mKj3.expValEquals)('platform_editor_offline_editing_web', 'isEnabled', true)) this.offlineCache?.set(this.userTeamEndpoint, result);
    }
    mergeAsyncAgentMentions(agentMentions, ursMentions) {
        if (!agentMentions.length) return ursMentions;
        // Studio agent results should win if URS ever returns the same agent ID.
        const agentMentionIds = new Set(agentMentions.map((mention)=>mention.id));
        const distinctUrsMentions = ursMentions.filter((mention)=>!agentMentionIds.has(mention.id));
        const limitedAgentMentions = agentMentions.slice(0, Math.max($76cb501321125a14$var$MIN_AGENT_RESULTS, $76cb501321125a14$var$MAX_RESULTS - distinctUrsMentions.length));
        return [
            ...limitedAgentMentions,
            ...distinctUrsMentions
        ];
    }
    debounceFilter(initialStateDebounceTime, searchDebounceTime) {
        const filter = this.filter.bind(this);
        const debouncedInitialStateFilter = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(filter, initialStateDebounceTime);
        const debouncedSearchFilter = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(filter, searchDebounceTime);
        this.filter = async (query, contextIdentifier)=>{
            if (query) {
                debouncedInitialStateFilter.cancel();
                return debouncedSearchFilter(query, contextIdentifier);
            } else {
                debouncedSearchFilter.cancel();
                return debouncedInitialStateFilter(query, contextIdentifier);
            }
        };
    }
    /**
   * Overrides `remoteInitialState` from `MentionResource`
   * This is invoked for bootstrap/empty queries,
   */ async remoteInitialState(contextIdentifier) {
        try {
            const promise = await this.doSearch('', contextIdentifier);
            // Control: cache the single settled result here. Treatment caches only from
            // notifyAgentMentionsWhenReady after both sources have succeeded.
            if ((!this.includeAgents || !(0, $6mKj3.isExperimentEnabled)('platform_editor_mention_search_order')) && (0, $6mKj3.expValEquals)('platform_editor_offline_editing_web', 'isEnabled', true)) this.offlineCache?.set(this.userTeamEndpoint, promise);
            this._notifyAnalyticsListeners((0, $b3nqj.SLI_EVENT_TYPE), $76cb501321125a14$var$INITIAL_STATE, $76cb501321125a14$var$SUCCEEDED);
            return promise;
        } catch (e) {
            this._notifyAnalyticsListeners((0, $b3nqj.SLI_EVENT_TYPE), $76cb501321125a14$var$INITIAL_STATE, $76cb501321125a14$var$FAILED);
            throw e;
        }
    }
    /**
   * Overrides `remoteSearch` from `MentionResource`
   * This is invoked for non-empty queries.
   */ async remoteSearch(query, contextIdentifier) {
        try {
            const promise = await this.doSearch(query, contextIdentifier);
            this._notifyAnalyticsListeners((0, $b3nqj.SLI_EVENT_TYPE), $76cb501321125a14$var$SEARCH, $76cb501321125a14$var$SUCCEEDED);
            return promise;
        } catch (e) {
            this._notifyAnalyticsListeners((0, $b3nqj.SLI_EVENT_TYPE), $76cb501321125a14$var$SEARCH, $76cb501321125a14$var$FAILED);
            throw e;
        }
    }
    async getCachedValue(query) {
        const cachedValue = this.offlineCache?.get(this.userTeamEndpoint);
        if (!cachedValue) return undefined;
        if (query === '') return Promise.resolve(cachedValue);
        else {
            // If we're offline allow basic filtering of the cached results by name.
            if (window?.navigator.onLine === false) return Promise.resolve({
                query: query,
                mentions: cachedValue.mentions?.filter((v)=>v?.name?.toLowerCase().includes(query.toLowerCase()) || v?.mentionName?.toLowerCase().includes(query.toLowerCase()) || v?.nickname?.toLowerCase().includes(query.toLowerCase()))
            });
        }
    }
    async doSearch(query, contextIdentifier) {
        if ((0, $6mKj3.expValEquals)('platform_editor_offline_editing_web', 'isEnabled', true)) {
            const cachedValue = await this.getCachedValue(query);
            // Use stale-while-revalidate - if the cached value exists use it first and
            // update the cache value in the background so that it's up to date when the
            // next call is made
            if (cachedValue) {
                if (query === '') this.doNetworkSearch(query, contextIdentifier).then((results)=>{
                    if (!$76cb501321125a14$var$hasPlaceholders(results) || !(0, $6mKj3.isExperimentEnabled)('platform_editor_mention_search_order')) this.offlineCache?.set(this.userTeamEndpoint, results);
                }).catch(()=>{
                // Pass, it's okay if the cache doesn't update
                });
                return cachedValue;
            }
            return this.doNetworkSearch(query, contextIdentifier);
        } else return this.doNetworkSearch(query, contextIdentifier);
    }
    async doNetworkSearch(query, contextIdentifier) {
        (0, $5CrKL.MENTIONS_QUERY_METRIC).start();
        const asyncAgentMentionsRequest = contextIdentifier?.[$76cb501321125a14$var$ASYNC_AGENT_MENTIONS_REQUEST];
        const responsePromise = (async ()=>this.post(await this.cloudId(), await this.orgId(), query, contextIdentifier))();
        const agentMentionsQueryResultPromise = this.includeAgents ? asyncAgentMentionsRequest && (0, $6mKj3.isExperimentEnabled)('platform_editor_mention_search_order') ? $76cb501321125a14$var$queryAgentMentionsWithTimeout(query, $76cb501321125a14$var$MAX_RESULTS, (0, $6mKj3.expValEquals)('platform_editor_agent_mentions_rovo_query_timeout', 'isEnabled', true)) : (0, $6mKj3.expValEquals)('platform_editor_agent_mentions_rovo_query_timeout', 'isEnabled', true) ? $76cb501321125a14$var$queryAgentMentionsWithTimeout(query, $76cb501321125a14$var$MAX_RESULTS) : $76cb501321125a14$var$queryAgentMentionsWithoutTimeout(query, $76cb501321125a14$var$MAX_RESULTS) : undefined;
        const response = await responsePromise;
        if (!response.ok) {
            const errorBody = await response.json();
            (0, $5CrKL.MENTIONS_QUERY_METRIC).stop({
                customData: {
                    isExCoEnabled: this.includeExternalCollaborators,
                    success: false
                }
            });
            throw new Error(JSON.stringify(errorBody));
        }
        const body = await response.json();
        const mentions = body.recommendedUsers.map((recommended)=>{
            if (this.isAgent(recommended)) return this.convertToAgentMention(recommended);
            if (this.isUser(recommended)) return this.convertToUserMention(recommended);
            if (this.isTeam(recommended)) return this.convertToTeamMention(recommended);
            // Fallback to user mention for unknown types
            return this.convertToUserMention(recommended);
        });
        let jiraMentions = [];
        if (mentions.length < $76cb501321125a14$var$MAX_RESULTS && this.isEligibleXProductUserInvite && await this.isEligibleXProductUserInvite()) try {
            const jiraResponse = await this.searchXproductUsers(await this.cloudId(), await this.orgId(), query, contextIdentifier);
            if (!jiraResponse.ok) {
                const errorBody = await jiraResponse.json();
                throw new Error(JSON.stringify(errorBody));
            }
            const jiraBody = await jiraResponse.json();
            // Remove objects from jiraMentions if an object with the same id is present in mentions
            const mentionIds = new Set(mentions.map((mention)=>mention.id));
            const recommendedJiraUsers = (jiraBody.recommendedUsers || []).filter((mention)=>!mentionIds.has(mention?.id)).slice(0, $76cb501321125a14$var$MAX_RESULTS - mentions.length);
            //only evaluate the experiment cohort if there are jira mentions to show
            if (recommendedJiraUsers.length > 0 && (0, $6mKj3.expValEquals)('cc_virality_x_product_user_invite', 'cohort', 'test')) jiraMentions = recommendedJiraUsers.map((recommended)=>{
                return {
                    ...this.convertToUserMention(recommended),
                    isXProductUser: true
                };
            });
        } catch (error) {
            const client = await (0, $04e9M.getAnalyticsWebClient)();
            const errorMessages = error instanceof Error ? error.message : String(error);
            client.sendOperationalEvent({
                source: 'editor',
                action: 'errored',
                actionSubject: 'xProductUserSearch',
                attributes: {
                    error: errorMessages,
                    stack: error?.stack
                }
            });
        }
        // Treatment: return URS immediately and publish Agent Studio in a later emission.
        if ((0, $6mKj3.isExperimentEnabled)('platform_editor_mention_search_order') && agentMentionsQueryResultPromise && asyncAgentMentionsRequest) {
            (0, $5CrKL.MENTIONS_QUERY_METRIC).stop({
                customData: {
                    isExCoEnabled: this.includeExternalCollaborators,
                    success: true
                }
            });
            this.notifyAgentMentionsWhenReady(query, [
                ...mentions,
                ...jiraMentions
            ], agentMentionsQueryResultPromise, asyncAgentMentionsRequest);
            return {
                query: query,
                // AbstractMentionResource only notifies its first 20 rows. Put placeholders
                // first so a full URS response cannot truncate the loading state.
                mentions: [
                    ...$76cb501321125a14$var$createAgentLoadingPlaceholders(),
                    ...mentions,
                    ...jiraMentions
                ]
            };
        }
        // Control: preserve the existing single-emission critical path below.
        const agentMentionsQueryResult = await agentMentionsQueryResultPromise;
        (0, $5CrKL.MENTIONS_QUERY_METRIC).stop({
            customData: {
                isExCoEnabled: this.includeExternalCollaborators,
                success: true,
                ...agentMentionsQueryResult?.timeoutApplied ? {
                    ...agentMentionsQueryResult.queryDurationMs !== undefined ? {
                        agentMentionsQueryDurationMs: agentMentionsQueryResult.queryDurationMs
                    } : {},
                    agentMentionsTimedOut: agentMentionsQueryResult?.timedOut ?? false,
                    agentMentionsTimeoutMs: $76cb501321125a14$var$AGENT_MENTIONS_QUERY_TIMEOUT_MS
                } : {}
            }
        });
        let agentMentions = agentMentionsQueryResult?.result.mentions ?? [];
        let nonAgentMentions = [
            ...mentions,
            ...jiraMentions
        ];
        if (agentMentions.length) {
            // Studio agent results should win if URS ever returns the same agent ID.
            const agentMentionIds = new Set(agentMentions.map((mention)=>mention.id));
            nonAgentMentions = nonAgentMentions.filter((mention)=>!agentMentionIds.has(mention.id));
            agentMentions = agentMentions.slice(0, Math.max($76cb501321125a14$var$MIN_AGENT_RESULTS, $76cb501321125a14$var$MAX_RESULTS - nonAgentMentions.length));
        }
        return {
            query: query,
            mentions: [
                ...agentMentions,
                ...nonAgentMentions
            ]
        };
    }
    async cloudId() {
        const { cloudId: cloudId } = await (0, $ge2sX.getSessionData)();
        return cloudId;
    }
    async orgId() {
        const { orgId: orgId } = await (0, $ge2sX.getSessionData)();
        return orgId;
    }
    async post(cloudId, orgId, query, contextIdentifier) {
        return await (0, $f7B1p.cfetch)(this.userTeamEndpoint, {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({
                context: {
                    contextType: $76cb501321125a14$var$CONTEXT_TYPE,
                    principalId: 'context',
                    productKey: contextIdentifier && contextIdentifier.product || 'confluence',
                    // defaults to 'confluence' to work with old editor
                    siteId: cloudId,
                    containerId: contextIdentifier && contextIdentifier.containerId,
                    objectId: contextIdentifier && contextIdentifier.objectId,
                    childObjectId: contextIdentifier && contextIdentifier.childObjectId,
                    mentionsSessionId: contextIdentifier && contextIdentifier.sessionId,
                    ...orgId ? {
                        organizationId: orgId
                    } : {},
                    ...this.includeExternalCollaborators ? {
                        productAttributes: {
                            isEntitledConfluenceExternalCollaborator: true
                        }
                    } : {}
                },
                searchQuery: {
                    queryString: query,
                    ...this.includeExternalCollaborators ? {
                        productAccessPermissionIds: [
                            'write',
                            'external-collaborator-write'
                        ]
                    } : {}
                },
                maxNumberOfResults: $76cb501321125a14$var$MAX_RESULTS,
                includeTeams: true
            })
        });
    }
    async searchXproductUsers(cloudId, orgId, query, contextIdentifier) {
        return await (0, $f7B1p.cfetch)(this.userTeamEndpoint, {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({
                context: {
                    contextType: $76cb501321125a14$var$CONTEXT_TYPE,
                    principalId: 'context',
                    productKey: 'jira',
                    // fetch only jira users
                    siteId: cloudId,
                    mentionsSessionId: contextIdentifier && contextIdentifier.sessionId,
                    ...orgId ? {
                        organizationId: orgId
                    } : {}
                },
                searchQuery: {
                    queryString: query,
                    productAccessPermissionIds: [
                        'write'
                    ]
                },
                maxNumberOfResults: $76cb501321125a14$var$MAX_RESULTS,
                includeTeams: false // Do not include teams
            })
        });
    }
    isAgent(recommended) {
        // Agents are returned as USER entity type with appType 'agent'
        return recommended.entityType === 'USER' && recommended.appType === 'agent';
    }
    convertToAgentMention(recommended) {
        return {
            id: recommended.id,
            name: recommended.name || recommended.nickname || '',
            mentionName: recommended.nickname || '',
            avatarUrl: recommended.avatarUrl,
            accessLevel: recommended.accessLevel,
            userType: 'APP',
            // Mark as app/agent type
            appType: 'agent'
        };
    }
    isUser(recommended) {
        // Regular users have entityType USER but no agent appType
        return recommended.entityType === 'USER' && recommended.appType !== 'agent';
    }
    convertToUserMention(recommended) {
        return {
            id: recommended.id,
            name: recommended.name || recommended.nickname || '',
            mentionName: recommended.nickname || '',
            avatarUrl: recommended.avatarUrl,
            accessLevel: recommended.accessLevel,
            userType: recommended.userType,
            ...recommended?.attributes?.isConfluenceExternalCollaborator ? {
                lozenge: (0, $9fywD.ExternalUserLozengeProps)
            } : {}
        };
    }
    isTeam(recommended) {
        return recommended.entityType === 'TEAM';
    }
    convertToTeamMention(recommended) {
        const { teamLinkResolver: teamLinkResolver } = this.teamMentionConfig;
        let teamLink = '';
        const defaultTeamLink = `${window.location.origin}/people/team/${recommended.id}`;
        if (typeof teamLinkResolver === 'function') teamLink = teamLinkResolver(recommended.id);
        return {
            id: recommended.id,
            name: recommended.displayName,
            mentionName: recommended.displayName,
            avatarUrl: recommended.smallAvatarImageUrl,
            accessLevel: (0, $caelp.UserAccessLevel)[(0, $caelp.UserAccessLevel).CONTAINER],
            userType: (0, $caelp.UserType)[(0, $caelp.UserType).TEAM],
            context: {
                members: recommended.members,
                includesYou: recommended.includesYou,
                memberCount: recommended.memberCount,
                teamLink: teamLink || defaultTeamLink
            }
        };
    }
    constructor(userTeamEndpoint, userMentionConfig, teamMentionConfig, includeExternalCollaborators, isEligibleXProductUserInvite, includeAgents = false){
        // To scale up agent search, we may want to increase the debounce time:
        let superDebounceTime = userMentionConfig.debounceTime ?? 0;
        let initialStateDebounceTime = 0;
        let searchDebounceTime = 0;
        if (includeAgents) {
            initialStateDebounceTime = Math.max((0, $6mKj3.expVal)('cc-agent-mentions-debounce-time', 'initialState', 0), superDebounceTime);
            searchDebounceTime = Math.max((0, $6mKj3.expVal)('cc-agent-mentions-debounce-time', 'search', 0), superDebounceTime);
            if (initialStateDebounceTime > superDebounceTime || searchDebounceTime > superDebounceTime) superDebounceTime = 0; // UserTeamMentionProvider's debounceFilter rather than the super will do the debouncing
        }
        super({
            ...userMentionConfig,
            debounceTime: superDebounceTime
        });
        this.userTeamEndpoint = void 0;
        this.teamMentionConfig = void 0;
        this.includeExternalCollaborators = void 0;
        this.includeAgents = void 0;
        this.offlineCache = void 0;
        this.isEligibleXProductUserInvite = void 0;
        this.agentMentionsFilterSequence = 0;
        if (!superDebounceTime && (initialStateDebounceTime || searchDebounceTime)) this.debounceFilter(initialStateDebounceTime, searchDebounceTime);
        this.teamMentionConfig = teamMentionConfig;
        this.userTeamEndpoint = userTeamEndpoint;
        this.includeExternalCollaborators = includeExternalCollaborators;
        this.includeAgents = includeAgents;
        this.isEligibleXProductUserInvite = isEligibleXProductUserInvite;
        const cache = (0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes') ? $76cb501321125a14$var$defaultCache : undefined;
        this.offlineCache = (0, $6mKj3.expValEquals)('platform_editor_offline_editing_web', 'isEnabled', true) ? new (0, $j5rtD.OfflineCache)(cache) : undefined;
    }
}
module.exports["UserTeamMentionProvider"] = $76cb501321125a14$export$f500b4849378edff;

});

parcelRegister("bijHC", function(module, exports) {
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $55fM8 = parcelRequire("55fM8");


var $gABt9 = parcelRequire("gABt9");


var $dJKHF = parcelRequire("dJKHF");


var $jymSm = parcelRequire("jymSm");


var $caelp = parcelRequire("caelp");


var $b3nqj = parcelRequire("b3nqj");


var $2SUNK = parcelRequire("2SUNK");


var $iXlTL = parcelRequire("iXlTL");




const $ec39392517ed4807$var$MAX_QUERY_ITEMS = 100;
const $ec39392517ed4807$var$emptySecurityProvider = ()=>{
    return {
        params: {},
        headers: {}
    };
};
class $ec39392517ed4807$export$5a4331e3e1c43553 extends (0, $iXlTL.AbstractMentionResource) {
    shouldHighlightMention(mention) {
        if (this.config.shouldHighlightMention) return this.config.shouldHighlightMention(mention);
        return false;
    }
    getMentionDisabledState(mention) {
        return this.config.getMentionDisabledState?.(mention);
    }
    notify(searchTime, mentionResult, query) {
        if (searchTime > this.lastReturnedSearch) {
            this.lastReturnedSearch = searchTime;
            this._notifyListeners(mentionResult, {
                duration: Date.now() - searchTime
            });
        } else {
            const date = new Date(searchTime).toISOString().substr(17, 6);
            (0, $2SUNK.default)('Stale search result, skipping', date, query); // eslint-disable-line no-console, max-len
        }
        this._notifyAllResultsListeners(mentionResult);
    }
    notifyError(error, query) {
        this._notifyErrorListeners(error, query);
        if (query) this.activeSearches.delete(query);
    }
    async filter(query, contextIdentifier) {
        try {
            const searchTime = Date.now();
            let results;
            if (!query) results = await this.initialState(contextIdentifier);
            else {
                this.activeSearches.add(query);
                const searchResponse = this.search(query, contextIdentifier);
                results = await searchResponse.mentions;
            }
            this.notify(searchTime, results, query);
        } catch (error) {
            this.notifyError(error, query);
        }
    }
    isFiltering(query) {
        return this.activeSearches.has(query);
    }
    resolveMentionName(id) {
        if (!this.config.mentionNameResolver) return {
            id: id,
            name: '',
            status: (0, $caelp.MentionNameStatus).UNKNOWN
        };
        return this.config.mentionNameResolver.lookupName(id);
    }
    cacheMentionName(id, mentionName) {
        if (!this.config.mentionNameResolver) return;
        this.config.mentionNameResolver.cacheName(id, mentionName);
    }
    supportsMentionNameResolving() {
        return !!this.config.mentionNameResolver;
    }
    updateActiveSearches(query) {
        this.activeSearches.add(query);
    }
    verifyMentionConfig(config) {
        if (!config.url) throw new Error('config.url is a required parameter');
        if (!config.securityProvider) config.securityProvider = $ec39392517ed4807$var$emptySecurityProvider;
    }
    initialState(contextIdentifier) {
        return this.remoteInitialState(contextIdentifier);
    }
    /**
   * Clear a context object to generate query params by removing empty
   * strings, `undefined` and empty values.
   *
   * @param contextIdentifier the current context identifier
   * @returns a safe context for query encoding
   */ clearContext(contextIdentifier = {}) {
        return Object.keys(contextIdentifier).filter((key)=>contextIdentifier[key]).reduce((context, key)=>({
                [key]: contextIdentifier[key],
                ...context
            }), {});
    }
    getQueryParams(contextIdentifier) {
        const configParams = {};
        if (this.config.containerId) configParams['containerId'] = this.config.containerId;
        if (this.config.productId) configParams['productIdentifier'] = this.config.productId;
        // if contextParams exist then it will override configParams for containerId
        return {
            ...configParams,
            ...this.clearContext(contextIdentifier)
        };
    }
    /**
   * Returns the initial mention display list before a search is performed for the specified
   * container.
   *
   * @param contextIdentifier
   * @returns Promise
   */ async remoteInitialState(contextIdentifier) {
        const queryParams = this.getQueryParams(contextIdentifier);
        const configHeaders = this.config.headers;
        const options = {
            path: 'bootstrap',
            queryParams: queryParams,
            ...configHeaders && {
                requestInit: {
                    headers: configHeaders
                }
            }
        };
        try {
            const result = await (0, $gABt9.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $b3nqj.SLI_EVENT_TYPE), (0, $caelp.SliNames).INITIAL_STATE, (0, $caelp.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, '');
        } catch (error) {
            this._notifyAnalyticsListeners((0, $b3nqj.SLI_EVENT_TYPE), (0, $caelp.SliNames).INITIAL_STATE, (0, $caelp.Actions).FAILED);
            throw error;
        }
    }
    search(query, contextIdentifier) {
        return {
            mentions: this.remoteSearch(query, contextIdentifier)
        };
    }
    async remoteSearch(query, contextIdentifier) {
        const configHeaders = this.config.headers;
        const options = {
            path: 'search',
            queryParams: {
                query: query,
                limit: $ec39392517ed4807$var$MAX_QUERY_ITEMS,
                ...this.getQueryParams(contextIdentifier)
            },
            ...configHeaders && {
                requestInit: {
                    headers: configHeaders
                }
            }
        };
        try {
            const result = await (0, $gABt9.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $b3nqj.SLI_EVENT_TYPE), (0, $caelp.SliNames).SEARCH, (0, $caelp.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, query);
        } catch (error) {
            this._notifyAnalyticsListeners((0, $b3nqj.SLI_EVENT_TYPE), (0, $caelp.SliNames).SEARCH, (0, $caelp.Actions).FAILED);
            throw error;
        }
    }
    transformServiceResponse(result, query) {
        const mentions = result.mentions.map((mention)=>{
            // Loading placeholders carry none of these fields and pass through untouched.
            if (mention.isPlaceholder) return mention;
            let lozenge;
            if ((0, $dJKHF.isAppMention)(mention)) lozenge = mention.userType;
            else if ((0, $jymSm.isTeamMention)(mention)) lozenge = mention.userType;
            return {
                ...mention,
                lozenge: lozenge,
                query: query
            };
        });
        return {
            ...result,
            mentions: mentions,
            query: result.query || query
        };
    }
    constructor(config){
        super();
        this.config = void 0;
        this.lastReturnedSearch = void 0;
        this.activeSearches = void 0;
        this.productName = void 0;
        this.shouldEnableInvite = void 0;
        this.userRole = void 0;
        this.onInviteItemClick = void 0;
        this.inviteXProductUser = void 0;
        this.verifyMentionConfig(config);
        this.config = config;
        this.lastReturnedSearch = 0;
        this.activeSearches = new Set();
        this.productName = config.productName;
        this.shouldEnableInvite = !!config.shouldEnableInvite;
        this.onInviteItemClick = config.onInviteItemClick;
        this.inviteXProductUser = config.inviteXProductUser;
        this.userRole = config.userRole || 'basic';
        if (this.config.debounceTime) this.filter = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(this.filter, this.config.debounceTime);
    }
}
var $ec39392517ed4807$export$2e2bcd8739ae039 = $ec39392517ed4807$export$5a4331e3e1c43553;
module.exports["MentionResource"] = $ec39392517ed4807$export$5a4331e3e1c43553;

});

parcelRegister("b3nqj", function(module, exports) {
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 







const $39262f9932c4c2bd$export$245097525aef1262 = 'sli';
const $39262f9932c4c2bd$export$c724588856bbfbcf = 'smart';
const $39262f9932c4c2bd$export$990f5c29478a61aa = 'atlassian.fabric.mention';
module.exports["SLI_EVENT_TYPE"] = $39262f9932c4c2bd$export$245097525aef1262;
module.exports["SMART_EVENT_TYPE"] = $39262f9932c4c2bd$export$c724588856bbfbcf;

});

parcelRegister("iXlTL", function(module, exports) {

var $2SUNK = parcelRequire("2SUNK");


var $dvMxu = parcelRequire("dvMxu");

const $f6b0f26d443249fd$var$MAX_NOTIFIED_ITEMS = 20;
class $f6b0f26d443249fd$export$8576ba1ed2760927 extends (0, $dvMxu.AbstractResource) {
    shouldHighlightMention(_mention) {
        return false;
    }
    // eslint-disable-next-line class-methods-use-this
    filter(query) {
        throw new Error(`not yet implemented.\nParams: query=${query}`);
    }
    // eslint-disable-next-line class-methods-use-this, no-unused-vars
    recordMentionSelection(_mention) {
    // Do nothing
    }
    isFiltering(_query) {
        return false;
    }
    _notifyListeners(mentionsResult, stats) {
        (0, $2SUNK.default)('ak-mention-resource._notifyListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.changeListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $f6b0f26d443249fd$var$MAX_NOTIFIED_ITEMS), mentionsResult.query, stats);
            } catch (e) {
                // ignore error from listener
                (0, $2SUNK.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAllResultsListeners(mentionsResult) {
        (0, $2SUNK.default)('ak-mention-resource._notifyAllResultsListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.allResultsListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $f6b0f26d443249fd$var$MAX_NOTIFIED_ITEMS), mentionsResult.query);
            } catch (e) {
                // ignore error from listener
                (0, $2SUNK.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyErrorListeners(error, query) {
        this.errListeners.forEach((listener, key)=>{
            try {
                listener(error, query);
            } catch (e) {
                // ignore error from listener
                (0, $2SUNK.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyInfoListeners(info) {
        this.infoListeners.forEach((listener, key)=>{
            try {
                listener(info);
            } catch (e) {
                // ignore error fromr listener
                (0, $2SUNK.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAnalyticsListeners(event, actionSubject, action, attributes) {
        this.analyticsListeners.forEach((listener, key)=>{
            try {
                listener(event, actionSubject, action, attributes);
            } catch (e) {
                // ignore error from listener
                (0, $2SUNK.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
}
module.exports["AbstractMentionResource"] = $f6b0f26d443249fd$export$8576ba1ed2760927;

});

parcelRegister("5CrKL", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $fd6g2 = parcelRequire("fd6g2");

const $41760797bb45431a$export$59eae628ebf25df4 = (0, $lSOAM.createCustomMetric)({
    key: (0, $fd6g2.MENTIONS_QUERY_CUSTOM_KEY)
});
module.exports["MENTIONS_QUERY_METRIC"] = $41760797bb45431a$export$59eae628ebf25df4;

});

parcelRegister("j5rtD", function(module, exports) {

var $cbY7C = parcelRequire("cbY7C");

class $099b8337f3ad112c$export$8904fcd398c673fb {
    update() {
        this.storageManager.setStoredValues(this.map).catch(()=>{
        // Pass, it's okay if this fails
        });
    }
    destroy() {
        this.unloadCleanup();
    }
    get(key) {
        return this.map.get(key);
    }
    set(key, value) {
        this.map.set(key, value);
    }
    constructor(storageManager){
        this.map = new Map();
        this.storageManager = void 0;
        this.unloadCleanup = ()=>{};
        const cacheName = 'editor:offline-network-request-cache';
        this.storageManager = storageManager ?? new $099b8337f3ad112c$var$IndexedDBManager(cacheName);
        this.storageManager.getStoredValues()?.then((v)=>{
            this.map = v;
        }).catch(()=>{
        // If the offline cache is rejected, use the initial empty map
        });
        if (window !== undefined) this.unloadCleanup = (0, $cbY7C.bind)(window, {
            type: 'beforeunload',
            listener: ()=>{
                this.update();
            }
        });
    }
}
/** Storage manager using indexeddb */ class $099b8337f3ad112c$var$IndexedDBManager {
    openDatabase() {
        return new Promise((resolve, reject)=>{
            const request = indexedDB.open(this.cacheName, 2);
            request.onupgradeneeded = (event)=>{
                const db = event.target.result;
                // Clear old results
                if (db.objectStoreNames.contains(this.objectStoreName)) db.deleteObjectStore(this.objectStoreName);
                db.createObjectStore(this.objectStoreName);
            };
            request.onsuccess = ()=>{
                resolve(request.result);
            };
            request.onerror = ()=>{
                reject(request.error);
            };
        });
    }
    // Retrieve a map of values for a store based on a set of keys
    async getAllStoredValues(store, keys) {
        const allValues = [];
        for (const key of keys){
            const valueRequest = store.get(key);
            allValues.push(new Promise((resolve, reject)=>{
                valueRequest.onsuccess = ()=>resolve([
                        key,
                        JSON.parse(valueRequest.result)
                    ]);
                valueRequest.onerror = ()=>reject(valueRequest.error);
            }));
        }
        return new Map(await Promise.all(allValues));
    }
    getStoredValues() {
        return this.dbPromise?.then((db)=>{
            return new Promise((resolve, reject)=>{
                const transaction = db.transaction(this.objectStoreName, 'readonly');
                const store = transaction.objectStore(this.objectStoreName);
                const request = store.getAllKeys();
                request.onsuccess = async ()=>{
                    const keys = request.result;
                    const resultMap = await this.getAllStoredValues(store, keys);
                    resolve(resultMap);
                };
                request.onerror = ()=>{
                    reject(request.error);
                };
            });
        }) ?? Promise.reject();
    }
    setStoredValues(values) {
        return this.dbPromise?.then((db)=>{
            return new Promise((resolve, reject)=>{
                const transaction = db.transaction(this.objectStoreName, 'readwrite');
                const store = transaction.objectStore(this.objectStoreName);
                transaction.oncomplete = ()=>resolve();
                transaction.onerror = ()=>reject(transaction.error);
                if (values.size === 0) return;
                // Clear the existing entries before setting new values
                store.clear().onsuccess = ()=>{
                    values.forEach((value, key)=>{
                        const serialisedValue = $099b8337f3ad112c$export$ad730aacbc246ec2(value);
                        if (serialisedValue !== null) store.put(serialisedValue, key);
                    });
                };
            });
        }) ?? Promise.reject();
    }
    constructor(cacheName){
        this.cacheName = cacheName;
        this.dbPromise = undefined;
        this.objectStoreName = 'cache';
        if (window?.indexedDB) this.dbPromise = this.openDatabase();
    }
}
function $099b8337f3ad112c$export$ad730aacbc246ec2(obj) {
    try {
        return JSON.stringify(obj, (_key, value)=>{
            if (typeof value !== 'string' && typeof value !== 'number' && typeof value !== 'boolean' && value !== null && value !== undefined && typeof value !== 'object' && !Array.isArray(value)) throw new Error('Non-serializable property found');
            return value;
        });
    } catch (error) {
        return null;
    }
}
module.exports["OfflineCache"] = $099b8337f3ad112c$export$8904fcd398c673fb;

});

parcelRegister("gYPwD", function(module, exports) {

var $gNfbp = parcelRequire("gNfbp");


var $eKwxR = parcelRequire("eKwxR");


var $kCDdC = parcelRequire("kCDdC");


var $as9lu = parcelRequire("as9lu");


var $c0rhi = parcelRequire("c0rhi");


var $3IBnw = parcelRequire("3IBnw");


var $6mKj3 = parcelRequire("6mKj3");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $ge2sX = parcelRequire("ge2sX");

const $5016900c96a66750$var$PRODUCT = 'confluence';
async function $5016900c96a66750$export$edde3720d795ca12(query, maxResults) {
    let mentions;
    try {
        mentions = query ? await $5016900c96a66750$var$queryAgentMentionsByName(query, maxResults) : await $5016900c96a66750$var$queryAgentMentionsForInitialState(maxResults);
    } catch (error) {
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).COMMENTS
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        throw error;
    }
    return {
        query: query,
        mentions: mentions
    };
}
async function $5016900c96a66750$var$queryAgentMentionsByName(query, maxResults) {
    const { cloudId: cloudId } = await (0, $ge2sX.getSessionData)();
    const input = {
        name: query,
        includeRovoChatAgent: (0, $6mKj3.isExperimentEnabled)('platform_editor_mention_rovo')
    };
    const { data: data, error: error } = await (0, $c0rhi.queryInterop)({
        query: $5016900c96a66750$var$queryAgentMentionsByNameQuery,
        ...(0, $6mKj3.isExperimentEnabled)('platform_editor_mention_search_order') ? {
            context: {
                fetchOptions: {
                    ignoreNoNetworkError: true
                }
            }
        } : {},
        variables: {
            cloudId: cloudId,
            first: maxResults,
            input: input,
            product: $5016900c96a66750$var$PRODUCT
        },
        interopApolloAggClient: true,
        __callerPackage__: "fabric-media-support"
    });
    if (error) throw error;
    return $5016900c96a66750$var$convertToMentions(data?.agentStudio_getAgents?.edges);
}
async function $5016900c96a66750$var$queryAgentMentionsForInitialState(maxResults) {
    const { cloudId: cloudId } = await (0, $ge2sX.getSessionData)();
    const { data: data, error: error } = await (0, $c0rhi.queryInterop)({
        query: $5016900c96a66750$var$queryAgentMentionsForInitialStateQuery,
        ...(0, $6mKj3.isExperimentEnabled)('platform_editor_mention_search_order') ? {
            context: {
                fetchOptions: {
                    ignoreNoNetworkError: true
                }
            }
        } : {},
        variables: {
            cloudId: cloudId,
            first: maxResults,
            includeMyAgents: (0, $6mKj3.isExperimentEnabled)('platform_editor_mention_search_order'),
            product: $5016900c96a66750$var$PRODUCT
        },
        interopApolloAggClient: true,
        __callerPackage__: "fabric-media-support"
    });
    if (error) throw error;
    const mentions = [
        ...$5016900c96a66750$var$convertToMentions(data?.favoriteAgents?.edges),
        ...$5016900c96a66750$var$convertToMentions(data?.myAgents?.edges),
        ...$5016900c96a66750$var$convertToMentions(data?.verifiedAgents?.edges),
        ...$5016900c96a66750$var$convertToMentions(data?.allAgents?.edges)
    ];
    // Only return the first distinct maxResults:
    const returnedMentionIds = new Set();
    return mentions.filter((mention)=>{
        if (returnedMentionIds.size >= maxResults || returnedMentionIds.has(mention.id)) return false;
        returnedMentionIds.add(mention.id);
        return true;
    });
}
function $5016900c96a66750$var$convertToMentions(edges) {
    return edges?.map((edge)=>edge.node).filter((agent)=>Boolean(agent?.identityAccountId && agent?.name)).map($5016900c96a66750$var$convertToMentionDescription) ?? [];
}
function $5016900c96a66750$var$convertToMentionDescription(agent) {
    return {
        appType: 'agent',
        avatarUrl: agent.identityAccount?.picture || undefined,
        description: agent.description || undefined,
        id: $5016900c96a66750$export$8cac12d91c2ad785(agent.identityAccountId),
        mentionName: agent.name,
        name: agent.name,
        userType: 'APP'
    };
}
function $5016900c96a66750$export$8cac12d91c2ad785(identityAccountId) {
    try {
        return (0, $as9lu.IdentityUserAri).parse(identityAccountId).userId;
    } catch  {
        return identityAccountId;
    }
}
const $5016900c96a66750$export$ee0ef79a58e4aab4 = (0, $kCDdC.default);
const $5016900c96a66750$var$queryAgentMentionsByNameQuery = (0, $eKwxR.default);
const $5016900c96a66750$var$queryAgentMentionsForInitialStateQuery = (0, $gNfbp.default);
module.exports["queryAgentMentions"] = $5016900c96a66750$export$edde3720d795ca12;

});

parcelRegister("gNfbp", function(module, exports) {
/**
 * @generated SignedSource<<9a35a589514d9691c04befe91526f69b>>
 * @relayHash b2eeb0cf48e639dc2a009682da32ff2e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID afb5b93e354d2e453248649cca26d11973fa9a96e9254c7a588ade0937e3eab7
const $23b05ae499fb93a6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeMyAgents"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "product"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v3 = {
        "kind": "Variable",
        "name": "product",
        "variableName": "product"
    }, v4 = [
        v1 /*: any*/ ,
        v2 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "input",
            "value": {
                "onlyFavouriteAgents": true
            }
        },
        v3 /*: any*/ 
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "description"
    }, v7 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v8 = {
        "kind": "ScalarField",
        "name": "identityAccountId"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = [
        {
            "concreteType": "AgentStudioAgentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "AgentStudioAssistant",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "identityAccount",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ 
                            ]
                        },
                        v8 /*: any*/ ,
                        v9 /*: any*/ 
                    ]
                }
            ]
        }
    ], v11 = [
        v1 /*: any*/ ,
        v2 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "input",
            "value": {
                "onlyMyAgents": true
            }
        },
        v3 /*: any*/ 
    ], v12 = [
        v1 /*: any*/ ,
        v2 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "input",
            "value": {
                "onlyVerifiedAgents": true
            }
        },
        v3 /*: any*/ 
    ], v13 = [
        v1 /*: any*/ ,
        v2 /*: any*/ ,
        v3 /*: any*/ 
    ], v14 = [
        {
            "concreteType": "AgentStudioAgentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "AgentStudioAssistant",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "identityAccount",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                v7 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        },
                        v8 /*: any*/ ,
                        v9 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "queryAgentMentionsForInitialStateQuery",
            "selections": [
                {
                    "alias": "favoriteAgents",
                    "args": v4 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": v10 /*: any*/ 
                },
                {
                    "condition": "includeMyAgents",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "myAgents",
                            "args": v11 /*: any*/ ,
                            "concreteType": "AgentStudioAgentsConnection",
                            "kind": "LinkedField",
                            "name": "agentStudio_getAgents",
                            "plural": false,
                            "selections": v10 /*: any*/ 
                        }
                    ]
                },
                {
                    "alias": "verifiedAgents",
                    "args": v12 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": v10 /*: any*/ 
                },
                {
                    "alias": "allAgents",
                    "args": v13 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": v10 /*: any*/ 
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "queryAgentMentionsForInitialStateQuery",
            "selections": [
                {
                    "alias": "favoriteAgents",
                    "args": v4 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": v14 /*: any*/ 
                },
                {
                    "condition": "includeMyAgents",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "myAgents",
                            "args": v11 /*: any*/ ,
                            "concreteType": "AgentStudioAgentsConnection",
                            "kind": "LinkedField",
                            "name": "agentStudio_getAgents",
                            "plural": false,
                            "selections": v14 /*: any*/ 
                        }
                    ]
                },
                {
                    "alias": "verifiedAgents",
                    "args": v12 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": v14 /*: any*/ 
                },
                {
                    "alias": "allAgents",
                    "args": v13 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": v14 /*: any*/ 
                }
            ]
        },
        "params": {
            "cacheID": "b2eeb0cf48e639dc2a009682da32ff2e",
            "id": "afb5b93e354d2e453248649cca26d11973fa9a96e9254c7a588ade0937e3eab7",
            "metadata": {},
            "name": "queryAgentMentionsForInitialStateQuery",
            "operationKind": "query",
            "text": "query queryAgentMentionsForInitialStateQuery($cloudId:String!,$first:Int,$includeMyAgents:Boolean!,$product:String){favoriteAgents:agentStudio_getAgents(cloudId:$cloudId,first:$first,input:{onlyFavouriteAgents:true},product:$product)@optIn(to:\"AgentStudio\"){edges{node{id,description,identityAccount{__typename,picture,id},identityAccountId,name}}},myAgents:agentStudio_getAgents(cloudId:$cloudId,first:$first,input:{onlyMyAgents:true},product:$product)@include(if:$includeMyAgents)@optIn(to:\"AgentStudio\"){edges{node{id,description,identityAccount{__typename,picture,id},identityAccountId,name}}},verifiedAgents:agentStudio_getAgents(cloudId:$cloudId,first:$first,input:{onlyVerifiedAgents:true},product:$product)@optIn(to:\"AgentStudio\"){edges{node{id,description,identityAccount{__typename,picture,id},identityAccountId,name}}},allAgents:agentStudio_getAgents(cloudId:$cloudId,first:$first,product:$product)@optIn(to:\"AgentStudio\"){edges{node{id,description,identityAccount{__typename,picture,id},identityAccountId,name}}}}"
        }
    };
}();
$23b05ae499fb93a6$var$node.hash = "0a100ab1ba01b559d511e874c261464b";
var $23b05ae499fb93a6$export$2e2bcd8739ae039 = $23b05ae499fb93a6$var$node;
module.exports["default"] = $23b05ae499fb93a6$export$2e2bcd8739ae039;

});

parcelRegister("eKwxR", function(module, exports) {
/**
 * @generated SignedSource<<d7f0b2c611d19b07a0220c2ed273693e>>
 * @relayHash eb2b45b6f1c6a0bf9f3f42710420bd9e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3bfb66bc29f1d4ba518f3f90ceb733bbc250f8984683a642222fe65ede346b9c
const $d9f9c84cb1e3d64f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "product"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        },
        {
            "kind": "Variable",
            "name": "product",
            "variableName": "product"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "description"
    }, v4 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v5 = {
        "kind": "ScalarField",
        "name": "identityAccountId"
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "queryAgentMentionsByNameQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "AgentStudioAgentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "AgentStudioAssistant",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "identityAccount",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "queryAgentMentionsByNameQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "AgentStudioAgentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "AgentStudioAssistant",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "identityAccount",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v4 /*: any*/ ,
                                                v2 /*: any*/ 
                                            ]
                                        },
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "eb2b45b6f1c6a0bf9f3f42710420bd9e",
            "id": "3bfb66bc29f1d4ba518f3f90ceb733bbc250f8984683a642222fe65ede346b9c",
            "metadata": {},
            "name": "queryAgentMentionsByNameQuery",
            "operationKind": "query",
            "text": "query queryAgentMentionsByNameQuery($cloudId:String!,$first:Int,$input:AgentStudioAgentQueryInput,$product:String){agentStudio_getAgents(cloudId:$cloudId,first:$first,input:$input,product:$product)@optIn(to:\"AgentStudio\"){edges{node{id,description,identityAccount{__typename,picture,id},identityAccountId,name}}}}"
        }
    };
}();
$d9f9c84cb1e3d64f$var$node.hash = "f44bfcd4dfdb02102d0d5899552fd79b";
var $d9f9c84cb1e3d64f$export$2e2bcd8739ae039 = $d9f9c84cb1e3d64f$var$node;
module.exports["default"] = $d9f9c84cb1e3d64f$export$2e2bcd8739ae039;

});

parcelRegister("kCDdC", function(module, exports) {
/**
 * @generated SignedSource<<5e3744baa56592241aa8051b0c2ab009>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5c4367f6180fde75$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "queryAgentMentionsFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "description"
        },
        {
            "kind": "LinkedField",
            "name": "identityAccount",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "picture"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "identityAccountId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        }
    ],
    "type": "AgentStudioAssistant"
};
$5c4367f6180fde75$var$node.hash = "c9fe20126b9ae533caed55eab71ee09d";
var $5c4367f6180fde75$export$2e2bcd8739ae039 = $5c4367f6180fde75$var$node;
module.exports["default"] = $5c4367f6180fde75$export$2e2bcd8739ae039;

});

parcelRegister("fQ3iN", function(module, exports) {
/**
 * BM3 Deprecation Phase 2 — gated wrapper around the raw BM3 page-segment-load factory.
 *
 * This file is the canonical implementation behind the public name
 * `createPageSegmentLoadMetric` (re-exported from
 * `@confluence/browser-metrics/entry-points/metricConfigs.ts`). All Confluence consumers
 * call the gated variant by virtue of importing the public name; there is no separate
 * "raw" public entry point.
 *
 * When the `cc_bm3_deprecation_phase_2` gate is OFF (default), every method call delegates
 * verbatim to the underlying BM3 PageSegmentLoadMetric so existing behaviour and the BM3
 * `PAGE_SEGMENT_LOAD` analytics events are preserved.
 *
 * When the gate is ON, the BM3 calls are skipped and equivalent UFO custom marks / custom
 * data are emitted instead. This lets us roll out the removal of the BM3 page-segment-load
 * events incrementally — controlled by Statsig — without touching any of the ~25
 * perf.config files or ~20 imperative call sites. Consumers continue to use
 * `METRIC.start()`, `.stop()`, `.cancel()`, `.mark()`, `.markFMP()`,
 * `.startFromPageLoad()` exactly as before; the gate decision is centralised here.
 *
 * The gate `fg(...)` is evaluated **inline at the callsite of each method**, never aliased
 * or wrapped, in line with the feature-gate-and-experiment-usage AGENTS guidance. Per-method
 * (rather than per-construction) evaluation is required because perf.config modules are
 * imported very early in app boot — earlier than Statsig data is loaded — so a one-shot
 * `fg()` call at construction time would always read the default (false) value.
 *
 * Implementation note: rather than returning a *new* wrapper object, this helper mutates
 * the real BM3 metric instance by overriding selected methods with bound functions that
 * consult the gate. This preserves the metric's class identity, prototype chain, and
 * private internal state so it remains a fully drop-in substitute everywhere a BM3
 * PageSegmentLoadMetric is used (including in `pageLoadMetric.include[]` / `until[]`
 * arrays where BM3 walks the internal experience graph).
 *
 * Once the gate has fully ramped, this file's body will be replaced with a UFO-only
 * implementation and the BM3 dependency removed entirely.
 */ 
var $gXfti = parcelRequire("gXfti");


var $knAY5 = parcelRequire("knAY5");


var $9wGTI = parcelRequire("9wGTI");


var $3YpC9 = parcelRequire("3YpC9");


var $kw6I9 = parcelRequire("kw6I9");

function $a96d58ddd476e3f0$export$34f706592a2f7442(config) {
    const metric = (0, $kw6I9.createBM3PageSegmentLoadMetricRaw)(config);
    const key = config.key;
    // Capture the original methods before overriding them.
    const realStart = metric.start.bind(metric);
    const realStartFromPageLoad = metric.startFromPageLoad.bind(metric);
    const realStop = metric.stop.bind(metric);
    const realCancel = metric.cancel.bind(metric);
    const realMark = metric.mark.bind(metric);
    const realMarkFMP = metric.markFMP.bind(metric);
    metric.start = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $knAY5.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${key}`);
            return;
        }
        return realStart(...args);
    };
    metric.startFromPageLoad = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $knAY5.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${key}`);
            return;
        }
        return realStartFromPageLoad(...args);
    };
    metric.stop = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $knAY5.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${key}`);
            const opts = args[0];
            if (opts?.customData) (0, $gXfti.addUFOCustomData)(opts.customData);
            return true;
        }
        return realStop(...args);
    };
    metric.cancel = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            // Note - there's no equivalent for cancel in UFO, so we use the end mark instead.
            (0, $knAY5.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${key}`);
            return;
        }
        return realCancel(...args);
    };
    metric.mark = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            const [name, timestamp] = args;
            (0, $knAY5.addUFOCustomMark)(name, timestamp);
            return;
        }
        return realMark(...args);
    };
    metric.markFMP = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            const [timestamp] = args;
            (0, $knAY5.addUFOCustomMark)(`fmp:${key}`, timestamp);
            return;
        }
        return realMarkFMP(...args);
    };
    return metric;
}
module.exports["createPageSegmentLoadMetric"] = $a96d58ddd476e3f0$export$34f706592a2f7442;

});

parcelRegister("3YpC9", function(module, exports) {
const $4dbe182ee19642b3$export$f59b3ea823fcdb3d = 'segment-start';
const $4dbe182ee19642b3$export$a217b163593f51a = 'segment-end';
module.exports["PAGE_SEGMENT_MARK_PREFIX_START"] = $4dbe182ee19642b3$export$f59b3ea823fcdb3d;
module.exports["PAGE_SEGMENT_MARK_PREFIX_END"] = $4dbe182ee19642b3$export$a217b163593f51a;

});

parcelRegister("kw6I9", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $iDdTC = parcelRequire("iDdTC");

const $864083edfead32eb$export$2a2fe1e11b4e0413 = (0, $iDdTC.metrics).pageSegmentLoad;
module.exports["createBM3PageSegmentLoadMetricRaw"] = $864083edfead32eb$export$2a2fe1e11b4e0413;

});

parcelRegister("g2yI6", function(module, exports) {

var $89CKS = parcelRequire("89CKS");


var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $28b5c5efee4d19cf$var$fetchMentionsProviderDataQuery = (0, $89CKS.default);
const $28b5c5efee4d19cf$export$5ced7267a5286f97 = async ()=>{
    return (0, $c0rhi.queryInterop)({
        query: $28b5c5efee4d19cf$var$fetchMentionsProviderDataQuery,
        __callerPackage__: "fabric-media-support"
    }).then(({ data: data })=>{
        return data;
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return undefined;
    });
};
module.exports["fetchMentionsProviderData"] = $28b5c5efee4d19cf$export$5ced7267a5286f97;

});

parcelRegister("24tIi", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9J6Os = parcelRequire("9J6Os");


var $7GkXv = parcelRequire("7GkXv");


var $55IIP = parcelRequire("55IIP");


var $cCc2a = parcelRequire("cCc2a");


var $9K2Ng = parcelRequire("9K2Ng");

const $146c3ccf1b168812$var$SmartUserPickerWithIntlProvider = (props)=>{
    const ufoId = props.inputId || props.fieldId;
    (0, $55IIP.useUFOConcurrentExperience)((0, $7GkXv.smartUserPickerRenderedUfoExperience), ufoId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9J6Os.UfoErrorBoundary), {
        id: ufoId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cCc2a.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9K2Ng.SmartUserPicker), props)));
};
var $146c3ccf1b168812$export$2e2bcd8739ae039 = $146c3ccf1b168812$var$SmartUserPickerWithIntlProvider;
module.exports["default"] = $146c3ccf1b168812$export$2e2bcd8739ae039;

});

parcelRegister("9J6Os", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7GkXv = parcelRequire("7GkXv");

class $153c8f37d7ffdc96$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidCatch() {
        (0, $7GkXv.smartUserPickerRenderedUfoExperience).getInstance(this.props.id).failure();
    }
    render() {
        return this.props.children;
    }
}
module.exports["UfoErrorBoundary"] = $153c8f37d7ffdc96$export$5ef1c2550074a375;

});

parcelRegister("7GkXv", function(module, exports) {

var $4MiWC = parcelRequire("4MiWC");


var $fh15z = parcelRequire("fh15z");

const $d95d43c2c4127308$var$COMPONENT_NAME = 'smart-user-picker';
const $d95d43c2c4127308$export$df77da4c0210f1c1 = new (0, $fh15z.ConcurrentExperience)('smart-user-picker-rendered', {
    platform: {
        component: $d95d43c2c4127308$var$COMPONENT_NAME
    },
    type: (0, $4MiWC.ExperienceTypes).Load,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).PageSegmentLoad
});
const $d95d43c2c4127308$export$a0e7cca3ab9586eb = new (0, $fh15z.ConcurrentExperience)('smart-user-picker-options-shown', {
    platform: {
        component: $d95d43c2c4127308$var$COMPONENT_NAME
    },
    type: (0, $4MiWC.ExperienceTypes).Operation,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).InlineResult
});
module.exports["smartUserPickerRenderedUfoExperience"] = $d95d43c2c4127308$export$df77da4c0210f1c1;
module.exports["smartUserPickerOptionsShownUfoExperience"] = $d95d43c2c4127308$export$a0e7cca3ab9586eb;

});

parcelRegister("55IIP", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $j7Sza = parcelRequire("j7Sza");

const $c946929add000bee$export$e5e0512991825310 = (experience, id)=>{
    const experienceForId = experience.getInstance(id);
    // Equivalent to pre-mount initialization - replace with @atlaskit/ufo's
    // useUFOComponentExperience when it supports ConcurrentExperience.
    (0, $cozmU.useState)(()=>{
        experienceForId.start();
    });
    // Replace with @atlaskit/ufo's <ExperienceSuccess> when it supports ConcurrentExperience
    (0, $cozmU.useEffect)(()=>{
        if (experienceForId.state !== (0, $j7Sza.UFOExperienceState)['FAILED']) experienceForId.success();
        return ()=>{
            if ([
                (0, $j7Sza.UFOExperienceState)['STARTED'],
                (0, $j7Sza.UFOExperienceState)['IN_PROGRESS']
            ].includes(experienceForId.state)) experienceForId.abort();
        };
    // We only want this useEffect to run once after component mount, so no deps are needed.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
module.exports["useUFOConcurrentExperience"] = $c946929add000bee$export$e5e0512991825310;

});

parcelRegister("cCc2a", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iX1XL = parcelRequire("iX1XL");

const $3783e719317347ac$var$EMPTY = {};
const $3783e719317347ac$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState($3783e719317347ac$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        let aborted = false;
        setMessages($3783e719317347ac$var$EMPTY);
        (0, $iX1XL.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $3783e719317347ac$var$MessagesIntlProvider = (props)=>{
    const { intl: intl, children: children } = props;
    const messages = $3783e719317347ac$var$useI18n(intl.locale);
    const mergedMessages = (0, $cozmU.useMemo)(()=>{
        return {
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        locale: intl.locale,
        messages: mergedMessages
    }, children);
};
const $3783e719317347ac$var$_default_1 = (0, $kSwu1.injectIntl)($3783e719317347ac$var$MessagesIntlProvider);
var $3783e719317347ac$export$2e2bcd8739ae039 = $3783e719317347ac$var$_default_1;
module.exports["default"] = $3783e719317347ac$export$2e2bcd8739ae039;

});

parcelRegister("iX1XL", function(module, exports) {
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ 





























const $792857de5d56fcc9$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("6npt8")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("gDFuO")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("68pf5")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("hHGlo")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("f1C0z")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("3gTwX")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("6pI2S")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("2ZlOL")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("8T8Ab")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("6nJ4E")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("5IoA9")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("g1CsZ")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("aZGmw")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("fOV60")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("g75fo")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("4yIMZ")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("1bALo")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("dhear")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("yo5gM")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("dbxCp")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("3E3J9")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("2tXi9")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("cCZAe")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("btBWb")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("kU1Eg")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("ePEp4")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("25Xis")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("79I5G")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("ibtYk")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $792857de5d56fcc9$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("hHGlo")).then((mod)=>mod.default);
            }
    }
};
module.exports["getMessagesForLocale"] = $792857de5d56fcc9$export$d0a3169680473b6c;

});

parcelRegister("6npt8", function(module, exports) {

let $4a48a5a7336ef556$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4a48a5a7336ef556$var$load("aQPG0").then(()=>parcelRequire('kNAr6'));

});

parcelRegister("gDFuO", function(module, exports) {

let $c1d07a1d592a63c6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c1d07a1d592a63c6$var$load("bkZFg").then(()=>parcelRequire('iQITF'));

});

parcelRegister("68pf5", function(module, exports) {

let $47771203695ddf00$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $47771203695ddf00$var$load("55jRH").then(()=>parcelRequire('4Y6NR'));

});

parcelRegister("hHGlo", function(module, exports) {

let $ce374c76d2f1e237$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ce374c76d2f1e237$var$load("7gZXw").then(()=>parcelRequire('44AgC'));

});

parcelRegister("f1C0z", function(module, exports) {

let $af046eaa9eb40603$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $af046eaa9eb40603$var$load("b3SDM").then(()=>parcelRequire('aAjDq'));

});

parcelRegister("3gTwX", function(module, exports) {

let $261df0f125d7ec52$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $261df0f125d7ec52$var$load("9yhAT").then(()=>parcelRequire('gebt4'));

});

parcelRegister("6pI2S", function(module, exports) {

let $4ab73e5e45bd9c3a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4ab73e5e45bd9c3a$var$load("cdSjM").then(()=>parcelRequire('66D3r'));

});

parcelRegister("2ZlOL", function(module, exports) {

let $22d233da3d024f10$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $22d233da3d024f10$var$load("d5cjH").then(()=>parcelRequire('5GOkE'));

});

parcelRegister("8T8Ab", function(module, exports) {

let $678a1e1a8fa5b9ec$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $678a1e1a8fa5b9ec$var$load("cM3qB").then(()=>parcelRequire('4kDHd'));

});

parcelRegister("6nJ4E", function(module, exports) {

let $4a57dacc74badc26$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4a57dacc74badc26$var$load("ju3RT").then(()=>parcelRequire('2EVaB'));

});

parcelRegister("5IoA9", function(module, exports) {

let $429421467dc9e033$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $429421467dc9e033$var$load("eKgTI").then(()=>parcelRequire('c7qHA'));

});

parcelRegister("g1CsZ", function(module, exports) {

let $baaa94056a83aeca$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $baaa94056a83aeca$var$load("4SiFB").then(()=>parcelRequire('bikcP'));

});

parcelRegister("aZGmw", function(module, exports) {

let $80107625e0a4f412$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $80107625e0a4f412$var$load("3sB8d").then(()=>parcelRequire('kuHNn'));

});

parcelRegister("fOV60", function(module, exports) {

let $b847d096a5dfc710$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b847d096a5dfc710$var$load("cufjc").then(()=>parcelRequire('gF7hG'));

});

parcelRegister("g75fo", function(module, exports) {

let $bbb15ec44325a35c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bbb15ec44325a35c$var$load("hPzC3").then(()=>parcelRequire('dffVf'));

});

parcelRegister("4yIMZ", function(module, exports) {

let $351d149a8785bd34$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $351d149a8785bd34$var$load("cjMnf").then(()=>parcelRequire('6FAuN'));

});

parcelRegister("1bALo", function(module, exports) {

let $0dd355f3ec300f90$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0dd355f3ec300f90$var$load("bdFVZ").then(()=>parcelRequire('5e6r7'));

});

parcelRegister("dhear", function(module, exports) {

let $9aa7da3b13e70e6f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9aa7da3b13e70e6f$var$load("73TPf").then(()=>parcelRequire('ag0hm'));

});

parcelRegister("yo5gM", function(module, exports) {

let $0675dbab9a2187ad$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0675dbab9a2187ad$var$load("84JCz").then(()=>parcelRequire('fK5Ez'));

});

parcelRegister("dbxCp", function(module, exports) {

let $99966165c3f9d8e1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $99966165c3f9d8e1$var$load("e9I4V").then(()=>parcelRequire('cOlwg'));

});

parcelRegister("3E3J9", function(module, exports) {

let $2a77ffa9ff93ba5e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2a77ffa9ff93ba5e$var$load("11Tbc").then(()=>parcelRequire('g7siS'));

});

parcelRegister("2tXi9", function(module, exports) {

let $1cec4853d1711128$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1cec4853d1711128$var$load("9tJmD").then(()=>parcelRequire('khkji'));

});

parcelRegister("cCZAe", function(module, exports) {

let $9318cdcec3856db5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9318cdcec3856db5$var$load("15Pfi").then(()=>parcelRequire('9Bj7P'));

});

parcelRegister("btBWb", function(module, exports) {

let $85afd4b72e7d87e4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $85afd4b72e7d87e4$var$load("5JkSw").then(()=>parcelRequire('8DnOd'));

});

parcelRegister("kU1Eg", function(module, exports) {

let $f37a50eefde1b8b9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f37a50eefde1b8b9$var$load("8yuuY").then(()=>parcelRequire('dD65A'));

});

parcelRegister("ePEp4", function(module, exports) {

let $acc52b641fad9633$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $acc52b641fad9633$var$load("gYFls").then(()=>parcelRequire('eZJS0'));

});

parcelRegister("25Xis", function(module, exports) {

let $186a0b79be7dcc0f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $186a0b79be7dcc0f$var$load("4tohK").then(()=>parcelRequire('d7z8J'));

});

parcelRegister("79I5G", function(module, exports) {

let $535b932ba5103996$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $535b932ba5103996$var$load("iXqHo").then(()=>parcelRequire('d1XXs'));

});

parcelRegister("ibtYk", function(module, exports) {

let $d3d080e86badaf7d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d3d080e86badaf7d$var$load("lcic8").then(()=>parcelRequire('9U3K8'));

});

parcelRegister("9K2Ng", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $55fM8 = parcelRequire("55fM8");


var $03RpJ = parcelRequire("03RpJ");


var $lzgC6 = parcelRequire("lzgC6");


var $dOBRD = parcelRequire("dOBRD");


var $kSwu1 = parcelRequire("kSwu1");


var $j7Sza = parcelRequire("j7Sza");


var $kfLla = parcelRequire("kfLla");


var $1e7zb = parcelRequire("1e7zb");


var $9rnjH = parcelRequire("9rnjH");


var $2wJhI = parcelRequire("2wJhI");


var $kea9V = parcelRequire("kea9V");


var $bsEy7 = parcelRequire("bsEy7");


var $iDrrr = parcelRequire("iDrrr");


var $kK1nI = parcelRequire("kK1nI");


var $1aAKX = parcelRequire("1aAKX");


var $hzyrU = parcelRequire("hzyrU");


var $l5d33 = parcelRequire("l5d33");


var $gyQlE = parcelRequire("gyQlE");


var $9UYr8 = parcelRequire("9UYr8");


var $lv0WZ = parcelRequire("lv0WZ");


var $832DI = parcelRequire("832DI");


var $cCc2a = parcelRequire("cCc2a");


var $jItb7 = parcelRequire("jItb7");


var $b9heI = parcelRequire("b9heI");


var $uUDXo = parcelRequire("uUDXo");


var $7GkXv = parcelRequire("7GkXv");

const $537559c2d938befb$var$DEFAULT_DEBOUNCE_TIME_MS = 150;
const $537559c2d938befb$var$ufoEndStateConfig = (fieldId)=>{
    return {
        metadata: {
            contextType: fieldId
        }
    };
};
const $537559c2d938befb$var$hasContextChanged = (oldContext, newContext)=>oldContext.siteId !== newContext.siteId || oldContext.orgId !== newContext.orgId || oldContext.userbaseId !== newContext.userbaseId || oldContext.productKey !== newContext.productKey || oldContext.principalId !== newContext.principalId || oldContext.containerId !== newContext.containerId || oldContext.objectId !== newContext.objectId || oldContext.childObjectId !== newContext.childObjectId;
const $537559c2d938befb$var$stringContains = (str, substr)=>{
    if (str === null || str === undefined) return false;
    if (substr === null || substr === '' || substr === undefined) return true;
    return str.toLowerCase().includes(substr.toLowerCase());
};
const $537559c2d938befb$var$getUsersForAnalytics = (users)=>(users || []).map(({ id: id, type: type })=>({
            id: id,
            type: type
        }));
const $537559c2d938befb$var$checkIf500Event = (statusCode)=>500 <= statusCode && statusCode < 600;
const $537559c2d938befb$var$isEmailQuery = (query)=>{
    return (0, $bsEy7.isValidEmail)(query.trim()) === 'VALID';
};
class $537559c2d938befb$export$9b9bd453d1d4e4ce extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    async componentDidMount() {
        try {
            const value = await (0, $uUDXo.default)(this.props.baseUrl, this.props.defaultValue, this.props.productKey, this.props.siteId, {
                tenantId: this.props.siteId,
                activationId: this.props.activationId
            });
            this.setState({
                defaultValue: value
            });
        } catch (e) {
            const defaultValue = await (this.props.onValueError ? this.props.onValueError(e, this.props.defaultValue) || Promise.resolve([]) : Promise.resolve([]));
            this.setState({
                defaultValue: defaultValue
            });
        }
        const { prefetch: prefetch } = this.props;
        if (prefetch) {
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            const sessionId = (0, $03RpJ.default)();
            this.fireEvent((0, $gyQlE.mountedWithPrefetchEvent), {
                sessionId: sessionId
            });
            this.setState({
                sessionId: sessionId
            });
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if ($537559c2d938befb$var$hasContextChanged(prevProps, this.props) || this.props.fieldId !== prevProps.fieldId) this.setState({
            users: []
        });
        if ((this.state.sessionId !== prevState.sessionId || this.state.query !== prevState.query) && (this.state.query !== '' || !this.props.bootstrapOptions)) this.getUsers();
        else if (!this.state.closed && !this.state.loading) // If the component has rendered (including its dropdown list) and it
        // is not loading anything further, send the success UFO event
        {
            if (![
                (0, $j7Sza.UFOExperienceState).FAILED.id,
                (0, $j7Sza.UFOExperienceState).SUCCEEDED.id,
                (0, $j7Sza.UFOExperienceState).ABORTED.id
            ].includes(this.optionsShownUfoExperienceInstance.state.id)) this.optionsShownUfoExperienceInstance.success($537559c2d938befb$var$ufoEndStateConfig(this.props.fieldId));
        }
    }
    render() {
        const { allowEmail: allowEmail, enableEmailSearch: enableEmailSearch, allowEmailSelectionWhenEmailMatched: allowEmailSelectionWhenEmailMatched, suggestEmailsForDomain: suggestEmailsForDomain, ...restProps } = this.props;
        // Determine whether to allow email selection based on allowEmailSelectionWhenEmailMatched, if needed
        let shouldAllowEmail = allowEmail;
        // When suggestEmailsForDomain is active, partial (non-email) input must still reach the base
        // picker's domain-suggestion creatable logic, so the isEmailQuery restriction is relaxed for
        // those queries only. Full email queries that matched an existing user remain suppressed.
        const isDomainSuggestionEnabled = (0, $iDrrr.fg)('smart_user_picker_suggest_emails_for_domain') && !!suggestEmailsForDomain;
        if (allowEmail && enableEmailSearch && !allowEmailSelectionWhenEmailMatched) {
            const isCurrentQueryEmail = $537559c2d938befb$var$isEmailQuery(this.state.query);
            if (isDomainSuggestionEnabled) // Allow email for partial queries so the "<query>@<domain>" suggestion can render,
            // but still suppress selection when a full email query matched an existing user,
            // or when the synthesized "<query>@<domain>" is itself an existing user's email.
            shouldAllowEmail = isCurrentQueryEmail ? !this.lastEmailSearchFoundMatches // full email: suppress when user matched
             : !this.lastDomainSuggestionMatchedUser; // partial: suppress when synth email matched a user
            else // Only allow email selection when:
            // 1. The query matches email format (validated by regex)
            // 2. No user/external user matches were found (only teams/groups suggested)
            shouldAllowEmail = isCurrentQueryEmail && !this.lastEmailSearchFoundMatches;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cCc2a.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kfLla.UserPicker), {
            ...restProps,
            allowEmail: shouldAllowEmail,
            suggestEmailsForDomain: suggestEmailsForDomain,
            onInputChange: this.onInputChange,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            defaultValue: this.state.defaultValue,
            isLoading: this.props.isLoading || this.state.loading && !this.state.closed && (!this.props.bootstrapOptions || this.state.query !== ''),
            options: this.filterUsers(),
            menuIsOpen: this.props.menuIsOpen
        }));
    }
    constructor(props){
        super(props);
        this.state = {
            users: [],
            loading: false,
            closed: true,
            query: '',
            defaultValue: [],
            bootstrapOptions: []
        };
        // Track if the last search was an email search that found matches
        this.lastEmailSearchFoundMatches = false;
        // Track if the domain-suggested email (`<query>@<suggestEmailsForDomain>`) for a partial
        // query already belongs to a returned user, in which case the suggestion is redundant
        this.lastDomainSuggestionMatchedUser = false;
        this.optionsShownUfoExperienceInstance = void 0;
        this.abortOptionsShownUfoExperience = ()=>{
            if (this.optionsShownUfoExperienceInstance.state.id === (0, $j7Sza.UFOExperienceState).STARTED.id) // There may be an existing UFO timing running from previous key entry or focus,
            // so abort it and restart it just in case.
            this.optionsShownUfoExperienceInstance.abort();
        };
        this.startOptionsShownUfoExperience = ()=>{
            this.abortOptionsShownUfoExperience();
            this.optionsShownUfoExperienceInstance.start();
        };
        this.fireEvent = (eventCreator, ...args)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) (0, $kK1nI.createAndFireEventInElementsChannel)(eventCreator(this.props, this.state, ...args))(createAnalyticsEvent);
        };
        this.filterOptions = (users, query, propFilterOptions)=>propFilterOptions ? propFilterOptions(users, query) : users;
        this.memoizedFilterOptions = (0, $dOBRD.default)(this.filterOptions);
        this.getUsers = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(async ()=>{
            const { query: query, sessionId: sessionId, closed: closed } = this.state;
            const { baseUrl: baseUrl, childObjectId: childObjectId, containerId: containerId, fieldId: fieldId, includeGroups: includeGroups, includeTeams: includeTeams, includeTeamsUpdates: includeTeamsUpdates, includeUsers: includeUsers, includeNonLicensedUsers: includeNonLicensedUsers, intl: intl, fetchOptions: fetchOptions, maxOptions: maxOptions, objectId: objectId, onEmpty: onEmpty, onError: onError, overrideByline: overrideByline, displayEmailInByline: displayEmailInByline, verifiedTeams: verifiedTeams, orgId: orgId, userbaseId: userbaseId, principalId: principalId, productAttributes: productAttributes, productKey: productKey, restrictTo: restrictTo, searchQueryFilter: searchQueryFilter, siteId: siteId, isTeamSyncedToGroupDirectoryFilter: isTeamSyncedToGroupDirectoryFilter, transformOptions: transformOptions, userResolvers: userResolvers, enableEmailSearch: enableEmailSearch } = this.props;
            const maxNumberOfResults = maxOptions || 100;
            const startTime = window.performance.now();
            // Check if this is an email search
            const isEmail = enableEmailSearch && $537559c2d938befb$var$isEmailQuery(query);
            const recommendationsRequest = {
                baseUrl: baseUrl,
                context: {
                    containerId: containerId,
                    contextType: fieldId,
                    objectId: objectId,
                    principalId: principalId,
                    productKey: productKey,
                    siteId: siteId,
                    organizationId: orgId,
                    userbaseId: userbaseId,
                    childObjectId: childObjectId,
                    sessionId: sessionId,
                    productAttributes: productAttributes
                },
                includeUsers: includeUsers,
                includeGroups: // For email searches, disable groups and teams
                includeGroups,
                includeTeams: includeTeams,
                includeNonLicensedUsers: includeNonLicensedUsers,
                maxNumberOfResults: maxNumberOfResults,
                query: query,
                searchEmail: isEmail,
                ...verifiedTeams === true && {
                    verifiedTeams: true
                },
                /*
        	For email-based searches, we have decided to filter out apps.
        	Also - because the other 2 filters ((NOT not_mentionable:true) AND (account_status:active)) are included
        	when filter is empty, they have been added here to maintain consistency.
        		Further ref: https://developer.atlassian.com/platform/user-recommendations/guides/frequently-asked-questions/#filter-behavior
         */ searchQueryFilter: isEmail && !searchQueryFilter ? '(NOT not_mentionable:true) AND (account_status:active) AND (NOT account_type:app)' : searchQueryFilter,
                ...restrictTo && {
                    restrictTo: restrictTo
                },
                ...isTeamSyncedToGroupDirectoryFilter === true && {
                    isTeamSyncedToGroupDirectoryFilter: true
                }
            };
            try {
                const { query: query } = this.state;
                this.fireEvent((0, $lv0WZ.requestUsersEvent));
                let recommendedUsers;
                if (fetchOptions && (0, $iDrrr.fg)('smart-user-picker-load-options-gate')) recommendedUsers = await fetchOptions(query);
                else {
                    const userRecommendationsPromise = (0, $b9heI.default)(recommendationsRequest, intl);
                    const userResolversPromises = (userResolvers ?? []).map((resolver)=>resolver(query).catch((error)=>{
                            this.fireEvent((0, $hzyrU.failedUserResolversEvent), {
                                resolverName: resolver.name,
                                error: error
                            });
                            return [];
                        }));
                    const [mainRecommendations, ...userResolverResults] = await Promise.all([
                        userRecommendationsPromise,
                        ...userResolversPromises
                    ]);
                    recommendedUsers = [
                        mainRecommendations,
                        ...userResolverResults
                    ].flat();
                }
                if (overrideByline) {
                    for (let option of recommendedUsers)if ((0, $kea9V.isUser)(option) || (0, $1e7zb.isExternalUser)(option) || (0, $9rnjH.isTeam)(option)) option.byline = overrideByline(option);
                }
                if (displayEmailInByline) {
                    for (let option of recommendedUsers)if ((0, $kea9V.isUser)(option) || (0, $1e7zb.isExternalUser)(option)) {
                        if (option.userType === (0, $jItb7.UserEntityType).DEFAULT || option.userType === (0, $jItb7.UserEntityType).CUSTOMER) // Respect existing byline if present
                        {
                            if (option.email && !option.byline) option.byline = option.email;
                        }
                    }
                }
                if (includeTeamsUpdates) {
                    for (let option of recommendedUsers)if ((0, $2wJhI.isGroup)(option) || (0, $9rnjH.isTeam)(option)) option.includeTeamsUpdates = includeTeamsUpdates;
                }
                // Track if email search found matches for conditional allowEmail logic
                if (isEmail) {
                    // Only count user/external user matches, not teams or groups
                    const userMatches = recommendedUsers.filter((user)=>(0, $kea9V.isUser)(user) || (0, $1e7zb.isExternalUser)(user));
                    this.lastEmailSearchFoundMatches = userMatches.length > 0;
                } else this.lastEmailSearchFoundMatches = false;
                // For a partial query with a suggested domain, check whether the email we would
                // synthesize (`<query>@<domain>`) already belongs to one of the returned users. If so,
                // the real user option is shown instead and the email suggestion is suppressed.
                const { suggestEmailsForDomain: suggestEmailsForDomain } = this.props;
                if (suggestEmailsForDomain && !isEmail && query) {
                    const suggestedEmail = `${query}@${suggestEmailsForDomain}`.toLowerCase();
                    this.lastDomainSuggestionMatchedUser = recommendedUsers.some((option)=>((0, $kea9V.isUser)(option) || (0, $1e7zb.isExternalUser)(option)) && option.email?.toLowerCase() === suggestedEmail);
                } else this.lastDomainSuggestionMatchedUser = false;
                const elapsedTimeMilli = window.performance.now() - startTime;
                const transformedOptions = transformOptions ? await transformOptions(recommendedUsers, query) : recommendedUsers;
                const displayedUsers = transformedOptions.length === 0 && onEmpty ? await onEmpty(query) ?? [] : transformedOptions;
                this.setState((state)=>{
                    const applicable = state.query === query;
                    const users = applicable ? displayedUsers : state.users;
                    const loading = !applicable;
                    this.fireEvent((0, $832DI.successfulRequestUsersEvent), {
                        users: $537559c2d938befb$var$getUsersForAnalytics(recommendedUsers),
                        elapsedTimeMilli: elapsedTimeMilli,
                        displayedUsers: $537559c2d938befb$var$getUsersForAnalytics(displayedUsers),
                        productAttributes: productAttributes,
                        applicable: applicable,
                        userResolvers: Array.isArray(userResolvers) ? userResolvers.map((resolver)=>resolver.name) : []
                    });
                    return {
                        users: users,
                        loading: loading
                    };
                });
            } catch (e) {
                if (this.state.query !== query && (0, $iDrrr.fg)('smart-user-picker-fetch-error-fix')) {
                    // The query has moved on since this request was sent, so its results are not the ones
                    // on screen. Applying the failure here would clear the options and fail the UFO
                    // experience that belong to the newer query.
                    this.fireEvent((0, $1aAKX.failedRequestUsersEvent), {
                        elapsedTimeMilli: window.performance.now() - startTime,
                        productAttributes: productAttributes
                    });
                    return;
                }
                const is5xxEvent = $537559c2d938befb$var$checkIf500Event(e.statusCode);
                if (!closed && !onError && is5xxEvent) // If the user lookup fails while the menu is open, and the consumer is not providing a
                // fallback data source via the onError prop, then send UFO failure
                this.optionsShownUfoExperienceInstance.failure($537559c2d938befb$var$ufoEndStateConfig(this.props.fieldId));
                this.setState({
                    users: []
                });
                let onErrorProducedError = false;
                let defaultUsers = [];
                try {
                    defaultUsers = onError ? await onError(e, recommendationsRequest) || [] : [];
                } catch  {
                    onErrorProducedError = true;
                }
                if (onErrorProducedError && is5xxEvent) // Log error from fallback data source `onError` to UFO
                this.optionsShownUfoExperienceInstance.failure($537559c2d938befb$var$ufoEndStateConfig(this.props.fieldId));
                if (!is5xxEvent && (!onError && !closed || onErrorProducedError)) this.abortOptionsShownUfoExperience();
                this.setState({
                    users: defaultUsers,
                    loading: false
                });
                const elapsedTimeMilli = window.performance.now() - startTime;
                this.fireEvent((0, $1aAKX.failedRequestUsersEvent), {
                    elapsedTimeMilli: elapsedTimeMilli,
                    productAttributes: productAttributes
                });
            }
        }, this.props.debounceTime ?? 0);
        this.onInputChange = (newQuery, sessionId)=>{
            const query = newQuery || '';
            const { closed: closed } = this.state;
            if (query === this.state.query) return;
            if (!closed) {
                // If the input has been typed into and the dropdown has not been closed
                // (i.e. input blurred) then start the UFO timer.
                // If there's a previous UFO timer running for the same "options shown" experience,
                // it will be aborted first.
                this.startOptionsShownUfoExperience();
                this.setState({
                    loading: true,
                    query: query,
                    sessionId: sessionId
                });
                if (this.props.onInputChange) this.props.onInputChange(query, sessionId);
            }
        };
        this.filterUsers = ()=>{
            const { loading: loading, users: users, query: query } = this.state;
            const filteredUsers = this.memoizedFilterOptions(users, query, this.props.filterOptions);
            //If bootstrapOptions have been passed in and it is bootstrap
            if (this.props.bootstrapOptions && this.props.bootstrapOptions.length !== 0 && query === '') {
                const bootstrapFilteredUsers = this.memoizedFilterOptions(this.props.bootstrapOptions, query, this.props.filterOptions);
                this.fireEvent((0, $l5d33.filterUsersEvent), {
                    filtered: $537559c2d938befb$var$getUsersForAnalytics(bootstrapFilteredUsers),
                    all: $537559c2d938befb$var$getUsersForAnalytics(this.props.bootstrapOptions)
                });
                return bootstrapFilteredUsers;
            }
            // while when not loading just return already filtered result from server.
            if (!loading) return filteredUsers;
            const queryFilteredUsers = filteredUsers.filter((user)=>$537559c2d938befb$var$stringContains(user.name, query));
            this.fireEvent((0, $l5d33.filterUsersEvent), {
                filtered: $537559c2d938befb$var$getUsersForAnalytics(queryFilteredUsers),
                all: $537559c2d938befb$var$getUsersForAnalytics(users)
            });
            // when loading filter previous result.
            return filteredUsers;
        };
        this.onFocus = (sessionId)=>{
            const state = {
                closed: false
            };
            this.startOptionsShownUfoExperience();
            if (this.state.users.length === 0) {
                state.sessionId = sessionId;
                state.loading = true;
            } else this.fireEvent((0, $9UYr8.preparedUsersLoadedEvent), {
                users: $537559c2d938befb$var$getUsersForAnalytics(this.state.users),
                preparedSessionId: this.state.sessionId,
                sessionId: sessionId
            });
            this.setState((currentState)=>({
                    ...currentState,
                    ...state
                }));
            if (this.props.onFocus) this.props.onFocus(sessionId);
        };
        this.onBlur = (sessionId)=>{
            this.getUsers.cancel();
            this.abortOptionsShownUfoExperience();
            // clear old users if query is populated so that on refocus,
            // the old list is not shown
            const users = this.state.query.length === 0 ? this.state.users : [];
            this.setState({
                loading: false,
                closed: true,
                users: users
            });
            if (this.props.onBlur) this.props.onBlur(sessionId);
        };
        this.optionsShownUfoExperienceInstance = (0, $7GkXv.smartUserPickerOptionsShownUfoExperience).getInstance(props.inputId || props.fieldId);
    }
}
// TODO: Smart User picker team will have to add a type annotation here
$537559c2d938befb$export$9b9bd453d1d4e4ce.defaultProps = {
    baseUrl: '',
    includeUsers: true,
    includeGroups: false,
    includeTeams: false,
    includeTeamsUpdates: false,
    includeNonLicensedUsers: false,
    displayEmailInByline: false,
    prefetch: false,
    principalId: 'Context',
    debounceTime: $537559c2d938befb$var$DEFAULT_DEBOUNCE_TIME_MS,
    userResolvers: [],
    enableEmailSearch: false,
    allowEmailSelectionWhenEmailMatched: true,
    verifiedTeams: false
};
const $537559c2d938befb$export$9eedb6e5d313efdb = (0, $lzgC6.default)()((0, $kSwu1.injectIntl)($537559c2d938befb$export$9b9bd453d1d4e4ce));
module.exports["SmartUserPicker"] = $537559c2d938befb$export$9eedb6e5d313efdb;

});

parcelRegister("kK1nI", function(module, exports) {

var $2iGHk = parcelRequire("2iGHk");

const $7fe07237a7d94e47$export$53eef0dcd9611650 = (0, $2iGHk.default)('fabric-elements');
module.exports["createAndFireEventInElementsChannel"] = $7fe07237a7d94e47$export$53eef0dcd9611650;

});

parcelRegister("1aAKX", function(module, exports) {

var $l3Jh7 = parcelRequire("l3Jh7");


var $H5Nas = parcelRequire("H5Nas");

const $5f0ef68b0178bc3d$export$738aca68b593db8e = (props, state, attributes = {})=>(0, $H5Nas.createSmartUserPickerEvent)('failed', 'usersRequest', {
        ...(0, $l3Jh7.createDefaultSmartPickerAttributes)(props, state),
        ...attributes
    });
module.exports["failedRequestUsersEvent"] = $5f0ef68b0178bc3d$export$738aca68b593db8e;

});

parcelRegister("l3Jh7", function(module, exports) {
const $010bedbbaebc0e35$export$b5ccf8b5dad08e8 = (props, state)=>{
    const { fieldId: fieldId, objectId: objectId, containerId: containerId, childObjectId: childObjectId, prefetch: prefetch, maxOptions: maxOptions, includeTeams: includeTeams, productKey: productKey, principalId: principalId, siteId: siteId, orgId: orgId, filterOptions: filterOptions } = props;
    const { sessionId: sessionId, query: query } = state;
    const maxNumberOfResults = maxOptions || 100;
    return {
        context: fieldId,
        childObjectId: childObjectId,
        containerId: containerId,
        hasFilterOptions: Boolean(filterOptions),
        includeTeams: includeTeams,
        maxNumberOfResults: maxNumberOfResults,
        objectId: objectId,
        prefetch: prefetch,
        principalId: principalId,
        productKey: productKey,
        queryLength: (query || '').length,
        siteId: siteId,
        orgId: orgId,
        sessionId: sessionId
    };
};
module.exports["createDefaultSmartPickerAttributes"] = $010bedbbaebc0e35$export$b5ccf8b5dad08e8;

});

parcelRegister("H5Nas", function(module, exports) {

var $detDO = parcelRequire("detDO");

const $9015a7904e344c52$export$1cb1add171d4906b = (action, actionSubect, attributes = {})=>({
        source: 'smart-user-picker',
        ...(0, $detDO.createEvent)('operational', action, actionSubect, attributes)
    });
module.exports["createSmartUserPickerEvent"] = $9015a7904e344c52$export$1cb1add171d4906b;

});

parcelRegister("detDO", function(module, exports) {

var $6RZvH = parcelRequire("6RZvH");


var $bgf7M = parcelRequire("bgf7M");

const $8433a68f5383ad39$export$c30017717ce2168e = (eventType, action, actionSubject, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        attributes: {
            packageName: $6RZvH.packageName,
            packageVersion: $bgf7M.packageVersion,
            ...attributes
        }
    });
module.exports["createEvent"] = $8433a68f5383ad39$export$c30017717ce2168e;

});

parcelRegister("6RZvH", function(module, exports) {
const $8b807dbe03c5f3e5$export$9345d7360ffe0722 = "platform-pkg";
module.exports["packageName"] = $8b807dbe03c5f3e5$export$9345d7360ffe0722;

});

parcelRegister("bgf7M", function(module, exports) {
const $1dd390faa896d611$export$91546b032799aa40 = "0.0.0-use.local";
module.exports["packageVersion"] = $1dd390faa896d611$export$91546b032799aa40;

});

parcelRegister("hzyrU", function(module, exports) {

var $l3Jh7 = parcelRequire("l3Jh7");


var $H5Nas = parcelRequire("H5Nas");

const $4d7e724e1f141428$export$b9358131e14a4b0b = (props, state, attributes = {})=>(0, $H5Nas.createSmartUserPickerEvent)('failed', 'userResolversRequest', {
        ...(0, $l3Jh7.createDefaultSmartPickerAttributes)(props, state),
        ...attributes
    });
module.exports["failedUserResolversEvent"] = $4d7e724e1f141428$export$b9358131e14a4b0b;

});

parcelRegister("l5d33", function(module, exports) {

var $l3Jh7 = parcelRequire("l3Jh7");


var $H5Nas = parcelRequire("H5Nas");

const $2bfcf081534e54dd$export$fbba77127d7cb173 = (props, state, attributes = {})=>(0, $H5Nas.createSmartUserPickerEvent)('filtered', 'users', {
        ...(0, $l3Jh7.createDefaultSmartPickerAttributes)(props, state),
        ...attributes
    });
module.exports["filterUsersEvent"] = $2bfcf081534e54dd$export$fbba77127d7cb173;

});

parcelRegister("gyQlE", function(module, exports) {

var $l3Jh7 = parcelRequire("l3Jh7");


var $H5Nas = parcelRequire("H5Nas");

const $a404165ee4d562e9$export$9cfb4251e50d7b91 = (props, state, attributes = {})=>(0, $H5Nas.createSmartUserPickerEvent)('mounted', 'prefetch', {
        ...(0, $l3Jh7.createDefaultSmartPickerAttributes)(props, state),
        ...attributes
    });
module.exports["mountedWithPrefetchEvent"] = $a404165ee4d562e9$export$9cfb4251e50d7b91;

});

parcelRegister("9UYr8", function(module, exports) {

var $l3Jh7 = parcelRequire("l3Jh7");


var $H5Nas = parcelRequire("H5Nas");

const $c5a5cd1ae83fab66$export$185f4c3d9b7ef9bf = (props, state, attributes = {})=>(0, $H5Nas.createSmartUserPickerEvent)('loaded', 'preparedUsers', {
        ...(0, $l3Jh7.createDefaultSmartPickerAttributes)(props, state),
        ...attributes
    });
module.exports["preparedUsersLoadedEvent"] = $c5a5cd1ae83fab66$export$185f4c3d9b7ef9bf;

});

parcelRegister("lv0WZ", function(module, exports) {

var $l3Jh7 = parcelRequire("l3Jh7");


var $H5Nas = parcelRequire("H5Nas");

const $6b12d2f43e054def$export$1762ed8845ff2d9b = (props, state, attributes = {})=>(0, $H5Nas.createSmartUserPickerEvent)('requested', 'users', {
        ...(0, $l3Jh7.createDefaultSmartPickerAttributes)(props, state),
        ...attributes
    });
module.exports["requestUsersEvent"] = $6b12d2f43e054def$export$1762ed8845ff2d9b;

});

parcelRegister("832DI", function(module, exports) {

var $l3Jh7 = parcelRequire("l3Jh7");


var $H5Nas = parcelRequire("H5Nas");

const $714bf89759330c21$export$bfc020018aa738d0 = (props, state, attributes = {})=>(0, $H5Nas.createSmartUserPickerEvent)('successful', 'usersRequest', {
        ...(0, $l3Jh7.createDefaultSmartPickerAttributes)(props, state),
        ...attributes
    });
module.exports["successfulRequestUsersEvent"] = $714bf89759330c21$export$bfc020018aa738d0;

});

parcelRegister("uUDXo", function(module, exports) {

var $9kYT2 = parcelRequire("9kYT2");


var $gh5tj = parcelRequire("gh5tj");


var $2Pcx3 = parcelRequire("2Pcx3");


var $7okd1 = parcelRequire("7okd1");


var $532Sr = parcelRequire("532Sr");

const $e67531141dda4e4c$var$getHydratedUsersFromProducts = (request)=>{
    const url = `${(0, $gh5tj.config).getUsersServiceUrl(request.productKey, request.baseUrl)}`;
    let params = new URLSearchParams();
    request.accountIds.map((id)=>params.append('accountId', id));
    params.append('maxResults', '2000');
    return fetch(`${url}?${params}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        }
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling users service, statusCode=${response.status}, statusText=${response.statusText}`
        });
    }).then(request.productKey === 'jira' ? $e67531141dda4e4c$var$transformJiraUsers : $e67531141dda4e4c$var$transformConfluenceUsers);
};
const $e67531141dda4e4c$var$transformJiraUsers = (userResponse)=>userResponse.values.map($e67531141dda4e4c$var$transformJiraUser).filter((user)=>!!user).map((user)=>user);
const $e67531141dda4e4c$var$transformJiraUser = (item)=>{
    if (!item) return null;
    return {
        id: item.accountId,
        type: (0, $9kYT2.UserType),
        avatarUrl: item.avatarUrls ? item.avatarUrls['16x16'] : '',
        name: item.displayName,
        email: item.emailAddress
    };
};
const $e67531141dda4e4c$var$transformConfluenceUsers = (userResponse)=>userResponse.results.map($e67531141dda4e4c$var$transformConfluenceUser).filter((user)=>!!user).map((user)=>user);
const $e67531141dda4e4c$var$transformConfluenceUser = (item)=>{
    if (!item) return null;
    return {
        id: item.accountId,
        type: (0, $9kYT2.UserType),
        avatarUrl: item.profilePicture ? item.profilePicture.path : '',
        name: item.publicName,
        email: item.email
    };
};
const $e67531141dda4e4c$var$sortResults = (options, sortIds)=>{
    const resultsMap = new Map(options.map((option)=>[
            option && option.id,
            option
        ]));
    return sortIds.map((option)=>{
        const user = resultsMap.get(option.id);
        if (user) return user;
        return {
            id: option.id,
            type: option.type,
            name: (0, $532Sr.UNKNOWN)
        };
    });
};
const $e67531141dda4e4c$var$isOptionData = (option)=>{
    return option.name !== undefined;
};
const $e67531141dda4e4c$var$hydrateTeamIds = async (baseUrl, values, siteId)=>{
    if (values.length === 0) return [];
    const legionPromises = values.map((value)=>(0, $7okd1.default)({
            baseUrl: baseUrl,
            id: value.id,
            siteId: siteId
        }));
    return await Promise.all(legionPromises);
};
const $e67531141dda4e4c$var$hydrateAccountIds = async (baseUrl, productKey, values, atlAttributes)=>{
    if (values.length === 0) return [];
    const accountIds = values.map((val)=>val.id);
    //if we are not jira or confluence then use PRS platform hydration
    return productKey === 'jira' || productKey === 'confluence' ? await $e67531141dda4e4c$var$getHydratedUsersFromProducts({
        baseUrl: baseUrl,
        productKey: productKey,
        accountIds: accountIds
    }) : await (0, $2Pcx3.default)(baseUrl, accountIds, {
        product: productKey,
        ...atlAttributes
    });
};
async function $e67531141dda4e4c$var$hydrateDefaultValues(baseUrl, value, productKey, siteId, atlAttributes) {
    //return if no value
    if (!value || Array.isArray(value) && value.length === 0) return [];
    const values = Array.isArray(value) ? value : [
        value
    ];
    // return if all hydrated
    if (!values.some((val)=>!$e67531141dda4e4c$var$isOptionData(val))) return value;
    const [hydratedUsers, hydratedTeams] = await Promise.all([
        $e67531141dda4e4c$var$hydrateAccountIds(baseUrl, productKey, values.filter((val)=>!$e67531141dda4e4c$var$isOptionData(val) && val.type === 'user'), atlAttributes),
        $e67531141dda4e4c$var$hydrateTeamIds(baseUrl, values.filter((val)=>!$e67531141dda4e4c$var$isOptionData(val) && val.type === 'team'), siteId)
    ]);
    const hydratedOptions = values.filter((val)=>$e67531141dda4e4c$var$isOptionData(val)).map((val)=>val).concat(hydratedUsers).concat(hydratedTeams);
    return $e67531141dda4e4c$var$sortResults(hydratedOptions, values);
}
var $e67531141dda4e4c$export$2e2bcd8739ae039 = $e67531141dda4e4c$var$hydrateDefaultValues;
module.exports["default"] = $e67531141dda4e4c$export$2e2bcd8739ae039;

});

parcelRegister("2Pcx3", function(module, exports) {

var $gh5tj = parcelRequire("gh5tj");


var $532Sr = parcelRequire("532Sr");


var $h2zzp = parcelRequire("h2zzp");

/**
 * @param  {string} accountIds ids to hydrate
 * @return GraphQL Query
 */ const $dd0e88f689d12292$var$buildUsersQuery = (accountIds)=>({
        query: `query usersQuery($accountIds: [ID!]!) {
    users(accountIds: $accountIds) {
      name
      accountId
      picture
    }
  }`,
        variables: {
            accountIds: accountIds
        }
    });
const $dd0e88f689d12292$var$makeRequest = async (url, accountIds, attributionData)=>{
    const query = $dd0e88f689d12292$var$buildUsersQuery(accountIds);
    return await (0, $h2zzp.graphqlQuery)(url, query, attributionData);
};
const $dd0e88f689d12292$var$modifyResponse = (users)=>users.map(({ accountId: accountId, name: name, picture: picture })=>({
            avatarUrl: picture,
            id: accountId,
            name: name,
            type: 'user'
        }));
const $dd0e88f689d12292$var$getHydratedUsers = (baseUrl, userIds, attributionData)=>{
    const url = (0, $gh5tj.config).getGraphQLUrl(baseUrl);
    return new Promise((resolve)=>{
        $dd0e88f689d12292$var$makeRequest(url, userIds, attributionData).then((data)=>{
            resolve($dd0e88f689d12292$var$modifyResponse(data.users));
        }).catch(()=>{
            // on network error, return original list with label 'Unknown'
            resolve(userIds.map((id)=>({
                    ...(0, $532Sr.UNKNOWN_USER),
                    id: id
                })));
        });
    });
};
var $dd0e88f689d12292$export$2e2bcd8739ae039 = $dd0e88f689d12292$var$getHydratedUsers;
module.exports["default"] = $dd0e88f689d12292$export$2e2bcd8739ae039;

});

parcelRegister("532Sr", function(module, exports) {
const $6db3863417a51977$export$78244dbb77cfa6b6 = 'Unknown';
const $6db3863417a51977$export$d1f5101c0939e3fe = {
    id: $6db3863417a51977$export$78244dbb77cfa6b6,
    name: $6db3863417a51977$export$78244dbb77cfa6b6,
    type: 'user'
};
const $6db3863417a51977$export$8144dcfc9025ca57 = {
    id: $6db3863417a51977$export$78244dbb77cfa6b6,
    name: $6db3863417a51977$export$78244dbb77cfa6b6,
    type: 'team'
};
module.exports["UNKNOWN"] = $6db3863417a51977$export$78244dbb77cfa6b6;
module.exports["UNKNOWN_USER"] = $6db3863417a51977$export$d1f5101c0939e3fe;
module.exports["UNKNOWN_TEAM"] = $6db3863417a51977$export$8144dcfc9025ca57;

});

parcelRegister("h2zzp", function(module, exports) {

var $bI2Ez = parcelRequire("bI2Ez");

const $cb73305b812b5ba3$var$buildHeaders = (attributionData)=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    const atlAttributionHeader = (0, $bI2Ez.createAtlAttributionHeader)(attributionData);
    headers.append('atl-attribution', atlAttributionHeader['atl-attribution']);
    return headers;
};
function $cb73305b812b5ba3$export$74eb8d79ae3e02b5(serviceUrl, query, attributionData) {
    const headers = $cb73305b812b5ba3$var$buildHeaders(attributionData);
    return fetch(new Request(`${serviceUrl}`, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    })).then((response)=>{
        if (!response.ok) return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
        return response;
    }).then((response)=>response.json()).then((json)=>{
        if (json.errors) return Promise.reject({
            reason: json.errors[0]?.category || 'default'
        });
        return json.data;
    });
}
module.exports["graphqlQuery"] = $cb73305b812b5ba3$export$74eb8d79ae3e02b5;

});

parcelRegister("bI2Ez", function(module, exports) {
/**
 * Utility for creating the atl-attribution header for AGG requests
 * Reference: https://hello.atlassian.net/wiki/spaces/AGG/pages/5954141702/Metrics+Attribution+Onboarding+Doc+for+AGG+Clients
 */ function $de0a2e7a5a86c4fd$export$14ef296862e3705e({ product: product = 'platform', activationId: activationId, ...props } = {}) {
    const headerData = {
        service: 'smart-experiences/smart-user-picker',
        product: product,
        atlWorkspaceId: activationId && props.tenantId ? `ari:cloud:${product}:${props.tenantId}:workspace/${activationId}` : undefined,
        ...props
    };
    return {
        'atl-attribution': JSON.stringify(headerData)
    };
}
module.exports["createAtlAttributionHeader"] = $de0a2e7a5a86c4fd$export$14ef296862e3705e;

});

parcelRegister("7okd1", function(module, exports) {

var $gh5tj = parcelRequire("gh5tj");


var $532Sr = parcelRequire("532Sr");

const $b51f40c08b009007$var$transformTeam = (team, id)=>{
    return {
        id: id,
        name: team.displayName,
        type: 'team',
        avatarUrl: team.smallAvatarImageUrl,
        ...team.state && {
            state: team.state
        }
    };
};
const $b51f40c08b009007$var$hydrateTeamFromLegion = (request)=>{
    const url = (0, $gh5tj.config).getTeamsUrl(request.id, request.baseUrl, request.siteId);
    return fetch(url, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        }
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling Legion, statusCode=${response.status}, statusText=${response.statusText}`
        });
    }).then((response)=>{
        return $b51f40c08b009007$var$transformTeam(response, request.id);
    }).catch(()=>({
            ...(0, $532Sr.UNKNOWN_TEAM),
            id: request.id
        }));
};
var $b51f40c08b009007$export$2e2bcd8739ae039 = $b51f40c08b009007$var$hydrateTeamFromLegion;
module.exports["default"] = $b51f40c08b009007$export$2e2bcd8739ae039;

});

parcelRegister("fa8WQ", function(module, exports) {

var $gtQgC = parcelRequire("gtQgC");


var $2J4Io = parcelRequire("2J4Io");

const $7a5b39f110eb7e66$var$STUDIO_PROD_URL = 'https://studio.atlassian.com';
const $7a5b39f110eb7e66$var$STUDIO_STAGING_URL = 'https://atlassian-studio.stg-east.frontend.public.atl-paas.net';
const $7a5b39f110eb7e66$export$72eb188ed9591973 = ()=>{
    return (0, $2J4Io.isStaging)() ? $7a5b39f110eb7e66$var$STUDIO_STAGING_URL : $7a5b39f110eb7e66$var$STUDIO_PROD_URL;
};
const $7a5b39f110eb7e66$var$getStudioEnv = ()=>(0, $2J4Io.isStaging)() ? 'staging' : 'production';
const $7a5b39f110eb7e66$export$372c8de5c124bdc8 = (path, email)=>{
    if (email) return (0, $gtQgC.getStudioSessionSyncUrl)($7a5b39f110eb7e66$var$getStudioEnv(), path, email);
    return `${$7a5b39f110eb7e66$export$72eb188ed9591973()}${path}`;
};
const $7a5b39f110eb7e66$var$buildStudioAutomationRuleEditUrl = (workspaceId, spaceId, ruleIdUuid)=>{
    const base = `/w/${workspaceId}/spaces/${spaceId}/automation#`;
    return `${base}/rule/${encodeURIComponent(ruleIdUuid)}`;
};
const $7a5b39f110eb7e66$export$bb5c2ff2ee505e4a = (siteId, navigationSource, csid, email, starterText)=>{
    const searchParams = new URLSearchParams();
    if (navigationSource) searchParams.set('navigationSource', navigationSource);
    if (csid) searchParams.set('csid', csid);
    if (starterText) searchParams.set('starterText', starterText);
    return $7a5b39f110eb7e66$export$372c8de5c124bdc8(`/s/${siteId}/agents/create/chat${searchParams.size > 0 ? `?${searchParams}` : ''}`, email);
};
const $7a5b39f110eb7e66$export$fe475324c26e3007 = (siteId, email)=>{
    return $7a5b39f110eb7e66$export$372c8de5c124bdc8(`/s/${siteId}/agents/create/overview`, email);
};
const $7a5b39f110eb7e66$export$ef221a159d6fa3e8 = (siteId, agentId, email)=>$7a5b39f110eb7e66$export$372c8de5c124bdc8(`/s/${siteId}/agents/enrich/rovo/agents/${agentId}`, email);
const $7a5b39f110eb7e66$export$a20abb994c34f0a4 = (siteId, agentId, navigationSource, email)=>{
    const redirectParam = `redirect=${encodeURIComponent('/:agentId/overview')}`;
    const sourceParam = navigationSource ? `&navigationSource=${encodeURIComponent(navigationSource)}` : '';
    return $7a5b39f110eb7e66$export$372c8de5c124bdc8(`/s/${siteId}/agents/enrich/rovo/agents/${agentId}?${redirectParam}${sourceParam}`, email);
};
const $7a5b39f110eb7e66$export$3da6a4b7798ba40b = (siteId, agentAri, navigationSource, email)=>{
    const sourceParam = navigationSource ? `?navigationSource=${encodeURIComponent(navigationSource)}` : '';
    return $7a5b39f110eb7e66$export$372c8de5c124bdc8(`/s/${siteId}/agents/${encodeURIComponent(agentAri)}/details${sourceParam}`, email);
};
const $7a5b39f110eb7e66$export$36c11ab884b7b2cb = (siteId, agentId, navigationSource, email)=>{
    const redirectParam = `redirect=${encodeURIComponent('/create')}`;
    const sourceParam = navigationSource ? `&navigationSource=${encodeURIComponent(navigationSource)}` : '';
    return $7a5b39f110eb7e66$export$372c8de5c124bdc8(`/s/${siteId}/agents/enrich/rovo/agents/${agentId}?${redirectParam}${sourceParam}`, email);
};
const $7a5b39f110eb7e66$export$c2d162390af7b91d = (siteId, agentAri, navigationSource, email)=>{
    const searchParams = new URLSearchParams();
    if (navigationSource) searchParams.set('navigationSource', encodeURIComponent(navigationSource));
    const query = searchParams.size > 0 ? `?${searchParams}` : '';
    return $7a5b39f110eb7e66$export$372c8de5c124bdc8(`/s/${siteId}/agents/${encodeURIComponent(agentAri)}/permissions${query}`, email);
};
const $7a5b39f110eb7e66$export$bae72ef7f23dbede = (workspaceId, spaceId, ruleIdUuid, email)=>$7a5b39f110eb7e66$export$372c8de5c124bdc8($7a5b39f110eb7e66$var$buildStudioAutomationRuleEditUrl(workspaceId, spaceId, ruleIdUuid), email);
module.exports["getStudioPath"] = $7a5b39f110eb7e66$export$372c8de5c124bdc8;
module.exports["getAtlassianStudioNLCreateUrl"] = $7a5b39f110eb7e66$export$bb5c2ff2ee505e4a;
module.exports["getAtlassianStudioAgentEditUrl"] = $7a5b39f110eb7e66$export$a20abb994c34f0a4;
module.exports["getAtlassianStudioAgentEditUrlWithAri"] = $7a5b39f110eb7e66$export$3da6a4b7798ba40b;
module.exports["getAtlassianStudioAgentDuplicateUrl"] = $7a5b39f110eb7e66$export$36c11ab884b7b2cb;
module.exports["getAtlassianStudioAutomationRuleEditUrl"] = $7a5b39f110eb7e66$export$bae72ef7f23dbede;

});

parcelRegister("6e6HL", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $1HhPq = parcelRequire("1HhPq");

const $788ef638343efbc9$export$d109ab46c9575565 = ()=>({
        type: 'doc',
        version: 1,
        content: []
    });
module.exports["getEmptyADF"] = $788ef638343efbc9$export$d109ab46c9575565;

});

parcelRegister("3sXr4", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

const $f685837601709ec0$var$GRADIENT_ANGLE_VARIABLE = '--gradient-angle';
const $f685837601709ec0$var$BORDER_ORANGE = "var(--ds-rovo-border-saffron, #FCA700)";
const $f685837601709ec0$var$BORDER_GREEN = "var(--ds-rovo-border-lime, #6A9A23)";
const $f685837601709ec0$var$BORDER_BLUE = "var(--ds-rovo-border-blue, #1868DB)";
const $f685837601709ec0$var$BORDER_PURPLE = "var(--ds-rovo-border-purple, #AF59E1)"; /**
                                                                * Because the aspect ratio of the actual thinking bars is very wide,
                                                                * the gradient will stretch out at each corner which would make the
                                                                * rovo colours very disproportionate.
                                                                *
                                                                * To workaround this we use a dynamic angle amplitude to narrow the angles as we approach
                                                                * 90 and 180 degrees, and we have a general aspect ratio of the expected design as
                                                                * it's not worth calculating the width and height of the actual components.
                                                                *
                                                                * Approximating the minimum edge span as inversely proportional to the expected
                                                                * wrapper aspect ratio.
                                                                *
                                                                * 360 / 48 is the approximated aspect ratio.
                                                                */ 
const $f685837601709ec0$var$DEFAULT_SIDE_ANGLE_SPAN = `2 * atan(1 / (360 / 48))`; /**
                                                             * Squared cosine produces a symmetric 0..1 signal based on rotation angle:
                                                             * 0 at top/bottom, 1 at left/right, which tells us how close the highlight is
                                                             * to the side edges.
                                                             */ 
const $f685837601709ec0$var$DEFAULT_SIDE_WEIGHT = `calc(cos(var(${$f685837601709ec0$var$GRADIENT_ANGLE_VARIABLE}, 39deg)) * cos(var(${$f685837601709ec0$var$GRADIENT_ANGLE_VARIABLE}, 39deg)))`; /**
                                                                                                                                * Interpolates the highlight span between the minimum side-edge span and a
                                                                                                                                * wider 90deg span, with amplitude scaling and side weighting for earlier/
                                                                                                                                * longer narrowing near the left and right edges.
                                                                                                                                */ 
const $f685837601709ec0$var$DEFAULT_HIGHLIGHT_SPAN = `calc(${$f685837601709ec0$var$DEFAULT_SIDE_ANGLE_SPAN} + ((90deg - ${$f685837601709ec0$var$DEFAULT_SIDE_ANGLE_SPAN})  * ${$f685837601709ec0$var$DEFAULT_SIDE_WEIGHT}))`; // Conic gradient that drives both the visible border and blurred glow.
const $f685837601709ec0$var$ROVO_MOSAIC_GRADIENT_BACKGROUND = `conic-gradient(
	from calc(var(${$f685837601709ec0$var$GRADIENT_ANGLE_VARIABLE}, 39deg) - (${$f685837601709ec0$var$DEFAULT_HIGHLIGHT_SPAN} / 2)) at 50% 50%,
	${$f685837601709ec0$var$BORDER_ORANGE} 0deg ${$f685837601709ec0$var$DEFAULT_HIGHLIGHT_SPAN},
	${$f685837601709ec0$var$BORDER_GREEN} ${$f685837601709ec0$var$DEFAULT_HIGHLIGHT_SPAN} 180deg,
	${$f685837601709ec0$var$BORDER_BLUE} 180deg calc(180deg + ${$f685837601709ec0$var$DEFAULT_HIGHLIGHT_SPAN}),
	${$f685837601709ec0$var$BORDER_PURPLE} calc(180deg + ${$f685837601709ec0$var$DEFAULT_HIGHLIGHT_SPAN}) 360deg
)`; // Rotate the custom angle property so the highlight continuously sweeps around the border.
const $f685837601709ec0$var$gradientRotation = null; // @property is required so the browser knows --gradient-angle is an interpolatable
// <angle> — without it, keyframe animation of a custom property has no effect.
const $f685837601709ec0$var$gradientAngleProperty = null;
const $f685837601709ec0$var$BLUR_SIZE = 32;
const $f685837601709ec0$var$BORDER_WIDTH = 1; // Outer position context for the decorative glow and border layers.
const $f685837601709ec0$var$wrapperBaseStyle = null; // Thinking shell uses pseudo-elements for the blurred glow and rotating gradient border.
const $f685837601709ec0$var$thinkingWrapperStyle = null;
const $f685837601709ec0$var$plainBorderStyle = null; // Shared layout/padding base for the actual content area so children can stay mounted
// while the surrounding thinking chrome changes.
const $f685837601709ec0$var$contentBaseStyle = null;
const $f685837601709ec0$export$f2f0a5c9bccb33b1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { children: children, isThinking: isThinking } = t0;
    const t1 = isThinking ? "rovo-thinking-bar-wrapper__thinking" : "rovo-thinking-bar-wrapper__idle";
    const t2 = isThinking && "";
    const t3 = isThinking && "";
    const t4 = isThinking && "";
    const t5 = isThinking && "_0bjKvDyzSk _4c065UHZdu _2Y7lL4HZdu _1mT5xdRAKS _39xV02N91d _2YgrGrP0S5 _1OimfudRhP _4eDJc6P4qp _2OUbymKNkB _3Ku51Iogpp _3dCYwDWVPG _3ScelFGJbM _1lBcDcGJbM _35I30Bey7F _1L3m71ey7F _3fRV4CV6HZ _0UsFEzYbGa _3qT6l0vQQr _0EnhYgdnbC _2Gfj6idRhP _2OWEWsP4qp _0h8XtNKNkB _0GBAIrogpp _2WYcYGWVPG _2tbAUcYbGa _39mJBjvQQr _32JO6cYbGa _2AwNtJYbGa";
    const t6 = !isThinking && "_0bjKvDyzSk _4bt5LAnQyn _2WAcuGnQyn _4c065UHZdu _2Y7lL4HZdu _39xV02N91d _0KLXruoI2d _2OUyjtGk8v";
    let t7;
    if ($[0] !== t2 || $[1] !== t3 || $[2] !== t4 || $[3] !== t5 || $[4] !== t6) {
        t7 = (0, $hekY6.default)([
            "_0bjKvDyzSk _1mT5xdRAKS _39xV02N91d",
            t2,
            t3,
            t4,
            t5,
            t6
        ]);
        $[0] = t2;
        $[1] = t3;
        $[2] = t4;
        $[3] = t5;
        $[4] = t6;
        $[5] = t7;
    } else t7 = $[5];
    let t8;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = (0, $hekY6.default)([
            "_0bjKvDyzSk _2Y7lL42ADO _4c065U2ADO _39xV02N91d _1mT5xdRAKS _42Yu6BdnbC _0KLXruoI2d _24h04i2Njc"
        ]);
        $[6] = t8;
    } else t8 = $[6];
    let t9;
    if ($[7] !== children) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t8
        }, children);
        $[7] = children;
        $[8] = t9;
    } else t9 = $[8];
    let t10;
    if ($[9] !== t1 || $[10] !== t7 || $[11] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": t1,
            className: t7
        }, t9);
        $[9] = t1;
        $[10] = t7;
        $[11] = t9;
        $[12] = t10;
    } else t10 = $[12];
    return t10;
} : ({ children: children, isThinking: isThinking })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": isThinking ? 'rovo-thinking-bar-wrapper__thinking' : 'rovo-thinking-bar-wrapper__idle',
        className: (0, $hekY6.default)([
            "_0bjKvDyzSk _1mT5xdRAKS _39xV02N91d",
            isThinking && "",
            isThinking && "",
            isThinking && "",
            isThinking && "_0bjKvDyzSk _4c065UHZdu _2Y7lL4HZdu _1mT5xdRAKS _39xV02N91d _2YgrGrP0S5 _1OimfudRhP _4eDJc6P4qp _2OUbymKNkB _3Ku51Iogpp _3dCYwDWVPG _3ScelFGJbM _1lBcDcGJbM _35I30Bey7F _1L3m71ey7F _3fRV4CV6HZ _0UsFEzYbGa _3qT6l0vQQr _0EnhYgdnbC _2Gfj6idRhP _2OWEWsP4qp _0h8XtNKNkB _0GBAIrogpp _2WYcYGWVPG _2tbAUcYbGa _39mJBjvQQr _32JO6cYbGa _2AwNtJYbGa",
            !isThinking && "_0bjKvDyzSk _4bt5LAnQyn _2WAcuGnQyn _4c065UHZdu _2Y7lL4HZdu _39xV02N91d _0KLXruoI2d _2OUyjtGk8v"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_0bjKvDyzSk _2Y7lL42ADO _4c065U2ADO _39xV02N91d _1mT5xdRAKS _42Yu6BdnbC _0KLXruoI2d _24h04i2Njc"
        ])
    }, children));
};
module.exports["RovoThinkingBarWrapper"] = $f685837601709ec0$export$f2f0a5c9bccb33b1;

});

parcelRegister("ft2zO", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $1sCHt = parcelRequire("1sCHt");


var $iZMIZ = parcelRequire("iZMIZ");


var $eh6Ml = parcelRequire("eh6Ml");


var $l3wuH = parcelRequire("l3wuH");


var $iDrrr = parcelRequire("iDrrr");


var $4aRua = parcelRequire("4aRua");


var $02Wb7 = parcelRequire("02Wb7");

const $2fbceb2d84c4630f$var$styles = {
    wrapper: "_24h04i2Njc _1mT5xdRAKS _3iDTPbQ4SZ _0hPCNLDIqT",
    updatedWrapper: "_17lj8pNHnM",
    iconContainer: "_39xV02oWWg _0jFU0VoWWg _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    content: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _3iDTPbQ4SZ _0hPCNLDIqT _17lj8p2ADO",
    buttonGroup: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT"
};
const $2fbceb2d84c4630f$export$64b2d10bbc0b6fdd = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RovoThinkingReady(t0) {
    const $ = (0, $bDgLe.c)(20);
    const { onView: onView, onClose: onClose, readyText: readyText, showCheckIcon: t1 } = t0;
    const showCheckIcon = t1 === undefined ? true : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            $2fbceb2d84c4630f$var$styles.wrapper,
            (0, $iDrrr.fg)("rovo_ready_bar_ui_update") && $2fbceb2d84c4630f$var$styles.updatedWrapper
        ]);
        t3 = (0, $hekY6.default)([
            $2fbceb2d84c4630f$var$styles.content
        ]);
        $[0] = t2;
        $[1] = t3;
    } else {
        t2 = $[0];
        t3 = $[1];
    }
    let t4;
    if ($[2] !== showCheckIcon) {
        t4 = (0, $iDrrr.fg)("rovo_ready_bar_ui_update") ? showCheckIcon && /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $2fbceb2d84c4630f$var$styles.iconContainer
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
            label: "",
            size: "medium",
            color: "var(--ds-icon-success, #6A9A23)",
            testId: "thinking-ready-check-icon"
        })) : /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $2fbceb2d84c4630f$var$styles.iconContainer
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($iZMIZ))), {
            label: "",
            color: "var(--ds-icon-success, #6A9A23)",
            testId: "thinking-ready-check-circle-icon"
        }));
        $[2] = showCheckIcon;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== formatMessage || $[5] !== readyText) {
        t5 = readyText ?? formatMessage((0, $02Wb7.default).thinkingReadyMessage);
        $[4] = formatMessage;
        $[5] = readyText;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, t5);
        $[7] = t5;
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    if ($[9] !== t4 || $[10] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t3
        }, t4, t6);
        $[9] = t4;
        $[10] = t6;
        $[11] = t7;
    } else t7 = $[11];
    let t8;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = (0, $hekY6.default)([
            $2fbceb2d84c4630f$var$styles.buttonGroup
        ]);
        $[12] = t8;
    } else t8 = $[12];
    let t9;
    if ($[13] !== formatMessage || $[14] !== onClose || $[15] !== onView) {
        t9 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t8
        }, (0, $iDrrr.fg)("rovo_ready_bar_ui_update") ? /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, onView && /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            spacing: "default",
            onClick: onClose,
            testId: "thinking-ready-close-button"
        }, formatMessage((0, $02Wb7.default).thinkingClose)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: onView,
            testId: "thinking-ready-view-button"
        }, formatMessage((0, $02Wb7.default).thinkingReadyView))), !onView && /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            appearance: "subtle",
            spacing: (0, $iDrrr.fg)("rovo_ready_bar_fix_height") ? "default" : "compact",
            onClick: onClose,
            testId: "thinking-ready-close-button",
            label: formatMessage((0, $02Wb7.default).thinkingClose),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH)))
        })) : /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, onView && /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: onView,
            testId: "thinking-ready-view-button"
        }, formatMessage((0, $02Wb7.default).thinkingReadyView)), /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            appearance: "subtle",
            spacing: !!onView || !(0, $iDrrr.fg)("rovo_ready_bar_fix_height") ? "compact" : "default",
            onClick: onClose,
            testId: "thinking-ready-close-button",
            label: formatMessage((0, $02Wb7.default).thinkingClose),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH)))
        })));
        $[13] = formatMessage;
        $[14] = onClose;
        $[15] = onView;
        $[16] = t9;
    } else t9 = $[16];
    let t10;
    if ($[17] !== t7 || $[18] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t2
        }, t7, t9);
        $[17] = t7;
        $[18] = t9;
        $[19] = t10;
    } else t10 = $[19];
    return t10;
} : function RovoThinkingReady({ onView: onView, onClose: onClose, readyText: readyText, showCheckIcon: showCheckIcon = true }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $2fbceb2d84c4630f$var$styles.wrapper,
            (0, $iDrrr.fg)('rovo_ready_bar_ui_update') && $2fbceb2d84c4630f$var$styles.updatedWrapper
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $2fbceb2d84c4630f$var$styles.content
        ])
    }, (0, $iDrrr.fg)('rovo_ready_bar_ui_update') ? showCheckIcon && /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $2fbceb2d84c4630f$var$styles.iconContainer
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
        label: "",
        size: "medium",
        color: "var(--ds-icon-success, #6A9A23)",
        testId: "thinking-ready-check-icon"
    })) : /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $2fbceb2d84c4630f$var$styles.iconContainer
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($iZMIZ))), {
        label: "",
        color: "var(--ds-icon-success, #6A9A23)",
        testId: "thinking-ready-check-circle-icon"
    })), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, readyText ?? formatMessage((0, $02Wb7.default).thinkingReadyMessage))), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $2fbceb2d84c4630f$var$styles.buttonGroup
        ])
    }, (0, $iDrrr.fg)('rovo_ready_bar_ui_update') ? /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, onView && /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        spacing: "default",
        onClick: onClose,
        testId: "thinking-ready-close-button"
    }, formatMessage((0, $02Wb7.default).thinkingClose)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: onView,
        testId: "thinking-ready-view-button"
    }, formatMessage((0, $02Wb7.default).thinkingReadyView))), !onView && /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "subtle",
        spacing: (0, $iDrrr.fg)('rovo_ready_bar_fix_height') ? 'default' : 'compact',
        onClick: onClose,
        testId: "thinking-ready-close-button",
        label: formatMessage((0, $02Wb7.default).thinkingClose),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH)))
    })) : /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, onView && /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: onView,
        testId: "thinking-ready-view-button"
    }, formatMessage((0, $02Wb7.default).thinkingReadyView)), /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "subtle",
        spacing: !!onView || !(0, $iDrrr.fg)('rovo_ready_bar_fix_height') ? 'compact' : 'default',
        onClick: onClose,
        testId: "thinking-ready-close-button",
        label: formatMessage((0, $02Wb7.default).thinkingClose),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH)))
    }))));
};
module.exports["RovoThinkingReady"] = $2fbceb2d84c4630f$export$64b2d10bbc0b6fdd;

});

parcelRegister("02Wb7", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $353693fd10aa5589$var$message = (0, $kSwu1.defineMessages)({
    followAiMateButton: {
        id: "ai-mate.inline-chat-input.follow-button.label",
        defaultMessage: "Follow"
    },
    stopGeneratingButtonLabel: {
        id: "ai-mate.inline-chat-input.stop-generating-button.label",
        defaultMessage: "Stop generating"
    },
    thinkingText: {
        id: "ai-mate.inline-chat-input.thinking",
        defaultMessage: "Rovo is analyzing"
    },
    thinkingTextShort: {
        id: "ai-mate.inline-chat-input.thinking.short",
        defaultMessage: "Analyzing"
    },
    editingText: {
        id: "ai-mate.inline-chat-input.editing",
        defaultMessage: "Rovo is editing"
    },
    editingTextShort: {
        id: "ai-mate.inline-chat-input.editing.short",
        defaultMessage: "Editing"
    },
    thinkingReadyMessage: {
        id: "ai-mate.thinking-bar.ready.message",
        defaultMessage: "Your edits are ready"
    },
    thinkingClose: {
        id: "ai-mate.thinking-bar.close",
        defaultMessage: "Close"
    },
    thinkingReadyView: {
        id: "ai-mate.thinking-bar.ready.view",
        defaultMessage: "View"
    },
    thinkingErrorMessage: {
        id: "ai-mate.thinking-bar.error.message",
        defaultMessage: "An unknown error occurred."
    },
    thinkingErrorTryAgain: {
        id: "ai-mate.thinking-bar.error.try-again",
        defaultMessage: "Try again"
    }
});
var $353693fd10aa5589$export$2e2bcd8739ae039 = $353693fd10aa5589$var$message;
module.exports["default"] = $353693fd10aa5589$export$2e2bcd8739ae039;

});

parcelRegister("kb1I3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $1sCHt = parcelRequire("1sCHt");


var $1pTZX = parcelRequire("1pTZX");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");


var $1kxki = parcelRequire("1kxki");


var $2diYd = parcelRequire("2diYd");


var $02Wb7 = parcelRequire("02Wb7");


var $7VOWp = parcelRequire("7VOWp");

const $6437c80744d7a710$var$ROTATION_INTERVAL_MS = 4000;
const $6437c80744d7a710$var$rotatingMessages = (0, $kSwu1.defineMessages)({
    rovoIsThinking: {
        id: "ai-mate.inline-chat-input.thinking.rotating.rovo-is-thinking",
        defaultMessage: "Rovo is thinking"
    },
    analyzingContent: {
        id: "ai-mate.inline-chat-input.thinking.rotating.analyzing-content",
        defaultMessage: "Analyzing your content"
    },
    puttingPiecesTogether: {
        id: "ai-mate.inline-chat-input.thinking.rotating.putting-pieces-together",
        defaultMessage: "Putting the pieces together"
    },
    structuringResponse: {
        id: "ai-mate.inline-chat-input.thinking.rotating.structuring-response",
        defaultMessage: "Structuring your response"
    },
    designingResponse: {
        id: "ai-mate.inline-chat-input.thinking.rotating.designing-response",
        defaultMessage: "Designing your response"
    },
    addingItAllTogether: {
        id: "ai-mate.inline-chat-input.thinking.rotating.adding-it-all-together",
        defaultMessage: "Adding it all together"
    },
    applyingFinalTouches: {
        id: "ai-mate.inline-chat-input.thinking.rotating.applying-final-touches",
        defaultMessage: "Applying the final touches"
    },
    almostDone: {
        id: "ai-mate.inline-chat-input.thinking.rotating.almost-done",
        defaultMessage: "Almost done"
    }
});
/**
 * Cycles through `texts` at a fixed interval, stopping on the last item.
 *
 * When `startedAt` (epoch ms) is provided, the current index is derived from the
 * elapsed time since that shared anchor, so multiple instances driven by the same
 * session show the same message and stay in sync across mount/unmount. When
 * omitted, rotation is anchored to this mount.
 */ function $6437c80744d7a710$var$useSequentialText(texts, enabled, startedAt) {
    const indexFromStart = ()=>{
        if (startedAt == null) return 0;
        const elapsed = Math.max(0, Date.now() - startedAt);
        return Math.min(texts.length - 1, Math.floor(elapsed / $6437c80744d7a710$var$ROTATION_INTERVAL_MS));
    };
    const [index, setIndex] = (0, $cozmU.useState)(indexFromStart);
    const indexRef = (0, $cozmU.useRef)(index);
    indexRef.current = index;
    const textsRef = (0, $cozmU.useRef)(texts);
    textsRef.current = texts;
    (0, $cozmU.useEffect)(()=>{
        if (!enabled || textsRef.current.length <= 1) return;
        if (indexRef.current >= textsRef.current.length - 1) return;
        const interval = setInterval(()=>{
            const next = indexRef.current + 1;
            if (next < textsRef.current.length) {
                indexRef.current = next;
                setIndex(next);
            } else clearInterval(interval);
        }, $6437c80744d7a710$var$ROTATION_INTERVAL_MS);
        return ()=>clearInterval(interval);
    }, [
        enabled,
        startedAt
    ]);
    return texts[index] ?? texts[texts.length - 1] ?? '';
}
const $6437c80744d7a710$var$styles = {
    container: "_2mHwu82ADO _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _39xV02N91d",
    actions: "_2XsHFMIZbP",
    indicatorWrapper: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC"
};
const $6437c80744d7a710$export$6430bc5d6cac94e6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(54);
    const { status: t1, onStop: onStop, onFollow: onFollow, useShortMessages: t2, showProgressBar: t3, isComplete: isComplete, onCompleteAnimationFinished: onCompleteAnimationFinished, useRotatingTitle: t4, customRotatingMessages: customRotatingMessages, startedAt: startedAt, progressTarget: progressTarget } = t0;
    const status = t1 === undefined ? "analyzing" : t1;
    const useShortMessages = t2 === undefined ? false : t2;
    const showProgressBar = t3 === undefined ? false : t3;
    const useRotatingTitle = t4 === undefined ? false : t4;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t5;
    if ($[0] !== isComplete || $[1] !== onCompleteAnimationFinished || $[2] !== progressTarget || $[3] !== startedAt) {
        t5 = {
            isComplete: isComplete,
            onCompleteAnimationFinished: onCompleteAnimationFinished,
            startedAt: startedAt,
            target: progressTarget
        };
        $[0] = isComplete;
        $[1] = onCompleteAnimationFinished;
        $[2] = progressTarget;
        $[3] = startedAt;
        $[4] = t5;
    } else t5 = $[4];
    const progress = (0, $7VOWp.useProgressFacade)(t5);
    const t6 = status === "editing" ? useShortMessages ? (0, $02Wb7.default).editingTextShort : (0, $02Wb7.default).editingText : useShortMessages ? (0, $02Wb7.default).thinkingTextShort : (0, $02Wb7.default).thinkingText;
    let t7;
    if ($[5] !== formatMessage || $[6] !== t6) {
        t7 = formatMessage(t6);
        $[5] = formatMessage;
        $[6] = t6;
        $[7] = t7;
    } else t7 = $[7];
    const staticTitle = t7;
    const rotatingEnabled = useRotatingTitle && !useShortMessages;
    let t8;
    if ($[8] !== formatMessage) {
        t8 = formatMessage($6437c80744d7a710$var$rotatingMessages.rovoIsThinking);
        $[8] = formatMessage;
        $[9] = t8;
    } else t8 = $[9];
    let t9;
    if ($[10] !== formatMessage) {
        t9 = formatMessage($6437c80744d7a710$var$rotatingMessages.analyzingContent);
        $[10] = formatMessage;
        $[11] = t9;
    } else t9 = $[11];
    let t10;
    if ($[12] !== formatMessage) {
        t10 = formatMessage($6437c80744d7a710$var$rotatingMessages.puttingPiecesTogether);
        $[12] = formatMessage;
        $[13] = t10;
    } else t10 = $[13];
    let t11;
    if ($[14] !== formatMessage) {
        t11 = formatMessage($6437c80744d7a710$var$rotatingMessages.structuringResponse);
        $[14] = formatMessage;
        $[15] = t11;
    } else t11 = $[15];
    let t12;
    if ($[16] !== formatMessage) {
        t12 = formatMessage($6437c80744d7a710$var$rotatingMessages.designingResponse);
        $[16] = formatMessage;
        $[17] = t12;
    } else t12 = $[17];
    let t13;
    if ($[18] !== formatMessage) {
        t13 = formatMessage($6437c80744d7a710$var$rotatingMessages.addingItAllTogether);
        $[18] = formatMessage;
        $[19] = t13;
    } else t13 = $[19];
    let t14;
    if ($[20] !== formatMessage) {
        t14 = formatMessage($6437c80744d7a710$var$rotatingMessages.applyingFinalTouches);
        $[20] = formatMessage;
        $[21] = t14;
    } else t14 = $[21];
    let t15;
    if ($[22] !== formatMessage) {
        t15 = formatMessage($6437c80744d7a710$var$rotatingMessages.almostDone);
        $[22] = formatMessage;
        $[23] = t15;
    } else t15 = $[23];
    let t16;
    if ($[24] !== t10 || $[25] !== t11 || $[26] !== t12 || $[27] !== t13 || $[28] !== t14 || $[29] !== t15 || $[30] !== t8 || $[31] !== t9) {
        t16 = [
            t8,
            t9,
            t10,
            t11,
            t12,
            t13,
            t14,
            t15
        ];
        $[24] = t10;
        $[25] = t11;
        $[26] = t12;
        $[27] = t13;
        $[28] = t14;
        $[29] = t15;
        $[30] = t8;
        $[31] = t9;
        $[32] = t16;
    } else t16 = $[32];
    const defaultRotatingTitles = t16;
    const rotatingTitles = customRotatingMessages && customRotatingMessages.length > 0 ? customRotatingMessages : defaultRotatingTitles;
    const rotatingTitle = $6437c80744d7a710$var$useSequentialText(rotatingTitles, rotatingEnabled, startedAt);
    const title = rotatingEnabled ? rotatingTitle : staticTitle;
    let t17;
    if ($[33] !== formatMessage || $[34] !== onFollow) {
        t17 = onFollow && /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: onFollow
        }, formatMessage((0, $02Wb7.default).followAiMateButton));
        $[33] = formatMessage;
        $[34] = onFollow;
        $[35] = t17;
    } else t17 = $[35];
    let t18;
    if ($[36] !== formatMessage) {
        t18 = formatMessage((0, $02Wb7.default).stopGeneratingButtonLabel);
        $[36] = formatMessage;
        $[37] = t18;
    } else t18 = $[37];
    let t19;
    if ($[38] !== onStop || $[39] !== t18) {
        t19 = /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            isTooltipDisabled: false,
            shape: "default",
            onClick: onStop,
            icon: $6437c80744d7a710$var$_temp,
            label: t18
        });
        $[38] = onStop;
        $[39] = t18;
        $[40] = t19;
    } else t19 = $[40];
    let t20;
    if ($[41] !== t17 || $[42] !== t19) {
        t20 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            testId: "inline-chat__thinking-view",
            alignBlock: "center",
            space: "space.100",
            xcss: $6437c80744d7a710$var$styles.actions
        }, t17, t19);
        $[41] = t17;
        $[42] = t19;
        $[43] = t20;
    } else t20 = $[43];
    const actionsNode = t20;
    let t21;
    if ($[44] !== progress || $[45] !== showProgressBar || $[46] !== title) {
        t21 = showProgressBar ? /*#__PURE__*/ $cozmU.createElement((0, $1kxki.RainbowProgressBar), {
            testId: "rovo-thinking-progress-bar",
            progress: progress,
            appearance: "static-rainbow",
            label: title
        }) : undefined;
        $[44] = progress;
        $[45] = showProgressBar;
        $[46] = title;
        $[47] = t21;
    } else t21 = $[47];
    let t22;
    if ($[48] !== t21 || $[49] !== title) {
        t22 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $6437c80744d7a710$var$styles.indicatorWrapper
        }, /*#__PURE__*/ $cozmU.createElement((0, $2diYd.RovoThinkingIndicator), {
            title: title,
            animation: true,
            bottomAdornment: t21
        }));
        $[48] = t21;
        $[49] = title;
        $[50] = t22;
    } else t22 = $[50];
    let t23;
    if ($[51] !== actionsNode || $[52] !== t22) {
        t23 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $6437c80744d7a710$var$styles.container
        }, t22, actionsNode);
        $[51] = actionsNode;
        $[52] = t22;
        $[53] = t23;
    } else t23 = $[53];
    return t23;
} : ({ status: status = 'analyzing', onStop: onStop, onFollow: onFollow, useShortMessages: useShortMessages = false, showProgressBar: showProgressBar = false, isComplete: isComplete, onCompleteAnimationFinished: onCompleteAnimationFinished, useRotatingTitle: useRotatingTitle = false, customRotatingMessages: customRotatingMessages, startedAt: startedAt, progressTarget: progressTarget })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const progress = (0, $7VOWp.useProgressFacade)({
        isComplete: isComplete,
        onCompleteAnimationFinished: onCompleteAnimationFinished,
        startedAt: startedAt,
        target: progressTarget
    });
    const staticTitle = formatMessage(status === 'editing' ? useShortMessages ? (0, $02Wb7.default).editingTextShort : (0, $02Wb7.default).editingText : useShortMessages ? (0, $02Wb7.default).thinkingTextShort : (0, $02Wb7.default).thinkingText);
    const rotatingEnabled = useRotatingTitle && !useShortMessages;
    const defaultRotatingTitles = [
        formatMessage($6437c80744d7a710$var$rotatingMessages.rovoIsThinking),
        formatMessage($6437c80744d7a710$var$rotatingMessages.analyzingContent),
        formatMessage($6437c80744d7a710$var$rotatingMessages.puttingPiecesTogether),
        formatMessage($6437c80744d7a710$var$rotatingMessages.structuringResponse),
        formatMessage($6437c80744d7a710$var$rotatingMessages.designingResponse),
        formatMessage($6437c80744d7a710$var$rotatingMessages.addingItAllTogether),
        formatMessage($6437c80744d7a710$var$rotatingMessages.applyingFinalTouches),
        formatMessage($6437c80744d7a710$var$rotatingMessages.almostDone)
    ];
    const rotatingTitles = customRotatingMessages && customRotatingMessages.length > 0 ? customRotatingMessages : defaultRotatingTitles;
    const rotatingTitle = $6437c80744d7a710$var$useSequentialText(rotatingTitles, rotatingEnabled, startedAt);
    const title = rotatingEnabled ? rotatingTitle : staticTitle;
    const actionsNode = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        testId: "inline-chat__thinking-view",
        alignBlock: "center",
        space: "space.100",
        xcss: $6437c80744d7a710$var$styles.actions
    }, onFollow && /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: onFollow
    }, formatMessage((0, $02Wb7.default).followAiMateButton)), /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        isTooltipDisabled: false,
        shape: 'default',
        onClick: onStop,
        icon: (iconProps)=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1pTZX))), {
                ...iconProps,
                color: "var(--ds-icon-danger, #C9372C)",
                label: ''
            }),
        label: formatMessage((0, $02Wb7.default).stopGeneratingButtonLabel)
    }));
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $6437c80744d7a710$var$styles.container
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $6437c80744d7a710$var$styles.indicatorWrapper
    }, /*#__PURE__*/ $cozmU.createElement((0, $2diYd.RovoThinkingIndicator), {
        title: title,
        animation: true,
        bottomAdornment: showProgressBar ? /*#__PURE__*/ $cozmU.createElement((0, $1kxki.RainbowProgressBar), {
            testId: "rovo-thinking-progress-bar",
            progress: progress,
            appearance: "static-rainbow",
            label: title
        }) : undefined
    })), actionsNode);
};
function $6437c80744d7a710$var$_temp(iconProps) {
    return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1pTZX))), {
        ...iconProps,
        color: "var(--ds-icon-danger, #C9372C)",
        label: ""
    });
}
module.exports["RovoThinkingBar"] = $6437c80744d7a710$export$6430bc5d6cac94e6;

});

parcelRegister("7VOWp", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $cccd0e8042c52039$var$DEFAULT_ESTIMATED_DURATION_MS = 30000;
const $cccd0e8042c52039$var$COMPLETION_ANIMATION_MS = 150;
function $cccd0e8042c52039$export$c350fe90f7013d5f({ isComplete: isComplete = false, onCompleteAnimationFinished: onCompleteAnimationFinished, estimatedDurationMs: estimatedDurationMs = $cccd0e8042c52039$var$DEFAULT_ESTIMATED_DURATION_MS, startedAt: startedAt = null, target: target }) {
    const randomTargetRef = (0, $cozmU.useRef)(85 + Math.random() * 10);
    const targetValue = target ?? randomTargetRef.current;
    // When anchored to a shared start time, seed the initial value from elapsed
    // time so a freshly-mounted bar jumps to the in-progress value instead of
    // restarting the animation from 0.
    const [progress, setProgress] = (0, $cozmU.useState)(()=>{
        if (startedAt == null) return 0;
        const elapsed = Math.max(0, Date.now() - startedAt);
        return Math.min(1, elapsed / estimatedDurationMs) * targetValue;
    });
    const completionStartValueRef = (0, $cozmU.useRef)(0);
    const completionStartTimeRef = (0, $cozmU.useRef)(null);
    const hasCalledFinishedRef = (0, $cozmU.useRef)(false);
    const onCompleteAnimationFinishedRef = (0, $cozmU.useRef)(onCompleteAnimationFinished);
    onCompleteAnimationFinishedRef.current = onCompleteAnimationFinished;
    // Phase 1: Animate from 0 → target over estimatedDurationMs.
    // When `startedAt` is provided, elapsed is measured from that shared anchor
    // (wall-clock) so every bar agrees regardless of mount time; otherwise it is
    // measured from the first animation frame of this mount.
    (0, $cozmU.useEffect)(()=>{
        if (isComplete) return;
        let rafId;
        let mountStartTime = null;
        const tick = (timestamp)=>{
            let elapsed;
            if (startedAt != null) elapsed = Math.max(0, Date.now() - startedAt);
            else {
                if (mountStartTime === null) mountStartTime = timestamp;
                elapsed = timestamp - mountStartTime;
            }
            const linearProgress = Math.min(1, elapsed / estimatedDurationMs);
            setProgress(linearProgress * targetValue);
            if (linearProgress < 1) rafId = requestAnimationFrame(tick);
        };
        rafId = requestAnimationFrame(tick);
        return ()=>{
            cancelAnimationFrame(rafId);
        };
    }, [
        isComplete,
        estimatedDurationMs,
        startedAt,
        targetValue
    ]);
    // Phase 2: When isComplete, rapidly animate from current value → 100
    const handleCompletion = (0, $cozmU.useCallback)(()=>{
        completionStartTimeRef.current = null;
        hasCalledFinishedRef.current = false;
        let rafId;
        const tick = (timestamp)=>{
            if (completionStartTimeRef.current === null) completionStartTimeRef.current = timestamp;
            const elapsed = timestamp - completionStartTimeRef.current;
            const t = Math.min(1, elapsed / $cccd0e8042c52039$var$COMPLETION_ANIMATION_MS);
            const startValue = completionStartValueRef.current;
            const value = startValue + (100 - startValue) * t;
            setProgress(value);
            if (t < 1) rafId = requestAnimationFrame(tick);
            else if (!hasCalledFinishedRef.current) {
                hasCalledFinishedRef.current = true;
                onCompleteAnimationFinishedRef.current?.();
            }
        };
        rafId = requestAnimationFrame(tick);
        return ()=>{
            cancelAnimationFrame(rafId);
        };
    }, []);
    (0, $cozmU.useEffect)(()=>{
        if (!isComplete) return;
        completionStartValueRef.current = progress;
        const cleanup = handleCompletion();
        return cleanup;
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only trigger when isComplete changes to true
    }, [
        isComplete,
        handleCompletion
    ]);
    return progress;
}
module.exports["useProgressFacade"] = $cccd0e8042c52039$export$c350fe90f7013d5f;

});

parcelRegister("88DFk", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6CGVr = parcelRequire("6CGVr");


var $9DHhW = parcelRequire("9DHhW");


var $iGwRU = parcelRequire("iGwRU");


var $kXiqf = parcelRequire("kXiqf");


var $l9F99 = parcelRequire("l9F99");


var $i8NpI = parcelRequire("i8NpI");

const $9d01a40d5c3361ba$var$DefaultActionSubject = 'rovoAgent';
const $9d01a40d5c3361ba$var$globalEventConfig = (0, $i8NpI.getDefaultTrackEventConfig)();
const $9d01a40d5c3361ba$export$b9dc0ab1bce924aa = (0, $gtMdU.isReactCompilerActivePlatform)() ? (commonAttributes)=>{
    const $ = (0, $bDgLe.c)(21);
    const [t0, t1] = (0, $kXiqf.useRovoAgentCSID)();
    const { csid: csid, globalCSID: globalCSID } = t0;
    const { refresh: refreshCSID } = t1;
    const analyticsContext = (0, $cozmU.useContext)((0, $6CGVr.default));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const commonAttributesRef = (0, $cozmU.useRef)(commonAttributes);
    let t2;
    if ($[0] !== analyticsContext || $[1] !== createAnalyticsEvent) {
        t2 = (event)=>{
            const referrer = typeof window !== "undefined" ? window.document.referrer : "unknown";
            const attributes = {
                ...(0, $l9F99.getAttributesFromContexts)(analyticsContext.getAtlaskitAnalyticsContext()),
                ...commonAttributesRef.current,
                ...event.attributes,
                actionGroup: "createFlow",
                referrer: referrer
            };
            createAnalyticsEvent({
                ...$9d01a40d5c3361ba$var$globalEventConfig,
                ...event,
                attributes: attributes
            }).fire((0, $iGwRU.ANALYTICS_CHANNEL));
        };
        $[0] = analyticsContext;
        $[1] = createAnalyticsEvent;
        $[2] = t2;
    } else t2 = $[2];
    const fireAnalyticsEvent = t2;
    let t3;
    if ($[3] !== fireAnalyticsEvent || $[4] !== globalCSID) {
        t3 = (action, attributes_0)=>{
            fireAnalyticsEvent({
                actionSubject: $9d01a40d5c3361ba$var$DefaultActionSubject,
                action: action,
                attributes: {
                    csid: globalCSID,
                    ...attributes_0
                }
            });
        };
        $[3] = fireAnalyticsEvent;
        $[4] = globalCSID;
        $[5] = t3;
    } else t3 = $[5];
    const trackCreateSession = t3;
    let t4;
    if ($[6] !== csid || $[7] !== fireAnalyticsEvent || $[8] !== refreshCSID) {
        t4 = (attributes_1)=>{
            fireAnalyticsEvent({
                actionSubject: $9d01a40d5c3361ba$var$DefaultActionSubject,
                action: "createFlowStart",
                attributes: {
                    csid: csid,
                    ...attributes_1
                }
            });
            refreshCSID();
        };
        $[6] = csid;
        $[7] = fireAnalyticsEvent;
        $[8] = refreshCSID;
        $[9] = t4;
    } else t4 = $[9];
    const trackCreateSessionStart = t4;
    let t5;
    if ($[10] !== fireAnalyticsEvent || $[11] !== globalCSID) {
        t5 = (error, attributes_2)=>{
            fireAnalyticsEvent({
                actionSubject: $9d01a40d5c3361ba$var$DefaultActionSubject,
                action: "createFlowError",
                attributes: {
                    error: {
                        message: error.message
                    },
                    csid: globalCSID,
                    ...attributes_2
                }
            });
        };
        $[10] = fireAnalyticsEvent;
        $[11] = globalCSID;
        $[12] = t5;
    } else t5 = $[12];
    const trackCreateSessionError = t5;
    let t6;
    if ($[13] !== refreshCSID || $[14] !== trackCreateSession || $[15] !== trackCreateSessionError || $[16] !== trackCreateSessionStart) {
        t6 = {
            trackCreateSession: trackCreateSession,
            trackCreateSessionStart: trackCreateSessionStart,
            trackCreateSessionError: trackCreateSessionError,
            refreshCSID: refreshCSID
        };
        $[13] = refreshCSID;
        $[14] = trackCreateSession;
        $[15] = trackCreateSessionError;
        $[16] = trackCreateSessionStart;
        $[17] = t6;
    } else t6 = $[17];
    let t7;
    if ($[18] !== csid || $[19] !== t6) {
        t7 = [
            csid,
            t6
        ];
        $[18] = csid;
        $[19] = t6;
        $[20] = t7;
    } else t7 = $[20];
    return t7;
} : (commonAttributes)=>{
    const [{ csid: csid, globalCSID: globalCSID }, { refresh: refreshCSID }] = (0, $kXiqf.useRovoAgentCSID)();
    const analyticsContext = (0, $cozmU.useContext)((0, $6CGVr.default));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const commonAttributesRef = (0, $cozmU.useRef)(commonAttributes);
    const fireAnalyticsEvent = (0, $cozmU.useCallback)((event)=>{
        const referrer = typeof window !== 'undefined' ? window.document.referrer : 'unknown';
        const attributes = {
            ...(0, $l9F99.getAttributesFromContexts)(analyticsContext.getAtlaskitAnalyticsContext()),
            ...commonAttributesRef.current,
            ...event.attributes,
            actionGroup: 'createFlow',
            referrer: referrer
        };
        createAnalyticsEvent({
            ...$9d01a40d5c3361ba$var$globalEventConfig,
            ...event,
            attributes: attributes
        }).fire((0, $iGwRU.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        analyticsContext
    ] // keep number of dependencies minimal to prevent re-rendering
    );
    /**
   * Fires an analytics event for a step in the create agent flow funnel.
   * Uses the CSID from the URL query parameter.
   */ const trackCreateSession = (0, $cozmU.useCallback)((action, attributes_0)=>{
        fireAnalyticsEvent({
            actionSubject: $9d01a40d5c3361ba$var$DefaultActionSubject,
            action: action,
            attributes: {
                csid: globalCSID,
                ...attributes_0
            }
        });
    }, [
        fireAnalyticsEvent,
        globalCSID
    ]);
    /**
   * Fires `createFlowStart` with the current CSID (matching the href),
   * then refreshes the CSID for the next session.
   * The component re-renders with the new CSID, updating any href attributes.
   */ const trackCreateSessionStart = (0, $cozmU.useCallback)((attributes_1)=>{
        fireAnalyticsEvent({
            actionSubject: $9d01a40d5c3361ba$var$DefaultActionSubject,
            action: 'createFlowStart',
            attributes: {
                csid: csid,
                ...attributes_1
            }
        });
        refreshCSID();
    }, [
        fireAnalyticsEvent,
        refreshCSID,
        csid
    ]);
    const trackCreateSessionError = (0, $cozmU.useCallback)((error, attributes_2)=>{
        fireAnalyticsEvent({
            actionSubject: $9d01a40d5c3361ba$var$DefaultActionSubject,
            action: 'createFlowError',
            attributes: {
                error: {
                    message: error.message
                },
                csid: globalCSID,
                ...attributes_2
            }
        });
    }, [
        fireAnalyticsEvent,
        globalCSID
    ]);
    return [
        csid,
        {
            trackCreateSession: trackCreateSession,
            trackCreateSessionStart: trackCreateSessionStart,
            trackCreateSessionError: trackCreateSessionError,
            refreshCSID: refreshCSID
        }
    ];
};
module.exports["useRovoAgentCreateAnalytics"] = $9d01a40d5c3361ba$export$b9dc0ab1bce924aa;

});

parcelRegister("kXiqf", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $debAY = parcelRequire("debAY");

let $3de3d827eb32710a$var$CACHED_CSID = null;
const $3de3d827eb32710a$var$generateCSID = ()=>{
    return crypto.randomUUID();
};
const $3de3d827eb32710a$export$2e155615ea28a17b = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(5);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = $3de3d827eb32710a$var$CACHED_CSID || $3de3d827eb32710a$var$generateCSID();
        $[0] = t0;
    } else t0 = $[0];
    const [csid, setCSID] = (0, $cozmU.useState)(t0);
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        const queryParams = new URLSearchParams(window.location.search);
        t1 = queryParams.get((0, $debAY.CSID_QUERY_PARAM));
        $[1] = t1;
    } else t1 = $[1];
    const globalCSID = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            refresh: ()=>{
                const newCSID = $3de3d827eb32710a$var$generateCSID();
                setCSID(newCSID);
                $3de3d827eb32710a$var$CACHED_CSID = newCSID;
                return newCSID;
            }
        };
        $[2] = t2;
    } else t2 = $[2];
    const actions = t2;
    let t3;
    if ($[3] !== csid) {
        t3 = [
            {
                csid: csid,
                globalCSID: globalCSID
            },
            actions
        ];
        $[3] = csid;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ()=>{
    const [csid, setCSID] = (0, $cozmU.useState)($3de3d827eb32710a$var$CACHED_CSID || $3de3d827eb32710a$var$generateCSID());
    const globalCSID = (0, $cozmU.useMemo)(()=>{
        const queryParams = new URLSearchParams(window.location.search);
        return queryParams.get((0, $debAY.CSID_QUERY_PARAM));
    }, []);
    const actions = (0, $cozmU.useMemo)(()=>{
        return {
            refresh: ()=>{
                const newCSID = $3de3d827eb32710a$var$generateCSID();
                setCSID(newCSID);
                $3de3d827eb32710a$var$CACHED_CSID = newCSID;
                return newCSID;
            }
        };
    }, []);
    return [
        {
            csid: csid,
            globalCSID: // generated CSID to be used in href and createFlowStart events
            globalCSID // CSID from the URL query parameter
        },
        actions
    ];
};
module.exports["useRovoAgentCSID"] = $3de3d827eb32710a$export$2e155615ea28a17b;

});

parcelRegister("debAY", function(module, exports) {
const $881ebb84c71795d2$export$61b85fb5d2d632d0 = 'csid';
module.exports["CSID_QUERY_PARAM"] = $881ebb84c71795d2$export$61b85fb5d2d632d0;

});

parcelRegister("banCF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iVxGn = parcelRequire("iVxGn");

parcelRequire("cgKJK");
var $96dZ7 = parcelRequire("96dZ7");




var $aSzLn = parcelRequire("aSzLn");


var $6nvBr = parcelRequire("6nvBr");

const $021914730fb82814$var$forEachActor = (actorRef, callback)=>{
    callback(actorRef);
    const children = actorRef.getSnapshot().children;
    if (children) Object.values(children).forEach((child)=>{
        $021914730fb82814$var$forEachActor(child, callback);
    });
};
function $021914730fb82814$var$stopRootWithRehydration(actorRef) {
    // persist snapshot here in a custom way allows us to persist inline actors and to preserve actor references
    // we do it to avoid setState in useEffect when the effect gets "reconnected"
    // this currently only happens in Strict Effects but it simulates the Offscreen aka Activity API
    // it also just allows us to end up with a somewhat more predictable behavior for the users
    const persistedSnapshots = [];
    $021914730fb82814$var$forEachActor(actorRef, (ref)=>{
        persistedSnapshots.push([
            ref,
            ref.getSnapshot()
        ]);
        // muting observers allow us to avoid `useSelector` from being notified about the stopped snapshot
        // React reconnects its subscribers (from the useSyncExternalStore) on its own
        // and userland subscibers should basically always do the same anyway
        // as each subscription should have its own cleanup logic and that should be called each such reconnect
        ref.observers = new Set();
    });
    const systemSnapshot = actorRef.system.getSnapshot?.();
    actorRef.stop();
    actorRef.system._snapshot = systemSnapshot;
    persistedSnapshots.forEach(([ref, snapshot])=>{
        ref._processingStatus = 0;
        ref._snapshot = snapshot;
    });
}
function $021914730fb82814$var$useIdleActorRef(logic, ...[options]) {
    let [[currentConfig, actorRef], setCurrent] = (0, $cozmU.useState)(()=>{
        const actorRef = (0, $96dZ7.A)(logic, options);
        return [
            logic.config,
            actorRef
        ];
    });
    if (logic.config !== currentConfig) {
        const newActorRef = (0, $96dZ7.A)(logic, {
            ...options,
            snapshot: actorRef.getPersistedSnapshot({
                __unsafeAllowInlineActors: true
            })
        });
        setCurrent([
            logic.config,
            newActorRef
        ]);
        actorRef = newActorRef;
    }
    // TODO: consider using `useAsapEffect` that would do this in `useInsertionEffect` is that's available
    (0, $iVxGn.default)(()=>{
        actorRef.logic.implementations = logic.implementations;
    });
    return actorRef;
}
function $021914730fb82814$export$e92bd910f9c89ff6(machine, ...[options, observerOrListener]) {
    const actorRef = $021914730fb82814$var$useIdleActorRef(machine, options);
    (0, $cozmU.useEffect)(()=>{
        if (!observerOrListener) return;
        const sub = actorRef.subscribe((0, $96dZ7.L)(observerOrListener));
        return ()=>{
            sub.unsubscribe();
        };
    }, [
        observerOrListener
    ]);
    (0, $cozmU.useEffect)(()=>{
        actorRef.start();
        return ()=>{
            $021914730fb82814$var$stopRootWithRehydration(actorRef);
        };
    }, [
        actorRef
    ]);
    return actorRef;
}
function $021914730fb82814$var$defaultCompare(a, b) {
    return a === b;
}
function $021914730fb82814$export$2105062e25df4afe(actor, selector, compare = $021914730fb82814$var$defaultCompare) {
    const subscribe = (0, $cozmU.useCallback)((handleStoreChange)=>{
        if (!actor) return ()=>{};
        const { unsubscribe: unsubscribe } = actor.subscribe(handleStoreChange);
        return unsubscribe;
    }, [
        actor
    ]);
    const boundGetSnapshot = (0, $cozmU.useCallback)(()=>actor?.getSnapshot(), [
        actor
    ]);
    const selectedSnapshot = (0, $aSzLn.useSyncExternalStoreWithSelector)(subscribe, boundGetSnapshot, boundGetSnapshot, selector, compare);
    return selectedSnapshot;
}
function $021914730fb82814$export$72ba36f8308928ab(actorLogic, actorOptions) {
    const ReactContext = /*#__PURE__*/ $cozmU.createContext(null);
    const OriginalProvider = ReactContext.Provider;
    function Provider({ children: children, logic: providedLogic = actorLogic, machine: machine, options: providedOptions }) {
        if (machine) throw new Error(`The "machine" prop has been deprecated. Please use "logic" instead.`);
        const actor = $021914730fb82814$export$e92bd910f9c89ff6(providedLogic, {
            ...actorOptions,
            ...providedOptions
        });
        return /*#__PURE__*/ $cozmU.createElement(OriginalProvider, {
            value: actor,
            children: children
        });
    }
    // TODO: add properties to actor ref to make more descriptive
    Provider.displayName = `ActorProvider`;
    function useContext() {
        const actor = $cozmU.useContext(ReactContext);
        if (!actor) throw new Error(`You used a hook from "${Provider.displayName}" but it's not inside a <${Provider.displayName}> component.`);
        return actor;
    }
    function useSelector$1(selector, compare) {
        const actor = useContext();
        return $021914730fb82814$export$2105062e25df4afe(actor, selector, compare);
    }
    return {
        Provider: Provider,
        useActorRef: useContext,
        useSelector: useSelector$1
    };
}
// From https://github.com/reduxjs/react-redux/blob/720f0ba79236cdc3e1115f4ef9a7760a21784b48/src/utils/shallowEqual.ts
function $021914730fb82814$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $021914730fb82814$export$d36bdfa510afb180(objA, objB) {
    if ($021914730fb82814$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$021914730fb82814$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
function $021914730fb82814$export$25c4ab29592aabd9(logic, ...[options]) {
    const actorRef = $021914730fb82814$var$useIdleActorRef(logic, options);
    const getSnapshot = (0, $cozmU.useCallback)(()=>{
        return actorRef.getSnapshot();
    }, [
        actorRef
    ]);
    const subscribe = (0, $cozmU.useCallback)((handleStoreChange)=>{
        const { unsubscribe: unsubscribe } = actorRef.subscribe(handleStoreChange);
        return unsubscribe;
    }, [
        actorRef
    ]);
    const actorSnapshot = (0, $6nvBr.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    (0, $cozmU.useEffect)(()=>{
        actorRef.start();
        return ()=>{
            $021914730fb82814$var$stopRootWithRehydration(actorRef);
        };
    }, [
        actorRef
    ]);
    return [
        actorSnapshot,
        actorRef.send,
        actorRef
    ];
}
/** @alias useActor */ function $021914730fb82814$export$e0338c4153421160(machine, ...[options]) {
    return $021914730fb82814$export$25c4ab29592aabd9(machine, options);
}
module.exports["useActorRef"] = $021914730fb82814$export$e92bd910f9c89ff6;
module.exports["useSelector"] = $021914730fb82814$export$2105062e25df4afe;
module.exports["createActorContext"] = $021914730fb82814$export$72ba36f8308928ab;
module.exports["shallowEqual"] = $021914730fb82814$export$d36bdfa510afb180;
module.exports["useMachine"] = $021914730fb82814$export$e0338c4153421160;

});

parcelRegister("iVxGn", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

var $dc77ad8576485322$export$2e2bcd8739ae039 = (0, $cozmU.useLayoutEffect);
module.exports["default"] = $dc77ad8576485322$export$2e2bcd8739ae039;

});

parcelRegister("cgKJK", function(module, exports) {
$parcel$export(module.exports, "createActor", () => (parcelRequire("96dZ7")).A);
$parcel$export(module.exports, "assign", () => (parcelRequire("dpSRg")).a);

var $eXLWP = parcelRequire("eXLWP");


var $96dZ7 = parcelRequire("96dZ7");


var $dpSRg = parcelRequire("dpSRg");

parcelRequire("e6Soq");

/**
 * Asserts that the given event object is of the specified type or types. Throws
 * an error if the event object is not of the specified types.
 *
 * @example
 *
 * ```ts
 * // ...
 * entry: ({ event }) => {
 *   assertEvent(event, 'doNothing');
 *   // event is { type: 'doNothing' }
 * },
 * // ...
 * exit: ({ event }) => {
 *   assertEvent(event, 'greet');
 *   // event is { type: 'greet'; message: string }
 *
 *   assertEvent(event, ['greet', 'notify']);
 *   // event is { type: 'greet'; message: string }
 *   // or { type: 'notify'; message: string; level: 'info' | 'error' }
 * },
 * ```
 */ function $8eeb3b9b9ffbca82$export$b3e112bfd3a4f448(event, type) {
    const types = (0, $96dZ7.t)(type);
    if (!types.includes(event.type)) {
        const typesText = types.length === 1 ? `type "${types[0]}"` : `one of types "${types.join('", "')}"`;
        throw new Error(`Expected event ${JSON.stringify(event)} to have ${typesText}`);
    }
}
const $8eeb3b9b9ffbca82$var$cache = new WeakMap();
function $8eeb3b9b9ffbca82$var$memo(object, key, fn) {
    let memoizedData = $8eeb3b9b9ffbca82$var$cache.get(object);
    if (!memoizedData) {
        memoizedData = {
            [key]: fn()
        };
        $8eeb3b9b9ffbca82$var$cache.set(object, memoizedData);
    } else if (!(key in memoizedData)) memoizedData[key] = fn();
    return memoizedData[key];
}
const $8eeb3b9b9ffbca82$var$EMPTY_OBJECT = {};
const $8eeb3b9b9ffbca82$var$toSerializableAction = (action)=>{
    if (typeof action === 'string') return {
        type: action
    };
    if (typeof action === 'function') {
        if ('resolve' in action) return {
            type: action.type
        };
        return {
            type: action.name
        };
    }
    return action;
};
class $8eeb3b9b9ffbca82$export$342f24f5edd47b1 {
    /** @internal */ _initialize() {
        this.transitions = (0, $96dZ7.f)(this);
        if (this.config.always) this.always = (0, $96dZ7.a)(this.config.always).map((t)=>(0, $96dZ7.b)(this, (0, $96dZ7.N), t));
        Object.keys(this.states).forEach((key)=>{
            this.states[key]._initialize();
        });
    }
    /** The well-structured state node definition. */ get definition() {
        return {
            id: this.id,
            key: this.key,
            version: this.machine.version,
            type: this.type,
            initial: this.initial ? {
                target: this.initial.target,
                source: this,
                actions: this.initial.actions.map($8eeb3b9b9ffbca82$var$toSerializableAction),
                eventType: null,
                reenter: false,
                toJSON: ()=>({
                        target: this.initial.target.map((t)=>`#${t.id}`),
                        source: `#${this.id}`,
                        actions: this.initial.actions.map($8eeb3b9b9ffbca82$var$toSerializableAction),
                        eventType: null
                    })
            } : undefined,
            history: this.history,
            states: (0, $96dZ7.m)(this.states, (state)=>{
                return state.definition;
            }),
            on: this.on,
            transitions: [
                ...this.transitions.values()
            ].flat().map((t)=>({
                    ...t,
                    actions: t.actions.map($8eeb3b9b9ffbca82$var$toSerializableAction)
                })),
            entry: this.entry.map($8eeb3b9b9ffbca82$var$toSerializableAction),
            exit: this.exit.map($8eeb3b9b9ffbca82$var$toSerializableAction),
            meta: this.meta,
            order: this.order || -1,
            output: this.output,
            invoke: this.invoke,
            description: this.description,
            tags: this.tags
        };
    }
    /** @internal */ toJSON() {
        return this.definition;
    }
    /** The logic invoked as actors by this state node. */ get invoke() {
        return $8eeb3b9b9ffbca82$var$memo(this, 'invoke', ()=>(0, $96dZ7.t)(this.config.invoke).map((invokeConfig, i)=>{
                const { src: src, systemId: systemId } = invokeConfig;
                const resolvedId = invokeConfig.id ?? (0, $96dZ7.c)(this.id, i);
                const sourceName = typeof src === 'string' ? src : `xstate.invoke.${(0, $96dZ7.c)(this.id, i)}`;
                return {
                    ...invokeConfig,
                    src: sourceName,
                    id: resolvedId,
                    systemId: systemId,
                    toJSON () {
                        const { onDone: onDone, onError: onError, ...invokeDefValues } = invokeConfig;
                        return {
                            ...invokeDefValues,
                            type: 'xstate.invoke',
                            src: sourceName,
                            id: resolvedId
                        };
                    }
                };
            }));
    }
    /** The mapping of events to transitions. */ get on() {
        return $8eeb3b9b9ffbca82$var$memo(this, 'on', ()=>{
            const transitions = this.transitions;
            return [
                ...transitions
            ].flatMap(([descriptor, t])=>t.map((t)=>[
                        descriptor,
                        t
                    ])).reduce((map, [descriptor, transition])=>{
                map[descriptor] = map[descriptor] || [];
                map[descriptor].push(transition);
                return map;
            }, {});
        });
    }
    get after() {
        return $8eeb3b9b9ffbca82$var$memo(this, 'delayedTransitions', ()=>(0, $96dZ7.g)(this));
    }
    get initial() {
        return $8eeb3b9b9ffbca82$var$memo(this, 'initial', ()=>(0, $96dZ7.d)(this, this.config.initial));
    }
    /** @internal */ next(snapshot, event) {
        const eventType = event.type;
        const actions = [];
        let selectedTransition;
        const candidates = $8eeb3b9b9ffbca82$var$memo(this, `candidates-${eventType}`, ()=>(0, $96dZ7.h)(this, eventType));
        for (const candidate of candidates){
            const { guard: guard } = candidate;
            const resolvedContext = snapshot.context;
            let guardPassed = false;
            try {
                guardPassed = !guard || (0, $96dZ7.e)(guard, resolvedContext, event, snapshot);
            } catch (err) {
                const guardType = typeof guard === 'string' ? guard : typeof guard === 'object' ? guard.type : undefined;
                throw new Error(`Unable to evaluate guard ${guardType ? `'${guardType}' ` : ''}in transition for event '${eventType}' in state node '${this.id}':\n${err.message}`);
            }
            if (guardPassed) {
                actions.push(...candidate.actions);
                selectedTransition = candidate;
                break;
            }
        }
        return selectedTransition ? [
            selectedTransition
        ] : undefined;
    }
    /** All the event types accepted by this state node and its descendants. */ get events() {
        return $8eeb3b9b9ffbca82$var$memo(this, 'events', ()=>{
            const { states: states } = this;
            const events = new Set(this.ownEvents);
            if (states) for (const stateId of Object.keys(states)){
                const state = states[stateId];
                if (state.states) for (const event of state.events)events.add(`${event}`);
            }
            return Array.from(events);
        });
    }
    /**
   * All the events that have transitions directly from this state node.
   *
   * Excludes any inert events.
   */ get ownEvents() {
        const events = new Set([
            ...this.transitions.keys()
        ].filter((descriptor)=>{
            return this.transitions.get(descriptor).some((transition)=>!(!transition.target && !transition.actions.length && !transition.reenter));
        }));
        return Array.from(events);
    }
    constructor(/** The raw config used to create the machine. */ config, options){
        this.config = config;
        /**
     * The relative key of the state node, which represents its location in the
     * overall state value.
     */ this.key = void 0;
        /** The unique ID of the state node. */ this.id = void 0;
        /**
     * The type of this state node:
     *
     * - `'atomic'` - no child state nodes
     * - `'compound'` - nested child state nodes (XOR)
     * - `'parallel'` - orthogonal nested child state nodes (AND)
     * - `'history'` - history state node
     * - `'final'` - final state node
     */ this.type = void 0;
        /** The string path from the root machine node to this node. */ this.path = void 0;
        /** The child state nodes. */ this.states = void 0;
        /**
     * The type of history on this state node. Can be:
     *
     * - `'shallow'` - recalls only top-level historical state value
     * - `'deep'` - recalls historical state value at all levels
     */ this.history = void 0;
        /** The action(s) to be executed upon entering the state node. */ this.entry = void 0;
        /** The action(s) to be executed upon exiting the state node. */ this.exit = void 0;
        /** The parent state node. */ this.parent = void 0;
        /** The root machine node. */ this.machine = void 0;
        /**
     * The meta data associated with this state node, which will be returned in
     * State instances.
     */ this.meta = void 0;
        /**
     * The output data sent with the "xstate.done.state._id_" event if this is a
     * final state node.
     */ this.output = void 0;
        /**
     * The order this state node appears. Corresponds to the implicit document
     * order.
     */ this.order = -1;
        this.description = void 0;
        this.tags = [];
        this.transitions = void 0;
        this.always = void 0;
        this.parent = options._parent;
        this.key = options._key;
        this.machine = options._machine;
        this.path = this.parent ? this.parent.path.concat(this.key) : [];
        this.id = this.config.id || [
            this.machine.id,
            ...this.path
        ].join((0, $96dZ7.S));
        this.type = this.config.type || (this.config.states && Object.keys(this.config.states).length ? 'compound' : this.config.history ? 'history' : 'atomic');
        this.description = this.config.description;
        this.order = this.machine.idMap.size;
        this.machine.idMap.set(this.id, this);
        this.states = this.config.states ? (0, $96dZ7.m)(this.config.states, (stateConfig, key)=>{
            const stateNode = new $8eeb3b9b9ffbca82$export$342f24f5edd47b1(stateConfig, {
                _parent: this,
                _key: key,
                _machine: this.machine
            });
            return stateNode;
        }) : $8eeb3b9b9ffbca82$var$EMPTY_OBJECT;
        if (this.type === 'compound' && !this.config.initial) throw new Error(`No initial state specified for compound state node "#${this.id}". Try adding { initial: "${Object.keys(this.states)[0]}" } to the state config.`);
        // History config
        this.history = this.config.history === true ? 'shallow' : this.config.history || false;
        this.entry = (0, $96dZ7.t)(this.config.entry).slice();
        this.exit = (0, $96dZ7.t)(this.config.exit).slice();
        this.meta = this.config.meta;
        this.output = this.type === 'final' || !this.parent ? this.config.output : undefined;
        this.tags = (0, $96dZ7.t)(config.tags).slice();
    }
}
const $8eeb3b9b9ffbca82$var$STATE_IDENTIFIER = '#';
class $8eeb3b9b9ffbca82$export$cbf2d83d1eab018a {
    /**
   * Clones this state machine with the provided implementations and merges the
   * `context` (if provided).
   *
   * @param implementations Options (`actions`, `guards`, `actors`, `delays`,
   *   `context`) to recursively merge with the existing options.
   * @returns A new `StateMachine` instance with the provided implementations.
   */ provide(implementations) {
        const { actions: actions, guards: guards, actors: actors, delays: delays } = this.implementations;
        return new $8eeb3b9b9ffbca82$export$cbf2d83d1eab018a(this.config, {
            actions: {
                ...actions,
                ...implementations.actions
            },
            guards: {
                ...guards,
                ...implementations.guards
            },
            actors: {
                ...actors,
                ...implementations.actors
            },
            delays: {
                ...delays,
                ...implementations.delays
            }
        });
    }
    resolveState(config) {
        const resolvedStateValue = (0, $96dZ7.r)(this.root, config.value);
        const nodeSet = (0, $96dZ7.i)((0, $96dZ7.j)(this.root, resolvedStateValue));
        return (0, $96dZ7.k)({
            _nodes: [
                ...nodeSet
            ],
            context: config.context || {},
            children: {},
            status: (0, $96dZ7.l)(nodeSet, this.root) ? 'done' : config.status || 'active',
            output: config.output,
            error: config.error,
            historyValue: config.historyValue
        }, this);
    }
    /**
   * Determines the next snapshot given the current `snapshot` and received
   * `event`. Calculates a full macrostep from all microsteps.
   *
   * @param snapshot The current snapshot
   * @param event The received event
   */ transition(snapshot, event, actorScope) {
        return (0, $96dZ7.n)(snapshot, event, actorScope, []).snapshot;
    }
    /**
   * Determines the next state given the current `state` and `event`. Calculates
   * a microstep.
   *
   * @param state The current state
   * @param event The received event
   */ microstep(snapshot, event, actorScope) {
        return (0, $96dZ7.n)(snapshot, event, actorScope, []).microstates;
    }
    getTransitionData(snapshot, event) {
        return (0, $96dZ7.o)(this.root, snapshot.value, snapshot, event) || [];
    }
    /**
   * The initial state _before_ evaluating any microsteps. This "pre-initial"
   * state is provided to initial actions executed in the initial state.
   */ getPreInitialState(actorScope, initEvent, internalQueue) {
        const { context: context } = this.config;
        const preInitial = (0, $96dZ7.k)({
            context: typeof context !== 'function' && context ? context : {},
            _nodes: [
                this.root
            ],
            children: {},
            status: 'active'
        }, this);
        if (typeof context === 'function') {
            const assignment = ({ spawn: spawn, event: event, self: self })=>context({
                    spawn: spawn,
                    input: event.input,
                    self: self
                });
            return (0, $96dZ7.p)(preInitial, initEvent, actorScope, [
                (0, $dpSRg.a)(assignment)
            ], internalQueue, undefined);
        }
        return preInitial;
    }
    /**
   * Returns the initial `State` instance, with reference to `self` as an
   * `ActorRef`.
   */ getInitialSnapshot(actorScope, input) {
        const initEvent = (0, $96dZ7.q)(input); // TODO: fix;
        const internalQueue = [];
        const preInitialState = this.getPreInitialState(actorScope, initEvent, internalQueue);
        const nextState = (0, $96dZ7.s)([
            {
                target: [
                    ...(0, $96dZ7.u)(this.root)
                ],
                source: this.root,
                reenter: true,
                actions: [],
                eventType: null,
                toJSON: null // TODO: fix
            }
        ], preInitialState, actorScope, initEvent, true, internalQueue);
        const { snapshot: macroState } = (0, $96dZ7.n)(nextState, initEvent, actorScope, internalQueue);
        return macroState;
    }
    start(snapshot) {
        Object.values(snapshot.children).forEach((child)=>{
            if (child.getSnapshot().status === 'active') child.start();
        });
    }
    getStateNodeById(stateId) {
        const fullPath = (0, $96dZ7.v)(stateId);
        const relativePath = fullPath.slice(1);
        const resolvedStateId = (0, $96dZ7.w)(fullPath[0]) ? fullPath[0].slice($8eeb3b9b9ffbca82$var$STATE_IDENTIFIER.length) : fullPath[0];
        const stateNode = this.idMap.get(resolvedStateId);
        if (!stateNode) throw new Error(`Child state node '#${resolvedStateId}' does not exist on machine '${this.id}'`);
        return (0, $96dZ7.x)(stateNode, relativePath);
    }
    get definition() {
        return this.root.definition;
    }
    toJSON() {
        return this.definition;
    }
    getPersistedSnapshot(snapshot, options) {
        return (0, $96dZ7.y)(snapshot, options);
    }
    restoreSnapshot(snapshot, _actorScope) {
        const children = {};
        const snapshotChildren = snapshot.children;
        Object.keys(snapshotChildren).forEach((actorId)=>{
            const actorData = snapshotChildren[actorId];
            const childState = actorData.snapshot;
            const src = actorData.src;
            const logic = typeof src === 'string' ? (0, $96dZ7.z)(this, src) : src;
            if (!logic) return;
            const actorRef = (0, $96dZ7.A)(logic, {
                id: actorId,
                parent: _actorScope.self,
                syncSnapshot: actorData.syncSnapshot,
                snapshot: childState,
                src: src,
                systemId: actorData.systemId
            });
            children[actorId] = actorRef;
        });
        const restoredSnapshot = (0, $96dZ7.k)({
            ...snapshot,
            children: children,
            _nodes: Array.from((0, $96dZ7.i)((0, $96dZ7.j)(this.root, snapshot.value)))
        }, this);
        const seen = new Set();
        function reviveContext(contextPart, children) {
            if (seen.has(contextPart)) return;
            seen.add(contextPart);
            for(const key in contextPart){
                const value = contextPart[key];
                if (value && typeof value === 'object') {
                    if ('xstate$$type' in value && value.xstate$$type === (0, $96dZ7.$)) {
                        contextPart[key] = children[value.id];
                        continue;
                    }
                    reviveContext(value, children);
                }
            }
        }
        reviveContext(restoredSnapshot.context, children);
        return restoredSnapshot;
    }
    constructor(/** The raw config used to create the machine. */ config, implementations){
        this.config = config;
        /** The machine's own version. */ this.version = void 0;
        this.schemas = void 0;
        this.implementations = void 0;
        /** @internal */ this.__xstatenode = true;
        /** @internal */ this.idMap = new Map();
        this.root = void 0;
        this.id = void 0;
        this.states = void 0;
        this.events = void 0;
        this.id = config.id || '(machine)';
        this.implementations = {
            actors: implementations?.actors ?? {},
            actions: implementations?.actions ?? {},
            delays: implementations?.delays ?? {},
            guards: implementations?.guards ?? {}
        };
        this.version = this.config.version;
        this.schemas = this.config.schemas;
        this.transition = this.transition.bind(this);
        this.getInitialSnapshot = this.getInitialSnapshot.bind(this);
        this.getPersistedSnapshot = this.getPersistedSnapshot.bind(this);
        this.restoreSnapshot = this.restoreSnapshot.bind(this);
        this.start = this.start.bind(this);
        this.root = new $8eeb3b9b9ffbca82$export$342f24f5edd47b1(config, {
            _key: this.id,
            _machine: this
        });
        this.root._initialize();
        this.states = this.root.states; // TODO: remove!
        this.events = this.root.events;
    }
}
/**
 * Creates a state machine (statechart) with the given configuration.
 *
 * The state machine represents the pure logic of a state machine actor.
 *
 * @example
 *
 * ```ts
 * import { createMachine } from 'xstate';
 *
 * const lightMachine = createMachine({
 *   id: 'light',
 *   initial: 'green',
 *   states: {
 *     green: {
 *       on: {
 *         TIMER: { target: 'yellow' }
 *       }
 *     },
 *     yellow: {
 *       on: {
 *         TIMER: { target: 'red' }
 *       }
 *     },
 *     red: {
 *       on: {
 *         TIMER: { target: 'green' }
 *       }
 *     }
 *   }
 * });
 *
 * const lightActor = createActor(lightMachine);
 * lightActor.start();
 *
 * lightActor.send({ type: 'TIMER' });
 * ```
 *
 * @param config The state machine configuration.
 * @param options DEPRECATED: use `setup({ ... })` or `machine.provide({ ... })`
 *   to provide machine implementations instead.
 */ function $8eeb3b9b9ffbca82$export$aaa7fa18f8e9b2e8(config, implementations) {
    return new $8eeb3b9b9ffbca82$export$cbf2d83d1eab018a(config, implementations);
}
/** @internal */ function $8eeb3b9b9ffbca82$var$createInertActorScope(actorLogic) {
    const self = (0, $96dZ7.A)(actorLogic);
    const inertActorScope = {
        self: self,
        defer: ()=>{},
        id: '',
        logger: ()=>{},
        sessionId: '',
        stopChild: ()=>{},
        system: self.system,
        emit: ()=>{},
        actionExecutor: ()=>{}
    };
    return inertActorScope;
}
/** @deprecated Use `initialTransition(…)` instead. */ function $8eeb3b9b9ffbca82$export$e1c3f9a97f5088ae(actorLogic, ...[input]) {
    const actorScope = $8eeb3b9b9ffbca82$var$createInertActorScope(actorLogic);
    return actorLogic.getInitialSnapshot(actorScope, input);
}
/**
 * Determines the next snapshot for the given `actorLogic` based on the given
 * `snapshot` and `event`.
 *
 * If the `snapshot` is `undefined`, the initial snapshot of the `actorLogic` is
 * used.
 *
 * @deprecated Use `transition(…)` instead.
 * @example
 *
 * ```ts
 * import { getNextSnapshot } from 'xstate';
 * import { trafficLightMachine } from './trafficLightMachine.ts';
 *
 * const nextSnapshot = getNextSnapshot(
 *   trafficLightMachine, // actor logic
 *   undefined, // snapshot (or initial state if undefined)
 *   { type: 'TIMER' }
 * ); // event object
 *
 * console.log(nextSnapshot.value);
 * // => 'yellow'
 *
 * const nextSnapshot2 = getNextSnapshot(
 *   trafficLightMachine, // actor logic
 *   nextSnapshot, // snapshot
 *   { type: 'TIMER' }
 * ); // event object
 *
 * console.log(nextSnapshot2.value);
 * // =>'red'
 * ```
 */ function $8eeb3b9b9ffbca82$export$3629c64713e6dfd7(actorLogic, snapshot, event) {
    const inertActorScope = $8eeb3b9b9ffbca82$var$createInertActorScope(actorLogic);
    inertActorScope.self._snapshot = snapshot;
    return actorLogic.transition(snapshot, event, inertActorScope);
}
// at the moment we allow extra actors - ones that are not specified by `children`
// this could be reconsidered in the future
function $8eeb3b9b9ffbca82$export$de27182ff8187d6c({ schemas: schemas, actors: actors, actions: actions, guards: guards, delays: delays }) {
    return {
        createMachine: (config)=>$8eeb3b9b9ffbca82$export$aaa7fa18f8e9b2e8({
                ...config,
                schemas: schemas
            }, {
                actors: actors,
                actions: actions,
                guards: guards,
                delays: delays
            })
    };
}
// eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging
// eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging
class $8eeb3b9b9ffbca82$export$7413adad607e2cdf {
    now() {
        return this._now;
    }
    getId() {
        return this._id++;
    }
    setTimeout(fn, timeout) {
        this._flushingInvalidated = this._flushing;
        const id = this.getId();
        this.timeouts.set(id, {
            start: this.now(),
            timeout: timeout,
            fn: fn
        });
        return id;
    }
    clearTimeout(id) {
        this._flushingInvalidated = this._flushing;
        this.timeouts.delete(id);
    }
    set(time) {
        if (this._now > time) throw new Error('Unable to travel back in time');
        this._now = time;
        this.flushTimeouts();
    }
    flushTimeouts() {
        if (this._flushing) {
            this._flushingInvalidated = true;
            return;
        }
        this._flushing = true;
        const sorted = [
            ...this.timeouts
        ].sort(([_idA, timeoutA], [_idB, timeoutB])=>{
            const endA = timeoutA.start + timeoutA.timeout;
            const endB = timeoutB.start + timeoutB.timeout;
            return endB > endA ? -1 : 1;
        });
        for (const [id, timeout] of sorted){
            if (this._flushingInvalidated) {
                this._flushingInvalidated = false;
                this._flushing = false;
                this.flushTimeouts();
                return;
            }
            if (this.now() - timeout.start >= timeout.timeout) {
                this.timeouts.delete(id);
                timeout.fn.call(null);
            }
        }
        this._flushing = false;
    }
    increment(ms) {
        this._now += ms;
        this.flushTimeouts();
    }
    constructor(){
        this.timeouts = new Map();
        this._now = 0;
        this._id = 0;
        this._flushing = false;
        this._flushingInvalidated = false;
    }
}
/**
 * Returns a promise that resolves to the `output` of the actor when it is done.
 *
 * @example
 *
 * ```ts
 * const machine = createMachine({
 *   // ...
 *   output: {
 *     count: 42
 *   }
 * });
 *
 * const actor = createActor(machine);
 *
 * actor.start();
 *
 * const output = await toPromise(actor);
 *
 * console.log(output);
 * // logs { count: 42 }
 * ```
 */ function $8eeb3b9b9ffbca82$export$4dbaaf6c79705e6c(actor) {
    return new Promise((resolve, reject)=>{
        actor.subscribe({
            complete: ()=>{
                resolve(actor.getSnapshot().output);
            },
            error: reject
        });
    });
}
/**
 * Given actor `logic`, a `snapshot`, and an `event`, returns a tuple of the
 * `nextSnapshot` and `actions` to execute.
 *
 * This is a pure function that does not execute `actions`.
 */ function $8eeb3b9b9ffbca82$export$66bb15e2994e6a26(logic, snapshot, event) {
    const executableActions = [];
    const actorScope = $8eeb3b9b9ffbca82$var$createInertActorScope(logic);
    actorScope.actionExecutor = (action)=>{
        executableActions.push(action);
    };
    const nextSnapshot = logic.transition(snapshot, event, actorScope);
    return [
        nextSnapshot,
        executableActions
    ];
}
/**
 * Given actor `logic` and optional `input`, returns a tuple of the
 * `nextSnapshot` and `actions` to execute from the initial transition (no
 * previous state).
 *
 * This is a pure function that does not execute `actions`.
 */ function $8eeb3b9b9ffbca82$export$5f4d25c77127242(logic, ...[input]) {
    const executableActions = [];
    const actorScope = $8eeb3b9b9ffbca82$var$createInertActorScope(logic);
    actorScope.actionExecutor = (action)=>{
        executableActions.push(action);
    };
    const nextSnapshot = logic.getInitialSnapshot(actorScope, input);
    return [
        nextSnapshot,
        executableActions
    ];
}
const $8eeb3b9b9ffbca82$var$defaultWaitForOptions = {
    timeout: Infinity // much more than 10 seconds
};
/**
 * Subscribes to an actor ref and waits for its emitted value to satisfy a
 * predicate, and then resolves with that value. Will throw if the desired state
 * is not reached after an optional timeout. (defaults to Infinity).
 *
 * @example
 *
 * ```js
 * const state = await waitFor(someService, (state) => {
 *   return state.hasTag('loaded');
 * });
 *
 * state.hasTag('loaded'); // true
 * ```
 *
 * @param actorRef The actor ref to subscribe to
 * @param predicate Determines if a value matches the condition to wait for
 * @param options
 * @returns A promise that eventually resolves to the emitted value that matches
 *   the condition
 */ function $8eeb3b9b9ffbca82$export$9bbfceb27f687c1b(actorRef, predicate, options) {
    const resolvedOptions = {
        ...$8eeb3b9b9ffbca82$var$defaultWaitForOptions,
        ...options
    };
    return new Promise((res, rej)=>{
        const { signal: signal } = resolvedOptions;
        if (signal?.aborted) {
            // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
            rej(signal.reason);
            return;
        }
        let done = false;
        const handle = resolvedOptions.timeout === Infinity ? undefined : setTimeout(()=>{
            dispose();
            rej(new Error(`Timeout of ${resolvedOptions.timeout} ms exceeded`));
        }, resolvedOptions.timeout);
        const dispose = ()=>{
            clearTimeout(handle);
            done = true;
            sub?.unsubscribe();
            if (abortListener) signal.removeEventListener('abort', abortListener);
        };
        function checkEmitted(emitted) {
            if (predicate(emitted)) {
                dispose();
                res(emitted);
            }
        }
        /**
     * If the `signal` option is provided, this will be the listener for its
     * `abort` event
     */ let abortListener;
        // eslint-disable-next-line prefer-const
        let sub; // avoid TDZ when disposing synchronously
        // See if the current snapshot already matches the predicate
        checkEmitted(actorRef.getSnapshot());
        if (done) return;
        // only define the `abortListener` if the `signal` option is provided
        if (signal) {
            abortListener = ()=>{
                dispose();
                // XState does not "own" the signal, so we should reject with its reason (if any)
                // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
                rej(signal.reason);
            };
            signal.addEventListener('abort', abortListener);
        }
        sub = actorRef.subscribe({
            next: checkEmitted,
            error: (err)=>{
                dispose();
                // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
                rej(err);
            },
            complete: ()=>{
                dispose();
                rej(new Error(`Actor terminated without satisfying predicate`));
            }
        });
        if (done) sub.unsubscribe();
    });
}
module.exports["createMachine"] = $8eeb3b9b9ffbca82$export$aaa7fa18f8e9b2e8;
module.exports["setup"] = $8eeb3b9b9ffbca82$export$de27182ff8187d6c;

});

parcelRegister("eXLWP", function(module, exports) {

var $96dZ7 = parcelRequire("96dZ7");

parcelRequire("e6Soq");

/**
 * Represents an actor created by `fromTransition`.
 *
 * The type of `self` within the actor's logic.
 *
 * @example
 *
 * ```ts
 * import {
 *   fromTransition,
 *   createActor,
 *   type AnyActorSystem
 * } from 'xstate';
 *
 * //* The actor's stored context.
 * type Context = {
 *   // The current count.
 *   count: number;
 *   // The amount to increase `count` by.
 *   step: number;
 * };
 * // The events the actor receives.
 * type Event = { type: 'increment' };
 * // The actor's input.
 * type Input = { step?: number };
 *
 * // Actor logic that increments `count` by `step` when it receives an event of
 * // type `increment`.
 * const logic = fromTransition<Context, Event, AnyActorSystem, Input>(
 *   (state, event, actorScope) => {
 *     actorScope.self;
 *     //         ^? TransitionActorRef<Context, Event>
 *
 *     if (event.type === 'increment') {
 *       return {
 *         ...state,
 *         count: state.count + state.step
 *       };
 *     }
 *     return state;
 *   },
 *   ({ input, self }) => {
 *     self;
 *     // ^? TransitionActorRef<Context, Event>
 *
 *     return {
 *       count: 0,
 *       step: input.step ?? 1
 *     };
 *   }
 * );
 *
 * const actor = createActor(logic, { input: { step: 10 } });
 * //    ^? TransitionActorRef<Context, Event>
 * ```
 *
 * @see {@link fromTransition}
 */ /**
 * Returns actor logic given a transition function and its initial state.
 *
 * A “transition function” is a function that takes the current `state` and
 * received `event` object as arguments, and returns the next state, similar to
 * a reducer.
 *
 * Actors created from transition logic (“transition actors”) can:
 *
 * - Receive events
 * - Emit snapshots of its state
 *
 * The transition function’s `state` is used as its transition actor’s
 * `context`.
 *
 * Note that the "state" for a transition function is provided by the initial
 * state argument, and is not the same as the State object of an actor or a
 * state within a machine configuration.
 *
 * @example
 *
 * ```ts
 * const transitionLogic = fromTransition(
 *   (state, event) => {
 *     if (event.type === 'increment') {
 *       return {
 *         ...state,
 *         count: state.count + 1
 *       };
 *     }
 *     return state;
 *   },
 *   { count: 0 }
 * );
 *
 * const transitionActor = createActor(transitionLogic);
 * transitionActor.subscribe((snapshot) => {
 *   console.log(snapshot);
 * });
 * transitionActor.start();
 * // => {
 * //   status: 'active',
 * //   context: { count: 0 },
 * //   ...
 * // }
 *
 * transitionActor.send({ type: 'increment' });
 * // => {
 * //   status: 'active',
 * //   context: { count: 1 },
 * //   ...
 * // }
 * ```
 *
 * @param transition The transition function used to describe the transition
 *   logic. It should return the next state given the current state and event.
 *   It receives the following arguments:
 *
 *   - `state` - the current state.
 *   - `event` - the received event.
 *   - `actorScope` - the actor scope object, with properties like `self` and
 *       `system`.
 *
 * @param initialContext The initial state of the transition function, either an
 *   object representing the state, or a function which returns a state object.
 *   If a function, it will receive as its only argument an object with the
 *   following properties:
 *
 *   - `input` - the `input` provided to its parent transition actor.
 *   - `self` - a reference to its parent transition actor.
 *
 * @returns Actor logic
 * @see {@link https://stately.ai/docs/input | Input docs} for more information about how input is passed
 */ function $ae4bc4d1d8af478f$export$439a4be7208a15ca(transition, initialContext) {
    return {
        config: transition,
        transition: (snapshot, event, actorScope)=>{
            return {
                ...snapshot,
                context: transition(snapshot.context, event, actorScope)
            };
        },
        getInitialSnapshot: (_, input)=>{
            return {
                status: 'active',
                output: undefined,
                error: undefined,
                context: typeof initialContext === 'function' ? initialContext({
                    input: input
                }) : initialContext
            };
        },
        getPersistedSnapshot: (snapshot)=>snapshot,
        restoreSnapshot: (snapshot)=>snapshot
    };
}
const $ae4bc4d1d8af478f$var$instanceStates = /* #__PURE__ */ new WeakMap();
/**
 * Represents an actor created by `fromCallback`.
 *
 * The type of `self` within the actor's logic.
 *
 * @example
 *
 * ```ts
 * import { fromCallback, createActor } from 'xstate';
 *
 * // The events the actor receives.
 * type Event = { type: 'someEvent' };
 * // The actor's input.
 * type Input = { name: string };
 *
 * // Actor logic that logs whenever it receives an event of type `someEvent`.
 * const logic = fromCallback<Event, Input>(({ self, input, receive }) => {
 *   self;
 *   // ^? CallbackActorRef<Event, Input>
 *
 *   receive((event) => {
 *     if (event.type === 'someEvent') {
 *       console.log(`${input.name}: received "someEvent" event`);
 *       // logs 'myActor: received "someEvent" event'
 *     }
 *   });
 * });
 *
 * const actor = createActor(logic, { input: { name: 'myActor' } });
 * //    ^? CallbackActorRef<Event, Input>
 * ```
 *
 * @see {@link fromCallback}
 */ /**
 * An actor logic creator which returns callback logic as defined by a callback
 * function.
 *
 * @remarks
 * Useful for subscription-based or other free-form logic that can send events
 * back to the parent actor.
 *
 * Actors created from callback logic (“callback actors”) can:
 *
 * - Receive events via the `receive` function
 * - Send events to the parent actor via the `sendBack` function
 *
 * Callback actors are a bit different from other actors in that they:
 *
 * - Do not work with `onDone`
 * - Do not produce a snapshot using `.getSnapshot()`
 * - Do not emit values when used with `.subscribe()`
 * - Can not be stopped with `.stop()`
 *
 * @example
 *
 * ```typescript
 * const callbackLogic = fromCallback(({ sendBack, receive }) => {
 *   let lockStatus = 'unlocked';
 *
 *   const handler = (event) => {
 *     if (lockStatus === 'locked') {
 *       return;
 *     }
 *     sendBack(event);
 *   };
 *
 *   receive((event) => {
 *     if (event.type === 'lock') {
 *       lockStatus = 'locked';
 *     } else if (event.type === 'unlock') {
 *       lockStatus = 'unlocked';
 *     }
 *   });
 *
 *   document.body.addEventListener('click', handler);
 *
 *   return () => {
 *     document.body.removeEventListener('click', handler);
 *   };
 * });
 * ```
 *
 * @param callback - The callback function used to describe the callback logic
 *   The callback function is passed an object with the following properties:
 *
 *   - `receive` - A function that can send events back to the parent actor; the
 *       listener is then called whenever events are received by the callback
 *       actor
 *   - `sendBack` - A function that can send events back to the parent actor
 *   - `input` - Data that was provided to the callback actor
 *   - `self` - The parent actor of the callback actor
 *   - `system` - The actor system to which the callback actor belongs The callback
 *       function can (optionally) return a cleanup function, which is called
 *       when the actor is stopped.
 *
 * @returns Callback logic
 * @see {@link CallbackLogicFunction} for more information about the callback function and its object argument
 * @see {@link https://stately.ai/docs/input | Input docs} for more information about how input is passed
 */ function $ae4bc4d1d8af478f$export$d0deb4828877173(callback) {
    const logic = {
        config: callback,
        start: (state, actorScope)=>{
            const { self: self, system: system, emit: emit } = actorScope;
            const callbackState = {
                receivers: undefined,
                dispose: undefined
            };
            $ae4bc4d1d8af478f$var$instanceStates.set(self, callbackState);
            callbackState.dispose = callback({
                input: state.input,
                system: system,
                self: self,
                sendBack: (event)=>{
                    if (self.getSnapshot().status === 'stopped') return;
                    if (self._parent) system._relay(self, self._parent, event);
                },
                receive: (listener)=>{
                    var _callbackState;
                    (_callbackState = callbackState).receivers ?? (_callbackState.receivers = new Set());
                    callbackState.receivers.add(listener);
                },
                emit: emit
            });
        },
        transition: (state, event, actorScope)=>{
            const callbackState = $ae4bc4d1d8af478f$var$instanceStates.get(actorScope.self);
            if (event.type === (0, $96dZ7.X)) {
                state = {
                    ...state,
                    status: 'stopped',
                    error: undefined
                };
                callbackState.dispose?.();
                return state;
            }
            callbackState.receivers?.forEach((receiver)=>receiver(event));
            return state;
        },
        getInitialSnapshot: (_, input)=>{
            return {
                status: 'active',
                output: undefined,
                error: undefined,
                input: input
            };
        },
        getPersistedSnapshot: (snapshot)=>snapshot,
        restoreSnapshot: (snapshot)=>snapshot
    };
    return logic;
}
const $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_NEXT = 'xstate.observable.next';
const $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_ERROR = 'xstate.observable.error';
const $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_COMPLETE = 'xstate.observable.complete';
/**
 * Represents an actor created by `fromObservable` or `fromEventObservable`.
 *
 * The type of `self` within the actor's logic.
 *
 * @example
 *
 * ```ts
 * import { fromObservable, createActor } from 'xstate';
 * import { interval } from 'rxjs';
 *
 * // The type of the value observed by the actor's logic.
 * type Context = number;
 * // The actor's input.
 * type Input = { period?: number };
 *
 * // Actor logic that observes a number incremented every `input.period`
 * // milliseconds (default: 1_000).
 * const logic = fromObservable<Context, Input>(({ input, self }) => {
 *   self;
 *   // ^? ObservableActorRef<Event, Input>
 *
 *   return interval(input.period ?? 1_000);
 * });
 *
 * const actor = createActor(logic, { input: { period: 2_000 } });
 * //    ^? ObservableActorRef<Event, Input>
 * ```
 *
 * @see {@link fromObservable}
 * @see {@link fromEventObservable}
 */ /**
 * Observable actor logic is described by an observable stream of values. Actors
 * created from observable logic (“observable actors”) can:
 *
 * - Emit snapshots of the observable’s emitted value
 *
 * The observable’s emitted value is used as its observable actor’s `context`.
 *
 * Sending events to observable actors will have no effect.
 *
 * @example
 *
 * ```ts
 * import { fromObservable, createActor } from 'xstate';
 * import { interval } from 'rxjs';
 *
 * const logic = fromObservable((obj) => interval(1000));
 *
 * const actor = createActor(logic);
 *
 * actor.subscribe((snapshot) => {
 *   console.log(snapshot.context);
 * });
 *
 * actor.start();
 * // At every second:
 * // Logs 0
 * // Logs 1
 * // Logs 2
 * // ...
 * ```
 *
 * @param observableCreator A function that creates an observable. It receives
 *   one argument, an object with the following properties:
 *
 *   - `input` - Data that was provided to the observable actor
 *   - `self` - The parent actor
 *   - `system` - The actor system to which the observable actor belongs
 *
 *   It should return a {@link Subscribable}, which is compatible with an RxJS
 *   Observable, although RxJS is not required to create them.
 * @see {@link https://rxjs.dev} for documentation on RxJS Observable and observable creators.
 * @see {@link Subscribable} interface in XState, which is based on and compatible with RxJS Observable.
 */ function $ae4bc4d1d8af478f$export$4b2432e2d8723823(observableCreator) {
    // TODO: add event types
    const logic = {
        config: observableCreator,
        transition: (snapshot, event)=>{
            if (snapshot.status !== 'active') return snapshot;
            switch(event.type){
                case $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_NEXT:
                    {
                        const newSnapshot = {
                            ...snapshot,
                            context: event.data
                        };
                        return newSnapshot;
                    }
                case $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_ERROR:
                    return {
                        ...snapshot,
                        status: 'error',
                        error: event.data,
                        input: undefined,
                        _subscription: undefined
                    };
                case $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_COMPLETE:
                    return {
                        ...snapshot,
                        status: 'done',
                        input: undefined,
                        _subscription: undefined
                    };
                case 0, $96dZ7.X:
                    snapshot._subscription.unsubscribe();
                    return {
                        ...snapshot,
                        status: 'stopped',
                        input: undefined,
                        _subscription: undefined
                    };
                default:
                    return snapshot;
            }
        },
        getInitialSnapshot: (_, input)=>{
            return {
                status: 'active',
                output: undefined,
                error: undefined,
                context: undefined,
                input: input,
                _subscription: undefined
            };
        },
        start: (state, { self: self, system: system, emit: emit })=>{
            if (state.status === 'done') // Do not restart a completed observable
            return;
            state._subscription = observableCreator({
                input: state.input,
                system: system,
                self: self,
                emit: emit
            }).subscribe({
                next: (value)=>{
                    system._relay(self, self, {
                        type: $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_NEXT,
                        data: value
                    });
                },
                error: (err)=>{
                    system._relay(self, self, {
                        type: $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_ERROR,
                        data: err
                    });
                },
                complete: ()=>{
                    system._relay(self, self, {
                        type: $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_COMPLETE
                    });
                }
            });
        },
        getPersistedSnapshot: ({ _subscription: _subscription, ...state })=>state,
        restoreSnapshot: (state)=>({
                ...state,
                _subscription: undefined
            })
    };
    return logic;
}
/**
 * Creates event observable logic that listens to an observable that delivers
 * event objects.
 *
 * Event observable actor logic is described by an observable stream of
 * {@link https://stately.ai/docs/transitions#event-objects | event objects}.
 * Actors created from event observable logic (“event observable actors”) can:
 *
 * - Implicitly send events to its parent actor
 * - Emit snapshots of its emitted event objects
 *
 * Sending events to event observable actors will have no effect.
 *
 * @example
 *
 * ```ts
 * import {
 *   fromEventObservable,
 *   Subscribable,
 *   EventObject,
 *   createMachine,
 *   createActor
 * } from 'xstate';
 * import { fromEvent } from 'rxjs';
 *
 * const mouseClickLogic = fromEventObservable(
 *   () => fromEvent(document.body, 'click') as Subscribable<EventObject>
 * );
 *
 * const canvasMachine = createMachine({
 *   invoke: {
 *     // Will send mouse `click` events to the canvas actor
 *     src: mouseClickLogic
 *   }
 * });
 *
 * const canvasActor = createActor(canvasMachine);
 * canvasActor.start();
 * ```
 *
 * @param lazyObservable A function that creates an observable that delivers
 *   event objects. It receives one argument, an object with the following
 *   properties:
 *
 *   - `input` - Data that was provided to the event observable actor
 *   - `self` - The parent actor
 *   - `system` - The actor system to which the event observable actor belongs.
 *
 *   It should return a {@link Subscribable}, which is compatible with an RxJS
 *   Observable, although RxJS is not required to create them.
 */ function $ae4bc4d1d8af478f$export$32b16bdebc365919(lazyObservable) {
    // TODO: event types
    const logic = {
        config: lazyObservable,
        transition: (state, event)=>{
            if (state.status !== 'active') return state;
            switch(event.type){
                case $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_ERROR:
                    return {
                        ...state,
                        status: 'error',
                        error: event.data,
                        input: undefined,
                        _subscription: undefined
                    };
                case $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_COMPLETE:
                    return {
                        ...state,
                        status: 'done',
                        input: undefined,
                        _subscription: undefined
                    };
                case 0, $96dZ7.X:
                    state._subscription.unsubscribe();
                    return {
                        ...state,
                        status: 'stopped',
                        input: undefined,
                        _subscription: undefined
                    };
                default:
                    return state;
            }
        },
        getInitialSnapshot: (_, input)=>{
            return {
                status: 'active',
                output: undefined,
                error: undefined,
                context: undefined,
                input: input,
                _subscription: undefined
            };
        },
        start: (state, { self: self, system: system, emit: emit })=>{
            if (state.status === 'done') // Do not restart a completed observable
            return;
            state._subscription = lazyObservable({
                input: state.input,
                system: system,
                self: self,
                emit: emit
            }).subscribe({
                next: (value)=>{
                    if (self._parent) system._relay(self, self._parent, value);
                },
                error: (err)=>{
                    system._relay(self, self, {
                        type: $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_ERROR,
                        data: err
                    });
                },
                complete: ()=>{
                    system._relay(self, self, {
                        type: $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_COMPLETE
                    });
                }
            });
        },
        getPersistedSnapshot: ({ _subscription: _subscription, ...snapshot })=>snapshot,
        restoreSnapshot: (snapshot)=>({
                ...snapshot,
                _subscription: undefined
            })
    };
    return logic;
}
const $ae4bc4d1d8af478f$var$XSTATE_PROMISE_RESOLVE = 'xstate.promise.resolve';
const $ae4bc4d1d8af478f$var$XSTATE_PROMISE_REJECT = 'xstate.promise.reject';
/**
 * Represents an actor created by `fromPromise`.
 *
 * The type of `self` within the actor's logic.
 *
 * @example
 *
 * ```ts
 * import { fromPromise, createActor } from 'xstate';
 *
 * // The actor's resolved output
 * type Output = string;
 * // The actor's input.
 * type Input = { message: string };
 *
 * // Actor logic that fetches the url of an image of a cat saying `input.message`.
 * const logic = fromPromise<Output, Input>(async ({ input, self }) => {
 *   self;
 *   // ^? PromiseActorRef<Output, Input>
 *
 *   const data = await fetch(
 *     `https://cataas.com/cat/says/${input.message}`
 *   );
 *   const url = await data.json();
 *   return url;
 * });
 *
 * const actor = createActor(logic, { input: { message: 'hello world' } });
 * //    ^? PromiseActorRef<Output, Input>
 * ```
 *
 * @see {@link fromPromise}
 */ const $ae4bc4d1d8af478f$var$controllerMap = new WeakMap();
/**
 * An actor logic creator which returns promise logic as defined by an async
 * process that resolves or rejects after some time.
 *
 * Actors created from promise actor logic (“promise actors”) can:
 *
 * - Emit the resolved value of the promise
 * - Output the resolved value of the promise
 *
 * Sending events to promise actors will have no effect.
 *
 * @example
 *
 * ```ts
 * const promiseLogic = fromPromise(async () => {
 *   const result = await fetch('https://example.com/...').then((data) =>
 *     data.json()
 *   );
 *
 *   return result;
 * });
 *
 * const promiseActor = createActor(promiseLogic);
 * promiseActor.subscribe((snapshot) => {
 *   console.log(snapshot);
 * });
 * promiseActor.start();
 * // => {
 * //   output: undefined,
 * //   status: 'active'
 * //   ...
 * // }
 *
 * // After promise resolves
 * // => {
 * //   output: { ... },
 * //   status: 'done',
 * //   ...
 * // }
 * ```
 *
 * @param promiseCreator A function which returns a Promise, and accepts an
 *   object with the following properties:
 *
 *   - `input` - Data that was provided to the promise actor
 *   - `self` - The parent actor of the promise actor
 *   - `system` - The actor system to which the promise actor belongs
 *
 * @see {@link https://stately.ai/docs/input | Input docs} for more information about how input is passed
 */ function $ae4bc4d1d8af478f$export$60f45028237c39d1(promiseCreator) {
    const logic = {
        config: promiseCreator,
        transition: (state, event, scope)=>{
            if (state.status !== 'active') return state;
            switch(event.type){
                case $ae4bc4d1d8af478f$var$XSTATE_PROMISE_RESOLVE:
                    {
                        const resolvedValue = event.data;
                        return {
                            ...state,
                            status: 'done',
                            output: resolvedValue,
                            input: undefined
                        };
                    }
                case $ae4bc4d1d8af478f$var$XSTATE_PROMISE_REJECT:
                    return {
                        ...state,
                        status: 'error',
                        error: event.data,
                        input: undefined
                    };
                case 0, $96dZ7.X:
                    $ae4bc4d1d8af478f$var$controllerMap.get(scope.self)?.abort();
                    return {
                        ...state,
                        status: 'stopped',
                        input: undefined
                    };
                default:
                    return state;
            }
        },
        start: (state, { self: self, system: system, emit: emit })=>{
            // TODO: determine how to allow customizing this so that promises
            // can be restarted if necessary
            if (state.status !== 'active') return;
            const controller = new AbortController();
            $ae4bc4d1d8af478f$var$controllerMap.set(self, controller);
            const resolvedPromise = Promise.resolve(promiseCreator({
                input: state.input,
                system: system,
                self: self,
                signal: controller.signal,
                emit: emit
            }));
            resolvedPromise.then((response)=>{
                if (self.getSnapshot().status !== 'active') return;
                $ae4bc4d1d8af478f$var$controllerMap.delete(self);
                system._relay(self, self, {
                    type: $ae4bc4d1d8af478f$var$XSTATE_PROMISE_RESOLVE,
                    data: response
                });
            }, (errorData)=>{
                if (self.getSnapshot().status !== 'active') return;
                $ae4bc4d1d8af478f$var$controllerMap.delete(self);
                system._relay(self, self, {
                    type: $ae4bc4d1d8af478f$var$XSTATE_PROMISE_REJECT,
                    data: errorData
                });
            });
        },
        getInitialSnapshot: (_, input)=>{
            return {
                status: 'active',
                output: undefined,
                error: undefined,
                input: input
            };
        },
        getPersistedSnapshot: (snapshot)=>snapshot,
        restoreSnapshot: (snapshot)=>snapshot
    };
    return logic;
}
const $ae4bc4d1d8af478f$var$emptyLogic = $ae4bc4d1d8af478f$export$439a4be7208a15ca((_)=>undefined, undefined);
function $ae4bc4d1d8af478f$export$302970cd5518279b() {
    return (0, $96dZ7.A)($ae4bc4d1d8af478f$var$emptyLogic);
}
module.exports["fromCallback"] = $ae4bc4d1d8af478f$export$d0deb4828877173;
module.exports["fromObservable"] = $ae4bc4d1d8af478f$export$4b2432e2d8723823;
module.exports["fromPromise"] = $ae4bc4d1d8af478f$export$60f45028237c39d1;

});

parcelRegister("96dZ7", function(module, exports) {

var $e6Soq = parcelRequire("e6Soq");

class $69ff85b27d828958$var$Mailbox {
    start() {
        this._active = true;
        this.flush();
    }
    clear() {
        // we can't set _current to null because we might be currently processing
        // and enqueue following clear shouldnt start processing the enqueued item immediately
        if (this._current) {
            this._current.next = null;
            this._last = this._current;
        }
    }
    enqueue(event) {
        const enqueued = {
            value: event,
            next: null
        };
        if (this._current) {
            this._last.next = enqueued;
            this._last = enqueued;
            return;
        }
        this._current = enqueued;
        this._last = enqueued;
        if (this._active) this.flush();
    }
    flush() {
        while(this._current){
            // atm the given _process is responsible for implementing proper try/catch handling
            // we assume here that this won't throw in a way that can affect this mailbox
            const consumed = this._current;
            this._process(consumed.value);
            this._current = consumed.next;
        }
        this._last = null;
    }
    constructor(_process){
        this._process = _process;
        this._active = false;
        this._current = null;
        this._last = null;
    }
}
const $69ff85b27d828958$export$25ce5a424b770e84 = '.';
const $69ff85b27d828958$var$TARGETLESS_KEY = '';
const $69ff85b27d828958$export$a07804094c3ecf2d = '';
const $69ff85b27d828958$var$STATE_IDENTIFIER = '#';
const $69ff85b27d828958$var$WILDCARD = '*';
const $69ff85b27d828958$var$XSTATE_INIT = 'xstate.init';
const $69ff85b27d828958$export$e7c866399fa523f5 = 'xstate.error';
const $69ff85b27d828958$export$78acf4525d8a74c4 = 'xstate.stop';
/**
 * Returns an event that represents an implicit event that is sent after the
 * specified `delay`.
 *
 * @param delayRef The delay in milliseconds
 * @param id The state node ID where this event is handled
 */ function $69ff85b27d828958$var$createAfterEvent(delayRef, id) {
    return {
        type: `xstate.after.${delayRef}.${id}`
    };
}
/**
 * Returns an event that represents that a final state node has been reached in
 * the parent state node.
 *
 * @param id The final state node's parent state node `id`
 * @param output The data to pass into the event
 */ function $69ff85b27d828958$var$createDoneStateEvent(id, output) {
    return {
        type: `xstate.done.state.${id}`,
        output: output
    };
}
/**
 * Returns an event that represents that an invoked service has terminated.
 *
 * An invoked service is terminated when it has reached a top-level final state
 * node, but not when it is canceled.
 *
 * @param invokeId The invoked service ID
 * @param output The data to pass into the event
 */ function $69ff85b27d828958$var$createDoneActorEvent(invokeId, output) {
    return {
        type: `xstate.done.actor.${invokeId}`,
        output: output,
        actorId: invokeId
    };
}
function $69ff85b27d828958$export$71cec2538cb2c617(id, error) {
    return {
        type: `xstate.error.actor.${id}`,
        error: error,
        actorId: id
    };
}
function $69ff85b27d828958$export$9e5f44173e64f162(input) {
    return {
        type: $69ff85b27d828958$var$XSTATE_INIT,
        input: input
    };
}
/**
 * This function makes sure that unhandled errors are thrown in a separate
 * macrotask. It allows those errors to be detected by global error handlers and
 * reported to bug tracking services without interrupting our own stack of
 * execution.
 *
 * @param err Error to be thrown
 */ function $69ff85b27d828958$var$reportUnhandledError(err) {
    setTimeout(()=>{
        throw err;
    });
}
const $69ff85b27d828958$var$symbolObservable = (()=>typeof Symbol === 'function' && Symbol.observable || '@@observable')();
function $69ff85b27d828958$export$b4171a6734a65d42(parentStateId, childStateId) {
    const parentStateValue = $69ff85b27d828958$var$toStateValue(parentStateId);
    const childStateValue = $69ff85b27d828958$var$toStateValue(childStateId);
    if (typeof childStateValue === 'string') {
        if (typeof parentStateValue === 'string') return childStateValue === parentStateValue;
        // Parent more specific than child
        return false;
    }
    if (typeof parentStateValue === 'string') return parentStateValue in childStateValue;
    return Object.keys(parentStateValue).every((key)=>{
        if (!(key in childStateValue)) return false;
        return $69ff85b27d828958$export$b4171a6734a65d42(parentStateValue[key], childStateValue[key]);
    });
}
function $69ff85b27d828958$export$90a7f3efeed30595(stateId) {
    if ($69ff85b27d828958$var$isArray(stateId)) return stateId;
    const result = [];
    let segment = '';
    for(let i = 0; i < stateId.length; i++){
        const char = stateId.charCodeAt(i);
        switch(char){
            // \
            case 92:
                // consume the next character
                segment += stateId[i + 1];
                // and skip over it
                i++;
                continue;
            // .
            case 46:
                result.push(segment);
                segment = '';
                continue;
        }
        segment += stateId[i];
    }
    result.push(segment);
    return result;
}
function $69ff85b27d828958$var$toStateValue(stateValue) {
    if ($69ff85b27d828958$export$7f8ddf7c7c20b3cd(stateValue)) return stateValue.value;
    if (typeof stateValue !== 'string') return stateValue;
    const statePath = $69ff85b27d828958$export$90a7f3efeed30595(stateValue);
    return $69ff85b27d828958$export$3466f893ebf79586(statePath);
}
function $69ff85b27d828958$export$3466f893ebf79586(statePath) {
    if (statePath.length === 1) return statePath[0];
    const value = {};
    let marker = value;
    for(let i = 0; i < statePath.length - 1; i++)if (i === statePath.length - 2) marker[statePath[i]] = statePath[i + 1];
    else {
        const previous = marker;
        marker = {};
        previous[statePath[i]] = marker;
    }
    return value;
}
function $69ff85b27d828958$export$953cecd6e717a553(collection, iteratee) {
    const result = {};
    const collectionKeys = Object.keys(collection);
    for(let i = 0; i < collectionKeys.length; i++){
        const key = collectionKeys[i];
        result[key] = iteratee(collection[key], key, collection, i);
    }
    return result;
}
function $69ff85b27d828958$var$toArrayStrict(value) {
    if ($69ff85b27d828958$var$isArray(value)) return value;
    return [
        value
    ];
}
function $69ff85b27d828958$export$625550452a3fa3ec(value) {
    if (value === undefined) return [];
    return $69ff85b27d828958$var$toArrayStrict(value);
}
function $69ff85b27d828958$var$resolveOutput(mapper, context, event, self) {
    if (typeof mapper === 'function') return mapper({
        context: context,
        event: event,
        self: self
    });
    return mapper;
}
function $69ff85b27d828958$var$isArray(value) {
    return Array.isArray(value);
}
function $69ff85b27d828958$var$isErrorActorEvent(event) {
    return event.type.startsWith('xstate.error.actor');
}
function $69ff85b27d828958$export$407448d2b89b1813(configLike) {
    return $69ff85b27d828958$var$toArrayStrict(configLike).map((transitionLike)=>{
        if (typeof transitionLike === 'undefined' || typeof transitionLike === 'string') return {
            target: transitionLike
        };
        return transitionLike;
    });
}
function $69ff85b27d828958$var$normalizeTarget(target) {
    if (target === undefined || target === $69ff85b27d828958$var$TARGETLESS_KEY) return undefined;
    return $69ff85b27d828958$export$625550452a3fa3ec(target);
}
function $69ff85b27d828958$export$61196ced6d74a310(nextHandler, errorHandler, completionHandler) {
    const isObserver = typeof nextHandler === 'object';
    const self = isObserver ? nextHandler : undefined;
    return {
        next: (isObserver ? nextHandler.next : nextHandler)?.bind(self),
        error: (isObserver ? nextHandler.error : errorHandler)?.bind(self),
        complete: (isObserver ? nextHandler.complete : completionHandler)?.bind(self)
    };
}
function $69ff85b27d828958$export$db3b6bfb95261072(stateNodeId, index) {
    return `${index}.${stateNodeId}`;
}
function $69ff85b27d828958$export$df995fae86a55f06(machine, src) {
    const match = src.match(/^xstate\.invoke\.(\d+)\.(.*)/);
    if (!match) return machine.implementations.actors[src];
    const [, indexStr, nodeId] = match;
    const node = machine.getStateNodeById(nodeId);
    const invokeConfig = node.config.invoke;
    return (Array.isArray(invokeConfig) ? invokeConfig[indexStr] : invokeConfig).src;
}
function $69ff85b27d828958$export$9bb611d729802a56(snapshot) {
    return [
        ...new Set([
            ...snapshot._nodes.flatMap((sn)=>sn.ownEvents)
        ])
    ];
}
function $69ff85b27d828958$var$createScheduledEventId(actorRef, id) {
    return `${actorRef.sessionId}.${id}`;
}
let $69ff85b27d828958$var$idCounter = 0;
function $69ff85b27d828958$var$createSystem(rootActor, options) {
    const children = new Map();
    const keyedActors = new Map();
    const reverseKeyedActors = new WeakMap();
    const inspectionObservers = new Set();
    const timerMap = {};
    const { clock: clock, logger: logger } = options;
    const scheduler = {
        schedule: (source, target, event, delay, id = Math.random().toString(36).slice(2))=>{
            const scheduledEvent = {
                source: source,
                target: target,
                event: event,
                delay: delay,
                id: id,
                startedAt: Date.now()
            };
            const scheduledEventId = $69ff85b27d828958$var$createScheduledEventId(source, id);
            system._snapshot._scheduledEvents[scheduledEventId] = scheduledEvent;
            const timeout = clock.setTimeout(()=>{
                delete timerMap[scheduledEventId];
                delete system._snapshot._scheduledEvents[scheduledEventId];
                system._relay(source, target, event);
            }, delay);
            timerMap[scheduledEventId] = timeout;
        },
        cancel: (source, id)=>{
            const scheduledEventId = $69ff85b27d828958$var$createScheduledEventId(source, id);
            const timeout = timerMap[scheduledEventId];
            delete timerMap[scheduledEventId];
            delete system._snapshot._scheduledEvents[scheduledEventId];
            if (timeout !== undefined) clock.clearTimeout(timeout);
        },
        cancelAll: (actorRef)=>{
            for(const scheduledEventId in system._snapshot._scheduledEvents){
                const scheduledEvent = system._snapshot._scheduledEvents[scheduledEventId];
                if (scheduledEvent.source === actorRef) scheduler.cancel(actorRef, scheduledEvent.id);
            }
        }
    };
    const sendInspectionEvent = (event)=>{
        if (!inspectionObservers.size) return;
        const resolvedInspectionEvent = {
            ...event,
            rootId: rootActor.sessionId
        };
        inspectionObservers.forEach((observer)=>observer.next?.(resolvedInspectionEvent));
    };
    const system = {
        _snapshot: {
            _scheduledEvents: (options?.snapshot && options.snapshot.scheduler) ?? {}
        },
        _bookId: ()=>`x:${$69ff85b27d828958$var$idCounter++}`,
        _register: (sessionId, actorRef)=>{
            children.set(sessionId, actorRef);
            return sessionId;
        },
        _unregister: (actorRef)=>{
            children.delete(actorRef.sessionId);
            const systemId = reverseKeyedActors.get(actorRef);
            if (systemId !== undefined) {
                keyedActors.delete(systemId);
                reverseKeyedActors.delete(actorRef);
            }
        },
        get: (systemId)=>{
            return keyedActors.get(systemId);
        },
        _set: (systemId, actorRef)=>{
            const existing = keyedActors.get(systemId);
            if (existing && existing !== actorRef) throw new Error(`Actor with system ID '${systemId}' already exists.`);
            keyedActors.set(systemId, actorRef);
            reverseKeyedActors.set(actorRef, systemId);
        },
        inspect: (observerOrFn)=>{
            const observer = $69ff85b27d828958$export$61196ced6d74a310(observerOrFn);
            inspectionObservers.add(observer);
            return {
                unsubscribe () {
                    inspectionObservers.delete(observer);
                }
            };
        },
        _sendInspectionEvent: sendInspectionEvent,
        _relay: (source, target, event)=>{
            system._sendInspectionEvent({
                type: '@xstate.event',
                sourceRef: source,
                actorRef: target,
                event: event
            });
            target._send(event);
        },
        scheduler: scheduler,
        getSnapshot: ()=>{
            return {
                _scheduledEvents: {
                    ...system._snapshot._scheduledEvents
                }
            };
        },
        start: ()=>{
            const scheduledEvents = system._snapshot._scheduledEvents;
            system._snapshot._scheduledEvents = {};
            for(const scheduledId in scheduledEvents){
                const { source: source, target: target, event: event, delay: delay, id: id } = scheduledEvents[scheduledId];
                scheduler.schedule(source, target, event, delay, id);
            }
        },
        _clock: clock,
        _logger: logger
    };
    return system;
}
let $69ff85b27d828958$var$executingCustomAction = false;
const $69ff85b27d828958$export$3d8c2f653ac9d0b9 = 1;
// those values are currently used by @xstate/react directly so it's important to keep the assigned values in sync
let $69ff85b27d828958$export$971d5caa766a69d7 = /*#__PURE__*/ function(ProcessingStatus) {
    ProcessingStatus[ProcessingStatus["NotStarted"] = 0] = "NotStarted";
    ProcessingStatus[ProcessingStatus["Running"] = 1] = "Running";
    ProcessingStatus[ProcessingStatus["Stopped"] = 2] = "Stopped";
    return ProcessingStatus;
}({});
const $69ff85b27d828958$var$defaultOptions = {
    clock: {
        setTimeout: (fn, ms)=>{
            return setTimeout(fn, ms);
        },
        clearTimeout: (id)=>{
            return clearTimeout(id);
        }
    },
    logger: console.log.bind(console),
    devTools: false
};
/**
 * An Actor is a running process that can receive events, send events and change
 * its behavior based on the events it receives, which can cause effects outside
 * of the actor. When you run a state machine, it becomes an actor.
 */ class $69ff85b27d828958$export$ef35774e6d314e91 {
    _initState(persistedState) {
        try {
            this._snapshot = persistedState ? this.logic.restoreSnapshot ? this.logic.restoreSnapshot(persistedState, this._actorScope) : persistedState : this.logic.getInitialSnapshot(this._actorScope, this.options?.input);
        } catch (err) {
            // if we get here then it means that we assign a value to this._snapshot that is not of the correct type
            // we can't get the true `TSnapshot & { status: 'error'; }`, it's impossible
            // so right now this is a lie of sorts
            this._snapshot = {
                status: 'error',
                output: undefined,
                error: err
            };
        }
    }
    update(snapshot, event) {
        // Update state
        this._snapshot = snapshot;
        // Execute deferred effects
        let deferredFn;
        while(deferredFn = this._deferred.shift())try {
            deferredFn();
        } catch (err) {
            // this error can only be caught when executing *initial* actions
            // it's the only time when we call actions provided by the user through those deferreds
            // when the actor is already running we always execute them synchronously while transitioning
            // no "builtin deferred" should actually throw an error since they are either safe
            // or the control flow is passed through the mailbox and errors should be caught by the `_process` used by the mailbox
            this._deferred.length = 0;
            this._snapshot = {
                ...snapshot,
                status: 'error',
                error: err
            };
        }
        switch(this._snapshot.status){
            case 'active':
                for (const observer of this.observers)try {
                    observer.next?.(snapshot);
                } catch (err) {
                    $69ff85b27d828958$var$reportUnhandledError(err);
                }
                break;
            case 'done':
                // next observers are meant to be notified about done snapshots
                // this can be seen as something that is different from how observable work
                // but with observables `complete` callback is called without any arguments
                // it's more ergonomic for XState to treat a done snapshot as a "next" value
                // and the completion event as something that is separate,
                // something that merely follows emitting that done snapshot
                for (const observer of this.observers)try {
                    observer.next?.(snapshot);
                } catch (err) {
                    $69ff85b27d828958$var$reportUnhandledError(err);
                }
                this._stopProcedure();
                this._complete();
                this._doneEvent = $69ff85b27d828958$var$createDoneActorEvent(this.id, this._snapshot.output);
                if (this._parent) this.system._relay(this, this._parent, this._doneEvent);
                break;
            case 'error':
                this._error(this._snapshot.error);
                break;
        }
        this.system._sendInspectionEvent({
            type: '@xstate.snapshot',
            actorRef: this,
            event: event,
            snapshot: snapshot
        });
    }
    /**
   * Subscribe an observer to an actor’s snapshot values.
   *
   * @remarks
   * The observer will receive the actor’s snapshot value when it is emitted.
   * The observer can be:
   *
   * - A plain function that receives the latest snapshot, or
   * - An observer object whose `.next(snapshot)` method receives the latest
   *   snapshot
   *
   * @example
   *
   * ```ts
   * // Observer as a plain function
   * const subscription = actor.subscribe((snapshot) => {
   *   console.log(snapshot);
   * });
   * ```
   *
   * @example
   *
   * ```ts
   * // Observer as an object
   * const subscription = actor.subscribe({
   *   next(snapshot) {
   *     console.log(snapshot);
   *   },
   *   error(err) {
   *     // ...
   *   },
   *   complete() {
   *     // ...
   *   }
   * });
   * ```
   *
   * The return value of `actor.subscribe(observer)` is a subscription object
   * that has an `.unsubscribe()` method. You can call
   * `subscription.unsubscribe()` to unsubscribe the observer:
   *
   * @example
   *
   * ```ts
   * const subscription = actor.subscribe((snapshot) => {
   *   // ...
   * });
   *
   * // Unsubscribe the observer
   * subscription.unsubscribe();
   * ```
   *
   * When the actor is stopped, all of its observers will automatically be
   * unsubscribed.
   *
   * @param observer - Either a plain function that receives the latest
   *   snapshot, or an observer object whose `.next(snapshot)` method receives
   *   the latest snapshot
   */ subscribe(nextListenerOrObserver, errorListener, completeListener) {
        const observer = $69ff85b27d828958$export$61196ced6d74a310(nextListenerOrObserver, errorListener, completeListener);
        if (this._processingStatus !== $69ff85b27d828958$export$971d5caa766a69d7.Stopped) this.observers.add(observer);
        else switch(this._snapshot.status){
            case 'done':
                try {
                    observer.complete?.();
                } catch (err) {
                    $69ff85b27d828958$var$reportUnhandledError(err);
                }
                break;
            case 'error':
                {
                    const err = this._snapshot.error;
                    if (!observer.error) $69ff85b27d828958$var$reportUnhandledError(err);
                    else try {
                        observer.error(err);
                    } catch (err) {
                        $69ff85b27d828958$var$reportUnhandledError(err);
                    }
                    break;
                }
        }
        return {
            unsubscribe: ()=>{
                this.observers.delete(observer);
            }
        };
    }
    on(type, handler) {
        let listeners = this.eventListeners.get(type);
        if (!listeners) {
            listeners = new Set();
            this.eventListeners.set(type, listeners);
        }
        const wrappedHandler = handler.bind(undefined);
        listeners.add(wrappedHandler);
        return {
            unsubscribe: ()=>{
                listeners.delete(wrappedHandler);
            }
        };
    }
    /** Starts the Actor from the initial state */ start() {
        if (this._processingStatus === $69ff85b27d828958$export$971d5caa766a69d7.Running) // Do not restart the service if it is already started
        return this;
        if (this._syncSnapshot) this.subscribe({
            next: (snapshot)=>{
                if (snapshot.status === 'active') this.system._relay(this, this._parent, {
                    type: `xstate.snapshot.${this.id}`,
                    snapshot: snapshot
                });
            },
            error: ()=>{}
        });
        this.system._register(this.sessionId, this);
        if (this._systemId) this.system._set(this._systemId, this);
        this._processingStatus = $69ff85b27d828958$export$971d5caa766a69d7.Running;
        // TODO: this isn't correct when rehydrating
        const initEvent = $69ff85b27d828958$export$9e5f44173e64f162(this.options.input);
        this.system._sendInspectionEvent({
            type: '@xstate.event',
            sourceRef: this._parent,
            actorRef: this,
            event: initEvent
        });
        const status = this._snapshot.status;
        switch(status){
            case 'done':
                // a state machine can be "done" upon initialization (it could reach a final state using initial microsteps)
                // we still need to complete observers, flush deferreds etc
                this.update(this._snapshot, initEvent);
                // TODO: rethink cleanup of observers, mailbox, etc
                return this;
            case 'error':
                this._error(this._snapshot.error);
                return this;
        }
        if (!this._parent) this.system.start();
        if (this.logic.start) try {
            this.logic.start(this._snapshot, this._actorScope);
        } catch (err) {
            this._snapshot = {
                ...this._snapshot,
                status: 'error',
                error: err
            };
            this._error(err);
            return this;
        }
        // TODO: this notifies all subscribers but usually this is redundant
        // there is no real change happening here
        // we need to rethink if this needs to be refactored
        this.update(this._snapshot, initEvent);
        if (this.options.devTools) this.attachDevTools();
        this.mailbox.start();
        return this;
    }
    _process(event) {
        let nextState;
        let caughtError;
        try {
            nextState = this.logic.transition(this._snapshot, event, this._actorScope);
        } catch (err) {
            // we wrap it in a box so we can rethrow it later even if falsy value gets caught here
            caughtError = {
                err: err
            };
        }
        if (caughtError) {
            const { err: err } = caughtError;
            this._snapshot = {
                ...this._snapshot,
                status: 'error',
                error: err
            };
            this._error(err);
            return;
        }
        this.update(nextState, event);
        if (event.type === $69ff85b27d828958$export$78acf4525d8a74c4) {
            this._stopProcedure();
            this._complete();
        }
    }
    _stop() {
        if (this._processingStatus === $69ff85b27d828958$export$971d5caa766a69d7.Stopped) return this;
        this.mailbox.clear();
        if (this._processingStatus === $69ff85b27d828958$export$971d5caa766a69d7.NotStarted) {
            this._processingStatus = $69ff85b27d828958$export$971d5caa766a69d7.Stopped;
            return this;
        }
        this.mailbox.enqueue({
            type: $69ff85b27d828958$export$78acf4525d8a74c4
        });
        return this;
    }
    /** Stops the Actor and unsubscribe all listeners. */ stop() {
        if (this._parent) throw new Error('A non-root actor cannot be stopped directly.');
        return this._stop();
    }
    _complete() {
        for (const observer of this.observers)try {
            observer.complete?.();
        } catch (err) {
            $69ff85b27d828958$var$reportUnhandledError(err);
        }
        this.observers.clear();
    }
    _reportError(err) {
        if (!this.observers.size) {
            if (!this._parent) $69ff85b27d828958$var$reportUnhandledError(err);
            return;
        }
        let reportError = false;
        for (const observer of this.observers){
            const errorListener = observer.error;
            reportError || (reportError = !errorListener);
            try {
                errorListener?.(err);
            } catch (err2) {
                $69ff85b27d828958$var$reportUnhandledError(err2);
            }
        }
        this.observers.clear();
        if (reportError) $69ff85b27d828958$var$reportUnhandledError(err);
    }
    _error(err) {
        this._stopProcedure();
        this._reportError(err);
        if (this._parent) this.system._relay(this, this._parent, $69ff85b27d828958$export$71cec2538cb2c617(this.id, err));
    }
    // TODO: atm children don't belong entirely to the actor so
    // in a way - it's not even super aware of them
    // so we can't stop them from here but we really should!
    // right now, they are being stopped within the machine's transition
    // but that could throw and leave us with "orphaned" active actors
    _stopProcedure() {
        if (this._processingStatus !== $69ff85b27d828958$export$971d5caa766a69d7.Running) // Actor already stopped; do nothing
        return this;
        // Cancel all delayed events
        this.system.scheduler.cancelAll(this);
        // TODO: mailbox.reset
        this.mailbox.clear();
        // TODO: after `stop` we must prepare ourselves for receiving events again
        // events sent *after* stop signal must be queued
        // it seems like this should be the common behavior for all of our consumers
        // so perhaps this should be unified somehow for all of them
        this.mailbox = new $69ff85b27d828958$var$Mailbox(this._process.bind(this));
        this._processingStatus = $69ff85b27d828958$export$971d5caa766a69d7.Stopped;
        this.system._unregister(this);
        return this;
    }
    /** @internal */ _send(event) {
        if (this._processingStatus === $69ff85b27d828958$export$971d5caa766a69d7.Stopped) return;
        this.mailbox.enqueue(event);
    }
    /**
   * Sends an event to the running Actor to trigger a transition.
   *
   * @param event The event to send
   */ send(event) {
        this.system._relay(undefined, this, event);
    }
    attachDevTools() {
        const { devTools: devTools } = this.options;
        if (devTools) {
            const resolvedDevToolsAdapter = typeof devTools === 'function' ? devTools : (0, $e6Soq.devToolsAdapter);
            resolvedDevToolsAdapter(this);
        }
    }
    toJSON() {
        return {
            xstate$$type: $69ff85b27d828958$export$3d8c2f653ac9d0b9,
            id: this.id
        };
    }
    /**
   * Obtain the internal state of the actor, which can be persisted.
   *
   * @remarks
   * The internal state can be persisted from any actor, not only machines.
   *
   * Note that the persisted state is not the same as the snapshot from
   * {@link Actor.getSnapshot}. Persisted state represents the internal state of
   * the actor, while snapshots represent the actor's last emitted value.
   *
   * Can be restored with {@link ActorOptions.state}
   * @see https://stately.ai/docs/persistence
   */ getPersistedSnapshot(options) {
        return this.logic.getPersistedSnapshot(this._snapshot, options);
    }
    [$69ff85b27d828958$var$symbolObservable]() {
        return this;
    }
    /**
   * Read an actor’s snapshot synchronously.
   *
   * @remarks
   * The snapshot represent an actor's last emitted value.
   *
   * When an actor receives an event, its internal state may change. An actor
   * may emit a snapshot when a state transition occurs.
   *
   * Note that some actors, such as callback actors generated with
   * `fromCallback`, will not emit snapshots.
   * @see {@link Actor.subscribe} to subscribe to an actor’s snapshot values.
   * @see {@link Actor.getPersistedSnapshot} to persist the internal state of an actor (which is more than just a snapshot).
   */ getSnapshot() {
        return this._snapshot;
    }
    /**
   * Creates a new actor instance for the given logic with the provided options,
   * if any.
   *
   * @param logic The logic to create an actor from
   * @param options Actor options
   */ constructor(logic, options){
        this.logic = logic;
        /** The current internal state of the actor. */ this._snapshot = void 0;
        /**
     * The clock that is responsible for setting and clearing timeouts, such as
     * delayed events and transitions.
     */ this.clock = void 0;
        this.options = void 0;
        /** The unique identifier for this actor relative to its parent. */ this.id = void 0;
        this.mailbox = new $69ff85b27d828958$var$Mailbox(this._process.bind(this));
        this.observers = new Set();
        this.eventListeners = new Map();
        this.logger = void 0;
        /** @internal */ this._processingStatus = $69ff85b27d828958$export$971d5caa766a69d7.NotStarted;
        // Actor Ref
        this._parent = void 0;
        /** @internal */ this._syncSnapshot = void 0;
        this.ref = void 0;
        // TODO: add typings for system
        this._actorScope = void 0;
        this._systemId = void 0;
        /** The globally unique process ID for this invocation. */ this.sessionId = void 0;
        /** The system to which this actor belongs. */ this.system = void 0;
        this._doneEvent = void 0;
        this.src = void 0;
        // array of functions to defer
        this._deferred = [];
        const resolvedOptions = {
            ...$69ff85b27d828958$var$defaultOptions,
            ...options
        };
        const { clock: clock, logger: logger, parent: parent, syncSnapshot: syncSnapshot, id: id, systemId: systemId, inspect: inspect } = resolvedOptions;
        this.system = parent ? parent.system : $69ff85b27d828958$var$createSystem(this, {
            clock: clock,
            logger: logger
        });
        if (inspect && !parent) // Always inspect at the system-level
        this.system.inspect($69ff85b27d828958$export$61196ced6d74a310(inspect));
        this.sessionId = this.system._bookId();
        this.id = id ?? this.sessionId;
        this.logger = options?.logger ?? this.system._logger;
        this.clock = options?.clock ?? this.system._clock;
        this._parent = parent;
        this._syncSnapshot = syncSnapshot;
        this.options = resolvedOptions;
        this.src = resolvedOptions.src ?? logic;
        this.ref = this;
        this._actorScope = {
            self: this,
            id: this.id,
            sessionId: this.sessionId,
            logger: this.logger,
            defer: (fn)=>{
                this._deferred.push(fn);
            },
            system: this.system,
            stopChild: (child)=>{
                if (child._parent !== this) throw new Error(`Cannot stop child actor ${child.id} of ${this.id} because it is not a child`);
                child._stop();
            },
            emit: (emittedEvent)=>{
                const listeners = this.eventListeners.get(emittedEvent.type);
                const wildcardListener = this.eventListeners.get('*');
                if (!listeners && !wildcardListener) return;
                const allListeners = [
                    ...listeners ? listeners.values() : [],
                    ...wildcardListener ? wildcardListener.values() : []
                ];
                for (const handler of allListeners)handler(emittedEvent);
            },
            actionExecutor: (action)=>{
                const exec = ()=>{
                    this._actorScope.system._sendInspectionEvent({
                        type: '@xstate.action',
                        actorRef: this,
                        action: {
                            type: action.type,
                            params: action.params
                        }
                    });
                    if (!action.exec) return;
                    const saveExecutingCustomAction = $69ff85b27d828958$var$executingCustomAction;
                    try {
                        $69ff85b27d828958$var$executingCustomAction = true;
                        action.exec(action.info, action.params);
                    } finally{
                        $69ff85b27d828958$var$executingCustomAction = saveExecutingCustomAction;
                    }
                };
                if (this._processingStatus === $69ff85b27d828958$export$971d5caa766a69d7.Running) exec();
                else this._deferred.push(exec);
            }
        };
        // Ensure that the send method is bound to this Actor instance
        // if destructured
        this.send = this.send.bind(this);
        this.system._sendInspectionEvent({
            type: '@xstate.actor',
            actorRef: this
        });
        if (systemId) {
            this._systemId = systemId;
            this.system._set(systemId, this);
        }
        this._initState(options?.snapshot ?? options?.state);
        if (systemId && this._snapshot.status !== 'active') this.system._unregister(this);
    }
}
/**
 * Creates a new actor instance for the given actor logic with the provided
 * options, if any.
 *
 * @remarks
 * When you create an actor from actor logic via `createActor(logic)`, you
 * implicitly create an actor system where the created actor is the root actor.
 * Any actors spawned from this root actor and its descendants are part of that
 * actor system.
 * @example
 *
 * ```ts
 * import { createActor } from 'xstate';
 * import { someActorLogic } from './someActorLogic.ts';
 *
 * // Creating the actor, which implicitly creates an actor system with itself as the root actor
 * const actor = createActor(someActorLogic);
 *
 * actor.subscribe((snapshot) => {
 *   console.log(snapshot);
 * });
 *
 * // Actors must be started by calling `actor.start()`, which will also start the actor system.
 * actor.start();
 *
 * // Actors can receive events
 * actor.send({ type: 'someEvent' });
 *
 * // You can stop root actors by calling `actor.stop()`, which will also stop the actor system and all actors in that system.
 * actor.stop();
 * ```
 *
 * @param logic - The actor logic to create an actor from. For a state machine
 *   actor logic creator, see {@link createMachine}. Other actor logic creators
 *   include {@link fromCallback}, {@link fromEventObservable},
 *   {@link fromObservable}, {@link fromPromise}, and {@link fromTransition}.
 * @param options - Actor options
 */ function $69ff85b27d828958$export$ebd11618f299a286(logic, ...[options]) {
    return new $69ff85b27d828958$export$ef35774e6d314e91(logic, options);
}
/**
 * Creates a new Interpreter instance for the given machine with the provided
 * options, if any.
 *
 * @deprecated Use `createActor` instead
 * @alias
 */ const $69ff85b27d828958$export$e7094788287c5e9b = $69ff85b27d828958$export$ebd11618f299a286;
/**
 * @deprecated Use `Actor` instead.
 * @alias
 */ function $69ff85b27d828958$var$resolveCancel(_, snapshot, actionArgs, actionParams, { sendId: sendId }) {
    const resolvedSendId = typeof sendId === 'function' ? sendId(actionArgs, actionParams) : sendId;
    return [
        snapshot,
        {
            sendId: resolvedSendId
        },
        undefined
    ];
}
function $69ff85b27d828958$var$executeCancel(actorScope, params) {
    actorScope.defer(()=>{
        actorScope.system.scheduler.cancel(actorScope.self, params.sendId);
    });
}
/**
 * Cancels a delayed `sendTo(...)` action that is waiting to be executed. The
 * canceled `sendTo(...)` action will not send its event or execute, unless the
 * `delay` has already elapsed before `cancel(...)` is called.
 *
 * @example
 *
 * ```ts
 * import { createMachine, sendTo, cancel } from 'xstate';
 *
 * const machine = createMachine({
 *   // ...
 *   on: {
 *     sendEvent: {
 *       actions: sendTo(
 *         'some-actor',
 *         { type: 'someEvent' },
 *         {
 *           id: 'some-id',
 *           delay: 1000
 *         }
 *       )
 *     },
 *     cancelEvent: {
 *       actions: cancel('some-id')
 *     }
 *   }
 * });
 * ```
 *
 * @param sendId The `id` of the `sendTo(...)` action to cancel.
 */ function $69ff85b27d828958$export$3a1a48c8f6ef640e(sendId) {
    function cancel(_args, _params) {}
    cancel.type = 'xstate.cancel';
    cancel.sendId = sendId;
    cancel.resolve = $69ff85b27d828958$var$resolveCancel;
    cancel.execute = $69ff85b27d828958$var$executeCancel;
    return cancel;
}
function $69ff85b27d828958$var$resolveSpawn(actorScope, snapshot, actionArgs, _actionParams, { id: id, systemId: systemId, src: src, input: input, syncSnapshot: syncSnapshot }) {
    const logic = typeof src === 'string' ? $69ff85b27d828958$export$df995fae86a55f06(snapshot.machine, src) : src;
    const resolvedId = typeof id === 'function' ? id(actionArgs) : id;
    let actorRef;
    let resolvedInput = undefined;
    if (logic) {
        resolvedInput = typeof input === 'function' ? input({
            context: snapshot.context,
            event: actionArgs.event,
            self: actorScope.self
        }) : input;
        actorRef = $69ff85b27d828958$export$ebd11618f299a286(logic, {
            id: resolvedId,
            src: src,
            parent: actorScope.self,
            syncSnapshot: syncSnapshot,
            systemId: systemId,
            input: resolvedInput
        });
    }
    return [
        $69ff85b27d828958$export$3a6d5c9ae78a2c08(snapshot, {
            children: {
                ...snapshot.children,
                [resolvedId]: actorRef
            }
        }),
        {
            id: id,
            systemId: systemId,
            actorRef: actorRef,
            src: src,
            input: resolvedInput
        },
        undefined
    ];
}
function $69ff85b27d828958$var$executeSpawn(actorScope, { actorRef: actorRef }) {
    if (!actorRef) return;
    actorScope.defer(()=>{
        if (actorRef._processingStatus === $69ff85b27d828958$export$971d5caa766a69d7.Stopped) return;
        actorRef.start();
    });
}
function $69ff85b27d828958$export$56c0d5a1e737357d(...[src, { id: id, systemId: systemId, input: input, syncSnapshot: syncSnapshot = false } = {}]) {
    function spawnChild1(_args, _params) {}
    spawnChild1.type = 'xstate.spawnChild';
    spawnChild1.id = id;
    spawnChild1.systemId = systemId;
    spawnChild1.src = src;
    spawnChild1.input = input;
    spawnChild1.syncSnapshot = syncSnapshot;
    spawnChild1.resolve = $69ff85b27d828958$var$resolveSpawn;
    spawnChild1.execute = $69ff85b27d828958$var$executeSpawn;
    return spawnChild1;
}
function $69ff85b27d828958$var$resolveStop(_, snapshot, args, actionParams, { actorRef: actorRef }) {
    const actorRefOrString = typeof actorRef === 'function' ? actorRef(args, actionParams) : actorRef;
    const resolvedActorRef = typeof actorRefOrString === 'string' ? snapshot.children[actorRefOrString] : actorRefOrString;
    let children = snapshot.children;
    if (resolvedActorRef) {
        children = {
            ...children
        };
        delete children[resolvedActorRef.id];
    }
    return [
        $69ff85b27d828958$export$3a6d5c9ae78a2c08(snapshot, {
            children: children
        }),
        resolvedActorRef,
        undefined
    ];
}
function $69ff85b27d828958$var$executeStop(actorScope, actorRef) {
    if (!actorRef) return;
    // we need to eagerly unregister it here so a new actor with the same systemId can be registered immediately
    // since we defer actual stopping of the actor but we don't defer actor creations (and we can't do that)
    // this could throw on `systemId` collision, for example, when dealing with reentering transitions
    actorScope.system._unregister(actorRef);
    // this allows us to prevent an actor from being started if it gets stopped within the same macrostep
    // this can happen, for example, when the invoking state is being exited immediately by an always transition
    if (actorRef._processingStatus !== $69ff85b27d828958$export$971d5caa766a69d7.Running) {
        actorScope.stopChild(actorRef);
        return;
    }
    // stopping a child enqueues a stop event in the child actor's mailbox
    // we need for all of the already enqueued events to be processed before we stop the child
    // the parent itself might want to send some events to a child (for example from exit actions on the invoking state)
    // and we don't want to ignore those events
    actorScope.defer(()=>{
        actorScope.stopChild(actorRef);
    });
}
/**
 * Stops a child actor.
 *
 * @param actorRef The actor to stop.
 */ function $69ff85b27d828958$export$db202ddc8be9136(actorRef) {
    function stop(_args, _params) {}
    stop.type = 'xstate.stopChild';
    stop.actorRef = actorRef;
    stop.resolve = $69ff85b27d828958$var$resolveStop;
    stop.execute = $69ff85b27d828958$var$executeStop;
    return stop;
}
/**
 * Stops a child actor.
 *
 * @deprecated Use `stopChild(...)` instead
 * @alias
 */ const $69ff85b27d828958$export$3722cfe417b6ed86 = $69ff85b27d828958$export$db202ddc8be9136;
function $69ff85b27d828958$var$checkStateIn(snapshot, _, { stateValue: stateValue }) {
    if (typeof stateValue === 'string' && $69ff85b27d828958$export$efccba1c4a2ef57b(stateValue)) {
        const target = snapshot.machine.getStateNodeById(stateValue);
        return snapshot._nodes.some((sn)=>sn === target);
    }
    return snapshot.matches(stateValue);
}
function $69ff85b27d828958$export$2329c99376c9d0a4(stateValue) {
    function stateIn() {
        return false;
    }
    stateIn.check = $69ff85b27d828958$var$checkStateIn;
    stateIn.stateValue = stateValue;
    return stateIn;
}
function $69ff85b27d828958$var$checkNot(snapshot, { context: context, event: event }, { guards: guards }) {
    return !$69ff85b27d828958$export$f1e1789686576879(guards[0], context, event, snapshot);
}
/**
 * Higher-order guard that evaluates to `true` if the `guard` passed to it
 * evaluates to `false`.
 *
 * @category Guards
 * @example
 *
 * ```ts
 * import { setup, not } from 'xstate';
 *
 * const machine = setup({
 *   guards: {
 *     someNamedGuard: () => false
 *   }
 * }).createMachine({
 *   on: {
 *     someEvent: {
 *       guard: not('someNamedGuard'),
 *       actions: () => {
 *         // will be executed if guard in `not(...)`
 *         // evaluates to `false`
 *       }
 *     }
 *   }
 * });
 * ```
 *
 * @returns A guard
 */ function $69ff85b27d828958$export$a9c23c6ac3fc3eca(guard) {
    function not(_args, _params) {
        return false;
    }
    not.check = $69ff85b27d828958$var$checkNot;
    not.guards = [
        guard
    ];
    return not;
}
function $69ff85b27d828958$var$checkAnd(snapshot, { context: context, event: event }, { guards: guards }) {
    return guards.every((guard)=>$69ff85b27d828958$export$f1e1789686576879(guard, context, event, snapshot));
}
/**
 * Higher-order guard that evaluates to `true` if all `guards` passed to it
 * evaluate to `true`.
 *
 * @category Guards
 * @example
 *
 * ```ts
 * import { setup, and } from 'xstate';
 *
 * const machine = setup({
 *   guards: {
 *     someNamedGuard: () => true
 *   }
 * }).createMachine({
 *   on: {
 *     someEvent: {
 *       guard: and([({ context }) => context.value > 0, 'someNamedGuard']),
 *       actions: () => {
 *         // will be executed if all guards in `and(...)`
 *         // evaluate to true
 *       }
 *     }
 *   }
 * });
 * ```
 *
 * @returns A guard action object
 */ function $69ff85b27d828958$export$96f57966bedc81b4(guards) {
    function and(_args, _params) {
        return false;
    }
    and.check = $69ff85b27d828958$var$checkAnd;
    and.guards = guards;
    return and;
}
function $69ff85b27d828958$var$checkOr(snapshot, { context: context, event: event }, { guards: guards }) {
    return guards.some((guard)=>$69ff85b27d828958$export$f1e1789686576879(guard, context, event, snapshot));
}
/**
 * Higher-order guard that evaluates to `true` if any of the `guards` passed to
 * it evaluate to `true`.
 *
 * @category Guards
 * @example
 *
 * ```ts
 * import { setup, or } from 'xstate';
 *
 * const machine = setup({
 *   guards: {
 *     someNamedGuard: () => true
 *   }
 * }).createMachine({
 *   on: {
 *     someEvent: {
 *       guard: or([({ context }) => context.value > 0, 'someNamedGuard']),
 *       actions: () => {
 *         // will be executed if any of the guards in `or(...)`
 *         // evaluate to true
 *       }
 *     }
 *   }
 * });
 * ```
 *
 * @returns A guard action object
 */ function $69ff85b27d828958$export$d66501df72047452(guards) {
    function or(_args, _params) {
        return false;
    }
    or.check = $69ff85b27d828958$var$checkOr;
    or.guards = guards;
    return or;
}
// TODO: throw on cycles (depth check should be enough)
function $69ff85b27d828958$export$f1e1789686576879(guard, context, event, snapshot) {
    const { machine: machine } = snapshot;
    const isInline = typeof guard === 'function';
    const resolved = isInline ? guard : machine.implementations.guards[typeof guard === 'string' ? guard : guard.type];
    if (!isInline && !resolved) throw new Error(`Guard '${typeof guard === 'string' ? guard : guard.type}' is not implemented.'.`);
    if (typeof resolved !== 'function') return $69ff85b27d828958$export$f1e1789686576879(resolved, context, event, snapshot);
    const guardArgs = {
        context: context,
        event: event
    };
    const guardParams = isInline || typeof guard === 'string' ? undefined : 'params' in guard ? typeof guard.params === 'function' ? guard.params({
        context: context,
        event: event
    }) : guard.params : undefined;
    if (!('check' in resolved)) // the existing type of `.guards` assumes non-nullable `TExpressionGuard`
    // inline guards expect `TExpressionGuard` to be set to `undefined`
    // it's fine to cast this here, our logic makes sure that we call those 2 "variants" correctly
    return resolved(guardArgs, guardParams);
    const builtinGuard = resolved;
    return builtinGuard.check(snapshot, guardArgs, resolved // this holds all params
    );
}
const $69ff85b27d828958$var$isAtomicStateNode = (stateNode)=>stateNode.type === 'atomic' || stateNode.type === 'final';
function $69ff85b27d828958$var$getChildren(stateNode) {
    return Object.values(stateNode.states).filter((sn)=>sn.type !== 'history');
}
function $69ff85b27d828958$var$getProperAncestors(stateNode, toStateNode) {
    const ancestors = [];
    if (toStateNode === stateNode) return ancestors;
    // add all ancestors
    let m = stateNode.parent;
    while(m && m !== toStateNode){
        ancestors.push(m);
        m = m.parent;
    }
    return ancestors;
}
function $69ff85b27d828958$export$23f2a1d2818174ef(stateNodes) {
    const nodeSet = new Set(stateNodes);
    const adjList = $69ff85b27d828958$var$getAdjList(nodeSet);
    // add descendants
    for (const s of nodeSet)// if previously active, add existing child nodes
    if (s.type === 'compound' && (!adjList.get(s) || !adjList.get(s).length)) $69ff85b27d828958$var$getInitialStateNodesWithTheirAncestors(s).forEach((sn)=>nodeSet.add(sn));
    else {
        if (s.type === 'parallel') for (const child of $69ff85b27d828958$var$getChildren(s)){
            if (child.type === 'history') continue;
            if (!nodeSet.has(child)) {
                const initialStates = $69ff85b27d828958$var$getInitialStateNodesWithTheirAncestors(child);
                for (const initialStateNode of initialStates)nodeSet.add(initialStateNode);
            }
        }
    }
    // add all ancestors
    for (const s of nodeSet){
        let m = s.parent;
        while(m){
            nodeSet.add(m);
            m = m.parent;
        }
    }
    return nodeSet;
}
function $69ff85b27d828958$var$getValueFromAdj(baseNode, adjList) {
    const childStateNodes = adjList.get(baseNode);
    if (!childStateNodes) return {}; // todo: fix?
    if (baseNode.type === 'compound') {
        const childStateNode = childStateNodes[0];
        if (childStateNode) {
            if ($69ff85b27d828958$var$isAtomicStateNode(childStateNode)) return childStateNode.key;
        } else return {};
    }
    const stateValue = {};
    for (const childStateNode of childStateNodes)stateValue[childStateNode.key] = $69ff85b27d828958$var$getValueFromAdj(childStateNode, adjList);
    return stateValue;
}
function $69ff85b27d828958$var$getAdjList(stateNodes) {
    const adjList = new Map();
    for (const s of stateNodes){
        if (!adjList.has(s)) adjList.set(s, []);
        if (s.parent) {
            if (!adjList.has(s.parent)) adjList.set(s.parent, []);
            adjList.get(s.parent).push(s);
        }
    }
    return adjList;
}
function $69ff85b27d828958$var$getStateValue(rootNode, stateNodes) {
    const config = $69ff85b27d828958$export$23f2a1d2818174ef(stateNodes);
    return $69ff85b27d828958$var$getValueFromAdj(rootNode, $69ff85b27d828958$var$getAdjList(config));
}
function $69ff85b27d828958$export$882b5998b3b9117c(stateNodeSet, stateNode) {
    if (stateNode.type === 'compound') return $69ff85b27d828958$var$getChildren(stateNode).some((s)=>s.type === 'final' && stateNodeSet.has(s));
    if (stateNode.type === 'parallel') return $69ff85b27d828958$var$getChildren(stateNode).every((sn)=>$69ff85b27d828958$export$882b5998b3b9117c(stateNodeSet, sn));
    return stateNode.type === 'final';
}
const $69ff85b27d828958$export$efccba1c4a2ef57b = (str)=>str[0] === $69ff85b27d828958$var$STATE_IDENTIFIER;
function $69ff85b27d828958$export$dda1d9f60106f0e9(stateNode, receivedEventType) {
    const candidates = stateNode.transitions.get(receivedEventType) || [
        ...stateNode.transitions.keys()
    ].filter((eventDescriptor)=>{
        // check if transition is a wildcard transition,
        // which matches any non-transient events
        if (eventDescriptor === $69ff85b27d828958$var$WILDCARD) return true;
        if (!eventDescriptor.endsWith('.*')) return false;
        const partialEventTokens = eventDescriptor.split('.');
        const eventTokens = receivedEventType.split('.');
        for(let tokenIndex = 0; tokenIndex < partialEventTokens.length; tokenIndex++){
            const partialEventToken = partialEventTokens[tokenIndex];
            const eventToken = eventTokens[tokenIndex];
            if (partialEventToken === '*') {
                const isLastToken = tokenIndex === partialEventTokens.length - 1;
                return isLastToken;
            }
            if (partialEventToken !== eventToken) return false;
        }
        return true;
    }).sort((a, b)=>b.length - a.length).flatMap((key)=>stateNode.transitions.get(key));
    return candidates;
}
/** All delayed transitions from the config. */ function $69ff85b27d828958$export$39b482c5e57630a8(stateNode) {
    const afterConfig = stateNode.config.after;
    if (!afterConfig) return [];
    const mutateEntryExit = (delay)=>{
        const afterEvent = $69ff85b27d828958$var$createAfterEvent(delay, stateNode.id);
        const eventType = afterEvent.type;
        stateNode.entry.push($69ff85b27d828958$export$c4ce752e73470fba(afterEvent, {
            id: eventType,
            delay: delay
        }));
        stateNode.exit.push($69ff85b27d828958$export$3a1a48c8f6ef640e(eventType));
        return eventType;
    };
    const delayedTransitions = Object.keys(afterConfig).flatMap((delay)=>{
        const configTransition = afterConfig[delay];
        const resolvedTransition = typeof configTransition === 'string' ? {
            target: configTransition
        } : configTransition;
        const resolvedDelay = Number.isNaN(+delay) ? delay : +delay;
        const eventType = mutateEntryExit(resolvedDelay);
        return $69ff85b27d828958$export$625550452a3fa3ec(resolvedTransition).map((transition)=>({
                ...transition,
                event: eventType,
                delay: resolvedDelay
            }));
    });
    return delayedTransitions.map((delayedTransition)=>{
        const { delay: delay } = delayedTransition;
        return {
            ...$69ff85b27d828958$export$8b22cf2602fb60ce(stateNode, delayedTransition.event, delayedTransition),
            delay: delay
        };
    });
}
function $69ff85b27d828958$export$8b22cf2602fb60ce(stateNode, descriptor, transitionConfig) {
    const normalizedTarget = $69ff85b27d828958$var$normalizeTarget(transitionConfig.target);
    const reenter = transitionConfig.reenter ?? false;
    const target = $69ff85b27d828958$var$resolveTarget(stateNode, normalizedTarget);
    const transition = {
        ...transitionConfig,
        actions: $69ff85b27d828958$export$625550452a3fa3ec(transitionConfig.actions),
        guard: transitionConfig.guard,
        target: target,
        source: stateNode,
        reenter: reenter,
        eventType: descriptor,
        toJSON: ()=>({
                ...transition,
                source: `#${stateNode.id}`,
                target: target ? target.map((t)=>`#${t.id}`) : undefined
            })
    };
    return transition;
}
function $69ff85b27d828958$export$2d1720544b23b823(stateNode) {
    const transitions = new Map();
    if (stateNode.config.on) for (const descriptor of Object.keys(stateNode.config.on)){
        if (descriptor === $69ff85b27d828958$export$a07804094c3ecf2d) throw new Error('Null events ("") cannot be specified as a transition key. Use `always: { ... }` instead.');
        const transitionsConfig = stateNode.config.on[descriptor];
        transitions.set(descriptor, $69ff85b27d828958$export$407448d2b89b1813(transitionsConfig).map((t)=>$69ff85b27d828958$export$8b22cf2602fb60ce(stateNode, descriptor, t)));
    }
    if (stateNode.config.onDone) {
        const descriptor = `xstate.done.state.${stateNode.id}`;
        transitions.set(descriptor, $69ff85b27d828958$export$407448d2b89b1813(stateNode.config.onDone).map((t)=>$69ff85b27d828958$export$8b22cf2602fb60ce(stateNode, descriptor, t)));
    }
    for (const invokeDef of stateNode.invoke){
        if (invokeDef.onDone) {
            const descriptor = `xstate.done.actor.${invokeDef.id}`;
            transitions.set(descriptor, $69ff85b27d828958$export$407448d2b89b1813(invokeDef.onDone).map((t)=>$69ff85b27d828958$export$8b22cf2602fb60ce(stateNode, descriptor, t)));
        }
        if (invokeDef.onError) {
            const descriptor = `xstate.error.actor.${invokeDef.id}`;
            transitions.set(descriptor, $69ff85b27d828958$export$407448d2b89b1813(invokeDef.onError).map((t)=>$69ff85b27d828958$export$8b22cf2602fb60ce(stateNode, descriptor, t)));
        }
        if (invokeDef.onSnapshot) {
            const descriptor = `xstate.snapshot.${invokeDef.id}`;
            transitions.set(descriptor, $69ff85b27d828958$export$407448d2b89b1813(invokeDef.onSnapshot).map((t)=>$69ff85b27d828958$export$8b22cf2602fb60ce(stateNode, descriptor, t)));
        }
    }
    for (const delayedTransition of stateNode.after){
        let existing = transitions.get(delayedTransition.eventType);
        if (!existing) {
            existing = [];
            transitions.set(delayedTransition.eventType, existing);
        }
        existing.push(delayedTransition);
    }
    return transitions;
}
function $69ff85b27d828958$export$4368d992c4eafac0(stateNode, _target) {
    const resolvedTarget = typeof _target === 'string' ? stateNode.states[_target] : _target ? stateNode.states[_target.target] : undefined;
    if (!resolvedTarget && _target) throw new Error(// eslint-disable-next-line @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-base-to-string
    `Initial state node "${_target}" not found on parent state node #${stateNode.id}`);
    const transition = {
        source: stateNode,
        actions: !_target || typeof _target === 'string' ? [] : $69ff85b27d828958$export$625550452a3fa3ec(_target.actions),
        eventType: null,
        reenter: false,
        target: resolvedTarget ? [
            resolvedTarget
        ] : [],
        toJSON: ()=>({
                ...transition,
                source: `#${stateNode.id}`,
                target: resolvedTarget ? [
                    `#${resolvedTarget.id}`
                ] : []
            })
    };
    return transition;
}
function $69ff85b27d828958$var$resolveTarget(stateNode, targets) {
    if (targets === undefined) // an undefined target signals that the state node should not transition from that state when receiving that event
    return undefined;
    return targets.map((target)=>{
        if (typeof target !== 'string') return target;
        if ($69ff85b27d828958$export$efccba1c4a2ef57b(target)) return stateNode.machine.getStateNodeById(target);
        const isInternalTarget = target[0] === $69ff85b27d828958$export$25ce5a424b770e84;
        // If internal target is defined on machine,
        // do not include machine key on target
        if (isInternalTarget && !stateNode.parent) return $69ff85b27d828958$export$d141bba7fdc215a3(stateNode, target.slice(1));
        const resolvedTarget = isInternalTarget ? stateNode.key + target : target;
        if (stateNode.parent) try {
            const targetStateNode = $69ff85b27d828958$export$d141bba7fdc215a3(stateNode.parent, resolvedTarget);
            return targetStateNode;
        } catch (err) {
            throw new Error(`Invalid transition definition for state node '${stateNode.id}':\n${err.message}`);
        }
        else throw new Error(`Invalid target: "${target}" is not a valid target from the root node. Did you mean ".${target}"?`);
    });
}
function $69ff85b27d828958$var$resolveHistoryDefaultTransition(stateNode) {
    const normalizedTarget = $69ff85b27d828958$var$normalizeTarget(stateNode.config.target);
    if (!normalizedTarget) return stateNode.parent.initial;
    return {
        target: normalizedTarget.map((t)=>typeof t === 'string' ? $69ff85b27d828958$export$d141bba7fdc215a3(stateNode.parent, t) : t)
    };
}
function $69ff85b27d828958$var$isHistoryNode(stateNode) {
    return stateNode.type === 'history';
}
function $69ff85b27d828958$var$getInitialStateNodesWithTheirAncestors(stateNode) {
    const states = $69ff85b27d828958$export$3b14a55fb2447963(stateNode);
    for (const initialState of states)for (const ancestor of $69ff85b27d828958$var$getProperAncestors(initialState, stateNode))states.add(ancestor);
    return states;
}
function $69ff85b27d828958$export$3b14a55fb2447963(stateNode) {
    const set = new Set();
    function iter(descStateNode) {
        if (set.has(descStateNode)) return;
        set.add(descStateNode);
        if (descStateNode.type === 'compound') iter(descStateNode.initial.target[0]);
        else if (descStateNode.type === 'parallel') for (const child of $69ff85b27d828958$var$getChildren(descStateNode))iter(child);
    }
    iter(stateNode);
    return set;
}
/** Returns the child state node from its relative `stateKey`, or throws. */ function $69ff85b27d828958$var$getStateNode(stateNode, stateKey) {
    if ($69ff85b27d828958$export$efccba1c4a2ef57b(stateKey)) return stateNode.machine.getStateNodeById(stateKey);
    if (!stateNode.states) throw new Error(`Unable to retrieve child state '${stateKey}' from '${stateNode.id}'; no child states exist.`);
    const result = stateNode.states[stateKey];
    if (!result) throw new Error(`Child state '${stateKey}' does not exist on '${stateNode.id}'`);
    return result;
}
/**
 * Returns the relative state node from the given `statePath`, or throws.
 *
 * @param statePath The string or string array relative path to the state node.
 */ function $69ff85b27d828958$export$d141bba7fdc215a3(stateNode, statePath) {
    if (typeof statePath === 'string' && $69ff85b27d828958$export$efccba1c4a2ef57b(statePath)) try {
        return stateNode.machine.getStateNodeById(statePath);
    } catch  {
    // try individual paths
    // throw e;
    }
    const arrayStatePath = $69ff85b27d828958$export$90a7f3efeed30595(statePath).slice();
    let currentStateNode = stateNode;
    while(arrayStatePath.length){
        const key = arrayStatePath.shift();
        if (!key.length) break;
        currentStateNode = $69ff85b27d828958$var$getStateNode(currentStateNode, key);
    }
    return currentStateNode;
}
/**
 * Returns the state nodes represented by the current state value.
 *
 * @param stateValue The state value or State instance
 */ function $69ff85b27d828958$export$35e795649ee09318(stateNode, stateValue) {
    if (typeof stateValue === 'string') {
        const childStateNode = stateNode.states[stateValue];
        if (!childStateNode) throw new Error(`State '${stateValue}' does not exist on '${stateNode.id}'`);
        return [
            stateNode,
            childStateNode
        ];
    }
    const childStateKeys = Object.keys(stateValue);
    const childStateNodes = childStateKeys.map((subStateKey)=>$69ff85b27d828958$var$getStateNode(stateNode, subStateKey)).filter(Boolean);
    return [
        stateNode.machine.root,
        stateNode
    ].concat(childStateNodes, childStateKeys.reduce((allSubStateNodes, subStateKey)=>{
        const subStateNode = $69ff85b27d828958$var$getStateNode(stateNode, subStateKey);
        if (!subStateNode) return allSubStateNodes;
        const subStateNodes = $69ff85b27d828958$export$35e795649ee09318(subStateNode, stateValue[subStateKey]);
        return allSubStateNodes.concat(subStateNodes);
    }, []));
}
function $69ff85b27d828958$var$transitionAtomicNode(stateNode, stateValue, snapshot, event) {
    const childStateNode = $69ff85b27d828958$var$getStateNode(stateNode, stateValue);
    const next = childStateNode.next(snapshot, event);
    if (!next || !next.length) return stateNode.next(snapshot, event);
    return next;
}
function $69ff85b27d828958$var$transitionCompoundNode(stateNode, stateValue, snapshot, event) {
    const subStateKeys = Object.keys(stateValue);
    const childStateNode = $69ff85b27d828958$var$getStateNode(stateNode, subStateKeys[0]);
    const next = $69ff85b27d828958$export$ae1af26003f05816(childStateNode, stateValue[subStateKeys[0]], snapshot, event);
    if (!next || !next.length) return stateNode.next(snapshot, event);
    return next;
}
function $69ff85b27d828958$var$transitionParallelNode(stateNode, stateValue, snapshot, event) {
    const allInnerTransitions = [];
    for (const subStateKey of Object.keys(stateValue)){
        const subStateValue = stateValue[subStateKey];
        if (!subStateValue) continue;
        const subStateNode = $69ff85b27d828958$var$getStateNode(stateNode, subStateKey);
        const innerTransitions = $69ff85b27d828958$export$ae1af26003f05816(subStateNode, subStateValue, snapshot, event);
        if (innerTransitions) allInnerTransitions.push(...innerTransitions);
    }
    if (!allInnerTransitions.length) return stateNode.next(snapshot, event);
    return allInnerTransitions;
}
function $69ff85b27d828958$export$ae1af26003f05816(stateNode, stateValue, snapshot, event) {
    // leaf node
    if (typeof stateValue === 'string') return $69ff85b27d828958$var$transitionAtomicNode(stateNode, stateValue, snapshot, event);
    // compound node
    if (Object.keys(stateValue).length === 1) return $69ff85b27d828958$var$transitionCompoundNode(stateNode, stateValue, snapshot, event);
    // parallel node
    return $69ff85b27d828958$var$transitionParallelNode(stateNode, stateValue, snapshot, event);
}
function $69ff85b27d828958$var$getHistoryNodes(stateNode) {
    return Object.keys(stateNode.states).map((key)=>stateNode.states[key]).filter((sn)=>sn.type === 'history');
}
function $69ff85b27d828958$var$isDescendant(childStateNode, parentStateNode) {
    let marker = childStateNode;
    while(marker.parent && marker.parent !== parentStateNode)marker = marker.parent;
    return marker.parent === parentStateNode;
}
function $69ff85b27d828958$var$hasIntersection(s1, s2) {
    const set1 = new Set(s1);
    const set2 = new Set(s2);
    for (const item of set1){
        if (set2.has(item)) return true;
    }
    for (const item of set2){
        if (set1.has(item)) return true;
    }
    return false;
}
function $69ff85b27d828958$var$removeConflictingTransitions(enabledTransitions, stateNodeSet, historyValue) {
    const filteredTransitions = new Set();
    for (const t1 of enabledTransitions){
        let t1Preempted = false;
        const transitionsToRemove = new Set();
        for (const t2 of filteredTransitions)if ($69ff85b27d828958$var$hasIntersection($69ff85b27d828958$var$computeExitSet([
            t1
        ], stateNodeSet, historyValue), $69ff85b27d828958$var$computeExitSet([
            t2
        ], stateNodeSet, historyValue))) {
            if ($69ff85b27d828958$var$isDescendant(t1.source, t2.source)) transitionsToRemove.add(t2);
            else {
                t1Preempted = true;
                break;
            }
        }
        if (!t1Preempted) {
            for (const t3 of transitionsToRemove)filteredTransitions.delete(t3);
            filteredTransitions.add(t1);
        }
    }
    return Array.from(filteredTransitions);
}
function $69ff85b27d828958$var$findLeastCommonAncestor(stateNodes) {
    const [head, ...tail] = stateNodes;
    for (const ancestor of $69ff85b27d828958$var$getProperAncestors(head, undefined)){
        if (tail.every((sn)=>$69ff85b27d828958$var$isDescendant(sn, ancestor))) return ancestor;
    }
}
function $69ff85b27d828958$var$getEffectiveTargetStates(transition, historyValue) {
    if (!transition.target) return [];
    const targets = new Set();
    for (const targetNode of transition.target)if ($69ff85b27d828958$var$isHistoryNode(targetNode)) {
        if (historyValue[targetNode.id]) for (const node of historyValue[targetNode.id])targets.add(node);
        else for (const node of $69ff85b27d828958$var$getEffectiveTargetStates($69ff85b27d828958$var$resolveHistoryDefaultTransition(targetNode), historyValue))targets.add(node);
    } else targets.add(targetNode);
    return [
        ...targets
    ];
}
function $69ff85b27d828958$var$getTransitionDomain(transition, historyValue) {
    const targetStates = $69ff85b27d828958$var$getEffectiveTargetStates(transition, historyValue);
    if (!targetStates) return;
    if (!transition.reenter && targetStates.every((target)=>target === transition.source || $69ff85b27d828958$var$isDescendant(target, transition.source))) return transition.source;
    const lca = $69ff85b27d828958$var$findLeastCommonAncestor(targetStates.concat(transition.source));
    if (lca) return lca;
    // at this point we know that it's a root transition since LCA couldn't be found
    if (transition.reenter) return;
    return transition.source.machine.root;
}
function $69ff85b27d828958$var$computeExitSet(transitions, stateNodeSet, historyValue) {
    const statesToExit = new Set();
    for (const t of transitions)if (t.target?.length) {
        const domain = $69ff85b27d828958$var$getTransitionDomain(t, historyValue);
        if (t.reenter && t.source === domain) statesToExit.add(domain);
        for (const stateNode of stateNodeSet)if ($69ff85b27d828958$var$isDescendant(stateNode, domain)) statesToExit.add(stateNode);
    }
    return [
        ...statesToExit
    ];
}
function $69ff85b27d828958$var$areStateNodeCollectionsEqual(prevStateNodes, nextStateNodeSet) {
    if (prevStateNodes.length !== nextStateNodeSet.size) return false;
    for (const node of prevStateNodes){
        if (!nextStateNodeSet.has(node)) return false;
    }
    return true;
}
/** https://www.w3.org/TR/scxml/#microstepProcedure */ function $69ff85b27d828958$export$2408f22a0fab9ae5(transitions, currentSnapshot, actorScope, event, isInitial, internalQueue) {
    if (!transitions.length) return currentSnapshot;
    const mutStateNodeSet = new Set(currentSnapshot._nodes);
    let historyValue = currentSnapshot.historyValue;
    const filteredTransitions = $69ff85b27d828958$var$removeConflictingTransitions(transitions, mutStateNodeSet, historyValue);
    let nextState = currentSnapshot;
    // Exit states
    if (!isInitial) [nextState, historyValue] = $69ff85b27d828958$var$exitStates(nextState, event, actorScope, filteredTransitions, mutStateNodeSet, historyValue, internalQueue, actorScope.actionExecutor);
    // Execute transition content
    nextState = $69ff85b27d828958$export$ffb5f4729a158638(nextState, event, actorScope, filteredTransitions.flatMap((t)=>t.actions), internalQueue, undefined);
    // Enter states
    nextState = $69ff85b27d828958$var$enterStates(nextState, event, actorScope, filteredTransitions, mutStateNodeSet, internalQueue, historyValue, isInitial);
    const nextStateNodes = [
        ...mutStateNodeSet
    ];
    if (nextState.status === 'done') nextState = $69ff85b27d828958$export$ffb5f4729a158638(nextState, event, actorScope, nextStateNodes.sort((a, b)=>b.order - a.order).flatMap((state)=>state.exit), internalQueue, undefined);
    // eslint-disable-next-line no-useless-catch
    try {
        if (historyValue === currentSnapshot.historyValue && $69ff85b27d828958$var$areStateNodeCollectionsEqual(currentSnapshot._nodes, mutStateNodeSet)) return nextState;
        return $69ff85b27d828958$export$3a6d5c9ae78a2c08(nextState, {
            _nodes: nextStateNodes,
            historyValue: historyValue
        });
    } catch (e) {
        // TODO: Refactor this once proper error handling is implemented.
        // See https://github.com/statelyai/rfcs/pull/4
        throw e;
    }
}
function $69ff85b27d828958$var$getMachineOutput(snapshot, event, actorScope, rootNode, rootCompletionNode) {
    if (rootNode.output === undefined) return;
    const doneStateEvent = $69ff85b27d828958$var$createDoneStateEvent(rootCompletionNode.id, rootCompletionNode.output !== undefined && rootCompletionNode.parent ? $69ff85b27d828958$var$resolveOutput(rootCompletionNode.output, snapshot.context, event, actorScope.self) : undefined);
    return $69ff85b27d828958$var$resolveOutput(rootNode.output, snapshot.context, doneStateEvent, actorScope.self);
}
function $69ff85b27d828958$var$enterStates(currentSnapshot, event, actorScope, filteredTransitions, mutStateNodeSet, internalQueue, historyValue, isInitial) {
    let nextSnapshot = currentSnapshot;
    const statesToEnter = new Set();
    // those are states that were directly targeted or indirectly targeted by the explicit target
    // in other words, those are states for which initial actions should be executed
    // when we target `#deep_child` initial actions of its ancestors shouldn't be executed
    const statesForDefaultEntry = new Set();
    $69ff85b27d828958$var$computeEntrySet(filteredTransitions, historyValue, statesForDefaultEntry, statesToEnter);
    // In the initial state, the root state node is "entered".
    if (isInitial) statesForDefaultEntry.add(currentSnapshot.machine.root);
    const completedNodes = new Set();
    for (const stateNodeToEnter of [
        ...statesToEnter
    ].sort((a, b)=>a.order - b.order)){
        mutStateNodeSet.add(stateNodeToEnter);
        const actions = [];
        // Add entry actions
        actions.push(...stateNodeToEnter.entry);
        for (const invokeDef of stateNodeToEnter.invoke)actions.push($69ff85b27d828958$export$56c0d5a1e737357d(invokeDef.src, {
            ...invokeDef,
            syncSnapshot: !!invokeDef.onSnapshot
        }));
        if (statesForDefaultEntry.has(stateNodeToEnter)) {
            const initialActions = stateNodeToEnter.initial.actions;
            actions.push(...initialActions);
        }
        nextSnapshot = $69ff85b27d828958$export$ffb5f4729a158638(nextSnapshot, event, actorScope, actions, internalQueue, stateNodeToEnter.invoke.map((invokeDef)=>invokeDef.id));
        if (stateNodeToEnter.type === 'final') {
            const parent = stateNodeToEnter.parent;
            let ancestorMarker = parent?.type === 'parallel' ? parent : parent?.parent;
            let rootCompletionNode = ancestorMarker || stateNodeToEnter;
            if (parent?.type === 'compound') internalQueue.push($69ff85b27d828958$var$createDoneStateEvent(parent.id, stateNodeToEnter.output !== undefined ? $69ff85b27d828958$var$resolveOutput(stateNodeToEnter.output, nextSnapshot.context, event, actorScope.self) : undefined));
            while(ancestorMarker?.type === 'parallel' && !completedNodes.has(ancestorMarker) && $69ff85b27d828958$export$882b5998b3b9117c(mutStateNodeSet, ancestorMarker)){
                completedNodes.add(ancestorMarker);
                internalQueue.push($69ff85b27d828958$var$createDoneStateEvent(ancestorMarker.id));
                rootCompletionNode = ancestorMarker;
                ancestorMarker = ancestorMarker.parent;
            }
            if (ancestorMarker) continue;
            nextSnapshot = $69ff85b27d828958$export$3a6d5c9ae78a2c08(nextSnapshot, {
                status: 'done',
                output: $69ff85b27d828958$var$getMachineOutput(nextSnapshot, event, actorScope, nextSnapshot.machine.root, rootCompletionNode)
            });
        }
    }
    return nextSnapshot;
}
function $69ff85b27d828958$var$computeEntrySet(transitions, historyValue, statesForDefaultEntry, statesToEnter) {
    for (const t of transitions){
        const domain = $69ff85b27d828958$var$getTransitionDomain(t, historyValue);
        for (const s of t.target || []){
            if (!$69ff85b27d828958$var$isHistoryNode(s) && // if the target is different than the source then it will *definitely* be entered
            (t.source !== s || // we know that the domain can't lie within the source
            // if it's different than the source then it's outside of it and it means that the target has to be entered as well
            t.source !== domain || // reentering transitions always enter the target, even if it's the source itself
            t.reenter)) {
                statesToEnter.add(s);
                statesForDefaultEntry.add(s);
            }
            $69ff85b27d828958$var$addDescendantStatesToEnter(s, historyValue, statesForDefaultEntry, statesToEnter);
        }
        const targetStates = $69ff85b27d828958$var$getEffectiveTargetStates(t, historyValue);
        for (const s of targetStates){
            const ancestors = $69ff85b27d828958$var$getProperAncestors(s, domain);
            if (domain?.type === 'parallel') ancestors.push(domain);
            $69ff85b27d828958$var$addAncestorStatesToEnter(statesToEnter, historyValue, statesForDefaultEntry, ancestors, !t.source.parent && t.reenter ? undefined : domain);
        }
    }
}
function $69ff85b27d828958$var$addDescendantStatesToEnter(stateNode, historyValue, statesForDefaultEntry, statesToEnter) {
    if ($69ff85b27d828958$var$isHistoryNode(stateNode)) {
        if (historyValue[stateNode.id]) {
            const historyStateNodes = historyValue[stateNode.id];
            for (const s of historyStateNodes){
                statesToEnter.add(s);
                $69ff85b27d828958$var$addDescendantStatesToEnter(s, historyValue, statesForDefaultEntry, statesToEnter);
            }
            for (const s of historyStateNodes)$69ff85b27d828958$var$addProperAncestorStatesToEnter(s, stateNode.parent, statesToEnter, historyValue, statesForDefaultEntry);
        } else {
            const historyDefaultTransition = $69ff85b27d828958$var$resolveHistoryDefaultTransition(stateNode);
            for (const s of historyDefaultTransition.target){
                statesToEnter.add(s);
                if (historyDefaultTransition === stateNode.parent?.initial) statesForDefaultEntry.add(stateNode.parent);
                $69ff85b27d828958$var$addDescendantStatesToEnter(s, historyValue, statesForDefaultEntry, statesToEnter);
            }
            for (const s of historyDefaultTransition.target)$69ff85b27d828958$var$addProperAncestorStatesToEnter(s, stateNode.parent, statesToEnter, historyValue, statesForDefaultEntry);
        }
    } else {
        if (stateNode.type === 'compound') {
            const [initialState] = stateNode.initial.target;
            if (!$69ff85b27d828958$var$isHistoryNode(initialState)) {
                statesToEnter.add(initialState);
                statesForDefaultEntry.add(initialState);
            }
            $69ff85b27d828958$var$addDescendantStatesToEnter(initialState, historyValue, statesForDefaultEntry, statesToEnter);
            $69ff85b27d828958$var$addProperAncestorStatesToEnter(initialState, stateNode, statesToEnter, historyValue, statesForDefaultEntry);
        } else if (stateNode.type === 'parallel') {
            for (const child of $69ff85b27d828958$var$getChildren(stateNode).filter((sn)=>!$69ff85b27d828958$var$isHistoryNode(sn)))if (![
                ...statesToEnter
            ].some((s)=>$69ff85b27d828958$var$isDescendant(s, child))) {
                if (!$69ff85b27d828958$var$isHistoryNode(child)) {
                    statesToEnter.add(child);
                    statesForDefaultEntry.add(child);
                }
                $69ff85b27d828958$var$addDescendantStatesToEnter(child, historyValue, statesForDefaultEntry, statesToEnter);
            }
        }
    }
}
function $69ff85b27d828958$var$addAncestorStatesToEnter(statesToEnter, historyValue, statesForDefaultEntry, ancestors, reentrancyDomain) {
    for (const anc of ancestors){
        if (!reentrancyDomain || $69ff85b27d828958$var$isDescendant(anc, reentrancyDomain)) statesToEnter.add(anc);
        if (anc.type === 'parallel') {
            for (const child of $69ff85b27d828958$var$getChildren(anc).filter((sn)=>!$69ff85b27d828958$var$isHistoryNode(sn)))if (![
                ...statesToEnter
            ].some((s)=>$69ff85b27d828958$var$isDescendant(s, child))) {
                statesToEnter.add(child);
                $69ff85b27d828958$var$addDescendantStatesToEnter(child, historyValue, statesForDefaultEntry, statesToEnter);
            }
        }
    }
}
function $69ff85b27d828958$var$addProperAncestorStatesToEnter(stateNode, toStateNode, statesToEnter, historyValue, statesForDefaultEntry) {
    $69ff85b27d828958$var$addAncestorStatesToEnter(statesToEnter, historyValue, statesForDefaultEntry, $69ff85b27d828958$var$getProperAncestors(stateNode, toStateNode));
}
function $69ff85b27d828958$var$exitStates(currentSnapshot, event, actorScope, transitions, mutStateNodeSet, historyValue, internalQueue, _actionExecutor) {
    let nextSnapshot = currentSnapshot;
    const statesToExit = $69ff85b27d828958$var$computeExitSet(transitions, mutStateNodeSet, historyValue);
    statesToExit.sort((a, b)=>b.order - a.order);
    let changedHistory;
    // From SCXML algorithm: https://www.w3.org/TR/scxml/#exitStates
    for (const exitStateNode of statesToExit)for (const historyNode of $69ff85b27d828958$var$getHistoryNodes(exitStateNode)){
        let predicate;
        if (historyNode.history === 'deep') predicate = (sn)=>$69ff85b27d828958$var$isAtomicStateNode(sn) && $69ff85b27d828958$var$isDescendant(sn, exitStateNode);
        else predicate = (sn)=>{
            return sn.parent === exitStateNode;
        };
        changedHistory ?? (changedHistory = {
            ...historyValue
        });
        changedHistory[historyNode.id] = Array.from(mutStateNodeSet).filter(predicate);
    }
    for (const s of statesToExit){
        nextSnapshot = $69ff85b27d828958$export$ffb5f4729a158638(nextSnapshot, event, actorScope, [
            ...s.exit,
            ...s.invoke.map((def)=>$69ff85b27d828958$export$db202ddc8be9136(def.id))
        ], internalQueue, undefined);
        mutStateNodeSet.delete(s);
    }
    return [
        nextSnapshot,
        changedHistory || historyValue
    ];
}
function $69ff85b27d828958$var$getAction(machine, actionType) {
    return machine.implementations.actions[actionType];
}
function $69ff85b27d828958$var$resolveAndExecuteActionsWithContext(currentSnapshot, event, actorScope, actions, extra, retries) {
    const { machine: machine } = currentSnapshot;
    let intermediateSnapshot = currentSnapshot;
    for (const action of actions){
        const isInline = typeof action === 'function';
        const resolvedAction = isInline ? action : // the existing type of `.actions` assumes non-nullable `TExpressionAction`
        // it's fine to cast this here to get a common type and lack of errors in the rest of the code
        // our logic below makes sure that we call those 2 "variants" correctly
        $69ff85b27d828958$var$getAction(machine, typeof action === 'string' ? action : action.type);
        const actionArgs = {
            context: intermediateSnapshot.context,
            event: event,
            self: actorScope.self,
            system: actorScope.system
        };
        const actionParams = isInline || typeof action === 'string' ? undefined : 'params' in action ? typeof action.params === 'function' ? action.params({
            context: intermediateSnapshot.context,
            event: event
        }) : action.params : undefined;
        if (!resolvedAction || !('resolve' in resolvedAction)) {
            actorScope.actionExecutor({
                type: typeof action === 'string' ? action : typeof action === 'object' ? action.type : action.name || '(anonymous)',
                info: actionArgs,
                params: actionParams,
                exec: resolvedAction
            });
            continue;
        }
        const builtinAction = resolvedAction;
        const [nextState, params, actions] = builtinAction.resolve(actorScope, intermediateSnapshot, actionArgs, actionParams, resolvedAction, // this holds all params
        extra);
        intermediateSnapshot = nextState;
        if ('retryResolve' in builtinAction) retries?.push([
            builtinAction,
            params
        ]);
        if ('execute' in builtinAction) actorScope.actionExecutor({
            type: builtinAction.type,
            info: actionArgs,
            params: params,
            exec: builtinAction.execute.bind(null, actorScope, params)
        });
        if (actions) intermediateSnapshot = $69ff85b27d828958$var$resolveAndExecuteActionsWithContext(intermediateSnapshot, event, actorScope, actions, extra, retries);
    }
    return intermediateSnapshot;
}
function $69ff85b27d828958$export$ffb5f4729a158638(currentSnapshot, event, actorScope, actions, internalQueue, deferredActorIds) {
    const retries = deferredActorIds ? [] : undefined;
    const nextState = $69ff85b27d828958$var$resolveAndExecuteActionsWithContext(currentSnapshot, event, actorScope, actions, {
        internalQueue: internalQueue,
        deferredActorIds: deferredActorIds
    }, retries);
    retries?.forEach(([builtinAction, params])=>{
        builtinAction.retryResolve(actorScope, nextState, params);
    });
    return nextState;
}
function $69ff85b27d828958$export$7ccc53e8f1e7dfc5(snapshot, event, actorScope, internalQueue) {
    let nextSnapshot = snapshot;
    const microstates = [];
    function addMicrostate(microstate, event, transitions) {
        actorScope.system._sendInspectionEvent({
            type: '@xstate.microstep',
            actorRef: actorScope.self,
            event: event,
            snapshot: microstate,
            _transitions: transitions
        });
        microstates.push(microstate);
    }
    // Handle stop event
    if (event.type === $69ff85b27d828958$export$78acf4525d8a74c4) {
        nextSnapshot = $69ff85b27d828958$export$3a6d5c9ae78a2c08($69ff85b27d828958$var$stopChildren(nextSnapshot, event, actorScope), {
            status: 'stopped'
        });
        addMicrostate(nextSnapshot, event, []);
        return {
            snapshot: nextSnapshot,
            microstates: microstates
        };
    }
    let nextEvent = event;
    // Assume the state is at rest (no raised events)
    // Determine the next state based on the next microstep
    if (nextEvent.type !== $69ff85b27d828958$var$XSTATE_INIT) {
        const currentEvent = nextEvent;
        const isErr = $69ff85b27d828958$var$isErrorActorEvent(currentEvent);
        const transitions = $69ff85b27d828958$var$selectTransitions(currentEvent, nextSnapshot);
        if (isErr && !transitions.length) {
            // TODO: we should likely only allow transitions selected by very explicit descriptors
            // `*` shouldn't be matched, likely `xstate.error.*` shouldnt be either
            // similarly `xstate.error.actor.*` and `xstate.error.actor.todo.*` have to be considered too
            nextSnapshot = $69ff85b27d828958$export$3a6d5c9ae78a2c08(snapshot, {
                status: 'error',
                error: currentEvent.error
            });
            addMicrostate(nextSnapshot, currentEvent, []);
            return {
                snapshot: nextSnapshot,
                microstates: microstates
            };
        }
        nextSnapshot = $69ff85b27d828958$export$2408f22a0fab9ae5(transitions, snapshot, actorScope, nextEvent, false, // isInitial
        internalQueue);
        addMicrostate(nextSnapshot, currentEvent, transitions);
    }
    let shouldSelectEventlessTransitions = true;
    while(nextSnapshot.status === 'active'){
        let enabledTransitions = shouldSelectEventlessTransitions ? $69ff85b27d828958$var$selectEventlessTransitions(nextSnapshot, nextEvent) : [];
        // eventless transitions should always be selected after selecting *regular* transitions
        // by assigning `undefined` to `previousState` we ensure that `shouldSelectEventlessTransitions` gets always computed to true in such a case
        const previousState = enabledTransitions.length ? nextSnapshot : undefined;
        if (!enabledTransitions.length) {
            if (!internalQueue.length) break;
            nextEvent = internalQueue.shift();
            enabledTransitions = $69ff85b27d828958$var$selectTransitions(nextEvent, nextSnapshot);
        }
        nextSnapshot = $69ff85b27d828958$export$2408f22a0fab9ae5(enabledTransitions, nextSnapshot, actorScope, nextEvent, false, internalQueue);
        shouldSelectEventlessTransitions = nextSnapshot !== previousState;
        addMicrostate(nextSnapshot, nextEvent, enabledTransitions);
    }
    if (nextSnapshot.status !== 'active') $69ff85b27d828958$var$stopChildren(nextSnapshot, nextEvent, actorScope);
    return {
        snapshot: nextSnapshot,
        microstates: microstates
    };
}
function $69ff85b27d828958$var$stopChildren(nextState, event, actorScope) {
    return $69ff85b27d828958$export$ffb5f4729a158638(nextState, event, actorScope, Object.values(nextState.children).map((child)=>$69ff85b27d828958$export$db202ddc8be9136(child)), [], undefined);
}
function $69ff85b27d828958$var$selectTransitions(event, nextState) {
    return nextState.machine.getTransitionData(nextState, event);
}
function $69ff85b27d828958$var$selectEventlessTransitions(nextState, event) {
    const enabledTransitionSet = new Set();
    const atomicStates = nextState._nodes.filter($69ff85b27d828958$var$isAtomicStateNode);
    for (const stateNode of atomicStates)loop: for (const s of [
        stateNode
    ].concat($69ff85b27d828958$var$getProperAncestors(stateNode, undefined))){
        if (!s.always) continue;
        for (const transition of s.always)if (transition.guard === undefined || $69ff85b27d828958$export$f1e1789686576879(transition.guard, nextState.context, event, nextState)) {
            enabledTransitionSet.add(transition);
            break loop;
        }
    }
    return $69ff85b27d828958$var$removeConflictingTransitions(Array.from(enabledTransitionSet), new Set(nextState._nodes), nextState.historyValue);
}
/**
 * Resolves a partial state value with its full representation in the state
 * node's machine.
 *
 * @param stateValue The partial state value to resolve.
 */ function $69ff85b27d828958$export$43caf9889c228507(rootNode, stateValue) {
    const allStateNodes = $69ff85b27d828958$export$23f2a1d2818174ef($69ff85b27d828958$export$35e795649ee09318(rootNode, stateValue));
    return $69ff85b27d828958$var$getStateValue(rootNode, [
        ...allStateNodes
    ]);
}
function $69ff85b27d828958$export$7f8ddf7c7c20b3cd(value) {
    return !!value && typeof value === 'object' && 'machine' in value && 'value' in value;
}
const $69ff85b27d828958$var$machineSnapshotMatches = function matches(testValue) {
    return $69ff85b27d828958$export$b4171a6734a65d42(testValue, this.value);
};
const $69ff85b27d828958$var$machineSnapshotHasTag = function hasTag(tag) {
    return this.tags.has(tag);
};
const $69ff85b27d828958$var$machineSnapshotCan = function can(event) {
    const transitionData = this.machine.getTransitionData(this, event);
    return !!transitionData?.length && // Check that at least one transition is not forbidden
    transitionData.some((t)=>t.target !== undefined || t.actions.length);
};
const $69ff85b27d828958$var$machineSnapshotToJSON = function toJSON() {
    const { _nodes: nodes, tags: tags, machine: machine, getMeta: getMeta, toJSON: toJSON, can: can, hasTag: hasTag, matches: matches, ...jsonValues } = this;
    return {
        ...jsonValues,
        tags: Array.from(tags)
    };
};
const $69ff85b27d828958$var$machineSnapshotGetMeta = function getMeta() {
    return this._nodes.reduce((acc, stateNode)=>{
        if (stateNode.meta !== undefined) acc[stateNode.id] = stateNode.meta;
        return acc;
    }, {});
};
function $69ff85b27d828958$export$342063e11d6c3cad(config, machine) {
    return {
        status: config.status,
        output: config.output,
        error: config.error,
        machine: machine,
        context: config.context,
        _nodes: config._nodes,
        value: $69ff85b27d828958$var$getStateValue(machine.root, config._nodes),
        tags: new Set(config._nodes.flatMap((sn)=>sn.tags)),
        children: config.children,
        historyValue: config.historyValue || {},
        matches: $69ff85b27d828958$var$machineSnapshotMatches,
        hasTag: $69ff85b27d828958$var$machineSnapshotHasTag,
        can: $69ff85b27d828958$var$machineSnapshotCan,
        getMeta: $69ff85b27d828958$var$machineSnapshotGetMeta,
        toJSON: $69ff85b27d828958$var$machineSnapshotToJSON
    };
}
function $69ff85b27d828958$export$3a6d5c9ae78a2c08(snapshot, config = {}) {
    return $69ff85b27d828958$export$342063e11d6c3cad({
        ...snapshot,
        ...config
    }, snapshot.machine);
}
function $69ff85b27d828958$export$4a5767248b18ef41(snapshot, options) {
    const { _nodes: nodes, tags: tags, machine: machine, children: children, context: context, can: can, hasTag: hasTag, matches: matches, getMeta: getMeta, toJSON: toJSON, ...jsonValues } = snapshot;
    const childrenJson = {};
    for(const id in children){
        const child = children[id];
        childrenJson[id] = {
            snapshot: child.getPersistedSnapshot(options),
            src: child.src,
            systemId: child._systemId,
            syncSnapshot: child._syncSnapshot
        };
    }
    const persisted = {
        ...jsonValues,
        context: $69ff85b27d828958$var$persistContext(context),
        children: childrenJson
    };
    return persisted;
}
function $69ff85b27d828958$var$persistContext(contextPart) {
    let copy;
    for(const key in contextPart){
        const value = contextPart[key];
        if (value && typeof value === 'object') {
            if ('sessionId' in value && 'send' in value && 'ref' in value) {
                copy ?? (copy = Array.isArray(contextPart) ? contextPart.slice() : {
                    ...contextPart
                });
                copy[key] = {
                    xstate$$type: $69ff85b27d828958$export$3d8c2f653ac9d0b9,
                    id: value.id
                };
            } else {
                const result = $69ff85b27d828958$var$persistContext(value);
                if (result !== value) {
                    copy ?? (copy = Array.isArray(contextPart) ? contextPart.slice() : {
                        ...contextPart
                    });
                    copy[key] = result;
                }
            }
        }
    }
    return copy ?? contextPart;
}
function $69ff85b27d828958$var$resolveRaise(_, snapshot, args, actionParams, { event: eventOrExpr, id: id, delay: delay }, { internalQueue: internalQueue }) {
    const delaysMap = snapshot.machine.implementations.delays;
    if (typeof eventOrExpr === 'string') throw new Error(// eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    `Only event objects may be used with raise; use raise({ type: "${eventOrExpr}" }) instead`);
    const resolvedEvent = typeof eventOrExpr === 'function' ? eventOrExpr(args, actionParams) : eventOrExpr;
    let resolvedDelay;
    if (typeof delay === 'string') {
        const configDelay = delaysMap && delaysMap[delay];
        resolvedDelay = typeof configDelay === 'function' ? configDelay(args, actionParams) : configDelay;
    } else resolvedDelay = typeof delay === 'function' ? delay(args, actionParams) : delay;
    if (typeof resolvedDelay !== 'number') internalQueue.push(resolvedEvent);
    return [
        snapshot,
        {
            event: resolvedEvent,
            id: id,
            delay: resolvedDelay
        },
        undefined
    ];
}
function $69ff85b27d828958$var$executeRaise(actorScope, params) {
    const { event: event, delay: delay, id: id } = params;
    if (typeof delay === 'number') {
        actorScope.defer(()=>{
            const self = actorScope.self;
            actorScope.system.scheduler.schedule(self, self, event, delay, id);
        });
        return;
    }
}
/**
 * Raises an event. This places the event in the internal event queue, so that
 * the event is immediately consumed by the machine in the current step.
 *
 * @param eventType The event to raise.
 */ function $69ff85b27d828958$export$c4ce752e73470fba(eventOrExpr, options) {
    function raise(_args, _params) {}
    raise.type = 'xstate.raise';
    raise.event = eventOrExpr;
    raise.id = options?.id;
    raise.delay = options?.delay;
    raise.resolve = $69ff85b27d828958$var$resolveRaise;
    raise.execute = $69ff85b27d828958$var$executeRaise;
    return raise;
}
module.exports["S"] = $69ff85b27d828958$export$25ce5a424b770e84;
module.exports["N"] = $69ff85b27d828958$export$a07804094c3ecf2d;
module.exports["V"] = $69ff85b27d828958$export$e7c866399fa523f5;
module.exports["X"] = $69ff85b27d828958$export$78acf4525d8a74c4;
module.exports["W"] = $69ff85b27d828958$export$71cec2538cb2c617;
module.exports["q"] = $69ff85b27d828958$export$9e5f44173e64f162;
module.exports["v"] = $69ff85b27d828958$export$90a7f3efeed30595;
module.exports["m"] = $69ff85b27d828958$export$953cecd6e717a553;
module.exports["t"] = $69ff85b27d828958$export$625550452a3fa3ec;
module.exports["a"] = $69ff85b27d828958$export$407448d2b89b1813;
module.exports["L"] = $69ff85b27d828958$export$61196ced6d74a310;
module.exports["c"] = $69ff85b27d828958$export$db3b6bfb95261072;
module.exports["z"] = $69ff85b27d828958$export$df995fae86a55f06;
module.exports["$"] = $69ff85b27d828958$export$3d8c2f653ac9d0b9;
module.exports["T"] = $69ff85b27d828958$export$971d5caa766a69d7;
module.exports["A"] = $69ff85b27d828958$export$ebd11618f299a286;
module.exports["M"] = $69ff85b27d828958$export$3a1a48c8f6ef640e;
module.exports["U"] = $69ff85b27d828958$export$3a6d5c9ae78a2c08;
module.exports["P"] = $69ff85b27d828958$export$56c0d5a1e737357d;
module.exports["R"] = $69ff85b27d828958$export$db202ddc8be9136;
module.exports["w"] = $69ff85b27d828958$export$efccba1c4a2ef57b;
module.exports["e"] = $69ff85b27d828958$export$f1e1789686576879;
module.exports["i"] = $69ff85b27d828958$export$23f2a1d2818174ef;
module.exports["l"] = $69ff85b27d828958$export$882b5998b3b9117c;
module.exports["h"] = $69ff85b27d828958$export$dda1d9f60106f0e9;
module.exports["g"] = $69ff85b27d828958$export$39b482c5e57630a8;
module.exports["O"] = $69ff85b27d828958$export$c4ce752e73470fba;
module.exports["b"] = $69ff85b27d828958$export$8b22cf2602fb60ce;
module.exports["f"] = $69ff85b27d828958$export$2d1720544b23b823;
module.exports["d"] = $69ff85b27d828958$export$4368d992c4eafac0;
module.exports["x"] = $69ff85b27d828958$export$d141bba7fdc215a3;
module.exports["u"] = $69ff85b27d828958$export$3b14a55fb2447963;
module.exports["j"] = $69ff85b27d828958$export$35e795649ee09318;
module.exports["o"] = $69ff85b27d828958$export$ae1af26003f05816;
module.exports["s"] = $69ff85b27d828958$export$2408f22a0fab9ae5;
module.exports["p"] = $69ff85b27d828958$export$ffb5f4729a158638;
module.exports["n"] = $69ff85b27d828958$export$7ccc53e8f1e7dfc5;
module.exports["r"] = $69ff85b27d828958$export$43caf9889c228507;
module.exports["k"] = $69ff85b27d828958$export$342063e11d6c3cad;
module.exports["y"] = $69ff85b27d828958$export$4a5767248b18ef41;

});

parcelRegister("e6Soq", function(module, exports) {
// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis
function $a45bd1884ca79325$export$a4e55266d2135a7f() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
}
function $a45bd1884ca79325$var$getDevTools() {
    const w = $a45bd1884ca79325$export$a4e55266d2135a7f();
    if (w.__xstate__) return w.__xstate__;
    return undefined;
}
function $a45bd1884ca79325$export$4d7a7d14704ebc13(service) {
    if (typeof window === 'undefined') return;
    const devTools = $a45bd1884ca79325$var$getDevTools();
    if (devTools) devTools.register(service);
}
const $a45bd1884ca79325$export$3ee8010769463234 = (service)=>{
    if (typeof window === 'undefined') return;
    const devTools = $a45bd1884ca79325$var$getDevTools();
    if (devTools) devTools.register(service);
};
module.exports["devToolsAdapter"] = $a45bd1884ca79325$export$3ee8010769463234;

});

parcelRegister("dpSRg", function(module, exports) {

var $96dZ7 = parcelRequire("96dZ7");

function $9c4829d96c0398b3$var$createSpawner(actorScope, { machine: machine, context: context }, event, spawnedChildren) {
    const spawn = (src, options = {})=>{
        const { systemId: systemId, input: input } = options;
        if (typeof src === 'string') {
            const logic = (0, $96dZ7.z)(machine, src);
            if (!logic) throw new Error(`Actor logic '${src}' not implemented in machine '${machine.id}'`);
            const actorRef = (0, $96dZ7.A)(logic, {
                id: options.id,
                parent: actorScope.self,
                syncSnapshot: options.syncSnapshot,
                input: typeof input === 'function' ? input({
                    context: context,
                    event: event,
                    self: actorScope.self
                }) : input,
                src: src,
                systemId: systemId
            });
            spawnedChildren[actorRef.id] = actorRef;
            return actorRef;
        } else {
            const actorRef = (0, $96dZ7.A)(src, {
                id: options.id,
                parent: actorScope.self,
                syncSnapshot: options.syncSnapshot,
                input: options.input,
                src: src,
                systemId: systemId
            });
            return actorRef;
        }
    };
    return (src, options)=>{
        const actorRef = spawn(src, options); // TODO: fix types
        spawnedChildren[actorRef.id] = actorRef;
        actorScope.defer(()=>{
            if (actorRef._processingStatus === (0, $96dZ7.T).Stopped) return;
            actorRef.start();
        });
        return actorRef;
    };
}
function $9c4829d96c0398b3$var$resolveAssign(actorScope, snapshot, actionArgs, actionParams, { assignment: assignment }) {
    if (!snapshot.context) throw new Error('Cannot assign to undefined `context`. Ensure that `context` is defined in the machine config.');
    const spawnedChildren = {};
    const assignArgs = {
        context: snapshot.context,
        event: actionArgs.event,
        spawn: $9c4829d96c0398b3$var$createSpawner(actorScope, snapshot, actionArgs.event, spawnedChildren),
        self: actorScope.self,
        system: actorScope.system
    };
    let partialUpdate = {};
    if (typeof assignment === 'function') partialUpdate = assignment(assignArgs, actionParams);
    else for (const key of Object.keys(assignment)){
        const propAssignment = assignment[key];
        partialUpdate[key] = typeof propAssignment === 'function' ? propAssignment(assignArgs, actionParams) : propAssignment;
    }
    const updatedContext = Object.assign({}, snapshot.context, partialUpdate);
    return [
        (0, $96dZ7.U)(snapshot, {
            context: updatedContext,
            children: Object.keys(spawnedChildren).length ? {
                ...snapshot.children,
                ...spawnedChildren
            } : snapshot.children
        }),
        undefined,
        undefined
    ];
}
/**
 * Updates the current context of the machine.
 *
 * @example
 *
 * ```ts
 * import { createMachine, assign } from 'xstate';
 *
 * const countMachine = createMachine({
 *   context: {
 *     count: 0,
 *     message: ''
 *   },
 *   on: {
 *     inc: {
 *       actions: assign({
 *         count: ({ context }) => context.count + 1
 *       })
 *     },
 *     updateMessage: {
 *       actions: assign(({ context, event }) => {
 *         return {
 *           message: event.message.trim()
 *         };
 *       })
 *     }
 *   }
 * });
 * ```
 *
 * @param assignment An object that represents the partial context to update, or
 *   a function that returns an object that represents the partial context to
 *   update.
 */ function $9c4829d96c0398b3$export$407448d2b89b1813(assignment) {
    function assign(_args, _params) {}
    assign.type = 'xstate.assign';
    assign.assignment = assignment;
    assign.resolve = $9c4829d96c0398b3$var$resolveAssign;
    return assign;
}
function $9c4829d96c0398b3$var$resolveEmit(_, snapshot, args, actionParams, { event: eventOrExpr }) {
    const resolvedEvent = typeof eventOrExpr === 'function' ? eventOrExpr(args, actionParams) : eventOrExpr;
    return [
        snapshot,
        {
            event: resolvedEvent
        },
        undefined
    ];
}
function $9c4829d96c0398b3$var$executeEmit(actorScope, { event: event }) {
    actorScope.defer(()=>actorScope.emit(event));
}
/**
 * Emits an event to event handlers registered on the actor via `actor.on(event,
 * handler)`.
 *
 * @example
 *
 * ```ts
 * import { emit } from 'xstate';
 *
 * const machine = createMachine({
 *   // ...
 *   on: {
 *     something: {
 *       actions: emit({
 *         type: 'emitted',
 *         some: 'data'
 *       })
 *     }
 *   }
 *   // ...
 * });
 *
 * const actor = createActor(machine).start();
 *
 * actor.on('emitted', (event) => {
 *   console.log(event);
 * });
 *
 * actor.send({ type: 'something' });
 * // logs:
 * // {
 * //   type: 'emitted',
 * //   some: 'data'
 * // }
 * ```
 */ function $9c4829d96c0398b3$export$f1e1789686576879(/** The event to emit, or an expression that returns an event to emit. */ eventOrExpr) {
    function emit(_args, _params) {}
    emit.type = 'xstate.emit';
    emit.event = eventOrExpr;
    emit.resolve = $9c4829d96c0398b3$var$resolveEmit;
    emit.execute = $9c4829d96c0398b3$var$executeEmit;
    return emit;
}
/**
 * @remarks
 * `T | unknown` reduces to `unknown` and that can be problematic when it comes
 * to contextual typing. It especially is a problem when the union has a
 * function member, like here:
 *
 * ```ts
 * declare function test(
 *   cbOrVal: ((arg: number) => unknown) | unknown
 * ): void;
 * test((arg) => {}); // oops, implicit any
 * ```
 *
 * This type can be used to avoid this problem. This union represents the same
 * value space as `unknown`.
 */ // https://github.com/microsoft/TypeScript/issues/23182#issuecomment-379091887
// @TODO: Replace with native `NoInfer` when TS issue gets fixed:
// https://github.com/microsoft/TypeScript/pull/57673
/** @deprecated Use the built-in `NoInfer` type instead */ /** The full definition of an event, with a string `type`. */ /**
 * The string or object representing the state value relative to the parent
 * state node.
 *
 * @remarks
 * - For a child atomic state node, this is a string, e.g., `"pending"`.
 * - For complex state nodes, this is an object, e.g., `{ success:
 *   "someChildState" }`.
 */ /** @deprecated Use `AnyMachineSnapshot` instead */ // TODO: possibly refactor this somehow, use even a simpler type, and maybe even make `machine.options` private or something
/** @ignore */ let $9c4829d96c0398b3$export$25ce5a424b770e84 = /*#__PURE__*/ function(SpecialTargets) {
    SpecialTargets["Parent"] = "#_parent";
    SpecialTargets["Internal"] = "#_internal";
    return SpecialTargets;
}({});
/** @deprecated Use `AnyActor` instead. */ // Based on RxJS types
// TODO: in v6, this should only accept AnyActorLogic, like ActorRefFromLogic
/** @deprecated Use `Actor<T>` instead. */ /**
 * Represents logic which can be used by an actor.
 *
 * @template TSnapshot - The type of the snapshot.
 * @template TEvent - The type of the event object.
 * @template TInput - The type of the input.
 * @template TSystem - The type of the actor system.
 */ /** @deprecated */ // TODO: cover all that can be actually returned
function $9c4829d96c0398b3$var$resolveSendTo(actorScope, snapshot, args, actionParams, { to: to, event: eventOrExpr, id: id, delay: delay }, extra) {
    const delaysMap = snapshot.machine.implementations.delays;
    if (typeof eventOrExpr === 'string') throw new Error(// eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    `Only event objects may be used with sendTo; use sendTo({ type: "${eventOrExpr}" }) instead`);
    const resolvedEvent = typeof eventOrExpr === 'function' ? eventOrExpr(args, actionParams) : eventOrExpr;
    let resolvedDelay;
    if (typeof delay === 'string') {
        const configDelay = delaysMap && delaysMap[delay];
        resolvedDelay = typeof configDelay === 'function' ? configDelay(args, actionParams) : configDelay;
    } else resolvedDelay = typeof delay === 'function' ? delay(args, actionParams) : delay;
    const resolvedTarget = typeof to === 'function' ? to(args, actionParams) : to;
    let targetActorRef;
    if (typeof resolvedTarget === 'string') {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
        if (resolvedTarget === $9c4829d96c0398b3$export$25ce5a424b770e84.Parent) targetActorRef = actorScope.self._parent;
        else if (resolvedTarget === $9c4829d96c0398b3$export$25ce5a424b770e84.Internal) targetActorRef = actorScope.self;
        else if (resolvedTarget.startsWith('#_')) // SCXML compatibility: https://www.w3.org/TR/scxml/#SCXMLEventProcessor
        // #_invokeid. If the target is the special term '#_invokeid', where invokeid is the invokeid of an SCXML session that the sending session has created by <invoke>, the Processor must add the event to the external queue of that session.
        targetActorRef = snapshot.children[resolvedTarget.slice(2)];
        else targetActorRef = extra.deferredActorIds?.includes(resolvedTarget) ? resolvedTarget : snapshot.children[resolvedTarget];
        if (!targetActorRef) throw new Error(`Unable to send event to actor '${resolvedTarget}' from machine '${snapshot.machine.id}'.`);
    } else targetActorRef = resolvedTarget || actorScope.self;
    return [
        snapshot,
        {
            to: targetActorRef,
            targetId: typeof resolvedTarget === 'string' ? resolvedTarget : undefined,
            event: resolvedEvent,
            id: id,
            delay: resolvedDelay
        },
        undefined
    ];
}
function $9c4829d96c0398b3$var$retryResolveSendTo(_, snapshot, params) {
    if (typeof params.to === 'string') params.to = snapshot.children[params.to];
}
function $9c4829d96c0398b3$var$executeSendTo(actorScope, params) {
    // this forms an outgoing events queue
    // thanks to that the recipient actors are able to read the *updated* snapshot value of the sender
    actorScope.defer(()=>{
        const { to: to, event: event, delay: delay, id: id } = params;
        if (typeof delay === 'number') {
            actorScope.system.scheduler.schedule(actorScope.self, to, event, delay, id);
            return;
        }
        actorScope.system._relay(actorScope.self, // at this point, in a deferred task, it should already be mutated by retryResolveSendTo
        // if it initially started as a string
        to, event.type === (0, $96dZ7.V) ? (0, $96dZ7.W)(actorScope.self.id, event.data) : event);
    });
}
/**
 * Sends an event to an actor.
 *
 * @param actor The `ActorRef` to send the event to.
 * @param event The event to send, or an expression that evaluates to the event
 *   to send
 * @param options Send action options
 *
 *   - `id` - The unique send event identifier (used with `cancel()`).
 *   - `delay` - The number of milliseconds to delay the sending of the event.
 */ function $9c4829d96c0398b3$export$db3b6bfb95261072(to, eventOrExpr, options) {
    function sendTo(_args, _params) {}
    sendTo.type = 'xstate.sendTo';
    sendTo.to = to;
    sendTo.event = eventOrExpr;
    sendTo.id = options?.id;
    sendTo.delay = options?.delay;
    sendTo.resolve = $9c4829d96c0398b3$var$resolveSendTo;
    sendTo.retryResolve = $9c4829d96c0398b3$var$retryResolveSendTo;
    sendTo.execute = $9c4829d96c0398b3$var$executeSendTo;
    return sendTo;
}
/**
 * Sends an event to this machine's parent.
 *
 * @param event The event to send to the parent machine.
 * @param options Options to pass into the send event.
 */ function $9c4829d96c0398b3$export$2408f22a0fab9ae5(event, options) {
    return $9c4829d96c0398b3$export$db3b6bfb95261072($9c4829d96c0398b3$export$25ce5a424b770e84.Parent, event, options);
}
/**
 * Forwards (sends) an event to the `target` actor.
 *
 * @param target The target actor to forward the event to.
 * @param options Options to pass into the send action creator.
 */ function $9c4829d96c0398b3$export$2d1720544b23b823(target, options) {
    return $9c4829d96c0398b3$export$db3b6bfb95261072(target, ({ event: event })=>event, options);
}
function $9c4829d96c0398b3$var$resolveEnqueueActions(actorScope, snapshot, args, actionParams, { collect: collect }) {
    const actions = [];
    const enqueue = function enqueue(action) {
        actions.push(action);
    };
    enqueue.assign = (...args)=>{
        actions.push($9c4829d96c0398b3$export$407448d2b89b1813(...args));
    };
    enqueue.cancel = (...args)=>{
        actions.push((0, $96dZ7.M)(...args));
    };
    enqueue.raise = (...args)=>{
        // for some reason it fails to infer `TDelay` from `...args` here and picks its default (`never`)
        // then it fails to typecheck that because `...args` use `string` in place of `TDelay`
        actions.push((0, $96dZ7.O)(...args));
    };
    enqueue.sendTo = (...args)=>{
        // for some reason it fails to infer `TDelay` from `...args` here and picks its default (`never`)
        // then it fails to typecheck that because `...args` use `string` in place of `TDelay
        actions.push($9c4829d96c0398b3$export$db3b6bfb95261072(...args));
    };
    enqueue.sendParent = (...args)=>{
        actions.push($9c4829d96c0398b3$export$2408f22a0fab9ae5(...args));
    };
    enqueue.spawnChild = (...args)=>{
        actions.push((0, $96dZ7.P)(...args));
    };
    enqueue.stopChild = (...args)=>{
        actions.push((0, $96dZ7.R)(...args));
    };
    enqueue.emit = (...args)=>{
        actions.push($9c4829d96c0398b3$export$f1e1789686576879(...args));
    };
    collect({
        context: args.context,
        event: args.event,
        enqueue: enqueue,
        check: (guard)=>(0, $96dZ7.e)(guard, snapshot.context, args.event, snapshot),
        self: actorScope.self,
        system: actorScope.system
    }, actionParams);
    return [
        snapshot,
        undefined,
        actions
    ];
}
/**
 * Creates an action object that will execute actions that are queued by the
 * `enqueue(action)` function.
 *
 * @example
 *
 * ```ts
 * import { createMachine, enqueueActions } from 'xstate';
 *
 * const machine = createMachine({
 *   entry: enqueueActions(({ enqueue, check }) => {
 *     enqueue.assign({ count: 0 });
 *
 *     if (check('someGuard')) {
 *       enqueue.assign({ count: 1 });
 *     }
 *
 *     enqueue('someAction');
 *   })
 * });
 * ```
 */ function $9c4829d96c0398b3$export$8b22cf2602fb60ce(collect) {
    function enqueueActions(_args, _params) {}
    enqueueActions.type = 'xstate.enqueueActions';
    enqueueActions.collect = collect;
    enqueueActions.resolve = $9c4829d96c0398b3$var$resolveEnqueueActions;
    return enqueueActions;
}
function $9c4829d96c0398b3$var$resolveLog(_, snapshot, actionArgs, actionParams, { value: value, label: label }) {
    return [
        snapshot,
        {
            value: typeof value === 'function' ? value(actionArgs, actionParams) : value,
            label: label
        },
        undefined
    ];
}
function $9c4829d96c0398b3$var$executeLog({ logger: logger }, { value: value, label: label }) {
    if (label) logger(label, value);
    else logger(value);
}
/**
 * @param expr The expression function to evaluate which will be logged. Takes
 *   in 2 arguments:
 *
 *   - `ctx` - the current state context
 *   - `event` - the event that caused this action to be executed.
 *
 * @param label The label to give to the logged expression.
 */ function $9c4829d96c0398b3$export$882b5998b3b9117c(value = ({ context: context, event: event })=>({
        context: context,
        event: event
    }), label) {
    function log1(_args, _params) {}
    log1.type = 'xstate.log';
    log1.value = value;
    log1.label = label;
    log1.resolve = $9c4829d96c0398b3$var$resolveLog;
    log1.execute = $9c4829d96c0398b3$var$executeLog;
    return log1;
}
module.exports["a"] = $9c4829d96c0398b3$export$407448d2b89b1813;
module.exports["e"] = $9c4829d96c0398b3$export$f1e1789686576879;
module.exports["c"] = $9c4829d96c0398b3$export$db3b6bfb95261072;
module.exports["b"] = $9c4829d96c0398b3$export$8b22cf2602fb60ce;

});

parcelRegister("5VSNw", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $a59ec0f880a08336$var$styles = {
    container: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0jFU0VxpxF _39xV02xpxF"
};
const $a59ec0f880a08336$var$ROVO_SVG_PATH = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M5.38007 0.169224C5.79665 -0.0605531 6.30508 -0.0563317 6.71827 0.181888L9.96761 2.05659L10.7381 2.50115C11.1589 2.7437 11.4193 3.1937 11.4193 3.67848V8.31707C11.4193 8.80377 11.1604 9.25178 10.7385 9.4942L7.71671 11.2376C7.72332 11.219 7.72963 11.2003 7.73565 11.1815C7.79172 11.0077 7.82146 10.8241 7.82146 10.6363V5.99777C7.82146 5.36053 7.4823 4.7729 6.92908 4.45501L6.37094 4.13313L4.67654 3.15598V1.35919C4.67654 1.21761 4.69845 1.0793 4.7399 0.948371C4.8418 0.631497 5.05854 0.357177 5.35505 0.185934L5.35594 0.185415C5.36443 0.180511 5.37252 0.175072 5.38007 0.169224Z" fill="#FCA700"/>
		<path d="M4.35709 0.762451L1.33533 2.50585C0.91337 2.74828 0.654541 3.19629 0.654541 3.68299V8.32158C0.654541 8.80636 0.914895 9.25633 1.33561 9.49887L2.05206 9.91223L5.35553 11.8182C5.76872 12.0563 6.27717 12.0606 6.69373 11.8308C6.70128 11.825 6.7093 11.8196 6.71781 11.8147C7.01463 11.6435 7.2317 11.3691 7.33376 11.0521C7.3753 10.9211 7.39725 10.7826 7.39725 10.6409V8.84408L5.64872 7.83569L5.14485 7.54513C4.59174 7.22722 4.25234 6.63946 4.25234 6.00228V1.3637C4.25234 1.17625 4.28199 0.992849 4.33793 0.81927C4.344 0.800208 4.35039 0.781265 4.35709 0.762451Z" fill="#FCA700"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M5.64872 7.83569L2.05206 9.91223L1.33561 9.49887C0.914895 9.25633 0.654541 8.80636 0.654541 8.32158V3.68299C0.654541 3.19629 0.91337 2.74828 1.33533 2.50585L4.35709 0.762451C4.35039 0.781265 4.344 0.800208 4.33793 0.81927C4.28199 0.992849 4.25234 1.17625 4.25234 1.3637V6.00228C4.25234 6.63946 4.59174 7.22722 5.14485 7.54513L5.64872 7.83569Z" fill="#1868DB"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M6.37094 4.13313L4.67654 3.15598V1.35919C4.67654 1.21761 4.69845 1.0793 4.7399 0.948371C4.8418 0.631497 5.05854 0.357177 5.35505 0.185934L5.35594 0.185415C5.36443 0.180511 5.37252 0.175072 5.38007 0.169224C5.79665 -0.0605531 6.30508 -0.0563317 6.71827 0.181888L9.96761 2.05659L6.37094 4.13313Z" fill="#FCA700"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M10.7381 2.5012L9.9676 2.05664L6.37094 4.13318L6.92907 4.45507C7.48229 4.77296 7.82146 5.36059 7.82146 5.99783V10.6364C7.82146 10.8241 7.79172 11.0078 7.73565 11.1816C7.72963 11.2004 7.72332 11.2191 7.71671 11.2377L10.7385 9.49426C11.1604 9.25184 11.4193 8.80382 11.4193 8.31712V3.67853C11.4193 3.19376 11.1589 2.74376 10.7381 2.5012Z" fill="#AF59E0"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M5.64873 7.83569L2.05206 9.91224L5.35553 11.8182C5.76873 12.0564 6.27718 12.0606 6.69373 11.8308C6.70128 11.825 6.70931 11.8196 6.71782 11.8147C7.01463 11.6436 7.2317 11.3691 7.33377 11.0521C7.37531 10.9211 7.39726 10.7826 7.39726 10.6409V8.84409L5.64873 7.83569Z" fill="#6A9A23"/>
	</svg>`;
const $a59ec0f880a08336$var$RovoLogoSVG = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { label: label, testId: testId } = t0;
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            __html: $a59ec0f880a08336$var$ROVO_SVG_PATH
        };
        t2 = (0, $hekY6.default)([
            $a59ec0f880a08336$var$styles.container
        ]);
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    let t3;
    if ($[2] !== label || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            role: "img",
            "aria-label": label,
            "data-testid": testId,
            dangerouslySetInnerHTML: t1,
            className: t2
        });
        $[2] = label;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ label: label, testId: testId })=>/*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        role: "img",
        "aria-label": label,
        "data-testid": testId,
        dangerouslySetInnerHTML: {
            __html: $a59ec0f880a08336$var$ROVO_SVG_PATH
        },
        className: (0, $hekY6.default)([
            $a59ec0f880a08336$var$styles.container
        ])
    });
const $a59ec0f880a08336$export$4476d508de061a72 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { label: label, testId: testId } = t0;
    let t1;
    if ($[0] !== label || $[1] !== testId) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)($a59ec0f880a08336$var$RovoLogoSVG, {
            label: label,
            testId: testId
        });
        $[0] = label;
        $[1] = testId;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ label: label, testId: testId })=>/*#__PURE__*/ (0, $8aG6j.jsx)($a59ec0f880a08336$var$RovoLogoSVG, {
        label: label,
        testId: testId
    });
module.exports["AIChatIcon"] = $a59ec0f880a08336$export$4476d508de061a72;

});

parcelRegister("3N2DH", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $ad7Ou = parcelRequire("ad7Ou");


var $1sCHt = parcelRequire("1sCHt");


var $5VSNw = parcelRequire("5VSNw");

var $6t3CY = parcelRequire("6t3CY");

var $lslMH = parcelRequire("lslMH");


var $cXtTj = parcelRequire("cXtTj");


var $dTHYM = parcelRequire("dTHYM");


var $dUI0h = parcelRequire("dUI0h");


var $7sJoX = parcelRequire("7sJoX");


var $blZUD = parcelRequire("blZUD");


var $bltJZ = parcelRequire("bltJZ");


var $iDrrr = parcelRequire("iDrrr");


var $4n1IT = parcelRequire("4n1IT");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $jPaq9 = parcelRequire("jPaq9");


var $hdBxM = parcelRequire("hdBxM");


var $4yg9g = parcelRequire("4yg9g");


var $jkcNT = parcelRequire("jkcNT");


var $lpNn5 = parcelRequire("lpNn5");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $kMkDS = parcelRequire("kMkDS");


var $hS1LZ = parcelRequire("hS1LZ");


var $8VrqA = parcelRequire("8VrqA");


var $lsp0E = parcelRequire("lsp0E");

const $c1b3e570a8bf3f0c$var$styles = {
    popupContainer: "_0Of8r2NHnM _1ZnuxbNHnM _1wydGWNHnM _2Zuz6QNHnM",
    formWrapper: "_43nrzT4F84",
    sendIconWrapper: "_03SyCP8HPE",
    rovoChatMoreOptionsButtonContainer: "_0GTcwR4F84",
    rovoChatOpenChatIcon: "_0LQT5EFQfX"
};
const $c1b3e570a8bf3f0c$export$1ccbc9113b239d47 = ({ selectedContent: selectedContent, product: product, onClickChat: onClickChat, onClickPromptOverride: onClickPromptOverride, onSubmitCustomPromptOverride: onSubmitCustomPromptOverride })=>{
    (0, $6cFsl.di)((0, $cXtTj.default), (0, $hS1LZ.useRovoChatHighlightActions));
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const { setIsMoreOptionsPopupOpen: setIsMoreOptionsPopupOpen } = (0, $hS1LZ.useRovoChatHighlightActionsActions)();
    const [{ isMoreOptionsPopupOpen: isMoreOptionsPopupOpen }] = (0, $hS1LZ.useRovoChatHighlightActions)();
    const { insertHighlightActionsEditorPlaceholder: insertHighlightActionsEditorPlaceholder } = (0, $8VrqA.useHighlightActionsEditorPlaceholder)();
    (0, $cozmU.useEffect)(()=>{
        sendAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'contextualMenuItem',
            actionSubjectId: 'rovoChatHighlightActions',
            attributes: {
                product: product
            }
        });
    }, [
        sendAnalyticsEvent,
        product
    ]);
    const onClose = (0, $cozmU.useCallback)(()=>{
        setIsMoreOptionsPopupOpen(false);
    }, [
        setIsMoreOptionsPopupOpen
    ]);
    const handleClickChat = (0, $cozmU.useCallback)(async ()=>{
        onClickChat();
        insertHighlightActionsEditorPlaceholder(selectedContent);
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'highlightActionsMenuRovoChatButton',
            attributes: {
                product: product
            }
        });
    }, [
        onClickChat,
        insertHighlightActionsEditorPlaceholder,
        selectedContent,
        sendAnalyticsEvent,
        product
    ]);
    const handlePromptSubmit = (0, $cozmU.useCallback)((values, form)=>{
        const formattedPrompt = (0, $kMkDS.appendADFContent)(selectedContent, values.prompt);
        if (onSubmitCustomPromptOverride) {
            onSubmitCustomPromptOverride(formattedPrompt);
            form.reset();
            sendAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'highlightActionsMenuSubmitPromptButton',
                attributes: {
                    product: product
                }
            });
            return;
        }
        publish({
            type: 'chat-new',
            source: `${product}-context-menu`,
            data: {
                name: values.prompt.substring(0, 30),
                dialogues: [],
                prompt: formattedPrompt
            }
        });
        form.reset();
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'highlightActionsMenuSubmitPromptButton',
            attributes: {
                product: product
            }
        });
    }, [
        publish,
        sendAnalyticsEvent,
        product,
        onSubmitCustomPromptOverride,
        selectedContent
    ]);
    const rovoChatPromptOptions = [
        {
            id: 'context-menu-rovo-chat-summarize-option',
            actionType: 'summarize',
            prompt: formatMessage((0, $lsp0E.default).rovoChatSummarizePrompt),
            optionText: formatMessage((0, $lsp0E.default).rovoChatSummarizeOptionText)
        },
        {
            id: 'context-menu-rovo-chat-explain-option',
            actionType: 'explain',
            prompt: formatMessage((0, $lsp0E.default).rovoChatExplainPrompt),
            optionText: formatMessage((0, $lsp0E.default).rovoChatExplainOptionText)
        },
        {
            id: 'context-menu-rovo-chat-find-resources-option',
            actionType: 'find-resources',
            prompt: formatMessage((0, $lsp0E.default).rovoChatFindResourcesPrompt),
            optionText: formatMessage((0, $lsp0E.default).rovoChatFindResourcesOptionText)
        },
        {
            id: 'context-menu-rovo-chat-give-feedback-option',
            actionType: 'give-feedback',
            prompt: formatMessage((0, $lsp0E.default).rovoChatGiveFeedbackPrompt),
            optionText: formatMessage((0, $lsp0E.default).rovoChatGiveFeedbackOptionText)
        },
        {
            id: 'context-menu-rovo-chat-give-examples-option',
            actionType: 'give-examples',
            prompt: formatMessage((0, $lsp0E.default).rovoChatGiveExamplesPrompt),
            optionText: formatMessage((0, $lsp0E.default).rovoChatGiveExamplesOptionText)
        }
    ];
    const renderPopupContent = ()=>{
        return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            testId: "context-menu-rovo-chat-popup",
            xcss: $c1b3e570a8bf3f0c$var$styles.popupContainer,
            space: "space.150"
        }, rovoChatPromptOptions.map((option)=>{
            return /*#__PURE__*/ $cozmU.createElement((0, $jPaq9.ChatPill), {
                key: option.id,
                testId: option.id,
                onClick: ()=>{
                    const formattedPrompt_0 = (0, $kMkDS.appendADFContent)(selectedContent, option.prompt);
                    if (onClickPromptOverride) {
                        onClickPromptOverride(formattedPrompt_0);
                        sendAnalyticsEvent({
                            action: 'clicked',
                            actionSubject: 'button',
                            actionSubjectId: 'highlightActionsMenuConvoStarterButton',
                            attributes: {
                                actionType: option.actionType,
                                product: product
                            }
                        });
                        return;
                    }
                    publish({
                        type: 'chat-new',
                        source: `${product}-context-menu`,
                        data: {
                            name: option.prompt.substring(0, 30),
                            dialogues: [],
                            prompt: formattedPrompt_0
                        }
                    });
                    sendAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'highlightActionsMenuConvoStarterButton',
                        attributes: {
                            actionType: option.actionType,
                            product: product
                        }
                    });
                }
            }, option.optionText);
        }), (0, $iDrrr.fg)('platform-design_system_team-form_conversion') ? /*#__PURE__*/ $cozmU.createElement((0, $dTHYM.default), {
            onSubmit: handlePromptSubmit
        }, /*#__PURE__*/ $cozmU.createElement((0, $dUI0h.default), {
            name: "prompt"
        }, ({ fieldProps: { value: value, ...fieldPropsRest }, meta: { dirty: dirty } })=>/*#__PURE__*/ $cozmU.createElement((0, $4yg9g.default // this prevents the highlight actions popup from closing when clicking on the input
            ), {
                onClick: (e)=>e.stopPropagation(),
                ...fieldPropsRest,
                testId: "context-menu-rovo-chat-custom-prompt",
                id: "context-menu-rovo-chat-custom-prompt",
                autoComplete: "off",
                elemAfterInput: /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                    xcss: $c1b3e570a8bf3f0c$var$styles.sendIconWrapper
                }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
                    testId: "context-menu-rovo-chat-custom-prompt-submit",
                    isDisabled: !dirty || !value,
                    label: formatMessage((0, $lsp0E.default).rovoChatCustomPromptSubmitButtonText),
                    type: "submit",
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($blZUD))),
                    spacing: "compact"
                })),
                placeholder: formatMessage((0, $lsp0E.default).rovoChatCustomPromptPlaceholder),
                "aria-label": formatMessage((0, $lsp0E.default).rovoChatCustomPromptPlaceholder)
            }))) : /*#__PURE__*/ $cozmU.createElement((0, $dTHYM.default), {
            onSubmit: handlePromptSubmit
        }, ({ formProps: formProps })=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $c1b3e570a8bf3f0c$var$styles.formWrapper
            }, /*#__PURE__*/ $cozmU.createElement("form", formProps, /*#__PURE__*/ $cozmU.createElement((0, $dUI0h.default), {
                name: "prompt"
            }, ({ fieldProps: { value: value_0, ...fieldPropsRest_0 }, meta: { dirty: dirty_0 } })=>/*#__PURE__*/ $cozmU.createElement((0, $4yg9g.default // this prevents the highlight actions popup from closing when clicking on the input
                ), {
                    onClick: (e_0)=>e_0.stopPropagation(),
                    ...fieldPropsRest_0,
                    testId: "context-menu-rovo-chat-custom-prompt",
                    id: "context-menu-rovo-chat-custom-prompt",
                    autoComplete: "off",
                    elemAfterInput: /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                        xcss: $c1b3e570a8bf3f0c$var$styles.sendIconWrapper
                    }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
                        testId: "context-menu-rovo-chat-custom-prompt-submit",
                        isDisabled: !dirty_0 || !value_0,
                        label: formatMessage((0, $lsp0E.default).rovoChatCustomPromptSubmitButtonText),
                        type: "submit",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($blZUD))),
                        spacing: "compact"
                    })),
                    placeholder: formatMessage((0, $lsp0E.default).rovoChatCustomPromptPlaceholder),
                    "aria-label": formatMessage((0, $lsp0E.default).rovoChatCustomPromptPlaceholder)
                }))))));
    };
    const isToolbarAIFCEnabled = (0, $jkcNT.editorExperiment)('platform_editor_toolbar_aifc', true);
    if (product === 'confluence' && isToolbarAIFCEnabled) return /*#__PURE__*/ $cozmU.createElement((0, $lslMH.ToolbarTooltip), {
        content: formatMessage((0, $lsp0E.default).rovoChatOpenChatTooltip)
    }, /*#__PURE__*/ $cozmU.createElement((0, $6t3CY.ToolbarButton), {
        iconBefore: /*#__PURE__*/ $cozmU.createElement((0, $5VSNw.AIChatIcon), {
            label: ""
        }),
        onClick: handleClickChat,
        testId: "context-menu-rovo-chat-button"
    }, formatMessage((0, $lsp0E.default).rovoChatAskRovoButtonText)));
    return /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), null, /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
        content: formatMessage((0, $lsp0E.default).rovoChatOpenChatTooltip)
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        iconBefore: ()=>/*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                xcss: $c1b3e570a8bf3f0c$var$styles.rovoChatOpenChatIcon
            }, /*#__PURE__*/ $cozmU.createElement((0, $bltJZ.RovoIcon), {
                size: "xsmall"
            })),
        onClick: handleClickChat,
        testId: "context-menu-rovo-chat-button"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        weight: "medium"
    }, formatMessage((0, $lsp0E.default).rovoChatAskRovoButtonText)))), /*#__PURE__*/ $cozmU.createElement((0, $4n1IT.Popup), {
        placement: "bottom-start",
        isOpen: isMoreOptionsPopupOpen,
        onClose: onClose,
        content: renderPopupContent,
        zIndex: 600,
        trigger: (triggerProps)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $c1b3e570a8bf3f0c$var$styles.rovoChatMoreOptionsButtonContainer
            }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
                ...triggerProps,
                appearance: "subtle",
                id: "context-menu-rovo-chat-more-options",
                testId: "context-menu-rovo-chat-more-options",
                isTooltipDisabled: false,
                icon: (props)=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                        ...props,
                        label: formatMessage((0, $lsp0E.default).rovoChatMoreOptionsTooltip),
                        size: "small"
                    }),
                label: formatMessage((0, $lsp0E.default).rovoChatMoreOptionsTooltip),
                onClick: ()=>{
                    setIsMoreOptionsPopupOpen(!isMoreOptionsPopupOpen);
                    sendAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'highlightActionsMenuRovoChatMoreOptionsButton',
                        attributes: {
                            product: product
                        }
                    });
                }
            }))
    }));
};
module.exports["RovoChatHighlightActions"] = $c1b3e570a8bf3f0c$export$1ccbc9113b239d47;

});

parcelRegister("hS1LZ", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $7fb521c50b890daa$var$store = (0, $8s9DV.createStore)({
    name: 'RovoChatHighlightActionsStore',
    initialState: {
        isMoreOptionsPopupOpen: false
    },
    actions: {
        setIsMoreOptionsPopupOpen: (isOpen)=>({ setState: setState })=>{
                setState({
                    isMoreOptionsPopupOpen: isOpen
                });
            }
    }
});
const $7fb521c50b890daa$export$6c9cf98a64763bb1 = (0, $kBr4q.createHook)($7fb521c50b890daa$var$store);
const $7fb521c50b890daa$export$f1e33ed2d48967b4 = (0, $kBr4q.createActionsHook)($7fb521c50b890daa$var$store);
module.exports["useRovoChatHighlightActions"] = $7fb521c50b890daa$export$6c9cf98a64763bb1;
module.exports["useRovoChatHighlightActionsActions"] = $7fb521c50b890daa$export$f1e33ed2d48967b4;

});

parcelRegister("lsp0E", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $47e267cfc6e317db$var$message = (0, $kSwu1.defineMessages)({
    rovoChatAskInChatButtonText: {
        id: "highlight-actions.rovo-chat.ask-in-chat-button-text",
        defaultMessage: "Ask in Chat"
    },
    rovoChatAskRovoButtonText: {
        id: "highlight-actions.rovo-chat.ask-rovo-button-text",
        defaultMessage: "Ask Rovo"
    },
    rovoChatOpenChatTooltip: {
        id: "highlight-actions.rovo-chat-open-chat.tooltip",
        defaultMessage: "Open Chat"
    },
    rovoChatMoreOptionsTooltip: {
        id: "highlight-actions.rovo-chat-more-options.tooltip",
        defaultMessage: "Chat recommendations"
    },
    rovoChatSummarizeOptionText: {
        id: "highlight-actions.rovo-chat-summarize-option.text",
        defaultMessage: "Summarize"
    },
    rovoChatExplainOptionText: {
        id: "highlight-actions.rovo-chat-explain-option.text",
        defaultMessage: "Explain"
    },
    rovoChatFindResourcesOptionText: {
        id: "highlight-actions.rovo-chat-find-resources-option.text",
        defaultMessage: "Find resources"
    },
    rovoChatGiveFeedbackOptionText: {
        id: "highlight-actions.rovo-chat-give-feedback-option.text",
        defaultMessage: "Give feedback"
    },
    rovoChatGiveExamplesOptionText: {
        id: "highlight-actions.rovo-chat-give-examples-option.text",
        defaultMessage: "Give examples"
    },
    rovoChatSummarizePrompt: {
        id: "highlight-actions.rovo-chat-summarize-prompt",
        defaultMessage: "Highlight the key points from this. Focus on essential information and exclude unnecessary details. Provide a concise overview in a single paragraph."
    },
    rovoChatExplainPrompt: {
        id: "highlight-actions.rovo-chat-explain-prompt",
        defaultMessage: "Explain this by rephrasing it and adding additional detail, but use very simple language, short sentences, and provide examples or definitions to any technical terminology used in the original phrasing."
    },
    rovoChatFindResourcesPrompt: {
        id: "highlight-actions.rovo-chat-find-resources-prompt",
        defaultMessage: "Find resources within organizational knowledge only that supports the statements made."
    },
    rovoChatGiveFeedbackPrompt: {
        id: "highlight-actions.rovo-chat-give-feedback-prompt",
        defaultMessage: "Give feedback by reviewing the phrasing of this. Provide commentary on word choice, grammar, punctuation. Be positive and enthusiastic but always provide at least one thing to improve or change."
    },
    rovoChatGiveExamplesPrompt: {
        id: "highlight-actions.rovo-chat-give-examples-prompt",
        defaultMessage: "Give examples of this from organizational resources or public knowledge. If there are no resources to provide attempt to give a metaphorical example that may help someone understand this more."
    },
    rovoChatCustomPromptPlaceholder: {
        id: "highlight-actions.rovo-chat-custom-prompt.placeholder",
        defaultMessage: "Ask AI about this"
    },
    rovoChatCustomPromptSubmitButtonText: {
        id: "highlight-actions.rovo-chat-custom-prompt-submit-button.text",
        defaultMessage: "Send"
    }
});
var $47e267cfc6e317db$export$2e2bcd8739ae039 = $47e267cfc6e317db$var$message;
module.exports["default"] = $47e267cfc6e317db$export$2e2bcd8739ae039;

});

parcelRegister("b6QLO", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $ieeJu = parcelRequire("ieeJu");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $jdv4R = parcelRequire("jdv4R");


var $kb1I3 = parcelRequire("kb1I3");


var $3sXr4 = parcelRequire("3sXr4");

const $79c6915ee8b28dcd$var$messages = (0, $kSwu1.defineMessages)({
    rovoIsThinking: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.rovo-is-thinking",
        defaultMessage: "Rovo is thinking"
    },
    analyzingContent: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.analyzing-content",
        defaultMessage: "Analyzing your content"
    },
    puttingPiecesTogether: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.putting-pieces-together",
        defaultMessage: "Putting the pieces together"
    },
    structuringRemix: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.structuring-remix",
        defaultMessage: "Structuring your remix"
    },
    designingRemix: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.designing-remix",
        defaultMessage: "Designing your remix"
    },
    structuringYourContent: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.structuring-content",
        defaultMessage: "Structuring your content"
    },
    designingYourContent: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.designing-content",
        defaultMessage: "Designing your content"
    },
    addingItAllTogether: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.adding-it-all-together",
        defaultMessage: "Adding it all together"
    },
    applyingFinalTouches: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.applying-final-touches",
        defaultMessage: "Applying the final touches"
    },
    almostDone: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.almost-done",
        defaultMessage: "Almost done"
    }
});
const $79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance = (0, $kSwu1.defineMessages)({
    rovoIsImagining: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.rovo-is-imagining",
        defaultMessage: "Rovo is dreaming it up"
    },
    sketchingSomeIdeas: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.sketching-some-ideas",
        defaultMessage: "Sketching ideas"
    },
    mixingTheColors: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.mixing-the-colors",
        defaultMessage: "Mixing colors"
    },
    findingTheRightStyle: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.finding-the-right-style",
        defaultMessage: "Finding the right style"
    },
    bringingItToLife: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.bringing-it-to-life",
        defaultMessage: "Bringing it to life"
    },
    addingTheDetails: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.adding-the-details",
        defaultMessage: "Adding details"
    },
    applyingTheFinalTouches: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.applying-the-final-touches",
        defaultMessage: "Applying final touches"
    },
    almostDone: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.image-almost-done",
        defaultMessage: "Almost done"
    }
});
const $79c6915ee8b28dcd$var$styles = {
    rovoWrapperFixed: "_313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _1mT5xdy1CL _0Bm75G5zaO _3OE6xY1Y8M _4ApkO21Y8M _39xV02E6Kk _42Yu6BbFo4",
    rovoWrapperFixedContentCentered: "_1mT5xdy1CL _0Bm75G5zaO _39xV02E6Kk _1VJPcajssS _42Yu6BbFo4",
    parentDetector: "_1mT5xdWVPG _0fKRyPnQyn _1pp6NdYbGa",
    rovoWrapperAbsolute: "_313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _1mT5xdWVPG _0Bm75G5zaO _3OE6xY1Y8M _4ApkO21Y8M _39xV02E6Kk _42Yu6BbFo4",
    rovoWrapperRelative: "_1mT5xdRAKS _0Of8r25zaO _1wydGW5zaO"
};
function $79c6915ee8b28dcd$export$d6f2d83daf5efc44({ onStop: onStop, remixAttemptId: remixAttemptId, optionType: _optionType, isRelative: isRelative = false, loadingBarType: loadingBarType = isRelative ? 'mini-bar' : 'big-bar', showProgressBar: showProgressBar = false, isComplete: isComplete = false, onCompleteAnimationFinished: onCompleteAnimationFinished, contentType: contentType, isRemixEntrance: isRemixEntrance = true, shouldMeasureContentBounds: shouldMeasureContentBounds = false }) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const loadingBarExperienceInstanceId = (0, $cozmU.useId)();
    const loadingBarMetadataRef = (0, $cozmU.useRef)({
        remixAttemptId: remixAttemptId,
        loadingBarType: loadingBarType,
        contentType: contentType,
        optionType: _optionType,
        isRemixEntrance: isRemixEntrance,
        hasCompletionHandshake: onCompleteAnimationFinished !== undefined
    });
    (0, $cozmU.useEffect)(()=>{
        const loadingBarExperience = (0, $jdv4R.createRemixLoadingBarExperience)(loadingBarExperienceInstanceId);
        loadingBarExperience.start();
        loadingBarExperience.addMetadata(loadingBarMetadataRef.current);
        if (loadingBarMetadataRef.current.isRemixEntrance) sendAnalyticsEvent({
            eventType: 'screen',
            name: 'remixProgressIndicator',
            attributes: {
                remixType: loadingBarMetadataRef.current.optionType
            }
        });
        return ()=>{
            loadingBarExperience.success();
        };
    }, [
        loadingBarExperienceInstanceId,
        sendAnalyticsEvent
    ]);
    const positionAbsolute = contentType === 'jira.issue'; // Confluence page remix uses the fixed/overlay path (no `contentType`, not `isRelative`).
    // When enabled, center the bar over the content area instead of the viewport so it stays
    // aligned when a sidenav/sidebar is open. Jira (`positionAbsolute`) is unaffected.
    const isCenterContentExpEnabled = (0, $ieeJu.expValEquals)('cc_maui_polish_changes_batch_2', 'isEnabled', true);
    const shouldCenterOnContent = isCenterContentExpEnabled && shouldMeasureContentBounds; // Measure the content container (the detector marker's parent) so the fixed bar can be
    // centered on the content rather than the viewport. Re-measures on container resize, which
    // covers a sidenav/sidebar opening or closing. Stays viewport-centered until measured.
    const parentDetectorRef = (0, $cozmU.useRef)(null);
    const [contentCenterX, setContentCenterX] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!shouldCenterOnContent) return;
        const parentContainer = parentDetectorRef.current?.parentElement;
        if (!parentContainer) return;
        const updateCenter = ()=>{
            const rect = parentContainer.getBoundingClientRect();
            setContentCenterX(rect.left + rect.width / 2);
        };
        const resizeObserver = new ResizeObserver(updateCenter);
        resizeObserver.observe(parentContainer);
        updateCenter();
        return ()=>resizeObserver.disconnect();
    }, [
        shouldCenterOnContent
    ]);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)(); // A/A experiment paired with cc_maui_create_keyword; called to balance exposures. Result unused.
    (0, $ieeJu.expValEquals)('cc_maui_create_keyword_aa', 'isEnabled', true);
    const thinkingTexts = [
        formatMessage($79c6915ee8b28dcd$var$messages.rovoIsThinking),
        formatMessage($79c6915ee8b28dcd$var$messages.analyzingContent),
        formatMessage($79c6915ee8b28dcd$var$messages.puttingPiecesTogether),
        formatMessage((0, $ieeJu.expValEquals)('cc_maui_create_keyword', 'isEnabled', true) ? $79c6915ee8b28dcd$var$messages.structuringYourContent : $79c6915ee8b28dcd$var$messages.structuringRemix),
        formatMessage((0, $ieeJu.expValEquals)('cc_maui_create_keyword', 'isEnabled', true) ? $79c6915ee8b28dcd$var$messages.designingYourContent : $79c6915ee8b28dcd$var$messages.designingRemix),
        formatMessage($79c6915ee8b28dcd$var$messages.addingItAllTogether),
        formatMessage($79c6915ee8b28dcd$var$messages.applyingFinalTouches),
        formatMessage($79c6915ee8b28dcd$var$messages.almostDone)
    ];
    const thinkingTextsNonRemixEntrance = [
        formatMessage($79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance.rovoIsImagining),
        formatMessage($79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance.sketchingSomeIdeas),
        formatMessage($79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance.mixingTheColors),
        formatMessage($79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance.findingTheRightStyle),
        formatMessage($79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance.bringingItToLife),
        formatMessage($79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance.addingTheDetails),
        formatMessage($79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance.applyingTheFinalTouches),
        formatMessage($79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance.almostDone)
    ];
    const barContent = /*#__PURE__*/ $cozmU.createElement((0, $3sXr4.RovoThinkingBarWrapper), {
        isThinking: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $kb1I3.RovoThinkingBar), {
        onStop: onStop,
        showProgressBar: showProgressBar,
        isComplete: isComplete,
        onCompleteAnimationFinished: onCompleteAnimationFinished,
        useRotatingTitle: true,
        customRotatingMessages: isRemixEntrance ? thinkingTexts : thinkingTextsNonRemixEntrance
    })); // Content-centered fixed path (Confluence view page, gated + opted in via
    // `shouldMeasureContentBounds`). Renders a hidden marker so the content container can be
    // measured, then centers the fixed bar on the content's horizontal midpoint. Falls back to
    // viewport-centering (`left: 50%`) until the measurement resolves.
    if (!isRelative && !positionAbsolute && shouldCenterOnContent) return /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        ref: parentDetectorRef,
        xcss: $79c6915ee8b28dcd$var$styles.parentDetector,
        testId: "remix-thinking-bar-parent-detector"
    }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $79c6915ee8b28dcd$var$styles.rovoWrapperFixedContentCentered,
        style: {
            minWidth: (0, $iDrrr.fg)('platform_maui_jira_ui_fix') ? 'min(400px, 100%)' : '400px',
            left: contentCenterX != null ? `${contentCenterX}px` : '50%'
        },
        testId: "remix-thinking-bar-gradient-border"
    }, barContent));
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: // eslint-disable-next-line no-nested-ternary
        isRelative ? $79c6915ee8b28dcd$var$styles.rovoWrapperRelative : positionAbsolute ? $79c6915ee8b28dcd$var$styles.rovoWrapperAbsolute : $79c6915ee8b28dcd$var$styles.rovoWrapperFixed,
        style: {
            minWidth: (0, $iDrrr.fg)('platform_maui_jira_ui_fix') ? 'min(400px, 100%)' : '400px'
        },
        testId: "remix-thinking-bar-gradient-border"
    }, barContent);
}
module.exports["RemixThinkingBar"] = $79c6915ee8b28dcd$export$d6f2d83daf5efc44;

});

parcelRegister("jdv4R", function(module, exports) {

var $cNAch = parcelRequire("cNAch");


var $4MiWC = parcelRequire("4MiWC");

const $8d105d30086155d7$export$4be31113674d294a = (instanceId)=>new (0, $cNAch.UFOExperience)('remix-loading-bar', {
        type: (0, $4MiWC.ExperienceTypes).Experience,
        performanceType: (0, $4MiWC.ExperiencePerformanceTypes).InlineResult
    }, instanceId);
module.exports["createRemixLoadingBarExperience"] = $8d105d30086155d7$export$4be31113674d294a;

});

parcelRegister("8GyO5", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $9kbTQ = parcelRequire("9kbTQ");


var $03RpJ = parcelRequire("03RpJ");


var $1hQ0e = parcelRequire("1hQ0e");


var $cha5E = parcelRequire("cha5E");


var $2pQiO = parcelRequire("2pQiO");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $1qYXT = parcelRequire("1qYXT");


var $crsgV = parcelRequire("crsgV");


var $b6QLO = parcelRequire("b6QLO");

const $1babe6d267af7ec0$var$randomId = ()=>{
    if (globalThis?.crypto?.randomUUID) return globalThis.crypto.randomUUID();
     // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- uuid is used as a fallback for environments where crypto.randomUUID is unavailable
    return (0, $03RpJ.default)();
};
const $1babe6d267af7ec0$var$styles = {
    anchorTrigger: "_1mT5xdy1CL _1pp6NdYbGa"
}; /**
    * Builds a `RemixPopup` `trigger` render function from a plain DOM rect snapshot: an invisible,
    * fixed-position div matching the rect's bounds, which the popup anchors to. Used for entry points
    * that don't have a persistent trigger element (e.g. a floating/selection toolbar, or a button that
    * may unmount while the flow is active) — they instead capture `getBoundingClientRect()` (or the
    * current selection's rect) once, at click time.
    *
    * Portaled directly to the top-level document body: `RemixContainer` can be mounted anywhere in a product's DOM
    * tree (e.g. deep inside an editor's content component), and `position: fixed` is only viewport-
    * relative when none of its ancestors have a `transform`/`filter`/`will-change` — which editors
    * commonly do for scroll/sticky containers. Portaling avoids inheriting any such ancestor, so the
    * rect is always interpreted relative to the viewport, matching where it was captured.
    */ 
function $1babe6d267af7ec0$var$buildAnchorRectTrigger(anchorRect) {
    return (triggerProps)=>{
        const document = (0, $1hQ0e.getDocument)();
        if (!document?.body) return null;
        return /*#__PURE__*/ (0, $9kbTQ.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ...triggerProps,
            xcss: $1babe6d267af7ec0$var$styles.anchorTrigger,
            style: {
                top: anchorRect.top,
                left: anchorRect.left,
                width: anchorRect.width,
                height: anchorRect.height
            },
            "aria-hidden": "true"
        }), document.body);
    };
} /**
   * Props for the Remix container composed entry point.
   */ 
function $1babe6d267af7ec0$export$d2a66369b43f5d65({ onClose: onClose, remixAttemptId: remixAttemptId, onOptionSelect: onOptionSelect, onRemixFlowActiveChange: onRemixFlowActiveChange, hideThinkingBar: hideThinkingBar = false, isEphemeralViewVisible: isEphemeralViewVisible = false, skipThinkingTypes: skipThinkingTypes, options: options, hiddenOptions: hiddenOptions, subtitle: subtitle, cascadingMenuHeader: cascadingMenuHeader, presentation: presentation = 'modal', trigger: trigger, anchorRect: anchorRect, popupPlacement: popupPlacement, popupOffset: popupOffset, isPopupOpen: isPopupOpen = true, shouldCloseOnScroll: shouldCloseOnScroll = false, shouldPreserveEditorFocus: shouldPreserveEditorFocus = false, popupRepositionKey: popupRepositionKey, showProgressBar: showProgressBar = false, isComplete: isComplete = false, isThinking: controlledIsThinking, onCompleteAnimationFinished: onCompleteAnimationFinished, contentType: contentType, autoSubmitUserPrompt: autoSubmitUserPrompt, autoSubmitSelection: autoSubmitSelection, onStopThinking: onStopThinking, isRemixEntrance: isRemixEntrance = true, shouldMeasureContentBounds: shouldMeasureContentBounds = false }) {
    // for editor, isThinking will be passed in, which is stored in editor state
    // Auto-submitted prompts/selections should skip the option picker on first render.
    const [localIsThinking, setLocalIsThinking] = (0, $cozmU.useState)(!!autoSubmitUserPrompt || !!autoSubmitSelection);
    const isThinking = controlledIsThinking ?? localIsThinking;
    const [localRemixAttemptId, setLocalRemixAttemptId] = (0, $cozmU.useState)();
    const localRemixAttemptIdRef = (0, $cozmU.useRef)(undefined);
    (0, $cozmU.useEffect)(()=>{
        var _localRemixAttemptIdRef;
        if (!isThinking || remixAttemptId) {
            localRemixAttemptIdRef.current = undefined;
            setLocalRemixAttemptId(undefined);
            return;
        }
        (_localRemixAttemptIdRef = localRemixAttemptIdRef).current ?? (_localRemixAttemptIdRef.current = $1babe6d267af7ec0$var$randomId());
        setLocalRemixAttemptId(localRemixAttemptIdRef.current);
    }, [
        isThinking,
        remixAttemptId
    ]);
    const currentRemixAttemptId = remixAttemptId ?? localRemixAttemptId;
    const [selectedOptionType, setSelectedOptionType] = (0, $cozmU.useState)(); // Prevent the option picker flashing after a cancelled auto-submit flow.
    const [isCancelledAutoSubmit, setIsCancelledAutoSubmit] = (0, $cozmU.useState)(false);
    const showThinkingBar = isThinking && currentRemixAttemptId !== undefined && !isEphemeralViewVisible && !hideThinkingBar;
    const remixMenuCohort = (0, $2pQiO.UNSAFE_expValNoExposure)((0, $1qYXT.REMIX_MENU_EXPERIMENT), (0, $1qYXT.REMIX_MENU_COHORT_PARAM), (0, $1qYXT.REMIX_MENU_CONTROL_COHORT));
    const isDropdownVariantEnabled = remixMenuCohort === (0, $1qYXT.REMIX_MENU_INLINE_DROPDOWN_COHORT);
    const effectiveTrigger = trigger ?? (isDropdownVariantEnabled && anchorRect ? $1babe6d267af7ec0$var$buildAnchorRectTrigger(anchorRect) : undefined);
    const effectivePresentation = isDropdownVariantEnabled && effectiveTrigger ? 'popup' : presentation; // Shared menu-open point for experiment exposure.
    const isRemixMenuOpen = (effectivePresentation !== 'popup' || !effectiveTrigger || isPopupOpen) && !isThinking; // Exposure only; variant behavior is added in follow-up PRs.
    (0, $cozmU.useEffect)(()=>{
        if (!isRemixMenuOpen) return;
        const remixMenuCohort = (0, $cha5E.expVal)((0, $1qYXT.REMIX_MENU_EXPERIMENT), (0, $1qYXT.REMIX_MENU_COHORT_PARAM), (0, $1qYXT.REMIX_MENU_CONTROL_COHORT));
        if (remixMenuCohort === (0, $1qYXT.REMIX_MENU_INLINE_DROPDOWN_COHORT)) ;
        else remixMenuCohort; // Keep the existing A/A exposure logic unchanged.
        (0, $cha5E.expVal)((0, $1qYXT.REMIX_MENU_AA_EXPERIMENT), (0, $1qYXT.REMIX_MENU_AA_VARIANT_PARAM), (0, $1qYXT.REMIX_MENU_CONTROL_COHORT));
    }, [
        isRemixMenuOpen
    ]); // When a selection is pre-supplied (the picker lives elsewhere, e.g. the editor
    // toolbar Remix dropdown), fire it once on mount and never render the in-app
    // picker. This runs even when a controlled `isThinking={false}` is passed.
    const hasAutoSubmittedSelectionRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(false);
    (0, $cozmU.useEffect)(()=>{
        if (hasAutoSubmittedSelectionRef.current || !autoSubmitSelection) return;
        hasAutoSubmittedSelectionRef.current = true;
        setSelectedOptionType(autoSubmitSelection.type);
        setLocalIsThinking(true);
        onRemixFlowActiveChange?.(true);
        onOptionSelect?.(autoSubmitSelection); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        autoSubmitSelection?.type,
        autoSubmitSelection?.subType,
        autoSubmitSelection?.userPrompt
    ]);
    const handleOptionSelect = (0, $cozmU.useCallback)((params)=>{
        if (!skipThinkingTypes?.has(params.type)) setLocalIsThinking(true);
        setSelectedOptionType(params.type);
        onRemixFlowActiveChange?.(true);
        onOptionSelect?.(params);
    }, [
        onOptionSelect,
        onRemixFlowActiveChange,
        skipThinkingTypes
    ]);
    const handleStopThinking = (0, $cozmU.useCallback)(()=>{
        if ((0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) onStopThinking?.();
        setLocalIsThinking(false);
        if (autoSubmitUserPrompt) setIsCancelledAutoSubmit(true);
         // for insertion, when cancel, the logic is from ProseMirror, we'll show the modal again and
        // - we call onRemixFlowActiveChange in useEffect to cancel the request
        // but for update, when cancel, the logic is from UI, we have to call onRemixFlowActiveChange manually
        // - cause the component tree will be unmounted and the useEffect will not be called
        onRemixFlowActiveChange?.(false);
    }, [
        autoSubmitUserPrompt,
        onRemixFlowActiveChange,
        onStopThinking
    ]); // only when show the thinking bar, we handle the escape key to stop the thinking
    // when the thinking bar is rendered in editor, the escape will also be handled by editor
    (0, $cozmU.useEffect)(()=>{
        if ((0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) {
            if (!showThinkingBar) return;
        } else {
            if ((0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading')) return;
            if (!isThinking) return;
        }
        return (0, $cbY7C.bind)(window, {
            type: 'keydown',
            listener: (e)=>{
                if (e.key === 'Escape') handleStopThinking();
            }
        });
    }, [
        isThinking,
        handleStopThinking,
        showThinkingBar
    ]); // Keep the trigger mounted so Popup can stay anchored.
    if (effectivePresentation === 'popup' && effectiveTrigger) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $crsgV.RemixPopup), {
        isOpen: isPopupOpen && !isThinking,
        onClose: onClose,
        trigger: effectiveTrigger,
        placement: popupPlacement,
        offset: popupOffset,
        useCascadingMenu: isDropdownVariantEnabled,
        cascadingMenuHeader: cascadingMenuHeader,
        shouldCloseOnScroll: shouldCloseOnScroll,
        shouldPreserveEditorFocus: shouldPreserveEditorFocus,
        onOptionSelect: handleOptionSelect,
        options: options,
        hiddenOptions: hiddenOptions,
        subtitle: subtitle,
        repositionKey: popupRepositionKey
    }), showThinkingBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6QLO.RemixThinkingBar), {
        remixAttemptId: currentRemixAttemptId,
        loadingBarType: "big-bar",
        onStop: handleStopThinking,
        optionType: selectedOptionType,
        showProgressBar: showProgressBar,
        isComplete: isComplete,
        onCompleteAnimationFinished: onCompleteAnimationFinished,
        contentType: contentType,
        isRemixEntrance: isRemixEntrance,
        shouldMeasureContentBounds: shouldMeasureContentBounds
    }));
     // Modal mode (default).
    if (isThinking) {
        if (showThinkingBar) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6QLO.RemixThinkingBar), {
            remixAttemptId: currentRemixAttemptId,
            loadingBarType: "big-bar",
            onStop: handleStopThinking,
            optionType: selectedOptionType,
            showProgressBar: showProgressBar,
            isComplete: isComplete,
            onCompleteAnimationFinished: onCompleteAnimationFinished,
            contentType: contentType,
            isRemixEntrance: isRemixEntrance,
            shouldMeasureContentBounds: shouldMeasureContentBounds
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
    } // Auto-submit cancellation leaves reopening to the caller.
    if (isCancelledAutoSubmit) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
     // Never render the in-app option-picker when a selection is pre-supplied — the
    // picker lives elsewhere (e.g. the editor toolbar Remix dropdown). The mount
    // only exists to run the flow; the auto-submit effect above starts it.
    if (autoSubmitSelection) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $crsgV.RemixOverlay), {
        onClose: onClose,
        onOptionSelect: handleOptionSelect,
        options: options,
        hiddenOptions: hiddenOptions,
        subtitle: subtitle
    });
}
module.exports["RemixContainer"] = $1babe6d267af7ec0$export$d2a66369b43f5d65;

});

parcelRegister("1qYXT", function(module, exports) {
const $f654d7d76017903f$export$dbf8cbce125113dc = 'cc-ce-maui-remix-menu-multivariant';
const $f654d7d76017903f$export$16d917a0604bca11 = 'cc-ce-maui-remix-menu-multivariant-aa';
const $f654d7d76017903f$export$2c70a635cf90671d = 'cohort';
const $f654d7d76017903f$export$1ae578a2cbbda68e = 'variant';
const $f654d7d76017903f$export$3d85c6890e42c40 = 'control';
const $f654d7d76017903f$export$c3c6fd65e75f7a5b = 'variant1';
const $f654d7d76017903f$export$7004846771b000c0 = [
    'mediaSingle',
    'mediaGroup',
    'media',
    'image',
    'extension',
    'bodiedExtension',
    'multiBodiedExtension',
    'embedCard',
    'blockCard',
    'inlineCard',
    // Source blocks
    'bodiedSyncBlock',
    // Reference blocks
    'syncBlock',
    'expand',
    'nestedExpand'
];
const $f654d7d76017903f$var$DENY_SET = new Set($f654d7d76017903f$export$7004846771b000c0);
const $f654d7d76017903f$export$bf9aef57175a93a2 = (nodeType)=>$f654d7d76017903f$var$DENY_SET.has(nodeType);
const $f654d7d76017903f$export$f5b180e87c8cf581 = 'cc_maui_polish_changes_batch_7';
const $f654d7d76017903f$export$937cbf4f7cf583ee = [
    'expand',
    'nestedExpand'
];
const $f654d7d76017903f$var$EXPAND_NODE_TYPES = new Set($f654d7d76017903f$export$937cbf4f7cf583ee);
const $f654d7d76017903f$export$abcc4815bdfd056c = (nodeType, areExpandsEnabled)=>{
    if ($f654d7d76017903f$var$EXPAND_NODE_TYPES.has(nodeType) && areExpandsEnabled()) return false;
    return $f654d7d76017903f$export$bf9aef57175a93a2(nodeType);
};
const $f654d7d76017903f$export$a7b703a84f6e523d = (extensionKey, allowList)=>extensionKey !== undefined && allowList.includes(extensionKey);
module.exports["REMIX_MENU_EXPERIMENT"] = $f654d7d76017903f$export$dbf8cbce125113dc;
module.exports["REMIX_MENU_AA_EXPERIMENT"] = $f654d7d76017903f$export$16d917a0604bca11;
module.exports["REMIX_MENU_COHORT_PARAM"] = $f654d7d76017903f$export$2c70a635cf90671d;
module.exports["REMIX_MENU_AA_VARIANT_PARAM"] = $f654d7d76017903f$export$1ae578a2cbbda68e;
module.exports["REMIX_MENU_CONTROL_COHORT"] = $f654d7d76017903f$export$3d85c6890e42c40;
module.exports["REMIX_MENU_INLINE_DROPDOWN_COHORT"] = $f654d7d76017903f$export$c3c6fd65e75f7a5b;
module.exports["REMIX_DENY_LIST_V1"] = $f654d7d76017903f$export$7004846771b000c0;
module.exports["isRemixRestrictedNodeType"] = $f654d7d76017903f$export$bf9aef57175a93a2;
module.exports["REMIX_EXPANDS_EXPERIMENT"] = $f654d7d76017903f$export$f5b180e87c8cf581;
module.exports["REMIX_EXPAND_NODE_TYPES"] = $f654d7d76017903f$export$937cbf4f7cf583ee;
module.exports["isRemixRestrictedNodeTypeWithExpands"] = $f654d7d76017903f$export$abcc4815bdfd056c;
module.exports["isAllowedMBEExtensionForRemix"] = $f654d7d76017903f$export$a7b703a84f6e523d;

});

parcelRegister("crsgV", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $kSwu1 = parcelRequire("kSwu1");


var $1hQ0e = parcelRequire("1hQ0e");


var $ad7Ou = parcelRequire("ad7Ou");


var $1sCHt = parcelRequire("1sCHt");


var $dTHYM = parcelRequire("dTHYM");


var $I7hWB = parcelRequire("I7hWB");


var $f6cdQ = parcelRequire("f6cdQ");


var $7sJoX = parcelRequire("7sJoX");


var $j6vyT = parcelRequire("j6vyT");


var $lSQgn = parcelRequire("lSQgn");


var $cJ0FD = parcelRequire("cJ0FD");


var $fEPJS = parcelRequire("fEPJS");


var $7aRdF = parcelRequire("7aRdF");


var $aRGok = parcelRequire("aRGok");


var $2LyZS = parcelRequire("2LyZS");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $4n1IT = parcelRequire("4n1IT");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $hBYtq = parcelRequire("hBYtq");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $e3Wrf = parcelRequire("e3Wrf");


var $ieeJu = parcelRequire("ieeJu");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $lpNn5 = parcelRequire("lpNn5");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $kDDrf = parcelRequire("kDDrf");


var $bjY3F = parcelRequire("bjY3F");


var $fkYYP = parcelRequire("fkYYP");


var $HvNsc = parcelRequire("HvNsc");


var $1LRKz = parcelRequire("1LRKz");


var $czfXc = parcelRequire("czfXc");


var $dcNzQ = parcelRequire("dcNzQ");


var $9z4Bk = parcelRequire("9z4Bk");


var $loej8 = parcelRequire("loej8");

const $be6de585ac044839$var$headerOuterStyle = null;
const $be6de585ac044839$var$headerOuterMinimizedStyle = null;
const $be6de585ac044839$var$labsPositionStyle = null;
const $be6de585ac044839$var$cascadingHeaderWrapperStyle = null;
const $be6de585ac044839$var$headerIconWrapperStyle = null;
const $be6de585ac044839$var$headerIconWrapperMinimizedStyle = null; // 92px = space.300 (24px top padding) + 64px icon + 4px gap
const $be6de585ac044839$var$headerHeadingStyle = null; // left: 16px (space.200) + 48px icon + 8px gap = 72px
// top: vertically centered with 48px icon — icon center is at 16px + 24px = 40px,
// heading line-height ~24px, so top = 40px - 12px = 28px
const $be6de585ac044839$var$headerHeadingMinimizedStyle = null; // 120px = 92px heading top + ~28px heading height
const $be6de585ac044839$var$headerSubtitleStyle = null; // Hide subtitle in minimized state — fast fade out, delayed fade in handled by base style
const $be6de585ac044839$var$headerSubtitleMinimizedStyle = null;
const $be6de585ac044839$var$subtitleStyle = null; // 113px = 64px icon + 4px gap + ~28px heading + ~4px gap + ~13px subtitle
const $be6de585ac044839$var$headerSpacerStyle = null; // 48px = minimized icon height (no subtitle in minimized state)
const $be6de585ac044839$var$headerSpacerMinimizedStyle = null; // ── RemixSubTypeGrid styles ────────────────────────────────────────────────
const $be6de585ac044839$var$gridStyles = {
    grid: "_2mHwu82ADO _3iDTPbgBM8 _2iEGP2PTnU _39xV02N91d _46hvQm2ADO",
    tile: "_0bjKvD8fU6 _4bt5LAnQyn _2WAcuGnQyn _23rrnHyKLB _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0jFU0VfI2J _0KLXruoI2d _0wOv4Q7zJH _0hPERGjOvk _1eOmH6d1Zr"
}; // ── RemixAccordionOption styles ────────────────────────────────────────────
const $be6de585ac044839$var$accordionStyles = {
    accordionWrapper: "_0bjKvD8fU6 _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _39xV02N91d",
    accordionHeader: "_0bjKvD8fU6 _2V7sgOdnbC _4c065U2ADO _39xV02N91d _0jFU0VpJKa _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3 _0KLXru66of _0LQT5E8HPE _03SyCP8HPE _0wOv4Q7zJH",
    expandedContent: "_2Y7lL48HPE _0xmtkoPgdg",
    pickForMeWrapper: "_2Y7lL4gVvo _46hvQmgVvo _0xmtkogVvo _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67 _43nrzT8HPE"
};
const $be6de585ac044839$var$accordionCollapsedStyle = null;
const $be6de585ac044839$var$accordionExpandedStyle = null;
const $be6de585ac044839$var$revealContentStyle = null;
const $be6de585ac044839$var$pickForMeButtonStyle = null; // ── RemixOverlay styles ────────────────────────────────────────────────────
const $be6de585ac044839$var$modalContentWrapperStyle = null; // ── RemixPopup styles ──────────────────────────────────────────────────────
const $be6de585ac044839$var$subtleSlideIn = null;
const $be6de585ac044839$var$popupStyles = {
    popupEnterAnimation: "_1gBibyf9Pz _0nFVCG2HTN _43vdfTdisq _3Y6bKp38c8 _39Ohv4YbGa",
    contentWrapper: "_4bt5LAnQyn _2WAcuGnQyn _0bjKvD8fU6 _3iDTPbQ4SZ _0aFT5vbt8w _39xV02sz7G _0KLXrunmFW",
    cascadingContentWrapper: "_4bt5LAYvD1 _2WAcuGYvD1 _3iDTPbQ4SZ _0aFT5vbt8w _0KLXrujOvk",
    body: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0aFT5vbt8w",
    cascadingBody: "_4bt5LAYvD1 _2WAcuGYvD1 _3iDTPbQ4SZ _0aFT5vbt8w",
    cascadingHeader: "_39xV02N91d _2fwxA5DIqT",
    cascadingHeaderIcon: "_39xV02mdCj _0jFU0VmdCj"
};
const $be6de585ac044839$var$transparentPopupContainerStyle = null;
const $be6de585ac044839$var$CascadingPopupContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((props, ref)=>{
    const { shouldRenderToParent: _shouldRenderToParent, shouldFitContainer: _shouldFitContainer, appearance: _appearance, xcss: _xcss, isReferenceHidden: _isReferenceHidden, children: children, 'data-testid': dataTestId, 'data-placement': dataPlacement, ...htmlAttributes } = props;
    const verticalDirection = (0, $dcNzQ.getCascadeVerticalDirectionForPlacement)(dataPlacement);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dcNzQ.CascadeVerticalDirectionContext).Provider, {
        value: verticalDirection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: ref,
        "data-testid": dataTestId ?? 'remix-cascading-popup-container',
        "data-remix-cascading-popup": true,
        "data-toolbar-nested-dropdown-menu": true,
        "data-placement": dataPlacement,
        ...htmlAttributes,
        className: (0, $hekY6.default)([
            "_0KLXrujOvk _2OUyjtYbGa"
        ])
    }, children));
});
$be6de585ac044839$var$CascadingPopupContainer.displayName = 'CascadingPopupContainer';
const $be6de585ac044839$var$scrollableBodyStyle = null;
const $be6de585ac044839$var$remixStyles = {
    describeInputBorderWrapper: "_39xV02N91d _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67",
    describeInputWrapper: "_4c065U8HPE _2Y7lL45zaO _39xV02N91d _0KLXrunmFW",
    compactDescribeInputWrapper: "_4c065UgVvo _2Y7lL42ADO _39xV02N91d _0KLXruoI2d",
    describePromptRow: "_2mHwu8gVvo _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLz9WS _39xV02N91d",
    describeTextAreaWrapper: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _4ouGXIdnbC",
    modalBodyPadding: "_2Y7lL45zaO _46hvQm1Y8M _0xmtko5zaO",
    remixOptionsStack: "_39xV02N91d"
}; // ── RemixOverlayHeader ─────────────────────────────────────────────────────
function $be6de585ac044839$var$RemixOverlayHeader({ subtitle: subtitle, isMinimized: isMinimized = false }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)(); // A/A experiment paired with cc_maui_create_keyword; called to balance exposures. Result unused.
    (0, $ieeJu.expValEquals)('cc_maui_create_keyword_aa', 'isEnabled', true);
    const subtitleMessage = subtitle ?? (0, $czfXc.default).subtitle; // Track minimized state changes to trigger the icon fade-out/fade-in animation.
    // When isMinimized changes, quickly fade out at the start, then fade back in
    // near the end of the 200ms position transition.
    const iconRef = (0, $cozmU.useRef)(null);
    const prevMinimizedRef = (0, $cozmU.useRef)(isMinimized);
    (0, $cozmU.useEffect)(()=>{
        if (prevMinimizedRef.current !== isMinimized) {
            prevMinimizedRef.current = isMinimized;
            const el = iconRef.current;
            if (el) {
                // Gently fade out (uses the 100ms ease-out opacity transition from the base style)
                el.style.opacity = '0'; // Near the end of the 200ms position transition, fade back in
                const timer = setTimeout(()=>{
                    el.style.opacity = '1';
                }, 130);
                return ()=>clearTimeout(timer);
            }
        }
    }, [
        isMinimized
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_23rrnHTaix _1mT5xdRAKS _39xV02N91d _46hvQmNHnM _0xmtkoNHnM",
            isMinimized && "_46hvQm5zaO _0xmtko5zaO"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _2IhTon8HPE _4ApkO28HPE _1pp6NdYbGa"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fkYYP.RemixLabsLozenge), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: iconRef,
        "aria-hidden": "true",
        className: (0, $hekY6.default)([
            "_23rrnHxGK8 _1mT5xdWVPG _3OE6xY715P _2IhTonNHnM _1VJPcajssS _39xV029LX5 _0jFU0V9LX5",
            isMinimized && "_3OE6xY5zaO _2IhTon5zaO _1VJPcalna5 _39xV02pJKa _0jFU0VpJKa"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($HvNsc))),
        alt: formatMessage((0, $czfXc.default).remixIconAlt),
        width: "100%"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_23rrnHYjhE _1mT5xdWVPG _3OE6xY715P _2IhTonaXQy _1VJPcajssS _1ANEUSLRg7",
            isMinimized && "_3OE6xYUudP _2IhToncM5X _1VJPcalna5"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: isMinimized ? 'medium' : 'large'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $ieeJu.expValEquals)('cc_maui_create_keyword', 'isEnabled', true) ? (0, $czfXc.default).createHeading : (0, $czfXc.default).heading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_23rrnHZWJM _1mT5xdWVPG _3OE6xY715P _2IhTonv6H3 _1VJPcajssS _1ANEUSLRg7",
            isMinimized && "_23rrnH52bh _1YKVNsdnbC _1pp6NdYbGa",
            "_1UtDYzKGUX"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), subtitleMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_23rrnHRiH9 _0jFU0VU9z0",
            isMinimized && "_0jFU0VpJKa"
        ])
    }));
} // ── RemixSubTypeGrid ───────────────────────────────────────────────────────
function $be6de585ac044839$var$RemixSubTypeGrid({ isAnimatedArtworkEnabled: isAnimatedArtworkEnabled, subTypes: subTypes, onSubTypeSelect: onSubTypeSelect }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)(); // Tiles opt into keyboard-focus artwork motion by rendering `data-remix-artwork-tile`, which the
    // artwork stylesheets key their `:focus-visible` rules off.
    const isKeyboardArtworkMotionEnabled = (0, $4o0zT.isExperimentEnabled)('cc_maui_polish_changes_batch_7');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $be6de585ac044839$var$gridStyles.grid
    }, subTypes.map((subType, motionIndex)=>{
        const IconComponent = (0, $9z4Bk.getSubTypeIconComponent)(subType.value, isAnimatedArtworkEnabled);
        const label = formatMessage(subType.labelMessage);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            key: subType.value,
            content: label,
            position: "top",
            delay: 0,
            ignoreTooltipPointerEvents: true
        }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                ...tooltipProps,
                ...isKeyboardArtworkMotionEnabled ? {
                    'data-remix-artwork-tile': true
                } : {},
                xcss: $be6de585ac044839$var$gridStyles.tile,
                onClick: ()=>onSubTypeSelect(subType.value),
                testId: subType.testId,
                "aria-label": label
            }, IconComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IconComponent, {
                alt: label,
                motionIndex: motionIndex
            }) : null));
    }));
} // ── RemixAccordionOption ───────────────────────────────────────────────────
const $be6de585ac044839$var$animationConfig = {
    duration: ()=>450
}; // Tracks preloaded option/theme/cohort groups to avoid duplicate work.
const $be6de585ac044839$var$preloadedIconGroups = new Set(); /**
                                                * Preloads sub-type icon images for a remix option so they display instantly
                                                * when the accordion expands. Only fetches icons for the active color mode.
                                                */ 
function $be6de585ac044839$var$preloadSubTypeIcons(option, colorMode, isAnimatedArtworkEnabled) {
    const preloadKey = `${option.type}-${colorMode}-${isAnimatedArtworkEnabled}`;
    if ($be6de585ac044839$var$preloadedIconGroups.has(preloadKey)) return;
    $be6de585ac044839$var$preloadedIconGroups.add(preloadKey);
    const isDark = colorMode === 'dark';
    for (const subType of option.subTypes){
        if (isAnimatedArtworkEnabled) {
            const animatedUrls = (0, $9z4Bk.getAnimatedSubTypeIconUrls)(subType.value);
            if (animatedUrls) {
                const img = new window.Image();
                img.src = isDark ? animatedUrls.dark : animatedUrls.light;
                continue;
            }
            if ((0, $9z4Bk.hasAnimatedSubTypeIcon)(subType.value)) continue;
        }
        const urls = (0, $1LRKz.SUB_TYPE_ICON_URLS)[subType.value];
        if (urls) {
            const img = new window.Image();
            img.src = isDark ? urls.dark : urls.light;
        }
    }
}
const $be6de585ac044839$var$renderOptionIcon = (option, alt)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
        icon: option.icon,
        label: alt,
        appearance: option.iconTileAppearance ?? 'gray',
        size: "small"
    });
};
function $be6de585ac044839$var$RemixAccordionOption({ option: option, isExpanded: isExpanded, isAnimatedArtworkEnabled: isAnimatedArtworkEnabled, onToggle: onToggle, onSubTypeSelect: onSubTypeSelect, onPickForMe: onPickForMe, colorMode: colorMode }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const smoothResizer = (0, $2LyZS.useResizingHeight)($be6de585ac044839$var$animationConfig);
    const handleToggle = (0, $cozmU.useCallback)(()=>{
        onToggle(option.type);
    }, [
        onToggle,
        option.type
    ]);
    const handleMouseEnter = (0, $cozmU.useCallback)(()=>{
        $be6de585ac044839$var$preloadSubTypeIcons(option, colorMode, isAnimatedArtworkEnabled);
    }, [
        option,
        colorMode,
        isAnimatedArtworkEnabled
    ]);
    const handleSubTypeSelect = (0, $cozmU.useCallback)((subTypeValue)=>{
        if ((0, $iDrrr.fg)('cc-maui-phase-3')) {
            const subTypeDef = option.subTypes.find((st)=>st.value === subTypeValue);
            onSubTypeSelect(subTypeDef?.emitType ?? option.type, subTypeValue);
            return;
        }
        onSubTypeSelect(option.type, subTypeValue);
    }, [
        onSubTypeSelect,
        option.type,
        option.subTypes
    ]);
    const handlePickForMe = (0, $cozmU.useCallback)(()=>{
        onPickForMe(option.type);
    }, [
        onPickForMe,
        option.type
    ]);
    const ChevronIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))) : (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX)));
    const optionIconAlt = formatMessage(option.iconAltMessage);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            isExpanded ? "_0bjKvD8fU6 _0KLXruoI2d" : "_23rrnHC1jD _0bjKvD8fU6 _0KLXruoI2d _1eOmH6d1Zr _3fSdSTGk8v"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $be6de585ac044839$var$accordionStyles.accordionWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $be6de585ac044839$var$accordionStyles.accordionHeader,
        onClick: handleToggle,
        onMouseEnter: handleMouseEnter,
        testId: option.testId,
        "aria-expanded": isExpanded,
        "aria-label": formatMessage(option.labelMessage)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        gap: "space.100"
    }, $be6de585ac044839$var$renderOptionIcon(option, optionIconAlt), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium"
    }, formatMessage(option.labelMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ChevronIcon, {
        label: "",
        color: "var(--ds-icon, #292A2E)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: smoothResizer.ref,
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn"
        ])
    }, isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $be6de585ac044839$var$accordionStyles.expandedContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$var$RemixSubTypeGrid, {
        isAnimatedArtworkEnabled: isAnimatedArtworkEnabled,
        subTypes: option.subTypes,
        onSubTypeSelect: handleSubTypeSelect
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $be6de585ac044839$var$accordionStyles.pickForMeWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2mpnYbKxmn _46PhP8u7m9 _2FH9z4N91d"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        spacing: "compact",
        onClick: handlePickForMe,
        testId: `${option.testId}-pick-for-me`
    }, formatMessage((0, $czfXc.default).pickForMe))))))));
}
const $be6de585ac044839$var$RemixFlatOption = ({ option: option, onSelect: onSelect })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleClick = (0, $cozmU.useCallback)(()=>{
        onSelect(option.type);
    }, [
        onSelect,
        option.type
    ]);
    const optionIconAlt = formatMessage(option.iconAltMessage);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_23rrnHC1jD _0bjKvD8fU6 _0KLXruoI2d _1eOmH6d1Zr _3fSdSTGk8v"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $be6de585ac044839$var$accordionStyles.accordionWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $be6de585ac044839$var$accordionStyles.accordionHeader,
        onClick: handleClick,
        testId: option.testId,
        "aria-label": formatMessage(option.labelMessage)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        gap: "space.100"
    }, $be6de585ac044839$var$renderOptionIcon(option, optionIconAlt), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium"
    }, formatMessage(option.labelMessage))))));
};
function $be6de585ac044839$var$setRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
        return;
    }
    if (ref) ref.current = value;
}
function $be6de585ac044839$var$RemixOpenMenuExperienceTracker() {
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    (0, $cozmU.useEffect)(()=>{
        (0, $kDDrf.succeedRemixOpenMenuExperience)(experienceTracker);
    }, [
        experienceTracker
    ]);
    return null;
} /**
   * Placements supported by the anchored RemixPopup.
   * - 'left-end': contextual object-level entry point (opens to the left).
   * - 'bottom-start': toolbar "Remix" button dropdown (opens downward, aligned to trigger start).
   * - 'bottom-end': toolbar "Remix" button dropdown when the cascade needs left-side room.
   */ 
const $be6de585ac044839$var$stopEditorNativeEvent = (event)=>{
    // Block controls and block-menu hosts install native document/editor listeners before
    // React's delegated handlers. Stop at the textarea DOM boundary so focusing the prompt
    // cannot be interpreted as an outside click. Do not preventDefault: native focus and
    // text editing must continue to work.
    event.stopPropagation();
    event.stopImmediatePropagation();
};
const $be6de585ac044839$var$bindEditorNativeEventListeners = (element)=>(0, $cbY7C.bindAll)(element, [
        {
            type: 'mousedown',
            listener: $be6de585ac044839$var$stopEditorNativeEvent
        },
        {
            type: 'mouseup',
            listener: $be6de585ac044839$var$stopEditorNativeEvent
        },
        {
            type: 'click',
            listener: $be6de585ac044839$var$stopEditorNativeEvent
        }
    ]); /**
      * Suppress the default focus transfer for a press inside the menu. `click` still fires, so option
      * selection works. Text controls are exempt because they must be focusable to be typed into.
      */ 
const $be6de585ac044839$var$preserveFocusOnPress = (event)=>{
    const target = event.target;
    if (target instanceof Element && target.closest('textarea, input, select, [contenteditable="true"]') !== null) return;
    event.preventDefault();
};
const $be6de585ac044839$var$bindPreserveFocusListener = (element)=>(0, $cbY7C.bind)(element, {
        type: 'mousedown',
        listener: $be6de585ac044839$var$preserveFocusOnPress
    });
function $be6de585ac044839$var$RemixDescribeInput({ value: value, onChange: onChange, onSubmit: onSubmit, autoFocus: autoFocus = false, isCompact: isCompact = false }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const describeTextAreaRef = (0, $cozmU.useRef)(null);
    const unbindDescribeInputBoundaryRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!autoFocus) return;
         // requestAnimationFrame so focus lands after the modal has fully mounted.
        const raf = requestAnimationFrame(()=>{
            describeTextAreaRef.current?.focus();
        });
        return ()=>cancelAnimationFrame(raf);
    }, [
        autoFocus
    ]);
    const setDescribeInputBoundaryRef = (0, $cozmU.useCallback)((element)=>{
        unbindDescribeInputBoundaryRef.current?.();
        unbindDescribeInputBoundaryRef.current = element && isCompact ? $be6de585ac044839$var$bindEditorNativeEventListeners(element) : null;
    }, [
        isCompact
    ]);
    const handleSubmit = (0, $cozmU.useCallback)(()=>{
        if (value?.trim()) onSubmit();
    }, [
        value,
        onSubmit
    ]);
    const handleKeyDown = (0, $cozmU.useCallback)((e)=>{
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSubmit();
        }
    }, [
        handleSubmit
    ]);
    const placeholder = formatMessage((0, $ieeJu.expValEquals)('cc_maui_create_keyword', 'isEnabled', true) ? (0, $czfXc.default).createDescribePlaceholder : (0, $czfXc.default).describePlaceholder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $be6de585ac044839$var$remixStyles.describeInputBorderWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: isCompact ? setDescribeInputBoundaryRef : undefined,
        xcss: isCompact ? $be6de585ac044839$var$remixStyles.compactDescribeInputWrapper : $be6de585ac044839$var$remixStyles.describeInputWrapper,
        testId: "remix-overlay-describe-input-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
        onSubmit: handleSubmit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $be6de585ac044839$var$remixStyles.describePromptRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $be6de585ac044839$var$remixStyles.describeTextAreaWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
        ref: describeTextAreaRef,
        appearance: "none",
        placeholder: placeholder,
        value: value,
        onChange: (e)=>onChange(e.currentTarget.value),
        onKeyDown: handleKeyDown,
        isCompact: true,
        minimumRows: 1,
        maxHeight: "200px",
        resize: "smart",
        "aria-label": placeholder,
        testId: "remix-overlay-describe-input",
        name: "remix-overlay-describe"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        type: "submit",
        appearance: "primary",
        isDisabled: !value?.trim(),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f6cdQ))),
        label: formatMessage((0, $czfXc.default).describeSubmitLabel),
        testId: "remix-overlay-describe-submit"
    })))));
}
function $be6de585ac044839$export$ced6b2e82a17b9f6({ onOptionSelect: onOptionSelect, options: options, hiddenOptions: hiddenOptions, subtitle: subtitle }) {
    // A/A experiment paired with cc_maui_create_keyword; called to balance exposures. Result unused.
    (0, $ieeJu.expValEquals)('cc_maui_create_keyword_aa', 'isEnabled', true);
    const isAnimatedArtworkEnabled = (0, $4o0zT.isExperimentEnabled)('cc_maui_polish_changes_batch_6');
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    const [describeValue, setDescribeValue] = (0, $cozmU.useState)('');
    const [expandedOption, setExpandedOption] = (0, $cozmU.useState)(null);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const resolvedOptions = (0, $cozmU.useMemo)(()=>(0, $loej8.getRemixMenuOptions)({
            source: options === undefined ? {
                kind: 'preset',
                preset: 'selection'
            } : {
                kind: 'custom',
                choices: options
            },
            excludedRemixTypes: hiddenOptions ? [
                ...hiddenOptions
            ] : undefined
        }), [
        hiddenOptions,
        options
    ]);
    const handleDescribeSubmit = (0, $cozmU.useCallback)(()=>{
        onOptionSelect?.({
            type: 'custom',
            userPrompt: describeValue
        });
    }, [
        describeValue,
        onOptionSelect
    ]);
    const handleToggle = (0, $cozmU.useCallback)((type)=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'remixOverlaySection',
            attributes: {
                sectionType: type
            }
        });
        setExpandedOption((prev)=>prev === type ? null : type);
    }, [
        sendAnalyticsEvent
    ]);
    const handleSubTypeSelect = (0, $cozmU.useCallback)((type, subType)=>{
        const trimmedDescribe = describeValue?.trim();
        const userPrompt = trimmedDescribe && (0, $4o0zT.isExperimentEnabled)('cc_maui_remix_combine_type_and_prompt') ? trimmedDescribe : undefined;
        onOptionSelect?.({
            type: type,
            subType: subType,
            userPrompt: userPrompt
        });
    }, [
        onOptionSelect,
        describeValue
    ]);
    const handlePickForMe = (0, $cozmU.useCallback)((type)=>{
        onOptionSelect?.({
            type: type
        });
    }, [
        onOptionSelect
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$var$RemixOverlayHeader, {
        subtitle: subtitle,
        isMinimized: expandedOption !== null
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _2WAcuGIZbP"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $be6de585ac044839$var$remixStyles.modalBodyPadding
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100",
        alignInline: "stretch",
        xcss: $be6de585ac044839$var$remixStyles.remixOptionsStack
    }, resolvedOptions.map((option)=>option.subTypes.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$var$RemixAccordionOption, {
            key: option.type,
            option: option,
            isExpanded: expandedOption === option.type,
            isAnimatedArtworkEnabled: isAnimatedArtworkEnabled,
            onToggle: handleToggle,
            onSubTypeSelect: handleSubTypeSelect,
            onPickForMe: handlePickForMe,
            colorMode: colorMode
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$var$RemixFlatOption, {
            key: option.type,
            option: option,
            onSelect: handlePickForMe
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$var$RemixDescribeInput, {
        value: describeValue,
        onChange: setDescribeValue,
        onSubmit: handleDescribeSubmit,
        autoFocus: true
    }));
} /**
   * RemixOverlay — centered ADS Modal presentation
   */ 
function $be6de585ac044839$export$48a746fedb7ffb({ onClose: onClose, onOptionSelect: onOptionSelect, options: options, hiddenOptions: hiddenOptions, subtitle: subtitle }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        onClose: onClose,
        width: 320,
        testId: "remix-overlay",
        shouldReturnFocus: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _4bt5LAnQyn _2WAcuGnQyn _0bjKvDOLYo _3iDTPbQ4SZ _0aFT5vbt8w _0KLXrunmFW"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), {
        hasInlinePadding: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$var$RemixOpenMenuExperienceTracker, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$export$ced6b2e82a17b9f6, {
        onOptionSelect: onOptionSelect,
        options: options,
        hiddenOptions: hiddenOptions,
        subtitle: subtitle
    })))));
} /**
   * Calls the Popup `update` function to reposition the popup whenever `repositionKey` changes.
   */ 
function $be6de585ac044839$var$PopupRepositionOnKeyChange({ repositionKey: repositionKey, update: update }) {
    const prevKey = (0, $cozmU.useRef)(repositionKey);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (prevKey.current !== repositionKey) {
            prevKey.current = repositionKey;
            update();
        }
    }, [
        repositionKey,
        update
    ]);
    return null;
} /**
   * RemixPopup — anchored ADS Popup presentation for contextual entry points (e.g. object-level sidebar).
   * No blanket, anchored to a trigger element.
   */ 
function $be6de585ac044839$export$a8b0b54f368ecbb0({ isOpen: isOpen, onClose: onClose, trigger: trigger, onOptionSelect: onOptionSelect, options: options, hiddenOptions: hiddenOptions, subtitle: subtitle, placement: placement = 'left-end', offset: offset = [
    8,
    16
], repositionKey: repositionKey, useCascadingMenu: useCascadingMenu = false, cascadingMenuHeader: cascadingMenuHeader, shouldCloseOnScroll: shouldCloseOnScroll = false, shouldPreserveEditorFocus: shouldPreserveEditorFocus = false }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [cascadeDirection, setCascadeDirection] = (0, $cozmU.useState)('right');
    const [hasMeasuredCascadeDirection, setHasMeasuredCascadeDirection] = (0, $cozmU.useState)(false);
    const [describeValue, setDescribeValue] = (0, $cozmU.useState)('');
    const effectivePlacement = useCascadingMenu && placement === 'bottom-start' && cascadeDirection === 'left' ? 'bottom-end' : placement;
    const popupRepositionKey = useCascadingMenu ? `${repositionKey ?? ''}:${cascadeDirection}` : repositionKey;
    (0, $cozmU.useEffect)(()=>{
        if (!isOpen) {
            setCascadeDirection('right');
            setHasMeasuredCascadeDirection(false);
            setDescribeValue('');
        }
    }, [
        isOpen
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isOpen || !useCascadingMenu || !shouldCloseOnScroll) return;
        const handleScroll = (event)=>{
            const target = event.target;
            if (target instanceof Element && target.closest('[data-remix-cascading-popup]')) return;
            onClose();
        }; // Scroll does not bubble, so capture on window to observe page and nested scroll containers.
        return (0, $cbY7C.bind)(window, {
            type: 'scroll',
            listener: handleScroll,
            options: {
                capture: true
            }
        });
    }, [
        isOpen,
        onClose,
        shouldCloseOnScroll,
        useCascadingMenu
    ]);
    const updateCascadeDirectionFromTrigger = (0, $cozmU.useCallback)((triggerElement)=>{
        if (!useCascadingMenu || !triggerElement || !isOpen) return;
        const document = (0, $1hQ0e.getDocument)();
        const viewportWidth = window.innerWidth || document?.documentElement.clientWidth || 0;
        const nextDirection = (0, $dcNzQ.getCascadeDirectionForAnchor)(triggerElement.getBoundingClientRect(), viewportWidth);
        setCascadeDirection((currentDirection)=>currentDirection === nextDirection ? currentDirection : nextDirection);
        setHasMeasuredCascadeDirection(true);
    }, [
        isOpen,
        useCascadingMenu
    ]);
    const unbindPreserveFocusRef = (0, $cozmU.useRef)(null); // Callback ref so the listener re-attaches when the popup is closed and reopened.
    const setPreserveFocusRef = (0, $cozmU.useCallback)((element)=>{
        unbindPreserveFocusRef.current?.();
        unbindPreserveFocusRef.current = element && shouldPreserveEditorFocus ? $be6de585ac044839$var$bindPreserveFocusListener(element) : null;
    }, [
        shouldPreserveEditorFocus
    ]); // A/A experiment paired with cc_maui_create_keyword; called to balance exposures. Result unused.
    (0, $ieeJu.expValEquals)('cc_maui_create_keyword_aa', 'isEnabled', true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
        isOpen: isOpen,
        popupComponent: useCascadingMenu ? $be6de585ac044839$var$CascadingPopupContainer : undefined,
        onClose: onClose,
        placement: effectivePlacement,
        offset: offset,
        label: formatMessage((0, $ieeJu.expValEquals)('cc_maui_create_keyword', 'isEnabled', true) ? (0, $czfXc.default).createHeading : (0, $czfXc.default).heading),
        role: "dialog",
        content: ({ update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$var$RemixOpenMenuExperienceTracker, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$var$PopupRepositionOnKeyChange, {
                repositionKey: popupRepositionKey,
                update: update
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $be6de585ac044839$var$popupStyles.popupEnterAnimation
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                ref: setPreserveFocusRef,
                "data-editor-remix-inline-dropdown-preserve-focus": shouldPreserveEditorFocus || undefined,
                xcss: useCascadingMenu ? $be6de585ac044839$var$popupStyles.cascadingContentWrapper : $be6de585ac044839$var$popupStyles.contentWrapper,
                testId: "remix-popup"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: useCascadingMenu ? $be6de585ac044839$var$popupStyles.cascadingBody : $be6de585ac044839$var$popupStyles.body
            }, useCascadingMenu ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dcNzQ.RemixCascadingMenuContent), {
                onOptionSelect: onOptionSelect,
                options: options,
                hiddenOptions: hiddenOptions,
                flyoutDirection: cascadeDirection,
                showFlyout: hasMeasuredCascadeDirection,
                header: cascadingMenuHeader ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                    className: (0, $hekY6.default)([
                        "_1mT5xdRAKS _39xV02N91d"
                    ])
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                    xcss: $be6de585ac044839$var$popupStyles.cascadingHeader,
                    space: "space.050",
                    alignInline: "center",
                    testId: "remix-cascading-menu-header-content"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: $be6de585ac044839$var$popupStyles.cascadingHeaderIcon,
                    "aria-hidden": "true"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($HvNsc))),
                    alt: "",
                    width: "100%"
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
                    size: "medium",
                    color: "color.text"
                }, formatMessage(cascadingMenuHeader.title)), cascadingMenuHeader.subtitle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                    color: "color.text"
                }, formatMessage(cascadingMenuHeader.subtitle)) : null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
                    alignItems: "center",
                    justifyContent: "space-between",
                    testId: "remix-cascading-menu-header-content"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                    weight: "semibold",
                    color: "color.text"
                }, formatMessage((0, $czfXc.default).heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fkYYP.RemixLabsLozenge), null)),
                headerHasBottomPadding: Boolean(cascadingMenuHeader),
                headerCornerElement: cascadingMenuHeader ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                    "data-testid": "remix-cascading-labs-lozenge",
                    className: (0, $hekY6.default)([
                        "_1mT5xdWVPG _2IhTon8HPE _4ApkO28HPE _1pp6NdYbGa"
                    ])
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fkYYP.RemixLabsLozenge), null)) : undefined,
                footer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$var$RemixDescribeInput, {
                    value: describeValue,
                    isCompact: true,
                    onChange: setDescribeValue,
                    onSubmit: ()=>onOptionSelect?.({
                            type: 'custom',
                            userPrompt: describeValue
                        })
                })
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$export$ced6b2e82a17b9f6, {
                onOptionSelect: onOptionSelect,
                options: options,
                hiddenOptions: hiddenOptions,
                subtitle: subtitle
            }))))),
        trigger: (triggerProps)=>{
            if (!useCascadingMenu) return trigger(triggerProps);
            return trigger({
                ...triggerProps,
                ref: (triggerElement)=>{
                    $be6de585ac044839$var$setRef(triggerProps.ref, triggerElement);
                    updateCascadeDirectionFromTrigger(triggerElement);
                }
            });
        }
    });
}
module.exports["RemixOverlay"] = $be6de585ac044839$export$48a746fedb7ffb;
module.exports["RemixPopup"] = $be6de585ac044839$export$a8b0b54f368ecbb0;

});

parcelRegister("fkYYP", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9KSWX = parcelRequire("9KSWX");


var $4ez2K = parcelRequire("4ez2K");


var $lpNn5 = parcelRequire("lpNn5");


var $czfXc = parcelRequire("czfXc");

function $7db9989015b3e40c$export$8617a37c485125e5() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: formatMessage((0, $czfXc.default).labsLozengeTooltip),
        position: "top",
        delay: 0
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            ...tooltipProps,
            justifyContent: "end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
            appearance: "discovery"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $czfXc.default).labsLozenge))));
}
module.exports["RemixLabsLozenge"] = $7db9989015b3e40c$export$8617a37c485125e5;

});

parcelRegister("czfXc", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $b0a9658e5a4289f5$var$messages = (0, $kSwu1.defineMessages)({
    // ── Header ──────────────────────────────────────────────────────────────
    heading: {
        id: "malleable-ui-components.remix.heading",
        defaultMessage: "Remix"
    },
    createHeading: {
        id: "malleable-ui-components.remix.create-heading",
        defaultMessage: "Create"
    },
    subtitle: {
        id: "malleable-ui-components.remix.subtitle",
        defaultMessage: "View this content in a new form"
    },
    labsLozenge: {
        id: "malleable-ui-components.remix.labs-lozenge.updated",
        defaultMessage: "Labs"
    },
    labsLozengeTooltip: {
        id: "malleable-ui-components.remix.option.lozenge-tooltip",
        defaultMessage: "Beta: This feature is still in development."
    },
    remixIconAlt: {
        id: "malleable-ui-components.remix.icon-alt",
        defaultMessage: "Remix icon"
    },
    // ── Describe input ─────────────────────────────────────────────────────
    describePlaceholder: {
        id: "malleable-ui-components.remix.describe-placeholder",
        defaultMessage: "Or describe your remix..."
    },
    createDescribePlaceholder: {
        id: "malleable-ui-components.remix.create-describe-placeholder",
        defaultMessage: "Or create something else\u2026"
    },
    describeSubmitLabel: {
        id: "malleable-ui-components.remix.describe-submit-label",
        defaultMessage: "Submit"
    },
    // ── Top-level option labels ────────────────────────────────────────────
    remixOptionChart: {
        id: "malleable-ui-components.remix.option.chart",
        defaultMessage: "Charts"
    },
    remixOptionDiagram: {
        id: "malleable-ui-components.remix.option.diagram",
        defaultMessage: "Diagrams"
    },
    remixOptionInfographic: {
        id: "malleable-ui-components.remix.option.infographic",
        defaultMessage: "Infographics"
    },
    remixOptionVisualization: {
        id: "malleable-ui-components.remix.option.visualization",
        defaultMessage: "Visualizations"
    },
    // ── Top-level option icon alts ─────────────────────────────────────────
    chartIconAlt: {
        id: "malleable-ui-components.remix.option.chart-icon-alt",
        defaultMessage: "Chart icon"
    },
    diagramIconAlt: {
        id: "malleable-ui-components.remix.option.diagram-icon-alt",
        defaultMessage: "Diagram icon"
    },
    infographicIconAlt: {
        id: "malleable-ui-components.remix.option.infographic-icon-alt",
        defaultMessage: "Infographic icon"
    },
    visualizationIconAlt: {
        id: "malleable-ui-components.remix.option.visualization-icon-alt",
        defaultMessage: "Visualization icon"
    },
    // ── Top-level option tooltips ──────────────────────────────────────────
    chartTooltip: {
        id: "malleable-ui-components.remix.option.chart-tooltip",
        defaultMessage: "View your data as a chart or graph"
    },
    diagramTooltip: {
        id: "malleable-ui-components.remix.option.diagram-tooltip",
        defaultMessage: "Show relationships with a diagram"
    },
    infographicTooltip: {
        id: "malleable-ui-components.remix.option.infographic-tooltip",
        defaultMessage: "Summarize key points with an infographic"
    },
    visualizationTooltip: {
        id: "malleable-ui-components.remix.option.visualization-tooltip",
        defaultMessage: "Bring your content to life with a bespoke visual"
    },
    // ── Sub-type labels (charts) ───────────────────────────────────────────
    subTypeLineChart: {
        id: "malleable-ui-components.remix.sub-type.line-chart",
        defaultMessage: "Line chart"
    },
    subTypeAreaChart: {
        id: "malleable-ui-components.remix.sub-type.area-chart",
        defaultMessage: "Area chart"
    },
    subTypeBarChart: {
        id: "malleable-ui-components.remix.sub-type.bar-chart",
        defaultMessage: "Bar chart"
    },
    subTypeFunnelChart: {
        id: "malleable-ui-components.remix.sub-type.funnel-chart",
        defaultMessage: "Funnel chart"
    },
    subTypePieChart: {
        id: "malleable-ui-components.remix.sub-type.pie-chart",
        defaultMessage: "Pie chart"
    },
    subTypeGanttChart: {
        id: "malleable-ui-components.remix.sub-type.gantt-chart",
        defaultMessage: "Gantt chart"
    },
    // ── Sub-type labels (diagrams) ─────────────────────────────────────────
    subTypeMindMap: {
        id: "malleable-ui-components.remix.sub-type.mind-map",
        defaultMessage: "Mindmap"
    },
    subTypeFlowChart: {
        id: "malleable-ui-components.remix.sub-type.flow-chart",
        defaultMessage: "Flowchart"
    },
    // ── Sub-type labels (infographics) ─────────────────────────────────────
    subTypeModernStyle: {
        id: "malleable-ui-components.remix.sub-type.modern-style",
        defaultMessage: "Modern style"
    },
    subTypeBoldStyle: {
        id: "malleable-ui-components.remix.sub-type.bold-style",
        defaultMessage: "Bold style"
    },
    subTypeSketchStyle: {
        id: "malleable-ui-components.remix.sub-type.sketch-style",
        defaultMessage: "Sketch style"
    },
    subTypeMinimalistStyle: {
        id: "malleable-ui-components.remix.sub-type.minimalist-style",
        defaultMessage: "Minimalist style"
    },
    // ── Sub-type labels (visual aids) ──────────────────────────────────────
    subTypeFlipCard: {
        id: "malleable-ui-components.remix.sub-type.flip-card",
        defaultMessage: "Flip card"
    },
    subTypeQuadrant: {
        id: "malleable-ui-components.remix.sub-type.quadrant",
        defaultMessage: "Quadrant"
    },
    subTypeTreeMap: {
        id: "malleable-ui-components.remix.sub-type.tree-map",
        defaultMessage: "Tree map"
    },
    subTypeTimeline: {
        id: "malleable-ui-components.remix.sub-type.timeline",
        defaultMessage: "Timeline"
    },
    subTypeGeographicalMap: {
        id: "malleable-ui-components.remix.sub-type.geographical-map",
        defaultMessage: "Geographical map"
    },
    subTypeOrgChart: {
        id: "malleable-ui-components.remix.sub-type.org-chart",
        defaultMessage: "Org chart"
    },
    subTypeImage: {
        id: "malleable-ui-components.remix.sub-type.image",
        defaultMessage: "Image"
    },
    pageRemixSubtitle: {
        id: "malleable-ui-components.remix.page-remix-subtitle",
        defaultMessage: "Create content inspired by this work"
    },
    pageContentGroupLabel: {
        id: "malleable-ui-components.remix.page-content-group-label",
        defaultMessage: "Confluence content"
    },
    remixOptionSlides: {
        id: "malleable-ui-components.remix.option.slides",
        defaultMessage: "Slides"
    },
    remixOptionWhiteboard: {
        id: "malleable-ui-components.remix.option.whiteboard",
        defaultMessage: "Whiteboard"
    },
    remixOptionDatabase: {
        id: "malleable-ui-components.remix.option.database",
        defaultMessage: "Database"
    },
    slidesIconAlt: {
        id: "malleable-ui-components.remix.option.slides-icon-alt",
        defaultMessage: "Slides icon"
    },
    whiteboardIconAlt: {
        id: "malleable-ui-components.remix.option.whiteboard-icon-alt",
        defaultMessage: "Whiteboard icon"
    },
    databaseIconAlt: {
        id: "malleable-ui-components.remix.option.database-icon-alt",
        defaultMessage: "Database icon"
    },
    slidesTooltip: {
        id: "malleable-ui-components.remix.option.slides-tooltip",
        defaultMessage: "Transform your page into a slide deck"
    },
    whiteboardTooltip: {
        id: "malleable-ui-components.remix.option.whiteboard-tooltip",
        defaultMessage: "Visualize your page on a whiteboard"
    },
    databaseTooltip: {
        id: "malleable-ui-components.remix.option.database-tooltip",
        defaultMessage: "Structure your page content as a database"
    },
    // ── Pick for me ────────────────────────────────────────────────────────
    pickForMe: {
        id: "malleable-ui-components.remix.pick-for-me",
        defaultMessage: "Pick for me"
    },
    auto: {
        id: "malleable-ui-components.remix.remix-overlay.auto",
        defaultMessage: "Auto"
    },
    pickForMeTooltip: {
        id: "malleable-ui-components.remix.remix-overlay.pickForMeTooltip",
        defaultMessage: "Pick a style for me"
    },
    // ── Unused legacy keys kept for i18n backwards compat ──────────────────
    selectedContent: {
        id: "malleable-ui-components.remix.selected-content",
        defaultMessage: "Selected content"
    },
    noContent: {
        id: "malleable-ui-components.remix.no-content",
        defaultMessage: "No content selected"
    }
});
var $b0a9658e5a4289f5$export$2e2bcd8739ae039 = $b0a9658e5a4289f5$var$messages;
module.exports["default"] = $b0a9658e5a4289f5$export$2e2bcd8739ae039;

});

parcelRegister("HvNsc", function(module, exports) {
module.exports = new URL("Remix-Illustration.7b8c03b3.svg", import.meta.url).toString();

});

parcelRegister("1LRKz", function(module, exports) {
/* constants.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iDrrr = parcelRequire("iDrrr");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $jdqQM = parcelRequire("jdqQM");


var $a3xS2 = parcelRequire("a3xS2");


var $1qKb1 = parcelRequire("1qKb1");


var $dZaRy = parcelRequire("dZaRy");


var $i6pum = parcelRequire("i6pum");


var $hT2Mn = parcelRequire("hT2Mn");


var $7vmkU = parcelRequire("7vmkU");


var $7K13i = parcelRequire("7K13i");


var $b5QJc = parcelRequire("b5QJc");


var $5QH2j = parcelRequire("5QH2j");


var $g8eHJ = parcelRequire("g8eHJ");


var $aoAJG = parcelRequire("aoAJG");


var $6A6ao = parcelRequire("6A6ao");


var $gg5rm = parcelRequire("gg5rm");


var $av9Cl = parcelRequire("av9Cl");


var $kuWlT = parcelRequire("kuWlT");


var $7mMw3 = parcelRequire("7mMw3");


var $gP7CA = parcelRequire("gP7CA");


var $l0Xml = parcelRequire("l0Xml");


var $h7GLM = parcelRequire("h7GLM");


var $lE1xe = parcelRequire("lE1xe");


var $4VjKY = parcelRequire("4VjKY");


var $7ZPjf = parcelRequire("7ZPjf");


var $5nwSN = parcelRequire("5nwSN");


var $jDDGi = parcelRequire("jDDGi");


var $h4zH8 = parcelRequire("h4zH8");


var $5udvx = parcelRequire("5udvx");


var $glBZK = parcelRequire("glBZK");


var $eCw66 = parcelRequire("eCw66");


var $g5RPh = parcelRequire("g5RPh");


var $iAb2S = parcelRequire("iAb2S");


var $9oYVI = parcelRequire("9oYVI");


var $l1bw1 = parcelRequire("l1bw1");


var $3Mo2w = parcelRequire("3Mo2w");


var $aBRLd = parcelRequire("aBRLd");


var $gpmJ3 = parcelRequire("gpmJ3");


var $aIlia = parcelRequire("aIlia");


var $9WcaJ = parcelRequire("9WcaJ");


var $iGdgz = parcelRequire("iGdgz");


var $8IXk3 = parcelRequire("8IXk3");

const $1624994978f78343$var$iconStyles = null; // Negative margins to counteract the default padding from the Pressable tile component,
// allowing the image icon to extend edge-to-edge within the tile.
const $1624994978f78343$var$edgeToEdgeIconStyles = null;
const $1624994978f78343$var$SubTypeIcon = ({ src: src, srcDark: srcDark, alt: alt })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    const resolvedSrc = colorMode === 'dark' ? srcDark : src;
    return /*#__PURE__*/ $cozmU.createElement("img", {
        src: resolvedSrc,
        alt: alt,
        "aria-hidden": "true",
        className: (0, $hekY6.default)([
            "_39xV02N91d _0jFU0VN91d _00EA0eiObl _3iDTPbvLZJ"
        ])
    });
};
const $1624994978f78343$export$e0452922cbc2989f = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($g5RPh))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($5QH2j))),
        alt: alt
    });
const $1624994978f78343$export$b08434c95e3df48d = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($lE1xe))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($jdqQM))),
        alt: alt
    });
const $1624994978f78343$export$472946dc5493045a = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4VjKY))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($a3xS2))),
        alt: alt
    });
const $1624994978f78343$export$ccba00b0f4d667f3 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($h4zH8))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($hT2Mn))),
        alt: alt
    });
const $1624994978f78343$export$b86b18d4ddcc0181 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($aBRLd))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($av9Cl))),
        alt: alt
    });
const $1624994978f78343$export$a95ef668d7975f40 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5udvx))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($7vmkU))),
        alt: alt
    });
const $1624994978f78343$export$4f7cb0192e7b1016 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iAb2S))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($g8eHJ))),
        alt: alt
    });
const $1624994978f78343$export$2df60ac16db5f072 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jDDGi))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($i6pum))),
        alt: alt
    });
const $1624994978f78343$export$77864082aab0bbe3 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($l1bw1))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($6A6ao))),
        alt: alt
    });
const $1624994978f78343$export$6fa49d5d85aab725 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7ZPjf))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($1qKb1))),
        alt: alt
    });
const $1624994978f78343$export$b8c6412fcf2fe65d = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9WcaJ))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($gP7CA))),
        alt: alt
    });
const $1624994978f78343$export$73f1bfda08325f1c = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($aIlia))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($7mMw3))),
        alt: alt
    });
const $1624994978f78343$export$1968847f71768cdf = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9oYVI))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($aoAJG))),
        alt: alt
    });
const $1624994978f78343$var$CorporateDoodleIcon = (props)=>(0, $iDrrr.fg)('cc-maui-phase-2') ? /*#__PURE__*/ $cozmU.createElement($1624994978f78343$export$73f1bfda08325f1c, props) : /*#__PURE__*/ $cozmU.createElement($1624994978f78343$export$b8c6412fcf2fe65d, props);
const $1624994978f78343$export$c02ff6805d67acb2 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5nwSN))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($dZaRy))),
        alt: alt
    });
const $1624994978f78343$export$368b8c86d4677a50 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gpmJ3))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($kuWlT))),
        alt: alt
    });
const $1624994978f78343$export$23e94ddbc9d88fae = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8IXk3))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($h7GLM))),
        alt: alt
    });
const $1624994978f78343$export$e5aa73ddcf9d62e8 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iGdgz))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($l0Xml))),
        alt: alt
    });
const $1624994978f78343$export$a18ea9af6c181602 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($glBZK))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($7K13i))),
        alt: alt
    });
const $1624994978f78343$export$84442c0324e009f8 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3Mo2w))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($gg5rm))),
        alt: alt
    });
const $1624994978f78343$var$ImageIcon = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_313842A17z _0adFHsmW1D _1DCdHiA17z _2XsHFMmW1D"
        ])
    }, /*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eCw66))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($b5QJc))),
        alt: alt
    }));
const $1624994978f78343$export$65d7e4b11d55029 = {
    // Charts
    'line-chart': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($g5RPh))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($5QH2j)))
    },
    'area-chart': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($lE1xe))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($jdqQM)))
    },
    'bar-chart': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($4VjKY))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($a3xS2)))
    },
    'funnel-chart': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($h4zH8))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($hT2Mn)))
    },
    'pie-chart': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($aBRLd))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($av9Cl)))
    },
    'gantt-chart': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($5udvx))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($7vmkU)))
    },
    // Diagrams
    mindmap: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($iAb2S))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($g8eHJ)))
    },
    flowchart: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($jDDGi))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($i6pum)))
    },
    // Infographics
    'corporate-modern': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($l1bw1))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($6A6ao)))
    },
    'corporate-doodle': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($aIlia))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($7mMw3)))
    },
    charlie: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($7ZPjf))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($1qKb1)))
    },
    minimalist: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($9oYVI))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($aoAJG)))
    },
    // Visual aids
    'flip-card': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($5nwSN))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($dZaRy)))
    },
    quadrant: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($gpmJ3))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($kuWlT)))
    },
    'tree-map': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($8IXk3))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($h7GLM)))
    },
    'horizontal-timeline': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($iGdgz))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($l0Xml)))
    },
    map: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($glBZK))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($7K13i)))
    },
    'org-chart': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($3Mo2w))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($gg5rm)))
    },
    image: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($eCw66))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($b5QJc)))
    }
};
const $1624994978f78343$export$ebd45e32b7708bfa = {
    // Charts
    'line-chart': $1624994978f78343$export$e0452922cbc2989f,
    'area-chart': $1624994978f78343$export$b08434c95e3df48d,
    'bar-chart': $1624994978f78343$export$472946dc5493045a,
    'funnel-chart': $1624994978f78343$export$ccba00b0f4d667f3,
    'pie-chart': $1624994978f78343$export$b86b18d4ddcc0181,
    'gantt-chart': $1624994978f78343$export$a95ef668d7975f40,
    // Diagrams
    mindmap: $1624994978f78343$export$4f7cb0192e7b1016,
    flowchart: $1624994978f78343$export$2df60ac16db5f072,
    // Infographics
    'corporate-modern': $1624994978f78343$export$77864082aab0bbe3,
    'corporate-doodle': $1624994978f78343$var$CorporateDoodleIcon,
    charlie: $1624994978f78343$export$6fa49d5d85aab725,
    minimalist: $1624994978f78343$export$1968847f71768cdf,
    // Visual aids
    'flip-card': $1624994978f78343$export$c02ff6805d67acb2,
    quadrant: $1624994978f78343$export$368b8c86d4677a50,
    'tree-map': $1624994978f78343$export$23e94ddbc9d88fae,
    'horizontal-timeline': $1624994978f78343$export$e5aa73ddcf9d62e8,
    map: $1624994978f78343$export$a18ea9af6c181602,
    'org-chart': $1624994978f78343$export$84442c0324e009f8,
    image: $1624994978f78343$var$ImageIcon
};
module.exports["SUB_TYPE_ICON_URLS"] = $1624994978f78343$export$65d7e4b11d55029;
module.exports["SUB_TYPE_ICON_MAP"] = $1624994978f78343$export$ebd45e32b7708bfa;

});

parcelRegister("jdqQM", function(module, exports) {
module.exports = new URL("area-chart.55f6e465.svg", import.meta.url).toString();

});

parcelRegister("a3xS2", function(module, exports) {
module.exports = new URL("bar-chart.fd78c047.svg", import.meta.url).toString();

});

parcelRegister("1qKb1", function(module, exports) {
module.exports = new URL("bold.49b06ac8.svg", import.meta.url).toString();

});

parcelRegister("dZaRy", function(module, exports) {
module.exports = new URL("flip-cards.5ca8ff0a.svg", import.meta.url).toString();

});

parcelRegister("i6pum", function(module, exports) {
module.exports = new URL("flowchart.be00d296.svg", import.meta.url).toString();

});

parcelRegister("hT2Mn", function(module, exports) {
module.exports = new URL("funnel-chart.c5c5ee8c.svg", import.meta.url).toString();

});

parcelRegister("7vmkU", function(module, exports) {
module.exports = new URL("gantt-chart.a8acacb3.svg", import.meta.url).toString();

});

parcelRegister("7K13i", function(module, exports) {
module.exports = new URL("geographical-map.8aed36b5.svg", import.meta.url).toString();

});

parcelRegister("b5QJc", function(module, exports) {
module.exports = new URL("image-option-dark.4ef2b9c9.png", import.meta.url).toString();

});

parcelRegister("5QH2j", function(module, exports) {
module.exports = new URL("line-chart.170f1aac.svg", import.meta.url).toString();

});

parcelRegister("g8eHJ", function(module, exports) {
module.exports = new URL("mindmap.3d2ae695.svg", import.meta.url).toString();

});

parcelRegister("aoAJG", function(module, exports) {
module.exports = new URL("minimalist.5f043ef2.svg", import.meta.url).toString();

});

parcelRegister("6A6ao", function(module, exports) {
module.exports = new URL("modern.b9c52e72.svg", import.meta.url).toString();

});

parcelRegister("gg5rm", function(module, exports) {
module.exports = new URL("org-chart.4294f091.svg", import.meta.url).toString();

});

parcelRegister("av9Cl", function(module, exports) {
module.exports = new URL("pie-chart.51f3bebf.svg", import.meta.url).toString();

});

parcelRegister("kuWlT", function(module, exports) {
module.exports = new URL("quadrant.199f7d1e.svg", import.meta.url).toString();

});

parcelRegister("7mMw3", function(module, exports) {
module.exports = new URL("sketch-v2.ed2b7bb9.svg", import.meta.url).toString();

});

parcelRegister("gP7CA", function(module, exports) {
module.exports = new URL("sketch.e9357258.svg", import.meta.url).toString();

});

parcelRegister("l0Xml", function(module, exports) {
module.exports = new URL("timeline.6ae6674b.svg", import.meta.url).toString();

});

parcelRegister("h7GLM", function(module, exports) {
module.exports = new URL("treemap.1a39a30f.svg", import.meta.url).toString();

});

parcelRegister("lE1xe", function(module, exports) {
module.exports = new URL("area-chart.5c4ca07f.svg", import.meta.url).toString();

});

parcelRegister("4VjKY", function(module, exports) {
module.exports = new URL("bar-chart.958c9357.svg", import.meta.url).toString();

});

parcelRegister("7ZPjf", function(module, exports) {
module.exports = new URL("bold.c47d431b.svg", import.meta.url).toString();

});

parcelRegister("5nwSN", function(module, exports) {
module.exports = new URL("flip-cards.429027cc.svg", import.meta.url).toString();

});

parcelRegister("jDDGi", function(module, exports) {
module.exports = new URL("flowchart.77339b70.svg", import.meta.url).toString();

});

parcelRegister("h4zH8", function(module, exports) {
module.exports = new URL("funnel-chart.12ecbc63.svg", import.meta.url).toString();

});

parcelRegister("5udvx", function(module, exports) {
module.exports = new URL("gantt-chart.1c11810d.svg", import.meta.url).toString();

});

parcelRegister("glBZK", function(module, exports) {
module.exports = new URL("geographical-map.ac5f4483.svg", import.meta.url).toString();

});

parcelRegister("eCw66", function(module, exports) {
module.exports = new URL("image-option.51f3f511.png", import.meta.url).toString();

});

parcelRegister("g5RPh", function(module, exports) {
module.exports = new URL("line-chart.57ecd877.svg", import.meta.url).toString();

});

parcelRegister("iAb2S", function(module, exports) {
module.exports = new URL("mindmap.d452b507.svg", import.meta.url).toString();

});

parcelRegister("9oYVI", function(module, exports) {
module.exports = new URL("minimalist.cbf91eb3.svg", import.meta.url).toString();

});

parcelRegister("l1bw1", function(module, exports) {
module.exports = new URL("modern.4ca836a7.svg", import.meta.url).toString();

});

parcelRegister("3Mo2w", function(module, exports) {
module.exports = new URL("org-chart.694f44ab.svg", import.meta.url).toString();

});

parcelRegister("aBRLd", function(module, exports) {
module.exports = new URL("pie-chart.0477082d.svg", import.meta.url).toString();

});

parcelRegister("gpmJ3", function(module, exports) {
module.exports = new URL("quadrant.5175de07.svg", import.meta.url).toString();

});

parcelRegister("aIlia", function(module, exports) {
module.exports = new URL("sketch-v2.a5dc9d56.svg", import.meta.url).toString();

});

parcelRegister("9WcaJ", function(module, exports) {
module.exports = new URL("sketch.66d6c571.svg", import.meta.url).toString();

});

parcelRegister("iGdgz", function(module, exports) {
module.exports = new URL("timeline.3d28aa4e.svg", import.meta.url).toString();

});

parcelRegister("8IXk3", function(module, exports) {
module.exports = new URL("treemap.1a39a30f.svg", import.meta.url).toString();

});

parcelRegister("dcNzQ", function(module, exports) {
/* remix-cascading-menu.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $aDSIl = parcelRequire("aDSIl");


var $9d7Pd = parcelRequire("9d7Pd");


var $6IL1T = parcelRequire("6IL1T");


var $8FgJC = parcelRequire("8FgJC");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $1LRKz = parcelRequire("1LRKz");


var $czfXc = parcelRequire("czfXc");


var $9z4Bk = parcelRequire("9z4Bk");


var $loej8 = parcelRequire("loej8");

const $53abef11e3c2aac8$export$d7cf732af02b8895 = /*#__PURE__*/ (0, $cozmU.createContext)('down');
function $53abef11e3c2aac8$export$2ba0f43a8fa8308d(placement) {
    return placement?.startsWith('top') ? 'up' : 'down';
} // Width of a menu column (top-level categories and sub-type submenu).
const $53abef11e3c2aac8$var$CATEGORY_WIDTH = 280;
const $53abef11e3c2aac8$var$SUBTYPE_WIDTH = 160;
const $53abef11e3c2aac8$var$PREVIEW_WIDTH = 144;
const $53abef11e3c2aac8$var$PREVIEW_HEIGHT = 104;
const $53abef11e3c2aac8$var$CASCADE_COLUMN_GAP = 6;
const $53abef11e3c2aac8$var$CASCADE_VIEWPORT_MARGIN = 8;
const $53abef11e3c2aac8$var$CASCADE_FLYOUT_WIDTH = $53abef11e3c2aac8$var$SUBTYPE_WIDTH + $53abef11e3c2aac8$var$PREVIEW_WIDTH + $53abef11e3c2aac8$var$CASCADE_COLUMN_GAP * 2;
function $53abef11e3c2aac8$export$a1ba6991d30166a0(anchorRect, viewportWidth) {
    const fullCascadeWidth = $53abef11e3c2aac8$var$CATEGORY_WIDTH + $53abef11e3c2aac8$var$CASCADE_FLYOUT_WIDTH;
    const availableRightForFullCascade = viewportWidth - anchorRect.left - $53abef11e3c2aac8$var$CASCADE_VIEWPORT_MARGIN;
    const availableLeftForFlyout = anchorRect.left - $53abef11e3c2aac8$var$CASCADE_VIEWPORT_MARGIN;
    return availableRightForFullCascade < fullCascadeWidth && availableLeftForFlyout >= $53abef11e3c2aac8$var$CASCADE_FLYOUT_WIDTH ? 'left' : 'right';
}
const $53abef11e3c2aac8$var$subtleSlideIn = null;
const $53abef11e3c2aac8$var$menuStyles = {
    rootRightDown: "_2mHwu8gVvo _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLchRC",
    rootLeftDown: "_2mHwu8gVvo _3iDTPbQ4SZ _0aFT5vf5Xk _0hPCNLchRC",
    rootRightUp: "_2mHwu8gVvo _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLz9WS",
    rootLeftUp: "_2mHwu8gVvo _3iDTPbQ4SZ _0aFT5vf5Xk _0hPCNLz9WS",
    categoryColumn: "_2O5VijdnbC _3YEZNOdnbC _1bHrqEIZbP _4bt5LAnQyn _2WAcuGnQyn _0bjKvD8fU6 _1mT5xdRAKS _39xV02ehCh _3iDTPbQ4SZ _0aFT5vbt8w _0KLXruoI2d _2OUyjtGk8v",
    categoryHeader: "_46hvQm5zaO _0xmtko5zaO _0LQT5E5zaO _03SyCP5zaO",
    categoryHeaderNoBottomPadding: "_46hvQm5zaO _0xmtkoPgdg _0LQT5E5zaO _03SyCP5zaO",
    subTypeColumnPositioner: "_2O5VijdnbC _3YEZNOdnbC _1bHrqEIZbP _39xV02oaux",
    subTypeColumn: "_4bt5LAnQyn _2WAcuGnQyn _0bjKvD8fU6 _39xV02N91d _0KLXruoI2d _2OUyjtGk8v _1gBibyf9Pz _0nFVCG2HTN _43vdfTdisq _3Y6bKp38c8 _39Ohv4YbGa",
    previewColumnRight: "_2O5VijdnbC _3YEZNOdnbC _1bHrqEIZbP _4bt5LAnQyn _2WAcuGnQyn _0bjKvD8fU6 _39xV02Ka7A _0jFU0VbUtj _4xdlr0IZbP _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _46hvQm2ADO _0xmtko2ADO _0LQT5E2ADO _03SyCP2ADO _24h04i2Njc _0KLXruoI2d _2OUyjtGk8v _1kOSYtC67X _3Z9K0wb8VS _0qk6IKdisq _1SdfoHYbGa",
    previewColumnLeft: "_2O5VijdnbC _3YEZNOdnbC _1bHrqEIZbP _4bt5LAnQyn _2WAcuGnQyn _0bjKvD8fU6 _39xV02Ka7A _0jFU0VbUtj _4xdlr0IZbP _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _46hvQm2ADO _0xmtko2ADO _0LQT5E2ADO _03SyCP2ADO _24h04i2Njc _0KLXruoI2d _2OUyjtGk8v _1kOSYtC67X _3Z9K0wb8VS _0qk6IKdisq _1SdfoHYbGa",
    previewColumnImageEdgeToEdge: "_2O5VijdnbC _3YEZNOdnbC _1bHrqEIZbP _4bt5LAnQyn _2WAcuGnQyn _0bjKvD8fU6 _4c065UdnbC _2Y7lL4dnbC _39xV02Ka7A _0jFU0VbUtj _4xdlr0IZbP _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _24h04i2Njc _0KLXruoI2d _2OUyjtGk8v _1kOSYtC67X _3Z9K0wb8VS _0qk6IKdisq _1SdfoHYbGa",
    previewImageEdgeToEdge: "_3iDTPbvLZJ _39xV02N91d _0jFU0VN91d _00EA0eiObl",
    categoryTrailing: "_3iDTPbQ4SZ _0hPCNLDIqT",
    previewContent: "_39xV02N91d _0jFU0VN91d _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _1pp6NdYbGa"
};
function $53abef11e3c2aac8$var$RemixSubTypeColumn({ subTypes: subTypes, categoryOffset: categoryOffset, pickForMeTestId: pickForMeTestId, onSubTypeSelect: onSubTypeSelect, onPickForMe: onPickForMe, onClearPreview: onClearPreview, onHoverSubType: onHoverSubType }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const verticalDirection = (0, $cozmU.useContext)($53abef11e3c2aac8$export$d7cf732af02b8895);
    const columnRef = (0, $cozmU.useRef)(null);
    const handleHoverSubType = (0, $cozmU.useCallback)((subTypeValue, rowElement)=>{
        const columnElement = columnRef.current;
        const rootElement = columnElement?.parentElement;
        if (!columnElement || !rootElement) {
            onHoverSubType(subTypeValue, {
                blockStart: 0,
                blockEnd: 0
            });
            return;
        }
        const rootRect = rootElement.getBoundingClientRect();
        const columnRect = columnElement.getBoundingClientRect();
        const rowRect = rowElement.getBoundingClientRect();
        const isFirstSubType = subTypes[0]?.value === subTypeValue;
        if (isFirstSubType) {
            // Reuse the subtype column's positioning source instead of measuring its translated top.
            // This prevents small rounding/timing differences between the first preview and the card.
            // Downward roots align from the top. Upward roots align from the bottom, so account for
            // the difference between the subtype and preview heights. Left/right does not affect it.
            onHoverSubType(subTypeValue, {
                blockStart: categoryOffset.blockStart,
                blockEnd: columnRect.height + categoryOffset.blockEnd - $53abef11e3c2aac8$var$PREVIEW_HEIGHT
            });
            return;
        } // Every non-first preview preserves the original exact row-centering calculation.
        const previewTop = rowRect.top + rowRect.height / 2 - $53abef11e3c2aac8$var$PREVIEW_HEIGHT / 2;
        onHoverSubType(subTypeValue, {
            blockStart: previewTop - rootRect.top,
            blockEnd: rootRect.bottom - previewTop - $53abef11e3c2aac8$var$PREVIEW_HEIGHT
        });
    }, [
        categoryOffset,
        onHoverSubType,
        subTypes
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        ref: columnRef,
        xcss: $53abef11e3c2aac8$var$menuStyles.subTypeColumnPositioner,
        style: {
            transform: `translateY(${verticalDirection === 'up' ? -categoryOffset.blockEnd : categoryOffset.blockStart}px)`
        },
        testId: "remix-menu-submenu"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $53abef11e3c2aac8$var$menuStyles.subTypeColumn,
        testId: "remix-menu-submenu-surface"
    }, /*#__PURE__*/ $cozmU.createElement((0, $6IL1T.default), null, /*#__PURE__*/ $cozmU.createElement((0, $8FgJC.default), null, subTypes.map((subType)=>{
        const label = formatMessage(subType.labelMessage);
        return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            key: subType.value,
            testId: `remix-menu-subtype-row-${subType.value}`,
            onMouseEnter: (event)=>handleHoverSubType(subType.value, event.currentTarget),
            onFocus: (event)=>handleHoverSubType(subType.value, event.currentTarget)
        }, /*#__PURE__*/ $cozmU.createElement((0, $9d7Pd.default), {
            testId: subType.testId ?? `remix-menu-subtype-${subType.value}`,
            onClick: ()=>onSubTypeSelect(subType.value)
        }, label));
    })), /*#__PURE__*/ $cozmU.createElement((0, $8FgJC.default), {
        hasSeparator: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        onMouseEnter: onClearPreview,
        onFocus: onClearPreview
    }, /*#__PURE__*/ $cozmU.createElement((0, $9d7Pd.default), {
        testId: pickForMeTestId,
        onClick: onPickForMe
    }, formatMessage((0, $czfXc.default).pickForMe)))))));
}
function $53abef11e3c2aac8$var$RemixPreviewColumn({ subType: subType, direction: direction, previewOffset: previewOffset, isAnimatedArtworkEnabled: isAnimatedArtworkEnabled }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    const verticalDirection = (0, $cozmU.useContext)($53abef11e3c2aac8$export$d7cf732af02b8895);
    if (!subType) return null;
    const label = formatMessage(subType.labelMessage);
    const isImagePreview = subType.value === 'image';
    const IconComponent = isImagePreview ? null : (0, $9z4Bk.getSubTypeIconComponent)(subType.value, isAnimatedArtworkEnabled);
    const previewArtwork = isImagePreview ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "img",
        src: colorMode === 'dark' ? (0, $1LRKz.SUB_TYPE_ICON_URLS).image.dark : (0, $1LRKz.SUB_TYPE_ICON_URLS).image.light,
        alt: label,
        "aria-hidden": "true",
        xcss: $53abef11e3c2aac8$var$menuStyles.previewImageEdgeToEdge,
        testId: "remix-menu-preview"
    }) : IconComponent ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $53abef11e3c2aac8$var$menuStyles.previewContent,
        testId: "remix-menu-preview"
    }, /*#__PURE__*/ $cozmU.createElement(IconComponent, {
        alt: label
    })) : null;
    if (!previewArtwork) return null;
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: isImagePreview ? $53abef11e3c2aac8$var$menuStyles.previewColumnImageEdgeToEdge : direction === 'left' ? $53abef11e3c2aac8$var$menuStyles.previewColumnLeft : $53abef11e3c2aac8$var$menuStyles.previewColumnRight,
        style: {
            transform: `translateY(${verticalDirection === 'up' ? -previewOffset.blockEnd : previewOffset.blockStart}px)`
        },
        testId: "remix-menu-preview-column"
    }, previewArtwork);
}
function $53abef11e3c2aac8$var$RemixCategoryItem({ option: option, onActivate: onActivate, onFlatSelect: onFlatSelect }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const label = formatMessage(option.labelMessage);
    const optionIconAlt = formatMessage(option.iconAltMessage);
    const OptionIcon = option.icon;
    const hasSubTypes = option.subTypes.length > 0;
    if (!hasSubTypes) return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        testId: `remix-menu-category-row-${option.type}`,
        // `mouseenter`) whenever layout shifts under a stationary pointer. Focusing the
        // describe-prompt footer resizes the category column and repositions the popup, which
        // would otherwise "hover" whichever row slid under the cursor and open its flyout.
        // `mousemove` only fires for genuine pointer movement. `onActivate` is idempotent per
        // row, so the repeated calls while moving across a row collapse into one activation.
        onMouseMove: (event)=>onActivate(option, event.currentTarget),
        onFocus: (event)=>onActivate(option, event.currentTarget)
    }, /*#__PURE__*/ $cozmU.createElement((0, $9d7Pd.default), {
        iconBefore: /*#__PURE__*/ $cozmU.createElement(OptionIcon, {
            label: optionIconAlt,
            size: "small",
            color: "var(--ds-icon, #292A2E)"
        }),
        testId: option.testId,
        onClick: ()=>onFlatSelect(option.type)
    }, label));
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        testId: `remix-menu-category-row-${option.type}`,
        // when layout shifts under a stationary pointer.
        onMouseMove: (event)=>onActivate(option, event.currentTarget),
        onFocus: (event)=>onActivate(option, event.currentTarget)
    }, /*#__PURE__*/ $cozmU.createElement((0, $9d7Pd.default), {
        iconBefore: /*#__PURE__*/ $cozmU.createElement(OptionIcon, {
            label: optionIconAlt,
            size: "small",
            color: "var(--ds-icon, #292A2E)"
        }),
        iconAfter: /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $53abef11e3c2aac8$var$menuStyles.categoryTrailing
        }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
            label: "",
            color: "var(--ds-icon, #292A2E)",
            size: "small"
        })),
        testId: option.testId,
        onClick: (event)=>onActivate(option, event.currentTarget)
    }, label));
}
function $53abef11e3c2aac8$export$5d44e1d911d4366f({ onOptionSelect: onOptionSelect, options: options, hiddenOptions: hiddenOptions, flyoutDirection: flyoutDirection = 'right', showFlyout: showFlyout = true, header: header, headerHasBottomPadding: headerHasBottomPadding = true, headerCornerElement: headerCornerElement, footer: footer }) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const verticalDirection = (0, $cozmU.useContext)($53abef11e3c2aac8$export$d7cf732af02b8895);
    const isAnimatedArtworkEnabled = (0, $4o0zT.isExperimentEnabled)('cc_maui_polish_changes_batch_6');
    const categoryColumnRef = (0, $cozmU.useRef)(null);
    const resolvedOptions = (0, $cozmU.useMemo)(()=>(0, $loej8.getRemixMenuOptions)({
            source: options === undefined ? {
                kind: 'preset',
                preset: 'selection'
            } : {
                kind: 'custom',
                choices: options
            },
            excludedRemixTypes: hiddenOptions ? [
                ...hiddenOptions
            ] : undefined
        }), [
        hiddenOptions,
        options
    ]); // The category whose sub-types are currently shown in the second column. Only
    // categories that have sub-types open a flyout; the rest close it.
    const [activeType, setActiveType] = (0, $cozmU.useState)(null); // Measured from both edges of the active category row, positioning the subtype card.
    const [categoryOffset, setCategoryOffset] = (0, $cozmU.useState)({
        blockStart: 0,
        blockEnd: 0
    }); // The sub-type currently hovered/focused, driving the preview column.
    const [hoveredSubType, setHoveredSubType] = (0, $cozmU.useState)(null); // Measured from both root edges so the preview center follows the subtype row center,
    // including when edge-row previews extend beyond the subtype card.
    const [previewOffset, setPreviewOffset] = (0, $cozmU.useState)({
        blockStart: 0,
        blockEnd: 0
    });
    const activeOption = (0, $cozmU.useMemo)(()=>resolvedOptions.find((opt)=>opt.type === activeType && opt.subTypes.length > 0) ?? null, [
        resolvedOptions,
        activeType
    ]);
    const activeSubTypes = activeOption?.subTypes ?? [];
    const hoveredSubTypeDef = activeSubTypes.find((st)=>st.value === hoveredSubType) ?? null;
    const firstCategoryType = resolvedOptions[0]?.type; // The category row that most recently claimed the flyout. Kept in a ref rather than derived from
    // `activeType` because categories without sub-types also "claim" the flyout (by closing it), and
    // because it must stay stable across the repeated `mousemove` events fired while the pointer
    // travels across a single row.
    const activatedTypeRef = (0, $cozmU.useRef)(null); // Resets the sub-type preview. Deliberately bails out when there is nothing to clear, so it is
    // safe to call from the high-frequency `mousemove` path without forcing a re-render.
    const clearPreview = (0, $cozmU.useCallback)(()=>{
        setHoveredSubType(null);
        setPreviewOffset((current)=>current.blockStart === 0 && current.blockEnd === 0 ? current : {
                blockStart: 0,
                blockEnd: 0
            });
    }, []);
    const handleActivate = (0, $cozmU.useCallback)((option, rowElement)=>{
        if (activatedTypeRef.current === option.type) {
            // This row already owns the flyout — usually because the pointer is travelling back out
            // of the flyout across its own category row. The flyout and its offset are unchanged
            // (the row has not moved relative to the column), but any sub-type preview picked up on
            // the way out is now stale, so clear it exactly as a fresh activation would.
            clearPreview();
            return;
        }
        activatedTypeRef.current = option.type;
        if (option.subTypes.length > 0) sendAnalyticsEvent({
            eventType: 'ui',
            action: 'opened',
            actionSubject: 'remixCascadingSubtypesMenu',
            attributes: {
                sectionType: option.type,
                remixType: option.type
            }
        });
        const categoryRect = categoryColumnRef.current?.getBoundingClientRect();
        const rowRect = rowElement.getBoundingClientRect();
        const isFirstCategory = option.type === firstCategoryType;
        setCategoryOffset(categoryRect ? {
            // ADS Section adds a 6px leading spacer before its first row. The first category's
            // flyout belongs at the category card edge, not below that internal content inset.
            blockStart: isFirstCategory ? 0 : Math.max(0, rowRect.top - categoryRect.top),
            blockEnd: Math.max(0, categoryRect.bottom - rowRect.bottom)
        } : {
            blockStart: 0,
            blockEnd: 0
        });
        setActiveType(option.subTypes.length > 0 ? option.type : null);
        clearPreview();
    }, [
        clearPreview,
        firstCategoryType,
        sendAnalyticsEvent
    ]);
    const handleHoverSubType = (0, $cozmU.useCallback)((subTypeValue, nextPreviewOffset)=>{
        setHoveredSubType(subTypeValue);
        setPreviewOffset(nextPreviewOffset);
    }, []); // Collapses the sub-type flyout and its preview back to the bare category column. Used when the
    // pointer or keyboard focus moves into the describe-prompt footer: the flyout belongs to a
    // category row, so leaving the category list for the free-text prompt must not leave a stale
    // submenu hanging beside the menu.
    const handleDismissFlyout = (0, $cozmU.useCallback)(()=>{
        if (activatedTypeRef.current === null) return;
        activatedTypeRef.current = null;
        setActiveType(null);
        clearPreview();
    }, [
        clearPreview
    ]);
    const handleFlatSelect = (0, $cozmU.useCallback)((type)=>{
        onOptionSelect?.({
            type: type
        });
    }, [
        onOptionSelect
    ]);
    const handleSubTypeSelect = (0, $cozmU.useCallback)((subTypeValue)=>{
        if (!activeOption) return;
        const subTypeDef = activeOption.subTypes.find((st)=>st.value === subTypeValue);
        const remixType = (0, $iDrrr.fg)('cc-maui-phase-3') ? subTypeDef?.emitType ?? activeOption.type : activeOption.type;
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'remixCascadingSubType',
            attributes: {
                sectionType: activeOption.type,
                remixType: remixType,
                remixSubtype: subTypeValue
            }
        });
        onOptionSelect?.({
            type: remixType,
            subType: subTypeValue
        });
    }, [
        activeOption,
        onOptionSelect,
        sendAnalyticsEvent
    ]);
    const handlePickForMe = (0, $cozmU.useCallback)(()=>{
        if (!activeOption) return;
        const randomSubType = activeOption.subTypes[Math.floor(Math.random() * activeOption.subTypes.length)];
        if (!randomSubType) return;
        handleSubTypeSelect(randomSubType.value);
    }, [
        activeOption,
        handleSubTypeSelect
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: flyoutDirection === 'left' ? verticalDirection === 'up' ? $53abef11e3c2aac8$var$menuStyles.rootLeftUp : $53abef11e3c2aac8$var$menuStyles.rootLeftDown : verticalDirection === 'up' ? $53abef11e3c2aac8$var$menuStyles.rootRightUp : $53abef11e3c2aac8$var$menuStyles.rootRightDown,
        testId: "remix-menu"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        ref: categoryColumnRef,
        xcss: $53abef11e3c2aac8$var$menuStyles.categoryColumn,
        testId: "remix-menu-categories"
    }, headerCornerElement, header ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: headerHasBottomPadding ? $53abef11e3c2aac8$var$menuStyles.categoryHeader : $53abef11e3c2aac8$var$menuStyles.categoryHeaderNoBottomPadding,
        testId: "remix-menu-header"
    }, header) : null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, /*#__PURE__*/ $cozmU.createElement((0, $6IL1T.default), null, /*#__PURE__*/ $cozmU.createElement((0, $8FgJC.default), null, resolvedOptions.map((option)=>/*#__PURE__*/ $cozmU.createElement($53abef11e3c2aac8$var$RemixCategoryItem, {
            key: option.type,
            option: option,
            onActivate: handleActivate,
            onFlatSelect: handleFlatSelect
        }))))), footer ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box // `onFocus` maps to the bubbling `focusin`, so this also catches focus landing on the
    ), {
        // textarea or submit button nested inside the footer.
        onFocus: handleDismissFlyout,
        onMouseEnter: handleDismissFlyout,
        testId: "remix-menu-footer-region"
    }, footer) : null), showFlyout && activeOption ? /*#__PURE__*/ $cozmU.createElement($53abef11e3c2aac8$var$RemixSubTypeColumn, {
        key: activeType,
        subTypes: activeSubTypes,
        categoryOffset: categoryOffset,
        pickForMeTestId: `${activeOption.testId}-pick-for-me`,
        onSubTypeSelect: handleSubTypeSelect,
        onPickForMe: handlePickForMe,
        onClearPreview: clearPreview,
        onHoverSubType: handleHoverSubType
    }) : null, showFlyout && hoveredSubTypeDef ? /*#__PURE__*/ $cozmU.createElement($53abef11e3c2aac8$var$RemixPreviewColumn, {
        subType: hoveredSubTypeDef,
        direction: flyoutDirection,
        previewOffset: previewOffset,
        isAnimatedArtworkEnabled: isAnimatedArtworkEnabled
    }) : null);
}
module.exports["CascadeVerticalDirectionContext"] = $53abef11e3c2aac8$export$d7cf732af02b8895;
module.exports["getCascadeVerticalDirectionForPlacement"] = $53abef11e3c2aac8$export$2ba0f43a8fa8308d;
module.exports["getCascadeDirectionForAnchor"] = $53abef11e3c2aac8$export$a1ba6991d30166a0;
module.exports["RemixCascadingMenuContent"] = $53abef11e3c2aac8$export$5d44e1d911d4366f;

});

parcelRegister("9z4Bk", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1LRKz = parcelRequire("1LRKz");


const $083ac59b0a0735a3$var$LazyAnimatedSubTypeIcon = (0, $cozmU.lazy)(()=>(parcelRequire("69fsv")).then(({ AnimatedSubTypeIcon: AnimatedSubTypeIcon })=>({
            default: AnimatedSubTypeIcon
        })));
function $083ac59b0a0735a3$var$createLazyAnimatedSubTypeIcon(subType) {
    const LegacyIcon = (0, $1LRKz.SUB_TYPE_ICON_MAP)[subType];
    function LazyAnimatedIcon(props) {
        return (0, $cozmU.createElement)((0, $cozmU.Suspense), {
            fallback: (0, $cozmU.createElement)(LegacyIcon, props)
        }, (0, $cozmU.createElement)($083ac59b0a0735a3$var$LazyAnimatedSubTypeIcon, {
            ...props,
            subType: subType
        }));
    }
    LazyAnimatedIcon.displayName = `LazyAnimatedIcon(${subType})`;
    return LazyAnimatedIcon;
}
const $083ac59b0a0735a3$var$ANIMATED_SUB_TYPE_ICON_MAP = {
    'line-chart': $083ac59b0a0735a3$var$createLazyAnimatedSubTypeIcon('line-chart'),
    'area-chart': $083ac59b0a0735a3$var$createLazyAnimatedSubTypeIcon('area-chart'),
    'bar-chart': $083ac59b0a0735a3$var$createLazyAnimatedSubTypeIcon('bar-chart'),
    'funnel-chart': $083ac59b0a0735a3$var$createLazyAnimatedSubTypeIcon('funnel-chart'),
    'pie-chart': $083ac59b0a0735a3$var$createLazyAnimatedSubTypeIcon('pie-chart'),
    'gantt-chart': $083ac59b0a0735a3$var$createLazyAnimatedSubTypeIcon('gantt-chart'),
    mindmap: $083ac59b0a0735a3$var$createLazyAnimatedSubTypeIcon('mindmap'),
    flowchart: $083ac59b0a0735a3$var$createLazyAnimatedSubTypeIcon('flowchart'),
    charlie: $083ac59b0a0735a3$var$createLazyAnimatedSubTypeIcon('charlie'),
    minimalist: $083ac59b0a0735a3$var$createLazyAnimatedSubTypeIcon('minimalist'),
    'corporate-doodle': $083ac59b0a0735a3$var$createLazyAnimatedSubTypeIcon('corporate-doodle'),
    'flip-card': $083ac59b0a0735a3$var$createLazyAnimatedSubTypeIcon('flip-card'),
    quadrant: $083ac59b0a0735a3$var$createLazyAnimatedSubTypeIcon('quadrant'),
    'tree-map': $083ac59b0a0735a3$var$createLazyAnimatedSubTypeIcon('tree-map'),
    'horizontal-timeline': $083ac59b0a0735a3$var$createLazyAnimatedSubTypeIcon('horizontal-timeline'),
    map: $083ac59b0a0735a3$var$createLazyAnimatedSubTypeIcon('map'),
    'org-chart': $083ac59b0a0735a3$var$createLazyAnimatedSubTypeIcon('org-chart'),
    image: $083ac59b0a0735a3$var$createLazyAnimatedSubTypeIcon('image')
};
function $083ac59b0a0735a3$export$8b2ab5969db96c32(subType) {
    return subType in $083ac59b0a0735a3$var$ANIMATED_SUB_TYPE_ICON_MAP;
}
function $083ac59b0a0735a3$export$920b4f52d48e1387(subType) {
    switch(subType){
        case 'charlie':
        case 'minimalist':
        case 'corporate-doodle':
        case 'image':
            return (0, $1LRKz.SUB_TYPE_ICON_URLS)[subType];
        default:
            return null;
    }
}
function $083ac59b0a0735a3$export$6848cfc5485b273d(subType, isAnimatedArtworkEnabled) {
    if (!(subType in (0, $1LRKz.SUB_TYPE_ICON_MAP))) return null;
    if (isAnimatedArtworkEnabled && $083ac59b0a0735a3$export$8b2ab5969db96c32(subType)) return $083ac59b0a0735a3$var$ANIMATED_SUB_TYPE_ICON_MAP[subType];
    return (0, $1LRKz.SUB_TYPE_ICON_MAP)[subType];
}
module.exports["hasAnimatedSubTypeIcon"] = $083ac59b0a0735a3$export$8b2ab5969db96c32;
module.exports["getAnimatedSubTypeIconUrls"] = $083ac59b0a0735a3$export$920b4f52d48e1387;
module.exports["getSubTypeIconComponent"] = $083ac59b0a0735a3$export$6848cfc5485b273d;

});

parcelRegister("69fsv", function(module, exports) {

let $479f931b72429617$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $479f931b72429617$var$load("5b66P").then(()=>parcelRequire('5ewHh'));

});

parcelRegister("loej8", function(module, exports) {

var $gJ798 = parcelRequire("gJ798");


var $eFBG8 = parcelRequire("eFBG8");


var $2lF67 = parcelRequire("2lF67");


var $lBKFk = parcelRequire("lBKFk");


var $a79Sy = parcelRequire("a79Sy");


var $9KPiA = parcelRequire("9KPiA");


var $bDjVc = parcelRequire("bDjVc");


var $iDrrr = parcelRequire("iDrrr");


var $czfXc = parcelRequire("czfXc");

/**
 * All available remix options with their sub-types (variants).
 *
 * Sub-type values match the backend `dynamicUiSubtype` parameter
 * used in the remix-content minion (see edit-with-rovo-bar).
 */ const $1b429d4516497df0$var$defaultInfographicSubTypes = [
    {
        value: 'corporate-modern',
        displayName: 'modern style infographic',
        labelMessage: (0, $czfXc.default).subTypeModernStyle,
        testId: 'remix-sub-type-corporate-modern'
    },
    {
        value: 'corporate-doodle',
        displayName: 'sketch style infographic',
        labelMessage: (0, $czfXc.default).subTypeSketchStyle,
        testId: 'remix-sub-type-corporate-doodle'
    }
];
const $1b429d4516497df0$var$newInfographicSubTypes = [
    {
        value: 'charlie',
        displayName: 'bold style infographic',
        labelMessage: (0, $czfXc.default).subTypeBoldStyle,
        testId: 'remix-sub-type-charlie'
    },
    {
        value: 'minimalist',
        displayName: 'minimalist style infographic',
        labelMessage: (0, $czfXc.default).subTypeMinimalistStyle,
        testId: 'remix-sub-type-minimalist'
    },
    {
        value: 'corporate-doodle',
        displayName: 'sketch style infographic',
        labelMessage: (0, $czfXc.default).subTypeSketchStyle,
        testId: 'remix-sub-type-corporate-doodle'
    }
];
function $1b429d4516497df0$export$b867d47ced1865f7() {
    return (0, $iDrrr.fg)('cc-maui-phase-2') ? $1b429d4516497df0$var$newInfographicSubTypes : $1b429d4516497df0$var$defaultInfographicSubTypes;
}
const $1b429d4516497df0$var$defaultVisualAidSubTypes = [
    {
        value: 'flip-card',
        displayName: 'flip card',
        labelMessage: (0, $czfXc.default).subTypeFlipCard,
        testId: 'remix-sub-type-flip-card'
    },
    {
        value: 'quadrant',
        displayName: 'quadrant',
        labelMessage: (0, $czfXc.default).subTypeQuadrant,
        testId: 'remix-sub-type-quadrant'
    },
    {
        value: 'tree-map',
        displayName: 'tree map',
        labelMessage: (0, $czfXc.default).subTypeTreeMap,
        testId: 'remix-sub-type-tree-map'
    },
    {
        value: 'horizontal-timeline',
        displayName: 'timeline',
        labelMessage: (0, $czfXc.default).subTypeTimeline,
        testId: 'remix-sub-type-horizontal-timeline'
    },
    {
        value: 'map',
        displayName: 'map',
        labelMessage: (0, $czfXc.default).subTypeGeographicalMap,
        testId: 'remix-sub-type-map'
    },
    {
        value: 'org-chart',
        displayName: 'org chart',
        labelMessage: (0, $czfXc.default).subTypeOrgChart,
        testId: 'remix-sub-type-org-chart'
    }
];
const $1b429d4516497df0$var$imageSubType = {
    value: 'image',
    displayName: 'image',
    labelMessage: (0, $czfXc.default).subTypeImage,
    testId: 'remix-sub-type-image',
    emitType: 'image'
};
function $1b429d4516497df0$export$b9ec4f683b57ea1d() {
    return (0, $iDrrr.fg)('cc-maui-phase-3') ? [
        ...$1b429d4516497df0$var$defaultVisualAidSubTypes,
        $1b429d4516497df0$var$imageSubType
    ] : $1b429d4516497df0$var$defaultVisualAidSubTypes;
}
const $1b429d4516497df0$export$f0ba07b8deaf6c2d = [
    {
        type: 'chart',
        displayName: 'chart',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gJ798))),
        labelMessage: (0, $czfXc.default).remixOptionChart,
        iconAltMessage: (0, $czfXc.default).chartIconAlt,
        tooltipMessage: (0, $czfXc.default).chartTooltip,
        testId: 'remix-overlay-option-chart',
        subTypes: [
            {
                value: 'line-chart',
                displayName: 'line chart',
                labelMessage: (0, $czfXc.default).subTypeLineChart,
                testId: 'remix-sub-type-line-chart'
            },
            {
                value: 'area-chart',
                displayName: 'area chart',
                labelMessage: (0, $czfXc.default).subTypeAreaChart,
                testId: 'remix-sub-type-area-chart'
            },
            {
                value: 'bar-chart',
                displayName: 'bar chart',
                labelMessage: (0, $czfXc.default).subTypeBarChart,
                testId: 'remix-sub-type-bar-chart'
            },
            {
                value: 'funnel-chart',
                displayName: 'funnel chart',
                labelMessage: (0, $czfXc.default).subTypeFunnelChart,
                testId: 'remix-sub-type-funnel-chart'
            },
            {
                value: 'pie-chart',
                displayName: 'pie chart',
                labelMessage: (0, $czfXc.default).subTypePieChart,
                testId: 'remix-sub-type-pie-chart'
            },
            {
                value: 'gantt-chart',
                displayName: 'Gantt chart',
                labelMessage: (0, $czfXc.default).subTypeGanttChart,
                testId: 'remix-sub-type-gantt-chart'
            }
        ]
    },
    {
        type: 'diagram',
        displayName: 'diagram',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eFBG8))),
        labelMessage: (0, $czfXc.default).remixOptionDiagram,
        iconAltMessage: (0, $czfXc.default).diagramIconAlt,
        tooltipMessage: (0, $czfXc.default).diagramTooltip,
        testId: 'remix-overlay-option-diagram',
        subTypes: [
            {
                value: 'mindmap',
                displayName: 'mind map',
                labelMessage: (0, $czfXc.default).subTypeMindMap,
                testId: 'remix-sub-type-mindmap'
            },
            {
                value: 'flowchart',
                displayName: 'flowchart',
                labelMessage: (0, $czfXc.default).subTypeFlowChart,
                testId: 'remix-sub-type-flowchart'
            }
        ]
    },
    {
        type: 'infographic',
        displayName: 'infographic',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2lF67))),
        labelMessage: (0, $czfXc.default).remixOptionInfographic,
        iconAltMessage: (0, $czfXc.default).infographicIconAlt,
        tooltipMessage: (0, $czfXc.default).infographicTooltip,
        testId: 'remix-overlay-option-infographic',
        subTypes: $1b429d4516497df0$var$defaultInfographicSubTypes
    },
    {
        type: 'visual-aid',
        displayName: 'visualization',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($a79Sy))),
        labelMessage: (0, $czfXc.default).remixOptionVisualization,
        iconAltMessage: (0, $czfXc.default).visualizationIconAlt,
        tooltipMessage: (0, $czfXc.default).visualizationTooltip,
        testId: 'remix-overlay-option-visual-aid',
        subTypes: $1b429d4516497df0$var$defaultVisualAidSubTypes
    }
];
const $1b429d4516497df0$export$839e8948e17d6e68 = [
    {
        type: 'slides',
        displayName: 'slides',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9KPiA))),
        labelMessage: (0, $czfXc.default).remixOptionSlides,
        iconAltMessage: (0, $czfXc.default).slidesIconAlt,
        tooltipMessage: (0, $czfXc.default).slidesTooltip,
        testId: 'remix-overlay-option-slides',
        subTypes: [],
        iconTileAppearance: 'green'
    },
    {
        type: 'whiteboard',
        displayName: 'whiteboard',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
        labelMessage: (0, $czfXc.default).remixOptionWhiteboard,
        iconAltMessage: (0, $czfXc.default).whiteboardIconAlt,
        tooltipMessage: (0, $czfXc.default).whiteboardTooltip,
        testId: 'remix-overlay-option-whiteboard',
        subTypes: [],
        iconTileAppearance: 'teal'
    },
    {
        type: 'database',
        displayName: 'database',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lBKFk))),
        labelMessage: (0, $czfXc.default).remixOptionDatabase,
        iconAltMessage: (0, $czfXc.default).databaseIconAlt,
        tooltipMessage: (0, $czfXc.default).databaseTooltip,
        testId: 'remix-overlay-option-database',
        subTypes: [],
        iconTileAppearance: 'purple'
    },
    {
        type: 'infographic',
        displayName: 'infographic',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2lF67))),
        labelMessage: (0, $czfXc.default).remixOptionInfographic,
        iconAltMessage: (0, $czfXc.default).infographicIconAlt,
        tooltipMessage: (0, $czfXc.default).infographicTooltip,
        testId: 'remix-overlay-option-infographic',
        subTypes: $1b429d4516497df0$var$defaultInfographicSubTypes
    }
];
function $1b429d4516497df0$var$applyGatedSubTypes(remixChoices) {
    const infographicSubTypes = $1b429d4516497df0$export$b867d47ced1865f7();
    const visualAidSubTypes = $1b429d4516497df0$export$b9ec4f683b57ea1d();
    return remixChoices.map((opt)=>{
        if (opt.type === 'infographic') return {
            ...opt,
            subTypes: infographicSubTypes
        };
        if (opt.type === 'visual-aid') return {
            ...opt,
            subTypes: visualAidSubTypes
        };
        return opt;
    });
}
function $1b429d4516497df0$export$eba289419a85029b({ source: source = {
    kind: 'preset',
    preset: 'selection'
}, excludedRemixTypes: excludedRemixTypes } = {}) {
    let sourceChoices;
    switch(source.kind){
        case 'preset':
            sourceChoices = source.preset === 'page' ? $1b429d4516497df0$export$839e8948e17d6e68 : $1b429d4516497df0$export$f0ba07b8deaf6c2d;
            break;
        case 'custom':
            sourceChoices = source.choices;
            break;
    }
    return $1b429d4516497df0$export$cf3073d90a2d0bae($1b429d4516497df0$var$applyGatedSubTypes(sourceChoices), excludedRemixTypes);
}
/** Render-time lookup reflects current feature gates */ function $1b429d4516497df0$var$getAllOptions() {
    return $1b429d4516497df0$export$eba289419a85029b({
        source: {
            kind: 'custom',
            choices: [
                ...$1b429d4516497df0$export$f0ba07b8deaf6c2d,
                ...$1b429d4516497df0$export$839e8948e17d6e68
            ]
        }
    });
}
function $1b429d4516497df0$export$cf3073d90a2d0bae(remixChoices, excludedRemixTypes) {
    if (!excludedRemixTypes?.length) return remixChoices;
    const excludedRemixTypeSet = new Set(excludedRemixTypes);
    return remixChoices.filter((choice)=>choice.type === 'custom' || !excludedRemixTypeSet.has(choice.type));
}
function $1b429d4516497df0$export$b3104233810c1e93(typeValue) {
    const match = $1b429d4516497df0$var$getAllOptions().find((option)=>option.type === typeValue);
    return match?.displayName ?? typeValue.replace(/-/g, ' ');
}
function $1b429d4516497df0$export$ca76798d0446453(subTypeValue) {
    for (const option of $1b429d4516497df0$var$getAllOptions()){
        const match = option.subTypes.find((st)=>st.value === subTypeValue);
        if (match) return match.displayName;
    }
    return subTypeValue.replace(/-/g, ' ');
}
const $1b429d4516497df0$var$DEFAULT_REMIX_PROMPTS = {
    chart: 'Remix the selected content as a chart',
    custom: 'Remix the selected content',
    database: 'Remix the selected content as a database',
    diagram: 'Remix the selected content as a diagram',
    image: 'Remix the selected content as an image',
    infographic: 'Remix the selected content as an infographic',
    slides: 'Remix the selected content as slides',
    'visual-aid': 'Remix the selected content as a visualization',
    whiteboard: 'Remix the selected content as a whiteboard'
};
function $1b429d4516497df0$export$376994f626d15236(typeValue, subTypeValue) {
    if (!subTypeValue) return $1b429d4516497df0$var$DEFAULT_REMIX_PROMPTS[typeValue];
    const subTypeDisplayName = $1b429d4516497df0$export$ca76798d0446453(subTypeValue);
    const article = /^[aeiou]/i.test(subTypeDisplayName) ? 'an' : 'a';
    return `Remix the selected content as ${article} ${subTypeDisplayName}`;
}
function $1b429d4516497df0$export$bd80fc308a7bbe16(dynamicUiType, dynamicUiSubtype) {
    const allOptions = $1b429d4516497df0$var$getAllOptions();
    // First, try to find the category by matching the dynamicUiType directly.
    let matchedOption = allOptions.find((opt)=>opt.type === dynamicUiType);
    // If the direct match doesn't contain the requested sub-type (e.g. the
    // node's emitType points to a different category than where the sub-type
    // actually lives), or if no category matched at all, fall back to scanning
    // all categories for a sub-type whose value or emitType matches.
    if (dynamicUiSubtype) {
        const subtypeInMatch = matchedOption?.subTypes.some((st)=>st.value === dynamicUiSubtype);
        if (!matchedOption || !subtypeInMatch) {
            const fallback = allOptions.find((opt)=>opt.subTypes.some((st)=>st.value === dynamicUiSubtype || st.emitType === dynamicUiType));
            if (fallback) matchedOption = fallback;
        }
    } else if (!matchedOption) {
        // No subtype provided and no direct category match — the dynamicUiType
        // may be an emitType override (e.g. 'image' which is a sub-type in
        // 'visual-aid' with emitType: 'image'). Scan all categories for a
        // sub-type whose emitType matches.
        const fallback = allOptions.find((opt)=>opt.subTypes.some((st)=>st.emitType === dynamicUiType));
        if (fallback) matchedOption = fallback;
    }
    // No matching category, or category has no sub-types (e.g. slides, whiteboard)
    if (!matchedOption || matchedOption.subTypes.length === 0) return null;
    const groupLabel = matchedOption.labelMessage.defaultMessage ?? '';
    const groupLabelMessage = matchedOption.labelMessage;
    // Find the current sub-type within the matched category.
    // When dynamicUiSubtype is provided, match by value directly.
    // When only dynamicUiType is provided (no subtype), try to find a sub-type
    // whose emitType matches dynamicUiType (e.g. emitType: 'image' → the 'image' sub-type).
    let currentSubType = dynamicUiSubtype ? matchedOption.subTypes.find((st)=>st.value === dynamicUiSubtype) : matchedOption.subTypes.find((st)=>st.emitType === dynamicUiType);
    // If a subtype was provided but not found in this category, return null
    // to avoid showing a broken dropdown.
    if (dynamicUiSubtype && !currentSubType) return null;
    // Variants with `emitType` are only selectable from the remix-overlay.
    // When the active subtype has an emitType override, hide the switcher
    // entirely so the user cannot switch away from it.
    if (currentSubType?.emitType) return null;
    // Filter out emitType variants from the switcher — they should only
    // appear in the remix-overlay, not in the editor toolbar dropdown.
    const filteredSubTypes = matchedOption.subTypes.filter((st)=>!st.emitType);
    if (filteredSubTypes.length === 0) return null;
    // Fall back to category-level label if no sub-type is set
    // (e.g. "Pick for me" was used).
    const currentLabel = currentSubType ? currentSubType.labelMessage.defaultMessage ?? '' : groupLabel;
    const currentLabelMessage = currentSubType ? currentSubType.labelMessage : groupLabelMessage;
    return {
        groupLabel: groupLabel,
        groupLabelMessage: groupLabelMessage,
        currentLabel: currentLabel,
        currentLabelMessage: currentLabelMessage,
        siblingSubTypes: filteredSubTypes
    };
}
module.exports["PAGE_REMIX_OPTIONS"] = $1b429d4516497df0$export$839e8948e17d6e68;
module.exports["getRemixMenuOptions"] = $1b429d4516497df0$export$eba289419a85029b;
module.exports["getTypeDisplayName"] = $1b429d4516497df0$export$b3104233810c1e93;
module.exports["getSubTypeDisplayName"] = $1b429d4516497df0$export$ca76798d0446453;
module.exports["getDefaultRemixPromptText"] = $1b429d4516497df0$export$376994f626d15236;
module.exports["getRemixSwitcherInfo"] = $1b429d4516497df0$export$bd80fc308a7bbe16;

});

parcelRegister("jz8lo", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $hdBxM = parcelRequire("hdBxM");


var $k1Pvg = parcelRequire("k1Pvg");


var $5BOJB = parcelRequire("5BOJB");


var $6iWVH = parcelRequire("6iWVH");


var $6mKj3 = parcelRequire("6mKj3");


var $jmjWc = parcelRequire("jmjWc");


var $lpaq2 = parcelRequire("lpaq2");


const $133397c2abdefdc4$var$LazyRovoChatRemixView = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "b2tBI",
    name: "LazyRovoChatRemixView",
    loader: async ()=>(await (parcelRequire("3C6ed"))).RovoChatRemixView
});
const $133397c2abdefdc4$var$isOpenRovoRemixSidebarPayload = (payload)=>payload.type === 'open-rovo-remix-sidebar';
const $133397c2abdefdc4$var$createRovoRemixAction = (session)=>{
    return {
        id: `confluence-rovo-remix:${crypto.randomUUID()}`,
        title: 'Remix',
        handleType: (0, $6iWVH.HandleActionType).Base,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null),
        presentation: {
            hideActionHeader: true,
            suppressPromptLibrary: true,
            fillAvailableHeight: true
        },
        viewConfig: {
            render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($133397c2abdefdc4$var$LazyRovoChatRemixView, {
                    renderRovoChatRemixPicker: (0, $lpaq2.renderRovoChatRemixPicker),
                    session: session
                })
        }
    };
};
const $133397c2abdefdc4$export$96c35e5f3a6712f8 = ()=>{
    const { setActiveAction: setActiveAction } = (0, $5BOJB.useActiveAction)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const handleEvent = (0, $cozmU.useCallback)((payload)=>{
        if (!$133397c2abdefdc4$var$isOpenRovoRemixSidebarPayload(payload)) return;
        // Variant2 Remix entry points converge here, ensuring one exposure per accepted launch.
        (0, $6mKj3.expVal)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'control');
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'rovoChatRemixScreen',
                source: payload.source,
                attributes: {
                    entryPoint: payload.source,
                    product: 'confluence'
                }
            }
        }).fire();
        setActiveAction($133397c2abdefdc4$var$createRovoRemixAction({
            consumer: payload.data.remixConsumer,
            scope: payload.data.remixPreset
        }), {
            preserveSelectedConversation: true
        });
    }, [
        createAnalyticsEvent,
        setActiveAction
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hdBxM.Subscriber), {
        consumeOnceKey: "confluence-rovo-remix-action-launcher",
        onEvent: handleEvent,
        topic: (0, $k1Pvg.Topics).ROVO_REMIX_LAUNCH,
        triggerLatest: true
    });
};
module.exports["RovoRemixActionLauncher"] = $133397c2abdefdc4$export$96c35e5f3a6712f8;

});

parcelRegister("lpaq2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


const $3c479359d4e5ebbf$var$LazyRovoChatRemixPickerAdapter = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "HAlgh",
    name: "LazyRovoChatRemixPickerAdapter",
    loader: async ()=>(await (parcelRequire("axNIt"))).RovoChatRemixPickerAdapter
});
const $3c479359d4e5ebbf$export$ff3dbf3fd6d623a0 = ({ isDisabled: isDisabled, onSelect: onSelect, preset: preset })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3c479359d4e5ebbf$var$LazyRovoChatRemixPickerAdapter, {
        isDisabled: isDisabled,
        onSelect: onSelect,
        preset: preset
    });
module.exports["renderRovoChatRemixPicker"] = $3c479359d4e5ebbf$export$ff3dbf3fd6d623a0;

});

parcelRegister("axNIt", function(module, exports) {

let $7ad38d1930e70dc0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7ad38d1930e70dc0$var$load("jPfa3"),
    $7ad38d1930e70dc0$var$load("6wr18"),
    $7ad38d1930e70dc0$var$load("ffEVr"),
    $7ad38d1930e70dc0$var$load("j1ofJ")
]).then(()=>parcelRequire('fK5VE'));

});

parcelRegister("3C6ed", function(module, exports) {

let $2a19c082dad9724c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2a19c082dad9724c$var$load("kT6dz"),
    $2a19c082dad9724c$var$load("1rjMs"),
    $2a19c082dad9724c$var$load("jPfa3"),
    $2a19c082dad9724c$var$load("2ixrW"),
    $2a19c082dad9724c$var$load("l6kfs"),
    $2a19c082dad9724c$var$load("evPcb"),
    $2a19c082dad9724c$var$load("6vqGz"),
    $2a19c082dad9724c$var$load("52ggd"),
    $2a19c082dad9724c$var$load("hUbK8"),
    $2a19c082dad9724c$var$load("aur8o"),
    $2a19c082dad9724c$var$load("eLOQ2"),
    $2a19c082dad9724c$var$load("3HjyT"),
    $2a19c082dad9724c$var$load("brdGh"),
    $2a19c082dad9724c$var$load("exl8k"),
    $2a19c082dad9724c$var$load("j5RRe"),
    $2a19c082dad9724c$var$load("2mGc6"),
    $2a19c082dad9724c$var$load("e5ukl"),
    $2a19c082dad9724c$var$load("kLS8s"),
    $2a19c082dad9724c$var$load("1R53K"),
    $2a19c082dad9724c$var$load("anA6E"),
    $2a19c082dad9724c$var$load("iPvQ1"),
    $2a19c082dad9724c$var$load("j2k0B"),
    $2a19c082dad9724c$var$load("14Wfp"),
    $2a19c082dad9724c$var$load("VXbA1"),
    $2a19c082dad9724c$var$load("2PVCX"),
    $2a19c082dad9724c$var$load("59hV4"),
    $2a19c082dad9724c$var$load("3R4oU"),
    $2a19c082dad9724c$var$load("dZYhM"),
    $2a19c082dad9724c$var$load("kwaPJ"),
    $2a19c082dad9724c$var$load("3ayyN"),
    $2a19c082dad9724c$var$load("4B1fg"),
    $2a19c082dad9724c$var$load("1VvO7"),
    $2a19c082dad9724c$var$load("g8Cky"),
    $2a19c082dad9724c$var$load("db7T5"),
    $2a19c082dad9724c$var$load("cIf37"),
    $2a19c082dad9724c$var$load("asveJ"),
    $2a19c082dad9724c$var$load("2TRyz"),
    $2a19c082dad9724c$var$load("lXUHS"),
    $2a19c082dad9724c$var$load("eoHHt"),
    $2a19c082dad9724c$var$load("51ESV"),
    $2a19c082dad9724c$var$load("4x9Jx"),
    $2a19c082dad9724c$var$load("ea3NB"),
    $2a19c082dad9724c$var$load("fibpY"),
    $2a19c082dad9724c$var$load("4O6U4"),
    $2a19c082dad9724c$var$load("bQQNo"),
    $2a19c082dad9724c$var$load("io6rG"),
    $2a19c082dad9724c$var$load("cL90P"),
    $2a19c082dad9724c$var$load("fob67"),
    $2a19c082dad9724c$var$load("gaT5l"),
    $2a19c082dad9724c$var$load("2Vm3g"),
    $2a19c082dad9724c$var$load("6wr18"),
    $2a19c082dad9724c$var$load("Wowvf"),
    $2a19c082dad9724c$var$load("ffEVr"),
    $2a19c082dad9724c$var$load("hhss7"),
    $2a19c082dad9724c$var$load("gnocL"),
    $2a19c082dad9724c$var$load("gw4CZ"),
    $2a19c082dad9724c$var$load("d1Ddn"),
    $2a19c082dad9724c$var$load("f4Nog"),
    $2a19c082dad9724c$var$load("7EorR"),
    $2a19c082dad9724c$var$load("7XiLa")
]).then(()=>parcelRequire('f7cmi'));

});

parcelRegister("5ruin", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $2b71e6bc29f732db$var$noopConfiguration = {
    getActions: async ()=>[]
};
const $2b71e6bc29f732db$var$initialState = {
    configuration: $2b71e6bc29f732db$var$noopConfiguration
};
const $2b71e6bc29f732db$var$actions = {
    setConfiguration: (configuration)=>({ setState: setState })=>{
            setState({
                configuration: configuration
            });
        },
    resetConfiguration: ()=>({ setState: setState })=>{
            setState({
                configuration: $2b71e6bc29f732db$var$noopConfiguration
            });
        },
    updateConfiguration: (configuration)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                configuration: {
                    ...state.configuration,
                    ...configuration
                }
            });
        }
};
const $2b71e6bc29f732db$export$e0afd2e658e4f7ce = (0, $8s9DV.createStore)({
    initialState: $2b71e6bc29f732db$var$initialState,
    actions: $2b71e6bc29f732db$var$actions,
    name: 'RovoCurrentConfigStore'
});
const $2b71e6bc29f732db$export$2cefdfe72db08be4 = (0, $kBr4q.createActionsHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce);
const $2b71e6bc29f732db$export$d7809b5c7bef1f6d = (0, $kBr4q.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration
});
const $2b71e6bc29f732db$export$897f16b7b08b0ac = (0, $kBr4q.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.getActions
});
const $2b71e6bc29f732db$export$1e0546f83460b30d = (0, $kBr4q.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.tags
});
const $2b71e6bc29f732db$export$2a73ca2333c94154 = (0, $kBr4q.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.customGreeting
});
const $2b71e6bc29f732db$export$9d0f592eafe765c0 = (0, $kBr4q.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.shouldShowGreeting
});
const $2b71e6bc29f732db$export$6745aa6ec6db525a = (0, $kBr4q.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.prioritizeCustomActionResults
});
const $2b71e6bc29f732db$export$77b1364ae13e9bf5 = (0, $kBr4q.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.numStartersToShow
});
module.exports["useRovoCurrentConfigStoreActions"] = $2b71e6bc29f732db$export$2cefdfe72db08be4;
module.exports["useRovoConfigGetActions"] = $2b71e6bc29f732db$export$897f16b7b08b0ac;
module.exports["useRovoConfigTags"] = $2b71e6bc29f732db$export$1e0546f83460b30d;
module.exports["useRovoConfigCustomGreeting"] = $2b71e6bc29f732db$export$2a73ca2333c94154;
module.exports["useRovoConfigShouldShowGreeting"] = $2b71e6bc29f732db$export$9d0f592eafe765c0;
module.exports["useRovoConfigPrioritizeCustomActionResults"] = $2b71e6bc29f732db$export$6745aa6ec6db525a;
module.exports["useRovoConfigNumStartersToShow"] = $2b71e6bc29f732db$export$77b1364ae13e9bf5;

});

parcelRegister("bWlOZ", function(module, exports) {
/**
 * Machine-backed Remix flow controller (plain module, no react-sweet-state).
 *
 * This replaces the previous `remixMachineStore` (which mirrored machine phase
 * into a SweetState store). The machine is now the SINGLE source of truth:
 *
 * - Each remix flow is a state **machine** (`./remixMachine`). Machines are
 *   imperative, non-serialisable objects; they live in a module-level registry
 *   (`machineRegistry`), NOT in any React store.
 * - React consumers read the machine directly via the `useSyncExternalStore`
 *   hooks in `./useMachineState` (phase, instance view, active ids, isAnyRemixing),
 *   which subscribe through `./machineBridge`. There is no mirrored phase copy.
 * - This file owns only the **write/lifecycle** side: create a flow, wire its
 *   transitions/teardown to the bridge, send events, end/reset. All of this is
 *   plain functions callable from anywhere (React or not) — the registry and
 *   bridge are module-scoped.
 *
 * The explicit-machine model (events in, `onTransition`/`onDone` out, effects for
 * side-effects) is exactly what the reviewers asked for; dropping SweetState
 * removes the redundant second source of truth.
 */ 
var $cKwXx = parcelRequire("cKwXx");


var $2sIE1 = parcelRequire("2sIE1");


var $h4gwB = parcelRequire("h4gwB");


var $2Pvub = parcelRequire("2Pvub");


var $MbeHu = parcelRequire("MbeHu");


var $1Ukdn = parcelRequire("1Ukdn");

/**
 * Single-active policy, same as before: a removable guard on top of a plural
 * model. Flip to `false` (or make per-call) to allow concurrent flows.
 */ const $b94e0c21d1c0143c$var$SINGLE_ACTIVE_POLICY = true;
/**
 * Non-reactive registry of live flows, keyed by remix id. Alongside each
 * machine, retain its dispatcher and immutable command identity so teardown
 * never depends on mutable machine context.
 */ const $b94e0c21d1c0143c$var$machineRegistry = new Map();
const $b94e0c21d1c0143c$export$bb6da1182d6c1fa5 = (id)=>$b94e0c21d1c0143c$var$machineRegistry.get(id)?.machine;
const $b94e0c21d1c0143c$export$354cb0a867425c7e = ()=>Array.from($b94e0c21d1c0143c$var$machineRegistry.keys());
const $b94e0c21d1c0143c$export$bdc0c29f889a7d10 = ()=>{
    for (const { machine: machine } of $b94e0c21d1c0143c$var$machineRegistry.values()){
        if ((0, $MbeHu.isActivePhase)(machine.state())) return true;
    }
    return false;
};
const $b94e0c21d1c0143c$var$generateRemixId = ()=>`remix-${crypto.randomUUID()}`;
const $b94e0c21d1c0143c$var$generateConversationId = ()=>crypto.randomUUID();
/**
 * Remove a flow from every synchronous read path, announce its final teardown,
 * then dispose the machine after the current state-machine send has unwound.
 */ const $b94e0c21d1c0143c$var$teardownRemix = (id, reason)=>{
    const record = $b94e0c21d1c0143c$var$machineRegistry.get(id);
    if (!record) {
        // Preserve stale bridge cleanup for unknown/already-ended ids.
        (0, $2Pvub.unregisterMachineFromBridge)(id);
        return;
    }
    // Delete before dispatch: a command handler may re-enter endRemix synchronously.
    $b94e0c21d1c0143c$var$machineRegistry.delete(id);
    (0, $2Pvub.unregisterMachineFromBridge)(id);
    try {
        record.dispatcher?.dispatch({
            type: 'RemixFlowEnded',
            ...record.commandBase,
            reason: reason
        });
    } finally{
        // Command handlers run inside machine effects. Destroying synchronously here
        // can therefore corrupt an in-flight state-machine send.
        queueMicrotask(()=>record.machine.destroy());
    }
};
const $b94e0c21d1c0143c$export$9573327fad1c6a2e = (args)=>{
    if ($b94e0c21d1c0143c$var$SINGLE_ACTIVE_POLICY && $b94e0c21d1c0143c$export$bdc0c29f889a7d10()) return undefined;
    const remixId = $b94e0c21d1c0143c$var$generateRemixId();
    const conversationId = args.conversationId ?? $b94e0c21d1c0143c$var$generateConversationId();
    const startedAt = Date.now();
    // Resolve the command dispatcher: an explicit (e.g. bridge-backed) one, or
    // the process-default in-memory dispatcher when `useCommandBus` is set, or none.
    const dispatcher = args.commandDispatcher ?? (args.useCommandBus ? (0, $2sIE1.defaultRemixCommandDispatcher) : undefined);
    // Two independent effect sources: port-based effects (direct calls) and, when
    // a dispatcher is present, command effects (dispatch typed commands). They are
    // NOT merged — the machine registers each set's callbacks separately, because
    // the builder's `.on('enter'|'exit', cb)` accumulates rather than overwrites.
    // Order matters: ports run before commands.
    //
    // The two are complementary, not alternatives: `ports` is the LOCAL writer of
    // editor/chat state, while commands are announcements for any number of
    // observers (analytics, other frames). Do not also register
    // `createPortsCommandHandler` with these same ports — that would make the
    // command path a second writer and double-fire every effect.
    const effectSets = [
        (0, $h4gwB.buildRemixEffects)(args.ports ?? {})
    ];
    if (dispatcher) effectSets.push((0, $cKwXx.buildRemixCommandEffects)(dispatcher));
    // `targetNodeId` is part of the base context, not an edit-only field: an
    // anchored create carries one too (it is what inline/embed loading targets).
    // Left `undefined` — never coerced to '' — so "unanchored" stays honest and
    // the loading port can distinguish "no anchor" from "an anchor called ''".
    const baseContext = {
        remixId: remixId,
        kind: args.kind,
        conversationId: conversationId,
        cancellationSessionId: args.cancellationSessionId,
        metadata: args.metadata,
        startedAt: startedAt,
        targetNodeId: args.targetNodeId
    };
    const machine = args.kind === 'update' ? (0, $1Ukdn.createRemixEditMachine)({
        ...baseContext,
        updateSentinel: args.updateSentinel,
        targetNodeId: args.targetNodeId
    }, ...effectSets) : (0, $1Ukdn.createRemixCreateMachine)(baseContext, ...effectSets);
    // `INSERTED` is the machine's only transition to `done`. Final transitions bypass
    // `onTransition` and synchronously fire `onDone` inside `send()`, making this the
    // required automatic-teardown hook. `teardownRemix` removes and announces the flow
    // immediately, then defers destruction until the in-flight `send()` has unwound.
    machine.onDone(()=>{
        $b94e0c21d1c0143c$var$teardownRemix(remixId, 'inserted');
    });
    $b94e0c21d1c0143c$var$machineRegistry.set(remixId, {
        machine: machine,
        dispatcher: dispatcher,
        commandBase: {
            remixId: remixId,
            conversationId: conversationId,
            targetNodeId: args.targetNodeId
        }
    });
    // Bridge the machine to React so `useSyncExternalStore` consumers re-render on
    // transitions and can read the current phase on mount. Registering also
    // notifies aggregate subscribers that membership changed (e.g. isAnyRemixing).
    (0, $2Pvub.registerMachineWithBridge)(remixId, machine);
    // @atlassian/state-machine does NOT fire the initial state's `onEnter` effect
    // at construction (effects only run on transitions). A flow starts life in
    // `thinking`, so invoke every source's "entered thinking" effect explicitly
    // here. Subsequent enter/exit of `thinking` are handled by the machine.
    //
    // This deliberately calls the SAME callbacks the machine registered rather
    // than re-implementing their bodies per source — otherwise adding a third
    // effect source would silently miss its initial fire.
    //
    // The context is read back off the machine so it is exactly what the effects
    // would receive on a real transition. The event producer is a no-op: there is
    // no triggering event at construction, and sending into a machine mid-setup
    // is not safe.
    const initialContext = machine.context();
    const noopEventProducer = ()=>{};
    for (const set of effectSets)set.onEnterThinking?.(initialContext, noopEventProducer);
    return {
        remixId: remixId,
        conversationId: conversationId
    };
};
const $b94e0c21d1c0143c$export$205cdacb7d65bba0 = (id, event)=>{
    $b94e0c21d1c0143c$var$machineRegistry.get(id)?.machine.send(event);
};
const $b94e0c21d1c0143c$export$8c1c097bfe1d213c = (id, reason)=>$b94e0c21d1c0143c$var$teardownRemix(id, reason);
const $b94e0c21d1c0143c$export$9a86eddda6568093 = ()=>{
    // Test-only hard reset deliberately bypasses command dispatch and deferred
    // disposal so each test starts from a fully clean synchronous state.
    $b94e0c21d1c0143c$var$machineRegistry.forEach(({ machine: machine }, id)=>{
        machine.destroy();
        (0, $2Pvub.unregisterMachineFromBridge)(id);
    });
    $b94e0c21d1c0143c$var$machineRegistry.clear();
};
module.exports["getRemixMachine"] = $b94e0c21d1c0143c$export$bb6da1182d6c1fa5;
module.exports["listRemixMachineIds"] = $b94e0c21d1c0143c$export$354cb0a867425c7e;
module.exports["startRemix"] = $b94e0c21d1c0143c$export$9573327fad1c6a2e;
module.exports["sendRemixEvent"] = $b94e0c21d1c0143c$export$205cdacb7d65bba0;
module.exports["endRemix"] = $b94e0c21d1c0143c$export$8c1c097bfe1d213c;

});

parcelRegister("cKwXx", function(module, exports) {
/**
 * Machine effects that DISPATCH COMMANDS (Abhi's "output commands" model).
 *
 * The command-based alternative to `../effects/remixEffects.ts` (which calls
 * injected ports directly). Here the machine's `onEnter` effects announce what
 * happened by dispatching typed commands through an injected
 * `RemixCommandDispatcher`; any number of handlers react. The machine has zero
 * knowledge of consumers OR of the command transport (real bridge vs in-memory).
 *
 * State → command mapping:
 *   enter `thinking` → RemixStarted           (generation began)
 *   enter `ready`    → RemixReady + RemixGenerationEnded(reason: 'ready')
 *   enter `error`    → RemixErrored + RemixGenerationEnded(reason: 'error')
 *   enter `aborted`  → RemixAborted + RemixGenerationEnded(reason: 'aborted')
 *
 * `RemixGenerationEnded` means "the thinking/loading phase finished" (so a
 * handler can clear editor loading); its `reason` is derived from the
 * destination so a single handler can branch. It does NOT mean the flow is over
 * — a `ready` flow lives on until the user accepts/inserts or cancels. The
 * separate `RemixFlowEnded` command (dispatched by the store on teardown) marks
 * the true end of a flow's life.
 *
 * Additive; not wired into live flows.
 */ const $d2add0c69158bec9$export$51f85b9f058f5e45 = (dispatcher)=>({
        onEnterThinking: (ctx)=>dispatcher.dispatch({
                type: 'RemixStarted',
                remixId: ctx.remixId,
                conversationId: ctx.conversationId,
                targetNodeId: ctx.targetNodeId
            }),
        onEnterReady: (ctx)=>{
            dispatcher.dispatch({
                type: 'RemixReady',
                remixId: ctx.remixId,
                conversationId: ctx.conversationId,
                targetNodeId: ctx.targetNodeId,
                resultId: ctx.resultId
            });
            dispatcher.dispatch({
                type: 'RemixGenerationEnded',
                remixId: ctx.remixId,
                conversationId: ctx.conversationId,
                targetNodeId: ctx.targetNodeId,
                reason: 'ready'
            });
        },
        onEnterError: (ctx)=>{
            dispatcher.dispatch({
                type: 'RemixErrored',
                remixId: ctx.remixId,
                conversationId: ctx.conversationId,
                targetNodeId: ctx.targetNodeId
            });
            dispatcher.dispatch({
                type: 'RemixGenerationEnded',
                remixId: ctx.remixId,
                conversationId: ctx.conversationId,
                targetNodeId: ctx.targetNodeId,
                reason: 'error'
            });
        },
        onEnterAborted: (ctx)=>{
            dispatcher.dispatch({
                type: 'RemixAborted',
                remixId: ctx.remixId,
                conversationId: ctx.conversationId,
                targetNodeId: ctx.targetNodeId
            });
            dispatcher.dispatch({
                type: 'RemixGenerationEnded',
                remixId: ctx.remixId,
                conversationId: ctx.conversationId,
                targetNodeId: ctx.targetNodeId,
                reason: 'aborted'
            });
        }
    });
module.exports["buildRemixCommandEffects"] = $d2add0c69158bec9$export$51f85b9f058f5e45;

});

parcelRegister("2sIE1", function(module, exports) {
/**
 * Remix command vocabulary + the injected-dispatcher seam.
 *
 * Abhi's model: the state machine emits **output commands** on state entry/exit
 * ("input events in, output commands out"). A command is a fire-and-forget
 * announcement ("a remix started", "a remix errored"); handlers decide what to
 * do (toggle editor loading, open chat, fire analytics, cross a frame).
 *
 * Transport is NOT the machine's concern. The real command transport is
 * `@atlassian/rovo-content-bridge-api` — a client/command API that works both
 * same-context (local handlers) and cross-frame (iframe/webview) via pluggable
 * transports, using the identical `send`/`on` surface. Rather than couple this
 * pure state layer to that package, the machine dispatches through a minimal
 * injected `RemixCommandDispatcher`. Product wiring supplies an adapter that
 * maps these typed commands onto real bridge `createCommand` classes and
 * `api.send(...)`; tests/local usage can use the in-memory dispatcher below.
 *
 * This keeps `malleable-ui-components` transport-agnostic while using the real
 * bridge in production (option B).
 *
 * Additive; not wired into live flows.
 */ /** Discriminant for every remix command. */ class $d1ea2b186e2500b1$export$fa920a2636a7fe90 {
    register(handler) {
        this.handlers.add(handler);
        return ()=>{
            this.handlers.delete(handler);
        };
    }
    dispatch(command) {
        for (const handler of Array.from(this.handlers))try {
            handler(command);
        } catch (error) {
            // Isolate handler failures from the state transition that emitted.
            // eslint-disable-next-line no-console
            console.error('[remix] command handler threw', command.type, error);
        }
    }
    clear() {
        this.handlers.clear();
    }
    constructor(){
        this.handlers = new Set();
    }
}
const $d1ea2b186e2500b1$export$bfed4a0e1ed5bbcf = new $d1ea2b186e2500b1$export$fa920a2636a7fe90();
const $d1ea2b186e2500b1$export$7aa05bbd09851bd = (handler)=>$d1ea2b186e2500b1$export$bfed4a0e1ed5bbcf.register(handler);
const $d1ea2b186e2500b1$export$3d4fd2920549228c = (command)=>$d1ea2b186e2500b1$export$bfed4a0e1ed5bbcf.dispatch(command);
const $d1ea2b186e2500b1$export$41e24c5543d9e719 = ()=>$d1ea2b186e2500b1$export$bfed4a0e1ed5bbcf.clear();
module.exports["defaultRemixCommandDispatcher"] = $d1ea2b186e2500b1$export$bfed4a0e1ed5bbcf;
module.exports["registerRemixCommandHandler"] = $d1ea2b186e2500b1$export$7aa05bbd09851bd;

});

parcelRegister("h4gwB", function(module, exports) {
/**
 * Builds the machine `onEnter`/`onExit` effects that project remix state into
 * other stores (editor loading, chat panel).
 *
 * This is the concrete realisation of option (A) — reactive projection. The
 * machine transitions; entering/leaving a phase runs an effect that calls a
 * narrow injected port. No imperative "also update the editor" calls are
 * sprinkled through the flow code.
 *
 * Example mapping:
 *   - enter `thinking`   → editor shows loading for the target node
 *   - exit  `thinking`   → editor clears loading (covers ready/error/abort)
 *   - enter `error`      → open the chat panel so the user sees the failure
 */ const $7bc2363dd5b18667$export$9392b02cdcf1c7c9 = (ports)=>{
    const { editorLoading: editorLoading, chatPanel: chatPanel } = ports;
    return {
        // Editor loading state is tied to the `thinking` phase: show on enter,
        // clear on exit (whichever phase we move to). Targeting uses the
        // context's targetNodeId (undefined for creates without an anchor).
        onEnterThinking: editorLoading ? (ctx)=>editorLoading.setLoading(ctx.targetNodeId) : undefined,
        onExitThinking: editorLoading ? (prev)=>editorLoading.clearLoading(prev.targetNodeId) : undefined,
        // Open chat when the flow errors so the user can see the failure / retry.
        onEnterError: chatPanel ? (ctx)=>chatPanel.open(ctx.conversationId) : undefined
    };
};
module.exports["buildRemixEffects"] = $7bc2363dd5b18667$export$9392b02cdcf1c7c9;

});

parcelRegister("2Pvub", function(module, exports) {
/**
 * Machine → React bridge.
 *
 * The @atlassian/state-machine machine is the single source of truth for a flow's phase
 * (`machine.state()`). But the machine is not React-aware, and its
 * `onTransition(listener)` registers a listener that can only be removed by
 * `destroy()`-ing the whole machine (there is no per-listener unsubscribe).
 * `useSyncExternalStore` requires a `subscribe(cb) => unsubscribe` contract, so
 * this module provides that missing piece.
 *
 * Design:
 * - We register exactly ONE `onTransition` listener per machine (a "fan-out"),
 *   and maintain our own `Set` of React subscriber callbacks that we can add to
 *   and remove from individually. That gives real unsubscribe semantics on top
 *   of the lib's append-only listener list.
 * - There is also a set of GLOBAL subscribers (for aggregate reads like
 *   "is any remix in progress"), notified on every machine's transition and on
 *   registry membership changes (start/end of a flow).
 *
 * With this bridge:
 * - A late-mounting component reads `machine.state()` synchronously on mount
 *   (correct initial value — no missed-command problem).
 * - A mounted component re-renders on the next transition (subscription).
 *
 * Both fall out of one `useSyncExternalStore` hook (see `useMachineState.ts`);
 * no separate reactive mirror of the phase is required.
 *
 * Additive; not wired into live flows.
 */ /** Per-machine React subscribers, keyed by remix id. */ const $5b9d77ef809dc852$var$perMachineSubscribers = new Map();
/** Machines we have already attached our single fan-out listener to. */ const $5b9d77ef809dc852$var$bridgedMachines = new Set();
/** Global subscribers (aggregate reads across all flows). */ const $5b9d77ef809dc852$var$globalSubscribers = new Set();
const $5b9d77ef809dc852$var$notify = (subscribers)=>{
    if (!subscribers) return;
    // Copy before iterating: a subscriber may unsubscribe during notification.
    for (const cb of Array.from(subscribers))cb();
};
const $5b9d77ef809dc852$export$fffa0fc87565fa3b = (id, machine)=>{
    if ($5b9d77ef809dc852$var$bridgedMachines.has(id)) return;
    $5b9d77ef809dc852$var$bridgedMachines.add(id);
    machine.onTransition(()=>{
        $5b9d77ef809dc852$var$notify($5b9d77ef809dc852$var$perMachineSubscribers.get(id));
        $5b9d77ef809dc852$var$notify($5b9d77ef809dc852$var$globalSubscribers);
    });
    // Membership changed → aggregate reads (e.g. isAnyRemixing) must re-evaluate.
    $5b9d77ef809dc852$var$notify($5b9d77ef809dc852$var$globalSubscribers);
};
const $5b9d77ef809dc852$export$b2ca8b3ec66a9029 = (id)=>{
    $5b9d77ef809dc852$var$perMachineSubscribers.delete(id);
    $5b9d77ef809dc852$var$bridgedMachines.delete(id);
    $5b9d77ef809dc852$var$notify($5b9d77ef809dc852$var$globalSubscribers);
};
const $5b9d77ef809dc852$export$d6df5c560ea5cbbc = (id, callback)=>{
    let set = $5b9d77ef809dc852$var$perMachineSubscribers.get(id);
    if (!set) {
        set = new Set();
        $5b9d77ef809dc852$var$perMachineSubscribers.set(id, set);
    }
    set.add(callback);
    return ()=>{
        set?.delete(callback);
    };
};
const $5b9d77ef809dc852$export$fae2e146ec761b28 = (callback)=>{
    $5b9d77ef809dc852$var$globalSubscribers.add(callback);
    return ()=>{
        $5b9d77ef809dc852$var$globalSubscribers.delete(callback);
    };
};
const $5b9d77ef809dc852$export$2faa64766bd050ee = ()=>{
    $5b9d77ef809dc852$var$perMachineSubscribers.clear();
    $5b9d77ef809dc852$var$bridgedMachines.clear();
    $5b9d77ef809dc852$var$globalSubscribers.clear();
};
module.exports["registerMachineWithBridge"] = $5b9d77ef809dc852$export$fffa0fc87565fa3b;
module.exports["unregisterMachineFromBridge"] = $5b9d77ef809dc852$export$b2ca8b3ec66a9029;
module.exports["subscribeToMachine"] = $5b9d77ef809dc852$export$d6df5c560ea5cbbc;
module.exports["subscribeToAnyMachine"] = $5b9d77ef809dc852$export$fae2e146ec761b28;

});

parcelRegister("MbeHu", function(module, exports) {
/**
 * Machine-spike types for the centralised Remix state model.
 *
 * This is the state-machine-based iteration of `../types.ts`, produced from the
 * review feedback on the initial store PR (Loom + Lauren):
 *
 * 1. **Discriminated union for create vs edit** (Loom feedback #3). Instead of
 *    one `RemixActionInstance` with a `kind` field and a pile of optional
 *    edit-only fields, we model `RemixCreateActionInstance` and
 *    `RemixEditActionInstance` as separate types. Edit-only context is then
 *    *required* on the edit type and *absent* on the create type, so the
 *    compiler enforces "these fields only exist for edits".
 *
 * 2. **No derived booleans in stored state** (Loom feedback #1). The phase is
 *    the single source of truth for lifecycle; we do not also store
 *    `isComplete` / `isError` / `isAborted`. Those are read off the phase.
 *
 * 3. **Explicit `targetNodeId`** (PR comment + Lauren's editor-loading
 *    requirement). The node identity (mediaId / contentMauiId) of the content a
 *    remix is anchored to is promoted to a first-class field, rather than being
 *    buried inside the opaque `historyEntry`. Cross-store effects (e.g. the
 *    editor inline/embed loading state) need this to target the right node.
 *
 *    Named `targetNodeId`, NOT `targetContentId`: in Confluence `contentId`
 *    conventionally means the *page* id, whereas this is a node identity within
 *    the page. It is required for edits and optional for creates (an anchored
 *    create — remixing a selected node — has one; an unanchored create does
 *    not).
 *
 * These types live under `machine/` alongside the parallel machine
 * implementation and do NOT replace `../types.ts` yet — both coexist during the
 * spike.
 */ const $8700088f0d91025e$export$7621bdd83abc7375 = (instance)=>instance.kind === 'update';
const $8700088f0d91025e$export$711431828c4c4090 = (instance)=>instance.kind === 'create';
const $8700088f0d91025e$export$e1fd53a08df613cf = [
    'error',
    'aborted'
];
/**
 * `TERMINAL_PHASES` as a Set, for O(1) membership checks on hot paths (the
 * `useSyncExternalStore` snapshot readers call this on every render).
 *
 * Derived from `TERMINAL_PHASES` rather than written out again, so adding a
 * phase to the array above automatically applies everywhere.
 */ const $8700088f0d91025e$var$TERMINAL_PHASE_SET = new Set($8700088f0d91025e$export$e1fd53a08df613cf);
const $8700088f0d91025e$export$ce0969ab998f2048 = (phase)=>!$8700088f0d91025e$var$TERMINAL_PHASE_SET.has(phase);
module.exports["isActivePhase"] = $8700088f0d91025e$export$ce0969ab998f2048;

});

parcelRegister("1Ukdn", function(module, exports) {
/**
 * The Remix state machines (create + edit).
 *
 * Review feedback (Loom #3/#4) asked for:
 *  - the lifecycle to be an *explicit* state machine (events in, state out) using
 *    the same primitive the whiteboard domain uses (the published
 *    `@atlassian/state-machine` package), rather than imperative phase
 *    assignment;
 *  - **two** small machines — one for create, one for edit — because they are
 *    driven by different network streams and, for edits, an extra suppression
 *    rule applies before the first real result.
 *
 * Both machines share the same `RemixPhase` states and the same event
 * vocabulary; they differ in their starting context and (for edit) the presence
 * of the sentinel guard. Keeping them separate means create-only and edit-only
 * behaviour is expressed structurally instead of via `if (kind === ...)`.
 *
 * Cross-store side-effects (editor loading state, opening chat on error) are NOT
 * hard-coded here — they are injected as `onEnter`/`onExit` effects by the
 * store, so this file stays free of editor/chat dependencies. See
 * `./effects/*`.
 */ 
var $ikKzo = parcelRequire("ikKzo");

/** Identity context update — most transitions carry context forward unchanged. */ const $28a5a24b75d16432$var$keepContext = (ctx)=>ctx;
/**
 * Apply every source's `onEnter`/`onExit` effect for a state to its builder.
 *
 * `.on('enter'|'exit', cb)` ACCUMULATES — the library's effect registrar does
 * `config.effects[name].push(callback)`, and its `EffectLookup` type is an
 * element of `Effects[...]` (an array). So calling it once per source registers
 * them all, in call order, and the machine invokes them in that order.
 *
 * That is why there is no composition helper here: multiple effect sources
 * (ports, command bus, ...) are simply registered one after another rather than
 * being merged into a single callback.
 */ const $28a5a24b75d16432$var$withEffects = (sb, effectSets, { enter: enter, exit: exit })=>{
    let next = sb;
    if (enter) for (const set of effectSets){
        const fn = set[enter];
        if (fn) next = next.on('enter', fn);
    }
    if (exit) for (const set of effectSets){
        const fn = set[exit];
        if (fn) next = next.on('exit', fn);
    }
    return next;
};
/**
 * Shared state graph used by both machines, expressed via the published
 * `@atlassian/state-machine` builder API (the same primitive canvas uses). The
 * only structural difference between create and edit is the initial context, so
 * the transition topology is defined once here.
 *
 * Transition chain reads: `.when(EVENT, t => t.label(...).if().context(...).to(STATE))`.
 * `.if()` with no args means "no guards"; `.context(fn)` is the context updater.
 */ const $28a5a24b75d16432$var$buildMachine = (context, effectSets)=>(0, $ikKzo.builder)().initial('thinking').context(context).state('thinking', (s)=>$28a5a24b75d16432$var$withEffects(s, effectSets, {
            enter: 'onEnterThinking',
            exit: 'onExitThinking'
        }).when('RESULT_READY', (t)=>t.label('result is previewable').if().context((ctx, event)=>({
                    ...ctx,
                    resultId: event.resultId
                })).to('ready')).when('GENERATION_ERROR', (t)=>t.label('generation failed').if().context($28a5a24b75d16432$var$keepContext).to('error')).when('GENERATION_ABORTED', (t)=>t.label('user aborted').if().context($28a5a24b75d16432$var$keepContext).to('aborted')).when('CANCELLED', (t)=>t.label('user cancelled').if().context($28a5a24b75d16432$var$keepContext).to('aborted'))).state('ready', (s)=>$28a5a24b75d16432$var$withEffects(s, effectSets, {
            enter: 'onEnterReady'
        }).when('PREVIEW_OPENED', (t)=>t.label('preview shown').if().context($28a5a24b75d16432$var$keepContext).to('previewing')).when('GENERATION_ERROR', (t)=>t.label('late error').if().context($28a5a24b75d16432$var$keepContext).to('error')).when('CANCELLED', (t)=>t.label('cancelled before preview').if().context($28a5a24b75d16432$var$keepContext).to('aborted'))).state('previewing', (s)=>s.when('ACCEPTED', (t)=>t.label('user accepted result').if().context($28a5a24b75d16432$var$keepContext).to('inserting')).when('CANCELLED', (t)=>t.label('user discarded preview').if().context($28a5a24b75d16432$var$keepContext).to('aborted')).when('GENERATION_ERROR', (t)=>t.label('error during preview').if().context($28a5a24b75d16432$var$keepContext).to('error'))).state('inserting', (s)=>// `inserting` is terminal from the machine's perspective: once INSERTED
        // fires the store removes the instance. Modelled as the `done` command.
        $28a5a24b75d16432$var$withEffects(s, effectSets, {
            enter: 'onEnterInserting'
        }).when('INSERTED', (t)=>t.label('insertion complete').if().context($28a5a24b75d16432$var$keepContext).to('done')).when('GENERATION_ERROR', (t)=>t.label('insertion failed').if().context($28a5a24b75d16432$var$keepContext).to('error'))).state('error', (s)=>$28a5a24b75d16432$var$withEffects(s, effectSets, {
            enter: 'onEnterError'
        })).state('aborted', (s)=>$28a5a24b75d16432$var$withEffects(s, effectSets, {
            enter: 'onEnterAborted'
        })).build();
const $28a5a24b75d16432$export$4c98f8ad39f53d35 = (context, ...effectSets)=>$28a5a24b75d16432$var$buildMachine({
        ...context
    }, effectSets);
const $28a5a24b75d16432$export$8efbabba11f68e43 = (context, ...effectSets)=>$28a5a24b75d16432$var$buildMachine({
        ...context
    }, effectSets);
module.exports["createRemixCreateMachine"] = $28a5a24b75d16432$export$4c98f8ad39f53d35;
module.exports["createRemixEditMachine"] = $28a5a24b75d16432$export$8efbabba11f68e43;

});

parcelRegister("ikKzo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gypE9 = parcelRequire("gypE9");

parcelRequire("aQvaf");

parcelRequire("3ThHj");

module.exports.asyncStateBuilder = $gypE9.asyncStateBuilder;
module.exports.builder = $gypE9.builder;
module.exports.effectNameMap = $gypE9.effectNameMap;
module.exports.stateBuilder = $gypE9.stateBuilder;
module.exports.transientStateBuilder = $gypE9.transientStateBuilder;

});

parcelRegister("gypE9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $c0d3b73437a6c94b$var$_nullishCoalesce(lhs, rhsFn) {
    if (lhs != null) return lhs;
    else return rhsFn();
}

var $aQvaf = parcelRequire("aQvaf");

// src/builder/state-machine-builder.ts
var $c0d3b73437a6c94b$var$effectNameMap = {
    enter: "onEnter",
    "re-enter": "onReEnter",
    exit: "onExit",
    execute: "onExecute"
};
var $c0d3b73437a6c94b$var$builder = ()=>{
    const config = {};
    config.states = {};
    const initial = (state2)=>{
        config.initial = state2;
        return {
            context: context
        };
    };
    const context = (context2)=>{
        config.context = context2;
        return {
            state: state,
            transientState: transientState,
            build: build,
            when: when,
            use: use,
            with: state,
            asyncState: asyncState
        };
    };
    const state = (name, doBuild)=>{
        const builder2 = $c0d3b73437a6c94b$var$stateBuilder(name, config);
        doBuild(builder2).build();
        return {
            state: state,
            transientState: transientState,
            build: build,
            when: when,
            use: use,
            with: state,
            asyncState: asyncState
        };
    };
    const transientState = (name, doBuild)=>{
        const builder2 = $c0d3b73437a6c94b$var$transientStateBuilder(name, config);
        doBuild(builder2).build();
        return {
            state: state,
            transientState: transientState,
            build: build,
            when: when,
            use: use,
            with: state,
            asyncState: asyncState
        };
    };
    const when = (on, doBuild)=>{
        var _config_globalTransitions, _on;
        const builder2 = $c0d3b73437a6c94b$var$transitionBuilder();
        const newTransitions = doBuild(builder2);
        if (!config.globalTransitions) config.globalTransitions = {};
        const transitionsForEvent = (_config_globalTransitions = config.globalTransitions)[_on = on] ?? (_config_globalTransitions[_on] = []);
        if (Array.isArray(newTransitions)) transitionsForEvent.push(...newTransitions);
        else transitionsForEvent.push(newTransitions);
        return {
            state: state,
            transientState: transientState,
            build: build,
            when: when,
            use: use,
            with: state,
            asyncState: asyncState
        };
    };
    const asyncState = (name, doBuild)=>{
        const builder2 = $c0d3b73437a6c94b$var$asyncStateBuilder(name, config);
        doBuild(builder2).build();
        return {
            state: state,
            transientState: transientState,
            build: build,
            when: when,
            use: use,
            with: state,
            asyncState: asyncState
        };
    };
    const use = (name, definition)=>{
        config.states[name] = definition;
        return {
            state: state,
            transientState: transientState,
            build: build,
            when: when,
            use: use,
            with: state,
            asyncState: asyncState
        };
    };
    const build = ()=>{
        return $aQvaf.createMachine.call(void 0, config);
    };
    return {
        initial: initial
    };
};
var $c0d3b73437a6c94b$var$stateBuilder = (name, config, baseConfig)=>{
    if (config && !config.states) config.states = {};
    const stateConfig = $c0d3b73437a6c94b$var$_nullishCoalesce(baseConfig, ()=>({}));
    if (!stateConfig.effects) stateConfig.effects = {};
    if (!stateConfig.transitions) stateConfig.transitions = {};
    if (!stateConfig.guards) stateConfig.guards = [];
    const when = (on2, build2, opts)=>{
        if (!stateConfig.transitions[on2]) stateConfig.transitions[on2] = [];
        const builder2 = $c0d3b73437a6c94b$var$transitionBuilder();
        const transition = build2(builder2);
        const transitions = Array.isArray(transition) ? transition : [
            transition
        ];
        const current = $c0d3b73437a6c94b$var$_nullishCoalesce(stateConfig.transitions[on2], ()=>[]);
        if (!opts) current.push(...transitions);
        else if ("before" in opts) {
            const idx = current.findIndex((t)=>t.label === opts.before);
            if (idx === -1) current.push(...transitions);
            else current.splice(idx, 0, ...transitions);
        } else {
            const idx = current.findIndex((t)=>t.label === opts.after);
            if (idx === -1) current.push(...transitions);
            else current.splice(idx + 1, 0, ...transitions);
        }
        return stateApi;
    };
    const trap = ()=>{
        stateConfig.trap = true;
        return stateApi;
    };
    const on = (name2, callback)=>{
        $c0d3b73437a6c94b$var$effectBuilder($c0d3b73437a6c94b$var$effectNameMap[name2], stateConfig, callback);
        return stateApi;
    };
    const childState = (name2, build2)=>{
        const builder2 = $c0d3b73437a6c94b$var$stateBuilder(name2, stateConfig);
        build2(builder2).build();
        return stateApi;
    };
    const transientChildState = (name2, doBuild)=>{
        const builder2 = $c0d3b73437a6c94b$var$transientStateBuilder(name2, stateConfig);
        doBuild(builder2).build();
        return stateApi;
    };
    const asyncState = (name2, doBuild)=>{
        const builder2 = $c0d3b73437a6c94b$var$asyncStateBuilder(name2, stateConfig);
        doBuild(builder2).build();
        return stateApi;
    };
    const build = ()=>{
        if (baseConfig) return stateConfig;
        if (config == null ? void 0 : config.states) config.states[name] = stateConfig;
        return stateConfig;
    };
    const guard = (guard2)=>{
        var _a;
        (_a = stateConfig.guards) == null || _a.push(guard2);
        return stateApi;
    };
    const stateApi = {
        when: when,
        on: on,
        build: build,
        state: childState,
        transientState: transientChildState,
        trap: trap,
        guard: guard,
        asyncState: asyncState
    };
    return stateApi;
};
var $c0d3b73437a6c94b$var$asyncStateBuilder = (name, config, baseConfig)=>{
    const stateConfig = {
        ...baseConfig,
        effects: {},
        resolvedTransitions: [],
        rejectedTransitions: []
    };
    if (config && !config.states) config.states = {};
    const onEnter = (action)=>{
        stateConfig.asyncAction = action;
        return {
            whenResolved: whenResolved,
            whenRejected: whenRejected
        };
    };
    const whenResolved = (doBuild)=>{
        const builder2 = $c0d3b73437a6c94b$var$transitionBuilder();
        stateConfig.resolvedTransitions.push(doBuild(builder2));
        return {
            whenResolved: whenResolved,
            whenRejected: whenRejected
        };
    };
    const whenRejected = (doBuild)=>{
        const builder2 = $c0d3b73437a6c94b$var$transitionBuilder();
        stateConfig.rejectedTransitions.push(doBuild(builder2));
        return {
            whenRejected: whenRejected,
            build: build,
            timeoutMs: timeoutMs
        };
    };
    const timeoutMs = (timeout)=>{
        stateConfig.timeout = timeout;
        return {
            build: build
        };
    };
    const build = ()=>{
        if (config == null ? void 0 : config.states) config.states[name] = stateConfig;
    };
    return {
        onEnter: onEnter
    };
};
var $c0d3b73437a6c94b$var$transientStateBuilder = (name, config)=>{
    const stateConfig = {};
    if (config && !config.states) config.states = {};
    if (!stateConfig.effects) stateConfig.effects = {};
    if (!stateConfig.passthroughs) stateConfig.passthroughs = [];
    const when = (build2)=>{
        const builder2 = $c0d3b73437a6c94b$var$transitionBuilder();
        stateConfig.passthroughs.push(build2(builder2));
        return statePassthroughApi;
    };
    const on = (name2, callback)=>{
        $c0d3b73437a6c94b$var$effectBuilder($c0d3b73437a6c94b$var$effectNameMap[name2], stateConfig, callback);
        return statePassthroughApi;
    };
    const build = ()=>{
        if (config == null ? void 0 : config.states) config.states[name] = stateConfig;
        return stateConfig;
    };
    const statePassthroughApi = {
        when: when,
        on: on,
        build: build
    };
    return statePassthroughApi;
};
var $c0d3b73437a6c94b$var$transitionBuilder = ()=>{
    const transitionConfig = {};
    let transitionLabel = "unknown";
    const label = (label2)=>{
        transitionLabel = label2;
        return {
            if: guard
        };
    };
    const guard = (...guards)=>{
        transitionConfig.guard = guards;
        return {
            context: context
        };
    };
    const context = (...context2)=>{
        transitionConfig.context = context2;
        return {
            to: to
        };
    };
    const to = (state)=>{
        transitionConfig.state = state;
        return {
            ...transitionConfig,
            label: transitionLabel
        };
    };
    const transitionApi = {
        label: label,
        if: guard
    };
    return transitionApi;
};
var $c0d3b73437a6c94b$var$effectBuilder = (name, config, callback)=>{
    if (!config.effects[name]) config.effects[name] = [];
    const effects = config.effects[name];
    effects.push(callback);
};
module.exports.effectNameMap = $c0d3b73437a6c94b$var$effectNameMap;
module.exports.builder = $c0d3b73437a6c94b$var$builder;
module.exports.stateBuilder = $c0d3b73437a6c94b$var$stateBuilder;
module.exports.asyncStateBuilder = $c0d3b73437a6c94b$var$asyncStateBuilder;
module.exports.transientStateBuilder = $c0d3b73437a6c94b$var$transientStateBuilder;

});

parcelRegister("aQvaf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $7e56ef485025db3c$var$_nullishCoalesce(lhs, rhsFn) {
    if (lhs != null) return lhs;
    else return rhsFn();
} // src/state-machine.ts
function $7e56ef485025db3c$var$getTransitionType(event) {
    if (event.type === "async-resolved") return 2 /* AsyncResolved */ ;
    if (event.type === "async-rejected") return 4 /* AsyncRejected */ ;
    return 1 /* Normal */ ;
}
function $7e56ef485025db3c$var$createMachine(config) {
    const pathLookup = /* @__PURE__ */ new Map();
    const currentConfig = config;
    const transitionListeners = [];
    const eventListeners = [];
    const doneListeners = [];
    let abortController;
    const prepare = (stateTree, statePrefix = "", statePath = [])=>{
        for (const [state2, branch] of Object.entries(stateTree)){
            const path = `${statePrefix}${state2}`;
            const nextTree = branch;
            const nextPath = [
                ...statePath,
                {
                    state: state2,
                    node: branch
                }
            ];
            pathLookup.set(state2, nextPath);
            if (nextTree.states) prepare(nextTree.states, `${path}:`, nextPath);
        }
    };
    prepare(config.states);
    const getNode = (statePath, position = statePath.length)=>{
        return statePath[position - 1].node;
    };
    const findState = (state2)=>{
        return $7e56ef485025db3c$var$_nullishCoalesce(pathLookup.get(state2), ()=>(console.log(pathLookup, config, state2), []));
    };
    const findStateConfig = (target)=>{
        var _a;
        return (_a = findState(target).at(-1)) == null ? void 0 : _a.node;
    };
    const findTransition = (statePath, event)=>{
        var _a;
        function firstMatchingTransition(transitions) {
            const transition = transitions.find((transition2)=>{
                var _a2;
                const transitionGuards = transition2.guard.every((guard)=>guard(currentContext, event));
                if (!transitionGuards) return;
                if (transitionGuards && transition2.state === "done") return transition2;
                const statePath2 = pathLookup.get(transition2.state);
                if (!statePath2) return;
                const stateGuards = (_a2 = getNode(statePath2)) == null ? void 0 : _a2.guards;
                if (!stateGuards) return transitionGuards ? transition2 : void 0;
                if (stateGuards.every((g)=>g())) return transition2;
            });
            if (transition) return transition;
        }
        for(let idx = statePath.length - 1; idx >= 0; idx--){
            const node = getNode(statePath, idx + 1);
            if ("transitions" in node) {
                const transitions = $7e56ef485025db3c$var$_nullishCoalesce(node.transitions[event.type], ()=>[]);
                const transition = firstMatchingTransition(transitions);
                if (transition) return transition;
                if (node.trap) return void 0;
            }
        }
        return firstMatchingTransition($7e56ef485025db3c$var$_nullishCoalesce((_a = config.globalTransitions) == null ? void 0 : _a[event.type], ()=>[]));
    };
    const sendEvent = (event, target = 1 /* Listeners */ )=>{
        if (target & 1 /* Listeners */ ) eventListeners.forEach((listener)=>listener(event));
        if (target & 2 /* StateMachine */ ) send(event);
    };
    let prevStatePath = findState(currentConfig.initial);
    let currentStatePath = findState(currentConfig.initial);
    const initialNode = {
        state: currentConfig.initial,
        node: currentStatePath[currentStatePath.length - 1].node
    };
    let prevContext = {
        ...currentConfig.context
    };
    let currentContext = {
        ...currentConfig.context
    };
    const send = (event)=>{
        const state2 = getNode(currentStatePath);
        if ("passthroughs" in state2) return;
        const transition = findTransition(currentStatePath, event);
        if (transition) {
            doTransition(event, transition);
            doPassthrough(event);
        }
    };
    const doTransition = (event, transition)=>{
        prevStatePath = [
            ...currentStatePath
        ];
        if (transition.state === "done") {
            resolveContext(transition, event);
            effect(getNode(currentStatePath), "onExit", currentContext, currentContext, sendEvent);
            doneListeners.forEach((listener)=>listener());
            return;
        }
        currentStatePath = findState(transition.state);
        prevContext = {
            ...currentContext
        };
        resolveContext(transition, event);
        transitionListeners.forEach((listener)=>{
            const transitionType = $7e56ef485025db3c$var$getTransitionType(event);
            if (listener.type & transitionType) listener.listener(event, currentContext, {
                previous: previous(),
                current: state()
            }, transition);
        });
        resolveEffects();
    };
    const doPassthrough = (event)=>{
        const nextState = getNode(currentStatePath);
        if ("passthroughs" in nextState) {
            const passthrough = nextState.passthroughs.find((passthrough2)=>passthrough2.guard.every((guard)=>guard(currentContext, event)));
            if (!passthrough) return;
            doTransition(event, passthrough);
            doPassthrough(event);
        }
    };
    const previous = ()=>prevStatePath[prevStatePath.length - 1].state;
    const current = ()=>currentStatePath[currentStatePath.length - 1].state;
    const state = ()=>current();
    const context = ()=>currentContext;
    const resolveContext = (transition, event)=>{
        transition.context.forEach((contextUpdater)=>{
            currentContext = contextUpdater(currentContext, event);
        });
    };
    const doAsyncTransition = (node, event)=>{
        let transition;
        if (event.type === "async-resolved") transition = node.resolvedTransitions.find((t)=>t.guard.every((guard)=>guard(currentContext, event)));
        else transition = node.rejectedTransitions.find((t)=>t.guard.every((guard)=>guard(currentContext, event)));
        if (!transition) return;
        doTransition(event, transition);
        doPassthrough(event);
    };
    const setupAsyncStateTimeout = (node, signal)=>{
        if (node.timeout) {
            const timeout = typeof node.timeout === "function" ? node.timeout(currentContext) : node.timeout;
            if (timeout <= 0) return;
            const timeoutId = setTimeout(()=>{
                if (!signal.aborted) {
                    doAsyncTransition(node, {
                        type: "async-rejected",
                        error: new Error("Async action timed out"),
                        reason: "timeout"
                    });
                    abortController == null || abortController.abort();
                }
            }, timeout);
            signal.addEventListener("abort", ()=>{
                clearTimeout(timeoutId);
            }, {
                once: true
            });
        }
    };
    const processAsyncState = (node)=>{
        abortController == null || abortController.abort();
        if ("asyncAction" in node) {
            abortController = new AbortController();
            const currentSignal = abortController.signal;
            setupAsyncStateTimeout(node, currentSignal);
            node.asyncAction(currentContext, currentSignal).then((result)=>{
                if (currentSignal.aborted) return;
                doAsyncTransition(node, {
                    type: "async-resolved",
                    result: result
                });
            }).catch((error)=>{
                if (currentSignal.aborted) return;
                doAsyncTransition(node, {
                    type: "async-rejected",
                    error: error,
                    reason: "error"
                });
            });
            return;
        }
    };
    const resolveEffects = ()=>{
        let prev = 0;
        let curr = 0;
        let overlapUntil = 0;
        while(prev < prevStatePath.length && curr < currentStatePath.length){
            if (prevStatePath[prev].state === currentStatePath[curr].state) overlapUntil++;
            prev++;
            curr++;
        }
        for(prev = overlapUntil; prev < prevStatePath.length; prev++)effect(getNode(prevStatePath, prev + 1), "onExit", prevContext, currentContext, sendEvent);
        const node = getNode(currentStatePath, currentStatePath.length);
        processAsyncState(node);
        for(curr = overlapUntil; curr < currentStatePath.length; curr++)effect(getNode(currentStatePath, curr + 1), "onEnter", currentContext, sendEvent);
        if (previous() === current()) effect(getNode(currentStatePath), "onReEnter", prevContext, currentContext, sendEvent);
    };
    const execute = ()=>{
        effect(getNode(currentStatePath), "onExecute", currentContext, sendEvent);
    };
    const effect = (effectState, effectKey, ...args)=>{
        const effects = effectState.effects;
        if (!effects[effectKey] || effects[effectKey].length === 0) return;
        effects[effectKey].forEach((fn)=>{
            try {
                fn(args[0], args[1], args[2]);
            } catch (error) {
                console.error(error);
            }
        });
    };
    const from = (initial, context2)=>{
        const nextConfig = {
            ...config,
            initial: initial
        };
        if (context2) nextConfig.context = context2;
        const machine = $7e56ef485025db3c$var$createMachine(nextConfig);
        transitionListeners.forEach((transitionListener)=>{
            machine.onTransition(transitionListener.listener);
        });
        doneListeners.forEach((doneListener)=>{
            machine.onDone(doneListener);
        });
        return machine;
    };
    const reset = ()=>{
        abortController == null || abortController.abort();
        abortController = void 0;
        prevStatePath = [
            {
                ...initialNode
            }
        ];
        currentStatePath = [
            {
                ...initialNode
            }
        ];
        prevContext = {
            ...currentConfig.context
        };
        currentContext = {
            ...currentConfig.context
        };
    };
    const destroy = ()=>{
        abortController == null || abortController.abort();
        abortController = void 0;
        prevStatePath.length = 0;
        currentStatePath.length = 0;
        transitionListeners.length = 0;
        eventListeners.length = 0;
        doneListeners.length = 0;
        pathLookup.clear();
    };
    const onTransition = (listener, type = 1 /* Normal */ )=>{
        transitionListeners.push({
            listener: listener,
            type: type
        });
    };
    const onEvent = (listener)=>{
        eventListeners.push(listener);
    };
    const onDone = (listener)=>{
        doneListeners.push(listener);
    };
    return {
        send: send,
        state: state,
        context: context,
        execute: execute,
        reset: reset,
        destroy: destroy,
        onTransition: onTransition,
        onEvent: onEvent,
        onDone: onDone,
        from: from,
        config: ()=>({
                initial: config.initial,
                states: {
                    ...config.states
                },
                globalTransitions: {
                    ...config.globalTransitions
                },
                context: {
                    ...config.context
                }
            }),
        lookup: findStateConfig
    };
}
module.exports.createMachine = $7e56ef485025db3c$var$createMachine;

});

parcelRegister("3ThHj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
}); // src/state-machine-types.ts
var $2d543c8c3b0ff81c$var$Target = /* @__PURE__ */ ((Target2)=>{
    Target2[Target2["Listeners"] = 1] = "Listeners";
    Target2[Target2["StateMachine"] = 2] = "StateMachine";
    return Target2;
})($2d543c8c3b0ff81c$var$Target || {});
var $2d543c8c3b0ff81c$var$TransitionType = /* @__PURE__ */ ((TransitionType2)=>{
    TransitionType2[TransitionType2["Normal"] = 1] = "Normal";
    TransitionType2[TransitionType2["AsyncResolved"] = 2] = "AsyncResolved";
    TransitionType2[TransitionType2["AsyncRejected"] = 4] = "AsyncRejected";
    TransitionType2[TransitionType2["All"] = 7] = "All";
    return TransitionType2;
})($2d543c8c3b0ff81c$var$TransitionType || {});
module.exports.Target = $2d543c8c3b0ff81c$var$Target;
module.exports.TransitionType = $2d543c8c3b0ff81c$var$TransitionType;

});

parcelRegister("3OD5k", function(module, exports) {
const $84c94bf7c9d9425b$export$5f321bb161ebfd54 = (contentType)=>contentType === 'blogpost' ? 'blogpost' : 'page';
module.exports["resolveRemixDynamicUiContentType"] = $84c94bf7c9d9425b$export$5f321bb161ebfd54;

});

parcelRegister("3rRes", function(module, exports) {

var $jTt8P = parcelRequire("jTt8P");


var $4Aqqh = parcelRequire("4Aqqh");


var $1qYXT = parcelRequire("1qYXT");


var $6mKj3 = parcelRequire("6mKj3");

/**
 * Confluence product-side read of `REMIX_EXPANDS_EXPERIMENT`.
 *
 * Only invoked for expand node types (see `isRemixRestrictedNodeTypeWithExpands`), so filtering a
 * fragment without expands does not touch the experiment.
 */ const $b43257b5198523a8$var$areRemixExpandsEnabled = ()=>(0, $6mKj3.isExperimentEnabled)((0, $1qYXT.REMIX_EXPANDS_EXPERIMENT));
const $b43257b5198523a8$export$cee0b7c2921c06e1 = (nodes)=>{
    if (nodes === null) return null;
    const result = [];
    for (const node of nodes){
        const filtered = (0, $jTt8P.traverse)(node, {
            any: (adfNode)=>{
                if ((0, $1qYXT.isRemixRestrictedNodeTypeWithExpands)(adfNode.type, $b43257b5198523a8$var$areRemixExpandsEnabled)) return false;
            }
        });
        if (filtered !== false) result.push(filtered);
    }
    return result;
};
const $b43257b5198523a8$export$d6cdcf2c2885fa31 = (nodes)=>{
    if ((0, $6mKj3.isExperimentEnabled)('cc_maui_polish_changes_batch_6')) {
        if (nodes === null) return null;
        const sanitizedNodes = nodes.flatMap((node)=>{
            // The sanitizer can remove an invalid root node at runtime even though its legacy return
            // type only exposes JSONNode.
            const sanitizedNode = (0, $4Aqqh.sanitizeNode)(node, {
                keepNestedTables: true
            });
            return sanitizedNode === false ? [] : [
                sanitizedNode
            ];
        });
        return $b43257b5198523a8$export$cee0b7c2921c06e1(sanitizedNodes);
    }
    return $b43257b5198523a8$export$cee0b7c2921c06e1(nodes);
};
module.exports["filterRemixFragmentNodes"] = $b43257b5198523a8$export$cee0b7c2921c06e1;
module.exports["prepareRemixFragmentNodes"] = $b43257b5198523a8$export$d6cdcf2c2885fa31;

});

parcelRegister("caVF7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $1118b6b7a2cd5d89$export$c8a930cce8a67fba = ({ onOpenPreview: onOpenPreview })=>{
    const [isComplete, setIsComplete] = (0, $cozmU.useState)(false);
    const signalActionReady = (0, $cozmU.useCallback)(()=>{
        // Defer opening the preview until the progress bar fills to 100%.
        setIsComplete(true);
    }, []);
    const resetCompletion = (0, $cozmU.useCallback)(()=>{
        setIsComplete(false);
    }, []);
    return (0, $cozmU.useMemo)(()=>({
            showProgressBar: true,
            isComplete: isComplete,
            onCompleteAnimationFinished: onOpenPreview,
            signalActionReady: signalActionReady,
            resetCompletion: resetCompletion
        }), [
        isComplete,
        onOpenPreview,
        signalActionReady,
        resetCompletion
    ]);
};
module.exports["useRemixThinkingBarProgress"] = $1118b6b7a2cd5d89$export$c8a930cce8a67fba;

});

parcelRegister("alDoy", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $kDDrf = parcelRequire("kDDrf");


var $iBsvI = parcelRequire("iBsvI");

const $760703998eb424cc$export$6a00edcd422023c4 = 120000;
const $760703998eb424cc$export$fb8e95ec88bc76df = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const activeGenerationRef = (0, $cozmU.useRef)(undefined);
    const hasRecordedSuccessRef = (0, $cozmU.useRef)(false);
    const timeoutRef = (0, $cozmU.useRef)(undefined);
    const clearPotentialTimeout = (0, $cozmU.useCallback)(()=>{
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = undefined;
        }
    }, []);
    const createAttributes = (0, $cozmU.useCallback)((attributes)=>({
            ...attributes,
            featureArea: attributes.featureArea ?? (0, $iBsvI.getRemixFeatureArea)({
                remixType: attributes.remixType,
                existingFeatureArea: 'remix'
            }) ?? 'remix',
            remixCreateId: (0, $kDDrf.getActiveRemixCreateId)()
        }), []);
    const trackRemixSubmitted = (0, $cozmU.useCallback)((attributes)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'remixSubmit',
                source: attributes.remixSource ?? attributes.entryPoint,
                attributes: createAttributes(attributes)
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        createAttributes
    ]);
    const trackGenerationStarted = (0, $cozmU.useCallback)((attributes)=>{
        clearPotentialTimeout();
        const activeAttributes = createAttributes(attributes);
        activeGenerationRef.current = activeAttributes;
        hasRecordedSuccessRef.current = false;
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'started',
                actionSubject: 'remixGeneration',
                source: attributes.remixSource ?? attributes.entryPoint,
                attributes: activeAttributes
            }
        }).fire();
        timeoutRef.current = setTimeout(()=>{
            const currentAttributes = activeGenerationRef.current;
            if (!currentAttributes) return;
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'potentialTimeout',
                    actionSubject: 'remixGeneration',
                    source: currentAttributes.remixSource ?? currentAttributes.entryPoint,
                    attributes: currentAttributes
                }
            }).fire();
        }, $760703998eb424cc$export$6a00edcd422023c4);
    }, [
        clearPotentialTimeout,
        createAnalyticsEvent,
        createAttributes
    ]);
    const trackGenerationFinished = (0, $cozmU.useCallback)((action, attributes)=>{
        const activeAttributes = activeGenerationRef.current;
        if (!activeAttributes) return;
        if (action === 'succeeded' && hasRecordedSuccessRef.current) return;
        clearPotentialTimeout();
        const finalAttributes = {
            ...activeAttributes,
            ...attributes
        };
        if (action === 'failed') activeGenerationRef.current = undefined;
        else {
            hasRecordedSuccessRef.current = true;
            activeGenerationRef.current = undefined;
        }
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: action,
                actionSubject: 'remixGeneration',
                source: finalAttributes.remixSource ?? finalAttributes.entryPoint,
                attributes: finalAttributes
            }
        }).fire();
    }, [
        clearPotentialTimeout,
        createAnalyticsEvent
    ]);
    const trackGenerationStopped = (0, $cozmU.useCallback)((attributes)=>{
        const activeAttributes = activeGenerationRef.current;
        if (!activeAttributes) return;
        clearPotentialTimeout();
        activeGenerationRef.current = undefined;
        hasRecordedSuccessRef.current = false;
        const finalAttributes = {
            ...activeAttributes,
            ...attributes
        };
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'stopped',
                actionSubject: 'remixGeneration',
                source: finalAttributes.remixSource ?? finalAttributes.entryPoint,
                attributes: finalAttributes
            }
        }).fire();
    }, [
        clearPotentialTimeout,
        createAnalyticsEvent
    ]);
    const trackGenerationFailed = (0, $cozmU.useCallback)((attributes)=>trackGenerationFinished('failed', attributes), [
        trackGenerationFinished
    ]);
    const trackGenerationSucceeded = (0, $cozmU.useCallback)((attributes)=>trackGenerationFinished('succeeded', attributes), [
        trackGenerationFinished
    ]);
    (0, $cozmU.useEffect)(()=>()=>{
            clearPotentialTimeout();
            activeGenerationRef.current = undefined;
            hasRecordedSuccessRef.current = false;
        }, [
        clearPotentialTimeout
    ]);
    return {
        trackGenerationFailed: trackGenerationFailed,
        trackGenerationStarted: trackGenerationStarted,
        trackGenerationStopped: trackGenerationStopped,
        trackGenerationSucceeded: trackGenerationSucceeded,
        trackRemixSubmitted: trackRemixSubmitted
    };
};
module.exports["useRemixGenerationAnalytics"] = $760703998eb424cc$export$fb8e95ec88bc76df;

});

parcelRegister("hxqA6", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $ep3mz = parcelRequire("ep3mz");


var $kqIWy = parcelRequire("kqIWy");

const $37285b1cb0d2d316$var$NO_HIDDEN_OPTIONS = [];
const $37285b1cb0d2d316$export$ddcfdb99d720c6b3 = ()=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { data: spaceDetail } = (0, $kqIWy.useSpaceDetail)(spaceKey, {
        includeSpaceTypeSettings: true
    });
    const isWhiteboardsEnabled = spaceDetail?.typeSettings?.enabledContentTypes?.isWhiteboardsEnabled ?? false;
    const enabledContentTypes = spaceDetail?.typeSettings?.enabledContentTypes;
    const hiddenOptions = [];
    // Only hide the diagram option when whiteboards are unavailable for the space
    if (!isWhiteboardsEnabled && (0, $6mKj3.expVal)('cc_maui_polish_changes_batch_2', 'isEnabled', false)) hiddenOptions.push('diagram');
    if (!enabledContentTypes?.isWhiteboardsEnabled) hiddenOptions.push('whiteboard');
    if (!enabledContentTypes?.isDatabasesEnabled) hiddenOptions.push('database');
    if (!enabledContentTypes?.isSlidesEnabled) hiddenOptions.push('slides');
    return hiddenOptions.length > 0 ? hiddenOptions : $37285b1cb0d2d316$var$NO_HIDDEN_OPTIONS;
};
module.exports["useShouldHideDiagramRemixOption"] = $37285b1cb0d2d316$export$ddcfdb99d720c6b3;

});

parcelRegister("7eOZ4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kyKWe = parcelRequire("kyKWe");


var $iDrrr = parcelRequire("iDrrr");


var $kuGC4 = parcelRequire("kuGC4");


var $kNXXO = parcelRequire("kNXXO");


var $c5wKe = parcelRequire("c5wKe");


var $i7OAD = parcelRequire("i7OAD");


var $aYC8J = parcelRequire("aYC8J");


var $igOtY = parcelRequire("igOtY");


var $iW40i = parcelRequire("iW40i");


var $hwgBi = parcelRequire("hwgBi");


var $8akfd = parcelRequire("8akfd");


var $lTU4O = parcelRequire("lTU4O");


var $loej8 = parcelRequire("loej8");


var $ew8wg = parcelRequire("ew8wg");


var $6mKj3 = parcelRequire("6mKj3");


var $3jwuS = parcelRequire("3jwuS");


var $ep3mz = parcelRequire("ep3mz");


var $htsj6 = parcelRequire("htsj6");


var $ficwO = parcelRequire("ficwO");


var $jyA9t = parcelRequire("jyA9t");

const $1e31de274ed01603$var$isActionComplete = (chatMessages)=>{
    // Scan backwards to find ACTION_COMPLETE in the latest turn.
    // If we encounter a HUMAN message first, that marks a turn boundary —
    // any ACTION_COMPLETE before it belongs to a previous turn.
    let hasActionCompleteStep = false;
    for(let i = chatMessages.length - 1; i >= 0; i--){
        const message = chatMessages[i];
        if (message.type === 'ACTION_COMPLETE') {
            hasActionCompleteStep = true;
            break;
        }
        if ((0, $igOtY.isStoreHuman)(message)) break;
    }
    const lastPlannedAIFCAction = (0, $kNXXO.findLastAssistantAction)(chatMessages, (action)=>(0, $i7OAD.isAIFCAction)(action) && action.status === 'planned');
    const hasCompletedAction = lastPlannedAIFCAction !== undefined;
    if ((0, $iDrrr.fg)('remix_product_modal_rovo_chat')) return hasActionCompleteStep || hasCompletedAction;
    else return hasActionCompleteStep;
};
/**
 * True when the latest turn contains ACTION_PREPARE but no ACTION_COMPLETE.
 * This happens when AdfEditorMinion early-exits with "no operations returned
 * by LLM" — the stream completes but the action is never sealed.
 */ const $1e31de274ed01603$var$hasActionPrepareWithoutComplete = (chatMessages)=>{
    let hasActionPrepare = false;
    for(let i = chatMessages.length - 1; i >= 0; i--){
        const message = chatMessages[i];
        if (message.type === 'ACTION_COMPLETE') return false;
        if (message.type === 'ACTION_PREPARE') hasActionPrepare = !!message.action && (0, $aYC8J.isRemixGeneratedFlow)(message.action);
        if ((0, $igOtY.isStoreHuman)(message)) break;
    }
    return hasActionPrepare;
};
function $1e31de274ed01603$var$shouldOpenEphemeralPreview(chatMessages) {
    for(let i = chatMessages.length - 1; i >= 0; i--){
        const message = chatMessages[i];
        if (message.type === 'ACTION_PREPARE') {
            if (!message.action) return false;
            if (!(0, $aYC8J.isRemixGeneratedFlow)(message.action)) return false;
            if ($1e31de274ed01603$var$isWhiteboardRemixActionKey(message.action.key) && !(0, $aYC8J.getDynamicUiSubtype)(message.action)) return false;
            return true;
        }
    }
    return false;
}
const $1e31de274ed01603$var$isWhiteboardRemixActionKey = (key)=>key === (0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY) || key === (0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_UPDATE_KEY);
/**
 * True when the latest matching assistant action is a whiteboard create/update
 * and checks if the action is in the ACTION_PART streaming status.
 * (`MessageAction.status === 'streaming'`).
 */ const $1e31de274ed01603$var$hasWhiteboardRemixActionStreaming = (chatMessages)=>(0, $kNXXO.findLastAssistantAction)(chatMessages, (action)=>$1e31de274ed01603$var$isWhiteboardRemixActionKey(action.key) && action.status?.toLowerCase() === 'streaming') !== undefined;
const $1e31de274ed01603$export$cca9e2432f59b3f8 = ({ onActionReady: onActionReady, stagingAreaTargetMode: stagingAreaTargetMode = 'current-content', onPreviewOpened: onPreviewOpened, onSubmitted: onSubmitted, onPreviewDismissed: onPreviewDismissed, trackRemixConversationById: trackRemixConversationById = false } = {})=>{
    const { sendMessage: sendMessage, createConversationOptimistically: createConversationOptimistically, abortRequests: abortRequests, activeConversation: activeConversation, setSelectedConversation: setSelectedConversation } = (0, $c5wKe.useSmartCreationChatStoreApi)();
    const { setPrompt: setPrompt, setDynamicUiContext: setDynamicUiContext, setUserSelectedDynamicUiSubtype: setUserSelectedDynamicUiSubtype, setInteractionSource: setInteractionSource, setForceSkipAutoConversationSelection: setForceSkipAutoConversationSelection } = (0, $8akfd.useStagingAreaActions)();
    const { preferences: preferences } = (0, $lTU4O.useUserPreferences)();
    const { openModal: openModal, closeModal: closeModal } = (0, $jyA9t.useSmartCreationModalActions)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { title: contentTitle } = (0, $ew8wg.usePageTitle)({
        contentId: contentId ?? ''
    });
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    const isDraftPage = contentStatus === 'draft';
    // Track the conversation ID created by this remix flow. Only when the
    // store's activeConversation matches this ID do we consider it "ours".
    // Stored as state so that setting it triggers a rerender, ensuring
    // derived values (activeRemixConversation, chatMessages, etc.) update
    // immediately rather than waiting for an external rerender.
    const [remixConversationId, setRemixConversationId] = (0, $cozmU.useState)(undefined);
    const outerCancellationIntentRef = (0, $cozmU.useRef)();
    const resetRemixConversationId = (0, $cozmU.useCallback)(()=>{
        outerCancellationIntentRef.current = undefined;
        setRemixConversationId(undefined);
    }, []);
    const remixConversation = (0, $kuGC4.useConversationById)({
        conversationId: remixConversationId ?? ''
    });
    const shouldTrackRemixConversationById = trackRemixConversationById && (0, $6mKj3.expVal)('cc_maui_polish_changes_batch_5', 'isEnabled', false);
    const activeRemixConversation = shouldTrackRemixConversationById ? remixConversation ?? null : activeConversation?.id && activeConversation.id === remixConversationId ? activeConversation : null;
    const [chatMessages] = (0, $iW40i.useChatMessages)({
        conversationId: shouldTrackRemixConversationById ? remixConversationId ?? '' : activeRemixConversation?.id ?? ''
    });
    const isRemixCancelled = shouldTrackRemixConversationById && remixConversation?.lastAgentMessageStatus === 'CANCELLED';
    // Extract the first StoreError from chatMessages so callers can surface
    // the specific Rovo error message as an experience attribute.
    const remixStoreError = chatMessages.find((message)=>(0, $igOtY.isStoreError)(message)) ?? null;
    // Detect whether Rovo encountered an error while processing a remix request.
    // This covers ACTION_ERROR at any stage — both before the ephemeral preview
    // opens (during awaitingResponse) and while it is loading (during typingResponse).
    // Uses the same isStoreError check as the smart-creation staging area.
    const isRemixError = activeRemixConversation?.status === (0, $igOtY.CHAT_STORE_STATUS).deactivatedAgentError || remixStoreError !== null;
    const isRemixAborted = !isRemixError && activeRemixConversation?.status === (0, $igOtY.CHAT_STORE_STATUS).idle && !$1e31de274ed01603$var$isActionComplete(chatMessages) && !$1e31de274ed01603$var$hasActionPrepareWithoutComplete(chatMessages) && chatMessages.some((0, $igOtY.isStoreAssistant));
    // Track whether the onActionReady callback has already been fired for the
    // current conversation to avoid duplicate invocations.
    const actionReadyFired = (0, $cozmU.useRef)(false);
    // Reset the fired flag when the active remix conversation changes (new remix flow).
    const prevConversationId = (0, $cozmU.useRef)(activeRemixConversation?.id);
    (0, $cozmU.useEffect)(()=>{
        if (prevConversationId.current !== activeRemixConversation?.id) {
            actionReadyFired.current = false;
            prevConversationId.current = activeRemixConversation?.id;
        }
    }, [
        activeRemixConversation?.id
    ]);
    // Fire onActionReady when the appropriate message arrives:
    // - For whiteboard create/update: when the action is `streaming` (early trigger so
    //   the whiteboard preview can start rendering while data is still arriving).
    // - For all other actions: when FINAL_RESPONSE is received from the stream,
    //   indicated by the conversation status transitioning to `idle`.
    // - Fallback: when the stream completed (idle) with ACTION_PREPARE but no
    //   ACTION_COMPLETE (AdfEditorMinion early-exit).
    (0, $cozmU.useEffect)(()=>{
        if (actionReadyFired.current || !onActionReady || isRemixCancelled) return;
        const whiteboardStreamingDetected = $1e31de274ed01603$var$hasWhiteboardRemixActionStreaming(chatMessages);
        const finalResponseReceived = activeRemixConversation?.status === (0, $igOtY.CHAT_STORE_STATUS).idle && $1e31de274ed01603$var$isActionComplete(chatMessages);
        const actionPreparedButNotCompleted = activeRemixConversation?.status === (0, $igOtY.CHAT_STORE_STATUS).idle && $1e31de274ed01603$var$hasActionPrepareWithoutComplete(chatMessages);
        if (whiteboardStreamingDetected || finalResponseReceived || actionPreparedButNotCompleted) {
            actionReadyFired.current = true;
            onActionReady();
        }
    }, [
        chatMessages,
        onActionReady,
        activeRemixConversation?.status,
        isRemixCancelled
    ]);
    const stopRemixing = (0, $cozmU.useCallback)(()=>{
        const remixCancellation = outerCancellationIntentRef.current;
        outerCancellationIntentRef.current = undefined;
        try {
            if (remixCancellation) (0, $hwgBi.recordRemixCancellation)(remixCancellation);
        } finally{
            abortRequests?.({
                conversationId: activeRemixConversation?.id
            });
        }
    }, [
        abortRequests,
        activeRemixConversation?.id
    ]);
    const openAIFCStagingModal = (0, $cozmU.useCallback)((options)=>{
        // Chart/visualization previews can become ready after Rovo has already
        // deactivated the conversation. Do not let a stale completion callback
        // open an empty modal after the user stopped that exact Remix.
        if (isRemixCancelled) return;
        setForceSkipAutoConversationSelection(true);
        // Open the Confluence Smart Creation Modal with stagingAreaActive=true
        // to skip the prompt screen and go straight to the staging area preview.
        //
        // Only keep the ephemeral preview for remix-generated preview content.
        // The shared helper currently treats dynamic UI, image-based remix flows,
        // and remix-generated whiteboards/diagrams as ephemeral-preview candidates.
        // All other ACTION_PREPARE results should open the full AIFC modal.
        //
        // Pass forceFullModal: true to bypass this check
        const shouldUseEphemeralPreview = options?.forceFullModal ? false : $1e31de274ed01603$var$shouldOpenEphemeralPreview(chatMessages);
        openModal({
            entryPoint: 'dynamicUi',
            spaceKey: spaceKey ?? undefined,
            parentContent: contentId && !isDraftPage ? {
                id: contentId,
                title: contentTitle ?? '',
                contentType: contentType ?? 'page'
            } : undefined,
            stagingAreaActive: true,
            isFloating: shouldUseEphemeralPreview,
            shouldShowBackButton: false,
            ...activeRemixConversation?.id && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true) ? {
                remixConversationId: activeRemixConversation.id
            } : {},
            // `stagingAreaTargetMode` decides whether the current content is also
            // registered as staging-area content, or preserved only as parent/source
            // context for generated-content flows.
            ...stagingAreaTargetMode === 'current-content' && contentId ? {
                content: {
                    id: contentId,
                    type: contentType ?? 'page',
                    subType: isLivePage ? 'live' : null
                }
            } : {},
            // Pass a submitCallback only for ephemeral (floating) previews to
            // prevent navigating away from the current page. For the full modal flow
            // (e.g. "Add to Confluence"), omit the callback so the default
            // handleSubmitSmartCreate handler runs and redirects to the newly created content.
            ...shouldUseEphemeralPreview ? {
                submitCallback: async ()=>{
                    // Refresh the page tree for ephemeral previews only when the experiment is enabled.
                    if (!(0, $6mKj3.expVal)('cc-maui-refresh-page-tree-with-diagram', 'isEnabled', false)) return;
                    if (contentId) (0, $ficwO.publishMessage)((0, $ficwO.Message).PageTreeRefreshRequested, {
                        parentId: contentId
                    });
                }
            } : {},
            onOpenCallback: onPreviewOpened,
            onSubmitCallback: onSubmitted,
            onCloseCallback: onPreviewDismissed
        });
    }, [
        openModal,
        spaceKey,
        contentId,
        contentType,
        contentTitle,
        isLivePage,
        isDraftPage,
        activeRemixConversation?.id,
        isRemixCancelled,
        setForceSkipAutoConversationSelection,
        chatMessages,
        stagingAreaTargetMode,
        onPreviewOpened,
        onSubmitted,
        onPreviewDismissed
    ]);
    const sendAIFCPrompt = (0, $cozmU.useCallback)(async ({ userPrompt: userPrompt, promptText: promptTextOverride, dynamicUiSubtype: dynamicUiSubtype, dynamicUiType: dynamicUiType, dynamicUiSource: dynamicUiSource, interactionSource: interactionSource, forcedContentType: forcedContentType, additionalCreationContextParams: additionalCreationContextParams, conversationId: reuseConversationId, remixCancellationSessionId: remixCancellationSessionId })=>{
        const defaultPromptText = 'Remix the selected content';
        const selectedDisplayName = dynamicUiSubtype ? (0, $loej8.getSubTypeDisplayName)(dynamicUiSubtype) : (0, $loej8.getTypeDisplayName)(dynamicUiType);
        const autoText = `Remix the selected content as a ${selectedDisplayName}`;
        let promptText;
        if (promptTextOverride) promptText = promptTextOverride;
        else if (dynamicUiType === 'custom') promptText = userPrompt ?? defaultPromptText;
        else promptText = userPrompt ? `${autoText}. ${userPrompt}` : autoText;
        // Build the ADF DocNode prompt.
        const prompt = {
            type: 'doc',
            version: 1,
            content: [
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: promptText
                        }
                    ]
                }
            ]
        };
        const newConversationId = reuseConversationId ?? (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
        outerCancellationIntentRef.current = remixCancellationSessionId ? {
            sessionId: remixCancellationSessionId,
            conversationId: newConversationId,
            scope: 'outer-lifecycle'
        } : undefined;
        // Store the ID so we can identify this conversation as the active remix.
        setRemixConversationId(newConversationId);
        actionReadyFired.current = false;
        if (reuseConversationId && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'variant2')) setSelectedConversation({
            conversationId: reuseConversationId
        });
        await createConversationOptimistically({
            id: newConversationId,
            ...shouldTrackRemixConversationById ? {
                isViewModeRemix: true
            } : {}
        });
        if (remixCancellationSessionId) // A reused Rovo conversation can still expose its previous generation's terminal
        // state. Activate only this admitted session after optimistic reset completes.
        (0, $hwgBi.activateRemixCancellationObservation)({
            conversationId: newConversationId,
            sessionId: remixCancellationSessionId
        });
        let creationContextExperienceParams = {};
        if (!additionalCreationContextParams) {
            if (dynamicUiType === 'custom') creationContextExperienceParams = {
                experience: 'remix_custom'
            };
            else creationContextExperienceParams = {
                experience: 'remix',
                blocks: [
                    dynamicUiType
                ]
            };
        }
        // Send the message to Rovo
        sendMessage({
            prompt: prompt,
            storeUserMessages: preferences.storeUserMessages,
            conversationId: newConversationId,
            messageSources: {
                interactionSource: interactionSource,
                // Use the same source for follow-ups: Remix doesn't have a separate follow-up entry point, but the "viewed" AIMAU analytics event uses `followUpSource`.
                followUpSource: interactionSource
            },
            productKey: 'confluence',
            contentContext: 'staging-area',
            creationContextParams: {
                dynamicUiType: dynamicUiType,
                dynamicUiSubtype: dynamicUiSubtype,
                dynamicUiSource: dynamicUiSource,
                source: 'remix',
                ...creationContextExperienceParams,
                ...forcedContentType ? {
                    forcedContentType: forcedContentType
                } : {},
                ...additionalCreationContextParams,
                ...dynamicUiType !== 'custom' && userPrompt ? {
                    hasUserInstruction: true
                } : {}
            }
        });
        // Store the prompt text for display in the staging area header.
        // Always show the brand keyword regardless of the user's custom prompt.
        // cc_maui_create_keyword: swap "Remix" -> "Create". Use the no-exposure variant since the
        // create-keyword exposure has already fired upstream when the remix flow was triggered.
        setPrompt((0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc_maui_create_keyword', 'isEnabled', true) ? 'Create' : 'Remix');
        // Persist the dynamic UI context so the update flow can use
        // the original type/source when sending remix adjustment messages
        setDynamicUiContext(dynamicUiType, dynamicUiSubtype, dynamicUiSource);
        // Keep the user's pick; setDynamicUiContext above gets overwritten with the
        // backend subtype on response, and EditWithRovoBar needs both to flag a mismatch.
        setUserSelectedDynamicUiSubtype(dynamicUiSubtype);
        setInteractionSource(interactionSource);
        return newConversationId;
    }, [
        createConversationOptimistically,
        sendMessage,
        setPrompt,
        setDynamicUiContext,
        setUserSelectedDynamicUiSubtype,
        setInteractionSource,
        setSelectedConversation,
        preferences.storeUserMessages,
        shouldTrackRemixConversationById
    ]);
    return {
        sendAIFCPrompt: sendAIFCPrompt,
        stopRemixing: stopRemixing,
        isRemixError: isRemixError,
        isRemixAborted: isRemixAborted,
        isRemixCancelled: isRemixCancelled,
        remixStoreError: remixStoreError,
        openAIFCStagingModal: openAIFCStagingModal,
        closeAIFCStagingModal: closeModal,
        remixConversationId: remixConversationId,
        resetRemixConversationId: resetRemixConversationId,
        setSelectedConversation: setSelectedConversation
    };
};
module.exports["useRemixToAIFC"] = $1e31de274ed01603$export$cca9e2432f59b3f8;

});

parcelRegister("ew8wg", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $duklN = parcelRequire("duklN");


var $cozmU = parcelRequire("cozmU");


var $1uFM6 = parcelRequire("1uFM6");


var $95rLf = parcelRequire("95rLf");


var $7Sm4c = parcelRequire("7Sm4c");


var $jMyy4 = parcelRequire("jMyy4");

const $df587a746afa9e84$export$4882d379d640c470 = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { contentId: contentId } = t0;
    let t1;
    if ($[0] !== contentId) {
        t1 = {
            variables: {
                contentId: contentId
            }
        };
        $[0] = contentId;
        $[1] = t1;
    } else t1 = $[1];
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)((0, $duklN.default), {
        ...t1,
        __callerPackage__: "content-title"
    });
    let t2;
    let t3;
    if ($[2] !== error) {
        t2 = ()=>{
            if (error && ((0, $1uFM6.isUnauthorizedError)(error) || (0, $95rLf.isExpectedApolloError)(error))) (0, $7Sm4c.markErrorAsHandled)(error);
        };
        t3 = [
            error
        ];
        $[2] = error;
        $[3] = t2;
        $[4] = t3;
    } else {
        t2 = $[3];
        t3 = $[4];
    }
    (0, $cozmU.useEffect)(t2, t3);
    const t4 = data?.singleContent?.title;
    let t5;
    if ($[5] !== error || $[6] !== t4) {
        t5 = {
            title: t4,
            error: error
        };
        $[5] = error;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    return t5;
};
module.exports["usePageTitle"] = $df587a746afa9e84$export$4882d379d640c470;

});

parcelRegister("13PMQ", function(module, exports) {
// DEFLATE is a complex format; to read this code, you should probably check the RFC first:
// https://tools.ietf.org/html/rfc1951
// You may also wish to take a look at the guide I made about this program:
// https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
// Some of the following code is similar to that of UZIP.js:
// https://github.com/photopea/UZIP.js
// However, the vast majority of the codebase has diverged from UZIP.js to increase performance and reduce bundle size.
// Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
// is better for memory in most engines (I *think*).
var $0c5e3e04f495ba65$var$ch2 = {};
var $0c5e3e04f495ba65$var$wk = function(c, id, msg, transfer, cb) {
    var w = new Worker($0c5e3e04f495ba65$var$ch2[id] || ($0c5e3e04f495ba65$var$ch2[id] = URL.createObjectURL(new Blob([
        c + ';addEventListener("error",function(e){e=e.error;postMessage({$e$:[e.message,e.code,e.stack]})})'
    ], {
        type: 'text/javascript'
    }))));
    w.onmessage = function(e) {
        var d = e.data, ed = d.$e$;
        if (ed) {
            var err = new Error(ed[0]);
            err['code'] = ed[1];
            err.stack = ed[2];
            cb(err, null);
        } else cb(null, d);
    };
    w.postMessage(msg, transfer);
    return w;
};
// aliases for shorter compressed code (most minifers don't do this)
var $0c5e3e04f495ba65$var$u8 = Uint8Array, $0c5e3e04f495ba65$var$u16 = Uint16Array, $0c5e3e04f495ba65$var$i32 = Int32Array;
// fixed length extra bits
var $0c5e3e04f495ba65$var$fleb = new $0c5e3e04f495ba65$var$u8([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    /* unused */ 0,
    0,
    /* impossible */ 0
]);
// fixed distance extra bits
var $0c5e3e04f495ba65$var$fdeb = new $0c5e3e04f495ba65$var$u8([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    /* unused */ 0,
    0
]);
// code length index map
var $0c5e3e04f495ba65$var$clim = new $0c5e3e04f495ba65$var$u8([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// get base, reverse index map from extra bits
var $0c5e3e04f495ba65$var$freb = function(eb, start) {
    var b = new $0c5e3e04f495ba65$var$u16(31);
    for(var i = 0; i < 31; ++i)b[i] = start += 1 << eb[i - 1];
    // numbers here are at max 18 bits
    var r = new $0c5e3e04f495ba65$var$i32(b[30]);
    for(var i = 1; i < 30; ++i)for(var j = b[i]; j < b[i + 1]; ++j)r[j] = j - b[i] << 5 | i;
    return {
        b: b,
        r: r
    };
};
var $0c5e3e04f495ba65$var$_a = $0c5e3e04f495ba65$var$freb($0c5e3e04f495ba65$var$fleb, 2), $0c5e3e04f495ba65$var$fl = $0c5e3e04f495ba65$var$_a.b, $0c5e3e04f495ba65$var$revfl = $0c5e3e04f495ba65$var$_a.r;
// we can ignore the fact that the other numbers are wrong; they never happen anyway
$0c5e3e04f495ba65$var$fl[28] = 258, $0c5e3e04f495ba65$var$revfl[258] = 28;
var $0c5e3e04f495ba65$var$_b = $0c5e3e04f495ba65$var$freb($0c5e3e04f495ba65$var$fdeb, 0), $0c5e3e04f495ba65$var$fd = $0c5e3e04f495ba65$var$_b.b, $0c5e3e04f495ba65$var$revfd = $0c5e3e04f495ba65$var$_b.r;
// map of value to reverse (assuming 16 bits)
var $0c5e3e04f495ba65$var$rev = new $0c5e3e04f495ba65$var$u16(32768);
for(var $0c5e3e04f495ba65$var$i = 0; $0c5e3e04f495ba65$var$i < 32768; ++$0c5e3e04f495ba65$var$i){
    // reverse table algorithm from SO
    var $0c5e3e04f495ba65$var$x = ($0c5e3e04f495ba65$var$i & 0xAAAA) >> 1 | ($0c5e3e04f495ba65$var$i & 0x5555) << 1;
    $0c5e3e04f495ba65$var$x = ($0c5e3e04f495ba65$var$x & 0xCCCC) >> 2 | ($0c5e3e04f495ba65$var$x & 0x3333) << 2;
    $0c5e3e04f495ba65$var$x = ($0c5e3e04f495ba65$var$x & 0xF0F0) >> 4 | ($0c5e3e04f495ba65$var$x & 0x0F0F) << 4;
    $0c5e3e04f495ba65$var$rev[$0c5e3e04f495ba65$var$i] = (($0c5e3e04f495ba65$var$x & 0xFF00) >> 8 | ($0c5e3e04f495ba65$var$x & 0x00FF) << 8) >> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var $0c5e3e04f495ba65$var$hMap = function(cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new $0c5e3e04f495ba65$var$u16(mb);
    // length of cd must be 288 (total # of codes)
    for(; i < s; ++i)if (cd[i]) ++l[cd[i] - 1];
    // u16 "map": index -> minimum code for bit length = index
    var le = new $0c5e3e04f495ba65$var$u16(mb);
    for(i = 1; i < mb; ++i)le[i] = le[i - 1] + l[i - 1] << 1;
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new $0c5e3e04f495ba65$var$u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for(i = 0; i < s; ++i)// ignore 0 lengths
        if (cd[i]) {
            // num encoding both symbol and bits read
            var sv = i << 4 | cd[i];
            // free bits
            var r_1 = mb - cd[i];
            // start value
            var v = le[cd[i] - 1]++ << r_1;
            // m is end value
            for(var m = v | (1 << r_1) - 1; v <= m; ++v)// every 16 bit value starting with the code yields the same result
            co[$0c5e3e04f495ba65$var$rev[v] >> rvb] = sv;
        }
    } else {
        co = new $0c5e3e04f495ba65$var$u16(s);
        for(i = 0; i < s; ++i)if (cd[i]) co[i] = $0c5e3e04f495ba65$var$rev[le[cd[i] - 1]++] >> 15 - cd[i];
    }
    return co;
};
// fixed length tree
var $0c5e3e04f495ba65$var$flt = new $0c5e3e04f495ba65$var$u8(288);
for(var $0c5e3e04f495ba65$var$i = 0; $0c5e3e04f495ba65$var$i < 144; ++$0c5e3e04f495ba65$var$i)$0c5e3e04f495ba65$var$flt[$0c5e3e04f495ba65$var$i] = 8;
for(var $0c5e3e04f495ba65$var$i = 144; $0c5e3e04f495ba65$var$i < 256; ++$0c5e3e04f495ba65$var$i)$0c5e3e04f495ba65$var$flt[$0c5e3e04f495ba65$var$i] = 9;
for(var $0c5e3e04f495ba65$var$i = 256; $0c5e3e04f495ba65$var$i < 280; ++$0c5e3e04f495ba65$var$i)$0c5e3e04f495ba65$var$flt[$0c5e3e04f495ba65$var$i] = 7;
for(var $0c5e3e04f495ba65$var$i = 280; $0c5e3e04f495ba65$var$i < 288; ++$0c5e3e04f495ba65$var$i)$0c5e3e04f495ba65$var$flt[$0c5e3e04f495ba65$var$i] = 8;
// fixed distance tree
var $0c5e3e04f495ba65$var$fdt = new $0c5e3e04f495ba65$var$u8(32);
for(var $0c5e3e04f495ba65$var$i = 0; $0c5e3e04f495ba65$var$i < 32; ++$0c5e3e04f495ba65$var$i)$0c5e3e04f495ba65$var$fdt[$0c5e3e04f495ba65$var$i] = 5;
// fixed length map
var $0c5e3e04f495ba65$var$flm = /*#__PURE__*/ $0c5e3e04f495ba65$var$hMap($0c5e3e04f495ba65$var$flt, 9, 0), $0c5e3e04f495ba65$var$flrm = /*#__PURE__*/ $0c5e3e04f495ba65$var$hMap($0c5e3e04f495ba65$var$flt, 9, 1);
// fixed distance map
var $0c5e3e04f495ba65$var$fdm = /*#__PURE__*/ $0c5e3e04f495ba65$var$hMap($0c5e3e04f495ba65$var$fdt, 5, 0), $0c5e3e04f495ba65$var$fdrm = /*#__PURE__*/ $0c5e3e04f495ba65$var$hMap($0c5e3e04f495ba65$var$fdt, 5, 1);
// find max of array
var $0c5e3e04f495ba65$var$max = function(a) {
    var m = a[0];
    for(var i = 1; i < a.length; ++i)if (a[i] > m) m = a[i];
    return m;
};
// read d, starting at bit p and mask with m
var $0c5e3e04f495ba65$var$bits = function(d, p, m) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8) >> (p & 7) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var $0c5e3e04f495ba65$var$bits16 = function(d, p) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >> (p & 7);
};
// get end of byte
var $0c5e3e04f495ba65$var$shft = function(p) {
    return (p + 7) / 8 | 0;
};
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var $0c5e3e04f495ba65$var$slc = function(v, s, e) {
    if (s == null || s < 0) s = 0;
    if (e == null || e > v.length) e = v.length;
    // can't use .constructor in case user-supplied
    return new $0c5e3e04f495ba65$var$u8(v.subarray(s, e));
};
var $0c5e3e04f495ba65$export$ae5516a5a74c19a8 = {
    UnexpectedEOF: 0,
    InvalidBlockType: 1,
    InvalidLengthLiteral: 2,
    InvalidDistance: 3,
    StreamFinished: 4,
    NoStreamHandler: 5,
    InvalidHeader: 6,
    NoCallback: 7,
    InvalidUTF8: 8,
    ExtraFieldTooLong: 9,
    InvalidDate: 10,
    FilenameTooLong: 11,
    StreamFinishing: 12,
    InvalidZipData: 13,
    UnknownCompressionMethod: 14
};
// error codes
var $0c5e3e04f495ba65$var$ec = [
    'unexpected EOF',
    'invalid block type',
    'invalid length/literal',
    'invalid distance',
    'stream finished',
    'no stream handler',
    ,
    'no callback',
    'invalid UTF-8 data',
    'extra field too long',
    'date not in range 1980-2099',
    'filename too long',
    'stream finishing',
    'invalid zip data'
];
var $0c5e3e04f495ba65$var$err = function(ind, msg, nt) {
    var e = new Error(msg || $0c5e3e04f495ba65$var$ec[ind]);
    e.code = ind;
    if (Error.captureStackTrace) Error.captureStackTrace(e, $0c5e3e04f495ba65$var$err);
    if (!nt) throw e;
    return e;
};
// expands raw DEFLATE data
var $0c5e3e04f495ba65$var$inflt = function(dat, st, buf, dict) {
    // source length       dict length
    var sl = dat.length, dl = dict ? dict.length : 0;
    if (!sl || st.f && !st.l) return buf || new $0c5e3e04f495ba65$var$u8(0);
    var noBuf = !buf;
    // have to estimate size
    var resize = noBuf || st.i != 2;
    // no state
    var noSt = st.i;
    // Assumes roughly 33% compression ratio average
    if (noBuf) buf = new $0c5e3e04f495ba65$var$u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function(l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new $0c5e3e04f495ba65$var$u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            final = $0c5e3e04f495ba65$var$bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = $0c5e3e04f495ba65$var$bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = $0c5e3e04f495ba65$var$shft(pos) + 4, l = dat[s - 4] | dat[s - 3] << 8, t = s + l;
                if (t > sl) {
                    if (noSt) $0c5e3e04f495ba65$var$err(0);
                    break;
                }
                // ensure size
                if (resize) cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8, st.f = final;
                continue;
            } else if (type == 1) lm = $0c5e3e04f495ba65$var$flrm, dm = $0c5e3e04f495ba65$var$fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = $0c5e3e04f495ba65$var$bits(dat, pos, 31) + 257, hcLen = $0c5e3e04f495ba65$var$bits(dat, pos + 10, 15) + 4;
                var tl = hLit + $0c5e3e04f495ba65$var$bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new $0c5e3e04f495ba65$var$u8(tl);
                // code length tree
                var clt = new $0c5e3e04f495ba65$var$u8(19);
                for(var i = 0; i < hcLen; ++i)// use index map to get real code
                clt[$0c5e3e04f495ba65$var$clim[i]] = $0c5e3e04f495ba65$var$bits(dat, pos + i * 3, 7);
                pos += hcLen * 3;
                // code lengths bits
                var clb = $0c5e3e04f495ba65$var$max(clt), clbmsk = (1 << clb) - 1;
                // code lengths map
                var clm = $0c5e3e04f495ba65$var$hMap(clt, clb, 1);
                for(var i = 0; i < tl;){
                    var r = clm[$0c5e3e04f495ba65$var$bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >> 4;
                    // code length to copy
                    if (s < 16) ldt[i++] = s;
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s == 16) n = 3 + $0c5e3e04f495ba65$var$bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17) n = 3 + $0c5e3e04f495ba65$var$bits(dat, pos, 7), pos += 3;
                        else if (s == 18) n = 11 + $0c5e3e04f495ba65$var$bits(dat, pos, 127), pos += 7;
                        while(n--)ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = $0c5e3e04f495ba65$var$max(lt);
                // max dist bits
                dbt = $0c5e3e04f495ba65$var$max(dt);
                lm = $0c5e3e04f495ba65$var$hMap(lt, lbt, 1);
                dm = $0c5e3e04f495ba65$var$hMap(dt, dbt, 1);
            } else $0c5e3e04f495ba65$var$err(1);
            if (pos > tbts) {
                if (noSt) $0c5e3e04f495ba65$var$err(0);
                break;
            }
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17
        if (resize) cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var lpos = pos;
        for(;; lpos = pos){
            // bits read, code
            var c = lm[$0c5e3e04f495ba65$var$bits16(dat, pos) & lms], sym = c >> 4;
            pos += c & 15;
            if (pos > tbts) {
                if (noSt) $0c5e3e04f495ba65$var$err(0);
                break;
            }
            if (!c) $0c5e3e04f495ba65$var$err(2);
            if (sym < 256) buf[bt++] = sym;
            else if (sym == 256) {
                lpos = pos, lm = null;
                break;
            } else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257, b = $0c5e3e04f495ba65$var$fleb[i];
                    add = $0c5e3e04f495ba65$var$bits(dat, pos, (1 << b) - 1) + $0c5e3e04f495ba65$var$fl[i];
                    pos += b;
                }
                // dist
                var d = dm[$0c5e3e04f495ba65$var$bits16(dat, pos) & dms], dsym = d >> 4;
                if (!d) $0c5e3e04f495ba65$var$err(3);
                pos += d & 15;
                var dt = $0c5e3e04f495ba65$var$fd[dsym];
                if (dsym > 3) {
                    var b = $0c5e3e04f495ba65$var$fdeb[dsym];
                    dt += $0c5e3e04f495ba65$var$bits16(dat, pos) & (1 << b) - 1, pos += b;
                }
                if (pos > tbts) {
                    if (noSt) $0c5e3e04f495ba65$var$err(0);
                    break;
                }
                if (resize) cbuf(bt + 131072);
                var end = bt + add;
                if (bt < dt) {
                    var shift = dl - dt, dend = Math.min(dt, end);
                    if (shift + bt < 0) $0c5e3e04f495ba65$var$err(3);
                    for(; bt < dend; ++bt)buf[bt] = dict[shift + bt];
                }
                for(; bt < end; ++bt)buf[bt] = buf[bt - dt];
            }
        }
        st.l = lm, st.p = lpos, st.b = bt, st.f = final;
        if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    }while (!final);
    // don't reallocate for streams or user buffers
    return bt != buf.length && noBuf ? $0c5e3e04f495ba65$var$slc(buf, 0, bt) : buf.subarray(0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var $0c5e3e04f495ba65$var$wbits = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var $0c5e3e04f495ba65$var$wbits16 = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
    d[o + 2] |= v >> 16;
};
// creates code lengths from a frequency table
var $0c5e3e04f495ba65$var$hTree = function(d, mb) {
    // Need extra info to make a tree
    var t = [];
    for(var i = 0; i < d.length; ++i)if (d[i]) t.push({
        s: i,
        f: d[i]
    });
    var s = t.length;
    var t2 = t.slice();
    if (!s) return {
        t: $0c5e3e04f495ba65$var$et,
        l: 0
    };
    if (s == 1) {
        var v = new $0c5e3e04f495ba65$var$u8(t[0].s + 1);
        v[t[0].s] = 1;
        return {
            t: v,
            l: 1
        };
    }
    t.sort(function(a, b) {
        return a.f - b.f;
    });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({
        s: -1,
        f: 25001
    });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = {
        s: -1,
        f: l.f + r.f,
        l: l,
        r: r
    };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while(i1 != s - 1){
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = {
            s: -1,
            f: l.f + r.f,
            l: l,
            r: r
        };
    }
    var maxSym = t2[0].s;
    for(var i = 1; i < s; ++i)if (t2[i].s > maxSym) maxSym = t2[i].s;
    // code lengths
    var tr = new $0c5e3e04f495ba65$var$u16(maxSym + 1);
    // max bits in tree
    var mbt = $0c5e3e04f495ba65$var$ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0, dt = 0;
        //    left            cost
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function(a, b) {
            return tr[b.s] - tr[a.s] || a.f - b.f;
        });
        for(; i < s; ++i){
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << mbt - tr[i2_1]);
                tr[i2_1] = mb;
            } else break;
        }
        dt >>= lft;
        while(dt > 0){
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;
            else ++i;
        }
        for(; i >= 0 && dt; --i){
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return {
        t: new $0c5e3e04f495ba65$var$u8(tr),
        l: mbt
    };
};
// get the max length and assign length codes
var $0c5e3e04f495ba65$var$ln = function(n, l, d) {
    return n.s == -1 ? Math.max($0c5e3e04f495ba65$var$ln(n.l, l, d + 1), $0c5e3e04f495ba65$var$ln(n.r, l, d + 1)) : l[n.s] = d;
};
// length codes generation
var $0c5e3e04f495ba65$var$lc = function(c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while(s && !c[--s]);
    var cl = new $0c5e3e04f495ba65$var$u16(++s);
    //  ind      num         streak
    var cli = 0, cln = c[0], cls = 1;
    var w = function(v) {
        cl[cli++] = v;
    };
    for(var i = 1; i <= s; ++i)if (c[i] == cln && i != s) ++cls;
    else {
        if (!cln && cls > 2) {
            for(; cls > 138; cls -= 138)w(32754);
            if (cls > 2) {
                w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
                cls = 0;
            }
        } else if (cls > 3) {
            w(cln), --cls;
            for(; cls > 6; cls -= 6)w(8304);
            if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
        }
        while(cls--)w(cln);
        cls = 1;
        cln = c[i];
    }
    return {
        c: cl.subarray(0, cli),
        n: s
    };
};
// calculate the length of output from tree, code lengths
var $0c5e3e04f495ba65$var$clen = function(cf, cl) {
    var l = 0;
    for(var i = 0; i < cl.length; ++i)l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var $0c5e3e04f495ba65$var$wfblk = function(out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = $0c5e3e04f495ba65$var$shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for(var i = 0; i < s; ++i)out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var $0c5e3e04f495ba65$var$wblk = function(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    $0c5e3e04f495ba65$var$wbits(out, p++, final);
    ++lf[256];
    var _a = $0c5e3e04f495ba65$var$hTree(lf, 15), dlt = _a.t, mlb = _a.l;
    var _b = $0c5e3e04f495ba65$var$hTree(df, 15), ddt = _b.t, mdb = _b.l;
    var _c = $0c5e3e04f495ba65$var$lc(dlt), lclt = _c.c, nlc = _c.n;
    var _d = $0c5e3e04f495ba65$var$lc(ddt), lcdt = _d.c, ndc = _d.n;
    var lcfreq = new $0c5e3e04f495ba65$var$u16(19);
    for(var i = 0; i < lclt.length; ++i)++lcfreq[lclt[i] & 31];
    for(var i = 0; i < lcdt.length; ++i)++lcfreq[lcdt[i] & 31];
    var _e = $0c5e3e04f495ba65$var$hTree(lcfreq, 7), lct = _e.t, mlcb = _e.l;
    var nlcc = 19;
    for(; nlcc > 4 && !lct[$0c5e3e04f495ba65$var$clim[nlcc - 1]]; --nlcc);
    var flen = bl + 5 << 3;
    var ftlen = $0c5e3e04f495ba65$var$clen(lf, $0c5e3e04f495ba65$var$flt) + $0c5e3e04f495ba65$var$clen(df, $0c5e3e04f495ba65$var$fdt) + eb;
    var dtlen = $0c5e3e04f495ba65$var$clen(lf, dlt) + $0c5e3e04f495ba65$var$clen(df, ddt) + eb + 14 + 3 * nlcc + $0c5e3e04f495ba65$var$clen(lcfreq, lct) + 2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18];
    if (bs >= 0 && flen <= ftlen && flen <= dtlen) return $0c5e3e04f495ba65$var$wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    $0c5e3e04f495ba65$var$wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = $0c5e3e04f495ba65$var$hMap(dlt, mlb, 0), ll = dlt, dm = $0c5e3e04f495ba65$var$hMap(ddt, mdb, 0), dl = ddt;
        var llm = $0c5e3e04f495ba65$var$hMap(lct, mlcb, 0);
        $0c5e3e04f495ba65$var$wbits(out, p, nlc - 257);
        $0c5e3e04f495ba65$var$wbits(out, p + 5, ndc - 1);
        $0c5e3e04f495ba65$var$wbits(out, p + 10, nlcc - 4);
        p += 14;
        for(var i = 0; i < nlcc; ++i)$0c5e3e04f495ba65$var$wbits(out, p + 3 * i, lct[$0c5e3e04f495ba65$var$clim[i]]);
        p += 3 * nlcc;
        var lcts = [
            lclt,
            lcdt
        ];
        for(var it = 0; it < 2; ++it){
            var clct = lcts[it];
            for(var i = 0; i < clct.length; ++i){
                var len = clct[i] & 31;
                $0c5e3e04f495ba65$var$wbits(out, p, llm[len]), p += lct[len];
                if (len > 15) $0c5e3e04f495ba65$var$wbits(out, p, clct[i] >> 5 & 127), p += clct[i] >> 12;
            }
        }
    } else lm = $0c5e3e04f495ba65$var$flm, ll = $0c5e3e04f495ba65$var$flt, dm = $0c5e3e04f495ba65$var$fdm, dl = $0c5e3e04f495ba65$var$fdt;
    for(var i = 0; i < li; ++i){
        var sym = syms[i];
        if (sym > 255) {
            var len = sym >> 18 & 31;
            $0c5e3e04f495ba65$var$wbits16(out, p, lm[len + 257]), p += ll[len + 257];
            if (len > 7) $0c5e3e04f495ba65$var$wbits(out, p, sym >> 23 & 31), p += $0c5e3e04f495ba65$var$fleb[len];
            var dst = sym & 31;
            $0c5e3e04f495ba65$var$wbits16(out, p, dm[dst]), p += dl[dst];
            if (dst > 3) $0c5e3e04f495ba65$var$wbits16(out, p, sym >> 5 & 8191), p += $0c5e3e04f495ba65$var$fdeb[dst];
        } else $0c5e3e04f495ba65$var$wbits16(out, p, lm[sym]), p += ll[sym];
    }
    $0c5e3e04f495ba65$var$wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var $0c5e3e04f495ba65$var$deo = /*#__PURE__*/ new $0c5e3e04f495ba65$var$i32([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]);
// empty
var $0c5e3e04f495ba65$var$et = /*#__PURE__*/ new $0c5e3e04f495ba65$var$u8(0);
// compresses data into a raw DEFLATE buffer
var $0c5e3e04f495ba65$var$dflt = function(dat, lvl, plvl, pre, post, st) {
    var s = st.z || dat.length;
    var o = new $0c5e3e04f495ba65$var$u8(pre + s + 5 * (1 + Math.ceil(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var lst = st.l;
    var pos = (st.r || 0) & 7;
    if (lvl) {
        if (pos) w[0] = st.r >> 3;
        var opt = $0c5e3e04f495ba65$var$deo[lvl - 1];
        var n = opt >> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = st.p || new $0c5e3e04f495ba65$var$u16(32768), head = st.h || new $0c5e3e04f495ba65$var$u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function(i) {
            return (dat[i] ^ dat[i + 1] << bs1_1 ^ dat[i + 2] << bs2_1) & msk_1;
        };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new $0c5e3e04f495ba65$var$i32(25000);
        // length/literal freq   distance freq
        var lf = new $0c5e3e04f495ba65$var$u16(288), df = new $0c5e3e04f495ba65$var$u16(32);
        //  l/lcnt  exbits  index          l/lind  waitdx          blkpos
        var lc_1 = 0, eb = 0, i = st.i || 0, li = 0, wi = st.w || 0, bs = 0;
        for(; i + 2 < s; ++i){
            // hash value
            var hv = hsh(i);
            // index mod 32768    previous index mod
            var imod = i & 32767, pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && (rem > 423 || !lst)) {
                    pos = $0c5e3e04f495ba65$var$wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for(var j = 0; j < 286; ++j)lf[j] = 0;
                    for(var j = 0; j < 30; ++j)df[j] = 0;
                }
                //  len    dist   chain
                var l = 2, d = 0, ch_1 = c, dif = imod - pimod & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while(dif <= maxd && --ch_1 && imod != pimod){
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for(; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl);
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn) break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for(var j = 0; j < mmd; ++j){
                                    var ti = i - dif + j & 32767;
                                    var pti = prev[ti];
                                    var cd = ti - pti & 32767;
                                    if (cd > md) md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += imod - pimod & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one int32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | $0c5e3e04f495ba65$var$revfl[l] << 18 | $0c5e3e04f495ba65$var$revfd[d];
                    var lin = $0c5e3e04f495ba65$var$revfl[l] & 31, din = $0c5e3e04f495ba65$var$revfd[d] & 31;
                    eb += $0c5e3e04f495ba65$var$fleb[lin] + $0c5e3e04f495ba65$var$fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                } else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        for(i = Math.max(i, wi); i < s; ++i){
            syms[li++] = dat[i];
            ++lf[dat[i]];
        }
        pos = $0c5e3e04f495ba65$var$wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        if (!lst) {
            st.r = pos & 7 | w[pos / 8 | 0] << 3;
            // shft(pos) now 1 less if pos & 7 != 0
            pos -= 7;
            st.h = head, st.p = prev, st.i = i, st.w = wi;
        }
    } else {
        for(var i = st.w || 0; i < s + lst; i += 65535){
            // end
            var e = i + 65535;
            if (e >= s) {
                // write final block
                w[pos / 8 | 0] = lst;
                e = s;
            }
            pos = $0c5e3e04f495ba65$var$wfblk(w, pos + 1, dat.subarray(i, e));
        }
        st.i = s;
    }
    return $0c5e3e04f495ba65$var$slc(o, 0, pre + $0c5e3e04f495ba65$var$shft(pos) + post);
};
// CRC32 table
var $0c5e3e04f495ba65$var$crct = /*#__PURE__*/ function() {
    var t = new Int32Array(256);
    for(var i = 0; i < 256; ++i){
        var c = i, k = 9;
        while(--k)c = (c & 1 && -306674912) ^ c >>> 1;
        t[i] = c;
    }
    return t;
}();
// CRC32
var $0c5e3e04f495ba65$var$crc = function() {
    var c = -1;
    return {
        p: function(d) {
            // closures have awful performance
            var cr = c;
            for(var i = 0; i < d.length; ++i)cr = $0c5e3e04f495ba65$var$crct[cr & 255 ^ d[i]] ^ cr >>> 8;
            c = cr;
        },
        d: function() {
            return ~c;
        }
    };
};
// Adler32
var $0c5e3e04f495ba65$var$adler = function() {
    var a = 1, b = 0;
    return {
        p: function(d) {
            // closures have awful performance
            var n = a, m = b;
            var l = d.length | 0;
            for(var i = 0; i != l;){
                var e = Math.min(i + 2655, l);
                for(; i < e; ++i)m += n += d[i];
                n = (n & 65535) + 15 * (n >> 16), m = (m & 65535) + 15 * (m >> 16);
            }
            a = n, b = m;
        },
        d: function() {
            a %= 65521, b %= 65521;
            return (a & 255) << 24 | (a & 0xFF00) << 8 | (b & 255) << 8 | b >> 8;
        }
    };
};
// deflate with opts
var $0c5e3e04f495ba65$var$dopt = function(dat, opt, pre, post, st) {
    if (!st) {
        st = {
            l: 1
        };
        if (opt.dictionary) {
            var dict = opt.dictionary.subarray(-32768);
            var newDat = new $0c5e3e04f495ba65$var$u8(dict.length + dat.length);
            newDat.set(dict);
            newDat.set(dat, dict.length);
            dat = newDat;
            st.w = dict.length;
        }
    }
    return $0c5e3e04f495ba65$var$dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? st.l ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 20 : 12 + opt.mem, pre, post, st);
};
// Walmart object spread
var $0c5e3e04f495ba65$var$mrg = function(a, b) {
    var o = {};
    for(var k in a)o[k] = a[k];
    for(var k in b)o[k] = b[k];
    return o;
};
// worker clone
// This is possibly the craziest part of the entire codebase, despite how simple it may seem.
// The only parameter to this function is a closure that returns an array of variables outside of the function scope.
// We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
// We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
// The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
// This took me three weeks to figure out how to do.
var $0c5e3e04f495ba65$var$wcln = function(fn, fnStr, td) {
    var dt = fn();
    var st = fn.toString();
    var ks = st.slice(st.indexOf('[') + 1, st.lastIndexOf(']')).replace(/\s+/g, '').split(',');
    for(var i = 0; i < dt.length; ++i){
        var v = dt[i], k = ks[i];
        if (typeof v == 'function') {
            fnStr += ';' + k + '=';
            var st_1 = v.toString();
            if (v.prototype) {
                // for global objects
                if (st_1.indexOf('[native code]') != -1) {
                    var spInd = st_1.indexOf(' ', 8) + 1;
                    fnStr += st_1.slice(spInd, st_1.indexOf('(', spInd));
                } else {
                    fnStr += st_1;
                    for(var t in v.prototype)fnStr += ';' + k + '.prototype.' + t + '=' + v.prototype[t].toString();
                }
            } else fnStr += st_1;
        } else td[k] = v;
    }
    return fnStr;
};
var $0c5e3e04f495ba65$var$ch = [];
// clone bufs
var $0c5e3e04f495ba65$var$cbfs = function(v) {
    var tl = [];
    for(var k in v)if (v[k].buffer) tl.push((v[k] = new v[k].constructor(v[k])).buffer);
    return tl;
};
// use a worker to execute code
var $0c5e3e04f495ba65$var$wrkr = function(fns, init, id, cb) {
    if (!$0c5e3e04f495ba65$var$ch[id]) {
        var fnStr = '', td_1 = {}, m = fns.length - 1;
        for(var i = 0; i < m; ++i)fnStr = $0c5e3e04f495ba65$var$wcln(fns[i], fnStr, td_1);
        $0c5e3e04f495ba65$var$ch[id] = {
            c: $0c5e3e04f495ba65$var$wcln(fns[m], fnStr, td_1),
            e: td_1
        };
    }
    var td = $0c5e3e04f495ba65$var$mrg({}, $0c5e3e04f495ba65$var$ch[id].e);
    return $0c5e3e04f495ba65$var$wk($0c5e3e04f495ba65$var$ch[id].c + ';onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=' + init.toString() + '}', id, td, $0c5e3e04f495ba65$var$cbfs(td), cb);
};
// base async inflate fn
var $0c5e3e04f495ba65$var$bInflt = function() {
    return [
        $0c5e3e04f495ba65$var$u8,
        $0c5e3e04f495ba65$var$u16,
        $0c5e3e04f495ba65$var$i32,
        $0c5e3e04f495ba65$var$fleb,
        $0c5e3e04f495ba65$var$fdeb,
        $0c5e3e04f495ba65$var$clim,
        $0c5e3e04f495ba65$var$fl,
        $0c5e3e04f495ba65$var$fd,
        $0c5e3e04f495ba65$var$flrm,
        $0c5e3e04f495ba65$var$fdrm,
        $0c5e3e04f495ba65$var$rev,
        $0c5e3e04f495ba65$var$ec,
        $0c5e3e04f495ba65$var$hMap,
        $0c5e3e04f495ba65$var$max,
        $0c5e3e04f495ba65$var$bits,
        $0c5e3e04f495ba65$var$bits16,
        $0c5e3e04f495ba65$var$shft,
        $0c5e3e04f495ba65$var$slc,
        $0c5e3e04f495ba65$var$err,
        $0c5e3e04f495ba65$var$inflt,
        $0c5e3e04f495ba65$export$90366d8b308ba94a,
        $0c5e3e04f495ba65$var$pbf,
        $0c5e3e04f495ba65$var$gopt
    ];
};
var $0c5e3e04f495ba65$var$bDflt = function() {
    return [
        $0c5e3e04f495ba65$var$u8,
        $0c5e3e04f495ba65$var$u16,
        $0c5e3e04f495ba65$var$i32,
        $0c5e3e04f495ba65$var$fleb,
        $0c5e3e04f495ba65$var$fdeb,
        $0c5e3e04f495ba65$var$clim,
        $0c5e3e04f495ba65$var$revfl,
        $0c5e3e04f495ba65$var$revfd,
        $0c5e3e04f495ba65$var$flm,
        $0c5e3e04f495ba65$var$flt,
        $0c5e3e04f495ba65$var$fdm,
        $0c5e3e04f495ba65$var$fdt,
        $0c5e3e04f495ba65$var$rev,
        $0c5e3e04f495ba65$var$deo,
        $0c5e3e04f495ba65$var$et,
        $0c5e3e04f495ba65$var$hMap,
        $0c5e3e04f495ba65$var$wbits,
        $0c5e3e04f495ba65$var$wbits16,
        $0c5e3e04f495ba65$var$hTree,
        $0c5e3e04f495ba65$var$ln,
        $0c5e3e04f495ba65$var$lc,
        $0c5e3e04f495ba65$var$clen,
        $0c5e3e04f495ba65$var$wfblk,
        $0c5e3e04f495ba65$var$wblk,
        $0c5e3e04f495ba65$var$shft,
        $0c5e3e04f495ba65$var$slc,
        $0c5e3e04f495ba65$var$dflt,
        $0c5e3e04f495ba65$var$dopt,
        $0c5e3e04f495ba65$export$21533ff51b8a0b4a,
        $0c5e3e04f495ba65$var$pbf
    ];
};
// gzip extra
var $0c5e3e04f495ba65$var$gze = function() {
    return [
        $0c5e3e04f495ba65$var$gzh,
        $0c5e3e04f495ba65$var$gzhl,
        $0c5e3e04f495ba65$var$wbytes,
        $0c5e3e04f495ba65$var$crc,
        $0c5e3e04f495ba65$var$crct
    ];
};
// gunzip extra
var $0c5e3e04f495ba65$var$guze = function() {
    return [
        $0c5e3e04f495ba65$var$gzs,
        $0c5e3e04f495ba65$var$gzl
    ];
};
// zlib extra
var $0c5e3e04f495ba65$var$zle = function() {
    return [
        $0c5e3e04f495ba65$var$zlh,
        $0c5e3e04f495ba65$var$wbytes,
        $0c5e3e04f495ba65$var$adler
    ];
};
// unzlib extra
var $0c5e3e04f495ba65$var$zule = function() {
    return [
        $0c5e3e04f495ba65$var$zls
    ];
};
// post buf
var $0c5e3e04f495ba65$var$pbf = function(msg) {
    return postMessage(msg, [
        msg.buffer
    ]);
};
// get opts
var $0c5e3e04f495ba65$var$gopt = function(o) {
    return o && {
        out: o.size && new $0c5e3e04f495ba65$var$u8(o.size),
        dictionary: o.dictionary
    };
};
// async helper
var $0c5e3e04f495ba65$var$cbify = function(dat, opts, fns, init, id, cb) {
    var w = $0c5e3e04f495ba65$var$wrkr(fns, init, id, function(err, dat) {
        w.terminate();
        cb(err, dat);
    });
    w.postMessage([
        dat,
        opts
    ], opts.consume ? [
        dat.buffer
    ] : []);
    return function() {
        w.terminate();
    };
};
// auto stream
var $0c5e3e04f495ba65$var$astrm = function(strm) {
    strm.ondata = function(dat, final) {
        return postMessage([
            dat,
            final
        ], [
            dat.buffer
        ]);
    };
    return function(ev) {
        if (ev.data[0]) {
            strm.push(ev.data[0], ev.data[1]);
            postMessage([
                ev.data[0].length
            ]);
        } else strm.flush(ev.data[1]);
    };
};
// async stream attach
var $0c5e3e04f495ba65$var$astrmify = function(fns, strm, opts, init, id, flush, ext) {
    var t;
    var w = $0c5e3e04f495ba65$var$wrkr(fns, init, id, function(err, dat) {
        if (err) w.terminate(), strm.ondata.call(strm, err);
        else if (!Array.isArray(dat)) ext(dat);
        else if (dat.length == 1) {
            strm.queuedSize -= dat[0];
            if (strm.ondrain) strm.ondrain(dat[0]);
        } else {
            if (dat[1]) w.terminate();
            strm.ondata.call(strm, err, dat[0], dat[1]);
        }
    });
    w.postMessage(opts);
    strm.queuedSize = 0;
    strm.push = function(d, f) {
        if (!strm.ondata) $0c5e3e04f495ba65$var$err(5);
        if (t) strm.ondata($0c5e3e04f495ba65$var$err(4, 0, 1), null, !!f);
        strm.queuedSize += d.length;
        // can fail for cross-realm Uint8Array, but ok - only a small performance penalty
        w.postMessage([
            d,
            t = f
        ], d.buffer instanceof ArrayBuffer ? [
            d.buffer
        ] : []);
    };
    strm.terminate = function() {
        w.terminate();
    };
    if (flush) strm.flush = function(sync) {
        w.postMessage([
            0,
            sync
        ]);
    };
};
// read 2 bytes
var $0c5e3e04f495ba65$var$b2 = function(d, b) {
    return d[b] | d[b + 1] << 8;
};
// read 4 bytes
var $0c5e3e04f495ba65$var$b4 = function(d, b) {
    return (d[b] | d[b + 1] << 8 | d[b + 2] << 16 | d[b + 3] << 24) >>> 0;
};
// read 8 bytes
var $0c5e3e04f495ba65$var$b8 = function(d, b) {
    return $0c5e3e04f495ba65$var$b4(d, b) + $0c5e3e04f495ba65$var$b4(d, b + 4) * 4294967296;
};
// write bytes
var $0c5e3e04f495ba65$var$wbytes = function(d, b, v) {
    for(; v; ++b)d[b] = v, v >>>= 8;
};
// gzip header
var $0c5e3e04f495ba65$var$gzh = function(c, o) {
    var fn = o.filename;
    c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix
    if (o.mtime != 0) $0c5e3e04f495ba65$var$wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));
    if (fn) {
        c[3] = 8;
        for(var i = 0; i <= fn.length; ++i)c[i + 10] = fn.charCodeAt(i);
    }
};
// gzip footer: -8 to -4 = CRC, -4 to -0 is length
// gzip start
var $0c5e3e04f495ba65$var$gzs = function(d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8) $0c5e3e04f495ba65$var$err(6, 'invalid gzip data');
    var flg = d[3];
    var st = 10;
    if (flg & 4) st += (d[10] | d[11] << 8) + 2;
    for(var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++]);
    return st + (flg & 2);
};
// gzip length
var $0c5e3e04f495ba65$var$gzl = function(d) {
    var l = d.length;
    return (d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16 | d[l - 1] << 24) >>> 0;
};
// gzip header length
var $0c5e3e04f495ba65$var$gzhl = function(o) {
    return 10 + (o.filename ? o.filename.length + 1 : 0);
};
// zlib header
var $0c5e3e04f495ba65$var$zlh = function(c, o) {
    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = fl << 6 | (o.dictionary && 32);
    c[1] |= 31 - (c[0] << 8 | c[1]) % 31;
    if (o.dictionary) {
        var h = $0c5e3e04f495ba65$var$adler();
        h.p(o.dictionary);
        $0c5e3e04f495ba65$var$wbytes(c, 2, h.d());
    }
};
// zlib start
var $0c5e3e04f495ba65$var$zls = function(d, dict) {
    if ((d[0] & 15) != 8 || d[0] >> 4 > 7 || (d[0] << 8 | d[1]) % 31) $0c5e3e04f495ba65$var$err(6, 'invalid zlib data');
    if ((d[1] >> 5 & 1) == +!dict) $0c5e3e04f495ba65$var$err(6, 'invalid zlib data: ' + (d[1] & 32 ? 'need' : 'unexpected') + ' dictionary');
    return (d[1] >> 3 & 4) + 2;
};
function $0c5e3e04f495ba65$var$StrmOpt(opts, cb) {
    if (typeof opts == 'function') cb = opts, opts = {};
    this.ondata = cb;
    return opts;
}
/**
 * Streaming DEFLATE compression
 */ var $0c5e3e04f495ba65$export$ae157b6234afe138 = /*#__PURE__*/ function() {
    function Deflate(opts, cb) {
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        this.o = opts || {};
        this.s = {
            l: 0,
            i: 32768,
            w: 32768,
            z: 32768
        };
        // Buffer length must always be 0 mod 32768 for index calculations to be correct when modifying head and prev
        // 98304 = 32768 (lookback) + 65536 (common chunk size)
        this.b = new $0c5e3e04f495ba65$var$u8(98304);
        if (this.o.dictionary) {
            var dict = this.o.dictionary.subarray(-32768);
            this.b.set(dict, 32768 - dict.length);
            this.s.i = 32768 - dict.length;
        }
    }
    Deflate.prototype.p = function(c, f) {
        this.ondata($0c5e3e04f495ba65$var$dopt(c, this.o, 0, 0, this.s), f);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Deflate.prototype.push = function(chunk, final) {
        if (!this.ondata) $0c5e3e04f495ba65$var$err(5);
        if (this.s.l) $0c5e3e04f495ba65$var$err(4);
        var endLen = chunk.length + this.s.z;
        if (endLen > this.b.length) {
            if (endLen > 2 * this.b.length - 32768) {
                var newBuf = new $0c5e3e04f495ba65$var$u8(endLen & -32768);
                newBuf.set(this.b.subarray(0, this.s.z));
                this.b = newBuf;
            }
            var split = this.b.length - this.s.z;
            this.b.set(chunk.subarray(0, split), this.s.z);
            this.s.z = this.b.length;
            this.p(this.b, false);
            this.b.set(this.b.subarray(-32768));
            this.b.set(chunk.subarray(split), 32768);
            this.s.z = chunk.length - split + 32768;
            this.s.i = 32766, this.s.w = 32768;
        } else {
            this.b.set(chunk, this.s.z);
            this.s.z += chunk.length;
        }
        this.s.l = final & 1;
        if (this.s.z > this.s.w + 8191 || final) {
            this.p(this.b, final || false);
            this.s.w = this.s.i, this.s.i -= 2;
        }
        if (final) {
            // cleanup unneeded buffers/state to reduce memory usage
            this.s = this.o = {};
            this.b = $0c5e3e04f495ba65$var$et;
        }
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * deflated output for small inputs.
     * @param sync Whether to flush to a byte boundary. A sync flush takes 4-5
     *             extra bytes, but guarantees all pushed data is immediately
     *             decompressible. A separate DEFLATE stream may be concatenated
     *             with the current output after a sync flush.
     */ Deflate.prototype.flush = function(sync) {
        if (!this.ondata) $0c5e3e04f495ba65$var$err(5);
        if (this.s.l) $0c5e3e04f495ba65$var$err(4);
        this.p(this.b, false);
        this.s.w = this.s.i, this.s.i -= 2;
        // could technically skip writing the type-0 block for (this.s.r & 7) == 0,
        // but the deterministic trailer (00 00 FF FF) is useful in some situations
        if (sync) {
            var c = new $0c5e3e04f495ba65$var$u8(6);
            c[0] = this.s.r >> 3;
            // write empty, non-final type-0 block
            var ep = $0c5e3e04f495ba65$var$wfblk(c, this.s.r, $0c5e3e04f495ba65$var$et);
            this.s.r = 0;
            this.ondata(c.subarray(0, ep >> 3), false);
        }
    };
    return Deflate;
}();
/**
 * Asynchronous streaming DEFLATE compression
 */ var $0c5e3e04f495ba65$export$84e526fabcba03e3 = /*#__PURE__*/ function() {
    function AsyncDeflate(opts, cb) {
        $0c5e3e04f495ba65$var$astrmify([
            $0c5e3e04f495ba65$var$bDflt,
            function() {
                return [
                    $0c5e3e04f495ba65$var$astrm,
                    $0c5e3e04f495ba65$export$ae157b6234afe138
                ];
            }
        ], this, $0c5e3e04f495ba65$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $0c5e3e04f495ba65$export$ae157b6234afe138(ev.data);
            onmessage = $0c5e3e04f495ba65$var$astrm(strm);
        }, 6, 1);
    }
    return AsyncDeflate;
}();
function $0c5e3e04f495ba65$export$2316623ecd1285ab(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    return $0c5e3e04f495ba65$var$cbify(data, opts, [
        $0c5e3e04f495ba65$var$bDflt
    ], function(ev) {
        return $0c5e3e04f495ba65$var$pbf($0c5e3e04f495ba65$export$21533ff51b8a0b4a(ev.data[0], ev.data[1]));
    }, 0, cb);
}
function $0c5e3e04f495ba65$export$21533ff51b8a0b4a(data, opts) {
    return $0c5e3e04f495ba65$var$dopt(data, opts || {}, 0, 0);
}
/**
 * Streaming DEFLATE decompression
 */ var $0c5e3e04f495ba65$export$d1de70a877d6e43c = /*#__PURE__*/ function() {
    function Inflate(opts, cb) {
        // no StrmOpt here to avoid adding to workerizer
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        var dict = opts && opts.dictionary && opts.dictionary.subarray(-32768);
        this.s = {
            i: 0,
            b: dict ? dict.length : 0
        };
        this.o = new $0c5e3e04f495ba65$var$u8(32768);
        this.p = new $0c5e3e04f495ba65$var$u8(0);
        if (dict) this.o.set(dict);
    }
    Inflate.prototype.e = function(c) {
        if (!this.ondata) $0c5e3e04f495ba65$var$err(5);
        if (this.d) $0c5e3e04f495ba65$var$err(4);
        if (!this.p.length) this.p = c;
        else if (c.length) {
            var n = new $0c5e3e04f495ba65$var$u8(this.p.length + c.length);
            n.set(this.p), n.set(c, this.p.length), this.p = n;
        }
    };
    Inflate.prototype.c = function(final) {
        this.s.i = +(this.d = final || false);
        var bts = this.s.b;
        var dt = $0c5e3e04f495ba65$var$inflt(this.p, this.s, this.o);
        this.ondata($0c5e3e04f495ba65$var$slc(dt, bts, this.s.b), this.d);
        this.o = $0c5e3e04f495ba65$var$slc(dt, this.s.b - 32768), this.s.b = this.o.length;
        this.p = $0c5e3e04f495ba65$var$slc(this.p, this.s.p / 8 | 0), this.s.p &= 7;
    };
    /**
     * Pushes a chunk to be inflated
     * @param chunk The chunk to push
     * @param final Whether this is the final chunk
     */ Inflate.prototype.push = function(chunk, final) {
        this.e(chunk), this.c(final);
    };
    return Inflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression
 */ var $0c5e3e04f495ba65$export$fff8358d6dbaa9cc = /*#__PURE__*/ function() {
    function AsyncInflate(opts, cb) {
        $0c5e3e04f495ba65$var$astrmify([
            $0c5e3e04f495ba65$var$bInflt,
            function() {
                return [
                    $0c5e3e04f495ba65$var$astrm,
                    $0c5e3e04f495ba65$export$d1de70a877d6e43c
                ];
            }
        ], this, $0c5e3e04f495ba65$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $0c5e3e04f495ba65$export$d1de70a877d6e43c(ev.data);
            onmessage = $0c5e3e04f495ba65$var$astrm(strm);
        }, 7, 0);
    }
    return AsyncInflate;
}();
function $0c5e3e04f495ba65$export$cae1ce83fe4a1782(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    return $0c5e3e04f495ba65$var$cbify(data, opts, [
        $0c5e3e04f495ba65$var$bInflt
    ], function(ev) {
        return $0c5e3e04f495ba65$var$pbf($0c5e3e04f495ba65$export$90366d8b308ba94a(ev.data[0], $0c5e3e04f495ba65$var$gopt(ev.data[1])));
    }, 1, cb);
}
function $0c5e3e04f495ba65$export$90366d8b308ba94a(data, opts) {
    return $0c5e3e04f495ba65$var$inflt(data, {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
// before you yell at me for not just using extends, my reason is that TS inheritance is hard to workerize.
/**
 * Streaming GZIP compression
 */ var $0c5e3e04f495ba65$export$8e4b66d280bf8342 = /*#__PURE__*/ function() {
    function Gzip(opts, cb) {
        this.c = $0c5e3e04f495ba65$var$crc();
        this.l = 0;
        this.v = 1;
        $0c5e3e04f495ba65$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gzip.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        this.l += chunk.length;
        $0c5e3e04f495ba65$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Gzip.prototype.p = function(c, f) {
        var raw = $0c5e3e04f495ba65$var$dopt(c, this.o, this.v && $0c5e3e04f495ba65$var$gzhl(this.o), f && 8, this.s);
        if (this.v) $0c5e3e04f495ba65$var$gzh(raw, this.o), this.v = 0;
        if (f) $0c5e3e04f495ba65$var$wbytes(raw, raw.length - 8, this.c.d()), $0c5e3e04f495ba65$var$wbytes(raw, raw.length - 4, this.l);
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * GZIPped output for small inputs.
     * @param sync Whether to flush to a byte boundary. A sync flush takes 4-5
     *             extra bytes, but guarantees all pushed data is immediately
     *             decompressible.
     */ Gzip.prototype.flush = function(sync) {
        $0c5e3e04f495ba65$export$ae157b6234afe138.prototype.flush.call(this, sync);
    };
    return Gzip;
}();
/**
 * Asynchronous streaming GZIP compression
 */ var $0c5e3e04f495ba65$export$b4c75ae96cdf708b = /*#__PURE__*/ function() {
    function AsyncGzip(opts, cb) {
        $0c5e3e04f495ba65$var$astrmify([
            $0c5e3e04f495ba65$var$bDflt,
            $0c5e3e04f495ba65$var$gze,
            function() {
                return [
                    $0c5e3e04f495ba65$var$astrm,
                    $0c5e3e04f495ba65$export$ae157b6234afe138,
                    $0c5e3e04f495ba65$export$8e4b66d280bf8342
                ];
            }
        ], this, $0c5e3e04f495ba65$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $0c5e3e04f495ba65$export$8e4b66d280bf8342(ev.data);
            onmessage = $0c5e3e04f495ba65$var$astrm(strm);
        }, 8, 1);
    }
    return AsyncGzip;
}();
function $0c5e3e04f495ba65$export$69f0ea7cf3a331a8(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    return $0c5e3e04f495ba65$var$cbify(data, opts, [
        $0c5e3e04f495ba65$var$bDflt,
        $0c5e3e04f495ba65$var$gze,
        function() {
            return [
                $0c5e3e04f495ba65$export$3d616c3fb3e15483
            ];
        }
    ], function(ev) {
        return $0c5e3e04f495ba65$var$pbf($0c5e3e04f495ba65$export$3d616c3fb3e15483(ev.data[0], ev.data[1]));
    }, 2, cb);
}
function $0c5e3e04f495ba65$export$3d616c3fb3e15483(data, opts) {
    if (!opts) opts = {};
    var c = $0c5e3e04f495ba65$var$crc(), l = data.length;
    c.p(data);
    var d = $0c5e3e04f495ba65$var$dopt(data, opts, $0c5e3e04f495ba65$var$gzhl(opts), 8), s = d.length;
    return $0c5e3e04f495ba65$var$gzh(d, opts), $0c5e3e04f495ba65$var$wbytes(d, s - 8, c.d()), $0c5e3e04f495ba65$var$wbytes(d, s - 4, l), d;
}
/**
 * Streaming single or multi-member GZIP decompression
 */ var $0c5e3e04f495ba65$export$4cb607de6db70415 = /*#__PURE__*/ function() {
    function Gunzip(opts, cb) {
        this.v = 1;
        this.r = 0;
        $0c5e3e04f495ba65$export$d1de70a877d6e43c.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GUNZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gunzip.prototype.push = function(chunk, final) {
        $0c5e3e04f495ba65$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        this.r += chunk.length;
        if (this.v) {
            var p = this.p.subarray(this.v - 1);
            var s = p.length > 3 ? $0c5e3e04f495ba65$var$gzs(p) : 4;
            if (s > p.length) {
                if (!final) return;
            } else if (this.v > 1 && this.onmember) this.onmember(this.r - p.length);
            this.p = p.subarray(s), this.v = 0;
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $0c5e3e04f495ba65$export$d1de70a877d6e43c.prototype.c.call(this, 0);
        // process concatenated GZIP
        if (this.s.f && !this.s.l) {
            this.v = $0c5e3e04f495ba65$var$shft(this.s.p) + 9;
            this.s = {
                i: 0
            };
            this.o = new $0c5e3e04f495ba65$var$u8(0);
            this.push(new $0c5e3e04f495ba65$var$u8(0), final);
        } else if (final) $0c5e3e04f495ba65$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Gunzip;
}();
/**
 * Asynchronous streaming single or multi-member GZIP decompression
 */ var $0c5e3e04f495ba65$export$d5adcdd968132151 = /*#__PURE__*/ function() {
    function AsyncGunzip(opts, cb) {
        var _this = this;
        $0c5e3e04f495ba65$var$astrmify([
            $0c5e3e04f495ba65$var$bInflt,
            $0c5e3e04f495ba65$var$guze,
            function() {
                return [
                    $0c5e3e04f495ba65$var$astrm,
                    $0c5e3e04f495ba65$export$d1de70a877d6e43c,
                    $0c5e3e04f495ba65$export$4cb607de6db70415
                ];
            }
        ], this, $0c5e3e04f495ba65$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $0c5e3e04f495ba65$export$4cb607de6db70415(ev.data);
            strm.onmember = function(offset) {
                return postMessage(offset);
            };
            onmessage = $0c5e3e04f495ba65$var$astrm(strm);
        }, 9, 0, function(offset) {
            return _this.onmember && _this.onmember(offset);
        });
    }
    return AsyncGunzip;
}();
function $0c5e3e04f495ba65$export$b6df3e950734d697(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    return $0c5e3e04f495ba65$var$cbify(data, opts, [
        $0c5e3e04f495ba65$var$bInflt,
        $0c5e3e04f495ba65$var$guze,
        function() {
            return [
                $0c5e3e04f495ba65$export$c80456f7aaba691c
            ];
        }
    ], function(ev) {
        return $0c5e3e04f495ba65$var$pbf($0c5e3e04f495ba65$export$c80456f7aaba691c(ev.data[0], ev.data[1]));
    }, 3, cb);
}
function $0c5e3e04f495ba65$export$c80456f7aaba691c(data, opts) {
    var st = $0c5e3e04f495ba65$var$gzs(data);
    if (st + 8 > data.length) $0c5e3e04f495ba65$var$err(6, 'invalid gzip data');
    return $0c5e3e04f495ba65$var$inflt(data.subarray(st, -8), {
        i: 2
    }, opts && opts.out || new $0c5e3e04f495ba65$var$u8($0c5e3e04f495ba65$var$gzl(data)), opts && opts.dictionary);
}
/**
 * Streaming Zlib compression
 */ var $0c5e3e04f495ba65$export$4187ccf2467013b9 = /*#__PURE__*/ function() {
    function Zlib(opts, cb) {
        this.c = $0c5e3e04f495ba65$var$adler();
        this.v = 1;
        $0c5e3e04f495ba65$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be zlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Zlib.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        $0c5e3e04f495ba65$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Zlib.prototype.p = function(c, f) {
        var raw = $0c5e3e04f495ba65$var$dopt(c, this.o, this.v && (this.o.dictionary ? 6 : 2), f && 4, this.s);
        if (this.v) $0c5e3e04f495ba65$var$zlh(raw, this.o), this.v = 0;
        if (f) $0c5e3e04f495ba65$var$wbytes(raw, raw.length - 4, this.c.d());
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * zlibbed output for small inputs.
     * @param sync Whether to flush to a byte boundary. A sync flush takes 4-5
     *             extra bytes, but guarantees all pushed data is immediately
     *             decompressible.
     */ Zlib.prototype.flush = function(sync) {
        $0c5e3e04f495ba65$export$ae157b6234afe138.prototype.flush.call(this, sync);
    };
    return Zlib;
}();
/**
 * Asynchronous streaming Zlib compression
 */ var $0c5e3e04f495ba65$export$bedbe3a2c2136490 = /*#__PURE__*/ function() {
    function AsyncZlib(opts, cb) {
        $0c5e3e04f495ba65$var$astrmify([
            $0c5e3e04f495ba65$var$bDflt,
            $0c5e3e04f495ba65$var$zle,
            function() {
                return [
                    $0c5e3e04f495ba65$var$astrm,
                    $0c5e3e04f495ba65$export$ae157b6234afe138,
                    $0c5e3e04f495ba65$export$4187ccf2467013b9
                ];
            }
        ], this, $0c5e3e04f495ba65$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $0c5e3e04f495ba65$export$4187ccf2467013b9(ev.data);
            onmessage = $0c5e3e04f495ba65$var$astrm(strm);
        }, 10, 1);
    }
    return AsyncZlib;
}();
function $0c5e3e04f495ba65$export$925212de7058410b(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    return $0c5e3e04f495ba65$var$cbify(data, opts, [
        $0c5e3e04f495ba65$var$bDflt,
        $0c5e3e04f495ba65$var$zle,
        function() {
            return [
                $0c5e3e04f495ba65$export$f87121a6d50aff25
            ];
        }
    ], function(ev) {
        return $0c5e3e04f495ba65$var$pbf($0c5e3e04f495ba65$export$f87121a6d50aff25(ev.data[0], ev.data[1]));
    }, 4, cb);
}
function $0c5e3e04f495ba65$export$f87121a6d50aff25(data, opts) {
    if (!opts) opts = {};
    var a = $0c5e3e04f495ba65$var$adler();
    a.p(data);
    var d = $0c5e3e04f495ba65$var$dopt(data, opts, opts.dictionary ? 6 : 2, 4);
    return $0c5e3e04f495ba65$var$zlh(d, opts), $0c5e3e04f495ba65$var$wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Streaming Zlib decompression
 */ var $0c5e3e04f495ba65$export$af2424f875ff1b17 = /*#__PURE__*/ function() {
    function Unzlib(opts, cb) {
        $0c5e3e04f495ba65$export$d1de70a877d6e43c.call(this, opts, cb);
        this.v = opts && opts.dictionary ? 2 : 1;
    }
    /**
     * Pushes a chunk to be unzlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzlib.prototype.push = function(chunk, final) {
        $0c5e3e04f495ba65$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        if (this.v) {
            if (this.p.length < 6 && !final) return;
            this.p = this.p.subarray($0c5e3e04f495ba65$var$zls(this.p, this.v - 1)), this.v = 0;
        }
        if (final) {
            if (this.p.length < 4) $0c5e3e04f495ba65$var$err(6, 'invalid zlib data');
            this.p = this.p.subarray(0, -4);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $0c5e3e04f495ba65$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Unzlib;
}();
/**
 * Asynchronous streaming Zlib decompression
 */ var $0c5e3e04f495ba65$export$cf6668790220dcad = /*#__PURE__*/ function() {
    function AsyncUnzlib(opts, cb) {
        $0c5e3e04f495ba65$var$astrmify([
            $0c5e3e04f495ba65$var$bInflt,
            $0c5e3e04f495ba65$var$zule,
            function() {
                return [
                    $0c5e3e04f495ba65$var$astrm,
                    $0c5e3e04f495ba65$export$d1de70a877d6e43c,
                    $0c5e3e04f495ba65$export$af2424f875ff1b17
                ];
            }
        ], this, $0c5e3e04f495ba65$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $0c5e3e04f495ba65$export$af2424f875ff1b17(ev.data);
            onmessage = $0c5e3e04f495ba65$var$astrm(strm);
        }, 11, 0);
    }
    return AsyncUnzlib;
}();
function $0c5e3e04f495ba65$export$ca7cbb494e731274(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    return $0c5e3e04f495ba65$var$cbify(data, opts, [
        $0c5e3e04f495ba65$var$bInflt,
        $0c5e3e04f495ba65$var$zule,
        function() {
            return [
                $0c5e3e04f495ba65$export$9ec8134f0f1b9fc6
            ];
        }
    ], function(ev) {
        return $0c5e3e04f495ba65$var$pbf($0c5e3e04f495ba65$export$9ec8134f0f1b9fc6(ev.data[0], $0c5e3e04f495ba65$var$gopt(ev.data[1])));
    }, 5, cb);
}
function $0c5e3e04f495ba65$export$9ec8134f0f1b9fc6(data, opts) {
    return $0c5e3e04f495ba65$var$inflt(data.subarray($0c5e3e04f495ba65$var$zls(data, opts && opts.dictionary), -4), {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
/**
 * Streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $0c5e3e04f495ba65$export$578fe199ef655b76 = /*#__PURE__*/ function() {
    function Decompress(opts, cb) {
        this.o = $0c5e3e04f495ba65$var$StrmOpt.call(this, opts, cb) || {};
        this.G = $0c5e3e04f495ba65$export$4cb607de6db70415;
        this.I = $0c5e3e04f495ba65$export$d1de70a877d6e43c;
        this.Z = $0c5e3e04f495ba65$export$af2424f875ff1b17;
    }
    // init substream
    // overriden by AsyncDecompress
    Decompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(dat, final) {
            _this.ondata(dat, final);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Decompress.prototype.push = function(chunk, final) {
        if (!this.ondata) $0c5e3e04f495ba65$var$err(5);
        if (!this.s) {
            if (this.p && this.p.length) {
                var n = new $0c5e3e04f495ba65$var$u8(this.p.length + chunk.length);
                n.set(this.p), n.set(chunk, this.p.length);
            } else this.p = chunk;
            if (this.p.length > 2) {
                this.s = this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8 ? new this.G(this.o) : (this.p[0] & 15) != 8 || this.p[0] >> 4 > 7 || (this.p[0] << 8 | this.p[1]) % 31 ? new this.I(this.o) : new this.Z(this.o);
                this.i();
                this.s.push(this.p, final);
                this.p = null;
            }
        } else this.s.push(chunk, final);
    };
    return Decompress;
}();
/**
 * Asynchronous streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $0c5e3e04f495ba65$export$ae2c1d81988d4b43 = /*#__PURE__*/ function() {
    function AsyncDecompress(opts, cb) {
        $0c5e3e04f495ba65$export$578fe199ef655b76.call(this, opts, cb);
        this.queuedSize = 0;
        this.G = $0c5e3e04f495ba65$export$d5adcdd968132151;
        this.I = $0c5e3e04f495ba65$export$fff8358d6dbaa9cc;
        this.Z = $0c5e3e04f495ba65$export$cf6668790220dcad;
    }
    AsyncDecompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(err, dat, final) {
            _this.ondata(err, dat, final);
        };
        this.s.ondrain = function(size) {
            _this.queuedSize -= size;
            if (_this.ondrain) _this.ondrain(size);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncDecompress.prototype.push = function(chunk, final) {
        this.queuedSize += chunk.length;
        $0c5e3e04f495ba65$export$578fe199ef655b76.prototype.push.call(this, chunk, final);
    };
    return AsyncDecompress;
}();
function $0c5e3e04f495ba65$export$678d868aab8fb3c7(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $0c5e3e04f495ba65$export$b6df3e950734d697(data, opts, cb) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $0c5e3e04f495ba65$export$cae1ce83fe4a1782(data, opts, cb) : $0c5e3e04f495ba65$export$ca7cbb494e731274(data, opts, cb);
}
function $0c5e3e04f495ba65$export$c4bdbbbc9a4faabe(data, opts) {
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $0c5e3e04f495ba65$export$c80456f7aaba691c(data, opts) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $0c5e3e04f495ba65$export$90366d8b308ba94a(data, opts) : $0c5e3e04f495ba65$export$9ec8134f0f1b9fc6(data, opts);
}
// flatten a directory structure
var $0c5e3e04f495ba65$var$fltn = function(d, p, t, o) {
    for(var k in d){
        var val = d[k], n = p + k, op = o;
        if (Array.isArray(val)) op = $0c5e3e04f495ba65$var$mrg(o, val[1]), val = val[0];
        if (ArrayBuffer.isView(val)) t[n] = [
            val,
            op
        ];
        else {
            t[n += '/'] = [
                new $0c5e3e04f495ba65$var$u8(0),
                op
            ];
            $0c5e3e04f495ba65$var$fltn(val, n, t, o);
        }
    }
};
// text encoder
var $0c5e3e04f495ba65$var$te = typeof TextEncoder != 'undefined' && /*#__PURE__*/ new TextEncoder();
// text decoder
var $0c5e3e04f495ba65$var$td = typeof TextDecoder != 'undefined' && /*#__PURE__*/ new TextDecoder();
// text decoder stream
var $0c5e3e04f495ba65$var$tds = 0;
try {
    $0c5e3e04f495ba65$var$td.decode($0c5e3e04f495ba65$var$et, {
        stream: true
    });
    $0c5e3e04f495ba65$var$tds = 1;
} catch (e) {}
// decode UTF8
var $0c5e3e04f495ba65$var$dutf8 = function(d) {
    for(var r = '', i = 0;;){
        var c = d[i++];
        var eb = (c > 127) + (c > 223) + (c > 239);
        if (i + eb > d.length) return {
            s: r,
            r: $0c5e3e04f495ba65$var$slc(d, i - 1)
        };
        if (!eb) r += String.fromCharCode(c);
        else if (eb == 3) c = ((c & 15) << 18 | (d[i++] & 63) << 12 | (d[i++] & 63) << 6 | d[i++] & 63) - 65536, r += String.fromCharCode(55296 | c >> 10, 56320 | c & 1023);
        else if (eb & 1) r += String.fromCharCode((c & 31) << 6 | d[i++] & 63);
        else r += String.fromCharCode((c & 15) << 12 | (d[i++] & 63) << 6 | d[i++] & 63);
    }
};
/**
 * Streaming UTF-8 decoding
 */ var $0c5e3e04f495ba65$export$ba46860a31c72e94 = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is decoded
     */ function DecodeUTF8(cb) {
        this.ondata = cb;
        if ($0c5e3e04f495ba65$var$tds) this.t = new TextDecoder();
        else this.p = $0c5e3e04f495ba65$var$et;
    }
    /**
     * Pushes a chunk to be decoded from UTF-8 binary
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ DecodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $0c5e3e04f495ba65$var$err(5);
        final = !!final;
        if (this.t) {
            this.ondata(this.t.decode(chunk, {
                stream: true
            }), final);
            if (final) {
                if (this.t.decode().length) $0c5e3e04f495ba65$var$err(8);
                this.t = null;
            }
            return;
        }
        if (!this.p) $0c5e3e04f495ba65$var$err(4);
        var dat = new $0c5e3e04f495ba65$var$u8(this.p.length + chunk.length);
        dat.set(this.p);
        dat.set(chunk, this.p.length);
        var _a = $0c5e3e04f495ba65$var$dutf8(dat), s = _a.s, r = _a.r;
        if (final) {
            if (r.length) $0c5e3e04f495ba65$var$err(8);
            this.p = null;
        } else this.p = r;
        this.ondata(s, final);
    };
    return DecodeUTF8;
}();
/**
 * Streaming UTF-8 encoding
 */ var $0c5e3e04f495ba65$export$283f13d12b1b210e = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is encoded
     */ function EncodeUTF8(cb) {
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be encoded to UTF-8
     * @param chunk The string data to push
     * @param final Whether this is the last chunk
     */ EncodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $0c5e3e04f495ba65$var$err(5);
        if (this.d) $0c5e3e04f495ba65$var$err(4);
        this.ondata($0c5e3e04f495ba65$export$366b39a6daa8ed7a(chunk), this.d = final || false);
    };
    return EncodeUTF8;
}();
function $0c5e3e04f495ba65$export$366b39a6daa8ed7a(str, latin1) {
    if (latin1) {
        var ar_1 = new $0c5e3e04f495ba65$var$u8(str.length);
        for(var i = 0; i < str.length; ++i)ar_1[i] = str.charCodeAt(i);
        return ar_1;
    }
    if ($0c5e3e04f495ba65$var$te) return $0c5e3e04f495ba65$var$te.encode(str);
    var l = str.length;
    var ar = new $0c5e3e04f495ba65$var$u8(str.length + (str.length >> 1));
    var ai = 0;
    var w = function(v) {
        ar[ai++] = v;
    };
    for(var i = 0; i < l; ++i){
        if (ai + 5 > ar.length) {
            var n = new $0c5e3e04f495ba65$var$u8(ai + 8 + (l - i << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1) w(c);
        else if (c < 2048) w(192 | c >> 6), w(128 | c & 63);
        else if (c > 55295 && c < 57344) c = 65536 + (c & 1047552) | str.charCodeAt(++i) & 1023, w(240 | c >> 18), w(128 | c >> 12 & 63), w(128 | c >> 6 & 63), w(128 | c & 63);
        else w(224 | c >> 12), w(128 | c >> 6 & 63), w(128 | c & 63);
    }
    return $0c5e3e04f495ba65$var$slc(ar, 0, ai);
}
function $0c5e3e04f495ba65$export$adb211f8cb999894(dat, latin1) {
    if (latin1) {
        var r = '';
        for(var i = 0; i < dat.length; i += 16384)r += String.fromCharCode.apply(null, dat.subarray(i, i + 16384));
        return r;
    } else if ($0c5e3e04f495ba65$var$td) return $0c5e3e04f495ba65$var$td.decode(dat);
    else {
        var _a = $0c5e3e04f495ba65$var$dutf8(dat), s = _a.s, r = _a.r;
        if (r.length) $0c5e3e04f495ba65$var$err(8);
        return s;
    }
}
// deflate bit flag
var $0c5e3e04f495ba65$var$dbf = function(l) {
    return l == 1 ? 3 : l < 6 ? 2 : l == 9 ? 1 : 0;
};
// skip local zip header
var $0c5e3e04f495ba65$var$slzh = function(d, b) {
    return b + 30 + $0c5e3e04f495ba65$var$b2(d, b + 26) + $0c5e3e04f495ba65$var$b2(d, b + 28);
};
// read zip header
var $0c5e3e04f495ba65$var$zh = function(d, b, z) {
    var fnl = $0c5e3e04f495ba65$var$b2(d, b + 28), efl = $0c5e3e04f495ba65$var$b2(d, b + 30), fn = $0c5e3e04f495ba65$export$adb211f8cb999894(d.subarray(b + 46, b + 46 + fnl), !($0c5e3e04f495ba65$var$b2(d, b + 8) & 2048)), es = b + 46 + fnl;
    var _a = $0c5e3e04f495ba65$var$z64hs(d, es, efl, z, $0c5e3e04f495ba65$var$b4(d, b + 20), $0c5e3e04f495ba65$var$b4(d, b + 24), $0c5e3e04f495ba65$var$b4(d, b + 42)), sc = _a[0], su = _a[1], off = _a[2];
    return [
        $0c5e3e04f495ba65$var$b2(d, b + 10),
        sc,
        su,
        fn,
        es + efl + $0c5e3e04f495ba65$var$b2(d, b + 32),
        off
    ];
};
// read zip64 header sizes
var $0c5e3e04f495ba65$var$z64hs = function(d, b, l, z, sc, su, off) {
    var nsc = sc == 4294967295, nsu = su == 4294967295, noff = off == 4294967295, e = b + l;
    var nf = nsc + nsu + noff;
    if (z && nf) {
        for(; b + 4 < e; b += 4 + $0c5e3e04f495ba65$var$b2(d, b + 2)){
            if ($0c5e3e04f495ba65$var$b2(d, b) == 1) return [
                nsc ? $0c5e3e04f495ba65$var$b8(d, b + 4 + 8 * nsu) : sc,
                nsu ? $0c5e3e04f495ba65$var$b8(d, b + 4) : su,
                noff ? $0c5e3e04f495ba65$var$b8(d, b + 4 + 8 * (nsu + nsc)) : off,
                1
            ];
        }
        // z == 2 for unknown whether or not zip64
        if (z < 2) $0c5e3e04f495ba65$var$err(13);
    }
    return [
        sc,
        su,
        off,
        0
    ];
};
// extra field length
var $0c5e3e04f495ba65$var$exfl = function(ex) {
    var le = 0;
    if (ex) for(var k in ex){
        var l = ex[k].length;
        if (l > 65535) $0c5e3e04f495ba65$var$err(9);
        le += l + 4;
    }
    return le;
};
// write zip header
var $0c5e3e04f495ba65$var$wzh = function(d, b, f, fn, u, c, ce, co) {
    var fl = fn.length, ex = f.extra, col = co && co.length;
    var exl = $0c5e3e04f495ba65$var$exfl(ex);
    $0c5e3e04f495ba65$var$wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
    if (ce != null) d[b++] = 20, d[b++] = f.os;
    d[b] = 20, b += 2; // spec compliance? what's that?
    d[b++] = f.flag << 1 | (c < 0 && 8), d[b++] = u && 8;
    d[b++] = f.compression & 255, d[b++] = f.compression >> 8;
    var dt = new Date(f.mtime == null ? Date.now() : f.mtime), y = dt.getFullYear() - 1980;
    if (y < 0 || y > 119) $0c5e3e04f495ba65$var$err(10);
    $0c5e3e04f495ba65$var$wbytes(d, b, y << 25 | dt.getMonth() + 1 << 21 | dt.getDate() << 16 | dt.getHours() << 11 | dt.getMinutes() << 5 | dt.getSeconds() >> 1), b += 4;
    if (c != -1) {
        $0c5e3e04f495ba65$var$wbytes(d, b, f.crc);
        $0c5e3e04f495ba65$var$wbytes(d, b + 4, c < 0 ? -c - 2 : c);
        $0c5e3e04f495ba65$var$wbytes(d, b + 8, f.size);
    }
    $0c5e3e04f495ba65$var$wbytes(d, b + 12, fl);
    $0c5e3e04f495ba65$var$wbytes(d, b + 14, exl), b += 16;
    if (ce != null) {
        $0c5e3e04f495ba65$var$wbytes(d, b, col);
        $0c5e3e04f495ba65$var$wbytes(d, b + 6, f.attrs);
        $0c5e3e04f495ba65$var$wbytes(d, b + 10, ce), b += 14;
    }
    d.set(fn, b);
    b += fl;
    if (exl) for(var k in ex){
        var exf = ex[k], l = exf.length;
        $0c5e3e04f495ba65$var$wbytes(d, b, +k);
        $0c5e3e04f495ba65$var$wbytes(d, b + 2, l);
        d.set(exf, b + 4), b += 4 + l;
    }
    if (col) d.set(co, b), b += col;
    return b;
};
// write zip footer (end of central directory)
var $0c5e3e04f495ba65$var$wzf = function(o, b, c, d, e) {
    $0c5e3e04f495ba65$var$wbytes(o, b, 0x6054B50); // skip disk
    $0c5e3e04f495ba65$var$wbytes(o, b + 8, c);
    $0c5e3e04f495ba65$var$wbytes(o, b + 10, c);
    $0c5e3e04f495ba65$var$wbytes(o, b + 12, d);
    $0c5e3e04f495ba65$var$wbytes(o, b + 16, e);
};
/**
 * A pass-through stream to keep data uncompressed in a ZIP archive.
 */ var $0c5e3e04f495ba65$export$2b25194e1767ea06 = /*#__PURE__*/ function() {
    /**
     * Creates a pass-through stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     */ function ZipPassThrough(filename) {
        this.filename = filename;
        this.c = $0c5e3e04f495ba65$var$crc();
        this.size = 0;
        this.compression = 0;
    }
    /**
     * Processes a chunk and pushes to the output stream. You can override this
     * method in a subclass for custom behavior, but by default this passes
     * the data through. You must call this.ondata(err, chunk, final) at some
     * point in this method.
     * @param chunk The chunk to process
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.process = function(chunk, final) {
        this.ondata(null, chunk, final);
    };
    /**
     * Pushes a chunk to be added. If you are subclassing this with a custom
     * compression algorithm, note that you must push data from the source
     * file only, pre-compression.
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.push = function(chunk, final) {
        if (!this.ondata) $0c5e3e04f495ba65$var$err(5);
        this.c.p(chunk);
        this.size += chunk.length;
        if (final) this.crc = this.c.d();
        // we shouldn't really do this cast, but properly handling ArrayBufferLike
        // makes the API unergonomic with Buffer
        this.process(chunk, final || false);
    };
    return ZipPassThrough;
}();
// I don't extend because TypeScript extension adds 1kB of runtime bloat
/**
 * Streaming DEFLATE compression for ZIP archives. Prefer using AsyncZipDeflate
 * for better performance
 */ var $0c5e3e04f495ba65$export$f7e481ca646388b6 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function ZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $0c5e3e04f495ba65$export$2b25194e1767ea06.call(this, filename);
        this.d = new $0c5e3e04f495ba65$export$ae157b6234afe138(opts, function(dat, final) {
            _this.ondata(null, dat, final);
        });
        this.compression = 8;
        this.flag = $0c5e3e04f495ba65$var$dbf(opts.level);
    }
    ZipDeflate.prototype.process = function(chunk, final) {
        try {
            this.d.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipDeflate.prototype.push = function(chunk, final) {
        $0c5e3e04f495ba65$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return ZipDeflate;
}();
/**
 * Asynchronous streaming DEFLATE compression for ZIP archives
 */ var $0c5e3e04f495ba65$export$ffb5e59e179924b2 = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function AsyncZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $0c5e3e04f495ba65$export$2b25194e1767ea06.call(this, filename);
        this.d = new $0c5e3e04f495ba65$export$84e526fabcba03e3(opts, function(err, dat, final) {
            _this.ondata(err, dat, final);
        });
        this.compression = 8;
        this.flag = $0c5e3e04f495ba65$var$dbf(opts.level);
        this.terminate = this.d.terminate;
    }
    AsyncZipDeflate.prototype.process = function(chunk, final) {
        this.d.push(chunk, final);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncZipDeflate.prototype.push = function(chunk, final) {
        $0c5e3e04f495ba65$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return AsyncZipDeflate;
}();
// TODO: Better tree shaking
/**
 * A zippable archive to which files can incrementally be added
 */ var $0c5e3e04f495ba65$export$9a4d4a7c32a75d2f = /*#__PURE__*/ function() {
    /**
     * Creates an empty ZIP archive to which files can be added
     * @param cb The callback to call whenever data for the generated ZIP archive
     *           is available
     */ function Zip(cb) {
        this.ondata = cb;
        this.u = [];
        this.d = 1;
    }
    /**
     * Adds a file to the ZIP archive
     * @param file The file stream to add
     */ Zip.prototype.add = function(file) {
        var _this = this;
        if (!this.ondata) $0c5e3e04f495ba65$var$err(5);
        // finishing or finished
        if (this.d & 2) this.ondata($0c5e3e04f495ba65$var$err(4 + (this.d & 1) * 8, 0, 1), null, false);
        else {
            var f = $0c5e3e04f495ba65$export$366b39a6daa8ed7a(file.filename), fl_1 = f.length;
            var com = file.comment, o = com && $0c5e3e04f495ba65$export$366b39a6daa8ed7a(com);
            var u = fl_1 != file.filename.length || o && com.length != o.length;
            var hl_1 = fl_1 + $0c5e3e04f495ba65$var$exfl(file.extra) + 30;
            if (fl_1 > 65535) this.ondata($0c5e3e04f495ba65$var$err(11, 0, 1), null, false);
            var header = new $0c5e3e04f495ba65$var$u8(hl_1);
            $0c5e3e04f495ba65$var$wzh(header, 0, file, f, u, -1);
            var chks_1 = [
                header
            ];
            var pAll_1 = function() {
                for(var _i = 0, chks_2 = chks_1; _i < chks_2.length; _i++){
                    var chk = chks_2[_i];
                    _this.ondata(null, chk, false);
                }
                chks_1 = [];
            };
            var tr_1 = this.d;
            this.d = 0;
            var ind_1 = this.u.length;
            var uf_1 = $0c5e3e04f495ba65$var$mrg(file, {
                f: f,
                u: u,
                o: o,
                t: function() {
                    if (file.terminate) file.terminate();
                },
                r: function() {
                    pAll_1();
                    if (tr_1) {
                        var nxt = _this.u[ind_1 + 1];
                        if (nxt) nxt.r();
                        else _this.d = 1;
                    }
                    tr_1 = 1;
                }
            });
            var cl_1 = 0;
            file.ondata = function(err, dat, final) {
                if (err) {
                    _this.ondata(err, dat, final);
                    _this.terminate();
                } else {
                    cl_1 += dat.length;
                    chks_1.push(dat);
                    if (final) {
                        var dd = new $0c5e3e04f495ba65$var$u8(16);
                        $0c5e3e04f495ba65$var$wbytes(dd, 0, 0x8074B50);
                        $0c5e3e04f495ba65$var$wbytes(dd, 4, file.crc);
                        $0c5e3e04f495ba65$var$wbytes(dd, 8, cl_1);
                        $0c5e3e04f495ba65$var$wbytes(dd, 12, file.size);
                        chks_1.push(dd);
                        uf_1.c = cl_1, uf_1.b = hl_1 + cl_1 + 16, uf_1.crc = file.crc, uf_1.size = file.size;
                        if (tr_1) uf_1.r();
                        tr_1 = 1;
                    } else if (tr_1) pAll_1();
                }
            };
            this.u.push(uf_1);
        }
    };
    /**
     * Ends the process of adding files and prepares to emit the final chunks.
     * This *must* be called after adding all desired files for the resulting
     * ZIP file to work properly.
     */ Zip.prototype.end = function() {
        var _this = this;
        if (this.d & 2) {
            this.ondata($0c5e3e04f495ba65$var$err(4 + (this.d & 1) * 8, 0, 1), null, true);
            return;
        }
        if (this.d) this.e();
        else this.u.push({
            r: function() {
                if (!(_this.d & 1)) return;
                _this.u.splice(-1, 1);
                _this.e();
            },
            t: function() {}
        });
        this.d = 3;
    };
    Zip.prototype.e = function() {
        var bt = 0, l = 0, tl = 0;
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            tl += 46 + f.f.length + $0c5e3e04f495ba65$var$exfl(f.extra) + (f.o ? f.o.length : 0);
        }
        var out = new $0c5e3e04f495ba65$var$u8(tl + 22);
        for(var _b = 0, _c = this.u; _b < _c.length; _b++){
            var f = _c[_b];
            $0c5e3e04f495ba65$var$wzh(out, bt, f, f.f, f.u, -f.c - 2, l, f.o);
            bt += 46 + f.f.length + $0c5e3e04f495ba65$var$exfl(f.extra) + (f.o ? f.o.length : 0), l += f.b;
        }
        $0c5e3e04f495ba65$var$wzf(out, bt, this.u.length, tl, l);
        this.ondata(null, out, true);
        this.d = 2;
    };
    /**
     * A method to terminate any internal workers used by the stream. Subsequent
     * calls to add() will fail.
     */ Zip.prototype.terminate = function() {
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            f.t();
        }
        this.d = 2;
    };
    return Zip;
}();
function $0c5e3e04f495ba65$export$8901015135f2fb22(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    var r = {};
    $0c5e3e04f495ba65$var$fltn(data, '', r, opts);
    var k = Object.keys(r);
    var lft = k.length, o = 0, tot = 0;
    var slft = lft, files = new Array(lft);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var cbd = function(a, b) {
        $0c5e3e04f495ba65$var$mt(function() {
            cb(a, b);
        });
    };
    $0c5e3e04f495ba65$var$mt(function() {
        cbd = cb;
    });
    var cbf = function() {
        var out = new $0c5e3e04f495ba65$var$u8(tot + 22), oe = o, cdl = tot - o;
        tot = 0;
        for(var i = 0; i < slft; ++i){
            var f = files[i];
            try {
                var l = f.c.length;
                $0c5e3e04f495ba65$var$wzh(out, tot, f, f.f, f.u, l);
                var badd = 30 + f.f.length + $0c5e3e04f495ba65$var$exfl(f.extra);
                var loc = tot + badd;
                out.set(f.c, loc);
                $0c5e3e04f495ba65$var$wzh(out, o, f, f.f, f.u, l, tot, f.m), o += 16 + badd + (f.m ? f.m.length : 0), tot = loc + l;
            } catch (e) {
                return cbd(e, null);
            }
        }
        $0c5e3e04f495ba65$var$wzf(out, o, files.length, cdl, oe);
        cbd(null, out);
    };
    if (!lft) cbf();
    var _loop_1 = function(i) {
        var fn = k[i];
        var _a = r[fn], file = _a[0], p = _a[1];
        var c = $0c5e3e04f495ba65$var$crc(), size = file.length;
        c.p(file);
        var f = $0c5e3e04f495ba65$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $0c5e3e04f495ba65$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $0c5e3e04f495ba65$var$exfl(p.extra);
        var compression = p.level == 0 ? 0 : 8;
        var cbl = function(e, d) {
            if (e) {
                tAll();
                cbd(e, null);
            } else {
                var l = d.length;
                files[i] = $0c5e3e04f495ba65$var$mrg(p, {
                    size: size,
                    crc: c.d(),
                    c: d,
                    f: f,
                    m: m,
                    u: s != fn.length || m && com.length != ms,
                    compression: compression
                });
                o += 30 + s + exl + l;
                tot += 76 + 2 * (s + exl) + (ms || 0) + l;
                if (!--lft) cbf();
            }
        };
        if (s > 65535) cbl($0c5e3e04f495ba65$var$err(11, 0, 1), null);
        if (!compression) cbl(null, file);
        else if (size < 160000) try {
            cbl(null, $0c5e3e04f495ba65$export$21533ff51b8a0b4a(file, p));
        } catch (e) {
            cbl(e, null);
        }
        else term.push($0c5e3e04f495ba65$export$2316623ecd1285ab(file, p, cbl));
    };
    // Cannot use lft because it can decrease
    for(var i = 0; i < slft; ++i)_loop_1(i);
    return tAll;
}
function $0c5e3e04f495ba65$export$eb1654f146d54eb3(data, opts) {
    if (!opts) opts = {};
    var r = {};
    var files = [];
    $0c5e3e04f495ba65$var$fltn(data, '', r, opts);
    var o = 0;
    var tot = 0;
    for(var fn in r){
        var _a = r[fn], file = _a[0], p = _a[1];
        var compression = p.level == 0 ? 0 : 8;
        var f = $0c5e3e04f495ba65$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $0c5e3e04f495ba65$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $0c5e3e04f495ba65$var$exfl(p.extra);
        if (s > 65535) $0c5e3e04f495ba65$var$err(11);
        var d = compression ? $0c5e3e04f495ba65$export$21533ff51b8a0b4a(file, p) : file, l = d.length;
        var c = $0c5e3e04f495ba65$var$crc();
        c.p(file);
        files.push($0c5e3e04f495ba65$var$mrg(p, {
            size: file.length,
            crc: c.d(),
            c: d,
            f: f,
            m: m,
            u: s != fn.length || m && com.length != ms,
            o: o,
            compression: compression
        }));
        o += 30 + s + exl + l;
        tot += 76 + 2 * (s + exl) + (ms || 0) + l;
    }
    var out = new $0c5e3e04f495ba65$var$u8(tot + 22), oe = o, cdl = tot - o;
    for(var i = 0; i < files.length; ++i){
        var f = files[i];
        $0c5e3e04f495ba65$var$wzh(out, f.o, f, f.f, f.u, f.c.length);
        var badd = 30 + f.f.length + $0c5e3e04f495ba65$var$exfl(f.extra);
        out.set(f.c, f.o + badd);
        $0c5e3e04f495ba65$var$wzh(out, o, f, f.f, f.u, f.c.length, f.o, f.m), o += 16 + badd + (f.m ? f.m.length : 0);
    }
    $0c5e3e04f495ba65$var$wzf(out, o, files.length, cdl, oe);
    return out;
}
/**
 * Streaming pass-through decompression for ZIP archives
 */ var $0c5e3e04f495ba65$export$93f81d5bbbb7c6bf = /*#__PURE__*/ function() {
    function UnzipPassThrough() {}
    UnzipPassThrough.prototype.push = function(chunk, final) {
        // same as ZipPassThrough: cast to retain Buffer ergonomics
        this.ondata(null, chunk, final);
    };
    UnzipPassThrough.compression = 0;
    return UnzipPassThrough;
}();
/**
 * Streaming DEFLATE decompression for ZIP archives. Prefer AsyncZipInflate for
 * better performance.
 */ var $0c5e3e04f495ba65$export$eb188945cc39e642 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function UnzipInflate() {
        var _this = this;
        this.i = new $0c5e3e04f495ba65$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
    }
    UnzipInflate.prototype.push = function(chunk, final) {
        try {
            this.i.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    UnzipInflate.compression = 8;
    return UnzipInflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression for ZIP archives
 */ var $0c5e3e04f495ba65$export$6235d84645dad4f9 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function AsyncUnzipInflate(_, sz) {
        var _this = this;
        if (sz < 320000) this.i = new $0c5e3e04f495ba65$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
        else {
            this.i = new $0c5e3e04f495ba65$export$fff8358d6dbaa9cc(function(err, dat, final) {
                _this.ondata(err, dat, final);
            });
            this.terminate = this.i.terminate;
        }
    }
    AsyncUnzipInflate.prototype.push = function(chunk, final) {
        if (this.i.terminate) chunk = $0c5e3e04f495ba65$var$slc(chunk, 0);
        this.i.push(chunk, final);
    };
    AsyncUnzipInflate.compression = 8;
    return AsyncUnzipInflate;
}();
/**
 * A ZIP archive decompression stream that emits files as they are discovered
 */ var $0c5e3e04f495ba65$export$9b7485f84cbaaa56 = /*#__PURE__*/ function() {
    /**
     * Creates a ZIP decompression stream
     * @param cb The callback to call whenever a file in the ZIP archive is found
     */ function Unzip(cb) {
        this.onfile = cb;
        this.k = [];
        this.o = {
            0: $0c5e3e04f495ba65$export$93f81d5bbbb7c6bf
        };
        this.p = $0c5e3e04f495ba65$var$et;
    }
    /**
     * Pushes a chunk to be unzipped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzip.prototype.push = function(chunk, final) {
        var _this = this;
        if (!this.onfile) $0c5e3e04f495ba65$var$err(5);
        if (!this.p) $0c5e3e04f495ba65$var$err(4);
        if (this.c > 0) {
            var len = Math.min(this.c, chunk.length);
            var toAdd = chunk.subarray(0, len);
            this.c -= len;
            if (this.d) this.d.push(toAdd, !this.c);
            else this.k[0].push(toAdd);
            chunk = chunk.subarray(len);
            if (chunk.length) return this.push(chunk, final);
        } else {
            var f = 0, i = 0, is = void 0, buf = void 0;
            if (!this.p.length) buf = chunk;
            else if (!chunk.length) buf = this.p;
            else {
                buf = new $0c5e3e04f495ba65$var$u8(this.p.length + chunk.length);
                buf.set(this.p), buf.set(chunk, this.p.length);
            }
            var l = buf.length, oc = this.c, add = oc && this.d;
            var _loop_2 = function() {
                var sig = $0c5e3e04f495ba65$var$b4(buf, i);
                if (sig == 0x4034B50) {
                    f = 1, is = i;
                    this_1.d = null;
                    this_1.c = 0;
                    var bf = $0c5e3e04f495ba65$var$b2(buf, i + 6), cmp_1 = $0c5e3e04f495ba65$var$b2(buf, i + 8), u = bf & 2048, dd = bf & 8, fnl = $0c5e3e04f495ba65$var$b2(buf, i + 26), es = $0c5e3e04f495ba65$var$b2(buf, i + 28);
                    if (l > i + 30 + fnl + es) {
                        var chks_3 = [];
                        this_1.k.unshift(chks_3);
                        f = 2;
                        var lsc = $0c5e3e04f495ba65$var$b4(buf, i + 18), lsu = $0c5e3e04f495ba65$var$b4(buf, i + 22);
                        var fn_1 = $0c5e3e04f495ba65$export$adb211f8cb999894(buf.subarray(i + 30, i += 30 + fnl), !u);
                        var _a = $0c5e3e04f495ba65$var$z64hs(buf, i, es, 2, lsc, lsu, 0), sc_1 = _a[0], su_1 = _a[1], z64 = _a[3];
                        if (dd) sc_1 = -1 - z64;
                        i += es;
                        this_1.c = sc_1;
                        var d_1;
                        var file_1 = {
                            name: fn_1,
                            compression: cmp_1,
                            start: function() {
                                if (!file_1.ondata) $0c5e3e04f495ba65$var$err(5);
                                if (!sc_1) file_1.ondata(null, $0c5e3e04f495ba65$var$et, true);
                                else {
                                    var ctr = _this.o[cmp_1];
                                    if (!ctr) file_1.ondata($0c5e3e04f495ba65$var$err(14, 'unknown compression type ' + cmp_1, 1), null, false);
                                    d_1 = sc_1 < 0 ? new ctr(fn_1) : new ctr(fn_1, sc_1, su_1);
                                    d_1.ondata = function(err, dat, final) {
                                        file_1.ondata(err, dat, final);
                                    };
                                    for(var _i = 0, chks_4 = chks_3; _i < chks_4.length; _i++){
                                        var dat = chks_4[_i];
                                        d_1.push(dat, false);
                                    }
                                    if (_this.k[0] == chks_3 && _this.c) _this.d = d_1;
                                    else d_1.push($0c5e3e04f495ba65$var$et, true);
                                }
                            },
                            terminate: function() {
                                if (d_1 && d_1.terminate) d_1.terminate();
                            }
                        };
                        if (sc_1 >= 0) file_1.size = sc_1, file_1.originalSize = su_1;
                        this_1.onfile(file_1);
                    }
                    return "break";
                } else if (oc) {
                    if (sig == 0x8074B50) {
                        is = i += 12 + (oc == -2 && 8), f = 3, this_1.c = 0;
                        return "break";
                    } else if (sig == 0x2014B50) {
                        is = i -= 4, f = 3, this_1.c = 0;
                        return "break";
                    }
                }
            };
            var this_1 = this;
            for(; i < l - 4; ++i){
                var state_1 = _loop_2();
                if (state_1 === "break") break;
            }
            this.p = $0c5e3e04f495ba65$var$et;
            if (oc < 0) {
                var dat = f ? buf.subarray(0, is - 12 - (oc == -2 && 8) - ($0c5e3e04f495ba65$var$b4(buf, is - 16) == 0x8074B50 && 4)) : buf.subarray(0, i);
                if (add) add.push(dat, !!f);
                else this.k[+(f == 2)].push(dat);
            }
            if (f & 2) return this.push(buf.subarray(i), final);
            this.p = buf.subarray(i);
        }
        if (final) {
            if (this.c) $0c5e3e04f495ba65$var$err(13);
            this.p = null;
        }
    };
    /**
     * Registers a decoder with the stream, allowing for files compressed with
     * the compression type provided to be expanded correctly
     * @param decoder The decoder constructor
     */ Unzip.prototype.register = function(decoder) {
        this.o[decoder.compression] = decoder;
    };
    return Unzip;
}();
var $0c5e3e04f495ba65$var$mt = typeof queueMicrotask == 'function' ? queueMicrotask : typeof setTimeout == 'function' ? setTimeout : function(fn) {
    fn();
};
function $0c5e3e04f495ba65$export$23c8d3f8757cab88(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var files = {};
    var cbd = function(a, b) {
        $0c5e3e04f495ba65$var$mt(function() {
            cb(a, b);
        });
    };
    $0c5e3e04f495ba65$var$mt(function() {
        cbd = cb;
    });
    var e = data.length - 22;
    for(; $0c5e3e04f495ba65$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) {
        cbd($0c5e3e04f495ba65$var$err(13, 0, 1), null);
        return tAll;
    }
    var lft = $0c5e3e04f495ba65$var$b2(data, e + 8);
    if (lft) {
        var c = lft;
        var o = $0c5e3e04f495ba65$var$b4(data, e + 16);
        var z = $0c5e3e04f495ba65$var$b4(data, e - 20) == 0x7064B50;
        if (z) {
            var ze = $0c5e3e04f495ba65$var$b4(data, e - 12);
            z = $0c5e3e04f495ba65$var$b4(data, ze) == 0x6064B50;
            if (z) {
                c = lft = $0c5e3e04f495ba65$var$b4(data, ze + 32);
                o = $0c5e3e04f495ba65$var$b4(data, ze + 48);
            }
        }
        var fltr = opts && opts.filter;
        var _loop_3 = function(i) {
            var _a = $0c5e3e04f495ba65$var$zh(data, o, z), c_1 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $0c5e3e04f495ba65$var$slzh(data, off);
            o = no;
            var cbl = function(e, d) {
                if (e) {
                    tAll();
                    cbd(e, null);
                } else {
                    if (d) files[fn] = d;
                    if (!--lft) cbd(null, files);
                }
            };
            if (!fltr || fltr({
                name: fn,
                size: sc,
                originalSize: su,
                compression: c_1
            })) {
                if (!c_1) cbl(null, $0c5e3e04f495ba65$var$slc(data, b, b + sc));
                else if (c_1 == 8) {
                    var infl = data.subarray(b, b + sc);
                    // Synchronously decompress under 512KB, or barely-compressed data
                    if (su < 524288 || sc > 0.8 * su) try {
                        cbl(null, $0c5e3e04f495ba65$export$90366d8b308ba94a(infl, {
                            out: new $0c5e3e04f495ba65$var$u8(su)
                        }));
                    } catch (e) {
                        cbl(e, null);
                    }
                    else term.push($0c5e3e04f495ba65$export$cae1ce83fe4a1782(infl, {
                        size: su
                    }, cbl));
                } else cbl($0c5e3e04f495ba65$var$err(14, 'unknown compression type ' + c_1, 1), null);
            } else cbl(null, null);
        };
        for(var i = 0; i < c; ++i)_loop_3(i);
    } else cbd(null, {});
    return tAll;
}
function $0c5e3e04f495ba65$export$c757709326bb5901(data, opts) {
    var files = {};
    var e = data.length - 22;
    for(; $0c5e3e04f495ba65$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) $0c5e3e04f495ba65$var$err(13);
    var c = $0c5e3e04f495ba65$var$b2(data, e + 8);
    if (!c) return {};
    var o = $0c5e3e04f495ba65$var$b4(data, e + 16);
    var z = $0c5e3e04f495ba65$var$b4(data, e - 20) == 0x7064B50;
    if (z) {
        var ze = $0c5e3e04f495ba65$var$b4(data, e - 12);
        z = $0c5e3e04f495ba65$var$b4(data, ze) == 0x6064B50;
        if (z) {
            c = $0c5e3e04f495ba65$var$b4(data, ze + 32);
            o = $0c5e3e04f495ba65$var$b4(data, ze + 48);
        }
    }
    var fltr = opts && opts.filter;
    for(var i = 0; i < c; ++i){
        var _a = $0c5e3e04f495ba65$var$zh(data, o, z), c_2 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $0c5e3e04f495ba65$var$slzh(data, off);
        o = no;
        if (!fltr || fltr({
            name: fn,
            size: sc,
            originalSize: su,
            compression: c_2
        })) {
            if (!c_2) files[fn] = $0c5e3e04f495ba65$var$slc(data, b, b + sc);
            else if (c_2 == 8) files[fn] = $0c5e3e04f495ba65$export$90366d8b308ba94a(data.subarray(b, b + sc), {
                out: new $0c5e3e04f495ba65$var$u8(su)
            });
            else $0c5e3e04f495ba65$var$err(14, 'unknown compression type ' + c_2);
        }
    }
    return files;
}
module.exports["gzipSync"] = $0c5e3e04f495ba65$export$3d616c3fb3e15483;
module.exports["gunzipSync"] = $0c5e3e04f495ba65$export$c80456f7aaba691c;

});


//# sourceMappingURL=ConversationAssistant.532d774d.js.map
